var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to2, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to2, key) && key !== except)
        __defProp(to2, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to2;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  A: () => A_default,
  AdditionalInfoSection: () => AdditionalInfoSection_default,
  AdditionalInfoSectionWithHistory: () => AdditionalInfoSectionWithHistory,
  AddressLabel: () => AddressLabel_default,
  Alert: () => Alert_default,
  Alerts: () => Alerts,
  AlertsContext: () => AlertsContext,
  AlertsProvider: () => AlertsProvider,
  AmenitiesSection: () => AmenitiesSection,
  ApiAccessChartWidget: () => ApiAccessChartWidget_default,
  Avatar: () => Avatar_default,
  AvatarUpload: () => AvatarUpload_default,
  Badge: () => Badge_default,
  Banner: () => Banner_default,
  BannerTypesEnum: () => BannerTypesEnum,
  BathsAndBedsSelect: () => BathsAndBedsSelect_default,
  Box: () => Box_default,
  Breadcrumb: () => Breadcrumb_default,
  BrokersBanner: () => BrokersBanner_default,
  BulkActionsContext: () => BulkActionsContext,
  BulkActionsProvider: () => BulkActionsProvider,
  Button: () => Button_default,
  ButtonGroups: () => ButtonGroups_default,
  Card: () => Card_default,
  CardPaymentForm: () => CardPaymentForm_default,
  Checkbox: () => Checkbox_default,
  ColorContext: () => ColorContext,
  ColorProvider: () => ColorProvider,
  CopyToClipboardButton: () => CopyToClipboardButton_default,
  DEFAULT_COUNTRY: () => DEFAULT_COUNTRY,
  DashPlaceholder: () => DashPlaceholder_default,
  DashboardBanner: () => DashboardBanner_default,
  DashboardNotificationBannerContext: () => DashboardNotificationBannerContext,
  DashboardNotificationBannerProvider: () => DashboardNotificationBannerProvider,
  DatePeriodPicker: () => DatePeriodPicker_default,
  DatePeriodTypesEnum: () => DatePeriodTypesEnum,
  DatePicker: () => DatePicker_default,
  DatePickerTimeRangeEnum: () => DatePickerTimeRangeEnum,
  DatePickerWithTimeRange: () => DatePickerWithTimeRange_default,
  DateRangePicker: () => DateRangePicker_default,
  DefaultPaginationValues: () => defaultContextValue3,
  DeleteModal: () => DeleteModal_default,
  DevelopInfoSection: () => DeveloperInfoSection_default,
  Devider: () => Devider_default,
  Drawer: () => Drawer,
  DropDown: () => DropDown_default,
  DropdownContext: () => DropdownContext,
  DropdownOptions: () => DropdownOptions_default,
  DropdownProvider: () => DropdownProvider,
  ExpandableHtmlText: () => ExpandableHtmlText_default,
  ExpandableText: () => ExpandableText_default,
  FEATURED_PORTFOLIO_MODAL: () => FEATURED_PORTFOLIO_MODAL,
  FeaturedPortfolioCard: () => FeaturedPortfolioCard,
  FeaturedPortfolioModal: () => FeaturedPortfolioModal,
  FeaturedPortfolioStateContext: () => FeaturedPortfolioStateContext,
  FeaturedPortfolioStateProvider: () => FeaturedPortfolioStateProvider,
  FeaturedPortfolioSummary: () => FeaturedPortfolioSummary,
  FeaturedPropertiesBanner: () => FeaturedPropertiesBanner,
  FeaturedPropertiesCarousel: () => FeaturedPropertiesCarousel,
  FeaturedPropertyCard: () => FeaturedPropertyCard,
  FeaturesAndAmenitiesList: () => FeaturesAndAmenitiesList_default,
  Feedback: () => Feedback_default,
  FileInput: () => FileInput_default,
  FileList: () => FileList_default,
  FilePreviewModal: () => FilePreviewModal_default,
  FileTypeIcon: () => FileTypeIcon_default,
  FileUpload: () => FileUpload_default,
  FilterContext: () => FilterContext,
  FilterProvider: () => FilterProvider,
  FlatPagination: () => FlatPagination_default,
  FlatPaginationContext: () => FlatPaginationContext,
  FlatPaginationProvider: () => FlatPaginationProvider,
  Flex: () => Flex_default,
  Form: () => Form_default,
  FormContext: () => FormContext,
  FormErrorMessages: () => FormErrorMessages,
  FormErrorTypes: () => FormErrorTypes,
  FormProvider: () => FormProvider,
  FullPageFilePreview: () => FullPageFilePreview_default,
  GeneralInfoSection: () => GeneralInfoSection_default,
  GoogleAutocomplete: () => GoogleAutocomplete_default,
  GoogleMap: () => GoogleMap_default,
  Group: () => Group_default,
  H: () => H_default,
  Icon: () => Icon_default,
  IconBadge: () => IconBadge_default,
  Image: () => Image_default,
  InfoCard: () => InfoCard_default,
  Input: () => Input_default,
  InputAutocomplete: () => InputAutocomplete_default,
  InputGroup: () => InputGroup_default,
  InputNumber: () => InputNumber_default,
  InputPassword: () => InputPassword_default,
  InputPercentage: () => InputPercentage_default,
  InputPhone: () => InputPhone_default,
  InputPrice: () => InputPrice_default,
  InputSearch: () => InputSearch_default,
  InventoryTable: () => InventoryTable_default,
  Label: () => Label_default,
  List: () => List_default,
  ListWithPagination: () => ListWithPagination_default,
  LocalCashTables: () => LocalCashTables,
  LocalTimeHoursInput: () => LocalTimeHoursInput_default,
  LocalTimeWeekHoursInput: () => LocalTimeWeekHoursInput_default,
  LocationAndContactSection: () => LocationAndContactSection_default,
  MapSection: () => MapSection_default,
  Marker: () => Marker_default,
  MarketAreaTag: () => Tag2,
  MarketAreasList: () => MarketAreasList,
  MarketingFiles: () => MarketingFiles_default,
  MarketingFilesContext: () => MarketingFilesContext,
  MarketingFilesProvider: () => MarketingFilesProvider,
  MediaDragAndDropContext: () => MediaDragAndDropContext,
  MediaDragAndDropProvider: () => MediaDragAndDropProvider,
  MediaFilePreviewCard: () => MediaFilePreviewCard_default,
  Modal: () => Modal3,
  ModalContext: () => ModalContext,
  ModalProvider: () => ModalProvider,
  ModalWithBrokerBanner: () => ModalWithBrokerBanner_default,
  MultiFileUploadContext: () => MultiFileUploadContext,
  MultiFileUploadProvider: () => MultiFileUploadProvider,
  NameSection: () => NameSection_default,
  NotFoundPage: () => NotFoundPage_default,
  PageViewContext: () => PageViewContext,
  PageViewProvider: () => PageViewProvider,
  PageViewToggle: () => PageViewToggle_default,
  PageViewTypeEnum: () => PageViewTypeEnum,
  Pagination: () => Pagination_default,
  PaginationContext: () => PaginationContext,
  PaginationInfoLabel: () => PaginationInfoLabel,
  PaginationLoadMore: () => PaginationLoadMore,
  PaginationPerPageSelect: () => PaginationPerPageSelect,
  PaginationProvider: () => PaginationProvider,
  PhoneInputMask: () => PhoneInputMask,
  PortfolioActions: () => PortfolioActions,
  PortfoliosTreeSelect: () => PortfoliosTreeSelect_default,
  PriceInputWithDropDown: () => PriceInputWithDropDown_default,
  PriceRange: () => PriceRange_default,
  ProgressBar: () => ProgressBar_default,
  PropertiesList: () => PropertiesList,
  PropertiesTable: () => PropertiesTable_default,
  PropertyActions: () => PropertyActions,
  PropertyHistoryModal: () => PropertyHistoryModal_default,
  PropertyMarker: () => PropertyMarker_default,
  PropertyPreviewExpandableText: () => ExpandableText2,
  PropertyPreviewGeneralInfoSection: () => PropertyPreviewGeneralInfoSection,
  PropertyPreviewNavigationTabs: () => PropertyNavigationTabs_default,
  PropertySalesAvailabilityModal: () => PropertySalesAvailabilityModal_default,
  PropertySalesGallerySection: () => PropertySalesGallerySection_default,
  PropertyStickyHeader: () => PropertyStickyHeader_default,
  PropertyUpgradeBanner: () => PropertyUpgradeBanner_default,
  RadioInput: () => RadioInput_default,
  RawNumberSelect: () => RawNumberSelect_default,
  ResponsivePills: () => ResponsivePills_default,
  ResponsiveTabs: () => ResponsiveTabs_default,
  RestrictedField: () => RestrictedField,
  ScrollDragable: () => ScrollDragable_default,
  SearchContext: () => SearchContext,
  SearchProvider: () => SearchProvider,
  Select: () => Select_default,
  SelectLegacy: () => SelectLegacy_default,
  SelectPrice: () => SelectPrice_default,
  SelectTree: () => SelectTree_default,
  SideBar: () => SideBar_default,
  SlideShowSection: () => SlideShowSection,
  Slider: () => Slider_default,
  Slideshow: () => Slideshow_default,
  SlideshowPreview: () => SlideshowPreview_default,
  SortByEnum: () => SortByEnum,
  SortContext: () => SortContext,
  SortHeader: () => SortHeader_default,
  SortProvider: () => SortProvider,
  Spinner: () => Spinner_default,
  Stepper: () => Stepper_default,
  Steps: () => Steps_default,
  SubscriptionRecurringSwitch: () => SubscriptionRecurringSwitch_default,
  SummarySection: () => SummarySection,
  Table: () => Table_default,
  TableView: () => TableView_default,
  TableViewContext: () => TableViewContext,
  TableViewProvider: () => TableViewProvider,
  TableViewToggle: () => TableViewToggle,
  TableViewType: () => TableViewType,
  TableWitPagination: () => TableWitPagination_default,
  TableWithFlatPagination: () => TableWithFlatPagination_default,
  Tabs: () => Tabs_default,
  TabsWithDropdown: () => TabsWithDropdown_default,
  Tag: () => Tag_default,
  TagSelect: () => TagSelect_default,
  Text: () => Text_default,
  Textarea: () => Textarea_default,
  ThemeProvider: () => theme_provider_default,
  Thumbnail: () => Thumbnail_default,
  TimePicker: () => TimePicker_default,
  ToastContainer: () => Toast_default,
  Toggle: () => Toggle_default,
  TooltipContext: () => TooltipContext,
  TooltipPopup: () => TooltipPopup_default,
  TooltipProvider: () => TooltipProvider,
  TooltipWrapper: () => TooltipWrapper_default,
  UnauthorizedPage: () => UnauthorizedPage_default,
  UpgradeSubscriptionModalType: () => UpgradeSubscriptionModalType,
  UploadMediaContainer: () => UploadMediaContainer_default,
  Video: () => Video_default,
  ViewerContext: () => ViewerContext,
  ViewerProvider: () => ViewerProvider,
  VirtualToursButton: () => VirtualToursButton,
  WasDeleted: () => WasDeleted_default,
  WorkingHoursInput: () => WorkingHoursInput_default,
  WorkingWeekHoursInput: () => WorkingWeekHoursInput_default,
  dictionary: () => dictionary,
  downloadFile: () => downloadFile,
  downloadMedia: () => downloadMedia,
  fetchAccessToken: () => fetchAccessToken,
  fileUploadFetch: () => fileUploadFetch,
  formatBathroomsRangeValues: () => formatBathroomsRangeValues,
  formatBedroomsRangeValues: () => formatBedroomsRangeValues,
  formatDisplayDate: () => formatDisplayDate,
  formatDisplayMonthDate: () => formatDisplayMonthDate,
  formatDisplayRange: () => formatDisplayRange,
  formatGeneralRangeValues: () => formatGeneralRangeValues,
  formatLocalizedDate: () => formatLocalizedDate,
  getCountryList: () => getCountryList,
  getIdxIframeViewport: () => getIdxIframeViewport,
  getPeriodRangeByPeriodType: () => getPeriodRangeByPeriodType,
  googlePlaceToAddress: () => googlePlaceToAddress,
  googleZoomLevelToMiles: () => googleZoomLevelToMiles,
  i18next: () => i18n_default,
  isAccessTokenExpired: () => isAccessTokenExpired,
  jwtDecodeSafely: () => jwtDecodeSafely,
  localStorage: () => localStorage2,
  mainTheme: () => mainTheme,
  mortgage: () => mortgage_exports,
  priceMaxRange: () => priceMaxRange,
  priceMaxRangeRent: () => priceMaxRangeRent,
  priceMinRange: () => priceMinRange,
  priceMinRangeRent: () => priceMinRangeRent,
  renderEmailField: () => renderEmailField,
  renderPhoneField: () => renderPhoneField,
  renderWebsiteField: () => renderWebsiteField,
  toDisplayLocaleDateString: () => toDisplayLocaleDateString,
  toast: () => toast,
  useAsyncState: () => useAsyncState,
  useBackendErrorMessage: () => useBackendErrorMessage,
  useCheckIfSubscriptionFeatureActiveBroker: () => useCheckIfSubscriptionFeatureActiveBroker,
  useFormState: () => useFormState,
  useFormValidation: () => useFormValidation,
  useFromNow: () => useFromNow,
  useGoogleApiLoader: () => useGoogleApiLoader,
  useInfiniteScroll: () => useInfiniteScroll,
  useIsVisible: () => useIsVisible,
  useOnClickOutside: () => useOnClickOutside,
  usePropertyUpdatedAgo: () => usePropertyUpdatedAgo,
  useScreenResolution: () => useScreenResolution,
  useScrollDirection: () => useScrollDirection,
  useServerResponseTranslation: () => useServerResponseTranslation,
  useSystemFolderName: () => useSystemFolderName,
  validatePrice: () => validatePrice
});
module.exports = __toCommonJS(src_exports);

// src/components/theme.provider.tsx
var import_react_modal = __toESM(require("react-modal"));
var import_react_i18next7 = require("react-i18next");
var import_styled_components12 = require("styled-components");
var import_react_dnd = require("react-dnd");
var import_react_dnd_html5_backend = require("react-dnd-html5-backend");

// src/i18n.ts
var import_react_i18next = require("react-i18next");
var import_dash_common8 = require("dash-common");
var import_i18next = __toESM(require("i18next"));
var import_moment = __toESM(require("moment"));
var import_es = require("moment/locale/es");
var import_pt_br = require("moment/locale/pt-br");

// src/assets/dictionary/index.ts
var import_dash_common7 = require("dash-common");

// src/assets/dictionary/en/common.ts
var import_dash_common = require("dash-common");
var import_lodash = require("lodash");
var common_default = {
  labels: {
    signOut: "Logout",
    account: "Account",
    apiUsers: "API Users",
    apiManagement: "API",
    settings: "Settings",
    properties: "Properties",
    propertyDetails: "Property Details",
    propertyPreview: "Property Overview",
    propertyOverview: "Property Overview",
    folderDetails: "Folder Details",
    rootMediaFolder: "Root Media Folder",
    users: "Users",
    salesTeam: "Sales Team",
    internalSaleTeam: "Internal Sales Team",
    organizations: "Organizations",
    organization: "Organization",
    organizationDetails: "Organization Details",
    featuresAndAmenities: "Features and Amenities",
    projectStatus: "Project Status",
    salesGalleryStatus: "Sales Gallery Status",
    amenities: "Amenities",
    brokers: "Agents",
    cardDescription: "Card Description",
    seekers: "Direct Users",
    contact: "Contact",
    contactAgent: "Contact Agent",
    testAccount: "Test Account",
    management: "Management",
    marketAreas: "Market Areas",
    externalSales: "External Sales",
    exploreNewProperties: "Explore New Properties",
    featuredProperties: "Featured Properties",
    newListings: "New Listings",
    newListingsSubtitle: "The newest development profiles added to DASH in the last 30 days.",
    trendingThisWeek: "Trending Properties",
    trendingThisWeekSubtitle: "The most-viewed developments on DASH, updated weekly.",
    similarProperties: "More Like This",
    similarPropertiesSubtitle: "Similar properties you might be interested in.",
    recommendedForYou: "Recommended for you",
    recommendedForYouSubtitle: "Based on other properties you\u2019ve viewed.",
    exploreOnMap: "Explore on the Map",
    exploreOnMapSubtitle: "Browse properties across Florida \u2014 click any pin to open the listing.",
    exploreOnMapSplitSubtitle: "Browse the map and the matching listings side by side.",
    exploreOnMapExpandableSubtitle: "Open an interactive map of available properties whenever you want.",
    exploreOnMapCta: "Show the map",
    launchingSoon: "Launching Soon",
    launchingSoonSubtitle: "Approved pre-construction developments with sales announcements expected soon.",
    ultraLuxuryResidences: "Ultra-Luxury Residences",
    ultraLuxuryResidencesSubtitle: "New premium residences priced at $4M and above across Florida's most active markets.",
    luxuryResidences: "Luxury Residences",
    luxuryResidencesSubtitle: "New premium residences priced at $1M and above across Florida's most active markets.",
    under1M: "Residences Under $1M",
    under1MSubtitle: "New inventory priced under $1M across Florida's most active markets.",
    newRentalDevelopments: "New Rental Developments",
    newRentalDevelopmentsSubtitle: "Explore the latest pre- and new construction rental developments across Florida's most active markets.",
    show: "Show",
    previous: "Previous",
    next: "Next",
    add: "Add",
    addVirtualTour: "Add Virtual Tour",
    skip: "Skip",
    update: "Update",
    address: "Address",
    cancel: "Cancel",
    confirm: "Confirm",
    confirmSwitch: "Confirm Switch",
    notFound: "Not Found",
    saveChanges: "Save Changes",
    save: "Save",
    close: "Close",
    for: "for",
    clear: "Clear",
    fullName: "Full name",
    uploadCancelled: "Upload Canceled",
    to: "To",
    edit: "Edit",
    delete: "Delete",
    view: "View",
    actions: "Actions",
    website: "Website",
    status: "Visibility Status",
    propertyStatus: "Property Status",
    notes: "Notes",
    changelogs: "Changelogs",
    preview: "Preview",
    name: "Name",
    phone: "Phone",
    seeMore: "See More",
    open: "Open",
    more: "More",
    private: "Private",
    public: "Public",
    hidden: "Hidden",
    draft: "Draft",
    media: "Media",
    inventory: "Floor Plans",
    featuredFloorPlans: "Featured Floor Plans",
    seeMoreFloorPlans: "See more floor plans",
    information: "Information",
    advanced: "Advanced",
    description: "Description",
    metrics: "Metrics",
    partners: "Partners",
    companies: "Companies",
    pluginUsers: "Plugin Users",
    invitations: "Invitations",
    apiConsole: "API Console",
    contentActivity: "Content Activity",
    tracking: "Tracking",
    savedProperties: "Saved Properties",
    watchlist: "Watchlist",
    emptyColumn: "N/A",
    weekDays: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    },
    today: "Today",
    dateRangePeriods: {
      currentWeek: "This Week",
      pastWeek: "Past Week",
      currentMonth: "This Month",
      pastMonth: "Past Month",
      threeMonth: "Three Months",
      custom: "Custom Time Period",
      currentYear: "This Year"
    },
    dateRangeGroups: {
      hourly: "Hourly",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly"
    },
    general: "General",
    location: "Location",
    folder: "Folder",
    folders: "Folders: ({{number}})",
    file: "File",
    files: "Files: ({{number}})",
    kBytes: "{{size}} KB",
    mBytes: "{{size}} MB",
    noOptions: "No Options",
    loading: "Loading...",
    from: "From",
    highlights: "Highlights",
    agentHighlights: "Agent Highlights",
    agentHighlightsNotes: "Agent Highlights Notes",
    upgradeToView: "Upgrade to view",
    about: "About",
    archive: "Archive",
    unarchive: "Unarchive",
    rename: "Rename",
    move: "Move",
    cvv: "CVV",
    creditCardNumber: "Credit Card Number",
    expiryDate: "Expiry Date",
    fileName: "Filename",
    category: "Category",
    size: "Size",
    added: "Added",
    download: "Download",
    dashboard: "Dashboard",
    menu: "Menu",
    portfolios: "Portfolios",
    portfolioDetails: "Portfolio Details",
    messages: "Messages",
    resend: "Re-send",
    resendViaEmail: "Re-send Via Email",
    email: "Email",
    showMore: "Show More",
    readMore: "Read More",
    showLess: "Show Less",
    any: "Any",
    miles: "Miles",
    subscription: "Subscription",
    payment: "Payment",
    contentCopy: "Duplicate",
    closed: "Closed",
    create: "Create",
    share: "Share",
    compare: "Compare",
    sortBy: "Sort By",
    sortAz: "Alphabetical A-Z",
    sortZa: "Alphabetical Z-A",
    sortCreatedAt: "Most Recently Added/Created",
    filterBy: "Filter By",
    selectAll: "Select All",
    change: "Change",
    state: "State",
    updated: "Updated",
    changePhoto: "Change Photo",
    goBack: "Go back",
    startSevenDayTrial: "Start 7-Day Free Trial",
    cancelAnytime: "Cancel anytime",
    date: "Date",
    branded: "Branded",
    unbranded: "Unbranded",
    shared: "Shared",
    brandingType: "Branding Type",
    selectBrandingType: "Select Branding Type",
    allBrandingTypes: "All Branding Types",
    all: "All",
    sharedFolder: "Shared folder",
    brandedFilesReady: "Branded Files Ready",
    track: "Track",
    createAlert: "Create Alert",
    calculate: "Calculate",
    moreOptions: "More Options",
    lessOptions: "Less Options",
    remove: "Remove",
    submit: "Submit",
    sqft: "SqFt",
    beds: "Beds",
    baths: "Baths",
    verified: "Verified",
    developerVerified: "Developer Verified",
    developerVerifiedOn: "Developer Verified {{date}}",
    unverified: "Unverified",
    comingSoon: "Coming Soon",
    dashLogo: "Dash logo",
    coming_soon: "Coming Soon",
    byAppointmentOnly: "By Appointment Only",
    soldOut: "Sold Out",
    sold_out: "Sold Out",
    leavingSoon: "Leaving Soon",
    leaving_soon: "Leaving Soon",
    leavingSoonBanner: "Single-family and townhome communities are leaving DASH this summer.",
    leavingSoonReadMore: "Learn More",
    proposed: "Proposed",
    new_construction: "New Construction",
    pre_construction: "Pre Construction",
    single_family_home: "Single Family Home",
    under_construction: "Under Construction",
    completed: "Completed",
    noValue: "N/A",
    notSet: "Not Set",
    cmsStatus: "CMS Status",
    // CMS Status values
    not_set: "Not Set",
    pending_approval: "Pending Approval",
    new_listing: "New Listing",
    active_listing: "Active Listing",
    awaiting_audit: "Awaiting Audit",
    recently_updated: "Recently Updated",
    recently_reviewed: "Recently Verified",
    pending_archive: "Pending Archive",
    archived: "Archived",
    // Management tabs
    cmsSettings: "CMS Settings",
    // CMS Status actions
    approve: "Approve",
    audit: "Audit",
    approveProperty: "Approve Property",
    auditProperty: "Audit Property",
    archiveProperty: "Archive Property",
    approvePropertyConfirmation: 'Are you sure you want to approve this Draft? This will make the property visible and update it as a "New Listing".',
    auditPropertyConfirmation: "Mark this property as audited? This confirms the information has been reviewed and is accurate.",
    archivePropertyConfirmation: "Are you sure you want to archive this property? This will hide it from public view and mark it as archived.",
    approving: "Approving...",
    auditing: "Auditing...",
    archiving: "Archiving...",
    propertyApprovedSuccess: "Property has been approved successfully",
    propertyApprovedError: "Failed to approve property",
    propertyAuditedSuccess: "Property has been audited successfully",
    propertyAuditedError: "Failed to audit property",
    propertyArchivedSuccess: "Property has been archived successfully",
    propertyArchivedError: "Failed to archive property",
    subscriptionNotSelected: "Subscription is Not Selected",
    billingAddress: "Billing Address",
    send: "Send",
    viewEditAction: "View / Edit",
    subscriptionBanner: "You need to have a <tag>{{subscriptionType}}</tag> to get access to this page",
    newNote: "New Note",
    read: "Read",
    search: "Search",
    reactions: "Reactions",
    current: "Current",
    notBillable: "Not Billable",
    studio: "Studio",
    dashSuffix: "| DASH",
    dashCMSSuffix: "| DASH CMS",
    dashApiAdminSuffix: "| DASH API Admin",
    notWorking: "Not Working",
    notAvailable: "Not Available",
    browserTabTitles: {
      dashboard: "Agent Dashboard",
      properties: "Properties",
      featuredContent: "Featured Content",
      featuredContentProperties: "Featured Properties",
      featuredContentPortfolios: "Featured Portfolios",
      portfolios: "Portfolios",
      unavailablePortfolioPage: "Portfolio Unavailable",
      profile: "Profile",
      tracking: "Tracked Properties",
      watchlist: "Watchlist",
      messages: "Messages",
      signIn: "Sign In",
      signUp: "Sign Up",
      completeSignUpCodeConfirmation: "Complete Sign Up",
      completeSignUpSSO: "Complete SSO Sign Up",
      forgotPassword: "Forgot/Lost Password",
      completeSignUpPickSubscription: "Pick Subscription",
      stripeCheckoutResult: "Process Payment",
      completeSignUpAddAdditionalInfo: "Add Additional Info",
      resetPassword: "Reset Password",
      termConditions: "Terms and Conditions",
      privacyPolicy: "Privacy Policy",
      organizations: "Organizations",
      amenities: "Amenities",
      brokers: "Agents",
      seekers: "Direct Users",
      externalSales: "External Sales",
      externalSalesUsers: "External Sales Users",
      management: "Management",
      account: "Account",
      apiUsers: "API Users",
      apiManagement: "API",
      apiDocs: "DASH API Documentation",
      apiReleaseNotes: "API Release Notes",
      settings: "Settings",
      marketAreas: "Market Areas",
      exchange: "Exchange",
      search: "Search",
      ssoCallback: "Redirecting from SSO...",
      featuredPortfolios: "Featured Portfolios"
    },
    exchange: "Exchange",
    verifyAccount: "Verify Account",
    verifyAccountShort: "Verify Acc.",
    apply: "Apply",
    processing: "Processing...",
    popular: "Popular",
    applied: "Applied",
    closeSearch: "Close search",
    scrollLeft: "Scroll left",
    scrollRight: "Scroll right"
  },
  placeholders: {
    cardExpiry: "mm/yy",
    noSearchResults: "Your search did not return any results.",
    searchNoResultsForQuery: 'No results found for "{{query}}"',
    firstAndLastName: "First and Last Name",
    selectOption: "Select Option",
    selectProjectStatus: "Select Project Status",
    selectBrandingType: "Select Branding Type",
    globalSearch: "Property, City, Market Area, Developer...",
    mobileSearchEmptyMessage: "Search for properties, cities, market areas, developers and more."
  },
  serverMessages: {
    notFound: "Incorrect Email or Password.",
    uploadFail: "Something went wrong. Could not upload.",
    unknown: "Something went wrong.",
    accountNotFound: "Account Not Found",
    licenseValidationError: "Error validating license",
    unauthorized: "Invalid or expired link. Please generate a new one."
  },
  alerts: {
    resetPasswordEmailsSent: "If an account is found, a password reset link will be sent to the email address!",
    passwordReset: "Password has been successfully updated! ",
    changesSaved: "Changes have been saved successfully!",
    alertWasHidden: "Property was Hidden",
    alertWasShown: "Property was Unhidden",
    accountIsUpdated: "Account is Updated",
    invitationHasBeenSent: "Invitation has been sent!"
  },
  roles: {
    ORG_SALES_DIRECTOR: "Director",
    ORG_SALES_ASSOCIATE: "Sales Associate",
    ORG_DEVELOPER: "Developer",
    ORG_OWNER: "Owner"
  },
  accountStatuses: {
    [import_dash_common.AccountStatusesEnum.ACTIVE]: "Active",
    [import_dash_common.AccountStatusesEnum.ADDED]: "Added",
    [import_dash_common.AccountStatusesEnum.ARCHIVED]: "Archived",
    [import_dash_common.AccountStatusesEnum.EXPIRED]: "Expired",
    [import_dash_common.AccountStatusesEnum.INVITED]: "Invited"
  },
  brokerPortalServerErrors: {
    [import_dash_common.ServerErrors.ACCOUNT_ARCHIVED]: "User account was blocked, please contact DASH support.",
    [import_dash_common.ServerErrors.BROKER_ACCOUNT_ARCHIVED]: "Your account is blocked. {{reason}}. Please contact DASH support.",
    [import_dash_common.ServerErrors.WRONG_VERIFICATION_CODE]: "Verification Code Incorrect",
    [import_dash_common.ServerErrors.LICENSE_ALREADY_EXISTS]: "License is already associated with a DASH account.",
    [import_dash_common.ServerErrors.PORTFOLIO_CONTAIN_FOLDER]: "This property has already been added to portfolio",
    [import_dash_common.ServerErrors.INCORRECT_PASSWORD]: "Incorrect Password",
    [import_dash_common.ServerErrors.PHONE_NUMBER_IS_USED]: "Phone number is already associated with a DASH account. If you are the owner of the phone number please contact DASH Support.",
    [import_dash_common.ServerErrors.MAX_CUSTOMER_CARD_PAYMENT_METHODS]: "You have reached the limit of allowed payment methods.",
    [import_dash_common.ServerErrors.PAYMENT_METHOD_NEEDED]: "A Payment Method is needed.",
    [import_dash_common.ServerErrors.UNAVAILABLE_FOR_BROKERS]: "Property is unavailable for brokers.",
    [import_dash_common.ServerErrors.INCORRECT_ACCOUNT_CREDENTIALS]: "Incorrect email or password."
  },
  serverErrors: {
    [import_dash_common.ServerErrors.PORTFOLIO_IS_EMPTY]: "Portfolio is empty",
    [import_dash_common.ServerErrors.PORTFOLIO_IS_PRIVATE]: "Portfolio is private",
    [import_dash_common.ServerErrors.PROPERTY_IS_PRIVATE]: "Property is private",
    [import_dash_common.ServerErrors.PORTFOLIO_NOT_EXISTS]: "Portfolio does not exist",
    [import_dash_common.ServerErrors.ACCOUNT_EMAIL_ALREADY_EXIST]: "There is already a DASH account with this email address. Contact DASH Support if you need to reset your password.",
    [import_dash_common.ServerErrors.ACCOUNT_ARCHIVED]: "There is an archived account with this email address. Unarchive the account to send an invitation.",
    [import_dash_common.ServerErrors.ACCOUNT_NOT_FOUND]: "Account Not Found",
    [import_dash_common.ServerErrors.INCORRECT_ACCOUNT_CREDENTIALS]: "Username or password is incorrect",
    [import_dash_common.ServerErrors.API_CREDENTIALS_ALREADY_EXIST]: "Cannot create Api Credentials. There are already credentials associated to this account.",
    [import_dash_common.ServerErrors.ACCOUNT_IS_NOT_RELATED_TO_APPLICATION]: "Account is not related to this application",
    [import_dash_common.ServerErrors.INVALID_PHONE_NUMBER]: "Invalid Phone Number",
    [import_dash_common.ServerErrors.ALREADY_ASSIGNED_USER_IN_SALE_TEAM]: "This user is already assigned to this sales team.",
    [import_dash_common.ServerErrors.PROPERTY_NAME_EXISTS]: "A property with this name already exists",
    [import_dash_common.ServerErrors.PORTFOLIO_FOLDER_NAME_EXISTS]: "Portfolio name must be unique",
    [import_dash_common.ServerErrors.PORTFOLIO_NAME_ROOT_FORBIDDEN]: 'Portfolio name cannot be "root"',
    [import_dash_common.ServerErrors.ALERT_CONFIG_WITH_SAME_NAME]: "There is already an alert with this name. Please give the alert a unique name.",
    [import_dash_common.ServerErrors.ALERT_CONFIG_WITH_SAME_FILTER]: "An alert with the same settings already exists. Please select unique criteria.",
    [import_dash_common.ServerErrors.FOLDER_ALREADY_EXISTS]: "Folder with the same name already exists in this directory.",
    [import_dash_common.ServerErrors.RESERVED_FOLDER]: "Folder with the same name already exists",
    [import_dash_common.ServerErrors.SALE_TEAM_PHONE_EXISTS]: "External Sales Team with this phone already exists.",
    [import_dash_common.ServerErrors.SUBSCRIPTION_ALREADY_CANCELED]: "Subscription is already canceled!",
    [import_dash_common.ServerErrors.PAYMENT_METHOD_DECLINED]: "Your card was declined. Please contact your card administrator or try a different card.",
    [import_dash_common.ServerErrors.INSUFFICIENT_FUNDS]: "Your card was declined. Reason: Insufficient funds",
    [import_dash_common.ServerErrors.STOLEN_CARD]: "Your card was declined. Reason: Stolen card",
    [import_dash_common.ServerErrors.LOST_CARD]: "Your card was declined. Reason: Lost card"
  },
  fileTypes: {
    photo: "PHOTO",
    video: "VIDEO",
    file: "FILE",
    exel: "XLS",
    doc: "DOC",
    pdf: "PDF"
  },
  subscriptionProductRecurringLabels: {
    [(0, import_lodash.camelCase)(import_dash_common.RecurringTypesEnum.FREE)]: "Free",
    [(0, import_lodash.camelCase)(import_dash_common.RecurringTypesEnum.MONTH)]: "Month",
    [(0, import_lodash.camelCase)(import_dash_common.RecurringTypesEnum.SIXMONTH)]: "Six months",
    [(0, import_lodash.camelCase)(import_dash_common.RecurringTypesEnum.YEAR)]: "Year"
  },
  subscriptionTypes: {
    [import_dash_common.BrokerSubscriptionTypesEnum.BILLABLE]: "Billable",
    [import_dash_common.BrokerSubscriptionTypesEnum.DEMO]: "Demo"
  },
  subscriptionStatuses: {
    [import_dash_common.ProductSubscriptionStatusesEnum.ACTIVE]: "Active",
    [import_dash_common.ProductSubscriptionStatusesEnum.CANCELED]: "Canceled",
    [import_dash_common.ProductSubscriptionStatusesEnum.SCHEDULED_CANCELLATION]: "Scheduled Cancellation",
    [import_dash_common.ProductSubscriptionStatusesEnum.INCOMPLETE]: "Incomplete",
    [import_dash_common.ProductSubscriptionStatusesEnum.INCOMPLETE_EXPIRED]: "Incomplete Expired",
    [import_dash_common.ProductSubscriptionStatusesEnum.PAST_DUE]: "Past Due",
    [import_dash_common.ProductSubscriptionStatusesEnum.TRIALING]: "Trialing",
    [import_dash_common.ProductSubscriptionStatusesEnum.UNPAID]: "Unpaid"
  },
  subscriptionPlanTypes: {
    [import_dash_common.SubscriptionProductNamesEnum.PRO]: "PRO",
    [import_dash_common.SubscriptionProductNamesEnum.BASIC]: "Basic"
  },
  ssoProviders: {
    [(0, import_lodash.camelCase)(import_dash_common.SSOProvidersEnum.GOOGLE)]: "Google",
    [(0, import_lodash.camelCase)(import_dash_common.SSOProvidersEnum.MIAMI_REALTORS)]: "Miami Realtors"
  },
  subscriptionBadgeTitles: {
    noCreditCard: "No credit card needed",
    trialAvailable: "{{trialDays}}-day trial available!",
    saveWithSixMonthPlan: "Save 10% with the 6-month plan",
    billedEverySixMonths: "Billed every six months"
  },
  subscriptionProductsCardsLabels: {
    basic: {
      fullDatabaseAccess: "Access to DASH's full database",
      pricingInventorySalesMaterials: "See pricing, inventory, sales materials & more",
      timestampedUpdates: "Timestamped updates & data verification",
      personalizedTracking: "Personalized tracking and alerts",
      unlimitedSavedProperties: "Add unlimited properties to your watchlist"
    },
    pro: {
      downloadUnbranded: "Download unbranded sales content",
      shareBrandedPortfolios: "Share agent-branded portfolios",
      integratedLeadGeneration: "Integrated lead generation",
      analyticsInsights: "Gain insights from analytics",
      comparisonTools: "Development comparison tools"
    },
    exchange: {
      embedFeeds: "Embed DASH feeds on your website",
      customizationOptions: "Customization options with multiple feed types",
      iframeImplementation: "Easy iframe implementation",
      platformSupport: "Supports all major web platforms"
    },
    api: {
      directDataAccess: "Direct Data Access: Connect to DASH\u2019s full database of new development projects",
      flexibleDisplay: "Flexible Display: Power your own search tools, custom dashboards, or internal tools",
      apiCredentials: "Includes API key + credentials"
    },
    direct: {
      overview: "Direct access to DASH\u2019s platform, built exclusively for discovering Florida\u2019s newest homes, condos, and rental communities",
      developerUpdates: "Real-time developer updates from over 400 communities",
      smartSearchFilters: "Search by city, delivery date, price, property type and more to match your needs",
      launchAndPriceAlerts: "Set alerts for launches & price changes",
      favoritesAndComparison: "Save & organize favorites as you compare options",
      salesTeamAccess: "Easy access to on-site sales teams for more information and scheduling property tours"
    }
  },
  subscriptionProductsCardsSectionTitles: {
    basic: "Features You'll Love",
    pro: "Everything in Basic, plus:",
    exchange: "Everything in Pro, plus:",
    api: "Custom Data Integrations"
  },
  subscriptionProductsKeyFeatures: "Key Features",
  subscriptionProductsCardsDescriptions: {
    basic: "Instant access to discover & explore DASH's new construction database.",
    pro: "Download unbranded sales materials & share agent-branded links.",
    exchange: "Seamlessly add hundreds of new developments to your website.",
    api: "Integrate DASH's new construction data into your custom applications."
  },
  featureLabels: {
    basic: {
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.NO_CREDIT_CARD)]: "NO CREDIT CARD REQUIRED",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.PRO_UPGRADE)]: "Upgrade to PRO anytime for advanced features",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.VIEW_ALL_PROPERTIES_IN_DATABASE)]: "Unlimited access to view DASH\u2019s new development property database",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.ACCESS_TO_PRICING_AVAILABILITY)]: "Access to view all property pricing & availability",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.ACCESS_TO_MARKETING_MATERIALS)]: "Access to view all property marketing materials",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.TRACK_UPDATES)]: "Track property updates with timestamps & verification",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.ADVANCED_FILTERS_FOR_PINPOINT_SEARCH)]: "Set advanced filters for refined inventory search",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.CUSTOM_ALERTS_NOTIFICATIONS)]: "Custom property and market alerts to your inbox",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.DASH_SUPPORT)]: "DASH Team support whenever needed"
    },
    pro: {
      base: "Includes all features in the Basic plan, PLUS...    ",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING)]: "Share Custom Portfolios",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.PROPERTY_COMPARE)]: "Side-by-side comparison tools",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.ANALYTICS_AND_REPORTING_TOOLS)]: "Gain insights from analytics",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT)]: "Download Unbranded Content"
    },
    idx: {
      base: "Includes all features in the PRO plan, PLUS...    ",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.EMBED_LISTINGS)]: "Embed DASH Listings on your website",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.MULTIPLE_FEED_TYPES)]: "Multiple Feed Types",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.LEAD_GENERATION)]: "Lead Generation",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.IDX_INTEGRATION)]: "Easy Integration"
    },
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.LIMITED_TIME_INTRODUCTORY_PRICING)]: "LIMITED-TIME INTRODUCTORY PRICING"
  },
  featureDescriptions: {
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT)]: "unlimited access to unbranded property marketing materials, each ready-to-share with clients or on your website and social media",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING)]: "easily customize and share development content and curated groups of development properties with your contact details",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.PROPERTY_COMPARE)]: "create and share links to development comp sets with your leading prospects",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.ANALYTICS_AND_REPORTING_TOOLS)]: "gain access to reporting tools that track your marketing efforts",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.EMBED_LISTINGS)]: "a convenient IDX solution to easily showcase new development properties",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.MULTIPLE_FEED_TYPES)]: "customize how properties are showcased, with multiple options including portfolios, single-property, search and more",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.LEAD_GENERATION)]: "collect leads directly from users interested in properties you showcase",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.IDX_INTEGRATION)]: "DASH Exchange works with all major websites, including WordPress, Wix, Squarespace and more\u2026"
  },
  brokerLicenseStatuses: {
    [import_dash_common.BrokerLicenseStatusesEnum.ACTIVE]: "Active",
    [import_dash_common.BrokerLicenseStatusesEnum.INACTIVE]: "Inactive",
    [import_dash_common.BrokerLicenseStatusesEnum.PENDING_REVIEW]: "Pending Review"
  },
  accountPhoneNumberStatuses: {
    [import_dash_common.AccountPhoneNumberStatusesEnum.VERIFIED]: "Verified",
    [import_dash_common.AccountPhoneNumberStatusesEnum.NOT_VERIFIED]: "Not Verified"
  },
  moments: {
    year: "year",
    month: "month",
    day: "day",
    hour: "hour",
    minute: "minute",
    second: "second",
    plural: {
      year: "years",
      month: "months",
      day: "days",
      hour: "hours",
      minute: "minutes",
      second: "seconds"
    },
    short: {
      year: "yr",
      month: "mo",
      day: "d",
      hour: "hr",
      minute: "min",
      second: "sec"
    },
    shortPlural: {
      year: "yrs",
      month: "mos",
      day: "d's",
      hour: "hrs",
      minute: "min",
      second: "sec"
    },
    agoLabel: "ago",
    momentLabel: "just now",
    updatedJustNow: "Updated just now",
    updatedAgo: {
      year_one: "Updated {{count}} year ago",
      year_other: "Updated {{count}} years ago",
      month_one: "Updated {{count}} month ago",
      month_other: "Updated {{count}} months ago",
      day_one: "Updated {{count}} day ago",
      day_other: "Updated {{count}} days ago",
      hour_one: "Updated {{count}} hour ago",
      hour_other: "Updated {{count}} hours ago",
      minute_one: "Updated {{count}} minute ago",
      minute_other: "Updated {{count}} minutes ago"
    },
    updatedAgoShort: {
      year_one: "Updated {{count}} yr ago",
      year_other: "Updated {{count}} yrs ago",
      month_one: "Updated {{count}} mo ago",
      month_other: "Updated {{count}} mos ago",
      day_one: "Updated {{count}} d ago",
      day_other: "Updated {{count}} d's ago",
      hour_one: "Updated {{count}} hr ago",
      hour_other: "Updated {{count}} hrs ago",
      minute_one: "Updated {{count}} min ago",
      minute_other: "Updated {{count}} min ago"
    }
  },
  historyTypesMessages: {
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_NAME]: "Property Name Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_PRICE]: "Pricing & Availability Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_WEBSITE]: "Property Website Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_DEVELOPER_ORGANIZATION]: "Developer Organization Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_LOCATION]: "Property Location Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_SALES_TEAMS]: "Sales Team Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_MEDIA_UPLOADED]: "New Marketing Files Uploaded to {{folderName}}",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_MEDIA_FILES_MOVED]: "Marketing Files Moved",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_MEDIA_RENAMED]: "Marketing Files Renamed",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_MEDIA_REMOVED]: "Marketing Files Removed",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_HIGHLIGHTS]: "Property Highlights Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_ABOUT]: "Property Details Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_FEATURES_AND_AMENITIES]: "Features and Amenities Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_ADDED]: "New Inventory Added",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_UPDATED]: "Inventory Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_REMOVED]: "Inventory Removed",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_ADDITIONAL_INFORMATION]: "Additional Information Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_VIRTUAL_TOURS]: "Virtual Tours Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_DATA_REVIEWED]: "Property Data Verified",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_CMS_STATUS]: "Status Changed",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_VISIBILITY]: "Visibility Changed"
  },
  history: {
    propertyUpdates: "Property Updates",
    historyUpdates: "History of Updates"
  },
  globalSearchCategories: {
    all: "All Results",
    properties: "Properties",
    locations: "Locations",
    organizations: "Developers"
  },
  searchIndexSubtypes: {
    PROPERTY: "Property",
    CITY: "City",
    COUNTY: "County",
    STATE: "State",
    MARKET_AREA: "Market Area",
    DEVELOPER: "Developer"
  },
  sortOptions: {
    alphabeticalAZ: "Alphabetical A-Z",
    alphabeticalZA: "Alphabetical Z-A",
    createdAt: "Newest (Most Recently Added)",
    newListing: "New Listings Only",
    updatedAt: "Last Updated",
    lastUpdatedAtByChangelog: "Last Updated",
    lastBrokerVisit: "Recently Visited",
    newestAdded: "Newest Added",
    oldestAdded: "Oldest Added",
    recentlyUpdated: "Recently Updated",
    mediaSizeUp: "Size from Largest to Smallest",
    mediaSizeDown: "Size from Smallest to Largest",
    yearBuilt: "Year Built",
    isMarkedAsVerified: "Verified",
    startingPriceAsc: "Starting Price (Low to High)",
    startingPriceDesc: "Starting Price (High to Low)",
    maxPriceAsc: "Max Price (Low to High)",
    maxPriceDesc: "Max Price (High to Low)"
  },
  modalDelete: {
    removedToast: "{{entity}} has been removed",
    note: "Note:",
    title: "Delete {{entity}}",
    confirmationText: "Confirm deletion of",
    confirmationTextSecond: "Confirm deletion of {{entity}}",
    confirmationWithName: "Confirm deletion of <bold>{{name}}</bold> {{entity}}?"
  },
  modalConfirmDelete: {
    actionUnassing: "This action will unassign the ",
    propertiesCurrentAssigned: ' "{{entity}}" from the properties that currently have it assigned.',
    ProceedDeletion: "Proceed with deletion?"
  },
  bannerPreview: {
    dimensions: "Height (fixed): {{height}} px | Current width: {{width}} px",
    device: "Device: {{device}}",
    mobile: "Mobile: {{isMobile}}",
    sliderInstruction: "Use the slider to resize the banner"
  },
  paymentFailedBanner: {
    message: "Your last payment didn't go through. Update your payment method to keep full access.",
    action: "Update payment method"
  },
  languageSwitcher: {
    label: "Language",
    accountHint: "Changes this browser only. Your account language is in Settings."
  },
  backendErrors: {
    apiCredentialsAlreadyExist: "Cannot create Api Credentials. There are already credentials associated to this account.",
    invalidIdxId: "Invalid feed ID.",
    propertyDoesNotExist: "Property does not exist.",
    passwordRequiredForPortfolio: "A password is required to open this portfolio.",
    portfolioNotAvailable: "Portfolio is not available.",
    trackedPropertiesLimitReached: "You have reached the limit of tracked properties.",
    unauthorized: "Unauthorized",
    internalServerError: "Internal server error",
    somethingWentWrong: "Something went wrong.",
    twoFactorAlreadyEnabled: "2FA already enabled.",
    twoFactorNotActivated: "2FA not activated.",
    invalidCode: "Invalid code.",
    authenticatorAppRequired: "This account verifies with an authenticator app.",
    qrCodeFailed: "Error generating QR Code.",
    invitationNotFound: "Invitation not found.",
    invitationUsed: "This invitation link has already been used.",
    invitationExpired: "This invitation link has expired.",
    invitationOnlyPendingResend: "Only pending invitations can be resent.",
    invitationOnlyPendingRevoke: "Only pending invitations can be revoked.",
    expirationDateInFuture: "Expiration date must be in the future.",
    apiCredentialNotFound: "API credential not found.",
    apiCredentialNotDeleted: "API credential is not deleted.",
    pluginUserNotFound: "Plugin user not found.",
    marketplacePartnersOnly: "Only marketplace partners can manage plugin users.",
    pluginUsersCannotSwitchAccountType: "API Plugin Users cannot switch account type",
    accountTypeSwitchedOnce: "Account type cannot be switched more than once.",
    brokerNotFound: "Broker not found.",
    notAllowedForRole: "Not allowed action for this role!",
    notAllowedForUser: "This user is not allowed to do this action.",
    featureNotInPlan: "Feature not available in current subscription",
    subscriptionNotActive: "Subscription is not active",
    subscriptionNotFound: "Subscription not found.",
    renewOnlyCanceled: "Renew available only for canceled subscriptions!",
    retryOnlyIncomplete: "Retry available only for incomplete subscriptions!",
    retryOnlyOpenInvoice: "Retry available only for opened subscription invoice!",
    activeStripeSubscriptionExists: "This customer already has an active subscription.",
    notStripeCustomer: "Account is not a Stripe customer.",
    portfolioNotFound: "Portfolio not found.",
    portfolioNotOwned: "Portfolio does not belong to this account.",
    featuredPortfolioNotFound: "Featured portfolio not found",
    featuredPortfolioNothingToCopy: "There are no public properties available to copy.",
    featuredPropertyNotFound: "Featured property not found",
    featuredPortfolioAlreadySaved: "Featured portfolio is already saved.",
    propertyNotFound: "Property not found.",
    propertyNotPublic: "Property is not public",
    propertyUnavailableForBrokers: "Property is unavailable for brokers",
    propertyAlreadyTracked: "Property is already tracked.",
    propertyAlreadyInPortfolio: "The property {{name}} has already been added to portfolio",
    propertiesAlreadyInFolder: "Some properties are already in this folder.",
    alertNotFound: "Alert not found.",
    amenityNotFound: "Amenity not found",
    accountNotFound: "Account Not Found",
    invalidApiCredentials: "Invalid App ID or API key.",
    targetNotFolder: "Target is not a folder",
    mediaNotFound: "Media file not found",
    noMediaToDownload: "No media found to download",
    mediaFolderNotFound: "Media folder not found or cannot be deleted",
    mediaDifferentFolders: "The selected media are not in the same folder.",
    incorrectFileSize: "Incorrect file size.",
    incorrectFileExtension: "Incorrect file extension.",
    feedNotFound: "Feed not found.",
    feedSettingsNotFound: "Feed settings not found.",
    feedSettingsAlreadyExist: "Feed settings already exist.",
    feedOwnerNotConfigured: "The feed owner has not configured IDX yet.",
    feedNoDownloads: "This feed does not offer downloads.",
    feedNoPortfolio: "This feed has no portfolio.",
    propertyNotInFeed: "This property does not belong to this feed.",
    portfolioNoLocations: "This portfolio does not follow locations.",
    salesMaterialsNotAvailable: "Sales materials are not available for Search Bar feed type.",
    startDateAfterEndDate: "Start date must not be after end date.",
    originRequired: "Origin or referer header is required.",
    sessionUrlInvalid: "Session URL is invalid",
    noteDeleteOwnOnly: "You can only delete your own notes.",
    noteEditOwnOnly: "You can only edit your own notes.",
    cardDeclined: "Your card was declined.",
    cardInsufficientFunds: "Your card has insufficient funds.",
    cardExpired: "Your card has expired.",
    cardCvcIncorrect: "Your card's security code is incorrect.",
    cardNumberIncorrect: "Your card number is incorrect.",
    cardExpiryIncorrect: "Your card's expiration date is incorrect.",
    cardNumberIncomplete: "Your card number is incomplete.",
    cardExpiryIncomplete: "Your card's expiration date is incomplete.",
    cardCvcIncomplete: "Your card's security code is incomplete.",
    cardNotSupported: "Your card does not support this type of purchase.",
    cardProcessingError: "An error occurred while processing your card. Try again in a little bit.",
    postalCodeIncomplete: "Your postal code is incomplete.",
    networkError: "Network error. Please check your connection and try again."
  },
  systemMediaFolders: {
    brochures: "Brochures",
    factSheets: "Fact Sheets",
    floorPlans: "Floor Plans",
    images: "Images",
    videos: "Videos",
    other: "Other",
    slideshow: "Slideshow",
    agentsOnly: "Agents-Only"
  },
  inventoryTypes: {
    MODEL: "Model",
    FOR_SALE: "For Sale"
  },
  components: {
    select: {
      selectAll: "Select all"
    },
    map: {
      close: "Close map",
      expandFullscreen: "Expand map to fullscreen",
      expand: "Expand map"
    },
    pdfViewer: {
      loadError: "An error occurred while loading this document."
    },
    slideshow: {
      previousImage: "Previous image",
      nextImage: "Next image"
    },
    featuredBanner: {
      seeMore: "See more",
      seeMoreDetails: "See more details"
    },
    upgradeBanner: {
      featurePropertyData: "Full property data & descriptions",
      featureContacts: "Developer & sales team contacts",
      featureAssets: "Floor plans, brochures & image assets",
      featureTracking: "Tracking tools for agents",
      title: "Unlock Full Access to {{propertyName}}",
      subtitle: "Get complete property insights with <bold>{{planName}}</bold>"
    },
    restrictedFiles: {
      ariaLabel: "Upgrade to access marketing files",
      empty: "There are no files in this folder",
      filesInFolder_one: "There is {{count}} file in this folder",
      filesInFolder_other: "There are {{count}} files in this folder",
      upgradeHint: "Upgrade and Get Access to Verified Developer Files"
    },
    inventory: {
      intSqft: "Int. SQFT:",
      extSqft: "Ext. SQFT:",
      totalSqft: "Total. SQFT:",
      seeMoreUnitsAria_one: "See {{count}} more unit",
      seeMoreUnitsAria_other: "See {{count}} more units",
      seeMoreUnits_one: "See {{count}} More Unit",
      seeMoreUnits_other: "See {{count}} More Units",
      viewAllHint: "View all floor plans, pricing & availability"
    },
    virtualTours: {
      numbered: "Virtual Tour {{number}}",
      select: "Select Virtual Tour"
    },
    apiChart: {
      requests: "API Requests"
    }
  },
  propertyMap: {
    propertiesInArea_one: "{{count}} Property in This Area",
    propertiesInArea_other: "{{count}} Properties in This Area",
    zoomHint: "Zoom in or click to explore individually",
    completionIn: "Completion in {{year}}"
  }
};

// src/assets/dictionary/en/forms.ts
var forms_default = {
  labels: {
    email: "Email",
    password: "Password",
    firstName: "First Name",
    lastName: "Last Name",
    apiReferralCode: "Referral Code",
    apiAccountType: "Account Type",
    apiDirectUser: "Direct API user",
    apiDirectUserDesc: "Uses the API for their own integration.",
    apiMarketplacePartner: "Marketplace partner",
    apiMarketplacePartnerDesc: "Resells API access. Gets a referral link to sign up plugin users, whose requests count against this company\u2019s quota. The link code is generated automatically.",
    apiCompany: "Company",
    apiCompanyRepresentative: "Representative",
    apiClientCount: "Clients",
    apiCompanyName: "Responsible Company",
    apiMonthlyAccess: "Monthly Access",
    apiInvitationExpiresAt: "Expiration Date",
    apiMfa: "MFA",
    apiMfaOn: "Enabled",
    apiMfaOff: "Disabled",
    // Named for what it counts: the company's own traffic. The quota it draws
    // on is shared with its plugin users and only shown on the account page.
    apiDirectRequests: "Direct requests this month",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    signIn: "Login",
    forgotPassword: "Forgot Password?",
    sendResetInstructions: "Send Password Reset Instructions",
    resetPassword: "Reset Password",
    inventoryType: "Type",
    name: "Name",
    url: "Website URL",
    address: "Address",
    map: "Map",
    logo: "Organization Logo",
    svgIcon: "SVG Icon",
    organization: "Organization",
    primaryOrganization: "Primary Organization",
    additionalOrganizations: "Additional Organizations",
    proposedPropertyOnly: "Create as Proposed (name only)",
    streetName: "Street Address",
    city: "City",
    zipCode: "Zip Code",
    workingHours: "Working Hours",
    county: "County",
    radius: "Radius",
    state: "State",
    marketArea: "Market Area",
    buildingType: "Property Type",
    propertyTag: "Property Tags",
    tags: "Tags",
    projectStatus: "Property Status",
    salesGalleryStatus: "Sales Gallery Status",
    salesGalleryAddress: "Sales Gallery Address",
    propertyTransactionType: "Transaction Type",
    teamLogo: "Team Logo",
    stories: "Stories",
    yearBuilt: "Year Built",
    leadArchitect: "Lead Architect",
    landscapeArchitect: "Landscape Architect",
    nbrOfTowers: "Number of Towers",
    constructionStartDate: "Scheduled Construction Start Date",
    nbrOfUnits: "Number of Units",
    completionDate: "Scheduled Completion Date",
    localArchitect: "Local Architect",
    interiorDesigner: "Interior Designer",
    overview: "Property Highlights",
    projectDetails: "Property Overview",
    taxInformation: "Taxes & HOA",
    websiteOfProperty: "Property Website",
    virtualTourUrl: "Virtual Tour URL {{number}}",
    virtualTourLabel: "Display Label (Optional)",
    priceOfProperty: "Price",
    salesTeam: "Sales Team",
    salesDirector: "Sales Director",
    salesAssociate: "Sales Associate",
    brokerLicense: "Agent License (US only)",
    brokerLicenseLabel: "Agent License",
    agentLicenseStatus: "Agent License Status",
    commission: "Commission %",
    contactUrl: "Contact URL",
    anyPrice: "Any Price",
    priceMin: "Price (MIN)",
    priceMax: "Price (MAX)",
    market: "Market",
    baths: "{{count}}-BTH",
    beds: "{{count}}-BR",
    share: "Share",
    visibility: "Visibility",
    link: "Link",
    portfolioLink: "Portfolio Link",
    saveToApplyChanges: "Save to apply changes",
    customRooms: "Additional Rooms",
    inventoryInfo: "Inventory Info",
    contactInfo: "Contact Info",
    defaultInventoryDetails: "Default Inventory Details",
    averageBedroomsNumber: "Average Number of Bedrooms",
    averageBathroomsNumber: "Average Number of Bathrooms",
    averageNumbersLabels: {
      bedrooms: "Bedrooms ({{range}})",
      bathrooms: "Bathrooms ({{range}})",
      interiorSqft: "Interior SQFT ({{range}})",
      exteriorSqft: "Exterior SQFT ({{range}})"
    },
    buildingTypes: {
      activeAdult: "Active Adult (55+)",
      boutique: "Boutique",
      condo: "Condo",
      condoConversion: "Condo Conversion",
      condoHotel: "Hotel Condo",
      luxuryApartment: "Rental Development",
      penthouse: "Penthouse",
      privateResidence: "Private Residence",
      shortTermRentalFriendly: "Short-Term Rental Friendly",
      singleFamilyHome: "Single-Family Home",
      townhome: "Townhome",
      villa: "Villa",
      workforceHousing: "Workforce Housing"
    },
    propertyTags: {
      activeAdult: "Active Adult (55+)",
      boutique: "Boutique",
      brandedResidences: "Branded Residences",
      condoConversion: "Condo Conversion",
      eb5Program: "EB-5 Program",
      limitedInventory: "Limited Inventory",
      masterPlanned: "Master Planned",
      penthouse: "Penthouse",
      resortStyle: "Resort Style",
      shortTermRentalFriendly: "Short-Term Rental Friendly",
      waterfront: "Waterfront",
      workforceHousing: "Workforce Housing"
    },
    projectStatuses: {
      comingSoon: "Coming Soon",
      soldOut: "Sold Out",
      developerInventory: "Developer Inventory",
      newConstruction: "New Construction",
      newListing: "New Listing",
      preConstruction: "Pre-Construction",
      underConstruction: "Under Construction",
      completed: "Completed",
      proposed: "Proposed",
      leavingSoon: "Leaving Soon"
    },
    salesGalleryStatuses: {
      appointmentOnly: "Appointment only",
      comingSoon: "Coming soon",
      hoursAvailable: "Hours available",
      noInformation: "No information (hide sales gallery)"
    },
    propertyStatuses: {
      draft: "Draft",
      public: "Public",
      private: "Private"
    },
    propertyTransactionTypes: {
      forSale: "For Sale",
      forRent: "For Rent"
    },
    markets: {
      florida: {
        alva: "Alva",
        aveMaria: "Ave Maria",
        aventura: "Aventura",
        balHarbour: "Bal Harbour",
        bayHarborIslands: "Bay Harbor Islands",
        belleGlade: "Belle Glade",
        bocaRaton: "Boca Raton",
        bonitaSprings: "Bonita Springs",
        boyntonBeach: "Boynton Beach",
        brandon: "Brandon",
        brickell: "Brickell",
        capeCoral: "Cape Coral",
        cityOfMarco: "City of Marco",
        clearwater: "Clearwater",
        cocoaBeach: "Cocoa Beach",
        coconutGrove: "Coconut Grove",
        cooperCity: "Cooper City",
        coralGables: "Coral Gables",
        coralSprings: "Coral Springs",
        cutlerBay: "Cutler Bay",
        daniaBeach: "Dania Beach",
        davie: "Davie",
        deerfieldBeach: "Deerfield Beach",
        delrayBeach: "Delray Beach",
        doral: "Doral",
        downtownFortLauderdale: "Downtown Fort Lauderdale",
        downtownFortMyers: "Downtown Fort Myers",
        downtownMiami: "Downtown Miami",
        downtownStPetersburg: "Downtown St. Petersburg",
        dunedin: "Dunedin",
        edgewater: "Edgewater",
        esteroBay: "Estero Bay",
        esteroIsland: "Estero Island",
        evergladesCity: "Everglades City",
        fisherIsland: "Fisher Island",
        floridaCity: "Florida City",
        fortLauderdale: "Fort Lauderdale",
        fortMyers: "Fort Myers",
        fortMyersBeach: "Fort Myers Beach",
        fortPierce: "Fort Pierce",
        greenacres: "Greenacres",
        hallandaleBeach: "Hallandale Beach",
        hillsboroBeach: "Hillsboro Beach",
        hobeSound: "Hobe Sound",
        hobeSoundBeach: "Hobe Sound Beach",
        hollywood: "Hollywood",
        homestead: "Homestead",
        jupiter: "Jupiter",
        kendall: "Kendall",
        lakeland: "Lakeland",
        lakePark: "Lake Park",
        lakeWorthBeach: "Lake Worth Beach",
        lasOlas: "Las Olas",
        lauderdaleLakes: "Lauderdale Lakes",
        lauderhill: "Lauderhill",
        lehighAcres: "Lehigh Acres",
        lidoKey: "Lido Key",
        loxahatchee: "Loxahatchee",
        mangoniaPark: "Mangonia Park",
        marcoIsland: "Marco Island",
        melbourne: "Melbourne",
        melbourneBeach: "Melbourne Beach",
        miami: "Miami",
        miamiBeach: "Miami Beach",
        miamiGardens: "Miami Gardens",
        miamiRiver: "Miami River",
        midtownMiami: "Midtown Miami",
        miramar: "Miramar",
        moorings: "Moorings",
        naples: "Naples",
        naplesPark: "Naples Park",
        northBayVillage: "North Bay Village",
        northMiami: "North Miami",
        northMiamiBeach: "North Miami Beach",
        northNaples: "North Naples",
        oaklandPark: "Oakland Park",
        oldNaples: "Old Naples",
        orlando: "Orlando",
        palmBay: "Palm Bay",
        palmBeachGardens: "Palm Beach Gardens",
        palmBeachShores: "Palm Beach Shores",
        palmHarbor: "Palm Harbor",
        parkland: "Parkland",
        parkShore: "Park Shore",
        pelicanBay: "Pelican Bay",
        pembrokePines: "Pembroke Pines",
        pinecrest: "Pinecrest",
        plantation: "Plantation",
        portCharlotte: "Port Charlotte",
        portStLucie: "Port St. Lucie",
        pompanoBeach: "Pompano Beach",
        princeton: "Princeton",
        puntaGorda: "Punta Gorda",
        richmondWest: "Richmond West",
        riverview: "Riverview",
        rivieraBeach: "Riviera Beach",
        royalPalmBeach: "Royal Palm Beach",
        sanibel: "Sanibel",
        sarasota: "Sarasota",
        sarasotaBay: "Sarasota Bay",
        satelliteBeach: "Satellite Beach",
        sebastian: "Sebastian",
        springHill: "Spring Hill",
        stPeteBeach: "St. Pete Beach",
        stPetersburg: "St. Petersburg",
        stuart: "Stuart",
        sunnyIslesBeach: "Sunny Isles Beach",
        sunrise: "Sunrise",
        surfside: "Surfside",
        tamarac: "Tamarac",
        tampa: "Tampa",
        tarponSprings: "Tarpon Springs",
        titusville: "Titusville",
        veroBeach: "Vero Beach",
        victoriaPark: "Victoria Park",
        westlake: "Westlake",
        westPalmBeach: "West Palm Beach",
        weston: "Weston",
        wynwood: "Wynwood"
      }
    },
    nameOfProperty: "Property Name",
    quantity: "Quantity",
    bedrooms: "# Bedrooms",
    bathrooms: "# Bathrooms",
    totalSqft: "Total SQFT",
    interiorSqft: "Interior SQFT",
    exteriorSqft: "Exterior SQFT",
    startingPrice: "Starting Price ",
    highestPrice: "Highest Price ",
    floorplan: "Floorplan (PDF)",
    login: "Log In",
    role: "Role",
    properties: "Properties",
    brokerLicenseNumber: "Agent License Number (US only)",
    addManually: "Add Manually",
    phoneNumber: "Phone Number",
    verifyPhoneNumberCode: "Verification Code",
    shortDescription: "Short Description",
    agencyName: "Agency Name",
    companyName: "Company Name",
    agencyWebsite: "Agency Website",
    website: "Website",
    propertyType: "Property Type",
    alertName: "Alert Name",
    oldPassword: "Old Password",
    subscriptionPlanName: "Subscription Plan Name",
    subscriptionPlanStatus: "Subscription Plan Status",
    subscriptionPlanTypes: "Subscription Type",
    subscriptionType: "Subscription Type",
    userStatus: "User Status",
    mortgageTotalPrice: "Mortgage Amount",
    mortgageDownPayment: "Down Payment",
    mortgageInterestRate: "Interest Rate (%) ",
    mortgageTerm: "Mortgage Term (Years)",
    mortgageTaxRate: "Property Tax (Yearly)",
    mortgageInsuranceRate: "Property Ins. (Yearly)",
    termForTheDemo: "Term for the Demo",
    reasonUnActive: "Specify the reason for deactivation",
    note: "Notes",
    attachFiles: "Attach Files",
    min: "MIN",
    max: "MAX",
    salesWorkingHours: "Sales Gallery Working Hours",
    realUser: "Agent Account",
    testUser: "Test Account",
    accountType: "Account Type",
    excludeFromReports: "Exclude from Reports",
    isAPIUser: "API User",
    portfolioName: "Portfolio Name",
    propertyName: "Title",
    bannerTitle: "Banner Title",
    description: "Description",
    coverImage: "Cover Image",
    shortOverview: "Short Overview",
    brokerContactCard: {
      yourName: "Your name",
      phone: "Phone",
      message: "Message",
      sendMessage: "Send Message",
      sendNewMessage: "Send New Message",
      visitWebsite: "Visit website",
      contactMe: "CONTACT ME:",
      messageSent: "Your message has been sent!",
      agentWillContact: "The agent will contact you shortly.",
      failedToSendMessage: "Failed to send message. Please try again.",
      nameRequired: "Name is required",
      messageRequired: "Message is required",
      morePropertiesTitle: "Residences in This Collection",
      morePropertiesTitleAgent: "Properties in This Portfolio",
      emailInvalid: "Please enter a valid email",
      logoAlt: "Dash logo"
    }
  },
  messages: {
    shareSettingsSaved: "Share settings saved successfully",
    emailBlank: "Email is blank",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email format",
    expirationRequired: "Expiration date is required",
    expirationFuture: "Expiration date must be in the future",
    passwordBlank: "Password is blank",
    passwordRequired: "Password is required",
    passwordInvalid: "Password must have at least 8 characters, 1 symbol, 1 number, 1 lowercase and 1 uppercase",
    passwordValid: "Your password is accepted",
    newPasswordValid: "Your password is accepted",
    confirmPasswordValid: "Your passwords match",
    confirmPasswordInValid: "Passwords must match",
    firstNameBlank: "First Name is blank",
    fieldLengthInvalid: "Too many characters.",
    lastNameBlank: "Last Name is blank",
    nameBlank: "Name is required",
    nameInvalid: "Name is invalid",
    iconBlank: "No uploaded icon",
    fileBlank: "No uploaded file",
    urlInvalid: "The link is not valid. Please try using the format www.website.com",
    urlBlank: "Website URL is blank",
    invalidUrl: "Please enter a valid URL (e.g., https://example.com)",
    urlRequiredWithLabel: "URL is required when a label is provided",
    invalidUrlsBeforeSaving: "Please fix invalid URLs before saving",
    labelsWithoutUrls: "Some virtual tours have labels but no URLs. Please add URLs or remove the labels.",
    addressInvalid: "Address is invalid",
    mapInvalid: "Map is invalid",
    marketBlank: "Market is required",
    stateBlank: "State is required",
    countyBlank: "County is required",
    cityBlank: "City is required",
    zipCodeBlank: "Zip Code is required",
    streetBlank: "Street is required",
    organizationBlank: "Organization is required",
    addressBlank: "Address is required",
    mapBlank: "Map is required",
    sqftBlank: "SQFT is required",
    maxCharacterLimit: "Max character limit is {{number}}",
    workingHoursValidateMessage: "End time cannot be before the start time",
    priceBlank: "Price is blank",
    uploadErrors: {
      fileInvalidType: "File type must be {{type}}",
      fileTooLarge: "File must be a max of {{maxSize}}MB",
      unknown: "Something went wrong.",
      tooManyFiles: "Multiple files cannot be selected here"
    },
    minMaxMissingValueValidationError: "Min value is required",
    defaultMinMaxValidationError: "Min value should be less than Max value",
    typeInvalid: "File type is invalid",
    startingPriceMoreThanHighest: "Starting price should be less than the highest price",
    highestPriceLessThanStarting: "Highest price should be more than the starting price",
    numberOfUnitsMoreThanHighest: "Number of units (MIN) should be less than Number of units (MAX)",
    roleBlank: "Role is blank",
    roleRequired: "Role is required",
    saleTeamBlank: "Sales Team is blank",
    propertiesBlank: "Properties is blank",
    characterLengthRestriction: "You have entered too many characters ",
    fieldIsRequired: "{{fieldName}} is required",
    inventoryMinRequired: {
      bedrooms: "Bedrooms (min) is required",
      bathrooms: "Bathrooms (min) is required",
      interiorSqft: "Interior sqft (min) is required",
      exteriorSqft: "Exterior sqft (min) is required"
    },
    invalidCharacters: "You have entered invalid characters for this field",
    digitsLengthRestriction: "User cannot enter more than {{number}} digits",
    selectFolder: "Select needed folder",
    selectBrandingType: "Please select a branding type",
    phoneNumberBlank: "Phone is blank",
    phoneNumberWrongLengthUS: "Phone number must have 10 numbers.",
    radius: "Radius",
    verificationCodeSend: "Verification code has been sent to your phone number",
    fileInvalidType: "File type must be {{type}}",
    percentageInvalid: "Percentage should be less than 100",
    mortgage: {
      totalPriceBlank: "Mortgage amount is required",
      downPaymentBlank: "Down payment is required ",
      interestRateBlank: "Interest rate is required",
      termBlank: "Mortgage term is required"
    },
    reasonBlank: "Reason is blank",
    noteBlank: "Notes is blank",
    noteInvalid: "Field does not accept more than {{length}} characters",
    brandedFilesReadyHelp: "When enabled, DASH Direct users will be able to see and download branded files from Property Downloads section. Shared folders will be displayed to all users.",
    switchAccount: {
      countryRequired: "Country is required.",
      stateRequired: "State is required.",
      licenseRequired: "License number is required.",
      licenseMax: "License number must have at most 10 characters."
    }
  },
  placeholders: {
    email: "john@dash.com",
    firstName: "Brooklyn",
    lastName: "Simmonsy",
    apiReferralCode: "company-referral-code",
    apiInvitationExpiresAt: "MM/DD/YYYY",
    apiCompanyName: "The Reeves Group",
    companyName: "The Reeves Group",
    password: "Enter Password",
    oldPassword: "Type Old Password",
    newPassword: "Type New Password",
    confirmPassword: "Type Password Again",
    organizationName: "Organization Name",
    saleTeamName: "Ex: Dash Inc",
    url: "https://website.com",
    address: "Enter Address",
    map: "Find on Map",
    nameOfProperty: "Name of Property",
    selectOne: "Select One",
    salesGalleryAddress: "Enter the sales gallery address, including street address, suite number, and any special instructions for visitors",
    virtualTourUrl: "https://example.com/virtual-tour",
    virtualTourLabel: "e.g., 360\xB0 Tour, Matterport Tour",
    nameOfCity: "Name of City",
    nameOfStreet: "Number and Name of Street",
    priceRange: "Ex: $1,000,000 - $2,000,000",
    digits: "{{number}} Digits",
    nbrOfStories: "Number of Stories",
    year: "Year",
    nameOfArchitect: "Name of Architect",
    nbrOfTowers: "Number of Towers",
    nbrOfUnits: "Number of Units",
    nameOfDesigner: "Name of Designer",
    overviewPlaceholder: "Add any highlights related to the property. Max of {{number}} characters.",
    projectDetailsPlaceholder: "Add the property\u2019s Project Overview. Max {{number}} characters",
    taxInformationPlaceholder: "Add taxes/fees. Max {{number}} characters",
    websiteOfProperty: "https://website.com",
    priceOfProperty: "Price",
    salesTeam: "Select Sales Team",
    salesDirector: "Select Sales Director",
    salesAssociate: "Select Sales Associate",
    commission: "Input Commission",
    contactUrl: "Type Contact URL",
    inventoryName: "EX: B Line, Penthouse",
    inventoryType: "EX: Model, For Sale",
    ex: "EX",
    sqft: "EX: 1,234",
    totalSqft: "Auto-calculate",
    dragAndDropZone: "Drag and Drop or Click to",
    cardDescription: "Short description for the portfolio card",
    selectFiles: "Select Files",
    folderName: "Folder Name",
    role: "Select Role",
    saleTeam: "Select Sales Team",
    properties: "Select Properties",
    brokerLicenseNumber: "856456456",
    mediaName: "Media Name",
    phoneNumber: "856456456",
    verifyPhoneNumberCode: "A1B2",
    enterPasswordToOpenLink: "Enter the password to open this link",
    enterFolderName: "Enter Folder Name",
    alertName: "Enter Alert Name",
    enterDescription: "Enter Description",
    agencyName: "The Reeves Group",
    marketAreaName: "Market Area Name",
    amenityName: "Amenity Name",
    mortgageTotalPrice: "670,400.00",
    mortgageDownPayment: "20%",
    mortgageInterestRate: "4.5%",
    mortgageTerm: "30",
    mortgageTaxRate: "$3,000",
    mortgageInsuranceRate: "$1,500",
    defaultInventoryPlaceholder: "Type Default Inventory Details",
    averageBedroomsNumber: "Type Number",
    averageBathroomsNumber: "1",
    reasonUnActive: "Type the reason for deactivation.",
    note: "Enter Your Property Notes",
    salesTeamName: "Sales Team Name",
    markets: "Select Market",
    buildingTypes: "Select Property Types",
    portfolioName: "Enter portfolio name",
    description: "What is this portfolio about?",
    selectProperties: "Select properties to include",
    propertyName: "Enter title",
    propertyNameSearch: "Enter property name",
    shortOverview: "Provide a brief summary..."
  }
};

// src/assets/dictionary/en/pages.ts
var import_dash_common2 = require("dash-common");
var import_lodash2 = require("lodash");
var pages_default = {
  common: {
    sortModal: {
      title: "Sort Display Order",
      cancel: "Cancel",
      save: "Save",
      instruction: "Drag and drop to reorder items. Changes will be saved when you click Save.",
      empty: "No items to sort"
    }
  },
  signInPage: {
    welcomeHeader: "Welcome to DASH!",
    welcomeSubHeader: "Sign in to your account.",
    bottomLabel: "Don\u2019t have an account?",
    bottomLabelLink: "Create an account",
    loginWithGoogle: "Login with Google",
    loginWithMiamiRealtors: "Login with MIAMI REALTORS",
    sendLoginLink: "Send login link to email",
    backToLogin: "Back to Login",
    magicLinkSent: "If we found an account associated with the email <bold>{{email}}</bold>, a secure login link has been sent. Please check your inbox \u2014 and your spam folder if you do not receive it. For your protection, <bold>the link is only valid for 10 minutes</bold>."
  },
  signInMfaPage: {
    // Shared field copy
    codeLabel: "Code",
    codePlaceholder: "123456",
    codeRequired: "Please enter the code from your authenticator app.",
    // Enrollment (first-time setup)
    enableHeader: "Set up two-factor authentication",
    // DSH-936: choosing between the app and an emailed code
    methodChoiceSubHeader: "Two-factor authentication is required for your account. Choose how you would like to receive your codes.",
    methodAppTitle: "Authenticator app",
    methodAppBody: "Use an app like Google Authenticator or Authy. The most secure option, and it works without a connection.",
    methodEmailTitle: "Email",
    methodEmailBody: "We send a code to your inbox each time you sign in. Nothing to install.",
    methodRecommended: "Recommended",
    emailCodeHeader: "Check your email",
    emailCodeSubHeader: "We sent you a code. Enter it below to continue.",
    emailCodeSubHeaderWithEmail: "We sent a code to {{email}}. Enter it below to continue.",
    emailCodeRequired: "Please enter the code we emailed you.",
    resendCode: "Send another code",
    resendCodeIn: "Send another code in {{seconds}}s",
    enableScanSubHeader: "Two-factor authentication is required for your account. Scan the QR code below with your authenticator app.",
    enableCodeSubHeader: "Enter the code from your authenticator app to finish enabling two-factor authentication.",
    qrCodeError: "Something went wrong while generating the QR code. Please try again or contact support.",
    continueButton: "Continue",
    backButton: "Back",
    successHeader: "You\u2019re all set",
    successSubHeader: "Two-factor authentication is now enabled. You\u2019ll be asked for a code each time you sign in.",
    doneButton: "Done",
    // Verification (returning login)
    verifyHeader: "Two-factor authentication",
    verifySubHeader: "Enter the code from your authenticator app to continue.",
    confirmButton: "Confirm",
    supportHint: "If your code is not working, please contact support.",
    qrAlt: "MFA QR code"
  },
  brokerSignUpPage: {
    welcomeHeader: "Create a DASH Account",
    welcomeSubHeader: "Your privacy is important to us. DASH will never share your information. ",
    submitButtonLabels: "Go to the next step",
    agreeTermsLabel: "I agree to the",
    termsAndConditionsLabel: "terms and conditions,",
    termsAndConditionsError: "You must accept the terms and conditions to register an account.",
    smsTermsLabel: "and to receive a verification code via SMS (standard messaging rates may apply).",
    bottomLabel: "Already a DASH member?",
    bottomLabelLink: "Log In"
  },
  brokerCompleteSignUpPage: {
    resendCodeLabel: "Didn\u2019t receive a verification code?",
    emailResendCodeLabel: "Didn\u2019t receive a verification code?",
    submitButtonLabels: "Create an Account",
    codeResent: "SMS Verification has been sent.",
    emailSent: "Email Verification has been sent."
  },
  forgotPasswordPage: {
    welcomeHeader: "Forgot Password",
    welcomeSubHeader: "Enter your email address to receive a link to reset your password."
  },
  resetPasswordPage: {
    welcomeHeader: "Reset Password",
    welcomeSubHeader: "Input your new password",
    goBack: "Or <link>go back to the Sign in page</link>"
  },
  emailLinkAccessPage: {
    welcomeHeader: "Login with email link",
    successRedirecting: "Login successful! Redirecting...",
    goBack: "Or <link>go back to the Sign in page</link>",
    validatingLink: "Validating login link, please wait...",
    linkInvalidOrExpired: "The link is invalid or has expired. Please generate a new one.",
    tokenValidationError: "There was an error with token validation: {{error}}. Please generate a new one or contact support if the problem persists.",
    backToSignIn: "Go back to the Sign in Page",
    missingToken: "No token found in the URL. Please use the link sent to your email or request a new one."
  },
  organizationSignUpPage: {
    welcomeHeader: "Sign Up",
    welcomeSubHeader: "Please enter your password to sign up.",
    submitButtonLabel: "Sign Up"
  },
  organizationSignUpExpiredPage: {
    welcomeHeader: "Invitation Has Expired",
    welcomeSubHeader: "Please write to us at this email address so our administrators can resend your invitation."
  },
  organisationPage: {
    addOrganisationModalLabel: "Add Organization",
    editOrganizationModalLabel: "Edit Organization",
    addressUnavailable: "Address Unavailable",
    websiteUnavailable: "Website Unavailable",
    deleteOrganizationModalTitle: "Delete Organization",
    deleteOrganizationModalText: "Are you sure you want to delete this organization and all of its users? Properties associated with the organization will not be deleted."
  },
  organizationSaleTeams: {
    addOrganisationModalLabel: "Add Sales Team",
    editOrganizationModalLabel: "Edit Sales Team",
    addressUnavailable: "Address Unavailable",
    websiteUnavailable: "Website Unavailable",
    deleteOrganizationSaleTeamModalLabel: "Delete Sales Team",
    deleteOrganizationSaleTeamModalText: "Are you sure you want to delete the sales team {{saleTeamName}}?"
  },
  organizationUsers: {
    addOrganisationUserModalLabel: "Add User to Organization",
    editOrganisationUserModalLabel: "Edit User in Organization",
    inviteUserModalTitle: "Send Invite",
    inviteUserModalSubtitle: "Would you like to invite this user to DASH?",
    inviteUserModalCancelButton: "No, Thanks",
    inviteUserModalSubmitButton: "Invite",
    archiveUserModalTitle: "Archive User",
    archiveUserModalSubtitle: "Are you sure you want to archive this organization user?",
    unarchiveUserModalTitle: "Unarchive User",
    unarchiveUserModalSubtitle: "Are you sure you want to unarchive this organization user?"
  },
  amenityPage: {
    updateAmenityModalLabel: "Update Amenity",
    addAmenityModalLabel: "Add Amenity",
    deleteAmenityModalLabel: "Delete Amenity",
    deleteAmenityModalText: "Are you sure you want to delete the amenity: {{amenityName}}?"
  },
  marketAreasPage: {
    updateMarketAreaModalLabel: "Update Market Area",
    addMarketAreaModalLabel: "Add Market Area",
    deleteMarketAreaModalNote: "This may impact associated properties"
  },
  propertyPage: {
    propertyName: "Property Name",
    mediaItemsCount: "({{itemsCount}} Items)",
    propertyCreateModalTitle: "Add New Property",
    amenitiesTabLabel: "Features and Amenities",
    buildingDetails: "Property Details",
    salesGalleryHours: "Sales Gallery Hours",
    salesGalleryInfo: "Sales Gallery Information",
    salesGallery: "Sales Gallery",
    leasingOfficeHours: "Leasing Office Hours",
    leasingOfficeInfo: "Leasing Office Information",
    virtualTours: "Virtual Tours",
    virtualTour: "Virtual Tour",
    leasingOffice: "Leasing Office",
    viewDetails: "View Details",
    subscribeToUnlock: "Subscribe to unlock this property",
    viewAllHighlights: "View All Highlights",
    viewFullOverview: "View Full Overview",
    manageAmenities: "Manage Amenities",
    searchAmenities: "Search Amenities",
    propertyFeaturesAndAmenities: "Property Features and Amenities",
    removeAmenityFromPropertyModalTitle: "Remove Amenity",
    removeAmenityFromPropertyModalText: "Are you sure you want to remove the amenity {{amenityName}} from this property?",
    inventoryCreateModalTitle: "Add New Unit",
    slideshow: "Slideshow",
    main: "Main",
    inventoryEditModalTitle: "Edit Unit",
    completedIn: "Completed in {{date}}",
    estCompletion: "Est. Completion in {{date}}",
    uploadMedia: "Upload Media",
    cancelAllUpdates: "Cancel All Updates",
    clearUploadHistory: "Clear Upload History",
    floorPlan: "Floor Plan (PDF)",
    addFloorPlan: "Add Floor Plan",
    mediaFiles: "Media Files",
    searchMedia: "Search Folder and Media Files",
    allFileTypes: "All File Types",
    paginationLabel: "Showing Page {{page}} of {{total}}",
    paginationMediaLabel: "Showing Page {{page}} of {{total}}",
    noFilesPlaceholder: "There are no images or videos added to the Slideshow. You can add Slideshow content by going to the media tab and adding them to the default folder called Slideshow",
    addFolderModalLabel: "Create Folder",
    editFolderModalLabel: "Edit Folder",
    removeFolderModalLabel: "Delete Folder",
    editMediaModalLabel: "Edit File Name",
    removeFolderModalBodyLabel: "Are you sure you want to delete the folder \u201C{{folderName}}\u201D? The content in this folder will be moved to the files section.",
    removeFolderModalCheckboxLabel: "Check here to delete the folder contents as well",
    deleteFileModalTitle: "Delete File",
    deleteFileModalPlaceholder: "Are you sure you want to delete the file {{fileName}}?",
    bulkDeleteFileModalPlaceholder: "Are you sure you want to delete the {{numberOfFiles}} selected files?",
    folderDeletedMessage: "{{folderName}} was deleted successfully",
    salesTeam: "Sales Team",
    addMoreUsers: "Add More Users",
    leavePage: "Leave Page",
    goBack: "Go Back",
    confirmChangesModalTitle: "Your Changes Are Not Yet Saved",
    confirmChangesModalText: "Are you sure you want to leave this page? Your changes will not be saved.",
    confirmChangelogCreationModalTitle: "Property Updates Visibility",
    confirmChangelogCreationModalText: "Would you like to make the current changes visible to agents in the Public Property Updates History?",
    addToChangelogButton: "Yes, Make Public",
    dontAddToChangelogButton: "No, Keep Internal",
    addToChangelogCheckbox: "Add changes to public property updates history",
    moveFileModalTitle: "Move to Folder",
    moveFileModalText: "Select the folder to which you would like to transfer this file",
    moveToFolder: "Move to Folder",
    changeBranding: "Change Branding",
    updateBrandingTitle: "Update File Branding",
    updateBrandingType: "Update Branding Type",
    updateBranding: "Update Branding",
    bulkUpdateBrandingText: "Update branding type for {{quantity}} selected files",
    brandingTypeUpdated: "Branding type updated successfully",
    bulkBrandingTypeUpdated: "Branding type updated for {{count}} files",
    brandedFilesReadyEnabled: "Branded files are now ready",
    brandedFilesReadyDisabled: "Branded files are now marked as not ready",
    currentFile: "Current file",
    bulkActionsText: "Selected {{quantity}} items for bulk action",
    searchProperty: "Search by Property Name",
    price: "Price",
    propertyType: "Property Type",
    advanced: "Advanced",
    bedsAndBath: "Beds & Bath",
    allListing: "All Properties",
    alertListing: "Property Alerts",
    savedSearches: "Saved Searches",
    resultsFor: "{{total}} properties found",
    resultsLimited: "Showing {{total}} out of {{totalProperties}}+ properties",
    availableUnits: "Avail. Units",
    from: "From",
    upTo: "Up to",
    noProperties: "Your search returned no properties.",
    showFeaturesAndAmenities: "Show All Features & Amenities",
    seeMoreAmenities: "See {{count}} More Amenities",
    seeMoreAmenities_one: "See {{count}} More Amenity",
    seeMoreAmenities_other: "See {{count}} More Amenities",
    startFreeTrial: "Start a Free Trial",
    lockedAmenitiesAriaLabel: "Locked content. Upgrade to view {{count}} more amenities. Start free trial.",
    lockedAmenitiesAriaLabel_one: "Locked content. Upgrade to view {{count}} more amenity. Start free trial.",
    lockedAmenitiesAriaLabel_other: "Locked content. Upgrade to view {{count}} more amenities. Start free trial.",
    filterTitle: "Advanced Filter",
    filterSubtitle: "Apply advanced filters to your search.",
    numberOfBedrooms: "Number of Bedrooms",
    numberOfBathrooms: "Number of Bathrooms",
    saveAndCreateAlert: "Save and Create Alert",
    createAlert: "Create Alert",
    clearFilter: "Clear Filter",
    goToTheClosestProperty: "Go to the Closest Property",
    noPropertiesWereFoundOnMap: "No properties were found for your query. Use the closest properties search function to view nearby properties.",
    contact: "Contact Development",
    contactDevelopmentSales: "Contact Development Sales",
    contactAgent: "Contact Me For Availability",
    contactLeasingOffice: "Contact Leasing Office",
    addToPortfolio: "Add to Portfolio",
    addToPortfolioFolder: "Add to Portfolio",
    addToPortfolioTooltip: "Add to portfolio",
    addToMorePortfoliosTooltip: "Add to more portfolios",
    generatePropertyPortfolio: "Create Portfolio",
    viewAsClient: "View as Client",
    contactMessage: "Questions? Contact the property developer below.",
    message: "Message",
    lastUpdated: "Last Updated",
    history: "History",
    checkAvailability: "Check Availability",
    propertyPortfolio: "Property Portfolio ({{amount}})",
    viewAll: "View All",
    presentedBy: "Presented by",
    editAmenityNameModalTitle: "Edit Amenity Name",
    deleteProperty: "Delete Property",
    deletePropertyModalConfirmationText: "Are you sure you want to delete this property?",
    appearedDate: "Date Added",
    scheduledConstruction: "Scheduled Construction",
    numberOfUnits: "Number of Units",
    yearBuilt: "Year Built",
    addToTrackToast: "Property has been added to the tracking folder",
    addToSaveToast: "Property has been added to your watchlist",
    propertyAlreadyTracked: "You are already tracking this property.",
    propertyAlreadySaved: "This property is already in your watchlist.",
    propertyRemovedFromTrack: "Property has been removed from your tracking list",
    propertyRemovedFromSave: "Property has been removed from your watchlist",
    unavailablePropertyTitle: "Property Unavailable",
    unavailablePropertySubTitle: "This property is currently unavailable. Contact Support for more details.",
    propertyNote: "Property Notes",
    deletePropertyNote: "Delete Note",
    deletePropertyNoteModalConfirmationText: "Are you sure you want to delete the note from this property note list?",
    addSaleTeam: "Add Sales Team",
    propertySearchPlaceholder: "Building, City, Neighborhood, Community",
    allMarket: "Market Area",
    priceRange: "Price Range",
    allPropertyStatus: "Property Status",
    completionDate: "Est. Completion Year",
    propertyLocation: "Property Location",
    developmentAndSalesLabel: "Development & Sales",
    mediaEmptyState: "There are no files in this folder",
    deleteSalesTeam: "Delete Sales Team",
    deleteSalesTeamText: "Are you sure you want to delete the Sales Team?",
    noPrimaryOrganizationError: "Property must have a primary organization.",
    noMarketAreaError: "Property must have a market area.",
    statusUpdateSuccess: "Status updated successfully",
    statusUpdateError: "Failed to update status",
    cmsStatusUpdateSuccess: "CMS status updated successfully",
    cmsStatusUpdateError: "Failed to update CMS status",
    visibilityStatusUpdateSuccess: "Visibility status updated successfully",
    visibilityStatusUpdateError: "Failed to update visibility status",
    sort: "Sort",
    sortBy: "Sort by",
    seeXMoreUnits: "See {{count}} more units",
    seeXMoreUnits_one: "See {{count}} more unit",
    seeXMoreUnits_other: "See {{count}} more units",
    seeXMoreUnitsCaps: "See {{count}} More Units",
    seeXMoreUnitsCaps_one: "See {{count}} More Unit",
    seeXMoreUnitsCaps_other: "See {{count}} More Units",
    viewAllFloorPlansPricingAvailability: "View all floor plans, pricing & availability",
    showingXOfYUnits: "Showing {{current}} of {{total}} units",
    today: "today",
    daysAgo: "{{days}} days ago",
    daysAgo_one: "{{days}} day ago",
    daysAgo_other: "{{days}} days ago",
    monthsAgo: "{{months}} months ago",
    monthsAgo_one: "{{months}} month ago",
    monthsAgo_other: "{{months}} months ago",
    yearsAgo: "{{years}} years ago",
    yearsAgo_one: "{{years}} year ago",
    yearsAgo_other: "{{years}} years ago"
  },
  propertyMediaFolderPage: {
    noFilesPlaceholder: "This folder is empty"
  },
  featuredPortfolios: {
    propertyUnavailable: "Property not found or no longer available.",
    title: "Featured Portfolios",
    subtitle: "Curated new development collections you can access, save, edit and share instantly with your own branded link.",
    viewAll: "View All",
    portfolioDetails: "View Details",
    details: "Portfolio Details",
    otherProperties: "Other Properties",
    moreProperties: "Other Residences",
    properties_one: "{{count}} property",
    properties_other: "{{count}} properties",
    createModalTitle: "New Featured Portfolio",
    createButton: "Create Portfolio",
    editPortfolio: "Edit Portfolio",
    deletePortfolio: "Delete Portfolio",
    deleteConfirmation: "Are you sure you want to delete this portfolio? This action cannot be undone.",
    notFound: "Portfolio not found",
    visibilityUpdateSuccess: "Visibility updated successfully",
    visibilityUpdateError: "Failed to update visibility",
    noPropertiesAdded: "No properties added to this portfolio",
    propertyAlreadyAdded: "This property is already in the portfolio",
    propertyAdded: "Property added",
    propertyRemoved: "Property removed",
    noSearchResults: "No properties found",
    labels: {
      overview: "Overview",
      cardDescription: "Card Description",
      saved: "Portfolio saved successfully",
      previewModal: "Preview Modal",
      previewCard: "Preview Card",
      properties: "Properties",
      propertiesAdded: "Properties Added",
      finishSorting: "Finish Sorting",
      resetOrder: "Reset Order",
      resetChanges: "Reset Changes",
      sort: "Sort"
    },
    sortModal: {
      title: "Sort Public Featured Portfolios",
      cancel: "Cancel",
      save: "Save",
      instruction: "Drag and drop to reorder portfolios. Changes will be saved when you click Save.",
      noPublicPortfolios: "No public portfolios to sort"
    },
    makePublicModal: {
      modalTitle: "Make Portfolio Public",
      warningTitle: "Make Portfolio Public?",
      cancel: "Cancel",
      continue: "Continue",
      makePublic: "Make Public",
      message: 'Where would you like to place "{{portfolioName}}"?',
      warningMessage: 'The portfolio "{{portfolioName}}" currently has only {{count}} {{count}} added. Are you sure you want to publish it?',
      warningMessage_one: 'The portfolio "{{portfolioName}}" currently has only {{count}} property added. Are you sure you want to publish it?',
      warningMessage_other: 'The portfolio "{{portfolioName}}" currently has only {{count}} properties added. Are you sure you want to publish it?',
      firstOption: "First",
      firstOptionDesc: "Portfolio will appear at the beginning",
      lastOption: "Last",
      lastOptionDesc: "Portfolio will appear at the end"
    },
    sortSuccess: "Portfolios reordered successfully",
    sortError: "Failed to reorder portfolios",
    placeholders: {
      searchProperty: "Search for a property..."
    },
    buttons: {
      addProperty: "Add Property"
    },
    resetChangesConfirmation: {
      title: "Reset All Changes?",
      message: "Are you sure you want to reset all changes? This will remove any newly added properties and revert to the last saved state."
    },
    resetOrderConfirmation: {
      title: "Reset Property Order?",
      message: "Are you sure you want to reset the property order? This will restore the original order of saved properties while keeping newly added ones."
    },
    resetConfirmation: {
      cancel: "Cancel",
      confirm: "Confirm"
    },
    modal: {
      title: "Featured Portfolio",
      properties: "Properties",
      overview: "Overview",
      viewPortfolio: "View Portfolio",
      sharePortfolio: "Share Portfolio",
      completionFrom: "Completion from",
      to: "to",
      propertiesCount: "properties",
      marketAreasLabel: "Market areas in this portfolio:",
      showLess: "Show less",
      xMore: "+{{count}} more",
      estCompletion: "Est. completion {{year}}"
    },
    agentBanner: {
      title: "Featured Portfolio",
      agentCollection: "Currently Viewing",
      share: "Share",
      notice: "This header will NOT be displayed when you share the portfolio with your clients."
    },
    quickSharePortfolio: "Instant-Share Link",
    sharePortfolio: "Share Featured Portfolio",
    addToSaveToast: "Portfolio has been added to your watchlist",
    portfolioAlreadySaved: "This portfolio is already in your watchlist.",
    portfolioRemovedFromSave: "Portfolio has been removed from your watchlist",
    copyToPortfolio: "Copy to My Portfolio",
    copyToPortfolioDescription: "Copy this featured portfolio to allow further customization.",
    copyToPortfolioButton: "Copy to My Portfolios",
    copying: "Copying...",
    toasts: {
      featuredPortfolioCopied: "Featured Portfolio copied successfully!",
      copyError: "Failed to copy portfolio",
      portfolioNameExists: "You already have a Portfolio with this name"
    },
    duplicateFeaturedPortfolioModal: {
      title: "Portfolio Already Exists",
      samePortfolioNameText: "A portfolio with this name already exists. You can share the existing portfolio using the link below:",
      unableToLoadPortfolioData: "Unable to load portfolio data. Please try again.",
      portfolioDataNotFound: "Portfolio data not found. Please try again.",
      clickHere: "Click here",
      toViewPortfolioDetails: "to view portfolio details.",
      createNewPortfolioText: "To create a new portfolio, enter a different name below:",
      createPortfolio: "Create Portfolio",
      portfolioNameAlreadyExistsError: "You already have a Portfolio with this name"
    },
    seeXMore: "See {{count}} More",
    seeXMore_one: "See {{count}} More Portfolio",
    seeXMore_other: "See {{count}} More Portfolios",
    seeXMoreCaps: "See {{count}} More",
    seeXMoreCaps_one: "See {{count}} More",
    seeXMoreCaps_other: "See {{count}} More",
    viewAllPortfolios: "View all featured portfolios",
    startFreeTrial: "Start a Free Trial",
    unlockDescription: "Access our ready-to-share curated collections",
    unlockPortfolio: "Unlock portfolio",
    unlockPortfolios: "View Portfolios"
  },
  featuredProperties: {
    title: "Featured Properties",
    subtitle: "Individual properties you can curate and feature for instant access and sharing.",
    createModalTitle: "New Featured Property",
    createButton: "Create Property",
    createSuccess: "Featured Property created successfully",
    visibilityUpdateSuccess: "Visibility updated successfully",
    visibilityUpdateError: "Failed to update visibility",
    labels: {
      property: "Property Selected",
      propertyRequired: "Property is required",
      overview: "Overview",
      shortOverview: "Short Overview",
      bannerPreview: "Banner Preview",
      saved: "Featured property saved successfully",
      searching: "Searching...",
      noPropertiesFound: "No properties found",
      desktopPreviewComingSoon: "Desktop preview coming soon",
      mobilePreviewComingSoon: "Mobile preview coming soon",
      overviewPlaceholder: "Provide a detailed overview...",
      shortOverviewPlaceholder: "Provide a brief summary..."
    },
    deleteProperty: "Delete Property",
    sortModal: {
      title: "Sort Public Featured Properties",
      cancel: "Cancel",
      save: "Save",
      instruction: "Drag and drop to reorder properties. Changes will be saved when you click Save.",
      noPublicProperties: "No public properties to sort"
    },
    sortSuccess: "Display order updated successfully",
    sortError: "Failed to update display order",
    makePublicModal: {
      modalTitle: "Make Property Public",
      warningTitle: "Make Property Public?",
      cancel: "Cancel",
      continue: "Continue",
      makePublic: "Make Public",
      message: 'Where would you like to place "{{portfolioName}}"?',
      warningMessage: 'The property "{{portfolioName}}" is about to be published. Are you sure you want to continue?',
      warningMessage_one: 'The property "{{portfolioName}}" is about to be published. Are you sure you want to continue?',
      firstOption: "At the beginning",
      firstOptionDesc: "Place at the first position of the list",
      lastOption: "At the end",
      lastOptionDesc: "Place at the last position of the list"
    }
  },
  propertyPreviewPage: {
    websiteLink: "Website Link",
    generalTabLabel: "Property Info",
    additionalTabLabel: "Additional Info",
    marketingTabLabel: "Marketing Files",
    propertyDownloadsTabLabel: "Property Downloads",
    downloadsTabLabel: "Downloads",
    downloadsLabel: "Downloads",
    developerInfoLabel: "Developer",
    salesTeamLabel: "Sales Team",
    propertyManagementLabel: "Property Management",
    additionalInformation: "Additional Information",
    additionalInformationShort: "Addl. Info",
    nbrOfStories: "Number of Stories",
    nbrOfTowers: "Number of Towers",
    constructionDate: "Construction Date",
    completionDate: "Completion Date",
    marketingFilesLabel: "Marketing Files",
    marketingFilesSecondLabel: "Below you will find all the Marketing Files related to this property.",
    propertyDownloadsLabel: "Property Downloads",
    propertyDownloadsSecondLabel: "Below you will find all the downloads and resources available for this property.",
    noSaleTeamLabel: "No Sales Team",
    moreInformation: "More Information",
    historyLabel: "This property was last {{date}}.",
    lastUpdatedToday: "This property was last updated today.",
    lastUpdatedDaysAgo_one: "This property was last updated {{count}} day ago.",
    lastUpdatedDaysAgo_other: "This property was last updated {{count}} days ago.",
    lastUpdatedLabel: "Last updated {{date}}",
    unknownDateLabel: "Unknown",
    shareActionLabel: "Share",
    saveActionLabel: "Add to Watchlist",
    savedActionLabel: "In Watchlist",
    shareProperty: "Share Property",
    shareThisProperty: "Share This Property",
    quickShareProperty: "Instant-Share Link:",
    generateQuickShareLink: "Generate Sharing Link",
    portfoliosDescription: "If you want more customization and access to traffic analytics, you can use Portfolios:",
    quickShareDescription: "Copy direct link to share this property immediately",
    loadingShareLink: "Generating share link...",
    instantShareDescription: "Share now with an agent-branded link.",
    addToPortfolioDescription: "Add this property to one of your saved property portfolios.",
    createPortfolioDescription: "Customize settings, add downloads and fine-tune before sharing.",
    stickyHeader: {
      propertyInfo: "Property Information",
      propertyInfoShort: "Property Info",
      inventory: "Floor Plans",
      contactInfo: "Contact Info",
      contactInfoShort: "Contact",
      downloads: "Downloads",
      downloadsShort: "Files"
    }
  },
  wasDeleted: {
    title: "{{entityName}} was deleted"
  },
  notFoundPage: {
    title: "Not Found",
    subtitle: "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable",
    buttonLabel: "Go to Homepage",
    notFound404: "404 Not Found",
    generalTabLabel: "Property Info",
    additionalTabLabel: "Additional Info",
    marketingTabLabel: "Marketing Files"
  },
  idx: {
    unauthorizedTitle: "Unauthorized",
    unauthorizedSubtitle: "Hey, this domain is not authorized to use our Exchange Data!",
    visitDash: "Visit DASH",
    labels: {
      showDashCredit: "Show DASH Data Credit",
      showPropertyDownloads: "Show sales materials",
      showCustomPropertyDownloads: "Show custom sales materials only",
      managePropertyDownloads: "Manage sales materials",
      back: "Back",
      backToPortfolio: "Back to portfolio",
      contact: "Contact"
    },
    tooltips: {
      showDashCredit: "Enable or disable the 'Powered By DASH' credit on your eXchange feeds.",
      showPropertyDownloads: "Enable to allow clients to view all sales materials available for a property.",
      showCustomPropertyDownloads: "Enable to display only the sales materials customized by you."
    }
  },
  footer: {
    termsLabel: "Terms & Conditions",
    policyLabel: "Privacy Policy",
    rightLabel: "2026 DASH Inc. All Rights Reserved.",
    termsOfService: "Terms of Service"
  },
  completeSignUp: {
    pickPlan: "Pick Plan",
    setupSubscriptionLabel: "Setup Subscription",
    setupSubscriptionShortLabel: "Setup",
    additionalLabel: "Additional Info",
    additionalShortLabel: "Addl. Info"
  },
  completeSignUpPickSubscription: {
    header: "Pick a Subscription",
    subheader: "Choose from the available options",
    // DSH-923: shown only on the API invite path, where the API plan is the one
    // option. Deliberately a plain sentence and not a link/button — an invitee
    // who wants the agent platform should be able to find their way, without
    // being offered an exit from the path they were invited into.
    apiOnlyNote: "You were invited to DASH API, so this is the plan available here. If you are a real estate agent looking for the DASH platform instead, you can sign up separately at dashtodash.com.",
    trialLabel: "{{countOfDays}} Day Free Trial",
    noTrialLabel: "Upgrade to Pro",
    submitButtonLabel: "Free {{countOfDays}}-day trial",
    cancelMySubscription: "Cancel my subscription",
    couponMiddleLabel: "vs our {{recurringType}} plan",
    stayOnthisPlan: "Stay on this plan",
    subscribeBasic: "Start for Free With Basic plan",
    subscribePro: "Subscribe to PRO plan",
    subscribeIdx: "Subscribe to DASH Exchange plan",
    promoInvalid: "That promo code isn't valid. Remove it or enter a different one.",
    promoLabel: "Have a promo code?",
    promoPlaceholder: "Enter code (optional)",
    newBadge: "NEW",
    subscriptionProductRecurringLabels: {
      [(0, import_lodash2.camelCase)(import_dash_common2.RecurringTypesEnum.FREE)]: "Free",
      [(0, import_lodash2.camelCase)(import_dash_common2.RecurringTypesEnum.MONTH)]: "Monthly",
      [(0, import_lodash2.camelCase)(import_dash_common2.RecurringTypesEnum.SIXMONTH)]: "Every six months",
      [(0, import_lodash2.camelCase)(import_dash_common2.RecurringTypesEnum.YEAR)]: "Yearly"
    }
  },
  completeSignUpAddAdditionalInfoPage: {
    header: "Additional Info",
    subheader: "Fill in now or later",
    profileSubHeader: "Profile",
    locationSubHeader: "2. Location",
    settingsSubHeader: "3. Property Settings"
  },
  portfoliosPage: {
    addPropertyToPortfolioModalTitle: "Add Property to a Portfolio",
    addPropertyToPortfolioModalText: "Create portfolios to organize and share property content with your clients and associates.",
    existingFolder: "Existing Portfolio",
    selectFolder: "Select Portfolio",
    createNewFolder: "Create a New Portfolio",
    folderName: "Portfolio Name",
    enterFolderName: "Enter a New Portfolio Name",
    statuses: {
      [import_dash_common2.BrokerPortfolioStatusesEnum.PRIVATE]: "Private/Draft",
      [import_dash_common2.BrokerPortfolioStatusesEnum.PUBLIC]: "Public Link",
      password: "Password-protected Link"
    },
    propertiesTotal: "{{total}} Properties",
    portfoliosTotal: "{{total}} Portfolio Items",
    totalViews: "{{total}} Views",
    views: "Views",
    portfoliosSearchPlaceholder: "Search by Portfolio Name",
    portfoliosPropertySearchPlaceholder: "Search by Property Name",
    portfoliosSearchPlaceholderShort: "Search by Portfolio",
    portfoliosPropertySearchPlaceholderShort: "Search by Property",
    sort: "Sort",
    sortBy: "Sort By",
    addNew: "Add New",
    portfolioName: "Portfolio Name",
    paginationLabel: "Showing Portfolio {{page}} of {{total}}",
    emptyPageLabel: "You don't have any portfolios yet!",
    emptyPageSubLabel: "Create portfolios to organize and share property content with your clients and associates.",
    emptyPageButtonLabel: "Start Browsing",
    emptyPageGuideLabel: "New to portfolios?",
    emptyPageGuideSubLabel: "Our guide walks you through building them and sharing them with clients.",
    emptyPageGuideLinkLabel: "Read the DASH Pro Quick-Start Guide",
    createFolderModalTitle: "Add Portfolio",
    createFolderModalSubtitle: "Then add properties to your portfolio for sharing.",
    portfolioNamePlaceholder: "Enter a New Portfolio Name",
    toasts: {
      shareLinkCopied: "Link Copied!",
      folderIsCreated: "Portfolio Created",
      folderIsUpdated: "Portfolio Updated",
      folderIsDeleted: "Portfolio Deleted",
      portfolioIsCreated: "Portfolio Created",
      propertyWasAdded: "Property Added to Portfolio",
      propertyAlreadyAdded: "Property already added to this portfolio"
    },
    removePropertyFromPortfolioModal: {
      header: "Delete Property from Portfolio",
      subheader: "Are you sure you want to delete this property from your portfolio?"
    },
    removeFolderFromPortfolioModal: {
      header: "Delete Portfolio",
      subheader: "Are you sure you want to delete this portfolio?"
    },
    movePropertyToPortfolioFolderModal: {
      title: "Add Property to Portfolio",
      subtitle: "Create a new Portfolio for this property, or add it to an existing portfolio?"
    },
    duplicatePortfolioModal: {
      title: "Portfolio Already Exists",
      createNewPortfolio: "Create New Portfolio",
      samePortfolioNameText: "A portfolio with this name already exists. You can share the existing portfolio using the link below:",
      createNewPropertyPortfolioText: "To create a new portfolio, enter a different name below:",
      portfolioNameAlreadyExistsError: "The new portfolio name entered already exists.",
      loadError: "Unable to load portfolio data. Please try again.",
      notFoundError: "Portfolio data not found. Please try again.",
      viewDetailsLink: "<italic><link>Click here</link> to view the portfolio details.</italic>"
    },
    followsLocationsOption: "{{name}} (follows locations)",
    followsLocationsHint: "Its properties will follow the locations you pick.",
    newFolderLabel: "New folder",
    emptyLocationsTitle: "No properties in these locations yet",
    emptyLocationsText: "Properties listed in this portfolio's locations will show up here automatically.",
    viewProperties: "View Properties",
    emptyPortfolioFolderSubtitle: "This portfolio is empty. To learn how to add properties, visit DASH Support",
    emptyPortfolioFolderTitle: "You don't have any properties yet!",
    emptyPortfolioFolderText: "Visit a property and add it to this portfolio to share it with your clients!",
    contactMe: "Contact Me",
    availability: "Availability",
    propertiesReady: "Properties Ready",
    propertiesSold: "Properties Sold",
    propertiesReadyShort: "Props. Ready",
    propertiesSoldShort: "Props. Sold",
    customers: "Customers",
    openPortfolioWithPasswordModal: {
      title: "Open the Portfolio",
      subtitle: "Please enter the password to view this portfolio."
    },
    rootFolder: "Root Folder",
    moreAboutPresenter: "More About Presenter",
    viewPropertyPortfolio: "View Property Portfolio",
    unitSizes: "Unit Sizes",
    customize: "Customize",
    propertyComparison: "Property Comparison",
    selectItemsToCompare: "Select Items to Compare",
    viewSharedPortfolio: "View Shared Portfolio",
    unavailablePortfolioPage: {
      title: "Unavailable Portfolio",
      subtitle: "Portfolio is currently unavailable. Contact the agent who shared it for more details."
    }
  },
  portfolioDetailsPage: {
    labels: {
      properties: "{{number}} Properties",
      shared: "Shared",
      views: "{{number}} Views",
      shareFolder: "Share Portfolio",
      deleteFolder: "Delete Portfolio",
      moveProperty: "Move Property",
      removeProperty: "Remove Property",
      move: "Move"
    },
    sharePortfolioForm: {
      header: "Share Portfolio",
      subHeader: "Choose how you want to share the portfolio.",
      publicShareType: "Public Link",
      privateShareType: "Private/Draft Portfolio",
      passwordType: "Password-Protected Link",
      passwordPlaceholder: "Enter a preferred password for this portfolio link",
      alertLabel: "This Portfolio is visible only to you; no others can view it.",
      emptyPortfolioAlertLabel: "This portfolio is empty. Add properties to be able to share it.",
      downloadsTooltip: "Allow visitors to view and download property media files and brochures you choose to share with them.",
      agentPopupTooltip: "Display a popup with agent contact info and portfolio list to visitors. Won\u2019t be displayed for single property portfolios.",
      showAgentPopup: "Show Agent Popup"
    },
    clientViewBanner: {
      message: "You are viewing this property in Presentation Mode.",
      switchToAgentView: "Switch to Agent View"
    }
  },
  portfolioFolderPreviewPage: {
    header: "{{totalCount}} properties are in this portfolio.",
    subHeader: "If you like these properties, please contact your agent",
    livingArea: "Living Area",
    bathrooms: "Bathrooms",
    bedrooms: "Bedrooms"
  },
  profilePage: {
    labels: {
      accountInfo: "Account Info",
      billing: "Billing",
      settings: "Settings",
      feedback: "Feedback",
      support: "Support",
      choosePlan: "Choose a plan"
    },
    billing: {
      stayOnThisPlan: "Stay on This Plan",
      active: "Active",
      deleted: "Deleted",
      cancelled: "Canceled",
      transactionHistory: "Transaction History",
      subscribe: "Subscribe",
      freeTrial: "Free {{trial}}-day trial",
      paymentMethod: "Payment Methods",
      upgradePlan: "Upgrade Plan",
      emptyPaymentMethodsText: "Please select another default payment method to renew your subscription",
      addPaymentMethod: "Add a Payment Method",
      default: "Default",
      expirationDate: "Expiration Date {{expiredMonth}}/{{expiredYear}}",
      recurringTypeChangeModalTitle: "Your recurring type will change",
      downgradeModalTitle: "Your subscription will be downgraded",
      cancelModalTitle: "Please tell us why you are canceling your subscription",
      cancelModalText: "If you cancel your subscription, your plan will not renew on your next billing date. You will continue to have full access to your plan\u2019s services and features until the expiration date. You can subscribe again at any time.",
      recurringTypeChangeModalText: "Your subscription recurring type will change to {{recurringType}} {{plan}} on your next billing date.",
      downgradeModalText: "Your subscription will downgrade to {{plan}} on your next billing date.",
      downloadAll: "Download All",
      cancelReasons: {
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.I_DONT_NEED_DASH_ANYMORE]: "I no longer need DASH's tools",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.IT_DOESNT_MEET_MY_NEEDS_EXPECTATIONS]: "DASH doesn't meet my needs/expectations",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.PLANS_COST_TOO_MUCH]: "DASH's plans cost too much",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.UNADDRESSED_ERRORS_OR_BUGS]: "Unaddressed errors or bugs",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.IM_USING_DIFFERENT_SERVICE]: "I'm using a different service",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.OTHER]: "Other"
      },
      otherCancelReasonPlaceholder: "Additional Information (optional)",
      cancelPlan: "Cancel Plan",
      changeRecurringType: "Change recurring type",
      backToBilling: "Back to Billing",
      addPaymentModalTitle: "Add a Payment Method",
      addPaymentModalSubTitle: "All information remains confidential and will not be shared",
      deletePaymentMethod: "Delete Payment Method",
      deletePaymentMethodDescription: "Are you sure you want to delete this payment method?",
      subscriptionProductChanged: "Your subscription has been changed!",
      unsuccessfulPayment: "Unsuccessful Payment",
      changePlanConfirmationModal: {
        upgradeButton: "Upgrade",
        downgradeButton: "Downgrade",
        yesButton: "Yes",
        upgradeTitle: "Upgrade to {{name}} Plan",
        downgradeTitle: "Downgrade to {{name}} Plan",
        changeToSixMonthPlan: "Change to six-month plan",
        changeToMonthlyPlan: "Change to monthly plan",
        changeDescription: "Are you sure you want to change your subscription plan from {{old}} to {{new}}?"
      },
      changeToSixMonthPlan: "Change to six-month plan",
      changeToMonthlyPlan: "Change to monthly plan",
      upgradeDownloadPlanModalTitle: "Upgrade Your Subscription to Unlock Unbranded Downloads!",
      upgradePortfolioPlanModalTitle: "Upgrade Your Subscription to Unlock Agent Portfolios",
      upgradeCompleteAccountPlanModalTitle: "Start a Trial to Access All Properties",
      upgradeExchangePlanModalTitle: "Upgrade Your Subscription to Unlock Easy Website Integration",
      upgradeSavedPropertiesPlanModalTitle: "Upgrade Your Subscription for an Unlimited Watchlist",
      upgradePlanModalSavedPropertiesSubtitle: "You've reached the {{limit}}-property limit on your free plan. Upgrade your subscription to add unlimited properties to your watchlist and keep track of every development you're watching, all in one place.",
      upgradePlanModalTitle: "Upgrade Subscription",
      successfulUpgradeMessage: "Your subscription was upgraded!",
      trialUpgrade: {
        title: "Start Your Free Trial",
        intro: "Your {{days}}-day free trial of {{plan}} starts today. Cancel before {{date}} and you go back to {{previousPlan}}.",
        currentPlanFallback: "your current plan",
        trialRow: "{{plan}} ({{days}}-day free trial)",
        creditRow: "Unused time on your current plan",
        creditTooltip: "Credit for the unused time on your current plan. It is applied to your first charge on {{date}}, not today.",
        creditCaption: "Applied to your first charge",
        thenRow: "From {{date}}",
        pricePerMonth: "${{price}} / month",
        pricePerYear: "${{price}} / year",
        confirmButton: "Start Free Trial",
        footerNote: "*You won't be charged until {{date}}",
        successToast: "Your free trial has started!"
      },
      trialRevert: {
        banner: "Your {{plan}} free trial ends on {{date}}, and your plan then goes back to {{previousPlan}}. You will not be charged for {{plan}}.",
        bannerAction: "Keep {{plan}}",
        undoButton: "Undo trial cancellation",
        planFromDate: "Your plan from {{date}}",
        previousPlanFallback: "your previous plan",
        keepTitle: "Keep {{plan}}",
        keepSubtitle: "Undo your trial cancellation",
        keepText: "Your free trial continues, and {{plan}} starts billing on {{date}}.",
        returnCanceledTitle: "Return to {{previousPlan}} canceled",
        returnCanceledText: "Your plan will no longer go back to {{previousPlan}} on {{date}}.",
        cancelAgainNote: "You can cancel the trial again at any time before {{date}}.",
        keepButton: "Keep {{plan}}",
        keepLoading: "Updating...",
        keepSuccess: "Your free trial will continue.",
        cancelTrialSubtitle: "Your plan goes back to {{previousPlan}} when the trial ends",
        cancelTrialUntil: "Until {{date}}:",
        cancelTrialUntilText: "You'll keep using all {{plan}} features",
        cancelTrialAfter: "After {{date}}:",
        cancelTrialAfterText: "Your plan goes back to {{previousPlan}}",
        cancelTrialNoCharge: "You will not be charged for {{plan}}",
        cancelTrialToast: "Trial canceled. Your plan goes back to {{previousPlan}} on {{date}}."
      },
      upgradePlanModalDownloadSubtitle: "With DASH Pro, you can easily download ready-to-share unbranded marketing content. Upgrade your subscription now for unlimited access to property content and other useful features.",
      upgradeCompleteAccountPlanModalSubtitle: "Get access to 400+ New Developments across Florida to boost your sales!",
      banners: {
        scheduledDowngrade: "Your subscription is scheduled to downgrade on {{date}}. <link>Cancel the downgrade</link> to keep or change your current plan.",
        scheduledCancellation: "Your subscription will be canceled on {{date}}. <link>Renew your plan</link> and keep enjoying DASH's full benefits!"
      },
      billingProblem: "I have a billing problem",
      cancelDowngrade: {
        success: "Scheduled downgrade canceled! Your current plan will continue.",
        error: "There was an error canceling the downgrade.",
        title: "Cancel Scheduled Downgrade",
        subtitle: "Keep your current plan active",
        keepPlan: "Keep {{plan}}",
        keepBenefits: "Continue enjoying all the benefits of your current plan",
        willBeCanceled: "Downgrade to {{plan}} on {{date}} will be canceled",
        rateNote: "Your subscription will continue at the current plan rate. You can change plans at any time.",
        canceling: "Canceling...",
        confirmButton: "Cancel Downgrade"
      },
      invoicePreview: {
        upgraded: "Your subscription was upgraded!",
        downgradeScheduled: "Your subscription is scheduled to downgrade.",
        title: "Confirm your subscription changes",
        fetchError: "\u26A0\uFE0F There was a problem while fetching your data. Please try again later or contact support.",
        promoCode: "Promo code",
        scheduleDowngrade: "Schedule Downgrade",
        addPaymentMethodWarning: "\u26A0\uFE0F Please <link>add a payment method</link> before continuing.",
        amountOff: "-${{amount}} OFF",
        percentOff: "-{{percent}}% OFF",
        amountDueToday: "Amount due today",
        amountDueStarting: "Amount due starting {{date}}",
        paymentMethod: "Payment Method",
        items: "Items",
        planRemainsActive: "Your current plan will remain active until <bold>{{date}}</bold>."
      },
      paymentAdded: "Payment method added!",
      paymentSetDefault: "Payment method set as default!",
      paymentError: "Error: {{message}}",
      paymentDetails: "Payment details",
      cardholderInfo: "Cardholder billing information",
      clientSecretError: "Failed to fetch client secret.",
      promoCodeInvalidChars: "Only letters and numbers are allowed",
      promoCodePlaceholder: "Enter coupon here...",
      changeConfirm: {
        titleUpgrade: "Confirm Subscription Upgrade",
        titleDowngrade: "Confirm Subscription Downgrade",
        reviewUpgrade: "Review your upgrade details",
        reviewDowngrade: "Review your downgrade details",
        confirmDowngrade: "Confirm Downgrade",
        confirmAndPay: "Confirm & Pay ${{amount}}",
        footerCharged: "*Your card will be charged immediately",
        footerDowngradeOn: "*Downgrade takes effect on {{date}}",
        footerDowngradeEnd: "*Downgrade will take effect at the end of your current billing period",
        noPaymentMethod: "No payment method",
        periodAnnual: "Annual",
        periodMonthly: "Monthly",
        billingAnnual: "annual",
        billingMonthly: "monthly",
        upgradeDescription: "You're <bold>upgrading to {{plan}}</bold> with {{billing}} billing. Your new subscription starts immediately.",
        downgradeDescription: "You're scheduling a <bold>downgrade to {{plan}}</bold> with {{billing}} billing. Your new subscription will start after your current billing period ends.",
        downgradeDescriptionWithDate: "You're scheduling a <bold>downgrade to {{plan}}</bold> with {{billing}} billing. Your new subscription will start after your current billing period ends on {{date}}.",
        unusedCredit: "Unused time credit",
        unusedCreditTooltip: "Credit for unused time on your current plan, applied to your new subscription.",
        planRow: "{{plan}} Plan ({{period}})",
        discount: "Discount ({{name}})",
        haveCode: "Have a promo code?",
        enterCode: "Enter code",
        totalDueToday: "Total Due Today",
        fetchError: "There was a problem while fetching your data. Please try again later or contact support.",
        changeError: "There was an error with the subscription change.",
        apiWarning: "Leaving the API plan will deactivate your API access. Your App ID and token are preserved (not deleted), but API requests will be rejected while you're not on the API plan.",
        apiAcknowledge: "I understand that my API access will be deactivated."
      },
      cancelTrial: {
        alreadyCanceled: "This trial has already been canceled.",
        cancelError: "There was an error canceling the trial.",
        title: "Cancel Trial?",
        subtitle: "You'll lose access to premium features",
        currentTrialNote: "You're currently on a free trial of this plan",
        whatHappens: "What happens when you cancel:",
        untilDate: "Until {{date}}:",
        keepFeatures: "You'll keep using all premium features",
        afterDate: "After {{date}}:",
        noCharge: "You will not be charged anything",
        keepTrial: "Keep Trial",
        confirmButton: "Cancel Trial"
      },
      recurringMonthlyAdjective: "monthly",
      recurringSixMonthAdjective: "six-month",
      paymentMethodEntity: "Payment method"
    },
    settings: {
      updatePassword: "Update Your Password",
      updatePasswordSubTitle: "Edit or change your password to secure your account.",
      updateEmailTitle: "Email Address",
      updateEmailSubTitle: "Edit or change the email address of your account.",
      changeEmailTile: "Change your email address",
      yourEmail: "Your email",
      switchToAgentButton: "Switch to Professional Account",
      switchToSeekerButton: "Switch to DASH Direct Account",
      switchToAgentSubTitle: "Are you a licensed real estate professional? Upgrade your account to unlock tools built for professionals, including lead generation, downloadable marketing assets, and website integrations.",
      switchToSeekerSubTitle: "Not actively working in real estate? You can switch to a non-professional DASH account with DASH Direct.<br>Please note: you\u2019ll lose access to professional tools like branded portfolios, unbranded marketing assets, and lead capture.",
      switchToSeekerConfirmModalTitle: "Confirm Account-Type Change",
      switchToAgentConfirmModalTitle: "Upgrade to a Professional Account",
      switchToAgentConfirmText: "To unlock access to DASH\u2019s professional tools, please verify your license details:",
      accountLanguageTitle: "Account Language",
      accountLanguageSubTitle: "Dash emails and notifications are sent in this language.",
      accountLanguageSaved: "Account language updated.",
      accountLanguageError: "We couldn't update your account language. Please try again.",
      accountLanguageBrowserOverride: "This browser is showing Dash in {{language}}.",
      accountLanguageUseHere: "Use the account language here",
      changeAccountType: "Change Account Type",
      country: "Country",
      selectCountry: "Select your country",
      selectState: "Select your state",
      licenseNumber: "License Number",
      switchToSeekerConfirmText: "Are you sure you want to switch to a non-professional DASH account? This will remove access to all features reserved for licensed real estate professionals and give you a simpler experience.",
      accountSwitchWarning: "WARNING: This change is permanent unless you contact DASH Support to switch back.",
      resetLinkSent: "A reset password link was sent to your email! If you didn't receive it, please check the Spam folder before trying again.",
      sendNewLink: "Send a new link",
      forgotPassword: "Don't remember your password?",
      sendResetLink: "Send a reset link to your email"
    },
    api: {
      tooltipMessage: "This is the information you will share with the company responsible for your API integration. To be able to use our API Plugin, you need to provide the App ID and the secret API Token.",
      apiKeys: "API Keys",
      apiUsage: "API Usage",
      apiUsageOwnLabel: "Your requests this month:",
      apiUsageLabel: "Requests this month:",
      apiUsageCompanyShare: "Your monthly limit is shared with everyone in your company. Together you have used {{usage}} of {{limit}} this month.",
      apiActivity: "API Activity",
      generateNewToken: "Generate New Token",
      tokenGeneratedSuccess: "Token generated successfully. Please keep it safe.",
      tokenGeneratedError: "Failed to generate token. Please try again.",
      newToken: "Your new token is:",
      newTokenStoreSafely: "Please copy and store it in a safe place. It will not be shown again after you close this modal.",
      noAppIdFoundMessage: "No App ID found. Please refresh the page or contact support if the problem persists.",
      inactiveNotice: "Your API access is currently inactive. You can still manage your App ID and token here, but API requests will be rejected until your API subscription is active again. Contact support if you believe this is an error.",
      referralLinkTitle: "Referral Link",
      referralLinkDescription: "Share this link with your clients to give them access to our API:",
      referralLinkCopied: "Link copied to clipboard!",
      referralLinkHint: "They have to follow the link, create an account, select the API plan and generate their tokens on the settings page.",
      pluginUsersTitle: "Plugin Users",
      pluginUsersDescription: "Clients who signed up through your referral link. Their API requests count towards your monthly quota.",
      pluginUsersEmpty: "No one has signed up with your referral link yet.",
      pluginUsersRequestsThisMonth: "requests this month",
      pluginUsersActive: "Active",
      pluginUsersInactive: "Inactive",
      pluginUsersBlocked: "Blocked by you",
      pluginUsersToggleLabel: "API access",
      pluginUsersBlockError: "We couldn't update this client's access. Please try again.",
      tokenActiveNote: "There is already an active token associated with this App ID.<br />You can generate a new one by clicking on the button below, but the current token <bold>will be invalidated</bold>.",
      tokenInactiveNote: "There is no active token associated with this App ID.<br />You can generate a new one by clicking on the button below.",
      usageError: "There was an error getting request metrics. Please refresh the page or contact support if the error persists.",
      needMoreRequests: "Need more requests? Click here",
      usageDelayed: "*Usage information may be delayed by up to 1 hour.",
      appIdIs: "Your <bold>App ID</bold> is: {{appId}}",
      searchingAppId: "searching App ID",
      appIdCopied: "App ID copied!",
      tokenCopied: "Token copied!",
      regenerateConfirm: "Are you sure you want to generate a new token?<br />The current one <bold>will be invalidated</bold>.",
      firstTokenNote: "<bold>Important!</bold> Once you generate a token, it will be displayed here.<br /><br />You <bold>need to copy</bold> it and store it in a safe place. If you lose it, you will need to generate a new one, and the old one <bold>will be invalidated</bold>.",
      generateTokenModalTitle: "Generate New API Token"
    },
    avatar: {
      uploadError: "Error uploading file: {{error}}",
      cropTitle: "Crop image",
      removeUnableError: "Unable to remove profile picture. Please try again.",
      removeFailedError: "Failed to remove profile picture. Please try again.",
      entity: "profile picture",
      removeTitle: "Remove profile picture",
      removeConfirm: "Are you sure you want to remove your profile picture?",
      removeNote: "Remember to save your changes to apply this removal."
    },
    accountInfo: {
      licenseValid: "Valid",
      licenseInvalid: "Invalid",
      licensePending: "Pending"
    },
    toasts: {
      updatedPassword: "Your password was successfully updated",
      updatedProfile: "Your profile was successfully updated",
      updatedEmail: "Your email was successfully updated",
      switchedToSeeker: "Account type switched to non-Agent!",
      switchedToAgent: "Account type switched to Agent!"
    }
  },
  alertPage: {
    labels: {
      addAlert: "Add an Alert",
      alertDetails: "Alert Details",
      alertInfo: "Alert Info",
      createAlertTitle: "Create an Alert",
      createAlertSubtitle: "Create an alert for new properties that match your search criteria",
      manageAlerts: "Manage Alerts",
      addAlertSelectFilter: "Select filters for your alert",
      hiddenAlert: "Hidden Alert",
      filterByAlertPlaceholder: "Search by alert name",
      manageAlertsModalTitle: "Manage Alerts",
      manageAlertsModalSuTitle: "View a comprehensive list of your alerts, and manage them as needed.",
      deleteAlertModalTitle: "Delete Alert",
      deleteAlertModalSubTitle: "Are you sure you want to delete this alert from the alerts list?",
      noPropertiesPlaceholderTitle: "You have not created any alerts",
      noPropertiesPlaceholder: "Create an alert to be notified when a new property matches your alert criteria",
      backButtonLabel: "Back to Manage Alerts"
    },
    toasts: {
      alertIsCreated: "Alert Successfully Created",
      alertIsUpdated: "Alert Successfully Updated"
    }
  },
  brokersPage: {
    licenseInfo: "License Info",
    licenseData: "License Data:",
    markAsInvalid: "Mark as Invalid",
    markValid: "Mark as Valid",
    saveBrokerDetails: "Save agent details",
    verifyBrokerLicense: "Verify",
    licenseId: "License ID:",
    blockBroker: "Block Account",
    subscriptionStatus: "Subscription Status",
    unblockBroker: "Unblock Account",
    unlockStandardPlans: "Unlock standard plans",
    lockToApiPlan: "Lock to API plan",
    billingAccess: "Billing",
    billingApiOnly: "API plan only",
    billingAllPlans: "All plans",
    notApiUserHint: "This agent is not an API user \u2014 they already see all plans.",
    toast: {
      paymentMethodAdded: "Payment method successfully added",
      paymentMethodRemoved: "Payment method successfully removed",
      paymentMethodSetAsDefault: "Payment method has been set as default",
      maxPaymentMethod: "You have reached the limit of allowed payment methods."
    },
    modals: {
      deactivateBrokerLicenseTitle: "Deactivate Agent License",
      activateBrokerLicenseTitle: "Set Agent License as Active",
      deactivateBrokerLicenseSuccess: "Agent License Invalidated",
      activateBrokerLicenseSuccess: "Agent License Validated",
      activateBrokerLicenseSubTitle: "Are you sure?",
      notifyThroughMailCheckbox: "Send email notification to Agent",
      blockBrokerSubtitle: "Are you sure you want to block this account?",
      blockBrokerReasonFieldTitle: "Specify the reason for blocking",
      blockBrokerReasonFieldPlaceholder: "Type the reason for blocking",
      unblockBrokerSubtitle: "Are you sure you want to unblock this account?"
    }
  },
  dashboardPage: {
    mortgageWidget: {
      mortgageModalTitle: "Mortgage Calculator",
      mortgageBalance: "Mortgage Balance",
      totalPayments: "Total Payments",
      monthlyPayments: "Monthly Payments",
      totalInterestPaid: "Total Interest Paid",
      propertyInsurance: "Property Insurance",
      propertyTax: "Property Tax",
      totalPropertyTax: "Total Property Tax",
      totalPropertyInsurance: "Total Property Ins."
    },
    currencyConverterWidget: {
      title: "Currency Converter",
      rate: "Rate: {{from}} / {{to}}",
      label: "For such {{amount}} you will get:",
      for: "On {{date}}",
      copied: "Copied"
    },
    propertyAlertsWidget: {
      propertiesAlertsModalTitle: "Property Alerts",
      infoPlaceholder: "New Properties",
      infoDescription: "New Property Alerts",
      infoPlaceholderDescription: "Get notifications when a new property matches your search criteria"
    },
    propertyUpdatesWidget: {
      infoPlaceholder: "Track Properties",
      infoDescription: "Property Updates",
      infoPlaceholderDescription: "Get notifications when a property in your portfolio is updated",
      infoPlaceholderSeekerDescription: "Get notifications when a tracked property is updated",
      noPropertyUpdatesPlaceholder: "No properties were updated during the selected time period"
    },
    reactionsWidget: {
      infoDescription: "Reactions",
      infoPlaceholderDescription: "Collect feedback from clients and colleagues on portfolios you share.",
      reactions: {
        interested: "Interested",
        notInterested: "Not Interested",
        maybeInterested: "Maybe Interested",
        dontKnow: "Don\u2019t Know"
      },
      enterYourData: "Enter Your Details",
      leaveReactionTitle: "How would you rate this property?",
      leaveReactionSuccessfulToast: "Thank You! Your agent will be notified",
      reactionsViews: "Reactions & Views",
      userView: "User View"
    },
    reactionsModal: {
      portfolioViewsLabel: "{{count}} Views",
      portfolioReactionsLabel: "{{count}} Reactions",
      noPortfoliosMessage: "No Portfolios Found",
      noPortfoliosSubMessage: "Collect feedback from clients and colleagues on portfolios you share.",
      noPortfoliosButtonMessage: "Create Your First Portfolio",
      noPublicPortfoliosMessage: "No Public Portfolios",
      noPublicPortfoliosSubMessage: "Make your portfolio public and collect feedback from clients and colleagues",
      noPublicPortfoliosButtonMessage: "Share portfolio"
    },
    viewedProperties: {
      viewed: "Viewed: {{date}}",
      unavailableProperty: "This property is unavailable right now",
      viewedProperties: "Viewed Properties",
      unavailableTitle: "Keep Track of Your Searches",
      unavailableSubtitle: "Once you start browsing properties, your history will appear here.",
      unavailableButton: "Browse"
    },
    addedToPortfolio: {
      addedToPortfolio: "Added to Portfolio",
      unavailableTitle: "Portfolio Properties",
      unavailableSubtitle: "Any properties added to a portfolio will be displayed here.",
      unavailableButton: "Create Portfolio",
      added: "Added: {{date}}",
      removed: "Removed",
      propertyNotAvailable: "Property is Not Available",
      noFolderName: "No Portfolio Name"
    },
    portfoliosWidget: {
      title: "Portfolio Views",
      titleShort: "Port. Views",
      portfoliosDropdownInput: "Manage Chart",
      portfoliosDropdownInputShort: "Chart",
      noPortfoliosPlaceholderTitle: "Analytics",
      noPortfoliosPlaceholderSubTitle: "When creating portfolios, you receive view analytics from potential buyers",
      noPublicPortfoliosPlaceholderSubTitle: "When sharing property portfolios, you receive view analytics from potential buyers",
      noPortfoliosPlaceholderMatches: "No matches were found for your query, please try again",
      noPortfoliosPlaceholderButtonLabel: "Create portfolios",
      noPublicPortfoliosPlaceholderButtonLabel: "Share portfolios",
      noPortfoliosPlaceholderNoMatches: "No matches were found for your query, please try again"
    },
    banner: {
      view: "View",
      renew: "Renew",
      dismiss: "Dismiss",
      notifications: {
        freePlanUpdate: "DASH is now FREE for Basic Plan users! Learn more about this update by clicking here.",
        upgradeSubscription: "Your free account has limited access - upgrade your plan to gain full access.",
        brokerInfoIncomplete: "Complete your profile and provide clients with a visually enhanced property viewing experience.",
        cancelSubscription: "Please note that when your subscription expires, access to platform features will be limited. Renew today to continue enjoying the full benefits.",
        phoneVerification: "Please verify your phone number.",
        brokerLicense: "Your agent license is invalid. Please contact DASH Support.",
        trialExpired: "Your DASH Trial period will end on {{date}}. The payment method on file will be charged automatically at the end of your trial. Visit your Account Billing Settings to review your payment methods."
      }
    }
  },
  managementPage: {
    addNewUser: "Add New User",
    editUser: "Edit User",
    emptyPlaceholder: "There Are No Users",
    archiveConfirmationTitle: "Archive User",
    unarchiveConfirmationTitle: "unarchive User",
    archiveConfirmationBody: "Are you sure you want to archive this user?",
    unarchiveConfirmationBody: "Are you sure you want to unarchive this user?",
    toasts: {
      userAdded: "User was added successfully",
      userUpdated: "User was updated successfully",
      userArchived: "User was archived successfully",
      userUnarchived: "User was unarchived successfully"
    }
  },
  apiUsersPage: {
    addNewUser: "Add New API Representative",
    addNewUserButton: "Add API Representative",
    editUser: "Edit API Representative"
  },
  apiInvitationsPage: {
    createInvitation: "Create API Invitation",
    createInvitationButton: "Create Invitation",
    emptyPlaceholder: "There Are No Invitations",
    toasts: {
      invitationCreated: "Invitation was created successfully",
      invitationRevoked: "Invitation was revoked successfully"
    }
  },
  apiConsolePage: {
    tabs: {
      overview: "Overview",
      accounts: "Accounts",
      invitations: "Invitations"
    },
    accountsModeCompanies: "Companies",
    accountsModePluginUsers: "Plugin users",
    allStatuses: "All statuses",
    showingRange: "Showing {{from}}\u2013{{to}} of {{total}}",
    rowsPerPage: "Show {{count}}",
    noAccounts: "There Are No API Accounts",
    apiUsage: "API usage",
    usageRange: "Period",
    usageGrouping: "Group by",
    usageFrom: "From",
    usageTo: "To",
    invitationFunnel: "Invitations",
    invitationTotal: "{{count}} total",
    requestsInDays: "{{count}} requests \xB7 last {{days}} days",
    requestsTotal: "{{count}} requests",
    noUsage: "No requests in this period.",
    totalApiAccess: "Total API Access",
    companiesApiAccess: "Companies API Access",
    pluginUsersApiAccess: "Plugin Users API Access",
    companyDirectAccess: "Company Direct API Access",
    clientsApiAccess: "Clients API Access",
    sharedQuota: "Monthly quota (company + plugin users)",
    resetsOn: "Resets on {{date}}",
    customLimit: "custom limit",
    defaultLimit: "default limit",
    noQuota: "No quota information for this account yet.",
    apiAccess: "API access",
    accessEnabled: "Enabled",
    accessDisabled: "Disabled by an admin",
    accessEnabledHint: "Disabling blocks this company and every plugin user signed up through it, no matter what their subscription says.",
    accessDisabledHint: "An admin blocked API access. Billing events cannot turn it back on while this block is in place.",
    disableAccess: "Disable API access",
    blockReasonLabel: "Reason (optional)",
    blockReasonPlaceholder: "Why is access being cut?",
    disabledOn: "Disabled on {{date}}",
    disabledOnWithReason: "Disabled on {{date}} \u2014 {{reason}}",
    reEnableAccess: "Re-enable API access",
    monthlyLimit: "Monthly request limit",
    newLimitPlaceholder: "New limit",
    saveLimit: "Save limit",
    restoreDefault: "Restore default",
    pluginUsers: "Plugin users",
    pluginUsersHint: "Signed up through this company\u2019s referral link. Their requests count against the quota above, and disabling the company blocks them too.",
    pluginUserStatus: "Status",
    pluginUserActive: "Active",
    pluginUserInactive: "Inactive",
    pluginUserBlockedByPartner: "Blocked by partner",
    pluginUserBlockedByAdmin: "Blocked by an admin",
    blockedByPartnerHint: "The partner switched this plugin user off. Only they can turn it back on.",
    noPluginUsers: "No plugin users signed up through this company.",
    referralLink: "Referral link",
    copyReferralLink: "Copy referral link",
    noReferralLink: "Direct account",
    deleteAccount: "Delete account",
    deleteAccountTitle: "Delete {{name}}?",
    deleteAccountBody: "API access stops immediately and the account disappears from this list. Nothing is erased: an admin can restore it later.",
    deleteAccountCascade_one: "Its 1 plugin user loses API access with it, and gets it back on restore. Their own account is untouched.",
    deleteAccountCascade_other: "Its {{count}} plugin users lose API access with it, and get it back on restore. Their own accounts are untouched.",
    deleteAccountCodeWarning: "Its referral code cannot be reused by a new account, even after a restore.",
    deleteChallenge: "Type {{name}} to confirm",
    restoreAccount: "Restore account",
    showDeleted: "Show deleted",
    deletedPill: "Deleted",
    deletedOn: "Deleted on {{date}}",
    accountNotFound: "We could not find that API account.",
    untitledAccount: "Unnamed company",
    responsibleCompany: "Responsible company",
    viewParentCompany: "View parent company",
    viewBrokerRecord: "View broker record",
    resendInvitation: "Resend",
    resendInvitationTitle: "Resend this invitation?",
    resendInvitationBody: "A new link is emailed to {{email}} and the previous one stops working.",
    resendInvitationExpiry: "New expiry date (optional)",
    invitationEmail: "Email",
    toasts: {
      accessDisabled: "API access disabled",
      accessReEnabled: "API access re-enabled",
      accessStillOff: "Admin block removed, but API access is still off: this company has no active API subscription.",
      accessFailed: "Failed to update API access",
      limitSaved: "Monthly limit set to {{limit}}",
      limitRestored: "Monthly limit restored to default",
      limitFailed: "Failed to update the monthly limit",
      inviteFailed: "Failed to create the invitation",
      revokeFailed: "Failed to revoke the invitation",
      saveAccountFailed: "Failed to save the API account",
      referralLinkCopied: "Referral link copied",
      accountDeleted: "Account deleted",
      accountDeletedWithPluginUsers_one: "Account deleted; 1 plugin user lost API access",
      accountDeletedWithPluginUsers_other: "Account deleted; {{count}} plugin users lost API access",
      deleteAccountFailed: "Failed to delete the account",
      accountRestored: "Account restored",
      accountRestoredInactive: "Account restored, but API access is still off: no active API subscription.",
      restoreAccountFailed: "Failed to restore the account",
      invitationResent: "Invitation resent",
      resendInvitationFailed: "Failed to resend the invitation",
      pluginUserBlocked: "Plugin user blocked",
      pluginUserUnblocked: "Plugin user unblocked"
    }
  },
  contentActivityPage: {
    from: "From",
    to: "To",
    period: "Period",
    totals: {
      propertiesEdited: "Properties edited",
      changes: "Changes",
      filesUploaded: "Files uploaded",
      propertiesCreated: "New properties"
    },
    byType: "By type of change",
    byTypeHint: "Every entry in the property history. File uploads include files removed later, so this can be higher than Files uploaded above.",
    byPerson: "By person",
    columns: {
      change: "Change",
      changes: "Changes",
      properties: "Properties",
      person: "Person",
      propertiesEdited: "Properties edited",
      filesUploaded: "Files uploaded",
      propertiesCreated: "New properties",
      when: "When",
      property: "Property",
      by: "By"
    },
    log: "Change log",
    logHint: "Every change in this period, newest first. Status and visibility changes are internal: agents never see them.",
    visibilityAlsoChanged: "Visibility: {{change}}",
    deletedProperty: "Deleted property",
    unknownPerson: "Unknown",
    unknownPersonHint: "Before author tracking",
    noChanges: "No changes in this period.",
    noContributors: "No activity in this period.",
    loadError: "Couldn't load content activity. Try again.",
    changeTypes: {
      PROPERTY_ABOUT: "Property details",
      PROPERTY_ADDITIONAL_INFORMATION: "Additional information",
      PROPERTY_CMS_STATUS: "Status",
      PROPERTY_DATA_REVIEWED: "Data verified",
      PROPERTY_DEVELOPER_ORGANIZATION: "Developer organization",
      PROPERTY_FEATURES_AND_AMENITIES: "Features & amenities",
      PROPERTY_HIGHLIGHTS: "Highlights",
      PROPERTY_INVENTORY_UNIT_ADDED: "Inventory added",
      PROPERTY_INVENTORY_UNIT_REMOVED: "Inventory removed",
      PROPERTY_INVENTORY_UNIT_UPDATED: "Inventory updated",
      PROPERTY_LOCATION: "Location",
      PROPERTY_MEDIA_FILES_MOVED: "Files moved",
      PROPERTY_MEDIA_REMOVED: "Files removed",
      PROPERTY_MEDIA_RENAMED: "Files renamed",
      PROPERTY_MEDIA_UPLOADED: "Files uploaded",
      PROPERTY_NAME: "Property name",
      PROPERTY_PRICE: "Pricing & availability",
      PROPERTY_SALES_TEAMS: "Sales team",
      PROPERTY_VIRTUAL_TOURS: "Virtual tours",
      PROPERTY_VISIBILITY: "Visibility",
      PROPERTY_WEBSITE: "Website",
      retired: "Other (retired type)"
    }
  },
  trackingPage: {
    noPropertiesLabelTitle: "You are not watching any properties yet!",
    noPropertiesLabel: "Add your favorite properties to your watchlist to easily access them.",
    noPropertiesButtonLabel: "Start Browsing",
    noPortfoliosLabelTitle: "You are not watching any portfolios yet!",
    noPortfoliosLabel: "Add your favorite portfolios to your watchlist to easily access them.",
    noPortfoliosButtonLabel: "Browse Portfolios",
    propertiesTab: "Properties",
    portfoliosTab: "Portfolios",
    trackProperty: "Track Property"
  },
  externalSalesPage: {
    addUser: "Add User",
    addExternalTeam: "Add New Team",
    editExternalTeam: "Edit Team",
    toasts: {
      teamAdded: "Team was added successfully",
      teamChanged: "Team was successfully changed",
      userAdded: "User was added successfully",
      userUpdated: "User was updated successfully"
    },
    deleteSaleTeamModalLabel: "Delete Team",
    deleteSaleTeamModalText: "Are you sure you want to delete the {{teamName}} team?",
    addSaleTeamUserModalLabel: "Add Users to the Sales Team",
    editSaleTeamUserModalLabel: "Edit Sales Team User",
    deleteSaleTeamUserModalLabel: "Delete Sales Team User",
    deleteSaleTeamUserModalText: "By deleting this user from the sales team you will revoke the user\u2019s access and permissions granted within the sales team. Are you sure you want to proceed?",
    archiveUserText: "Are you sure you want to archive this sales team user?",
    unarchiveUserText: "Are you sure you want to unarchive this sales team user?"
  },
  organizationDashboardPage: {
    deleteOrganizationModalNote: "This may impact associated properties",
    mediaKitWidgetPlaceholderTitle: "File / DASH Downloads",
    propertySavesPlaceholderTitle: "Property Saves",
    propertySavesPlaceholderText: "This property has not been saved by any agents yet.",
    propertySharesPlaceholderTitle: "Property Shares",
    propertySharesPlaceholderText: "This property has not been shared by any agents yet.",
    addedToPortfoliosPlaceholderTitle: "Added to Portfolios",
    addedToPortfoliosPlaceholderText: "This property has not yet been added to a portfolio.",
    propertySavesPlaceholderTextPeriod: "This property was not added by any agents during the selected time range.",
    propertySharesPlaceholderTextPeriod: "No properties shared for the selected time range.",
    propertyAddedPortfolioPlaceholderText: "This property has not yet been added to a portfolio.",
    propertyAddedPortfolioPlaceholderTextPeriod: "This property was not added to a portfolio during the selected time range.",
    propertyMediaKitPlaceholderText: "No downloads yet.",
    propertyMediaKitPlaceholderTextPeriod: "No downloads for the selected time range.",
    viewedByAgents: "Viewed by Agents",
    viewedByAgentsNoResult: "No views for the selected time frame",
    viewedByAgentsPlaceholderTitle: "No views by agents yet",
    downloadedFilesTitle: "Most Popular Files",
    downloadedFilesPlaceholderTitle: "No files have been downloaded yet.",
    exportData: "Export Data",
    propertyName: "Property Name",
    filterByDate: "Filter by Date",
    selectRange: "Select Range",
    customRange: "Custom Range",
    totalValue: "Total Value",
    widgetsEmptyFilterTexts: {
      propertyShared: "No properties shared during the selected time period",
      addedToPortfolios: "This property was not added to any portfolios during the selected time period.",
      propertySaves: "This property was not saved by any agents during the selected time frame.",
      fileDownloads: "No downloads for the selected time period"
    }
  },
  mediaKit: {
    dashDownloads: "Property Downloads",
    enableDashDownloads: "Enable Property Downloads",
    mediaKitText: "Add and customize which property media files show for this property in your portfolio.",
    propertyMediaFiles: "Property Media",
    addedToDashDownloads: "{{total}} Files Added to portfolio",
    manageMediaKit: "Property Downloads",
    numberOfAddedItems: "Added Media Files",
    addToMedia: "Add to Media",
    added: "Added",
    addTitle: "Share Your Portfolio",
    addSubtitle: "Configure portfolio visibility and sharing options.",
    firstShareSubtitle: "Your portfolio is already public. You can copy and share the link below with your clients or change the sharing options.",
    editTitle: "Manage Property Downloads",
    editSubtitle: "You can add/delete property media files to the media kit",
    confirmChangesTitle: "Confirm your changes",
    confirmAddAllBody: "\u26A0\uFE0F This action will <bold>add all the property's media files</bold> to your portfolio. Are you sure?",
    confirmRemoveAllBody: "\u26A0\uFE0F This action will <bold>remove all the property's media files</bold> from your portfolio. Are you sure?",
    confirmAndSave: "Confirm and save",
    updateSuccess: "Property Downloads updated successfully!",
    updateError: "There was an error updating media kit settings.",
    attachIntro: "Attach agent-ready, unbranded brochures, floor plans, and other presentation files your prospects can download right from the property page.",
    unsavedChanges: "You have unsaved changes!",
    addAllFiles: "Add all files",
    removeAllFiles: "Remove all files"
  },
  releaseNotes: {
    subtitle: "Stay up to date with the latest changes, improvements, and new features in the DASH API."
  },
  welcomeDiscoveryModal: {
    eyebrow: "YOU'RE IN",
    heading: "Welcome to DASH, {{firstName}}.",
    intro: "You're now on a <tag>free plan</tag> and can browse every new development on DASH.",
    includedTitle: "INCLUDED IN THE FREE PLAN:",
    feature1: "Browse DASH\u2019s full property database",
    feature2: "Access the Weekly Trending Properties feed",
    feature3: "Save and track up to 5 properties",
    feature4: "Book a free demo to see how DASH supports new development sales",
    unlockHeading: "Unlock the full database for just $10/mo",
    unlockSubtext: "7-day free trial, cancel anytime",
    seeAllPlans: "See All Plans",
    startExploring: "Start Exploring",
    close: "Close",
    firstNameFallback: "there"
  },
  quickTour: {
    label: "Quick tour",
    progress: "{{current}} of {{total}}",
    skip: "Skip tour",
    back: "Back",
    next: "Next",
    done: "Done",
    searchTitle: "Start a property search",
    searchDescription: "Search DASH by property, location, or developer.",
    sectionsTitle: "Discover properties",
    sectionsDescription: "Explore trending properties and categories with dynamic recommendations.",
    featuredPortfoliosTitle: "Featured portfolios",
    featuredPortfoliosDescription: "Shareable property collections, each expertly curated by the DASH team.",
    mapTitle: "Explore the Map",
    mapDescription: "Browse geographically for a full picture of Florida's pre- and new-construction condo markets.",
    sidebarTitle: "Easily navigate DASH",
    sidebarDescription: "Quickly and easily access key DASH features.",
    bottomNavTitle: "Easily navigate DASH",
    bottomNavDescription: "Quickly and easily access key DASH features.",
    profileTitle: "Manage your account",
    profileDescription: "Access your account profile, billing, and account settings.",
    searchFiltersTitle: "Search With Filters",
    searchFiltersDescription: "Combine search terms with DASH filters to find exactly what you're looking for.",
    searchSortTitle: "Search Sorting",
    searchSortDescription: "Sort results by price, recent updates, and more for efficient browsing.",
    searchViewsTitle: "Grid and Map Views",
    searchViewsDescription: "View results in a list grid, or switch to the map view for a geographic view.",
    searchWatchlistTitle: "Add To Your Watchlist",
    searchWatchlistDescription: "Click the heart icon to add a property or portfolio to your personal watchlist.",
    searchPortfolioTitle: "Save Properties to a Portfolio",
    searchPortfolioDescription: "Click the folder icon to save a property to a portfolio for future sharing.",
    watchlistPropertiesTitle: "Properties Watchlist",
    watchlistPropertiesDescription: "Properties you save to your watchlist are stored here for update alerts and easy access.",
    watchlistPortfoliosTitle: "Portfolios Watchlist",
    watchlistPortfoliosDescription: "Curated portfolios you save to your watchlist are stored here for easy access and sharing.",
    watchlistSavedTitle: "Saved Searches",
    watchlistSavedDescription: "Save a custom search with filters to get alerts when new or updated properties are a match.",
    portfolioAddTitle: "Custom Portfolios",
    portfolioAddDescription: "Create a new portfolio to organize and share properties on your own branded links.",
    portfolioPreviewTitle: "Preview Your Portfolio",
    portfolioPreviewDescription: "Preview your portfolio in client mode to see how it will look when shared.",
    portfolioShareTitle: "Custom Sharing Settings",
    portfolioShareDescription: "Portfolios can be public, password-protected, or set to be private and visible only to you.",
    portfolioCreateTitle: "Name Your Portfolio",
    portfolioCreateDescription: "Give your portfolio a name, then start adding properties to share with your clients.",
    portfolioGuideTitle: "Read the guide",
    portfolioGuideDescription: "Review our DASH Pro Quick-Start Guide for tips on building and sharing portfolios.",
    exchangeSettingsTitle: "Connect Your Website",
    exchangeSettingsDescription: "Enter the website URL that will host your new development feed, and customize your feed colors.",
    exchangeAddFeedTitle: "Create Feeds",
    exchangeAddFeedDescription: "Create a feed to display a single property, portfolio, or a DASH search bar on your website.",
    exchangeNewFeedTitle: "Set Up a Feed",
    exchangeNewFeedDescription: "Give your feed a name and select a feed type, then click Create to save the new feed.",
    exchangeFeedSaveTitle: "Save & Preview",
    exchangeFeedSaveDescription: "Save your settings and the feed preview will show how the feed will look within the iFrame on your website.",
    exchangeFeedGuideTitle: "Read the guide",
    exchangeFeedGuideDescription: "Review our DASH eXchange Quick-Start Guide for more tips."
  },
  quickStart: {
    eyebrow: "Quick start",
    // DSH-857: page-aware pill brand ("Pulse · [page]") + panel section headers.
    pulse: "Pulse",
    onThisPage: "On this page",
    exploreNext: "Explore next",
    unlockTitle: "Unlock with PRO & eXchange",
    lockedHint: "Upgrade to unlock",
    replay: "Replay",
    title: "Get set up",
    doneCount: "<highlight>{{current}}</highlight> of {{total}} done",
    close: "Close",
    dontShowAgain: "Don't show again",
    itemTour: "Take the product tour",
    itemSearch: "Run your first search",
    itemOpenDevelopment: "Open a development",
    itemSaveProperty: "Save a property",
    itemTryFilter: "Try a filter",
    itemPortfolios: "Check portfolios",
    itemViewWatchlist: "Review your watchlist",
    itemExploreExchange: "Explore DASH eXchange"
  },
  cmsSettingsPage: {
    title: "CMS Status Transition Settings",
    description: "Configure automated status transitions for property listings. These settings determine how long properties remain in each status before automatically transitioning to the next status.",
    automatedTransitions: "Enable Automated Transitions",
    automatedTransitionsDescription: "When enabled, property statuses will automatically transition based on the time settings below",
    transitionTimes: "Transition Times",
    newListingToActive: "New Listing \u2192 Active Listing",
    newListingToActiveHelp: "Days before a newly approved property becomes active",
    activeToAudit: "Active Listing \u2192 Awaiting Audit",
    activeToAuditHelp: "Days before an active listing requires content review",
    recentlyUpdatedToActive: "Recently Updated \u2192 Active Listing",
    recentlyUpdatedToActiveHelp: "Days before an updated property returns to active status",
    resetToDefaults: "Reset to Defaults",
    resetConfirmationTitle: "Reset Settings",
    resetConfirmationMessage: "Are you sure you want to reset to default settings?",
    confirm: "Confirm",
    validationError: "Please fix validation errors before submitting",
    updateSuccess: "Settings updated successfully",
    updateError: "Failed to update settings",
    resetSuccess: "Settings reset to defaults",
    resetError: "Failed to reset settings"
  },
  v2Components: {
    agentContact: {
      messageSent: "Your message has been sent and the agent will contact you shortly.",
      brokerImageAlt: "Broker Image",
      logoAlt: "Dash logo",
      visitWebsite: "Visit Website",
      contactMe: "Contact me",
      contactMeTitle: "Contact Me"
    },
    brokerModal: {
      contactMe: "Contact Me",
      loadingProperties: "Loading properties...",
      propertyPortfolio: "Property Portfolio ({{total}})",
      loadMore: "Load More"
    },
    subscriptionCard: {
      newBadge: "NEW",
      saveTenPercent: "Save 10%!",
      currentPlanBadge: "Current plan",
      cancelsOn: "Cancels on {{date}}",
      trialEnds: "Trial ends {{date}}",
      getPlan: "Get {{name}}",
      trialBadge: "{{days}}-day trial",
      yourCurrentPlan: "Your current plan",
      cancelTrial: "Cancel trial",
      manageOrCancel: "Manage or Cancel Subscription"
    },
    idxContactForm: {
      fillRequiredFields: "Please, fill all the required fields before sending the message.",
      avatarAlt: "Avatar image",
      contactMe: "CONTACT ME"
    },
    idxProperty: {
      developerVerified: "Developer Verified",
      completionIn: "Completion in {{year}}."
    },
    idxSettings: {
      title: "Exchange Settings",
      websiteDomain: "Website Domain",
      websiteDomainRequired: "Website Domain is required.",
      invalidUrl: "URL must start with http:// or https:// and be a valid URL.",
      websiteDomainHelp: "Enter the url of the website that will render the Exchange feed.",
      wixDomainWarning: "This URL contains <code>.filesusr.com</code>, which is specific to Wix sites. If you're no longer using Wix, update the URL to your site's actual domain.",
      wixFormatNote: "On save, your URL will be transformed to the Wix iframe format (e.g. <code>www-yoursite-com.filesusr.com</code>).",
      wixSite: "Wix Site",
      wixSiteHelp: "Check this option if your site was created with <link>Wix</link> so we can correctly format the address for you.",
      brandingColors: "Branding Colors",
      mainColor: "Main Color",
      textColor: "Text Color",
      backgroundColor: "Background Color",
      chooseColor: "Choose a color",
      transparent: "Transparent",
      resetColors: "Reset Colors"
    },
    deleteFeed: {
      title: "Confirm Deletion?",
      question: "Do you really want to delete the {{name}} feed?",
      warning: "Please note that this action cannot be undone."
    },
    newFeed: {
      title: "New Exchange Feed",
      name: "Name",
      namePlaceholder: "Enter a name",
      nameRequired: "Name is required.",
      type: "Type",
      typeRequired: "Type is required.",
      selectType: "Select a type",
      typeSingleProperty: "Single Property",
      typePortfolio: "Portfolio",
      typeSearchBar: "Search Bar",
      typeLocation: "Location"
    },
    searchBar: {
      filters: "Filters",
      filtersSubtitle: "Filter properties by your preferences",
      type: "Type",
      status: "Status",
      marketArea: "Market Area",
      marketAreas: "Market Areas",
      buildingType: "Building Type",
      selectType: "Select type",
      selectStatus: "Select status",
      selectTransaction: "Select transaction",
      selectTag: "Select tag",
      selectMarketAreas: "Select market areas",
      filterAreasPlaceholder: "Type to filter areas",
      noMarketAreas: "No market areas found.",
      minPrice: "Min Price",
      maxPrice: "Max Price",
      selectOptions: "Select options...",
      searchPlaceholder: "Search...",
      noOptionsFound: "No options found.",
      seeMore: "See more"
    }
  },
  authCommon: {
    logoAlt: "Dash Logo",
    peopleAlt: "People at Dash"
  },
  codeConfirmationPage: {
    emailResent: "Email resent!",
    invalidCode: "Invalid Code.",
    invalidOrExpiredCode: "Invalid or expired Code.",
    title: "Confirm Your Email",
    subtitle: "Please enter the verification code sent to your email: {{email}}.",
    codeLabel: "Confirmation Code",
    submitButton: "Confirm Your Code",
    resendHelp: "Didn't get the email?<br />Check your Spam folder and <resend>re-send the code</resend>.",
    differentAccount: "Or <logout>try a different account</logout>"
  },
  ssoCallbackPage: {
    redirecting: "Redirecting...",
    reloadHint: "If you are not redirected within 5 seconds, please reload the page."
  },
  signUpValidation: {
    firstNameRequired: "First name is required.",
    firstNameMin: "First name must have at least 2 characters.",
    firstNameMax: "First name must have at most 20 characters.",
    firstNameLetters: "First name must contains only letters and hyphen.",
    firstNameHyphen: "First name cannot begin or end with a hyphen.",
    lastNameRequired: "Last name is required.",
    lastNameMin: "Last name must have at least 2 characters.",
    lastNameMax: "Last name must have at most 20 characters.",
    lastNameLetters: "Last name must contains only letters and hyphen.",
    lastNameHyphen: "Last name cannot begin or end with a hyphen.",
    emailRequired: "Email is required.",
    emailInvalid: "Email must be valid.",
    countryRequired: "Country is required.",
    stateRequired: "State is required.",
    licenseMax: "License number must have at most 20 characters.",
    licenseRequired: "License number is required.",
    agreementRequired: "You must accept the terms and conditions.",
    passwordRequired: "Password is required.",
    passwordMin: "Password must have at least 8 characters.",
    passwordMin6: "Password must have at least 6 characters.",
    passwordComplexity: "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number and a special character.",
    confirmPasswordRequired: "Password confirmation is required.",
    confirmPasswordMismatch: "Password confirmation does not match."
  },
  signUpV2Page: {
    emailAlreadyRegistered: "Email already registered.",
    licenseAlreadyRegistered: "Agent license number already registered. Please contact support.",
    apiAccessSetupFailed: "Failed to set up API access: {{message}}",
    areYouAgent: "Are you a Real Estate Agent?",
    selectAnswer: "Please select one answer to proceed with your registration.",
    yes: "Yes",
    no: "No",
    notAgent: "Not a Real Estate Agent?",
    clickHere: "Click here",
    title: "Create a Dash Account",
    subtitle: "Your privacy is important to us. DASH will never share your information.",
    signUpMiamiRealtors: "Sign up with MIAMI REALTORS",
    signUpGoogle: "Sign up with Google",
    alreadyMember: "Already a DASH member? <link>Log in</link>",
    country: "Country",
    selectCountry: "Select your country",
    selectState: "Select your state",
    agentLicenseNumber: "Agent License Number",
    agreeTerms: "I agree to the <terms>terms and conditions</terms> and <privacy>privacy policy</privacy>.",
    createAccount: "Create account"
  },
  ssoSignUpPage: {
    licenseAlreadyExists: "License number already exists.",
    welcome: "Welcome!",
    welcomeName: "Welcome, {{name}}!",
    authenticated: "You have been successfully authenticated with {{provider}}. Please complete your profile before proceeding.",
    useNormalSignUp: "Want to use a different e-mail? <link>Use normal sign up</link> instead.",
    finishSignUp: "Finish sign up"
  },
  apiAccessAcceptPage: {
    linkFailed: "Failed to link API access.",
    validateFailed: "Failed to validate invitation.",
    acceptFailed: "Failed to accept invitation.",
    title: "API Access",
    verifying: "Verifying your invitation\u2026",
    missingToken: "No invitation token found in the link. Please use the link from your invitation email.",
    goToSignIn: "Go to Sign in",
    expired: "This invitation has expired. Please ask your administrator to send a new one.",
    invalid: "This invitation link is invalid or has already been used.",
    wrongAccount: "This invitation was issued to {{invitedEmail}}, but you are signed in as {{currentEmail}}. Sign out to continue accepting it.",
    anotherEmail: "another email",
    differentUser: "a different user",
    signOut: "Sign out",
    accountExists: "An account already exists for {{email}}. Please sign in to link API access to it.",
    signInToContinue: "Sign in to continue",
    invited: "You've been invited to access the DASH API. Create your account to continue.",
    invitedWithCompany: "You've been invited to access the DASH API for {{company}}. Create your account to continue.",
    passwordPlaceholder: "Enter password",
    passwordHint: "At least 6 characters with an uppercase, a lowercase, a number and a symbol.",
    accepting: "Accepting\u2026",
    acceptButton: "Accept Invitation",
    genericError: "Something went wrong. Please try again."
  },
  stripeCheckoutResultPage: {
    processing: "Please wait while we setup your subscription",
    takingTooLong: "Is this taking too long? <reload>Reload the page</reload> or <support>contact DASH Support</support>",
    getApiKeys: "Get your API keys!",
    startBrowsing: "Start browsing!",
    allSet: "You're all set!",
    thankYou: "Thank you for your purchase, {{name}}!",
    trialEnds: "Your trial will end on <highlight>{{date}}</highlight>",
    paymentProcessed: "Your payment of <highlight>${{amount}}</highlight> was processed successfully.",
    errorTitle: "Oops, there was an error processing your subscription!",
    contactSupport: "Contact support",
    expiredTitle: "Oops, this page has expired!",
    goToDashboard: "Go to Dashboard"
  },
  chunkErrorBoundary: {
    newVersion: "A new version of DASH is available.",
    reload: "Reload"
  },
  confirmSsoNameModal: {
    title: "Confirm your name",
    subtitle: "This is how you will appear to your clients.",
    firstName: "First name",
    lastName: "Last name",
    continue: "Continue"
  },
  maintenancePage: {
    logoAlt: "Dash Logo",
    title: "We're moving things around!",
    apology: "Sorry for the inconvenience!",
    updating: "We're currently updating our servers to improve service.",
    tryLater: "Please try again later."
  },
  exchangePage: {
    settingsCreated: "IDX Settings created successfully.",
    settingsUpdated: "IDX Settings updated successfully.",
    feedCreated: "IDX Feed created successfully.",
    feedDeleted: "IDX Feed deleted successfully.",
    searchPlaceholder: "Search feed by name",
    sortNameAsc: "Name (A-Z)",
    sortNameDesc: "Name (Z-A)",
    sortNewest: "Newest First",
    sortOldest: "Oldest First",
    addNew: "Add New",
    missingSettingsAlert: "To begin creating eXchange feeds, please open the settings tab to configure your domain name.",
    loadError: "Error loading Exchange feeds.",
    noResults: "No results found.",
    feedsCount_one: "{{count}} Exchange Feed",
    feedsCount_other: "{{count}} Exchange Feeds",
    typePortfolio: "Portfolio",
    typeProperty: "Property",
    typeSearchBar: "Search Bar",
    typeLocation: "Location",
    showingFeeds: "Showing {{from}} - {{to}} of {{total}} Feeds"
  },
  exchangeFeedPage: {
    updated: "Exchange Feed updated successfully!",
    updateError: "Error updating Exchange Feed.",
    upgradeTitle: "Get access to Exchange Feeds with the DASH Exchange plan!",
    manageSubscription: "Manage your subscription",
    previewNotice: "The preview shows what's live on your website. Save to publish your changes.",
    breadcrumb: "Feed Details",
    title: "Feed Details",
    feedNameLabel: "Feed Name*",
    feedNamePlaceholder: "Feed Name",
    feedTypeLabel: "Feed Type*",
    feedTypePlaceholder: "Feed Type",
    typePortfolio: "Portfolio",
    typeSingleProperty: "Single Property",
    typeSearchBar: "Search Bar",
    typeLocation: "Location",
    propertyLabel: "Property",
    propertyPlaceholder: "Search and select a property",
    propertySearchHint: "Please write at least 3 characters to see the results",
    portfolioLabel: "Portfolio",
    portfolioPlaceholder: "Search and select one of your portfolios",
    layoutLabel: "Layout*",
    layoutGrid: "Grid Default",
    layoutMap: "Map Default",
    propertiesPerPage: "Properties per page",
    propertiesPerPageTitle: "Properties Per Page",
    contentLabel: "Content*",
    contentSearchBarOnly: "Search bar only",
    contentListGrid: "Search bar with List (Grid Default)",
    contentListMap: "Search bar with List (Map Default)",
    locationsLabel: "Locations*",
    embedStandard: "Standard",
    embedScrollbarFree: "Scrollbar-Free",
    embedFixedDescription: "The easiest to set up. The iframe has a fixed height and the content scrolls inside it.",
    embedDynamicDescription: "The iframe adjusts its height to match the content, removing the internal scrollbar.",
    resizeHint: "Drag the bottom right corner to resize the preview.",
    scriptHint: "This option includes a small script that must run on your page.",
    codeTitle: "Code",
    codeIntro: "Copy and paste this piece of code on your website. <bold>Avoid editing this code, as it may not work properly.</bold>",
    navbarFixedHint: "If your site has a sticky or fixed navbar, adjust the <mono>height: calc(100vh - 0px)</mono> value to match its height (e.g. <mono2>height: calc(100vh - 60px)</mono2>).",
    navbarDynamicHint: "If your site has a sticky or fixed navbar, adjust the <mono>scroll-margin-top</mono> and <mono2>dashIdxNavbarHeight</mono2> values to match its height.",
    codeCopied: "Code copied!",
    copyCode: "Copy Code",
    guideTitle: "Learn How to Use DASH eXchange",
    guideBody: "Review our <link>DASH eXchange Quick-Start Guide</link> for guidance on creating and managing DASH feeds.",
    helpBody: "Need Help? <link>Contact support</link> for assistance with setting up DASH eXchange on your website.",
    chartTitle: "Properties clicked between {{start}} and {{end}}",
    missingEmbedPortfolio: "Select a portfolio and save to generate your embed code.",
    missingEmbedProperty: "Select a property and save to generate your embed code.",
    missingEmbedLocation: "Select at least one location and save to generate your embed code.",
    missingEmbedSearchBar: "Save to generate your embed code.",
    errors: {
      nameRequired: "Name is required.",
      searchBarContentRequired: "Search bar content is required.",
      propertyRequired: "Property is required.",
      portfolioRequired: "Portfolio is required.",
      locationRequired: "Select at least one county, city or market area.",
      pageLengthRequired: "Page length is required.",
      layoutRequired: "Portfolio display content is required.",
      salesMaterialsSearchBar: "Sales materials are not available for Search Bar feed type.",
      customSalesSingleProperty: "Custom sales materials are not available for Single Property feed type.",
      customSalesLocation: "Custom sales materials are not available for Location feed type.",
      customSalesRequireSales: "Custom sales materials require 'Show sales materials' to be active."
    }
  },
  idxEmbedded: {
    viewMode: "View Mode:",
    gridView: "Grid",
    emptyArea: "No properties are available in this area yet.",
    emptyFeed: "{{name}} has not yet added any properties to this Feed.",
    loadingProperties: "Loading properties...",
    priceFrom: "From",
    completionIn: "Completion in {{year}}.",
    completedIn: "Completed in {{year}}",
    estCompletionIn: ", Est. Completion in {{year}}",
    poweredBy: "Powered By",
    searchPlaceholder: "Development Name, City, Address, Developer...",
    resetMapBoundaries: "Reset Map Boundaries",
    showingProperties_one: "Showing {{from}} - {{to}} of {{total}} Property",
    showingProperties_other: "Showing {{from}} - {{to}} of {{total}} Properties",
    propertiesFound_one: "{{count}} Property found",
    propertiesFound_other: "{{count}} Properties found",
    noResults: "No properties found. Change your filters and try again!",
    inventorySection: "Inventory Section",
    model: "Model",
    loadingUnits: "Loading units...",
    contactForAvailability: "Contact Me For Availability",
    pricedFrom: "Priced from:",
    addlRooms: "Addl. Rooms:",
    totalSqft: "TOTAL SQFT:",
    showingRange: "Showing {{from}} - {{to}} of {{total}}",
    numberOfStories: "Number of Stories",
    interiorDesign: "Interior Design"
  },
  propertiesSearch: {
    selectedMarketArea: "Selected market area"
  },
  locationPicker: {
    label: "Locations",
    loading: "Loading locations...",
    searchPlaceholder: "Search counties, cities and market areas",
    includedIn: "Included in {{places}}",
    remove: "Remove {{name}}",
    counting: "Counting properties...",
    matchCount_one: "Your selection matches {{count}} property.",
    matchCount_other: "Your selection matches {{count}} properties."
  },
  locationPortfolio: {
    updated: "Locations updated.",
    editLocations: "Edit locations",
    editModalBody: "Properties in these locations are added to the portfolio automatically, and removed when they leave or stop being listed.",
    followedLocations: "Followed locations",
    followsLocations: "Follows locations",
    panelBody: "Properties in these locations are added and removed automatically as listings change.",
    sourceQuestion: "How do you want to build it?",
    sourceManualTitle: "Choose properties yourself",
    sourceManualBody: "Add properties one by one from search, alerts or any property page.",
    sourceLocationsTitle: "Follow locations",
    sourceLocationsBody: "Pick counties, cities or market areas. Properties are added and removed automatically as listings change."
  },
  sharePropertyPage: {
    contactMe: "Contact me",
    messageSent: "Your message has been sent and the agent will contact you shortly.",
    brokerImageAlt: "Broker Image"
  },
  landingPages: {
    upgradeNow: "Upgrade Now",
    portfolio: {
      heroTitle: "Go PRO \u2014 The Smarter Way to Sell New Construction",
      heroSubtitle: "Showcase. Share. Close.",
      heroDescription: "With DASH Pro, you're equipped to market and sell Florida's hottest new developments with ease and confidence in 3 simple steps:",
      step1Title: "Create Curated Property Portfolios",
      step1Feature1: "Add properties from any Florida market",
      step1Feature2: "No limits, full access",
      step1Feature3: "Share polished presentations in minutes",
      step2Title: "Add Unbranded Sales Assets",
      step2Feature1: "Download Floorplans, brochures, and developer content",
      step2Feature2: "All content unbranded and ready to share",
      step2Feature3: "Easily add files and send presentations to your clients",
      step3Title: "Share Your Agent-Branded Links",
      step3Feature1: "Replace developer branding with your own contact info",
      step3Feature2: "Effortless data and property information updates in real-time",
      step3Feature3: "Easily collect leads from every link you share",
      ctaTitle: "Upgrade to PRO now for just $25/month",
      ctaSubtitle: "Includes everything in the BASIC plan, plus full access to downloads and portfolio tools for agents.",
      ctaDescription: "Share Your Portfolios With Clients"
    },
    exchange: {
      heroTitle: "Showcase New Construction Effortlessly on Your Website",
      heroDescription: "DASH's eXchange feeds deliver customizable, real-time property listings that help you impress prospects and close more new development deals.",
      feature1Title: "Showcase New Dev on Your Website",
      feature1Item1: "Full access to DASH\u2019s verified new- and pre-construction data",
      feature1Item2: "Multiple feed types, like search, portfolios and single-properties",
      feature1Item3: "Customizable colors and styles",
      feature2Title: "Customized Lead Gen",
      feature2Item1: "Replace development sales branding with your own",
      feature2Item2: "Generate leads via secure contact forms",
      feature2Item3: "Mobile-optimized and ready to convert",
      feature3Title: "Easy Website Integration",
      feature3Item1: "Embed eXchange iframe feeds anywhere on your website",
      feature3Item2: "Real-time updates, no manual upkeep",
      feature3Item3: "Compatible with all major website platforms",
      ctaTitle: "Upgrade to DASH Exchange now for just $60/month",
      ctaSubtitle: "Includes everything in the PRO plan, plus full access to website feed tools for agents.",
      demoLink: "See how top agents use eXchange"
    }
  },
  portalShell: {
    logoAlt: "Dash Logo",
    home: "Home",
    showMore: "Show more",
    showLess: "Show less",
    customRoomsPlaceholder: "Den, Study, Garage, etc...",
    intSqft: "Int. SQFT:",
    extSqft: "Ext. SQFT:",
    totalSqft: "Total. SQFT:"
  },
  apiPortal: {
    notFound: "404 Not Found",
    apiDocumentation: "API Documentation",
    layout: {
      buildingsAlt: "Dash Buildings",
      apiDocs: "API Docs",
      apiReleaseNotes: "API Release Notes",
      apiTerms: "API Terms of Use",
      privacyPolicy: "Privacy Policy",
      copyright: "2026 Dash Inc. All Rights Reserved"
    },
    auth: {
      emailRequired: "Email is required.",
      emailInvalid: "Email must be valid.",
      passwordRequired: "Password is required.",
      passwordPlaceholder: "Enter password",
      tokenMissing: "Token was not provided by API.",
      incorrectCredentials: "Incorrect credentials.",
      loadingAccount: "Loading account info, please wait...",
      redirectHint: "If you are not redirected in 5 seconds, please refresh the page or contact support.",
      backToSignIn: "Or <link>go back to the Sign in page</link>"
    },
    mfa: {
      codeRequired: "Code is required.",
      accessTokenMissing: "Error: Access token not provided. Please contact support.",
      title: "Multi Factor Authentication",
      confirmPrompt: "Please, confirm the code on your Authenticator App.",
      qrError: "Something went wrong while generating the QR code for MFA activation. Please contact the support.",
      enableTitle: "Enable MFA",
      enableScan: "Please enable MFA to proceed. Scan the QR code with your authenticator app.",
      enableCode: "Now enter the code that appears in your authenticator app before it expires.",
      enableDone: "Done! Now MFA will be requested every time you log into the application."
    },
    dashboard: {
      tabTitle: "API Dashboard | DASH",
      requestsThisMonth: "Requests this month (company + plugin users):",
      needMoreRequests: "Need more requests? Click here",
      metricsError: "There was an error getting request metrics. Please refresh the page or contact support if the error persists.",
      usageDelay: "*Usage information may be delayed by up to 1 hour."
    },
    releaseNotes: {
      filterTitle: "Filter Release Notes",
      clearFilters: "Clear filters",
      year: "Year",
      allYears: "All Years",
      changeTypesLabel: "Change Types",
      emptyState: "No release note entries match your filters.",
      changeTypes: {
        newEndpoint: "New Endpoint",
        enhancement: "Enhancement",
        deprecation: "Deprecation",
        behaviorChange: "Behavior Change",
        documentation: "Documentation",
        performance: "Performance"
      }
    },
    settings: {
      appIdNotFound: "No App ID found. Please refresh the page or contact support if the problem persists.",
      appIdTitle: "App ID",
      appIdIs: "Your <bold>App ID</bold> is: {{appId}}",
      appIdSearching: "searching App ID",
      linkCopied: "Link copied to clipboard!",
      docsLine: "You can access our documentation by <link>clicking here.</link>",
      releaseNotesLine: "View the latest API changes in our <link>release notes.</link>",
      termsLine: "Review our <link>API Terms of Use.</link>",
      tokenTitle: "API Token",
      tokenActive: "There is already an active token associated with this App ID.<br/>You can generate a new one by clicking on the button below, but the current token <bold>will be invalidated</bold>.",
      tokenNone: "There is no active token associated with this App ID.<br/>You can generate a new one by clicking on the button below.",
      generateToken: "Generate New Token",
      referralTitle: "Referral Link",
      referralShare: "Share this link with your clients to give them access to our API:",
      referralSteps: "They have to follow the link, create an account, select the API plan and generate their tokens on the settings page.",
      referralSupport: "If you need support, please contact us at <mail>support@dashtodash.com</mail>",
      tokenGenerated: "Token generated successfully. Please keep it safe.",
      tokenGenerateFailed: "Failed to generate token. Please try again.",
      newTokenIs: "Your new token is:",
      tokenCopied: "Token copied to clipboard!",
      tokenStoreWarning: "Please copy and store it in a safe place. It will not be shown again after you close this modal.",
      confirmRegenerate: "Are you sure you want to generate a new token?<br/> The current one <bold>will be invalidated</bold>.",
      firstTokenWarning: "<bold>Important!</bold> Once you generate a token, it will be displayed here.<br/><br/>You <bold>need to copy</bold> it and store it in a safe place. If you lose it, you will need to generate a new one, and the old one <bold>will be invalidated</bold>.",
      generateModalTitle: "Generate New API Token",
      close: "Close",
      cancel: "Cancel"
    }
  },
  confirmUserType: {
    setupError: "Something went wrong while setting up your account. Please try again.",
    title: "Are you a Real Estate Agent?",
    subtitle: "Please answer to proceed.",
    yes: "Yes",
    no: "No"
  },
  subscriptionPlans: {
    billedAnnually: "Billed Annually",
    billedEverySixMonths: "Billed every 6 months",
    saveDiscount: "Save {{percent}}%",
    withYearly: "with yearly",
    withSixMonths: "with six months",
    monthly: "Monthly",
    yearly: "Yearly",
    semiAnnually: "Semi-annually",
    errorLoading: "We're having trouble loading subscription information. Please refresh the page to try again.",
    errorTitle: "Something went wrong",
    refreshPage: "Refresh page",
    errorSupport: "If this problem persists, please contact support.",
    discontinued: "Discontinued",
    legacyPrice: "Legacy price",
    perMonth: "/month",
    yourCurrentPlan: "Your current plan",
    startFreeTrial: "Start a Free Trial",
    getPlan: "Get {{plan}}",
    seeAllPlans: "See all plans",
    contactSales: "Contact Sales",
    bookDemo: "Book a Demo",
    reactivateTrial: "Reactivate Trial",
    cancelTrial: "Cancel trial",
    cancelScheduledDowngrade: "Cancel Scheduled Downgrade",
    currentPlanNote: "This is your current plan.",
    reactivateSubscription: "Reactivate Subscription",
    daysLeftInTrial_one: "{{count}} day left in trial",
    daysLeftInTrial_other: "{{count}} days left in trial",
    accessExpiresIn_one: "Access expires in {{count}} day",
    accessExpiresIn_other: "Access expires in {{count}} days",
    manageOrResubscribe: "Manage or Resubscribe",
    manageOrCancel: "Manage or Cancel Subscription",
    apiCancelNote: "Cancelling deactivates your API access at the end of your billing period. Your App ID and token are preserved."
  }
};

// src/assets/dictionary/en/tables.ts
var tables_default = {
  organizations: {
    addNewButtonLabel: "Add New Organization",
    searchInputPlaceholder: "Search Organizations",
    organizationNameLabel: "Organization Name",
    totalPropertiesLabel: "Total Properties:",
    addedOnLabel: "Added On:",
    placeholder: "There are no properties assigned to this organization",
    paginationLabel: "Showing {{page}} of {{total}} Organizations",
    thereAreNoOrganizations: "There are no organizations"
  },
  marketAreas: {
    addNewMarket: "Add New Market",
    paginationLabel: "Showing {{page}} of {{total}} Market Areas",
    search: "Search",
    placeholder: "There are no market areas"
  },
  amenities: {
    addNewAmenity: "Add New Amenity",
    noAmenities: "No amenities are created yet",
    searchAmenities: "Search Amenities",
    paginationLabel: "Showing {{page}} of {{total}} Amenities"
  },
  organizationSaleTeams: {
    addNewButtonLabel: "Add New Sales Team",
    searchInputPlaceholder: "Search Sales Team",
    placeholder: "No Sales Teams Assigned to this Organization",
    paginationLabel: "Showing {{page}} of {{total}} Sale Teams"
  },
  organizationUsers: {
    addNewButtonLabel: "Invite New User",
    searchInputPlaceholder: "Search Users",
    placeholder: "No Users Assigned to this Organization",
    paginationLabel: "Showing {{page}} of {{total}} Users",
    sendInvitation: "Send Invitation",
    resendInvitation: "Resend Invite"
  },
  organizationProperties: {
    placeholder: "No Properties Assigned to this Organization",
    placeholderSearch: "Your search did not returned any results."
  },
  properties: {
    nameLabel: "Property Name",
    updatedAtLabel: "Last Update",
    addNewButtonLabel: "Add New Property",
    searchInputPlaceholder: "Search Properties",
    placeholder: "There are no properties.",
    placeholderSearch: "Your search did not return any results.",
    paginationLabel: "Showing {{page}} of {{total}} Properties",
    statusSelectPlaceholder: "Visibility",
    cmsStatusSelectPlaceholder: "CMS Status",
    transactionTypeSelectPlaceholder: "For Sale/Rent",
    organizationSelectPlaceholder: "All Organizations",
    updatePaginationLabel: "Showing {{page}} of {{total}}",
    marketAreaSelectPlaceholder: "Market Area",
    buildingTypeSelectPlaceholder: "Property Type",
    tagsSelectPlaceholder: "Tags",
    projectStatusSelectPlaceholder: "Property Status"
  },
  inventory: {
    addNewButtonLabel: "Add Inventory",
    searchInputPlaceholder: "Search Inventory",
    placeholder: "There is no inventory associated with this property",
    paginationLabel: "Showing {{page}} of {{total}} Floor Plans",
    name: "Name",
    quantity: "Quantity",
    quantityShort: "QTY",
    bedrooms: "Beds",
    bathrooms: "Baths",
    breakdownSqft: "SQFT Breakdown",
    totalSqft: "TOTAL SQFT",
    interiorSqft: "Int. SQFT",
    exteriorSqft: "Ext. SQFT",
    inventoryType: "Type",
    priceRange: "Price range",
    floorplan: "Floorplan",
    viewFloorPlan: "View Floor Plan",
    customRooms: "Additional Rooms",
    customRoomsShortened: "Addl. Rooms",
    lastListedFrom: "Last listed from",
    lastListedFromShortened: "Priced from",
    units: "Units",
    recent: "Recent",
    priceDown: "Price (Highest to Lowest)",
    priceUp: "Price (Lowest to Highest)"
  },
  marketingFiles: {
    categoryPlaceholder: "All Categories",
    fileTypePlaceholder: "All File Types",
    totalCountLabel: "{{totalCount}} Marketing Files",
    paginationLabel: "Showing {{page}} of {{total}}",
    filesSelectedLabel: "{{totalCount}} Files Selected",
    downloadAllLabel: "Download All",
    downloadSelectedLabel: "Download Selected",
    searchInputPlaceholder: "Search",
    placeholder: "Currently there are no media files available for this property"
  },
  transactionHistory: {
    invoiceName: "Invoice Name",
    dateOfCharge: "Date of Charge",
    status: "Status",
    amount: "Amount",
    statuses: {
      draft: "Draft",
      open: "Open",
      paid: "Successful",
      uncollectible: "Uncollectible",
      void: "Void"
    }
  },
  brokers: {
    searchBrokers: "Search Agents",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    userStatus: "User Status",
    subscriptionPlan: "Sub. Plan",
    createdAt: "Created Date",
    subStatus: "Sub. Status",
    placeholder: "There are no agents",
    viewAction: "View / Edit",
    unblockAction: "Unblock",
    blockAction: "Block",
    delete: "Delete",
    paginationLabel: "Showing {{page}} of {{total}} Agents",
    userAccountStatus: "User Account Status"
  },
  cmsUsers: {
    unarchive: "Unarchive",
    archive: "Archive",
    edit: "Edit",
    delete: "Delete"
  },
  apiInvitations: {
    status: "Status",
    expiresAt: "Expiration Date",
    createdAt: "Created Date",
    revoke: "Revoke",
    statuses: {
      pending: "Pending",
      accepted: "Accepted",
      // DSH-921: the invitee subscribed to the API plan (invitation consumed).
      fulfilled: "Fulfilled",
      expired: "Expired",
      revoked: "Revoked"
    }
  },
  reactions: {
    nameOrId: "Name or ID",
    email: "Email",
    properties: "Properties",
    reactions: "Reactions"
  },
  propertyNote: {
    placeholder: "This property has no notes",
    paginationLabel: "Showing {{page}} of {{total}}"
  },
  externalSales: {
    placeholder: "There is no external sales team",
    paginationLabel: "Showing {{page}} of {{total}} External Sales"
  },
  propertyComparison: {
    bedrooms: "Beds Range",
    bathrooms: "Baths Range",
    status: "Property Status",
    availableUnits: "Total Units"
  },
  featuredPortfolios: {
    nameLabel: "Portfolio Name",
    updatedAtLabel: "Last Update",
    createdAtLabel: "Created At",
    visibilityLabel: "Visibility",
    propertiesCountLabel: "Properties",
    actionsLabel: "Actions",
    placeholder: "There are no featured portfolios.",
    placeholderSearch: "Your search did not return any results.",
    paginationLabel: "Showing {{page}} of {{total}} Portfolios",
    searchInputPlaceholder: "Search Portfolios",
    addNewButtonLabel: "Create Portfolio",
    sortButtonLabel: "Sort",
    sortPublicDisplay: "Sort Public Display"
  },
  featuredProperties: {
    nameLabel: "Title",
    updatedAtLabel: "Last Update",
    createdAtLabel: "Created At",
    visibilityLabel: "Visibility",
    placeholder: "There are no featured properties.",
    placeholderSearch: "Your search did not return any results.",
    paginationLabel: "Showing {{page}} of {{total}} Properties",
    searchInputPlaceholder: "Search Properties",
    addNewButtonLabel: "Create Property",
    sortPublicDisplay: "Sort Public Display"
  }
};

// src/assets/dictionary/es/common.ts
var import_dash_common3 = require("dash-common");
var import_lodash3 = require("lodash");
var common = {
  labels: {
    signOut: "Cerrar sesi\xF3n",
    account: "Cuenta",
    apiUsers: "Usuarios de API",
    apiManagement: "API",
    settings: "Configuraci\xF3n",
    properties: "Propiedades",
    propertyDetails: "Detalles de la propiedad",
    propertyPreview: "Resumen de la propiedad",
    propertyOverview: "Resumen de la propiedad",
    folderDetails: "Detalles de la carpeta",
    rootMediaFolder: "Carpeta ra\xEDz de medios",
    users: "Usuarios",
    salesTeam: "Equipo de ventas",
    internalSaleTeam: "Equipo de ventas interno",
    organizations: "Organizaciones",
    organization: "Organizaci\xF3n",
    organizationDetails: "Detalles de la organizaci\xF3n",
    featuresAndAmenities: "Caracter\xEDsticas y amenidades",
    projectStatus: "Estado del proyecto",
    salesGalleryStatus: "Estado de la sala de ventas",
    amenities: "Amenidades",
    brokers: "Agentes",
    cardDescription: "Descripci\xF3n de la tarjeta",
    seekers: "Usuarios directos",
    contact: "Contacto",
    contactAgent: "Contactar al agente",
    testAccount: "Cuenta de prueba",
    management: "Gesti\xF3n",
    marketAreas: "Zonas de mercado",
    externalSales: "Ventas externas",
    exploreNewProperties: "Explora propiedades nuevas",
    featuredProperties: "Propiedades destacadas",
    newListings: "Nuevas publicaciones",
    newListingsSubtitle: "Los perfiles de desarrollos m\xE1s recientes agregados a DASH en los \xFAltimos 30 d\xEDas.",
    trendingThisWeek: "Propiedades en tendencia",
    trendingThisWeekSubtitle: "Los desarrollos m\xE1s vistos en DASH, actualizado cada semana.",
    similarProperties: "M\xE1s como esta",
    similarPropertiesSubtitle: "Propiedades similares que podr\xEDan interesarte.",
    recommendedForYou: "Recomendado para ti",
    recommendedForYouSubtitle: "Basado en otras propiedades que has visto.",
    exploreOnMap: "Explora en el mapa",
    exploreOnMapSubtitle: "Recorre propiedades en toda Florida: haz clic en cualquier pin para abrir la propiedad.",
    exploreOnMapSplitSubtitle: "Recorre el mapa y las propiedades correspondientes lado a lado.",
    exploreOnMapExpandableSubtitle: "Abre un mapa interactivo de las propiedades disponibles cuando quieras.",
    exploreOnMapCta: "Mostrar el mapa",
    launchingSoon: "Pr\xF3ximo lanzamiento",
    launchingSoonSubtitle: "Desarrollos en preventa aprobados con anuncios de ventas previstos pronto.",
    ultraLuxuryResidences: "Residencias de ultra lujo",
    ultraLuxuryResidencesSubtitle: "Nuevas residencias premium desde $4M en los mercados m\xE1s activos de Florida.",
    luxuryResidences: "Residencias de lujo",
    luxuryResidencesSubtitle: "Nuevas residencias premium desde $1M en los mercados m\xE1s activos de Florida.",
    under1M: "Residencias por menos de $1M",
    under1MSubtitle: "Nuevo inventario por menos de $1M en los mercados m\xE1s activos de Florida.",
    newRentalDevelopments: "Nuevos desarrollos de renta",
    newRentalDevelopmentsSubtitle: "Explora los desarrollos de renta en preventa y obra nueva m\xE1s recientes en los mercados m\xE1s activos de Florida.",
    show: "Mostrar",
    previous: "Anterior",
    next: "Siguiente",
    add: "Agregar",
    addVirtualTour: "Agregar tour virtual",
    skip: "Omitir",
    update: "Actualizar",
    address: "Direcci\xF3n",
    cancel: "Cancelar",
    confirm: "Confirmar",
    confirmSwitch: "Confirmar cambio",
    notFound: "No encontrado",
    saveChanges: "Guardar cambios",
    save: "Guardar",
    close: "Cerrar",
    for: "para",
    clear: "Borrar",
    fullName: "Nombre completo",
    uploadCancelled: "Subida cancelada",
    to: "A",
    edit: "Editar",
    delete: "Eliminar",
    view: "Ver",
    actions: "Acciones",
    website: "Sitio web",
    status: "Estado de visibilidad",
    propertyStatus: "Estado de la propiedad",
    notes: "Notas",
    changelogs: "Historial de cambios",
    preview: "Vista previa",
    name: "Nombre",
    phone: "Tel\xE9fono",
    seeMore: "Ver m\xE1s",
    open: "Abrir",
    more: "M\xE1s",
    private: "Privado",
    public: "P\xFAblico",
    hidden: "Oculto",
    draft: "Borrador",
    media: "Medios",
    inventory: "Planos",
    featuredFloorPlans: "Planos destacados",
    seeMoreFloorPlans: "Ver m\xE1s planos",
    information: "Informaci\xF3n",
    advanced: "Avanzado",
    description: "Descripci\xF3n",
    metrics: "M\xE9tricas",
    partners: "Socios",
    companies: "Empresas",
    pluginUsers: "Usuarios del plugin",
    invitations: "Invitaciones",
    apiConsole: "Consola de API",
    contentActivity: "Actividad de contenido",
    tracking: "Seguimiento",
    savedProperties: "Propiedades guardadas",
    watchlist: "Lista de seguimiento",
    emptyColumn: "N/D",
    weekDays: {
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Mi\xE9rcoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "S\xE1bado",
      sunday: "Domingo"
    },
    today: "Hoy",
    dateRangePeriods: {
      currentWeek: "Esta semana",
      pastWeek: "Semana pasada",
      currentMonth: "Este mes",
      pastMonth: "Mes pasado",
      threeMonth: "Tres meses",
      custom: "Per\xEDodo personalizado",
      currentYear: "Este a\xF1o"
    },
    dateRangeGroups: {
      hourly: "Por hora",
      daily: "Diario",
      weekly: "Semanal",
      monthly: "Mensual"
    },
    general: "General",
    location: "Ubicaci\xF3n",
    folder: "Carpeta",
    folders: "Carpetas: ({{number}})",
    file: "Archivo",
    files: "Archivos: ({{number}})",
    kBytes: "{{size}} KB",
    mBytes: "{{size}} MB",
    noOptions: "Sin opciones",
    loading: "Cargando...",
    from: "Desde",
    highlights: "Aspectos destacados",
    agentHighlights: "Destacados del agente",
    agentHighlightsNotes: "Notas de destacados del agente",
    upgradeToView: "Mejora tu plan para ver",
    about: "Acerca de",
    archive: "Archivar",
    unarchive: "Desarchivar",
    rename: "Renombrar",
    move: "Mover",
    cvv: "CVV",
    creditCardNumber: "N\xFAmero de tarjeta de cr\xE9dito",
    expiryDate: "Fecha de vencimiento",
    fileName: "Nombre del archivo",
    category: "Categor\xEDa",
    size: "Tama\xF1o",
    added: "Agregado",
    download: "Descargar",
    dashboard: "Panel",
    menu: "Men\xFA",
    portfolios: "Portafolios",
    portfolioDetails: "Detalles del portafolio",
    messages: "Mensajes",
    resend: "Reenviar",
    resendViaEmail: "Reenviar por correo",
    email: "Correo electr\xF3nico",
    showMore: "Mostrar m\xE1s",
    readMore: "Leer m\xE1s",
    showLess: "Mostrar menos",
    any: "Cualquiera",
    miles: "Millas",
    subscription: "Suscripci\xF3n",
    payment: "Pago",
    contentCopy: "Duplicar",
    closed: "Cerrado",
    create: "Crear",
    share: "Compartir",
    compare: "Comparar",
    sortBy: "Ordenar por",
    sortAz: "Alfab\xE9tico A-Z",
    sortZa: "Alfab\xE9tico Z-A",
    sortCreatedAt: "Agregados/creados recientemente",
    filterBy: "Filtrar por",
    selectAll: "Seleccionar todo",
    change: "Cambiar",
    state: "Estado",
    updated: "Actualizado",
    changePhoto: "Cambiar foto",
    goBack: "Volver",
    startSevenDayTrial: "Iniciar prueba gratis de 7 d\xEDas",
    cancelAnytime: "Cancela cuando quieras",
    date: "Fecha",
    branded: "Con marca",
    unbranded: "Sin marca",
    shared: "Compartido",
    brandingType: "Tipo de marca",
    selectBrandingType: "Seleccionar tipo de marca",
    allBrandingTypes: "Todos los tipos de marca",
    all: "Todos",
    sharedFolder: "Carpeta compartida",
    brandedFilesReady: "Archivos con marca listos",
    track: "Seguir",
    createAlert: "Crear alerta",
    calculate: "Calcular",
    moreOptions: "M\xE1s opciones",
    lessOptions: "Menos opciones",
    remove: "Quitar",
    submit: "Enviar",
    sqft: "SqFt",
    beds: "Hab.",
    baths: "Ba\xF1os",
    verified: "Verificado",
    developerVerified: "Verificado por la desarrolladora",
    developerVerifiedOn: "Verificado por la desarrolladora el {{date}}",
    unverified: "Sin verificar",
    comingSoon: "Pr\xF3ximamente",
    dashLogo: "Logotipo de Dash",
    coming_soon: "Pr\xF3ximamente",
    byAppointmentOnly: "Solo con cita",
    soldOut: "Agotado",
    sold_out: "Agotado",
    leavingSoon: "Sale pronto",
    leaving_soon: "Sale pronto",
    leavingSoonBanner: "Las comunidades de casas unifamiliares y townhomes saldr\xE1n de DASH este verano.",
    leavingSoonReadMore: "M\xE1s informaci\xF3n",
    proposed: "Propuesto",
    new_construction: "Obra nueva",
    pre_construction: "Preventa",
    single_family_home: "Casa unifamiliar",
    under_construction: "En construcci\xF3n",
    completed: "Terminado",
    noValue: "N/D",
    notSet: "Sin definir",
    cmsStatus: "Estado en CMS",
    not_set: "Sin definir",
    pending_approval: "Pendiente de aprobaci\xF3n",
    new_listing: "Nueva publicaci\xF3n",
    active_listing: "Publicaci\xF3n activa",
    awaiting_audit: "Pendiente de auditor\xEDa",
    recently_updated: "Actualizado recientemente",
    recently_reviewed: "Verificado recientemente",
    pending_archive: "Pendiente de archivar",
    archived: "Archivado",
    cmsSettings: "Configuraci\xF3n del CMS",
    approve: "Aprobar",
    audit: "Auditar",
    approveProperty: "Aprobar propiedad",
    auditProperty: "Auditar propiedad",
    archiveProperty: "Archivar propiedad",
    approvePropertyConfirmation: '\xBFSeguro que quieres aprobar este borrador? La propiedad ser\xE1 visible y se actualizar\xE1 como "Nueva publicaci\xF3n".',
    auditPropertyConfirmation: "\xBFMarcar esta propiedad como auditada? Esto confirma que la informaci\xF3n fue revisada y es correcta.",
    archivePropertyConfirmation: "\xBFSeguro que quieres archivar esta propiedad? Se ocultar\xE1 de la vista p\xFAblica y se marcar\xE1 como archivada.",
    approving: "Aprobando...",
    auditing: "Auditando...",
    archiving: "Archivando...",
    propertyApprovedSuccess: "La propiedad se aprob\xF3 correctamente",
    propertyApprovedError: "No se pudo aprobar la propiedad",
    propertyAuditedSuccess: "La propiedad se audit\xF3 correctamente",
    propertyAuditedError: "No se pudo auditar la propiedad",
    propertyArchivedSuccess: "La propiedad se archiv\xF3 correctamente",
    propertyArchivedError: "No se pudo archivar la propiedad",
    subscriptionNotSelected: "No se ha seleccionado una suscripci\xF3n",
    billingAddress: "Direcci\xF3n de facturaci\xF3n",
    send: "Enviar",
    viewEditAction: "Ver / Editar",
    subscriptionBanner: "Necesitas tener <tag>{{subscriptionType}}</tag> para acceder a esta p\xE1gina",
    newNote: "Nueva nota",
    read: "Leer",
    search: "Buscar",
    reactions: "Reacciones",
    current: "Actual",
    notBillable: "No facturable",
    studio: "Estudio",
    dashSuffix: "| DASH",
    dashCMSSuffix: "| DASH CMS",
    dashApiAdminSuffix: "| DASH API Admin",
    notWorking: "No funciona",
    notAvailable: "No disponible",
    browserTabTitles: {
      dashboard: "Panel del agente",
      properties: "Propiedades",
      featuredContent: "Contenido destacado",
      featuredContentProperties: "Propiedades destacadas",
      featuredContentPortfolios: "Portafolios destacados",
      portfolios: "Portafolios",
      unavailablePortfolioPage: "Portafolio no disponible",
      profile: "Perfil",
      tracking: "Propiedades en seguimiento",
      watchlist: "Lista de seguimiento",
      messages: "Mensajes",
      signIn: "Iniciar sesi\xF3n",
      signUp: "Registrarse",
      completeSignUpCodeConfirmation: "Completar registro",
      completeSignUpSSO: "Completar registro con SSO",
      forgotPassword: "Contrase\xF1a olvidada",
      completeSignUpPickSubscription: "Elegir suscripci\xF3n",
      stripeCheckoutResult: "Procesar pago",
      completeSignUpAddAdditionalInfo: "Agregar informaci\xF3n adicional",
      resetPassword: "Restablecer contrase\xF1a",
      termConditions: "T\xE9rminos y condiciones",
      privacyPolicy: "Pol\xEDtica de privacidad",
      organizations: "Organizaciones",
      amenities: "Amenidades",
      brokers: "Agentes",
      seekers: "Usuarios directos",
      externalSales: "Ventas externas",
      externalSalesUsers: "Usuarios de ventas externas",
      management: "Gesti\xF3n",
      account: "Cuenta",
      apiUsers: "Usuarios de API",
      apiManagement: "API",
      apiDocs: "Documentaci\xF3n de la API de DASH",
      apiReleaseNotes: "Novedades de la API",
      settings: "Configuraci\xF3n",
      marketAreas: "Zonas de mercado",
      exchange: "Exchange",
      search: "Buscar",
      ssoCallback: "Redirigiendo desde SSO...",
      featuredPortfolios: "Portafolios destacados"
    },
    exchange: "Exchange",
    verifyAccount: "Verificar cuenta",
    verifyAccountShort: "Verificar",
    apply: "Aplicar",
    processing: "Procesando...",
    popular: "Popular",
    applied: "Aplicado",
    closeSearch: "Cerrar b\xFAsqueda",
    scrollLeft: "Desplazar a la izquierda",
    scrollRight: "Desplazar a la derecha"
  },
  placeholders: {
    cardExpiry: "mm/aa",
    noSearchResults: "Tu b\xFAsqueda no arroj\xF3 resultados.",
    searchNoResultsForQuery: 'No se encontraron resultados para "{{query}}"',
    firstAndLastName: "Nombre y apellido",
    selectOption: "Seleccionar opci\xF3n",
    selectProjectStatus: "Seleccionar estado del proyecto",
    selectBrandingType: "Seleccionar tipo de marca",
    globalSearch: "Propiedad, ciudad, zona de mercado, desarrolladora...",
    mobileSearchEmptyMessage: "Busca propiedades, ciudades, zonas de mercado, desarrolladoras y m\xE1s."
  },
  serverMessages: {
    notFound: "Correo o contrase\xF1a incorrectos.",
    uploadFail: "Algo sali\xF3 mal. No se pudo subir.",
    unknown: "Algo sali\xF3 mal.",
    accountNotFound: "Cuenta no encontrada",
    licenseValidationError: "Error al validar la licencia",
    unauthorized: "Enlace inv\xE1lido o vencido. Genera uno nuevo."
  },
  alerts: {
    resetPasswordEmailsSent: "Si se encuentra una cuenta, se enviar\xE1 un enlace para restablecer la contrase\xF1a al correo electr\xF3nico.",
    passwordReset: "\xA1La contrase\xF1a se actualiz\xF3 correctamente! ",
    changesSaved: "\xA1Los cambios se guardaron correctamente!",
    alertWasHidden: "La propiedad fue ocultada",
    alertWasShown: "La propiedad fue mostrada de nuevo",
    accountIsUpdated: "La cuenta fue actualizada",
    invitationHasBeenSent: "\xA1La invitaci\xF3n fue enviada!"
  },
  roles: {
    ORG_SALES_DIRECTOR: "Director",
    ORG_SALES_ASSOCIATE: "Asociado de ventas",
    ORG_DEVELOPER: "Desarrollador",
    ORG_OWNER: "Propietario"
  },
  accountStatuses: {
    [import_dash_common3.AccountStatusesEnum.ACTIVE]: "Activo",
    [import_dash_common3.AccountStatusesEnum.ADDED]: "Agregado",
    [import_dash_common3.AccountStatusesEnum.ARCHIVED]: "Archivado",
    [import_dash_common3.AccountStatusesEnum.EXPIRED]: "Vencido",
    [import_dash_common3.AccountStatusesEnum.INVITED]: "Invitado"
  },
  brokerPortalServerErrors: {
    [import_dash_common3.ServerErrors.ACCOUNT_ARCHIVED]: "La cuenta de usuario fue bloqueada, comun\xEDcate con el soporte de DASH.",
    [import_dash_common3.ServerErrors.BROKER_ACCOUNT_ARCHIVED]: "Tu cuenta est\xE1 bloqueada. {{reason}}. Comun\xEDcate con el soporte de DASH.",
    [import_dash_common3.ServerErrors.WRONG_VERIFICATION_CODE]: "C\xF3digo de verificaci\xF3n incorrecto",
    [import_dash_common3.ServerErrors.LICENSE_ALREADY_EXISTS]: "La licencia ya est\xE1 asociada a una cuenta de DASH.",
    [import_dash_common3.ServerErrors.PORTFOLIO_CONTAIN_FOLDER]: "Esta propiedad ya fue agregada al portafolio",
    [import_dash_common3.ServerErrors.INCORRECT_PASSWORD]: "Contrase\xF1a incorrecta",
    [import_dash_common3.ServerErrors.PHONE_NUMBER_IS_USED]: "El n\xFAmero de tel\xE9fono ya est\xE1 asociado a una cuenta de DASH. Si eres el titular del n\xFAmero, comun\xEDcate con el soporte de DASH.",
    [import_dash_common3.ServerErrors.MAX_CUSTOMER_CARD_PAYMENT_METHODS]: "Alcanzaste el l\xEDmite de m\xE9todos de pago permitidos.",
    [import_dash_common3.ServerErrors.PAYMENT_METHOD_NEEDED]: "Se necesita un m\xE9todo de pago.",
    [import_dash_common3.ServerErrors.UNAVAILABLE_FOR_BROKERS]: "La propiedad no est\xE1 disponible para agentes.",
    [import_dash_common3.ServerErrors.INCORRECT_ACCOUNT_CREDENTIALS]: "Correo o contrase\xF1a incorrectos."
  },
  serverErrors: {
    [import_dash_common3.ServerErrors.PORTFOLIO_IS_EMPTY]: "El portafolio est\xE1 vac\xEDo",
    [import_dash_common3.ServerErrors.PORTFOLIO_IS_PRIVATE]: "El portafolio es privado",
    [import_dash_common3.ServerErrors.PROPERTY_IS_PRIVATE]: "La propiedad es privada",
    [import_dash_common3.ServerErrors.PORTFOLIO_NOT_EXISTS]: "El portafolio no existe",
    [import_dash_common3.ServerErrors.ACCOUNT_EMAIL_ALREADY_EXIST]: "Ya existe una cuenta de DASH con este correo electr\xF3nico. Comun\xEDcate con el soporte de DASH si necesitas restablecer tu contrase\xF1a.",
    [import_dash_common3.ServerErrors.ACCOUNT_ARCHIVED]: "Hay una cuenta archivada con este correo electr\xF3nico. Desarchiva la cuenta para enviar una invitaci\xF3n.",
    [import_dash_common3.ServerErrors.ACCOUNT_NOT_FOUND]: "Cuenta no encontrada",
    [import_dash_common3.ServerErrors.INCORRECT_ACCOUNT_CREDENTIALS]: "El usuario o la contrase\xF1a son incorrectos",
    [import_dash_common3.ServerErrors.API_CREDENTIALS_ALREADY_EXIST]: "No se pueden crear credenciales de API. Ya hay credenciales asociadas a esta cuenta.",
    [import_dash_common3.ServerErrors.ACCOUNT_IS_NOT_RELATED_TO_APPLICATION]: "La cuenta no est\xE1 relacionada con esta aplicaci\xF3n",
    [import_dash_common3.ServerErrors.INVALID_PHONE_NUMBER]: "N\xFAmero de tel\xE9fono inv\xE1lido",
    [import_dash_common3.ServerErrors.ALREADY_ASSIGNED_USER_IN_SALE_TEAM]: "Este usuario ya est\xE1 asignado a este equipo de ventas.",
    [import_dash_common3.ServerErrors.PROPERTY_NAME_EXISTS]: "Ya existe una propiedad con este nombre",
    [import_dash_common3.ServerErrors.PORTFOLIO_FOLDER_NAME_EXISTS]: "El nombre del portafolio debe ser \xFAnico",
    [import_dash_common3.ServerErrors.PORTFOLIO_NAME_ROOT_FORBIDDEN]: 'El nombre del portafolio no puede ser "root"',
    [import_dash_common3.ServerErrors.ALERT_CONFIG_WITH_SAME_NAME]: "Ya existe una alerta con este nombre. Dale a la alerta un nombre \xFAnico.",
    [import_dash_common3.ServerErrors.ALERT_CONFIG_WITH_SAME_FILTER]: "Ya existe una alerta con la misma configuraci\xF3n. Selecciona criterios distintos.",
    [import_dash_common3.ServerErrors.FOLDER_ALREADY_EXISTS]: "Ya existe una carpeta con el mismo nombre en este directorio.",
    [import_dash_common3.ServerErrors.RESERVED_FOLDER]: "Ya existe una carpeta con el mismo nombre",
    [import_dash_common3.ServerErrors.SALE_TEAM_PHONE_EXISTS]: "Ya existe un equipo de ventas externo con este tel\xE9fono.",
    [import_dash_common3.ServerErrors.SUBSCRIPTION_ALREADY_CANCELED]: "\xA1La suscripci\xF3n ya fue cancelada!",
    [import_dash_common3.ServerErrors.PAYMENT_METHOD_DECLINED]: "Tu tarjeta fue rechazada. Comun\xEDcate con el administrador de tu tarjeta o prueba con otra.",
    [import_dash_common3.ServerErrors.INSUFFICIENT_FUNDS]: "Tu tarjeta fue rechazada. Motivo: fondos insuficientes",
    [import_dash_common3.ServerErrors.STOLEN_CARD]: "Tu tarjeta fue rechazada. Motivo: tarjeta robada",
    [import_dash_common3.ServerErrors.LOST_CARD]: "Tu tarjeta fue rechazada. Motivo: tarjeta extraviada"
  },
  fileTypes: {
    photo: "FOTO",
    video: "VIDEO",
    file: "ARCHIVO",
    exel: "XLS",
    doc: "DOC",
    pdf: "PDF"
  },
  subscriptionProductRecurringLabels: {
    [(0, import_lodash3.camelCase)(import_dash_common3.RecurringTypesEnum.FREE)]: "Gratis",
    [(0, import_lodash3.camelCase)(import_dash_common3.RecurringTypesEnum.MONTH)]: "Mes",
    [(0, import_lodash3.camelCase)(import_dash_common3.RecurringTypesEnum.SIXMONTH)]: "Seis meses",
    [(0, import_lodash3.camelCase)(import_dash_common3.RecurringTypesEnum.YEAR)]: "A\xF1o"
  },
  subscriptionTypes: {
    [import_dash_common3.BrokerSubscriptionTypesEnum.BILLABLE]: "Facturable",
    [import_dash_common3.BrokerSubscriptionTypesEnum.DEMO]: "Demo"
  },
  subscriptionStatuses: {
    [import_dash_common3.ProductSubscriptionStatusesEnum.ACTIVE]: "Activa",
    [import_dash_common3.ProductSubscriptionStatusesEnum.CANCELED]: "Cancelada",
    [import_dash_common3.ProductSubscriptionStatusesEnum.SCHEDULED_CANCELLATION]: "Cancelaci\xF3n programada",
    [import_dash_common3.ProductSubscriptionStatusesEnum.INCOMPLETE]: "Incompleta",
    [import_dash_common3.ProductSubscriptionStatusesEnum.INCOMPLETE_EXPIRED]: "Incompleta vencida",
    [import_dash_common3.ProductSubscriptionStatusesEnum.PAST_DUE]: "Pago vencido",
    [import_dash_common3.ProductSubscriptionStatusesEnum.TRIALING]: "En prueba",
    [import_dash_common3.ProductSubscriptionStatusesEnum.UNPAID]: "Sin pagar"
  },
  subscriptionPlanTypes: {
    [import_dash_common3.SubscriptionProductNamesEnum.PRO]: "PRO",
    [import_dash_common3.SubscriptionProductNamesEnum.BASIC]: "Basic"
  },
  ssoProviders: {
    [(0, import_lodash3.camelCase)(import_dash_common3.SSOProvidersEnum.GOOGLE)]: "Google",
    [(0, import_lodash3.camelCase)(import_dash_common3.SSOProvidersEnum.MIAMI_REALTORS)]: "Miami Realtors"
  },
  subscriptionBadgeTitles: {
    noCreditCard: "No necesitas tarjeta de cr\xE9dito",
    trialAvailable: "\xA1Prueba de {{trialDays}} d\xEDas disponible!",
    saveWithSixMonthPlan: "Ahorra 10% con el plan de 6 meses",
    billedEverySixMonths: "Se factura cada seis meses"
  },
  subscriptionProductsCardsLabels: {
    basic: {
      fullDatabaseAccess: "Acceso a toda la base de datos de DASH",
      pricingInventorySalesMaterials: "Consulta precios, inventario, materiales de venta y m\xE1s",
      timestampedUpdates: "Actualizaciones con fecha y verificaci\xF3n de datos",
      personalizedTracking: "Seguimiento y alertas personalizados",
      unlimitedSavedProperties: "Agrega propiedades ilimitadas a tu lista de seguimiento"
    },
    pro: {
      downloadUnbranded: "Descarga contenido de ventas sin marca",
      shareBrandedPortfolios: "Comparte portafolios con tu marca de agente",
      integratedLeadGeneration: "Generaci\xF3n de leads integrada",
      analyticsInsights: "Obt\xE9n informaci\xF3n con anal\xEDticas",
      comparisonTools: "Herramientas para comparar desarrollos"
    },
    exchange: {
      embedFeeds: "Inserta los feeds de DASH en tu sitio web",
      customizationOptions: "Opciones de personalizaci\xF3n con varios tipos de feed",
      iframeImplementation: "Implementaci\xF3n sencilla con iframe",
      platformSupport: "Compatible con las principales plataformas web"
    },
    api: {
      directDataAccess: "Acceso directo a los datos: con\xE9ctate a toda la base de datos de DASH de nuevos proyectos de desarrollo",
      flexibleDisplay: "Visualizaci\xF3n flexible: impulsa tus propias herramientas de b\xFAsqueda, paneles personalizados o herramientas internas",
      apiCredentials: "Incluye clave de API y credenciales"
    },
    direct: {
      overview: "Acceso directo a la plataforma de DASH, creada exclusivamente para descubrir las casas, condominios y comunidades de renta m\xE1s nuevos de Florida",
      developerUpdates: "Actualizaciones de desarrolladoras en tiempo real de m\xE1s de 400 comunidades",
      smartSearchFilters: "Busca por ciudad, fecha de entrega, precio, tipo de propiedad y m\xE1s para encontrar lo que necesitas",
      launchAndPriceAlerts: "Configura alertas de lanzamientos y cambios de precio",
      favoritesAndComparison: "Guarda y organiza tus favoritas mientras comparas opciones",
      salesTeamAccess: "Acceso f\xE1cil a los equipos de ventas en sitio para obtener m\xE1s informaci\xF3n y agendar visitas a las propiedades"
    }
  },
  subscriptionProductsCardsSectionTitles: {
    basic: "Funciones que te encantar\xE1n",
    pro: "Todo lo de Basic, y adem\xE1s:",
    exchange: "Todo lo de Pro, y adem\xE1s:",
    api: "Integraciones de datos personalizadas"
  },
  subscriptionProductsKeyFeatures: "Funciones clave",
  subscriptionProductsCardsDescriptions: {
    basic: "Acceso inmediato para descubrir y explorar la base de datos de obra nueva de DASH.",
    pro: "Descarga materiales de venta sin marca y comparte enlaces con tu marca de agente.",
    exchange: "Agrega cientos de nuevos desarrollos a tu sitio web sin complicaciones.",
    api: "Integra los datos de obra nueva de DASH en tus aplicaciones personalizadas."
  },
  featureLabels: {
    basic: {
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.NO_CREDIT_CARD)]: "NO SE REQUIERE TARJETA DE CR\xC9DITO",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.PRO_UPGRADE)]: "Mejora a PRO cuando quieras para obtener funciones avanzadas",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.VIEW_ALL_PROPERTIES_IN_DATABASE)]: "Acceso ilimitado a la base de datos de propiedades de nuevos desarrollos de DASH",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.ACCESS_TO_PRICING_AVAILABILITY)]: "Acceso a precios y disponibilidad de todas las propiedades",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.ACCESS_TO_MARKETING_MATERIALS)]: "Acceso a los materiales de venta de todas las propiedades",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.TRACK_UPDATES)]: "Sigue las actualizaciones de las propiedades con fecha y verificaci\xF3n",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.ADVANCED_FILTERS_FOR_PINPOINT_SEARCH)]: "Filtros avanzados para una b\xFAsqueda de inventario m\xE1s precisa",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.CUSTOM_ALERTS_NOTIFICATIONS)]: "Alertas personalizadas de propiedades y mercado en tu correo",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashBaseFeaturesEnum.DASH_SUPPORT)]: "Soporte del equipo de DASH cuando lo necesites"
    },
    pro: {
      base: "Incluye todas las funciones del plan Basic, M\xC1S...    ",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING)]: "Comparte portafolios personalizados",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.PROPERTY_COMPARE)]: "Herramientas de comparaci\xF3n lado a lado",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.ANALYTICS_AND_REPORTING_TOOLS)]: "Obt\xE9n informaci\xF3n con anal\xEDticas",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT)]: "Descarga contenido sin marca"
    },
    idx: {
      base: "Incluye todas las funciones del plan PRO, M\xC1S...    ",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.EMBED_LISTINGS)]: "Inserta propiedades de DASH en tu sitio web",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.MULTIPLE_FEED_TYPES)]: "Varios tipos de feed",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.LEAD_GENERATION)]: "Generaci\xF3n de leads",
      [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.IDX_INTEGRATION)]: "Integraci\xF3n sencilla"
    },
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.LIMITED_TIME_INTRODUCTORY_PRICING)]: "PRECIO DE LANZAMIENTO POR TIEMPO LIMITADO"
  },
  featureDescriptions: {
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT)]: "acceso ilimitado a materiales de venta de propiedades sin marca, listos para compartir con clientes o usar en tu sitio web y redes sociales",
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING)]: "personaliza y comparte f\xE1cilmente contenido de desarrollos y grupos seleccionados de propiedades con tus datos de contacto",
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.PROPERTY_COMPARE)]: "crea y comparte con tus principales prospectos enlaces a comparativas de desarrollos",
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.ANALYTICS_AND_REPORTING_TOOLS)]: "accede a herramientas de reportes que miden tus esfuerzos de marketing",
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.EMBED_LISTINGS)]: "una soluci\xF3n IDX pr\xE1ctica para mostrar f\xE1cilmente propiedades de nuevos desarrollos",
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.MULTIPLE_FEED_TYPES)]: "personaliza c\xF3mo se muestran las propiedades, con varias opciones como portafolios, una sola propiedad, b\xFAsqueda y m\xE1s",
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.LEAD_GENERATION)]: "recibe leads directamente de usuarios interesados en las propiedades que muestras",
    [(0, import_lodash3.camelCase)(import_dash_common3.DashFeaturesEnum.IDX_INTEGRATION)]: "DASH Exchange funciona con los principales sitios web, incluidos WordPress, Wix, Squarespace y m\xE1s\u2026"
  },
  brokerLicenseStatuses: {
    [import_dash_common3.BrokerLicenseStatusesEnum.ACTIVE]: "Activa",
    [import_dash_common3.BrokerLicenseStatusesEnum.INACTIVE]: "Inactiva",
    [import_dash_common3.BrokerLicenseStatusesEnum.PENDING_REVIEW]: "Pendiente de revisi\xF3n"
  },
  accountPhoneNumberStatuses: {
    [import_dash_common3.AccountPhoneNumberStatusesEnum.VERIFIED]: "Verificado",
    [import_dash_common3.AccountPhoneNumberStatusesEnum.NOT_VERIFIED]: "Sin verificar"
  },
  moments: {
    year: "a\xF1o",
    month: "mes",
    day: "d\xEDa",
    hour: "hora",
    minute: "minuto",
    second: "segundo",
    plural: {
      year: "a\xF1os",
      month: "meses",
      day: "d\xEDas",
      hour: "horas",
      minute: "minutos",
      second: "segundos"
    },
    short: {
      year: "a",
      month: "mes",
      day: "d",
      hour: "h",
      minute: "min",
      second: "seg"
    },
    shortPlural: {
      year: "a",
      month: "meses",
      day: "d",
      hour: "h",
      minute: "min",
      second: "seg"
    },
    agoLabel: "hace",
    momentLabel: "justo ahora",
    updatedJustNow: "Actualizado justo ahora",
    updatedAgo: {
      year_one: "Actualizado hace {{count}} a\xF1o",
      year_other: "Actualizado hace {{count}} a\xF1os",
      month_one: "Actualizado hace {{count}} mes",
      month_other: "Actualizado hace {{count}} meses",
      day_one: "Actualizado hace {{count}} d\xEDa",
      day_other: "Actualizado hace {{count}} d\xEDas",
      hour_one: "Actualizado hace {{count}} hora",
      hour_other: "Actualizado hace {{count}} horas",
      minute_one: "Actualizado hace {{count}} minuto",
      minute_other: "Actualizado hace {{count}} minutos"
    },
    updatedAgoShort: {
      year_one: "Actualizado hace {{count}} a",
      year_other: "Actualizado hace {{count}} a",
      month_one: "Actualizado hace {{count}} mes",
      month_other: "Actualizado hace {{count}} meses",
      day_one: "Actualizado hace {{count}} d",
      day_other: "Actualizado hace {{count}} d",
      hour_one: "Actualizado hace {{count}} h",
      hour_other: "Actualizado hace {{count}} h",
      minute_one: "Actualizado hace {{count}} min",
      minute_other: "Actualizado hace {{count}} min"
    }
  },
  historyTypesMessages: {
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_NAME]: "Nombre de la propiedad actualizado",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_PRICE]: "Precios y disponibilidad actualizados",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_WEBSITE]: "Sitio web de la propiedad actualizado",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_DEVELOPER_ORGANIZATION]: "Organizaci\xF3n desarrolladora actualizada",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_LOCATION]: "Ubicaci\xF3n de la propiedad actualizada",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_SALES_TEAMS]: "Equipo de ventas actualizado",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_MEDIA_UPLOADED]: "Nuevos materiales de venta subidos a {{folderName}}",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_MEDIA_FILES_MOVED]: "Materiales de venta movidos",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_MEDIA_RENAMED]: "Materiales de venta renombrados",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_MEDIA_REMOVED]: "Materiales de venta eliminados",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_HIGHLIGHTS]: "Aspectos destacados de la propiedad actualizados",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_ABOUT]: "Detalles de la propiedad actualizados",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_FEATURES_AND_AMENITIES]: "Caracter\xEDsticas y amenidades actualizadas",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_ADDED]: "Nuevo inventario agregado",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_UPDATED]: "Inventario actualizado",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_REMOVED]: "Inventario eliminado",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_ADDITIONAL_INFORMATION]: "Informaci\xF3n adicional actualizada",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_VIRTUAL_TOURS]: "Tours virtuales actualizados",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_DATA_REVIEWED]: "Datos de la propiedad verificados",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_CMS_STATUS]: "Estado modificado",
    [import_dash_common3.PropertyChangelogTypesEnum.PROPERTY_VISIBILITY]: "Visibilidad modificada"
  },
  history: {
    propertyUpdates: "Actualizaciones de la propiedad",
    historyUpdates: "Historial de actualizaciones"
  },
  globalSearchCategories: {
    all: "Todos los resultados",
    properties: "Propiedades",
    locations: "Ubicaciones",
    organizations: "Desarrolladoras"
  },
  searchIndexSubtypes: {
    PROPERTY: "Propiedad",
    CITY: "Ciudad",
    COUNTY: "Condado",
    STATE: "Estado",
    MARKET_AREA: "Zona de mercado",
    DEVELOPER: "Desarrolladora"
  },
  sortOptions: {
    alphabeticalAZ: "Alfab\xE9tico A-Z",
    alphabeticalZA: "Alfab\xE9tico Z-A",
    createdAt: "M\xE1s recientes (agregadas \xFAltimamente)",
    newListing: "Solo nuevas publicaciones",
    updatedAt: "\xDAltima actualizaci\xF3n",
    lastUpdatedAtByChangelog: "\xDAltima actualizaci\xF3n",
    lastBrokerVisit: "Visitadas recientemente",
    newestAdded: "Agregadas m\xE1s recientemente",
    oldestAdded: "Agregadas hace m\xE1s tiempo",
    recentlyUpdated: "Actualizadas recientemente",
    mediaSizeUp: "Tama\xF1o de mayor a menor",
    mediaSizeDown: "Tama\xF1o de menor a mayor",
    yearBuilt: "A\xF1o de construcci\xF3n",
    isMarkedAsVerified: "Verificadas",
    startingPriceAsc: "Precio inicial (menor a mayor)",
    startingPriceDesc: "Precio inicial (mayor a menor)",
    maxPriceAsc: "Precio m\xE1ximo (menor a mayor)",
    maxPriceDesc: "Precio m\xE1ximo (mayor a menor)"
  },
  modalDelete: {
    removedToast: "{{entity}} fue eliminado",
    note: "Nota:",
    title: "Eliminar {{entity}}",
    confirmationText: "Confirmar la eliminaci\xF3n de",
    confirmationTextSecond: "Confirmar la eliminaci\xF3n de {{entity}}",
    confirmationWithName: "\xBFConfirmas que quieres eliminar <bold>{{name}}</bold> ({{entity}})?"
  },
  modalConfirmDelete: {
    actionUnassing: "Esta acci\xF3n quitar\xE1 ",
    propertiesCurrentAssigned: ' "{{entity}}" de las propiedades que lo tienen asignado actualmente.',
    ProceedDeletion: "\xBFContinuar con la eliminaci\xF3n?"
  },
  bannerPreview: {
    dimensions: "Altura (fija): {{height}} px | Ancho actual: {{width}} px",
    device: "Dispositivo: {{device}}",
    mobile: "Celular: {{isMobile}}",
    sliderInstruction: "Usa el control deslizante para cambiar el tama\xF1o del banner"
  },
  paymentFailedBanner: {
    message: "Tu \xFAltimo pago no se proces\xF3. Actualiza tu m\xE9todo de pago para mantener el acceso completo.",
    action: "Actualizar m\xE9todo de pago"
  },
  languageSwitcher: {
    label: "Idioma",
    accountHint: "Solo cambia este navegador. El idioma de tu cuenta est\xE1 en Configuraci\xF3n."
  },
  backendErrors: {
    apiCredentialsAlreadyExist: "No se pueden crear credenciales de API. Ya hay credenciales asociadas a esta cuenta.",
    invalidIdxId: "ID de feed no v\xE1lido.",
    propertyDoesNotExist: "La propiedad no existe.",
    passwordRequiredForPortfolio: "Se requiere una contrase\xF1a para abrir este portafolio.",
    portfolioNotAvailable: "El portafolio no est\xE1 disponible.",
    trackedPropertiesLimitReached: "Alcanzaste el l\xEDmite de propiedades en seguimiento.",
    unauthorized: "No autorizado",
    internalServerError: "Error interno del servidor",
    somethingWentWrong: "Algo sali\xF3 mal.",
    twoFactorAlreadyEnabled: "La verificaci\xF3n en dos pasos ya est\xE1 activada.",
    twoFactorNotActivated: "La verificaci\xF3n en dos pasos no est\xE1 activada.",
    invalidCode: "C\xF3digo no v\xE1lido.",
    authenticatorAppRequired: "Esta cuenta se verifica con una aplicaci\xF3n de autenticaci\xF3n.",
    qrCodeFailed: "Error al generar el c\xF3digo QR.",
    invitationNotFound: "Invitaci\xF3n no encontrada.",
    invitationUsed: "Este enlace de invitaci\xF3n ya fue utilizado.",
    invitationExpired: "Este enlace de invitaci\xF3n venci\xF3.",
    invitationOnlyPendingResend: "Solo se pueden reenviar invitaciones pendientes.",
    invitationOnlyPendingRevoke: "Solo se pueden revocar invitaciones pendientes.",
    expirationDateInFuture: "La fecha de vencimiento debe ser futura.",
    apiCredentialNotFound: "Credencial de API no encontrada.",
    apiCredentialNotDeleted: "La credencial de API no est\xE1 eliminada.",
    pluginUserNotFound: "Usuario del plugin no encontrado.",
    marketplacePartnersOnly: "Solo los socios del marketplace pueden administrar usuarios del plugin.",
    pluginUsersCannotSwitchAccountType: "Los usuarios del plugin de API no pueden cambiar el tipo de cuenta.",
    accountTypeSwitchedOnce: "El tipo de cuenta no se puede cambiar m\xE1s de una vez.",
    brokerNotFound: "Agente no encontrado.",
    notAllowedForRole: "\xA1Acci\xF3n no permitida para este rol!",
    notAllowedForUser: "Este usuario no tiene permiso para realizar esta acci\xF3n.",
    featureNotInPlan: "Funci\xF3n no disponible en tu suscripci\xF3n actual",
    subscriptionNotActive: "La suscripci\xF3n no est\xE1 activa",
    subscriptionNotFound: "Suscripci\xF3n no encontrada.",
    renewOnlyCanceled: "\xA1La renovaci\xF3n solo est\xE1 disponible para suscripciones canceladas!",
    retryOnlyIncomplete: "\xA1El reintento solo est\xE1 disponible para suscripciones incompletas!",
    retryOnlyOpenInvoice: "\xA1El reintento solo est\xE1 disponible para facturas de suscripci\xF3n abiertas!",
    activeStripeSubscriptionExists: "Este cliente ya tiene una suscripci\xF3n activa.",
    notStripeCustomer: "La cuenta no es un cliente de Stripe.",
    portfolioNotFound: "Portafolio no encontrado.",
    portfolioNotOwned: "El portafolio no pertenece a esta cuenta.",
    featuredPortfolioNotFound: "Portafolio destacado no encontrado",
    featuredPortfolioNothingToCopy: "No hay propiedades p\xFAblicas disponibles para copiar.",
    featuredPropertyNotFound: "Propiedad destacada no encontrada",
    featuredPortfolioAlreadySaved: "El portafolio destacado ya est\xE1 guardado.",
    propertyNotFound: "Propiedad no encontrada.",
    propertyNotPublic: "La propiedad no es p\xFAblica",
    propertyUnavailableForBrokers: "La propiedad no est\xE1 disponible para agentes",
    propertyAlreadyTracked: "La propiedad ya est\xE1 en seguimiento.",
    propertyAlreadyInPortfolio: "La propiedad {{name}} ya se agreg\xF3 al portafolio",
    propertiesAlreadyInFolder: "Algunas propiedades ya est\xE1n en esta carpeta.",
    alertNotFound: "Alerta no encontrada.",
    amenityNotFound: "Amenidad no encontrada",
    accountNotFound: "Cuenta no encontrada",
    invalidApiCredentials: "ID de aplicaci\xF3n o clave de API no v\xE1lidos.",
    targetNotFolder: "El destino no es una carpeta",
    mediaNotFound: "Archivo multimedia no encontrado",
    noMediaToDownload: "No se encontraron archivos multimedia para descargar",
    mediaFolderNotFound: "Carpeta de archivos multimedia no encontrada o no se puede eliminar",
    mediaDifferentFolders: "Los archivos multimedia seleccionados no est\xE1n en la misma carpeta.",
    incorrectFileSize: "Tama\xF1o de archivo incorrecto.",
    incorrectFileExtension: "Extensi\xF3n de archivo incorrecta.",
    feedNotFound: "Feed no encontrado.",
    feedSettingsNotFound: "Configuraci\xF3n del feed no encontrada.",
    feedSettingsAlreadyExist: "La configuraci\xF3n del feed ya existe.",
    feedOwnerNotConfigured: "El propietario del feed a\xFAn no ha configurado IDX.",
    feedNoDownloads: "Este feed no ofrece descargas.",
    feedNoPortfolio: "Este feed no tiene portafolio.",
    propertyNotInFeed: "Esta propiedad no pertenece a este feed.",
    portfolioNoLocations: "Este portafolio no sigue ubicaciones.",
    salesMaterialsNotAvailable: "Los materiales de venta no est\xE1n disponibles para el tipo de feed Search Bar.",
    startDateAfterEndDate: "La fecha de inicio no puede ser posterior a la fecha de finalizaci\xF3n.",
    originRequired: "Se requiere el encabezado Origin o Referer.",
    sessionUrlInvalid: "La URL de la sesi\xF3n no es v\xE1lida",
    noteDeleteOwnOnly: "Solo puedes eliminar tus propias notas.",
    noteEditOwnOnly: "Solo puedes editar tus propias notas.",
    cardDeclined: "Tu tarjeta fue rechazada.",
    cardInsufficientFunds: "Tu tarjeta no tiene fondos suficientes.",
    cardExpired: "Tu tarjeta venci\xF3.",
    cardCvcIncorrect: "El c\xF3digo de seguridad de tu tarjeta es incorrecto.",
    cardNumberIncorrect: "El n\xFAmero de tu tarjeta es incorrecto.",
    cardExpiryIncorrect: "La fecha de vencimiento de tu tarjeta es incorrecta.",
    cardNumberIncomplete: "El n\xFAmero de tu tarjeta est\xE1 incompleto.",
    cardExpiryIncomplete: "La fecha de vencimiento de tu tarjeta est\xE1 incompleta.",
    cardCvcIncomplete: "El c\xF3digo de seguridad de tu tarjeta est\xE1 incompleto.",
    cardNotSupported: "Tu tarjeta no admite este tipo de compra.",
    cardProcessingError: "Ocurri\xF3 un error al procesar tu tarjeta. Int\xE9ntalo de nuevo en unos minutos.",
    postalCodeIncomplete: "Tu c\xF3digo postal est\xE1 incompleto.",
    networkError: "Error de red. Revisa tu conexi\xF3n e int\xE9ntalo de nuevo."
  },
  systemMediaFolders: {
    brochures: "Folletos",
    factSheets: "Fichas t\xE9cnicas",
    floorPlans: "Planos",
    images: "Im\xE1genes",
    videos: "Videos",
    other: "Otros",
    slideshow: "Presentaci\xF3n",
    agentsOnly: "Solo agentes"
  },
  inventoryTypes: {
    MODEL: "Modelo",
    FOR_SALE: "En venta"
  },
  components: {
    select: {
      selectAll: "Seleccionar todo"
    },
    map: {
      close: "Cerrar mapa",
      expandFullscreen: "Expandir mapa a pantalla completa",
      expand: "Expandir mapa"
    },
    pdfViewer: {
      loadError: "Ocurri\xF3 un error al cargar este documento."
    },
    slideshow: {
      previousImage: "Imagen anterior",
      nextImage: "Imagen siguiente"
    },
    featuredBanner: {
      seeMore: "Ver m\xE1s",
      seeMoreDetails: "Ver m\xE1s detalles"
    },
    upgradeBanner: {
      featurePropertyData: "Datos y descripciones completos de la propiedad",
      featureContacts: "Contactos de la desarrolladora y del equipo de ventas",
      featureAssets: "Planos, folletos e im\xE1genes",
      featureTracking: "Herramientas de seguimiento para agentes",
      title: "Desbloquea el acceso completo a {{propertyName}}",
      subtitle: "Obt\xE9n informaci\xF3n completa de la propiedad con <bold>{{planName}}</bold>"
    },
    restrictedFiles: {
      ariaLabel: "Mejora tu plan para acceder a los materiales de venta",
      empty: "No hay archivos en esta carpeta",
      filesInFolder_one: "Hay {{count}} archivo en esta carpeta",
      filesInFolder_other: "Hay {{count}} archivos en esta carpeta",
      upgradeHint: "Mejora tu plan y accede a los archivos verificados de la desarrolladora"
    },
    inventory: {
      intSqft: "SQFT int.:",
      extSqft: "SQFT ext.:",
      totalSqft: "SQFT total:",
      seeMoreUnitsAria_one: "Ver {{count}} unidad m\xE1s",
      seeMoreUnitsAria_other: "Ver {{count}} unidades m\xE1s",
      seeMoreUnits_one: "Ver {{count}} unidad m\xE1s",
      seeMoreUnits_other: "Ver {{count}} unidades m\xE1s",
      viewAllHint: "Ver todos los planos, precios y disponibilidad"
    },
    virtualTours: {
      numbered: "Recorrido virtual {{number}}",
      select: "Seleccionar recorrido virtual"
    },
    apiChart: {
      requests: "Solicitudes de API"
    }
  },
  propertyMap: {
    propertiesInArea_one: "{{count}} propiedad en esta zona",
    propertiesInArea_other: "{{count}} propiedades en esta zona",
    zoomHint: "Ac\xE9rcate o haz clic para explorar cada una",
    completionIn: "Finalizaci\xF3n en {{year}}"
  }
};
var common_default2 = common;

// src/assets/dictionary/es/forms.ts
var forms = {
  labels: {
    email: "Correo electr\xF3nico",
    password: "Contrase\xF1a",
    firstName: "Nombre",
    lastName: "Apellido",
    apiReferralCode: "C\xF3digo de referido",
    apiAccountType: "Tipo de cuenta",
    apiDirectUser: "Usuario directo de API",
    apiDirectUserDesc: "Usa la API para su propia integraci\xF3n.",
    apiMarketplacePartner: "Socio de marketplace",
    apiMarketplacePartnerDesc: "Revende acceso a la API. Recibe un enlace de referido para registrar usuarios de plugin, cuyas solicitudes cuentan contra la cuota de esta empresa. El c\xF3digo del enlace se genera autom\xE1ticamente.",
    apiCompany: "Empresa",
    apiCompanyRepresentative: "Representante",
    apiClientCount: "Clientes",
    apiCompanyName: "Empresa responsable",
    apiMonthlyAccess: "Acceso mensual",
    apiInvitationExpiresAt: "Fecha de vencimiento",
    apiMfa: "MFA",
    apiMfaOn: "Activada",
    apiMfaOff: "Desactivada",
    apiDirectRequests: "Solicitudes directas este mes",
    newPassword: "Nueva contrase\xF1a",
    confirmPassword: "Confirmar contrase\xF1a",
    signIn: "Iniciar sesi\xF3n",
    forgotPassword: "\xBFOlvidaste tu contrase\xF1a?",
    sendResetInstructions: "Enviar instrucciones para restablecer la contrase\xF1a",
    resetPassword: "Restablecer contrase\xF1a",
    inventoryType: "Tipo",
    name: "Nombre",
    url: "URL del sitio web",
    address: "Direcci\xF3n",
    map: "Mapa",
    logo: "Logo de la organizaci\xF3n",
    svgIcon: "\xCDcono SVG",
    organization: "Organizaci\xF3n",
    primaryOrganization: "Organizaci\xF3n principal",
    additionalOrganizations: "Organizaciones adicionales",
    proposedPropertyOnly: "Crear como propuesta (solo nombre)",
    streetName: "Direcci\xF3n",
    city: "Ciudad",
    zipCode: "C\xF3digo postal",
    workingHours: "Horario de atenci\xF3n",
    county: "Condado",
    radius: "Radio",
    state: "Estado",
    marketArea: "Zona de mercado",
    buildingType: "Tipo de propiedad",
    propertyTag: "Etiquetas de la propiedad",
    tags: "Etiquetas",
    projectStatus: "Estado de la propiedad",
    salesGalleryStatus: "Estado de la sala de ventas",
    salesGalleryAddress: "Direcci\xF3n de la sala de ventas",
    propertyTransactionType: "Tipo de transacci\xF3n",
    teamLogo: "Logo del equipo",
    stories: "Pisos",
    yearBuilt: "A\xF1o de construcci\xF3n",
    leadArchitect: "Arquitecto principal",
    landscapeArchitect: "Arquitecto paisajista",
    nbrOfTowers: "N\xFAmero de torres",
    constructionStartDate: "Fecha prevista de inicio de obra",
    nbrOfUnits: "N\xFAmero de unidades",
    completionDate: "Fecha prevista de finalizaci\xF3n",
    localArchitect: "Arquitecto local",
    interiorDesigner: "Dise\xF1ador de interiores",
    overview: "Aspectos destacados de la propiedad",
    projectDetails: "Resumen de la propiedad",
    taxInformation: "Impuestos y HOA",
    websiteOfProperty: "Sitio web de la propiedad",
    virtualTourUrl: "URL del tour virtual {{number}}",
    virtualTourLabel: "Etiqueta visible (opcional)",
    priceOfProperty: "Precio",
    salesTeam: "Equipo de ventas",
    salesDirector: "Director de ventas",
    salesAssociate: "Asociado de ventas",
    brokerLicense: "Licencia de agente (solo EE. UU.)",
    brokerLicenseLabel: "Licencia de agente",
    agentLicenseStatus: "Estado de la licencia del agente",
    commission: "Comisi\xF3n %",
    contactUrl: "URL de contacto",
    anyPrice: "Cualquier precio",
    priceMin: "Precio (M\xCDN)",
    priceMax: "Precio (M\xC1X)",
    market: "Mercado",
    baths: "{{count}} ba\xF1os",
    beds: "{{count}} hab.",
    share: "Compartir",
    visibility: "Visibilidad",
    link: "Enlace",
    portfolioLink: "Enlace del portafolio",
    saveToApplyChanges: "Guarda para aplicar los cambios",
    customRooms: "Habitaciones adicionales",
    inventoryInfo: "Informaci\xF3n del inventario",
    contactInfo: "Informaci\xF3n de contacto",
    defaultInventoryDetails: "Detalles de inventario predeterminados",
    averageBedroomsNumber: "Promedio de habitaciones",
    averageBathroomsNumber: "Promedio de ba\xF1os",
    averageNumbersLabels: {
      bedrooms: "Habitaciones ({{range}})",
      bathrooms: "Ba\xF1os ({{range}})",
      interiorSqft: "SQFT interiores ({{range}})",
      exteriorSqft: "SQFT exteriores ({{range}})"
    },
    buildingTypes: {
      activeAdult: "Adultos activos (55+)",
      boutique: "Boutique",
      condo: "Condominio",
      condoConversion: "Conversi\xF3n a condominio",
      condoHotel: "Condo-hotel",
      luxuryApartment: "Desarrollo de renta",
      penthouse: "Penthouse",
      privateResidence: "Residencia privada",
      shortTermRentalFriendly: "Apto para renta a corto plazo",
      singleFamilyHome: "Casa unifamiliar",
      townhome: "Townhome",
      villa: "Villa",
      workforceHousing: "Vivienda asequible"
    },
    propertyTags: {
      activeAdult: "Adultos activos (55+)",
      boutique: "Boutique",
      brandedResidences: "Residencias de marca",
      condoConversion: "Conversi\xF3n a condominio",
      eb5Program: "Programa EB-5",
      limitedInventory: "Inventario limitado",
      masterPlanned: "Comunidad planificada",
      penthouse: "Penthouse",
      resortStyle: "Estilo resort",
      shortTermRentalFriendly: "Apto para renta a corto plazo",
      waterfront: "Frente al agua",
      workforceHousing: "Vivienda asequible"
    },
    projectStatuses: {
      comingSoon: "Pr\xF3ximamente",
      soldOut: "Agotado",
      developerInventory: "Inventario de la desarrolladora",
      newConstruction: "Obra nueva",
      newListing: "Nueva publicaci\xF3n",
      preConstruction: "Preventa",
      underConstruction: "En construcci\xF3n",
      completed: "Terminado",
      proposed: "Propuesto",
      leavingSoon: "Sale pronto"
    },
    salesGalleryStatuses: {
      appointmentOnly: "Solo con cita",
      comingSoon: "Pr\xF3ximamente",
      hoursAvailable: "Horario disponible",
      noInformation: "Sin informaci\xF3n (ocultar sala de ventas)"
    },
    propertyStatuses: {
      draft: "Borrador",
      public: "P\xFAblico",
      private: "Privado"
    },
    propertyTransactionTypes: {
      forSale: "En venta",
      forRent: "En renta"
    },
    markets: {
      florida: {
        alva: "Alva",
        aveMaria: "Ave Maria",
        aventura: "Aventura",
        balHarbour: "Bal Harbour",
        bayHarborIslands: "Bay Harbor Islands",
        belleGlade: "Belle Glade",
        bocaRaton: "Boca Raton",
        bonitaSprings: "Bonita Springs",
        boyntonBeach: "Boynton Beach",
        brandon: "Brandon",
        brickell: "Brickell",
        capeCoral: "Cape Coral",
        cityOfMarco: "City of Marco",
        clearwater: "Clearwater",
        cocoaBeach: "Cocoa Beach",
        coconutGrove: "Coconut Grove",
        cooperCity: "Cooper City",
        coralGables: "Coral Gables",
        coralSprings: "Coral Springs",
        cutlerBay: "Cutler Bay",
        daniaBeach: "Dania Beach",
        davie: "Davie",
        deerfieldBeach: "Deerfield Beach",
        delrayBeach: "Delray Beach",
        doral: "Doral",
        downtownFortLauderdale: "Downtown Fort Lauderdale",
        downtownFortMyers: "Downtown Fort Myers",
        downtownMiami: "Downtown Miami",
        downtownStPetersburg: "Downtown St. Petersburg",
        dunedin: "Dunedin",
        edgewater: "Edgewater",
        esteroBay: "Estero Bay",
        esteroIsland: "Estero Island",
        evergladesCity: "Everglades City",
        fisherIsland: "Fisher Island",
        floridaCity: "Florida City",
        fortLauderdale: "Fort Lauderdale",
        fortMyers: "Fort Myers",
        fortMyersBeach: "Fort Myers Beach",
        fortPierce: "Fort Pierce",
        greenacres: "Greenacres",
        hallandaleBeach: "Hallandale Beach",
        hillsboroBeach: "Hillsboro Beach",
        hobeSound: "Hobe Sound",
        hobeSoundBeach: "Hobe Sound Beach",
        hollywood: "Hollywood",
        homestead: "Homestead",
        jupiter: "Jupiter",
        kendall: "Kendall",
        lakeland: "Lakeland",
        lakePark: "Lake Park",
        lakeWorthBeach: "Lake Worth Beach",
        lasOlas: "Las Olas",
        lauderdaleLakes: "Lauderdale Lakes",
        lauderhill: "Lauderhill",
        lehighAcres: "Lehigh Acres",
        lidoKey: "Lido Key",
        loxahatchee: "Loxahatchee",
        mangoniaPark: "Mangonia Park",
        marcoIsland: "Marco Island",
        melbourne: "Melbourne",
        melbourneBeach: "Melbourne Beach",
        miami: "Miami",
        miamiBeach: "Miami Beach",
        miamiGardens: "Miami Gardens",
        miamiRiver: "Miami River",
        midtownMiami: "Midtown Miami",
        miramar: "Miramar",
        moorings: "Moorings",
        naples: "Naples",
        naplesPark: "Naples Park",
        northBayVillage: "North Bay Village",
        northMiami: "North Miami",
        northMiamiBeach: "North Miami Beach",
        northNaples: "North Naples",
        oaklandPark: "Oakland Park",
        oldNaples: "Old Naples",
        orlando: "Orlando",
        palmBay: "Palm Bay",
        palmBeachGardens: "Palm Beach Gardens",
        palmBeachShores: "Palm Beach Shores",
        palmHarbor: "Palm Harbor",
        parkland: "Parkland",
        parkShore: "Park Shore",
        pelicanBay: "Pelican Bay",
        pembrokePines: "Pembroke Pines",
        pinecrest: "Pinecrest",
        plantation: "Plantation",
        portCharlotte: "Port Charlotte",
        portStLucie: "Port St. Lucie",
        pompanoBeach: "Pompano Beach",
        princeton: "Princeton",
        puntaGorda: "Punta Gorda",
        richmondWest: "Richmond West",
        riverview: "Riverview",
        rivieraBeach: "Riviera Beach",
        royalPalmBeach: "Royal Palm Beach",
        sanibel: "Sanibel",
        sarasota: "Sarasota",
        sarasotaBay: "Sarasota Bay",
        satelliteBeach: "Satellite Beach",
        sebastian: "Sebastian",
        springHill: "Spring Hill",
        stPeteBeach: "St. Pete Beach",
        stPetersburg: "St. Petersburg",
        stuart: "Stuart",
        sunnyIslesBeach: "Sunny Isles Beach",
        sunrise: "Sunrise",
        surfside: "Surfside",
        tamarac: "Tamarac",
        tampa: "Tampa",
        tarponSprings: "Tarpon Springs",
        titusville: "Titusville",
        veroBeach: "Vero Beach",
        victoriaPark: "Victoria Park",
        westlake: "Westlake",
        westPalmBeach: "West Palm Beach",
        weston: "Weston",
        wynwood: "Wynwood"
      }
    },
    nameOfProperty: "Nombre de la propiedad",
    quantity: "Cantidad",
    bedrooms: "# de habitaciones",
    bathrooms: "# de ba\xF1os",
    totalSqft: "SQFT totales",
    interiorSqft: "SQFT interiores",
    exteriorSqft: "SQFT exteriores",
    startingPrice: "Precio inicial ",
    highestPrice: "Precio m\xE1s alto ",
    floorplan: "Plano (PDF)",
    login: "Iniciar sesi\xF3n",
    role: "Rol",
    properties: "Propiedades",
    brokerLicenseNumber: "N\xFAmero de licencia de agente (solo EE. UU.)",
    addManually: "Agregar manualmente",
    phoneNumber: "N\xFAmero de tel\xE9fono",
    verifyPhoneNumberCode: "C\xF3digo de verificaci\xF3n",
    shortDescription: "Descripci\xF3n breve",
    agencyName: "Nombre de la agencia",
    companyName: "Nombre de la empresa",
    agencyWebsite: "Sitio web de la agencia",
    website: "Sitio web",
    propertyType: "Tipo de propiedad",
    alertName: "Nombre de la alerta",
    oldPassword: "Contrase\xF1a anterior",
    subscriptionPlanName: "Nombre del plan de suscripci\xF3n",
    subscriptionPlanStatus: "Estado del plan de suscripci\xF3n",
    subscriptionPlanTypes: "Tipo de suscripci\xF3n",
    subscriptionType: "Tipo de suscripci\xF3n",
    userStatus: "Estado del usuario",
    mortgageTotalPrice: "Monto de la hipoteca",
    mortgageDownPayment: "Pago inicial",
    mortgageInterestRate: "Tasa de inter\xE9s (%) ",
    mortgageTerm: "Plazo de la hipoteca (a\xF1os)",
    mortgageTaxRate: "Impuesto predial (anual)",
    mortgageInsuranceRate: "Seguro de la propiedad (anual)",
    termForTheDemo: "Duraci\xF3n de la demo",
    reasonUnActive: "Indica el motivo de la desactivaci\xF3n",
    note: "Notas",
    attachFiles: "Adjuntar archivos",
    min: "M\xCDN",
    max: "M\xC1X",
    salesWorkingHours: "Horario de la sala de ventas",
    realUser: "Cuenta de agente",
    testUser: "Cuenta de prueba",
    accountType: "Tipo de cuenta",
    excludeFromReports: "Excluir de los reportes",
    isAPIUser: "Usuario de API",
    portfolioName: "Nombre del portafolio",
    propertyName: "T\xEDtulo",
    bannerTitle: "T\xEDtulo del banner",
    description: "Descripci\xF3n",
    coverImage: "Imagen de portada",
    shortOverview: "Resumen breve",
    brokerContactCard: {
      yourName: "Tu nombre",
      phone: "Tel\xE9fono",
      message: "Mensaje",
      sendMessage: "Enviar mensaje",
      sendNewMessage: "Enviar otro mensaje",
      visitWebsite: "Visitar sitio web",
      contactMe: "CONT\xC1CTAME:",
      messageSent: "\xA1Tu mensaje fue enviado!",
      agentWillContact: "El agente se comunicar\xE1 contigo pronto.",
      failedToSendMessage: "No se pudo enviar el mensaje. Int\xE9ntalo de nuevo.",
      nameRequired: "El nombre es obligatorio",
      messageRequired: "El mensaje es obligatorio",
      morePropertiesTitle: "Residencias de esta colecci\xF3n",
      morePropertiesTitleAgent: "Propiedades de este portafolio",
      emailInvalid: "Ingresa un correo v\xE1lido",
      logoAlt: "Logotipo de Dash"
    }
  },
  messages: {
    shareSettingsSaved: "La configuraci\xF3n para compartir se guard\xF3 correctamente",
    emailBlank: "El email est\xE1 vac\xEDo",
    emailRequired: "El email es obligatorio",
    emailInvalid: "Formato de email inv\xE1lido",
    expirationRequired: "La fecha de vencimiento es obligatoria",
    expirationFuture: "La fecha de vencimiento debe ser futura",
    passwordBlank: "La contrase\xF1a est\xE1 vac\xEDa",
    passwordRequired: "La contrase\xF1a es obligatoria",
    passwordInvalid: "La contrase\xF1a debe tener al menos 8 caracteres, 1 s\xEDmbolo, 1 n\xFAmero, 1 min\xFAscula y 1 may\xFAscula",
    passwordValid: "Tu contrase\xF1a es v\xE1lida",
    newPasswordValid: "Tu contrase\xF1a es v\xE1lida",
    confirmPasswordValid: "Las contrase\xF1as coinciden",
    confirmPasswordInValid: "Las contrase\xF1as deben coincidir",
    firstNameBlank: "El nombre est\xE1 vac\xEDo",
    fieldLengthInvalid: "Demasiados caracteres.",
    lastNameBlank: "El apellido est\xE1 vac\xEDo",
    nameBlank: "El nombre es obligatorio",
    nameInvalid: "El nombre es inv\xE1lido",
    iconBlank: "No se subi\xF3 ning\xFAn \xEDcono",
    fileBlank: "No se subi\xF3 ning\xFAn archivo",
    urlInvalid: "El enlace no es v\xE1lido. Prueba con el formato www.sitio.com",
    urlBlank: "La URL del sitio web est\xE1 vac\xEDa",
    invalidUrl: "Ingresa una URL v\xE1lida (p. ej., https://example.com)",
    urlRequiredWithLabel: "La URL es obligatoria cuando se indica una etiqueta",
    invalidUrlsBeforeSaving: "Corrige las URL inv\xE1lidas antes de guardar",
    labelsWithoutUrls: "Algunos tours virtuales tienen etiqueta pero no URL. Agrega las URL o quita las etiquetas.",
    addressInvalid: "La direcci\xF3n es inv\xE1lida",
    mapInvalid: "El mapa es inv\xE1lido",
    marketBlank: "El mercado es obligatorio",
    stateBlank: "El estado es obligatorio",
    countyBlank: "El condado es obligatorio",
    cityBlank: "La ciudad es obligatoria",
    zipCodeBlank: "El c\xF3digo postal es obligatorio",
    streetBlank: "La calle es obligatoria",
    organizationBlank: "La organizaci\xF3n es obligatoria",
    addressBlank: "La direcci\xF3n es obligatoria",
    mapBlank: "El mapa es obligatorio",
    sqftBlank: "Los SQFT son obligatorios",
    maxCharacterLimit: "El l\xEDmite m\xE1ximo es de {{number}} caracteres",
    workingHoursValidateMessage: "La hora de cierre no puede ser anterior a la de inicio",
    priceBlank: "El precio est\xE1 vac\xEDo",
    uploadErrors: {
      fileInvalidType: "El tipo de archivo debe ser {{type}}",
      fileTooLarge: "El archivo debe pesar m\xE1ximo {{maxSize}} MB",
      unknown: "Algo sali\xF3 mal.",
      tooManyFiles: "Aqu\xED no se pueden seleccionar varios archivos"
    },
    minMaxMissingValueValidationError: "El valor m\xEDnimo es obligatorio",
    defaultMinMaxValidationError: "El valor m\xEDnimo debe ser menor que el m\xE1ximo",
    typeInvalid: "El tipo de archivo es inv\xE1lido",
    startingPriceMoreThanHighest: "El precio inicial debe ser menor que el precio m\xE1s alto",
    highestPriceLessThanStarting: "El precio m\xE1s alto debe ser mayor que el precio inicial",
    numberOfUnitsMoreThanHighest: "El n\xFAmero de unidades (M\xCDN) debe ser menor que el n\xFAmero de unidades (M\xC1X)",
    roleBlank: "El rol est\xE1 vac\xEDo",
    roleRequired: "El rol es obligatorio",
    saleTeamBlank: "El equipo de ventas est\xE1 vac\xEDo",
    propertiesBlank: "Las propiedades est\xE1n vac\xEDas",
    characterLengthRestriction: "Ingresaste demasiados caracteres ",
    fieldIsRequired: "{{fieldName}} es obligatorio",
    inventoryMinRequired: {
      bedrooms: "Habitaciones (m\xEDn.) es obligatorio",
      bathrooms: "Ba\xF1os (m\xEDn.) es obligatorio",
      interiorSqft: "Sqft interiores (m\xEDn.) es obligatorio",
      exteriorSqft: "Sqft exteriores (m\xEDn.) es obligatorio"
    },
    invalidCharacters: "Ingresaste caracteres inv\xE1lidos en este campo",
    digitsLengthRestriction: "No se pueden ingresar m\xE1s de {{number}} d\xEDgitos",
    selectFolder: "Selecciona la carpeta necesaria",
    selectBrandingType: "Selecciona un tipo de marca",
    phoneNumberBlank: "El tel\xE9fono est\xE1 vac\xEDo",
    phoneNumberWrongLengthUS: "El n\xFAmero de tel\xE9fono debe tener 10 d\xEDgitos.",
    radius: "Radio",
    verificationCodeSend: "Se envi\xF3 un c\xF3digo de verificaci\xF3n a tu n\xFAmero de tel\xE9fono",
    fileInvalidType: "El tipo de archivo debe ser {{type}}",
    percentageInvalid: "El porcentaje debe ser menor que 100",
    mortgage: {
      totalPriceBlank: "El monto de la hipoteca es obligatorio",
      downPaymentBlank: "El pago inicial es obligatorio ",
      interestRateBlank: "La tasa de inter\xE9s es obligatoria",
      termBlank: "El plazo de la hipoteca es obligatorio"
    },
    reasonBlank: "El motivo est\xE1 vac\xEDo",
    noteBlank: "Las notas est\xE1n vac\xEDas",
    noteInvalid: "El campo no admite m\xE1s de {{length}} caracteres",
    brandedFilesReadyHelp: "Si se activa, los usuarios de DASH Direct podr\xE1n ver y descargar archivos con marca en la secci\xF3n de descargas de la propiedad. Las carpetas compartidas se mostrar\xE1n a todos los usuarios.",
    switchAccount: {
      countryRequired: "El pa\xEDs es obligatorio.",
      stateRequired: "El estado es obligatorio.",
      licenseRequired: "El n\xFAmero de licencia es obligatorio.",
      licenseMax: "El n\xFAmero de licencia debe tener como m\xE1ximo 10 caracteres."
    }
  },
  placeholders: {
    email: "john@dash.com",
    firstName: "Brooklyn",
    lastName: "Simmonsy",
    apiReferralCode: "codigo-de-referido-de-la-empresa",
    apiInvitationExpiresAt: "MM/DD/AAAA",
    apiCompanyName: "The Reeves Group",
    companyName: "The Reeves Group",
    password: "Ingresa la contrase\xF1a",
    oldPassword: "Escribe la contrase\xF1a anterior",
    newPassword: "Escribe la nueva contrase\xF1a",
    confirmPassword: "Escribe la contrase\xF1a otra vez",
    organizationName: "Nombre de la organizaci\xF3n",
    saleTeamName: "Ej.: Dash Inc",
    url: "https://website.com",
    address: "Ingresa la direcci\xF3n",
    map: "Buscar en el mapa",
    nameOfProperty: "Nombre de la propiedad",
    selectOne: "Selecciona una",
    salesGalleryAddress: "Ingresa la direcci\xF3n de la sala de ventas, con calle, n\xFAmero de oficina y cualquier indicaci\xF3n especial para los visitantes",
    virtualTourUrl: "https://example.com/virtual-tour",
    virtualTourLabel: "p. ej., Tour 360\xB0, Tour Matterport",
    nameOfCity: "Nombre de la ciudad",
    nameOfStreet: "N\xFAmero y nombre de la calle",
    priceRange: "Ej.: $1,000,000 - $2,000,000",
    digits: "{{number}} d\xEDgitos",
    nbrOfStories: "N\xFAmero de pisos",
    year: "A\xF1o",
    nameOfArchitect: "Nombre del arquitecto",
    nbrOfTowers: "N\xFAmero de torres",
    nbrOfUnits: "N\xFAmero de unidades",
    nameOfDesigner: "Nombre del dise\xF1ador",
    overviewPlaceholder: "Agrega los aspectos destacados de la propiedad. M\xE1ximo {{number}} caracteres.",
    projectDetailsPlaceholder: "Agrega el resumen del proyecto. M\xE1ximo {{number}} caracteres",
    taxInformationPlaceholder: "Agrega impuestos/cuotas. M\xE1ximo {{number}} caracteres",
    websiteOfProperty: "https://website.com",
    priceOfProperty: "Precio",
    salesTeam: "Selecciona un equipo de ventas",
    salesDirector: "Selecciona un director de ventas",
    salesAssociate: "Selecciona un asociado de ventas",
    commission: "Ingresa la comisi\xF3n",
    contactUrl: "Escribe la URL de contacto",
    inventoryName: "EJ.: B Line, Penthouse",
    inventoryType: "EJ.: Modelo, En venta",
    ex: "EJ.",
    sqft: "EJ.: 1,234",
    totalSqft: "C\xE1lculo autom\xE1tico",
    dragAndDropZone: "Arrastra y suelta o haz clic para",
    cardDescription: "Descripci\xF3n breve para la tarjeta del portafolio",
    selectFiles: "Seleccionar archivos",
    folderName: "Nombre de la carpeta",
    role: "Selecciona un rol",
    saleTeam: "Selecciona un equipo de ventas",
    properties: "Selecciona propiedades",
    brokerLicenseNumber: "856456456",
    mediaName: "Nombre del medio",
    phoneNumber: "856456456",
    verifyPhoneNumberCode: "A1B2",
    enterPasswordToOpenLink: "Ingresa la contrase\xF1a para abrir este enlace",
    enterFolderName: "Ingresa el nombre de la carpeta",
    alertName: "Ingresa el nombre de la alerta",
    enterDescription: "Ingresa una descripci\xF3n",
    agencyName: "The Reeves Group",
    marketAreaName: "Nombre de la zona de mercado",
    amenityName: "Nombre de la amenidad",
    mortgageTotalPrice: "670,400.00",
    mortgageDownPayment: "20%",
    mortgageInterestRate: "4.5%",
    mortgageTerm: "30",
    mortgageTaxRate: "$3,000",
    mortgageInsuranceRate: "$1,500",
    defaultInventoryPlaceholder: "Escribe los detalles de inventario predeterminados",
    averageBedroomsNumber: "Escribe un n\xFAmero",
    averageBathroomsNumber: "1",
    reasonUnActive: "Escribe el motivo de la desactivaci\xF3n.",
    note: "Ingresa tus notas de la propiedad",
    salesTeamName: "Nombre del equipo de ventas",
    markets: "Selecciona un mercado",
    buildingTypes: "Selecciona tipos de propiedad",
    portfolioName: "Ingresa el nombre del portafolio",
    description: "\xBFDe qu\xE9 trata este portafolio?",
    selectProperties: "Selecciona las propiedades a incluir",
    propertyName: "Ingresa el t\xEDtulo",
    propertyNameSearch: "Ingresa el nombre de la propiedad",
    shortOverview: "Escribe un resumen breve..."
  }
};
var forms_default2 = forms;

// src/assets/dictionary/es/pages.ts
var import_lodash4 = require("lodash");
var import_dash_common4 = require("dash-common");
var pages = {
  common: {
    sortModal: {
      title: "Ordenar visualizaci\xF3n",
      cancel: "Cancelar",
      save: "Guardar",
      instruction: "Arrastra y suelta para reordenar los elementos. Los cambios se guardar\xE1n cuando hagas clic en Guardar.",
      empty: "No hay elementos para ordenar"
    }
  },
  signInPage: {
    welcomeHeader: "\xA1Te damos la bienvenida a DASH!",
    welcomeSubHeader: "Inicia sesi\xF3n en tu cuenta.",
    bottomLabel: "\xBFNo tienes una cuenta?",
    bottomLabelLink: "Crear una cuenta",
    magicLinkSent: "Si encontramos una cuenta asociada al correo <bold>{{email}}</bold>, te enviamos un enlace de acceso seguro. Revisa tu bandeja de entrada y, si no lo recibes, tu carpeta de spam. Para tu protecci\xF3n, <bold>el enlace solo es v\xE1lido por 10 minutos</bold>.",
    backToLogin: "Volver a iniciar sesi\xF3n",
    sendLoginLink: "Enviar enlace de acceso al correo",
    loginWithMiamiRealtors: "Iniciar sesi\xF3n con MIAMI REALTORS",
    loginWithGoogle: "Iniciar sesi\xF3n con Google"
  },
  signInMfaPage: {
    codeLabel: "C\xF3digo",
    codePlaceholder: "123456",
    codeRequired: "Ingresa el c\xF3digo de tu aplicaci\xF3n de autenticaci\xF3n.",
    enableHeader: "Configura la verificaci\xF3n en dos pasos",
    methodChoiceSubHeader: "Tu cuenta requiere verificaci\xF3n en dos pasos. Elige c\xF3mo quieres recibir tus c\xF3digos.",
    methodAppTitle: "Aplicaci\xF3n de autenticaci\xF3n",
    methodAppBody: "Usa una aplicaci\xF3n como Google Authenticator o Authy. Es la opci\xF3n m\xE1s segura y funciona sin conexi\xF3n.",
    methodEmailTitle: "Correo electr\xF3nico",
    methodEmailBody: "Te enviamos un c\xF3digo a tu bandeja de entrada cada vez que inicias sesi\xF3n. No necesitas instalar nada.",
    methodRecommended: "Recomendado",
    emailCodeHeader: "Revisa tu correo",
    emailCodeSubHeader: "Te enviamos un c\xF3digo. Ingr\xE9salo abajo para continuar.",
    emailCodeSubHeaderWithEmail: "Enviamos un c\xF3digo a {{email}}. Ingr\xE9salo abajo para continuar.",
    emailCodeRequired: "Ingresa el c\xF3digo que te enviamos por correo.",
    resendCode: "Enviar otro c\xF3digo",
    resendCodeIn: "Enviar otro c\xF3digo en {{seconds}} s",
    enableScanSubHeader: "Tu cuenta requiere verificaci\xF3n en dos pasos. Escanea el c\xF3digo QR de abajo con tu aplicaci\xF3n de autenticaci\xF3n.",
    enableCodeSubHeader: "Ingresa el c\xF3digo de tu aplicaci\xF3n de autenticaci\xF3n para terminar de activar la verificaci\xF3n en dos pasos.",
    qrCodeError: "Algo sali\xF3 mal al generar el c\xF3digo QR. Int\xE9ntalo de nuevo o contacta a soporte.",
    continueButton: "Continuar",
    backButton: "Atr\xE1s",
    successHeader: "Todo listo",
    successSubHeader: "La verificaci\xF3n en dos pasos ya est\xE1 activada. Te pediremos un c\xF3digo cada vez que inicies sesi\xF3n.",
    doneButton: "Listo",
    verifyHeader: "Verificaci\xF3n en dos pasos",
    verifySubHeader: "Ingresa el c\xF3digo de tu aplicaci\xF3n de autenticaci\xF3n para continuar.",
    confirmButton: "Confirmar",
    supportHint: "Si tu c\xF3digo no funciona, contacta a soporte.",
    qrAlt: "C\xF3digo QR de MFA"
  },
  brokerSignUpPage: {
    welcomeHeader: "Crear una cuenta de DASH",
    welcomeSubHeader: "Tu privacidad es importante para nosotros. DASH nunca compartir\xE1 tu informaci\xF3n. ",
    submitButtonLabels: "Ir al siguiente paso",
    agreeTermsLabel: "Acepto los",
    termsAndConditionsLabel: "t\xE9rminos y condiciones,",
    termsAndConditionsError: "Debes aceptar los t\xE9rminos y condiciones para registrar una cuenta.",
    smsTermsLabel: "y recibir un c\xF3digo de verificaci\xF3n por SMS (pueden aplicar tarifas est\xE1ndar de mensajer\xEDa).",
    bottomLabel: "\xBFYa eres miembro de DASH?",
    bottomLabelLink: "Iniciar sesi\xF3n"
  },
  brokerCompleteSignUpPage: {
    resendCodeLabel: "\xBFNo recibiste un c\xF3digo de verificaci\xF3n?",
    emailResendCodeLabel: "\xBFNo recibiste un c\xF3digo de verificaci\xF3n?",
    submitButtonLabels: "Crear una cuenta",
    codeResent: "Se envi\xF3 la verificaci\xF3n por SMS.",
    emailSent: "Se envi\xF3 la verificaci\xF3n por correo."
  },
  forgotPasswordPage: {
    welcomeHeader: "Olvid\xE9 mi contrase\xF1a",
    welcomeSubHeader: "Ingresa tu correo electr\xF3nico para recibir un enlace y restablecer tu contrase\xF1a."
  },
  resetPasswordPage: {
    welcomeHeader: "Restablecer contrase\xF1a",
    welcomeSubHeader: "Ingresa tu nueva contrase\xF1a",
    goBack: "O <link>vuelve a la p\xE1gina de inicio de sesi\xF3n</link>"
  },
  emailLinkAccessPage: {
    welcomeHeader: "Iniciar sesi\xF3n con enlace por correo",
    successRedirecting: "\xA1Inicio de sesi\xF3n exitoso! Redirigiendo...",
    goBack: "O <link>vuelve a la p\xE1gina de inicio de sesi\xF3n</link>",
    validatingLink: "Validando el enlace de inicio de sesi\xF3n, espera un momento...",
    missingToken: "No se encontr\xF3 ning\xFAn token en la URL. Usa el enlace que te enviamos por correo o solicita uno nuevo.",
    backToSignIn: "Volver a la p\xE1gina de inicio de sesi\xF3n",
    tokenValidationError: "Hubo un error al validar el token: {{error}}. Genera uno nuevo o contacta a soporte si el problema contin\xFAa.",
    linkInvalidOrExpired: "El enlace no es v\xE1lido o ya venci\xF3. Genera uno nuevo."
  },
  organizationSignUpPage: {
    welcomeHeader: "Registrarse",
    welcomeSubHeader: "Ingresa tu contrase\xF1a para registrarte.",
    submitButtonLabel: "Registrarse"
  },
  organizationSignUpExpiredPage: {
    welcomeHeader: "La invitaci\xF3n expir\xF3",
    welcomeSubHeader: "Escr\xEDbenos a este correo para que nuestros administradores puedan reenviar tu invitaci\xF3n."
  },
  organisationPage: {
    addOrganisationModalLabel: "Agregar organizaci\xF3n",
    editOrganizationModalLabel: "Editar organizaci\xF3n",
    addressUnavailable: "Direcci\xF3n no disponible",
    websiteUnavailable: "Sitio web no disponible",
    deleteOrganizationModalTitle: "Eliminar organizaci\xF3n",
    deleteOrganizationModalText: "\xBFSeguro que quieres eliminar esta organizaci\xF3n y todos sus usuarios? Las propiedades asociadas a la organizaci\xF3n no se eliminar\xE1n."
  },
  organizationSaleTeams: {
    addOrganisationModalLabel: "Agregar equipo de ventas",
    editOrganizationModalLabel: "Editar equipo de ventas",
    addressUnavailable: "Direcci\xF3n no disponible",
    websiteUnavailable: "Sitio web no disponible",
    deleteOrganizationSaleTeamModalLabel: "Eliminar equipo de ventas",
    deleteOrganizationSaleTeamModalText: "\xBFSeguro que quieres eliminar el equipo de ventas {{saleTeamName}}?"
  },
  organizationUsers: {
    addOrganisationUserModalLabel: "Agregar usuario a la organizaci\xF3n",
    editOrganisationUserModalLabel: "Editar usuario de la organizaci\xF3n",
    inviteUserModalTitle: "Enviar invitaci\xF3n",
    inviteUserModalSubtitle: "\xBFQuieres invitar a este usuario a DASH?",
    inviteUserModalCancelButton: "No, gracias",
    inviteUserModalSubmitButton: "Invitar",
    archiveUserModalTitle: "Archivar usuario",
    archiveUserModalSubtitle: "\xBFSeguro que quieres archivar a este usuario de la organizaci\xF3n?",
    unarchiveUserModalTitle: "Desarchivar usuario",
    unarchiveUserModalSubtitle: "\xBFSeguro que quieres desarchivar a este usuario de la organizaci\xF3n?"
  },
  amenityPage: {
    updateAmenityModalLabel: "Actualizar amenidad",
    addAmenityModalLabel: "Agregar amenidad",
    deleteAmenityModalLabel: "Eliminar amenidad",
    deleteAmenityModalText: "\xBFSeguro que quieres eliminar la amenidad {{amenityName}}?"
  },
  marketAreasPage: {
    updateMarketAreaModalLabel: "Actualizar zona de mercado",
    addMarketAreaModalLabel: "Agregar zona de mercado",
    deleteMarketAreaModalNote: "Esto puede afectar a las propiedades asociadas"
  },
  propertyPage: {
    propertyName: "Nombre de la propiedad",
    mediaItemsCount: "({{itemsCount}} elementos)",
    propertyCreateModalTitle: "Agregar nueva propiedad",
    amenitiesTabLabel: "Caracter\xEDsticas y amenidades",
    buildingDetails: "Detalles de la propiedad",
    salesGalleryHours: "Horario de la sala de ventas",
    salesGalleryInfo: "Informaci\xF3n de la sala de ventas",
    salesGallery: "Sala de ventas",
    leasingOfficeHours: "Horario de la oficina de arrendamiento",
    leasingOfficeInfo: "Informaci\xF3n de la oficina de arrendamiento",
    virtualTours: "Recorridos virtuales",
    virtualTour: "Recorrido virtual",
    leasingOffice: "Oficina de arrendamiento",
    viewDetails: "Ver detalles",
    subscribeToUnlock: "Suscr\xEDbete para desbloquear esta propiedad",
    viewAllHighlights: "Ver todos los destacados",
    viewFullOverview: "Ver resumen completo",
    manageAmenities: "Administrar amenidades",
    searchAmenities: "Buscar amenidades",
    propertyFeaturesAndAmenities: "Caracter\xEDsticas y amenidades de la propiedad",
    removeAmenityFromPropertyModalTitle: "Quitar amenidad",
    removeAmenityFromPropertyModalText: "\xBFSeguro que quieres quitar la amenidad {{amenityName}} de esta propiedad?",
    inventoryCreateModalTitle: "Agregar nueva unidad",
    slideshow: "Presentaci\xF3n",
    main: "Principal",
    inventoryEditModalTitle: "Editar unidad",
    completedIn: "Terminado en {{date}}",
    estCompletion: "Fin estimado en {{date}}",
    uploadMedia: "Subir archivos",
    cancelAllUpdates: "Cancelar todas las cargas",
    clearUploadHistory: "Borrar historial de cargas",
    floorPlan: "Plano (PDF)",
    addFloorPlan: "Agregar plano",
    mediaFiles: "Archivos multimedia",
    searchMedia: "Buscar carpetas y archivos multimedia",
    allFileTypes: "Todos los tipos de archivo",
    paginationLabel: "Mostrando la p\xE1gina {{page}} de {{total}}",
    paginationMediaLabel: "Mostrando la p\xE1gina {{page}} de {{total}}",
    noFilesPlaceholder: "No hay im\xE1genes ni videos en la presentaci\xF3n. Puedes agregar contenido a la presentaci\xF3n desde la pesta\xF1a de multimedia, a\xF1adi\xE9ndolo a la carpeta predeterminada llamada Slideshow",
    addFolderModalLabel: "Crear carpeta",
    editFolderModalLabel: "Editar carpeta",
    removeFolderModalLabel: "Eliminar carpeta",
    editMediaModalLabel: "Editar nombre del archivo",
    removeFolderModalBodyLabel: "\xBFSeguro que quieres eliminar la carpeta \u201C{{folderName}}\u201D? El contenido de esta carpeta se mover\xE1 a la secci\xF3n de archivos.",
    removeFolderModalCheckboxLabel: "Marca aqu\xED para eliminar tambi\xE9n el contenido de la carpeta",
    deleteFileModalTitle: "Eliminar archivo",
    deleteFileModalPlaceholder: "\xBFSeguro que quieres eliminar el archivo {{fileName}}?",
    bulkDeleteFileModalPlaceholder: "\xBFSeguro que quieres eliminar los {{numberOfFiles}} archivos seleccionados?",
    folderDeletedMessage: "{{folderName}} se elimin\xF3 correctamente",
    salesTeam: "Equipo de ventas",
    addMoreUsers: "Agregar m\xE1s usuarios",
    leavePage: "Salir de la p\xE1gina",
    goBack: "Volver",
    confirmChangesModalTitle: "Tus cambios a\xFAn no se han guardado",
    confirmChangesModalText: "\xBFSeguro que quieres salir de esta p\xE1gina? Tus cambios no se guardar\xE1n.",
    confirmChangelogCreationModalTitle: "Visibilidad de las actualizaciones de la propiedad",
    confirmChangelogCreationModalText: "\xBFQuieres que los cambios actuales sean visibles para los agentes en el historial p\xFAblico de actualizaciones de la propiedad?",
    addToChangelogButton: "S\xED, hacerlos p\xFAblicos",
    dontAddToChangelogButton: "No, mantenerlos internos",
    addToChangelogCheckbox: "Agregar cambios al historial p\xFAblico de actualizaciones de la propiedad",
    moveFileModalTitle: "Mover a carpeta",
    moveFileModalText: "Selecciona la carpeta a la que quieres mover este archivo",
    moveToFolder: "Mover a carpeta",
    changeBranding: "Cambiar marca",
    updateBrandingTitle: "Actualizar marca del archivo",
    updateBrandingType: "Actualizar tipo de marca",
    updateBranding: "Actualizar marca",
    bulkUpdateBrandingText: "Actualizar el tipo de marca de {{quantity}} archivos seleccionados",
    brandingTypeUpdated: "Tipo de marca actualizado correctamente",
    bulkBrandingTypeUpdated: "Tipo de marca actualizado en {{count}} archivos",
    brandedFilesReadyEnabled: "Los archivos con marca ya est\xE1n listos",
    brandedFilesReadyDisabled: "Los archivos con marca se marcaron como no listos",
    currentFile: "Archivo actual",
    bulkActionsText: "{{quantity}} elementos seleccionados para acci\xF3n masiva",
    searchProperty: "Buscar por nombre de propiedad",
    price: "Precio",
    propertyType: "Tipo de propiedad",
    advanced: "Avanzado",
    bedsAndBath: "Habitaciones y ba\xF1os",
    allListing: "Todas las propiedades",
    alertListing: "Alertas de propiedades",
    savedSearches: "B\xFAsquedas guardadas",
    resultsFor: "{{total}} propiedades encontradas",
    resultsLimited: "Mostrando {{total}} de m\xE1s de {{totalProperties}} propiedades",
    availableUnits: "Unid. disp.",
    from: "Desde",
    upTo: "Hasta",
    noProperties: "Tu b\xFAsqueda no arroj\xF3 propiedades.",
    showFeaturesAndAmenities: "Ver todas las caracter\xEDsticas y amenidades",
    seeMoreAmenities: "Ver {{count}} amenidades m\xE1s",
    seeMoreAmenities_one: "Ver {{count}} amenidad m\xE1s",
    seeMoreAmenities_other: "Ver {{count}} amenidades m\xE1s",
    startFreeTrial: "Comenzar prueba gratis",
    lockedAmenitiesAriaLabel: "Contenido bloqueado. Mejora tu plan para ver {{count}} amenidades m\xE1s. Comienza la prueba gratis.",
    lockedAmenitiesAriaLabel_one: "Contenido bloqueado. Mejora tu plan para ver {{count}} amenidad m\xE1s. Comienza la prueba gratis.",
    lockedAmenitiesAriaLabel_other: "Contenido bloqueado. Mejora tu plan para ver {{count}} amenidades m\xE1s. Comienza la prueba gratis.",
    filterTitle: "Filtro avanzado",
    filterSubtitle: "Aplica filtros avanzados a tu b\xFAsqueda.",
    numberOfBedrooms: "N\xFAmero de habitaciones",
    numberOfBathrooms: "N\xFAmero de ba\xF1os",
    saveAndCreateAlert: "Guardar y crear alerta",
    createAlert: "Crear alerta",
    clearFilter: "Borrar filtro",
    goToTheClosestProperty: "Ir a la propiedad m\xE1s cercana",
    noPropertiesWereFoundOnMap: "No se encontraron propiedades para tu b\xFAsqueda. Usa la b\xFAsqueda de propiedades cercanas para ver las que est\xE1n m\xE1s pr\xF3ximas.",
    contact: "Contactar al desarrollo",
    contactDevelopmentSales: "Contactar a ventas del desarrollo",
    contactAgent: "Cont\xE1ctame para ver disponibilidad",
    contactLeasingOffice: "Contactar a la oficina de arrendamiento",
    addToPortfolio: "Agregar al portafolio",
    addToPortfolioFolder: "Agregar al portafolio",
    addToPortfolioTooltip: "Agregar al portafolio",
    addToMorePortfoliosTooltip: "Agregar a m\xE1s portafolios",
    generatePropertyPortfolio: "Crear portafolio",
    viewAsClient: "Ver como cliente",
    contactMessage: "\xBFTienes preguntas? Contacta abajo a la desarrolladora de la propiedad.",
    message: "Mensaje",
    lastUpdated: "\xDAltima actualizaci\xF3n",
    history: "Historial",
    checkAvailability: "Consultar disponibilidad",
    propertyPortfolio: "Portafolio de propiedades ({{amount}})",
    viewAll: "Ver todo",
    presentedBy: "Presentado por",
    editAmenityNameModalTitle: "Editar nombre de la amenidad",
    deleteProperty: "Eliminar propiedad",
    deletePropertyModalConfirmationText: "\xBFSeguro que quieres eliminar esta propiedad?",
    appearedDate: "Fecha de alta",
    scheduledConstruction: "Construcci\xF3n programada",
    numberOfUnits: "N\xFAmero de unidades",
    yearBuilt: "A\xF1o de construcci\xF3n",
    addToTrackToast: "La propiedad se agreg\xF3 a la carpeta de seguimiento",
    addToSaveToast: "La propiedad se agreg\xF3 a tu lista de seguimiento",
    propertyAlreadyTracked: "Ya est\xE1s dando seguimiento a esta propiedad.",
    propertyAlreadySaved: "Esta propiedad ya est\xE1 en tu lista de seguimiento.",
    propertyRemovedFromTrack: "La propiedad se quit\xF3 de tu lista de seguimiento",
    propertyRemovedFromSave: "La propiedad se quit\xF3 de tu lista de seguimiento",
    unavailablePropertyTitle: "Propiedad no disponible",
    unavailablePropertySubTitle: "Esta propiedad no est\xE1 disponible por ahora. Contacta a soporte para m\xE1s detalles.",
    propertyNote: "Notas de la propiedad",
    deletePropertyNote: "Eliminar nota",
    deletePropertyNoteModalConfirmationText: "\xBFSeguro que quieres eliminar la nota de la lista de notas de esta propiedad?",
    addSaleTeam: "Agregar equipo de ventas",
    propertySearchPlaceholder: "Edificio, ciudad, vecindario, comunidad",
    allMarket: "Zona de mercado",
    priceRange: "Rango de precio",
    allPropertyStatus: "Estado de la propiedad",
    completionDate: "A\xF1o estimado de finalizaci\xF3n",
    propertyLocation: "Ubicaci\xF3n de la propiedad",
    developmentAndSalesLabel: "Desarrollo y ventas",
    mediaEmptyState: "No hay archivos en esta carpeta",
    deleteSalesTeam: "Eliminar equipo de ventas",
    deleteSalesTeamText: "\xBFSeguro que quieres eliminar el equipo de ventas?",
    noPrimaryOrganizationError: "La propiedad debe tener una organizaci\xF3n principal.",
    noMarketAreaError: "La propiedad debe tener una zona de mercado.",
    statusUpdateSuccess: "Estado actualizado correctamente",
    statusUpdateError: "No se pudo actualizar el estado",
    cmsStatusUpdateSuccess: "Estado del CMS actualizado correctamente",
    cmsStatusUpdateError: "No se pudo actualizar el estado del CMS",
    visibilityStatusUpdateSuccess: "Estado de visibilidad actualizado correctamente",
    visibilityStatusUpdateError: "No se pudo actualizar el estado de visibilidad",
    sort: "Ordenar",
    sortBy: "Ordenar por",
    seeXMoreUnits: "Ver {{count}} unidades m\xE1s",
    seeXMoreUnits_one: "Ver {{count}} unidad m\xE1s",
    seeXMoreUnits_other: "Ver {{count}} unidades m\xE1s",
    seeXMoreUnitsCaps: "Ver {{count}} unidades m\xE1s",
    seeXMoreUnitsCaps_one: "Ver {{count}} unidad m\xE1s",
    seeXMoreUnitsCaps_other: "Ver {{count}} unidades m\xE1s",
    viewAllFloorPlansPricingAvailability: "Ver todos los planos, precios y disponibilidad",
    showingXOfYUnits: "Mostrando {{current}} de {{total}} unidades",
    today: "hoy",
    daysAgo: "hace {{days}} d\xEDas",
    daysAgo_one: "hace {{days}} d\xEDa",
    daysAgo_other: "hace {{days}} d\xEDas",
    monthsAgo: "hace {{months}} meses",
    monthsAgo_one: "hace {{months}} mes",
    monthsAgo_other: "hace {{months}} meses",
    yearsAgo: "hace {{years}} a\xF1os",
    yearsAgo_one: "hace {{years}} a\xF1o",
    yearsAgo_other: "hace {{years}} a\xF1os"
  },
  propertyMediaFolderPage: {
    noFilesPlaceholder: "Esta carpeta est\xE1 vac\xEDa"
  },
  featuredPortfolios: {
    propertyUnavailable: "La propiedad no se encontr\xF3 o ya no est\xE1 disponible.",
    title: "Portafolios destacados",
    subtitle: "Colecciones curadas de desarrollos nuevos que puedes consultar, guardar, editar y compartir al instante con tu propio enlace de marca.",
    viewAll: "Ver todo",
    portfolioDetails: "Ver detalles",
    details: "Detalles del portafolio",
    otherProperties: "Otras propiedades",
    moreProperties: "Otras residencias",
    properties_one: "{{count}} propiedad",
    properties_other: "{{count}} propiedades",
    createModalTitle: "Nuevo portafolio destacado",
    createButton: "Crear portafolio",
    editPortfolio: "Editar portafolio",
    deletePortfolio: "Eliminar portafolio",
    deleteConfirmation: "\xBFSeguro que quieres eliminar este portafolio? Esta acci\xF3n no se puede deshacer.",
    notFound: "Portafolio no encontrado",
    visibilityUpdateSuccess: "Visibilidad actualizada correctamente",
    visibilityUpdateError: "No se pudo actualizar la visibilidad",
    noPropertiesAdded: "No hay propiedades agregadas a este portafolio",
    propertyAlreadyAdded: "Esta propiedad ya est\xE1 en el portafolio",
    propertyAdded: "Propiedad agregada",
    propertyRemoved: "Propiedad quitada",
    noSearchResults: "No se encontraron propiedades",
    labels: {
      overview: "Resumen",
      cardDescription: "Descripci\xF3n de la tarjeta",
      saved: "Portafolio guardado correctamente",
      previewModal: "Vista previa del modal",
      previewCard: "Vista previa de la tarjeta",
      properties: "Propiedades",
      propertiesAdded: "Propiedades agregadas",
      finishSorting: "Terminar de ordenar",
      resetOrder: "Restablecer orden",
      resetChanges: "Restablecer cambios",
      sort: "Ordenar"
    },
    sortModal: {
      title: "Ordenar portafolios destacados p\xFAblicos",
      cancel: "Cancelar",
      save: "Guardar",
      instruction: "Arrastra y suelta para reordenar los portafolios. Los cambios se guardar\xE1n cuando hagas clic en Guardar.",
      noPublicPortfolios: "No hay portafolios p\xFAblicos para ordenar"
    },
    makePublicModal: {
      modalTitle: "Hacer p\xFAblico el portafolio",
      warningTitle: "\xBFHacer p\xFAblico el portafolio?",
      cancel: "Cancelar",
      continue: "Continuar",
      makePublic: "Hacer p\xFAblico",
      message: '\xBFD\xF3nde quieres colocar "{{portfolioName}}"?',
      warningMessage: 'El portafolio "{{portfolioName}}" tiene actualmente solo {{count}} {{count}} agregadas. \xBFSeguro que quieres publicarlo?',
      warningMessage_one: 'El portafolio "{{portfolioName}}" tiene actualmente solo {{count}} propiedad agregada. \xBFSeguro que quieres publicarlo?',
      warningMessage_other: 'El portafolio "{{portfolioName}}" tiene actualmente solo {{count}} propiedades agregadas. \xBFSeguro que quieres publicarlo?',
      firstOption: "Primero",
      firstOptionDesc: "El portafolio aparecer\xE1 al principio",
      lastOption: "\xDAltimo",
      lastOptionDesc: "El portafolio aparecer\xE1 al final"
    },
    sortSuccess: "Portafolios reordenados correctamente",
    sortError: "No se pudieron reordenar los portafolios",
    placeholders: {
      searchProperty: "Buscar una propiedad..."
    },
    buttons: {
      addProperty: "Agregar propiedad"
    },
    resetChangesConfirmation: {
      title: "\xBFRestablecer todos los cambios?",
      message: "\xBFSeguro que quieres restablecer todos los cambios? Se quitar\xE1n las propiedades reci\xE9n agregadas y se volver\xE1 al \xFAltimo estado guardado."
    },
    resetOrderConfirmation: {
      title: "\xBFRestablecer el orden de las propiedades?",
      message: "\xBFSeguro que quieres restablecer el orden de las propiedades? Se restaurar\xE1 el orden original de las propiedades guardadas y se conservar\xE1n las reci\xE9n agregadas."
    },
    resetConfirmation: {
      cancel: "Cancelar",
      confirm: "Confirmar"
    },
    modal: {
      title: "Portafolio destacado",
      properties: "Propiedades",
      overview: "Resumen",
      viewPortfolio: "Ver portafolio",
      sharePortfolio: "Compartir portafolio",
      completionFrom: "Finalizaci\xF3n desde",
      to: "hasta",
      propertiesCount: "propiedades",
      marketAreasLabel: "Zonas de mercado en este portafolio:",
      showLess: "Ver menos",
      xMore: "+{{count}} m\xE1s",
      estCompletion: "Fin estimado {{year}}"
    },
    agentBanner: {
      title: "Portafolio destacado",
      agentCollection: "Est\xE1s viendo",
      share: "Compartir",
      notice: "Este encabezado NO se mostrar\xE1 cuando compartas el portafolio con tus clientes."
    },
    quickSharePortfolio: "Enlace para compartir al instante",
    sharePortfolio: "Compartir portafolio destacado",
    addToSaveToast: "El portafolio se agreg\xF3 a tu lista de seguimiento",
    portfolioAlreadySaved: "Este portafolio ya est\xE1 en tu lista de seguimiento.",
    portfolioRemovedFromSave: "El portafolio se quit\xF3 de tu lista de seguimiento",
    copyToPortfolio: "Copiar a mi portafolio",
    copyToPortfolioDescription: "Copia este portafolio destacado para poder personalizarlo m\xE1s.",
    copyToPortfolioButton: "Copiar a mis portafolios",
    copying: "Copiando...",
    toasts: {
      featuredPortfolioCopied: "\xA1Portafolio destacado copiado correctamente!",
      copyError: "No se pudo copiar el portafolio",
      portfolioNameExists: "Ya tienes un portafolio con este nombre"
    },
    duplicateFeaturedPortfolioModal: {
      title: "El portafolio ya existe",
      samePortfolioNameText: "Ya existe un portafolio con este nombre. Puedes compartir el portafolio existente con el enlace de abajo:",
      unableToLoadPortfolioData: "No se pudieron cargar los datos del portafolio. Int\xE9ntalo de nuevo.",
      portfolioDataNotFound: "No se encontraron los datos del portafolio. Int\xE9ntalo de nuevo.",
      clickHere: "Haz clic aqu\xED",
      toViewPortfolioDetails: "para ver los detalles del portafolio.",
      createNewPortfolioText: "Para crear un portafolio nuevo, ingresa un nombre distinto abajo:",
      createPortfolio: "Crear portafolio",
      portfolioNameAlreadyExistsError: "Ya tienes un portafolio con este nombre"
    },
    seeXMore: "Ver {{count}} m\xE1s",
    seeXMore_one: "Ver {{count}} portafolio m\xE1s",
    seeXMore_other: "Ver {{count}} portafolios m\xE1s",
    seeXMoreCaps: "Ver {{count}} m\xE1s",
    seeXMoreCaps_one: "Ver {{count}} m\xE1s",
    seeXMoreCaps_other: "Ver {{count}} m\xE1s",
    viewAllPortfolios: "Ver todos los portafolios destacados",
    startFreeTrial: "Comenzar prueba gratis",
    unlockDescription: "Accede a nuestras colecciones curadas listas para compartir",
    unlockPortfolio: "Desbloquear portafolio",
    unlockPortfolios: "Ver portafolios"
  },
  featuredProperties: {
    title: "Propiedades destacadas",
    subtitle: "Propiedades individuales que puedes curar y destacar para acceder y compartir al instante.",
    createModalTitle: "Nueva propiedad destacada",
    createButton: "Crear propiedad",
    createSuccess: "Propiedad destacada creada correctamente",
    visibilityUpdateSuccess: "Visibilidad actualizada correctamente",
    visibilityUpdateError: "No se pudo actualizar la visibilidad",
    labels: {
      property: "Propiedad seleccionada",
      propertyRequired: "La propiedad es obligatoria",
      overview: "Resumen",
      shortOverview: "Resumen corto",
      bannerPreview: "Vista previa del banner",
      saved: "Propiedad destacada guardada correctamente",
      searching: "Buscando...",
      noPropertiesFound: "No se encontraron propiedades",
      desktopPreviewComingSoon: "La vista previa en computadora estar\xE1 disponible pronto",
      mobilePreviewComingSoon: "La vista previa en celular estar\xE1 disponible pronto",
      overviewPlaceholder: "Escribe un resumen detallado...",
      shortOverviewPlaceholder: "Escribe un resumen breve..."
    },
    deleteProperty: "Eliminar propiedad",
    sortModal: {
      title: "Ordenar propiedades destacadas p\xFAblicas",
      cancel: "Cancelar",
      save: "Guardar",
      instruction: "Arrastra y suelta para reordenar las propiedades. Los cambios se guardar\xE1n cuando hagas clic en Guardar.",
      noPublicProperties: "No hay propiedades p\xFAblicas para ordenar"
    },
    sortSuccess: "Orden de visualizaci\xF3n actualizado correctamente",
    sortError: "No se pudo actualizar el orden de visualizaci\xF3n",
    makePublicModal: {
      modalTitle: "Hacer p\xFAblica la propiedad",
      warningTitle: "\xBFHacer p\xFAblica la propiedad?",
      cancel: "Cancelar",
      continue: "Continuar",
      makePublic: "Hacer p\xFAblica",
      message: '\xBFD\xF3nde quieres colocar "{{portfolioName}}"?',
      warningMessage: 'La propiedad "{{portfolioName}}" est\xE1 a punto de publicarse. \xBFSeguro que quieres continuar?',
      warningMessage_one: 'La propiedad "{{portfolioName}}" est\xE1 a punto de publicarse. \xBFSeguro que quieres continuar?',
      firstOption: "Al principio",
      firstOptionDesc: "Colocar en la primera posici\xF3n de la lista",
      lastOption: "Al final",
      lastOptionDesc: "Colocar en la \xFAltima posici\xF3n de la lista"
    }
  },
  propertyPreviewPage: {
    websiteLink: "Enlace del sitio web",
    generalTabLabel: "Info de la propiedad",
    additionalTabLabel: "Info adicional",
    marketingTabLabel: "Materiales de venta",
    propertyDownloadsTabLabel: "Descargas de la propiedad",
    downloadsTabLabel: "Descargas",
    downloadsLabel: "Descargas",
    developerInfoLabel: "Desarrolladora",
    salesTeamLabel: "Equipo de ventas",
    propertyManagementLabel: "Administraci\xF3n de la propiedad",
    additionalInformation: "Informaci\xF3n adicional",
    additionalInformationShort: "Info adic.",
    nbrOfStories: "N\xFAmero de pisos",
    nbrOfTowers: "N\xFAmero de torres",
    constructionDate: "Fecha de construcci\xF3n",
    completionDate: "Fecha de finalizaci\xF3n",
    marketingFilesLabel: "Materiales de venta",
    marketingFilesSecondLabel: "Aqu\xED encontrar\xE1s todos los materiales de venta relacionados con esta propiedad.",
    propertyDownloadsLabel: "Descargas de la propiedad",
    propertyDownloadsSecondLabel: "Aqu\xED encontrar\xE1s todas las descargas y recursos disponibles para esta propiedad.",
    noSaleTeamLabel: "Sin equipo de ventas",
    moreInformation: "M\xE1s informaci\xF3n",
    historyLabel: "Esta propiedad fue {{date}} por \xFAltima vez.",
    lastUpdatedDaysAgo_other: "Esta propiedad se actualiz\xF3 por \xFAltima vez hace {{count}} d\xEDas.",
    lastUpdatedDaysAgo_one: "Esta propiedad se actualiz\xF3 por \xFAltima vez hace {{count}} d\xEDa.",
    lastUpdatedToday: "Esta propiedad se actualiz\xF3 por \xFAltima vez hoy.",
    lastUpdatedLabel: "\xDAltima actualizaci\xF3n {{date}}",
    unknownDateLabel: "Desconocido",
    shareActionLabel: "Compartir",
    saveActionLabel: "Agregar a seguimiento",
    savedActionLabel: "En seguimiento",
    shareProperty: "Compartir propiedad",
    shareThisProperty: "Compartir esta propiedad",
    quickShareProperty: "Enlace para compartir al instante:",
    generateQuickShareLink: "Generar enlace para compartir",
    portfoliosDescription: "Si quieres m\xE1s personalizaci\xF3n y acceso a anal\xEDticas de tr\xE1fico, puedes usar portafolios:",
    quickShareDescription: "Copia el enlace directo para compartir esta propiedad de inmediato",
    loadingShareLink: "Generando enlace para compartir...",
    instantShareDescription: "Comparte ahora con un enlace con tu marca de agente.",
    addToPortfolioDescription: "Agrega esta propiedad a uno de tus portafolios guardados.",
    createPortfolioDescription: "Personaliza la configuraci\xF3n, agrega descargas y ajusta los detalles antes de compartir.",
    stickyHeader: {
      propertyInfo: "Informaci\xF3n de la propiedad",
      propertyInfoShort: "Info de la propiedad",
      inventory: "Planos",
      contactInfo: "Info de contacto",
      contactInfoShort: "Contacto",
      downloads: "Descargas",
      downloadsShort: "Archivos"
    }
  },
  wasDeleted: {
    title: "{{entityName}} fue eliminado"
  },
  notFoundPage: {
    title: "No encontrada",
    subtitle: "La p\xE1gina que buscas pudo haberse eliminado, cambiado de nombre o no estar disponible temporalmente",
    buttonLabel: "Ir al inicio",
    notFound404: "404 No encontrado",
    generalTabLabel: "Info de la propiedad",
    additionalTabLabel: "Info adicional",
    marketingTabLabel: "Materiales de venta"
  },
  idx: {
    unauthorizedTitle: "No autorizado",
    unauthorizedSubtitle: "\xA1Este dominio no est\xE1 autorizado para usar nuestros datos de Exchange!",
    visitDash: "Visitar DASH",
    labels: {
      showDashCredit: "Mostrar cr\xE9dito de datos de DASH",
      showPropertyDownloads: "Mostrar materiales de venta",
      showCustomPropertyDownloads: "Mostrar solo materiales de venta personalizados",
      managePropertyDownloads: "Administrar materiales de venta",
      back: "Atr\xE1s",
      backToPortfolio: "Volver al portafolio",
      contact: "Contacto"
    },
    tooltips: {
      showDashCredit: "Activa o desactiva el cr\xE9dito 'Powered By DASH' en tus feeds de eXchange.",
      showPropertyDownloads: "Act\xEDvalo para que tus clientes vean todos los materiales de venta disponibles de una propiedad.",
      showCustomPropertyDownloads: "Act\xEDvalo para mostrar solo los materiales de venta que t\xFA personalizaste."
    }
  },
  footer: {
    termsLabel: "T\xE9rminos y condiciones",
    policyLabel: "Pol\xEDtica de privacidad",
    rightLabel: "2026 DASH Inc. Todos los derechos reservados.",
    termsOfService: "T\xE9rminos de servicio"
  },
  completeSignUp: {
    pickPlan: "Elegir plan",
    setupSubscriptionLabel: "Configurar suscripci\xF3n",
    setupSubscriptionShortLabel: "Configurar",
    additionalLabel: "Info adicional",
    additionalShortLabel: "Info adic."
  },
  completeSignUpPickSubscription: {
    header: "Elige una suscripci\xF3n",
    subheader: "Elige entre las opciones disponibles",
    apiOnlyNote: "Te invitaron a DASH API, por eso este es el plan disponible aqu\xED. Si eres agente inmobiliario y buscas la plataforma DASH, puedes registrarte por separado en dashtodash.com.",
    trialLabel: "Prueba gratis de {{countOfDays}} d\xEDas",
    noTrialLabel: "Mejorar a Pro",
    submitButtonLabel: "Prueba gratis de {{countOfDays}} d\xEDas",
    cancelMySubscription: "Cancelar mi suscripci\xF3n",
    couponMiddleLabel: "vs. nuestro plan {{recurringType}}",
    stayOnthisPlan: "Quedarme en este plan",
    subscribeBasic: "Comenzar gratis con el plan Basic",
    subscribePro: "Suscribirme al plan PRO",
    subscribeIdx: "Suscribirme al plan DASH Exchange",
    newBadge: "NUEVO",
    promoPlaceholder: "Ingresa el c\xF3digo (opcional)",
    promoLabel: "\xBFTienes un c\xF3digo promocional?",
    promoInvalid: "Ese c\xF3digo promocional no es v\xE1lido. Qu\xEDtalo o ingresa otro.",
    subscriptionProductRecurringLabels: {
      [(0, import_lodash4.camelCase)(import_dash_common4.RecurringTypesEnum.FREE)]: "Gratis",
      [(0, import_lodash4.camelCase)(import_dash_common4.RecurringTypesEnum.MONTH)]: "Mensual",
      [(0, import_lodash4.camelCase)(import_dash_common4.RecurringTypesEnum.SIXMONTH)]: "Cada seis meses",
      [(0, import_lodash4.camelCase)(import_dash_common4.RecurringTypesEnum.YEAR)]: "Anual"
    }
  },
  completeSignUpAddAdditionalInfoPage: {
    header: "Info adicional",
    subheader: "Compl\xE9tala ahora o despu\xE9s",
    profileSubHeader: "Perfil",
    locationSubHeader: "2. Ubicaci\xF3n",
    settingsSubHeader: "3. Configuraci\xF3n de propiedades"
  },
  portfoliosPage: {
    addPropertyToPortfolioModalTitle: "Agregar propiedad a un portafolio",
    addPropertyToPortfolioModalText: "Crea portafolios para organizar y compartir el contenido de las propiedades con tus clientes y colegas.",
    existingFolder: "Portafolio existente",
    selectFolder: "Seleccionar portafolio",
    createNewFolder: "Crear un portafolio nuevo",
    folderName: "Nombre del portafolio",
    enterFolderName: "Ingresa un nombre para el portafolio nuevo",
    statuses: {
      [import_dash_common4.BrokerPortfolioStatusesEnum.PRIVATE]: "Privado/Borrador",
      [import_dash_common4.BrokerPortfolioStatusesEnum.PUBLIC]: "Enlace p\xFAblico",
      password: "Enlace protegido con contrase\xF1a"
    },
    propertiesTotal: "{{total}} propiedades",
    portfoliosTotal: "{{total}} portafolios",
    totalViews: "{{total}} vistas",
    views: "Vistas",
    portfoliosSearchPlaceholder: "Buscar por nombre de portafolio",
    portfoliosPropertySearchPlaceholder: "Buscar por nombre de propiedad",
    portfoliosSearchPlaceholderShort: "Buscar portafolio",
    portfoliosPropertySearchPlaceholderShort: "Buscar propiedad",
    sort: "Ordenar",
    sortBy: "Ordenar por",
    addNew: "Agregar",
    portfolioName: "Nombre del portafolio",
    paginationLabel: "Mostrando portafolio {{page}} de {{total}}",
    emptyPageLabel: "\xA1A\xFAn no tienes portafolios!",
    emptyPageSubLabel: "Crea portafolios para organizar y compartir el contenido de las propiedades con tus clientes y colegas.",
    emptyPageButtonLabel: "Empezar a explorar",
    emptyPageGuideLabel: "\xBFEres nuevo en los portafolios?",
    emptyPageGuideSubLabel: "Nuestra gu\xEDa te explica c\xF3mo crearlos y compartirlos con tus clientes.",
    emptyPageGuideLinkLabel: "Lee la gu\xEDa de inicio r\xE1pido de DASH Pro",
    createFolderModalTitle: "Agregar portafolio",
    createFolderModalSubtitle: "Luego agrega propiedades a tu portafolio para compartirlo.",
    portfolioNamePlaceholder: "Ingresa un nombre para el portafolio nuevo",
    toasts: {
      shareLinkCopied: "\xA1Enlace copiado!",
      folderIsCreated: "Portafolio creado",
      folderIsUpdated: "Portafolio actualizado",
      folderIsDeleted: "Portafolio eliminado",
      portfolioIsCreated: "Portafolio creado",
      propertyWasAdded: "Propiedad agregada al portafolio",
      propertyAlreadyAdded: "La propiedad ya est\xE1 en este portafolio"
    },
    removePropertyFromPortfolioModal: {
      header: "Quitar propiedad del portafolio",
      subheader: "\xBFSeguro que quieres quitar esta propiedad de tu portafolio?"
    },
    removeFolderFromPortfolioModal: {
      header: "Eliminar portafolio",
      subheader: "\xBFSeguro que quieres eliminar este portafolio?"
    },
    movePropertyToPortfolioFolderModal: {
      title: "Agregar propiedad al portafolio",
      subtitle: "\xBFQuieres crear un portafolio nuevo para esta propiedad o agregarla a uno existente?"
    },
    duplicatePortfolioModal: {
      title: "El portafolio ya existe",
      createNewPortfolio: "Crear portafolio nuevo",
      samePortfolioNameText: "Ya existe un portafolio con este nombre. Puedes compartir el portafolio existente con el enlace de abajo:",
      createNewPropertyPortfolioText: "Para crear un portafolio nuevo, ingresa un nombre distinto abajo:",
      portfolioNameAlreadyExistsError: "El nombre del portafolio nuevo ya existe.",
      viewDetailsLink: "<italic><link>Haz clic aqu\xED</link> para ver los detalles del portafolio.</italic>",
      notFoundError: "No se encontraron los datos del portafolio. Int\xE9ntalo de nuevo.",
      loadError: "No se pudieron cargar los datos del portafolio. Int\xE9ntalo de nuevo."
    },
    viewProperties: "Ver propiedades",
    emptyLocationsText: "Las propiedades publicadas en las ubicaciones de este portafolio aparecer\xE1n aqu\xED autom\xE1ticamente.",
    emptyLocationsTitle: "A\xFAn no hay propiedades en estas ubicaciones",
    newFolderLabel: "Nueva carpeta",
    followsLocationsHint: "Sus propiedades seguir\xE1n las ubicaciones que elijas.",
    followsLocationsOption: "{{name}} (sigue ubicaciones)",
    emptyPortfolioFolderSubtitle: "Este portafolio est\xE1 vac\xEDo. Para aprender a agregar propiedades, visita el soporte de DASH",
    emptyPortfolioFolderTitle: "\xA1A\xFAn no tienes propiedades!",
    emptyPortfolioFolderText: "\xA1Visita una propiedad y agr\xE9gala a este portafolio para compartirla con tus clientes!",
    contactMe: "Cont\xE1ctame",
    availability: "Disponibilidad",
    propertiesReady: "Propiedades listas",
    propertiesSold: "Propiedades vendidas",
    propertiesReadyShort: "Prop. listas",
    propertiesSoldShort: "Prop. vendidas",
    customers: "Clientes",
    openPortfolioWithPasswordModal: {
      title: "Abrir el portafolio",
      subtitle: "Ingresa la contrase\xF1a para ver este portafolio."
    },
    rootFolder: "Carpeta ra\xEDz",
    moreAboutPresenter: "M\xE1s sobre quien presenta",
    viewPropertyPortfolio: "Ver portafolio de propiedades",
    unitSizes: "Tama\xF1os de unidad",
    customize: "Personalizar",
    propertyComparison: "Comparaci\xF3n de propiedades",
    selectItemsToCompare: "Selecciona elementos para comparar",
    viewSharedPortfolio: "Ver portafolio compartido",
    unavailablePortfolioPage: {
      title: "Portafolio no disponible",
      subtitle: "El portafolio no est\xE1 disponible por ahora. Contacta al agente que lo comparti\xF3 para m\xE1s detalles."
    }
  },
  portfolioDetailsPage: {
    labels: {
      properties: "{{number}} propiedades",
      shared: "Compartido",
      views: "{{number}} vistas",
      shareFolder: "Compartir portafolio",
      deleteFolder: "Eliminar portafolio",
      moveProperty: "Mover propiedad",
      removeProperty: "Quitar propiedad",
      move: "Mover"
    },
    sharePortfolioForm: {
      header: "Compartir portafolio",
      subHeader: "Elige c\xF3mo quieres compartir el portafolio.",
      publicShareType: "Enlace p\xFAblico",
      privateShareType: "Portafolio privado/borrador",
      passwordType: "Enlace protegido con contrase\xF1a",
      passwordPlaceholder: "Ingresa la contrase\xF1a que prefieras para el enlace de este portafolio",
      alertLabel: "Este portafolio solo es visible para ti; nadie m\xE1s puede verlo.",
      emptyPortfolioAlertLabel: "Este portafolio est\xE1 vac\xEDo. Agrega propiedades para poder compartirlo.",
      downloadsTooltip: "Permite que los visitantes vean y descarguen los archivos multimedia y folletos de las propiedades que elijas compartir.",
      agentPopupTooltip: "Muestra a los visitantes una ventana con la informaci\xF3n de contacto del agente y la lista de portafolios. No se mostrar\xE1 en portafolios de una sola propiedad.",
      showAgentPopup: "Mostrar ventana del agente"
    },
    clientViewBanner: {
      message: "Est\xE1s viendo esta propiedad en modo presentaci\xF3n.",
      switchToAgentView: "Cambiar a vista de agente"
    }
  },
  portfolioFolderPreviewPage: {
    header: "Este portafolio tiene {{totalCount}} propiedades.",
    subHeader: "Si te gustan estas propiedades, contacta a tu agente",
    livingArea: "\xC1rea habitable",
    bathrooms: "Ba\xF1os",
    bedrooms: "Habitaciones"
  },
  profilePage: {
    labels: {
      accountInfo: "Info de la cuenta",
      billing: "Facturaci\xF3n",
      settings: "Configuraci\xF3n",
      feedback: "Comentarios",
      support: "Soporte",
      choosePlan: "Elige un plan"
    },
    billing: {
      stayOnThisPlan: "Quedarme en este plan",
      active: "Activa",
      deleted: "Eliminada",
      cancelled: "Cancelada",
      transactionHistory: "Historial de transacciones",
      subscribe: "Suscribirme",
      freeTrial: "Prueba gratis de {{trial}} d\xEDas",
      paymentMethod: "M\xE9todos de pago",
      upgradePlan: "Mejorar plan",
      emptyPaymentMethodsText: "Selecciona otro m\xE9todo de pago predeterminado para renovar tu suscripci\xF3n",
      addPaymentMethod: "Agregar un m\xE9todo de pago",
      default: "Predeterminado",
      expirationDate: "Vencimiento {{expiredMonth}}/{{expiredYear}}",
      recurringTypeChangeModalTitle: "Cambiar\xE1 la frecuencia de tu suscripci\xF3n",
      downgradeModalTitle: "Tu suscripci\xF3n bajar\xE1 de plan",
      cancelModalTitle: "Cu\xE9ntanos por qu\xE9 cancelas tu suscripci\xF3n",
      cancelModalText: "Si cancelas tu suscripci\xF3n, tu plan no se renovar\xE1 en la pr\xF3xima fecha de facturaci\xF3n. Seguir\xE1s teniendo acceso completo a los servicios y funciones de tu plan hasta la fecha de vencimiento. Puedes volver a suscribirte cuando quieras.",
      recurringTypeChangeModalText: "La frecuencia de tu suscripci\xF3n cambiar\xE1 a {{recurringType}} {{plan}} en tu pr\xF3xima fecha de facturaci\xF3n.",
      downgradeModalText: "Tu suscripci\xF3n bajar\xE1 al plan {{plan}} en tu pr\xF3xima fecha de facturaci\xF3n.",
      downloadAll: "Descargar todo",
      cancelReasons: {
        [import_dash_common4.ProductSubscriptionCancelationReasonsEnum.I_DONT_NEED_DASH_ANYMORE]: "Ya no necesito las herramientas de DASH",
        [import_dash_common4.ProductSubscriptionCancelationReasonsEnum.IT_DOESNT_MEET_MY_NEEDS_EXPECTATIONS]: "DASH no cumple con mis necesidades o expectativas",
        [import_dash_common4.ProductSubscriptionCancelationReasonsEnum.PLANS_COST_TOO_MUCH]: "Los planes de DASH cuestan demasiado",
        [import_dash_common4.ProductSubscriptionCancelationReasonsEnum.UNADDRESSED_ERRORS_OR_BUGS]: "Errores sin resolver",
        [import_dash_common4.ProductSubscriptionCancelationReasonsEnum.IM_USING_DIFFERENT_SERVICE]: "Estoy usando otro servicio",
        [import_dash_common4.ProductSubscriptionCancelationReasonsEnum.OTHER]: "Otro"
      },
      otherCancelReasonPlaceholder: "Informaci\xF3n adicional (opcional)",
      cancelPlan: "Cancelar plan",
      changeRecurringType: "Cambiar frecuencia",
      backToBilling: "Volver a facturaci\xF3n",
      addPaymentModalTitle: "Agregar un m\xE9todo de pago",
      addPaymentModalSubTitle: "Toda la informaci\xF3n es confidencial y no se compartir\xE1",
      deletePaymentMethod: "Eliminar m\xE9todo de pago",
      deletePaymentMethodDescription: "\xBFSeguro que quieres eliminar este m\xE9todo de pago?",
      subscriptionProductChanged: "\xA1Tu suscripci\xF3n cambi\xF3!",
      unsuccessfulPayment: "Pago fallido",
      changePlanConfirmationModal: {
        upgradeButton: "Mejorar",
        downgradeButton: "Bajar de plan",
        yesButton: "S\xED",
        upgradeTitle: "Mejorar al plan {{name}}",
        downgradeTitle: "Bajar al plan {{name}}",
        changeToSixMonthPlan: "Cambiar al plan semestral",
        changeToMonthlyPlan: "Cambiar al plan mensual",
        changeDescription: "\xBFSeguro que quieres cambiar tu plan de suscripci\xF3n de {{old}} a {{new}}?"
      },
      changeToSixMonthPlan: "Cambiar al plan semestral",
      changeToMonthlyPlan: "Cambiar al plan mensual",
      upgradeDownloadPlanModalTitle: "\xA1Mejora tu suscripci\xF3n para desbloquear descargas sin marca!",
      upgradePortfolioPlanModalTitle: "Mejora tu suscripci\xF3n para desbloquear los portafolios de agente",
      upgradeCompleteAccountPlanModalTitle: "Comienza una prueba para acceder a todas las propiedades",
      upgradeExchangePlanModalTitle: "Mejora tu suscripci\xF3n para desbloquear la integraci\xF3n sencilla con tu sitio web",
      upgradeSavedPropertiesPlanModalTitle: "Mejora tu suscripci\xF3n para tener una lista de seguimiento ilimitada",
      upgradePlanModalSavedPropertiesSubtitle: "Llegaste al l\xEDmite de {{limit}} propiedades de tu plan gratuito. Mejora tu suscripci\xF3n para agregar propiedades ilimitadas a tu lista de seguimiento y llevar el control de cada desarrollo que sigues, todo en un solo lugar.",
      upgradePlanModalTitle: "Mejorar suscripci\xF3n",
      successfulUpgradeMessage: "\xA1Tu suscripci\xF3n se mejor\xF3!",
      trialUpgrade: {
        title: "Comienza tu prueba gratis",
        intro: "Tu prueba gratis de {{days}} d\xEDas de {{plan}} comienza hoy. Cancela antes del {{date}} y volver\xE1s a {{previousPlan}}.",
        currentPlanFallback: "tu plan actual",
        trialRow: "{{plan}} (prueba gratis de {{days}} d\xEDas)",
        creditRow: "Tiempo sin usar de tu plan actual",
        creditTooltip: "Cr\xE9dito por el tiempo sin usar de tu plan actual. Se aplica a tu primer cobro del {{date}}, no hoy.",
        creditCaption: "Se aplica a tu primer cobro",
        thenRow: "A partir del {{date}}",
        pricePerMonth: "${{price}} / mes",
        pricePerYear: "${{price}} / a\xF1o",
        confirmButton: "Comenzar prueba gratis",
        footerNote: "*No se te cobrar\xE1 hasta el {{date}}",
        successToast: "\xA1Tu prueba gratis comenz\xF3!"
      },
      trialRevert: {
        banner: "Tu prueba gratis de {{plan}} termina el {{date}} y despu\xE9s tu plan vuelve a {{previousPlan}}. No se te cobrar\xE1 {{plan}}.",
        bannerAction: "Conservar {{plan}}",
        undoButton: "Deshacer cancelaci\xF3n de la prueba",
        planFromDate: "Tu plan a partir del {{date}}",
        previousPlanFallback: "tu plan anterior",
        keepTitle: "Conservar {{plan}}",
        keepSubtitle: "Deshaz la cancelaci\xF3n de tu prueba",
        keepText: "Tu prueba gratis contin\xFAa y {{plan}} comenzar\xE1 a cobrarse el {{date}}.",
        returnCanceledTitle: "Se cancel\xF3 el regreso a {{previousPlan}}",
        returnCanceledText: "Tu plan ya no volver\xE1 a {{previousPlan}} el {{date}}.",
        cancelAgainNote: "Puedes volver a cancelar la prueba en cualquier momento antes del {{date}}.",
        keepButton: "Conservar {{plan}}",
        keepLoading: "Actualizando...",
        keepSuccess: "Tu prueba gratis continuar\xE1.",
        cancelTrialSubtitle: "Tu plan vuelve a {{previousPlan}} cuando termine la prueba",
        cancelTrialUntil: "Hasta el {{date}}:",
        cancelTrialUntilText: "Seguir\xE1s usando todas las funciones de {{plan}}",
        cancelTrialAfter: "Despu\xE9s del {{date}}:",
        cancelTrialAfterText: "Tu plan vuelve a {{previousPlan}}",
        cancelTrialNoCharge: "No se te cobrar\xE1 {{plan}}",
        cancelTrialToast: "Prueba cancelada. Tu plan vuelve a {{previousPlan}} el {{date}}."
      },
      upgradePlanModalDownloadSubtitle: "Con DASH Pro puedes descargar f\xE1cilmente materiales de venta sin marca, listos para compartir. Mejora tu suscripci\xF3n ahora para tener acceso ilimitado al contenido de las propiedades y otras funciones \xFAtiles.",
      upgradeCompleteAccountPlanModalSubtitle: "\xA1Accede a m\xE1s de 400 desarrollos nuevos en toda Florida para impulsar tus ventas!",
      paymentMethodEntity: "M\xE9todo de pago",
      recurringSixMonthAdjective: "semestral",
      recurringMonthlyAdjective: "mensual",
      cancelTrial: {
        alreadyCanceled: "Esta prueba ya fue cancelada.",
        cancelError: "Hubo un error al cancelar la prueba.",
        title: "\xBFCancelar la prueba?",
        subtitle: "Perder\xE1s el acceso a las funciones premium",
        currentTrialNote: "Actualmente est\xE1s en una prueba gratis de este plan",
        whatHappens: "Qu\xE9 pasa si cancelas:",
        untilDate: "Hasta el {{date}}:",
        keepFeatures: "Seguir\xE1s usando todas las funciones premium",
        afterDate: "Despu\xE9s del {{date}}:",
        noCharge: "No se te cobrar\xE1 nada",
        keepTrial: "Mantener prueba",
        confirmButton: "Cancelar prueba"
      },
      changeConfirm: {
        titleUpgrade: "Confirmar mejora de suscripci\xF3n",
        titleDowngrade: "Confirmar baja de plan",
        reviewUpgrade: "Revisa los detalles de tu mejora",
        reviewDowngrade: "Revisa los detalles de tu cambio a un plan inferior",
        confirmDowngrade: "Confirmar baja de plan",
        confirmAndPay: "Confirmar y pagar ${{amount}}",
        footerCharged: "*Se cobrar\xE1 a tu tarjeta de inmediato",
        footerDowngradeOn: "*El cambio de plan entra en vigor el {{date}}",
        footerDowngradeEnd: "*El cambio de plan entrar\xE1 en vigor al final de tu per\xEDodo de facturaci\xF3n actual",
        noPaymentMethod: "Sin m\xE9todo de pago",
        periodAnnual: "Anual",
        periodMonthly: "Mensual",
        billingAnnual: "anual",
        billingMonthly: "mensual",
        upgradeDescription: "Vas a <bold>mejorar a {{plan}}</bold> con facturaci\xF3n {{billing}}. Tu nueva suscripci\xF3n comienza de inmediato.",
        downgradeDescription: "Vas a programar un <bold>cambio a {{plan}}</bold> con facturaci\xF3n {{billing}}. Tu nueva suscripci\xF3n comenzar\xE1 cuando termine tu per\xEDodo de facturaci\xF3n actual.",
        downgradeDescriptionWithDate: "Vas a programar un <bold>cambio a {{plan}}</bold> con facturaci\xF3n {{billing}}. Tu nueva suscripci\xF3n comenzar\xE1 cuando termine tu per\xEDodo de facturaci\xF3n actual, el {{date}}.",
        unusedCredit: "Cr\xE9dito por tiempo no utilizado",
        unusedCreditTooltip: "Cr\xE9dito por el tiempo no utilizado de tu plan actual, aplicado a tu nueva suscripci\xF3n.",
        planRow: "Plan {{plan}} ({{period}})",
        discount: "Descuento ({{name}})",
        haveCode: "\xBFTienes un c\xF3digo promocional?",
        enterCode: "Ingresa el c\xF3digo",
        totalDueToday: "Total a pagar hoy",
        fetchError: "Hubo un problema al obtener tus datos. Int\xE9ntalo m\xE1s tarde o contacta a soporte.",
        changeError: "Hubo un error en el cambio de suscripci\xF3n.",
        apiWarning: "Al dejar el plan API se desactivar\xE1 tu acceso a la API. Tu App ID y tu token se conservan (no se eliminan), pero las solicitudes a la API ser\xE1n rechazadas mientras no est\xE9s en el plan API.",
        apiAcknowledge: "Entiendo que mi acceso a la API se desactivar\xE1."
      },
      promoCodePlaceholder: "Ingresa el cup\xF3n aqu\xED...",
      promoCodeInvalidChars: "Solo se permiten letras y n\xFAmeros",
      clientSecretError: "No se pudo obtener el client secret.",
      cardholderInfo: "Datos de facturaci\xF3n del titular de la tarjeta",
      paymentDetails: "Detalles del pago",
      paymentError: "Error: {{message}}",
      paymentSetDefault: "\xA1M\xE9todo de pago establecido como predeterminado!",
      paymentAdded: "\xA1M\xE9todo de pago agregado!",
      invoicePreview: {
        upgraded: "\xA1Tu suscripci\xF3n fue mejorada!",
        downgradeScheduled: "Tu suscripci\xF3n est\xE1 programada para bajar de plan.",
        title: "Confirma los cambios de tu suscripci\xF3n",
        fetchError: "\u26A0\uFE0F Hubo un problema al obtener tus datos. Int\xE9ntalo m\xE1s tarde o contacta a soporte.",
        promoCode: "C\xF3digo promocional",
        scheduleDowngrade: "Programar cambio de plan",
        addPaymentMethodWarning: "\u26A0\uFE0F <link>Agrega un m\xE9todo de pago</link> antes de continuar.",
        amountOff: "-${{amount}} DE DESCUENTO",
        percentOff: "-{{percent}}% DE DESCUENTO",
        amountDueToday: "Monto a pagar hoy",
        amountDueStarting: "Monto a pagar desde el {{date}}",
        paymentMethod: "M\xE9todo de pago",
        items: "Conceptos",
        planRemainsActive: "Tu plan actual seguir\xE1 activo hasta el <bold>{{date}}</bold>."
      },
      cancelDowngrade: {
        success: "Se cancel\xF3 el cambio programado. Tu plan actual continuar\xE1.",
        error: "Hubo un error al cancelar el cambio de plan.",
        title: "Cancelar cambio de plan programado",
        subtitle: "Mant\xE9n activo tu plan actual",
        keepPlan: "Mantener {{plan}}",
        keepBenefits: "Sigue disfrutando de todos los beneficios de tu plan actual",
        willBeCanceled: "Se cancelar\xE1 el cambio a {{plan}} del {{date}}",
        rateNote: "Tu suscripci\xF3n continuar\xE1 con la tarifa del plan actual. Puedes cambiar de plan en cualquier momento.",
        canceling: "Cancelando...",
        confirmButton: "Cancelar cambio"
      },
      billingProblem: "Tengo un problema de facturaci\xF3n",
      banners: {
        scheduledDowngrade: "Tu suscripci\xF3n est\xE1 programada para bajar de plan el {{date}}. <link>Cancela el cambio</link> para mantener o cambiar tu plan actual.",
        scheduledCancellation: "Tu suscripci\xF3n se cancelar\xE1 el {{date}}. <link>Renueva tu plan</link> y sigue disfrutando de todos los beneficios de DASH."
      }
    },
    settings: {
      updatePassword: "Actualiza tu contrase\xF1a",
      updatePasswordSubTitle: "Edita o cambia tu contrase\xF1a para proteger tu cuenta.",
      updateEmailTitle: "Correo electr\xF3nico",
      updateEmailSubTitle: "Edita o cambia el correo electr\xF3nico de tu cuenta.",
      changeEmailTile: "Cambia tu correo electr\xF3nico",
      yourEmail: "Tu correo electr\xF3nico",
      switchToAgentButton: "Cambiar a cuenta profesional",
      switchToSeekerButton: "Cambiar a cuenta DASH Direct",
      switchToAgentSubTitle: "\xBFEres un profesional inmobiliario con licencia? Mejora tu cuenta para desbloquear herramientas dise\xF1adas para profesionales, como generaci\xF3n de leads, materiales de venta descargables e integraciones con sitios web.",
      switchToSeekerSubTitle: "\xBFNo trabajas activamente en bienes ra\xEDces? Puedes cambiar a una cuenta DASH no profesional con DASH Direct.<br>Ten en cuenta que perder\xE1s el acceso a herramientas profesionales como portafolios con tu marca, materiales de venta sin marca y captura de leads.",
      switchToSeekerConfirmModalTitle: "Confirmar cambio de tipo de cuenta",
      switchToAgentConfirmModalTitle: "Mejorar a una cuenta profesional",
      switchToAgentConfirmText: "Para desbloquear las herramientas profesionales de DASH, verifica los datos de tu licencia:",
      accountLanguageTitle: "Idioma de la cuenta",
      accountLanguageSubTitle: "Los correos y las notificaciones de Dash te llegan en este idioma.",
      accountLanguageSaved: "Idioma de la cuenta actualizado.",
      accountLanguageError: "No pudimos actualizar el idioma de tu cuenta. Int\xE9ntalo de nuevo.",
      accountLanguageBrowserOverride: "Este navegador muestra Dash en {{language}}.",
      accountLanguageUseHere: "Usar aqu\xED el idioma de la cuenta",
      sendResetLink: "Enviar un enlace de restablecimiento a tu correo",
      forgotPassword: "\xBFNo recuerdas tu contrase\xF1a?",
      sendNewLink: "Enviar un nuevo enlace",
      resetLinkSent: "\xA1Te enviamos un enlace para restablecer tu contrase\xF1a! Si no lo recibes, revisa la carpeta de spam antes de intentarlo de nuevo.",
      accountSwitchWarning: "ADVERTENCIA: este cambio es permanente, a menos que contactes a Soporte de DASH para revertirlo.",
      switchToSeekerConfirmText: "\xBFSeguro que quieres cambiar a una cuenta DASH no profesional? Perder\xE1s el acceso a todas las funciones reservadas para profesionales inmobiliarios con licencia y tendr\xE1s una experiencia m\xE1s simple.",
      licenseNumber: "N\xFAmero de licencia",
      selectState: "Selecciona tu estado",
      selectCountry: "Selecciona tu pa\xEDs",
      country: "Pa\xEDs",
      changeAccountType: "Cambiar tipo de cuenta"
    },
    api: {
      tooltipMessage: "Esta es la informaci\xF3n que compartir\xE1s con la empresa responsable de tu integraci\xF3n de API. Para usar nuestro plugin de API necesitas proporcionar el App ID y el token secreto de API.",
      apiKeys: "Claves de API",
      apiUsage: "Uso de la API",
      apiUsageOwnLabel: "Tus solicitudes este mes:",
      apiUsageLabel: "Solicitudes este mes:",
      apiUsageCompanyShare: "Tu l\xEDmite mensual se comparte con todos en tu empresa. Entre todos han usado {{usage}} de {{limit}} este mes.",
      apiActivity: "Actividad de la API",
      generateNewToken: "Generar token nuevo",
      tokenGeneratedSuccess: "Token generado correctamente. Gu\xE1rdalo en un lugar seguro.",
      tokenGeneratedError: "No se pudo generar el token. Int\xE9ntalo de nuevo.",
      newToken: "Tu nuevo token es:",
      newTokenStoreSafely: "C\xF3pialo y gu\xE1rdalo en un lugar seguro. No se volver\xE1 a mostrar despu\xE9s de cerrar esta ventana.",
      noAppIdFoundMessage: "No se encontr\xF3 el App ID. Actualiza la p\xE1gina o contacta a soporte si el problema contin\xFAa.",
      inactiveNotice: "Tu acceso a la API est\xE1 inactivo por ahora. A\xFAn puedes administrar tu App ID y tu token aqu\xED, pero las solicitudes a la API ser\xE1n rechazadas hasta que tu suscripci\xF3n a la API vuelva a estar activa. Contacta a soporte si crees que se trata de un error.",
      referralLinkTitle: "Enlace de referido",
      referralLinkDescription: "Comparte este enlace con tus clientes para darles acceso a nuestra API:",
      referralLinkCopied: "\xA1Enlace copiado al portapapeles!",
      referralLinkHint: "Deben abrir el enlace, crear una cuenta, elegir el plan de API y generar sus tokens en la p\xE1gina de configuraci\xF3n.",
      pluginUsersTitle: "Usuarios del plugin",
      pluginUsersDescription: "Clientes que se registraron con tu enlace de referido. Sus solicitudes a la API cuentan para tu cuota mensual.",
      pluginUsersEmpty: "Nadie se ha registrado todav\xEDa con tu enlace de referido.",
      pluginUsersRequestsThisMonth: "solicitudes este mes",
      pluginUsersActive: "Activo",
      pluginUsersInactive: "Inactivo",
      pluginUsersBlocked: "Bloqueado por ti",
      pluginUsersToggleLabel: "Acceso a la API",
      pluginUsersBlockError: "No pudimos actualizar el acceso de este cliente. Int\xE9ntalo de nuevo.",
      generateTokenModalTitle: "Generar nuevo token de API",
      firstTokenNote: "<bold>\xA1Importante!</bold> Cuando generes un token, se mostrar\xE1 aqu\xED.<br /><br />Debes <bold>copiarlo</bold> y guardarlo en un lugar seguro. Si lo pierdes, tendr\xE1s que generar uno nuevo y el anterior <bold>quedar\xE1 invalidado</bold>.",
      regenerateConfirm: "\xBFSeguro que quieres generar un nuevo token?<br />El actual <bold>quedar\xE1 invalidado</bold>.",
      tokenCopied: "\xA1Token copiado!",
      appIdCopied: "\xA1App ID copiado!",
      searchingAppId: "buscando App ID",
      appIdIs: "Tu <bold>App ID</bold> es: {{appId}}",
      usageDelayed: "*La informaci\xF3n de uso puede tardar hasta 1 hora en actualizarse.",
      needMoreRequests: "\xBFNecesitas m\xE1s solicitudes? Haz clic aqu\xED",
      usageError: "Hubo un error al obtener las m\xE9tricas de solicitudes. Actualiza la p\xE1gina o contacta a soporte si el error contin\xFAa.",
      tokenInactiveNote: "No hay ning\xFAn token activo asociado a este App ID.<br />Puedes generar uno nuevo con el bot\xF3n de abajo.",
      tokenActiveNote: "Ya hay un token activo asociado a este App ID.<br />Puedes generar uno nuevo con el bot\xF3n de abajo, pero el token actual <bold>quedar\xE1 invalidado</bold>."
    },
    accountInfo: {
      licenseValid: "V\xE1lida",
      licenseInvalid: "No v\xE1lida",
      licensePending: "Pendiente"
    },
    avatar: {
      uploadError: "Error al subir el archivo: {{error}}",
      cropTitle: "Recortar imagen",
      removeUnableError: "No se pudo quitar la foto de perfil. Int\xE9ntalo de nuevo.",
      removeFailedError: "No se pudo quitar la foto de perfil. Int\xE9ntalo de nuevo.",
      entity: "foto de perfil",
      removeTitle: "Quitar foto de perfil",
      removeConfirm: "\xBFSeguro que quieres quitar tu foto de perfil?",
      removeNote: "Recuerda guardar tus cambios para aplicar este cambio."
    },
    toasts: {
      updatedPassword: "Tu contrase\xF1a se actualiz\xF3 correctamente",
      updatedProfile: "Tu perfil se actualiz\xF3 correctamente",
      updatedEmail: "Tu correo electr\xF3nico se actualiz\xF3 correctamente",
      switchedToSeeker: "\xA1El tipo de cuenta cambi\xF3 a no agente!",
      switchedToAgent: "\xA1El tipo de cuenta cambi\xF3 a agente!"
    }
  },
  alertPage: {
    labels: {
      addAlert: "Agregar una alerta",
      alertDetails: "Detalles de la alerta",
      alertInfo: "Info de la alerta",
      createAlertTitle: "Crear una alerta",
      createAlertSubtitle: "Crea una alerta para las propiedades nuevas que coincidan con tus criterios de b\xFAsqueda",
      manageAlerts: "Administrar alertas",
      addAlertSelectFilter: "Selecciona los filtros de tu alerta",
      hiddenAlert: "Alerta oculta",
      filterByAlertPlaceholder: "Buscar por nombre de alerta",
      manageAlertsModalTitle: "Administrar alertas",
      manageAlertsModalSuTitle: "Consulta la lista completa de tus alertas y admin\xEDstralas seg\xFAn lo necesites.",
      deleteAlertModalTitle: "Eliminar alerta",
      deleteAlertModalSubTitle: "\xBFSeguro que quieres eliminar esta alerta de la lista de alertas?",
      noPropertiesPlaceholderTitle: "No has creado ninguna alerta",
      noPropertiesPlaceholder: "Crea una alerta para recibir una notificaci\xF3n cuando una propiedad nueva coincida con tus criterios",
      backButtonLabel: "Volver a administrar alertas"
    },
    toasts: {
      alertIsCreated: "Alerta creada correctamente",
      alertIsUpdated: "Alerta actualizada correctamente"
    }
  },
  brokersPage: {
    licenseInfo: "Info de la licencia",
    licenseData: "Datos de la licencia:",
    markAsInvalid: "Marcar como no v\xE1lida",
    markValid: "Marcar como v\xE1lida",
    saveBrokerDetails: "Guardar datos del agente",
    verifyBrokerLicense: "Verificar",
    licenseId: "ID de licencia:",
    blockBroker: "Bloquear cuenta",
    subscriptionStatus: "Estado de la suscripci\xF3n",
    unblockBroker: "Desbloquear cuenta",
    unlockStandardPlans: "Desbloquear planes est\xE1ndar",
    lockToApiPlan: "Limitar al plan de API",
    billingAccess: "Facturaci\xF3n",
    billingApiOnly: "Solo plan de API",
    billingAllPlans: "Todos los planes",
    notApiUserHint: "Este agente no es usuario de API: ya ve todos los planes.",
    toast: {
      paymentMethodAdded: "M\xE9todo de pago agregado correctamente",
      paymentMethodRemoved: "M\xE9todo de pago eliminado correctamente",
      paymentMethodSetAsDefault: "El m\xE9todo de pago se estableci\xF3 como predeterminado",
      maxPaymentMethod: "Llegaste al l\xEDmite de m\xE9todos de pago permitidos."
    },
    modals: {
      deactivateBrokerLicenseTitle: "Desactivar licencia del agente",
      activateBrokerLicenseTitle: "Establecer licencia del agente como activa",
      deactivateBrokerLicenseSuccess: "Licencia del agente invalidada",
      activateBrokerLicenseSuccess: "Licencia del agente validada",
      activateBrokerLicenseSubTitle: "\xBFEst\xE1s seguro?",
      notifyThroughMailCheckbox: "Enviar notificaci\xF3n por correo al agente",
      blockBrokerSubtitle: "\xBFSeguro que quieres bloquear esta cuenta?",
      blockBrokerReasonFieldTitle: "Indica el motivo del bloqueo",
      blockBrokerReasonFieldPlaceholder: "Escribe el motivo del bloqueo",
      unblockBrokerSubtitle: "\xBFSeguro que quieres desbloquear esta cuenta?"
    }
  },
  dashboardPage: {
    mortgageWidget: {
      mortgageModalTitle: "Calculadora de hipoteca",
      mortgageBalance: "Saldo de la hipoteca",
      totalPayments: "Pagos totales",
      monthlyPayments: "Pagos mensuales",
      totalInterestPaid: "Total de intereses pagados",
      propertyInsurance: "Seguro de la propiedad",
      propertyTax: "Impuesto predial",
      totalPropertyTax: "Total de impuesto predial",
      totalPropertyInsurance: "Total seguro prop."
    },
    currencyConverterWidget: {
      title: "Conversor de divisas",
      rate: "Tasa: {{from}} / {{to}}",
      label: "Por {{amount}} obtendr\xE1s:",
      for: "El {{date}}",
      copied: "Copiado"
    },
    propertyAlertsWidget: {
      propertiesAlertsModalTitle: "Alertas de propiedades",
      infoPlaceholder: "Propiedades nuevas",
      infoDescription: "Alertas de propiedades nuevas",
      infoPlaceholderDescription: "Recibe notificaciones cuando una propiedad nueva coincida con tus criterios de b\xFAsqueda"
    },
    propertyUpdatesWidget: {
      infoPlaceholder: "Seguir propiedades",
      infoDescription: "Actualizaciones de propiedades",
      infoPlaceholderDescription: "Recibe notificaciones cuando se actualice una propiedad de tu portafolio",
      infoPlaceholderSeekerDescription: "Recibe notificaciones cuando se actualice una propiedad que sigues",
      noPropertyUpdatesPlaceholder: "No se actualiz\xF3 ninguna propiedad en el periodo seleccionado"
    },
    reactionsWidget: {
      infoDescription: "Reacciones",
      infoPlaceholderDescription: "Recopila comentarios de clientes y colegas sobre los portafolios que compartes.",
      reactions: {
        interested: "Interesado",
        notInterested: "No interesado",
        maybeInterested: "Tal vez interesado",
        dontKnow: "No s\xE9"
      },
      enterYourData: "Ingresa tus datos",
      leaveReactionTitle: "\xBFC\xF3mo calificar\xEDas esta propiedad?",
      leaveReactionSuccessfulToast: "\xA1Gracias! Se notificar\xE1 a tu agente",
      reactionsViews: "Reacciones y vistas",
      userView: "Vista del usuario"
    },
    reactionsModal: {
      portfolioViewsLabel: "{{count}} vistas",
      portfolioReactionsLabel: "{{count}} reacciones",
      noPortfoliosMessage: "No se encontraron portafolios",
      noPortfoliosSubMessage: "Recopila comentarios de clientes y colegas sobre los portafolios que compartes.",
      noPortfoliosButtonMessage: "Crea tu primer portafolio",
      noPublicPortfoliosMessage: "No hay portafolios p\xFAblicos",
      noPublicPortfoliosSubMessage: "Haz p\xFAblico tu portafolio y recopila comentarios de clientes y colegas",
      noPublicPortfoliosButtonMessage: "Compartir portafolio"
    },
    viewedProperties: {
      viewed: "Visto: {{date}}",
      unavailableProperty: "Esta propiedad no est\xE1 disponible por ahora",
      viewedProperties: "Propiedades vistas",
      unavailableTitle: "Lleva el control de tus b\xFAsquedas",
      unavailableSubtitle: "Cuando empieces a explorar propiedades, tu historial aparecer\xE1 aqu\xED.",
      unavailableButton: "Explorar"
    },
    addedToPortfolio: {
      addedToPortfolio: "Agregadas a un portafolio",
      unavailableTitle: "Propiedades del portafolio",
      unavailableSubtitle: "Las propiedades que agregues a un portafolio se mostrar\xE1n aqu\xED.",
      unavailableButton: "Crear portafolio",
      added: "Agregada: {{date}}",
      removed: "Quitada",
      propertyNotAvailable: "La propiedad no est\xE1 disponible",
      noFolderName: "Portafolio sin nombre"
    },
    portfoliosWidget: {
      title: "Vistas de portafolios",
      titleShort: "Vistas port.",
      portfoliosDropdownInput: "Administrar gr\xE1fica",
      portfoliosDropdownInputShort: "Gr\xE1fica",
      noPortfoliosPlaceholderTitle: "Anal\xEDticas",
      noPortfoliosPlaceholderSubTitle: "Al crear portafolios, recibes anal\xEDticas de vistas de posibles compradores",
      noPublicPortfoliosPlaceholderSubTitle: "Al compartir portafolios de propiedades, recibes anal\xEDticas de vistas de posibles compradores",
      noPortfoliosPlaceholderMatches: "No se encontraron coincidencias para tu b\xFAsqueda, int\xE9ntalo de nuevo",
      noPortfoliosPlaceholderButtonLabel: "Crear portafolios",
      noPublicPortfoliosPlaceholderButtonLabel: "Compartir portafolios",
      noPortfoliosPlaceholderNoMatches: "No se encontraron coincidencias para tu b\xFAsqueda, int\xE9ntalo de nuevo"
    },
    banner: {
      view: "Ver",
      renew: "Renovar",
      dismiss: "Descartar",
      notifications: {
        freePlanUpdate: "\xA1DASH ahora es GRATIS para los usuarios del plan Basic! Haz clic aqu\xED para ver m\xE1s informaci\xF3n sobre esta novedad.",
        upgradeSubscription: "Tu cuenta gratuita tiene acceso limitado. Mejora tu plan para tener acceso completo.",
        brokerInfoIncomplete: "Completa tu perfil y ofrece a tus clientes una experiencia visual m\xE1s atractiva al ver propiedades.",
        cancelSubscription: "Cuando tu suscripci\xF3n venza, el acceso a las funciones de la plataforma ser\xE1 limitado. Renueva hoy para seguir disfrutando de todos los beneficios.",
        phoneVerification: "Verifica tu n\xFAmero de tel\xE9fono.",
        brokerLicense: "Tu licencia de agente no es v\xE1lida. Contacta a soporte de DASH.",
        trialExpired: "Tu periodo de prueba de DASH termina el {{date}}. El m\xE9todo de pago registrado se cobrar\xE1 autom\xE1ticamente al final de la prueba. Visita la configuraci\xF3n de facturaci\xF3n de tu cuenta para revisar tus m\xE9todos de pago."
      }
    }
  },
  managementPage: {
    addNewUser: "Agregar usuario",
    editUser: "Editar usuario",
    emptyPlaceholder: "No hay usuarios",
    archiveConfirmationTitle: "Archivar usuario",
    unarchiveConfirmationTitle: "Desarchivar usuario",
    archiveConfirmationBody: "\xBFSeguro que quieres archivar a este usuario?",
    unarchiveConfirmationBody: "\xBFSeguro que quieres desarchivar a este usuario?",
    toasts: {
      userAdded: "El usuario se agreg\xF3 correctamente",
      userUpdated: "El usuario se actualiz\xF3 correctamente",
      userArchived: "El usuario se archiv\xF3 correctamente",
      userUnarchived: "El usuario se desarchiv\xF3 correctamente"
    }
  },
  apiUsersPage: {
    addNewUser: "Agregar representante de API",
    addNewUserButton: "Agregar representante de API",
    editUser: "Editar representante de API"
  },
  apiInvitationsPage: {
    createInvitation: "Crear invitaci\xF3n de API",
    createInvitationButton: "Crear invitaci\xF3n",
    emptyPlaceholder: "No hay invitaciones",
    toasts: {
      invitationCreated: "La invitaci\xF3n se cre\xF3 correctamente",
      invitationRevoked: "La invitaci\xF3n se revoc\xF3 correctamente"
    }
  },
  apiConsolePage: {
    tabs: {
      overview: "Resumen",
      accounts: "Cuentas",
      invitations: "Invitaciones"
    },
    accountsModeCompanies: "Empresas",
    accountsModePluginUsers: "Usuarios del plugin",
    allStatuses: "Todos los estados",
    showingRange: "Mostrando {{from}}\u2013{{to}} de {{total}}",
    rowsPerPage: "Mostrar {{count}}",
    noAccounts: "No hay cuentas de API",
    apiUsage: "Uso de la API",
    usageRange: "Periodo",
    usageGrouping: "Agrupar por",
    usageFrom: "Desde",
    usageTo: "Hasta",
    invitationFunnel: "Invitaciones",
    invitationTotal: "{{count}} en total",
    requestsInDays: "{{count}} solicitudes \xB7 \xFAltimos {{days}} d\xEDas",
    requestsTotal: "{{count}} solicitudes",
    noUsage: "No hay solicitudes en este periodo.",
    totalApiAccess: "Acceso total a la API",
    companiesApiAccess: "Acceso a la API de empresas",
    pluginUsersApiAccess: "Acceso a la API de usuarios del plugin",
    companyDirectAccess: "Acceso directo a la API de la empresa",
    clientsApiAccess: "Acceso a la API de clientes",
    sharedQuota: "Cuota mensual (empresa + usuarios del plugin)",
    resetsOn: "Se restablece el {{date}}",
    customLimit: "l\xEDmite personalizado",
    defaultLimit: "l\xEDmite predeterminado",
    noQuota: "A\xFAn no hay informaci\xF3n de cuota para esta cuenta.",
    apiAccess: "Acceso a la API",
    accessEnabled: "Habilitado",
    accessDisabled: "Deshabilitado por un administrador",
    accessEnabledHint: "Al deshabilitarlo se bloquea a esta empresa y a todos los usuarios del plugin registrados a trav\xE9s de ella, sin importar el estado de su suscripci\xF3n.",
    accessDisabledHint: "Un administrador bloque\xF3 el acceso a la API. Los eventos de facturaci\xF3n no pueden reactivarlo mientras exista este bloqueo.",
    disableAccess: "Deshabilitar acceso a la API",
    blockReasonLabel: "Motivo (opcional)",
    blockReasonPlaceholder: "\xBFPor qu\xE9 se corta el acceso?",
    disabledOn: "Deshabilitado el {{date}}",
    disabledOnWithReason: "Deshabilitado el {{date}} \u2014 {{reason}}",
    reEnableAccess: "Volver a habilitar el acceso a la API",
    monthlyLimit: "L\xEDmite mensual de solicitudes",
    newLimitPlaceholder: "Nuevo l\xEDmite",
    saveLimit: "Guardar l\xEDmite",
    restoreDefault: "Restaurar predeterminado",
    pluginUsers: "Usuarios del plugin",
    pluginUsersHint: "Se registraron con el enlace de referido de esta empresa. Sus solicitudes cuentan para la cuota de arriba y, si se deshabilita la empresa, tambi\xE9n se les bloquea.",
    pluginUserStatus: "Estado",
    pluginUserActive: "Activo",
    pluginUserInactive: "Inactivo",
    pluginUserBlockedByPartner: "Bloqueado por el socio",
    pluginUserBlockedByAdmin: "Bloqueado por un administrador",
    blockedByPartnerHint: "El socio desactiv\xF3 a este usuario del plugin. Solo \xE9l puede volver a activarlo.",
    noPluginUsers: "Ning\xFAn usuario del plugin se registr\xF3 a trav\xE9s de esta empresa.",
    referralLink: "Enlace de referido",
    copyReferralLink: "Copiar enlace de referido",
    noReferralLink: "Cuenta directa",
    deleteAccount: "Eliminar cuenta",
    deleteAccountTitle: "\xBFEliminar {{name}}?",
    deleteAccountBody: "El acceso a la API se detiene de inmediato y la cuenta desaparece de esta lista. No se borra nada: un administrador puede restaurarla m\xE1s adelante.",
    deleteAccountCascade_one: "Su \xFAnico usuario del plugin pierde el acceso a la API con ella y lo recupera al restaurarla. Su propia cuenta no se modifica.",
    deleteAccountCascade_other: "Sus {{count}} usuarios del plugin pierden el acceso a la API con ella y lo recuperan al restaurarla. Sus propias cuentas no se modifican.",
    deleteAccountCodeWarning: "Su c\xF3digo de referido no puede reutilizarse en una cuenta nueva, ni siquiera despu\xE9s de restaurarla.",
    deleteChallenge: "Escribe {{name}} para confirmar",
    restoreAccount: "Restaurar cuenta",
    showDeleted: "Mostrar eliminadas",
    deletedPill: "Eliminada",
    deletedOn: "Eliminada el {{date}}",
    accountNotFound: "No pudimos encontrar esa cuenta de API.",
    untitledAccount: "Empresa sin nombre",
    responsibleCompany: "Empresa responsable",
    viewParentCompany: "Ver empresa matriz",
    viewBrokerRecord: "Ver registro del agente",
    resendInvitation: "Reenviar",
    resendInvitationTitle: "\xBFReenviar esta invitaci\xF3n?",
    resendInvitationBody: "Se enviar\xE1 un enlace nuevo a {{email}} por correo y el anterior dejar\xE1 de funcionar.",
    resendInvitationExpiry: "Nueva fecha de vencimiento (opcional)",
    invitationEmail: "Correo electr\xF3nico",
    toasts: {
      accessDisabled: "Acceso a la API deshabilitado",
      accessReEnabled: "Acceso a la API habilitado de nuevo",
      accessStillOff: "Se quit\xF3 el bloqueo del administrador, pero el acceso a la API sigue desactivado: esta empresa no tiene una suscripci\xF3n activa a la API.",
      accessFailed: "No se pudo actualizar el acceso a la API",
      limitSaved: "L\xEDmite mensual establecido en {{limit}}",
      limitRestored: "L\xEDmite mensual restaurado al predeterminado",
      limitFailed: "No se pudo actualizar el l\xEDmite mensual",
      inviteFailed: "No se pudo crear la invitaci\xF3n",
      revokeFailed: "No se pudo revocar la invitaci\xF3n",
      saveAccountFailed: "No se pudo guardar la cuenta de API",
      referralLinkCopied: "Enlace de referido copiado",
      accountDeleted: "Cuenta eliminada",
      accountDeletedWithPluginUsers_one: "Cuenta eliminada; 1 usuario del plugin perdi\xF3 el acceso a la API",
      accountDeletedWithPluginUsers_other: "Cuenta eliminada; {{count}} usuarios del plugin perdieron el acceso a la API",
      deleteAccountFailed: "No se pudo eliminar la cuenta",
      accountRestored: "Cuenta restaurada",
      accountRestoredInactive: "Cuenta restaurada, pero el acceso a la API sigue desactivado: no hay una suscripci\xF3n activa a la API.",
      restoreAccountFailed: "No se pudo restaurar la cuenta",
      invitationResent: "Invitaci\xF3n reenviada",
      resendInvitationFailed: "No se pudo reenviar la invitaci\xF3n",
      pluginUserBlocked: "Usuario del plugin bloqueado",
      pluginUserUnblocked: "Usuario del plugin desbloqueado"
    }
  },
  contentActivityPage: {
    from: "Desde",
    to: "Hasta",
    period: "Periodo",
    totals: {
      propertiesEdited: "Propiedades editadas",
      changes: "Cambios",
      filesUploaded: "Archivos subidos",
      propertiesCreated: "Propiedades nuevas"
    },
    byType: "Por tipo de cambio",
    byTypeHint: "Cada entrada del historial de propiedades. Las cargas de archivos incluyen archivos eliminados despu\xE9s, por lo que esta cifra puede ser mayor que la de Archivos subidos de arriba.",
    byPerson: "Por persona",
    columns: {
      change: "Cambio",
      changes: "Cambios",
      properties: "Propiedades",
      person: "Persona",
      propertiesEdited: "Propiedades editadas",
      filesUploaded: "Archivos subidos",
      propertiesCreated: "Propiedades nuevas",
      when: "Cu\xE1ndo",
      property: "Propiedad",
      by: "Por"
    },
    log: "Registro de cambios",
    logHint: "Todos los cambios de este periodo, del m\xE1s reciente al m\xE1s antiguo. Los cambios de estado y de visibilidad son internos: los agentes nunca los ven.",
    visibilityAlsoChanged: "Visibilidad: {{change}}",
    deletedProperty: "Propiedad eliminada",
    unknownPerson: "Desconocido",
    unknownPersonHint: "Antes del registro de autores",
    noChanges: "No hay cambios en este periodo.",
    noContributors: "No hay actividad en este periodo.",
    loadError: "No se pudo cargar la actividad de contenido. Int\xE9ntalo de nuevo.",
    changeTypes: {
      PROPERTY_ABOUT: "Detalles de la propiedad",
      PROPERTY_ADDITIONAL_INFORMATION: "Informaci\xF3n adicional",
      PROPERTY_CMS_STATUS: "Estado",
      PROPERTY_DATA_REVIEWED: "Datos verificados",
      PROPERTY_DEVELOPER_ORGANIZATION: "Organizaci\xF3n desarrolladora",
      PROPERTY_FEATURES_AND_AMENITIES: "Caracter\xEDsticas y amenidades",
      PROPERTY_HIGHLIGHTS: "Destacados",
      PROPERTY_INVENTORY_UNIT_ADDED: "Inventario agregado",
      PROPERTY_INVENTORY_UNIT_REMOVED: "Inventario eliminado",
      PROPERTY_INVENTORY_UNIT_UPDATED: "Inventario actualizado",
      PROPERTY_LOCATION: "Ubicaci\xF3n",
      PROPERTY_MEDIA_FILES_MOVED: "Archivos movidos",
      PROPERTY_MEDIA_REMOVED: "Archivos eliminados",
      PROPERTY_MEDIA_RENAMED: "Archivos renombrados",
      PROPERTY_MEDIA_UPLOADED: "Archivos subidos",
      PROPERTY_NAME: "Nombre de la propiedad",
      PROPERTY_PRICE: "Precios y disponibilidad",
      PROPERTY_SALES_TEAMS: "Equipo de ventas",
      PROPERTY_VIRTUAL_TOURS: "Recorridos virtuales",
      PROPERTY_VISIBILITY: "Visibilidad",
      PROPERTY_WEBSITE: "Sitio web",
      retired: "Otro (tipo retirado)"
    }
  },
  trackingPage: {
    noPropertiesLabelTitle: "\xA1A\xFAn no sigues ninguna propiedad!",
    noPropertiesLabel: "Agrega tus propiedades favoritas a tu lista de seguimiento para acceder a ellas f\xE1cilmente.",
    noPropertiesButtonLabel: "Empezar a explorar",
    noPortfoliosLabelTitle: "\xA1A\xFAn no sigues ning\xFAn portafolio!",
    noPortfoliosLabel: "Agrega tus portafolios favoritos a tu lista de seguimiento para acceder a ellos f\xE1cilmente.",
    noPortfoliosButtonLabel: "Explorar portafolios",
    propertiesTab: "Propiedades",
    portfoliosTab: "Portafolios",
    trackProperty: "Seguir propiedad"
  },
  externalSalesPage: {
    addUser: "Agregar usuario",
    addExternalTeam: "Agregar equipo nuevo",
    editExternalTeam: "Editar equipo",
    toasts: {
      teamAdded: "El equipo se agreg\xF3 correctamente",
      teamChanged: "El equipo se modific\xF3 correctamente",
      userAdded: "El usuario se agreg\xF3 correctamente",
      userUpdated: "El usuario se actualiz\xF3 correctamente"
    },
    deleteSaleTeamModalLabel: "Eliminar equipo",
    deleteSaleTeamModalText: "\xBFSeguro que quieres eliminar el equipo {{teamName}}?",
    addSaleTeamUserModalLabel: "Agregar usuarios al equipo de ventas",
    editSaleTeamUserModalLabel: "Editar usuario del equipo de ventas",
    deleteSaleTeamUserModalLabel: "Eliminar usuario del equipo de ventas",
    deleteSaleTeamUserModalText: "Al eliminar a este usuario del equipo de ventas, revocar\xE1s su acceso y los permisos que ten\xEDa dentro del equipo. \xBFSeguro que quieres continuar?",
    archiveUserText: "\xBFSeguro que quieres archivar a este usuario del equipo de ventas?",
    unarchiveUserText: "\xBFSeguro que quieres desarchivar a este usuario del equipo de ventas?"
  },
  organizationDashboardPage: {
    deleteOrganizationModalNote: "Esto puede afectar a las propiedades asociadas",
    mediaKitWidgetPlaceholderTitle: "Archivos / descargas de DASH",
    propertySavesPlaceholderTitle: "Propiedades guardadas",
    propertySavesPlaceholderText: "Ning\xFAn agente ha guardado esta propiedad todav\xEDa.",
    propertySharesPlaceholderTitle: "Propiedades compartidas",
    propertySharesPlaceholderText: "Ning\xFAn agente ha compartido esta propiedad todav\xEDa.",
    addedToPortfoliosPlaceholderTitle: "Agregadas a portafolios",
    addedToPortfoliosPlaceholderText: "Esta propiedad a\xFAn no se ha agregado a un portafolio.",
    propertySavesPlaceholderTextPeriod: "Ning\xFAn agente agreg\xF3 esta propiedad durante el rango de tiempo seleccionado.",
    propertySharesPlaceholderTextPeriod: "No se compartieron propiedades en el rango de tiempo seleccionado.",
    propertyAddedPortfolioPlaceholderText: "Esta propiedad a\xFAn no se ha agregado a un portafolio.",
    propertyAddedPortfolioPlaceholderTextPeriod: "Esta propiedad no se agreg\xF3 a ning\xFAn portafolio durante el rango de tiempo seleccionado.",
    propertyMediaKitPlaceholderText: "A\xFAn no hay descargas.",
    propertyMediaKitPlaceholderTextPeriod: "No hay descargas en el rango de tiempo seleccionado.",
    viewedByAgents: "Vistas por agentes",
    viewedByAgentsNoResult: "No hay vistas en el periodo seleccionado",
    viewedByAgentsPlaceholderTitle: "A\xFAn no hay vistas de agentes",
    downloadedFilesTitle: "Archivos m\xE1s populares",
    downloadedFilesPlaceholderTitle: "A\xFAn no se ha descargado ning\xFAn archivo.",
    exportData: "Exportar datos",
    propertyName: "Nombre de la propiedad",
    filterByDate: "Filtrar por fecha",
    selectRange: "Seleccionar rango",
    customRange: "Rango personalizado",
    totalValue: "Valor total",
    widgetsEmptyFilterTexts: {
      propertyShared: "No se compartieron propiedades en el periodo seleccionado",
      addedToPortfolios: "Esta propiedad no se agreg\xF3 a ning\xFAn portafolio durante el periodo seleccionado.",
      propertySaves: "Ning\xFAn agente guard\xF3 esta propiedad durante el periodo seleccionado.",
      fileDownloads: "No hay descargas en el periodo seleccionado"
    }
  },
  mediaKit: {
    dashDownloads: "Descargas de la propiedad",
    enableDashDownloads: "Habilitar descargas de la propiedad",
    mediaKitText: "Agrega y personaliza qu\xE9 archivos multimedia de esta propiedad se muestran en tu portafolio.",
    propertyMediaFiles: "Multimedia de la propiedad",
    addedToDashDownloads: "{{total}} archivos agregados al portafolio",
    manageMediaKit: "Descargas de la propiedad",
    numberOfAddedItems: "Archivos multimedia agregados",
    addToMedia: "Agregar a multimedia",
    added: "Agregado",
    addTitle: "Comparte tu portafolio",
    addSubtitle: "Configura la visibilidad y las opciones para compartir el portafolio.",
    firstShareSubtitle: "Tu portafolio ya es p\xFAblico. Puedes copiar y compartir el enlace de abajo con tus clientes o cambiar las opciones para compartir.",
    editTitle: "Administrar descargas de la propiedad",
    editSubtitle: "Puedes agregar o eliminar archivos multimedia de la propiedad en el kit de medios",
    removeAllFiles: "Quitar todos los archivos",
    addAllFiles: "Agregar todos los archivos",
    unsavedChanges: "\xA1Tienes cambios sin guardar!",
    attachIntro: "Adjunta folletos sin marca, planos y otros archivos de presentaci\xF3n listos para el agente, que tus prospectos podr\xE1n descargar desde la p\xE1gina de la propiedad.",
    updateError: "Hubo un error al actualizar la configuraci\xF3n del kit de medios.",
    updateSuccess: "\xA1Las descargas de la propiedad se actualizaron!",
    confirmAndSave: "Confirmar y guardar",
    confirmRemoveAllBody: "\u26A0\uFE0F Esta acci\xF3n <bold>quitar\xE1 todos los archivos multimedia de la propiedad</bold> de tu portafolio. \xBFSeguro?",
    confirmAddAllBody: "\u26A0\uFE0F Esta acci\xF3n <bold>agregar\xE1 todos los archivos multimedia de la propiedad</bold> a tu portafolio. \xBFSeguro?",
    confirmChangesTitle: "Confirma tus cambios"
  },
  releaseNotes: {
    subtitle: "Mantente al d\xEDa con los \xFAltimos cambios, mejoras y funciones nuevas de la API de DASH."
  },
  welcomeDiscoveryModal: {
    eyebrow: "YA EST\xC1S DENTRO",
    heading: "Te damos la bienvenida a DASH, {{firstName}}.",
    intro: "Ahora tienes un <tag>plan gratuito</tag> y puedes explorar todos los desarrollos nuevos de DASH.",
    includedTitle: "INCLUIDO EN EL PLAN GRATUITO:",
    feature1: "Explora toda la base de datos de propiedades de DASH",
    feature2: "Accede al feed semanal de propiedades en tendencia",
    feature3: "Guarda y sigue hasta 5 propiedades",
    feature4: "Reserva una demo gratis y mira c\xF3mo DASH apoya la venta de desarrollos nuevos",
    unlockHeading: "Desbloquea toda la base de datos por solo $10/mes",
    unlockSubtext: "Prueba gratis de 7 d\xEDas, cancela cuando quieras",
    seeAllPlans: "Ver todos los planes",
    startExploring: "Empezar a explorar",
    close: "Cerrar",
    firstNameFallback: "t\xFA"
  },
  quickTour: {
    label: "Recorrido r\xE1pido",
    progress: "{{current}} de {{total}}",
    skip: "Omitir recorrido",
    back: "Atr\xE1s",
    next: "Siguiente",
    done: "Listo",
    searchTitle: "Inicia una b\xFAsqueda de propiedades",
    searchDescription: "Busca en DASH por propiedad, ubicaci\xF3n o desarrolladora.",
    sectionsTitle: "Descubre propiedades",
    sectionsDescription: "Explora propiedades y categor\xEDas en tendencia con recomendaciones din\xE1micas.",
    featuredPortfoliosTitle: "Portafolios destacados",
    featuredPortfoliosDescription: "Colecciones de propiedades listas para compartir, curadas por el equipo de DASH.",
    mapTitle: "Explora el mapa",
    mapDescription: "Recorre el mapa para tener una visi\xF3n completa del mercado de condominios en preventa y obra nueva de Florida.",
    sidebarTitle: "Navega DASH con facilidad",
    sidebarDescription: "Accede de forma r\xE1pida y sencilla a las funciones clave de DASH.",
    bottomNavTitle: "Navega DASH con facilidad",
    bottomNavDescription: "Accede de forma r\xE1pida y sencilla a las funciones clave de DASH.",
    profileTitle: "Administra tu cuenta",
    profileDescription: "Accede al perfil, la facturaci\xF3n y la configuraci\xF3n de tu cuenta.",
    searchFiltersTitle: "Busca con filtros",
    searchFiltersDescription: "Combina t\xE9rminos de b\xFAsqueda con los filtros de DASH para encontrar justo lo que buscas.",
    searchSortTitle: "Orden de resultados",
    searchSortDescription: "Ordena los resultados por precio, actualizaciones recientes y m\xE1s para explorar con eficiencia.",
    searchViewsTitle: "Vistas de cuadr\xEDcula y mapa",
    searchViewsDescription: "Mira los resultados en una cuadr\xEDcula o cambia a la vista de mapa para verlos geogr\xE1ficamente.",
    searchWatchlistTitle: "Agrega a tu lista de seguimiento",
    searchWatchlistDescription: "Haz clic en el coraz\xF3n para agregar una propiedad o un portafolio a tu lista de seguimiento personal.",
    searchPortfolioTitle: "Guarda propiedades en un portafolio",
    searchPortfolioDescription: "Haz clic en el \xEDcono de carpeta para guardar una propiedad en un portafolio y compartirla despu\xE9s.",
    watchlistPropertiesTitle: "Seguimiento de propiedades",
    watchlistPropertiesDescription: "Las propiedades que guardas en tu lista de seguimiento se almacenan aqu\xED para recibir alertas de cambios y acceder f\xE1cilmente.",
    watchlistPortfoliosTitle: "Seguimiento de portafolios",
    watchlistPortfoliosDescription: "Los portafolios curados que guardas en tu lista de seguimiento se almacenan aqu\xED para acceder y compartirlos f\xE1cilmente.",
    watchlistSavedTitle: "B\xFAsquedas guardadas",
    watchlistSavedDescription: "Guarda una b\xFAsqueda personalizada con filtros para recibir alertas cuando haya propiedades nuevas o actualizadas que coincidan.",
    portfolioAddTitle: "Portafolios personalizados",
    portfolioAddDescription: "Crea un portafolio nuevo para organizar y compartir propiedades con tus propios enlaces de marca.",
    portfolioPreviewTitle: "Vista previa de tu portafolio",
    portfolioPreviewDescription: "Mira tu portafolio en modo cliente para ver c\xF3mo se ver\xE1 al compartirlo.",
    portfolioShareTitle: "Opciones para compartir a tu medida",
    portfolioShareDescription: "Los portafolios pueden ser p\xFAblicos, estar protegidos con contrase\xF1a o ser privados y visibles solo para ti.",
    portfolioCreateTitle: "Ponle nombre a tu portafolio",
    portfolioCreateDescription: "Dale un nombre a tu portafolio y empieza a agregar propiedades para compartir con tus clientes.",
    portfolioGuideTitle: "Lee la gu\xEDa",
    portfolioGuideDescription: "Consulta la gu\xEDa de inicio r\xE1pido de DASH Pro con consejos para crear y compartir portafolios.",
    exchangeSettingsTitle: "Conecta tu sitio web",
    exchangeSettingsDescription: "Ingresa la URL del sitio que mostrar\xE1 tu feed de desarrollos nuevos y personaliza sus colores.",
    exchangeAddFeedTitle: "Crea feeds",
    exchangeAddFeedDescription: "Crea un feed para mostrar en tu sitio web una propiedad, un portafolio o una barra de b\xFAsqueda de DASH.",
    exchangeNewFeedTitle: "Configura un feed",
    exchangeNewFeedDescription: "Ponle nombre a tu feed, elige un tipo y haz clic en Crear para guardarlo.",
    exchangeFeedSaveTitle: "Guarda y previsualiza",
    exchangeFeedSaveDescription: "Guarda tu configuraci\xF3n y la vista previa te mostrar\xE1 c\xF3mo se ver\xE1 el feed dentro del iFrame de tu sitio web.",
    exchangeFeedGuideTitle: "Lee la gu\xEDa",
    exchangeFeedGuideDescription: "Consulta la gu\xEDa de inicio r\xE1pido de DASH eXchange para m\xE1s consejos."
  },
  quickStart: {
    eyebrow: "Inicio r\xE1pido",
    pulse: "Pulse",
    onThisPage: "En esta p\xE1gina",
    exploreNext: "Explora a continuaci\xF3n",
    unlockTitle: "Desbloquea con PRO y eXchange",
    lockedHint: "Mejora tu plan para desbloquear",
    replay: "Repetir",
    title: "Primeros pasos",
    doneCount: "<highlight>{{current}}</highlight> de {{total}} completados",
    close: "Cerrar",
    dontShowAgain: "No volver a mostrar",
    itemTour: "Haz el recorrido por el producto",
    itemSearch: "Haz tu primera b\xFAsqueda",
    itemOpenDevelopment: "Abre un desarrollo",
    itemSaveProperty: "Guarda una propiedad",
    itemTryFilter: "Prueba un filtro",
    itemPortfolios: "Revisa tus portafolios",
    itemViewWatchlist: "Revisa tu lista de seguimiento",
    itemExploreExchange: "Explora DASH eXchange"
  },
  cmsSettingsPage: {
    title: "Configuraci\xF3n de transici\xF3n de estados del CMS",
    description: "Configura las transiciones autom\xE1ticas de estado de las propiedades. Estos ajustes determinan cu\xE1nto tiempo permanece una propiedad en cada estado antes de pasar autom\xE1ticamente al siguiente.",
    automatedTransitions: "Habilitar transiciones autom\xE1ticas",
    automatedTransitionsDescription: "Cuando est\xE1 habilitado, los estados de las propiedades cambiar\xE1n autom\xE1ticamente seg\xFAn los tiempos de abajo",
    transitionTimes: "Tiempos de transici\xF3n",
    newListingToActive: "Propiedad nueva \u2192 Propiedad activa",
    newListingToActiveHelp: "D\xEDas antes de que una propiedad reci\xE9n aprobada pase a activa",
    activeToAudit: "Propiedad activa \u2192 En espera de auditor\xEDa",
    activeToAuditHelp: "D\xEDas antes de que una propiedad activa requiera revisi\xF3n de contenido",
    recentlyUpdatedToActive: "Actualizada recientemente \u2192 Propiedad activa",
    recentlyUpdatedToActiveHelp: "D\xEDas antes de que una propiedad actualizada vuelva a estado activo",
    resetToDefaults: "Restablecer valores predeterminados",
    resetConfirmationTitle: "Restablecer configuraci\xF3n",
    resetConfirmationMessage: "\xBFSeguro que quieres restablecer la configuraci\xF3n predeterminada?",
    confirm: "Confirmar",
    validationError: "Corrige los errores de validaci\xF3n antes de enviar",
    updateSuccess: "Configuraci\xF3n actualizada correctamente",
    updateError: "No se pudo actualizar la configuraci\xF3n",
    resetSuccess: "Configuraci\xF3n restablecida a los valores predeterminados",
    resetError: "No se pudo restablecer la configuraci\xF3n"
  },
  subscriptionPlans: {
    billedAnnually: "Facturaci\xF3n anual",
    billedEverySixMonths: "Facturaci\xF3n cada 6 meses",
    saveDiscount: "Ahorra {{percent}}%",
    withYearly: "con pago anual",
    withSixMonths: "con pago semestral",
    monthly: "Mensual",
    yearly: "Anual",
    semiAnnually: "Semestral",
    errorLoading: "Tenemos problemas para cargar la informaci\xF3n de suscripci\xF3n. Actualiza la p\xE1gina para intentarlo de nuevo.",
    errorTitle: "Algo sali\xF3 mal",
    refreshPage: "Actualizar p\xE1gina",
    errorSupport: "Si el problema contin\xFAa, contacta a soporte.",
    discontinued: "Descontinuado",
    legacyPrice: "Precio anterior",
    perMonth: "/mes",
    yourCurrentPlan: "Tu plan actual",
    startFreeTrial: "Iniciar prueba gratis",
    getPlan: "Obtener {{plan}}",
    seeAllPlans: "Ver todos los planes",
    contactSales: "Contactar a ventas",
    bookDemo: "Reservar una demo",
    reactivateTrial: "Reactivar prueba",
    cancelTrial: "Cancelar prueba",
    cancelScheduledDowngrade: "Cancelar cambio de plan programado",
    currentPlanNote: "Este es tu plan actual.",
    reactivateSubscription: "Reactivar suscripci\xF3n",
    daysLeftInTrial_one: "Queda {{count}} d\xEDa de prueba",
    daysLeftInTrial_other: "Quedan {{count}} d\xEDas de prueba",
    accessExpiresIn_one: "El acceso vence en {{count}} d\xEDa",
    accessExpiresIn_other: "El acceso vence en {{count}} d\xEDas",
    manageOrResubscribe: "Administrar o volver a suscribirse",
    manageOrCancel: "Administrar o cancelar suscripci\xF3n",
    apiCancelNote: "Al cancelar se desactiva tu acceso a la API al final de tu per\xEDodo de facturaci\xF3n. Tu App ID y tu token se conservan."
  },
  confirmUserType: {
    setupError: "Algo sali\xF3 mal al configurar tu cuenta. Int\xE9ntalo de nuevo.",
    title: "\xBFEres agente inmobiliario?",
    subtitle: "Responde para continuar.",
    yes: "S\xED",
    no: "No"
  },
  apiPortal: {
    notFound: "404 No encontrado",
    apiDocumentation: "Documentaci\xF3n de la API",
    layout: {
      buildingsAlt: "Edificios de Dash",
      apiDocs: "Documentaci\xF3n de la API",
      apiReleaseNotes: "Novedades de la API",
      apiTerms: "T\xE9rminos de uso de la API",
      privacyPolicy: "Pol\xEDtica de privacidad",
      copyright: "2026 Dash Inc. Todos los derechos reservados"
    },
    auth: {
      emailRequired: "El correo es obligatorio.",
      emailInvalid: "El correo debe ser v\xE1lido.",
      passwordRequired: "La contrase\xF1a es obligatoria.",
      passwordPlaceholder: "Ingresa tu contrase\xF1a",
      tokenMissing: "La API no proporcion\xF3 el token.",
      incorrectCredentials: "Credenciales incorrectas.",
      loadingAccount: "Cargando datos de la cuenta, espera un momento...",
      redirectHint: "Si no te redirigimos en 5 segundos, actualiza la p\xE1gina o contacta a soporte.",
      backToSignIn: "O <link>vuelve a la p\xE1gina de inicio de sesi\xF3n</link>"
    },
    mfa: {
      codeRequired: "El c\xF3digo es obligatorio.",
      accessTokenMissing: "Error: no se proporcion\xF3 el token de acceso. Contacta a soporte.",
      title: "Autenticaci\xF3n multifactor",
      confirmPrompt: "Confirma el c\xF3digo en tu aplicaci\xF3n de autenticaci\xF3n.",
      qrError: "Algo sali\xF3 mal al generar el c\xF3digo QR para activar MFA. Contacta a soporte.",
      enableTitle: "Activar MFA",
      enableScan: "Activa MFA para continuar. Escanea el c\xF3digo QR con tu aplicaci\xF3n de autenticaci\xF3n.",
      enableCode: "Ahora ingresa el c\xF3digo que aparece en tu aplicaci\xF3n de autenticaci\xF3n antes de que venza.",
      enableDone: "\xA1Listo! A partir de ahora se te pedir\xE1 MFA cada vez que inicies sesi\xF3n en la aplicaci\xF3n."
    },
    dashboard: {
      tabTitle: "Panel de API | DASH",
      requestsThisMonth: "Solicitudes este mes (empresa + usuarios del plugin):",
      needMoreRequests: "\xBFNecesitas m\xE1s solicitudes? Haz clic aqu\xED",
      metricsError: "Hubo un error al obtener las m\xE9tricas de solicitudes. Actualiza la p\xE1gina o contacta a soporte si el error contin\xFAa.",
      usageDelay: "*La informaci\xF3n de uso puede tardar hasta 1 hora en actualizarse."
    },
    releaseNotes: {
      filterTitle: "Filtrar novedades",
      clearFilters: "Borrar filtros",
      year: "A\xF1o",
      allYears: "Todos los a\xF1os",
      changeTypesLabel: "Tipos de cambio",
      emptyState: "Ninguna novedad coincide con tus filtros.",
      changeTypes: {
        newEndpoint: "Nuevo endpoint",
        enhancement: "Mejora",
        deprecation: "Obsolescencia",
        behaviorChange: "Cambio de comportamiento",
        documentation: "Documentaci\xF3n",
        performance: "Rendimiento"
      }
    },
    settings: {
      appIdNotFound: "No se encontr\xF3 ning\xFAn App ID. Actualiza la p\xE1gina o contacta a soporte si el problema contin\xFAa.",
      appIdTitle: "App ID",
      appIdIs: "Tu <bold>App ID</bold> es: {{appId}}",
      appIdSearching: "buscando App ID",
      linkCopied: "\xA1Enlace copiado al portapapeles!",
      docsLine: "Puedes consultar nuestra documentaci\xF3n <link>haciendo clic aqu\xED.</link>",
      releaseNotesLine: "Consulta los \xFAltimos cambios de la API en nuestras <link>novedades.</link>",
      termsLine: "Revisa nuestros <link>T\xE9rminos de uso de la API.</link>",
      tokenTitle: "Token de API",
      tokenActive: "Ya hay un token activo asociado a este App ID.<br/>Puedes generar uno nuevo con el bot\xF3n de abajo, pero el token actual <bold>quedar\xE1 invalidado</bold>.",
      tokenNone: "No hay ning\xFAn token activo asociado a este App ID.<br/>Puedes generar uno nuevo con el bot\xF3n de abajo.",
      generateToken: "Generar nuevo token",
      referralTitle: "Enlace de referido",
      referralShare: "Comparte este enlace con tus clientes para darles acceso a nuestra API:",
      referralSteps: "Deben abrir el enlace, crear una cuenta, seleccionar el plan API y generar sus tokens en la p\xE1gina de configuraci\xF3n.",
      referralSupport: "Si necesitas ayuda, escr\xEDbenos a <mail>support@dashtodash.com</mail>",
      tokenGenerated: "Token generado correctamente. Gu\xE1rdalo en un lugar seguro.",
      tokenGenerateFailed: "No se pudo generar el token. Int\xE9ntalo de nuevo.",
      newTokenIs: "Tu nuevo token es:",
      tokenCopied: "\xA1Token copiado al portapapeles!",
      tokenStoreWarning: "C\xF3pialo y gu\xE1rdalo en un lugar seguro. No se volver\xE1 a mostrar cuando cierres esta ventana.",
      confirmRegenerate: "\xBFSeguro que quieres generar un nuevo token?<br/> El actual <bold>quedar\xE1 invalidado</bold>.",
      firstTokenWarning: "<bold>\xA1Importante!</bold> Cuando generes un token, se mostrar\xE1 aqu\xED.<br/><br/>Debes <bold>copiarlo</bold> y guardarlo en un lugar seguro. Si lo pierdes, tendr\xE1s que generar uno nuevo y el anterior <bold>quedar\xE1 invalidado</bold>.",
      generateModalTitle: "Generar nuevo token de API",
      close: "Cerrar",
      cancel: "Cancelar"
    }
  },
  portalShell: {
    logoAlt: "Logo de Dash",
    home: "Inicio",
    showMore: "Ver m\xE1s",
    showLess: "Ver menos",
    customRoomsPlaceholder: "Estudio, garaje, etc...",
    intSqft: "SQFT int.:",
    extSqft: "SQFT ext.:",
    totalSqft: "SQFT total:"
  },
  landingPages: {
    upgradeNow: "Mejorar ahora",
    portfolio: {
      heroTitle: "P\xE1sate a PRO: la forma m\xE1s inteligente de vender obra nueva",
      heroSubtitle: "Muestra. Comparte. Cierra.",
      heroDescription: "Con DASH Pro tienes todo para promocionar y vender los desarrollos nuevos m\xE1s buscados de Florida con facilidad y confianza, en 3 sencillos pasos:",
      step1Title: "Crea portafolios de propiedades a tu medida",
      step1Feature1: "Agrega propiedades de cualquier mercado de Florida",
      step1Feature2: "Sin l\xEDmites, con acceso total",
      step1Feature3: "Comparte presentaciones profesionales en minutos",
      step2Title: "Agrega materiales de venta sin marca",
      step2Feature1: "Descarga planos, folletos y contenido de las desarrolladoras",
      step2Feature2: "Todo el contenido sin marca y listo para compartir",
      step2Feature3: "Agrega archivos y env\xEDa presentaciones a tus clientes f\xE1cilmente",
      step3Title: "Comparte tus enlaces con tu marca de agente",
      step3Feature1: "Reemplaza la marca de la desarrolladora por tus datos de contacto",
      step3Feature2: "Actualizaciones de datos e informaci\xF3n de propiedades en tiempo real, sin esfuerzo",
      step3Feature3: "Captura leads f\xE1cilmente desde cada enlace que compartas",
      ctaTitle: "Mejora a PRO ahora por solo $25/mes",
      ctaSubtitle: "Incluye todo lo del plan BASIC, m\xE1s acceso completo a las descargas y a las herramientas de portafolio para agentes.",
      ctaDescription: "Comparte tus portafolios con tus clientes"
    },
    exchange: {
      heroTitle: "Muestra obra nueva en tu sitio web sin esfuerzo",
      heroDescription: "Los feeds de eXchange de DASH ofrecen listados personalizables y en tiempo real que te ayudan a impresionar a tus prospectos y a cerrar m\xE1s ventas de desarrollos nuevos.",
      feature1Title: "Muestra desarrollos nuevos en tu sitio web",
      feature1Item1: "Acceso total a los datos verificados de obra nueva y preventa de DASH",
      feature1Item2: "Varios tipos de feed: b\xFAsqueda, portafolios y propiedades individuales",
      feature1Item3: "Colores y estilos personalizables",
      feature2Title: "Captaci\xF3n de leads personalizada",
      feature2Item1: "Reemplaza la marca de ventas del desarrollo por la tuya",
      feature2Item2: "Genera leads con formularios de contacto seguros",
      feature2Item3: "Optimizado para celulares y listo para convertir",
      feature3Title: "Integraci\xF3n sencilla con tu sitio web",
      feature3Item1: "Inserta los feeds iframe de eXchange en cualquier parte de tu sitio web",
      feature3Item2: "Actualizaciones en tiempo real, sin mantenimiento manual",
      feature3Item3: "Compatible con las principales plataformas web",
      ctaTitle: "Mejora a DASH Exchange ahora por solo $60/mes",
      ctaSubtitle: "Incluye todo lo del plan PRO, m\xE1s acceso completo a las herramientas de feeds para sitios web de agentes.",
      demoLink: "Mira c\xF3mo usan eXchange los mejores agentes"
    }
  },
  sharePropertyPage: {
    contactMe: "Cont\xE1ctame",
    messageSent: "Tu mensaje fue enviado y el agente te contactar\xE1 pronto.",
    brokerImageAlt: "Imagen del agente"
  },
  locationPortfolio: {
    updated: "Ubicaciones actualizadas.",
    editLocations: "Editar ubicaciones",
    editModalBody: "Las propiedades de estas ubicaciones se agregan al portafolio autom\xE1ticamente y se quitan cuando salen del mercado o dejan de estar publicadas.",
    followedLocations: "Ubicaciones seguidas",
    followsLocations: "Sigue ubicaciones",
    panelBody: "Las propiedades de estas ubicaciones se agregan y se quitan autom\xE1ticamente a medida que cambian las publicaciones.",
    sourceQuestion: "\xBFC\xF3mo quieres armarlo?",
    sourceManualTitle: "Elegir propiedades t\xFA mismo",
    sourceManualBody: "Agrega propiedades una por una desde la b\xFAsqueda, las alertas o cualquier p\xE1gina de propiedad.",
    sourceLocationsTitle: "Seguir ubicaciones",
    sourceLocationsBody: "Elige condados, ciudades o zonas de mercado. Las propiedades se agregan y se quitan autom\xE1ticamente a medida que cambian las publicaciones."
  },
  locationPicker: {
    label: "Ubicaciones",
    loading: "Cargando ubicaciones...",
    searchPlaceholder: "Buscar condados, ciudades y zonas de mercado",
    includedIn: "Incluida en {{places}}",
    remove: "Quitar {{name}}",
    counting: "Contando propiedades...",
    matchCount_one: "Tu selecci\xF3n incluye {{count}} propiedad.",
    matchCount_other: "Tu selecci\xF3n incluye {{count}} propiedades."
  },
  propertiesSearch: { selectedMarketArea: "Zona de mercado seleccionada" },
  idxEmbedded: {
    viewMode: "Vista:",
    gridView: "Cuadr\xEDcula",
    emptyArea: "A\xFAn no hay propiedades disponibles en esta zona.",
    emptyFeed: "{{name}} a\xFAn no ha agregado propiedades a este feed.",
    loadingProperties: "Cargando propiedades...",
    priceFrom: "Desde",
    completionIn: "Entrega en {{year}}.",
    completedIn: "Entregado en {{year}}",
    estCompletionIn: ", entrega est. en {{year}}",
    poweredBy: "Con tecnolog\xEDa de",
    searchPlaceholder: "Nombre del proyecto, ciudad, direcci\xF3n, desarrolladora...",
    resetMapBoundaries: "Restablecer l\xEDmites del mapa",
    showingProperties_one: "Mostrando {{from}} - {{to}} de {{total}} propiedad",
    showingProperties_other: "Mostrando {{from}} - {{to}} de {{total}} propiedades",
    propertiesFound_one: "{{count}} propiedad encontrada",
    propertiesFound_other: "{{count}} propiedades encontradas",
    noResults: "No se encontraron propiedades. \xA1Cambia tus filtros e int\xE9ntalo de nuevo!",
    inventorySection: "Secci\xF3n de inventario",
    model: "Modelo",
    loadingUnits: "Cargando unidades...",
    contactForAvailability: "Cont\xE1ctame para ver disponibilidad",
    pricedFrom: "Desde:",
    addlRooms: "Hab. adicionales:",
    totalSqft: "SQFT TOTAL:",
    showingRange: "Mostrando {{from}} - {{to}} de {{total}}",
    numberOfStories: "N\xFAmero de pisos",
    interiorDesign: "Dise\xF1o interior"
  },
  exchangeFeedPage: {
    updated: "\xA1El feed de Exchange se actualiz\xF3 correctamente!",
    updateError: "Error al actualizar el feed de Exchange.",
    upgradeTitle: "\xA1Accede a los feeds de Exchange con el plan DASH Exchange!",
    manageSubscription: "Administra tu suscripci\xF3n",
    previewNotice: "La vista previa muestra lo que est\xE1 activo en tu sitio web. Guarda para publicar tus cambios.",
    breadcrumb: "Detalles del feed",
    title: "Detalles del feed",
    feedNameLabel: "Nombre del feed*",
    feedNamePlaceholder: "Nombre del feed",
    feedTypeLabel: "Tipo de feed*",
    feedTypePlaceholder: "Tipo de feed",
    typePortfolio: "Portafolio",
    typeSingleProperty: "Una propiedad",
    typeSearchBar: "Barra de b\xFAsqueda",
    typeLocation: "Ubicaci\xF3n",
    propertyLabel: "Propiedad",
    propertyPlaceholder: "Busca y selecciona una propiedad",
    propertySearchHint: "Escribe al menos 3 caracteres para ver resultados",
    portfolioLabel: "Portafolio",
    portfolioPlaceholder: "Busca y selecciona uno de tus portafolios",
    layoutLabel: "Dise\xF1o*",
    layoutGrid: "Cuadr\xEDcula por defecto",
    layoutMap: "Mapa por defecto",
    propertiesPerPage: "Propiedades por p\xE1gina",
    propertiesPerPageTitle: "Propiedades por p\xE1gina",
    contentLabel: "Contenido*",
    contentSearchBarOnly: "Solo barra de b\xFAsqueda",
    contentListGrid: "Barra de b\xFAsqueda con lista (cuadr\xEDcula por defecto)",
    contentListMap: "Barra de b\xFAsqueda con lista (mapa por defecto)",
    locationsLabel: "Ubicaciones*",
    embedStandard: "Est\xE1ndar",
    embedScrollbarFree: "Sin barra de desplazamiento",
    embedFixedDescription: "La m\xE1s f\xE1cil de configurar. El iframe tiene una altura fija y el contenido se desplaza dentro de \xE9l.",
    embedDynamicDescription: "El iframe ajusta su altura al contenido y elimina la barra de desplazamiento interna.",
    resizeHint: "Arrastra la esquina inferior derecha para cambiar el tama\xF1o de la vista previa.",
    scriptHint: "Esta opci\xF3n incluye un peque\xF1o script que debe ejecutarse en tu p\xE1gina.",
    codeTitle: "C\xF3digo",
    codeIntro: "Copia y pega este fragmento de c\xF3digo en tu sitio web. <bold>Evita editarlo, ya que podr\xEDa dejar de funcionar correctamente.</bold>",
    navbarFixedHint: "Si tu sitio tiene una barra de navegaci\xF3n fija, ajusta el valor <mono>height: calc(100vh - 0px)</mono> a la altura de esa barra (p. ej., <mono2>height: calc(100vh - 60px)</mono2>).",
    navbarDynamicHint: "Si tu sitio tiene una barra de navegaci\xF3n fija, ajusta los valores <mono>scroll-margin-top</mono> y <mono2>dashIdxNavbarHeight</mono2> a la altura de esa barra.",
    codeCopied: "\xA1C\xF3digo copiado!",
    copyCode: "Copiar c\xF3digo",
    guideTitle: "Aprende a usar DASH eXchange",
    guideBody: "Consulta la <link>gu\xEDa de inicio r\xE1pido de DASH eXchange</link> para crear y administrar tus feeds de DASH.",
    helpBody: "\xBFNecesitas ayuda? <link>Contacta a soporte</link> para configurar DASH eXchange en tu sitio web.",
    chartTitle: "Propiedades con clics entre el {{start}} y el {{end}}",
    missingEmbedPortfolio: "Selecciona un portafolio y guarda para generar tu c\xF3digo para insertar.",
    missingEmbedProperty: "Selecciona una propiedad y guarda para generar tu c\xF3digo para insertar.",
    missingEmbedLocation: "Selecciona al menos una ubicaci\xF3n y guarda para generar tu c\xF3digo para insertar.",
    missingEmbedSearchBar: "Guarda para generar tu c\xF3digo para insertar.",
    errors: {
      nameRequired: "El nombre es obligatorio.",
      searchBarContentRequired: "El contenido de la barra de b\xFAsqueda es obligatorio.",
      propertyRequired: "La propiedad es obligatoria.",
      portfolioRequired: "El portafolio es obligatorio.",
      locationRequired: "Selecciona al menos un condado, ciudad o zona de mercado.",
      pageLengthRequired: "La cantidad por p\xE1gina es obligatoria.",
      layoutRequired: "El contenido de visualizaci\xF3n del portafolio es obligatorio.",
      salesMaterialsSearchBar: "Los materiales de venta no est\xE1n disponibles para el tipo de feed Barra de b\xFAsqueda.",
      customSalesSingleProperty: "Los materiales de venta personalizados no est\xE1n disponibles para el tipo de feed Una propiedad.",
      customSalesLocation: "Los materiales de venta personalizados no est\xE1n disponibles para el tipo de feed Ubicaci\xF3n.",
      customSalesRequireSales: 'Los materiales de venta personalizados requieren que "Mostrar materiales de venta" est\xE9 activo.'
    }
  },
  exchangePage: {
    settingsCreated: "La configuraci\xF3n de IDX se cre\xF3 correctamente.",
    settingsUpdated: "La configuraci\xF3n de IDX se actualiz\xF3 correctamente.",
    feedCreated: "El feed de IDX se cre\xF3 correctamente.",
    feedDeleted: "El feed de IDX se elimin\xF3 correctamente.",
    searchPlaceholder: "Buscar feed por nombre",
    sortNameAsc: "Nombre (A-Z)",
    sortNameDesc: "Nombre (Z-A)",
    sortNewest: "M\xE1s recientes primero",
    sortOldest: "M\xE1s antiguos primero",
    addNew: "Agregar nuevo",
    missingSettingsAlert: "Para empezar a crear feeds de eXchange, abre la pesta\xF1a de configuraci\xF3n y define tu nombre de dominio.",
    loadError: "Error al cargar los feeds de Exchange.",
    noResults: "No se encontraron resultados.",
    feedsCount_one: "{{count}} feed de Exchange",
    feedsCount_other: "{{count}} feeds de Exchange",
    typePortfolio: "Portafolio",
    typeProperty: "Propiedad",
    typeSearchBar: "Barra de b\xFAsqueda",
    typeLocation: "Ubicaci\xF3n",
    showingFeeds: "Mostrando {{from}} - {{to}} de {{total}} feeds"
  },
  maintenancePage: {
    logoAlt: "Logo de Dash",
    title: "\xA1Estamos haciendo cambios!",
    apology: "\xA1Disculpa las molestias!",
    updating: "Estamos actualizando nuestros servidores para mejorar el servicio.",
    tryLater: "Int\xE9ntalo de nuevo m\xE1s tarde."
  },
  confirmSsoNameModal: {
    title: "Confirma tu nombre",
    subtitle: "As\xED aparecer\xE1s ante tus clientes.",
    firstName: "Nombre",
    lastName: "Apellido",
    continue: "Continuar"
  },
  chunkErrorBoundary: {
    newVersion: "Hay una nueva versi\xF3n de DASH disponible.",
    reload: "Recargar"
  },
  stripeCheckoutResultPage: {
    processing: "Espera mientras configuramos tu suscripci\xF3n",
    takingTooLong: "\xBFEst\xE1 tardando demasiado? <reload>Vuelve a cargar la p\xE1gina</reload> o <support>contacta a Soporte de DASH</support>",
    getApiKeys: "\xA1Obt\xE9n tus claves de API!",
    startBrowsing: "\xA1Empieza a explorar!",
    allSet: "\xA1Todo listo!",
    thankYou: "\xA1Gracias por tu compra, {{name}}!",
    trialEnds: "Tu prueba terminar\xE1 el <highlight>{{date}}</highlight>",
    paymentProcessed: "Tu pago de <highlight>${{amount}}</highlight> se proces\xF3 correctamente.",
    errorTitle: "\xA1Ups, hubo un error al procesar tu suscripci\xF3n!",
    contactSupport: "Contactar a soporte",
    expiredTitle: "\xA1Ups, esta p\xE1gina venci\xF3!",
    goToDashboard: "Ir al panel"
  },
  apiAccessAcceptPage: {
    linkFailed: "No se pudo vincular el acceso a la API.",
    validateFailed: "No se pudo validar la invitaci\xF3n.",
    acceptFailed: "No se pudo aceptar la invitaci\xF3n.",
    title: "Acceso a la API",
    verifying: "Verificando tu invitaci\xF3n\u2026",
    missingToken: "No se encontr\xF3 ning\xFAn token de invitaci\xF3n en el enlace. Usa el enlace del correo de invitaci\xF3n.",
    goToSignIn: "Ir a iniciar sesi\xF3n",
    expired: "Esta invitaci\xF3n venci\xF3. Pide a tu administrador que te env\xEDe una nueva.",
    invalid: "Este enlace de invitaci\xF3n no es v\xE1lido o ya fue utilizado.",
    wrongAccount: "Esta invitaci\xF3n fue emitida para {{invitedEmail}}, pero iniciaste sesi\xF3n como {{currentEmail}}. Cierra sesi\xF3n para continuar acept\xE1ndola.",
    anotherEmail: "otro correo",
    differentUser: "otro usuario",
    signOut: "Cerrar sesi\xF3n",
    accountExists: "Ya existe una cuenta para {{email}}. Inicia sesi\xF3n para vincularle el acceso a la API.",
    signInToContinue: "Inicia sesi\xF3n para continuar",
    invited: "Te invitaron a acceder a la API de DASH. Crea tu cuenta para continuar.",
    invitedWithCompany: "Te invitaron a acceder a la API de DASH para {{company}}. Crea tu cuenta para continuar.",
    passwordPlaceholder: "Ingresa tu contrase\xF1a",
    passwordHint: "Al menos 6 caracteres, con una may\xFAscula, una min\xFAscula, un n\xFAmero y un s\xEDmbolo.",
    accepting: "Aceptando\u2026",
    acceptButton: "Aceptar invitaci\xF3n",
    genericError: "Algo sali\xF3 mal. Int\xE9ntalo de nuevo."
  },
  ssoSignUpPage: {
    licenseAlreadyExists: "El n\xFAmero de licencia ya existe.",
    welcome: "\xA1Bienvenido!",
    welcomeName: "\xA1Bienvenido, {{name}}!",
    authenticated: "Te autenticaste correctamente con {{provider}}. Completa tu perfil antes de continuar.",
    useNormalSignUp: "\xBFQuieres usar otro correo? <link>Usa el registro normal</link>.",
    finishSignUp: "Finalizar registro"
  },
  signUpV2Page: {
    emailAlreadyRegistered: "El correo ya est\xE1 registrado.",
    licenseAlreadyRegistered: "El n\xFAmero de licencia del agente ya est\xE1 registrado. Contacta a soporte.",
    apiAccessSetupFailed: "No se pudo configurar el acceso a la API: {{message}}",
    areYouAgent: "\xBFEres agente inmobiliario?",
    selectAnswer: "Selecciona una respuesta para continuar con tu registro.",
    yes: "S\xED",
    no: "No",
    notAgent: "\xBFNo eres agente inmobiliario?",
    clickHere: "Haz clic aqu\xED",
    title: "Crea una cuenta de Dash",
    subtitle: "Tu privacidad es importante para nosotros. DASH nunca compartir\xE1 tu informaci\xF3n.",
    signUpMiamiRealtors: "Registrarse con MIAMI REALTORS",
    signUpGoogle: "Registrarse con Google",
    alreadyMember: "\xBFYa eres miembro de DASH? <link>Inicia sesi\xF3n</link>",
    country: "Pa\xEDs",
    selectCountry: "Selecciona tu pa\xEDs",
    selectState: "Selecciona tu estado",
    agentLicenseNumber: "N\xFAmero de licencia de agente",
    agreeTerms: "Acepto los <terms>t\xE9rminos y condiciones</terms> y la <privacy>pol\xEDtica de privacidad</privacy>.",
    createAccount: "Crear cuenta"
  },
  signUpValidation: {
    firstNameRequired: "El nombre es obligatorio.",
    firstNameMin: "El nombre debe tener al menos 2 caracteres.",
    firstNameMax: "El nombre debe tener como m\xE1ximo 20 caracteres.",
    firstNameLetters: "El nombre solo puede contener letras y guion.",
    firstNameHyphen: "El nombre no puede empezar ni terminar con guion.",
    lastNameRequired: "El apellido es obligatorio.",
    lastNameMin: "El apellido debe tener al menos 2 caracteres.",
    lastNameMax: "El apellido debe tener como m\xE1ximo 20 caracteres.",
    lastNameLetters: "El apellido solo puede contener letras y guion.",
    lastNameHyphen: "El apellido no puede empezar ni terminar con guion.",
    emailRequired: "El correo es obligatorio.",
    emailInvalid: "El correo debe ser v\xE1lido.",
    countryRequired: "El pa\xEDs es obligatorio.",
    stateRequired: "El estado es obligatorio.",
    licenseMax: "El n\xFAmero de licencia debe tener como m\xE1ximo 20 caracteres.",
    licenseRequired: "El n\xFAmero de licencia es obligatorio.",
    agreementRequired: "Debes aceptar los t\xE9rminos y condiciones.",
    passwordRequired: "La contrase\xF1a es obligatoria.",
    passwordMin: "La contrase\xF1a debe tener al menos 8 caracteres.",
    passwordMin6: "La contrase\xF1a debe tener al menos 6 caracteres.",
    passwordComplexity: "La contrase\xF1a debe contener al menos 1 may\xFAscula, 1 min\xFAscula, 1 n\xFAmero y un car\xE1cter especial.",
    confirmPasswordRequired: "La confirmaci\xF3n de la contrase\xF1a es obligatoria.",
    confirmPasswordMismatch: "La confirmaci\xF3n de la contrase\xF1a no coincide."
  },
  ssoCallbackPage: {
    redirecting: "Redirigiendo...",
    reloadHint: "Si no te redirigimos en 5 segundos, vuelve a cargar la p\xE1gina."
  },
  codeConfirmationPage: {
    emailResent: "\xA1Correo reenviado!",
    invalidCode: "C\xF3digo no v\xE1lido.",
    invalidOrExpiredCode: "C\xF3digo no v\xE1lido o vencido.",
    title: "Confirma tu correo",
    subtitle: "Ingresa el c\xF3digo de verificaci\xF3n que enviamos a tu correo: {{email}}.",
    codeLabel: "C\xF3digo de confirmaci\xF3n",
    submitButton: "Confirmar c\xF3digo",
    resendHelp: "\xBFNo recibiste el correo?<br />Revisa tu carpeta de spam y <resend>reenv\xEDa el c\xF3digo</resend>.",
    differentAccount: "O <logout>prueba con otra cuenta</logout>"
  },
  authCommon: { logoAlt: "Logo de Dash", peopleAlt: "Personas en Dash" },
  v2Components: {
    agentContact: {
      messageSent: "Tu mensaje fue enviado y el agente te contactar\xE1 pronto.",
      brokerImageAlt: "Imagen del agente",
      logoAlt: "Logo de Dash",
      visitWebsite: "Visitar sitio web",
      contactMe: "Cont\xE1ctame",
      contactMeTitle: "Cont\xE1ctame"
    },
    brokerModal: {
      contactMe: "Cont\xE1ctame",
      loadingProperties: "Cargando propiedades...",
      propertyPortfolio: "Portafolio de propiedades ({{total}})",
      loadMore: "Cargar m\xE1s"
    },
    subscriptionCard: {
      newBadge: "NUEVO",
      saveTenPercent: "\xA1Ahorra 10%!",
      currentPlanBadge: "Plan actual",
      cancelsOn: "Se cancela el {{date}}",
      trialEnds: "La prueba termina el {{date}}",
      getPlan: "Obtener {{name}}",
      trialBadge: "Prueba de {{days}} d\xEDas",
      yourCurrentPlan: "Tu plan actual",
      cancelTrial: "Cancelar prueba",
      manageOrCancel: "Administrar o cancelar suscripci\xF3n"
    },
    idxContactForm: {
      fillRequiredFields: "Completa todos los campos obligatorios antes de enviar el mensaje.",
      avatarAlt: "Imagen de avatar",
      contactMe: "CONT\xC1CTAME"
    },
    idxProperty: {
      developerVerified: "Desarrolladora verificada",
      completionIn: "Entrega en {{year}}."
    },
    idxSettings: {
      title: "Configuraci\xF3n de Exchange",
      websiteDomain: "Dominio del sitio web",
      websiteDomainRequired: "El dominio del sitio web es obligatorio.",
      invalidUrl: "La URL debe comenzar con http:// o https:// y ser v\xE1lida.",
      websiteDomainHelp: "Ingresa la URL del sitio web que mostrar\xE1 el feed de Exchange.",
      wixDomainWarning: "Esta URL contiene <code>.filesusr.com</code>, que es propio de los sitios de Wix. Si ya no usas Wix, actualiza la URL al dominio real de tu sitio.",
      wixFormatNote: "Al guardar, tu URL se transformar\xE1 al formato de iframe de Wix (p. ej., <code>www-yoursite-com.filesusr.com</code>).",
      wixSite: "Sitio de Wix",
      wixSiteHelp: "Marca esta opci\xF3n si tu sitio fue creado con <link>Wix</link> para que podamos darle el formato correcto a la direcci\xF3n.",
      brandingColors: "Colores de marca",
      mainColor: "Color principal",
      textColor: "Color del texto",
      backgroundColor: "Color de fondo",
      chooseColor: "Elige un color",
      transparent: "Transparente",
      resetColors: "Restablecer colores"
    },
    deleteFeed: {
      title: "\xBFConfirmar eliminaci\xF3n?",
      question: "\xBFSeguro que quieres eliminar el feed {{name}}?",
      warning: "Ten en cuenta que esta acci\xF3n no se puede deshacer."
    },
    newFeed: {
      title: "Nuevo feed de Exchange",
      name: "Nombre",
      namePlaceholder: "Ingresa un nombre",
      nameRequired: "El nombre es obligatorio.",
      type: "Tipo",
      typeRequired: "El tipo es obligatorio.",
      selectType: "Selecciona un tipo",
      typeSingleProperty: "Una propiedad",
      typePortfolio: "Portafolio",
      typeSearchBar: "Barra de b\xFAsqueda",
      typeLocation: "Ubicaci\xF3n"
    },
    searchBar: {
      filters: "Filtros",
      filtersSubtitle: "Filtra las propiedades seg\xFAn tus preferencias",
      type: "Tipo",
      status: "Estado",
      marketArea: "Zona de mercado",
      marketAreas: "Zonas de mercado",
      buildingType: "Tipo de edificio",
      selectType: "Selecciona un tipo",
      selectStatus: "Selecciona un estado",
      selectTransaction: "Selecciona una transacci\xF3n",
      selectTag: "Selecciona una etiqueta",
      selectMarketAreas: "Selecciona zonas de mercado",
      filterAreasPlaceholder: "Escribe para filtrar zonas",
      noMarketAreas: "No se encontraron zonas de mercado.",
      minPrice: "Precio m\xEDn.",
      maxPrice: "Precio m\xE1x.",
      selectOptions: "Selecciona opciones...",
      searchPlaceholder: "Buscar...",
      noOptionsFound: "No se encontraron opciones.",
      seeMore: "Ver m\xE1s"
    }
  }
};
var pages_default2 = pages;

// src/assets/dictionary/es/tables.ts
var tables = {
  organizations: {
    addNewButtonLabel: "Agregar organizaci\xF3n",
    searchInputPlaceholder: "Buscar organizaciones",
    organizationNameLabel: "Nombre de la organizaci\xF3n",
    totalPropertiesLabel: "Total de propiedades:",
    addedOnLabel: "Agregada el:",
    placeholder: "No hay propiedades asignadas a esta organizaci\xF3n",
    paginationLabel: "Mostrando {{page}} de {{total}} organizaciones",
    thereAreNoOrganizations: "No hay organizaciones"
  },
  marketAreas: {
    addNewMarket: "Agregar mercado",
    paginationLabel: "Mostrando {{page}} de {{total}} zonas de mercado",
    search: "Buscar",
    placeholder: "No hay zonas de mercado"
  },
  amenities: {
    addNewAmenity: "Agregar amenidad",
    noAmenities: "A\xFAn no se han creado amenidades",
    searchAmenities: "Buscar amenidades",
    paginationLabel: "Mostrando {{page}} de {{total}} amenidades"
  },
  organizationSaleTeams: {
    addNewButtonLabel: "Agregar equipo de ventas",
    searchInputPlaceholder: "Buscar equipo de ventas",
    placeholder: "No hay equipos de ventas asignados a esta organizaci\xF3n",
    paginationLabel: "Mostrando {{page}} de {{total}} equipos de ventas"
  },
  organizationUsers: {
    addNewButtonLabel: "Invitar usuario",
    searchInputPlaceholder: "Buscar usuarios",
    placeholder: "No hay usuarios asignados a esta organizaci\xF3n",
    paginationLabel: "Mostrando {{page}} de {{total}} usuarios",
    sendInvitation: "Enviar invitaci\xF3n",
    resendInvitation: "Reenviar invitaci\xF3n"
  },
  organizationProperties: {
    placeholder: "No hay propiedades asignadas a esta organizaci\xF3n",
    placeholderSearch: "Tu b\xFAsqueda no arroj\xF3 resultados."
  },
  properties: {
    nameLabel: "Nombre de la propiedad",
    updatedAtLabel: "\xDAltima actualizaci\xF3n",
    addNewButtonLabel: "Agregar propiedad",
    searchInputPlaceholder: "Buscar propiedades",
    placeholder: "No hay propiedades.",
    placeholderSearch: "Tu b\xFAsqueda no arroj\xF3 resultados.",
    paginationLabel: "Mostrando {{page}} de {{total}} propiedades",
    statusSelectPlaceholder: "Visibilidad",
    cmsStatusSelectPlaceholder: "Estado en CMS",
    transactionTypeSelectPlaceholder: "Venta/Renta",
    organizationSelectPlaceholder: "Todas las organizaciones",
    updatePaginationLabel: "Mostrando {{page}} de {{total}}",
    marketAreaSelectPlaceholder: "Zona de mercado",
    buildingTypeSelectPlaceholder: "Tipo de propiedad",
    tagsSelectPlaceholder: "Etiquetas",
    projectStatusSelectPlaceholder: "Estado de la propiedad"
  },
  inventory: {
    addNewButtonLabel: "Agregar inventario",
    searchInputPlaceholder: "Buscar inventario",
    placeholder: "No hay inventario asociado a esta propiedad",
    paginationLabel: "Mostrando {{page}} de {{total}} planos",
    name: "Nombre",
    quantity: "Cantidad",
    quantityShort: "CANT.",
    bedrooms: "Hab.",
    bathrooms: "Ba\xF1os",
    breakdownSqft: "Desglose de SQFT",
    totalSqft: "SQFT TOTALES",
    interiorSqft: "SQFT int.",
    exteriorSqft: "SQFT ext.",
    inventoryType: "Tipo",
    priceRange: "Rango de precio",
    floorplan: "Plano",
    viewFloorPlan: "Ver plano",
    customRooms: "Habitaciones adicionales",
    customRoomsShortened: "Hab. adic.",
    lastListedFrom: "\xDAltimo precio desde",
    lastListedFromShortened: "Desde",
    units: "Unidades",
    recent: "Recientes",
    priceDown: "Precio (de mayor a menor)",
    priceUp: "Precio (de menor a mayor)"
  },
  marketingFiles: {
    categoryPlaceholder: "Todas las categor\xEDas",
    fileTypePlaceholder: "Todos los tipos de archivo",
    totalCountLabel: "{{totalCount}} materiales de venta",
    paginationLabel: "Mostrando {{page}} de {{total}}",
    filesSelectedLabel: "{{totalCount}} archivos seleccionados",
    downloadAllLabel: "Descargar todo",
    downloadSelectedLabel: "Descargar selecci\xF3n",
    searchInputPlaceholder: "Buscar",
    placeholder: "Por ahora no hay archivos multimedia disponibles para esta propiedad"
  },
  transactionHistory: {
    invoiceName: "Nombre de la factura",
    dateOfCharge: "Fecha del cobro",
    status: "Estado",
    amount: "Monto",
    statuses: {
      draft: "Borrador",
      open: "Abierta",
      paid: "Exitoso",
      uncollectible: "Incobrable",
      void: "Anulada"
    }
  },
  brokers: {
    searchBrokers: "Buscar agentes",
    fullName: "Nombre completo",
    email: "Email",
    phoneNumber: "N\xFAmero de tel\xE9fono",
    userStatus: "Estado del usuario",
    subscriptionPlan: "Plan susc.",
    createdAt: "Fecha de creaci\xF3n",
    subStatus: "Estado susc.",
    placeholder: "No hay agentes",
    viewAction: "Ver / Editar",
    unblockAction: "Desbloquear",
    blockAction: "Bloquear",
    delete: "Eliminar",
    paginationLabel: "Mostrando {{page}} de {{total}} agentes",
    userAccountStatus: "Estado de la cuenta de usuario"
  },
  cmsUsers: {
    unarchive: "Desarchivar",
    archive: "Archivar",
    edit: "Editar",
    delete: "Eliminar"
  },
  apiInvitations: {
    status: "Estado",
    expiresAt: "Fecha de vencimiento",
    createdAt: "Fecha de creaci\xF3n",
    revoke: "Revocar",
    statuses: {
      pending: "Pendiente",
      accepted: "Aceptada",
      fulfilled: "Completada",
      expired: "Vencida",
      revoked: "Revocada"
    }
  },
  reactions: {
    nameOrId: "Nombre o ID",
    email: "Email",
    properties: "Propiedades",
    reactions: "Reacciones"
  },
  propertyNote: {
    placeholder: "Esta propiedad no tiene notas",
    paginationLabel: "Mostrando {{page}} de {{total}}"
  },
  externalSales: {
    placeholder: "No hay equipo de ventas externo",
    paginationLabel: "Mostrando {{page}} de {{total}} ventas externas"
  },
  propertyComparison: {
    bedrooms: "Rango de hab.",
    bathrooms: "Rango de ba\xF1os",
    status: "Estado de la propiedad",
    availableUnits: "Total de unidades"
  },
  featuredPortfolios: {
    nameLabel: "Nombre del portafolio",
    updatedAtLabel: "\xDAltima actualizaci\xF3n",
    createdAtLabel: "Creado el",
    visibilityLabel: "Visibilidad",
    propertiesCountLabel: "Propiedades",
    actionsLabel: "Acciones",
    placeholder: "No hay portafolios destacados.",
    placeholderSearch: "Tu b\xFAsqueda no arroj\xF3 resultados.",
    paginationLabel: "Mostrando {{page}} de {{total}} portafolios",
    searchInputPlaceholder: "Buscar portafolios",
    addNewButtonLabel: "Crear portafolio",
    sortButtonLabel: "Ordenar",
    sortPublicDisplay: "Ordenar vista p\xFAblica"
  },
  featuredProperties: {
    nameLabel: "T\xEDtulo",
    updatedAtLabel: "\xDAltima actualizaci\xF3n",
    createdAtLabel: "Creado el",
    visibilityLabel: "Visibilidad",
    placeholder: "No hay propiedades destacadas.",
    placeholderSearch: "Tu b\xFAsqueda no arroj\xF3 resultados.",
    paginationLabel: "Mostrando {{page}} de {{total}} propiedades",
    searchInputPlaceholder: "Buscar propiedades",
    addNewButtonLabel: "Crear propiedad",
    sortPublicDisplay: "Ordenar vista p\xFAblica"
  }
};
var tables_default2 = tables;

// src/assets/dictionary/pt/common.ts
var import_dash_common5 = require("dash-common");
var import_lodash5 = require("lodash");
var common2 = {
  labels: {
    signOut: "Sair",
    account: "Conta",
    apiUsers: "Usu\xE1rios da API",
    apiManagement: "API",
    settings: "Configura\xE7\xF5es",
    properties: "Im\xF3veis",
    propertyDetails: "Detalhes do im\xF3vel",
    propertyPreview: "Vis\xE3o geral do im\xF3vel",
    propertyOverview: "Vis\xE3o geral do im\xF3vel",
    folderDetails: "Detalhes da pasta",
    rootMediaFolder: "Pasta raiz de m\xEDdia",
    users: "Usu\xE1rios",
    salesTeam: "Equipe de vendas",
    internalSaleTeam: "Equipe de vendas interna",
    organizations: "Organiza\xE7\xF5es",
    organization: "Organiza\xE7\xE3o",
    organizationDetails: "Detalhes da organiza\xE7\xE3o",
    featuresAndAmenities: "Caracter\xEDsticas e comodidades",
    projectStatus: "Status do empreendimento",
    salesGalleryStatus: "Status do stand de vendas",
    amenities: "Comodidades",
    brokers: "Corretores",
    cardDescription: "Descri\xE7\xE3o do card",
    seekers: "Usu\xE1rios diretos",
    contact: "Contato",
    contactAgent: "Contatar corretor",
    testAccount: "Conta de teste",
    management: "Gest\xE3o",
    marketAreas: "Regi\xF5es de mercado",
    externalSales: "Vendas externas",
    exploreNewProperties: "Explorar novos im\xF3veis",
    featuredProperties: "Im\xF3veis em destaque",
    newListings: "Novos an\xFAncios",
    newListingsSubtitle: "Os perfis de empreendimentos mais recentes adicionados \xE0 DASH nos \xFAltimos 30 dias.",
    trendingThisWeek: "Im\xF3veis em alta",
    trendingThisWeekSubtitle: "Os empreendimentos mais visualizados na DASH, atualizados semanalmente.",
    similarProperties: "Mais como este",
    similarPropertiesSubtitle: "Im\xF3veis semelhantes que podem te interessar.",
    recommendedForYou: "Recomendados para voc\xEA",
    recommendedForYouSubtitle: "Com base em outros im\xF3veis que voc\xEA visualizou.",
    exploreOnMap: "Explorar no mapa",
    exploreOnMapSubtitle: "Navegue pelos im\xF3veis em toda a Fl\xF3rida \u2014 clique em qualquer pin para abrir o an\xFAncio.",
    exploreOnMapSplitSubtitle: "Navegue pelo mapa e pelos an\xFAncios correspondentes lado a lado.",
    exploreOnMapExpandableSubtitle: "Abra um mapa interativo dos im\xF3veis dispon\xEDveis quando quiser.",
    exploreOnMapCta: "Mostrar o mapa",
    launchingSoon: "Lan\xE7amento em breve",
    launchingSoonSubtitle: "Empreendimentos aprovados na planta com an\xFAncio de vendas previsto para breve.",
    ultraLuxuryResidences: "Resid\xEAncias de ultraluxo",
    ultraLuxuryResidencesSubtitle: "Novas resid\xEAncias premium a partir de $4M nos mercados mais ativos da Fl\xF3rida.",
    luxuryResidences: "Resid\xEAncias de luxo",
    luxuryResidencesSubtitle: "Novas resid\xEAncias premium a partir de $1M nos mercados mais ativos da Fl\xF3rida.",
    under1M: "Resid\xEAncias abaixo de $1M",
    under1MSubtitle: "Novas unidades abaixo de $1M nos mercados mais ativos da Fl\xF3rida.",
    newRentalDevelopments: "Novos empreendimentos para loca\xE7\xE3o",
    newRentalDevelopmentsSubtitle: "Explore os empreendimentos de loca\xE7\xE3o mais recentes, na planta e novos, nos mercados mais ativos da Fl\xF3rida.",
    show: "Mostrar",
    previous: "Anterior",
    next: "Pr\xF3ximo",
    add: "Adicionar",
    addVirtualTour: "Adicionar tour virtual",
    skip: "Pular",
    update: "Atualizar",
    address: "Endere\xE7o",
    cancel: "Cancelar",
    confirm: "Confirmar",
    confirmSwitch: "Confirmar troca",
    notFound: "N\xE3o encontrado",
    saveChanges: "Salvar altera\xE7\xF5es",
    save: "Salvar",
    close: "Fechar",
    for: "para",
    clear: "Limpar",
    fullName: "Nome completo",
    uploadCancelled: "Envio cancelado",
    to: "At\xE9",
    edit: "Editar",
    delete: "Excluir",
    view: "Ver",
    actions: "A\xE7\xF5es",
    website: "Site",
    status: "Status de visibilidade",
    propertyStatus: "Status do empreendimento",
    notes: "Observa\xE7\xF5es",
    changelogs: "Hist\xF3rico de altera\xE7\xF5es",
    preview: "Pr\xE9-visualizar",
    name: "Nome",
    phone: "Telefone",
    seeMore: "Ver mais",
    open: "Abrir",
    more: "Mais",
    private: "Privado",
    public: "P\xFAblico",
    hidden: "Oculto",
    draft: "Rascunho",
    media: "M\xEDdia",
    inventory: "Plantas",
    featuredFloorPlans: "Plantas em destaque",
    seeMoreFloorPlans: "Ver mais plantas",
    information: "Informa\xE7\xF5es",
    advanced: "Avan\xE7ado",
    description: "Descri\xE7\xE3o",
    metrics: "M\xE9tricas",
    partners: "Parceiros",
    companies: "Empresas",
    pluginUsers: "Usu\xE1rios do plugin",
    invitations: "Convites",
    apiConsole: "Console da API",
    contentActivity: "Atividade de conte\xFAdo",
    tracking: "Acompanhamento",
    savedProperties: "Im\xF3veis salvos",
    watchlist: "Lista de acompanhamento",
    emptyColumn: "N/D",
    weekDays: {
      monday: "Segunda-feira",
      tuesday: "Ter\xE7a-feira",
      wednesday: "Quarta-feira",
      thursday: "Quinta-feira",
      friday: "Sexta-feira",
      saturday: "S\xE1bado",
      sunday: "Domingo"
    },
    today: "Hoje",
    dateRangePeriods: {
      currentWeek: "Esta semana",
      pastWeek: "Semana passada",
      currentMonth: "Este m\xEAs",
      pastMonth: "M\xEAs passado",
      threeMonth: "Tr\xEAs meses",
      custom: "Per\xEDodo personalizado",
      currentYear: "Este ano"
    },
    dateRangeGroups: {
      hourly: "Por hora",
      daily: "Di\xE1rio",
      weekly: "Semanal",
      monthly: "Mensal"
    },
    general: "Geral",
    location: "Localiza\xE7\xE3o",
    folder: "Pasta",
    folders: "Pastas: ({{number}})",
    file: "Arquivo",
    files: "Arquivos: ({{number}})",
    kBytes: "{{size}} KB",
    mBytes: "{{size}} MB",
    noOptions: "Sem op\xE7\xF5es",
    loading: "Carregando...",
    from: "De",
    highlights: "Destaques",
    agentHighlights: "Destaques do corretor",
    agentHighlightsNotes: "Observa\xE7\xF5es dos destaques do corretor",
    upgradeToView: "Fa\xE7a upgrade para ver",
    about: "Sobre",
    archive: "Arquivar",
    unarchive: "Desarquivar",
    rename: "Renomear",
    move: "Mover",
    cvv: "CVV",
    creditCardNumber: "N\xFAmero do cart\xE3o de cr\xE9dito",
    expiryDate: "Validade",
    fileName: "Nome do arquivo",
    category: "Categoria",
    size: "Tamanho",
    added: "Adicionado",
    download: "Baixar",
    dashboard: "Painel",
    menu: "Menu",
    portfolios: "Portf\xF3lios",
    portfolioDetails: "Detalhes do portf\xF3lio",
    messages: "Mensagens",
    resend: "Reenviar",
    resendViaEmail: "Reenviar por e-mail",
    email: "E-mail",
    showMore: "Mostrar mais",
    readMore: "Ler mais",
    showLess: "Mostrar menos",
    any: "Qualquer",
    miles: "Milhas",
    subscription: "Assinatura",
    payment: "Pagamento",
    contentCopy: "Duplicar",
    closed: "Fechado",
    create: "Criar",
    share: "Compartilhar",
    compare: "Comparar",
    sortBy: "Ordenar por",
    sortAz: "Ordem alfab\xE9tica A-Z",
    sortZa: "Ordem alfab\xE9tica Z-A",
    sortCreatedAt: "Adicionados/criados mais recentemente",
    filterBy: "Filtrar por",
    selectAll: "Selecionar tudo",
    change: "Alterar",
    state: "Estado",
    updated: "Atualizado",
    changePhoto: "Alterar foto",
    goBack: "Voltar",
    startSevenDayTrial: "Iniciar teste gr\xE1tis de 7 dias",
    cancelAnytime: "Cancele quando quiser",
    date: "Data",
    branded: "Com marca",
    unbranded: "Sem marca",
    shared: "Compartilhado",
    brandingType: "Tipo de marca",
    selectBrandingType: "Selecionar tipo de marca",
    allBrandingTypes: "Todos os tipos de marca",
    all: "Todos",
    sharedFolder: "Pasta compartilhada",
    brandedFilesReady: "Arquivos com marca prontos",
    track: "Acompanhar",
    createAlert: "Criar alerta",
    calculate: "Calcular",
    moreOptions: "Mais op\xE7\xF5es",
    lessOptions: "Menos op\xE7\xF5es",
    remove: "Remover",
    submit: "Enviar",
    sqft: "SqFt",
    beds: "Quartos",
    baths: "Banheiros",
    verified: "Verificado",
    developerVerified: "Verificado pela incorporadora",
    developerVerifiedOn: "Verificado pela incorporadora em {{date}}",
    unverified: "N\xE3o verificado",
    dashLogo: "Logo da Dash",
    comingSoon: "Em breve",
    coming_soon: "Em breve",
    byAppointmentOnly: "Somente com agendamento",
    soldOut: "Esgotado",
    sold_out: "Esgotado",
    leavingSoon: "Saindo em breve",
    leaving_soon: "Saindo em breve",
    leavingSoonBanner: "Condom\xEDnios de casas e townhomes sair\xE3o da DASH neste ver\xE3o.",
    leavingSoonReadMore: "Saiba mais",
    proposed: "Proposto",
    new_construction: "Lan\xE7amento",
    pre_construction: "Na planta",
    single_family_home: "Casa unifamiliar",
    under_construction: "Em constru\xE7\xE3o",
    completed: "Conclu\xEDdo",
    noValue: "N/D",
    notSet: "N\xE3o definido",
    cmsStatus: "Status no CMS",
    // CMS Status values
    not_set: "N\xE3o definido",
    pending_approval: "Aprova\xE7\xE3o pendente",
    new_listing: "Novo an\xFAncio",
    active_listing: "An\xFAncio ativo",
    awaiting_audit: "Aguardando auditoria",
    recently_updated: "Atualizado recentemente",
    recently_reviewed: "Verificado recentemente",
    pending_archive: "Arquivamento pendente",
    archived: "Arquivado",
    // Management tabs
    cmsSettings: "Configura\xE7\xF5es do CMS",
    // CMS Status actions
    approve: "Aprovar",
    audit: "Auditar",
    approveProperty: "Aprovar im\xF3vel",
    auditProperty: "Auditar im\xF3vel",
    archiveProperty: "Arquivar im\xF3vel",
    approvePropertyConfirmation: 'Tem certeza de que deseja aprovar este rascunho? O im\xF3vel ficar\xE1 vis\xEDvel e ser\xE1 atualizado como "Novo an\xFAncio".',
    auditPropertyConfirmation: "Marcar este im\xF3vel como auditado? Isso confirma que as informa\xE7\xF5es foram revisadas e est\xE3o corretas.",
    archivePropertyConfirmation: "Tem certeza de que deseja arquivar este im\xF3vel? Ele ser\xE1 ocultado do p\xFAblico e marcado como arquivado.",
    approving: "Aprovando...",
    auditing: "Auditando...",
    archiving: "Arquivando...",
    propertyApprovedSuccess: "O im\xF3vel foi aprovado com sucesso",
    propertyApprovedError: "Falha ao aprovar o im\xF3vel",
    propertyAuditedSuccess: "O im\xF3vel foi auditado com sucesso",
    propertyAuditedError: "Falha ao auditar o im\xF3vel",
    propertyArchivedSuccess: "O im\xF3vel foi arquivado com sucesso",
    propertyArchivedError: "Falha ao arquivar o im\xF3vel",
    subscriptionNotSelected: "Nenhuma assinatura selecionada",
    billingAddress: "Endere\xE7o de cobran\xE7a",
    send: "Enviar",
    viewEditAction: "Ver / Editar",
    subscriptionBanner: "Voc\xEA precisa ter um <tag>{{subscriptionType}}</tag> para acessar esta p\xE1gina",
    newNote: "Nova observa\xE7\xE3o",
    read: "Ler",
    search: "Buscar",
    reactions: "Rea\xE7\xF5es",
    current: "Atual",
    notBillable: "N\xE3o cobr\xE1vel",
    studio: "Studio",
    dashSuffix: "| DASH",
    dashCMSSuffix: "| DASH CMS",
    dashApiAdminSuffix: "| DASH API Admin",
    notWorking: "N\xE3o funciona",
    notAvailable: "Indispon\xEDvel",
    browserTabTitles: {
      dashboard: "Painel do corretor",
      properties: "Im\xF3veis",
      featuredContent: "Conte\xFAdo em destaque",
      featuredContentProperties: "Im\xF3veis em destaque",
      featuredContentPortfolios: "Portf\xF3lios em destaque",
      portfolios: "Portf\xF3lios",
      unavailablePortfolioPage: "Portf\xF3lio indispon\xEDvel",
      profile: "Perfil",
      tracking: "Im\xF3veis acompanhados",
      watchlist: "Lista de acompanhamento",
      messages: "Mensagens",
      signIn: "Entrar",
      signUp: "Cadastrar-se",
      completeSignUpCodeConfirmation: "Concluir cadastro",
      completeSignUpSSO: "Concluir cadastro com SSO",
      forgotPassword: "Esqueci/perdi a senha",
      completeSignUpPickSubscription: "Escolher assinatura",
      stripeCheckoutResult: "Processar pagamento",
      completeSignUpAddAdditionalInfo: "Adicionar informa\xE7\xF5es adicionais",
      resetPassword: "Redefinir senha",
      termConditions: "Termos e condi\xE7\xF5es",
      privacyPolicy: "Pol\xEDtica de privacidade",
      organizations: "Organiza\xE7\xF5es",
      amenities: "Comodidades",
      brokers: "Corretores",
      seekers: "Usu\xE1rios diretos",
      externalSales: "Vendas externas",
      externalSalesUsers: "Usu\xE1rios de vendas externas",
      management: "Gest\xE3o",
      account: "Conta",
      apiUsers: "Usu\xE1rios da API",
      apiManagement: "API",
      apiDocs: "Documenta\xE7\xE3o da API da DASH",
      apiReleaseNotes: "Novidades da API",
      settings: "Configura\xE7\xF5es",
      marketAreas: "Regi\xF5es de mercado",
      exchange: "Exchange",
      search: "Buscar",
      ssoCallback: "Redirecionando do SSO...",
      featuredPortfolios: "Portf\xF3lios em destaque"
    },
    exchange: "Exchange",
    verifyAccount: "Verificar conta",
    verifyAccountShort: "Verificar",
    apply: "Aplicar",
    processing: "Processando...",
    popular: "Popular",
    applied: "Aplicado",
    closeSearch: "Fechar busca",
    scrollLeft: "Rolar para a esquerda",
    scrollRight: "Rolar para a direita"
  },
  placeholders: {
    cardExpiry: "mm/aa",
    noSearchResults: "Sua busca n\xE3o retornou resultados.",
    searchNoResultsForQuery: 'Nenhum resultado para "{{query}}"',
    firstAndLastName: "Nome e sobrenome",
    selectOption: "Selecionar op\xE7\xE3o",
    selectProjectStatus: "Selecionar status do empreendimento",
    selectBrandingType: "Selecionar tipo de marca",
    globalSearch: "Im\xF3vel, cidade, regi\xE3o de mercado, incorporadora...",
    mobileSearchEmptyMessage: "Busque im\xF3veis, cidades, regi\xF5es de mercado, incorporadoras e mais."
  },
  serverMessages: {
    notFound: "E-mail ou senha incorretos.",
    uploadFail: "Algo deu errado. N\xE3o foi poss\xEDvel enviar.",
    unknown: "Algo deu errado.",
    accountNotFound: "Conta n\xE3o encontrada",
    licenseValidationError: "Erro ao validar a licen\xE7a",
    unauthorized: "Link inv\xE1lido ou expirado. Gere um novo."
  },
  alerts: {
    resetPasswordEmailsSent: "Se houver uma conta, enviaremos um link de redefini\xE7\xE3o de senha para o e-mail informado!",
    passwordReset: "Senha atualizada com sucesso! ",
    changesSaved: "Altera\xE7\xF5es salvas com sucesso!",
    alertWasHidden: "O im\xF3vel foi ocultado",
    alertWasShown: "O im\xF3vel foi reexibido",
    accountIsUpdated: "Conta atualizada",
    invitationHasBeenSent: "Convite enviado!"
  },
  roles: {
    ORG_SALES_DIRECTOR: "Diretor",
    ORG_SALES_ASSOCIATE: "Associado de vendas",
    ORG_DEVELOPER: "Incorporador",
    ORG_OWNER: "Propriet\xE1rio"
  },
  accountStatuses: {
    [import_dash_common5.AccountStatusesEnum.ACTIVE]: "Ativo",
    [import_dash_common5.AccountStatusesEnum.ADDED]: "Adicionado",
    [import_dash_common5.AccountStatusesEnum.ARCHIVED]: "Arquivado",
    [import_dash_common5.AccountStatusesEnum.EXPIRED]: "Expirado",
    [import_dash_common5.AccountStatusesEnum.INVITED]: "Convidado"
  },
  brokerPortalServerErrors: {
    [import_dash_common5.ServerErrors.ACCOUNT_ARCHIVED]: "A conta de usu\xE1rio foi bloqueada. Entre em contato com o suporte da DASH.",
    [import_dash_common5.ServerErrors.BROKER_ACCOUNT_ARCHIVED]: "Sua conta est\xE1 bloqueada. {{reason}}. Entre em contato com o suporte da DASH.",
    [import_dash_common5.ServerErrors.WRONG_VERIFICATION_CODE]: "C\xF3digo de verifica\xE7\xE3o incorreto",
    [import_dash_common5.ServerErrors.LICENSE_ALREADY_EXISTS]: "A licen\xE7a j\xE1 est\xE1 associada a uma conta DASH.",
    [import_dash_common5.ServerErrors.PORTFOLIO_CONTAIN_FOLDER]: "Este im\xF3vel j\xE1 foi adicionado ao portf\xF3lio",
    [import_dash_common5.ServerErrors.INCORRECT_PASSWORD]: "Senha incorreta",
    [import_dash_common5.ServerErrors.PHONE_NUMBER_IS_USED]: "O telefone j\xE1 est\xE1 associado a uma conta DASH. Se voc\xEA \xE9 o dono do n\xFAmero, entre em contato com o suporte da DASH.",
    [import_dash_common5.ServerErrors.MAX_CUSTOMER_CARD_PAYMENT_METHODS]: "Voc\xEA atingiu o limite de formas de pagamento permitidas.",
    [import_dash_common5.ServerErrors.PAYMENT_METHOD_NEEDED]: "\xC9 necess\xE1ria uma forma de pagamento.",
    [import_dash_common5.ServerErrors.UNAVAILABLE_FOR_BROKERS]: "O im\xF3vel n\xE3o est\xE1 dispon\xEDvel para corretores.",
    [import_dash_common5.ServerErrors.INCORRECT_ACCOUNT_CREDENTIALS]: "E-mail ou senha incorretos."
  },
  serverErrors: {
    [import_dash_common5.ServerErrors.PORTFOLIO_IS_EMPTY]: "O portf\xF3lio est\xE1 vazio",
    [import_dash_common5.ServerErrors.PORTFOLIO_IS_PRIVATE]: "O portf\xF3lio \xE9 privado",
    [import_dash_common5.ServerErrors.PROPERTY_IS_PRIVATE]: "O im\xF3vel \xE9 privado",
    [import_dash_common5.ServerErrors.PORTFOLIO_NOT_EXISTS]: "O portf\xF3lio n\xE3o existe",
    [import_dash_common5.ServerErrors.ACCOUNT_EMAIL_ALREADY_EXIST]: "J\xE1 existe uma conta DASH com este e-mail. Entre em contato com o suporte da DASH se precisar redefinir sua senha.",
    [import_dash_common5.ServerErrors.ACCOUNT_ARCHIVED]: "Existe uma conta arquivada com este e-mail. Desarquive a conta para enviar um convite.",
    [import_dash_common5.ServerErrors.ACCOUNT_NOT_FOUND]: "Conta n\xE3o encontrada",
    [import_dash_common5.ServerErrors.INCORRECT_ACCOUNT_CREDENTIALS]: "Usu\xE1rio ou senha incorretos",
    [import_dash_common5.ServerErrors.API_CREDENTIALS_ALREADY_EXIST]: "N\xE3o \xE9 poss\xEDvel criar credenciais da API. J\xE1 existem credenciais associadas a esta conta.",
    [import_dash_common5.ServerErrors.ACCOUNT_IS_NOT_RELATED_TO_APPLICATION]: "A conta n\xE3o est\xE1 vinculada a este aplicativo",
    [import_dash_common5.ServerErrors.INVALID_PHONE_NUMBER]: "Telefone inv\xE1lido",
    [import_dash_common5.ServerErrors.ALREADY_ASSIGNED_USER_IN_SALE_TEAM]: "Este usu\xE1rio j\xE1 est\xE1 atribu\xEDdo a esta equipe de vendas.",
    [import_dash_common5.ServerErrors.PROPERTY_NAME_EXISTS]: "J\xE1 existe um im\xF3vel com este nome",
    [import_dash_common5.ServerErrors.PORTFOLIO_FOLDER_NAME_EXISTS]: "O nome do portf\xF3lio deve ser \xFAnico",
    [import_dash_common5.ServerErrors.PORTFOLIO_NAME_ROOT_FORBIDDEN]: 'O nome do portf\xF3lio n\xE3o pode ser "root"',
    [import_dash_common5.ServerErrors.ALERT_CONFIG_WITH_SAME_NAME]: "J\xE1 existe um alerta com este nome. D\xEA um nome \xFAnico ao alerta.",
    [import_dash_common5.ServerErrors.ALERT_CONFIG_WITH_SAME_FILTER]: "J\xE1 existe um alerta com as mesmas configura\xE7\xF5es. Selecione crit\xE9rios diferentes.",
    [import_dash_common5.ServerErrors.FOLDER_ALREADY_EXISTS]: "J\xE1 existe uma pasta com o mesmo nome neste diret\xF3rio.",
    [import_dash_common5.ServerErrors.RESERVED_FOLDER]: "J\xE1 existe uma pasta com o mesmo nome",
    [import_dash_common5.ServerErrors.SALE_TEAM_PHONE_EXISTS]: "J\xE1 existe uma equipe de vendas externa com este telefone.",
    [import_dash_common5.ServerErrors.SUBSCRIPTION_ALREADY_CANCELED]: "A assinatura j\xE1 foi cancelada!",
    [import_dash_common5.ServerErrors.PAYMENT_METHOD_DECLINED]: "Seu cart\xE3o foi recusado. Entre em contato com o administrador do cart\xE3o ou tente outro cart\xE3o.",
    [import_dash_common5.ServerErrors.INSUFFICIENT_FUNDS]: "Seu cart\xE3o foi recusado. Motivo: saldo insuficiente",
    [import_dash_common5.ServerErrors.STOLEN_CARD]: "Seu cart\xE3o foi recusado. Motivo: cart\xE3o roubado",
    [import_dash_common5.ServerErrors.LOST_CARD]: "Seu cart\xE3o foi recusado. Motivo: cart\xE3o perdido"
  },
  fileTypes: {
    photo: "FOTO",
    video: "V\xCDDEO",
    file: "ARQUIVO",
    exel: "XLS",
    doc: "DOC",
    pdf: "PDF"
  },
  subscriptionProductRecurringLabels: {
    [(0, import_lodash5.camelCase)(import_dash_common5.RecurringTypesEnum.FREE)]: "Gr\xE1tis",
    [(0, import_lodash5.camelCase)(import_dash_common5.RecurringTypesEnum.MONTH)]: "M\xEAs",
    [(0, import_lodash5.camelCase)(import_dash_common5.RecurringTypesEnum.SIXMONTH)]: "Seis meses",
    [(0, import_lodash5.camelCase)(import_dash_common5.RecurringTypesEnum.YEAR)]: "Ano"
  },
  subscriptionTypes: {
    [import_dash_common5.BrokerSubscriptionTypesEnum.BILLABLE]: "Cobr\xE1vel",
    [import_dash_common5.BrokerSubscriptionTypesEnum.DEMO]: "Demo"
  },
  subscriptionStatuses: {
    [import_dash_common5.ProductSubscriptionStatusesEnum.ACTIVE]: "Ativa",
    [import_dash_common5.ProductSubscriptionStatusesEnum.CANCELED]: "Cancelada",
    [import_dash_common5.ProductSubscriptionStatusesEnum.SCHEDULED_CANCELLATION]: "Cancelamento agendado",
    [import_dash_common5.ProductSubscriptionStatusesEnum.INCOMPLETE]: "Incompleta",
    [import_dash_common5.ProductSubscriptionStatusesEnum.INCOMPLETE_EXPIRED]: "Incompleta expirada",
    [import_dash_common5.ProductSubscriptionStatusesEnum.PAST_DUE]: "Em atraso",
    [import_dash_common5.ProductSubscriptionStatusesEnum.TRIALING]: "Em teste",
    [import_dash_common5.ProductSubscriptionStatusesEnum.UNPAID]: "N\xE3o paga"
  },
  subscriptionPlanTypes: {
    [import_dash_common5.SubscriptionProductNamesEnum.PRO]: "PRO",
    [import_dash_common5.SubscriptionProductNamesEnum.BASIC]: "Basic"
  },
  ssoProviders: {
    [(0, import_lodash5.camelCase)(import_dash_common5.SSOProvidersEnum.GOOGLE)]: "Google",
    [(0, import_lodash5.camelCase)(import_dash_common5.SSOProvidersEnum.MIAMI_REALTORS)]: "Miami Realtors"
  },
  subscriptionBadgeTitles: {
    noCreditCard: "Sem necessidade de cart\xE3o de cr\xE9dito",
    trialAvailable: "Teste de {{trialDays}} dias dispon\xEDvel!",
    saveWithSixMonthPlan: "Economize 10% com o plano de 6 meses",
    billedEverySixMonths: "Cobrado a cada seis meses"
  },
  subscriptionProductsCardsLabels: {
    basic: {
      fullDatabaseAccess: "Acesso a toda a base de dados da DASH",
      pricingInventorySalesMaterials: "Veja pre\xE7os, unidades dispon\xEDveis, materiais de vendas e mais",
      timestampedUpdates: "Atualiza\xE7\xF5es com data e hora e verifica\xE7\xE3o de dados",
      personalizedTracking: "Acompanhamento e alertas personalizados",
      unlimitedSavedProperties: "Adicione im\xF3veis ilimitados \xE0 sua lista de acompanhamento"
    },
    pro: {
      downloadUnbranded: "Baixe materiais de vendas sem marca",
      shareBrandedPortfolios: "Compartilhe portf\xF3lios com a sua marca",
      integratedLeadGeneration: "Gera\xE7\xE3o de leads integrada",
      analyticsInsights: "Obtenha insights com as an\xE1lises",
      comparisonTools: "Ferramentas de compara\xE7\xE3o de empreendimentos"
    },
    exchange: {
      embedFeeds: "Incorpore feeds da DASH no seu site",
      customizationOptions: "Op\xE7\xF5es de personaliza\xE7\xE3o com v\xE1rios tipos de feed",
      iframeImplementation: "Implementa\xE7\xE3o simples via iframe",
      platformSupport: "Compat\xEDvel com as principais plataformas web"
    },
    api: {
      directDataAccess: "Acesso direto aos dados: conecte-se \xE0 base completa de empreendimentos novos da DASH",
      flexibleDisplay: "Exibi\xE7\xE3o flex\xEDvel: alimente suas pr\xF3prias ferramentas de busca, pain\xE9is personalizados ou ferramentas internas",
      apiCredentials: "Inclui chave de API + credenciais"
    },
    direct: {
      overview: "Acesso direto \xE0 plataforma da DASH, criada exclusivamente para descobrir as casas, condom\xEDnios e comunidades de loca\xE7\xE3o mais novos da Fl\xF3rida",
      developerUpdates: "Atualiza\xE7\xF5es das incorporadoras em tempo real de mais de 400 comunidades",
      smartSearchFilters: "Busque por cidade, data de entrega, pre\xE7o, tipo de im\xF3vel e mais para encontrar o que voc\xEA precisa",
      launchAndPriceAlerts: "Receba alertas de lan\xE7amentos e mudan\xE7as de pre\xE7o",
      favoritesAndComparison: "Salve e organize seus favoritos enquanto compara op\xE7\xF5es",
      salesTeamAccess: "Acesso f\xE1cil \xE0s equipes de vendas no local para obter mais informa\xE7\xF5es e agendar visitas"
    }
  },
  subscriptionProductsCardsSectionTitles: {
    basic: "Recursos que voc\xEA vai adorar",
    pro: "Tudo do Basic, mais:",
    exchange: "Tudo do Pro, mais:",
    api: "Integra\xE7\xF5es de dados personalizadas"
  },
  subscriptionProductsKeyFeatures: "Principais recursos",
  subscriptionProductsCardsDescriptions: {
    basic: "Acesso imediato para descobrir e explorar a base de lan\xE7amentos da DASH.",
    pro: "Baixe materiais de vendas sem marca e compartilhe links com a sua marca.",
    exchange: "Adicione centenas de novos empreendimentos ao seu site com facilidade.",
    api: "Integre os dados de lan\xE7amentos da DASH aos seus aplicativos personalizados."
  },
  featureLabels: {
    basic: {
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.NO_CREDIT_CARD)]: "SEM NECESSIDADE DE CART\xC3O DE CR\xC9DITO",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.PRO_UPGRADE)]: "Fa\xE7a upgrade para o PRO a qualquer momento e tenha recursos avan\xE7ados",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.VIEW_ALL_PROPERTIES_IN_DATABASE)]: "Acesso ilimitado \xE0 base de im\xF3veis novos da DASH",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.ACCESS_TO_PRICING_AVAILABILITY)]: "Acesso a pre\xE7os e disponibilidade de todos os im\xF3veis",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.ACCESS_TO_MARKETING_MATERIALS)]: "Acesso aos materiais de marketing de todos os im\xF3veis",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.TRACK_UPDATES)]: "Acompanhe atualiza\xE7\xF5es dos im\xF3veis com data e hora e verifica\xE7\xE3o",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.ADVANCED_FILTERS_FOR_PINPOINT_SEARCH)]: "Use filtros avan\xE7ados para refinar a busca por unidades",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.CUSTOM_ALERTS_NOTIFICATIONS)]: "Alertas personalizados de im\xF3veis e do mercado na sua caixa de entrada",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashBaseFeaturesEnum.DASH_SUPPORT)]: "Suporte da equipe DASH sempre que precisar"
    },
    pro: {
      base: "Inclui todos os recursos do plano Basic, MAIS...    ",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING)]: "Compartilhe portf\xF3lios personalizados",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.PROPERTY_COMPARE)]: "Ferramentas de compara\xE7\xE3o lado a lado",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.ANALYTICS_AND_REPORTING_TOOLS)]: "Obtenha insights com as an\xE1lises",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT)]: "Baixe conte\xFAdo sem marca"
    },
    idx: {
      base: "Inclui todos os recursos do plano PRO, MAIS...    ",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.EMBED_LISTINGS)]: "Incorpore an\xFAncios da DASH no seu site",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.MULTIPLE_FEED_TYPES)]: "V\xE1rios tipos de feed",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.LEAD_GENERATION)]: "Gera\xE7\xE3o de leads",
      [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.IDX_INTEGRATION)]: "Integra\xE7\xE3o simples"
    },
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.LIMITED_TIME_INTRODUCTORY_PRICING)]: "PRE\xC7O PROMOCIONAL DE LAN\xC7AMENTO POR TEMPO LIMITADO"
  },
  featureDescriptions: {
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT)]: "acesso ilimitado a materiais de marketing sem marca dos im\xF3veis, prontos para compartilhar com clientes ou usar no seu site e nas redes sociais",
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING)]: "personalize e compartilhe com facilidade conte\xFAdo de empreendimentos e grupos selecionados de im\xF3veis com os seus dados de contato",
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.PROPERTY_COMPARE)]: "crie e compartilhe links de comparativos de empreendimentos com os seus principais prospects",
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.ANALYTICS_AND_REPORTING_TOOLS)]: "tenha acesso a ferramentas de relat\xF3rios que acompanham seus esfor\xE7os de marketing",
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.EMBED_LISTINGS)]: "uma solu\xE7\xE3o IDX pr\xE1tica para exibir novos empreendimentos com facilidade",
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.MULTIPLE_FEED_TYPES)]: "personalize como os im\xF3veis s\xE3o exibidos, com v\xE1rias op\xE7\xF5es, como portf\xF3lios, im\xF3vel \xFAnico, busca e mais",
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.LEAD_GENERATION)]: "colete leads diretamente de usu\xE1rios interessados nos im\xF3veis que voc\xEA exibe",
    [(0, import_lodash5.camelCase)(import_dash_common5.DashFeaturesEnum.IDX_INTEGRATION)]: "O DASH Exchange funciona com os principais sites, incluindo WordPress, Wix, Squarespace e mais\u2026"
  },
  brokerLicenseStatuses: {
    [import_dash_common5.BrokerLicenseStatusesEnum.ACTIVE]: "Ativa",
    [import_dash_common5.BrokerLicenseStatusesEnum.INACTIVE]: "Inativa",
    [import_dash_common5.BrokerLicenseStatusesEnum.PENDING_REVIEW]: "Revis\xE3o pendente"
  },
  accountPhoneNumberStatuses: {
    [import_dash_common5.AccountPhoneNumberStatusesEnum.VERIFIED]: "Verificado",
    [import_dash_common5.AccountPhoneNumberStatusesEnum.NOT_VERIFIED]: "N\xE3o verificado"
  },
  moments: {
    year: "ano",
    month: "m\xEAs",
    day: "dia",
    hour: "hora",
    minute: "minuto",
    second: "segundo",
    plural: {
      year: "anos",
      month: "meses",
      day: "dias",
      hour: "horas",
      minute: "minutos",
      second: "segundos"
    },
    short: {
      year: "ano",
      month: "m\xEAs",
      day: "d",
      hour: "h",
      minute: "min",
      second: "s"
    },
    shortPlural: {
      year: "anos",
      month: "meses",
      day: "d",
      hour: "h",
      minute: "min",
      second: "s"
    },
    agoLabel: "atr\xE1s",
    momentLabel: "agora mesmo",
    updatedJustNow: "Atualizado agora mesmo",
    updatedAgo: {
      year_one: "Atualizado h\xE1 {{count}} ano",
      year_other: "Atualizado h\xE1 {{count}} anos",
      month_one: "Atualizado h\xE1 {{count}} m\xEAs",
      month_other: "Atualizado h\xE1 {{count}} meses",
      day_one: "Atualizado h\xE1 {{count}} dia",
      day_other: "Atualizado h\xE1 {{count}} dias",
      hour_one: "Atualizado h\xE1 {{count}} hora",
      hour_other: "Atualizado h\xE1 {{count}} horas",
      minute_one: "Atualizado h\xE1 {{count}} minuto",
      minute_other: "Atualizado h\xE1 {{count}} minutos"
    },
    updatedAgoShort: {
      year_one: "Atualizado h\xE1 {{count}} ano",
      year_other: "Atualizado h\xE1 {{count}} anos",
      month_one: "Atualizado h\xE1 {{count}} m\xEAs",
      month_other: "Atualizado h\xE1 {{count}} meses",
      day_one: "Atualizado h\xE1 {{count}} d",
      day_other: "Atualizado h\xE1 {{count}} d",
      hour_one: "Atualizado h\xE1 {{count}} h",
      hour_other: "Atualizado h\xE1 {{count}} h",
      minute_one: "Atualizado h\xE1 {{count}} min",
      minute_other: "Atualizado h\xE1 {{count}} min"
    }
  },
  historyTypesMessages: {
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_NAME]: "Nome do im\xF3vel atualizado",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_PRICE]: "Pre\xE7os e disponibilidade atualizados",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_WEBSITE]: "Site do im\xF3vel atualizado",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_DEVELOPER_ORGANIZATION]: "Incorporadora atualizada",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_LOCATION]: "Localiza\xE7\xE3o do im\xF3vel atualizada",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_SALES_TEAMS]: "Equipe de vendas atualizada",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_MEDIA_UPLOADED]: "Novos arquivos de marketing enviados para {{folderName}}",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_MEDIA_FILES_MOVED]: "Arquivos de marketing movidos",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_MEDIA_RENAMED]: "Arquivos de marketing renomeados",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_MEDIA_REMOVED]: "Arquivos de marketing removidos",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_HIGHLIGHTS]: "Destaques do im\xF3vel atualizados",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_ABOUT]: "Detalhes do im\xF3vel atualizados",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_FEATURES_AND_AMENITIES]: "Caracter\xEDsticas e comodidades atualizadas",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_ADDED]: "Novas unidades adicionadas",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_UPDATED]: "Unidades atualizadas",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_REMOVED]: "Unidades removidas",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_ADDITIONAL_INFORMATION]: "Informa\xE7\xF5es adicionais atualizadas",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_VIRTUAL_TOURS]: "Tours virtuais atualizados",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_DATA_REVIEWED]: "Dados do im\xF3vel verificados",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_CMS_STATUS]: "Status alterado",
    [import_dash_common5.PropertyChangelogTypesEnum.PROPERTY_VISIBILITY]: "Visibilidade alterada"
  },
  history: {
    propertyUpdates: "Atualiza\xE7\xF5es do im\xF3vel",
    historyUpdates: "Hist\xF3rico de atualiza\xE7\xF5es"
  },
  globalSearchCategories: {
    all: "Todos os resultados",
    properties: "Im\xF3veis",
    locations: "Localiza\xE7\xF5es",
    organizations: "Incorporadoras"
  },
  searchIndexSubtypes: {
    PROPERTY: "Im\xF3vel",
    CITY: "Cidade",
    COUNTY: "Condado",
    STATE: "Estado",
    MARKET_AREA: "Regi\xE3o de mercado",
    DEVELOPER: "Incorporadora"
  },
  sortOptions: {
    alphabeticalAZ: "Ordem alfab\xE9tica A-Z",
    alphabeticalZA: "Ordem alfab\xE9tica Z-A",
    createdAt: "Mais recentes (adicionados h\xE1 menos tempo)",
    newListing: "Somente novos an\xFAncios",
    updatedAt: "\xDAltima atualiza\xE7\xE3o",
    lastUpdatedAtByChangelog: "\xDAltima atualiza\xE7\xE3o",
    lastBrokerVisit: "Visitados recentemente",
    newestAdded: "Adicionados mais recentemente",
    oldestAdded: "Adicionados h\xE1 mais tempo",
    recentlyUpdated: "Atualizados recentemente",
    mediaSizeUp: "Tamanho: do maior para o menor",
    mediaSizeDown: "Tamanho: do menor para o maior",
    yearBuilt: "Ano de constru\xE7\xE3o",
    isMarkedAsVerified: "Verificado",
    startingPriceAsc: "Pre\xE7o inicial (menor para maior)",
    startingPriceDesc: "Pre\xE7o inicial (maior para menor)",
    maxPriceAsc: "Pre\xE7o m\xE1ximo (menor para maior)",
    maxPriceDesc: "Pre\xE7o m\xE1ximo (maior para menor)"
  },
  modalDelete: {
    removedToast: "{{entity}} foi removido",
    note: "Observa\xE7\xE3o:",
    title: "Excluir {{entity}}",
    confirmationText: "Confirmar exclus\xE3o de",
    confirmationTextSecond: "Confirmar exclus\xE3o de {{entity}}",
    confirmationWithName: "Confirmar a exclus\xE3o de <bold>{{name}}</bold> ({{entity}})?"
  },
  modalConfirmDelete: {
    actionUnassing: "Esta a\xE7\xE3o remover\xE1 a atribui\xE7\xE3o de ",
    propertiesCurrentAssigned: ' "{{entity}}" dos im\xF3veis aos quais ele est\xE1 atribu\xEDdo atualmente.',
    ProceedDeletion: "Continuar com a exclus\xE3o?"
  },
  bannerPreview: {
    dimensions: "Altura (fixa): {{height}} px | Largura atual: {{width}} px",
    device: "Dispositivo: {{device}}",
    mobile: "Celular: {{isMobile}}",
    sliderInstruction: "Use o controle deslizante para redimensionar o banner"
  },
  paymentFailedBanner: {
    message: "Seu \xFAltimo pagamento n\xE3o foi processado. Atualize sua forma de pagamento para manter o acesso completo.",
    action: "Atualizar forma de pagamento"
  },
  languageSwitcher: {
    label: "Idioma",
    accountHint: "Altera apenas este navegador. O idioma da sua conta fica em Configura\xE7\xF5es."
  },
  backendErrors: {
    apiCredentialsAlreadyExist: "N\xE3o \xE9 poss\xEDvel criar credenciais da API. J\xE1 existem credenciais associadas a esta conta.",
    invalidIdxId: "ID do feed inv\xE1lido.",
    propertyDoesNotExist: "O im\xF3vel n\xE3o existe.",
    passwordRequiredForPortfolio: "\xC9 necess\xE1ria uma senha para abrir este portf\xF3lio.",
    portfolioNotAvailable: "O portf\xF3lio n\xE3o est\xE1 dispon\xEDvel.",
    trackedPropertiesLimitReached: "Voc\xEA atingiu o limite de im\xF3veis acompanhados.",
    unauthorized: "N\xE3o autorizado",
    internalServerError: "Erro interno do servidor",
    somethingWentWrong: "Algo deu errado.",
    twoFactorAlreadyEnabled: "A verifica\xE7\xE3o em duas etapas j\xE1 est\xE1 ativada.",
    twoFactorNotActivated: "A verifica\xE7\xE3o em duas etapas n\xE3o est\xE1 ativada.",
    invalidCode: "C\xF3digo inv\xE1lido.",
    authenticatorAppRequired: "Esta conta \xE9 verificada com um aplicativo autenticador.",
    qrCodeFailed: "Erro ao gerar o QR Code.",
    invitationNotFound: "Convite n\xE3o encontrado.",
    invitationUsed: "Este link de convite j\xE1 foi utilizado.",
    invitationExpired: "Este link de convite expirou.",
    invitationOnlyPendingResend: "Somente convites pendentes podem ser reenviados.",
    invitationOnlyPendingRevoke: "Somente convites pendentes podem ser revogados.",
    expirationDateInFuture: "A data de expira\xE7\xE3o deve ser no futuro.",
    apiCredentialNotFound: "Credencial da API n\xE3o encontrada.",
    apiCredentialNotDeleted: "A credencial da API n\xE3o foi exclu\xEDda.",
    pluginUserNotFound: "Usu\xE1rio do plugin n\xE3o encontrado.",
    marketplacePartnersOnly: "Somente parceiros do marketplace podem gerenciar usu\xE1rios do plugin.",
    pluginUsersCannotSwitchAccountType: "Usu\xE1rios do plugin da API n\xE3o podem mudar o tipo de conta",
    accountTypeSwitchedOnce: "O tipo de conta n\xE3o pode ser alterado mais de uma vez.",
    brokerNotFound: "Corretor n\xE3o encontrado.",
    notAllowedForRole: "A\xE7\xE3o n\xE3o permitida para esta fun\xE7\xE3o!",
    notAllowedForUser: "Este usu\xE1rio n\xE3o tem permiss\xE3o para realizar esta a\xE7\xE3o.",
    featureNotInPlan: "Recurso indispon\xEDvel na assinatura atual",
    subscriptionNotActive: "A assinatura n\xE3o est\xE1 ativa",
    subscriptionNotFound: "Assinatura n\xE3o encontrada.",
    renewOnlyCanceled: "A renova\xE7\xE3o est\xE1 dispon\xEDvel apenas para assinaturas canceladas!",
    retryOnlyIncomplete: "A nova tentativa est\xE1 dispon\xEDvel apenas para assinaturas incompletas!",
    retryOnlyOpenInvoice: "A nova tentativa est\xE1 dispon\xEDvel apenas para faturas de assinatura em aberto!",
    activeStripeSubscriptionExists: "Este cliente j\xE1 tem uma assinatura ativa.",
    notStripeCustomer: "A conta n\xE3o \xE9 uma cliente do Stripe.",
    portfolioNotFound: "Portf\xF3lio n\xE3o encontrado.",
    portfolioNotOwned: "O portf\xF3lio n\xE3o pertence a esta conta.",
    featuredPortfolioNotFound: "Portf\xF3lio em destaque n\xE3o encontrado",
    featuredPortfolioNothingToCopy: "N\xE3o h\xE1 im\xF3veis p\xFAblicos dispon\xEDveis para copiar.",
    featuredPropertyNotFound: "Im\xF3vel em destaque n\xE3o encontrado",
    featuredPortfolioAlreadySaved: "O portf\xF3lio em destaque j\xE1 est\xE1 salvo.",
    propertyNotFound: "Im\xF3vel n\xE3o encontrado.",
    propertyNotPublic: "O im\xF3vel n\xE3o \xE9 p\xFAblico",
    propertyUnavailableForBrokers: "O im\xF3vel n\xE3o est\xE1 dispon\xEDvel para corretores",
    propertyAlreadyTracked: "O im\xF3vel j\xE1 est\xE1 sendo acompanhado.",
    propertyAlreadyInPortfolio: "O im\xF3vel {{name}} j\xE1 foi adicionado ao portf\xF3lio",
    propertiesAlreadyInFolder: "Alguns im\xF3veis j\xE1 est\xE3o nesta pasta.",
    alertNotFound: "Alerta n\xE3o encontrado.",
    amenityNotFound: "Comodidade n\xE3o encontrada",
    accountNotFound: "Conta n\xE3o encontrada",
    invalidApiCredentials: "ID do aplicativo ou chave de API inv\xE1lidos.",
    targetNotFolder: "O destino n\xE3o \xE9 uma pasta",
    mediaNotFound: "Arquivo de m\xEDdia n\xE3o encontrado",
    noMediaToDownload: "Nenhuma m\xEDdia encontrada para baixar",
    mediaFolderNotFound: "Pasta de m\xEDdia n\xE3o encontrada ou n\xE3o pode ser exclu\xEDda",
    mediaDifferentFolders: "As m\xEDdias selecionadas n\xE3o est\xE3o na mesma pasta.",
    incorrectFileSize: "Tamanho de arquivo incorreto.",
    incorrectFileExtension: "Extens\xE3o de arquivo incorreta.",
    feedNotFound: "Feed n\xE3o encontrado.",
    feedSettingsNotFound: "Configura\xE7\xF5es do feed n\xE3o encontradas.",
    feedSettingsAlreadyExist: "As configura\xE7\xF5es do feed j\xE1 existem.",
    feedOwnerNotConfigured: "O dono do feed ainda n\xE3o configurou o IDX.",
    feedNoDownloads: "Este feed n\xE3o oferece downloads.",
    feedNoPortfolio: "Este feed n\xE3o tem portf\xF3lio.",
    propertyNotInFeed: "Este im\xF3vel n\xE3o pertence a este feed.",
    portfolioNoLocations: "Este portf\xF3lio n\xE3o acompanha localiza\xE7\xF5es.",
    salesMaterialsNotAvailable: "Os materiais de vendas n\xE3o est\xE3o dispon\xEDveis para o tipo de feed Barra de busca.",
    startDateAfterEndDate: "A data inicial n\xE3o pode ser posterior \xE0 data final.",
    originRequired: "O cabe\xE7alho Origin ou Referer \xE9 obrigat\xF3rio.",
    sessionUrlInvalid: "O URL da sess\xE3o \xE9 inv\xE1lido",
    noteDeleteOwnOnly: "Voc\xEA s\xF3 pode excluir as suas pr\xF3prias observa\xE7\xF5es.",
    noteEditOwnOnly: "Voc\xEA s\xF3 pode editar as suas pr\xF3prias observa\xE7\xF5es.",
    cardDeclined: "Seu cart\xE3o foi recusado.",
    cardInsufficientFunds: "Seu cart\xE3o n\xE3o tem saldo suficiente.",
    cardExpired: "Seu cart\xE3o expirou.",
    cardCvcIncorrect: "O c\xF3digo de seguran\xE7a do seu cart\xE3o est\xE1 incorreto.",
    cardNumberIncorrect: "O n\xFAmero do seu cart\xE3o est\xE1 incorreto.",
    cardExpiryIncorrect: "A data de validade do seu cart\xE3o est\xE1 incorreta.",
    cardNumberIncomplete: "O n\xFAmero do seu cart\xE3o est\xE1 incompleto.",
    cardExpiryIncomplete: "A data de validade do seu cart\xE3o est\xE1 incompleta.",
    cardCvcIncomplete: "O c\xF3digo de seguran\xE7a do seu cart\xE3o est\xE1 incompleto.",
    cardNotSupported: "Seu cart\xE3o n\xE3o aceita este tipo de compra.",
    cardProcessingError: "Ocorreu um erro ao processar seu cart\xE3o. Tente novamente em instantes.",
    postalCodeIncomplete: "Seu CEP est\xE1 incompleto.",
    networkError: "Erro de rede. Verifique sua conex\xE3o e tente novamente."
  },
  systemMediaFolders: {
    brochures: "Folhetos",
    factSheets: "Fichas t\xE9cnicas",
    floorPlans: "Plantas",
    images: "Imagens",
    videos: "V\xEDdeos",
    other: "Outros",
    slideshow: "Apresenta\xE7\xE3o",
    agentsOnly: "Somente corretores"
  },
  inventoryTypes: {
    MODEL: "Decorado",
    FOR_SALE: "\xC0 venda"
  },
  components: {
    select: {
      selectAll: "Selecionar tudo"
    },
    map: {
      close: "Fechar mapa",
      expandFullscreen: "Expandir mapa em tela cheia",
      expand: "Expandir mapa"
    },
    pdfViewer: {
      loadError: "Ocorreu um erro ao carregar este documento."
    },
    slideshow: {
      previousImage: "Imagem anterior",
      nextImage: "Pr\xF3xima imagem"
    },
    featuredBanner: {
      seeMore: "Ver mais",
      seeMoreDetails: "Ver mais detalhes"
    },
    upgradeBanner: {
      featurePropertyData: "Dados e descri\xE7\xF5es completos do im\xF3vel",
      featureContacts: "Contatos da incorporadora e da equipe de vendas",
      featureAssets: "Plantas, folders e imagens",
      featureTracking: "Ferramentas de acompanhamento para corretores",
      title: "Desbloqueie o acesso completo a {{propertyName}}",
      subtitle: "Obtenha informa\xE7\xF5es completas do im\xF3vel com o <bold>{{planName}}</bold>"
    },
    restrictedFiles: {
      ariaLabel: "Fa\xE7a upgrade para acessar os arquivos de marketing",
      empty: "N\xE3o h\xE1 arquivos nesta pasta",
      filesInFolder_one: "H\xE1 {{count}} arquivo nesta pasta",
      filesInFolder_other: "H\xE1 {{count}} arquivos nesta pasta",
      upgradeHint: "Fa\xE7a upgrade e acesse os arquivos verificados da incorporadora"
    },
    inventory: {
      intSqft: "SQFT int.:",
      extSqft: "SQFT ext.:",
      totalSqft: "SQFT total:",
      seeMoreUnitsAria_one: "Ver mais {{count}} unidade",
      seeMoreUnitsAria_other: "Ver mais {{count}} unidades",
      seeMoreUnits_one: "Ver mais {{count}} unidade",
      seeMoreUnits_other: "Ver mais {{count}} unidades",
      viewAllHint: "Veja todas as plantas, pre\xE7os e disponibilidade"
    },
    virtualTours: {
      numbered: "Tour virtual {{number}}",
      select: "Selecionar tour virtual"
    },
    apiChart: {
      requests: "Requisi\xE7\xF5es da API"
    }
  },
  propertyMap: {
    propertiesInArea_one: "{{count}} im\xF3vel nesta \xE1rea",
    propertiesInArea_other: "{{count}} im\xF3veis nesta \xE1rea",
    zoomHint: "Aproxime ou clique para explorar individualmente",
    completionIn: "Conclus\xE3o em {{year}}"
  }
};
var common_default3 = common2;

// src/assets/dictionary/pt/forms.ts
var forms2 = {
  labels: {
    email: "E-mail",
    password: "Senha",
    firstName: "Nome",
    lastName: "Sobrenome",
    apiReferralCode: "C\xF3digo de indica\xE7\xE3o",
    apiAccountType: "Tipo de conta",
    apiDirectUser: "Usu\xE1rio direto da API",
    apiDirectUserDesc: "Usa a API na pr\xF3pria integra\xE7\xE3o.",
    apiMarketplacePartner: "Parceiro de marketplace",
    apiMarketplacePartnerDesc: "Revende o acesso \xE0 API. Recebe um link de indica\xE7\xE3o para cadastrar usu\xE1rios do plugin, cujas requisi\xE7\xF5es contam na cota desta empresa. O c\xF3digo do link \xE9 gerado automaticamente.",
    apiCompany: "Empresa",
    apiCompanyRepresentative: "Representante",
    apiClientCount: "Clientes",
    apiCompanyName: "Empresa respons\xE1vel",
    apiMonthlyAccess: "Acesso mensal",
    apiInvitationExpiresAt: "Data de expira\xE7\xE3o",
    apiMfa: "MFA",
    apiMfaOn: "Ativada",
    apiMfaOff: "Desativada",
    // Named for what it counts: the company's own traffic. The quota it draws
    // on is shared with its plugin users and only shown on the account page.
    apiDirectRequests: "Requisi\xE7\xF5es diretas neste m\xEAs",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar senha",
    signIn: "Entrar",
    forgotPassword: "Esqueceu a senha?",
    sendResetInstructions: "Enviar instru\xE7\xF5es para redefinir a senha",
    resetPassword: "Redefinir senha",
    inventoryType: "Tipo",
    name: "Nome",
    url: "URL do site",
    address: "Endere\xE7o",
    map: "Mapa",
    logo: "Logotipo da organiza\xE7\xE3o",
    svgIcon: "\xCDcone SVG",
    organization: "Organiza\xE7\xE3o",
    primaryOrganization: "Organiza\xE7\xE3o principal",
    additionalOrganizations: "Organiza\xE7\xF5es adicionais",
    proposedPropertyOnly: "Criar como proposto (somente nome)",
    streetName: "Endere\xE7o (rua)",
    city: "Cidade",
    zipCode: "CEP",
    workingHours: "Hor\xE1rio de funcionamento",
    county: "Condado",
    radius: "Raio",
    state: "Estado",
    marketArea: "Regi\xE3o de mercado",
    buildingType: "Tipo de im\xF3vel",
    propertyTag: "Tags do im\xF3vel",
    tags: "Tags",
    projectStatus: "Status do empreendimento",
    salesGalleryStatus: "Status do stand de vendas",
    salesGalleryAddress: "Endere\xE7o do stand de vendas",
    propertyTransactionType: "Tipo de transa\xE7\xE3o",
    teamLogo: "Logotipo da equipe",
    stories: "Andares",
    yearBuilt: "Ano de constru\xE7\xE3o",
    leadArchitect: "Arquiteto principal",
    landscapeArchitect: "Paisagista",
    nbrOfTowers: "N\xFAmero de torres",
    constructionStartDate: "Data prevista de in\xEDcio da obra",
    nbrOfUnits: "N\xFAmero de unidades",
    completionDate: "Data prevista de conclus\xE3o",
    localArchitect: "Arquiteto local",
    interiorDesigner: "Designer de interiores",
    overview: "Destaques do im\xF3vel",
    projectDetails: "Vis\xE3o geral do im\xF3vel",
    taxInformation: "Impostos e HOA",
    websiteOfProperty: "Site do im\xF3vel",
    virtualTourUrl: "URL do tour virtual {{number}}",
    virtualTourLabel: "R\xF3tulo de exibi\xE7\xE3o (opcional)",
    priceOfProperty: "Pre\xE7o",
    salesTeam: "Equipe de vendas",
    salesDirector: "Diretor de vendas",
    salesAssociate: "Associado de vendas",
    brokerLicense: "Licen\xE7a de corretor (somente EUA)",
    brokerLicenseLabel: "Licen\xE7a de corretor",
    agentLicenseStatus: "Status da licen\xE7a de corretor",
    commission: "Comiss\xE3o %",
    contactUrl: "URL de contato",
    anyPrice: "Qualquer pre\xE7o",
    priceMin: "Pre\xE7o (M\xCDN)",
    priceMax: "Pre\xE7o (M\xC1X)",
    market: "Mercado",
    baths: "{{count}} banh.",
    beds: "{{count}} qt.",
    share: "Compartilhar",
    visibility: "Visibilidade",
    link: "Link",
    portfolioLink: "Link do portf\xF3lio",
    saveToApplyChanges: "Salve para aplicar as altera\xE7\xF5es",
    customRooms: "Ambientes adicionais",
    inventoryInfo: "Informa\xE7\xF5es das unidades",
    contactInfo: "Informa\xE7\xF5es de contato",
    defaultInventoryDetails: "Detalhes padr\xE3o das unidades",
    averageBedroomsNumber: "N\xFAmero m\xE9dio de quartos",
    averageBathroomsNumber: "N\xFAmero m\xE9dio de banheiros",
    averageNumbersLabels: {
      bedrooms: "Quartos ({{range}})",
      bathrooms: "Banheiros ({{range}})",
      interiorSqft: "SQFT interno ({{range}})",
      exteriorSqft: "SQFT externo ({{range}})"
    },
    buildingTypes: {
      activeAdult: "Active Adult (55+)",
      boutique: "Boutique",
      condo: "Condom\xEDnio",
      condoConversion: "Convers\xE3o em condom\xEDnio",
      condoHotel: "Condo-hotel",
      luxuryApartment: "Empreendimento para loca\xE7\xE3o",
      penthouse: "Cobertura",
      privateResidence: "Resid\xEAncia privativa",
      shortTermRentalFriendly: "Permite loca\xE7\xE3o de curta temporada",
      singleFamilyHome: "Casa unifamiliar",
      townhome: "Townhome",
      villa: "Villa",
      workforceHousing: "Habita\xE7\xE3o para trabalhadores"
    },
    propertyTags: {
      activeAdult: "Active Adult (55+)",
      boutique: "Boutique",
      brandedResidences: "Resid\xEAncias de marca",
      condoConversion: "Convers\xE3o em condom\xEDnio",
      eb5Program: "Programa EB-5",
      limitedInventory: "Estoque limitado",
      masterPlanned: "Comunidade planejada",
      penthouse: "Cobertura",
      resortStyle: "Estilo resort",
      shortTermRentalFriendly: "Permite loca\xE7\xE3o de curta temporada",
      waterfront: "Frente para a \xE1gua",
      workforceHousing: "Habita\xE7\xE3o para trabalhadores"
    },
    projectStatuses: {
      comingSoon: "Em breve",
      soldOut: "Esgotado",
      developerInventory: "Estoque da incorporadora",
      newConstruction: "Lan\xE7amento",
      newListing: "Novo an\xFAncio",
      preConstruction: "Na planta",
      underConstruction: "Em constru\xE7\xE3o",
      completed: "Conclu\xEDdo",
      proposed: "Proposto",
      leavingSoon: "Saindo em breve"
    },
    salesGalleryStatuses: {
      appointmentOnly: "Somente com agendamento",
      comingSoon: "Em breve",
      hoursAvailable: "Hor\xE1rios dispon\xEDveis",
      noInformation: "Sem informa\xE7\xF5es (ocultar stand de vendas)"
    },
    propertyStatuses: {
      draft: "Rascunho",
      public: "P\xFAblico",
      private: "Privado"
    },
    propertyTransactionTypes: {
      forSale: "\xC0 venda",
      forRent: "Para alugar"
    },
    markets: {
      florida: {
        alva: "Alva",
        aveMaria: "Ave Maria",
        aventura: "Aventura",
        balHarbour: "Bal Harbour",
        bayHarborIslands: "Bay Harbor Islands",
        belleGlade: "Belle Glade",
        bocaRaton: "Boca Raton",
        bonitaSprings: "Bonita Springs",
        boyntonBeach: "Boynton Beach",
        brandon: "Brandon",
        brickell: "Brickell",
        capeCoral: "Cape Coral",
        cityOfMarco: "City of Marco",
        clearwater: "Clearwater",
        cocoaBeach: "Cocoa Beach",
        coconutGrove: "Coconut Grove",
        cooperCity: "Cooper City",
        coralGables: "Coral Gables",
        coralSprings: "Coral Springs",
        cutlerBay: "Cutler Bay",
        daniaBeach: "Dania Beach",
        davie: "Davie",
        deerfieldBeach: "Deerfield Beach",
        delrayBeach: "Delray Beach",
        doral: "Doral",
        downtownFortLauderdale: "Downtown Fort Lauderdale",
        downtownFortMyers: "Downtown Fort Myers",
        downtownMiami: "Downtown Miami",
        downtownStPetersburg: "Downtown St. Petersburg",
        dunedin: "Dunedin",
        edgewater: "Edgewater",
        esteroBay: "Estero Bay",
        esteroIsland: "Estero Island",
        evergladesCity: "Everglades City",
        fisherIsland: "Fisher Island",
        floridaCity: "Florida City",
        fortLauderdale: "Fort Lauderdale",
        fortMyers: "Fort Myers",
        fortMyersBeach: "Fort Myers Beach",
        fortPierce: "Fort Pierce",
        greenacres: "Greenacres",
        hallandaleBeach: "Hallandale Beach",
        hillsboroBeach: "Hillsboro Beach",
        hobeSound: "Hobe Sound",
        hobeSoundBeach: "Hobe Sound Beach",
        hollywood: "Hollywood",
        homestead: "Homestead",
        jupiter: "Jupiter",
        kendall: "Kendall",
        lakeland: "Lakeland",
        lakePark: "Lake Park",
        lakeWorthBeach: "Lake Worth Beach",
        lasOlas: "Las Olas",
        lauderdaleLakes: "Lauderdale Lakes",
        lauderhill: "Lauderhill",
        lehighAcres: "Lehigh Acres",
        lidoKey: "Lido Key",
        loxahatchee: "Loxahatchee",
        mangoniaPark: "Mangonia Park",
        marcoIsland: "Marco Island",
        melbourne: "Melbourne",
        melbourneBeach: "Melbourne Beach",
        miami: "Miami",
        miamiBeach: "Miami Beach",
        miamiGardens: "Miami Gardens",
        miamiRiver: "Miami River",
        midtownMiami: "Midtown Miami",
        miramar: "Miramar",
        moorings: "Moorings",
        naples: "Naples",
        naplesPark: "Naples Park",
        northBayVillage: "North Bay Village",
        northMiami: "North Miami",
        northMiamiBeach: "North Miami Beach",
        northNaples: "North Naples",
        oaklandPark: "Oakland Park",
        oldNaples: "Old Naples",
        orlando: "Orlando",
        palmBay: "Palm Bay",
        palmBeachGardens: "Palm Beach Gardens",
        palmBeachShores: "Palm Beach Shores",
        palmHarbor: "Palm Harbor",
        parkland: "Parkland",
        parkShore: "Park Shore",
        pelicanBay: "Pelican Bay",
        pembrokePines: "Pembroke Pines",
        pinecrest: "Pinecrest",
        plantation: "Plantation",
        portCharlotte: "Port Charlotte",
        portStLucie: "Port St. Lucie",
        pompanoBeach: "Pompano Beach",
        princeton: "Princeton",
        puntaGorda: "Punta Gorda",
        richmondWest: "Richmond West",
        riverview: "Riverview",
        rivieraBeach: "Riviera Beach",
        royalPalmBeach: "Royal Palm Beach",
        sanibel: "Sanibel",
        sarasota: "Sarasota",
        sarasotaBay: "Sarasota Bay",
        satelliteBeach: "Satellite Beach",
        sebastian: "Sebastian",
        springHill: "Spring Hill",
        stPeteBeach: "St. Pete Beach",
        stPetersburg: "St. Petersburg",
        stuart: "Stuart",
        sunnyIslesBeach: "Sunny Isles Beach",
        sunrise: "Sunrise",
        surfside: "Surfside",
        tamarac: "Tamarac",
        tampa: "Tampa",
        tarponSprings: "Tarpon Springs",
        titusville: "Titusville",
        veroBeach: "Vero Beach",
        victoriaPark: "Victoria Park",
        westlake: "Westlake",
        westPalmBeach: "West Palm Beach",
        weston: "Weston",
        wynwood: "Wynwood"
      }
    },
    nameOfProperty: "Nome do im\xF3vel",
    quantity: "Quantidade",
    bedrooms: "N\xBA de quartos",
    bathrooms: "N\xBA de banheiros",
    totalSqft: "SQFT total",
    interiorSqft: "SQFT interno",
    exteriorSqft: "SQFT externo",
    startingPrice: "Pre\xE7o inicial ",
    highestPrice: "Pre\xE7o m\xE1ximo ",
    floorplan: "Planta (PDF)",
    login: "Entrar",
    role: "Fun\xE7\xE3o",
    properties: "Im\xF3veis",
    brokerLicenseNumber: "N\xFAmero da licen\xE7a de corretor (somente EUA)",
    addManually: "Adicionar manualmente",
    phoneNumber: "Telefone",
    verifyPhoneNumberCode: "C\xF3digo de verifica\xE7\xE3o",
    shortDescription: "Descri\xE7\xE3o curta",
    agencyName: "Nome da imobili\xE1ria",
    companyName: "Nome da empresa",
    agencyWebsite: "Site da imobili\xE1ria",
    website: "Site",
    propertyType: "Tipo de im\xF3vel",
    alertName: "Nome do alerta",
    oldPassword: "Senha atual",
    subscriptionPlanName: "Nome do plano da assinatura",
    subscriptionPlanStatus: "Status do plano da assinatura",
    subscriptionPlanTypes: "Tipo de assinatura",
    subscriptionType: "Tipo de assinatura",
    userStatus: "Status do usu\xE1rio",
    mortgageTotalPrice: "Valor do financiamento",
    mortgageDownPayment: "Entrada",
    mortgageInterestRate: "Taxa de juros (%) ",
    mortgageTerm: "Prazo do financiamento (anos)",
    mortgageTaxRate: "Imposto predial (anual)",
    mortgageInsuranceRate: "Seguro do im\xF3vel (anual)",
    termForTheDemo: "Dura\xE7\xE3o da demo",
    reasonUnActive: "Informe o motivo da desativa\xE7\xE3o",
    note: "Observa\xE7\xF5es",
    attachFiles: "Anexar arquivos",
    min: "M\xCDN",
    max: "M\xC1X",
    salesWorkingHours: "Hor\xE1rio de funcionamento do stand de vendas",
    realUser: "Conta de corretor",
    testUser: "Conta de teste",
    accountType: "Tipo de conta",
    excludeFromReports: "Excluir dos relat\xF3rios",
    isAPIUser: "Usu\xE1rio da API",
    portfolioName: "Nome do portf\xF3lio",
    propertyName: "T\xEDtulo",
    bannerTitle: "T\xEDtulo do banner",
    description: "Descri\xE7\xE3o",
    coverImage: "Imagem de capa",
    shortOverview: "Resumo",
    brokerContactCard: {
      yourName: "Seu nome",
      phone: "Telefone",
      message: "Mensagem",
      sendMessage: "Enviar mensagem",
      sendNewMessage: "Enviar nova mensagem",
      visitWebsite: "Visitar site",
      contactMe: "FALE COMIGO:",
      messageSent: "Sua mensagem foi enviada!",
      agentWillContact: "O corretor entrar\xE1 em contato em breve.",
      failedToSendMessage: "Falha ao enviar a mensagem. Tente novamente.",
      nameRequired: "O nome \xE9 obrigat\xF3rio",
      messageRequired: "A mensagem \xE9 obrigat\xF3ria",
      morePropertiesTitle: "Resid\xEAncias desta cole\xE7\xE3o",
      morePropertiesTitleAgent: "Im\xF3veis deste portf\xF3lio",
      emailInvalid: "Informe um e-mail v\xE1lido",
      logoAlt: "Logo da Dash"
    }
  },
  messages: {
    shareSettingsSaved: "Configura\xE7\xF5es de compartilhamento salvas com sucesso",
    emailBlank: "O e-mail est\xE1 em branco",
    emailRequired: "O e-mail \xE9 obrigat\xF3rio",
    emailInvalid: "Formato de e-mail inv\xE1lido",
    expirationRequired: "A data de expira\xE7\xE3o \xE9 obrigat\xF3ria",
    expirationFuture: "A data de expira\xE7\xE3o deve ser futura",
    passwordBlank: "A senha est\xE1 em branco",
    passwordRequired: "A senha \xE9 obrigat\xF3ria",
    passwordInvalid: "A senha deve ter pelo menos 8 caracteres, 1 s\xEDmbolo, 1 n\xFAmero, 1 letra min\xFAscula e 1 mai\xFAscula",
    passwordValid: "Sua senha foi aceita",
    newPasswordValid: "Sua senha foi aceita",
    confirmPasswordValid: "As senhas coincidem",
    confirmPasswordInValid: "As senhas devem coincidir",
    firstNameBlank: "O nome est\xE1 em branco",
    fieldLengthInvalid: "Caracteres demais.",
    lastNameBlank: "O sobrenome est\xE1 em branco",
    nameBlank: "O nome \xE9 obrigat\xF3rio",
    nameInvalid: "O nome \xE9 inv\xE1lido",
    iconBlank: "Nenhum \xEDcone enviado",
    fileBlank: "Nenhum arquivo enviado",
    urlInvalid: "O link n\xE3o \xE9 v\xE1lido. Tente usar o formato www.website.com",
    urlBlank: "A URL do site est\xE1 em branco",
    invalidUrl: "Informe uma URL v\xE1lida (ex.: https://example.com)",
    urlRequiredWithLabel: "A URL \xE9 obrigat\xF3ria quando h\xE1 um r\xF3tulo",
    invalidUrlsBeforeSaving: "Corrija as URLs inv\xE1lidas antes de salvar",
    labelsWithoutUrls: "Alguns tours virtuais t\xEAm r\xF3tulo, mas n\xE3o t\xEAm URL. Adicione as URLs ou remova os r\xF3tulos.",
    addressInvalid: "O endere\xE7o \xE9 inv\xE1lido",
    mapInvalid: "O mapa \xE9 inv\xE1lido",
    marketBlank: "O mercado \xE9 obrigat\xF3rio",
    stateBlank: "O estado \xE9 obrigat\xF3rio",
    countyBlank: "O condado \xE9 obrigat\xF3rio",
    cityBlank: "A cidade \xE9 obrigat\xF3ria",
    zipCodeBlank: "O CEP \xE9 obrigat\xF3rio",
    streetBlank: "A rua \xE9 obrigat\xF3ria",
    organizationBlank: "A organiza\xE7\xE3o \xE9 obrigat\xF3ria",
    addressBlank: "O endere\xE7o \xE9 obrigat\xF3rio",
    mapBlank: "O mapa \xE9 obrigat\xF3rio",
    sqftBlank: "O SQFT \xE9 obrigat\xF3rio",
    maxCharacterLimit: "O limite m\xE1ximo \xE9 de {{number}} caracteres",
    workingHoursValidateMessage: "O hor\xE1rio de t\xE9rmino n\xE3o pode ser anterior ao de in\xEDcio",
    priceBlank: "O pre\xE7o est\xE1 em branco",
    uploadErrors: {
      fileInvalidType: "O tipo de arquivo deve ser {{type}}",
      fileTooLarge: "O arquivo deve ter no m\xE1ximo {{maxSize}} MB",
      unknown: "Algo deu errado.",
      tooManyFiles: "N\xE3o \xE9 poss\xEDvel selecionar v\xE1rios arquivos aqui"
    },
    minMaxMissingValueValidationError: "O valor m\xEDnimo \xE9 obrigat\xF3rio",
    defaultMinMaxValidationError: "O valor m\xEDnimo deve ser menor que o m\xE1ximo",
    typeInvalid: "O tipo de arquivo \xE9 inv\xE1lido",
    startingPriceMoreThanHighest: "O pre\xE7o inicial deve ser menor que o pre\xE7o m\xE1ximo",
    highestPriceLessThanStarting: "O pre\xE7o m\xE1ximo deve ser maior que o pre\xE7o inicial",
    numberOfUnitsMoreThanHighest: "O n\xFAmero de unidades (M\xCDN) deve ser menor que o (M\xC1X)",
    roleBlank: "A fun\xE7\xE3o est\xE1 em branco",
    roleRequired: "A fun\xE7\xE3o \xE9 obrigat\xF3ria",
    saleTeamBlank: "A equipe de vendas est\xE1 em branco",
    propertiesBlank: "Os im\xF3veis est\xE3o em branco",
    characterLengthRestriction: "Voc\xEA digitou caracteres demais ",
    fieldIsRequired: "{{fieldName}} \xE9 obrigat\xF3rio",
    inventoryMinRequired: {
      bedrooms: "Quartos (m\xEDn.) \xE9 obrigat\xF3rio",
      bathrooms: "Banheiros (m\xEDn.) \xE9 obrigat\xF3rio",
      interiorSqft: "SqFt interna (m\xEDn.) \xE9 obrigat\xF3rio",
      exteriorSqft: "SqFt externa (m\xEDn.) \xE9 obrigat\xF3rio"
    },
    invalidCharacters: "Voc\xEA digitou caracteres inv\xE1lidos para este campo",
    digitsLengthRestriction: "N\xE3o \xE9 poss\xEDvel digitar mais de {{number}} d\xEDgitos",
    selectFolder: "Selecione a pasta necess\xE1ria",
    selectBrandingType: "Selecione um tipo de marca",
    phoneNumberBlank: "O telefone est\xE1 em branco",
    phoneNumberWrongLengthUS: "O telefone deve ter 10 n\xFAmeros.",
    radius: "Raio",
    verificationCodeSend: "O c\xF3digo de verifica\xE7\xE3o foi enviado para o seu telefone",
    fileInvalidType: "O tipo de arquivo deve ser {{type}}",
    percentageInvalid: "A porcentagem deve ser menor que 100",
    mortgage: {
      totalPriceBlank: "O valor do financiamento \xE9 obrigat\xF3rio",
      downPaymentBlank: "A entrada \xE9 obrigat\xF3ria ",
      interestRateBlank: "A taxa de juros \xE9 obrigat\xF3ria",
      termBlank: "O prazo do financiamento \xE9 obrigat\xF3rio"
    },
    reasonBlank: "O motivo est\xE1 em branco",
    noteBlank: "As observa\xE7\xF5es est\xE3o em branco",
    noteInvalid: "O campo n\xE3o aceita mais de {{length}} caracteres",
    brandedFilesReadyHelp: "Quando ativado, os usu\xE1rios do DASH Direct poder\xE3o ver e baixar arquivos com marca na se\xE7\xE3o Downloads do im\xF3vel. As pastas compartilhadas ser\xE3o exibidas a todos os usu\xE1rios.",
    switchAccount: {
      countryRequired: "O pa\xEDs \xE9 obrigat\xF3rio.",
      stateRequired: "O estado \xE9 obrigat\xF3rio.",
      licenseRequired: "O n\xFAmero da licen\xE7a \xE9 obrigat\xF3rio.",
      licenseMax: "O n\xFAmero da licen\xE7a deve ter no m\xE1ximo 10 caracteres."
    }
  },
  placeholders: {
    email: "john@dash.com",
    firstName: "Brooklyn",
    lastName: "Simmonsy",
    apiReferralCode: "codigo-de-indicacao-da-empresa",
    apiInvitationExpiresAt: "MM/DD/YYYY",
    apiCompanyName: "The Reeves Group",
    companyName: "The Reeves Group",
    password: "Digite a senha",
    oldPassword: "Digite a senha atual",
    newPassword: "Digite a nova senha",
    confirmPassword: "Digite a senha novamente",
    organizationName: "Nome da organiza\xE7\xE3o",
    saleTeamName: "Ex.: Dash Inc",
    url: "https://website.com",
    address: "Digite o endere\xE7o",
    map: "Encontrar no mapa",
    nameOfProperty: "Nome do im\xF3vel",
    selectOne: "Selecione uma op\xE7\xE3o",
    salesGalleryAddress: "Informe o endere\xE7o do stand de vendas, incluindo rua, n\xFAmero da sala e qualquer instru\xE7\xE3o especial para os visitantes",
    virtualTourUrl: "https://example.com/virtual-tour",
    virtualTourLabel: "ex.: Tour 360\xB0, Tour Matterport",
    nameOfCity: "Nome da cidade",
    nameOfStreet: "N\xFAmero e nome da rua",
    priceRange: "Ex.: $1,000,000 - $2,000,000",
    digits: "{{number}} d\xEDgitos",
    nbrOfStories: "N\xFAmero de andares",
    year: "Ano",
    nameOfArchitect: "Nome do arquiteto",
    nbrOfTowers: "N\xFAmero de torres",
    nbrOfUnits: "N\xFAmero de unidades",
    nameOfDesigner: "Nome do designer",
    overviewPlaceholder: "Adicione destaques sobre o im\xF3vel. M\xE1ximo de {{number}} caracteres.",
    projectDetailsPlaceholder: "Adicione a vis\xE3o geral do empreendimento. M\xE1ximo de {{number}} caracteres",
    taxInformationPlaceholder: "Adicione impostos/taxas. M\xE1ximo de {{number}} caracteres",
    websiteOfProperty: "https://website.com",
    priceOfProperty: "Pre\xE7o",
    salesTeam: "Selecione a equipe de vendas",
    salesDirector: "Selecione o diretor de vendas",
    salesAssociate: "Selecione o associado de vendas",
    commission: "Informe a comiss\xE3o",
    contactUrl: "Digite a URL de contato",
    inventoryName: "EX: Linha B, Cobertura",
    inventoryType: "EX: Decorado, \xC0 venda",
    ex: "EX",
    sqft: "EX: 1,234",
    totalSqft: "C\xE1lculo autom\xE1tico",
    dragAndDropZone: "Arraste e solte ou clique para",
    cardDescription: "Descri\xE7\xE3o curta para o card do portf\xF3lio",
    selectFiles: "Selecionar arquivos",
    folderName: "Nome da pasta",
    role: "Selecione a fun\xE7\xE3o",
    saleTeam: "Selecione a equipe de vendas",
    properties: "Selecione os im\xF3veis",
    brokerLicenseNumber: "856456456",
    mediaName: "Nome da m\xEDdia",
    phoneNumber: "856456456",
    verifyPhoneNumberCode: "A1B2",
    enterPasswordToOpenLink: "Digite a senha para abrir este link",
    enterFolderName: "Digite o nome da pasta",
    alertName: "Digite o nome do alerta",
    enterDescription: "Digite a descri\xE7\xE3o",
    agencyName: "The Reeves Group",
    marketAreaName: "Nome da regi\xE3o de mercado",
    amenityName: "Nome da comodidade",
    mortgageTotalPrice: "670,400.00",
    mortgageDownPayment: "20%",
    mortgageInterestRate: "4.5%",
    mortgageTerm: "30",
    mortgageTaxRate: "$3,000",
    mortgageInsuranceRate: "$1,500",
    defaultInventoryPlaceholder: "Digite os detalhes padr\xE3o das unidades",
    averageBedroomsNumber: "Digite o n\xFAmero",
    averageBathroomsNumber: "1",
    reasonUnActive: "Digite o motivo da desativa\xE7\xE3o.",
    note: "Digite as observa\xE7\xF5es do im\xF3vel",
    salesTeamName: "Nome da equipe de vendas",
    markets: "Selecione o mercado",
    buildingTypes: "Selecione os tipos de im\xF3vel",
    portfolioName: "Digite o nome do portf\xF3lio",
    description: "Sobre o que \xE9 este portf\xF3lio?",
    selectProperties: "Selecione os im\xF3veis a incluir",
    propertyName: "Digite o t\xEDtulo",
    propertyNameSearch: "Digite o nome do im\xF3vel",
    shortOverview: "Escreva um breve resumo..."
  }
};
var forms_default3 = forms2;

// src/assets/dictionary/pt/pages.ts
var import_dash_common6 = require("dash-common");
var import_lodash6 = require("lodash");
var pages2 = {
  common: {
    sortModal: {
      title: "Ordenar exibi\xE7\xE3o",
      cancel: "Cancelar",
      save: "Salvar",
      instruction: "Arraste e solte para reordenar os itens. As altera\xE7\xF5es ser\xE3o salvas quando voc\xEA clicar em Salvar.",
      empty: "Nenhum item para ordenar"
    }
  },
  signInPage: {
    welcomeHeader: "Boas-vindas \xE0 DASH!",
    welcomeSubHeader: "Entre na sua conta.",
    bottomLabel: "N\xE3o tem uma conta?",
    bottomLabelLink: "Criar conta",
    loginWithGoogle: "Entrar com o Google",
    loginWithMiamiRealtors: "Entrar com MIAMI REALTORS",
    sendLoginLink: "Enviar link de acesso por e-mail",
    backToLogin: "Voltar ao login",
    magicLinkSent: "Se encontrarmos uma conta associada ao e-mail <bold>{{email}}</bold>, enviamos um link de acesso seguro. Verifique sua caixa de entrada e a pasta de spam, caso n\xE3o o receba. Para sua prote\xE7\xE3o, <bold>o link \xE9 v\xE1lido por apenas 10 minutos</bold>."
  },
  signInMfaPage: {
    // Shared field copy
    codeLabel: "C\xF3digo",
    codePlaceholder: "123456",
    codeRequired: "Digite o c\xF3digo do seu app autenticador.",
    // Enrollment (first-time setup)
    enableHeader: "Configurar a verifica\xE7\xE3o em duas etapas",
    // DSH-936: choosing between the app and an emailed code
    methodChoiceSubHeader: "A verifica\xE7\xE3o em duas etapas \xE9 obrigat\xF3ria na sua conta. Escolha como voc\xEA quer receber seus c\xF3digos.",
    methodAppTitle: "App autenticador",
    methodAppBody: "Use um app como Google Authenticator ou Authy. \xC9 a op\xE7\xE3o mais segura e funciona sem conex\xE3o.",
    methodEmailTitle: "E-mail",
    methodEmailBody: "Enviamos um c\xF3digo para sua caixa de entrada a cada vez que voc\xEA entrar. N\xE3o precisa instalar nada.",
    methodRecommended: "Recomendado",
    emailCodeHeader: "Confira seu e-mail",
    emailCodeSubHeader: "Enviamos um c\xF3digo para voc\xEA. Digite-o abaixo para continuar.",
    emailCodeSubHeaderWithEmail: "Enviamos um c\xF3digo para {{email}}. Digite-o abaixo para continuar.",
    emailCodeRequired: "Digite o c\xF3digo que enviamos por e-mail.",
    resendCode: "Enviar outro c\xF3digo",
    resendCodeIn: "Enviar outro c\xF3digo em {{seconds}}s",
    enableScanSubHeader: "A verifica\xE7\xE3o em duas etapas \xE9 obrigat\xF3ria na sua conta. Escaneie o QR code abaixo com seu app autenticador.",
    enableCodeSubHeader: "Digite o c\xF3digo do seu app autenticador para concluir a ativa\xE7\xE3o da verifica\xE7\xE3o em duas etapas.",
    qrCodeError: "Algo deu errado ao gerar o QR code. Tente novamente ou entre em contato com o suporte.",
    continueButton: "Continuar",
    backButton: "Voltar",
    successHeader: "Tudo pronto",
    successSubHeader: "A verifica\xE7\xE3o em duas etapas agora est\xE1 ativada. Pediremos um c\xF3digo a cada vez que voc\xEA entrar.",
    doneButton: "Conclu\xEDdo",
    // Verification (returning login)
    verifyHeader: "Verifica\xE7\xE3o em duas etapas",
    verifySubHeader: "Digite o c\xF3digo do seu app autenticador para continuar.",
    confirmButton: "Confirmar",
    supportHint: "Se o seu c\xF3digo n\xE3o funcionar, entre em contato com o suporte.",
    qrAlt: "QR code da verifica\xE7\xE3o em duas etapas"
  },
  brokerSignUpPage: {
    welcomeHeader: "Criar uma conta DASH",
    welcomeSubHeader: "Sua privacidade \xE9 importante para n\xF3s. A DASH nunca compartilhar\xE1 suas informa\xE7\xF5es. ",
    submitButtonLabels: "Ir para a pr\xF3xima etapa",
    agreeTermsLabel: "Eu concordo com os",
    termsAndConditionsLabel: "termos e condi\xE7\xF5es,",
    termsAndConditionsError: "Voc\xEA precisa aceitar os termos e condi\xE7\xF5es para cadastrar uma conta.",
    smsTermsLabel: "e em receber um c\xF3digo de verifica\xE7\xE3o por SMS (podem ser aplicadas tarifas padr\xE3o de mensagens).",
    bottomLabel: "J\xE1 \xE9 membro da DASH?",
    bottomLabelLink: "Entrar"
  },
  brokerCompleteSignUpPage: {
    resendCodeLabel: "N\xE3o recebeu um c\xF3digo de verifica\xE7\xE3o?",
    emailResendCodeLabel: "N\xE3o recebeu um c\xF3digo de verifica\xE7\xE3o?",
    submitButtonLabels: "Criar conta",
    codeResent: "A verifica\xE7\xE3o por SMS foi enviada.",
    emailSent: "A verifica\xE7\xE3o por e-mail foi enviada."
  },
  forgotPasswordPage: {
    welcomeHeader: "Esqueci minha senha",
    welcomeSubHeader: "Digite seu e-mail para receber um link de redefini\xE7\xE3o de senha."
  },
  resetPasswordPage: {
    welcomeHeader: "Redefinir senha",
    welcomeSubHeader: "Digite sua nova senha",
    goBack: "Ou <link>volte para a p\xE1gina de login</link>"
  },
  emailLinkAccessPage: {
    welcomeHeader: "Entrar com link por e-mail",
    successRedirecting: "Login realizado com sucesso! Redirecionando...",
    goBack: "Ou <link>volte para a p\xE1gina de login</link>",
    validatingLink: "Validando o link de acesso, aguarde...",
    linkInvalidOrExpired: "O link \xE9 inv\xE1lido ou expirou. Gere um novo.",
    tokenValidationError: "Ocorreu um erro na valida\xE7\xE3o do token: {{error}}. Gere um novo link ou entre em contato com o suporte se o problema persistir.",
    backToSignIn: "Voltar para a p\xE1gina de login",
    missingToken: "Nenhum token encontrado na URL. Use o link enviado ao seu e-mail ou solicite um novo."
  },
  organizationSignUpPage: {
    welcomeHeader: "Cadastre-se",
    welcomeSubHeader: "Digite sua senha para se cadastrar.",
    submitButtonLabel: "Cadastrar-se"
  },
  organizationSignUpExpiredPage: {
    welcomeHeader: "O convite expirou",
    welcomeSubHeader: "Escreva para este e-mail para que nossos administradores reenviem seu convite."
  },
  organisationPage: {
    addOrganisationModalLabel: "Adicionar organiza\xE7\xE3o",
    editOrganizationModalLabel: "Editar organiza\xE7\xE3o",
    addressUnavailable: "Endere\xE7o indispon\xEDvel",
    websiteUnavailable: "Site indispon\xEDvel",
    deleteOrganizationModalTitle: "Excluir organiza\xE7\xE3o",
    deleteOrganizationModalText: "Tem certeza de que deseja excluir esta organiza\xE7\xE3o e todos os seus usu\xE1rios? Os im\xF3veis associados \xE0 organiza\xE7\xE3o n\xE3o ser\xE3o exclu\xEDdos."
  },
  organizationSaleTeams: {
    addOrganisationModalLabel: "Adicionar equipe de vendas",
    editOrganizationModalLabel: "Editar equipe de vendas",
    addressUnavailable: "Endere\xE7o indispon\xEDvel",
    websiteUnavailable: "Site indispon\xEDvel",
    deleteOrganizationSaleTeamModalLabel: "Excluir equipe de vendas",
    deleteOrganizationSaleTeamModalText: "Tem certeza de que deseja excluir a equipe de vendas {{saleTeamName}}?"
  },
  organizationUsers: {
    addOrganisationUserModalLabel: "Adicionar usu\xE1rio \xE0 organiza\xE7\xE3o",
    editOrganisationUserModalLabel: "Editar usu\xE1rio da organiza\xE7\xE3o",
    inviteUserModalTitle: "Enviar convite",
    inviteUserModalSubtitle: "Voc\xEA gostaria de convidar este usu\xE1rio para a DASH?",
    inviteUserModalCancelButton: "N\xE3o, obrigado",
    inviteUserModalSubmitButton: "Convidar",
    archiveUserModalTitle: "Arquivar usu\xE1rio",
    archiveUserModalSubtitle: "Tem certeza de que deseja arquivar este usu\xE1rio da organiza\xE7\xE3o?",
    unarchiveUserModalTitle: "Desarquivar usu\xE1rio",
    unarchiveUserModalSubtitle: "Tem certeza de que deseja desarquivar este usu\xE1rio da organiza\xE7\xE3o?"
  },
  amenityPage: {
    updateAmenityModalLabel: "Atualizar comodidade",
    addAmenityModalLabel: "Adicionar comodidade",
    deleteAmenityModalLabel: "Excluir comodidade",
    deleteAmenityModalText: "Tem certeza de que deseja excluir a comodidade: {{amenityName}}?"
  },
  marketAreasPage: {
    updateMarketAreaModalLabel: "Atualizar regi\xE3o de mercado",
    addMarketAreaModalLabel: "Adicionar regi\xE3o de mercado",
    deleteMarketAreaModalNote: "Isso pode afetar os im\xF3veis associados"
  },
  propertyPage: {
    propertyName: "Nome do im\xF3vel",
    mediaItemsCount: "({{itemsCount}} itens)",
    propertyCreateModalTitle: "Adicionar novo im\xF3vel",
    amenitiesTabLabel: "Caracter\xEDsticas e comodidades",
    buildingDetails: "Detalhes do im\xF3vel",
    salesGalleryHours: "Hor\xE1rio do stand de vendas",
    salesGalleryInfo: "Informa\xE7\xF5es do stand de vendas",
    salesGallery: "Stand de vendas",
    leasingOfficeHours: "Hor\xE1rio do escrit\xF3rio de loca\xE7\xE3o",
    leasingOfficeInfo: "Informa\xE7\xF5es do escrit\xF3rio de loca\xE7\xE3o",
    virtualTours: "Tours virtuais",
    virtualTour: "Tour virtual",
    leasingOffice: "Escrit\xF3rio de loca\xE7\xE3o",
    viewDetails: "Ver detalhes",
    subscribeToUnlock: "Assine para desbloquear este im\xF3vel",
    viewAllHighlights: "Ver todos os destaques",
    viewFullOverview: "Ver vis\xE3o geral completa",
    manageAmenities: "Gerenciar comodidades",
    searchAmenities: "Buscar comodidades",
    propertyFeaturesAndAmenities: "Caracter\xEDsticas e comodidades do im\xF3vel",
    removeAmenityFromPropertyModalTitle: "Remover comodidade",
    removeAmenityFromPropertyModalText: "Tem certeza de que deseja remover a comodidade {{amenityName}} deste im\xF3vel?",
    inventoryCreateModalTitle: "Adicionar nova unidade",
    slideshow: "Slideshow",
    main: "Principal",
    inventoryEditModalTitle: "Editar unidade",
    completedIn: "Conclu\xEDdo em {{date}}",
    estCompletion: "Conclus\xE3o est. em {{date}}",
    uploadMedia: "Enviar m\xEDdia",
    cancelAllUpdates: "Cancelar todos os envios",
    clearUploadHistory: "Limpar hist\xF3rico de envios",
    floorPlan: "Planta (PDF)",
    addFloorPlan: "Adicionar planta",
    mediaFiles: "Arquivos de m\xEDdia",
    searchMedia: "Buscar pastas e arquivos de m\xEDdia",
    allFileTypes: "Todos os tipos de arquivo",
    paginationLabel: "Mostrando a p\xE1gina {{page}} de {{total}}",
    paginationMediaLabel: "Mostrando a p\xE1gina {{page}} de {{total}}",
    noFilesPlaceholder: "N\xE3o h\xE1 imagens ou v\xEDdeos no Slideshow. Para adicionar conte\xFAdo ao Slideshow, v\xE1 at\xE9 a aba de m\xEDdia e adicione os arquivos \xE0 pasta padr\xE3o chamada Slideshow",
    addFolderModalLabel: "Criar pasta",
    editFolderModalLabel: "Editar pasta",
    removeFolderModalLabel: "Excluir pasta",
    editMediaModalLabel: "Editar nome do arquivo",
    removeFolderModalBodyLabel: "Tem certeza de que deseja excluir a pasta \u201C{{folderName}}\u201D? O conte\xFAdo desta pasta ser\xE1 movido para a se\xE7\xE3o de arquivos.",
    removeFolderModalCheckboxLabel: "Marque aqui para excluir tamb\xE9m o conte\xFAdo da pasta",
    deleteFileModalTitle: "Excluir arquivo",
    deleteFileModalPlaceholder: "Tem certeza de que deseja excluir o arquivo {{fileName}}?",
    bulkDeleteFileModalPlaceholder: "Tem certeza de que deseja excluir os {{numberOfFiles}} arquivos selecionados?",
    folderDeletedMessage: "{{folderName}} foi exclu\xEDda com sucesso",
    salesTeam: "Equipe de vendas",
    addMoreUsers: "Adicionar mais usu\xE1rios",
    leavePage: "Sair da p\xE1gina",
    goBack: "Voltar",
    confirmChangesModalTitle: "Suas altera\xE7\xF5es ainda n\xE3o foram salvas",
    confirmChangesModalText: "Tem certeza de que deseja sair desta p\xE1gina? Suas altera\xE7\xF5es n\xE3o ser\xE3o salvas.",
    confirmChangelogCreationModalTitle: "Visibilidade das atualiza\xE7\xF5es do im\xF3vel",
    confirmChangelogCreationModalText: "Voc\xEA gostaria de tornar as altera\xE7\xF5es atuais vis\xEDveis para os corretores no Hist\xF3rico p\xFAblico de atualiza\xE7\xF5es do im\xF3vel?",
    addToChangelogButton: "Sim, tornar p\xFAblico",
    dontAddToChangelogButton: "N\xE3o, manter interno",
    addToChangelogCheckbox: "Adicionar altera\xE7\xF5es ao hist\xF3rico p\xFAblico de atualiza\xE7\xF5es do im\xF3vel",
    moveFileModalTitle: "Mover para a pasta",
    moveFileModalText: "Selecione a pasta para a qual voc\xEA quer transferir este arquivo",
    moveToFolder: "Mover para a pasta",
    changeBranding: "Alterar marca",
    updateBrandingTitle: "Atualizar marca do arquivo",
    updateBrandingType: "Atualizar tipo de marca",
    updateBranding: "Atualizar marca",
    bulkUpdateBrandingText: "Atualizar o tipo de marca de {{quantity}} arquivos selecionados",
    brandingTypeUpdated: "Tipo de marca atualizado com sucesso",
    bulkBrandingTypeUpdated: "Tipo de marca atualizado em {{count}} arquivos",
    brandedFilesReadyEnabled: "Os arquivos com marca agora est\xE3o prontos",
    brandedFilesReadyDisabled: "Os arquivos com marca agora est\xE3o marcados como n\xE3o prontos",
    currentFile: "Arquivo atual",
    bulkActionsText: "{{quantity}} itens selecionados para a\xE7\xE3o em massa",
    searchProperty: "Buscar pelo nome do im\xF3vel",
    price: "Pre\xE7o",
    propertyType: "Tipo de im\xF3vel",
    advanced: "Avan\xE7ado",
    bedsAndBath: "Quartos e banheiros",
    allListing: "Todos os im\xF3veis",
    alertListing: "Alertas de im\xF3veis",
    savedSearches: "Buscas salvas",
    resultsFor: "{{total}} im\xF3veis encontrados",
    resultsLimited: "Mostrando {{total}} de {{totalProperties}}+ im\xF3veis",
    availableUnits: "Unid. disp.",
    from: "A partir de",
    upTo: "At\xE9",
    noProperties: "Sua busca n\xE3o retornou nenhum im\xF3vel.",
    showFeaturesAndAmenities: "Mostrar todas as caracter\xEDsticas e comodidades",
    seeMoreAmenities: "Ver mais {{count}} comodidades",
    seeMoreAmenities_one: "Ver mais {{count}} comodidade",
    seeMoreAmenities_other: "Ver mais {{count}} comodidades",
    startFreeTrial: "Iniciar teste gr\xE1tis",
    lockedAmenitiesAriaLabel: "Conte\xFAdo bloqueado. Fa\xE7a upgrade para ver mais {{count}} comodidades. Inicie o teste gr\xE1tis.",
    lockedAmenitiesAriaLabel_one: "Conte\xFAdo bloqueado. Fa\xE7a upgrade para ver mais {{count}} comodidade. Inicie o teste gr\xE1tis.",
    lockedAmenitiesAriaLabel_other: "Conte\xFAdo bloqueado. Fa\xE7a upgrade para ver mais {{count}} comodidades. Inicie o teste gr\xE1tis.",
    filterTitle: "Filtro avan\xE7ado",
    filterSubtitle: "Aplique filtros avan\xE7ados \xE0 sua busca.",
    numberOfBedrooms: "N\xFAmero de quartos",
    numberOfBathrooms: "N\xFAmero de banheiros",
    saveAndCreateAlert: "Salvar e criar alerta",
    createAlert: "Criar alerta",
    clearFilter: "Limpar filtro",
    goToTheClosestProperty: "Ir para o im\xF3vel mais pr\xF3ximo",
    noPropertiesWereFoundOnMap: "Nenhum im\xF3vel foi encontrado para a sua busca. Use a busca pelos im\xF3veis mais pr\xF3ximos para ver im\xF3veis na regi\xE3o.",
    contact: "Contatar incorporadora",
    contactDevelopmentSales: "Contatar vendas do empreendimento",
    contactAgent: "Fale comigo sobre disponibilidade",
    contactLeasingOffice: "Contatar escrit\xF3rio de loca\xE7\xE3o",
    addToPortfolio: "Adicionar ao portf\xF3lio",
    addToPortfolioFolder: "Adicionar ao portf\xF3lio",
    addToPortfolioTooltip: "Adicionar ao portf\xF3lio",
    addToMorePortfoliosTooltip: "Adicionar a mais portf\xF3lios",
    generatePropertyPortfolio: "Criar portf\xF3lio",
    viewAsClient: "Ver como cliente",
    contactMessage: "D\xFAvidas? Entre em contato com a incorporadora do im\xF3vel abaixo.",
    message: "Mensagem",
    lastUpdated: "\xDAltima atualiza\xE7\xE3o",
    history: "Hist\xF3rico",
    checkAvailability: "Consultar disponibilidade",
    propertyPortfolio: "Portf\xF3lio de im\xF3veis ({{amount}})",
    viewAll: "Ver todos",
    presentedBy: "Apresentado por",
    editAmenityNameModalTitle: "Editar nome da comodidade",
    deleteProperty: "Excluir im\xF3vel",
    deletePropertyModalConfirmationText: "Tem certeza de que deseja excluir este im\xF3vel?",
    appearedDate: "Data de inclus\xE3o",
    scheduledConstruction: "Obra prevista",
    numberOfUnits: "N\xFAmero de unidades",
    yearBuilt: "Ano de constru\xE7\xE3o",
    addToTrackToast: "O im\xF3vel foi adicionado \xE0 pasta de acompanhamento",
    addToSaveToast: "O im\xF3vel foi adicionado \xE0 sua lista de acompanhamento",
    propertyAlreadyTracked: "Voc\xEA j\xE1 est\xE1 acompanhando este im\xF3vel.",
    propertyAlreadySaved: "Este im\xF3vel j\xE1 est\xE1 na sua lista de acompanhamento.",
    propertyRemovedFromTrack: "O im\xF3vel foi removido da sua lista de acompanhamento",
    propertyRemovedFromSave: "O im\xF3vel foi removido da sua lista de acompanhamento",
    unavailablePropertyTitle: "Im\xF3vel indispon\xEDvel",
    unavailablePropertySubTitle: "Este im\xF3vel est\xE1 indispon\xEDvel no momento. Entre em contato com o suporte para mais detalhes.",
    propertyNote: "Anota\xE7\xF5es do im\xF3vel",
    deletePropertyNote: "Excluir anota\xE7\xE3o",
    deletePropertyNoteModalConfirmationText: "Tem certeza de que deseja excluir a anota\xE7\xE3o da lista de anota\xE7\xF5es deste im\xF3vel?",
    addSaleTeam: "Adicionar equipe de vendas",
    propertySearchPlaceholder: "Edif\xEDcio, cidade, bairro, comunidade",
    allMarket: "Regi\xE3o de mercado",
    priceRange: "Faixa de pre\xE7o",
    allPropertyStatus: "Status do empreendimento",
    completionDate: "Ano est. de conclus\xE3o",
    propertyLocation: "Localiza\xE7\xE3o do im\xF3vel",
    developmentAndSalesLabel: "Incorpora\xE7\xE3o e vendas",
    mediaEmptyState: "N\xE3o h\xE1 arquivos nesta pasta",
    deleteSalesTeam: "Excluir equipe de vendas",
    deleteSalesTeamText: "Tem certeza de que deseja excluir a equipe de vendas?",
    noPrimaryOrganizationError: "O im\xF3vel precisa ter uma organiza\xE7\xE3o principal.",
    noMarketAreaError: "O im\xF3vel precisa ter uma regi\xE3o de mercado.",
    statusUpdateSuccess: "Status atualizado com sucesso",
    statusUpdateError: "N\xE3o foi poss\xEDvel atualizar o status",
    cmsStatusUpdateSuccess: "Status do CMS atualizado com sucesso",
    cmsStatusUpdateError: "N\xE3o foi poss\xEDvel atualizar o status do CMS",
    visibilityStatusUpdateSuccess: "Status de visibilidade atualizado com sucesso",
    visibilityStatusUpdateError: "N\xE3o foi poss\xEDvel atualizar o status de visibilidade",
    sort: "Ordenar",
    sortBy: "Ordenar por",
    seeXMoreUnits: "Ver mais {{count}} unidades",
    seeXMoreUnits_one: "Ver mais {{count}} unidade",
    seeXMoreUnits_other: "Ver mais {{count}} unidades",
    seeXMoreUnitsCaps: "Ver mais {{count}} unidades",
    seeXMoreUnitsCaps_one: "Ver mais {{count}} unidade",
    seeXMoreUnitsCaps_other: "Ver mais {{count}} unidades",
    viewAllFloorPlansPricingAvailability: "Ver todas as plantas, pre\xE7os e disponibilidade",
    showingXOfYUnits: "Mostrando {{current}} de {{total}} unidades",
    today: "hoje",
    daysAgo: "h\xE1 {{days}} dias",
    daysAgo_one: "h\xE1 {{days}} dia",
    daysAgo_other: "h\xE1 {{days}} dias",
    monthsAgo: "h\xE1 {{months}} meses",
    monthsAgo_one: "h\xE1 {{months}} m\xEAs",
    monthsAgo_other: "h\xE1 {{months}} meses",
    yearsAgo: "h\xE1 {{years}} anos",
    yearsAgo_one: "h\xE1 {{years}} ano",
    yearsAgo_other: "h\xE1 {{years}} anos"
  },
  propertyMediaFolderPage: {
    noFilesPlaceholder: "Esta pasta est\xE1 vazia"
  },
  featuredPortfolios: {
    propertyUnavailable: "Im\xF3vel n\xE3o encontrado ou n\xE3o est\xE1 mais dispon\xEDvel.",
    title: "Portf\xF3lios em destaque",
    subtitle: "Cole\xE7\xF5es selecionadas de lan\xE7amentos que voc\xEA pode acessar, salvar, editar e compartilhar na hora com seu pr\xF3prio link personalizado.",
    viewAll: "Ver todos",
    portfolioDetails: "Ver detalhes",
    details: "Detalhes do portf\xF3lio",
    otherProperties: "Outros im\xF3veis",
    moreProperties: "Outras unidades",
    properties_one: "{{count}} im\xF3vel",
    properties_other: "{{count}} im\xF3veis",
    createModalTitle: "Novo portf\xF3lio em destaque",
    createButton: "Criar portf\xF3lio",
    editPortfolio: "Editar portf\xF3lio",
    deletePortfolio: "Excluir portf\xF3lio",
    deleteConfirmation: "Tem certeza de que deseja excluir este portf\xF3lio? Esta a\xE7\xE3o n\xE3o pode ser desfeita.",
    notFound: "Portf\xF3lio n\xE3o encontrado",
    visibilityUpdateSuccess: "Visibilidade atualizada com sucesso",
    visibilityUpdateError: "N\xE3o foi poss\xEDvel atualizar a visibilidade",
    noPropertiesAdded: "Nenhum im\xF3vel adicionado a este portf\xF3lio",
    propertyAlreadyAdded: "Este im\xF3vel j\xE1 est\xE1 no portf\xF3lio",
    propertyAdded: "Im\xF3vel adicionado",
    propertyRemoved: "Im\xF3vel removido",
    noSearchResults: "Nenhum im\xF3vel encontrado",
    labels: {
      overview: "Vis\xE3o geral",
      cardDescription: "Descri\xE7\xE3o do card",
      saved: "Portf\xF3lio salvo com sucesso",
      previewModal: "Pr\xE9via do modal",
      previewCard: "Pr\xE9via do card",
      properties: "Im\xF3veis",
      propertiesAdded: "Im\xF3veis adicionados",
      finishSorting: "Concluir ordena\xE7\xE3o",
      resetOrder: "Redefinir ordem",
      resetChanges: "Descartar altera\xE7\xF5es",
      sort: "Ordenar"
    },
    sortModal: {
      title: "Ordenar portf\xF3lios p\xFAblicos em destaque",
      cancel: "Cancelar",
      save: "Salvar",
      instruction: "Arraste e solte para reordenar os portf\xF3lios. As altera\xE7\xF5es ser\xE3o salvas quando voc\xEA clicar em Salvar.",
      noPublicPortfolios: "Nenhum portf\xF3lio p\xFAblico para ordenar"
    },
    makePublicModal: {
      modalTitle: "Tornar portf\xF3lio p\xFAblico",
      warningTitle: "Tornar portf\xF3lio p\xFAblico?",
      cancel: "Cancelar",
      continue: "Continuar",
      makePublic: "Tornar p\xFAblico",
      message: 'Onde voc\xEA quer posicionar "{{portfolioName}}"?',
      warningMessage: 'O portf\xF3lio "{{portfolioName}}" tem atualmente apenas {{count}} {{count}} adicionado. Tem certeza de que deseja public\xE1-lo?',
      warningMessage_one: 'O portf\xF3lio "{{portfolioName}}" tem atualmente apenas {{count}} im\xF3vel adicionado. Tem certeza de que deseja public\xE1-lo?',
      warningMessage_other: 'O portf\xF3lio "{{portfolioName}}" tem atualmente apenas {{count}} im\xF3veis adicionados. Tem certeza de que deseja public\xE1-lo?',
      firstOption: "Primeiro",
      firstOptionDesc: "O portf\xF3lio aparecer\xE1 no in\xEDcio",
      lastOption: "\xDAltimo",
      lastOptionDesc: "O portf\xF3lio aparecer\xE1 no fim"
    },
    sortSuccess: "Portf\xF3lios reordenados com sucesso",
    sortError: "N\xE3o foi poss\xEDvel reordenar os portf\xF3lios",
    placeholders: {
      searchProperty: "Buscar um im\xF3vel..."
    },
    buttons: {
      addProperty: "Adicionar im\xF3vel"
    },
    resetChangesConfirmation: {
      title: "Descartar todas as altera\xE7\xF5es?",
      message: "Tem certeza de que deseja descartar todas as altera\xE7\xF5es? Isso remover\xE1 os im\xF3veis rec\xE9m-adicionados e voltar\xE1 ao \xFAltimo estado salvo."
    },
    resetOrderConfirmation: {
      title: "Redefinir a ordem dos im\xF3veis?",
      message: "Tem certeza de que deseja redefinir a ordem dos im\xF3veis? Isso restaurar\xE1 a ordem original dos im\xF3veis salvos, mantendo os rec\xE9m-adicionados."
    },
    resetConfirmation: {
      cancel: "Cancelar",
      confirm: "Confirmar"
    },
    modal: {
      title: "Portf\xF3lio em destaque",
      properties: "Im\xF3veis",
      overview: "Vis\xE3o geral",
      viewPortfolio: "Ver portf\xF3lio",
      sharePortfolio: "Compartilhar portf\xF3lio",
      completionFrom: "Conclus\xE3o de",
      to: "a",
      propertiesCount: "im\xF3veis",
      marketAreasLabel: "Regi\xF5es de mercado neste portf\xF3lio:",
      showLess: "Mostrar menos",
      xMore: "+{{count}} a mais",
      estCompletion: "Conclus\xE3o est. {{year}}"
    },
    agentBanner: {
      title: "Portf\xF3lio em destaque",
      agentCollection: "Visualizando agora",
      share: "Compartilhar",
      notice: "Este cabe\xE7alho N\xC3O ser\xE1 exibido quando voc\xEA compartilhar o portf\xF3lio com seus clientes."
    },
    quickSharePortfolio: "Link de compartilhamento instant\xE2neo",
    sharePortfolio: "Compartilhar portf\xF3lio em destaque",
    addToSaveToast: "O portf\xF3lio foi adicionado \xE0 sua lista de acompanhamento",
    portfolioAlreadySaved: "Este portf\xF3lio j\xE1 est\xE1 na sua lista de acompanhamento.",
    portfolioRemovedFromSave: "O portf\xF3lio foi removido da sua lista de acompanhamento",
    copyToPortfolio: "Copiar para meu portf\xF3lio",
    copyToPortfolioDescription: "Copie este portf\xF3lio em destaque para poder personaliz\xE1-lo.",
    copyToPortfolioButton: "Copiar para meus portf\xF3lios",
    copying: "Copiando...",
    toasts: {
      featuredPortfolioCopied: "Portf\xF3lio em destaque copiado com sucesso!",
      copyError: "N\xE3o foi poss\xEDvel copiar o portf\xF3lio",
      portfolioNameExists: "Voc\xEA j\xE1 tem um portf\xF3lio com este nome"
    },
    duplicateFeaturedPortfolioModal: {
      title: "O portf\xF3lio j\xE1 existe",
      samePortfolioNameText: "J\xE1 existe um portf\xF3lio com este nome. Voc\xEA pode compartilhar o portf\xF3lio existente usando o link abaixo:",
      unableToLoadPortfolioData: "N\xE3o foi poss\xEDvel carregar os dados do portf\xF3lio. Tente novamente.",
      portfolioDataNotFound: "Dados do portf\xF3lio n\xE3o encontrados. Tente novamente.",
      clickHere: "Clique aqui",
      toViewPortfolioDetails: "para ver os detalhes do portf\xF3lio.",
      createNewPortfolioText: "Para criar um novo portf\xF3lio, digite um nome diferente abaixo:",
      createPortfolio: "Criar portf\xF3lio",
      portfolioNameAlreadyExistsError: "Voc\xEA j\xE1 tem um portf\xF3lio com este nome"
    },
    seeXMore: "Ver mais {{count}}",
    seeXMore_one: "Ver mais {{count}} portf\xF3lio",
    seeXMore_other: "Ver mais {{count}} portf\xF3lios",
    seeXMoreCaps: "Ver mais {{count}}",
    seeXMoreCaps_one: "Ver mais {{count}}",
    seeXMoreCaps_other: "Ver mais {{count}}",
    viewAllPortfolios: "Ver todos os portf\xF3lios em destaque",
    startFreeTrial: "Iniciar teste gr\xE1tis",
    unlockDescription: "Acesse nossas cole\xE7\xF5es selecionadas, prontas para compartilhar",
    unlockPortfolio: "Desbloquear portf\xF3lio",
    unlockPortfolios: "Ver portf\xF3lios"
  },
  featuredProperties: {
    title: "Im\xF3veis em destaque",
    subtitle: "Im\xF3veis individuais que voc\xEA pode selecionar e destacar para acesso e compartilhamento instant\xE2neos.",
    createModalTitle: "Novo im\xF3vel em destaque",
    createButton: "Criar im\xF3vel",
    createSuccess: "Im\xF3vel em destaque criado com sucesso",
    visibilityUpdateSuccess: "Visibilidade atualizada com sucesso",
    visibilityUpdateError: "N\xE3o foi poss\xEDvel atualizar a visibilidade",
    labels: {
      property: "Im\xF3vel selecionado",
      propertyRequired: "O im\xF3vel \xE9 obrigat\xF3rio",
      overview: "Vis\xE3o geral",
      shortOverview: "Vis\xE3o geral resumida",
      bannerPreview: "Pr\xE9via do banner",
      saved: "Im\xF3vel em destaque salvo com sucesso",
      searching: "Buscando...",
      noPropertiesFound: "Nenhum im\xF3vel encontrado",
      desktopPreviewComingSoon: "Pr\xE9via para desktop em breve",
      mobilePreviewComingSoon: "Pr\xE9via para celular em breve",
      overviewPlaceholder: "Escreva uma vis\xE3o geral detalhada...",
      shortOverviewPlaceholder: "Escreva um breve resumo..."
    },
    deleteProperty: "Excluir im\xF3vel",
    sortModal: {
      title: "Ordenar im\xF3veis p\xFAblicos em destaque",
      cancel: "Cancelar",
      save: "Salvar",
      instruction: "Arraste e solte para reordenar os im\xF3veis. As altera\xE7\xF5es ser\xE3o salvas quando voc\xEA clicar em Salvar.",
      noPublicProperties: "Nenhum im\xF3vel p\xFAblico para ordenar"
    },
    sortSuccess: "Ordem de exibi\xE7\xE3o atualizada com sucesso",
    sortError: "N\xE3o foi poss\xEDvel atualizar a ordem de exibi\xE7\xE3o",
    makePublicModal: {
      modalTitle: "Tornar im\xF3vel p\xFAblico",
      warningTitle: "Tornar im\xF3vel p\xFAblico?",
      cancel: "Cancelar",
      continue: "Continuar",
      makePublic: "Tornar p\xFAblico",
      message: 'Onde voc\xEA quer posicionar "{{portfolioName}}"?',
      warningMessage: 'O im\xF3vel "{{portfolioName}}" est\xE1 prestes a ser publicado. Tem certeza de que deseja continuar?',
      warningMessage_one: 'O im\xF3vel "{{portfolioName}}" est\xE1 prestes a ser publicado. Tem certeza de que deseja continuar?',
      firstOption: "No in\xEDcio",
      firstOptionDesc: "Colocar na primeira posi\xE7\xE3o da lista",
      lastOption: "No fim",
      lastOptionDesc: "Colocar na \xFAltima posi\xE7\xE3o da lista"
    }
  },
  propertyPreviewPage: {
    websiteLink: "Link do site",
    generalTabLabel: "Info do im\xF3vel",
    additionalTabLabel: "Info adicional",
    marketingTabLabel: "Materiais de marketing",
    propertyDownloadsTabLabel: "Downloads do im\xF3vel",
    downloadsTabLabel: "Downloads",
    downloadsLabel: "Downloads",
    developerInfoLabel: "Incorporadora",
    salesTeamLabel: "Equipe de vendas",
    propertyManagementLabel: "Administra\xE7\xE3o do im\xF3vel",
    additionalInformation: "Informa\xE7\xF5es adicionais",
    additionalInformationShort: "Info adic.",
    nbrOfStories: "N\xFAmero de andares",
    nbrOfTowers: "N\xFAmero de torres",
    constructionDate: "Data de constru\xE7\xE3o",
    completionDate: "Data de conclus\xE3o",
    marketingFilesLabel: "Materiais de marketing",
    marketingFilesSecondLabel: "Abaixo voc\xEA encontra todos os materiais de marketing deste im\xF3vel.",
    propertyDownloadsLabel: "Downloads do im\xF3vel",
    propertyDownloadsSecondLabel: "Abaixo voc\xEA encontra todos os downloads e recursos dispon\xEDveis para este im\xF3vel.",
    noSaleTeamLabel: "Sem equipe de vendas",
    moreInformation: "Mais informa\xE7\xF5es",
    historyLabel: "Este im\xF3vel foi {{date}} pela \xFAltima vez.",
    lastUpdatedToday: "Este im\xF3vel foi atualizado hoje.",
    lastUpdatedDaysAgo_one: "Este im\xF3vel foi atualizado h\xE1 {{count}} dia.",
    lastUpdatedDaysAgo_other: "Este im\xF3vel foi atualizado h\xE1 {{count}} dias.",
    lastUpdatedLabel: "\xDAltima atualiza\xE7\xE3o {{date}}",
    unknownDateLabel: "Desconhecida",
    shareActionLabel: "Compartilhar",
    saveActionLabel: "Adicionar \xE0 lista de acompanhamento",
    savedActionLabel: "Na lista de acompanhamento",
    shareProperty: "Compartilhar im\xF3vel",
    shareThisProperty: "Compartilhar este im\xF3vel",
    quickShareProperty: "Link de compartilhamento instant\xE2neo:",
    generateQuickShareLink: "Gerar link de compartilhamento",
    portfoliosDescription: "Se voc\xEA quer mais personaliza\xE7\xE3o e acesso \xE0s an\xE1lises de tr\xE1fego, use os portf\xF3lios:",
    quickShareDescription: "Copie o link direto para compartilhar este im\xF3vel imediatamente",
    loadingShareLink: "Gerando link de compartilhamento...",
    instantShareDescription: "Compartilhe agora com um link com a sua marca de corretor.",
    addToPortfolioDescription: "Adicione este im\xF3vel a um dos seus portf\xF3lios de im\xF3veis salvos.",
    createPortfolioDescription: "Personalize as configura\xE7\xF5es, adicione downloads e ajuste os detalhes antes de compartilhar.",
    stickyHeader: {
      propertyInfo: "Informa\xE7\xF5es do im\xF3vel",
      propertyInfoShort: "Info do im\xF3vel",
      inventory: "Plantas",
      contactInfo: "Contato",
      contactInfoShort: "Contato",
      downloads: "Downloads",
      downloadsShort: "Arquivos"
    }
  },
  wasDeleted: {
    title: "{{entityName}} foi exclu\xEDdo"
  },
  notFoundPage: {
    title: "N\xE3o encontrada",
    subtitle: "A p\xE1gina que voc\xEA procura pode ter sido removida, ter mudado de nome ou estar temporariamente indispon\xEDvel",
    buttonLabel: "Ir para a p\xE1gina inicial",
    notFound404: "404 N\xE3o encontrado",
    generalTabLabel: "Info do im\xF3vel",
    additionalTabLabel: "Info adicional",
    marketingTabLabel: "Materiais de marketing"
  },
  idx: {
    unauthorizedTitle: "N\xE3o autorizado",
    unauthorizedSubtitle: "Ei, este dom\xEDnio n\xE3o est\xE1 autorizado a usar os dados do eXchange!",
    visitDash: "Visitar a DASH",
    labels: {
      showDashCredit: "Mostrar cr\xE9dito de dados da DASH",
      showPropertyDownloads: "Mostrar materiais de vendas",
      showCustomPropertyDownloads: "Mostrar somente materiais de vendas personalizados",
      managePropertyDownloads: "Gerenciar materiais de vendas",
      back: "Voltar",
      backToPortfolio: "Voltar ao portf\xF3lio",
      contact: "Contato"
    },
    tooltips: {
      showDashCredit: "Ative ou desative o cr\xE9dito 'Powered By DASH' nos seus feeds do eXchange.",
      showPropertyDownloads: "Ative para permitir que os clientes vejam todos os materiais de vendas dispon\xEDveis de um im\xF3vel.",
      showCustomPropertyDownloads: "Ative para exibir somente os materiais de vendas personalizados por voc\xEA."
    }
  },
  footer: {
    termsLabel: "Termos e condi\xE7\xF5es",
    policyLabel: "Pol\xEDtica de privacidade",
    rightLabel: "2026 DASH Inc. Todos os direitos reservados.",
    termsOfService: "Termos de Servi\xE7o"
  },
  completeSignUp: {
    pickPlan: "Escolher plano",
    setupSubscriptionLabel: "Configurar assinatura",
    setupSubscriptionShortLabel: "Configurar",
    additionalLabel: "Info adicional",
    additionalShortLabel: "Info adic."
  },
  completeSignUpPickSubscription: {
    header: "Escolha uma assinatura",
    subheader: "Escolha entre as op\xE7\xF5es dispon\xEDveis",
    // DSH-923: shown only on the API invite path, where the API plan is the one
    // option. Deliberately a plain sentence and not a link/button — an invitee
    // who wants the agent platform should be able to find their way, without
    // being offered an exit from the path they were invited into.
    apiOnlyNote: "Voc\xEA foi convidado para a API da DASH, por isso este \xE9 o plano dispon\xEDvel aqui. Se voc\xEA \xE9 corretor de im\xF3veis e procura a plataforma DASH, pode se cadastrar separadamente em dashtodash.com.",
    trialLabel: "Teste gr\xE1tis de {{countOfDays}} dias",
    noTrialLabel: "Fazer upgrade para o Pro",
    submitButtonLabel: "Teste gr\xE1tis de {{countOfDays}} dias",
    cancelMySubscription: "Cancelar minha assinatura",
    couponMiddleLabel: "vs. nosso plano {{recurringType}}",
    stayOnthisPlan: "Continuar neste plano",
    subscribeBasic: "Come\xE7ar gr\xE1tis com o plano Basic",
    subscribePro: "Assinar o plano PRO",
    subscribeIdx: "Assinar o plano DASH Exchange",
    promoInvalid: "Esse c\xF3digo promocional n\xE3o \xE9 v\xE1lido. Remova-o ou digite outro.",
    promoLabel: "Tem um c\xF3digo promocional?",
    promoPlaceholder: "Digite o c\xF3digo (opcional)",
    newBadge: "NOVO",
    subscriptionProductRecurringLabels: {
      [(0, import_lodash6.camelCase)(import_dash_common6.RecurringTypesEnum.FREE)]: "Gr\xE1tis",
      [(0, import_lodash6.camelCase)(import_dash_common6.RecurringTypesEnum.MONTH)]: "Mensal",
      [(0, import_lodash6.camelCase)(import_dash_common6.RecurringTypesEnum.SIXMONTH)]: "Semestral",
      [(0, import_lodash6.camelCase)(import_dash_common6.RecurringTypesEnum.YEAR)]: "Anual"
    }
  },
  completeSignUpAddAdditionalInfoPage: {
    header: "Info adicional",
    subheader: "Preencha agora ou depois",
    profileSubHeader: "Perfil",
    locationSubHeader: "2. Localiza\xE7\xE3o",
    settingsSubHeader: "3. Configura\xE7\xF5es de im\xF3veis"
  },
  portfoliosPage: {
    addPropertyToPortfolioModalTitle: "Adicionar im\xF3vel a um portf\xF3lio",
    addPropertyToPortfolioModalText: "Crie portf\xF3lios para organizar e compartilhar o conte\xFAdo dos im\xF3veis com seus clientes e parceiros.",
    existingFolder: "Portf\xF3lio existente",
    selectFolder: "Selecionar portf\xF3lio",
    createNewFolder: "Criar um novo portf\xF3lio",
    folderName: "Nome do portf\xF3lio",
    enterFolderName: "Digite o nome do novo portf\xF3lio",
    statuses: {
      [import_dash_common6.BrokerPortfolioStatusesEnum.PRIVATE]: "Privado/Rascunho",
      [import_dash_common6.BrokerPortfolioStatusesEnum.PUBLIC]: "Link p\xFAblico",
      password: "Link protegido por senha"
    },
    propertiesTotal: "{{total}} im\xF3veis",
    portfoliosTotal: "{{total}} itens do portf\xF3lio",
    totalViews: "{{total}} visualiza\xE7\xF5es",
    views: "Visualiza\xE7\xF5es",
    portfoliosSearchPlaceholder: "Buscar pelo nome do portf\xF3lio",
    portfoliosPropertySearchPlaceholder: "Buscar pelo nome do im\xF3vel",
    portfoliosSearchPlaceholderShort: "Buscar por portf\xF3lio",
    portfoliosPropertySearchPlaceholderShort: "Buscar por im\xF3vel",
    sort: "Ordenar",
    sortBy: "Ordenar por",
    addNew: "Adicionar",
    portfolioName: "Nome do portf\xF3lio",
    paginationLabel: "Mostrando o portf\xF3lio {{page}} de {{total}}",
    emptyPageLabel: "Voc\xEA ainda n\xE3o tem portf\xF3lios!",
    emptyPageSubLabel: "Crie portf\xF3lios para organizar e compartilhar o conte\xFAdo dos im\xF3veis com seus clientes e parceiros.",
    emptyPageButtonLabel: "Come\xE7ar a explorar",
    emptyPageGuideLabel: "Novo nos portf\xF3lios?",
    emptyPageGuideSubLabel: "Nosso guia mostra como cri\xE1-los e compartilh\xE1-los com seus clientes.",
    emptyPageGuideLinkLabel: "Leia o guia de in\xEDcio r\xE1pido do DASH Pro",
    createFolderModalTitle: "Adicionar portf\xF3lio",
    createFolderModalSubtitle: "Depois, adicione im\xF3veis ao seu portf\xF3lio para compartilhar.",
    portfolioNamePlaceholder: "Digite o nome do novo portf\xF3lio",
    toasts: {
      shareLinkCopied: "Link copiado!",
      folderIsCreated: "Portf\xF3lio criado",
      folderIsUpdated: "Portf\xF3lio atualizado",
      folderIsDeleted: "Portf\xF3lio exclu\xEDdo",
      portfolioIsCreated: "Portf\xF3lio criado",
      propertyWasAdded: "Im\xF3vel adicionado ao portf\xF3lio",
      propertyAlreadyAdded: "O im\xF3vel j\xE1 foi adicionado a este portf\xF3lio"
    },
    removePropertyFromPortfolioModal: {
      header: "Excluir im\xF3vel do portf\xF3lio",
      subheader: "Tem certeza de que deseja excluir este im\xF3vel do seu portf\xF3lio?"
    },
    removeFolderFromPortfolioModal: {
      header: "Excluir portf\xF3lio",
      subheader: "Tem certeza de que deseja excluir este portf\xF3lio?"
    },
    movePropertyToPortfolioFolderModal: {
      title: "Adicionar im\xF3vel ao portf\xF3lio",
      subtitle: "Criar um novo portf\xF3lio para este im\xF3vel ou adicion\xE1-lo a um portf\xF3lio existente?"
    },
    duplicatePortfolioModal: {
      title: "O portf\xF3lio j\xE1 existe",
      createNewPortfolio: "Criar novo portf\xF3lio",
      samePortfolioNameText: "J\xE1 existe um portf\xF3lio com este nome. Voc\xEA pode compartilhar o portf\xF3lio existente usando o link abaixo:",
      createNewPropertyPortfolioText: "Para criar um novo portf\xF3lio, digite um nome diferente abaixo:",
      portfolioNameAlreadyExistsError: "J\xE1 existe um portf\xF3lio com o nome informado.",
      loadError: "N\xE3o foi poss\xEDvel carregar os dados do portf\xF3lio. Tente novamente.",
      notFoundError: "Dados do portf\xF3lio n\xE3o encontrados. Tente novamente.",
      viewDetailsLink: "<italic><link>Clique aqui</link> para ver os detalhes do portf\xF3lio.</italic>"
    },
    followsLocationsOption: "{{name}} (segue localiza\xE7\xF5es)",
    followsLocationsHint: "Os im\xF3veis dele seguir\xE3o as localiza\xE7\xF5es que voc\xEA escolher.",
    newFolderLabel: "Nova pasta",
    emptyLocationsTitle: "Ainda n\xE3o h\xE1 im\xF3veis nessas localiza\xE7\xF5es",
    emptyLocationsText: "Os im\xF3veis anunciados nas localiza\xE7\xF5es deste portf\xF3lio aparecer\xE3o aqui automaticamente.",
    viewProperties: "Ver im\xF3veis",
    emptyPortfolioFolderSubtitle: "Este portf\xF3lio est\xE1 vazio. Para saber como adicionar im\xF3veis, acesse o suporte da DASH",
    emptyPortfolioFolderTitle: "Voc\xEA ainda n\xE3o tem im\xF3veis!",
    emptyPortfolioFolderText: "Acesse um im\xF3vel e adicione-o a este portf\xF3lio para compartilh\xE1-lo com seus clientes!",
    contactMe: "Fale comigo",
    availability: "Disponibilidade",
    propertiesReady: "Im\xF3veis prontos",
    propertiesSold: "Im\xF3veis vendidos",
    propertiesReadyShort: "Im\xF3v. prontos",
    propertiesSoldShort: "Im\xF3v. vendidos",
    customers: "Clientes",
    openPortfolioWithPasswordModal: {
      title: "Abrir o portf\xF3lio",
      subtitle: "Digite a senha para ver este portf\xF3lio."
    },
    rootFolder: "Pasta raiz",
    moreAboutPresenter: "Mais sobre o apresentador",
    viewPropertyPortfolio: "Ver portf\xF3lio de im\xF3veis",
    unitSizes: "Tamanhos das unidades",
    customize: "Personalizar",
    propertyComparison: "Compara\xE7\xE3o de im\xF3veis",
    selectItemsToCompare: "Selecione itens para comparar",
    viewSharedPortfolio: "Ver portf\xF3lio compartilhado",
    unavailablePortfolioPage: {
      title: "Portf\xF3lio indispon\xEDvel",
      subtitle: "O portf\xF3lio est\xE1 indispon\xEDvel no momento. Entre em contato com o corretor que o compartilhou para mais detalhes."
    }
  },
  portfolioDetailsPage: {
    labels: {
      properties: "{{number}} im\xF3veis",
      shared: "Compartilhado",
      views: "{{number}} visualiza\xE7\xF5es",
      shareFolder: "Compartilhar portf\xF3lio",
      deleteFolder: "Excluir portf\xF3lio",
      moveProperty: "Mover im\xF3vel",
      removeProperty: "Remover im\xF3vel",
      move: "Mover"
    },
    sharePortfolioForm: {
      header: "Compartilhar portf\xF3lio",
      subHeader: "Escolha como voc\xEA quer compartilhar o portf\xF3lio.",
      publicShareType: "Link p\xFAblico",
      privateShareType: "Portf\xF3lio privado/rascunho",
      passwordType: "Link protegido por senha",
      passwordPlaceholder: "Digite a senha que voc\xEA prefere para o link deste portf\xF3lio",
      alertLabel: "Este portf\xF3lio \xE9 vis\xEDvel somente para voc\xEA; ningu\xE9m mais pode v\xEA-lo.",
      emptyPortfolioAlertLabel: "Este portf\xF3lio est\xE1 vazio. Adicione im\xF3veis para poder compartilh\xE1-lo.",
      downloadsTooltip: "Permita que os visitantes vejam e baixem os arquivos de m\xEDdia e as brochuras dos im\xF3veis que voc\xEA escolher compartilhar.",
      agentPopupTooltip: "Exibe aos visitantes um pop-up com os dados de contato do corretor e a lista de portf\xF3lios. N\xE3o ser\xE1 exibido em portf\xF3lios de um \xFAnico im\xF3vel.",
      showAgentPopup: "Mostrar pop-up do corretor"
    },
    clientViewBanner: {
      message: "Voc\xEA est\xE1 vendo este im\xF3vel no Modo de Apresenta\xE7\xE3o.",
      switchToAgentView: "Mudar para a vis\xE3o do corretor"
    }
  },
  portfolioFolderPreviewPage: {
    header: "H\xE1 {{totalCount}} im\xF3veis neste portf\xF3lio.",
    subHeader: "Se voc\xEA gostou destes im\xF3veis, entre em contato com seu corretor",
    livingArea: "\xC1rea \xFAtil",
    bathrooms: "Banheiros",
    bedrooms: "Quartos"
  },
  profilePage: {
    labels: {
      accountInfo: "Dados da conta",
      billing: "Cobran\xE7a",
      settings: "Configura\xE7\xF5es",
      feedback: "Feedback",
      support: "Suporte",
      choosePlan: "Escolher um plano"
    },
    billing: {
      stayOnThisPlan: "Continuar neste plano",
      active: "Ativa",
      deleted: "Exclu\xEDda",
      cancelled: "Cancelada",
      transactionHistory: "Hist\xF3rico de transa\xE7\xF5es",
      subscribe: "Assinar",
      freeTrial: "Teste gr\xE1tis de {{trial}} dias",
      paymentMethod: "Formas de pagamento",
      upgradePlan: "Fazer upgrade do plano",
      emptyPaymentMethodsText: "Selecione outra forma de pagamento padr\xE3o para renovar sua assinatura",
      addPaymentMethod: "Adicionar forma de pagamento",
      default: "Padr\xE3o",
      expirationDate: "Validade {{expiredMonth}}/{{expiredYear}}",
      recurringTypeChangeModalTitle: "A recorr\xEAncia da sua assinatura vai mudar",
      downgradeModalTitle: "Sua assinatura vai sofrer downgrade",
      cancelModalTitle: "Conte para n\xF3s por que voc\xEA est\xE1 cancelando sua assinatura",
      cancelModalText: "Se voc\xEA cancelar sua assinatura, seu plano n\xE3o ser\xE1 renovado na pr\xF3xima data de cobran\xE7a. Voc\xEA continuar\xE1 com acesso total aos servi\xE7os e recursos do seu plano at\xE9 a data de expira\xE7\xE3o. Voc\xEA pode assinar novamente a qualquer momento.",
      recurringTypeChangeModalText: "A recorr\xEAncia da sua assinatura mudar\xE1 para {{recurringType}} {{plan}} na pr\xF3xima data de cobran\xE7a.",
      downgradeModalText: "Sua assinatura passar\xE1 para o plano {{plan}} na pr\xF3xima data de cobran\xE7a.",
      downloadAll: "Baixar tudo",
      cancelReasons: {
        [import_dash_common6.ProductSubscriptionCancelationReasonsEnum.I_DONT_NEED_DASH_ANYMORE]: "N\xE3o preciso mais das ferramentas da DASH",
        [import_dash_common6.ProductSubscriptionCancelationReasonsEnum.IT_DOESNT_MEET_MY_NEEDS_EXPECTATIONS]: "A DASH n\xE3o atende \xE0s minhas necessidades/expectativas",
        [import_dash_common6.ProductSubscriptionCancelationReasonsEnum.PLANS_COST_TOO_MUCH]: "Os planos da DASH s\xE3o caros demais",
        [import_dash_common6.ProductSubscriptionCancelationReasonsEnum.UNADDRESSED_ERRORS_OR_BUGS]: "Erros ou bugs n\xE3o resolvidos",
        [import_dash_common6.ProductSubscriptionCancelationReasonsEnum.IM_USING_DIFFERENT_SERVICE]: "Estou usando outro servi\xE7o",
        [import_dash_common6.ProductSubscriptionCancelationReasonsEnum.OTHER]: "Outro"
      },
      otherCancelReasonPlaceholder: "Informa\xE7\xF5es adicionais (opcional)",
      cancelPlan: "Cancelar plano",
      changeRecurringType: "Alterar recorr\xEAncia",
      backToBilling: "Voltar \xE0 cobran\xE7a",
      addPaymentModalTitle: "Adicionar forma de pagamento",
      addPaymentModalSubTitle: "Todas as informa\xE7\xF5es s\xE3o confidenciais e n\xE3o ser\xE3o compartilhadas",
      deletePaymentMethod: "Excluir forma de pagamento",
      deletePaymentMethodDescription: "Tem certeza de que deseja excluir esta forma de pagamento?",
      subscriptionProductChanged: "Sua assinatura foi alterada!",
      unsuccessfulPayment: "Pagamento n\xE3o conclu\xEDdo",
      changePlanConfirmationModal: {
        upgradeButton: "Fazer upgrade",
        downgradeButton: "Fazer downgrade",
        yesButton: "Sim",
        upgradeTitle: "Upgrade para o plano {{name}}",
        downgradeTitle: "Downgrade para o plano {{name}}",
        changeToSixMonthPlan: "Mudar para o plano semestral",
        changeToMonthlyPlan: "Mudar para o plano mensal",
        changeDescription: "Tem certeza de que deseja mudar seu plano de assinatura de {{old}} para {{new}}?"
      },
      changeToSixMonthPlan: "Mudar para o plano semestral",
      changeToMonthlyPlan: "Mudar para o plano mensal",
      upgradeDownloadPlanModalTitle: "Fa\xE7a upgrade da sua assinatura para liberar downloads sem marca!",
      upgradePortfolioPlanModalTitle: "Fa\xE7a upgrade da sua assinatura para liberar os portf\xF3lios de corretor",
      upgradeCompleteAccountPlanModalTitle: "Inicie um teste para acessar todos os im\xF3veis",
      upgradeExchangePlanModalTitle: "Fa\xE7a upgrade da sua assinatura para liberar a integra\xE7\xE3o f\xE1cil com o seu site",
      upgradeSavedPropertiesPlanModalTitle: "Fa\xE7a upgrade da sua assinatura para ter uma lista de acompanhamento ilimitada",
      upgradePlanModalSavedPropertiesSubtitle: "Voc\xEA atingiu o limite de {{limit}} im\xF3veis do seu plano gratuito. Fa\xE7a upgrade da sua assinatura para adicionar im\xF3veis ilimitados \xE0 sua lista de acompanhamento e acompanhar todos os empreendimentos que lhe interessam, em um s\xF3 lugar.",
      upgradePlanModalTitle: "Fazer upgrade da assinatura",
      successfulUpgradeMessage: "Sua assinatura foi atualizada!",
      trialUpgrade: {
        title: "Inicie seu teste gr\xE1tis",
        intro: "Seu teste gr\xE1tis de {{days}} dias do {{plan}} come\xE7a hoje. Cancele antes de {{date}} e voc\xEA volta para o {{previousPlan}}.",
        currentPlanFallback: "seu plano atual",
        trialRow: "{{plan}} (teste gr\xE1tis de {{days}} dias)",
        creditRow: "Tempo n\xE3o utilizado do seu plano atual",
        creditTooltip: "Cr\xE9dito pelo tempo n\xE3o utilizado do seu plano atual. Ele \xE9 aplicado na sua primeira cobran\xE7a em {{date}}, n\xE3o hoje.",
        creditCaption: "Aplicado na sua primeira cobran\xE7a",
        thenRow: "A partir de {{date}}",
        pricePerMonth: "${{price}} / m\xEAs",
        pricePerYear: "${{price}} / ano",
        confirmButton: "Iniciar teste gr\xE1tis",
        footerNote: "*Voc\xEA n\xE3o ser\xE1 cobrado at\xE9 {{date}}",
        successToast: "Seu teste gr\xE1tis come\xE7ou!"
      },
      trialRevert: {
        banner: "Seu teste gr\xE1tis do {{plan}} termina em {{date}}, e seu plano volta para o {{previousPlan}}. Voc\xEA n\xE3o ser\xE1 cobrado pelo {{plan}}.",
        bannerAction: "Manter {{plan}}",
        undoButton: "Desfazer cancelamento do teste",
        planFromDate: "Seu plano a partir de {{date}}",
        previousPlanFallback: "seu plano anterior",
        keepTitle: "Manter {{plan}}",
        keepSubtitle: "Desfa\xE7a o cancelamento do seu teste",
        keepText: "Seu teste gr\xE1tis continua, e a cobran\xE7a do {{plan}} come\xE7a em {{date}}.",
        returnCanceledTitle: "Volta para o {{previousPlan}} cancelada",
        returnCanceledText: "Seu plano n\xE3o voltar\xE1 mais para o {{previousPlan}} em {{date}}.",
        cancelAgainNote: "Voc\xEA pode cancelar o teste novamente a qualquer momento antes de {{date}}.",
        keepButton: "Manter {{plan}}",
        keepLoading: "Atualizando...",
        keepSuccess: "Seu teste gr\xE1tis vai continuar.",
        cancelTrialSubtitle: "Seu plano volta para o {{previousPlan}} quando o teste terminar",
        cancelTrialUntil: "At\xE9 {{date}}:",
        cancelTrialUntilText: "Voc\xEA continuar\xE1 usando todos os recursos do {{plan}}",
        cancelTrialAfter: "Depois de {{date}}:",
        cancelTrialAfterText: "Seu plano volta para o {{previousPlan}}",
        cancelTrialNoCharge: "Voc\xEA n\xE3o ser\xE1 cobrado pelo {{plan}}",
        cancelTrialToast: "Teste cancelado. Seu plano volta para o {{previousPlan}} em {{date}}."
      },
      upgradePlanModalDownloadSubtitle: "Com o DASH Pro, voc\xEA baixa com facilidade materiais de marketing sem marca, prontos para compartilhar. Fa\xE7a upgrade da sua assinatura agora para ter acesso ilimitado ao conte\xFAdo dos im\xF3veis e a outros recursos \xFAteis.",
      upgradeCompleteAccountPlanModalSubtitle: "Tenha acesso a mais de 400 lan\xE7amentos em toda a Fl\xF3rida e impulsione suas vendas!",
      banners: {
        scheduledDowngrade: "Sua assinatura est\xE1 programada para fazer downgrade em {{date}}. <link>Cancele o downgrade</link> para manter ou alterar seu plano atual.",
        scheduledCancellation: "Sua assinatura ser\xE1 cancelada em {{date}}. <link>Renove seu plano</link> e continue aproveitando todos os benef\xEDcios da DASH!"
      },
      billingProblem: "Tenho um problema de cobran\xE7a",
      cancelDowngrade: {
        success: "Downgrade programado cancelado! Seu plano atual continuar\xE1.",
        error: "Ocorreu um erro ao cancelar o downgrade.",
        title: "Cancelar downgrade programado",
        subtitle: "Mantenha seu plano atual ativo",
        keepPlan: "Manter {{plan}}",
        keepBenefits: "Continue aproveitando todos os benef\xEDcios do seu plano atual",
        willBeCanceled: "O downgrade para {{plan}} em {{date}} ser\xE1 cancelado",
        rateNote: "Sua assinatura continuar\xE1 com o valor do plano atual. Voc\xEA pode trocar de plano a qualquer momento.",
        canceling: "Cancelando...",
        confirmButton: "Cancelar downgrade"
      },
      invoicePreview: {
        upgraded: "Sua assinatura passou por upgrade!",
        downgradeScheduled: "Sua assinatura est\xE1 programada para fazer downgrade.",
        title: "Confirme as altera\xE7\xF5es na sua assinatura",
        fetchError: "\u26A0\uFE0F Houve um problema ao buscar seus dados. Tente novamente mais tarde ou entre em contato com o suporte.",
        promoCode: "C\xF3digo promocional",
        scheduleDowngrade: "Programar downgrade",
        addPaymentMethodWarning: "\u26A0\uFE0F <link>Adicione uma forma de pagamento</link> antes de continuar.",
        amountOff: "-${{amount}} DE DESCONTO",
        percentOff: "-{{percent}}% DE DESCONTO",
        amountDueToday: "Valor a pagar hoje",
        amountDueStarting: "Valor a pagar a partir de {{date}}",
        paymentMethod: "Forma de pagamento",
        items: "Itens",
        planRemainsActive: "Seu plano atual continuar\xE1 ativo at\xE9 <bold>{{date}}</bold>."
      },
      paymentAdded: "Forma de pagamento adicionada!",
      paymentSetDefault: "Forma de pagamento definida como padr\xE3o!",
      paymentError: "Erro: {{message}}",
      paymentDetails: "Dados de pagamento",
      cardholderInfo: "Dados de cobran\xE7a do titular do cart\xE3o",
      clientSecretError: "Falha ao obter o client secret.",
      promoCodeInvalidChars: "Somente letras e n\xFAmeros s\xE3o permitidos",
      promoCodePlaceholder: "Digite o cupom aqui...",
      changeConfirm: {
        titleUpgrade: "Confirmar upgrade da assinatura",
        titleDowngrade: "Confirmar downgrade da assinatura",
        reviewUpgrade: "Revise os detalhes do seu upgrade",
        reviewDowngrade: "Revise os detalhes do seu downgrade",
        confirmDowngrade: "Confirmar downgrade",
        confirmAndPay: "Confirmar e pagar ${{amount}}",
        footerCharged: "*Seu cart\xE3o ser\xE1 cobrado imediatamente",
        footerDowngradeOn: "*O downgrade entra em vigor em {{date}}",
        footerDowngradeEnd: "*O downgrade entrar\xE1 em vigor ao final do seu per\xEDodo de cobran\xE7a atual",
        noPaymentMethod: "Sem forma de pagamento",
        periodAnnual: "Anual",
        periodMonthly: "Mensal",
        billingAnnual: "anual",
        billingMonthly: "mensal",
        upgradeDescription: "Voc\xEA est\xE1 fazendo <bold>upgrade para {{plan}}</bold> com cobran\xE7a {{billing}}. Sua nova assinatura come\xE7a imediatamente.",
        downgradeDescription: "Voc\xEA est\xE1 programando um <bold>downgrade para {{plan}}</bold> com cobran\xE7a {{billing}}. Sua nova assinatura come\xE7ar\xE1 ap\xF3s o fim do seu per\xEDodo de cobran\xE7a atual.",
        downgradeDescriptionWithDate: "Voc\xEA est\xE1 programando um <bold>downgrade para {{plan}}</bold> com cobran\xE7a {{billing}}. Sua nova assinatura come\xE7ar\xE1 ap\xF3s o fim do seu per\xEDodo de cobran\xE7a atual, em {{date}}.",
        unusedCredit: "Cr\xE9dito por tempo n\xE3o utilizado",
        unusedCreditTooltip: "Cr\xE9dito pelo tempo n\xE3o utilizado do seu plano atual, aplicado \xE0 sua nova assinatura.",
        planRow: "Plano {{plan}} ({{period}})",
        discount: "Desconto ({{name}})",
        haveCode: "Tem um c\xF3digo promocional?",
        enterCode: "Digite o c\xF3digo",
        totalDueToday: "Total a pagar hoje",
        fetchError: "Houve um problema ao buscar seus dados. Tente novamente mais tarde ou entre em contato com o suporte.",
        changeError: "Ocorreu um erro na altera\xE7\xE3o da assinatura.",
        apiWarning: "Sair do plano API desativar\xE1 seu acesso \xE0 API. Seu App ID e seu token s\xE3o preservados (n\xE3o s\xE3o exclu\xEDdos), mas as requisi\xE7\xF5es \xE0 API ser\xE3o rejeitadas enquanto voc\xEA n\xE3o estiver no plano API.",
        apiAcknowledge: "Entendo que meu acesso \xE0 API ser\xE1 desativado."
      },
      cancelTrial: {
        alreadyCanceled: "Este per\xEDodo de teste j\xE1 foi cancelado.",
        cancelError: "Ocorreu um erro ao cancelar o per\xEDodo de teste.",
        title: "Cancelar per\xEDodo de teste?",
        subtitle: "Voc\xEA perder\xE1 o acesso aos recursos premium",
        currentTrialNote: "Voc\xEA est\xE1 em um teste gr\xE1tis deste plano",
        whatHappens: "O que acontece ao cancelar:",
        untilDate: "At\xE9 {{date}}:",
        keepFeatures: "Voc\xEA continuar\xE1 usando todos os recursos premium",
        afterDate: "Depois de {{date}}:",
        noCharge: "Voc\xEA n\xE3o ser\xE1 cobrado por nada",
        keepTrial: "Manter teste",
        confirmButton: "Cancelar teste"
      },
      recurringMonthlyAdjective: "mensal",
      recurringSixMonthAdjective: "semestral",
      paymentMethodEntity: "Forma de pagamento"
    },
    settings: {
      updatePassword: "Atualizar sua senha",
      updatePasswordSubTitle: "Edite ou altere sua senha para proteger sua conta.",
      updateEmailTitle: "Endere\xE7o de e-mail",
      updateEmailSubTitle: "Edite ou altere o endere\xE7o de e-mail da sua conta.",
      changeEmailTile: "Alterar seu endere\xE7o de e-mail",
      yourEmail: "Seu e-mail",
      switchToAgentButton: "Mudar para conta profissional",
      switchToSeekerButton: "Mudar para conta DASH Direct",
      switchToAgentSubTitle: "Voc\xEA \xE9 um profissional imobili\xE1rio licenciado? Fa\xE7a upgrade da sua conta para liberar ferramentas feitas para profissionais, como gera\xE7\xE3o de leads, materiais de marketing para download e integra\xE7\xF5es com sites.",
      switchToSeekerSubTitle: "Voc\xEA n\xE3o trabalha ativamente no mercado imobili\xE1rio? Voc\xEA pode mudar para uma conta DASH n\xE3o profissional com o DASH Direct.<br>Aten\xE7\xE3o: voc\xEA perder\xE1 o acesso \xE0s ferramentas profissionais, como portf\xF3lios com sua marca, materiais de marketing sem marca e capta\xE7\xE3o de leads.",
      switchToSeekerConfirmModalTitle: "Confirmar mudan\xE7a do tipo de conta",
      switchToAgentConfirmModalTitle: "Fazer upgrade para uma conta profissional",
      switchToAgentConfirmText: "Para liberar o acesso \xE0s ferramentas profissionais da DASH, confirme os dados da sua licen\xE7a:",
      accountLanguageTitle: "Idioma da conta",
      accountLanguageSubTitle: "Os e-mails e as notifica\xE7\xF5es da Dash chegam neste idioma.",
      accountLanguageSaved: "Idioma da conta atualizado.",
      accountLanguageError: "N\xE3o foi poss\xEDvel atualizar o idioma da sua conta. Tente novamente.",
      accountLanguageBrowserOverride: "Este navegador est\xE1 mostrando a Dash em {{language}}.",
      accountLanguageUseHere: "Usar aqui o idioma da conta",
      changeAccountType: "Alterar tipo de conta",
      country: "Pa\xEDs",
      selectCountry: "Selecione seu pa\xEDs",
      selectState: "Selecione seu estado",
      licenseNumber: "N\xFAmero da licen\xE7a",
      switchToSeekerConfirmText: "Tem certeza de que quer mudar para uma conta DASH n\xE3o profissional? Isso remover\xE1 o acesso a todos os recursos reservados a profissionais imobili\xE1rios licenciados e oferecer\xE1 uma experi\xEAncia mais simples.",
      accountSwitchWarning: "ATEN\xC7\xC3O: esta altera\xE7\xE3o \xE9 permanente, a menos que voc\xEA entre em contato com o suporte da DASH para reverter.",
      resetLinkSent: "Enviamos um link de redefini\xE7\xE3o de senha para o seu e-mail! Se n\xE3o o receber, verifique a pasta de spam antes de tentar novamente.",
      sendNewLink: "Enviar um novo link",
      forgotPassword: "N\xE3o lembra sua senha?",
      sendResetLink: "Enviar um link de redefini\xE7\xE3o para o seu e-mail"
    },
    api: {
      tooltipMessage: "Estas s\xE3o as informa\xE7\xF5es que voc\xEA compartilhar\xE1 com a empresa respons\xE1vel pela sua integra\xE7\xE3o com a API. Para usar nosso plugin da API, voc\xEA precisa informar o App ID e o token secreto da API.",
      apiKeys: "Chaves de API",
      apiUsage: "Uso da API",
      apiUsageOwnLabel: "Suas requisi\xE7\xF5es neste m\xEAs:",
      apiUsageLabel: "Requisi\xE7\xF5es neste m\xEAs:",
      apiUsageCompanyShare: "Seu limite mensal \xE9 compartilhado com todos da sua empresa. Juntos, voc\xEAs usaram {{usage}} de {{limit}} neste m\xEAs.",
      apiActivity: "Atividade da API",
      generateNewToken: "Gerar novo token",
      tokenGeneratedSuccess: "Token gerado com sucesso. Guarde-o em local seguro.",
      tokenGeneratedError: "N\xE3o foi poss\xEDvel gerar o token. Tente novamente.",
      newToken: "Seu novo token \xE9:",
      newTokenStoreSafely: "Copie e guarde em um local seguro. Ele n\xE3o ser\xE1 exibido novamente depois que voc\xEA fechar este modal.",
      noAppIdFoundMessage: "Nenhum App ID encontrado. Atualize a p\xE1gina ou entre em contato com o suporte se o problema persistir.",
      inactiveNotice: "Seu acesso \xE0 API est\xE1 inativo no momento. Voc\xEA ainda pode gerenciar seu App ID e seu token aqui, mas as requisi\xE7\xF5es \xE0 API ser\xE3o rejeitadas at\xE9 que sua assinatura da API volte a ficar ativa. Entre em contato com o suporte se acreditar que isso \xE9 um erro.",
      referralLinkTitle: "Link de indica\xE7\xE3o",
      referralLinkDescription: "Compartilhe este link com seus clientes para dar a eles acesso \xE0 nossa API:",
      referralLinkCopied: "Link copiado para a \xE1rea de transfer\xEAncia!",
      referralLinkHint: "Eles precisam acessar o link, criar uma conta, selecionar o plano da API e gerar seus tokens na p\xE1gina de configura\xE7\xF5es.",
      pluginUsersTitle: "Usu\xE1rios do plugin",
      pluginUsersDescription: "Clientes que se cadastraram pelo seu link de indica\xE7\xE3o. As requisi\xE7\xF5es deles contam para a sua cota mensal.",
      pluginUsersEmpty: "Ningu\xE9m se cadastrou pelo seu link de indica\xE7\xE3o ainda.",
      pluginUsersRequestsThisMonth: "requisi\xE7\xF5es neste m\xEAs",
      pluginUsersActive: "Ativo",
      pluginUsersInactive: "Inativo",
      pluginUsersBlocked: "Bloqueado por voc\xEA",
      pluginUsersToggleLabel: "Acesso \xE0 API",
      pluginUsersBlockError: "N\xE3o foi poss\xEDvel atualizar o acesso deste cliente. Tente novamente.",
      tokenActiveNote: "J\xE1 existe um token ativo associado a este App ID.<br />Voc\xEA pode gerar um novo clicando no bot\xE3o abaixo, mas o token atual <bold>ser\xE1 invalidado</bold>.",
      tokenInactiveNote: "N\xE3o h\xE1 nenhum token ativo associado a este App ID.<br />Voc\xEA pode gerar um novo clicando no bot\xE3o abaixo.",
      usageError: "Ocorreu um erro ao obter as m\xE9tricas de requisi\xE7\xF5es. Atualize a p\xE1gina ou entre em contato com o suporte se o erro persistir.",
      needMoreRequests: "Precisa de mais requisi\xE7\xF5es? Clique aqui",
      usageDelayed: "*As informa\xE7\xF5es de uso podem ter um atraso de at\xE9 1 hora.",
      appIdIs: "Seu <bold>App ID</bold> \xE9: {{appId}}",
      searchingAppId: "buscando App ID",
      appIdCopied: "App ID copiado!",
      tokenCopied: "Token copiado!",
      regenerateConfirm: "Tem certeza de que quer gerar um novo token?<br />O atual <bold>ser\xE1 invalidado</bold>.",
      firstTokenNote: "<bold>Importante!</bold> Depois de gerar um token, ele ser\xE1 exibido aqui.<br /><br />Voc\xEA <bold>precisa copi\xE1-lo</bold> e guard\xE1-lo em um lugar seguro. Se o perder, ser\xE1 preciso gerar um novo, e o antigo <bold>ser\xE1 invalidado</bold>.",
      generateTokenModalTitle: "Gerar novo token da API"
    },
    avatar: {
      uploadError: "Erro ao enviar o arquivo: {{error}}",
      cropTitle: "Recortar imagem",
      removeUnableError: "N\xE3o foi poss\xEDvel remover a foto de perfil. Tente novamente.",
      removeFailedError: "Falha ao remover a foto de perfil. Tente novamente.",
      entity: "foto de perfil",
      removeTitle: "Remover foto de perfil",
      removeConfirm: "Tem certeza de que quer remover sua foto de perfil?",
      removeNote: "Lembre-se de salvar suas altera\xE7\xF5es para aplicar esta remo\xE7\xE3o."
    },
    accountInfo: {
      licenseValid: "V\xE1lida",
      licenseInvalid: "Inv\xE1lida",
      licensePending: "Pendente"
    },
    toasts: {
      updatedPassword: "Sua senha foi atualizada com sucesso",
      updatedProfile: "Seu perfil foi atualizado com sucesso",
      updatedEmail: "Seu e-mail foi atualizado com sucesso",
      switchedToSeeker: "Tipo de conta alterado para n\xE3o corretor!",
      switchedToAgent: "Tipo de conta alterado para corretor!"
    }
  },
  alertPage: {
    labels: {
      addAlert: "Adicionar um alerta",
      alertDetails: "Detalhes do alerta",
      alertInfo: "Info do alerta",
      createAlertTitle: "Criar um alerta",
      createAlertSubtitle: "Crie um alerta para novos im\xF3veis que correspondam aos seus crit\xE9rios de busca",
      manageAlerts: "Gerenciar alertas",
      addAlertSelectFilter: "Selecione os filtros do seu alerta",
      hiddenAlert: "Alerta oculto",
      filterByAlertPlaceholder: "Buscar pelo nome do alerta",
      manageAlertsModalTitle: "Gerenciar alertas",
      manageAlertsModalSuTitle: "Veja a lista completa dos seus alertas e gerencie-os conforme necess\xE1rio.",
      deleteAlertModalTitle: "Excluir alerta",
      deleteAlertModalSubTitle: "Tem certeza de que deseja excluir este alerta da lista de alertas?",
      noPropertiesPlaceholderTitle: "Voc\xEA n\xE3o criou nenhum alerta",
      noPropertiesPlaceholder: "Crie um alerta para ser avisado quando um novo im\xF3vel corresponder aos seus crit\xE9rios",
      backButtonLabel: "Voltar para Gerenciar alertas"
    },
    toasts: {
      alertIsCreated: "Alerta criado com sucesso",
      alertIsUpdated: "Alerta atualizado com sucesso"
    }
  },
  brokersPage: {
    licenseInfo: "Info da licen\xE7a",
    licenseData: "Dados da licen\xE7a:",
    markAsInvalid: "Marcar como inv\xE1lida",
    markValid: "Marcar como v\xE1lida",
    saveBrokerDetails: "Salvar dados do corretor",
    verifyBrokerLicense: "Verificar",
    licenseId: "ID da licen\xE7a:",
    blockBroker: "Bloquear conta",
    subscriptionStatus: "Status da assinatura",
    unblockBroker: "Desbloquear conta",
    unlockStandardPlans: "Liberar planos padr\xE3o",
    lockToApiPlan: "Restringir ao plano da API",
    billingAccess: "Cobran\xE7a",
    billingApiOnly: "Somente plano da API",
    billingAllPlans: "Todos os planos",
    notApiUserHint: "Este corretor n\xE3o \xE9 usu\xE1rio da API \u2014 ele j\xE1 v\xEA todos os planos.",
    toast: {
      paymentMethodAdded: "Forma de pagamento adicionada com sucesso",
      paymentMethodRemoved: "Forma de pagamento removida com sucesso",
      paymentMethodSetAsDefault: "A forma de pagamento foi definida como padr\xE3o",
      maxPaymentMethod: "Voc\xEA atingiu o limite de formas de pagamento permitidas."
    },
    modals: {
      deactivateBrokerLicenseTitle: "Desativar licen\xE7a do corretor",
      activateBrokerLicenseTitle: "Definir licen\xE7a do corretor como ativa",
      deactivateBrokerLicenseSuccess: "Licen\xE7a do corretor invalidada",
      activateBrokerLicenseSuccess: "Licen\xE7a do corretor validada",
      activateBrokerLicenseSubTitle: "Tem certeza?",
      notifyThroughMailCheckbox: "Enviar notifica\xE7\xE3o por e-mail ao corretor",
      blockBrokerSubtitle: "Tem certeza de que deseja bloquear esta conta?",
      blockBrokerReasonFieldTitle: "Informe o motivo do bloqueio",
      blockBrokerReasonFieldPlaceholder: "Digite o motivo do bloqueio",
      unblockBrokerSubtitle: "Tem certeza de que deseja desbloquear esta conta?"
    }
  },
  dashboardPage: {
    mortgageWidget: {
      mortgageModalTitle: "Calculadora de financiamento",
      mortgageBalance: "Saldo do financiamento",
      totalPayments: "Total de pagamentos",
      monthlyPayments: "Pagamentos mensais",
      totalInterestPaid: "Total de juros pagos",
      propertyInsurance: "Seguro do im\xF3vel",
      propertyTax: "Imposto predial",
      totalPropertyTax: "Total do imposto predial",
      totalPropertyInsurance: "Total do seguro"
    },
    currencyConverterWidget: {
      title: "Conversor de moedas",
      rate: "Cota\xE7\xE3o: {{from}} / {{to}}",
      label: "Por {{amount}} voc\xEA receber\xE1:",
      for: "Em {{date}}",
      copied: "Copiado"
    },
    propertyAlertsWidget: {
      propertiesAlertsModalTitle: "Alertas de im\xF3veis",
      infoPlaceholder: "Novos im\xF3veis",
      infoDescription: "Alertas de novos im\xF3veis",
      infoPlaceholderDescription: "Receba notifica\xE7\xF5es quando um novo im\xF3vel corresponder aos seus crit\xE9rios de busca"
    },
    propertyUpdatesWidget: {
      infoPlaceholder: "Acompanhar im\xF3veis",
      infoDescription: "Atualiza\xE7\xF5es de im\xF3veis",
      infoPlaceholderDescription: "Receba notifica\xE7\xF5es quando um im\xF3vel do seu portf\xF3lio for atualizado",
      infoPlaceholderSeekerDescription: "Receba notifica\xE7\xF5es quando um im\xF3vel acompanhado for atualizado",
      noPropertyUpdatesPlaceholder: "Nenhum im\xF3vel foi atualizado no per\xEDodo selecionado"
    },
    reactionsWidget: {
      infoDescription: "Rea\xE7\xF5es",
      infoPlaceholderDescription: "Receba o feedback de clientes e colegas sobre os portf\xF3lios que voc\xEA compartilha.",
      reactions: {
        interested: "Interessado",
        notInterested: "Sem interesse",
        maybeInterested: "Talvez interessado",
        dontKnow: "N\xE3o sei"
      },
      enterYourData: "Informe seus dados",
      leaveReactionTitle: "Como voc\xEA avalia este im\xF3vel?",
      leaveReactionSuccessfulToast: "Obrigado! Seu corretor ser\xE1 avisado",
      reactionsViews: "Rea\xE7\xF5es e visualiza\xE7\xF5es",
      userView: "Vis\xE3o do usu\xE1rio"
    },
    reactionsModal: {
      portfolioViewsLabel: "{{count}} visualiza\xE7\xF5es",
      portfolioReactionsLabel: "{{count}} rea\xE7\xF5es",
      noPortfoliosMessage: "Nenhum portf\xF3lio encontrado",
      noPortfoliosSubMessage: "Receba o feedback de clientes e colegas sobre os portf\xF3lios que voc\xEA compartilha.",
      noPortfoliosButtonMessage: "Crie seu primeiro portf\xF3lio",
      noPublicPortfoliosMessage: "Nenhum portf\xF3lio p\xFAblico",
      noPublicPortfoliosSubMessage: "Torne seu portf\xF3lio p\xFAblico e receba o feedback de clientes e colegas",
      noPublicPortfoliosButtonMessage: "Compartilhar portf\xF3lio"
    },
    viewedProperties: {
      viewed: "Visto: {{date}}",
      unavailableProperty: "Este im\xF3vel est\xE1 indispon\xEDvel no momento",
      viewedProperties: "Im\xF3veis vistos",
      unavailableTitle: "Acompanhe suas buscas",
      unavailableSubtitle: "Quando voc\xEA come\xE7ar a explorar im\xF3veis, seu hist\xF3rico aparecer\xE1 aqui.",
      unavailableButton: "Explorar"
    },
    addedToPortfolio: {
      addedToPortfolio: "Adicionados ao portf\xF3lio",
      unavailableTitle: "Im\xF3veis do portf\xF3lio",
      unavailableSubtitle: "Os im\xF3veis adicionados a um portf\xF3lio ser\xE3o exibidos aqui.",
      unavailableButton: "Criar portf\xF3lio",
      added: "Adicionado: {{date}}",
      removed: "Removido",
      propertyNotAvailable: "Im\xF3vel indispon\xEDvel",
      noFolderName: "Portf\xF3lio sem nome"
    },
    portfoliosWidget: {
      title: "Visualiza\xE7\xF5es de portf\xF3lios",
      titleShort: "Visualiz. portf.",
      portfoliosDropdownInput: "Gerenciar gr\xE1fico",
      portfoliosDropdownInputShort: "Gr\xE1fico",
      noPortfoliosPlaceholderTitle: "An\xE1lises",
      noPortfoliosPlaceholderSubTitle: "Ao criar portf\xF3lios, voc\xEA recebe an\xE1lises de visualiza\xE7\xE3o de potenciais compradores",
      noPublicPortfoliosPlaceholderSubTitle: "Ao compartilhar portf\xF3lios de im\xF3veis, voc\xEA recebe an\xE1lises de visualiza\xE7\xE3o de potenciais compradores",
      noPortfoliosPlaceholderMatches: "Nenhum resultado encontrado para a sua busca. Tente novamente",
      noPortfoliosPlaceholderButtonLabel: "Criar portf\xF3lios",
      noPublicPortfoliosPlaceholderButtonLabel: "Compartilhar portf\xF3lios",
      noPortfoliosPlaceholderNoMatches: "Nenhum resultado encontrado para a sua busca. Tente novamente"
    },
    banner: {
      view: "Ver",
      renew: "Renovar",
      dismiss: "Dispensar",
      notifications: {
        freePlanUpdate: "A DASH agora \xE9 GR\xC1TIS para usu\xE1rios do plano Basic! Saiba mais sobre esta novidade clicando aqui.",
        upgradeSubscription: "Sua conta gratuita tem acesso limitado - fa\xE7a upgrade do seu plano para ter acesso total.",
        brokerInfoIncomplete: "Complete seu perfil e ofere\xE7a aos clientes uma experi\xEAncia de visualiza\xE7\xE3o de im\xF3veis mais completa.",
        cancelSubscription: "Aten\xE7\xE3o: quando sua assinatura expirar, o acesso aos recursos da plataforma ser\xE1 limitado. Renove hoje para continuar aproveitando todos os benef\xEDcios.",
        phoneVerification: "Verifique seu n\xFAmero de telefone.",
        brokerLicense: "Sua licen\xE7a de corretor \xE9 inv\xE1lida. Entre em contato com o suporte da DASH.",
        trialExpired: "Seu per\xEDodo de teste da DASH termina em {{date}}. A forma de pagamento cadastrada ser\xE1 cobrada automaticamente ao final do teste. Acesse as configura\xE7\xF5es de cobran\xE7a da sua conta para revisar suas formas de pagamento."
      }
    }
  },
  managementPage: {
    addNewUser: "Adicionar novo usu\xE1rio",
    editUser: "Editar usu\xE1rio",
    emptyPlaceholder: "N\xE3o h\xE1 usu\xE1rios",
    archiveConfirmationTitle: "Arquivar usu\xE1rio",
    unarchiveConfirmationTitle: "Desarquivar usu\xE1rio",
    archiveConfirmationBody: "Tem certeza de que deseja arquivar este usu\xE1rio?",
    unarchiveConfirmationBody: "Tem certeza de que deseja desarquivar este usu\xE1rio?",
    toasts: {
      userAdded: "Usu\xE1rio adicionado com sucesso",
      userUpdated: "Usu\xE1rio atualizado com sucesso",
      userArchived: "Usu\xE1rio arquivado com sucesso",
      userUnarchived: "Usu\xE1rio desarquivado com sucesso"
    }
  },
  apiUsersPage: {
    addNewUser: "Adicionar novo representante da API",
    addNewUserButton: "Adicionar representante da API",
    editUser: "Editar representante da API"
  },
  apiInvitationsPage: {
    createInvitation: "Criar convite da API",
    createInvitationButton: "Criar convite",
    emptyPlaceholder: "N\xE3o h\xE1 convites",
    toasts: {
      invitationCreated: "Convite criado com sucesso",
      invitationRevoked: "Convite revogado com sucesso"
    }
  },
  apiConsolePage: {
    tabs: {
      overview: "Vis\xE3o geral",
      accounts: "Contas",
      invitations: "Convites"
    },
    accountsModeCompanies: "Empresas",
    accountsModePluginUsers: "Usu\xE1rios do plugin",
    allStatuses: "Todos os status",
    showingRange: "Mostrando {{from}}\u2013{{to}} de {{total}}",
    rowsPerPage: "Mostrar {{count}}",
    noAccounts: "N\xE3o h\xE1 contas da API",
    apiUsage: "Uso da API",
    usageRange: "Per\xEDodo",
    usageGrouping: "Agrupar por",
    usageFrom: "De",
    usageTo: "At\xE9",
    invitationFunnel: "Convites",
    invitationTotal: "{{count}} no total",
    requestsInDays: "{{count}} requisi\xE7\xF5es \xB7 \xFAltimos {{days}} dias",
    requestsTotal: "{{count}} requisi\xE7\xF5es",
    noUsage: "Nenhuma requisi\xE7\xE3o neste per\xEDodo.",
    totalApiAccess: "Acesso total \xE0 API",
    companiesApiAccess: "Acesso \xE0 API das empresas",
    pluginUsersApiAccess: "Acesso \xE0 API dos usu\xE1rios do plugin",
    companyDirectAccess: "Acesso direto da empresa \xE0 API",
    clientsApiAccess: "Acesso \xE0 API dos clientes",
    sharedQuota: "Cota mensal (empresa + usu\xE1rios do plugin)",
    resetsOn: "Reinicia em {{date}}",
    customLimit: "limite personalizado",
    defaultLimit: "limite padr\xE3o",
    noQuota: "Ainda n\xE3o h\xE1 informa\xE7\xF5es de cota para esta conta.",
    apiAccess: "Acesso \xE0 API",
    accessEnabled: "Ativado",
    accessDisabled: "Desativado por um administrador",
    accessEnabledHint: "Ao desativar, esta empresa e todos os usu\xE1rios do plugin cadastrados por ela ficam bloqueados, independentemente da assinatura.",
    accessDisabledHint: "Um administrador bloqueou o acesso \xE0 API. Eventos de cobran\xE7a n\xE3o conseguem reativ\xE1-lo enquanto este bloqueio existir.",
    disableAccess: "Desativar acesso \xE0 API",
    blockReasonLabel: "Motivo (opcional)",
    blockReasonPlaceholder: "Por que o acesso est\xE1 sendo cortado?",
    disabledOn: "Desativado em {{date}}",
    disabledOnWithReason: "Desativado em {{date}} \u2014 {{reason}}",
    reEnableAccess: "Reativar acesso \xE0 API",
    monthlyLimit: "Limite mensal de requisi\xE7\xF5es",
    newLimitPlaceholder: "Novo limite",
    saveLimit: "Salvar limite",
    restoreDefault: "Restaurar padr\xE3o",
    pluginUsers: "Usu\xE1rios do plugin",
    pluginUsersHint: "Cadastrados pelo link de indica\xE7\xE3o desta empresa. As requisi\xE7\xF5es deles contam para a cota acima, e desativar a empresa tamb\xE9m os bloqueia.",
    pluginUserStatus: "Status",
    pluginUserActive: "Ativo",
    pluginUserInactive: "Inativo",
    pluginUserBlockedByPartner: "Bloqueado pelo parceiro",
    pluginUserBlockedByAdmin: "Bloqueado por um administrador",
    blockedByPartnerHint: "O parceiro desativou este usu\xE1rio do plugin. Somente ele pode reativ\xE1-lo.",
    noPluginUsers: "Nenhum usu\xE1rio do plugin se cadastrou por esta empresa.",
    referralLink: "Link de indica\xE7\xE3o",
    copyReferralLink: "Copiar link de indica\xE7\xE3o",
    noReferralLink: "Conta direta",
    deleteAccount: "Excluir conta",
    deleteAccountTitle: "Excluir {{name}}?",
    deleteAccountBody: "O acesso \xE0 API \xE9 interrompido imediatamente e a conta some desta lista. Nada \xE9 apagado: um administrador pode restaur\xE1-la depois.",
    deleteAccountCascade_one: "O 1 usu\xE1rio do plugin dela perde o acesso \xE0 API junto e o recupera na restaura\xE7\xE3o. A conta dele n\xE3o \xE9 alterada.",
    deleteAccountCascade_other: "Os {{count}} usu\xE1rios do plugin dela perdem o acesso \xE0 API junto e o recuperam na restaura\xE7\xE3o. As contas deles n\xE3o s\xE3o alteradas.",
    deleteAccountCodeWarning: "O c\xF3digo de indica\xE7\xE3o dela n\xE3o pode ser reutilizado por uma nova conta, nem ap\xF3s uma restaura\xE7\xE3o.",
    deleteChallenge: "Digite {{name}} para confirmar",
    restoreAccount: "Restaurar conta",
    showDeleted: "Mostrar exclu\xEDdas",
    deletedPill: "Exclu\xEDda",
    deletedOn: "Exclu\xEDda em {{date}}",
    accountNotFound: "N\xE3o encontramos essa conta da API.",
    untitledAccount: "Empresa sem nome",
    responsibleCompany: "Empresa respons\xE1vel",
    viewParentCompany: "Ver empresa respons\xE1vel",
    viewBrokerRecord: "Ver registro do corretor",
    resendInvitation: "Reenviar",
    resendInvitationTitle: "Reenviar este convite?",
    resendInvitationBody: "Um novo link ser\xE1 enviado por e-mail para {{email}} e o anterior deixar\xE1 de funcionar.",
    resendInvitationExpiry: "Nova data de expira\xE7\xE3o (opcional)",
    invitationEmail: "E-mail",
    toasts: {
      accessDisabled: "Acesso \xE0 API desativado",
      accessReEnabled: "Acesso \xE0 API reativado",
      accessStillOff: "Bloqueio do administrador removido, mas o acesso \xE0 API continua desativado: esta empresa n\xE3o tem assinatura ativa da API.",
      accessFailed: "N\xE3o foi poss\xEDvel atualizar o acesso \xE0 API",
      limitSaved: "Limite mensal definido em {{limit}}",
      limitRestored: "Limite mensal restaurado para o padr\xE3o",
      limitFailed: "N\xE3o foi poss\xEDvel atualizar o limite mensal",
      inviteFailed: "N\xE3o foi poss\xEDvel criar o convite",
      revokeFailed: "N\xE3o foi poss\xEDvel revogar o convite",
      saveAccountFailed: "N\xE3o foi poss\xEDvel salvar a conta da API",
      referralLinkCopied: "Link de indica\xE7\xE3o copiado",
      accountDeleted: "Conta exclu\xEDda",
      accountDeletedWithPluginUsers_one: "Conta exclu\xEDda; 1 usu\xE1rio do plugin perdeu o acesso \xE0 API",
      accountDeletedWithPluginUsers_other: "Conta exclu\xEDda; {{count}} usu\xE1rios do plugin perderam o acesso \xE0 API",
      deleteAccountFailed: "N\xE3o foi poss\xEDvel excluir a conta",
      accountRestored: "Conta restaurada",
      accountRestoredInactive: "Conta restaurada, mas o acesso \xE0 API continua desativado: n\xE3o h\xE1 assinatura ativa da API.",
      restoreAccountFailed: "N\xE3o foi poss\xEDvel restaurar a conta",
      invitationResent: "Convite reenviado",
      resendInvitationFailed: "N\xE3o foi poss\xEDvel reenviar o convite",
      pluginUserBlocked: "Usu\xE1rio do plugin bloqueado",
      pluginUserUnblocked: "Usu\xE1rio do plugin desbloqueado"
    }
  },
  contentActivityPage: {
    from: "De",
    to: "At\xE9",
    period: "Per\xEDodo",
    totals: {
      propertiesEdited: "Im\xF3veis editados",
      changes: "Altera\xE7\xF5es",
      filesUploaded: "Arquivos enviados",
      propertiesCreated: "Novos im\xF3veis"
    },
    byType: "Por tipo de altera\xE7\xE3o",
    byTypeHint: "Todas as entradas do hist\xF3rico dos im\xF3veis. Os envios de arquivos incluem arquivos removidos depois, ent\xE3o este n\xFAmero pode ser maior que Arquivos enviados acima.",
    byPerson: "Por pessoa",
    columns: {
      change: "Altera\xE7\xE3o",
      changes: "Altera\xE7\xF5es",
      properties: "Im\xF3veis",
      person: "Pessoa",
      propertiesEdited: "Im\xF3veis editados",
      filesUploaded: "Arquivos enviados",
      propertiesCreated: "Novos im\xF3veis",
      when: "Quando",
      property: "Im\xF3vel",
      by: "Por"
    },
    log: "Registro de altera\xE7\xF5es",
    logHint: "Todas as altera\xE7\xF5es deste per\xEDodo, das mais recentes \xE0s mais antigas. Altera\xE7\xF5es de status e visibilidade s\xE3o internas: os corretores nunca as veem.",
    visibilityAlsoChanged: "Visibilidade: {{change}}",
    deletedProperty: "Im\xF3vel exclu\xEDdo",
    unknownPerson: "Desconhecido",
    unknownPersonHint: "Antes do registro de autoria",
    noChanges: "Nenhuma altera\xE7\xE3o neste per\xEDodo.",
    noContributors: "Nenhuma atividade neste per\xEDodo.",
    loadError: "N\xE3o foi poss\xEDvel carregar a atividade de conte\xFAdo. Tente novamente.",
    changeTypes: {
      PROPERTY_ABOUT: "Detalhes do im\xF3vel",
      PROPERTY_ADDITIONAL_INFORMATION: "Informa\xE7\xF5es adicionais",
      PROPERTY_CMS_STATUS: "Status",
      PROPERTY_DATA_REVIEWED: "Dados verificados",
      PROPERTY_DEVELOPER_ORGANIZATION: "Organiza\xE7\xE3o da incorporadora",
      PROPERTY_FEATURES_AND_AMENITIES: "Caracter\xEDsticas e comodidades",
      PROPERTY_HIGHLIGHTS: "Destaques",
      PROPERTY_INVENTORY_UNIT_ADDED: "Unidade adicionada",
      PROPERTY_INVENTORY_UNIT_REMOVED: "Unidade removida",
      PROPERTY_INVENTORY_UNIT_UPDATED: "Unidade atualizada",
      PROPERTY_LOCATION: "Localiza\xE7\xE3o",
      PROPERTY_MEDIA_FILES_MOVED: "Arquivos movidos",
      PROPERTY_MEDIA_REMOVED: "Arquivos removidos",
      PROPERTY_MEDIA_RENAMED: "Arquivos renomeados",
      PROPERTY_MEDIA_UPLOADED: "Arquivos enviados",
      PROPERTY_NAME: "Nome do im\xF3vel",
      PROPERTY_PRICE: "Pre\xE7os e disponibilidade",
      PROPERTY_SALES_TEAMS: "Equipe de vendas",
      PROPERTY_VIRTUAL_TOURS: "Tours virtuais",
      PROPERTY_VISIBILITY: "Visibilidade",
      PROPERTY_WEBSITE: "Site",
      retired: "Outro (tipo descontinuado)"
    }
  },
  trackingPage: {
    noPropertiesLabelTitle: "Voc\xEA ainda n\xE3o est\xE1 acompanhando nenhum im\xF3vel!",
    noPropertiesLabel: "Adicione seus im\xF3veis favoritos \xE0 lista de acompanhamento para acess\xE1-los com facilidade.",
    noPropertiesButtonLabel: "Come\xE7ar a explorar",
    noPortfoliosLabelTitle: "Voc\xEA ainda n\xE3o est\xE1 acompanhando nenhum portf\xF3lio!",
    noPortfoliosLabel: "Adicione seus portf\xF3lios favoritos \xE0 lista de acompanhamento para acess\xE1-los com facilidade.",
    noPortfoliosButtonLabel: "Explorar portf\xF3lios",
    propertiesTab: "Im\xF3veis",
    portfoliosTab: "Portf\xF3lios",
    trackProperty: "Acompanhar im\xF3vel"
  },
  externalSalesPage: {
    addUser: "Adicionar usu\xE1rio",
    addExternalTeam: "Adicionar nova equipe",
    editExternalTeam: "Editar equipe",
    toasts: {
      teamAdded: "Equipe adicionada com sucesso",
      teamChanged: "Equipe alterada com sucesso",
      userAdded: "Usu\xE1rio adicionado com sucesso",
      userUpdated: "Usu\xE1rio atualizado com sucesso"
    },
    deleteSaleTeamModalLabel: "Excluir equipe",
    deleteSaleTeamModalText: "Tem certeza de que deseja excluir a equipe {{teamName}}?",
    addSaleTeamUserModalLabel: "Adicionar usu\xE1rios \xE0 equipe de vendas",
    editSaleTeamUserModalLabel: "Editar usu\xE1rio da equipe de vendas",
    deleteSaleTeamUserModalLabel: "Excluir usu\xE1rio da equipe de vendas",
    deleteSaleTeamUserModalText: "Ao excluir este usu\xE1rio da equipe de vendas, voc\xEA revogar\xE1 o acesso e as permiss\xF5es que ele tem na equipe. Tem certeza de que deseja continuar?",
    archiveUserText: "Tem certeza de que deseja arquivar este usu\xE1rio da equipe de vendas?",
    unarchiveUserText: "Tem certeza de que deseja desarquivar este usu\xE1rio da equipe de vendas?"
  },
  organizationDashboardPage: {
    deleteOrganizationModalNote: "Isso pode afetar os im\xF3veis associados",
    mediaKitWidgetPlaceholderTitle: "Arquivos / downloads da DASH",
    propertySavesPlaceholderTitle: "Im\xF3vel salvo",
    propertySavesPlaceholderText: "Este im\xF3vel ainda n\xE3o foi salvo por nenhum corretor.",
    propertySharesPlaceholderTitle: "Im\xF3vel compartilhado",
    propertySharesPlaceholderText: "Este im\xF3vel ainda n\xE3o foi compartilhado por nenhum corretor.",
    addedToPortfoliosPlaceholderTitle: "Adicionados a portf\xF3lios",
    addedToPortfoliosPlaceholderText: "Este im\xF3vel ainda n\xE3o foi adicionado a um portf\xF3lio.",
    propertySavesPlaceholderTextPeriod: "Este im\xF3vel n\xE3o foi adicionado por nenhum corretor no per\xEDodo selecionado.",
    propertySharesPlaceholderTextPeriod: "Nenhum im\xF3vel compartilhado no per\xEDodo selecionado.",
    propertyAddedPortfolioPlaceholderText: "Este im\xF3vel ainda n\xE3o foi adicionado a um portf\xF3lio.",
    propertyAddedPortfolioPlaceholderTextPeriod: "Este im\xF3vel n\xE3o foi adicionado a um portf\xF3lio no per\xEDodo selecionado.",
    propertyMediaKitPlaceholderText: "Ainda n\xE3o h\xE1 downloads.",
    propertyMediaKitPlaceholderTextPeriod: "Nenhum download no per\xEDodo selecionado.",
    viewedByAgents: "Visto por corretores",
    viewedByAgentsNoResult: "Nenhuma visualiza\xE7\xE3o no per\xEDodo selecionado",
    viewedByAgentsPlaceholderTitle: "Ainda n\xE3o h\xE1 visualiza\xE7\xF5es por corretores",
    downloadedFilesTitle: "Arquivos mais populares",
    downloadedFilesPlaceholderTitle: "Nenhum arquivo foi baixado ainda.",
    exportData: "Exportar dados",
    propertyName: "Nome do im\xF3vel",
    filterByDate: "Filtrar por data",
    selectRange: "Selecionar per\xEDodo",
    customRange: "Per\xEDodo personalizado",
    totalValue: "Valor total",
    widgetsEmptyFilterTexts: {
      propertyShared: "Nenhum im\xF3vel compartilhado no per\xEDodo selecionado",
      addedToPortfolios: "Este im\xF3vel n\xE3o foi adicionado a nenhum portf\xF3lio no per\xEDodo selecionado.",
      propertySaves: "Este im\xF3vel n\xE3o foi salvo por nenhum corretor no per\xEDodo selecionado.",
      fileDownloads: "Nenhum download no per\xEDodo selecionado"
    }
  },
  mediaKit: {
    dashDownloads: "Downloads do im\xF3vel",
    enableDashDownloads: "Ativar downloads do im\xF3vel",
    mediaKitText: "Adicione e personalize quais arquivos de m\xEDdia deste im\xF3vel aparecem no seu portf\xF3lio.",
    propertyMediaFiles: "M\xEDdia do im\xF3vel",
    addedToDashDownloads: "{{total}} arquivos adicionados ao portf\xF3lio",
    manageMediaKit: "Downloads do im\xF3vel",
    numberOfAddedItems: "Arquivos de m\xEDdia adicionados",
    addToMedia: "Adicionar \xE0 m\xEDdia",
    added: "Adicionado",
    addTitle: "Compartilhe seu portf\xF3lio",
    addSubtitle: "Configure a visibilidade e as op\xE7\xF5es de compartilhamento do portf\xF3lio.",
    firstShareSubtitle: "Seu portf\xF3lio j\xE1 \xE9 p\xFAblico. Voc\xEA pode copiar e compartilhar o link abaixo com seus clientes ou alterar as op\xE7\xF5es de compartilhamento.",
    editTitle: "Gerenciar downloads do im\xF3vel",
    editSubtitle: "Voc\xEA pode adicionar ou excluir arquivos de m\xEDdia do im\xF3vel no m\xEDdia kit",
    confirmChangesTitle: "Confirme suas altera\xE7\xF5es",
    confirmAddAllBody: "\u26A0\uFE0F Esta a\xE7\xE3o vai <bold>adicionar todos os arquivos de m\xEDdia do im\xF3vel</bold> ao seu portf\xF3lio. Tem certeza?",
    confirmRemoveAllBody: "\u26A0\uFE0F Esta a\xE7\xE3o vai <bold>remover todos os arquivos de m\xEDdia do im\xF3vel</bold> do seu portf\xF3lio. Tem certeza?",
    confirmAndSave: "Confirmar e salvar",
    updateSuccess: "Downloads do im\xF3vel atualizados com sucesso!",
    updateError: "Ocorreu um erro ao atualizar as configura\xE7\xF5es do m\xEDdia kit.",
    attachIntro: "Anexe brochuras sem marca, plantas e outros arquivos de apresenta\xE7\xE3o prontos para o corretor, que seus clientes podem baixar direto da p\xE1gina do im\xF3vel.",
    unsavedChanges: "Voc\xEA tem altera\xE7\xF5es n\xE3o salvas!",
    addAllFiles: "Adicionar todos os arquivos",
    removeAllFiles: "Remover todos os arquivos"
  },
  releaseNotes: {
    subtitle: "Fique por dentro das \xFAltimas mudan\xE7as, melhorias e novos recursos da API da DASH."
  },
  welcomeDiscoveryModal: {
    eyebrow: "VOC\xCA ENTROU",
    heading: "Boas-vindas \xE0 DASH, {{firstName}}.",
    intro: "Agora voc\xEA est\xE1 em um <tag>plano gratuito</tag> e pode explorar todos os lan\xE7amentos da DASH.",
    includedTitle: "INCLU\xCDDO NO PLANO GRATUITO:",
    feature1: "Explore todo o banco de dados de im\xF3veis da DASH",
    feature2: "Acesse o feed semanal de im\xF3veis em alta",
    feature3: "Salve e acompanhe at\xE9 5 im\xF3veis",
    feature4: "Agende uma demonstra\xE7\xE3o gr\xE1tis para ver como a DASH apoia as vendas de lan\xE7amentos",
    unlockHeading: "Libere todo o banco de dados por apenas $10/m\xEAs",
    unlockSubtext: "7 dias de teste gr\xE1tis, cancele quando quiser",
    seeAllPlans: "Ver todos os planos",
    startExploring: "Come\xE7ar a explorar",
    close: "Fechar",
    firstNameFallback: "voc\xEA"
  },
  quickTour: {
    label: "Tour r\xE1pido",
    progress: "{{current}} de {{total}}",
    skip: "Pular tour",
    back: "Voltar",
    next: "Pr\xF3ximo",
    done: "Conclu\xEDdo",
    searchTitle: "Inicie uma busca de im\xF3veis",
    searchDescription: "Busque na DASH por im\xF3vel, localiza\xE7\xE3o ou incorporadora.",
    sectionsTitle: "Descubra im\xF3veis",
    sectionsDescription: "Explore im\xF3veis em alta e categorias com recomenda\xE7\xF5es din\xE2micas.",
    featuredPortfoliosTitle: "Portf\xF3lios em destaque",
    featuredPortfoliosDescription: "Cole\xE7\xF5es de im\xF3veis prontas para compartilhar, selecionadas pela equipe da DASH.",
    mapTitle: "Explore o mapa",
    mapDescription: "Navegue pelo mapa para ter uma vis\xE3o completa do mercado de condom\xEDnios novos e na planta da Fl\xF3rida.",
    sidebarTitle: "Navegue pela DASH com facilidade",
    sidebarDescription: "Acesse os principais recursos da DASH de forma r\xE1pida e simples.",
    bottomNavTitle: "Navegue pela DASH com facilidade",
    bottomNavDescription: "Acesse os principais recursos da DASH de forma r\xE1pida e simples.",
    profileTitle: "Gerencie sua conta",
    profileDescription: "Acesse o perfil, a cobran\xE7a e as configura\xE7\xF5es da sua conta.",
    searchFiltersTitle: "Busque com filtros",
    searchFiltersDescription: "Combine termos de busca com os filtros da DASH para encontrar exatamente o que procura.",
    searchSortTitle: "Ordena\xE7\xE3o da busca",
    searchSortDescription: "Ordene os resultados por pre\xE7o, atualiza\xE7\xF5es recentes e mais para navegar com efici\xEAncia.",
    searchViewsTitle: "Visualiza\xE7\xE3o em grade e em mapa",
    searchViewsDescription: "Veja os resultados em uma grade de lista ou mude para o mapa para uma vis\xE3o geogr\xE1fica.",
    searchWatchlistTitle: "Adicione \xE0 sua lista de acompanhamento",
    searchWatchlistDescription: "Clique no \xEDcone de cora\xE7\xE3o para adicionar um im\xF3vel ou portf\xF3lio \xE0 sua lista de acompanhamento pessoal.",
    searchPortfolioTitle: "Salve im\xF3veis em um portf\xF3lio",
    searchPortfolioDescription: "Clique no \xEDcone de pasta para salvar um im\xF3vel em um portf\xF3lio e compartilh\xE1-lo depois.",
    watchlistPropertiesTitle: "Lista de acompanhamento de im\xF3veis",
    watchlistPropertiesDescription: "Os im\xF3veis que voc\xEA salva na sua lista de acompanhamento ficam aqui, com alertas de atualiza\xE7\xE3o e acesso f\xE1cil.",
    watchlistPortfoliosTitle: "Lista de acompanhamento de portf\xF3lios",
    watchlistPortfoliosDescription: "Os portf\xF3lios selecionados que voc\xEA salva na sua lista de acompanhamento ficam aqui, para acesso e compartilhamento f\xE1ceis.",
    watchlistSavedTitle: "Buscas salvas",
    watchlistSavedDescription: "Salve uma busca personalizada com filtros para receber alertas quando im\xF3veis novos ou atualizados corresponderem.",
    portfolioAddTitle: "Portf\xF3lios personalizados",
    portfolioAddDescription: "Crie um novo portf\xF3lio para organizar e compartilhar im\xF3veis em links com a sua marca.",
    portfolioPreviewTitle: "Veja uma pr\xE9via do seu portf\xF3lio",
    portfolioPreviewDescription: "Veja seu portf\xF3lio no modo cliente para saber como ele ficar\xE1 quando for compartilhado.",
    portfolioShareTitle: "Configura\xE7\xF5es de compartilhamento personalizadas",
    portfolioShareDescription: "Os portf\xF3lios podem ser p\xFAblicos, protegidos por senha ou privados, vis\xEDveis somente para voc\xEA.",
    portfolioCreateTitle: "D\xEA um nome ao seu portf\xF3lio",
    portfolioCreateDescription: "D\xEA um nome ao seu portf\xF3lio e comece a adicionar im\xF3veis para compartilhar com seus clientes.",
    portfolioGuideTitle: "Leia o guia",
    portfolioGuideDescription: "Confira o guia de in\xEDcio r\xE1pido do DASH Pro com dicas para criar e compartilhar portf\xF3lios.",
    exchangeSettingsTitle: "Conecte seu site",
    exchangeSettingsDescription: "Informe a URL do site que vai exibir o seu feed de lan\xE7amentos e personalize as cores do feed.",
    exchangeAddFeedTitle: "Crie feeds",
    exchangeAddFeedDescription: "Crie um feed para exibir no seu site um \xFAnico im\xF3vel, um portf\xF3lio ou uma barra de busca da DASH.",
    exchangeNewFeedTitle: "Configure um feed",
    exchangeNewFeedDescription: "D\xEA um nome ao seu feed e escolha o tipo de feed. Depois clique em Criar para salvar o novo feed.",
    exchangeFeedSaveTitle: "Salvar e visualizar",
    exchangeFeedSaveDescription: "Salve suas configura\xE7\xF5es e a pr\xE9via do feed mostrar\xE1 como ele ficar\xE1 dentro do iFrame no seu site.",
    exchangeFeedGuideTitle: "Leia o guia",
    exchangeFeedGuideDescription: "Confira o guia de in\xEDcio r\xE1pido do DASH eXchange para mais dicas."
  },
  quickStart: {
    eyebrow: "In\xEDcio r\xE1pido",
    // DSH-857: page-aware pill brand ("Pulse · [page]") + panel section headers.
    pulse: "Pulse",
    onThisPage: "Nesta p\xE1gina",
    exploreNext: "Explore a seguir",
    unlockTitle: "Libere com PRO e eXchange",
    lockedHint: "Fa\xE7a upgrade para liberar",
    replay: "Rever",
    title: "Configure sua conta",
    doneCount: "<highlight>{{current}}</highlight> de {{total}} conclu\xEDdos",
    close: "Fechar",
    dontShowAgain: "N\xE3o mostrar novamente",
    itemTour: "Fa\xE7a o tour do produto",
    itemSearch: "Fa\xE7a sua primeira busca",
    itemOpenDevelopment: "Abra um empreendimento",
    itemSaveProperty: "Salve um im\xF3vel",
    itemTryFilter: "Experimente um filtro",
    itemPortfolios: "Veja os portf\xF3lios",
    itemViewWatchlist: "Revise sua lista de acompanhamento",
    itemExploreExchange: "Conhe\xE7a o DASH eXchange"
  },
  cmsSettingsPage: {
    title: "Configura\xE7\xF5es de transi\xE7\xE3o de status do CMS",
    description: "Configure as transi\xE7\xF5es autom\xE1ticas de status dos an\xFAncios de im\xF3veis. Estas configura\xE7\xF5es definem por quanto tempo os im\xF3veis permanecem em cada status antes de passar automaticamente para o pr\xF3ximo.",
    automatedTransitions: "Ativar transi\xE7\xF5es autom\xE1ticas",
    automatedTransitionsDescription: "Quando ativado, o status dos im\xF3veis mudar\xE1 automaticamente com base nos prazos definidos abaixo",
    transitionTimes: "Prazos de transi\xE7\xE3o",
    newListingToActive: "Novo an\xFAncio \u2192 An\xFAncio ativo",
    newListingToActiveHelp: "Dias at\xE9 um im\xF3vel rec\xE9m-aprovado se tornar ativo",
    activeToAudit: "An\xFAncio ativo \u2192 Aguardando auditoria",
    activeToAuditHelp: "Dias at\xE9 um an\xFAncio ativo exigir revis\xE3o de conte\xFAdo",
    recentlyUpdatedToActive: "Atualizado recentemente \u2192 An\xFAncio ativo",
    recentlyUpdatedToActiveHelp: "Dias at\xE9 um im\xF3vel atualizado voltar ao status ativo",
    resetToDefaults: "Restaurar padr\xF5es",
    resetConfirmationTitle: "Redefinir configura\xE7\xF5es",
    resetConfirmationMessage: "Tem certeza de que deseja restaurar as configura\xE7\xF5es padr\xE3o?",
    confirm: "Confirmar",
    validationError: "Corrija os erros de valida\xE7\xE3o antes de enviar",
    updateSuccess: "Configura\xE7\xF5es atualizadas com sucesso",
    updateError: "N\xE3o foi poss\xEDvel atualizar as configura\xE7\xF5es",
    resetSuccess: "Configura\xE7\xF5es restauradas para o padr\xE3o",
    resetError: "N\xE3o foi poss\xEDvel restaurar as configura\xE7\xF5es"
  },
  v2Components: {
    agentContact: {
      messageSent: "Sua mensagem foi enviada e o corretor entrar\xE1 em contato em breve.",
      brokerImageAlt: "Imagem do corretor",
      logoAlt: "Logo da Dash",
      visitWebsite: "Visitar site",
      contactMe: "Fale comigo",
      contactMeTitle: "Fale comigo"
    },
    brokerModal: {
      contactMe: "Fale comigo",
      loadingProperties: "Carregando im\xF3veis...",
      propertyPortfolio: "Portf\xF3lio de im\xF3veis ({{total}})",
      loadMore: "Carregar mais"
    },
    subscriptionCard: {
      newBadge: "NOVO",
      saveTenPercent: "Economize 10%!",
      currentPlanBadge: "Plano atual",
      cancelsOn: "Cancela em {{date}}",
      trialEnds: "O teste termina em {{date}}",
      getPlan: "Assinar {{name}}",
      trialBadge: "Teste de {{days}} dias",
      yourCurrentPlan: "Seu plano atual",
      cancelTrial: "Cancelar teste",
      manageOrCancel: "Gerenciar ou cancelar assinatura"
    },
    idxContactForm: {
      fillRequiredFields: "Preencha todos os campos obrigat\xF3rios antes de enviar a mensagem.",
      avatarAlt: "Imagem do avatar",
      contactMe: "FALE COMIGO"
    },
    idxProperty: {
      developerVerified: "Incorporadora verificada",
      completionIn: "Conclus\xE3o em {{year}}."
    },
    idxSettings: {
      title: "Configura\xE7\xF5es do Exchange",
      websiteDomain: "Dom\xEDnio do site",
      websiteDomainRequired: "O dom\xEDnio do site \xE9 obrigat\xF3rio.",
      invalidUrl: "A URL deve come\xE7ar com http:// ou https:// e ser v\xE1lida.",
      websiteDomainHelp: "Digite a URL do site que exibir\xE1 o feed do Exchange.",
      wixDomainWarning: "Esta URL cont\xE9m <code>.filesusr.com</code>, espec\xEDfico de sites Wix. Se voc\xEA n\xE3o usa mais o Wix, atualize a URL para o dom\xEDnio real do seu site.",
      wixFormatNote: "Ao salvar, sua URL ser\xE1 convertida para o formato de iframe do Wix (ex.: <code>www-yoursite-com.filesusr.com</code>).",
      wixSite: "Site Wix",
      wixSiteHelp: "Marque esta op\xE7\xE3o se seu site foi criado com o <link>Wix</link> para que possamos formatar o endere\xE7o corretamente.",
      brandingColors: "Cores da marca",
      mainColor: "Cor principal",
      textColor: "Cor do texto",
      backgroundColor: "Cor de fundo",
      chooseColor: "Escolha uma cor",
      transparent: "Transparente",
      resetColors: "Redefinir cores"
    },
    deleteFeed: {
      title: "Confirmar exclus\xE3o?",
      question: "Voc\xEA realmente quer excluir o feed {{name}}?",
      warning: "Observe que esta a\xE7\xE3o n\xE3o pode ser desfeita."
    },
    newFeed: {
      title: "Novo feed do Exchange",
      name: "Nome",
      namePlaceholder: "Digite um nome",
      nameRequired: "O nome \xE9 obrigat\xF3rio.",
      type: "Tipo",
      typeRequired: "O tipo \xE9 obrigat\xF3rio.",
      selectType: "Selecione um tipo",
      typeSingleProperty: "Im\xF3vel \xFAnico",
      typePortfolio: "Portf\xF3lio",
      typeSearchBar: "Barra de busca",
      typeLocation: "Localiza\xE7\xE3o"
    },
    searchBar: {
      filters: "Filtros",
      filtersSubtitle: "Filtre os im\xF3veis de acordo com suas prefer\xEAncias",
      type: "Tipo",
      status: "Status",
      marketArea: "Regi\xE3o de mercado",
      marketAreas: "Regi\xF5es de mercado",
      buildingType: "Tipo de edif\xEDcio",
      selectType: "Selecione o tipo",
      selectStatus: "Selecione o status",
      selectTransaction: "Selecione a transa\xE7\xE3o",
      selectTag: "Selecione a tag",
      selectMarketAreas: "Selecione as regi\xF5es de mercado",
      filterAreasPlaceholder: "Digite para filtrar regi\xF5es",
      noMarketAreas: "Nenhuma regi\xE3o de mercado encontrada.",
      minPrice: "Pre\xE7o m\xEDn.",
      maxPrice: "Pre\xE7o m\xE1x.",
      selectOptions: "Selecione as op\xE7\xF5es...",
      searchPlaceholder: "Buscar...",
      noOptionsFound: "Nenhuma op\xE7\xE3o encontrada.",
      seeMore: "Ver mais"
    }
  },
  authCommon: {
    logoAlt: "Logo da Dash",
    peopleAlt: "Pessoas na Dash"
  },
  codeConfirmationPage: {
    emailResent: "E-mail reenviado!",
    invalidCode: "C\xF3digo inv\xE1lido.",
    invalidOrExpiredCode: "C\xF3digo inv\xE1lido ou expirado.",
    title: "Confirme seu e-mail",
    subtitle: "Digite o c\xF3digo de verifica\xE7\xE3o enviado para o seu e-mail: {{email}}.",
    codeLabel: "C\xF3digo de confirma\xE7\xE3o",
    submitButton: "Confirmar c\xF3digo",
    resendHelp: "N\xE3o recebeu o e-mail?<br />Verifique a pasta de spam e <resend>reenvie o c\xF3digo</resend>.",
    differentAccount: "Ou <logout>tente outra conta</logout>"
  },
  ssoCallbackPage: {
    redirecting: "Redirecionando...",
    reloadHint: "Se voc\xEA n\xE3o for redirecionado em at\xE9 5 segundos, recarregue a p\xE1gina."
  },
  signUpValidation: {
    firstNameRequired: "O nome \xE9 obrigat\xF3rio.",
    firstNameMin: "O nome deve ter pelo menos 2 caracteres.",
    firstNameMax: "O nome deve ter no m\xE1ximo 20 caracteres.",
    firstNameLetters: "O nome deve conter apenas letras e h\xEDfen.",
    firstNameHyphen: "O nome n\xE3o pode come\xE7ar nem terminar com h\xEDfen.",
    lastNameRequired: "O sobrenome \xE9 obrigat\xF3rio.",
    lastNameMin: "O sobrenome deve ter pelo menos 2 caracteres.",
    lastNameMax: "O sobrenome deve ter no m\xE1ximo 20 caracteres.",
    lastNameLetters: "O sobrenome deve conter apenas letras e h\xEDfen.",
    lastNameHyphen: "O sobrenome n\xE3o pode come\xE7ar nem terminar com h\xEDfen.",
    emailRequired: "O e-mail \xE9 obrigat\xF3rio.",
    emailInvalid: "O e-mail deve ser v\xE1lido.",
    countryRequired: "O pa\xEDs \xE9 obrigat\xF3rio.",
    stateRequired: "O estado \xE9 obrigat\xF3rio.",
    licenseMax: "O n\xFAmero da licen\xE7a deve ter no m\xE1ximo 20 caracteres.",
    licenseRequired: "O n\xFAmero da licen\xE7a \xE9 obrigat\xF3rio.",
    agreementRequired: "Voc\xEA deve aceitar os termos e condi\xE7\xF5es.",
    passwordRequired: "A senha \xE9 obrigat\xF3ria.",
    passwordMin: "A senha deve ter pelo menos 8 caracteres.",
    passwordMin6: "A senha deve ter pelo menos 6 caracteres.",
    passwordComplexity: "A senha deve conter pelo menos 1 letra mai\xFAscula, 1 letra min\xFAscula, 1 n\xFAmero e 1 caractere especial.",
    confirmPasswordRequired: "A confirma\xE7\xE3o da senha \xE9 obrigat\xF3ria.",
    confirmPasswordMismatch: "A confirma\xE7\xE3o da senha n\xE3o confere."
  },
  signUpV2Page: {
    emailAlreadyRegistered: "E-mail j\xE1 cadastrado.",
    licenseAlreadyRegistered: "N\xFAmero de licen\xE7a de corretor j\xE1 cadastrado. Entre em contato com o suporte.",
    apiAccessSetupFailed: "Falha ao configurar o acesso \xE0 API: {{message}}",
    areYouAgent: "Voc\xEA \xE9 corretor de im\xF3veis?",
    selectAnswer: "Selecione uma resposta para continuar com o cadastro.",
    yes: "Sim",
    no: "N\xE3o",
    notAgent: "N\xE3o \xE9 corretor de im\xF3veis?",
    clickHere: "Clique aqui",
    title: "Criar uma conta na Dash",
    subtitle: "Sua privacidade \xE9 importante para n\xF3s. A DASH nunca compartilhar\xE1 suas informa\xE7\xF5es.",
    signUpMiamiRealtors: "Cadastrar-se com MIAMI REALTORS",
    signUpGoogle: "Cadastrar-se com o Google",
    alreadyMember: "J\xE1 \xE9 membro da DASH? <link>Entrar</link>",
    country: "Pa\xEDs",
    selectCountry: "Selecione seu pa\xEDs",
    selectState: "Selecione seu estado",
    agentLicenseNumber: "N\xFAmero da licen\xE7a de corretor",
    agreeTerms: "Concordo com os <terms>termos e condi\xE7\xF5es</terms> e com a <privacy>pol\xEDtica de privacidade</privacy>.",
    createAccount: "Criar conta"
  },
  ssoSignUpPage: {
    licenseAlreadyExists: "O n\xFAmero da licen\xE7a j\xE1 existe.",
    welcome: "Boas-vindas!",
    welcomeName: "Boas-vindas, {{name}}!",
    authenticated: "Voc\xEA foi autenticado com sucesso com {{provider}}. Complete seu perfil antes de continuar.",
    useNormalSignUp: "Quer usar outro e-mail? <link>Use o cadastro normal</link>.",
    finishSignUp: "Concluir cadastro"
  },
  apiAccessAcceptPage: {
    linkFailed: "Falha ao vincular o acesso \xE0 API.",
    validateFailed: "Falha ao validar o convite.",
    acceptFailed: "Falha ao aceitar o convite.",
    title: "Acesso \xE0 API",
    verifying: "Verificando seu convite\u2026",
    missingToken: "Nenhum token de convite encontrado no link. Use o link do e-mail do seu convite.",
    goToSignIn: "Ir para o login",
    expired: "Este convite expirou. Pe\xE7a ao seu administrador que envie um novo.",
    invalid: "Este link de convite \xE9 inv\xE1lido ou j\xE1 foi usado.",
    wrongAccount: "Este convite foi emitido para {{invitedEmail}}, mas voc\xEA est\xE1 conectado como {{currentEmail}}. Saia para continuar aceitando.",
    anotherEmail: "outro e-mail",
    differentUser: "outro usu\xE1rio",
    signOut: "Sair",
    accountExists: "J\xE1 existe uma conta para {{email}}. Entre para vincular o acesso \xE0 API a ela.",
    signInToContinue: "Entre para continuar",
    invited: "Voc\xEA foi convidado a acessar a API da DASH. Crie sua conta para continuar.",
    invitedWithCompany: "Voc\xEA foi convidado a acessar a API da DASH para {{company}}. Crie sua conta para continuar.",
    passwordPlaceholder: "Digite a senha",
    passwordHint: "Pelo menos 6 caracteres, com uma letra mai\xFAscula, uma min\xFAscula, um n\xFAmero e um s\xEDmbolo.",
    accepting: "Aceitando\u2026",
    acceptButton: "Aceitar convite",
    genericError: "Algo deu errado. Tente novamente."
  },
  stripeCheckoutResultPage: {
    processing: "Aguarde enquanto configuramos sua assinatura",
    takingTooLong: "Est\xE1 demorando muito? <reload>Recarregue a p\xE1gina</reload> ou <support>entre em contato com o suporte da DASH</support>",
    getApiKeys: "Obtenha suas chaves de API!",
    startBrowsing: "Comece a explorar!",
    allSet: "Tudo pronto!",
    thankYou: "Obrigado pela sua compra, {{name}}!",
    trialEnds: "Seu per\xEDodo de teste termina em <highlight>{{date}}</highlight>",
    paymentProcessed: "Seu pagamento de <highlight>${{amount}}</highlight> foi processado com sucesso.",
    errorTitle: "Ops, ocorreu um erro ao processar sua assinatura!",
    contactSupport: "Falar com o suporte",
    expiredTitle: "Ops, esta p\xE1gina expirou!",
    goToDashboard: "Ir para o painel"
  },
  chunkErrorBoundary: {
    newVersion: "H\xE1 uma nova vers\xE3o da DASH dispon\xEDvel.",
    reload: "Recarregar"
  },
  confirmSsoNameModal: {
    title: "Confirme seu nome",
    subtitle: "\xC9 assim que voc\xEA aparecer\xE1 para seus clientes.",
    firstName: "Nome",
    lastName: "Sobrenome",
    continue: "Continuar"
  },
  maintenancePage: {
    logoAlt: "Logo da Dash",
    title: "Estamos reorganizando as coisas!",
    apology: "Desculpe o transtorno!",
    updating: "Estamos atualizando nossos servidores para melhorar o servi\xE7o.",
    tryLater: "Tente novamente mais tarde."
  },
  exchangePage: {
    settingsCreated: "Configura\xE7\xF5es do IDX criadas com sucesso.",
    settingsUpdated: "Configura\xE7\xF5es do IDX atualizadas com sucesso.",
    feedCreated: "Feed do IDX criado com sucesso.",
    feedDeleted: "Feed do IDX exclu\xEDdo com sucesso.",
    searchPlaceholder: "Buscar feed por nome",
    sortNameAsc: "Nome (A-Z)",
    sortNameDesc: "Nome (Z-A)",
    sortNewest: "Mais recentes primeiro",
    sortOldest: "Mais antigos primeiro",
    addNew: "Adicionar novo",
    missingSettingsAlert: "Para come\xE7ar a criar feeds do eXchange, abra a aba de configura\xE7\xF5es e defina o nome do seu dom\xEDnio.",
    loadError: "Erro ao carregar os feeds do Exchange.",
    noResults: "Nenhum resultado encontrado.",
    feedsCount_one: "{{count}} feed do Exchange",
    feedsCount_other: "{{count}} feeds do Exchange",
    typePortfolio: "Portf\xF3lio",
    typeProperty: "Im\xF3vel",
    typeSearchBar: "Barra de busca",
    typeLocation: "Localiza\xE7\xE3o",
    showingFeeds: "Exibindo {{from}} - {{to}} de {{total}} feeds"
  },
  exchangeFeedPage: {
    updated: "Feed do Exchange atualizado com sucesso!",
    updateError: "Erro ao atualizar o feed do Exchange.",
    upgradeTitle: "Tenha acesso aos feeds do Exchange com o plano DASH Exchange!",
    manageSubscription: "Gerenciar sua assinatura",
    previewNotice: "A pr\xE9via mostra o que est\xE1 no ar no seu site. Salve para publicar suas altera\xE7\xF5es.",
    breadcrumb: "Detalhes do feed",
    title: "Detalhes do feed",
    feedNameLabel: "Nome do feed*",
    feedNamePlaceholder: "Nome do feed",
    feedTypeLabel: "Tipo de feed*",
    feedTypePlaceholder: "Tipo de feed",
    typePortfolio: "Portf\xF3lio",
    typeSingleProperty: "Im\xF3vel \xFAnico",
    typeSearchBar: "Barra de busca",
    typeLocation: "Localiza\xE7\xE3o",
    propertyLabel: "Im\xF3vel",
    propertyPlaceholder: "Busque e selecione um im\xF3vel",
    propertySearchHint: "Digite pelo menos 3 caracteres para ver os resultados",
    portfolioLabel: "Portf\xF3lio",
    portfolioPlaceholder: "Busque e selecione um dos seus portf\xF3lios",
    layoutLabel: "Layout*",
    layoutGrid: "Grade como padr\xE3o",
    layoutMap: "Mapa como padr\xE3o",
    propertiesPerPage: "Im\xF3veis por p\xE1gina",
    propertiesPerPageTitle: "Im\xF3veis por p\xE1gina",
    contentLabel: "Conte\xFAdo*",
    contentSearchBarOnly: "Somente barra de busca",
    contentListGrid: "Barra de busca com lista (grade como padr\xE3o)",
    contentListMap: "Barra de busca com lista (mapa como padr\xE3o)",
    locationsLabel: "Localiza\xE7\xF5es*",
    embedStandard: "Padr\xE3o",
    embedScrollbarFree: "Sem barra de rolagem",
    embedFixedDescription: "A mais f\xE1cil de configurar. O iframe tem altura fixa e o conte\xFAdo rola dentro dele.",
    embedDynamicDescription: "O iframe ajusta a altura ao conte\xFAdo, eliminando a barra de rolagem interna.",
    resizeHint: "Arraste o canto inferior direito para redimensionar a pr\xE9via.",
    scriptHint: "Esta op\xE7\xE3o inclui um pequeno script que precisa ser executado na sua p\xE1gina.",
    codeTitle: "C\xF3digo",
    codeIntro: "Copie e cole este trecho de c\xF3digo no seu site. <bold>Evite editar este c\xF3digo, pois ele pode deixar de funcionar corretamente.</bold>",
    navbarFixedHint: "Se o seu site tem uma barra de navega\xE7\xE3o fixa, ajuste o valor <mono>height: calc(100vh - 0px)</mono> para a altura dela (ex.: <mono2>height: calc(100vh - 60px)</mono2>).",
    navbarDynamicHint: "Se o seu site tem uma barra de navega\xE7\xE3o fixa, ajuste os valores <mono>scroll-margin-top</mono> e <mono2>dashIdxNavbarHeight</mono2> para a altura dela.",
    codeCopied: "C\xF3digo copiado!",
    copyCode: "Copiar c\xF3digo",
    guideTitle: "Aprenda a usar o DASH eXchange",
    guideBody: "Consulte o <link>Guia de in\xEDcio r\xE1pido do DASH eXchange</link> para saber como criar e gerenciar feeds da DASH.",
    helpBody: "Precisa de ajuda? <link>Fale com o suporte</link> para configurar o DASH eXchange no seu site.",
    chartTitle: "Im\xF3veis clicados entre {{start}} e {{end}}",
    missingEmbedPortfolio: "Selecione um portf\xF3lio e salve para gerar seu c\xF3digo de incorpora\xE7\xE3o.",
    missingEmbedProperty: "Selecione um im\xF3vel e salve para gerar seu c\xF3digo de incorpora\xE7\xE3o.",
    missingEmbedLocation: "Selecione pelo menos uma localiza\xE7\xE3o e salve para gerar seu c\xF3digo de incorpora\xE7\xE3o.",
    missingEmbedSearchBar: "Salve para gerar seu c\xF3digo de incorpora\xE7\xE3o.",
    errors: {
      nameRequired: "O nome \xE9 obrigat\xF3rio.",
      searchBarContentRequired: "O conte\xFAdo da barra de busca \xE9 obrigat\xF3rio.",
      propertyRequired: "O im\xF3vel \xE9 obrigat\xF3rio.",
      portfolioRequired: "O portf\xF3lio \xE9 obrigat\xF3rio.",
      locationRequired: "Selecione pelo menos um condado, cidade ou regi\xE3o de mercado.",
      pageLengthRequired: "O tamanho da p\xE1gina \xE9 obrigat\xF3rio.",
      layoutRequired: "O conte\xFAdo de exibi\xE7\xE3o do portf\xF3lio \xE9 obrigat\xF3rio.",
      salesMaterialsSearchBar: "Os materiais de vendas n\xE3o est\xE3o dispon\xEDveis para o tipo de feed Barra de busca.",
      customSalesSingleProperty: "Os materiais de vendas personalizados n\xE3o est\xE3o dispon\xEDveis para o tipo de feed Im\xF3vel \xFAnico.",
      customSalesLocation: "Os materiais de vendas personalizados n\xE3o est\xE3o dispon\xEDveis para o tipo de feed Localiza\xE7\xE3o.",
      customSalesRequireSales: "Os materiais de vendas personalizados exigem que 'Mostrar materiais de vendas' esteja ativo."
    }
  },
  idxEmbedded: {
    viewMode: "Modo de exibi\xE7\xE3o:",
    gridView: "Grade",
    emptyArea: "Ainda n\xE3o h\xE1 im\xF3veis dispon\xEDveis nesta regi\xE3o.",
    emptyFeed: "{{name}} ainda n\xE3o adicionou nenhum im\xF3vel a este feed.",
    loadingProperties: "Carregando im\xF3veis...",
    priceFrom: "A partir de",
    completionIn: "Conclus\xE3o em {{year}}.",
    completedIn: "Conclu\xEDdo em {{year}}",
    estCompletionIn: ", conclus\xE3o estimada em {{year}}",
    poweredBy: "Desenvolvido por",
    searchPlaceholder: "Nome do empreendimento, cidade, endere\xE7o, incorporadora...",
    resetMapBoundaries: "Redefinir limites do mapa",
    showingProperties_one: "Exibindo {{from}} - {{to}} de {{total}} im\xF3vel",
    showingProperties_other: "Exibindo {{from}} - {{to}} de {{total}} im\xF3veis",
    propertiesFound_one: "{{count}} im\xF3vel encontrado",
    propertiesFound_other: "{{count}} im\xF3veis encontrados",
    noResults: "Nenhum im\xF3vel encontrado. Altere os filtros e tente novamente!",
    inventorySection: "Se\xE7\xE3o de estoque",
    model: "Modelo",
    loadingUnits: "Carregando unidades...",
    contactForAvailability: "Fale comigo sobre disponibilidade",
    pricedFrom: "A partir de:",
    addlRooms: "C\xF4modos adic.:",
    totalSqft: "TOTAL SQFT:",
    showingRange: "Exibindo {{from}} - {{to}} de {{total}}",
    numberOfStories: "N\xFAmero de andares",
    interiorDesign: "Design de interiores"
  },
  propertiesSearch: {
    selectedMarketArea: "Regi\xE3o de mercado selecionada"
  },
  locationPicker: {
    label: "Localiza\xE7\xF5es",
    loading: "Carregando localiza\xE7\xF5es...",
    searchPlaceholder: "Busque condados, cidades e regi\xF5es de mercado",
    includedIn: "Inclu\xEDdo em {{places}}",
    remove: "Remover {{name}}",
    counting: "Contando im\xF3veis...",
    matchCount_one: "Sua sele\xE7\xE3o corresponde a {{count}} im\xF3vel.",
    matchCount_other: "Sua sele\xE7\xE3o corresponde a {{count}} im\xF3veis."
  },
  locationPortfolio: {
    updated: "Localiza\xE7\xF5es atualizadas.",
    editLocations: "Editar localiza\xE7\xF5es",
    editModalBody: "Os im\xF3veis dessas localiza\xE7\xF5es s\xE3o adicionados ao portf\xF3lio automaticamente e removidos quando saem ou deixam de ser anunciados.",
    followedLocations: "Localiza\xE7\xF5es acompanhadas",
    followsLocations: "Segue localiza\xE7\xF5es",
    panelBody: "Os im\xF3veis dessas localiza\xE7\xF5es s\xE3o adicionados e removidos automaticamente conforme os an\xFAncios mudam.",
    sourceQuestion: "Como voc\xEA quer mont\xE1-lo?",
    sourceManualTitle: "Escolher os im\xF3veis voc\xEA mesmo",
    sourceManualBody: "Adicione im\xF3veis um a um a partir da busca, de alertas ou de qualquer p\xE1gina de im\xF3vel.",
    sourceLocationsTitle: "Seguir localiza\xE7\xF5es",
    sourceLocationsBody: "Escolha condados, cidades ou regi\xF5es de mercado. Os im\xF3veis s\xE3o adicionados e removidos automaticamente conforme os an\xFAncios mudam."
  },
  sharePropertyPage: {
    contactMe: "Fale comigo",
    messageSent: "Sua mensagem foi enviada e o corretor entrar\xE1 em contato em breve.",
    brokerImageAlt: "Imagem do corretor"
  },
  landingPages: {
    upgradeNow: "Fazer upgrade agora",
    portfolio: {
      heroTitle: "Seja PRO \u2014 o jeito mais inteligente de vender lan\xE7amentos",
      heroSubtitle: "Apresente. Compartilhe. Feche.",
      heroDescription: "Com o DASH Pro, voc\xEA tem tudo para divulgar e vender os lan\xE7amentos mais quentes da Fl\xF3rida com facilidade e confian\xE7a, em 3 passos simples:",
      step1Title: "Crie portf\xF3lios de im\xF3veis selecionados",
      step1Feature1: "Adicione im\xF3veis de qualquer mercado da Fl\xF3rida",
      step1Feature2: "Sem limites, acesso total",
      step1Feature3: "Compartilhe apresenta\xE7\xF5es profissionais em minutos",
      step2Title: "Adicione materiais de vendas sem marca",
      step2Feature1: "Baixe plantas, brochuras e conte\xFAdo das incorporadoras",
      step2Feature2: "Todo o conte\xFAdo sem marca e pronto para compartilhar",
      step2Feature3: "Adicione arquivos e envie apresenta\xE7\xF5es aos seus clientes com facilidade",
      step3Title: "Compartilhe links com a sua marca de corretor",
      step3Feature1: "Troque a marca da incorporadora pelas suas informa\xE7\xF5es de contato",
      step3Feature2: "Dados e informa\xE7\xF5es dos im\xF3veis atualizados em tempo real, sem esfor\xE7o",
      step3Feature3: "Capte leads facilmente em cada link que voc\xEA compartilhar",
      ctaTitle: "Fa\xE7a upgrade para o PRO agora por apenas $25/month",
      ctaSubtitle: "Inclui tudo do plano BASIC, mais acesso total aos downloads e \xE0s ferramentas de portf\xF3lio para corretores.",
      ctaDescription: "Compartilhe seus portf\xF3lios com clientes"
    },
    exchange: {
      heroTitle: "Apresente lan\xE7amentos no seu site sem esfor\xE7o",
      heroDescription: "Os feeds do eXchange da DASH entregam an\xFAncios de im\xF3veis personaliz\xE1veis e em tempo real, que ajudam voc\xEA a impressionar clientes e fechar mais neg\xF3cios de empreendimentos novos.",
      feature1Title: "Apresente empreendimentos novos no seu site",
      feature1Item1: "Acesso total aos dados verificados da DASH sobre lan\xE7amentos e im\xF3veis na planta",
      feature1Item2: "V\xE1rios tipos de feed, como busca, portf\xF3lios e im\xF3veis \xFAnicos",
      feature1Item3: "Cores e estilos personaliz\xE1veis",
      feature2Title: "Gera\xE7\xE3o de leads personalizada",
      feature2Item1: "Troque a marca de vendas do empreendimento pela sua",
      feature2Item2: "Gere leads por meio de formul\xE1rios de contato seguros",
      feature2Item3: "Otimizado para celular e pronto para converter",
      feature3Title: "Integra\xE7\xE3o f\xE1cil com o seu site",
      feature3Item1: "Incorpore os feeds iframe do eXchange em qualquer lugar do seu site",
      feature3Item2: "Atualiza\xE7\xF5es em tempo real, sem manuten\xE7\xE3o manual",
      feature3Item3: "Compat\xEDvel com as principais plataformas de sites",
      ctaTitle: "Fa\xE7a upgrade para o DASH Exchange agora por apenas $60/month",
      ctaSubtitle: "Inclui tudo do plano PRO, mais acesso total \xE0s ferramentas de feed para sites, para corretores.",
      demoLink: "Veja como os melhores corretores usam o eXchange"
    }
  },
  portalShell: {
    logoAlt: "Logo da Dash",
    home: "In\xEDcio",
    showMore: "Mostrar mais",
    showLess: "Mostrar menos",
    customRoomsPlaceholder: "Escrit\xF3rio, estudo, garagem, etc...",
    intSqft: "SQFT int.:",
    extSqft: "SQFT ext.:",
    totalSqft: "SQFT total:"
  },
  apiPortal: {
    notFound: "404 N\xE3o encontrado",
    apiDocumentation: "Documenta\xE7\xE3o da API",
    layout: {
      buildingsAlt: "Edif\xEDcios da Dash",
      apiDocs: "Documenta\xE7\xE3o da API",
      apiReleaseNotes: "Novidades da API",
      apiTerms: "Termos de Uso da API",
      privacyPolicy: "Pol\xEDtica de Privacidade",
      copyright: "2026 Dash Inc. Todos os direitos reservados"
    },
    auth: {
      emailRequired: "O e-mail \xE9 obrigat\xF3rio.",
      emailInvalid: "O e-mail deve ser v\xE1lido.",
      passwordRequired: "A senha \xE9 obrigat\xF3ria.",
      passwordPlaceholder: "Digite a senha",
      tokenMissing: "O token n\xE3o foi fornecido pela API.",
      incorrectCredentials: "Credenciais incorretas.",
      loadingAccount: "Carregando as informa\xE7\xF5es da conta, aguarde...",
      redirectHint: "Se voc\xEA n\xE3o for redirecionado em 5 segundos, atualize a p\xE1gina ou entre em contato com o suporte.",
      backToSignIn: "Ou <link>volte para a p\xE1gina de login</link>"
    },
    mfa: {
      codeRequired: "O c\xF3digo \xE9 obrigat\xF3rio.",
      accessTokenMissing: "Erro: token de acesso n\xE3o fornecido. Entre em contato com o suporte.",
      title: "Verifica\xE7\xE3o em duas etapas",
      confirmPrompt: "Confirme o c\xF3digo no seu app autenticador.",
      qrError: "Algo deu errado ao gerar o QR code para ativar a verifica\xE7\xE3o em duas etapas. Entre em contato com o suporte.",
      enableTitle: "Ativar verifica\xE7\xE3o em duas etapas",
      enableScan: "Ative a verifica\xE7\xE3o em duas etapas para continuar. Escaneie o QR code com seu app autenticador.",
      enableCode: "Agora digite o c\xF3digo que aparece no seu app autenticador antes que ele expire.",
      enableDone: "Pronto! Agora a verifica\xE7\xE3o em duas etapas ser\xE1 solicitada toda vez que voc\xEA entrar no aplicativo."
    },
    dashboard: {
      tabTitle: "Painel da API | DASH",
      requestsThisMonth: "Requisi\xE7\xF5es neste m\xEAs (empresa + usu\xE1rios do plugin):",
      needMoreRequests: "Precisa de mais requisi\xE7\xF5es? Clique aqui",
      metricsError: "Ocorreu um erro ao obter as m\xE9tricas de requisi\xE7\xF5es. Atualize a p\xE1gina ou entre em contato com o suporte se o erro persistir.",
      usageDelay: "*As informa\xE7\xF5es de uso podem ter um atraso de at\xE9 1 hora."
    },
    releaseNotes: {
      filterTitle: "Filtrar novidades",
      clearFilters: "Limpar filtros",
      year: "Ano",
      allYears: "Todos os anos",
      changeTypesLabel: "Tipos de altera\xE7\xE3o",
      emptyState: "Nenhuma entrada das novidades corresponde aos seus filtros.",
      changeTypes: {
        newEndpoint: "Novo endpoint",
        enhancement: "Melhoria",
        deprecation: "Descontinua\xE7\xE3o",
        behaviorChange: "Mudan\xE7a de comportamento",
        documentation: "Documenta\xE7\xE3o",
        performance: "Desempenho"
      }
    },
    settings: {
      appIdNotFound: "Nenhum App ID encontrado. Atualize a p\xE1gina ou entre em contato com o suporte se o problema persistir.",
      appIdTitle: "App ID",
      appIdIs: "Seu <bold>App ID</bold> \xE9: {{appId}}",
      appIdSearching: "buscando App ID",
      linkCopied: "Link copiado para a \xE1rea de transfer\xEAncia!",
      docsLine: "Voc\xEA pode acessar nossa documenta\xE7\xE3o <link>clicando aqui.</link>",
      releaseNotesLine: "Veja as altera\xE7\xF5es mais recentes da API nas nossas <link>novidades.</link>",
      termsLine: "Leia os nossos <link>Termos de Uso da API.</link>",
      tokenTitle: "Token da API",
      tokenActive: "J\xE1 existe um token ativo associado a este App ID.<br/>Voc\xEA pode gerar um novo clicando no bot\xE3o abaixo, mas o token atual <bold>ser\xE1 invalidado</bold>.",
      tokenNone: "N\xE3o h\xE1 nenhum token ativo associado a este App ID.<br/>Voc\xEA pode gerar um novo clicando no bot\xE3o abaixo.",
      generateToken: "Gerar novo token",
      referralTitle: "Link de indica\xE7\xE3o",
      referralShare: "Compartilhe este link com seus clientes para dar a eles acesso \xE0 nossa API:",
      referralSteps: "Eles precisam acessar o link, criar uma conta, selecionar o plano API e gerar seus tokens na p\xE1gina de configura\xE7\xF5es.",
      referralSupport: "Se precisar de suporte, entre em contato conosco em <mail>support@dashtodash.com</mail>",
      tokenGenerated: "Token gerado com sucesso. Guarde-o em seguran\xE7a.",
      tokenGenerateFailed: "Falha ao gerar o token. Tente novamente.",
      newTokenIs: "Seu novo token \xE9:",
      tokenCopied: "Token copiado para a \xE1rea de transfer\xEAncia!",
      tokenStoreWarning: "Copie e guarde-o em um lugar seguro. Ele n\xE3o ser\xE1 exibido novamente depois que voc\xEA fechar esta janela.",
      confirmRegenerate: "Tem certeza de que quer gerar um novo token?<br/> O atual <bold>ser\xE1 invalidado</bold>.",
      firstTokenWarning: "<bold>Importante!</bold> Depois de gerar um token, ele ser\xE1 exibido aqui.<br/><br/>Voc\xEA <bold>precisa copi\xE1-lo</bold> e guard\xE1-lo em um lugar seguro. Se o perder, ser\xE1 preciso gerar um novo, e o antigo <bold>ser\xE1 invalidado</bold>.",
      generateModalTitle: "Gerar novo token da API",
      close: "Fechar",
      cancel: "Cancelar"
    }
  },
  confirmUserType: {
    setupError: "Algo deu errado ao configurar sua conta. Tente novamente.",
    title: "Voc\xEA \xE9 corretor de im\xF3veis?",
    subtitle: "Responda para continuar.",
    yes: "Sim",
    no: "N\xE3o"
  },
  subscriptionPlans: {
    billedAnnually: "Cobrado anualmente",
    billedEverySixMonths: "Cobrado a cada 6 meses",
    saveDiscount: "Economize {{percent}}%",
    withYearly: "no plano anual",
    withSixMonths: "no plano semestral",
    monthly: "Mensal",
    yearly: "Anual",
    semiAnnually: "Semestral",
    errorLoading: "Estamos com dificuldade para carregar as informa\xE7\xF5es da assinatura. Atualize a p\xE1gina para tentar novamente.",
    errorTitle: "Algo deu errado",
    refreshPage: "Atualizar p\xE1gina",
    errorSupport: "Se o problema persistir, entre em contato com o suporte.",
    discontinued: "Descontinuado",
    legacyPrice: "Pre\xE7o legado",
    perMonth: "/m\xEAs",
    yourCurrentPlan: "Seu plano atual",
    startFreeTrial: "Come\xE7ar teste gr\xE1tis",
    getPlan: "Assinar {{plan}}",
    seeAllPlans: "Ver todos os planos",
    contactSales: "Falar com vendas",
    bookDemo: "Agendar demonstra\xE7\xE3o",
    reactivateTrial: "Reativar teste",
    cancelTrial: "Cancelar teste",
    cancelScheduledDowngrade: "Cancelar downgrade programado",
    currentPlanNote: "Este \xE9 o seu plano atual.",
    reactivateSubscription: "Reativar assinatura",
    daysLeftInTrial_one: "{{count}} dia restante no teste",
    daysLeftInTrial_other: "{{count}} dias restantes no teste",
    accessExpiresIn_one: "O acesso expira em {{count}} dia",
    accessExpiresIn_other: "O acesso expira em {{count}} dias",
    manageOrResubscribe: "Gerenciar ou reassinar",
    manageOrCancel: "Gerenciar ou cancelar assinatura",
    apiCancelNote: "O cancelamento desativa seu acesso \xE0 API ao final do per\xEDodo de cobran\xE7a. Seu App ID e seu token s\xE3o preservados."
  }
};
var pages_default3 = pages2;

// src/assets/dictionary/pt/tables.ts
var tables2 = {
  organizations: {
    addNewButtonLabel: "Adicionar organiza\xE7\xE3o",
    searchInputPlaceholder: "Buscar organiza\xE7\xF5es",
    organizationNameLabel: "Nome da organiza\xE7\xE3o",
    totalPropertiesLabel: "Total de im\xF3veis:",
    addedOnLabel: "Adicionada em:",
    placeholder: "N\xE3o h\xE1 im\xF3veis atribu\xEDdos a esta organiza\xE7\xE3o",
    paginationLabel: "Mostrando {{page}} de {{total}} organiza\xE7\xF5es",
    thereAreNoOrganizations: "N\xE3o h\xE1 organiza\xE7\xF5es"
  },
  marketAreas: {
    addNewMarket: "Adicionar regi\xE3o",
    paginationLabel: "Mostrando {{page}} de {{total}} regi\xF5es de mercado",
    search: "Buscar",
    placeholder: "N\xE3o h\xE1 regi\xF5es de mercado"
  },
  amenities: {
    addNewAmenity: "Adicionar comodidade",
    noAmenities: "Nenhuma comodidade criada ainda",
    searchAmenities: "Buscar comodidades",
    paginationLabel: "Mostrando {{page}} de {{total}} comodidades"
  },
  organizationSaleTeams: {
    addNewButtonLabel: "Adicionar equipe de vendas",
    searchInputPlaceholder: "Buscar equipe de vendas",
    placeholder: "Nenhuma equipe de vendas atribu\xEDda a esta organiza\xE7\xE3o",
    paginationLabel: "Mostrando {{page}} de {{total}} equipes de vendas"
  },
  organizationUsers: {
    addNewButtonLabel: "Convidar usu\xE1rio",
    searchInputPlaceholder: "Buscar usu\xE1rios",
    placeholder: "Nenhum usu\xE1rio atribu\xEDdo a esta organiza\xE7\xE3o",
    paginationLabel: "Mostrando {{page}} de {{total}} usu\xE1rios",
    sendInvitation: "Enviar convite",
    resendInvitation: "Reenviar convite"
  },
  organizationProperties: {
    placeholder: "Nenhum im\xF3vel atribu\xEDdo a esta organiza\xE7\xE3o",
    placeholderSearch: "Sua busca n\xE3o retornou resultados."
  },
  properties: {
    nameLabel: "Nome do im\xF3vel",
    updatedAtLabel: "\xDAltima atualiza\xE7\xE3o",
    addNewButtonLabel: "Adicionar im\xF3vel",
    searchInputPlaceholder: "Buscar im\xF3veis",
    placeholder: "N\xE3o h\xE1 im\xF3veis.",
    placeholderSearch: "Sua busca n\xE3o retornou resultados.",
    paginationLabel: "Mostrando {{page}} de {{total}} im\xF3veis",
    statusSelectPlaceholder: "Visibilidade",
    cmsStatusSelectPlaceholder: "Status no CMS",
    transactionTypeSelectPlaceholder: "Venda/Loca\xE7\xE3o",
    organizationSelectPlaceholder: "Todas as organiza\xE7\xF5es",
    updatePaginationLabel: "Mostrando {{page}} de {{total}}",
    marketAreaSelectPlaceholder: "Regi\xE3o de mercado",
    buildingTypeSelectPlaceholder: "Tipo de im\xF3vel",
    tagsSelectPlaceholder: "Tags",
    projectStatusSelectPlaceholder: "Status do empreendimento"
  },
  inventory: {
    addNewButtonLabel: "Adicionar unidades",
    searchInputPlaceholder: "Buscar unidades",
    placeholder: "N\xE3o h\xE1 unidades associadas a este im\xF3vel",
    paginationLabel: "Mostrando {{page}} de {{total}} plantas",
    name: "Nome",
    quantity: "Quantidade",
    quantityShort: "QTD",
    bedrooms: "Quartos",
    bathrooms: "Banheiros",
    breakdownSqft: "Detalhamento de SQFT",
    totalSqft: "SQFT TOTAL",
    interiorSqft: "SQFT int.",
    exteriorSqft: "SQFT ext.",
    inventoryType: "Tipo",
    priceRange: "Faixa de pre\xE7o",
    floorplan: "Planta",
    viewFloorPlan: "Ver planta",
    customRooms: "Ambientes adicionais",
    customRoomsShortened: "Amb. adic.",
    lastListedFrom: "\xDAltimo pre\xE7o anunciado a partir de",
    lastListedFromShortened: "A partir de",
    units: "Unidades",
    recent: "Recentes",
    priceDown: "Pre\xE7o (do maior para o menor)",
    priceUp: "Pre\xE7o (do menor para o maior)"
  },
  marketingFiles: {
    categoryPlaceholder: "Todas as categorias",
    fileTypePlaceholder: "Todos os tipos de arquivo",
    totalCountLabel: "{{totalCount}} arquivos de marketing",
    paginationLabel: "Mostrando {{page}} de {{total}}",
    filesSelectedLabel: "{{totalCount}} arquivos selecionados",
    downloadAllLabel: "Baixar tudo",
    downloadSelectedLabel: "Baixar selecionados",
    searchInputPlaceholder: "Buscar",
    placeholder: "No momento n\xE3o h\xE1 arquivos de m\xEDdia dispon\xEDveis para este im\xF3vel"
  },
  transactionHistory: {
    invoiceName: "Nome da fatura",
    dateOfCharge: "Data da cobran\xE7a",
    status: "Status",
    amount: "Valor",
    statuses: {
      draft: "Rascunho",
      open: "Em aberto",
      paid: "Conclu\xEDda",
      uncollectible: "Incobr\xE1vel",
      void: "Anulada"
    }
  },
  brokers: {
    searchBrokers: "Buscar corretores",
    fullName: "Nome completo",
    email: "E-mail",
    phoneNumber: "Telefone",
    userStatus: "Status do usu\xE1rio",
    subscriptionPlan: "Plano",
    createdAt: "Data de cria\xE7\xE3o",
    subStatus: "Status da assin.",
    placeholder: "N\xE3o h\xE1 corretores",
    viewAction: "Ver / Editar",
    unblockAction: "Desbloquear",
    blockAction: "Bloquear",
    delete: "Excluir",
    paginationLabel: "Mostrando {{page}} de {{total}} corretores",
    userAccountStatus: "Status da conta do usu\xE1rio"
  },
  cmsUsers: {
    unarchive: "Desarquivar",
    archive: "Arquivar",
    edit: "Editar",
    delete: "Excluir"
  },
  apiInvitations: {
    status: "Status",
    expiresAt: "Data de expira\xE7\xE3o",
    createdAt: "Data de cria\xE7\xE3o",
    revoke: "Revogar",
    statuses: {
      pending: "Pendente",
      accepted: "Aceito",
      // DSH-921: the invitee subscribed to the API plan (invitation consumed).
      fulfilled: "Conclu\xEDdo",
      expired: "Expirado",
      revoked: "Revogado"
    }
  },
  reactions: {
    nameOrId: "Nome ou ID",
    email: "E-mail",
    properties: "Im\xF3veis",
    reactions: "Rea\xE7\xF5es"
  },
  propertyNote: {
    placeholder: "Este im\xF3vel n\xE3o tem observa\xE7\xF5es",
    paginationLabel: "Mostrando {{page}} de {{total}}"
  },
  externalSales: {
    placeholder: "N\xE3o h\xE1 equipe de vendas externa",
    paginationLabel: "Mostrando {{page}} de {{total}} vendas externas"
  },
  propertyComparison: {
    bedrooms: "Faixa de quartos",
    bathrooms: "Faixa de banheiros",
    status: "Status do im\xF3vel",
    availableUnits: "Total de unidades"
  },
  featuredPortfolios: {
    nameLabel: "Nome do portf\xF3lio",
    updatedAtLabel: "\xDAltima atualiza\xE7\xE3o",
    createdAtLabel: "Criado em",
    visibilityLabel: "Visibilidade",
    propertiesCountLabel: "Im\xF3veis",
    actionsLabel: "A\xE7\xF5es",
    placeholder: "N\xE3o h\xE1 portf\xF3lios em destaque.",
    placeholderSearch: "Sua busca n\xE3o retornou resultados.",
    paginationLabel: "Mostrando {{page}} de {{total}} portf\xF3lios",
    searchInputPlaceholder: "Buscar portf\xF3lios",
    addNewButtonLabel: "Criar portf\xF3lio",
    sortButtonLabel: "Ordenar",
    sortPublicDisplay: "Ordenar exibi\xE7\xE3o p\xFAblica"
  },
  featuredProperties: {
    nameLabel: "T\xEDtulo",
    updatedAtLabel: "\xDAltima atualiza\xE7\xE3o",
    createdAtLabel: "Criado em",
    visibilityLabel: "Visibilidade",
    placeholder: "N\xE3o h\xE1 im\xF3veis em destaque.",
    placeholderSearch: "Sua busca n\xE3o retornou resultados.",
    paginationLabel: "Mostrando {{page}} de {{total}} im\xF3veis",
    searchInputPlaceholder: "Buscar im\xF3veis",
    addNewButtonLabel: "Criar im\xF3vel",
    sortPublicDisplay: "Ordenar exibi\xE7\xE3o p\xFAblica"
  }
};
var tables_default3 = tables2;

// src/assets/dictionary/index.ts
var dictionary = {
  [import_dash_common7.DashLanguages.EN]: {
    common: common_default,
    forms: forms_default,
    pages: pages_default,
    tables: tables_default
  },
  [import_dash_common7.DashLanguages.ES]: {
    common: common_default2,
    forms: forms_default2,
    pages: pages_default2,
    tables: tables_default2
  },
  [import_dash_common7.DashLanguages.PT]: {
    common: common_default3,
    forms: forms_default3,
    pages: pages_default3,
    tables: tables_default3
  }
};

// src/i18n.ts
import_i18next.default.use(import_react_i18next.initReactI18next).init({
  debug: false,
  defaultNS: ["common"],
  ns: Object.keys(dictionary.en),
  supportedLngs: Object.values(import_dash_common8.DashLanguages),
  fallbackLng: import_dash_common8.DashLanguages.EN,
  resources: dictionary,
  returnNull: false,
  // React already escapes what it renders; escaping here too shows "O'Brien" as "O&#39;Brien".
  interpolation: { escapeValue: false }
});
var MOMENT_LOCALES = {
  [import_dash_common8.DashLanguages.EN]: "en",
  [import_dash_common8.DashLanguages.ES]: "es",
  [import_dash_common8.DashLanguages.PT]: "pt-br"
};
var applyMomentLocale = (language) => {
  import_moment.default.locale(MOMENT_LOCALES[(language || "").split("-")[0]] || "en");
};
applyMomentLocale();
import_i18next.default.on("languageChanged", applyMomentLocale);
var i18n_default = import_i18next.default;

// src/themes/main.ts
function hexToRgb(hex2) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex2);
  return result ? `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}` : "";
}
var breakpoints = {
  xsm: 576,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280
};
var mainTheme = {
  space: 4,
  colors: {
    // gray scale
    black: "#000000",
    gr1: "#202020",
    gr2: "#3A3A3A",
    gr3: "#4A4A4A",
    gr4: "#686868",
    gr5: "#919191",
    gr6: "#BEBEBE",
    gr7: "#DFDFDF",
    gr8: "#F3F3F3",
    white: "#FFFFFF",
    // primary
    bluePrimary: "#337ab7",
    b200: "#00278E",
    b90: "#00278E",
    b80: "#0e3979",
    b70: "#143d79",
    b60: "#004c87",
    b50: "#1B75BB",
    b50Hover: "#338ACE",
    b50Active: "#1773BA",
    b100: "#1B75BB",
    b40: "#8DBADD",
    b30: "#D4E5F3",
    b20: "#E2EDF6",
    b10: "#F8FBFD",
    b5: "#F3F7FB",
    // secondary
    g20: "#00905B",
    g20Hover: "#0E7E55",
    g20Active: "#1A6B4E",
    g10: "#F2F9F7",
    g40: "#2cf37b",
    r60: "#ED3C11",
    r20: "#D13C3C",
    r20Hover: "#CD2727",
    r20Active: "#CF1010",
    r10: "#FCF5F5",
    y20: "#FABF3F",
    y15: "#FFF2BC",
    y10: "#FFFAE6",
    p10: "#6F0B71",
    or1: "#FF6900",
    // naturals
    n200: "#253858",
    n90: "#191C35",
    n80: "#525569",
    n70: "#888A98",
    n60: "#BABAC0",
    n50: "#D8D8D8",
    n40: "#E6E6E6",
    n30: "#EDEDEF",
    n20: "#F8F8F9",
    n10: "#FCFCFC",
    setOpacity: (color2, opacity) => `rgb(${hexToRgb(color2)} / ${opacity}%)`
  },
  gradientColorsSet: {
    blue: ["#94D0FF", "#1B75BB"],
    red: ["#FE6C6C", "#FE464B"],
    purple: ["#FDAEFF", "#B111B5"],
    green: ["#B6FFE4", "#00905B"],
    yellow: ["#FFD572", "#FEBD38"]
  },
  typography: {
    weight: {
      bolder: 900,
      bold: 700,
      semibold: 600,
      medium: 500,
      regular: 400
    },
    fontSize: {
      // xs  sm smplus md  lg  xl  xxl
      //note: md was reduced from 15 to 14.89 due to a specific case that caused a line break on the property card
      text: [11, 12, 13, 14.89, 17, 20, 24],
      header: [28, 28, 36, 36, 36]
    },
    lineHeight: {
      text: [1.5, 1.5, 1.5, 1.5, 1.5, 1.25, 1.25],
      header: [44, 44, 44, 56, 56]
    }
  },
  modalSize: {
    width: {
      // xsm  sm  md  lg  xl  xxl
      sm: [327, 432, 432, 432, 432],
      md: [327, 610, 610, 610, 610],
      lg: [343, 724, 724, 724, 724],
      xl: [463, 724, 926, 926, 926]
    }
  },
  breakpoints,
  devices: {
    mobile: `only screen and (max-width: ${breakpoints.md - 1}px)`,
    tablet: `only screen and (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.lg}px)`,
    laptop: `only screen and (min-width: ${breakpoints.lg + 1}px) and (max-width: ${breakpoints.xl - 1}px)`,
    desktop: `only screen and (min-width: ${breakpoints.xl}px)`
  },
  shadows: {
    shadow1: "0px 2px 14px rgba(0, 0, 0, 0.05)",
    shadow2: "0px 0px 8px rgba(0, 0, 0, 0.12)",
    shadow3: "0px 0px 0px 3px rgba(27, 117, 187, 0.3)",
    subscriptionCardShadow: "0 0 20px rgb(0 0 0 / 0.25)",
    sidebarShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)"
  }
};

// src/components/atoms/Form/Select/Select.styles.ts
var import_styled_components11 = __toESM(require("styled-components"));

// src/components/atoms/Flex/Flex.tsx
var import_styled_components2 = __toESM(require("styled-components"));

// src/components/atoms/Box/Box.tsx
var import_styled_components = __toESM(require("styled-components"));
var parseResponsiveProps = (box, index2, key) => (
  // @ts-ignore
  Array.isArray(box[key]) ? box[key][index2] : box[key]
);
var getBoxStyle = (box, theme, index2) => {
  const w = parseResponsiveProps(box, index2, "w");
  const h = parseResponsiveProps(box, index2, "h");
  const minWidth = parseResponsiveProps(box, index2, "minWidth");
  const minHeight = parseResponsiveProps(box, index2, "minHeight");
  const maxWidth = parseResponsiveProps(box, index2, "maxWidth");
  const maxHeight = parseResponsiveProps(box, index2, "maxHeight");
  const p = parseResponsiveProps(box, index2, "p");
  const px = parseResponsiveProps(box, index2, "px");
  const py = parseResponsiveProps(box, index2, "py");
  const pt = parseResponsiveProps(box, index2, "pt");
  const pb = parseResponsiveProps(box, index2, "pb");
  const pr = parseResponsiveProps(box, index2, "pr");
  const pl = parseResponsiveProps(box, index2, "pl");
  const m = parseResponsiveProps(box, index2, "m");
  const mx = parseResponsiveProps(box, index2, "mx");
  const my = parseResponsiveProps(box, index2, "my");
  const mt = parseResponsiveProps(box, index2, "mt");
  const mb = parseResponsiveProps(box, index2, "mb");
  const mr = parseResponsiveProps(box, index2, "mr");
  const ml = parseResponsiveProps(box, index2, "ml");
  const gap = parseResponsiveProps(box, index2, "gap");
  const pos = parseResponsiveProps(box, index2, "pos");
  const flex = parseResponsiveProps(box, index2, "flex");
  const overflow = parseResponsiveProps(box, index2, "overflow");
  return `
    ${w ? `width:${w}${typeof w === "number" ? "px" : ""};` : ""}
    ${minWidth ? `min-width:${minWidth}${typeof minWidth === "number" ? "px" : ""};` : ""}
    ${maxWidth ? `max-width:${maxWidth}${typeof maxWidth === "number" ? "px" : ""};` : ""}
    ${h ? `height:${h}${typeof h === "number" ? "px" : ""};` : ""}
    ${minHeight ? `min-height:${minHeight}${typeof minHeight === "number" ? "px" : ""};` : ""}
    ${maxHeight ? `max-height:${maxHeight}${typeof maxHeight === "number" ? "px" : ""};` : ""}
    ${typeof p === "number" ? `padding:${p * theme.space}px;` : ""}
    ${typeof py === "number" ? `padding-top:${py * theme.space}px;padding-bottom:${py * theme.space}px;` : ""}
    ${typeof px === "number" ? `padding-right:${px * theme.space}px;padding-left:${px * theme.space}px;` : ""}
    ${typeof pt === "number" ? `padding-top:${pt * theme.space}px;` : ""}
    ${typeof pb === "number" ? `padding-bottom:${pb * theme.space}px;` : ""}
    ${typeof pr === "number" ? `padding-right:${pr * theme.space}px;` : ""}
    ${typeof pl === "number" ? `padding-left:${pl * theme.space}px;` : ""}
    ${typeof m === "number" ? `margin:${m * theme.space}px;` : ""}
    ${typeof my === "number" ? `margin-top:${my * theme.space}px;margin-bottom:${my * theme.space}px;` : ""}
    ${typeof mx === "number" ? `margin-right:${mx * theme.space}px;margin-left:${mx * theme.space}px;` : ""}
    ${typeof mt === "number" ? `margin-top:${mt * theme.space}px;` : ""}
    ${typeof mb === "number" ? `margin-bottom:${mb * theme.space}px;` : ""}
    ${typeof mr === "number" ? `margin-right:${mr * theme.space}px;` : ""}
    ${typeof ml === "number" ? `margin-left:${ml * theme.space}px;` : ""}
    ${gap ? `gap:${gap}px;` : ""}
    ${pos ? `position: ${pos};` : ""}
    ${flex ? `flex: ${flex};` : ""}
    ${overflow ? `overflow: ${overflow};` : ""}
    
  `;
};
var getResponsiveStyle = (box, theme) => {
  const mobile = getBoxStyle(box, theme, 0);
  const tablet = getBoxStyle(box, theme, 1);
  const laptop = getBoxStyle(box, theme, 2);
  const desktop = getBoxStyle(box, theme, 3);
  return `
    ${mobile.trim().length ? `@media ${theme.devices.mobile} {${mobile}};` : ""}
    ${tablet.trim().length ? `@media ${theme.devices.tablet} {${tablet}};` : ""}
    ${laptop.trim().length ? `@media ${theme.devices.laptop} {${laptop}};` : ""}
    ${laptop.trim().length ? `@media ${theme.devices.desktop} {${desktop}};` : ""}
  `;
};
var boxStyle = import_styled_components.css`
  ${({ theme, ...box }) => getBoxStyle(box, theme, 3)}
  ${({ theme, ...box }) => getResponsiveStyle(box, theme)}
`;
var Box = import_styled_components.default.div`
  ${boxStyle};
  box-sizing: border-box;
`;
var Box_default = Box;

// src/components/atoms/Flex/Flex.tsx
var getFlexStyle = (box, index2) => {
  const flex = parseResponsiveProps(box, index2, "flex");
  const justifyContent = parseResponsiveProps(box, index2, "justifyContent") || "start";
  const alignItems = parseResponsiveProps(box, index2, "alignItems") || "start";
  const flexDirection = parseResponsiveProps(box, index2, "flexDirection") || "row";
  const flexWrap = parseResponsiveProps(box, index2, "flexWrap") || "nowrap";
  const flexGrow = parseResponsiveProps(box, index2, "flexGrow");
  const alignSelf = parseResponsiveProps(box, index2, "alignSelf") || "auto";
  return `
    ${flex ? `flex: ${flex};` : ""};
    justify-content: ${justifyContent};
    align-items: ${alignItems};
    flex-direction: ${flexDirection};
    flex-wrap: ${flexWrap};
    align-self: ${alignSelf};
    flex-grow: ${flexGrow !== void 0 ? flexGrow : ""};
  `;
};
var getResponsiveStyle2 = (box, theme) => {
  const mobile = getFlexStyle(box, 0);
  const tablet = getFlexStyle(box, 1);
  const laptop = getFlexStyle(box, 2);
  return `
    ${mobile.trim().length ? `@media ${theme.devices.mobile} {${mobile}};` : ""}
    ${tablet.trim().length ? `@media ${theme.devices.tablet} {${tablet}};` : ""}
    ${laptop.trim().length ? `@media ${theme.devices.laptop} {${laptop}};` : ""}
  `;
};
var flexStyle = import_styled_components2.css`
  display: flex;
  ${(props) => getFlexStyle(props, 3)}
  ${({ theme, ...box }) => getResponsiveStyle2(box, theme)}
`;
var Flex = (0, import_styled_components2.default)(Box_default)`
  ${flexStyle}
`;
var Flex_default = Flex;

// src/components/atoms/Form/Input/Input.styles.ts
var import_styled_components5 = __toESM(require("styled-components"));

// src/components/atoms/Text/Text.tsx
var import_styled_components3 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var getSize = (theme, { xs, sm, smplus, md, lg, xl, xxl }, textFieldType, type) => {
  const sizeArray = theme.typography[textFieldType][type || "text"];
  const size = { xs, sm, smplus, md, lg, xl, xxl };
  const index2 = Object.keys(size).findIndex((key) => !!size[key]);
  return sizeArray[index2] || sizeArray[3];
};
var getFontWeight = (theme, { bolder, bold, semibold, medium, regular = true }) => {
  const {
    typography: { weight }
  } = theme;
  return bolder && weight?.bolder || bold && weight?.bold || semibold && weight?.semibold || medium && weight?.medium || regular && weight?.regular;
};
var textStyle = import_styled_components3.css`
  margin-block-start: unset;
  margin-block-end: unset;
  font-family: 'Work Sans';
  overflow-wrap: ${({ overflowWrap }) => overflowWrap || "anywhere"}};
  font-style: normal;
  font-weight: ${({ theme, bolder, bold, semibold, medium, regular = true }) => getFontWeight(theme, {
  bolder,
  bold,
  semibold,
  medium,
  regular
})};
  font-size: ${({ theme, xs, sm, smplus, md, lg, xl, xxl }) => getSize(theme, { xs, sm, smplus, md, lg, xl, xxl }, "fontSize")}px;
  line-height: ${({ theme, xs, sm, md, lg, xl, xxl }) => getSize(theme, { xs, sm, md, lg, xl, xxl }, "lineHeight")};
  color: ${({ color: color2, theme }) => color2 || theme.colors.n90};
  text-decoration-line: ${({ textDecoration }) => textDecoration || "none"};
  white-space: ${({ whiteSpace }) => whiteSpace || "normal"};
  ${({ cursor }) => cursor && `cursor: ${cursor}`};
`;
var ellipsisStyle = import_styled_components3.css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: ${({ clamp }) => clamp || 1};
  -webkit-box-orient: vertical;
`;
var TextPStyles = import_styled_components3.default.p`
  ${textStyle}
  ${({ ellipsis }) => ellipsis ? ellipsisStyle : ""}
`;
var TextSpamStyles = import_styled_components3.default.span`
  ${textStyle}
  ${({ ellipsis }) => ellipsis ? ellipsisStyle : ""}
`;
function Text({ id: id2, children, textRef, as = "p", ...args }) {
  const TextStyles = as === "p" ? TextPStyles : TextSpamStyles;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextStyles, { id: id2, ref: textRef, ...args, children });
}
var Text_default = Text;

// src/components/atoms/Icon/Icon.tsx
var import_styled_components4 = __toESM(require("styled-components"));

// src/components/atoms/Icon/Icon.generated.ts
var icons = { "account": { "viewBox": "0 0 16 16", "path": "M.62 14.667a.666.666 0 1 0 1.333 0 5.956 5.956 0 0 1 3.465-5.42 4.635 4.635 0 0 0 5.077-.006 5.962 5.962 0 0 1 3.458 5.425.666.666 0 1 0 1.333 0 7.286 7.286 0 0 0-2.148-5.184 7.384 7.384 0 0 0-1.58-1.19 4.645 4.645 0 0 0 1.061-2.959A4.672 4.672 0 0 0 7.952.667a4.672 4.672 0 0 0-4.666 4.666c0 1.12.397 2.149 1.057 2.954a7.29 7.29 0 0 0-3.723 6.38ZM7.952 2a3.337 3.337 0 0 1 3.334 3.333 3.337 3.337 0 0 1-3.334 3.334A3.337 3.337 0 0 1 4.62 5.333 3.337 3.337 0 0 1 7.952 2Z", "properties": { "fill": "currentColor" } }, "addPhoto": { "viewBox": "0 0 26 26", "path": "M21.333 7.333v3.987s-2.653.013-2.666 0V7.333h-4s.013-2.653 0-2.666h4v-4h2.666v4h4v2.666h-4Zm-4 5.334v-4h-4v-4H2.667A2.675 2.675 0 0 0 0 7.333v16C0 24.8 1.2 26 2.667 26h16c1.466 0 2.666-1.2 2.666-2.667V12.667h-4ZM2.667 23.333l4-5.333 2.666 4 4-5.333 5.334 6.666h-16Z", "properties": { "fill": "currentColor" } }, "addCircleOutline": { "viewBox": "0 0 24 24", "path": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7Zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z", "properties": { "fill": "currentColor" } }, "apps": { "viewBox": "0 0 24 24", "path": "M7 0H4a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3Zm11-7h-3a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3ZM7 13H4a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3Zm11-7h-3a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3Z", "properties": { "fill": "currentColor" } }, "archive": { "viewBox": "0 0 12 12", "path": "m11.693 1.487-.926-1.12A.968.968 0 0 0 10 0H2a.99.99 0 0 0-.773.367l-.92 1.12A1.305 1.305 0 0 0 0 2.333v8.334C0 11.4.6 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V2.333c0-.32-.113-.62-.307-.846ZM6 9.667 2.333 6h2.334V4.667h2.666V6h2.334L6 9.667ZM1.413 1.333l.54-.666h8l.627.666H1.413Z", "properties": { "fill": "currentColor" } }, "arrowDown": { "viewBox": "0 0 24 24", "path": "M18.53 8.47a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 1.06-1.06L12 13.94l5.47-5.47a.75.75 0 0 1 1.06 0Z", "properties": { "fill": "currentColor" } }, "arrowUp": { "viewBox": "0 0 24 24", "path": "M5.47 15.53a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06L12 10.06l-5.47 5.47a.75.75 0 0 1-1.06 0Z", "properties": { "fill": "currentColor" } }, "arrowLeft": { "viewBox": "0 0 24 24", "path": "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41Z", "properties": { "fill": "currentColor" } }, "arrowRight": { "viewBox": "0 0 24 24", "path": "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41Z", "properties": { "fill": "currentColor" } }, "artboard": { "viewBox": "0 0 16 14", "path": "M6 7a3.301 3.301 0 0 1-3.333-3.333A3.301 3.301 0 0 1 6 .333a3.301 3.301 0 0 1 3.333 3.334A3.301 3.301 0 0 1 6 7Zm0-5.333c-1.133 0-2 .867-2 2s.867 2 2 2 2-.867 2-2-.867-2-2-2Zm9.334 12c-.4 0-.667-.267-.667-.667v-1.333c0-.933-.6-1.733-1.533-1.933-.334-.067-.6-.467-.467-.8.067-.334.467-.6.8-.467 1.467.4 2.467 1.733 2.533 3.2V13c0 .4-.266.667-.666.667Zm-4.667-6.733c-.267 0-.6-.2-.667-.534-.067-.333.133-.733.467-.8a2.043 2.043 0 0 0 1.466-1.466c.267-1.067-.4-2.134-1.466-2.467-.334 0-.534-.4-.467-.733.067-.334.467-.6.8-.467a3.32 3.32 0 0 1 2.4 4.067c-.333 1.2-1.2 2.133-2.4 2.4h-.133Zm.666 6.733c-.4 0-.666-.267-.666-.667v-1.333c0-1.133-.867-2-2-2H3.333c-1.133 0-2 .867-2 2V13c0 .4-.266.667-.666.667S0 13.4 0 13v-1.333a3.3 3.3 0 0 1 3.333-3.333h5.334A3.301 3.301 0 0 1 12 11.667V13c0 .4-.267.667-.667.667Z", "properties": { "fill": "currentColor" } }, "at": { "viewBox": "0 0 24 24", "path": "M9.868 11.492c-.195.769-.25 1.453-.18 2.059l.001.004c.06.555.221.93.436 1.174.204.222.449.326.778.326.632 0 1.111-.169 1.482-.48.387-.332.737-.851 1.023-1.6l.36-3.766c-.277-.213-.657-.336-1.19-.336-.603 0-1.14.204-1.628.65-.488.451-.858 1.095-1.082 1.969Zm3.887 3.866c-.226.24-.477.447-.755.617-.606.37-1.307.549-2.08.549-.496 0-.957-.101-1.363-.321a2.558 2.558 0 0 1-.97-.94l-.001-.003c-.472-.792-.617-1.796-.503-2.961v-.004c.154-1.417.621-2.598 1.442-3.5.825-.912 1.86-1.4 3.081-1.4.807 0 1.53.209 2.139.638l.002.001.011.009.254.19a1 1 0 0 1 .395.894l-.417 4.413c-.059.587.05.954.226 1.178.168.2.426.329.878.329.594 0 1.08-.238 1.485-.803l.001-.001c.424-.584.695-1.442.758-2.622v-.002c.129-2.125-.345-3.63-1.306-4.612-.958-.98-2.45-1.514-4.59-1.514-1.256 0-2.385.277-3.398.827a6.133 6.133 0 0 0-2.401 2.307c-.59.995-.927 2.128-1.002 3.407-.068 1.299.14 2.434.606 3.42a5.062 5.062 0 0 0 2.086 2.258c.924.535 2.024.811 3.322.811a139.035 139.035 0 0 1 1.515.008h1.335a.734.734 0 1 1 0 1.469h-2.887c-1.594 0-2.998-.32-4.189-.982a6.25 6.25 0 0 1-2.671-2.836c-.58-1.217-.82-2.621-.745-4.197.076-1.564.465-2.96 1.183-4.174a7.332 7.332 0 0 1 2.98-2.82C9.448 4.326 10.888 4 12.48 4c2.475 0 4.428.646 5.751 2.02 1.32 1.361 1.873 3.273 1.755 5.647a6.664 6.664 0 0 1-.539 2.445c-.328.75-.775 1.355-1.361 1.779l-.004.002a3.406 3.406 0 0 1-2.014.63c-.723 0-1.36-.198-1.858-.631a2.347 2.347 0 0 1-.454-.534Z", "properties": { "fill": "currentColor" } }, "autorenew": { "viewBox": "0 0 24 24", "path": "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 0 1 6 12c0-3.31 2.69-6 6-6Zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26Z", "properties": { "fill": "currentColor" } }, "backupTable": { "viewBox": "0 0 24 24", "path": "M20 6v14H6v2h14c1.1 0 2-.9 2-2V6h-2Z M16 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2ZM9 16H4v-5h5v5Zm7 0h-5v-5h5v5Zm0-7H4V4h12v5Z", "properties": { "fill": "currentColor" } }, "bank": { "viewBox": "0 0 24 24", "path": "M4 11.5v4c0 .83.67 1.5 1.5 1.5S7 16.33 7 15.5v-4c0-.83-.67-1.5-1.5-1.5S4 10.67 4 11.5Zm6 0v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5ZM3.5 22h16c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-16c-.83 0-1.5.67-1.5 1.5S2.67 22 3.5 22ZM16 11.5v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5ZM10.57 1.49l-7.9 4.16c-.41.21-.67.64-.67 1.1C2 7.44 2.56 8 3.25 8h16.51C20.44 8 21 7.44 21 6.75c0-.46-.26-.89-.67-1.1l-7.9-4.16c-.58-.31-1.28-.31-1.86 0Z", "properties": { "fill": "currentColor" } }, "bathroom": { "viewBox": "0 0 24 24", "path": "M16.718 16.629H6.939a2.387 2.387 0 0 1-2.335-1.841l-.981-4.086a1.373 1.373 0 0 1 1.349-1.616h7.2a.343.343 0 0 1 0 .686h-7.2a.686.686 0 0 0-.686.685c0 .041.006.083.01.124l.975 4.048a1.705 1.705 0 0 0 1.668 1.314h9.779c.8 0 1.486-.54 1.669-1.313l.981-4.088c-.003-.002.003-.043.003-.085a.686.686 0 0 0-.685-.685H16.5c-.19 0-.3-.283-.3-.472s.11-.214.3-.214h2.186a1.373 1.373 0 0 1 1.355 1.578l-.987 4.125a2.39 2.39 0 0 1-2.336 1.84Z M7.371 17.998a.344.344 0 0 1-.307-.497l.686-1.37a.344.344 0 0 1 .614.306l-.686 1.371a.342.342 0 0 1-.307.19Zm8.915 0a.343.343 0 0 1-.307-.189l-.685-1.371a.343.343 0 0 1 .613-.307l.686 1.372a.344.344 0 0 1-.307.495ZM15.3 13.5h-1.8c-.827 0-1.5-.674-1.5-1.5V9.6a.9.9 0 0 1 .9-.9h3a.9.9 0 0 1 .9.9V12c0 .826-.673 1.5-1.5 1.5Zm-2.4-4.2a.3.3 0 0 0-.3.3V12c0 .495.404.9.9.9h1.8c.496 0 .9-.405.9-.9V9.6a.3.3 0 0 0-.3-.3h-3ZM9.33 7.499a.33.33 0 0 1-.66 0h.66Zm-3.66 1.8v-1.8h.66v1.8h-.66Zm0-1.8c0-.61.22-1.093.574-1.423A1.84 1.84 0 0 1 7.5 5.594c.45 0 .908.157 1.256.482.354.33.574.814.574 1.423h-.66c0-.441-.155-.745-.364-.94a1.18 1.18 0 0 0-.806-.305c-.3 0-.592.105-.806.305-.21.195-.364.499-.364.94h-.66Z M12.171 11.826H4.286a.343.343 0 0 1 0-.685h7.885a.343.343 0 0 1 0 .685Zm7.286 0h-2.85a.343.343 0 0 1 0-.685h2.85a.343.343 0 0 1 0 .685Z", "properties": { "fill": "currentColor" } }, "bathtub": { "viewBox": "0 0 24 24", "path": "M7 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm13 4V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25a.828.828 0 0 1 1.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5A2.251 2.251 0 0 0 5 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2Z", "properties": { "fill": "currentColor" } }, "bedroom": { "viewBox": "0 0 24 24", "path": "M19.13 10.977V7.765c0-.973-.793-1.765-1.765-1.765H6.776c-.972 0-1.764.792-1.764 1.765v3.212A1.768 1.768 0 0 0 3.6 12.706v4.941a.353.353 0 0 0 .706 0v-1.059h15.53v1.059a.353.353 0 0 0 .705 0v-4.941c0-.852-.608-1.565-1.412-1.729ZM5.717 7.765a1.06 1.06 0 0 1 1.058-1.06h10.589a1.06 1.06 0 0 1 1.059 1.06v3.176h-.972a1.05 1.05 0 0 0 .035-.61l-.352-1.412a1.057 1.057 0 0 0-1.027-.801h-2.273a1.06 1.06 0 0 0-1.059 1.058v1.412c0 .125.026.242.065.353H11.3c.04-.11.065-.229.065-.353V9.176a1.06 1.06 0 0 0-1.06-1.058h-2.27c-.487 0-.91.33-1.027.801l-.353 1.412a1.05 1.05 0 0 0 .035.61h-.971V7.765Zm11.02 3.04a.35.35 0 0 1-.278.136h-2.625a.353.353 0 0 1-.353-.353V9.176c0-.194.158-.353.353-.353h2.273c.162 0 .302.11.342.268l.353 1.412a.349.349 0 0 1-.065.303Zm-6.08-1.63v1.412a.353.353 0 0 1-.353.354H7.68a.351.351 0 0 1-.342-.438L7.69 9.09a.355.355 0 0 1 .342-.267h2.272c.195 0 .353.158.353.353Zm9.177 6.707H4.305v-.705h15.53v.705Zm0-1.411H4.305v-1.765a1.06 1.06 0 0 1 1.06-1.059h13.411a1.06 1.06 0 0 1 1.06 1.059v1.765Z", "properties": { "fill": "currentColor" } }, "bookmark": { "viewBox": "0 0 24 24", "path": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2Z", "properties": { "fill": "currentColor" } }, "bookmarkBorder": { "viewBox": "0 0 24 24", "path": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2Zm0 15-5-2.18L7 18V5h10v13Z", "properties": { "fill": "currentColor" } }, "building": { "viewBox": "0 0 48 48", "path": "M43.178 45.187V10.693h-4.466v34.494h-2.814V0L12.095 6.674v9.56h10.168v28.953H19.45v-26.14H7.635v26.14H1.867V48h44.266v-2.813h-2.955ZM27.614 29.149v-5.658h2.813v5.658h-2.813Zm2.813 4.676v5.658h-2.813v-5.658h2.813Zm-2.813-15.01v-5.659h2.813v5.659h-2.813ZM12.136 23.49h2.813v5.658h-2.813V23.49Zm0 10.334h2.813v5.658h-2.813v-5.658Z", "properties": { "fill": "currentColor" } }, "calendarToday": { "viewBox": "0 0 24 24", "path": "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 18H4V8h16v13Z", "properties": { "fill": "currentColor" } }, "cancelCircle": { "viewBox": "0 0 16 16", "path": "M8 1.333A6.66 6.66 0 0 0 1.333 8 6.66 6.66 0 0 0 8 14.667 6.66 6.66 0 0 0 14.667 8 6.66 6.66 0 0 0 8 1.333Zm3.334 9.06-.94.94L8 8.94l-2.393 2.393-.94-.94L7.06 8 4.667 5.607l.94-.94L8 7.06l2.393-2.393.94.94L8.94 8l2.394 2.393Z", "properties": { "fill": "currentColor" } }, "cancel": { "viewBox": "0 0 17 16", "path": "M8.5 0a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8ZM4.057 2.77A6.85 6.85 0 0 1 8.5 1.143c1.62 0 3.189.576 4.423 1.626l-9.657 9.657a6.85 6.85 0 0 1 .79-9.656Zm8.886 10.46A6.85 6.85 0 0 1 8.5 14.857a6.825 6.825 0 0 1-4.423-1.626l9.657-9.657a6.85 6.85 0 0 1-.79 9.656Z", "properties": { "fill": "currentColor" } }, "chart": { "viewBox": "0 0 16 16", "path": "M15.333 14.667h-12a2 2 0 0 1-2-2v-12A.667.667 0 1 0 0 .667v12A3.337 3.337 0 0 0 3.333 16h12a.666.666 0 1 0 0-1.333Z M4 13.333a.666.666 0 0 0 .667-.667V8a.667.667 0 1 0-1.333 0v4.666a.666.666 0 0 0 .666.667Zm2.667-6.666v6a.667.667 0 0 0 1.333 0v-6a.667.667 0 0 0-1.333 0Zm3.333 2v4a.667.667 0 1 0 1.333 0v-4a.667.667 0 1 0-1.333 0ZM13.334 6v6.666a.666.666 0 1 0 1.333 0V6a.667.667 0 1 0-1.333 0ZM4 6c.177 0 .346-.07.471-.196l2.39-2.39a.683.683 0 0 1 .943 0l1.448 1.448a2 2 0 0 0 2.828 0l3.724-3.724a.667.667 0 0 0-.942-.943l-3.724 3.723a.667.667 0 0 1-.943 0L8.747 2.471a2 2 0 0 0-2.828 0l-2.39 2.39A.667.667 0 0 0 3.998 6Z", "properties": { "fill": "currentColor" } }, "checkCircle": { "viewBox": "0 0 16 16", "path": "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333Zm-1.333 10L3.334 8l.94-.94 2.393 2.387 5.06-5.06.94.946-6 6Z", "properties": { "fill": "currentColor" } }, "check": { "viewBox": "0 0 24 24", "path": "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17Z", "properties": { "fill": "currentColor" } }, "checklist": { "viewBox": "0 0 16 16", "path": "M5.091 1.818H.728A.727.727 0 0 0 0 2.546v4.363c0 .402.326.727.728.727H5.09a.727.727 0 0 0 .728-.727V2.546a.727.727 0 0 0-.728-.728Zm-.727 4.364H1.455v-2.91h2.909v2.91ZM15.273 4H8a.727.727 0 1 0 0 1.455h7.273a.727.727 0 1 0 0-1.455Zm0 7.273H8a.727.727 0 0 0 0 1.454h7.273a.727.727 0 1 0 0-1.454ZM4.582 10.028l-2.421 2.393-.91-.946a.728.728 0 0 0-1.046 1.012l1.42 1.477a.733.733 0 0 0 .515.218h.009c.19 0 .373-.076.509-.21l2.942-2.91a.727.727 0 1 0-1.018-1.034Z", "properties": { "fill": "currentColor" } }, "chevronDown": { "viewBox": "0 0 24 24", "path": "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41Z", "properties": { "fill": "currentColor" } }, "chevronLeft": { "viewBox": "0 0 24 24", "path": "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59Z", "properties": { "fill": "currentColor" } }, "chevronRight": { "viewBox": "0 0 24 24", "path": "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6Z", "properties": { "fill": "currentColor" } }, "chevronUp": { "viewBox": "0 0 24 24", "path": "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41Z", "properties": { "fill": "currentColor" } }, "city": { "viewBox": "0 0 126 126", "path": "M96.642 15.12v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.276a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.276a2.527 2.527 0 0 0 2.52-2.52V15.12a2.527 2.527 0 0 0-2.52-2.52H99.162a2.527 2.527 0 0 0-2.52 2.52Z M96.642 15.12v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.276a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.276a2.527 2.527 0 0 0 2.52-2.52V15.12a2.527 2.527 0 0 0-2.52-2.52H99.162a2.527 2.527 0 0 0-2.52 2.52Z M29.358 18.9v-3.78a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v9.198c0 1.008-.63 2.016-1.638 2.394l-5.292 2.142c-1.008.378-1.638 1.26-1.638 2.394v79.632a2.527 2.527 0 0 0 2.52 2.52h36.918a2.527 2.527 0 0 0 2.52-2.52v-94.5c0-1.764-1.764-3.024-3.402-2.394l-18.27 7.308c-1.386.63-3.276-.504-3.276-2.394Zm-2.52 86.058h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52V65.52a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm16.884 50.4H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52V65.52A2.527 2.527 0 0 1 40.32 63h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Z M29.358 18.9v-3.78a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v9.198c0 1.008-.63 2.016-1.638 2.394l-5.292 2.142c-1.008.378-1.638 1.26-1.638 2.394v79.632a2.527 2.527 0 0 0 2.52 2.52h36.918a2.527 2.527 0 0 0 2.52-2.52v-94.5c0-1.764-1.764-3.024-3.402-2.394l-18.27 7.308c-1.386.63-3.276-.504-3.276-2.394Zm-2.52 86.058h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52V65.52a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm16.884 50.4H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52V65.52A2.527 2.527 0 0 1 40.32 63h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Z M79.758 26.838V15.12a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v11.718a2.527 2.527 0 0 1-2.52 2.52H65.52a2.527 2.527 0 0 0-2.52 2.52v79.002a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 0 2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.276a2.527 2.527 0 0 0 2.52-2.52V31.878a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 1-2.52-2.52Zm-2.52 69.804h-3.402a2.527 2.527 0 0 1-2.52-2.52V90.72a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52V40.32a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Z M79.758 26.838V15.12a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v11.718a2.527 2.527 0 0 1-2.52 2.52H65.52a2.527 2.527 0 0 0-2.52 2.52v79.002a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 0 2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.276a2.527 2.527 0 0 0 2.52-2.52V31.878a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 1-2.52-2.52Zm-2.52 69.804h-3.402a2.527 2.527 0 0 1-2.52-2.52V90.72a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52V40.32a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Z", "properties": { "fill": "currentColor" } }, "close": { "viewBox": "0 0 24 24", "path": "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z", "properties": { "fill": "currentColor" } }, "comment": { "viewBox": "0 0 16 16", "path": "M16 7.498A8.008 8.008 0 1 0 8.01 16h4.655A3.337 3.337 0 0 0 16 12.667V7.498Zm-1.334 5.169a2 2 0 0 1-2 2H8.011a6.694 6.694 0 0 1-6.373-4.655 6.611 6.611 0 0 1-.262-2.783 6.695 6.695 0 0 1 5.771-5.84c.288-.037.577-.055.867-.055a6.614 6.614 0 0 1 4.252 1.533 6.692 6.692 0 0 1 2.4 4.695v5.105Z M5.333 6H8a.667.667 0 1 0 0-1.333H5.333a.667.667 0 0 0 0 1.333Zm5.333 1.333H5.333a.667.667 0 0 0 0 1.333h5.333a.667.667 0 1 0 0-1.333Zm0 2.667H5.333a.666.666 0 1 0 0 1.333h5.333a.667.667 0 1 0 0-1.333Z", "properties": { "fill": "currentColor" } }, "compareArrows": { "viewBox": "0 0 24 24", "path": "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3Zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4Z", "properties": { "fill": "currentColor" } }, "condoHotels": { "viewBox": "0 0 16 16", "path": "m9.106 2.355.719-.704a.267.267 0 0 0-.148-.454l-.993-.145L8.24.15a.267.267 0 0 0-.48 0l-.444.903-.992.145a.267.267 0 0 0-.148.454l.719.704-.17.993a.267.267 0 0 0 .387.281L8 3.16c.856.452.92.496.985.5h.028c.166 0 .29-.15.263-.312l-.17-.993Zm-3.92.478.032.183a.267.267 0 0 1-.263.312c-.07 0-.107-.02-.216-.078a9.988 9.988 0 0 0-.073-.04l-.165.087a.267.267 0 0 1-.387-.28l.031-.184a.577.577 0 0 0-.044-.042c-.108-.102-.21-.198-.157-.362.054-.164.191-.181.34-.2l.06-.008.083-.167a.267.267 0 0 1 .478 0l.082.167.06.008c.148.018.287.036.34.2.053.164-.047.259-.157.361l-.044.042ZM2.853 4.165l.031.184a.267.267 0 0 1-.263.311c-.07 0-.106-.02-.215-.078l-.074-.04-.165.088a.267.267 0 0 1-.386-.281l.031-.184-.044-.042c-.109-.102-.21-.197-.157-.362.053-.164.19-.181.34-.2l.06-.008.082-.167a.267.267 0 0 1 .479 0l.082.167.06.008c.148.019.286.036.34.2.053.165-.048.26-.157.362l-.044.042Zm9.002-1.334.031.184a.267.267 0 0 1-.262.312c-.07 0-.107-.02-.216-.078a9.727 9.727 0 0 0-.073-.04l-.054.03c-.13.071-.253.138-.392.037-.14-.101-.114-.237-.086-.384l.011-.06-.133-.13a.267.267 0 0 1 .148-.455l.184-.027.026-.055c.063-.135.123-.261.296-.261.172 0 .231.125.295.26l.026.056.06.008c.148.018.286.036.34.2.053.164-.048.259-.157.361l-.044.042Zm2.333 1.334.032.184a.267.267 0 0 1-.263.311c-.07 0-.107-.02-.216-.078a9.405 9.405 0 0 0-.073-.04l-.053.03c-.131.072-.253.139-.393.037-.14-.101-.114-.237-.086-.384l.012-.06-.134-.13a.267.267 0 0 1 .148-.455l.184-.027c.01-.018.018-.036.026-.054.064-.135.123-.262.296-.262s.231.126.295.261c.009.018.017.037.027.055l.06.008c.147.019.286.036.34.2.053.165-.048.26-.158.362l-.044.042ZM3.806 16c.15 0 .27-.124.266-.274-.01-.306-.009-1.046-.007-2.984L4.067 8.8a.267.267 0 0 0-.267-.267H2.4c-.589 0-1.067.478-1.067 1.067v5.333c0 .59.478 1.067 1.067 1.067h1.406ZM2.9 10.933c.147 0 .267.12.267.267v1.133a.267.267 0 0 1-.534 0V11.2c0-.147.12-.267.267-.267Zm11.767 4V9.6c0-.59-.478-1.067-1.067-1.067h-1.4a.267.267 0 0 0-.266.267c0 1.715 0 3.012.002 3.995.001 1.9.002 2.628-.008 2.93a.266.266 0 0 0 .267.275H13.6c.59 0 1.067-.478 1.067-1.067Zm-1.567-4c.148 0 .267.12.267.267v1.133a.267.267 0 0 1-.534 0V11.2c0-.147.12-.267.267-.267ZM8.667 16H7.333a.267.267 0 0 1-.266-.267v-2.5c0-.147.12-.266.266-.266h1.334c.147 0 .266.119.266.266v2.5a.266.266 0 0 1-.266.267Zm2.733-.267V5.8c0-.59-.477-1.067-1.066-1.067H5.667c-.59 0-1.067.478-1.067 1.067v9.933c0 .148.12.267.267.267h1.4c.147 0 .266-.12.266-.267V12.7c0-.147.12-.267.267-.267h2.4c.147 0 .267.12.267.267v3.033c0 .148.12.267.266.267h1.4c.148 0 .267-.12.267-.267ZM8.794 6.667h.325c.118 0 .214.12.214.27v3.46c0 .15-.096.27-.214.27h-.325c-.118 0-.214-.12-.214-.27V9.14H7.42v1.257c0 .15-.096.27-.214.27H6.88c-.118 0-.214-.12-.214-.27v-3.46c0-.15.096-.27.214-.27h.325c.118 0 .215.12.215.27v1.257h1.16V6.936c0-.149.096-.27.214-.27Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "currentColor" } }, "condominium": { "viewBox": "0 0 16 16", "path": "M15.167 14H.833a.833.833 0 0 0-.833.833v.334c0 .46.373.833.833.833h14.334c.46 0 .833-.373.833-.833v-.334a.833.833 0 0 0-.833-.833Zm-1-.333a.167.167 0 0 0 .166-.167V4.833A.834.834 0 0 0 13.5 4H7.833A.833.833 0 0 0 7 4.833V13.5a.167.167 0 0 0 .167.167H9.5v-1.334a1.167 1.167 0 0 1 2.333 0v1.334h2.334ZM9.833 9.833a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 8.5 8.5h1a.333.333 0 0 1 .333.333v1Zm0-3a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 8.5 5.5h1a.333.333 0 0 1 .333.333v1Zm1.667-1a.333.333 0 0 1 .333-.333h1a.333.333 0 0 1 .334.333v1a.333.333 0 0 1-.334.334h-1a.333.333 0 0 1-.333-.334v-1Zm0 4v-1a.333.333 0 0 1 .333-.333h1a.333.333 0 0 1 .334.333v1a.333.333 0 0 1-.334.334h-1a.333.333 0 0 1-.333-.334Z M9.833 0H2.167a.833.833 0 0 0-.834.833V13.5a.167.167 0 0 0 .167.167h5a.167.167 0 0 0 .167-.167V4.833a1.167 1.167 0 0 1 1.166-1.166H10.5a.167.167 0 0 0 .167-.167V.833A.833.833 0 0 0 9.833 0Zm-5 12.833a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 3.5 11.5h1a.333.333 0 0 1 .333.333v1Zm0-3.333a.333.333 0 0 1-.333.333h-1a.333.333 0 0 1-.333-.333v-1a.333.333 0 0 1 .333-.333h1a.333.333 0 0 1 .333.333v1Zm0-3.333A.333.333 0 0 1 4.5 6.5h-1a.333.333 0 0 1-.333-.333v-1a.333.333 0 0 1 .333-.334h1a.333.333 0 0 1 .333.334v1Zm0-3.334a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 3.5 1.5h1a.333.333 0 0 1 .333.333v1Zm4 0a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 7.5 1.5h1a.333.333 0 0 1 .333.333v1Z", "properties": { "fill": "currentColor" } }, "contentCopy": { "viewBox": "0 0 24 24", "path": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm0 16H8V7h11v14Z", "properties": { "fill": "currentColor" } }, "creadit": { "viewBox": "0 0 24 24", "path": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm1 14.915V18h-2v-1.08c-2.339-.367-3-2.002-3-2.92h2c.011.143.159 1 2 1 1.38 0 2-.585 2-1 0-.324 0-1-2-1-3.48 0-4-1.88-4-3 0-1.288 1.029-2.584 3-2.915V6.012h2v1.109c1.734.41 2.4 1.853 2.4 2.879h-1l-1 .018C13.386 9.638 13.185 9 12 9c-1.299 0-2 .516-2 1 0 .374 0 1 2 1 3.48 0 4 1.88 4 3 0 1.288-1.029 2.584-3 2.915Z", "properties": { "fill": "currentColor" } }, "creditCard": { "viewBox": "0 0 20 16", "path": "M18 0H2C.89 0 .01.89.01 2L0 14c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V2c0-1.11-.89-2-2-2Zm0 14H2V8h16v6Zm0-10H2V2h16v2Z", "properties": { "fill": "currentColor" } }, "dashExchange": { "viewBox": "0 0 16 18", "path": "M4 0H0l6 9-6 9h4l6-9-6-9Z M10.986 7.078 9.592 4.986 12.283.5h2.815l-4.112 6.578ZM12.283 17.5l-2.691-4.486 1.394-2.092 4.112 6.578h-2.815Z", "properties": { "fill": "currentColor" } }, "dashboard": { "viewBox": "0 0 24 24", "path": "M3 11h8V3H3v8Zm0 10h8v-8H3v8Zm10 0h8v-8h-8v8Zm0-18v8h8V3h-8Z", "properties": { "fill": "currentColor" } }, "dashboard2": { "viewBox": "0 -960 960 960", "path": "M520-600v-240h320v240H520ZM120-440v-400h320v400H120Zm400 320v-400h320v400H520Zm-400 0v-240h320v240H120Zm80-400h160v-240H200v240Zm400 320h160v-240H600v240Zm0-480h160v-80H600v80ZM200-200h160v-80H200v80Zm160-320Zm240-160Zm0 240ZM360-280Z", "properties": { "fill": "currentColor" } }, "domain": { "viewBox": "0 0 24 24", "path": "M12 7V3H2v18h20V7H12ZM6 19H4v-2h2v2Zm0-4H4v-2h2v2Zm0-4H4V9h2v2Zm0-4H4V5h2v2Zm4 12H8v-2h2v2Zm0-4H8v-2h2v2Zm0-4H8V9h2v2Zm0-4H8V5h2v2Zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10Zm-2-8h-2v2h2v-2Zm0 4h-2v2h2v-2Z", "properties": { "fill": "currentColor" } }, "domainDisabled": { "viewBox": "0 0 24 24", "path": "M8 5h2v2h-.9L12 9.9V9h8v8.9l2 2V7H12V3H5.1L8 5.9V5Zm8 6h2v2h-2v-2ZM1.3 1.8.1 3.1 2 5v16h16l3 3 1.3-1.3-21-20.9ZM6 19H4v-2h2v2Zm0-4H4v-2h2v2Zm0-4H4V9h2v2Zm4 8H8v-2h2v2Zm0-4H8v-2h2v2Zm2 4v-2h2l2 2h-4Z", "properties": { "fill": "currentColor" } }, "doneAll": { "viewBox": "0 0 24 24", "path": "m18 7-1.41-1.41-6.34 6.34 1.41 1.41L18 7Zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41ZM.41 13.41 6 19l1.41-1.41L1.83 12 .41 13.41Z", "properties": { "fill": "currentColor" } }, "dots": { "viewBox": "0 0 16 16", "path": "M8 6.5c-.827 0-1.5.673-1.5 1.5S7.173 9.5 8 9.5 9.5 8.827 9.5 8 8.827 6.5 8 6.5Zm-5 0c-.827 0-1.5.673-1.5 1.5S2.173 9.5 3 9.5 4.5 8.827 4.5 8 3.827 6.5 3 6.5Zm10 0c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5Z", "properties": { "fill": "currentColor" } }, "download": { "viewBox": "0 0 24 24", "path": "M21 18.25v-3a.75.75 0 1 0-1.5 0v3a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75v-3a.75.75 0 1 0-1.5 0v3a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 18.25Zm-4.785-3.915-3.75 3a.75.75 0 0 1-.93 0l-3.75-3a.75.75 0 0 1 .93-1.17l2.535 2.025V4.75a.75.75 0 1 1 1.5 0v10.44l2.535-2.025a.75.75 0 1 1 .93 1.17Z", "properties": { "fill": "currentColor" } }, "downloadSolid": { "viewBox": "0 0 18 18", "path": "M14.25 6.75h-3v-4.5h-4.5v4.5h-3L9 12l5.25-5.25ZM3.75 13.5V15h10.5v-1.5H3.75Z", "properties": { "fill": "currentColor" } }, "driveFileRenameOutline": { "viewBox": "0 0 24 24", "path": "M18.41 5.8 17.2 4.59c-.78-.78-2.05-.78-2.83 0l-2.68 2.68L3 15.96V20h4.04l8.74-8.74 2.63-2.63c.79-.78.79-2.05 0-2.83ZM6.21 18H5v-1.21l8.66-8.66 1.21 1.21L6.21 18ZM11 20l4-4h6v4H11Z", "properties": { "fill": "currentColor" } }, "driveFileMove": { "viewBox": "0 0 24 24", "path": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-6 12v-3h-4v-4h4V8l5 5-5 5Z", "properties": { "fill": "currentColor" } }, "editRoad": { "viewBox": "0 0 24 24", "path": "M18 4h-2v7.9l2-2V4ZM6 4H4v16h2V4Zm6 0h-2v4h2V4Zm0 6h-2v4h2v-4Zm0 6h-2v4h2v-4Zm10.56-3.41-1.15-1.15a1.49 1.49 0 0 0-2.12 0L14 16.73V20h3.27l5.29-5.29c.59-.59.59-1.54 0-2.12Zm-5.98 5.86h-1.03v-1.03L19 13.97 20.03 15l-3.45 3.45Z", "properties": { "fill": "currentColor" } }, "edit": { "viewBox": "0 0 24 24", "path": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z", "properties": { "fill": "currentColor" } }, "email": { "viewBox": "0 0 24 24", "path": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 4-8 5-8-5V6l8 5 8-5v2Z", "properties": { "fill": "currentColor" } }, "exchangeLogo": { "viewBox": "0 0 61 20", "path": "M3.778.008c0 .004.013.026.028.047a1048.675 1048.675 0 0 0 1.982 2.932c.005.009.283.42.619.914.336.494.612.902.614.907.006.01.945 1.4 1.046 1.547.108.156.922 1.36.927 1.371.002.005.279.414.615.908a123.897 123.897 0 0 1 .772 1.144c.083.12.144.223.14.235-.005.011-.282.424-.616.917l-1.12 1.656a2097.996 2097.996 0 0 1-1.32 1.953c-.01.014-.073.11-.144.212-.233.34-1.078 1.589-1.086 1.604-.004.008-.295.439-.646.957a1178.503 1178.503 0 0 0-1.45 2.14c-.035.046-.361.534-.361.542 0 .003.967.006 2.15.006h2.15l.258-.376a410.65 410.65 0 0 1 .64-.93l.202-.295a407.565 407.565 0 0 1 .974-1.415c.023-.035.255-.373.648-.943l.422-.614a333.703 333.703 0 0 1 1.212-1.76 594.23 594.23 0 0 1 1.375-2c.082-.12.159-.232.17-.25l.203-.295.68-.985c.047-.07.086-.13.086-.135 0-.008-.242-.364-.633-.93a1284.2 1284.2 0 0 1-.82-1.19 124.43 124.43 0 0 0-.476-.694 85.838 85.838 0 0 1-.558-.812 138.71 138.71 0 0 0-.693-1.007c-.25-.362-.575-.834-.603-.878a165.26 165.26 0 0 0-.612-.89 429.51 429.51 0 0 1-1.02-1.483 76.955 76.955 0 0 1-.759-1.106L8.336.376 8.077 0h-2.15C4.746 0 3.779.004 3.779.008Zm13.867.02c-.008.014-.145.21-.304.434a142.12 142.12 0 0 0-.735 1.043l-.15.212a306.989 306.989 0 0 1-.752 1.066l-.196.278A253.217 253.217 0 0 0 14.494 4.5a180.792 180.792 0 0 0-.674.96c-.003.01.053.101.126.204.073.103.18.253.235.333l.817 1.166a164.714 164.714 0 0 1 .73 1.04l.177.252a.218.218 0 0 0 .054.062c.006 0 .028-.024.048-.055a36.832 36.832 0 0 1 .5-.712 61.753 61.753 0 0 1 .722-1.022 54.26 54.26 0 0 1 .38-.541l.144-.205a92.98 92.98 0 0 0 .526-.745l.191-.27.277-.394a140.952 140.952 0 0 0 .453-.643 132.814 132.814 0 0 0 .675-.957l.31-.438a55.224 55.224 0 0 0 .459-.654 499.35 499.35 0 0 0 .952-1.348l.217-.307c.057-.08.115-.164.127-.186l.023-.04h-2.152c-2.086 0-2.152 0-2.166.027Zm7.974 3.818c-.004.01-.006 2.155-.004 4.766l.004 4.748.741.004.74.004.001-1.691c0-2.082.01-2.34.106-2.736.095-.39.212-.626.415-.838.204-.213.444-.334.804-.408.213-.043.664-.047.834-.006.272.065.42.14.574.294.192.19.3.445.352.834.025.19.027.351.027 2.377v2.173h1.49v-2.29c0-1.921-.004-2.33-.023-2.539a2.875 2.875 0 0 0-.066-.437c0-.051-.114-.376-.176-.505-.272-.563-.765-.92-1.47-1.064a4.128 4.128 0 0 0-1.221-.046 3.067 3.067 0 0 0-.738.208c-.358.166-.676.44-.883.76-.027.043-.11.06-.095.02.009-.022.033-.299.055-.634.008-.122.015-.85.015-1.617V3.828h-.738c-.576 0-.739.004-.744.018ZM2.877 6.465l-.186.021a3.06 3.06 0 0 0-1.331.46c-.209.136-.41.322-.628.579C.389 7.93.137 8.559.03 9.277c-.04.264-.04 1.202-.001 1.439.139.845.43 1.438.944 1.921.492.463 1.127.737 1.904.82.231.026.963.026 1.236.001.338-.03.59-.076.953-.17a4.745 4.745 0 0 0 .69-.261c.013-.01.018-.147.018-.596 0-.67.016-.615-.158-.537a6.595 6.595 0 0 1-.925.304 5.78 5.78 0 0 1-1.062.127c-.753.027-1.313-.189-1.678-.647-.246-.31-.39-.73-.432-1.258l-.01-.12 2.3-.004 2.3-.004-.001-.54c-.002-.67-.028-.907-.143-1.322-.252-.907-.894-1.565-1.785-1.83a3.72 3.72 0 0 0-.543-.114 7.656 7.656 0 0 0-.76-.021Zm19.287 0-.209.022c-.562.053-1.063.218-1.477.485-.564.365-.984.98-1.179 1.728-.116.444-.144.697-.144 1.3 0 .706.041 1.004.21 1.541.06.186.08.235.175.424.442.875 1.199 1.373 2.266 1.492.35.04 1.113.022 1.43-.032.347-.059.724-.184.956-.318l.072-.041.004-.64a8.346 8.346 0 0 0-.008-.634c-.007.003-.09.042-.183.088-.54.261-1.07.384-1.653.382-.317-.001-.545-.043-.761-.14-.474-.213-.774-.634-.912-1.282-.12-.561-.094-1.434.058-1.936.04-.136.11-.314.153-.394.3-.558.775-.824 1.477-.825.381 0 .834.093 1.355.282a.78.78 0 0 0 .198.055.484.484 0 0 0 .042-.09 375.204 375.204 0 0 0 .401-1.064c0-.016-.279-.129-.456-.185a4.775 4.775 0 0 0-.9-.19 9.464 9.464 0 0 0-.915-.029Zm13.739-.001c-.012.003-.11.013-.216.022-.4.035-.994.158-1.303.27l-.142.051c-.153.055-.25.096-.487.205-.04.018-.071.04-.071.05 0 .01.024.066.053.126.03.06.103.219.163.353a9.16 9.16 0 0 0 .2.425c.033.07.062.128.064.128.003 0 .082-.034.176-.075a7.054 7.054 0 0 1 .379-.151c.309-.116.55-.186.815-.236.175-.034.237-.038.54-.04.332-.001.347 0 .492.04.34.093.535.245.666.52.095.198.118.327.127.71l.007.338-.14.009c-.076.005-.434.02-.794.032-.819.028-1.152.063-1.616.168-1.237.279-1.842.946-1.839 2.023.003.83.325 1.44.938 1.777.065.036.145.076.178.088.173.068.222.085.244.085a2.433 2.433 0 0 0 .371.075c.358.05.912.028 1.262-.049.563-.124.947-.365 1.381-.87a.89.89 0 0 1 .115-.12c.013 0 .04.072.087.226a38.005 38.005 0 0 0 .179.577l.043.14h1.069v-2.39c0-1.87-.004-2.425-.02-2.556-.11-.961-.54-1.506-1.408-1.788a2.315 2.315 0 0 0-.351-.09 4.407 4.407 0 0 0-.805-.073 6.35 6.35 0 0 0-.357 0Zm8.057 0c-.012.003-.09.013-.171.022-.352.04-.726.154-.998.305a2.029 2.029 0 0 0-.674.568c-.05.064-.093.106-.11.106-.029 0-.03 0-.086-.255a24.328 24.328 0 0 0-.144-.618c-.004-.014-.134-.018-.587-.018h-.58v6.793h1.488v-1.815c0-1.037.007-1.906.015-2.027.063-.905.341-1.446.87-1.694.247-.115.47-.162.82-.171.219-.006.276-.003.41.024.372.074.595.216.756.482.107.175.166.354.208.629.02.133.025.442.03 2.363l.006 2.21h1.474l-.005-2.473c-.005-2.45-.006-2.474-.037-2.612a5.6 5.6 0 0 1-.04-.19 2.294 2.294 0 0 0-.06-.204c-.266-.814-.85-1.266-1.803-1.397a6.804 6.804 0 0 0-.782-.028Zm6.546.001c-.017.003-.11.012-.209.021-.63.058-1.181.275-1.56.615a2.63 2.63 0 0 0-.326.379 2.185 2.185 0 0 0-.33 1.293c0 .323.003.381.032.504.106.45.27.75.574 1.046.175.17.276.245.454.334.06.03.106.056.104.059l-.126.085a3.579 3.579 0 0 0-.155.107c-.308.246-.418.378-.507.613-.027.07-.034.126-.04.305-.006.205-.004.227.031.332.093.277.295.52.539.646.04.022.06.037.043.037-.063 0-.437.137-.572.21l-.112.06c-.245.136-.504.4-.628.642a1.71 1.71 0 0 0-.169.725c0 .131.039.41.073.527.135.457.494.831 1.017 1.058.29.126.606.207 1.033.266.283.038 1.337.038 1.683 0 .672-.076 1.162-.204 1.605-.42.477-.234.833-.566 1.044-.974.167-.32.241-.753.204-1.178-.04-.464-.18-.782-.463-1.064-.288-.286-.624-.442-1.154-.537-.248-.044-.618-.06-1.434-.06-.963 0-1.161-.021-1.334-.146-.187-.135-.214-.348-.076-.612.032-.06.213-.24.307-.305.066-.044.074-.046.134-.033.103.024.683.035.928.018.226-.016.372-.039.603-.093.726-.17 1.29-.587 1.562-1.153.118-.246.17-.447.197-.77.042-.49-.06-.948-.294-1.314a.87.87 0 0 1-.05-.083c0-.003.022-.008.049-.012.026-.003.105-.017.175-.03l.253-.048.555-.102.13-.024v-.815h-1.21c-.998 0-1.231-.005-1.33-.022a5.738 5.738 0 0 0-1.25-.087Zm7.081.02c-.545.066-.987.225-1.377.493a3.004 3.004 0 0 0-1.073 1.437c-.086.205-.178.622-.226 1.015a6.332 6.332 0 0 0-.007 1.081c.011.073.025.182.033.243.027.234.11.553.215.824a3.665 3.665 0 0 0 .29.556 2.98 2.98 0 0 0 1.743 1.216c.37.097.648.127 1.192.127.662 0 1.031-.044 1.578-.187.157-.041.433-.141.63-.229l.07-.031v-.59c0-.493-.003-.592-.02-.592a.821.821 0 0 0-.137.052c-.2.09-.653.239-.892.294-.186.043-.485.09-.693.11a5.376 5.376 0 0 1-.901 0c-.84-.122-1.353-.615-1.54-1.479a2.31 2.31 0 0 1-.038-.262 4.69 4.69 0 0 0-.018-.194l-.009-.07H61l-.005-.639c-.005-.533-.01-.664-.032-.792-.091-.516-.236-.9-.472-1.245-.44-.647-1.094-1.026-1.958-1.137a4.995 4.995 0 0 0-.946-.001Zm-7.089.943c-.485.075-.791.354-.932.848-.04.14-.041.16-.042.49 0 .318.002.351.034.46.114.382.288.597.6.742.181.084.348.114.636.114.441 0 .684-.083.918-.315.18-.176.27-.376.313-.686.05-.36.013-.73-.101-1.017-.069-.173-.261-.412-.38-.472a2.966 2.966 0 0 1-.093-.049 1.499 1.499 0 0 0-.406-.12 2.35 2.35 0 0 0-.547.005Zm-47.614.161c-.538.069-.947.391-1.169.92a2.66 2.66 0 0 0-.162.64l-.01.099h3.099v-.092a2.449 2.449 0 0 0-.13-.697 1.243 1.243 0 0 0-.33-.512c-.21-.203-.458-.316-.784-.358a1.785 1.785 0 0 0-.514 0Zm54.897.001c-.617.083-1.042.472-1.243 1.139a3.708 3.708 0 0 0-.097.478v.04h3.097v-.12c0-.191-.063-.503-.142-.705a1.312 1.312 0 0 0-.63-.7 1.585 1.585 0 0 0-.471-.133 1.762 1.762 0 0 0-.514.001Zm-21.2 2.579c-.512.027-.741.052-.969.104-.61.14-.912.371-1.05.808-.028.088-.033.137-.033.343 0 .225.003.249.04.349.104.283.278.44.595.54.115.035.138.037.456.037.315 0 .344-.002.493-.039.344-.085.575-.205.785-.408a1.22 1.22 0 0 0 .27-.357c.151-.297.18-.452.18-.992v-.415l-.138.002c-.076 0-.36.014-.63.028Zm-20.632 1.07a2.824 2.824 0 0 1-.089.127 141.218 141.218 0 0 0-.632.875l-.114.158a102.68 102.68 0 0 1-.72.998l-.322.45c-.14.195-.256.359-.256.364a.56.56 0 0 0 .05.083 194.496 194.496 0 0 1 .434.651 346.233 346.233 0 0 1 .73 1.096 190.242 190.242 0 0 0 .774 1.161l.398.6.283.423a315.957 315.957 0 0 1 .7 1.052l.466.7c.014.021.22.023 2.164.02l2.15-.004-.495-.73-1.198-1.769-1.454-2.147-1.554-2.294-1.031-1.523a4.432 4.432 0 0 0-.242-.34c-.007 0-.026.022-.042.048Zm33.939 2.127c-.318.054-.558.17-.736.354-.166.172-.243.347-.271.62a.99.99 0 0 0 .068.396c.145.323.565.543 1.147.602a6.723 6.723 0 0 0 1.363-.048c.897-.161 1.391-.572 1.392-1.156 0-.296-.127-.52-.361-.631a2.09 2.09 0 0 0-.532-.137c-.096-.012-.427-.02-1.028-.022-.799-.004-.901-.001-1.042.022Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "#1B75BB" } }, "favorite": { "viewBox": "50 -850 900 600", "path": "m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Zm0-108q96-86 158-147.5t98-107q36-45.5 50-81t14-70.5q0-60-40-100t-100-40q-47 0-87 26.5T518-680h-76q-15-41-55-67.5T300-774q-60 0-100 40t-40 100q0 35 14 70.5t50 81q36 45.5 98 107T480-228Zm0-273Z", "properties": { "fill": "currentColor" } }, "favoriteFilledStroke": { "viewBox": "0 0 102 102", "path": "M71.975 10c6.877 0 12.57 2.308 17.149 6.915C93.704 21.522 96 27.252 96 34.177c0 3.395-.568 6.717-1.707 9.97-1.132 3.233-3.14 6.825-6.06 10.78-2.919 3.953-6.865 8.436-11.848 13.45-4.989 5.019-11.306 10.995-18.957 17.93L51.5 91.653l-5.928-5.346c-7.65-6.936-13.969-12.912-18.957-17.93-4.983-5.014-8.93-9.497-11.848-13.45-2.92-3.955-4.928-7.547-6.06-10.78A29.958 29.958 0 0 1 7 34.177c0-6.925 2.296-12.655 6.876-17.262C18.456 12.308 24.148 10 31.026 10c3.795 0 7.404.807 10.834 2.423 3.433 1.616 6.39 3.892 8.876 6.836l.764.903.764-.903c2.487-2.944 5.443-5.22 8.876-6.836A25.119 25.119 0 0 1 71.975 10Z", "properties": { "fill": "currentColor", "stroke": "currentColor", "strokeWidth": "6" } }, "favoriteFilled": { "viewBox": "0 -960 960 960", "path": "m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z", "properties": { "fill": "currentColor" } }, "filePresent": { "viewBox": "0 0 24 24", "path": "M15 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V7l-5-5ZM6 20V4h8v4h4v12H6Zm10-10v5c0 2.21-1.79 4-4 4s-4-1.79-4-4V8.5a2.5 2.5 0 0 1 2.76-2.49c1.3.13 2.24 1.32 2.24 2.63V15h-2V8.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V15c0 1.1.9 2 2 2s2-.9 2-2v-5h2Z", "properties": { "fill": "currentColor" } }, "file": { "viewBox": "0 0 21 24", "path": "M20.845 6.495 13.525.142a.61.61 0 0 0-.4-.142H2.216C.993 0 0 .827 0 1.845v20.31C0 23.172.993 24 2.215 24h16.57C20.007 24 21 23.172 21 22.155V6.815a.425.425 0 0 0-.155-.32ZM2.215 1C1.367 1 1 1.543 1 1.845v20.31c0 .302.367.845 1.215.845h16.57c.848 0 1.215-.543 1.215-.845V7.085L12.988 1H2.215Z", "properties": { "stroke": "currentColor" } }, "fileDoc": { "viewBox": "0 0 6 10", "path": "M4.875 3.021c.173 0 .313.14.313.313v3.645a2.188 2.188 0 0 1-4.375 0V2.396a1.563 1.563 0 1 1 3.125 0v3.75a.938.938 0 0 1-1.876 0V3.333a.312.312 0 1 1 .626 0v2.813a.313.313 0 0 0 .624 0v-3.75a.937.937 0 1 0-1.874 0v4.583a1.562 1.562 0 1 0 3.125 0V3.333c0-.172.14-.312.312-.312Z", "properties": { "fill": "currentColor" } }, "filePdf": { "viewBox": "0 0 8 9", "path": "M3.547.149a.9.9 0 0 0-.23.03c-.214.053-.56.263-.46 1.065.043.354.172.805.365 1.291-.104.324-.219.663-.332.996-.107.314-.217.638-.315.944-.079.245-.15.477-.219.696-.095.307-.182.586-.267.838C.623 6.842.038 7.563.002 8.007a.457.457 0 0 0 .193.43.532.532 0 0 0 .305.085c.138 0 .315-.04.54-.152.79-.396 1.164-1.05 1.497-1.983.282-.154.6-.315.962-.482a7.713 7.713 0 0 1 1.463-.521c.471.495.97.82 1.438.82.509 0 .868-.168.985-.461.086-.216.02-.457-.177-.643-.279-.265-.775-.401-1.397-.383a4.537 4.537 0 0 0-.652.069c-.517-.62-1.019-1.482-1.356-2.275.346-1.115.472-1.844.157-2.186a.55.55 0 0 0-.413-.176Zm-.004.548h.014c.01.012.11.158-.07.913a3.324 3.324 0 0 1-.087-.433c-.04-.33.018-.458.05-.467a.383.383 0 0 1 .093-.013Zm.01 2.584a9.734 9.734 0 0 0 1.013 1.64 8.705 8.705 0 0 0-1.296.486c-.17.078-.331.156-.486.232l.096-.305c.067-.218.14-.448.217-.691.097-.302.206-.624.312-.935l.145-.427Zm2.3 1.984c.493-.008.761.102.844.143.117.058.161.115.173.138-.029.032-.157.11-.47.11-.233 0-.498-.142-.771-.38.08-.007.154-.01.225-.011Zm-4.1 1.593c-.232.472-.514.799-.958 1.021a.985.985 0 0 1-.22.084c.083-.184.39-.58 1.178-1.105Z", "properties": { "fill": "currentColor" } }, "filePhoto": { "viewBox": "0 0 8 6", "path": "M7 0H1C.667 0 .333.333.333.667v4.666C.333 5.7.633 6 1 6h6c.333 0 .667-.333.667-.667V.667C7.667.333 7.333 0 7 0ZM1.667 4.667l1.166-1.5.834 1.003 1.166-1.503 1.5 2H1.667Z", "properties": { "fill": "currentColor" } }, "filePlaceholder": { "viewBox": "0 0 32 40", "path": "M21.71.31a.968.968 0 0 0-.696-.31H5.41C2.531 0 .154 2.367.154 5.246v29.507C.154 37.633 2.531 40 5.41 40h21.18c2.88 0 5.256-2.367 5.256-5.247v-23.43a1.04 1.04 0 0 0-.28-.676L21.71.31Zm.28 3.1 6.6 6.928H24.3a2.301 2.301 0 0 1-2.31-2.3V3.412Zm4.599 34.658H5.41c-1.806 0-3.323-1.498-3.323-3.315V5.246c0-1.806 1.507-3.314 3.323-3.314h14.648V8.04a4.227 4.227 0 0 0 4.241 4.232h5.614v22.482c0 1.817-1.508 3.315-3.324 3.315Z", "properties": { "fill": "currentColor" } }, "fileVideo": { "viewBox": "0 0 9 7", "path": "M6.792 2.813V1.208A.46.46 0 0 0 6.333.75h-5.5a.46.46 0 0 0-.458.458v4.584a.46.46 0 0 0 .458.458h5.5a.46.46 0 0 0 .459-.458V4.188L8.625 6.02V.979L6.792 2.812Z", "properties": { "fill": "currentColor" } }, "fileCopy": { "viewBox": "0 0 24 24", "path": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm-1 4 6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7Zm-1 7h5.5L14 6.5V12Z", "properties": { "fill": "currentColor" } }, "fillTrash": { "viewBox": "0 0 24 24", "path": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4Z", "properties": { "fill": "currentColor" } }, "filterList": { "viewBox": "0 0 24 24", "path": "M10 18h4v-2h-4v2ZM3 6v2h18V6H3Zm3 7h12v-2H6v2Z", "properties": { "fill": "currentColor" } }, "floorPlan": { "viewBox": "-100 -100 750 700", "path": "M21.4 107.4v367.8c0 3.7 3 6.6 6.6 6.6h234c1.8 0 3.4-.7 4.7-1.9l47.9-47.9c2.6-2.6 2.6-6.8 0-9.3-2.6-2.6-6.8-2.6-9.3 0l-46 46h-50.8v-39.9c0-3.7-3-6.6-6.6-6.6s-6.6 3-6.6 6.6v39.9H34.6V323.3h160.7v45.1c0 3.7 3 6.6 6.6 6.6s6.6-3 6.6-6.6V262.1c0-3.7-3-6.6-6.6-6.6s-6.6 3-6.6 6.6v48H34.6V114h160.7v87.9c0 3.7 3 6.6 6.6 6.6s6.6-3 6.6-6.6V31.3h256.9v283h-65.6c-3.7 0-6.6 3-6.6 6.6v147.8H323c-3.7 0-6.6 3-6.6 6.6s3 6.6 6.6 6.6h76.8c3.7 0 6.6-3 6.6-6.6V327.5H472c3.7 0 6.6-3 6.6-6.6V24.6c0-3.7-3-6.6-6.6-6.6H201.9c-3.7 0-6.6 3-6.6 6.6v76.1H28c-3.6.1-6.6 3-6.6 6.7z", "properties": { "fill": "none", "stroke": "currentColor", "strokeWidth": "12" } }, "folder": { "viewBox": "0 0 16 16", "path": "M12.667 2H8.315a.68.68 0 0 1-.298-.066L5.913.878a2.01 2.01 0 0 0-.894-.211H3.333A3.337 3.337 0 0 0 0 4v8a3.337 3.337 0 0 0 3.333 3.334h9.334A3.337 3.337 0 0 0 16 12V5.334A3.337 3.337 0 0 0 12.667 2ZM3.333 2H5.02a.68.68 0 0 1 .298.067L7.42 3.12c.277.14.583.212.894.214h4.352a2 2 0 0 1 1.852 1.254l-13.186.075V4a2 2 0 0 1 2-2Zm9.334 12H3.333a2 2 0 0 1-2-2V5.996l13.334-.075v6.08a2 2 0 0 1-2 2Z", "properties": { "fill": "currentColor" } }, "folderCheckFilledStroke": { "viewBox": "0 0 138 138", "path": "M23 24h34.086l11.5 11.5H115c2.895 0 5.349 1.019 7.415 3.085S125.5 43.105 125.5 46v57.5c0 2.895-1.019 5.349-3.085 7.415S117.895 114 115 114H23c-2.895 0-5.349-1.019-7.415-3.085s-3.085-4.52-3.085-7.415v-69c0-2.895 1.019-5.349 3.085-7.415S20.105 24 23 24Zm39.388 53.648L50.168 65.43l-.706.707-8.194 8.193-.71.71.712.707 20.413 20.269.709.704.704-.708L95.584 63.38l.704-.707-9.463-9.463-24.437 24.437Z", "properties": { "fill": "currentColor", "stroke": "currentColor", "strokeWidth": "6" } }, "folderFilledStroke": { "viewBox": "0 0 58 58", "path": "M9.667 10.667h14.086l4.54 4.54.294.293h19.747c1.062 0 1.946.366 2.706 1.127.76.76 1.127 1.645 1.127 2.707V43.5c0 1.062-.367 1.946-1.127 2.707-.76.76-1.644 1.127-2.706 1.127H9.667c-1.062 0-1.946-.367-2.706-1.127S5.834 44.562 5.834 43.5v-29c0-1.062.367-1.946 1.127-2.706s1.644-1.127 2.706-1.127Z", "properties": { "fill": "currentColor", "stroke": "currentColor", "strokeWidth": "3" } }, "folderPlaceholder": { "viewBox": "0 0 48 40", "path": "M41.81 7.284H26.85c-.608 0-1.2-.25-1.61-.673l-4.668-4.917C19.45.575 17.915-.01 16.36 0H6.19A5.83 5.83 0 0 0 .368 5.824v28.352A5.83 5.83 0 0 0 6.191 40h35.645c3.21-.014 5.812-2.64 5.797-5.842v-21.05a5.83 5.83 0 0 0-5.823-5.824Zm2.262 26.882a2.264 2.264 0 0 1-2.244 2.272H6.19a2.265 2.265 0 0 1-2.262-2.262V5.824A2.268 2.268 0 0 1 6.191 3.56h10.275c.594 0 1.171.237 1.56.622l4.642 4.894a5.851 5.851 0 0 0 4.182 1.77h14.96a2.265 2.265 0 0 1 2.261 2.262v21.058Z", "properties": { "fill": "currentColor" } }, "hide": { "viewBox": "0 0 16 12", "path": "m2.853 11.854 11-11a.5.5 0 1 0-.707-.707l-1.618 1.618A8.42 8.42 0 0 0 8 1C2.766 1 .17 5.563.063 5.757a.5.5 0 0 0 0 .486c.07.128 1.22 2.138 3.483 3.504l-1.4 1.4a.5.5 0 1 0 .708.707Zm13.084-6.097c-.061-.11-.934-1.639-2.639-2.934l-.727.728A10.005 10.005 0 0 1 14.91 6c-.59.903-2.915 4-6.91 4a7.347 7.347 0 0 1-1.68-.199l-.822.822A8.47 8.47 0 0 0 8 11c5.234 0 7.83-4.563 7.937-4.757a.5.5 0 0 0 0-.486Zm-5.95.378.908-.909c.066.247.105.506.105.774 0 1.654-1.346 3-3 3a2.99 2.99 0 0 1-.774-.105l.909-.909a1.991 1.991 0 0 0 1.851-1.851ZM4.291 9l1.266-1.265A2.98 2.98 0 0 1 5 6c0-1.654 1.346-3 3-3a2.98 2.98 0 0 1 1.736.557l1.023-1.023A7.362 7.362 0 0 0 8 2C4.006 2 1.68 5.097 1.088 6c.377.57 1.458 2.012 3.204 3Zm4.717-4.718L6.283 7.01A1.977 1.977 0 0 1 6 6c0-1.103.897-2 2-2 .37 0 .712.108 1.01.283Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "currentColor" } }, "history": { "viewBox": "0 -960 960 960", "path": "M480-120q-138 0-240.5-91.5T122-440h82q14 104 92.5 172T480-200q117 0 198.5-81.5T760-480q0-117-81.5-198.5T480-760q-69 0-129 32t-101 88h110v80H120v-240h80v94q51-64 124.5-99T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Zm112-192L440-464v-216h80v184l128 128-56 56Z", "properties": { "fill": "currentColor" } }, "home": { "viewBox": "0 0 12 13", "path": "M12 12.333a.667.667 0 0 1-.667.667H.667A.667.667 0 0 1 0 12.333V5.327A.667.667 0 0 1 .257 4.8L5.591.652a.667.667 0 0 1 .818 0L11.743 4.8a.666.666 0 0 1 .257.527v7.006Zm-1.333-.666V5.652L6 2.022l-4.667 3.63v6.015h9.334Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "currentColor" } }, "home1": { "viewBox": "0 0 16 16", "path": "M15.414 6.046 10.358.99a3.339 3.339 0 0 0-4.715 0L.586 6.046A1.985 1.985 0 0 0 0 7.46v6.545a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.46a1.986 1.986 0 0 0-.586-1.414ZM10 14.672H6v-2.623a2 2 0 1 1 4 0v2.623Zm4.667-.667a.667.667 0 0 1-.667.667h-2.666v-2.623a3.333 3.333 0 0 0-6.667 0v2.623H2a.667.667 0 0 1-.666-.667V7.46c0-.176.07-.346.195-.47l5.057-5.056a2.005 2.005 0 0 1 2.829 0l5.057 5.057a.672.672 0 0 1 .195.47v6.544Z", "properties": { "fill": "currentColor" } }, "home2": { "viewBox": "0 0 12 12", "path": "M3.667 11.333a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h1.333a1 1 0 0 0 1-1V6.555c0-.307.248-.555.555-.555a.555.555 0 0 0 .37-.967L6.67.603a1 1 0 0 0-1.338 0L.408 5.032A.555.555 0 0 0 .778 6c.307 0 .555.248.555.555v3.778a1 1 0 0 0 1 1h1.334Z", "properties": { "fill": "currentColor" } }, "house": { "viewBox": "0 0 24 24", "path": "M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3l-3-2.7Zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4Z", "properties": { "fill": "currentColor" } }, "infoCircle": { "viewBox": "0 0 16 16", "path": "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.669 6.669 0 0 0 8 14.667 6.669 6.669 0 0 0 14.667 8 6.669 6.669 0 0 0 8 1.333Zm.667 10H7.334v-4h1.333v4Zm0-5.333H7.334V4.667h1.333V6Z", "properties": { "fill": "currentColor" } }, "libraryAddCheck": { "viewBox": "0 0 24 24", "path": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14ZM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6Z", "properties": { "fill": "currentColor" } }, "listAlt": { "viewBox": "0 0 24 24", "path": "M19 5v14H5V5h14Zm1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9ZM11 7h6v2h-6V7Zm0 4h6v2h-6v-2Zm0 4h6v2h-6v-2ZM7 7h2v2H7V7Zm0 4h2v2H7v-2Zm0 4h2v2H7v-2Z", "properties": { "fill": "currentColor" } }, "listStraight": { "viewBox": "0 0 24 24", "path": "M4.668 4.5a.75.75 0 0 0 0 1.5h14.666a.75.75 0 0 0 0-1.5H4.668Zm0 13.5a.75.75 0 0 0 0 1.5h14.666a.75.75 0 0 0 0-1.5H4.668Zm-.75-3.75a.75.75 0 0 1 .75-.75h14.666a.75.75 0 0 1 0 1.5H4.668a.75.75 0 0 1-.75-.75ZM4.668 9a.75.75 0 0 0 0 1.5h14.666a.75.75 0 0 0 0-1.5H4.668Z", "properties": { "fill": "currentColor" } }, "list": { "viewBox": "0 0 24 24", "path": "M3 13h2v-2H3v2Zm0 4h2v-2H3v2Zm0-8h2V7H3v2Zm4 4h14v-2H7v2Zm0 4h14v-2H7v2ZM7 7v2h14V7H7Z", "properties": { "fill": "currentColor" } }, "liveChat": { "viewBox": "0 0 24 24", "path": "M7.4 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3.5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z M10 19c.596 0 1.177-.065 1.735-.189A5.74 5.74 0 0 0 16.25 21a5.73 5.73 0 0 0 2.538-.59l2.116.527a.85.85 0 0 0 1.027-1.045l-.548-2.048a5.752 5.752 0 0 0-3.481-8.103 8 8 0 1 0-14.844 5.237.097.097 0 0 1 .012.048v2.945a.97.97 0 0 0 1.424.857l1.551-.821a.098.098 0 0 1 .093 0A7.964 7.964 0 0 0 10 19Zm0-1.454a6.51 6.51 0 0 1-3.159-.811 1.552 1.552 0 0 0-1.476-.014l-.84.445v-2.14c0-.273-.072-.54-.206-.773A6.545 6.545 0 1 1 10 17.545Zm6.25 1.954a4.235 4.235 0 0 1-2.964-1.204 8.003 8.003 0 0 0 4.705-6.924 4.252 4.252 0 0 1 1.956 5.977.835.835 0 0 0-.081.628l.33 1.238-1.29-.32a.835.835 0 0 0-.605.079 4.227 4.227 0 0 1-2.051.526Z", "properties": { "fill": "currentColor" } }, "loading": { "viewBox": "0 0 24 24", "path": "M12 22C6.49 22 2 17.51 2 12c0-1.87.52-3.69 1.5-5.27a1.003 1.003 0 0 1 1.7 1.06A8.008 8.008 0 0 0 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.55 0-1-.45-1-1s.45-1 1-1c5.51 0 10 4.49 10 10s-4.49 10-10 10Z", "properties": { "fill": "currentColor" } }, "localHotel": { "viewBox": "0 0 24 24", "path": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3Zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4Z", "properties": { "fill": "currentColor" } }, "lock": { "viewBox": "0 0 24 24", "path": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2Zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2Z", "properties": { "fill": "currentColor" } }, "lockOutline": { "viewBox": "0 0 24 24", "path": "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2ZM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6ZM18 20H6V10h12v10Z", "properties": { "fill": "currentColor" } }, "logout": { "viewBox": "0 0 24 24", "path": "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5ZM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5Z", "properties": { "fill": "currentColor" } }, "luxuryEstate": { "viewBox": "0 0 16 16", "path": "M2.743 9.371H1.37v4.114H.686a.686.686 0 0 0 0 1.372H4.57V9.37H2.743Zm12.571 4.114h-.685V9.371h-3.201v5.486h3.886a.686.686 0 1 0 0-1.372Zm.626-6.45-1.828-4.114a.686.686 0 0 0-.626-.407h-2.058v-.686a.686.686 0 1 0-1.37 0v.686H2.513a.686.686 0 0 0-.626.407L.059 7.035A.686.686 0 0 0 .686 8H4.57v-.686c0-.216.102-.42.275-.549l.183-.137 2.56-1.92a.686.686 0 0 1 .822 0l2.56 1.92.183.137c.173.13.275.333.275.549V8h3.886a.686.686 0 0 0 .627-.965Z m8.686 6.629.914.685.457.343v7.2H8.686V12.8a.686.686 0 1 0-1.372 0v2.057H5.943v-7.2l.457-.343.914-.685L8 6.114l.686.515Zm-.277 2.23.22-.225a.133.133 0 0 0-.075-.225l-.298-.046-.135-.286a.133.133 0 0 0-.242 0l-.134.286-.298.046a.133.133 0 0 0-.076.225l.22.225-.052.32a.133.133 0 0 0 .196.138L8 9.17l.265.147a.132.132 0 0 0 .166-.03.133.133 0 0 0 .03-.109l-.052-.32Z", "properties": { "fill": "currentColor" } }, "mapMarker": { "viewBox": "0 0 24 24", "path": "M11.999 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm8.66 3.157-.72-.239A7.999 7.999 0 0 0 12 0a7.993 7.993 0 0 0-7.914 9.092 5.045 5.045 0 0 0-2.548 1.3A4.946 4.946 0 0 0-.001 14v4.075a5.013 5.013 0 0 0 3.6 4.8l2.87.9a5.045 5.045 0 0 0 2.844.039l5.78-1.71a2.988 2.988 0 0 1 1.573 0l2.387.8a4 4 0 0 0 4.946-3.883v-5.149a5.014 5.014 0 0 0-3.34-4.716v.001ZM7.757 3.762a5.987 5.987 0 0 1 8.484 0 6.037 6.037 0 0 1 .01 8.5L12.7 15.717a.992.992 0 0 1-1.39 0l-3.552-3.44a6.04 6.04 0 0 1 0-8.515Zm14.242 15.259a1.99 1.99 0 0 1-.764 1.572 1.97 1.97 0 0 1-1.626.395l-2.345-.788a5.023 5.023 0 0 0-2.717-.016l-5.784 1.708a3 3 0 0 1-1.694-.029l-2.894-.9a3.013 3.013 0 0 1-2.176-2.888V14a2.964 2.964 0 0 1 .92-2.163 3.025 3.025 0 0 1 1.669-.806A8.02 8.02 0 0 0 6.353 13.7l3.567 3.453a2.983 2.983 0 0 0 4.174 0l3.563-3.463a7.961 7.961 0 0 0 1.813-2.821l.537.178a3.006 3.006 0 0 1 1.992 2.825v5.149Z", "properties": { "fill": "currentColor" } }, "mediaFolderPlaceholder": { "viewBox": "0 0 124 124", "path": "M110 26H56L44 14H14C7.4 14 2 19.4 2 26v24h120V38c0-6.6-5.4-12-12-12Z M110 26H14C7.4 26 2 31.4 2 38v60c0 6.6 5.4 12 12 12h96c6.6 0 12-5.4 12-12V38c0-6.6-5.4-12-12-12Z", "properties": { "fill": "currentColor" } }, "menu": { "viewBox": "0 -960 960 960", "path": "M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z", "properties": { "fill": "currentColor" } }, "miamiRealtorsIcon": { "viewBox": "0 0 494 497", "path": "M223 13.4c0 2.1 1.6 3.1 21.7 13 15 7.4 19.6 10.2 22.1 13.2 3.7 4.5 6.4 12.8 8.7 26.4.9 5.2 3.4 20.3 5.6 33.5 5.4 32.6 6.7 40.4 8.5 51.5 2.5 16.3 5 20.3 6.7 10.9 3.4-18.9 5.7-30.8 9-46.1.9-3.7 2.3-8.5 3.4-10.5 3.2-6.7 1.9-7.2 45.3 17.4 6.7 3.8 23.4 13 30.4 16.8 3.3 1.9 7 4.5 8 5.9 2.7 3.6 3.1 11.7 1.1 21.2-3.8 17.5-6.5 33.4-8.5 50.4-.6 4.7-1.5 12.1-2 16.5-1.5 11.9-4 58.8-4 74.4 0 42.5 9.2 131.3 13.7 132.8 1.6.6 13.8-10 25.7-22.1 13.4-13.7 24.7-28.4 34.8-45.1 3.9-6.5 14.8-27.8 14.8-29 0-.4.6-2.1 1.4-3.8 6.6-15.5 10.9-31.2 14.8-54.7 2.9-17.8 2.9-51.2 0-69-3.2-19.2-7.8-37.7-12-48-.6-1.4-2-5-3.2-8-3.9-9.7-13.9-29-19.7-37.9-13.8-21.3-34-43.9-51.3-57.6-33.2-26.4-73.1-44.3-112.5-50.5-3.8-.6-7.1-1.5-7.3-2.1-.2-.5-11.4-.9-27.8-.9-22.6 0-27.4.2-27.4 1.4zm-53 11.3c-38.7 14.8-62.2 29.4-88.8 54.8-18.8 17.9-36.5 41.8-47.6 64.4-3.4 7-6.7 13.9-7.3 15.6-.7 1.6-2.1 5.5-3.3 8.5-4.3 11.2-6.1 17.4-10 34.5-2.9 12.6-4 24.7-4 44.7 0 12.8.4 20.8 1 20.8.5 0 8.5-7.3 17.6-16.3 58.6-57.1 106.9-128.3 151.3-222.9 3.5-7.5 1.9-8.3-8.9-4.1z M208.4 122.1c-2 3.1-3.4 5.5-3.9 6.9-1.5 3.7-14.4 29.2-17.9 35.5C154.3 221.9 120 266.4 81 301.4c-15.5 14-29.3 24.9-43.3 34.4-5.9 4-10.7 8-10.7 8.7 0 3.2 15.5 31.7 23.3 42.7 39.2 55.7 94.3 90.2 162.2 101.4 15.5 2.6 54.3 2.6 70 0 20.7-3.4 42.3-9.7 61-17.8 12.1-5.3 25.5-12.7 26.2-14.4.3-.8-.8-5.8-2.5-11.2-1.6-5.3-3.7-12.6-4.7-16.2-1-3.6-2.3-8.5-3-11-7.1-25.4-16.9-70-20.5-93.5-.6-3.9-1.7-11.1-2.5-16-.8-5-2.2-15.1-3-22.5-.9-7.4-2-13.9-2.5-14.4-1.5-1.6-3.9.9-11.3 12.1-13.7 20.5-22.6 42.2-25.2 61.1-.4 2.8-1.5 6.2-2.5 7.4-1.7 2.1-2.1 2.2-7.4 1.1-7.3-1.5-27.6-11.6-50.3-25-10.4-6.2-10-5.4-12.7-21.8-4.8-28.9-9.4-69.5-11.8-105-1.7-24.6-1.6-62.1.1-70.7.8-4.4 1-7.2.3-8.3-.8-1.5-1.1-1.5-1.8-.4z" }, "mobile": { "viewBox": "0 0 24 24", "path": "M13.5 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z M16.5 1A2.5 2.5 0 0 1 19 3.5v17a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 20.5v-17A2.5 2.5 0 0 1 7.5 1h9ZM9 2.5H7.5a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1H15V3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-.5Z", "properties": { "fill": "currentColor" } }, "money": { "viewBox": "0 0 24 24", "path": "M2 4v16h20V4H2Zm2 14V6h16v12H4ZM5 8h2v8H5V8Zm7 0H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1Zm-1 6h-1v-4h1v4Zm7-6h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1Zm-1 6h-1v-4h1v4Z", "properties": { "fill": "currentColor" } }, "note": { "viewBox": "0 0 17 16", "path": "M6.753 4.501c-.274 0-.5.225-.5.499s.225.5.5.5h3.5c.274 0 .5-.226.5-.5a.502.502 0 0 0-.5-.499h-3.5Zm0 2.999c-.275 0-.5.226-.5.5v.001c0 .274.225.5.5.5h3.5c.274 0 .5-.226.5-.5V8c0-.274-.226-.5-.5-.5h-3.5Zm0 3.001c-.275 0-.5.226-.5.5a.503.503 0 0 0 .5.499h3.5c.273 0 .5-.225.5-.498V11c0-.274-.226-.5-.5-.5h-3.5ZM4.002 1a1.5 1.5 0 0 0-1.5 1.501V13.5a1.504 1.504 0 0 0 1.5 1.502h9.001a1.5 1.5 0 0 0 1.5-1.502V2.501A1.501 1.501 0 0 0 13.003 1h-9Zm0 1h9.001a.499.499 0 0 1 .5.501V13.5a.499.499 0 0 1-.5.5h-9a.499.499 0 0 1-.499-.5V2.501a.5.5 0 0 1 .498-.5Z", "properties": { "fill": "currentColor" } }, "notification": { "viewBox": "0 0 24 24", "path": "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2Zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2Z", "properties": { "fill": "currentColor" } }, "pauseCircleOutline": { "viewBox": "0 0 24 24", "path": "M9 16h2V8H9v8Zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm1-4h2V8h-2v8Z", "properties": { "fill": "currentColor" } }, "penthouse": { "viewBox": "0 0 16 16", "path": "m12.48 4.868.151-.22a.83.83 0 0 0-.151-1.108L8.537.22a.833.833 0 0 0-1.074 0L3.52 3.54a.831.831 0 0 0-.151 1.108l.151.22a.839.839 0 0 0 1.225.167l3.148-2.651a.167.167 0 0 1 .214 0l3.148 2.65a.839.839 0 0 0 1.225-.166Zm2.687 2.798H.833A.833.833 0 0 0 0 8.499v1c0 .46.373.834.833.834h14.334c.46 0 .833-.373.833-.834v-1a.833.833 0 0 0-.833-.833Zm-.5 7.5v-4.333a.167.167 0 0 0-.167-.167h-13a.167.167 0 0 0-.167.167v4.333a.833.833 0 0 0 .834.833h1.666v-.833a.667.667 0 0 1 .667-.667h1a.667.667 0 0 1 .667.667v.833h3.666v-.833a.667.667 0 0 1 .667-.667h1a.667.667 0 0 1 .667.667v.833h1.666a.833.833 0 0 0 .834-.833Zm-8.5-2.333a.667.667 0 0 1-.667.666h-1a.667.667 0 0 1-.667-.666v-1a.667.667 0 0 1 .667-.667h1a.667.667 0 0 1 .667.667v1Zm6 0a.666.666 0 0 1-.667.666h-1a.667.667 0 0 1-.667-.666v-1a.667.667 0 0 1 .667-.667h1a.667.667 0 0 1 .667.667v1Z M11.167 7.333a.167.167 0 0 0 .166-.167V5.572a.166.166 0 0 0-.088-.147 1.123 1.123 0 0 1-.204-.134l-2.934-2.47a.167.167 0 0 0-.214 0l-2.934 2.47a1.13 1.13 0 0 1-.204.134.167.167 0 0 0-.088.147v1.594a.167.167 0 0 0 .166.167h2.334v-1a.833.833 0 1 1 1.666 0v1h2.334Z", "properties": { "fill": "currentColor" } }, "personOutline": { "viewBox": "0 0 24 24", "path": "M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2Zm0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1ZM12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4Z", "properties": { "fill": "currentColor" } }, "photoLibrary": { "viewBox": "0 0 24 24", "path": "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2Zm-11-4 2.03 2.71L16 11l4 5H8l3-4ZM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2Z", "properties": { "fill": "currentColor" } }, "pin": { "viewBox": "0 0 24 24", "path": "M12 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 12a5.27 5.27 0 0 1-4.311-2.2c-3.811-5.257-5.744-9.209-5.744-11.747a10.055 10.055 0 1 1 20.11 0c0 2.538-1.933 6.49-5.744 11.747A5.27 5.27 0 0 1 12 24Zm0-21.819a7.883 7.883 0 0 0-7.874 7.874c0 2.01 1.893 5.727 5.329 10.466a3.145 3.145 0 0 0 5.09 0c3.436-4.739 5.329-8.456 5.329-10.466A7.883 7.883 0 0 0 12 2.181Z", "properties": { "fill": "currentColor" } }, "playCircleOutline": { "viewBox": "0 0 24 24", "path": "m10 16.5 6-4.5-6-4.5v9ZM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z", "properties": { "fill": "currentColor" } }, "plus": { "viewBox": "0 0 24 24", "path": "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z", "properties": { "fill": "currentColor" } }, "presentation": { "viewBox": "0 0 126 126", "path": "M110.25 6.563h-94.5a9.187 9.187 0 0 0-9.188 9.187v63a9.187 9.187 0 0 0 9.188 9.188h29.4l-16.905 25.41a3.935 3.935 0 0 0 1.05 5.25 4.26 4.26 0 0 0 2.205.629 3.826 3.826 0 0 0 3.255-1.732L54.6 87.728h4.462V115.5a3.936 3.936 0 1 0 7.876 0V87.937H71.4l19.845 29.768a3.833 3.833 0 0 0 3.255 1.733 4.261 4.261 0 0 0 2.205-.631 3.935 3.935 0 0 0 1.05-5.25L80.85 87.937h29.4a9.188 9.188 0 0 0 9.188-9.187v-63a9.187 9.187 0 0 0-9.188-9.188ZM42 68.25a5.25 5.25 0 1 1-10.5 0V52.5a5.25 5.25 0 1 1 10.5 0v15.75Zm26.25 0a5.25 5.25 0 1 1-10.5 0v-42a5.25 5.25 0 1 1 10.5 0v42Zm26.25 0a5.25 5.25 0 1 1-10.5 0V42a5.25 5.25 0 1 1 10.5 0v26.25Z", "properties": { "fill": "currentColor" } }, "priorityHigh": { "viewBox": "0 0 24 24", "path": "M12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM10 3h4v12h-4V3Z", "properties": { "fill": "currentColor" } }, "reactionNeutral": { "viewBox": "0 0 24 24", "path": "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0ZM5 9.07a2 2 0 1 1 3.999-.001A2 2 0 0 1 5 9.07Zm10.25 9.18h-6.5a1 1 0 0 1 0-2h6.5a1 1 0 0 1 0 2ZM17 11.07a2 2 0 1 1-.001-4.001A2 2 0 0 1 17 11.07Z", "properties": { "fill": "currentColor" } }, "reactionSad": { "viewBox": "0 0 24 24", "path": "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0ZM4.656 9.547a.703.703 0 1 1 1.33-.454 1.664 1.664 0 0 0 3.15 0 .703.703 0 1 1 1.33.456 3.07 3.07 0 0 1-5.81-.002Zm11.932 7.627a.703.703 0 0 1-.964-.244A4.238 4.238 0 0 0 12 14.87a4.24 4.24 0 0 0-3.619 2.051.703.703 0 1 1-1.206-.722A5.653 5.653 0 0 1 12 13.465a5.65 5.65 0 0 1 4.832 2.745.703.703 0 0 1-.244.964Zm2.76-7.625a3.07 3.07 0 0 1-5.81-.002.703.703 0 1 1 1.33-.454 1.664 1.664 0 0 0 3.15 0 .703.703 0 0 1 1.33.456Z", "properties": { "fill": "currentColor" } }, "reactionSmile": { "viewBox": "0 0 24 24", "path": "M20.485 3.515A11.922 11.922 0 0 0 12 0a11.922 11.922 0 0 0-8.485 3.515A11.922 11.922 0 0 0 0 12c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0 0 12 24c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0 0 24 12c0-3.205-1.248-6.219-3.515-8.485ZM4.52 9.74a2.966 2.966 0 0 1 2.96-2.962 2.966 2.966 0 0 1 2.963 2.963.703.703 0 1 1-1.407 0c0-.859-.698-1.557-1.556-1.557-.858 0-1.556.699-1.556 1.557a.703.703 0 0 1-1.406 0Zm14.536 4.753A7.494 7.494 0 0 1 12 19.48c-3.165 0-6-2.004-7.055-4.987a.703.703 0 1 1 1.326-.469A6.085 6.085 0 0 0 12 18.075a6.085 6.085 0 0 0 5.729-4.05.703.703 0 0 1 1.326.469Zm-.277-4.05a.703.703 0 0 1-.703-.703c0-.859-.698-1.557-1.556-1.557-.858 0-1.556.699-1.556 1.557a.703.703 0 1 1-1.407 0 2.966 2.966 0 0 1 2.963-2.963 2.966 2.966 0 0 1 2.962 2.963.703.703 0 0 1-.703.703Z", "properties": { "fill": "currentColor" } }, "removeCircle": { "viewBox": "0 0 18 18", "path": "M5.25 8.25v1.5h7.5v-1.5h-7.5ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5ZM9 15c-3.308 0-6-2.693-6-6 0-3.308 2.692-6 6-6 3.307 0 6 2.692 6 6 0 3.307-2.693 6-6 6Z", "properties": { "fill": "currentColor" } }, "screenShare": { "viewBox": "0 0 24 24", "path": "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2H0v2h24v-2h-4Zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74Z", "properties": { "fill": "currentColor" } }, "search": { "viewBox": "0 0 24 24", "path": "M16.125 10.875a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0Zm-1.157 4.888a6.375 6.375 0 1 1 .795-.796l3.572 3.573a.562.562 0 1 1-.795.795l-3.572-3.572Z", "properties": { "fill": "currentColor" } }, "send": { "viewBox": "0 0 15 14", "path": "M12.333.667H1.666C.933.667.333 1.267.333 2v8c0 .733.6 1.333 1.333 1.333h6V10h-6V3.333L7 6.667l5.333-3.334v3.334h1.333V2c0-.733-.6-1.333-1.333-1.333ZM7 5.333 1.666 2h10.667L7 5.333ZM11.666 8l2.667 2.667-2.667 2.666v-2H9V10h2.666V8Z", "properties": { "fill": "currentColor" } }, "setting2": { "viewBox": "0 0 16 16", "path": "M15.333 12.667h-1.775A2.329 2.329 0 0 0 11.333 11a2.33 2.33 0 0 0-2.224 1.667H.667a.667.667 0 0 0 0 1.333h8.442a2.329 2.329 0 0 0 2.224 1.667A2.33 2.33 0 0 0 13.558 14h1.775a.667.667 0 1 0 0-1.333Zm-4 1.666a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2Zm4-7H6.891a2.33 2.33 0 0 0-2.224-1.666 2.33 2.33 0 0 0-2.225 1.666H.667a.667.667 0 0 0 0 1.334h1.775a2.33 2.33 0 0 0 2.225 1.666A2.33 2.33 0 0 0 6.89 8.667h8.442a.666.666 0 1 0 0-1.334ZM4.667 9a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2Zm10.666-7h-1.775A2.33 2.33 0 0 0 11.333.333 2.33 2.33 0 0 0 9.11 2H.667a.667.667 0 0 0 0 1.333h8.442A2.33 2.33 0 0 0 11.333 5a2.33 2.33 0 0 0 2.225-1.667h1.775a.666.666 0 1 0 0-1.333Zm-4 1.667a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2Z", "properties": { "fill": "currentColor" } }, "settings": { "viewBox": "0 0 24 24", "path": "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94 0 .31.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58ZM12 15.6A3.61 3.61 0 0 1 8.4 12c0-1.98 1.62-3.6 3.6-3.6s3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6Z", "properties": { "fill": "currentColor" } }, "share": { "viewBox": "0 0 24 24", "path": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92Z", "properties": { "fill": "currentColor" } }, "show": { "viewBox": "0 0 16 10", "path": "M.063 5.243C.171 5.437 2.766 10 8 10s7.83-4.563 7.937-4.757a.5.5 0 0 0 0-.486C15.829 4.563 13.234 0 8 0S.17 4.563.063 4.757a.5.5 0 0 0 0 .486ZM8 9C4.018 9 1.683 5.9 1.088 5 1.681 4.096 4.006 1 8 1c3.982 0 6.317 3.1 6.912 4-.593.903-2.918 4-6.912 4Zm0-1C6.346 8 5 6.654 5 5s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3ZM6 5c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "currentColor" } }, "singleFamily": { "viewBox": "0 0 16 16", "path": "m15.731 7.284-2.424-2.425V2.058a.917.917 0 0 0-1.835 0v.967L9.667 1.219c-.893-.892-2.445-.89-3.335.002L.268 7.284A.918.918 0 0 0 1.566 8.58l6.062-6.063a.541.541 0 0 1 .742-.001l6.064 6.064a.915.915 0 0 0 1.298 0 .917.917 0 0 0 0-1.297Z M8.318 4.258a.45.45 0 0 0-.637 0L2.348 9.59a.451.451 0 0 0-.132.319v3.888c0 .913.74 1.652 1.653 1.652h2.64V11.36H9.49v4.09h2.64c.913 0 1.653-.74 1.653-1.653V9.91a.45.45 0 0 0-.132-.32L8.318 4.259Z", "properties": { "fill": "currentColor" } }, "sort": { "viewBox": "0 -960 960 960", "path": "M120-240v-80h240v80H120Zm0-200v-80h480v80H120Zm0-200v-80h720v80H120Z", "properties": { "fill": "currentColor" } }, "squareFoot": { "viewBox": "0 -960 960 960", "path": "M208-120q-37 0-62.5-25.5T120-208v-548q0-29 27-40.5t47 8.5l90 90-54 54 28 28 54-54 104 104-54 54 28 28 54-54 104 104-54 54 28 28 54-54 104 104-54 54 28 28 54-54 80 80q20 20 8.5 47T756-120H208Zm32-120h332L240-572v332Z", "properties": { "fill": "currentColor" } }, "star": { "viewBox": "0 -960 960 960", "path": "m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z", "properties": { "fill": "currentColor" } }, "suitcase": { "viewBox": "0 0 18 18", "path": "M12.938 4.688v10.875a.563.563 0 0 0 1.124 0V4.687a.563.563 0 0 0-1.124 0Zm-9 0v10.875a.563.563 0 0 0 1.124 0V4.687a.563.563 0 0 0-1.125 0ZM12 5.25c.31 0 .563-.252.563-.563v-.75c0-.538-.195-1.053-.533-1.433a1.82 1.82 0 0 0-1.364-.629H7.333a1.82 1.82 0 0 0-1.363.628c-.338.38-.532.896-.532 1.434v.75c0 .311.252.563.562.563h6Zm-.563-1.125H6.564v-.188c0-.257.087-.505.248-.686A.704.704 0 0 1 7.333 3h3.333c.198 0 .384.094.523.25.162.182.248.43.248.688v.187Zm5.626 2.063A2.066 2.066 0 0 0 15 4.124H3c-.547 0-1.072.218-1.459.604a2.066 2.066 0 0 0-.603 1.458v7.875c0 .547.217 1.072.603 1.46.387.386.912.603 1.459.603h12a2.066 2.066 0 0 0 2.063-2.063V6.189Zm-1.125 0v7.875A.939.939 0 0 1 15 15H3a.94.94 0 0 1-.938-.938V6.189A.94.94 0 0 1 3 5.25h12a.939.939 0 0 1 .938.938Z", "properties": { "fill": "currentColor" } }, "swapVert": { "viewBox": "0 0 24 24", "path": "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3ZM9 3 5 6.99h3V14h2V6.99h3L9 3Z", "properties": { "fill": "currentColor" } }, "timelapse": { "viewBox": "0 0 16 16", "path": "M10.827 5.174A3.983 3.983 0 0 0 8 4.001v4l-2.827 2.826a4.008 4.008 0 0 0 5.66 0 3.993 3.993 0 0 0-.006-5.653ZM8 1.334a6.67 6.67 0 0 0-6.667 6.667A6.669 6.669 0 0 0 8 14.667a6.669 6.669 0 0 0 6.667-6.666A6.67 6.67 0 0 0 8 1.334Zm0 12a5.332 5.332 0 0 1-5.333-5.333A5.332 5.332 0 0 1 8 2.667a5.332 5.332 0 0 1 5.334 5.334A5.332 5.332 0 0 1 8 13.334Z", "properties": { "fill": "currentColor" } }, "townhouses": { "viewBox": "0 0 16 16", "path": "M7.059 2.353a.47.47 0 0 0-.47-.47H3.293a.47.47 0 0 0-.47.47v2.823H.94V.941c0-.52.422-.941.941-.941H8a.94.94 0 0 1 .941.941v4.235H7.06V2.353ZM10.118 16v-2.823a.47.47 0 0 0-.47-.471H6.352a.47.47 0 0 0-.47.47V16H.47a.47.47 0 0 1-.47-.47V8.94h16v6.588a.47.47 0 0 1-.47.471h-5.412Zm-6.589-4.706v-.941a.47.47 0 0 0-.94 0v.941a.47.47 0 1 0 .94 0Zm3.295 0v-.941a.47.47 0 0 0-.942 0v.941a.47.47 0 1 0 .942 0Zm3.294 0v-.941a.47.47 0 1 0-.942 0v.941a.47.47 0 1 0 .942 0Zm3.294 0v-.941a.47.47 0 0 0-.941 0v.941a.47.47 0 0 0 .94 0Zm0 2.824v-.941a.47.47 0 0 0-.941 0v.94a.47.47 0 0 0 .94 0Zm-9.883 0v-.941a.47.47 0 1 0-.94 0v.94a.47.47 0 1 0 .94 0ZM.18 8l.812-1.622a.47.47 0 0 1 .42-.26h13.177c.179 0 .341.1.421.26L15.82 8H.18Zm3.586-5.176h2.353v2.352H3.765V2.824ZM6.824 16v-2.353h2.352V16H6.824Z", "properties": { "fill": "currentColor" } }, "trash": { "viewBox": "0 0 24 24", "path": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM8 9h8v10H8V9Zm7.5-5-1-1h-5l-1 1H5v2h14V4h-3.5Z", "properties": { "fill": "currentColor" } }, "trashSolid": { "viewBox": "0 0 24 24", "path": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12Zm2.46-7.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12ZM15.5 4l-1-1h-5l-1 1H5v2h14V4h-3.5Z", "properties": { "fill": "currentColor" } }, "twinHomes": { "viewBox": "0 0 16 16", "path": "M2.375 11.781h.938v1.875h-.938v-1.875ZM.031 14.594v.937c0 .26.21.469.469.469h7.031v-1.406h-7.5Zm5.157-4.219c0-.611-.392-1.133-.938-1.326v1.795h.938v-.47ZM3.781 4.906a.469.469 0 1 0 0-.937.469.469 0 0 0 0 .937Zm.469 6.875h.938v1.875H4.25v-1.875Zm-1.875-1.406v.469h.938V9.049a1.409 1.409 0 0 0-.938 1.326Z M4.137.163a.469.469 0 0 0-.711 0L.145 3.975a.469.469 0 0 0-.114.306v9.375h1.407v-3.281A2.346 2.346 0 0 1 3.78 8.031a2.346 2.346 0 0 1 2.344 2.344v3.281H7.53V4.107L4.137.163Zm-.356 5.68a1.407 1.407 0 0 1 0-2.812 1.407 1.407 0 0 1 0 2.813Zm8.907 5.938h.937v1.875h-.938v-1.875Zm3.281 2.813v.937c0 .26-.21.469-.469.469H8.469v-1.406h7.5Zm-5.156-4.219c0-.611.391-1.133.937-1.326v1.795h-.938v-.47Zm1.406-5.469a.469.469 0 1 0 0-.937.469.469 0 0 0 0 .937Zm-1.406 6.875h.937v1.875h-.938v-1.875Zm2.812-1.406v.469h-.938V9.049c.546.193.938.715.938 1.326Z M8.469 4.107v9.55h1.406v-3.282a2.346 2.346 0 0 1 2.344-2.344 2.346 2.346 0 0 1 2.344 2.344v3.281h1.406V4.281c0-.112-.04-.22-.114-.306L12.574.163a.469.469 0 0 0-.71 0L8.469 4.107Zm2.344.33c0-.775.63-1.406 1.406-1.406a1.408 1.408 0 0 1 0 2.813 1.408 1.408 0 0 1-1.406-1.407Z", "properties": { "fill": "currentColor" } }, "unarchive": { "viewBox": "0 0 12 12", "path": "M11.7 1.48 10.773.36C10.587.14 10.313 0 10 0H2a.968.968 0 0 0-.767.367L.307 1.48A1.323 1.323 0 0 0 0 2.333v8.334C0 11.4.593 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V2.333c0-.326-.113-.62-.3-.853ZM6 4.333 9.667 8H7.333v1.333H4.667V8H2.333L6 4.333Zm-4.587-3L1.96.667h8l.62.666H1.413Z", "properties": { "fill": "currentColor" } }, "upload": { "viewBox": "0 0 25 32", "path": "M12.668 10.645a.777.777 0 0 0-.564.246l-4.53 4.861a.77.77 0 0 0 .04 1.09.789.789 0 0 0 1.105-.037l3.184-3.426v8.441c0 .425.348.774.773.774a.776.776 0 0 0 .774-.774v-8.44l3.183 3.426a.768.768 0 0 0 1.09.037.77.77 0 0 0 .04-1.09l-4.53-4.861a.778.778 0 0 0-.565-.246zM6.315 25.12a.776.776 0 0 0-.773.774c0 .425.348.773.773.773h12.73a.776.776 0 0 0 .774-.773.778.778 0 0 0-.781-.774zM17.245.247A.774.774 0 0 0 16.687 0H4.205C1.9 0 0 1.894 0 4.197v23.606C0 30.106 1.901 32 4.205 32h16.943c2.303 0 4.205-1.894 4.205-4.197V9.059a.83.83 0 0 0-.225-.541zm.224 2.482 5.279 5.542h-3.432a1.84 1.84 0 0 1-1.847-1.84zm3.679 27.725H4.205c-1.445 0-2.66-1.198-2.66-2.651V4.197c0-1.445 1.207-2.651 2.66-2.651h11.718V6.43a3.381 3.381 0 0 0 3.393 3.385h4.49v17.987c0 1.453-1.205 2.651-2.658 2.651z", "properties": { "fill": "currentColor" } }, "verified": { "viewBox": "0 0 24 24", "path": "m23 12-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12Zm-12.91 4.72-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35Z", "properties": { "fill": "currentColor" } }, "viewCarousel": { "viewBox": "0 0 24 24", "path": "M7 19h10V4H7v15Zm-5-2h4V6H2v11ZM18 6v11h4V6h-4Z", "properties": { "fill": "currentColor" } }, "villa": { "viewBox": "0 0 16 16", "path": "M10.375 6.593h2.813V3.88l-2.813.703v2.009Z M15.4.018 5.962 2.831a.466.466 0 0 0-.318.58.466.466 0 0 0 .581.32L7.5 3.348v2.308H.469c-.26 0-.469.21-.469.468v2.813c0 .259.21.469.469.469H16V.468a.45.45 0 0 0-.188-.375.467.467 0 0 0-.412-.075ZM1.875 8.468H.937V6.593h.938v1.875Zm1.875 0h-.938V6.593h.938v1.875Zm1.875 0h-.938V6.593h.938v1.875Zm1.875 0h-.938V6.593H7.5v1.875Zm6.625-1.406c0 .259-.21.469-.469.469h-3.75a.468.468 0 0 1-.469-.47V4.219c0-.215.147-.402.356-.454l3.75-.938a.468.468 0 0 1 .582.455v3.78Zm-2.812 3.281h.937v5.656h-.938v-5.656Zm1.875 0h.937v5.656h-.938v-5.656ZM1.875 15.062H.469A.464.464 0 0 0 0 15.53c0 .263.206.469.469.469H3.75v-4.25c0-.26.21-.469.469-.469h3.75c.259 0 .468.21.468.469v4.25h1.938v-5.656h-8.5v4.719Zm13.188.937h.468A.464.464 0 0 0 16 15.53v-5.187h-.938v5.656Z M7.031 13.155H7.5v-.937H4.687v3.781H7.5v-1.906h-.469a.469.469 0 1 1 0-.938Z", "properties": { "fill": "currentColor" } }, "visibilityOff": { "viewBox": "0 0 24 24", "path": "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7ZM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27ZM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2Zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01Z", "properties": { "fill": "currentColor" } }, "visibility": { "viewBox": "0 0 24 24", "path": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5ZM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3Z", "properties": { "fill": "currentColor" } }, "warningFilled": { "viewBox": "0 0 24 24", "path": "m2.095 19.886 9.248-16.5a.753.753 0 0 1 1.313 0l9.248 16.5a.75.75 0 0 1-.656 1.116H2.752a.75.75 0 0 1-.657-1.116zm9.907-6.881a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75zm-.002-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z", "properties": { "fillRule": "nonzero" } }, "warningOutlined": { "viewBox": "0 0 24 24", "path": "m2.095 19.886 9.248-16.5a.753.753 0 0 1 1.313 0l9.248 16.5a.75.75 0 0 1-.656 1.116H2.752a.75.75 0 0 1-.657-1.116zm1.935-.384h15.939l-7.97-14.219zm7.972-6.497a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75zm-.002-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z", "properties": { "fillRule": "nonzero" } }, "world": { "viewBox": "0 0 24 24", "path": "M3.533 11.25a8.507 8.507 0 0 1 5.68-7.283 8.903 8.903 0 0 0-.6 1.207c-.664 1.613-1.085 3.741-1.16 6.076h-3.92ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 1.5c.261 0 .58.125.945.5.367.377.732.962 1.055 1.745.578 1.404.972 3.33 1.046 5.505H8.954c.074-2.175.468-4.101 1.046-5.505.323-.783.688-1.368 1.055-1.745.364-.375.684-.5.945-.5Zm4.547 7.75c-.075-2.335-.496-4.463-1.16-6.076a8.897 8.897 0 0 0-.6-1.207 8.507 8.507 0 0 1 5.68 7.283h-3.92Zm-1.501 1.5c-.074 2.175-.468 4.102-1.046 5.505-.323.784-.688 1.368-1.055 1.745-.364.375-.684.5-.945.5-.261 0-.58-.125-.945-.5-.367-.377-.732-.962-1.055-1.745-.578-1.403-.972-3.33-1.046-5.505h6.092Zm-.26 7.283c.222-.367.422-.773.6-1.207.665-1.613 1.086-3.741 1.16-6.076h3.921a8.507 8.507 0 0 1-5.68 7.283Zm-5.573 0a8.507 8.507 0 0 1-5.68-7.283h3.92c.075 2.335.496 4.463 1.16 6.076.179.434.379.84.6 1.207Z", "properties": { "fill": "currentColor" } } };
var Icon_generated_default = icons;

// src/components/atoms/Icon/Icon.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var SvgStyles = import_styled_components4.default.svg`
  ${boxStyle}
`;
function Icon({ name, size = 16, color: color2, onClick, fill: fill2 = "currentcolor", ...args }) {
  const icon = Icon_generated_default[name];
  return icon ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    SvgStyles,
    {
      ...args,
      color: color2,
      viewBox: icon.viewBox,
      w: size,
      h: size,
      fill: fill2,
      onClick: (e) => {
        if (onClick) {
          onClick(e);
        }
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("path", { d: icon.path, ...icon.properties })
    }
  ) : null;
}
var Icon_default = Icon;

// src/common/form/constants.ts
var FormErrorMessages = {
  EMAIL_BLANK: "Email is blank",
  EMAIL_INVALID: "Email is wrong format",
  PASSWORD_BLANK: "Password is blank",
  PASSWORD_INVALID: "Too weak. Must be at least 8 characters.",
  PASSWORD_WARNING: "Could be stronger",
  PASSWORD_VALID: "Strong password",
  FIRST_NAME_BLANK: "First name is blank",
  LAST_NAME_BLANK: "Last name is blank",
  MAX_CHARACTERS: "Use maximum %n characters",
  EMAIL_NOT_UNIQUE: "Email already in use",
  EMAIL_DOMAIN_NOT_UNIQUE: "Email domain already exist in DB"
};
var FormErrorTypes = /* @__PURE__ */ ((FormErrorTypes2) => {
  FormErrorTypes2["Info"] = "info";
  FormErrorTypes2["Valid"] = "valid";
  FormErrorTypes2["Invalid"] = "invalid";
  return FormErrorTypes2;
})(FormErrorTypes || {});

// src/components/atoms/Form/Input/Input.styles.ts
var stateStyle = import_styled_components5.css`
  ${({ $errorType }) => {
  const states = {
    ["info" /* Info */]: import_styled_components5.css`
        border: 1px solid ${({ theme }) => theme.colors.n70};
      `,
    ["valid" /* Valid */]: import_styled_components5.css`
        border: 1px solid ${({ theme }) => theme.colors.g20};
      `,
    ["invalid" /* Invalid */]: import_styled_components5.css`
        border: 1px solid ${({ theme }) => theme.colors.r20};
      `
  };
  return $errorType ? states[$errorType] : "";
}}
`;
var inputVariationStyles = import_styled_components5.css`
  ${({ inputVariation = "default" }) => {
  const states = {
    default: import_styled_components5.css`
        border: 1px solid ${({ theme }) => theme.colors.n60};
        &:hover {
          border: 1px solid ${({ theme }) => theme.colors.b40};
          box-shadow: ${({ theme }) => theme.shadows.shadow3};
        }
        &:focus {
          outline-width: 0;
          border: 1px solid ${({ theme }) => theme.colors.n40};
          box-shadow: unset;
        }
        &:disabled {
          background-color: ${({ theme }) => theme.colors.n20};
          border: 1px solid ${({ theme }) => theme.colors.n70};
          color: ${({ theme }) => theme.colors.n60};
        }
      `,
    outline: import_styled_components5.css`
        outline: none;
        border: none;
      `
  };
  return inputVariation ? states[inputVariation] : "";
}}
`;
var IconStyle = (0, import_styled_components5.default)(Icon_default)`
  position: absolute;
  cursor: ${({ isPointer }) => isPointer ? "pointer" : "inherit"};
  top: 0;
  bottom: 0;
  margin: auto;
  left: 10px;
`;
var IconRightStyle = (0, import_styled_components5.default)(IconStyle)`
  right: 12px;
  left: auto;
`;
var BoxStyle = (0, import_styled_components5.default)(Box_default)`
  position: relative;
`;
var InputStyle = import_styled_components5.default.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid transparent;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.black};
  ${({ theme }) => `border-radius:${2 * theme.space}px;`}
  background-color: ${({ theme }) => theme.colors.white};
  ${inputVariationStyles}
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${boxStyle}
  ${textStyle}
  font-size: 16px; /* Prevent iOS Safari zoom on focus */
  ${stateStyle}
  ${({ css: css33 }) => css33}
`;

// src/common/context/viewerContext/viewerContext.tsx
var import_react = require("react");

// src/common/localStorage/viewer.ts
var viewer_exports = {};
__export(viewer_exports, {
  getAccessToken: () => getAccessToken,
  getPortfolioPassword: () => getPortfolioPassword,
  getRefreshToken: () => getRefreshToken,
  getRefreshTokenExpiry: () => getRefreshTokenExpiry,
  setAccessToken: () => setAccessToken,
  setPortfolioPassword: () => setPortfolioPassword,
  setRefreshToken: () => setRefreshToken,
  setRefreshTokenExpiry: () => setRefreshTokenExpiry
});

// src/common/localStorage/constants.ts
var ACCESS_TOKEN = "ACCESS_TOKEN";
var REFRESH_TOKEN = "REFRESH_TOKEN";
var REFRESH_TOKEN_EXPIRY = "REFRESH_TOKEN_EXPIRY";
var PORTFOLIO_PASSWORD = "PORTFOLIO_PASSWORD";
var TABLE_PROPERTIES_FILTER = "TABLE_PROPERTIES_FILTER";
var TABLE_PROPERTIES_PAGINATION = "TABLE_PROPERTIES_PAGINATION";
var TABLE_PROPERTIES_SORT = "TABLE_PROPERTIES_SORT";
var TABLE_PROPERTIES_SEARCH = "TABLE_PROPERTIES_SEARCH";
var TABLE_BROKERS_FILTER = "TABLE_BROKERS_FILTER";
var TABLE_BROKERS_PAGINATION = "TABLE_BROKERS_PAGINATION";
var TABLE_ORGANIZATIONS_PAGINATION = "TABLE_ORGANIZATIONS_PAGINATION";
var TABLE_ORGANIZATIONS_PROPERTIES_PAGINATION = "TABLE_ORGANIZATIONS_PROPERTIES_PAGINATION";
var TABLE_ORGANIZATIONS_PROPERTIES_FILTER = "TABLE_ORGANIZATIONS_PROPERTIES_FILTER";
var TABLE_MARKET_AREA_FILTER = "TABLE_MARKET_AREA_FILTER";
var TABLE_MARKET_AREA_PAGINATION = "TABLE_MARKET_AREA_PAGINATION";
var API_REFERRAL_CODE = "API_REFERRAL_CODE";
var API_FIRST_ACCESS = "API_FIRST_ACCESS";
var PROPERTY_TRANSACTION_TYPE_USER_DEFAULT = "PROPERTY_TRANSACTION_TYPE_USER_DEFAULT";
var SIDEBAR_PINNED = "SIDEBAR_PINNED";
var WELCOME_DISCOVERY_MODAL_PENDING = "WELCOME_DISCOVERY_MODAL_PENDING";
var SIGNUP_CONVERSION_TRACKED = "SIGNUP_CONVERSION_TRACKED";

// src/common/localStorage/viewer.ts
var setAccessToken = (value) => localStorage.setItem(ACCESS_TOKEN, value);
var setRefreshToken = (value) => localStorage.setItem(REFRESH_TOKEN, value);
var setRefreshTokenExpiry = (value) => localStorage.setItem(REFRESH_TOKEN_EXPIRY, value);
var setPortfolioPassword = (value) => localStorage.setItem(PORTFOLIO_PASSWORD, value);
var getAccessToken = () => localStorage.getItem(ACCESS_TOKEN);
var getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);
var getRefreshTokenExpiry = () => localStorage.getItem(REFRESH_TOKEN_EXPIRY);
var getPortfolioPassword = () => localStorage.getItem(PORTFOLIO_PASSWORD);

// src/common/context/viewerContext/viewerContext.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var defaultContextValue = {
  account: null,
  profile: null,
  broker: null,
  developer: null,
  subscription: null,
  userHasTrialed: false,
  canRedirect: true,
  tokens: {
    accessToken: getAccessToken() || "",
    refreshToken: getRefreshToken() || "",
    refreshTokenExpiry: getRefreshTokenExpiry() || ""
  }
};
var ViewerContext = (0, import_react.createContext)(defaultContextValue);
function ViewerProvider({ children }) {
  const [account, setAccount] = (0, import_react.useState)(
    defaultContextValue.account
  );
  const [subscription, setSubscription] = (0, import_react.useState)(defaultContextValue.subscription);
  const [profile, setProfile] = (0, import_react.useState)(defaultContextValue.profile);
  const [broker, setBroker] = (0, import_react.useState)(defaultContextValue.broker);
  const [tokens, setTokens] = (0, import_react.useState)(defaultContextValue.tokens);
  const [canRedirect, setCanRedirect] = (0, import_react.useState)(
    defaultContextValue.canRedirect
  );
  const [userHasTrialed, setUserHasTrialed] = (0, import_react.useState)(
    defaultContextValue.userHasTrialed
  );
  const [developer, setDeveloper] = (0, import_react.useState)(defaultContextValue.developer);
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    ViewerContext.Provider,
    {
      value: {
        account,
        profile,
        broker,
        tokens,
        subscription,
        canRedirect,
        userHasTrialed,
        developer,
        setAccount,
        setProfile,
        setBroker,
        setTokens,
        setSubscription,
        setCanRedirect,
        setUserHasTrialed,
        setDeveloper
      },
      children
    }
  );
}

// src/common/context/dropdownContext/dropdownContext.tsx
var import_react2 = require("react");
var import_lodash7 = require("lodash");
var import_dash_common9 = require("dash-common");
var import_jsx_runtime4 = require("react/jsx-runtime");
var defaultContextValue2 = {
  isOpen: false,
  setIsOpen: () => {
  },
  setItems: () => {
  },
  items: [],
  config: {
    id: "",
    variant: "light",
    trigger: "click",
    optionsStyle: {}
  },
  setConfig: () => {
  },
  children: null,
  setChildren: () => {
  },
  refOptions: null,
  handlePosition: () => {
  }
};
var DropdownContext = (0, import_react2.createContext)(defaultContextValue2);
function DropdownProvider({ children: providerChildren }) {
  const refOptions = (0, import_react2.useRef)(null);
  const [isOpen, setIsOpen] = (0, import_react2.useState)(defaultContextValue2.isOpen);
  const [config, setConfig] = (0, import_react2.useState)(defaultContextValue2.config);
  const [items, setItems] = (0, import_react2.useState)(defaultContextValue2.items);
  const [children, setChildren] = (0, import_react2.useState)(defaultContextValue2.children);
  const handlePosition = ({
    rectBox,
    rectOptions,
    placement,
    placementHorizontal,
    newItems = [],
    newChildren = null
  }) => {
    const element = refOptions.current;
    const isScreenHeightOverflow = placement === "auto" && rectBox.top + rectBox.height + rectOptions.height + 10 > window.innerHeight;
    if ((0, import_dash_common9.or)(placement === "top", isScreenHeightOverflow)) {
      element.style.top = rectBox.top - rectOptions.height + window.scrollY + "px";
    } else if ((0, import_dash_common9.or)(placement === "bottom", placement === "auto")) {
      element.style.top = rectBox.top + rectBox.height + window.scrollY + "px";
    }
    if (placementHorizontal === "right") {
      element.style.left = rectBox.left + window.scrollX + "px";
    }
    if (placementHorizontal === "left") {
      element.style.left = rectBox.left + rectBox.width - rectOptions.width + window.scrollX + "px";
    }
    if (newItems.length > 0) {
      setItems(newItems);
    }
    if (!(0, import_lodash7.isNil)(newChildren)) {
      setChildren(() => newChildren);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    DropdownContext.Provider,
    {
      value: {
        isOpen,
        setIsOpen,
        handlePosition,
        refOptions,
        items,
        setItems,
        config,
        setConfig,
        children,
        setChildren
      },
      children: providerChildren
    }
  );
}

// src/common/context/pagination-context/pagination-context.tsx
var import_react3 = require("react");

// src/common/localStorage/portfolio.ts
var portfolio_exports = {};
__export(portfolio_exports, {
  getPortfolioPassword: () => getPortfolioPassword2,
  setPortfolioPassword: () => setPortfolioPassword2
});
var setPortfolioPassword2 = (value) => localStorage.setItem(PORTFOLIO_PASSWORD, value);
var getPortfolioPassword2 = () => localStorage.getItem(PORTFOLIO_PASSWORD);

// src/common/localStorage/table.tsx
var table_exports = {};
__export(table_exports, {
  getTableFilter: () => getTableFilter,
  getTablePagination: () => getTablePagination,
  getTableSearch: () => getTableSearch,
  getTableSort: () => getTableSort,
  setTableFilter: () => setTableFilter,
  setTablePagination: () => setTablePagination,
  setTableSearch: () => setTableSearch,
  setTableSort: () => setTableSort
});

// src/common/localStorage/table.interfaces.tsx
var LocalCashTables = /* @__PURE__ */ ((LocalCashTables5) => {
  LocalCashTables5["PROPERTIES"] = "PROPERTIES";
  LocalCashTables5["BROKERS"] = "BROKERS";
  LocalCashTables5["ORGANIZATIONS"] = "ORGANIZATIONS";
  LocalCashTables5["ORGANIZATIONS_PROPERTIES"] = "ORGANIZATIONS_PROPERTIES";
  LocalCashTables5["MARKET_AREA"] = "MARKET_AREA";
  return LocalCashTables5;
})(LocalCashTables || {});

// src/common/localStorage/table.tsx
var PaginationMap = {
  ["PROPERTIES" /* PROPERTIES */]: TABLE_PROPERTIES_PAGINATION,
  ["BROKERS" /* BROKERS */]: TABLE_BROKERS_PAGINATION,
  ["ORGANIZATIONS" /* ORGANIZATIONS */]: TABLE_ORGANIZATIONS_PAGINATION,
  ["ORGANIZATIONS_PROPERTIES" /* ORGANIZATIONS_PROPERTIES */]: TABLE_ORGANIZATIONS_PROPERTIES_PAGINATION,
  ["MARKET_AREA" /* MARKET_AREA */]: TABLE_MARKET_AREA_PAGINATION
};
var FilterMap = {
  ["PROPERTIES" /* PROPERTIES */]: TABLE_PROPERTIES_FILTER,
  ["BROKERS" /* BROKERS */]: TABLE_BROKERS_FILTER,
  ["ORGANIZATIONS_PROPERTIES" /* ORGANIZATIONS_PROPERTIES */]: TABLE_ORGANIZATIONS_PROPERTIES_FILTER,
  ["MARKET_AREA" /* MARKET_AREA */]: TABLE_MARKET_AREA_FILTER
};
var SortMap = {
  ["PROPERTIES" /* PROPERTIES */]: TABLE_PROPERTIES_SORT
};
var SearchMap = {
  ["PROPERTIES" /* PROPERTIES */]: TABLE_PROPERTIES_SEARCH
};
var setTableFilter = (tableName, value) => {
  const key = FilterMap[tableName];
  if (key) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
var setTablePagination = (tableName, value) => {
  const key = PaginationMap[tableName];
  if (key) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
var getTableFilter = (tableName) => {
  const value = localStorage.getItem(FilterMap[tableName]);
  return value || "";
};
var getTablePagination = (tableName) => {
  const value = localStorage.getItem(PaginationMap[tableName]);
  return value || "";
};
var setTableSort = (tableName, value) => {
  const key = SortMap[tableName];
  if (key) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
var getTableSort = (tableName) => {
  const value = localStorage.getItem(SortMap[tableName]);
  return value || "";
};
var setTableSearch = (tableName, value) => {
  const key = SearchMap[tableName];
  if (key) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
var getTableSearch = (tableName) => {
  const value = localStorage.getItem(SearchMap[tableName]);
  return value || "";
};

// src/common/localStorage/general.ts
var general_exports = {};
__export(general_exports, {
  getSidebarPinned: () => getSidebarPinned,
  getSignupConversionTracked: () => getSignupConversionTracked,
  getTransactionTypeUserDefault: () => getTransactionTypeUserDefault,
  getWelcomeDiscoveryModalPending: () => getWelcomeDiscoveryModalPending,
  setSidebarPinned: () => setSidebarPinned,
  setSignupConversionTracked: () => setSignupConversionTracked,
  setTransactionTypeUserDefault: () => setTransactionTypeUserDefault,
  setWelcomeDiscoveryModalPending: () => setWelcomeDiscoveryModalPending
});
var setTransactionTypeUserDefault = (value) => localStorage.setItem(PROPERTY_TRANSACTION_TYPE_USER_DEFAULT, value);
var getTransactionTypeUserDefault = () => localStorage.getItem(PROPERTY_TRANSACTION_TYPE_USER_DEFAULT);
var setSidebarPinned = (value) => localStorage.setItem(SIDEBAR_PINNED, String(value));
var getSidebarPinned = () => localStorage.getItem(SIDEBAR_PINNED) === "true";
var setWelcomeDiscoveryModalPending = (value) => localStorage.setItem(WELCOME_DISCOVERY_MODAL_PENDING, String(value));
var getWelcomeDiscoveryModalPending = () => localStorage.getItem(WELCOME_DISCOVERY_MODAL_PENDING) === "true";
var setSignupConversionTracked = (accountId) => localStorage.setItem(`${SIGNUP_CONVERSION_TRACKED}_${accountId}`, "true");
var getSignupConversionTracked = (accountId) => localStorage.getItem(`${SIGNUP_CONVERSION_TRACKED}_${accountId}`) === "true";

// src/common/localStorage/api.ts
var api_exports = {};
__export(api_exports, {
  getApiFirstAccess: () => getApiFirstAccess,
  getApiReferralCode: () => getApiReferralCode,
  setApiFirstAccess: () => setApiFirstAccess,
  setApiReferralCode: () => setApiReferralCode
});
var setApiReferralCode = (value) => localStorage.setItem(API_REFERRAL_CODE, value);
var getApiReferralCode = () => localStorage.getItem(API_REFERRAL_CODE);
var setApiFirstAccess = (value) => localStorage.setItem(API_FIRST_ACCESS, value);
var getApiFirstAccess = () => localStorage.getItem(API_FIRST_ACCESS);

// src/common/localStorage/index.ts
var localStorage2 = {
  ...viewer_exports,
  ...portfolio_exports,
  ...table_exports,
  ...general_exports,
  ...api_exports
};

// src/common/context/pagination-context/pagination-context.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var defaultContextValue3 = {
  total: 0,
  perPage: 10,
  currentPage: 0,
  buttons: []
};
var PaginationContext = (0, import_react3.createContext)({
  state: defaultContextValue3,
  goToPage: () => null,
  setTotal: () => null,
  setPerPage: () => null,
  getRefetchProps: () => ({ skip: 0, limit: defaultContextValue3.perPage }),
  resetPagination: () => null,
  setButtons: () => null
});
var getRefetchProps = (state) => ({
  skip: state.currentPage * state.perPage,
  limit: state.perPage
});
function PaginationProvider({
  children,
  perPage,
  storageTableName
}) {
  const defaultContext = storageTableName && localStorage2.getTablePagination(storageTableName) && JSON.parse(localStorage2.getTablePagination(storageTableName));
  const [state, setState] = (0, import_react3.useState)(
    defaultContext ? defaultContext : {
      ...defaultContextValue3,
      perPage: perPage || defaultContextValue3.perPage
    }
  );
  const goToPage = (index2) => {
    setState((currentState) => ({
      ...currentState,
      currentPage: index2
    }));
  };
  const setTotal = (total) => {
    setState((currentState) => ({
      ...currentState,
      total
    }));
  };
  const setPerPage = (perPage2) => {
    setState((currentState) => ({
      ...currentState,
      perPage: perPage2,
      currentPage: 0
    }));
  };
  const resetPagination = (total) => {
    setState((currentState) => ({
      ...defaultContextValue3,
      total: total || currentState.total,
      perPage: currentState.perPage
    }));
  };
  const setButtons = (buttons) => {
    setState((currentState) => ({
      ...currentState,
      buttons
    }));
  };
  (0, import_react3.useEffect)(() => {
    if (storageTableName) {
      localStorage2.setTablePagination(storageTableName, state);
    }
  }, [state]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    PaginationContext.Provider,
    {
      value: {
        state,
        goToPage,
        setTotal,
        setPerPage,
        getRefetchProps,
        resetPagination,
        setButtons
      },
      children
    }
  );
}

// src/common/context/pagination-context/flat-pagination-context.tsx
var import_react4 = require("react");
var import_jsx_runtime6 = require("react/jsx-runtime");
var defaultContextValue4 = {
  perPage: 12
};
var FlatPaginationContext = (0, import_react4.createContext)({
  state: defaultContextValue4,
  setStartingAfter: () => null,
  setEndingBefore: () => null,
  getRefetchProps: () => ({ limit: defaultContextValue4.perPage }),
  resetPagination: () => null
});
var getRefetchProps2 = ({
  perPage,
  ...state
}) => ({ limit: perPage, ...state });
function FlatPaginationProvider({ children }) {
  const [state, setState] = (0, import_react4.useState)(defaultContextValue4);
  const setStartingAfter = (startingAfter) => setState((currentState) => ({
    perPage: currentState.perPage,
    startingAfter
  }));
  const setEndingBefore = (endingBefore) => setState((currentState) => ({
    perPage: currentState.perPage,
    endingBefore
  }));
  const resetPagination = () => setState((currentState) => ({ perPage: currentState.perPage }));
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    FlatPaginationContext.Provider,
    {
      value: { state, setStartingAfter, setEndingBefore, resetPagination, getRefetchProps: getRefetchProps2 },
      children
    }
  );
}

// src/common/context/alertsContext/alertsContext.tsx
var import_react5 = require("react");

// src/common/context/alertsContext/alertsContext.interfaces.tsx
var Alerts = /* @__PURE__ */ ((Alerts2) => {
  Alerts2["ResetPasswordEmailsSent"] = "ResetPasswordEmailsSent";
  Alerts2["PasswordReset"] = "PasswordReset";
  Alerts2["ChangesSaved"] = "ChangesSaved";
  return Alerts2;
})(Alerts || {});

// src/common/context/alertsContext/alertsContext.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var defaultContextValue5 = {
  state: {
    ["ResetPasswordEmailsSent" /* ResetPasswordEmailsSent */]: false,
    ["PasswordReset" /* PasswordReset */]: false,
    ["ChangesSaved" /* ChangesSaved */]: false
  },
  toggleAlert: () => null
};
var AlertsContext = (0, import_react5.createContext)(defaultContextValue5);
function AlertsProvider({ children }) {
  const [state, setState] = (0, import_react5.useState)(
    defaultContextValue5.state
  );
  const toggleAlert = (type, value) => {
    setState({
      ...state,
      [type]: value
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(AlertsContext.Provider, { value: { state, toggleAlert }, children });
}

// src/common/context/sortContext/sortContext.tsx
var import_react6 = require("react");
var import_jsx_runtime8 = require("react/jsx-runtime");
var defaultContextValue6 = {
  fieldName: "",
  sortOrder: 0
};
var SortContext = (0, import_react6.createContext)({
  state: defaultContextValue6,
  setSortState: () => null
});
function SortProvider({
  children,
  defaultContext,
  storageTableName
}) {
  const persisted = storageTableName && localStorage2.getTableSort(storageTableName) && JSON.parse(localStorage2.getTableSort(storageTableName));
  const [state, setState] = (0, import_react6.useState)(
    persisted || defaultContext || defaultContextValue6
  );
  const setSortState = (newState) => {
    setState(newState);
  };
  (0, import_react6.useEffect)(() => {
    if (storageTableName) {
      localStorage2.setTableSort(storageTableName, state);
    }
  }, [state]);
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
    SortContext.Provider,
    {
      value: { state, setSortState },
      children
    }
  );
}

// src/common/context/searchContext/searchContext.tsx
var import_react7 = require("react");
var import_use_debounce = require("use-debounce");
var import_jsx_runtime9 = require("react/jsx-runtime");
var SearchContext = (0, import_react7.createContext)({
  searchSlug: "",
  setSearchSlug: () => null
});
function SearchProvider({
  children,
  delay = 300,
  storageTableName
}) {
  const persisted = storageTableName && localStorage2.getTableSearch(storageTableName) && JSON.parse(localStorage2.getTableSearch(storageTableName));
  const [text, setText] = (0, import_react7.useState)(persisted || "");
  const [value] = (0, import_use_debounce.useDebounce)(text, delay);
  const setSearchSlug = (0, import_react7.useCallback)((next) => {
    setText(next);
  }, []);
  (0, import_react7.useEffect)(() => {
    if (storageTableName) {
      localStorage2.setTableSearch(storageTableName, value);
    }
  }, [value]);
  const contextValue = (0, import_react7.useMemo)(
    () => ({ searchSlug: value, setSearchSlug }),
    [value, setSearchSlug]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(SearchContext.Provider, { value: contextValue, children });
}

// src/common/context/filterContext/filterContext.tsx
var import_react8 = require("react");
var import_jsx_runtime10 = require("react/jsx-runtime");
var FilterContext = (0, import_react8.createContext)({
  state: {},
  setFilterState: () => null,
  resetFilterState: () => null
});
function FilterProvider({ children }) {
  const [state, setState] = (0, import_react8.useState)({});
  const setFilterState = (key, value) => {
    setState((currentState) => ({
      ...currentState,
      [key]: value
    }));
  };
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(FilterContext.Provider, { value: { state, setFilterState, resetFilterState: () => setState({}) }, children });
}

// src/common/context/formContext/formContext.tsx
var import_react19 = require("react");

// src/common/hooks/useFormValidation/useFormValidation.ts
var import_react9 = require("react");
var useFormValidation = (fieldsList) => {
  const getErrorFields = () => fieldsList.reduce((obj, key) => ({ ...obj, [key]: null }), {});
  const [errors, setErrors] = (0, import_react9.useState)(getErrorFields());
  const [isValid, setIsValid] = (0, import_react9.useState)(false);
  const [isSetterCalls, setIsSetterCalls] = (0, import_react9.useState)(false);
  const setters = fieldsList.map((key) => (value) => {
    setIsSetterCalls(true);
    setErrors((currentState) => ({
      ...currentState,
      [key]: value
    }));
  });
  (0, import_react9.useEffect)(() => {
    if (isSetterCalls) {
      setIsValid(!fieldsList.find((key) => Boolean(errors[key]?.type === "invalid" /* Invalid */)));
    }
  }, [errors]);
  const resetFormErrors = () => {
    setIsSetterCalls(false);
    setErrors(getErrorFields());
  };
  return [errors, isValid, setters, [resetFormErrors]];
};
var useFormState = (fieldsList, defaultValue) => {
  const [defaultValues, setDefaultValues] = (0, import_react9.useState)(defaultValue || {});
  const getFormFields = () => fieldsList.reduce(
    (obj, key) => ({ ...obj, [key]: defaultValues && defaultValues[key] !== void 0 ? defaultValues[key] : null }),
    {}
  );
  const [formState, setFormState] = (0, import_react9.useState)({
    isLoading: false,
    errorSlug: "",
    ...getFormFields()
  });
  const setters = fieldsList.map((key) => (value) => {
    setFormState((currentState) => ({ ...currentState, [key]: value }));
  });
  const onSubmit = () => {
    setFormState((currentState) => ({ ...currentState, isLoading: true, errorSlug: "" }));
  };
  const onError = (message) => {
    setFormState((currentState) => ({ ...currentState, isLoading: false, errorSlug: message || "" }));
  };
  const onSuccess = () => {
    setFormState((currentState) => ({ ...currentState, isLoading: false, errorSlug: "" }));
  };
  const setFormValues = (formValue) => {
    setFormState((currentState) => ({ ...currentState, ...formValue }));
  };
  const setDefaultFormValues = (formValues) => {
    setDefaultValues(formValues);
    setFormValues(formValues);
  };
  const resetForm = () => {
    setFormState({
      isLoading: false,
      errorSlug: "",
      ...getFormFields()
    });
  };
  return [
    formState,
    setters,
    [onSubmit, onError, onSuccess, setFormValues, setDefaultFormValues, resetForm]
  ];
};

// src/common/hooks/useOnClickOutside/useOnClickOutside.ts
var import_react10 = require("react");
function useOnClickOutside(ref, handler, disablePortalTarget) {
  (0, import_react10.useEffect)(
    () => {
      const listener = (event) => {
        if ((!ref.current || ref.current.contains(event.target)) && !disablePortalTarget) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}

// src/common/hooks/useIsVisible/useIsVisible.ts
var import_react11 = require("react");
function useIsVisible(ref, rootMargin) {
  const [isIntersecting, setIntersecting] = (0, import_react11.useState)(false);
  (0, import_react11.useEffect)(() => {
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), {
      rootMargin
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return isIntersecting;
}

// src/common/hooks/useServerResponseTranslation/useServerResponseTranslation.ts
var import_react_i18next2 = require("react-i18next");
var useServerResponseTranslation = () => {
  const { t, i18n: i18nErrorSlugs } = (0, import_react_i18next2.useTranslation)(["forms", "common"]);
  const translateErrorMessage = (error, extralFields) => t(
    [
      ...(extralFields || []).map((key) => `${key}:${error.message}`),
      `common:serverErrors:${error.message}`,
      `common:brokerPortalServerErrors:${error.message}`
    ].find((key) => i18nErrorSlugs.exists(key)) || "common:serverMessages:unknown"
  );
  return translateErrorMessage;
};

// src/common/hooks/useGoogleApiLoader/useGoogleApiLoader.ts
var import_api = require("@react-google-maps/api");
var libraries = ["places", "drawing"];
var id = "google-map-script";
function useGoogleApiLoader() {
  const { isLoaded } = (0, import_api.useJsApiLoader)({
    id,
    googleMapsApiKey: process.env.REACT_APP_GOOGLE || "",
    // @ts-ignore
    libraries
  });
  return isLoaded;
}

// src/common/hooks/useScreenResolution/useScreenResolution.ts
var import_react12 = require("react");
var import_use_debounce2 = require("use-debounce");
var import_styled_components6 = require("styled-components");
var useScreenResolution = () => {
  const theme = (0, import_styled_components6.useTheme)();
  const [width, setWidth] = (0, import_react12.useState)(window.innerWidth);
  const onScreenResize = (0, import_use_debounce2.useDebouncedCallback)(() => {
    setWidth(document.documentElement.clientWidth);
  }, 100);
  (0, import_react12.useEffect)(() => {
    window.addEventListener("resize", onScreenResize, true);
    return () => window.removeEventListener("resize", onScreenResize, true);
  }, []);
  const devices = (0, import_react12.useMemo)(
    () => ({
      isMobile: width < theme.breakpoints.md,
      isTablet: width >= theme.breakpoints.md && width <= theme.breakpoints.lg,
      isLaptop: width > theme.breakpoints.lg && width <= theme.breakpoints.xl,
      isDesktop: width > theme.breakpoints.xl
    }),
    [width]
  );
  return { width, devices };
};

// src/common/hooks/useFromNow/useFromNow.ts
var import_react_i18next3 = require("react-i18next");
var import_moment2 = __toESM(require("moment"));
function useFromNow(settings) {
  const { t } = (0, import_react_i18next3.useTranslation)(["common"]);
  const fromNow = (date) => {
    const nowMoment = (0, import_moment2.default)();
    const pastMoment = (0, import_moment2.default)(date);
    const year = nowMoment.year() - pastMoment.year();
    const month = nowMoment.month() - pastMoment.month();
    const day = nowMoment.day() - pastMoment.day();
    const hour = nowMoment.hour() - pastMoment.hour();
    const minute = nowMoment.minute() - pastMoment.minute();
    const group = settings.short ? "updatedAgoShort" : "updatedAgo";
    const getLabel = (count, key) => t(`common:moments.${group}.${key}`, { count });
    if (year > 0) {
      return getLabel(year, "year");
    }
    if (month > 0) {
      return getLabel(month, "month");
    }
    if (day > 0) {
      return getLabel(day, "day");
    }
    if (hour > 0) {
      return getLabel(hour, "hour");
    }
    if (minute > 0) {
      return getLabel(minute, "minute");
    }
    return t("common:moments.updatedJustNow");
  };
  return fromNow;
}

// src/common/hooks/usePropertyUpdatedAgo/usePropertyUpdatedAgo.ts
var import_react_i18next4 = require("react-i18next");
var MS_IN_DAY = 24 * 60 * 60 * 1e3;
var MONTHS_IN_YEAR = 12;
var monthsBetween = (past, now) => {
  const months = (now.getFullYear() - past.getFullYear()) * MONTHS_IN_YEAR + (now.getMonth() - past.getMonth());
  return now.getDate() < past.getDate() ? months - 1 : months;
};
function usePropertyUpdatedAgo(date) {
  const { t } = (0, import_react_i18next4.useTranslation)(["pages"]);
  const past = date ? new Date(date) : null;
  if (!past || Number.isNaN(past.getTime())) {
    return t("pages:propertyPreviewPage.unknownDateLabel");
  }
  const now = /* @__PURE__ */ new Date();
  const days = Math.floor((now.getTime() - past.getTime()) / MS_IN_DAY);
  if (days < 1) {
    return t("pages:propertyPage.today");
  }
  const months = monthsBetween(past, now);
  if (months < 1) {
    return t("pages:propertyPage.daysAgo", { count: days, days });
  }
  if (months < MONTHS_IN_YEAR) {
    return t("pages:propertyPage.monthsAgo", { count: months, months });
  }
  const years = Math.floor(months / MONTHS_IN_YEAR);
  return t("pages:propertyPage.yearsAgo", { count: years, years });
}

// src/common/hooks/use-async-state/use-async-state.ts
var import_react13 = require("react");
function useAsyncState(initialState) {
  const [state, setState] = (0, import_react13.useState)(initialState);
  const resolveState = (0, import_react13.useRef)();
  const isMounted = (0, import_react13.useRef)(false);
  (0, import_react13.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  (0, import_react13.useEffect)(() => {
    if (resolveState.current) {
      resolveState.current(state);
    }
  }, [state]);
  const setAsyncState = (0, import_react13.useCallback)(
    (newState) => new Promise((resolve2) => {
      if (isMounted.current) {
        resolveState.current = resolve2;
        setState(newState);
      }
    }),
    []
  );
  return [state, setAsyncState, setState];
}

// src/common/hooks/useCheckIfSubscriptionFeatureActiveBroker/useCheckIfSubscriptionFeatureActiveBroker.ts
var import_react14 = require("react");
var import_dash_common10 = require("dash-common");
var useCheckIfSubscriptionFeatureActiveBroker = (features = []) => {
  const { subscription, broker } = (0, import_react14.useContext)(ViewerContext);
  const { toggleModal, setPayload } = (0, import_react14.useContext)(ModalContext);
  const isDemo = broker?.subscriptionType === import_dash_common10.BrokerSubscriptionTypesEnum.DEMO;
  const isSubscriptionActive = isDemo || subscription && import_dash_common10.SUBSCRIPTION_ACTIVE_STATUSES.includes(subscription.status);
  return {
    checkFeatureAccess: ({ disableModal } = {}) => {
      const isActive = isDemo || (0, import_dash_common10.checkPermissionAccessByFeatures)({
        requiredFeature: features,
        subscriptionFeatures: subscription?.subscriptionProduct?.features
      });
      if (!isActive && !disableModal)
        toggleModal(true, "UpgradeSubscriptionModal");
      return isActive;
    },
    triggerSubscriptionModal: ({
      onCompleted
    } = {}) => {
      toggleModal(true, "UpgradeSubscriptionModal");
      setPayload({ onCompleted });
    },
    isSubscriptionActive,
    subscriptionInactiveAt: subscription?.subscriptionInactiveAt,
    isSubscriptionUnpaid: subscription && subscription.status === import_dash_common10.ProductSubscriptionStatusesEnum.UNPAID
  };
};

// src/common/hooks/useScrollDirection/useScrollDirection.ts
var import_react15 = require("react");
function useScrollDirection(threshold = 10) {
  const [scrollDirection, setScrollDirection] = (0, import_react15.useState)(null);
  (0, import_react15.useEffect)(() => {
    let lastScrollY = window.pageYOffset;
    let ticking = false;
    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDirection(scrollY > lastScrollY ? "down" : "up");
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDirection);
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return scrollDirection;
}

// src/common/hooks/useInfiniteScroll/useInfiniteScroll.ts
var import_react16 = require("react");
var useInfiniteScroll = ({
  isLoadingMore,
  onLoadMore,
  rootMargin = "100px",
  threshold = 0
}) => {
  const loadMoreRef = (0, import_react16.useRef)(null);
  const handleObserver = (0, import_react16.useCallback)(
    (entries) => {
      const [target] = entries;
      if (target.isIntersecting && !isLoadingMore && onLoadMore) {
        onLoadMore();
      }
    },
    [isLoadingMore, onLoadMore]
  );
  (0, import_react16.useEffect)(() => {
    const element = loadMoreRef.current;
    if (!element)
      return;
    const option = {
      root: null,
      rootMargin,
      threshold
    };
    const observer = new IntersectionObserver(handleObserver, option);
    observer.observe(element);
    return () => {
      observer.unobserve(element);
    };
  }, [handleObserver, rootMargin, threshold]);
  return loadMoreRef;
};

// src/common/hooks/use-backend-error-message.ts
var import_react17 = require("react");
var import_react_i18next5 = require("react-i18next");
var EXACT_MESSAGE_KEYS = {
  "Cannot create Api Credentials. There are already credentials associated to this account.": "apiCredentialsAlreadyExist",
  INVALID_IDX_ID: "invalidIdxId",
  PROPERTY_DOES_NOT_EXIST: "propertyDoesNotExist",
  PASSWORD_IS_REQUIRED_FOR_PORTFOLIO: "passwordRequiredForPortfolio",
  PORTFOLIO_NOT_AVAILABLE: "portfolioNotAvailable",
  TRACKED_PROPERTIES_LIMIT_REACHED: "trackedPropertiesLimitReached",
  Unauthorized: "unauthorized",
  "Internal server error": "internalServerError",
  "Something went wrong.": "somethingWentWrong",
  "2FA already enabled.": "twoFactorAlreadyEnabled",
  "The user has already activated 2-factor authentication.": "twoFactorAlreadyEnabled",
  "2FA not activated.": "twoFactorNotActivated",
  "2FA secret not found.": "twoFactorNotActivated",
  "Invalid code.": "invalidCode",
  "This account verifies with an authenticator app.": "authenticatorAppRequired",
  "Error generating QR Code.": "qrCodeFailed",
  "Invitation not found.": "invitationNotFound",
  "This invitation link has already been used.": "invitationUsed",
  "This invitation link has expired.": "invitationExpired",
  "Only pending invitations can be resent.": "invitationOnlyPendingResend",
  "Only pending invitations can be revoked.": "invitationOnlyPendingRevoke",
  "Expiration date must be in the future.": "expirationDateInFuture",
  "API credential not found.": "apiCredentialNotFound",
  "API Credentials not found.": "apiCredentialNotFound",
  "No API credentials found for the account": "apiCredentialNotFound",
  "API credential is not deleted.": "apiCredentialNotDeleted",
  "Plugin user not found.": "pluginUserNotFound",
  "Only marketplace partners can manage plugin users.": "marketplacePartnersOnly",
  "API Plugin Users cannot switch account type": "pluginUsersCannotSwitchAccountType",
  "Account type cannot be switched more than once.": "accountTypeSwitchedOnce",
  "Broker not found.": "brokerNotFound",
  "Broker not found for account": "brokerNotFound",
  "Not allowed action for this role!": "notAllowedForRole",
  "This user is not allowed to do this action.": "notAllowedForUser",
  "Feature not available in current subscription": "featureNotInPlan",
  "Subscription is not active": "subscriptionNotActive",
  "This broker does not have an active subscription.": "subscriptionNotActive",
  "Subscription not found": "subscriptionNotFound",
  "Subscription not found.": "subscriptionNotFound",
  "No subscription found.": "subscriptionNotFound",
  "Not found subscription for current broker": "subscriptionNotFound",
  "Renew available only for canceled subscriptions!": "renewOnlyCanceled",
  "Retry available only for incomplete subscriptions!": "retryOnlyIncomplete",
  "Retry available only for opened subscription invoice!": "retryOnlyOpenInvoice",
  "This customer already have active stripe subscription": "activeStripeSubscriptionExists",
  "Account is not a stripe customer": "notStripeCustomer",
  "Portfolio not found": "portfolioNotFound",
  "Portfolio not found.": "portfolioNotFound",
  "Portfolio does not belong to this account.": "portfolioNotOwned",
  "Featured portfolio not found": "featuredPortfolioNotFound",
  "Featured portfolio has no properties to copy": "featuredPortfolioNothingToCopy",
  "No public properties available to copy": "featuredPortfolioNothingToCopy",
  "Featured property not found": "featuredPropertyNotFound",
  "Property not found": "propertyNotFound",
  "Property not found.": "propertyNotFound",
  "Property is not public": "propertyNotPublic",
  "Property is unavailable for brokers": "propertyUnavailableForBrokers",
  "Alert config is not exists": "alertNotFound",
  "Amenity not found": "amenityNotFound",
  "Target is not a folder": "targetNotFolder",
  "Media file not found": "mediaNotFound",
  "Media files not found": "mediaNotFound",
  "No media found to download": "noMediaToDownload",
  "Media folder not found or cannot be deleted": "mediaFolderNotFound",
  "Media are not in same folder": "mediaDifferentFolders",
  "Some media placed in different property as target folder": "mediaDifferentFolders",
  "All media should be related to one property": "mediaDifferentFolders",
  "IDX Feed not found.": "feedNotFound",
  "Exchange Feed not found.": "feedNotFound",
  "Exchange feed not found.": "feedNotFound",
  "Exchange Settings not found.": "feedSettingsNotFound",
  "Exchange settings not found.": "feedSettingsNotFound",
  "Exchange Settings already exists.": "feedSettingsAlreadyExist",
  "The Exchange feed owner has not configured IDX yet.": "feedOwnerNotConfigured",
  "This Exchange Feed does not offer downloads.": "feedNoDownloads",
  "This Exchange Feed has no portfolio.": "feedNoPortfolio",
  "This property does not belong to this Exchange Feed.": "propertyNotInFeed",
  "This portfolio does not follow locations.": "portfolioNoLocations",
  "Sales materials are not available for Search Bar feed type.": "salesMaterialsNotAvailable",
  "startDate must not be after endDate.": "startDateAfterEndDate",
  "Origin or referer header is required.": "originRequired",
  "Session URL is invalid": "sessionUrlInvalid",
  "Property note was created by other user. Can delete only own notes": "noteDeleteOwnOnly",
  "Property note was not added by current user. Can edit only own notes": "noteEditOwnOnly",
  "Your card was declined.": "cardDeclined",
  "Your card has insufficient funds.": "cardInsufficientFunds",
  "Your card has expired.": "cardExpired",
  "Your card's security code is incorrect.": "cardCvcIncorrect",
  "Your card number is incorrect.": "cardNumberIncorrect",
  "Your card's expiration date is incorrect.": "cardExpiryIncorrect",
  "Your card's expiration year is in the past.": "cardExpired",
  "Your card's expiration month is invalid.": "cardExpiryIncorrect",
  "Your card's security code is invalid.": "cardCvcIncorrect",
  "Your card number is incomplete.": "cardNumberIncomplete",
  "Your card's expiration date is incomplete.": "cardExpiryIncomplete",
  "Your card's security code is incomplete.": "cardCvcIncomplete",
  "Your card does not support this type of purchase.": "cardNotSupported",
  "An error occurred while processing your card. Try again in a little bit.": "cardProcessingError",
  "Your postal code is incomplete.": "postalCodeIncomplete",
  "Failed to fetch": "networkError",
  "Network request failed": "networkError"
};
var PATTERN_KEYS = [
  { pattern: /^Property \w+ is already tracked$/, key: "propertyAlreadyTracked" },
  {
    pattern: /^The property (.+) has already been added to portfolio$/,
    key: "propertyAlreadyInPortfolio",
    params: ["name"]
  },
  { pattern: /^Featured portfolio \w+ is already saved$/, key: "featuredPortfolioAlreadySaved" },
  { pattern: /^Featured portfolio \w+ is not public$/, key: "portfolioNotAvailable" },
  { pattern: /^Featured portfolio \w+ does not exist$/, key: "featuredPortfolioNotFound" },
  { pattern: /^Account with email .+ not found$/, key: "accountNotFound" },
  { pattern: /^Invalid .+ App ID or API key$/, key: "invalidApiCredentials" },
  { pattern: /^Incorrect file size /, key: "incorrectFileSize" },
  { pattern: /^Incorrect file extension /, key: "incorrectFileExtension" },
  { pattern: /^Properties already in folder: /, key: "propertiesAlreadyInFolder" }
];
var resolveBackendErrorKey = (message) => {
  const exact = EXACT_MESSAGE_KEYS[message];
  if (exact) {
    return { key: exact, options: {} };
  }
  for (const { pattern, key, params } of PATTERN_KEYS) {
    const match = message.match(pattern);
    if (match) {
      const options = {};
      (params || []).forEach((name, index2) => {
        options[name] = match[index2 + 1];
      });
      return { key, options };
    }
  }
  return null;
};
var useBackendErrorMessage = () => {
  const { t, i18n } = (0, import_react_i18next5.useTranslation)("common");
  return (0, import_react17.useCallback)(
    (error, fallback) => {
      const message = (typeof error === "string" ? error : error?.message) || "";
      if (!message) {
        return fallback || "";
      }
      const codeKey = [`serverErrors.${message}`, `brokerPortalServerErrors.${message}`].find(
        (key) => i18n.exists(`common:${key}`)
      );
      if (codeKey) {
        return t(codeKey);
      }
      const resolved = resolveBackendErrorKey(message);
      if (resolved && i18n.exists(`common:backendErrors.${resolved.key}`)) {
        return t(`backendErrors.${resolved.key}`, resolved.options);
      }
      return message;
    },
    [t, i18n]
  );
};

// src/common/hooks/use-system-folder-name.ts
var import_react18 = require("react");
var import_react_i18next6 = require("react-i18next");
var SYSTEM_FOLDER_KEYS = {
  Brochures: "brochures",
  "Fact Sheets": "factSheets",
  "Floor Plans": "floorPlans",
  Images: "images",
  Videos: "videos",
  Other: "other",
  Slideshow: "slideshow",
  "Agents-Only": "agentsOnly"
};
var useSystemFolderName = () => {
  const { t } = (0, import_react_i18next6.useTranslation)("common");
  return (0, import_react18.useCallback)(
    (folderName) => {
      const key = folderName && Object.prototype.hasOwnProperty.call(SYSTEM_FOLDER_KEYS, folderName) ? SYSTEM_FOLDER_KEYS[folderName] : void 0;
      return key ? t(`systemMediaFolders.${key}`) : folderName ?? "";
    },
    [t]
  );
};

// src/common/context/formContext/formContext.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var defaultContextValue7 = {
  formErrors: {},
  formState: { isLoading: false, errorSlug: "" },
  stateHandlers: {},
  errorHandlers: {},
  resetFormErrors: () => {
  },
  resetForm: () => {
  },
  formOnSubmit: () => {
  },
  formOnError: () => {
  },
  setFormValues: () => {
  },
  setDefaultFormValues: () => {
  },
  formOnSuccess: () => {
  }
};
var FormContext = (0, import_react19.createContext)(defaultContextValue7);
function FormProvider({
  children,
  fieldsList,
  defaultValues
}) {
  const [formErrors, , formErrorHandlers, [resetFormErrors]] = useFormValidation(fieldsList);
  const [
    formState,
    formStateHandlers,
    [formOnSubmit, formOnError, formOnSuccess, setFormValues, setDefaultFormValues, resetForm]
  ] = useFormState(fieldsList, defaultValues);
  const stateHandlers = fieldsList.reduce((obj, name, index2) => {
    obj[name] = formStateHandlers[index2];
    return obj;
  }, {});
  const errorHandlers = fieldsList.reduce((obj, name, index2) => {
    obj[name] = formErrorHandlers[index2];
    return obj;
  }, {});
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
    FormContext.Provider,
    {
      value: {
        formErrors,
        formState,
        stateHandlers,
        errorHandlers,
        formOnSubmit,
        formOnSuccess,
        formOnError,
        resetFormErrors,
        resetForm,
        setFormValues,
        setDefaultFormValues
      },
      children
    }
  );
}

// src/common/context/modalContext/modalContext.tsx
var import_react20 = require("react");
var import_jsx_runtime12 = require("react/jsx-runtime");
var defaultContextValue8 = {
  isOpen: false,
  isOpenCurrent: {},
  payload: void 0,
  upgradeSubscriptionModal: void 0,
  toggleModal: () => null,
  setPayload: () => null,
  setUpgradeSubscriptionModal: () => null
};
var ModalContext = (0, import_react20.createContext)(defaultContextValue8);
function ModalProvider({ children }) {
  const [isOpen, setIsOpen] = (0, import_react20.useState)(defaultContextValue8.isOpen);
  const [upgradeSubscriptionModal, setUpgradeSubscriptionModal] = (0, import_react20.useState)(defaultContextValue8.upgradeSubscriptionModal);
  const [isOpenCurrent, setIsOpenCurrent] = (0, import_react20.useState)(
    defaultContextValue8.isOpenCurrent
  );
  const [payload, setPayload] = (0, import_react20.useState)(defaultContextValue8.payload);
  const toggleModal = (value, key) => {
    if (key) {
      setIsOpenCurrent((prevState) => ({ ...prevState, [key]: value }));
    } else {
      setIsOpen(value);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(ModalContext.Provider, { value: { isOpen, isOpenCurrent, toggleModal, payload, setPayload, upgradeSubscriptionModal, setUpgradeSubscriptionModal }, children });
}

// src/common/context/modalContext/enum.ts
var UpgradeSubscriptionModalType = /* @__PURE__ */ ((UpgradeSubscriptionModalType2) => {
  UpgradeSubscriptionModalType2["PORTFOLIO"] = "PORTFOLIO";
  UpgradeSubscriptionModalType2["DOWNLOAD"] = "DOWNLOAD";
  UpgradeSubscriptionModalType2["BASIC"] = "BASIC";
  UpgradeSubscriptionModalType2["PRO"] = "PRO";
  UpgradeSubscriptionModalType2["IDX"] = "IDX";
  UpgradeSubscriptionModalType2["GENERAL"] = "GENERAL";
  UpgradeSubscriptionModalType2["PICK_PLAN"] = "PICK_PLAN";
  UpgradeSubscriptionModalType2["COMPLETE_ACCOUNT"] = "COMPLETE_ACCOUNT";
  UpgradeSubscriptionModalType2["SAVED_PROPERTIES"] = "SAVED_PROPERTIES";
  return UpgradeSubscriptionModalType2;
})(UpgradeSubscriptionModalType || {});

// src/common/context/pageViewContext/constants.ts
var PageViewTypeEnum = /* @__PURE__ */ ((PageViewTypeEnum2) => {
  PageViewTypeEnum2["LIST"] = "LIST";
  PageViewTypeEnum2["MAP"] = "MAP";
  PageViewTypeEnum2["CARDS"] = "CARDS";
  return PageViewTypeEnum2;
})(PageViewTypeEnum || {});

// src/common/context/pageViewContext/context.tsx
var import_react21 = require("react");
var import_jsx_runtime13 = require("react/jsx-runtime");
var PageViewContext = (0, import_react21.createContext)({
  viewType: "LIST" /* LIST */,
  setViewType: () => null
});
var PageViewProvider = ({ children }) => {
  const [propertyViewType, setPropertyViewType] = (0, import_react21.useState)("LIST" /* LIST */);
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
    PageViewContext.Provider,
    {
      value: { viewType: propertyViewType, setViewType: setPropertyViewType },
      children
    }
  );
};

// src/common/context/bulkActionsContext/bulkActionsContext.tsx
var import_react22 = require("react");
var import_jsx_runtime14 = require("react/jsx-runtime");
var defaultContextValue9 = {
  selectedItems: [],
  setSelectedItems: () => null,
  resetState: () => null
};
var BulkActionsContext = (0, import_react22.createContext)(defaultContextValue9);
var BulkActionsProvider = ({ children }) => {
  const [state, setState] = (0, import_react22.useState)(
    defaultContextValue9.selectedItems
  );
  const setSelectedItems = (checked, media) => {
    if (checked) {
      return setState((prev) => [...prev, media]);
    }
    setState((prev) => prev.filter((item) => item._id !== media._id));
  };
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
    BulkActionsContext.Provider,
    {
      value: {
        selectedItems: state,
        setSelectedItems,
        resetState: () => setState([])
      },
      children
    }
  );
};

// src/common/context/multi-file-upload-context/multi-file-upload-context.tsx
var import_dash_common11 = require("dash-common");
var import_react23 = require("react");
var import_jsx_runtime15 = require("react/jsx-runtime");
var defaultContextValue10 = {
  filesToUpload: [],
  onClear: () => {
  },
  onAbort: () => {
  },
  onError: () => {
  },
  onReject: () => {
  },
  onAbortAll: () => {
  },
  onHistoryClear: () => {
  },
  onCompleted: () => {
  },
  onFileClear: () => {
  },
  setAbortHandler: () => {
  },
  setRejectedFiles: () => {
  },
  initiateAsyncFilesUpload: async () => [],
  addProgressTrackingEvent: () => {
  }
};
var MultiFileUploadContext = (0, import_react23.createContext)(defaultContextValue10);
var MultiFileUploadProvider = ({ children }) => {
  const [filesToUpload, setAsyncState, setStateSync] = useAsyncState(
    defaultContextValue10.filesToUpload
  );
  const getFileUploadStateByProgressTrackingId = (progressTrackingId) => filesToUpload.find((doc) => doc.progressTrackingId === progressTrackingId);
  const setFileStateByProgressTrackingId = (progressTrackingId, newFileState) => setAsyncState((docs) => {
    const newDocs = [...docs];
    const index2 = docs.findIndex((doc) => doc.progressTrackingId === progressTrackingId);
    newDocs[index2] = newFileState;
    return newDocs;
  });
  const initiateAsyncFilesUpload = async (files) => {
    const filesToUploads = [];
    const fileState = files.map((file) => {
      const progressTrackingId = (0, import_dash_common11.RandomId)();
      filesToUploads.push({ file, progressTrackingId, fileSize: file.size });
      return {
        progressTrackingId,
        status: import_dash_common11.ProgressTrackingFileStatusesEnum.INITIALIZATION,
        progress: 0,
        filename: file.name,
        fileSize: file.size,
        operations: {}
      };
    });
    await setAsyncState([...filesToUpload, ...fileState]);
    return filesToUploads;
  };
  const setRejectedFiles = (fileRejections) => {
    const rejectedDocs = fileRejections.map(({ file, errors }) => ({
      progressTrackingId: (0, import_dash_common11.RandomId)(),
      filename: file.name,
      fileSize: file.size,
      messages: errors,
      status: import_dash_common11.ProgressTrackingFileStatusesEnum.ERROR,
      progress: 0
    }));
    setStateSync((docs) => [...docs, ...rejectedDocs]);
  };
  const addProgressTrackingEvent = (event) => {
    const {
      expectedOperations = [],
      operation,
      status,
      type,
      progress,
      progressTrackingId
    } = event;
    let fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (!fileUploadState || type !== import_dash_common11.ProgressTrackingTypesEnum.FILE_UPLOAD)
      return;
    if (status === import_dash_common11.ProgressTrackingFileStatusesEnum.INITIALIZATION) {
      const operations = expectedOperations.reduce(
        (memo2, expectedOperation) => ({
          ...memo2,
          [expectedOperation]: { progress: 0, operationStatus: status }
        }),
        {}
      );
      fileUploadState.status = import_dash_common11.ProgressTrackingFileStatusesEnum.INITIALIZATION;
      fileUploadState.operations = operations;
    }
    if (operation && fileUploadState.operations && fileUploadState.operations[operation]) {
      if (status !== import_dash_common11.ProgressTrackingFileStatusesEnum.INITIALIZATION) {
        fileUploadState.operations[operation].operationStatus = status;
      }
      if (status === import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADING && progress) {
        fileUploadState.operations[operation].progress = progress;
      }
      if (status === import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADED) {
        fileUploadState.operations[operation].progress = 100;
      }
    }
    const operationsMap = Object.values(fileUploadState.operations || {});
    const isUploading = operationsMap.some(
      (doc) => doc.operationStatus === import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADING
    );
    if (isUploading) {
      const operationCount = operationsMap.length;
      const totalPercentage = operationsMap.reduce((memo2, doc) => memo2 + doc.progress || 0, 0);
      fileUploadState.status = import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADING;
      fileUploadState.progress = Math.ceil(totalPercentage / operationCount);
    }
    const isUploaded = operationsMap.every(
      (doc) => doc.operationStatus === import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADED
    );
    if (isUploaded) {
      fileUploadState.status = import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADED;
    }
    if (status === import_dash_common11.ProgressTrackingFileStatusesEnum.ABORTED) {
      fileUploadState.status = import_dash_common11.ProgressTrackingFileStatusesEnum.ABORTED;
    }
    if (status === import_dash_common11.ProgressTrackingFileStatusesEnum.ERROR) {
      fileUploadState.status = import_dash_common11.ProgressTrackingFileStatusesEnum.ERROR;
    }
    setFileStateByProgressTrackingId(progressTrackingId, fileUploadState);
  };
  const setAbortHandler = (progressTrackingId, abortHandler) => {
    setAsyncState((docs) => {
      const newDocs = [...docs];
      const index2 = newDocs.findIndex((doc) => doc.progressTrackingId === progressTrackingId);
      if (index2 > -1) {
        newDocs[index2].abortHandler = abortHandler;
      }
      return newDocs;
    });
  };
  const onReject = (progressTrackingId) => {
    const fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (fileUploadState) {
      fileUploadState.status = import_dash_common11.ProgressTrackingFileStatusesEnum.ABORTED;
      setFileStateByProgressTrackingId(progressTrackingId, fileUploadState);
    }
  };
  const onAbort = (progressTrackingId) => {
    const fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (fileUploadState && fileUploadState.abortHandler) {
      fileUploadState.abortHandler();
    }
    onReject(progressTrackingId);
  };
  const onAbortAll = () => setAsyncState(
    (docs) => docs.map((doc) => {
      if (doc.abortHandler) {
        doc.abortHandler();
      }
      return { ...doc, status: import_dash_common11.ProgressTrackingFileStatusesEnum.ABORTED, progress: 0 };
    })
  );
  const onCompleted = (progressTrackingId) => {
    const fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (fileUploadState) {
      fileUploadState.status = import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADED;
      setFileStateByProgressTrackingId(progressTrackingId, fileUploadState);
    }
  };
  const onClear = (progressTrackingId) => setAsyncState((prev) => prev.filter((item) => item.progressTrackingId !== progressTrackingId));
  const onError = (progressTrackingId) => {
    const fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (fileUploadState) {
      fileUploadState.status = import_dash_common11.ProgressTrackingFileStatusesEnum.ERROR;
      setFileStateByProgressTrackingId(progressTrackingId, fileUploadState);
    }
  };
  const onFileClear = (progressTrackingId) => setAsyncState((prev) => prev.filter((item) => item.progressTrackingId !== progressTrackingId));
  const onHistoryClear = () => setAsyncState(
    (prev) => prev.filter((item) => item.status === import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADING)
  );
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    MultiFileUploadContext.Provider,
    {
      value: {
        onClear,
        onAbort,
        onError,
        onReject,
        onAbortAll,
        onCompleted,
        onFileClear,
        onHistoryClear,
        filesToUpload,
        setAbortHandler,
        setRejectedFiles,
        addProgressTrackingEvent,
        initiateAsyncFilesUpload
      },
      children
    }
  );
};

// src/common/context/mediaDragAndDropContext/mediaDragAndDropContext.tsx
var import_react24 = require("react");
var import_jsx_runtime16 = require("react/jsx-runtime");
var MediaDragAndDropContext = (0, import_react24.createContext)({ mediaIds: [], setMediaIds: () => null, resetState: () => null });
var MediaDragAndDropProvider = ({ children }) => {
  const [mediaIds, setMediaIds] = (0, import_react24.useState)(
    []
  );
  const setCurrentMediaIds = ({
    mediaIdToMove,
    mediaIdToReplace
  }) => {
    setMediaIds((prev) => {
      const isEqual = prev.some(
        (item) => item.mediaIdToMove === mediaIdToMove && item.mediaIdToReplace === mediaIdToReplace
      );
      if (isEqual)
        return prev;
      if (mediaIdToMove === mediaIdToReplace)
        return prev;
      return [...prev, { mediaIdToMove, mediaIdToReplace }];
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
    MediaDragAndDropContext.Provider,
    {
      value: { mediaIds, setMediaIds: setCurrentMediaIds, resetState: () => setMediaIds([]) },
      children
    }
  );
};

// src/common/context/tooltipContext/tooltipContext.tsx
var import_react25 = require("react");
var import_dash_common12 = require("dash-common");
var import_jsx_runtime17 = require("react/jsx-runtime");
var defaultContextValue11 = {
  isOpen: false,
  setIsOpen: () => {
  },
  config: {
    id: "",
    placement: "bottom"
  },
  setConfig: () => {
  },
  children: null,
  setChildren: () => {
  },
  content: null,
  setContent: () => {
  },
  handlePosition: () => {
  },
  refModal: null,
  leftShift: 0
};
var TooltipContext = (0, import_react25.createContext)(defaultContextValue11);
function TooltipProvider({ children: providerChildren }) {
  const refModal = (0, import_react25.useRef)(null);
  const [isOpen, setIsOpen] = (0, import_react25.useState)(defaultContextValue11.isOpen);
  const [config, setConfig] = (0, import_react25.useState)(defaultContextValue11.config);
  const [children, setChildren] = (0, import_react25.useState)(defaultContextValue11.children);
  const [content, setContent] = (0, import_react25.useState)(defaultContextValue11.content);
  const [leftShift, setLeftShift] = (0, import_react25.useState)(defaultContextValue11.leftShift);
  const handlePosition = ({ rectBox, rectModal }) => {
    const element = refModal.current;
    let isScreenHeightTopOverflow = config.placement === "top" && rectBox.top - rectModal.height - 10 < 0;
    let isScreenHeightBottomOverflow = rectBox.bottom + window.scrollY + rectModal.height + 20 > window.innerHeight;
    const leftShift2 = rectBox.left > 150 && rectModal.height > 100 ? 100 : 0;
    setLeftShift(leftShift2);
    let newHeight = rectModal.height;
    if (leftShift2) {
      newHeight = rectModal.height * rectModal.width / (rectModal.width + leftShift2) - rectModal.height * 4 / 30;
      isScreenHeightTopOverflow = config.placement === "top" && rectBox.top - newHeight - 10 < 0;
      isScreenHeightBottomOverflow = rectBox.bottom + window.scrollY + newHeight + 20 > window.innerHeight;
    }
    if (isScreenHeightTopOverflow) {
      setConfig((state) => ({
        ...state,
        placement: "bottom"
      }));
    }
    if (isScreenHeightBottomOverflow) {
      setConfig((state) => ({
        ...state,
        placement: "top"
      }));
    }
    const offset = config.offset ?? 0;
    if (config.placement === "top" && !isScreenHeightTopOverflow) {
      element.style.bottom = window.innerHeight - rectBox.top - window.scrollY + offset + "px";
      element.style.left = rectBox.left + window.scrollX - leftShift2 + "px";
      element.style.top = "";
    } else if ((0, import_dash_common12.or)(config.placement === "bottom", isScreenHeightTopOverflow)) {
      if (config.placement !== "bottom") {
        setConfig((state) => ({
          ...state,
          placement: "bottom"
        }));
      }
      element.style.top = rectBox.top + rectBox.height + window.scrollY + 7 + offset + "px";
      element.style.left = rectBox.left + window.scrollX - leftShift2 + "px";
      element.style.bottom = "";
    } else if (config.placement === "left") {
      element.style.top = rectBox.top - rectBox.height / 4 + window.scrollY + "px";
      element.style.left = rectBox.left - rectModal.width + window.scrollX - 7 - offset + "px";
    } else if (config.placement === "right") {
      element.style.top = rectBox.top - rectBox.height / 4 + window.scrollY + "px";
      element.style.left = rectBox.left + rectModal.width + window.scrollX - 13 + offset + "px";
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
    TooltipContext.Provider,
    {
      value: {
        isOpen,
        setIsOpen,
        handlePosition,
        config,
        setConfig,
        refModal,
        children,
        setChildren,
        content,
        setContent,
        leftShift
      },
      children: providerChildren
    }
  );
}

// src/common/context/colorContext/colorContext.tsx
var import_react26 = require("react");
var import_styled_components7 = require("styled-components");
var import_randomcolor = __toESM(require("randomcolor"));
var import_jsx_runtime18 = require("react/jsx-runtime");
var ColorContext = (0, import_react26.createContext)({
  colorMap: {},
  setColorMap: () => null,
  getDashColor: () => "",
  getGradientColor: () => [],
  getRandomColor: () => "",
  gradientColorSets: []
});
function ColorProvider({ children }) {
  const [colorMap, setColorMap] = (0, import_react26.useState)({});
  const theme = (0, import_styled_components7.useTheme)();
  const colors2 = (0, import_react26.useMemo)(
    () => [
      theme.colors.b90,
      theme.colors.b80,
      theme.colors.b70,
      theme.colors.b60,
      theme.colors.b50,
      theme.colors.b50Hover,
      theme.colors.b50Active,
      theme.colors.b100,
      theme.colors.b40,
      theme.colors.b30,
      theme.colors.b20,
      theme.colors.g20,
      theme.colors.g20Hover,
      theme.colors.g20Active,
      theme.colors.g40,
      theme.colors.r60,
      theme.colors.r20,
      theme.colors.r20Hover,
      theme.colors.r20Active,
      theme.colors.y20,
      theme.colors.n200,
      theme.colors.n90,
      theme.colors.n80,
      theme.colors.n70,
      theme.colors.n60
    ],
    [theme]
  );
  const gradientColorSets = (0, import_react26.useMemo)(
    () => [
      theme.gradientColorsSet.blue,
      theme.gradientColorsSet.green,
      theme.gradientColorsSet.red,
      theme.gradientColorsSet.yellow,
      theme.gradientColorsSet.purple
    ],
    [theme]
  );
  const getDashColor = (0, import_react26.useCallback)(() => {
    const randomColorIndex = Math.floor(Math.random() * colors2.length);
    return colors2[randomColorIndex];
  }, [colors2]);
  const setColorMapSpy = (0, import_react26.useCallback)(
    (newState) => {
      setColorMap(newState);
    },
    [setColorMap]
  );
  const getRandomColor = () => (0, import_randomcolor.default)();
  const getGradientColor = (0, import_react26.useCallback)(() => {
    const randomColorIndex = Math.floor(Math.random() * gradientColorSets.length);
    return gradientColorSets[randomColorIndex];
  }, [gradientColorSets]);
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
    ColorContext.Provider,
    {
      value: {
        colorMap,
        setColorMap: setColorMapSpy,
        getDashColor,
        getRandomColor,
        getGradientColor,
        gradientColorSets
      },
      children
    }
  );
}

// src/common/context/featuredPortfolioStateContext/featuredPortfolioStateContext.tsx
var import_react27 = require("react");
var import_jsx_runtime19 = require("react/jsx-runtime");
var defaultContextValue12 = {
  savedPortfoliosMap: /* @__PURE__ */ new Map(),
  loadingPortfolioIds: /* @__PURE__ */ new Set(),
  initializeSaved: () => {
  },
  addToSaved: () => {
  },
  removeFromSaved: () => {
  },
  isSaved: () => false,
  isLoading: () => false,
  setLoading: () => {
  }
};
var FeaturedPortfolioStateContext = (0, import_react27.createContext)(defaultContextValue12);
function FeaturedPortfolioStateProvider({ children }) {
  const [savedPortfoliosMap, setSavedPortfoliosMap] = (0, import_react27.useState)(
    defaultContextValue12.savedPortfoliosMap
  );
  const [loadingPortfolioIds, setLoadingPortfolioIds] = (0, import_react27.useState)(
    defaultContextValue12.loadingPortfolioIds
  );
  const addToSaved = (0, import_react27.useCallback)((portfolioId, savedRecordId) => {
    setSavedPortfoliosMap((prev) => new Map(prev).set(portfolioId, savedRecordId));
  }, []);
  const initializeSaved = (0, import_react27.useCallback)((portfolios) => {
    setSavedPortfoliosMap(new Map(portfolios));
  }, []);
  const removeFromSaved = (0, import_react27.useCallback)((portfolioId) => {
    setSavedPortfoliosMap((prev) => {
      const next = new Map(prev);
      next.delete(portfolioId);
      return next;
    });
  }, []);
  const isSaved = (0, import_react27.useCallback)(
    (portfolioId) => {
      return savedPortfoliosMap.has(portfolioId);
    },
    [savedPortfoliosMap]
  );
  const isLoading = (0, import_react27.useCallback)(
    (portfolioId) => {
      return loadingPortfolioIds.has(portfolioId);
    },
    [loadingPortfolioIds]
  );
  const setLoading = (0, import_react27.useCallback)((portfolioId, loading) => {
    if (loading) {
      setLoadingPortfolioIds((prev) => new Set(prev).add(portfolioId));
    } else {
      setLoadingPortfolioIds((prev) => {
        const next = new Set(prev);
        next.delete(portfolioId);
        return next;
      });
    }
  }, []);
  const contextValue = (0, import_react27.useMemo)(
    () => ({
      savedPortfoliosMap,
      loadingPortfolioIds,
      initializeSaved,
      addToSaved,
      removeFromSaved,
      isSaved,
      isLoading,
      setLoading
    }),
    [
      savedPortfoliosMap,
      loadingPortfolioIds,
      initializeSaved,
      addToSaved,
      removeFromSaved,
      isSaved,
      isLoading,
      setLoading
    ]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(FeaturedPortfolioStateContext.Provider, { value: contextValue, children });
}

// src/common/account/access-token-helpers.ts
var import_jwt_decode = __toESM(require("jwt-decode"));
var jwtDecodeSafely = (accessToken) => {
  try {
    return (0, import_jwt_decode.default)(accessToken);
  } catch {
    return null;
  }
};
var isAccessTokenExpired = (accessToken, tolerance = 5e3) => {
  if (!accessToken) {
    return true;
  }
  try {
    const decodedJwt = (0, import_jwt_decode.default)(accessToken);
    return decodedJwt.exp * 1e3 <= Date.now() + tolerance;
  } catch {
    return true;
  }
};
var fetchAccessToken = async (url, refreshToken) => {
  if (!refreshToken) {
    return Promise.reject(new Error("Refresh token not found"));
  }
  const res = await fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Refresh: refreshToken
    },
    body: JSON.stringify({
      query: `
          mutation refreshTokens {
            refreshTokens {
              accessToken
              refreshToken
              refreshTokenExpiry
            }
          }`
    })
  });
  const { data, errors } = await res.json();
  if (errors?.length) {
    return Promise.reject(errors[0]);
  }
  return data?.refreshTokens;
};

// src/common/files/file-upload-helpers.ts
var fileUploadFetch = (url, options) => new Promise((resolve2, reject) => {
  const xhr = new XMLHttpRequest();
  xhr.open(options.method, url, true);
  Object.entries(options.headers).forEach(
    ([key, value]) => xhr.setRequestHeader(key, value)
  );
  xhr.onload = ({ target: { responseText } }) => {
    resolve2({
      ok: true,
      text: () => Promise.resolve(responseText),
      json: () => Promise.resolve(JSON.parse(responseText))
    });
  };
  xhr.onerror = reject;
  xhr.ontimeout = reject;
  if (xhr.upload) {
    xhr.upload.onprogress = options.onProgress;
  }
  if (options.onAbort) {
    options.onAbort(() => xhr.abort());
  }
  xhr.send(options.body);
});

// src/common/tables/constants.ts
var SortByEnum = /* @__PURE__ */ ((SortByEnum2) => {
  SortByEnum2["SORT_AZ"] = "SORT_AZ";
  SortByEnum2["SORT_ZA"] = "SORT_ZA";
  SortByEnum2["SORT_CREATED_AT"] = "SORT_CREATED_AT";
  return SortByEnum2;
})(SortByEnum || {});

// src/common/address/googlePlaceToAddress.ts
var googlePlaceToAddress = (place) => {
  const address = {
    street: "",
    zipCode: "",
    city: "",
    county: "",
    state: ""
  };
  for (const component of place?.address_components || []) {
    const componentType = component.types[0];
    switch (componentType) {
      case "postal_code": {
        address.zipCode = component.long_name;
        break;
      }
      case "route": {
        address.street += component.long_name;
        break;
      }
      case "street_number": {
        address.street = `${component.long_name} ${address.street}`;
        break;
      }
      case "locality": {
        address.city = component.long_name;
        break;
      }
      case "administrative_area_level_2":
        address.county = component.long_name.replace(" County", "");
        break;
      case "administrative_area_level_1": {
        address.state = component.long_name;
        break;
      }
    }
  }
  return address;
};

// src/common/mortgage/mortgage.ts
var mortgage_exports = {};
__export(mortgage_exports, {
  calculateMortgage: () => calculateMortgage,
  nextPenny: () => nextPenny
});

// src/common/mortgage/mortgage-js.v1.ts
var nextPenny = (value) => Math.ceil(value * 100) / 100;
var calculateMonthlyPIPayment = (loanAmount, annualRate, termMonths) => {
  let monthlyRate = annualRate / 12;
  let payment = monthlyRate * loanAmount * Math.pow(1 + monthlyRate, termMonths) / (Math.pow(1 + monthlyRate, termMonths) - 1);
  return payment;
};
var calculatePaymentSchedule = (loanAmount, annualRate, termMonths, additionalPrincipalPayments = 0) => {
  const monthlyRate = annualRate / 12;
  const monthlyPayment = calculateMonthlyPIPayment(loanAmount, annualRate, termMonths);
  let principal = loanAmount;
  let payments = [];
  let totalInterest = 0;
  let totalPayments = 0;
  let i = 0;
  while (principal > 0 && i < termMonths) {
    let interestPayment = principal * monthlyRate;
    let principalPayment = monthlyPayment - interestPayment + additionalPrincipalPayments;
    if (principal > principalPayment) {
      principal = principal - principalPayment;
    } else {
      principalPayment = principal;
      principal = 0;
    }
    let totalPayment = interestPayment + principalPayment;
    totalInterest += interestPayment;
    totalPayments += totalPayment;
    payments[i] = {
      count: i + 1,
      interestPayment,
      totalInterest,
      principalPayment,
      totalPayment,
      totalPayments,
      balance: principal
    };
    i++;
  }
  return payments;
};
var calculatePayment = ({
  totalPrice,
  downPayment,
  interestRate,
  months,
  taxRate = 0,
  insuranceRate = 0,
  mortgageInsuranceRate = 0,
  mortgageInsuranceEnabled = false,
  mortgageInsuranceThreshold = 0,
  additionalPrincipalPayment = 0
}) => {
  let loanAmount = totalPrice - downPayment;
  let paymentSchedule = calculatePaymentSchedule(
    loanAmount,
    interestRate,
    months,
    additionalPrincipalPayment
  );
  let piPayment = paymentSchedule.length ? paymentSchedule[0].totalPayment : 0;
  let downPaymentPercentage = downPayment / totalPrice;
  let mortgageInsurance = 0;
  if (mortgageInsuranceEnabled && downPaymentPercentage < mortgageInsuranceThreshold) {
    mortgageInsurance = loanAmount * mortgageInsuranceRate / 12;
  }
  let propertyTax = totalPrice * taxRate / 12;
  let homeOwnerInsurance = totalPrice * insuranceRate / 12;
  return {
    loanAmount,
    principalAndInterest: piPayment,
    tax: propertyTax,
    insurance: homeOwnerInsurance,
    total: piPayment + propertyTax + homeOwnerInsurance + mortgageInsurance,
    termMonths: months,
    paymentSchedule,
    mortgageInsurance
  };
};

// src/common/mortgage/mortgage.ts
var calculateMortgage = (input) => {
  const { totalPrice, downPayment, interestRate, months, taxRate = 0, insuranceRate = 0 } = input;
  const taxRatePercentage = taxRate > 0 ? totalPrice / taxRate : 0;
  const insuranceRatePercentage = insuranceRate > 0 ? totalPrice / insuranceRate : 0;
  const downPaymentAmount = totalPrice * (downPayment / 100);
  return calculatePayment({
    totalPrice,
    downPayment: downPaymentAmount,
    interestRate,
    months,
    taxRate: taxRatePercentage,
    insuranceRate: insuranceRatePercentage,
    mortgageInsuranceRate: 0,
    mortgageInsuranceEnabled: false,
    mortgageInsuranceThreshold: 0,
    additionalPrincipalPayment: 0
  });
};

// src/common/googleMap/googleZoomLevelToMiles.ts
var googleZoomLevelToMiles = (lat, zoom) => 156543.03392 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom) * 1.609;

// src/common/helpers/string.helpers.ts
var import_lodash8 = require("lodash");
var formatBedroomsRangeValues = (range, options) => {
  if (!range)
    return "";
  const { min, max } = range;
  if (min === null && max === null)
    return "";
  if (min === 0 && options && options.t && max && max > 0) {
    return `${options.t("common:labels.studio")[0]} - ${max}`;
  }
  if (options && options.isNullable && options.t) {
    return options.t("common:labels.studio");
  }
  if ((0, import_lodash8.isNumber)(min) && (0, import_lodash8.isNumber)(max) && min !== max) {
    return `${min} - ${max}`;
  }
  if (min || max) {
    return min ?? max;
  }
  return "";
};
var formatBathroomsRangeValues = (range, options) => {
  if (!range)
    return "";
  const { min, max } = range;
  if (min === 0 && options && options.t && max && max > 0) {
    return `${min} - ${max}`;
  }
  if (options && options.isNullable && options.t) {
    return "";
  }
  if ((0, import_lodash8.isNumber)(min) && (0, import_lodash8.isNumber)(max) && min !== max) {
    return `${min} - ${max}`;
  }
  if (min || max) {
    return min ?? max;
  }
  return "";
};
var formatGeneralRangeValues = (range, options) => {
  if (!range)
    return "";
  const { min, max } = range;
  if (min === 0 && options && options.t && max && max > 0) {
    return `${min.toLocaleString("en-US")} - ${max.toLocaleString("en-US")}`;
  }
  if (options && options.isNullable && options.t) {
    return "";
  }
  if ((0, import_lodash8.isNumber)(min) && (0, import_lodash8.isNumber)(max) && min !== max && max > 0) {
    return `${min.toLocaleString("en-US")} - ${max.toLocaleString("en-US")}`;
  }
  if (min || max) {
    if (min)
      return min.toLocaleString("en-US");
    else
      return max?.toLocaleString("en-US");
  }
  return "";
};

// src/common/helpers/download.helpers.ts
function downloadMedia(mediaIds) {
  window.open(
    process.env["REACT_APP_REST"] + `/media/download?accessToken=${localStorage2.getAccessToken()}&mediaIds=${JSON.stringify(
      mediaIds
    )}`
  );
}
function downloadFile(fileIds) {
  window.open(
    process.env["REACT_APP_REST"] + `/media/download-file?accessToken=${localStorage2.getAccessToken()}&fileIds=${JSON.stringify(
      fileIds
    )}`
  );
}

// src/common/helpers/idx-iframe.helpers.ts
function getIdxIframeViewport() {
  if (window.self === window.top)
    return null;
  const root = document.documentElement;
  const top = root.style.getPropertyValue("--idx-viewport-top");
  const height = root.style.getPropertyValue("--idx-viewport-height");
  if (!top || !height)
    return null;
  return { top: parseFloat(top), height: parseFloat(height) };
}

// src/common/helpers/date.helpers.ts
var import_moment3 = __toESM(require("moment"));
var isEnglish = (m) => m.locale().startsWith("en");
var formatDisplayDate = (input) => (0, import_moment3.default)(input).format("L");
var formatDisplayMonthDate = (input) => {
  const m = (0, import_moment3.default)(input);
  return isEnglish(m) ? m.format("MMM DD, YYYY") : m.format("ll");
};
var toDisplayLocaleDateString = (date, language) => date.toLocaleDateString(language && !language.startsWith("en") ? language : void 0);
var formatDisplayRange = (start, end, language) => `${toDisplayLocaleDateString(start, language)} - ${toDisplayLocaleDateString(end, language)}`;
var INTL_LOCALES = { es: "es", pt: "pt-BR" };
var formatLocalizedDate = (input, options) => new Date(input).toLocaleDateString(
  INTL_LOCALES[(i18n_default.language || "en").split("-")[0]] || "en-US",
  options
);

// src/components/atoms/Spinner/Spinner.tsx
var import_styled_components9 = require("styled-components");

// src/components/atoms/Spinner/Spinner.styles.tsx
var import_styled_components8 = __toESM(require("styled-components"));
var StyledIcon = (0, import_styled_components8.default)(Icon_default)`
  -webkit-animation: spin 1.6s ease-in-out infinite;
  -moz-animation: spin 1.6s ease-in-out infinite;
  animation: spin 1.6s ease-in-out infinite;
  @-moz-keyframes spin {
    100% {
      -moz-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;
var SpinnerWrapper = (0, import_styled_components8.default)(Flex_default)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  background: ${({ theme, bgColor, opacity }) => theme.colors.setOpacity(bgColor || theme.colors.white, opacity || 80)};

  ${({ theme, ignoreResponsive }) => !ignoreResponsive && `@media ${theme.devices.mobile} {
      align-items: start;
      padding-top: ${theme.space * 8}px;
  })`}
`;

// src/components/atoms/Spinner/Spinner.tsx
var import_jsx_runtime20 = require("react/jsx-runtime");
function Spinner({
  fullContent = false,
  ignoreResponsive = false,
  bgColor,
  color: color2,
  opacity,
  ...props
}) {
  const theme = (0, import_styled_components9.useTheme)();
  const iconProps = { size: 24, color: color2 || theme.colors.b50, ...props };
  if (!fullContent) {
    return /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(StyledIcon, { ...iconProps, name: "loading" });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
    SpinnerWrapper,
    {
      pos: "absolute",
      alignItems: "center",
      justifyContent: "center",
      w: "100%",
      bgColor,
      opacity,
      ignoreResponsive,
      children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(StyledIcon, { ...iconProps, name: "loading" })
    }
  );
}
var Spinner_default = Spinner;

// src/components/atoms/Badge/Badge.styles.tsx
var import_styled_components10 = __toESM(require("styled-components"));
var badgeStyle = import_styled_components10.css`
  ${({ theme, type = "neutral" }) => {
  const typesStyleRelations = {
    neutral: import_styled_components10.css`
        color: ${theme.colors.b50};
        background-color: ${theme.colors.b20};
      `,
    ["neutralSolid"]: import_styled_components10.css`
        color: ${theme.colors.white};
        background-color: ${theme.colors.b50};
      `,
    alert: import_styled_components10.css`
        color: ${theme.colors.white};
        background-color: ${theme.colors.r20};
      `,
    active: import_styled_components10.css`
        color: ${theme.colors.g20};
        background-color: ${theme.colors.g10};
      `,
    activeSolid: import_styled_components10.css`
        color: ${theme.colors.white};
        background-color: ${theme.colors.g20};
      `,
    inactive: import_styled_components10.css`
        color: ${theme.colors.n80};
        background-color: ${theme.colors.n20};
      `,
    danger: import_styled_components10.css`
        color: ${theme.colors.r20};
        background-color: ${theme.colors.r10};
      `,
    warning: import_styled_components10.css`
        color: ${theme.colors.y20};
        background-color: ${theme.colors.y10};
      `
  };
  return typesStyleRelations[type] || "";
}}
`;
var BadgeStyle = (0, import_styled_components10.default)(Flex_default)`
  cursor: ${({ isPointer }) => isPointer ? "pointer" : "default"};
  border-radius: ${({ square, borderRadius }) => borderRadius || (square ? 4 : 16)}px;
  ${textStyle}
  ${badgeStyle}
  ${({ bgColor }) => bgColor && `background-color: ${bgColor}`};
  ${({ titleColor }) => titleColor && `color: ${titleColor}`};
`;

// src/components/atoms/Badge/Badge.tsx
var import_jsx_runtime21 = require("react/jsx-runtime");
function Badge({
  title,
  onClick,
  iconRight,
  iconRightProps,
  iconLeft,
  iconLeftProps,
  px = 2,
  py = 1,
  sm = true,
  semibold = true,
  loading,
  renderLeftIcon,
  ...args
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
    BadgeStyle,
    {
      onClick: (e) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
      },
      isPointer: !!onClick,
      alignItems: "center",
      justifyContent: "center",
      px,
      py,
      sm,
      semibold,
      ...args,
      children: loading ? /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Spinner_default, { size: 20, pos: "absolute", color: "inherit" }) : /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)(import_jsx_runtime21.Fragment, { children: [
        renderLeftIcon && renderLeftIcon(),
        iconLeft && /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Flex_default, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Icon_default, { size: 24, mr: 1, name: iconLeft, ...iconLeftProps }) }),
        title,
        iconRight && /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Flex_default, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Icon_default, { size: 24, ml: 1, name: iconRight, ...iconRightProps }) })
      ] })
    }
  );
}
var Badge_default = Badge;

// src/components/atoms/Form/Select/Select.styles.ts
var StyledSelectWrapper = (0, import_styled_components11.default)(Flex_default)`
  cursor: pointer;
  position: relative;
  & > div:first-child {
    width: inherit;
  }
  .select__control {
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.n60};
    box-shadow: none;
    height: ${({ h }) => h ? h : "40px"};
    width: inherit;
    visibility: ${({ isButtonSelect }) => isButtonSelect ? "hidden" : "visible"};

    :hover {
      background: ${({ theme }) => theme.colors.white};
      border-color: ${({ theme }) => theme.colors.b40};
      box-shadow: ${({ theme }) => theme.shadows.shadow3};
      cursor: pointer;
    }

    ${stateStyle}
  }
  .select__control--is-focused {
    background-color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme, $errorType }) => $errorType === "invalid" /* Invalid */ ? theme.colors.r20 : theme.colors.n70};
  }
  .select__indicator-separator {
    display: none;
  }

  .select__indicators {
    margin-right: 10px;
    margin-left: 2px;
    color: ${({ theme }) => theme.colors.n200};
  }

  .select__control--is-disabled {
    background-color: ${({ theme }) => theme.colors.n20};
    border-color: ${({ theme }) => theme.colors.n60};
    .select__indicators {
      color: ${({ theme }) => theme.colors.n200};
    }
  }
  .select__placeholder {
    font-size: 14px;
    line-height: 23px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.colors.n60};
  }

  .select__input {
    cursor: pointer;

    input {
      font-size: 16px; /* Prevent iOS Safari zoom on focus */
    }
  }

  .select__value-container {
    flex-wrap: nowrap;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: unset;

    -ms-overflow-style: none;
    scrollbar-width: none;
    margin-left: ${({ leftIcon }) => leftIcon ? 42 : 12}px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  ${boxStyle}
  ${textStyle}
  ${({ css: css33 }) => css33}
`;
var SelectMenuDropdownStyles = import_styled_components11.css`
  .select__menu {
    min-width: fit-content;
    border-radius: ${({ theme }) => theme.space * 3}px !important;
  }
  .select__menu-list {
    width: inherit;
    padding: 0 !important;
    border-radius: ${({ theme }) => theme.space * 3}px !important;
    .select__option {
      width: inherit;
      cursor: pointer;
      margin-top: ${({ theme }) => theme.space}px;
      margin-bottom: ${({ theme }) => theme.space}px;
    }
    .select__option--is-focused {
      background-color: ${({ theme }) => theme.colors.b10};
      border-radius: ${({ theme }) => theme.space * 2}px;
      &:active {
        background-color: ${({ theme }) => theme.colors.b10};
      }
    }
    .select__option--is-selected {
      background-color: ${({ theme }) => theme.colors.b20};
      &:active {
        background-color: ${({ theme }) => theme.colors.b20};
      }
    }
    .hover-disable {
      :hover {
        background: transparent;
      }
    }
    .hover-disable.select__option--is-focused,
    .hover-disable.select__option--is-selected {
      background: transparent;
    }
  }
`;
var StyledLeftIconContainer = (0, import_styled_components11.default)(Flex_default)`
  position: absolute;
  left: ${({ theme }) => theme.space * 3}px;
  width: ${({ theme }) => theme.space * 6}px;
  height: ${({ theme }) => theme.space * 6}px;
  z-index: 2;
  cursor: pointer;
`;
var StyledValueText = (0, import_styled_components11.default)(Box_default)`
  ${textStyle}
`;
var StyledBadge = (0, import_styled_components11.default)(Badge_default)`
  z-index: 1;
  transition: background-color 120ms ease, color 120ms ease;
  :hover {
    background-color: ${({ theme }) => theme.colors.b30};
  }

  ${({ $isActive, theme }) => $isActive && import_styled_components11.css`
      background-color: ${theme.colors.b50};
      color: ${theme.colors.white};
      :hover {
        background-color: ${theme.colors.b60};
      }
    `}
`;

// src/components/theme.provider.tsx
var import_jsx_runtime22 = require("react/jsx-runtime");
var GlobalStyles = import_styled_components12.createGlobalStyle`
  ${SelectMenuDropdownStyles}

  html {
    overflow-y: overlay;
  }
`;
var ThemeProvider = ({ children }) => {
  import_react_modal.default.setAppElement("#root");
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(import_styled_components12.ThemeProvider, { theme: mainTheme, children: /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(import_react_dnd.DndProvider, { backend: import_react_dnd_html5_backend.HTML5Backend, children: /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)(import_react_i18next7.I18nextProvider, { i18n: i18n_default, children: [
    /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(GlobalStyles, {}),
    children
  ] }) }) });
};
var theme_provider_default = ThemeProvider;

// src/components/atoms/H/H.tsx
var import_styled_components13 = __toESM(require("styled-components"));
var import_jsx_runtime23 = require("react/jsx-runtime");
var textStyle2 = import_styled_components13.css`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  margin-block-start: unset;
  margin-block-end: unset;
  font-weight: ${({ theme, bold, semibold, medium, regular = true }) => getFontWeight(theme, {
  bold,
  semibold,
  medium,
  regular
})};
  font-size: ${({ theme, md, lg, sm, xs }) => getSize(theme, { md, lg, sm, xs }, "fontSize", "header")}px;
  line-height: ${({ theme, md, lg, sm, xs }) => getSize(theme, { md, lg, sm, xs }, "lineHeight", "header")}px;
  color: ${({ color: color2, theme }) => color2 || theme.colors.n90};
`;
var h3 = import_styled_components13.default.h3`
  ${textStyle2}
`;
var h4 = import_styled_components13.default.h4`
  ${textStyle2}
`;
function H({ children, as = 1, ...args }) {
  const H2 = [h3, h4][as - 1] || h3;
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(H2, { ...args, children });
}
var H_default = H;

// src/components/atoms/Banner/Banner.styles.tsx
var import_styled_components14 = __toESM(require("styled-components"));
var BannerContainer = (0, import_styled_components14.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

// src/components/atoms/Banner/Banner.interfaces.ts
var BannerTypesEnum = /* @__PURE__ */ ((BannerTypesEnum2) => {
  BannerTypesEnum2["SUCCESS"] = "success";
  BannerTypesEnum2["WARNING"] = "warning";
  BannerTypesEnum2["ERROR"] = "error";
  return BannerTypesEnum2;
})(BannerTypesEnum || {});

// src/components/atoms/Banner/Banner.constants.ts
var BANNER_OPTIONS = {
  ["success" /* SUCCESS */]: {
    background: mainTheme.colors.g10,
    color: mainTheme.colors.g20
  },
  ["warning" /* WARNING */]: {
    background: mainTheme.colors.y20,
    color: mainTheme.colors.n90
  },
  ["error" /* ERROR */]: {
    background: mainTheme.colors.r10,
    color: mainTheme.colors.r20
  }
};
var BANNER_SORT_ORDER = {
  ["error" /* ERROR */]: 1,
  ["warning" /* WARNING */]: 2,
  ["success" /* SUCCESS */]: 3
};

// src/components/molecules/DashboardBanner/DashboardBanner.styles.ts
var import_styled_components16 = __toESM(require("styled-components"));

// src/components/atoms/Button/Button.tsx
var import_styled_components15 = __toESM(require("styled-components"));

// src/components/atoms/Button/Button.helpers.ts
var getButtonColors = ({ colorVariation = "default", theme }) => {
  const variation = {
    danger: {
      color: theme.colors.r20,
      hoverColor: theme.colors.r20Hover,
      outlineColor: theme.colors.r10
    },
    success: {
      color: theme.colors.g20,
      hoverColor: theme.colors.g20Hover,
      outlineColor: theme.colors.g10
    },
    default: {
      color: theme.colors.bluePrimary,
      hoverColor: theme.colors.b50Hover,
      outlineColor: theme.colors.b10
    },
    light: {
      color: theme.colors.white,
      hoverColor: theme.colors.setOpacity(theme.colors.white, 20),
      outlineColor: theme.colors.white
    }
  };
  return variation[colorVariation];
};

// src/components/atoms/Button/components/ButtonIcon/ButtonIcon.tsx
var import_jsx_runtime24 = require("react/jsx-runtime");
function ButtonIcon({
  left,
  right,
  hasContent,
  icon,
  iconProps,
  regular,
  medium,
  small
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
    Flex_default,
    {
      w: regular && 24 || medium && 18 || small && 16 || 24,
      alignItems: "center",
      justifyContent: "center",
      ...hasContent && left && { mr: 1 },
      ...hasContent && right && { ml: 1.5 },
      children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
        Icon_default,
        {
          name: icon,
          size: regular && 24 || medium && 18 || small && 16 || 16,
          ...iconProps
        }
      )
    }
  );
}
var ButtonIcon_default = ButtonIcon;

// src/components/atoms/Button/Button.tsx
var import_jsx_runtime25 = require("react/jsx-runtime");
var getButtonHeight = ({ regular, medium, small }) => regular && 40 || medium && 32 || small && 24 || 40;
var getScale = ({ regular, medium, small }) => regular && 3 || medium && 2 || small && 1 || 3;
var variationsStyle = import_styled_components15.css`
  ${(props) => {
  const { theme, variation = "primary", colorVariation } = props;
  const { color: color2, outlineColor, hoverColor } = getButtonColors(props);
  const variations = {
    primary: import_styled_components15.css`
        background-color: ${color2};
        border: 1px solid ${color2};
        color: ${theme.colors.white};
        &:hover {
          background-color: ${hoverColor};
          border: 1px solid ${hoverColor};
          & p {
            color: ${colorVariation === "light" ? color2 : "inherit"};
          }
        }
        &:disabled {
          background-color: ${theme.colors.n60};
          border: 1px solid ${theme.colors.n60};
          cursor: not-allowed;
          color: ${theme.colors.white};
          & p {
            color: ${theme.colors.white};
          }
        }
        & p {
          color: ${colorVariation === "light" ? theme.colors.b50 : theme.colors.white};
        }
      `,
    outline: import_styled_components15.css`
        background-color: transparent;
        border: 1px solid ${color2};
        color: ${color2};
        &:hover {
          background-color: ${colorVariation === "light" ? hoverColor : outlineColor};
        }
        &:disabled {
          color: ${theme.colors.n60};
          border: 1px solid ${theme.colors.n60};
          cursor: not-allowed;
          & p {
            color: ${theme.colors.n60};
          }
        }
        & p {
          color: ${color2};
        }
      `,
    flat: import_styled_components15.css`
        background-color: transparent;
        color: ${color2};
        &:hover {
          background-color: ${outlineColor};
          color: ${color2};
          & p {
            color: ${color2};
          }
        }
        &:disabled {
          color: ${theme.colors.n60};
          cursor: not-allowed;
          & p {
            color: ${theme.colors.n60};
          }
        }
        & p {
          color: ${color2};
        }
      `
  };
  return variations[variation] || "";
}}
`;
var roundStyle = import_styled_components15.css`
  border-radius: 50%;
`;
var ButtonStyle = import_styled_components15.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  cursor: pointer;
  position: relative;
  ${textStyle}
  ${boxStyle}
  display: flex;
  align-items: center;
  justify-content: ${({ contentCentered }) => contentCentered ? "center" : "flex-start"};
  ${variationsStyle}
  ${({ theme }) => `border-radius:${2 * theme.space}px;`}
  ${({ round: round2 }) => round2 ? roundStyle : ""}
  border-radius: ${({ borderRadius }) => borderRadius}px;
  padding: ${({ theme, round: round2, square, ...props }) => round2 || square ? "unset" : `${theme.space}px ${theme.space * (1 + getScale(props))}px`};
`;
var ContentContainer = (0, import_styled_components15.default)(Flex_default)`
  max-width: 100%;
  visibility: ${({ isLoading }) => isLoading ? "collapse" : "inherit"};
  justify-content: ${({ contentCentered }) => contentCentered ? "center" : "flex-start"};
`;
var TextLabel = (0, import_styled_components15.default)(Text_default)`
  line-height: normal;
  font-size: inherit;
`;
function Button({
  children,
  w,
  h,
  square,
  variation = "primary",
  icon,
  iconProps,
  iconRight,
  iconRightProps,
  round: round2,
  regular,
  medium,
  small,
  onClick,
  isLoading,
  contentCentered = true,
  colorVariation,
  className,
  textLabelClassName,
  ...args
}) {
  const buttonSizes = { regular, medium, small };
  const height = h || getButtonHeight(buttonSizes);
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsxs)(
    ButtonStyle,
    {
      w: square || round2 ? height : w,
      h: height,
      square,
      variation,
      round: round2,
      icon,
      onClick,
      contentCentered,
      colorVariation,
      sm: small,
      className,
      ...args,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime25.jsxs)(
          ContentContainer,
          {
            alignItems: "center",
            contentCentered,
            isLoading,
            children: [
              icon && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
                ButtonIcon_default,
                {
                  left: true,
                  icon,
                  iconProps,
                  hasContent: !!children,
                  ...buttonSizes
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(TextLabel, { ellipsis: true, className: textLabelClassName, children }),
              iconRight && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
                ButtonIcon_default,
                {
                  right: true,
                  icon: iconRight,
                  iconProps: iconRightProps,
                  hasContent: !!children,
                  ...buttonSizes
                }
              )
            ]
          }
        ),
        isLoading && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
          Spinner_default,
          {
            pos: "absolute",
            color: colorVariation === "light" || variation === "outline" ? "#004c87" : "white",
            size: regular && 20 || medium && 15 || small && 14 || 20
          }
        )
      ]
    }
  );
}
var Button_default = Button;

// src/components/molecules/DashboardBanner/DashboardBanner.styles.ts
var BannerContainer2 = (0, import_styled_components16.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
var PaginationButton = (0, import_styled_components16.default)(Button_default)`
  background-color: ${({ background }) => background};
  color: ${({ color: color2 }) => color2};
  & p {
    color: ${({ color: color2 }) => color2};
  }

  :hover:not(:disabled) {
    background-color: ${({ background }) => background};
  }
`;
var PaginationDot = (0, import_styled_components16.default)(Box_default)`
  cursor: pointer;
  border-radius: 100%;
  background-color: ${({ theme, isActive }) => isActive ? theme.colors.b40 : theme.colors.b20};
`;
var ActionButton = (0, import_styled_components16.default)(Box_default)`
  cursor: pointer;

  p {
    white-space: nowrap;
  }
`;

// src/components/atoms/Banner/Banner.tsx
var import_styled_components17 = require("styled-components");
var import_react_i18next8 = require("react-i18next");
var import_jsx_runtime26 = require("react/jsx-runtime");
function Banner({
  message,
  type,
  onViewClick,
  onDismissClick,
  submitButtonLabel,
  ...args
}) {
  const theme = (0, import_styled_components17.useTheme)();
  const { t } = (0, import_react_i18next8.useTranslation)("pages");
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const { background, color: color2 } = BANNER_OPTIONS[type || "success" /* SUCCESS */];
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)(
    BannerContainer,
    {
      w: "100%",
      p: 3,
      backgroundColor: background,
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "flex-start" : "center",
      justifyContent: isMobile ? "center" : "space-between",
      ...args,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(Text_default, { color: color2, sm: true, semibold: true, children: message }),
        /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)(Flex_default, { alignItems: "center", mt: [3, 0, 0, 0], children: [
          onViewClick && /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
            ActionButton,
            {
              mr: 3,
              ml: [0, 3, 3, 3],
              onClick: () => onViewClick(),
              h: "fit-content",
              children: /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(Text_default, { color: color2, children: submitButtonLabel || t("dashboardPage.banner.view") })
            }
          ),
          onDismissClick && /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
            ActionButton,
            {
              onClick: () => onDismissClick(),
              h: "fit-content",
              children: /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
                Text_default,
                {
                  color: type === "warning" /* WARNING */ ? theme.colors.white : theme.colors.n70,
                  children: t("dashboardPage.banner.dismiss")
                }
              )
            }
          )
        ] })
      ]
    }
  );
}
var Banner_default = Banner;

// src/components/atoms/ButtonGroups/ButtonGroups.tsx
var import_styled_components18 = __toESM(require("styled-components"));
var orientationStyle = import_styled_components18.css`
  ${({ orientation }) => {
  const variations = {
    horizontal: import_styled_components18.css`
        &:last-child {
          border-right-width: 1px;
          border-top-right-radius: ${({ theme }) => `${2 * theme.space}px;`}
          border-bottom-right-radius: ${({ theme }) => `${2 * theme.space}px;`}
        }
        &:first-child {
          border-right-width: 1px;
          border-top-left-radius: ${({ theme }) => `${2 * theme.space}px;`}
          border-bottom-left-radius: ${({ theme }) => `${2 * theme.space}px;`}
        }
      `,
    vertical: import_styled_components18.css`
        &:first-child {
          border-bottom-width: 1px;
          border-top-right-radius: ${({ theme }) => `${2 * theme.space}px;`}
          border-top-left-radius: ${({ theme }) => `${2 * theme.space}px;`}
        }
        &:last-child {
          border-top-width: 1px;
          border-bottom-left-radius:   ${({ theme }) => `${2 * theme.space}px;`}
          border-bottom-right-radius:   ${({ theme }) => `${2 * theme.space}px;`}
        }
      `
  };
  return variations[orientation] || "";
}}
`;
var ButtonGroups = (0, import_styled_components18.default)(Flex_default)`
  border-radius: ${({ theme }) => `${2 * theme.space}px;`} 
  & button {
    border-right-width: 0;
    border-radius: 0;
    ${orientationStyle}
  }
`;
var ButtonGroups_default = ButtonGroups;

// src/components/atoms/Form/Form/Form.tsx
var import_styled_components51 = __toESM(require("styled-components"));

// src/components/atoms/Form/Input/Input.tsx
var import_react28 = __toESM(require("react"));
var import_styled_components19 = require("styled-components");
var import_jsx_runtime27 = require("react/jsx-runtime");
var Input = import_react28.default.forwardRef(
  ({
    children,
    disabled,
    icon,
    iconRight,
    iconRightProps,
    iconLeftProps,
    w = "inherit",
    onClick,
    ...args
  }, forwardRef4) => {
    const theme = (0, import_styled_components19.useTheme)();
    const pl = icon ? 9 : 2;
    const pr = iconRight ? 9 : 2;
    const width = typeof w === "number" ? w - theme.space * pl - theme.space * pr : w;
    return /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(BoxStyle, { onClick, w, children: [
      icon && /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
        IconStyle,
        {
          isPointer: Boolean(iconRightProps?.onClick),
          size: 16,
          ...iconLeftProps ? iconLeftProps : {},
          name: icon
        }
      ),
      iconRight && /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
        IconRightStyle,
        {
          isPointer: Boolean(iconRightProps?.onClick),
          size: 16,
          ...iconRightProps ? iconRightProps : {},
          name: iconRight
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
        InputStyle,
        {
          p: 2,
          disabled,
          ...args,
          pl,
          pr,
          w: width,
          ref: forwardRef4
        }
      )
    ] });
  }
);
var Input_default = Input;

// src/components/atoms/Form/Label/Label.tsx
var import_styled_components20 = __toESM(require("styled-components"));
var import_jsx_runtime28 = require("react/jsx-runtime");
var LabelStyle = import_styled_components20.default.label`
  ${textStyle};
  color: ${({ color: color2, theme }) => color2 || theme.colors.n80};
  width: 100%;
`;
function Label({ children, sm = true, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)(LabelStyle, { sm, ...args, children: [
    children,
    args.required && "*"
  ] });
}
var Label_default = Label;

// src/components/atoms/Form/Select/Select.tsx
var import_react31 = require("react");
var import_react_select2 = __toESM(require("react-select"));
var import_async = __toESM(require("react-select/async"));
var import_react_i18next10 = require("react-i18next");
var import_styled_components26 = require("styled-components");
var import_lodash9 = require("lodash");

// src/components/atoms/Form/Select/components/Menu.tsx
var import_react_i18next9 = require("react-i18next");
var import_react30 = require("react");
var import_styled_components24 = __toESM(require("styled-components"));

// src/components/atoms/Devider/Devider.tsx
var import_styled_components21 = __toESM(require("styled-components"));
var Devider = (0, import_styled_components21.default)(Box_default)`
  ${({ size = 1, orientation = "horizontal", theme, color: color2 }) => `
    border-bottom: ${orientation === "horizontal" ? size : 0}px solid  ${color2 || theme.colors.n20};
    border-right: ${orientation === "vertical" ? size : 0}px solid  ${color2 || theme.colors.n20};
  `}
`;
var Devider_default = Devider;

// src/components/atoms/Form/Checkbox/Checkbox.tsx
var import_react29 = require("react");
var import_styled_components23 = require("styled-components");

// src/components/atoms/Form/Checkbox/Checkbox.styles.ts
var import_styled_components22 = __toESM(require("styled-components"));
var disabledStyles = import_styled_components22.css`
  cursor: not-allowed;
  border: 1px solid ${({ theme }) => theme.colors.n50};
  background: ${({ theme }) => theme.colors.n20};
  :hover {
    border: 1px solid ${({ theme }) => theme.colors.n50};
  }
`;
var checkedStyles = import_styled_components22.css`
  background: ${({ theme }) => theme.colors.b50};
  border: none;
  :hover {
    background: ${({ theme }) => theme.colors.b50Hover};
  }
`;
var checkedDisabledStyles = import_styled_components22.css`
  background: ${({ theme }) => theme.colors.n60};
  border: none;
  :hover {
    background: ${({ theme }) => theme.colors.n60};
    border: none;
  }
`;
var CheckboxWrapper = (0, import_styled_components22.default)(Flex_default)`
  cursor: pointer;
`;
var StyledCheckbox = (0, import_styled_components22.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  border: 1px solid ${({ theme }) => theme.colors.n60};
  background: ${({ theme }) => theme.colors.white};

  :hover {
    border-color: ${({ theme }) => theme.colors.n70};
  }

  ${({ disabled }) => disabled && disabledStyles}
  ${({ checked }) => checked && checkedStyles}
  ${({ checked, disabled }) => checked && disabled && checkedDisabledStyles}  
  ${stateStyle}
`;
var StyledLabel = (0, import_styled_components22.default)(Text_default)`
  white-space: nowrap;
  color: ${({ theme, disabled }) => disabled ? theme.colors.n60 : theme.colors.n90};
`;

// src/components/atoms/Form/Checkbox/Checkbox.tsx
var import_jsx_runtime29 = require("react/jsx-runtime");
var Checkbox = ({
  disabled = false,
  label,
  checked = false,
  onChange,
  $errorType,
  size,
  ...args
}) => {
  const [isChecked, setIsChecked] = (0, import_react29.useState)(checked);
  const theme = (0, import_styled_components23.useTheme)();
  const onClick = (e) => {
    e.stopPropagation();
    const newIsChecked = !isChecked;
    if (!disabled) {
      setIsChecked(newIsChecked);
      if (onChange) {
        onChange(newIsChecked);
      }
    }
  };
  (0, import_react29.useEffect)(() => {
    setIsChecked(checked);
  }, [checked]);
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsxs)(CheckboxWrapper, { alignItems: "center", onClick, ...args, "data-testid": "checkbox", children: [
    /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
      StyledCheckbox,
      {
        mr: label ? 2 : 0,
        alignItems: "center",
        justifyContent: "center",
        checked: isChecked,
        disabled,
        $errorType,
        w: size || [18, 18, 24, 24],
        h: size || [18, 18, 24, 24],
        children: isChecked && /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(Icon_default, { size: [12, 12, 14, 14], name: "check", color: theme.colors.white })
      }
    ),
    label && /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(StyledLabel, { disabled, children: label })
  ] });
};
var Checkbox_default = Checkbox;

// src/components/atoms/Form/Select/components/Menu.tsx
var import_jsx_runtime30 = require("react/jsx-runtime");
var Container = (0, import_styled_components24.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 8px 24px -6px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.4);
  border-radius: ${({ theme }) => theme.space * 3}px;
  overflow-x: ${({ menuFixedWidth }) => menuFixedWidth ? "hidden" : "auto"};
  @media ${({ theme }) => theme.devices.mobile} {
    min-width: 160px;
    max-width: 100%;
  }
`;
var InputContainer = (0, import_styled_components24.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.white};
  top: 0;
`;
var inputCSS = import_styled_components24.css`
  border: unset;
  padding-left: 42px !important;
  &:hover {
    border: unset;
    box-shadow: unset;
  }
  &:focus {
    border: unset;
    box-shadow: unset;
  }
`;
var Menu = ({
  setSearchSlug,
  searchSlug,
  isSearchable,
  children,
  selectInputRef,
  inputPlaceholder,
  menuFixedWidth,
  isSelectAll,
  onSelectAll,
  isSelected,
  ...rest
}) => {
  const { t } = (0, import_react_i18next9.useTranslation)("common");
  const inputRef = (0, import_react30.useRef)(null);
  const theme = (0, import_styled_components24.useTheme)();
  (0, import_react30.useEffect)(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  (0, import_react30.useEffect)(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [searchSlug]);
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)(Container, { menuFixedWidth, flexDirection: "column", ...rest, children: [
    isSearchable && /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)(InputContainer, { w: "100%", flexDirection: "column", pos: "sticky", children: [
      /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
        Input_default,
        {
          w: "100%",
          h: 48,
          icon: "search",
          iconLeftProps: {
            color: theme.colors.n200,
            size: 24
          },
          ref: inputRef,
          value: searchSlug,
          placeholder: inputPlaceholder,
          onClick: () => {
            if (inputRef.current) {
              inputRef.current.focus();
            }
          },
          onChange: (e) => {
            setSearchSlug(e.target.value);
            if (selectInputRef.current) {
              const valueSetter = Object.getOwnPropertyDescriptor(
                selectInputRef.current,
                "value"
              )?.set;
              const prototype = Object.getPrototypeOf(selectInputRef.current);
              const prototypeValueSetter = Object.getOwnPropertyDescriptor(
                prototype,
                "value"
              )?.set;
              if (valueSetter && valueSetter !== prototypeValueSetter) {
                prototypeValueSetter?.call(selectInputRef.current, e.target.value);
              } else {
                valueSetter?.call(selectInputRef.current, e.target.value);
              }
              selectInputRef.current.dispatchEvent(new Event("input", { bubbles: true }));
            }
          },
          css: inputCSS
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Devider_default, { w: "100%" })
    ] }),
    isSelectAll && /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)(import_jsx_runtime30.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)(Flex_default, { px: 3, py: 2, alignItems: "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Checkbox_default, { size: 18, mr: 2, onChange: onSelectAll, checked: isSelected }),
        /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Text_default, { children: t("components.select.selectAll") })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Devider_default, { w: "100%" })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Flex_default, { flexDirection: "column", w: "100%", children })
  ] });
};
var Menu_default = Menu;

// src/components/atoms/Form/Select/components/SelectOption.tsx
var import_react_select = require("react-select");
var import_styled_components25 = __toESM(require("styled-components"));
var import_jsx_runtime31 = require("react/jsx-runtime");
var { Option } = import_react_select.components;
var TextContainer = (0, import_styled_components25.default)(Flex_default)`
  flex-grow: 0;
  overflow: hidden;
`;
var SelectOption = ({
  data,
  setValue,
  innerProps,
  isSelected,
  isMulti,
  closeDropdown,
  withCheckbox,
  ...props
}) => {
  const theme = (0, import_styled_components25.useTheme)();
  const { label } = data;
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
    Option,
    {
      data,
      innerProps: {
        ...innerProps,
        ...!isMulti ? {
          onClick: () => {
            if (!props.isDisabled) {
              setValue(data, "select-option");
              closeDropdown();
            }
          }
        } : {}
      },
      setValue,
      isSelected,
      isMulti,
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(Flex_default, { flex: 1, flexDirection: "row", alignItems: "center", children: [
        withCheckbox && isMulti && /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(Flex_default, { mr: 2.5, children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
          Checkbox_default,
          {
            size: 18,
            onClick: innerProps.onClick,
            checked: isSelected,
            disabled: props.isDisabled
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(TextContainer, { overflow: "hidden", children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
          Text_default,
          {
            className: "select__option__value",
            ellipsis: true,
            ...props.isDisabled && {
              color: theme.colors.n60,
              cursor: "not-allowed"
            },
            children: label
          }
        ) })
      ] })
    }
  );
};
var SelectOption_default = SelectOption;

// src/components/atoms/Form/Select/Select.tsx
var import_jsx_runtime32 = require("react/jsx-runtime");
var { Input: Input2, SingleValue, MenuPortal, MenuList, ClearIndicator } = import_react_select2.components;
var ChevronUp = () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Icon_default, { name: "chevronUp", size: 24 });
var ChevronDown = () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Icon_default, { name: "chevronDown", size: 24 });
var ReactSelect = ({
  isClearable = false,
  $errorType,
  valuePrefix = "",
  onChanged,
  options,
  disabled,
  value,
  defaultValue,
  isMulti = false,
  withCheckbox = true,
  isAsync = false,
  components: components8 = {},
  placeholder,
  isSearchable = true,
  leftIcon,
  leftIconColor,
  onMouseDown,
  inputValue,
  onMenuClose,
  loadOptions,
  inputPlaceholder,
  menuPortalTarget,
  menuPlacementHorizontal,
  menuFixedWidth = true,
  menuPosition = "absolute",
  menuPortalZIndex = 150,
  onClear,
  styles,
  w,
  h,
  disablePortalTarget,
  defaultOptions: defaultOptions2,
  isButtonSelect,
  strictMenuWidth,
  isSelectAll,
  valueContainerMaxWidth,
  buttonSelectType = "badge",
  showSelectedFirst = false,
  showCount = false,
  isActive,
  ...props
}) => {
  const { t } = (0, import_react_i18next10.useTranslation)("common", { keyPrefix: "labels" });
  const theme = (0, import_styled_components26.useTheme)();
  const [isOpen, setIsOpen] = (0, import_react31.useState)(false);
  const [selectedValue, setSelectedValue] = (0, import_react31.useState)(null);
  const [searchSlug, setSearchSlug] = (0, import_react31.useState)("");
  const boxProps = props;
  const [isClosable, setIsClosable] = (0, import_react31.useState)(false);
  const ref = (0, import_react31.useRef)(null);
  const refSelect = (0, import_react31.useRef)(null);
  const inputRef = (0, import_react31.useRef)(null);
  const menuPortalScrollTopRef = (0, import_react31.useRef)(0);
  const containerRef = (0, import_react31.useRef)(null);
  const [isAllOptionsSelected, setIsAllOptionsSelected] = (0, import_react31.useState)(false);
  const isOpenRef = (0, import_react31.useRef)(isOpen);
  const searchSlugRef = (0, import_react31.useRef)(searchSlug);
  const isAllOptionsSelectedRef = (0, import_react31.useRef)(isAllOptionsSelected);
  const isSelectAllOptionRef = (0, import_react31.useRef)(false);
  const isButtonSelectRef = (0, import_react31.useRef)(isButtonSelect);
  const shouldReorderRef = (0, import_react31.useRef)(true);
  const reorderedOptionsCacheRef = (0, import_react31.useRef)(null);
  const lastReorderedValueRef = (0, import_react31.useRef)(null);
  (0, import_react31.useEffect)(() => {
    if (!isOpen && isOpenRef.current) {
      shouldReorderRef.current = true;
    }
    isOpenRef.current = isOpen;
  }, [isOpen, showSelectedFirst]);
  (0, import_react31.useEffect)(() => {
    searchSlugRef.current = searchSlug;
    isAllOptionsSelectedRef.current = isAllOptionsSelected;
    isButtonSelectRef.current = isButtonSelect;
  }, [searchSlug, isAllOptionsSelected, isButtonSelect]);
  const getSelectValue = (0, import_react31.useCallback)(
    (currentValue) => {
      if (currentValue === void 0) {
        return selectedValue;
      }
      let _options = options;
      if (!options?.length && Array.isArray(defaultOptions2))
        _options = defaultOptions2;
      if (isMulti) {
        return selectedValue || _options?.filter(
          (item) => (currentValue || []).includes(item.value)
        );
      }
      return _options?.find((item) => item.value === currentValue);
    },
    [options, defaultOptions2, selectedValue]
  );
  const selectValue = getSelectValue(value);
  const selectDefaultValue = getSelectValue(defaultValue);
  useOnClickOutside(
    ref,
    (event) => {
      const elemId = event.target?.getAttribute("id");
      const isDropdownOption = elemId?.includes("price-range-option");
      if (isClosable && !isDropdownOption) {
        setIsOpen(false);
        setIsClosable(false);
        onMenuClose && onMenuClose();
      }
    },
    disablePortalTarget
  );
  (0, import_react31.useEffect)(() => {
    if (defaultValue === void 0 || value === void 0) {
      setSelectedValue(null);
    }
  }, [defaultValue, value]);
  (0, import_react31.useEffect)(() => {
    if (isOpen) {
      setIsClosable(true);
    } else {
      setSearchSlug("");
    }
  }, [isOpen]);
  const aggressivelyRestoreScrollPosition = (0, import_react31.useCallback)((scrollPosition) => {
    const getMenuElement = () => ref.current?.firstChild?.firstChild;
    const menuElement = getMenuElement();
    if (menuElement) {
      menuElement.scrollTop = scrollPosition;
    }
    requestAnimationFrame(() => {
      const menuElement2 = getMenuElement();
      if (menuElement2) {
        menuElement2.scrollTop = scrollPosition;
      }
    });
    setTimeout(() => {
      const menuElement2 = getMenuElement();
      if (menuElement2) {
        menuElement2.scrollTop = scrollPosition;
      }
    }, 0);
    setTimeout(() => {
      const menuElement2 = getMenuElement();
      if (menuElement2) {
        menuElement2.scrollTop = scrollPosition;
      }
    }, 10);
  }, []);
  const handleSelectValues = (record) => {
    let savedScroll = null;
    if (showSelectedFirst && isMulti && reorderedOptionsCacheRef.current) {
      if (ref.current?.firstChild?.firstChild) {
        savedScroll = ref.current.firstChild.firstChild.scrollTop;
        menuPortalScrollTopRef.current = savedScroll || 0;
      }
    }
    setSelectedValue(record);
    refSelect.current?.blur();
    if (savedScroll !== null) {
      aggressivelyRestoreScrollPosition(savedScroll);
    }
    if (onChanged) {
      if (isMulti) {
        return onChanged(
          "",
          record.map((item) => item.value)
        );
      }
      onChanged(record?.value);
      if ((0, import_lodash9.isNil)(record?.value)) {
        setSelectedValue(null);
      }
    }
  };
  const Select2 = isAsync ? import_async.default : import_react_select2.default;
  const {
    Option: OverwriteOption,
    DropdownIndicator: OverwriteDropdownIndicator,
    ...overwriteComponents
  } = components8;
  (0, import_react31.useLayoutEffect)(() => {
    const onMenuPortalScroll = (e) => {
      menuPortalScrollTopRef.current = e.target.scrollTop;
    };
    if (isOpen && isMulti) {
      setTimeout(() => {
        if (ref.current?.firstChild?.firstChild) {
          ref.current.firstChild.firstChild.addEventListener("scroll", onMenuPortalScroll);
        }
      });
    }
    return () => {
      if (ref.current?.firstChild?.firstChild) {
        ref.current.firstChild.firstChild.removeEventListener("scroll", onMenuPortalScroll);
      }
    };
  }, [ref, isOpen, isMulti]);
  (0, import_react31.useEffect)(() => {
    if (isMulti) {
      setTimeout(() => {
        if (ref.current?.firstChild?.firstChild) {
          ref.current.firstChild.firstChild.scrollTop = menuPortalScrollTopRef?.current || 0;
        }
      });
    }
  }, [selectedValue, isMulti]);
  const isSelectAllOption = (0, import_react31.useMemo)(
    () => isMulti && (value || defaultValue) && (options || defaultOptions2).every(
      (item) => (value || defaultValue)?.includes(item.value)
    ),
    [options, value, defaultValue]
  );
  isSelectAllOptionRef.current = isSelectAllOption;
  const placeholderValue = (0, import_react31.useMemo)(() => {
    if (disabled)
      return placeholder;
    let selectionCount = 0;
    if (isMulti && Array.isArray(value) && value.length > 0) {
      selectionCount = value.length;
    } else if (isMulti && Array.isArray(selectValue) && selectValue.length > 0) {
      selectionCount = selectValue.length;
    }
    if (selectionCount === 0)
      return placeholder;
    if (isMulti) {
      if (isButtonSelect) {
        if (showCount && selectionCount > 0) {
          return `${placeholder} (${selectionCount})`;
        }
        return placeholder;
      }
      return selectValue.map((sv) => sv?.label).join(", ");
    }
    return selectValue?.label;
  }, [disabled, options, selectedValue, isMulti, isButtonSelect, showCount, placeholder, value]);
  const onSelectAllStable = (0, import_react31.useCallback)(
    (selected) => {
      setIsAllOptionsSelected(selected);
      setSelectedValue(selected ? options || defaultOptions2 : []);
      if (onChanged) {
        onChanged(
          "",
          selected ? (options || (Array.isArray(defaultOptions2) ? defaultOptions2 : [])).map(
            (item) => item.value
          ) : []
        );
      }
    },
    [options, defaultOptions2, onChanged]
  );
  const onSelectAllRef = (0, import_react31.useRef)(onSelectAllStable);
  onSelectAllRef.current = onSelectAllStable;
  const [reorderedOptionsCache, setReorderedOptionsCache] = (0, import_react31.useState)(null);
  (0, import_react31.useEffect)(() => {
    if (!showSelectedFirst || !isMulti) {
      setReorderedOptionsCache(null);
      reorderedOptionsCacheRef.current = null;
      lastReorderedValueRef.current = null;
      return;
    }
    if (!options || !Array.isArray(options) || options.length === 0) {
      return;
    }
    const currentValues = value || defaultValue || [];
    const valueHasChanged = JSON.stringify(lastReorderedValueRef.current) !== JSON.stringify(currentValues);
    const shouldReorder = !isOpen && (shouldReorderRef.current || !reorderedOptionsCache || valueHasChanged);
    if (shouldReorder) {
      if (!Array.isArray(currentValues) || currentValues.length === 0) {
        setReorderedOptionsCache(options);
        reorderedOptionsCacheRef.current = options;
        lastReorderedValueRef.current = currentValues;
        shouldReorderRef.current = false;
        return;
      }
      const selectedOptions = [];
      const unselectedOptions = [];
      options.forEach((option) => {
        if (currentValues.includes(option.value)) {
          selectedOptions.push(option);
        } else {
          unselectedOptions.push(option);
        }
      });
      selectedOptions.sort((a, b) => a.label.localeCompare(b.label));
      const reordered = [...selectedOptions, ...unselectedOptions];
      setReorderedOptionsCache(reordered);
      reorderedOptionsCacheRef.current = reordered;
      lastReorderedValueRef.current = currentValues;
      shouldReorderRef.current = false;
    }
  }, [showSelectedFirst, isOpen, isMulti, options, value, defaultValue]);
  const optionsToUse = showSelectedFirst && reorderedOptionsCache ? reorderedOptionsCache : options;
  const closeDropdown = (0, import_react31.useCallback)(() => {
    setIsOpen(false);
    setIsClosable(false);
    setSearchSlug("");
  }, []);
  const memoizedComponents = (0, import_react31.useMemo)(
    () => ({
      DropdownIndicator: () => {
        if (OverwriteDropdownIndicator) {
          return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(OverwriteDropdownIndicator, { isOpen: isOpenRef.current });
        }
        return isOpenRef.current ? /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(ChevronUp, {}) : /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(ChevronDown, {});
      },
      ClearIndicator: ({ innerProps, ...props2 }) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
        ClearIndicator,
        {
          innerProps: { ...innerProps, onMouseDown: onClear || innerProps.onMouseDown },
          ...props2,
          children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Icon_default, { name: "close", size: 20, color: theme.colors.r20 })
        }
      ),
      MenuList: ({ children, ...props2 }) => {
        return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(MenuList, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
          Menu_default,
          {
            w: strictMenuWidth ? containerRef.current?.clientWidth : void 0,
            menuFixedWidth,
            isSearchable,
            searchSlug,
            setSearchSlug,
            selectInputRef: inputRef,
            inputPlaceholder: inputPlaceholder || "Search...",
            isSelectAll,
            isSelected: isAllOptionsSelectedRef.current || isSelectAllOptionRef.current,
            onSelectAll: (selected) => onSelectAllRef.current(selected),
            children
          }
        ) });
      },
      MenuPortal: ({ children, innerProps, ...rest }) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(MenuPortal, { innerProps: { ...innerProps, ref }, ...rest, children }),
      Option: OverwriteOption ? (props2) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
        OverwriteOption,
        {
          ...props2,
          closeDropdown
        }
      ) : (props2) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
        SelectOption_default,
        {
          ...props2,
          withCheckbox,
          closeDropdown
        }
      ),
      Input: (props2) => {
        return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
          Input2,
          {
            ...props2,
            value: inputValue ? props2.value : "",
            innerRef: (ref2) => {
              if (props2.innerRef) {
                props2.innerRef(ref2);
              }
              if (isAsync) {
                inputRef.current = ref2;
              }
            }
          }
        );
      },
      // MultiValue renders each selected item in the control.
      // Returns null in button select mode to prevent items from rendering in the hidden control,
      // which would cause the dropdown width to grow. Button select displays a badge/button overlay instead.
      MultiValue: ({ data, index: index2 }) => isButtonSelectRef.current ? null : /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(import_jsx_runtime32.Fragment, { children: `${index2 !== 0 ? " / " : ""}${data.label}` }),
      SingleValue: (props2) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(SingleValue, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)(Text_default, { ellipsis: true, children: [
        valuePrefix,
        " ",
        props2.data.label
      ] }) }),
      LoadingIndicator: () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Spinner_default, { size: 14 }),
      NoOptionsMessage: () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Flex_default, { h: 42, w: "100%", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Text_default, { color: theme.colors.n70, children: t`noOptions` }) }),
      LoadingMessage: () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Flex_default, { h: 42, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Text_default, { color: theme.colors.n70, children: t`loading` }) }),
      ...overwriteComponents
    }),
    // searchSlug is included to allow Menu's useEffect to respond to changes
    // Other values use refs to avoid unnecessary component recreation
    [searchSlug]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)(
    StyledSelectWrapper,
    {
      leftIcon,
      ref: containerRef,
      alignItems: "center",
      isMulti,
      $errorType,
      isButtonSelect,
      onMouseDown: (e) => {
        if (!disabled) {
          if (onMouseDown) {
            onMouseDown(e);
          }
          setIsOpen(true);
        }
      },
      w,
      h,
      ...boxProps,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
          Select2,
          {
            ref: refSelect,
            filterOption: (0, import_react_select2.createFilter)({ matchFrom: "any", stringify: (option) => `${option.label}` }),
            options: optionsToUse,
            menuPortalTarget: disablePortalTarget ? void 0 : menuPortalTarget || document.body,
            menuPlacement: "auto",
            menuPosition,
            placeholder: placeholderValue,
            ...props,
            isMulti,
            isClearable,
            defaultValue: selectDefaultValue,
            value: !disabled ? selectValue : null,
            inputValue: inputValue || searchSlug,
            classNamePrefix: "select",
            isDisabled: disabled,
            onChange: handleSelectValues,
            closeMenuOnSelect: !isMulti,
            hideSelectedOptions: false,
            styles: {
              menuPortal: (base) => ({
                ...base,
                zIndex: menuPortalZIndex,
                ...menuPlacementHorizontal === "right" ? { display: "flex", justifyContent: "end" } : {}
              }),
              valueContainer: (base) => ({
                ...base,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: valueContainerMaxWidth
              }),
              // Prevent iOS Safari zoom on focus (requires 16px minimum)
              input: (base) => ({ ...base, fontSize: "16px" }),
              ...styles
            },
            menuIsOpen: isOpen,
            onFocus: () => !disabled && setIsOpen(true),
            isSearchable,
            components: memoizedComponents,
            menuShouldScrollIntoView: false,
            loadOptions,
            defaultOptions: defaultOptions2
          }
        ),
        leftIcon && /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(StyledLeftIconContainer, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Icon_default, { name: leftIcon, color: leftIconColor, size: 24 }) }),
        isButtonSelect && /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Box_default, { pos: "absolute", w: w || "100%", children: buttonSelectType === "badge" ? /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
          StyledBadge,
          {
            h: boxProps.h || 40,
            title: (placeholderValue || "").toString(),
            sm: false,
            py: 2,
            px: 4,
            w: "100%",
            whiteSpace: "nowrap",
            iconRight: isOpen ? "arrowUp" : "arrowDown",
            cursor: "pointer",
            $isActive: isActive
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
          Button_default,
          {
            variation: "outline",
            w,
            iconRight: isOpen ? "arrowUp" : "arrowDown",
            iconRightProps: { size: 20 },
            children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Box_default, { w: w ? +w - 50 : "100%", overflow: "hidden", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Text_default, { color: "inherit", ellipsis: true, children: placeholderValue }) })
          }
        ) })
      ]
    }
  );
};
var Select_default = ReactSelect;

// src/components/atoms/Form/InputPassword/InputPassword.tsx
var import_react32 = require("react");
var import_jsx_runtime33 = require("react/jsx-runtime");
function InputPassword({ onChange, value, ...args }) {
  const inputRef = (0, import_react32.useRef)(null);
  const [isShow, setIsShow] = (0, import_react32.useState)(false);
  const [isWithValue, setIsWithValue] = (0, import_react32.useState)(false);
  const onIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsShow(!isShow);
    if (inputRef.current) {
      setTimeout(() => {
        if (inputRef.current) {
          const end = inputRef.current.value.length || 0;
          inputRef.current.setSelectionRange(end, end);
          inputRef.current.focus();
        }
      }, 0);
    }
  };
  const onChangeSpy = (e) => {
    setIsWithValue(Boolean(e.target.value.length));
    if (onChange) {
      onChange(e);
    }
  };
  const iconName = isShow ? "hide" : "show";
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
    Input_default,
    {
      ref: inputRef,
      type: isShow ? "text" : "password",
      iconRight: value || isWithValue ? iconName : void 0,
      value,
      iconRightProps: value || isWithValue ? {
        onClick: onIconClick
      } : void 0,
      onChange: onChangeSpy,
      ...args
    }
  );
}
var InputPassword_default = InputPassword;

// src/components/atoms/Form/InputPrice/InputPrice.tsx
var import_react33 = __toESM(require("react"));
var import_react_i18next11 = require("react-i18next");
var import_dash_common13 = require("dash-common");
var import_react_text_mask = __toESM(require("react-text-mask"));
var import_text_mask_addons = require("text-mask-addons");
var import_lodash10 = require("lodash");
var import_jsx_runtime34 = require("react/jsx-runtime");
var defaultMaskOptions = {
  suffix: "",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ",",
  allowDecimal: true,
  decimalSymbol: ".",
  decimalLimit: import_dash_common13.DashValidation.CurrencyDecimalLimit,
  // how many digits allowed after the decimal
  allowNegative: false,
  allowLeadingZeroes: false
};
var InputPrice = import_react33.default.forwardRef(
  ({
    onChangeValue,
    value,
    maskOptions = {},
    innerRef,
    onChange,
    disabled,
    label = "max",
    anyPrice = false,
    ...args
  }, forwardRef4) => {
    const { t } = (0, import_react_i18next11.useTranslation)("forms");
    const anyPriceLabel = t("labels.anyPrice");
    const currencyMask = (0, import_text_mask_addons.createNumberMask)({
      prefix: "$",
      ...defaultMaskOptions,
      ...maskOptions
    });
    const getMask = () => {
      if (disabled)
        return false;
      if (label === "max" && value === "Any Price")
        return false;
      return currencyMask;
    };
    const getValue = () => {
      if (anyPrice)
        return anyPriceLabel;
      if (label === "max" && value === "Any Price")
        return anyPriceLabel;
      return value;
    };
    const getNewValue = (v) => {
      if ((0, import_lodash10.isNil)(v))
        return void 0;
      if (v === "Any Price" || v === anyPriceLabel)
        return "Any Price";
      const newValue = parseFloat(v.replace(/[^0-9.]/g, ""));
      if (isNaN(newValue))
        return void 0;
      return newValue;
    };
    return /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
      import_react_text_mask.default,
      {
        ref: (_ref) => {
          if (forwardRef4) {
            forwardRef4.current = _ref?.inputElement;
          }
          if (innerRef) {
            innerRef.current = _ref;
          }
        },
        mask: getMask(),
        disabled,
        render: (ref, props) => /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
          Input_default,
          {
            ref,
            ...props,
            ...args,
            value: getValue(),
            onChange: (event) => {
              const newValue = getNewValue(event.target.value);
              if (onChangeValue) {
                onChangeValue(newValue);
              }
              props.onChange && props.onChange(event);
              onChange && onChange(event);
            }
          }
        )
      }
    );
  }
);
var InputPrice_default = InputPrice;

// src/components/atoms/Form/Group/Group.tsx
var import_styled_components27 = __toESM(require("styled-components"));
var Group = (0, import_styled_components27.default)(Box_default)``;
var Group_default = Group;

// src/components/atoms/Form/Feedback/Feedback.tsx
var import_styled_components28 = __toESM(require("styled-components"));
var import_jsx_runtime35 = require("react/jsx-runtime");
var stateStyle2 = import_styled_components28.css`
  ${({ theme, $errorType }) => {
  const states = {
    ["info" /* Info */]: import_styled_components28.css`
        color: ${theme.colors.b50};
      `,
    ["valid" /* Valid */]: import_styled_components28.css`
        color: ${theme.colors.g20};
      `,
    ["invalid" /* Invalid */]: import_styled_components28.css`
        color: ${theme.colors.r20};
      `
  };
  return $errorType ? states[$errorType] : "display: none;";
}}
`;
var FeedbackStyle = import_styled_components28.default.div`
  ${boxStyle};
  ${textStyle};
  ${stateStyle2};
  width: 100%;
`;
function Label2({ children, sm = true, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(FeedbackStyle, { sm, ...args, children });
}
var Feedback_default = Label2;

// src/components/atoms/Form/InputSearch/InputSearch.tsx
var import_react34 = __toESM(require("react"));
var import_styled_components30 = require("styled-components");

// src/components/atoms/Form/InputSearch/InputSearch.styles.tsx
var import_styled_components29 = __toESM(require("styled-components"));
var SearchContainer = (0, import_styled_components29.default)(Flex_default)`
  .clear-icon {
    border: 1px solid ${({ theme }) => theme.colors.b50};
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 50%;
  }
`;

// src/components/atoms/Form/InputSearch/InputSearch.tsx
var import_jsx_runtime36 = require("react/jsx-runtime");
var InputSearch = import_react34.default.forwardRef(({
  onChange,
  onClear,
  value,
  placeholder,
  css: css33,
  inputVariation,
  showIcon = true,
  ...args
}, forwardRef4) => {
  const theme = (0, import_styled_components30.useTheme)();
  const [isValue, setIsValue] = (0, import_react34.useState)(false);
  const onSearchChange = (event) => {
    setIsValue(!!event.target.value.length);
    if (onChange)
      onChange(event);
  };
  const onClearClick = () => {
    setIsValue(false);
    onClear();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(SearchContainer, { ...args, children: /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
    Input_default,
    {
      ref: forwardRef4,
      ...showIcon && { icon: "search" },
      inputVariation,
      iconLeftProps: {
        color: isValue ? theme.colors.black : theme.colors.n70,
        size: 24
      },
      ...isValue && {
        iconRight: "close",
        iconRightProps: {
          onClick: onClearClick,
          color: theme.colors.b50,
          className: "clear-icon",
          p: 1
        }
      },
      value,
      onChange: onSearchChange,
      placeholder,
      css: css33
    }
  ) });
});
var InputSearch_default = InputSearch;

// src/components/atoms/Form/InputGroup/InputGroup.tsx
var import_react35 = __toESM(require("react"));
var import_styled_components31 = __toESM(require("styled-components"));
var import_jsx_runtime37 = require("react/jsx-runtime");
var LeftContainer = (0, import_styled_components31.default)(Flex_default)`
  position: absolute;
  cursor: default;
  top: 0;
  bottom: 0;
  margin: auto;
  background-color: ${({ theme }) => theme.colors.n20};
  color: ${({ theme }) => theme.colors.n80};
  height: calc(100% - 2px);
  left: 1px;
  border-top-left-radius: ${({ theme }) => theme.space * 2}px;
  border-bottom-left-radius: ${({ theme }) => theme.space * 2}px;
  border-right: 1px solid ${({ theme }) => theme.colors.n60};
`;
var BoxStyle2 = (0, import_styled_components31.default)(Box_default)`
  position: relative;
  &:hover {
    & > div {
      border-right: 1px solid ${({ theme }) => theme.colors.b40};
    }
  }
  &:has(input:focus) {
    & > div {
      border-right: 1px solid ${({ theme }) => theme.colors.n40};
    }
  }
`;
var InputGroup = import_react35.default.forwardRef(
  ({ children, disabled, w = "inherit", onClick, LeftGroup, ...args }, forwardRef4) => {
    const theme = (0, import_styled_components31.useTheme)();
    const leftContainerWidth = 80;
    const width = typeof w === "number" ? w - leftContainerWidth : w;
    return /* @__PURE__ */ (0, import_jsx_runtime37.jsxs)(BoxStyle2, { onClick, w, children: [
      /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(LeftContainer, { w: leftContainerWidth, children: LeftGroup }),
      /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
        InputStyle,
        {
          p: 2,
          disabled,
          ...args,
          pl: leftContainerWidth / theme.space + 2,
          w: width,
          ref: forwardRef4
        }
      )
    ] });
  }
);
var InputGroup_default = InputGroup;

// src/components/atoms/Form/InputPhone/InputPhone.tsx
var import_react39 = require("react");
var import_react_text_mask2 = __toESM(require("react-text-mask"));
var import_country_list_with_dial_code_and_flag2 = __toESM(require("country-list-with-dial-code-and-flag"));

// src/components/atoms/DropDown/DropDown.tsx
var import_react36 = require("react");
var import_styled_components32 = __toESM(require("styled-components"));
var import_jsx_runtime38 = require("react/jsx-runtime");
var import_react37 = require("react");
var Container2 = (0, import_styled_components32.default)(Box_default)`
  display:inline-block;
  cursor: pointer;
  height: inherit;
`;
var ButtonItemStyle = import_styled_components32.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  cursor: pointer;
  ${textStyle}
  ${boxStyle}
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  width: max-content;

  ${({ theme, disabled }) => disabled && `
    color: ${theme.colors.n60};
    cursor: not-allowed;
  `}
`;
var StyleButtonLight = (0, import_styled_components32.default)(Button_default)`
    & > div {
      width: 100%;
    }
  `;
function Dropdown({
  Anchor,
  children,
  onToggle,
  variant = "light",
  trigger = "click",
  placement = "auto",
  placementHorizontal = "right",
  items = [],
  optionsStyle = {},
  rerender,
  ...args
}) {
  const id2 = (0, import_react36.useId)();
  const refBox = (0, import_react36.useRef)(null);
  const { isOpen, setIsOpen, refOptions, handlePosition, setConfig, config, setChildren, setItems } = (0, import_react36.useContext)(DropdownContext);
  (0, import_react36.useEffect)(() => {
    setConfig((state) => ({
      ...state,
      id: id2,
      variant,
      trigger,
      optionsStyle
    }));
  }, []);
  useOnClickOutside(refOptions, (e) => {
    if (e.target.matches(".select__option__value"))
      return;
    if (trigger === "click")
      setIsOpen(false);
  });
  const LightContainerItems = () => /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Box_default, { children: items.map(({ key, icon, onClick, children: itemChildren, ...rest }) => /* @__PURE__ */ (0, import_react37.createElement)(
    StyleButtonLight,
    {
      w: 124,
      medium: true,
      ...rest,
      variation: "flat",
      minWidth: "unset",
      key,
      icon,
      onClick: (e) => {
        if (onClick) {
          onClick(e);
          setIsOpen(false);
        }
      }
    },
    itemChildren
  )) });
  const DarkContainerItems = () => /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Box_default, { children: items.map(({ key, icon, onClick, children: itemChildren, disabled }) => /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
    ButtonItemStyle,
    {
      px: 4,
      py: 2,
      disabled,
      onClick: (e) => {
        if (!disabled && onClick) {
          onClick(e);
          setIsOpen(false);
        }
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)("div", { style: { display: "flex", alignItems: "center" }, children: [
        icon && /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Icon_default, { name: icon, mr: 2, size: 22 }),
        itemChildren
      ] })
    },
    key
  )) });
  const ItemsMap = {
    light: LightContainerItems,
    dark: DarkContainerItems
  };
  const handleOpenDropdown = () => {
    setConfig((state) => ({
      ...state,
      id: id2,
      variant,
      trigger,
      optionsStyle
    }));
    const Items = ItemsMap[variant];
    if (items.length > 0) {
      setChildren(() => Items);
    } else {
      setItems([]);
      setChildren(() => children);
    }
    setIsOpen(true);
  };
  const thisHandlePosition = (0, import_react36.useCallback)(() => {
    const elemBox = refBox.current;
    const rectBox = elemBox.getBoundingClientRect();
    const elemOptions = refOptions.current;
    const rectOptions = elemOptions.getBoundingClientRect();
    handlePosition({
      rectBox,
      rectOptions,
      placement,
      placementHorizontal,
      newItems: items
    });
  }, [items]);
  (0, import_react36.useEffect)(() => {
    if (isOpen && config.id === id2) {
      handleOpenDropdown();
    }
  }, [rerender]);
  (0, import_react36.useLayoutEffect)(() => {
    if (isOpen && config.id === id2) {
      thisHandlePosition();
    }
  }, [isOpen]);
  const onContainerClick = (e) => {
    e.stopPropagation();
    handleOpenDropdown();
  };
  const containerProps = trigger === "click" || trigger === "none" ? { onClick: onContainerClick } : { onMouseEnter: () => {
    handleOpenDropdown();
    thisHandlePosition();
  } };
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Flex_default, { w: "100%", justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Container2, { ref: refBox, ...containerProps, ...args, children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Anchor, { isOpen: isOpen && config.id === id2, onClick: () => handleOpenDropdown() }) }) });
}
var DropDown_default = Dropdown;

// src/components/atoms/DropDown/DropdownOptions.tsx
var import_react38 = require("react");
var import_styled_components33 = __toESM(require("styled-components"));
var import_lodash11 = require("lodash");
var import_jsx_runtime39 = require("react/jsx-runtime");
var OptionsContainer = (0, import_styled_components33.default)(Box_default)`
  position: absolute;
  z-index: 120;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: ${({ theme }) => theme.space * 2}px;
  overflow-y: auto;
`;
function DropdownOptions() {
  const { refOptions, isOpen, setIsOpen, children, config } = (0, import_react38.useContext)(DropdownContext);
  const contentTypeMap = () => {
    if (!(0, import_lodash11.isNil)(children)) {
      return children({ closeDropdown: () => setIsOpen(false) });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("div", {});
  };
  const containerProps = config.trigger === "hover" ? { onMouseLeave: () => setIsOpen(false) } : {};
  return /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
    OptionsContainer,
    {
      ...containerProps,
      style: { display: isOpen ? "flex" : "none", ...config.optionsStyle },
      py: 2,
      ref: refOptions,
      children: contentTypeMap()
    }
  );
}
var DropdownOptions_default = DropdownOptions;

// src/components/atoms/Form/InputPhone/InputPhone.constants.ts
var import_country_list_with_dial_code_and_flag = __toESM(require("country-list-with-dial-code-and-flag"));
var PhoneInputMask = [
  "(",
  /[1-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/
];
var DEFAULT_COUNTRY = import_country_list_with_dial_code_and_flag.default.findOneByCountryCode("US");
if (!DEFAULT_COUNTRY && process.env.NODE_ENV === "development") {
  console.error("Failed to load US country data from country-list library");
}
var getCountryList = () => {
  const countryList = [...import_country_list_with_dial_code_and_flag.default.getAll()];
  if (!DEFAULT_COUNTRY) {
    return countryList;
  }
  const usIndex = countryList.findIndex((country) => country.code === DEFAULT_COUNTRY.code);
  if (usIndex !== -1) {
    countryList.splice(usIndex, 1);
    countryList.splice(0, 0, DEFAULT_COUNTRY);
  }
  return countryList;
};

// src/components/atoms/Form/InputPhone/components/FlagCodeItem.component.tsx
var import_styled_components34 = require("styled-components");
var import_flag_svg = __toESM(require("country-list-with-dial-code-and-flag/dist/flag-svg"));
var import_dompurify = __toESM(require("dompurify"));
var import_jsx_runtime40 = require("react/jsx-runtime");
var FlagCodeItem = ({ country }) => {
  const theme = (0, import_styled_components34.useTheme)();
  const flag = country?.code ? import_flag_svg.default[country.code] : void 0;
  const sanitizedFlag = flag ? import_dompurify.default.sanitize(flag, { USE_PROFILES: { svg: true } }) : void 0;
  return /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)(Flex_default, { alignItems: "center", justifyContent: "center", h: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Box_default, { ml: 1, mr: 1, children: sanitizedFlag ? /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("div", { style: { width: 20 }, dangerouslySetInnerHTML: { __html: sanitizedFlag } }) : /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Text_default, { md: true, children: country?.flag }) }),
    /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Box_default, { children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Text_default, { ellipsis: true, sm: true, color: theme.colors.n80, children: country?.code }) })
  ] });
};
var FlagCodeItem_component_default = FlagCodeItem;

// src/components/atoms/Form/InputPhone/InputPhone.tsx
var import_jsx_runtime41 = require("react/jsx-runtime");
var countryLists = getCountryList();
var InputPhone = ({ onChangePhoneValue, dialCode, number, ...args }) => {
  const [numberValue, setNumberValue] = (0, import_react39.useState)(number);
  const [selectedCountry, setSelectedCountry] = (0, import_react39.useState)(
    DEFAULT_COUNTRY
  );
  const [rawEntry, setRawEntry] = (0, import_react39.useState)(number);
  (0, import_react39.useEffect)(() => {
    if (onChangePhoneValue && (numberValue || numberValue === "")) {
      onChangePhoneValue({
        dialCode: selectedCountry?.dial_code,
        number: numberValue,
        isUSCodeSelected: selectedCountry?.dial_code === DEFAULT_COUNTRY?.dial_code
      });
    }
  }, [numberValue, selectedCountry, rawEntry]);
  (0, import_react39.useEffect)(() => {
    if (number || number === "") {
      setNumberValue(number);
    }
  }, [number]);
  (0, import_react39.useEffect)(() => {
    if (dialCode) {
      const country = import_country_list_with_dial_code_and_flag2.default.findOneByDialCode(dialCode);
      if (country) {
        setSelectedCountry(country);
      }
    }
  }, [dialCode]);
  const onItemClick = (0, import_react39.useCallback)(
    (country) => {
      setSelectedCountry(country);
      if (country.dial_code !== selectedCountry?.dial_code) {
        setNumberValue("");
      }
    },
    [setSelectedCountry, selectedCountry]
  );
  const items = (0, import_react39.useMemo)(
    () => countryLists.map((country) => ({
      w: 80,
      minHeight: 40,
      key: country.code,
      type: "button",
      children: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(FlagCodeItem_component_default, { country }),
      onClick: () => onItemClick(country)
    })),
    [onItemClick]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
    import_react_text_mask2.default,
    {
      mask: PhoneInputMask,
      value: numberValue,
      guide: false,
      render: (ref, props) => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
        InputGroup_default,
        {
          ref,
          LeftGroup: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(Flex_default, { h: "inherit", w: "inherit", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            DropDown_default,
            {
              placement: "bottom",
              Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(FlagCodeItem_component_default, { country: selectedCountry }),
              items,
              optionsStyle: {
                maxHeight: "35vh"
              }
            }
          ) }),
          ...props,
          ...args,
          onChange: (event) => {
            const rawValue = event.target.value;
            setRawEntry(rawValue);
            const numericValue = rawValue.replace(/\D+/g, "");
            setNumberValue(numericValue);
          }
        }
      )
    }
  );
};
var InputPhone_default = InputPhone;

// src/components/atoms/Form/FileUpload/FileUpload.tsx
var import_styled_components42 = __toESM(require("styled-components"));

// src/components/atoms/Form/FileUpload/SingleUpload/SingleUpload.tsx
var import_react41 = require("react");
var import_dash_common18 = require("dash-common");

// src/components/atoms/Form/FileUpload/components/ItemUpload/ItemUpload.tsx
var import_lodash12 = require("lodash");
var import_styled_components37 = require("styled-components");
var import_react_i18next12 = require("react-i18next");
var import_dash_common16 = require("dash-common");

// src/components/atoms/ProgressBar/ProgressBar.styles.tsx
var import_styled_components35 = __toESM(require("styled-components"));
var ProgressContainer = (0, import_styled_components35.default)(Box_default)`
  flex: 1;
  overflow: hidden;
`;
var ProgressLineContainer = (0, import_styled_components35.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;
var Progress = import_styled_components35.default.div`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background-color: ${({ theme }) => theme.colors.b50};
  border-radius: inherit;
  text-align: right;
  transition: width 1s ease-in-out;
`;
var ProgressLabel = (0, import_styled_components35.default)(Box_default)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${textStyle}
  color: ${({ theme, color: color2 }) => color2 || theme.colors.b50};
`;
var ProgressWrapper = (0, import_styled_components35.default)(Flex_default)`
  overflow: hidden;
  flex: 1;
`;

// src/components/atoms/ProgressBar/ProgressBar.tsx
var import_jsx_runtime42 = require("react/jsx-runtime");
function ProgressBar({ progress, label, labelColor, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(ProgressWrapper, { alignItems: "center", ...args, style: { overflow: "hidden", flex: 1 }, children: [
    /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(ProgressContainer, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(ProgressLabel, { title: label, color: labelColor, mb: 1, children: label }),
      /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(ProgressLineContainer, { w: "100%", h: 4, children: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(Progress, { progress }) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(ProgressLabel, { ml: 4, children: [
      progress.toFixed(2),
      "%"
    ] })
  ] });
}
var ProgressBar_default = ProgressBar;

// src/components/atoms/Form/FileUpload/components/ItemUpload/ItemUpload.constants.ts
var import_dash_common14 = require("dash-common");
var STATUS_TO_ICON_RELATIONS = {
  [import_dash_common14.ProgressTrackingFileStatusesEnum.INITIALIZATION]: "close",
  [import_dash_common14.ProgressTrackingFileStatusesEnum.UPLOADING]: "close",
  [import_dash_common14.ProgressTrackingFileStatusesEnum.UPLOADED]: "check",
  [import_dash_common14.ProgressTrackingFileStatusesEnum.ABORTED]: "cancel",
  [import_dash_common14.ProgressTrackingFileStatusesEnum.ERROR]: "close"
};

// src/components/atoms/Form/FileUpload/components/ItemUpload/ItemUpload.styles.tsx
var import_dash_common15 = require("dash-common");
var import_styled_components36 = __toESM(require("styled-components"));
var iconWrapperStyle = import_styled_components36.css`
  ${({ theme, status }) => {
  const statusStyleRelations = {
    [import_dash_common15.ProgressTrackingFileStatusesEnum.INITIALIZATION]: import_styled_components36.css`
        color: ${theme.colors.b50};
        border: 1px solid ${theme.colors.b50};
        background-color: ${theme.colors.white};
      `,
    [import_dash_common15.ProgressTrackingFileStatusesEnum.UPLOADING]: import_styled_components36.css`
        color: ${theme.colors.b50};
        border: 1px solid ${theme.colors.b50};
        background-color: ${theme.colors.white};
      `,
    [import_dash_common15.ProgressTrackingFileStatusesEnum.UPLOADED]: import_styled_components36.css`
        color: ${theme.colors.g20};
        cursor: default;
      `,
    [import_dash_common15.ProgressTrackingFileStatusesEnum.ABORTED]: import_styled_components36.css`
        color: ${theme.colors.n70};
        cursor: default;
      `,
    [import_dash_common15.ProgressTrackingFileStatusesEnum.ERROR]: import_styled_components36.css`
        color: ${theme.colors.r20};
        border: 1px solid ${theme.colors.r20};
        background-color: ${theme.colors.white};
      `
  };
  return statusStyleRelations[status] || "";
}}
`;
var ItemUploadWrapper = (0, import_styled_components36.default)(Flex_default)`
  overflow: hidden;
  position: relative;
  border-top: ${({ multiple, theme }) => multiple ? `1px solid ${theme.colors.n20}` : "none"};

  ${({ isHovered, theme }) => isHovered && `
    :hover {
      background-color: ${theme.colors.g10};
      & > div > button {
        display: flex;
      }
    }
  `};
`;
var IconWrapper = import_styled_components36.default.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  padding: 7px;
  cursor: pointer;
  margin-right: 16px;
  ${iconWrapperStyle}
`;
var OverflowContainer = (0, import_styled_components36.default)(Flex_default)`
  overflow: hidden;
`;
var FileLabel = (0, import_styled_components36.default)(Text_default)`
  color: ${({ theme, status }) => {
  if (status === import_dash_common15.ProgressTrackingFileStatusesEnum.ERROR)
    return theme.colors.r20;
  if (status === import_dash_common15.ProgressTrackingFileStatusesEnum.UPLOADED)
    return theme.colors.g20;
  return theme.colors.black;
}};
`;
var ClearButton = (0, import_styled_components36.default)(Button_default)`
  display: none;
`;

// src/components/atoms/Form/FileUpload/components/ItemUpload/ItemUpload.tsx
var import_jsx_runtime43 = require("react/jsx-runtime");
function ItemUpload({
  multiple,
  progress,
  filename,
  status,
  messages,
  onAbort,
  onReject,
  onClear
}) {
  const { t, i18n } = (0, import_react_i18next12.useTranslation)(["common", "forms"]);
  const theme = (0, import_styled_components37.useTheme)();
  const isError = multiple && status === import_dash_common16.ProgressTrackingFileStatusesEnum.ERROR;
  const isUploading = multiple && status !== import_dash_common16.ProgressTrackingFileStatusesEnum.UPLOADING;
  const isInitialization = status === import_dash_common16.ProgressTrackingFileStatusesEnum.INITIALIZATION;
  const iconName = STATUS_TO_ICON_RELATIONS[status];
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
    ItemUploadWrapper,
    {
      w: "100%",
      py: status === import_dash_common16.ProgressTrackingFileStatusesEnum.ABORTED || status === import_dash_common16.ProgressTrackingFileStatusesEnum.ERROR ? 4 : 5.5,
      px: 4.25,
      alignItems: "center",
      justifyContent: "space-between",
      isHovered: isUploading && !isInitialization,
      multiple,
      children: /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(Flex_default, { w: "inherit", flex: 1, alignItems: "center", children: [
        isInitialization ? /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Box_default, { mr: 1, children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Spinner_default, {}) }) : /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          IconWrapper,
          {
            status,
            onClick: (e) => {
              e.stopPropagation();
              if (isError) {
                onReject();
              }
              if (status === import_dash_common16.ProgressTrackingFileStatusesEnum.UPLOADING) {
                onAbort();
              }
            },
            children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Icon_default, { name: iconName, size: 16 })
          }
        ),
        isInitialization || status === import_dash_common16.ProgressTrackingFileStatusesEnum.UPLOADING ? /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          ProgressBar_default,
          {
            label: filename,
            progress,
            labelColor: multiple ? theme.colors.black : theme.colors.b50
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(OverflowContainer, { alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(FileLabel, { ellipsis: true, title: filename, status, children: filename }),
          status === import_dash_common16.ProgressTrackingFileStatusesEnum.ABORTED && /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Text_default, { ellipsis: true, sm: true, color: theme.colors.n70, children: t("common:labels.uploadCancelled") }),
          isError && /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Text_default, { ellipsis: true, sm: true, color: theme.colors.r20, children: messages && messages.length ? messages.map(({ code, message }) => {
            const errorLabel = `forms:messages.uploadErrors.${(0, import_lodash12.camelCase)(code)}`;
            return i18n.exists(errorLabel) ? t(errorLabel) : message;
          }) : t("common:serverMessages.uploadFail") })
        ] }),
        isUploading && /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          ClearButton,
          {
            minWidth: 73,
            ml: theme.space,
            medium: true,
            variation: "outline",
            onClick: (e) => {
              e.stopPropagation();
              if (onClear) {
                onClear();
              }
            },
            children: t("common:labels.clear")
          }
        )
      ] })
    }
  );
}
var ItemUpload_default = ItemUpload;

// src/components/atoms/Form/FileUpload/components/FilesDropzone/FilesDropzone.tsx
var import_react_dropzone = __toESM(require("react-dropzone"));
var import_react_i18next13 = require("react-i18next");

// src/components/atoms/Form/FileUpload/components/FilesDropzone/FilesDropzone.styles.tsx
var import_styled_components38 = __toESM(require("styled-components"));
var SelectFileLabel = import_styled_components38.default.a`
  text-decoration: underline;
  cursor: pointer;
  margin-left: 5px;
`;

// src/components/atoms/Form/FileUpload/components/FilesDropzone/FilesDropzone.tsx
var import_jsx_runtime44 = require("react/jsx-runtime");
function FilesDropzone({
  accept,
  minSize,
  maxSize,
  disabled,
  validator,
  multiple = false,
  onFilesUpload,
  onFilesUploadError,
  onDropRejected,
  isFilesExists,
  children
}) {
  const { t } = (0, import_react_i18next13.useTranslation)("forms");
  return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
    import_react_dropzone.default,
    {
      validator,
      multiple,
      accept,
      minSize,
      maxSize,
      disabled,
      onDrop: onFilesUpload,
      onError: onFilesUploadError,
      onDropRejected,
      children: ({ getRootProps, getInputProps }) => /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(Box_default, { ...getRootProps(), h: isFilesExists || !multiple ? void 0 : 168, children: [
        /* @__PURE__ */ (0, import_jsx_runtime44.jsx)("input", { ...getInputProps() }),
        /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(Box_default, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(Flex_default, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(Icon_default, { color: mainTheme.colors.n90, name: "upload", size: 32, pb: 2 }) }),
          /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(Flex_default, { pl: 2, pr: 2, justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(Text_default, { color: mainTheme.colors.n80, children: [
            t`placeholders.dragAndDropZone`,
            /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(SelectFileLabel, { children: t`placeholders.selectFiles` })
          ] }) })
        ] }),
        children
      ] })
    }
  );
}
var FilesDropzone_default = FilesDropzone;

// src/components/atoms/Form/FileUpload/FileUpload.styles.tsx
var import_dash_common17 = require("dash-common");
var import_styled_components39 = __toESM(require("styled-components"));
var fileUploadStyle = import_styled_components39.css`
  ${({
  theme,
  uploadStatus
}) => {
  const statusStyleRelations = {
    [import_dash_common17.ProgressTrackingFileStatusesEnum.UPLOADING]: import_styled_components39.css`
        border: none;
        background-color: ${theme.colors.b20};
      `,
    [import_dash_common17.ProgressTrackingFileStatusesEnum.UPLOADED]: import_styled_components39.css`
        border: none;
        background-color: ${({ theme: theme2 }) => theme2.colors.n20};
        min-height: 160px;
      `,
    [import_dash_common17.ProgressTrackingFileStatusesEnum.ERROR]: import_styled_components39.css`
        background-color: ${theme.colors.white};
        border: 1px solid ${theme.colors.r20};
      `
  };
  return uploadStatus && statusStyleRelations[uploadStatus] || "";
}}
`;
var FileUploadContainer = import_styled_components39.default.div`
  border: 1px solid ${({ theme }) => theme.colors.n50};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: 96px;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ multiple }) => multiple ? 0 : "8px"};
  ${fileUploadStyle}
  ${stateStyle}
  ${boxStyle}
`;

// src/components/atoms/Form/FileUpload/SingleUpload/SingleUpload.styles.tsx
var import_styled_components41 = __toESM(require("styled-components"));

// src/components/atoms/Image/Image.tsx
var import_styled_components40 = __toESM(require("styled-components"));

// src/common/hooks/usePermission/usePermission.tsx
var import_react40 = require("react");
var usePermission = () => {
  const { subscription } = (0, import_react40.useContext)(ViewerContext);
  (0, import_react40.useLayoutEffect)(() => {
    if (subscription?.subscriptionProduct?.name.toLowerCase() === "basic") {
      const blockedTags = ["img", "video"];
      document.addEventListener(
        "contextmenu",
        function(e) {
          const clickedTag = e.target?.tagName;
          if (blockedTags.includes(clickedTag.toLowerCase()))
            e.preventDefault();
        },
        false
      );
      document.addEventListener(
        "dragover",
        (e) => {
          const clickedTag = e.target?.tagName;
          if (blockedTags.includes(clickedTag.toLowerCase()))
            e.preventDefault();
        },
        false
      );
      document.addEventListener("dragstart", (e) => {
        const clickedTag = e.target?.tagName;
        if (blockedTags.includes(clickedTag.toLowerCase()))
          e.preventDefault();
      });
      document.addEventListener(
        "drop",
        (e) => {
          const clickedTag = e.target?.tagName;
          if (blockedTags.includes(clickedTag.toLowerCase()))
            e.preventDefault();
        },
        false
      );
    }
  }, []);
};

// src/components/atoms/Image/Image.tsx
var import_jsx_runtime45 = require("react/jsx-runtime");
var ImgStyle = import_styled_components40.default.img`
  ${boxStyle}
  ${({ size }) => size ? `width:${size}${typeof size === "number" ? "px" : ""};` : ""}
  ${({ size }) => size ? `height:${size}${typeof size === "number" ? "px" : ""};` : ""}
  border-radius: ${({ borderRadius, theme }) => borderRadius || theme.space * 2}px;
  object-fit: ${({ fit }) => fit};
  object-position: ${({ position }) => position};
`;
function Image({
  src,
  alt,
  size = 48,
  fit = "cover",
  position = "50% 50%",
  borderRadius,
  ...args
}) {
  usePermission();
  return /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(
    ImgStyle,
    {
      src,
      alt,
      size,
      borderRadius,
      fit,
      position,
      ...args
    }
  );
}
var Image_default = Image;

// src/components/atoms/Form/FileUpload/SingleUpload/SingleUpload.styles.tsx
var UploadResultWrapper = (0, import_styled_components41.default)(Flex_default)`
  border-top: 1px solid
    ${({ theme, withBorder }) => withBorder ? theme.colors.n20 : "transparent"};
  padding: 12px 12px 0;
`;
var UploadedImageViewContainer = (0, import_styled_components41.default)(Image_default)`
  max-width: ${({ $imagePreviewWidth }) => $imagePreviewWidth || "88px"};
  max-height: ${({ $imagePreviewMaxHeight }) => $imagePreviewMaxHeight || "none"};
  width: auto;
  height: auto;
  margin: auto;
  object-fit: contain;
`;
var IconWrapper2 = import_styled_components41.default.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  padding: 7px;
  cursor: pointer;
  margin-left: 16px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.b50};
`;

// src/components/atoms/Form/FileUpload/SingleUpload/SingleUpload.tsx
var import_jsx_runtime46 = require("react/jsx-runtime");
function SingleUpload({
  initialFile,
  accept,
  minSize,
  maxSize,
  disabled,
  onUpload,
  onChanged,
  onDropRejected,
  defaultValue,
  imagePreviewWidth,
  imagePreviewMaxHeight,
  ...args
}) {
  const [progress, setProgress] = (0, import_react41.useState)(0);
  const [uploadStatus, setUploadStatus] = (0, import_react41.useState)(
    import_dash_common18.ProgressTrackingFileStatusesEnum.UPLOADING
  );
  const [fileToUploadInfo, setFileToUploadInfo] = (0, import_react41.useState)(null);
  const [uploadedFileDoc, setUploadedFileDoc] = (0, import_react41.useState)(initialFile || null);
  (0, import_react41.useEffect)(() => {
    if (defaultValue && Object.keys(defaultValue).length) {
      setUploadedFileDoc(defaultValue);
      setUploadStatus(import_dash_common18.ProgressTrackingFileStatusesEnum.UPLOADED);
    }
  }, [defaultValue]);
  (0, import_react41.useEffect)(() => {
    if (!uploadedFileDoc && initialFile) {
      setUploadedFileDoc(initialFile);
    }
  }, [initialFile]);
  const onReject = () => {
    setProgress(0);
    setUploadStatus(import_dash_common18.ProgressTrackingFileStatusesEnum.UPLOADING);
    setFileToUploadInfo(null);
    setUploadedFileDoc(null);
    onChanged && onChanged("");
  };
  const onAbort = () => {
    if (fileToUploadInfo?.abortHandler) {
      fileToUploadInfo.abortHandler();
    }
    onReject();
  };
  const onProgress = (progress2) => setProgress(progress2);
  const onCompleted = (uploadedFileDoc2) => {
    setUploadedFileDoc(uploadedFileDoc2);
    setUploadStatus(import_dash_common18.ProgressTrackingFileStatusesEnum.UPLOADED);
    onChanged && onChanged(uploadedFileDoc2._id);
  };
  const onError = () => {
    setUploadStatus(import_dash_common18.ProgressTrackingFileStatusesEnum.ERROR);
  };
  const onFileUpload = ([file]) => {
    if (file) {
      setUploadStatus(import_dash_common18.ProgressTrackingFileStatusesEnum.UPLOADING);
      setFileToUploadInfo({ filename: file?.name });
      onUpload(file, { onProgress, setAbortHandler, onCompleted, onError });
    }
  };
  const setAbortHandler = (abortHandler) => setFileToUploadInfo((doc) => ({ ...doc, abortHandler }));
  return /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(FileUploadContainer, { ...args, uploadStatus: fileToUploadInfo && uploadStatus, children: [
    !fileToUploadInfo && !uploadedFileDoc && /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
      FilesDropzone_default,
      {
        accept,
        minSize,
        maxSize,
        disabled,
        multiple: false,
        onFilesUpload: onFileUpload,
        onFilesUploadError: onError,
        onDropRejected: (fileRejections) => {
          const { errors } = fileRejections[0];
          if (onDropRejected) {
            onDropRejected(errors[0]);
          }
        }
      }
    ),
    fileToUploadInfo && !uploadedFileDoc && /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
      ItemUpload_default,
      {
        progress,
        filename: fileToUploadInfo?.filename || "",
        status: uploadStatus,
        onReject,
        onAbort
      }
    ),
    uploadedFileDoc && /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(import_jsx_runtime46.Fragment, { children: [
      uploadedFileDoc.type?.includes("image") && /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
        UploadedImageViewContainer,
        {
          src: uploadedFileDoc.publicUrl,
          alt: "upload",
          $imagePreviewWidth: imagePreviewWidth,
          $imagePreviewMaxHeight: imagePreviewMaxHeight,
          size: void 0
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(
        UploadResultWrapper,
        {
          alignItems: "center",
          justifyContent: "center",
          withBorder: uploadedFileDoc.type?.includes("image"),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(Text_default, { ellipsis: true, title: uploadedFileDoc.name, children: uploadedFileDoc.name }),
            !disabled && /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(IconWrapper2, { onClick: onReject, children: /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(Icon_default, { name: "trash", size: 16 }) })
          ]
        }
      )
    ] })
  ] });
}
var SingleUpload_default = SingleUpload;

// src/components/atoms/Form/FileUpload/MultiUpload/MultiUpload.tsx
var import_react42 = require("react");
var import_jsx_runtime47 = require("react/jsx-runtime");
function MultiUpload({
  accept,
  minSize,
  maxSize,
  disabled,
  onUpload,
  validator,
  onDropRejected,
  onFilesUploadError,
  isInContainer,
  onAbortManually
}) {
  const { filesToUpload, onAbort, onClear, onReject, setRejectedFiles, initiateAsyncFilesUpload } = (0, import_react42.useContext)(MultiFileUploadContext);
  const onFileUpload = async (files) => {
    if (files.length) {
      const filesToUpload2 = await initiateAsyncFilesUpload(files);
      onUpload(filesToUpload2);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(FileUploadContainer, { uploadStatus: null, multiple: true, children: /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
    FilesDropzone_default,
    {
      multiple: true,
      accept,
      minSize,
      maxSize,
      disabled,
      validator,
      onFilesUpload: onFileUpload,
      onFilesUploadError,
      isFilesExists: filesToUpload.length > 0,
      onDropRejected: (fileRejections) => {
        if (isInContainer) {
          setRejectedFiles(fileRejections);
        }
        if (onDropRejected) {
          onDropRejected(fileRejections);
        }
      },
      children: filesToUpload.map(({ progressTrackingId, progress, status, filename, messages }) => /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
        ItemUpload_default,
        {
          multiple: true,
          progress,
          messages,
          filename,
          status,
          onReject: () => onReject(progressTrackingId),
          onAbort: () => {
            if (onAbortManually) {
              onAbortManually(progressTrackingId);
            }
            onAbort(progressTrackingId);
          },
          onClear: () => onClear(progressTrackingId)
        },
        progressTrackingId
      ))
    }
  ) });
}
var MultiUpload_default = MultiUpload;

// src/components/atoms/Form/FileUpload/FileUpload.tsx
var FileUpload2 = import_styled_components42.default.div`
  ${boxStyle}
`;
var Extends = {
  Single: SingleUpload_default,
  Multi: MultiUpload_default
};
var FileUpload_default = Object.assign(FileUpload2, Extends);

// src/components/atoms/Form/Textarea/Textarea.tsx
var import_styled_components43 = __toESM(require("styled-components"));
var import_react43 = require("react");
var import_jsx_runtime48 = require("react/jsx-runtime");
var stateStyle3 = import_styled_components43.css`
  ${({ $errorType }) => {
  const states = {
    ["info" /* Info */]: import_styled_components43.css`
        border: 1px solid ${({ theme }) => theme.colors.n70};
      `,
    ["valid" /* Valid */]: import_styled_components43.css`
        border: 1px solid ${({ theme }) => theme.colors.g20};
      `,
    ["invalid" /* Invalid */]: import_styled_components43.css`
        border: 1px solid ${({ theme }) => theme.colors.r20};
      `
  };
  return $errorType ? states[$errorType] : "";
}}
`;
var StyledTextarea = import_styled_components43.default.textarea`
  -webkit-appearance: none;
  -moz-appearance: none;
  overflow: hidden;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.white};
  resize: ${({ resizable }) => resizable ? "both" : "none"};
  border: 1px solid ${({ theme }) => theme.colors.n60};
  min-height: ${({ minHeight }) => minHeight || 0};
  height: ${({ height }) => height || "auto"};
  color: ${({ theme }) => theme.colors.black};
  border-radius: ${({ theme }) => theme.space * 2}px;
  color: ${({ theme }) => theme.colors.n90};
  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.b40};
    box-shadow: ${({ theme }) => theme.shadows.shadow3};
  }
  &:focus {
    outline-width: 0;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.n70};
  }
  &:disabled {
    background-color: ${({ theme }) => theme.colors.n20};
    color: ${({ theme }) => theme.colors.n60};
    border: 1px solid ${({ theme }) => theme.colors.n60};
    cursor: not-allowed;
  }
  &::placeholder {
    color: ${({ theme }) => theme.colors.n60};
  }
  ${boxStyle}
  ${textStyle}
  font-size: 16px; /* Prevent iOS Safari zoom on focus */
  ${stateStyle3}
  ${({ css: css33 }) => css33}
`;
var Textarea = ({ w, minHeight, height, value, defaultValue, ...args }) => {
  const ref = (0, import_react43.useRef)(null);
  const adjustHeight = (event) => {
    event.currentTarget.style.height = "inherit";
    event.currentTarget.style.height = `${event.currentTarget.scrollHeight}px`;
  };
  (0, import_react43.useEffect)(() => {
    if (ref.current && !height) {
      ref.current.style.height = "inherit";
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }
  }, [value, defaultValue, height]);
  return /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(Box_default, { w, style: height ? { height } : void 0, children: /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
    StyledTextarea,
    {
      w: w || "100%",
      value,
      defaultValue,
      ref,
      minHeight,
      height,
      onKeyUp: height ? void 0 : adjustHeight,
      p: 2,
      ...args
    }
  ) });
};
var Textarea_default = Textarea;

// src/components/atoms/Form/DatePicker/DatePicker.tsx
var import_react44 = require("react");
var import_react_datepicker = __toESM(require("react-datepicker"));
var import_styled_components45 = require("styled-components");
var import_react_text_mask3 = __toESM(require("react-text-mask"));
var import_dash_common19 = require("dash-common");
var import_react_datepicker2 = require("react-datepicker/dist/react-datepicker.css");

// src/components/atoms/Form/DatePicker/DatePicker.styles.ts
var import_styled_components44 = __toESM(require("styled-components"));
var IconWrapper3 = (0, import_styled_components44.default)(Flex_default)`
  top: 0;
  bottom: 0;
  right: 0;
`;
var InputWrapper = (0, import_styled_components44.default)(Box_default)`
  input {
    padding-right: ${({ theme }) => theme.space * 12}px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
var DatePickerWrapper = import_styled_components44.default.div`
  .react-datepicker-wrapper {
    width: 100%;
  }
`;

// src/components/atoms/Form/DatePicker/DatePicker.constants.ts
var monthPickerMask = [/\d/, /\d/];
var yearPickerMask = [/\d/, /\d/, /\d/, /\d/];
var datePickerMask = [/\d/, /\d/, "/", ...monthPickerMask, "/", ...yearPickerMask];

// src/components/atoms/Form/DatePicker/DatePicker.tsx
var import_jsx_runtime49 = require("react/jsx-runtime");
var CustomInput = (0, import_react44.forwardRef)(
  ({
    showYearPicker,
    showMonthYearPicker,
    customInputProps,
    ...datePickerProps
  }, forwardRef4) => {
    const theme = (0, import_styled_components45.useTheme)();
    const maskY = showYearPicker && yearPickerMask;
    const maskM = showMonthYearPicker && monthPickerMask;
    const mask = maskY || maskM || datePickerMask;
    return /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)(InputWrapper, { pos: "relative", children: [
      /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
        import_react_text_mask3.default,
        {
          mask: customInputProps?.mask || mask || "",
          render: (ref, props) => /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
            Input_default,
            {
              w: "100%",
              ref: (_ref) => {
                ref(_ref);
                forwardRef4(_ref);
              },
              ...props,
              ...datePickerProps,
              onChange: (e) => {
                if (props.onChange) {
                  props.onChange(e);
                }
                if (datePickerProps.onChange) {
                  datePickerProps.onChange(e);
                }
              },
              onClick: (e) => {
                if (datePickerProps.onClick) {
                  datePickerProps.onClick(e);
                }
                if (customInputProps?.onClick) {
                  customInputProps.onClick(e);
                }
              }
            }
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(IconWrapper3, { pos: "absolute", alignItems: "center", pr: 2, children: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
        Icon_default,
        {
          color: theme.colors.n200,
          onClick: datePickerProps.onClick,
          size: 22,
          name: "calendarToday"
        }
      ) })
    ] });
  }
);
var DatePicker = ({ selected, customInputProps, ...args }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(DatePickerWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
    import_react_datepicker.default,
    {
      selected: selected ? new Date(selected) : null,
      dateFormat: import_dash_common19.DATE_FORMAT,
      customInput: (
        // @ts-ignore
        /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
          CustomInput,
          {
            showYearPicker: args.showYearPicker,
            showMonthYearPicker: args.showMonthYearPicker,
            customInputProps
          }
        )
      ),
      showPopperArrow: false,
      ...args
    }
  ) });
};
var DatePicker_default = DatePicker;

// src/components/atoms/Form/CardCvvInput/CardCvvInput.tsx
var import_react_stripe_js = require("@stripe/react-stripe-js");
var import_styled_components46 = __toESM(require("styled-components"));
var import_jsx_runtime50 = require("react/jsx-runtime");
var stripeElementsStyles = import_styled_components46.css`
  border: 1px solid ${({ theme }) => theme.colors.n60};
  border-radius: ${({ theme }) => theme.space + 2}px;
  display: flex;
  align-items: center;
  :focus,
  :hover {
    border: 1px solid ${({ theme }) => theme.colors.b50};
  }
  & > div {
    width: 100%;
  }
`;
var StyledCardCvcElement = (0, import_styled_components46.default)(import_react_stripe_js.CardCvcElement)`
  ${stripeElementsStyles}
  ${boxStyle}
`;
var InputWrapper2 = (0, import_styled_components46.default)(Flex_default)`
  position: relative;

  svg {
    position: absolute;
    right: 14px;
  }
`;
var CardCvvInput = ({ ...props }) => {
  const theme = (0, import_styled_components46.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime50.jsxs)(InputWrapper2, { w: "100%", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(StyledCardCvcElement, { ...props, w: "100%", px: 3, h: 40 }),
    /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(Icon_default, { name: "creditCard", size: 20, color: theme.colors.n200 })
  ] });
};
var CardCvvInput_default = CardCvvInput;

// src/components/atoms/Form/ExpiryDateInput/ExpiryDateInput.tsx
var import_react_stripe_js2 = require("@stripe/react-stripe-js");
var import_styled_components47 = __toESM(require("styled-components"));
var import_jsx_runtime51 = require("react/jsx-runtime");
var StyledCardExpiryElement = (0, import_styled_components47.default)(import_react_stripe_js2.CardExpiryElement)`
  ${stripeElementsStyles}
  ${boxStyle}
  box-sizing: border-box;
`;
var ExpiryDateInput = ({ ...props }) => /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(StyledCardExpiryElement, { ...props, px: 3, h: 40 });
var ExpiryDateInput_default = ExpiryDateInput;

// src/components/atoms/Form/CardNumberInput/CardNumberInput.tsx
var import_react_stripe_js3 = require("@stripe/react-stripe-js");
var import_styled_components48 = __toESM(require("styled-components"));
var import_jsx_runtime52 = require("react/jsx-runtime");
var StyledCardNumberElement = (0, import_styled_components48.default)(import_react_stripe_js3.CardNumberElement)`
  ${stripeElementsStyles}
  ${boxStyle}
`;
var CardNumberInput = ({ ...props }) => /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
  StyledCardNumberElement,
  {
    ...props,
    px: 3,
    h: 40,
    options: { showIcon: true }
  }
);
var CardNumberInput_default = CardNumberInput;

// src/components/atoms/Form/Slider/Slider.tsx
var import_rc_slider = __toESM(require("rc-slider"));
var import_styled_components49 = __toESM(require("styled-components"));
var import_assets = require("rc-slider/assets/index.css");
var import_jsx_runtime53 = require("react/jsx-runtime");
var SliderWrapper = (0, import_styled_components49.default)(Box_default)`
  .rc-slider-rail {
    background-color: ${({ theme }) => theme.colors.n20};
    border-radius: ${({ theme }) => theme.space * 4};
  }
  .rc-slider-track {
    border: 2px solid ${({ theme }) => theme.colors.b50};
    border-radius: ${({ theme }) => theme.space * 4};
  }
  .rc-slider-handle {
    border: 2px solid ${({ theme }) => theme.colors.b50};
    background-color: ${({ theme }) => theme.colors.b50};
    opacity: 1;
    width: 17px;
    height: 17px;
    margin-top: -7px;
  }
  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
    border-color: ${({ theme }) => theme.colors.b50};
    box-shadow: 0 0 0 5px ${({ theme }) => theme.colors.b20};
  }
  .rc-slider-disabled {
    background-color: inherit;
    opacity: 0.5;
  }
`;
function Slider(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(SliderWrapper, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(import_rc_slider.default, { ...props }) });
}
var Slider_default = Slider;

// src/components/atoms/Form/DateRangePicker/DateRangePicker.tsx
var import_moment4 = __toESM(require("moment"));
var import_react_datepicker3 = __toESM(require("react-datepicker"));
var import_styled_components50 = __toESM(require("styled-components"));
var import_react45 = require("react");
var import_react_datepicker4 = require("react-datepicker/dist/react-datepicker.css");
var import_jsx_runtime54 = require("react/jsx-runtime");
var CustomInput2 = (0, import_react45.forwardRef)(({ iconProps, onClear, ...props }, ref) => {
  const theme = (0, import_styled_components50.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsxs)(InputWrapper, { w: "100%", pos: "relative", children: [
    /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
      Input_default,
      {
        ref,
        w: "100%",
        ...props,
        onChange: (e) => {
          if (!e.target.value) {
            setTimeout(() => {
              onClear();
            });
          }
          props.onChange(e);
        }
      }
    ),
    iconProps && /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(IconWrapper3, { pos: "absolute", alignItems: "center", pr: 8, children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(Icon_default, { color: theme.colors.r20, size: 22, name: "close", ...iconProps }) }),
    /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(IconWrapper3, { pos: "absolute", alignItems: "center", pr: 2, children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(Icon_default, { color: theme.colors.n200, onClick: props.onClick, size: 22, name: "calendarToday" }) })
  ] });
});
var StyledBox = (0, import_styled_components50.default)(Box_default)`
  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }

  .datepicker {
    width: 100%;
  }
`;
var DateRangePicker = ({
  onChange,
  onClear,
  startDate: initialStartDate,
  endDate: initialEndDate,
  isClearable,
  ...props
}) => {
  const [startDate, setStartDate] = (0, import_react45.useState)(/* @__PURE__ */ new Date());
  const [endDate, setEndDate] = (0, import_react45.useState)(null);
  (0, import_react45.useEffect)(() => {
    if (startDate && endDate) {
      onChange({ startDate, endDate });
    }
  }, [startDate, endDate]);
  (0, import_react45.useEffect)(() => {
    setStartDate(
      (prevDate) => ((0, import_moment4.default)(prevDate).isSame(initialStartDate) ? prevDate : initialStartDate) || null
    );
  }, [initialStartDate]);
  (0, import_react45.useEffect)(() => {
    setEndDate(
      (prevDate) => ((0, import_moment4.default)(prevDate).isSame(initialEndDate) ? prevDate : initialEndDate) || null
    );
  }, [initialEndDate]);
  const onValueChange = (dates) => {
    const [startDate2, endDate2] = dates;
    setStartDate(startDate2);
    setEndDate(endDate2);
    if (onClear && !startDate2 && !endDate2) {
      onClear();
    }
  };
  const handleClear = (0, import_react45.useCallback)(() => {
    setStartDate(null);
    setEndDate(null);
    if (onClear) {
      onClear();
    }
  }, [setStartDate, setEndDate, onClear]);
  const customInputIconProps = (0, import_react45.useMemo)(() => {
    return isClearable && (startDate || endDate) ? { onClick: handleClear } : void 0;
  }, [isClearable, startDate, endDate, handleClear]);
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(StyledBox, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
    import_react_datepicker3.default,
    {
      wrapperClassName: "datepicker",
      popperPlacement: "top",
      dateFormat: "MM/dd/yyyy",
      selected: startDate,
      onChange: onValueChange,
      startDate,
      endDate,
      selectsRange: true,
      customInput: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(CustomInput2, { iconProps: customInputIconProps, onClear: handleClear }),
      ...props
    }
  ) });
};
var DateRangePicker_default = DateRangePicker;

// src/components/atoms/Form/Form/Form.tsx
var Form = import_styled_components51.default.form`
  ${boxStyle}
  ${({ isFlex }) => isFlex ? flexStyle : ""}
`;
var Extends2 = {
  Input: Input_default,
  Label: Label_default,
  Group: Group_default,
  FileUpload: FileUpload_default,
  Feedback: Feedback_default,
  Select: Select_default,
  InputPassword: InputPassword_default,
  InputSearch: InputSearch_default,
  InputGroup: InputGroup_default,
  InputPhone: InputPhone_default,
  Checkbox: Checkbox_default,
  Textarea: Textarea_default,
  InputPrice: InputPrice_default,
  DatePicker: DatePicker_default,
  CardCvvInput: CardCvvInput_default,
  DateRangePicker: DateRangePicker_default,
  ExpiryDateInput: ExpiryDateInput_default,
  CardNumberInput: CardNumberInput_default,
  Slider: Slider_default
};
var Form_default = Object.assign(Form, Extends2);

// src/components/atoms/Form/Select/SelectLegacy.tsx
var import_react46 = require("react");
var import_react_select3 = __toESM(require("react-select"));
var import_async2 = __toESM(require("react-select/async"));
var import_react_i18next14 = require("react-i18next");
var import_styled_components52 = require("styled-components");
var import_lodash13 = require("lodash");
var import_jsx_runtime55 = require("react/jsx-runtime");
var { Input: Input3, SingleValue: SingleValue2, MenuPortal: MenuPortal2, MenuList: MenuList2, ClearIndicator: ClearIndicator2 } = import_react_select3.components;
var ChevronUp2 = () => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Icon_default, { name: "chevronUp", size: 24 });
var ChevronDown2 = () => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Icon_default, { name: "chevronDown", size: 24 });
var SelectLegacy = ({
  isClearable = false,
  $errorType,
  valuePrefix = "",
  onChanged,
  options,
  disabled,
  value,
  defaultValue,
  isMulti = false,
  withCheckbox = true,
  isAsync = false,
  components: components8 = {},
  placeholder,
  isSearchable = true,
  leftIcon,
  leftIconColor,
  onMouseDown,
  inputValue,
  onMenuClose,
  loadOptions,
  inputPlaceholder,
  menuPortalTarget,
  menuPlacementHorizontal,
  menuFixedWidth = true,
  menuPosition = "absolute",
  menuPortalZIndex = 150,
  onClear,
  styles,
  w,
  h,
  disablePortalTarget,
  defaultOptions: defaultOptions2,
  isButtonSelect,
  strictMenuWidth,
  isSelectAll,
  valueContainerMaxWidth,
  buttonSelectType = "badge",
  isActive,
  ...props
}) => {
  const { t } = (0, import_react_i18next14.useTranslation)("common", { keyPrefix: "labels" });
  const theme = (0, import_styled_components52.useTheme)();
  const [isOpen, setIsOpen] = (0, import_react46.useState)(false);
  const [selectedValue, setSelectedValue] = (0, import_react46.useState)(null);
  const [searchSlug, setSearchSlug] = (0, import_react46.useState)("");
  const boxProps = props;
  const [isClosable, setIsClosable] = (0, import_react46.useState)(false);
  const ref = (0, import_react46.useRef)(null);
  const refSelect = (0, import_react46.useRef)(null);
  const inputRef = (0, import_react46.useRef)(null);
  const menuPortalScrollTopRef = (0, import_react46.useRef)(0);
  const containerRef = (0, import_react46.useRef)(null);
  const [isAllOptionsSelected, setIsAllOptionsSelected] = (0, import_react46.useState)(false);
  const getSelectValue = (0, import_react46.useCallback)(
    (currentValue) => {
      if (currentValue === void 0) {
        return selectedValue;
      }
      let _options = options;
      if (!options?.length && Array.isArray(defaultOptions2))
        _options = defaultOptions2;
      if (isMulti) {
        return selectedValue || _options?.filter(
          (item) => (currentValue || []).includes(item.value)
        );
      }
      return _options?.find((item) => item.value === currentValue);
    },
    [options, defaultOptions2, selectedValue]
  );
  const selectValue = getSelectValue(value);
  const selectDefaultValue = getSelectValue(defaultValue);
  useOnClickOutside(
    ref,
    (event) => {
      const elemId = event.target?.getAttribute("id");
      const isDropdownOption = elemId?.includes("price-range-option");
      if (isClosable && !isDropdownOption) {
        setIsOpen(false);
        setIsClosable(false);
        onMenuClose && onMenuClose();
      }
    },
    disablePortalTarget
  );
  (0, import_react46.useEffect)(() => {
    if (defaultValue === void 0 || value === void 0) {
      setSelectedValue(null);
    }
  }, [defaultValue, value]);
  (0, import_react46.useEffect)(() => {
    if (isOpen) {
      setIsClosable(true);
    }
  }, [isOpen]);
  const handleSelectValues = (record) => {
    setSelectedValue(record);
    refSelect.current?.blur();
    if (onChanged) {
      if (isMulti) {
        return onChanged(
          "",
          record.map((item) => item.value)
        );
      }
      onChanged(record?.value);
      if ((0, import_lodash13.isNil)(record?.value)) {
        setSelectedValue(null);
      }
    }
  };
  const Select2 = isAsync ? import_async2.default : import_react_select3.default;
  const {
    Option: OverwriteOption,
    DropdownIndicator: OverwriteDropdownIndicator,
    ...overwriteComponents
  } = components8;
  (0, import_react46.useLayoutEffect)(() => {
    const onMenuPortalScroll = (e) => {
      menuPortalScrollTopRef.current = e.target.scrollTop;
    };
    if (isOpen && isMulti) {
      setTimeout(() => {
        if (ref.current?.firstChild?.firstChild) {
          ref.current.firstChild.firstChild.addEventListener("scroll", onMenuPortalScroll);
        }
      });
    }
    return () => {
      if (ref.current?.firstChild?.firstChild) {
        ref.current.firstChild.firstChild.removeEventListener("scroll", onMenuPortalScroll);
      }
    };
  }, [ref, isOpen, isMulti, selectedValue]);
  (0, import_react46.useEffect)(() => {
    if (isMulti) {
      setTimeout(() => {
        if (ref.current?.firstChild?.firstChild) {
          ref.current.firstChild.firstChild.scrollTop = menuPortalScrollTopRef?.current || 0;
        }
      });
    }
  }, [selectedValue, isMulti]);
  const isSelectAllOption = (0, import_react46.useMemo)(
    () => isMulti && (value || defaultValue) && (options || defaultOptions2).every(
      (item) => (value || defaultValue)?.includes(item.value)
    ),
    [options, value, defaultValue]
  );
  const placeholderValue = (0, import_react46.useMemo)(() => {
    if (!selectValue || Array.isArray(selectValue) && !selectValue?.length) {
      return placeholder;
    }
    if (isMulti)
      return selectValue.map((sv) => sv?.label).join(", ");
    return selectValue?.label;
  }, [selectValue, placeholder, isMulti]);
  const onSelectAll = (0, import_react46.useCallback)(
    (selected) => {
      setIsAllOptionsSelected(selected);
      setSelectedValue(selected ? options || defaultOptions2 : []);
      if (onChanged) {
        onChanged(
          "",
          selected ? (options || (Array.isArray(defaultOptions2) ? defaultOptions2 : [])).map(
            (item) => item.value
          ) : []
        );
      }
    },
    [options, defaultOptions2, onChanged]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime55.jsxs)(
    StyledSelectWrapper,
    {
      leftIcon,
      ref: containerRef,
      alignItems: "center",
      isMulti,
      $errorType,
      isButtonSelect,
      onMouseDown: (e) => {
        if (!disabled) {
          if (onMouseDown) {
            onMouseDown(e);
          }
          setIsOpen(true);
        }
      },
      w,
      h,
      ...boxProps,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
          Select2,
          {
            ref: refSelect,
            filterOption: (0, import_react_select3.createFilter)({ matchFrom: "any", stringify: (option) => `${option.label}` }),
            options,
            menuPortalTarget: disablePortalTarget ? void 0 : menuPortalTarget || document.body,
            menuPlacement: "auto",
            menuPosition,
            placeholder: placeholderValue,
            ...props,
            isMulti,
            isClearable,
            defaultValue: selectDefaultValue,
            value: !disabled ? selectValue : null,
            inputValue: inputValue || searchSlug,
            classNamePrefix: "select",
            isDisabled: disabled,
            onChange: handleSelectValues,
            closeMenuOnSelect: !isMulti,
            hideSelectedOptions: false,
            styles: {
              menuPortal: (base) => ({
                ...base,
                zIndex: menuPortalZIndex,
                ...menuPlacementHorizontal === "right" ? { display: "flex", justifyContent: "end" } : {}
              }),
              valueContainer: (base) => ({
                ...base,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: valueContainerMaxWidth
              }),
              ...styles
            },
            menuIsOpen: isOpen,
            onFocus: () => !disabled && setIsOpen(true),
            isSearchable,
            components: {
              DropdownIndicator: () => {
                if (OverwriteDropdownIndicator) {
                  return /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(OverwriteDropdownIndicator, { isOpen });
                }
                return isOpen ? /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(ChevronUp2, {}) : /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(ChevronDown2, {});
              },
              ClearIndicator: ({ innerProps, ...props2 }) => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
                ClearIndicator2,
                {
                  innerProps: { ...innerProps, onMouseDown: onClear || innerProps.onMouseDown },
                  ...props2,
                  children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Icon_default, { name: "close", size: 20, color: theme.colors.r20 })
                }
              ),
              MenuList: ({ children, ...props2 }) => {
                return /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(MenuList2, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
                  Menu_default,
                  {
                    w: strictMenuWidth ? containerRef.current?.clientWidth : void 0,
                    menuFixedWidth,
                    isSearchable,
                    searchSlug,
                    setSearchSlug,
                    selectInputRef: inputRef,
                    inputPlaceholder,
                    isSelectAll,
                    isSelected: isAllOptionsSelected || isSelectAllOption,
                    onSelectAll,
                    children
                  }
                ) });
              },
              MenuPortal: ({ children, innerProps, ...rest }) => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(MenuPortal2, { innerProps: { ...innerProps, ref }, ...rest, children }),
              Option: OverwriteOption ? (props2) => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
                OverwriteOption,
                {
                  ...props2,
                  closeDropdown: () => {
                    setIsOpen(false);
                    setIsClosable(false);
                    setSearchSlug("");
                  }
                }
              ) : (props2) => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
                SelectOption_default,
                {
                  ...props2,
                  withCheckbox,
                  closeDropdown: () => {
                    setIsOpen(false);
                    setIsClosable(false);
                    setSearchSlug("");
                  }
                }
              ),
              Input: (props2) => {
                return /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
                  Input3,
                  {
                    ...props2,
                    value: inputValue ? props2.value : "",
                    innerRef: (ref2) => {
                      if (props2.innerRef) {
                        props2.innerRef(ref2);
                      }
                      if (isAsync) {
                        inputRef.current = ref2;
                      }
                    }
                  }
                );
              },
              MultiValue: ({ data, index: index2 }) => isButtonSelect ? null : /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(import_jsx_runtime55.Fragment, { children: `${index2 !== 0 ? " / " : ""}${data.label}` }),
              SingleValue: (props2) => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(SingleValue2, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime55.jsxs)(Text_default, { ellipsis: true, children: [
                valuePrefix,
                " ",
                props2.data.label
              ] }) }),
              LoadingIndicator: () => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Spinner_default, { size: 14 }),
              NoOptionsMessage: () => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Flex_default, { h: 42, w: "100%", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Text_default, { color: theme.colors.n70, children: t`noOptions` }) }),
              LoadingMessage: () => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Flex_default, { h: 42, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Text_default, { color: theme.colors.n70, children: t`loading` }) }),
              ...overwriteComponents
            },
            loadOptions,
            defaultOptions: defaultOptions2
          }
        ),
        leftIcon && /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(StyledLeftIconContainer, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Icon_default, { name: leftIcon, color: leftIconColor, size: 24 }) }),
        isButtonSelect && /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Box_default, { pos: "absolute", w: w || "100%", children: buttonSelectType === "badge" ? /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
          StyledBadge,
          {
            h: boxProps.h || 40,
            title: (placeholder || "").toString(),
            sm: false,
            py: 2,
            px: 4,
            w: "100%",
            whiteSpace: "nowrap",
            iconRight: isOpen ? "arrowUp" : "arrowDown",
            cursor: "pointer",
            $isActive: isActive
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
          Button_default,
          {
            variation: "outline",
            w,
            iconRight: isOpen ? "arrowUp" : "arrowDown",
            iconRightProps: { size: 20 },
            children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Box_default, { w: w ? +w - 50 : "100%", overflow: "hidden", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(Text_default, { color: "inherit", ellipsis: true, children: placeholder }) })
          }
        ) })
      ]
    }
  );
};
var SelectLegacy_default = SelectLegacy;

// src/components/atoms/Form/FileInput/FileInput.tsx
var import_react47 = require("react");
var import_styled_components53 = __toESM(require("styled-components"));
var import_react_i18next15 = require("react-i18next");
var import_jsx_runtime56 = require("react/jsx-runtime");
var StyledInput = import_styled_components53.default.input`
  display: none;
`;
var FileInput = ({ label, accept, multiple, onFilesUpload, ...args }) => {
  const { t } = (0, import_react_i18next15.useTranslation)(["forms"]);
  const inputRef = (0, import_react47.useRef)(null);
  return /* @__PURE__ */ (0, import_jsx_runtime56.jsxs)(import_jsx_runtime56.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
      Button_default,
      {
        onClick: () => {
          if (inputRef.current) {
            inputRef.current.click();
          }
        },
        variation: "flat",
        icon: "filePresent",
        bold: true,
        ...args,
        children: label || t("forms:labels:attachFiles")
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
      StyledInput,
      {
        ref: inputRef,
        type: "file",
        multiple,
        accept,
        onChange: (e) => {
          if (onFilesUpload) {
            onFilesUpload(Object.values(e.target.files || {}));
          }
        }
      }
    )
  ] });
};
var FileInput_default = FileInput;

// src/components/atoms/Form/InputNumber/InputNumber.tsx
var import_react48 = __toESM(require("react"));
var import_dash_common20 = require("dash-common");
var import_react_text_mask4 = __toESM(require("react-text-mask"));
var import_text_mask_addons2 = require("text-mask-addons");
var import_jsx_runtime57 = require("react/jsx-runtime");
var defaultMaskOptions2 = {
  suffix: "",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ",",
  allowDecimal: true,
  decimalSymbol: ".",
  decimalLimit: import_dash_common20.DashValidation.CurrencyDecimalLimit,
  // how many digits allowed after the decimal
  allowNegative: false,
  allowLeadingZeroes: false
};
var InputPrice2 = import_react48.default.forwardRef(
  ({
    onChangeValue,
    value,
    maskOptions = {},
    innerRef,
    onChange,
    disabled,
    ...args
  }, forwardRef4) => {
    const currencyMask = (0, import_text_mask_addons2.createNumberMask)({
      prefix: "$",
      ...defaultMaskOptions2,
      ...maskOptions
    });
    const handleNewValue = (eventValue) => {
      if (eventValue === "")
        return eventValue;
      const options = { ...defaultMaskOptions2, ...maskOptions };
      const { allowDecimal, decimalLimit } = options;
      if (allowDecimal) {
        if (eventValue === ".")
          return eventValue;
        let formattedValue = eventValue.replace(/[^0-9.]/g, "");
        if (decimalLimit > 0) {
          const parts = formattedValue.split(".");
          if (parts.length > 1) {
            const fractionalPart = parts[1].substring(0, decimalLimit);
            if (fractionalPart) {
              formattedValue = parts[0] + (fractionalPart ? "." + fractionalPart : "");
            } else
              formattedValue = parts[0] + ".";
          }
        }
        if (formattedValue.includes("."))
          return formattedValue;
        return `${+formattedValue}`;
      }
      return parseFloat(eventValue.replace(/[^0-9.]/g, ""));
    };
    return /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
      import_react_text_mask4.default,
      {
        ref: (_ref) => {
          if (forwardRef4) {
            forwardRef4.current = _ref?.inputElement;
          }
          if (innerRef) {
            innerRef.current = _ref;
          }
        },
        mask: disabled ? () => false : currencyMask,
        disabled,
        render: (ref, props) => /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
          Input_default,
          {
            ref,
            ...props,
            ...args,
            value,
            onChange: (event) => {
              const newValue = handleNewValue(event.target.value);
              if (onChangeValue) {
                if (value || value === "") {
                  value !== newValue && onChangeValue(newValue.toString());
                } else {
                  onChangeValue(newValue.toString());
                }
              }
              props.onChange && props.onChange(event);
              onChange && onChange(event);
            }
          }
        )
      }
    );
  }
);
var InputNumber_default = InputPrice2;

// src/components/atoms/Form/InputPercentage/InputPercentage.tsx
var import_react49 = __toESM(require("react"));
var import_jsx_runtime58 = require("react/jsx-runtime");
var InputPercentage = import_react49.default.forwardRef(
  ({ maskOptions = {}, ...args }, forwardRef4) => {
    return /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
      InputNumber_default,
      {
        ...args,
        ref: forwardRef4,
        maskOptions: {
          prefix: "",
          suffix: "%",
          includeThousandsSeparator: false,
          ...maskOptions
        }
      }
    );
  }
);
var InputPercentage_default = InputPercentage;

// src/components/atoms/Form/DatePickerWithTimeRange/DatePickerWithTimeRange.tsx
var import_react50 = require("react");

// src/components/atoms/Form/DatePickerWithTimeRange/DatePickerWithTimeRange.interfaces.tsx
var DatePickerTimeRangeEnum = /* @__PURE__ */ ((DatePickerTimeRangeEnum2) => {
  DatePickerTimeRangeEnum2["YEAR"] = "year";
  DatePickerTimeRangeEnum2["MONTH"] = "month";
  DatePickerTimeRangeEnum2["Day"] = "date";
  return DatePickerTimeRangeEnum2;
})(DatePickerTimeRangeEnum || {});

// src/components/atoms/Form/DatePickerWithTimeRange/DatePickerWithTimeRange.tsx
var import_jsx_runtime59 = require("react/jsx-runtime");
var DatePickerWithTimeRange = ({
  selected,
  timeRangePickerType = "date" /* Day */,
  onClickOutside,
  onSelect,
  ...args
}) => {
  const [timeRangeState, setTimeRangeState] = (0, import_react50.useState)(timeRangePickerType);
  const [isOpen, setIsOpen] = (0, import_react50.useState)(false);
  const timeRange = (0, import_react50.useMemo)(
    () => [
      timeRangePickerType === "year" /* YEAR */ && "year" /* YEAR */,
      ["year" /* YEAR */, "month" /* MONTH */].includes(
        timeRangePickerType
      ) && "month" /* MONTH */,
      [
        "year" /* YEAR */,
        "month" /* MONTH */,
        "date" /* Day */
      ].includes(timeRangePickerType) && "date" /* Day */
    ].filter(Boolean),
    [timeRangePickerType]
  );
  const onSelectSpy = (0, import_react50.useCallback)(
    (date, e) => {
      const currentIndex = timeRange.indexOf(timeRangeState);
      const nextIndex = currentIndex >= 0 && currentIndex + 1 < timeRange.length ? currentIndex + 1 : 0;
      setTimeRangeState(timeRange[nextIndex] || timeRange[0]);
      setIsOpen(nextIndex !== 0);
      if (onSelect) {
        onSelect(date, e);
      }
    },
    [onSelect, setIsOpen, setTimeRangeState, timeRange, timeRangeState]
  );
  const onClickOutsideSpy = (e) => {
    setIsOpen(false);
    if (onClickOutside) {
      onClickOutside(e);
    }
  };
  (0, import_react50.useEffect)(() => {
    if (!isOpen) {
      setTimeRangeState(timeRangePickerType);
    }
  }, [isOpen, setTimeRangeState, timeRangePickerType]);
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
    DatePicker_default,
    {
      ...args,
      open: isOpen,
      selected: selected ? new Date(selected) : null,
      showYearPicker: timeRangeState === "year" /* YEAR */,
      showMonthYearPicker: timeRangeState === "month" /* MONTH */,
      showFullMonthYearPicker: true,
      onSelect: onSelectSpy,
      onClickOutside: onClickOutsideSpy,
      customInputProps: {
        onClick: () => setIsOpen(true),
        mask: datePickerMask
      }
    }
  );
};
var DatePickerWithTimeRange_default = DatePickerWithTimeRange;

// src/components/atoms/Form/GoogleAutocomplete/GoogleAutocomplete.tsx
var import_react_google_autocomplete = require("react-google-autocomplete");
var import_react51 = require("react");
var import_styled_components54 = require("styled-components");
var import_jsx_runtime60 = require("react/jsx-runtime");
var ContainerStyle = import_styled_components54.createGlobalStyle`
  body {
    .pac-container {
      border-radius: 8px;
      padding-top: ${({ theme }) => theme.space}px;
      padding-bottom: ${({ theme }) => theme.space}px;;
      overflow: hidden;
      .pac-item {
        display: flex;
        align-items: center;
        border: unset;
        padding-top: ${({ theme }) => theme.space * 2}px;
        padding-bottom: ${({ theme }) => theme.space * 2}px;
        padding-left: ${({ theme }) => theme.space * 3}px;
        padding-right: ${({ theme }) => theme.space * 3}px;
        margin-top: ${({ theme }) => theme.space}px;
        margin-bottom: ${({ theme }) => theme.space}px;
        ${textStyle};
        cursor: pointer;
      }
      .pac-icon-marker {
        display: none;
      }
      .pac-item:hover {
        background: ${({ theme }) => theme.colors.b20};
      }
    }
    .pac-logo::after {
      display: none;
    }
  }
`;
var defaultOptions = {
  componentRestrictions: { country: "us" },
  fields: ["address_components", "geometry", "formatted_address", "place_id"],
  types: []
};
var GoogleAutocomplete = ({
  options,
  // <- see more https://developers.google.com/maps/documentation/javascript/place-autocomplete#set-options-at-construction
  onPlaceSelected,
  onChange,
  menuPortalTarget,
  ...args
}) => {
  const { ref, autocompleteRef } = (0, import_react_google_autocomplete.usePlacesWidget)({
    options: {
      ...options || {},
      ...defaultOptions
    }
  });
  (0, import_react51.useEffect)(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.addListener("place_changed", () => {
        if (onPlaceSelected && autocompleteRef && autocompleteRef.current) {
          onPlaceSelected(autocompleteRef.current.getPlace(), ref.current, autocompleteRef.current);
        }
      });
    }
  }, [autocompleteRef, onPlaceSelected]);
  const onChangeSpy = (event) => {
    onChange && onChange(event);
    const dropdownElement = document.querySelector(".pac-container");
    if (dropdownElement && menuPortalTarget && !menuPortalTarget.querySelector(".pac-container")) {
      menuPortalTarget.appendChild(dropdownElement);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime60.jsxs)(import_jsx_runtime60.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(Input_default, { icon: "search", ref, onChange: onChangeSpy, ...args }),
    /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(ContainerStyle, {})
  ] });
};
var GoogleAutocomplete_default = GoogleAutocomplete;

// src/components/atoms/Form/SelectTree/SelectTree.tsx
var import_react_select4 = require("react-select");
var import_styled_components55 = __toESM(require("styled-components"));
var import_jsx_runtime61 = require("react/jsx-runtime");
var { Option: Option2 } = import_react_select4.components;
var GlobalStyles2 = import_styled_components55.createGlobalStyle`
  .select__menu-list {
    padding: ${({ theme }) => theme.space}px;
    .select__option {
      border-radius: ${({ theme }) => theme.space}px;
    }
  }
`;
var TextSelect = (0, import_styled_components55.default)(Text_default)`
  white-space: nowrap;
`;
var SelectTree = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime61.jsxs)(import_jsx_runtime61.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
      Select_default,
      {
        isMulti: true,
        components: {
          Option: ({ isSelected, data, ...props2 }) => {
            const { isVisible = true, treeIndex, label } = data;
            return isVisible && /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(Option2, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime61.jsxs)(Flex_default, { flexDirection: "row", ml: treeIndex * 8, alignItems: "center", children: [
              /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(Checkbox_default, { onClick: props2.innerProps.onClick, checked: isSelected, mr: 2 }) }),
              /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(TextSelect, { children: label }) })
            ] }) });
          }
        },
        ...props,
        menuFixedWidth: false
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(GlobalStyles2, {})
  ] });
};
var SelectTree_default = SelectTree;

// src/components/atoms/Form/SelectPrice/service.ts
var import_dash_common21 = require("dash-common");
var import_lodash14 = require("lodash");
var priceMaxRange = (min) => [
  "Any Price",
  ...import_dash_common21.PRICE_MAX_SELECT_OPTIONS.filter((p) => p >= (min || 0))
];
var priceMinRange = (max) => (0, import_lodash14.isNil)(max) || max === "Any Price" ? import_dash_common21.PRICE_MIN_SELECT_OPTIONS : import_dash_common21.PRICE_MIN_SELECT_OPTIONS.filter((p) => p <= max);
var priceMaxRangeRent = (min) => [
  "Any Price",
  ...import_dash_common21.PRICE_MAX_SELECT_OPTIONS_RENT.filter((p) => p >= (min || 0))
];
var priceMinRangeRent = (max) => (0, import_lodash14.isNil)(max) || max === "Any Price" ? import_dash_common21.PRICE_MIN_SELECT_OPTIONS_RENT : import_dash_common21.PRICE_MIN_SELECT_OPTIONS_RENT.filter((p) => p <= max);
var validatePrice = (min, max) => {
  if (max === "Any Price")
    return true;
  if ((0, import_lodash14.isNil)(min) || (0, import_lodash14.isNil)(max))
    return true;
  if (isNaN(min) || isNaN(max))
    return true;
  return min <= max;
};

// src/components/atoms/Form/SelectPrice/components/PriceRange/PriceRange.tsx
var import_react53 = require("react");
var import_styled_components57 = require("styled-components");
var import_react_i18next17 = require("react-i18next");

// src/components/atoms/Form/SelectPrice/components/PriceInputWithDropDown/PriceInputWithDropDown.tsx
var import_react52 = require("react");
var import_react_i18next16 = require("react-i18next");
var import_styled_components56 = __toESM(require("styled-components"));
var import_jsx_runtime62 = require("react/jsx-runtime");
var Option3 = (0, import_styled_components56.default)(Box_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  :hover {
    background-color: ${({ theme }) => theme.colors.b20};
  }
`;
var PriceInputWithDropDown = ({
  onChangeValue,
  placeholder,
  value,
  autoFocus,
  range,
  disableDropdown,
  placement = "bottom",
  inputRef,
  label,
  ...restProps
}) => {
  const { t } = (0, import_react_i18next16.useTranslation)("forms");
  const containerRef = (0, import_react52.useRef)(null);
  const getLabel = (item) => item === "Any Price" ? t("labels.anyPrice") : item === void 0 ? item : `$${Number(item)?.toLocaleString("en")}`;
  return /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
    DropDown_default,
    {
      trigger: "hover",
      placement,
      optionsStyle: { zIndex: 160 },
      Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(Box_default, { ref: containerRef, children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
        InputPrice_default,
        {
          innerRef: inputRef,
          autoFocus,
          w: "100%",
          value,
          onChangeValue,
          placeholder,
          autoComplete: "off",
          maskOptions: {
            includeThousandsSeparator: true
          },
          label,
          ...restProps
        }
      ) }),
      children: !disableDropdown ? ({ closeDropdown }) => /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(Box_default, { maxHeight: 300, w: containerRef.current?.offsetWidth, onClick: closeDropdown, children: range.map((item, index2) => /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
        Option3,
        {
          m: 1,
          p: 3,
          onClick: () => {
            onChangeValue(item);
            inputRef.current?.inputElement?.blur();
          },
          children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(Text_default, { id: "price-range-option", children: getLabel(item) })
        },
        index2
      )) }) : void 0
    }
  );
};
var PriceInputWithDropDown_default = PriceInputWithDropDown;

// src/components/atoms/Form/SelectPrice/components/PriceRange/PriceRange.tsx
var import_jsx_runtime63 = require("react/jsx-runtime");
var PriceRange = ({
  price,
  setNodeKey,
  nodeKey,
  minLabel,
  maxLabel,
  disableRangeDropdown,
  isRent,
  handlePrice
}) => {
  const theme = (0, import_styled_components57.useTheme)();
  const { t } = (0, import_react_i18next17.useTranslation)("forms");
  const minRef = (0, import_react53.useRef)(null);
  const maxRef = (0, import_react53.useRef)(null);
  const thisHandlePrice = (field) => (value) => {
    handlePrice(field)(value);
  };
  (0, import_react53.useLayoutEffect)(() => {
    const inputRef = nodeKey === "min" ? minRef : maxRef;
    setTimeout(() => {
      if (inputRef.current) {
        const inputElement = inputRef.current.inputElement;
        inputElement.focus();
      }
    }, 1);
  }, [nodeKey]);
  return /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(Box_default, { p: 4, children: /* @__PURE__ */ (0, import_jsx_runtime63.jsxs)(Flex_default, { alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime63.jsxs)(Form_default.Group, { w: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(Form_default.Label, { children: minLabel || t("labels.priceMin") }),
      /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
        PriceInputWithDropDown_default,
        {
          placement: "bottom",
          value: price?.min,
          onChangeValue: thisHandlePrice("min"),
          placeholder: "$0",
          inputRef: minRef,
          range: isRent ? priceMinRangeRent(price?.max) : priceMinRange(price?.max),
          disableDropdown: disableRangeDropdown,
          label: "min",
          onFocus: () => setNodeKey("min")
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(Devider_default, { mx: 2, mt: 4, minWidth: 17, h: 1, color: theme.colors.n80 }),
    /* @__PURE__ */ (0, import_jsx_runtime63.jsxs)(Form_default.Group, { w: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(Form_default.Label, { children: maxLabel || t("labels.priceMax") }),
      /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
        PriceInputWithDropDown_default,
        {
          placement: "bottom",
          value: price?.max,
          onChangeValue: thisHandlePrice("max"),
          placeholder: t("labels.anyPrice"),
          inputRef: maxRef,
          range: isRent ? priceMaxRangeRent(price?.min) : priceMaxRange(price?.min),
          disableDropdown: disableRangeDropdown,
          label: "max",
          onFocus: () => setNodeKey("max")
        }
      )
    ] })
  ] }) });
};
var PriceRange_default = PriceRange;

// src/components/atoms/Form/SelectPrice/SelectPrice.tsx
var import_react56 = require("react");

// src/components/atoms/Form/SelectPrice/SelectPrice.styles.ts
var import_styled_components58 = __toESM(require("styled-components"));
var StyledBox2 = (0, import_styled_components58.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.05);
  border-radius: 8px;

  .select__menu {
    min-width: fit-content;
  }
  .select__menu-list {
    padding: 4px;

    .select__option {
      cursor: pointer;
      border-radius: 8px;
      height: 48px;
      display: flex;
      align-items: center;
    }
    .select__option--is-selected {
      background-color: ${({ theme }) => theme.colors.b20};
      color: ${({ theme }) => theme.colors.b50};
    }
    .hover-disable {
      padding: 2px 4px;
      :hover {
        background: transparent;
      }
    }
    .hover-disable.select__option--is-focused,
    .hover-disable.select__option--is-selected {
      background: transparent;
    }
  }
`;

// src/components/atoms/Form/SelectPrice/SelectPrice.helpers.ts
var compactPrice = (n) => {
  if (n >= 1e6) {
    const v = n / 1e6;
    return `$${v % 1 === 0 ? v.toString() : v.toFixed(1)}M`;
  }
  if (n >= 1e3) {
    const v = n / 1e3;
    return `$${v % 1 === 0 ? v.toString() : v.toFixed(1)}K`;
  }
  return `$${n.toLocaleString("en")}`;
};
var formatSelectPriceValue = (price, {
  disablePriceMask,
  compact
} = {}) => {
  const pMin = price?.min ?? 0;
  const pMax = price?.max === "Any Price" ? 0 : price?.max ?? 0;
  const min = compact ? compactPrice(pMin) : `$${pMin.toLocaleString("en")}`;
  const max = compact ? compactPrice(pMax) : `$${pMax.toLocaleString("en")}`;
  if (pMin && pMax) {
    return `${min} - ${max}`;
  }
  if (pMax) {
    const maxMask = "<";
    return `${!disablePriceMask ? maxMask : ""} ${max}`;
  }
  if (pMin) {
    const minMask = "+";
    return `${min}${!disablePriceMask ? minMask : ""}`;
  }
  return "";
};

// src/components/atoms/Tooltip/TooltipWrapper.tsx
var import_react54 = require("react");
var import_styled_components59 = __toESM(require("styled-components"));
var import_jsx_runtime64 = require("react/jsx-runtime");
var Container3 = (0, import_styled_components59.default)(Box_default)`
  display: inline-block;
  cursor: pointer;
  height: inherit;
  max-width: 100%;
`;
function TooltipWrapper({
  placement = "top",
  children,
  content,
  rerender,
  delay = 400,
  disableOnTouch = false,
  offset = 0,
  ...args
}) {
  const id2 = (0, import_react54.useId)();
  const refBox = (0, import_react54.useRef)(null);
  const { refModal, isOpen, setIsOpen, handlePosition, setConfig, config, setContent } = (0, import_react54.useContext)(TooltipContext);
  const isTouchDevice = (0, import_react54.useMemo)(
    () => disableOnTouch && typeof window !== "undefined" && ("ontouchstart" in window || navigator.maxTouchPoints > 0),
    [disableOnTouch]
  );
  const handleOpenTooltip = () => {
    if (isTouchDevice)
      return;
    setConfig((state) => ({
      ...state,
      id: id2,
      placement,
      offset
    }));
    setContent(() => content);
    setIsOpen(true);
  };
  const thisHandlePosition = () => {
    const elemBox = refBox.current;
    const rectBox = elemBox.getBoundingClientRect();
    const elemModal = refModal.current;
    const rectModal = elemModal.getBoundingClientRect();
    handlePosition({ rectBox, rectModal });
  };
  (0, import_react54.useEffect)(() => {
    if (isOpen && config.id === id2) {
      handleOpenTooltip();
    }
  }, [rerender]);
  (0, import_react54.useLayoutEffect)(() => {
    if (isOpen && config.id === id2) {
      thisHandlePosition();
    }
  }, [isOpen]);
  const containerProps = {
    onMouseEnter: () => {
      handleOpenTooltip();
      thisHandlePosition();
    },
    onMouseLeave: () => {
      setIsOpen(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(Container3, { id: id2, ref: refBox, ...containerProps, ...args, children });
}
var TooltipWrapper_default = TooltipWrapper;

// src/components/atoms/Tooltip/TooltipPopup.tsx
var import_react55 = require("react");
var import_styled_components60 = __toESM(require("styled-components"));
var import_lodash15 = require("lodash");
var import_jsx_runtime65 = require("react/jsx-runtime");
var tooltipArrowSize = "6";
var ContainerS = import_styled_components60.default.div`
  position: absolute;
  z-index: 120;
  margin-right: 10px;

  .Tooltip-Tip {
    ${boxStyle}
    ${textStyle}
    padding: 6px 14px;
    background: ${({ theme }) => theme.colors.setOpacity(theme.colors.n200, 90)};
    color: ${({ theme }) => theme.colors.white};
    border-radius: ${({ theme }) => `${theme.space / 2}px`};
  }

  .Tooltip-Tip::before {
    position: absolute;
    content: ' ';
    border: solid transparent;
    height: 0;
    width: 0;
    pointer-events: none;
    border-width: ${tooltipArrowSize}px;
    border-top-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.n200, 90)};
  }

  .Tooltip-Tip.top::before {
    top: 100%;
    left: ${({ leftShift = 0 }) => leftShift + 15}px;
  }

  .Tooltip-Tip.bottom::before {
    bottom: 100%;
    transform: rotate(180deg);
    left: ${({ leftShift = 0 }) => leftShift + 15}px;
  }

  .Tooltip-Tip.left::before {
    left: 100%;
    transform: rotate(0) rotate(-90deg);
  }

  .Tooltip-Tip.right::before {
    right: 100%;
    transform: rotate(0) rotate(90deg);
  }
`;
function TooltipPopup() {
  const { refModal, isOpen, content, config, leftShift } = (0, import_react55.useContext)(TooltipContext);
  const display = !(0, import_lodash15.isNil)(content) && (typeof content === "string" ? content.length > 0 : true);
  return /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
    ContainerS,
    {
      leftShift,
      style: { display: isOpen && display ? "flex" : "none" },
      ref: refModal,
      children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("div", { className: `Tooltip-Tip ${config.placement}`, children: content })
    }
  );
}
var TooltipPopup_default = TooltipPopup;

// src/components/atoms/Form/SelectPrice/constants.ts
var PriceRangeInt = {
  min: 0,
  max: void 0
};

// src/components/atoms/Form/SelectPrice/SelectPrice.tsx
var import_jsx_runtime66 = require("react/jsx-runtime");
var SelectPrice = ({
  onChange,
  defaultValue,
  placeholder,
  menuProps = {},
  $errorType,
  disableRangeDropdown,
  onMenuClose,
  onClear,
  menuPortalZIndex = 150,
  isButtonSelect,
  hasInput,
  isRent,
  menuAlign,
  ...props
}) => {
  const [price, setPrice] = (0, import_react56.useState)(
    defaultValue ?? PriceRangeInt
  );
  const [nodeKey, setNodeKey] = (0, import_react56.useState)("min");
  const { min, max } = price || {};
  const prevDefaultValueRef = (0, import_react56.useRef)(defaultValue);
  const onChangeRef = (0, import_react56.useRef)(onChange);
  (0, import_react56.useEffect)(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  (0, import_react56.useEffect)(() => {
    const prevDefault = prevDefaultValueRef.current;
    prevDefaultValueRef.current = defaultValue;
    if (prevDefault !== void 0 && defaultValue === void 0) {
      setPrice(PriceRangeInt);
    } else if (price.min === 0 && price.max === void 0 && defaultValue) {
      setPrice(defaultValue);
    }
  }, [defaultValue]);
  (0, import_react56.useEffect)(() => {
    const isDefault = price.min === 0 && price.max === void 0;
    if (!isDefault) {
      onChangeRef.current({ min, max: max === "Any Price" ? void 0 : max });
    }
  }, [min, max]);
  const handlePrice = (field) => (value) => {
    if (value === "Any Price") {
      setPrice((prev) => ({ ...prev, [field]: "Any Price" }));
      return;
    }
    const isValueNaN = value !== void 0 && isNaN(value);
    setPrice((prev) => ({
      ...prev,
      [field]: isValueNaN ? void 0 : value
    }));
  };
  const inputValue = (0, import_react56.useMemo)(() => formatSelectPriceValue(price), [price]);
  const compactValue = (0, import_react56.useMemo)(
    () => formatSelectPriceValue(price, { compact: true }),
    [price]
  );
  const isActive = !!inputValue;
  const buttonLabel = isButtonSelect ? compactValue : inputValue;
  return /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(Box_default, { pos: "relative", w: "fit-content", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(TooltipWrapper_default, { w: "100%", content: inputValue, children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
    SelectLegacy_default,
    {
      w: "100%",
      isClearable: true,
      isButtonSelect,
      isActive,
      placeholder: isActive ? buttonLabel : placeholder,
      onMenuClose,
      inputValue,
      options: [{ value: inputValue, label: inputValue }],
      value: inputValue || void 0,
      styles: {
        menuPortal: (base) => ({
          ...base,
          zIndex: menuPortalZIndex,
          ...menuAlign === "right" ? { display: "flex", justifyContent: "end" } : {}
        })
      },
      onClear: () => {
        setPrice(PriceRangeInt);
        onChange(PriceRangeInt);
        onClear && onClear();
      },
      components: {
        Menu: () => /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(StyledBox2, { mt: 1, minWidth: 311, children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
          PriceRange_default,
          {
            ...menuProps,
            nodeKey,
            setNodeKey,
            price,
            disableRangeDropdown,
            handlePrice,
            isRent
          }
        ) })
      },
      $errorType
    }
  ) }) });
};
var SelectPrice_default = SelectPrice;

// src/components/atoms/Form/RawNumberSelect/RawNumberSelect.tsx
var import_react57 = require("react");
var import_styled_components62 = require("styled-components");
var import_react_i18next18 = require("react-i18next");

// src/components/atoms/Form/RawNumberSelect/RawNumberSelect.styles.ts
var import_styled_components61 = __toESM(require("styled-components"));
var StyledBox3 = (0, import_styled_components61.default)(Flex_default)`
  background-color: ${({ theme, isActive }) => isActive ? theme.colors.b50 : theme.colors.white};
  cursor: pointer;
`;
var StyledWrapper = (0, import_styled_components61.default)(Flex_default)`
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.n40};

  & > div:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.colors.n40};
  }

  & > div:last-child {
    border-radius: 0 6px 6px 0;
  }

  & > div:first-child {
    border-radius: 6px 0 0 6px;
  }
`;

// src/components/atoms/Form/RawNumberSelect/RawNumberSelect.tsx
var import_jsx_runtime67 = require("react/jsx-runtime");
var RawNumberSelect = ({
  onChange,
  value = null,
  options = [1, 2, 3, 4, 5]
}) => {
  const theme = (0, import_styled_components62.useTheme)();
  const { t } = (0, import_react_i18next18.useTranslation)("common");
  const [itemValue, setItemValue] = (0, import_react57.useState)(value);
  const rawOptions = (0, import_react57.useMemo)(
    () => [
      { label: t("labels.any"), value: null },
      ...options.map((item) => ({ label: item, value: item }))
    ],
    [options]
  );
  (0, import_react57.useEffect)(() => {
    if (itemValue !== value) {
      setItemValue(value);
    }
  }, [value, itemValue, setItemValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(StyledWrapper, { w: "fit-content", children: rawOptions.map((item, index2) => {
    const isActive = item.value === itemValue;
    const isLastIndex = index2 === rawOptions.length - 1;
    return /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
      StyledBox3,
      {
        onClick: () => {
          setItemValue(item.value);
          onChange(item.value);
        },
        w: 41,
        h: 32,
        alignItems: "center",
        justifyContent: "center",
        isActive,
        children: /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(Text_default, { color: isActive ? theme.colors.white : theme.colors.n90, children: isLastIndex ? `${item.label}+` : item.label })
      },
      `${item.value}-${index2}`
    );
  }) });
};
var RawNumberSelect_default = RawNumberSelect;

// src/components/atoms/Form/BathsAndBedsSelect/BathsAndBedsSelect.tsx
var import_react58 = require("react");
var import_react_select5 = require("react-select");
var import_react_i18next19 = require("react-i18next");

// src/components/atoms/Form/BathsAndBedsSelect/BathsAndBedsSelect.helpers.ts
var formatValue = (units, t) => {
  const arr = [];
  const { unitNumberOfBathrooms, unitNumberOfBedrooms } = units;
  if (unitNumberOfBedrooms || unitNumberOfBathrooms) {
    arr.push(t("forms:labels.beds", { count: unitNumberOfBedrooms || 0 }));
    arr.push(t("forms:labels.baths", { count: unitNumberOfBathrooms || 0 }));
  }
  return arr.join(", ");
};

// src/components/atoms/Form/BathsAndBedsSelect/BathsAndBedsSelect.tsx
var import_jsx_runtime68 = require("react/jsx-runtime");
var { Menu: Menu2 } = import_react_select5.components;
var Component = ({ setUnits, units }) => {
  const { t } = (0, import_react_i18next19.useTranslation)("pages");
  const handleInputs = (key) => (value) => {
    setUnits({ ...units, [key]: value });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)(Box_default, { p: 4, minWidth: 272, children: [
    /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)(Form_default.Group, { mb: 6, children: [
      /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(Form_default.Label, { children: t("propertyPage.numberOfBedrooms") }),
      /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
        RawNumberSelect_default,
        {
          value: units?.unitNumberOfBedrooms,
          onChange: handleInputs("unitNumberOfBedrooms")
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)(Form_default.Group, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(Form_default.Label, { children: t("propertyPage.numberOfBathrooms") }),
      /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
        RawNumberSelect_default,
        {
          value: units?.unitNumberOfBathrooms,
          onChange: handleInputs("unitNumberOfBathrooms")
        }
      )
    ] })
  ] });
};
var BathsAndBedsSelect = ({
  onSelectChanged,
  unitsValue,
  ...props
}) => {
  const [units, setUnits] = (0, import_react58.useState)({});
  const { t } = (0, import_react_i18next19.useTranslation)();
  (0, import_react58.useEffect)(() => {
    setUnits(unitsValue || {});
  }, [unitsValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
    Select_default,
    {
      ...props,
      inputValue: formatValue(units, t),
      isClearable: true,
      components: {
        Menu: (args) => /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(Menu2, { ...args, children: /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
          Component,
          {
            units,
            setUnits: (value) => {
              setUnits(value);
              if (onSelectChanged) {
                onSelectChanged(value);
              }
            }
          }
        ) })
      }
    }
  );
};
var BathsAndBedsSelect_default = BathsAndBedsSelect;

// src/components/atoms/Form/TagSelect/TagSelect.tsx
var import_react59 = require("react");
var import_styled_components64 = __toESM(require("styled-components"));
var import_lodash16 = require("lodash");

// src/components/atoms/Tag/Tag.tsx
var import_styled_components63 = __toESM(require("styled-components"));
var import_jsx_runtime69 = require("react/jsx-runtime");
var disabledStyle = import_styled_components63.css`
  cursor: not-allowed;
  background-color: ${({ theme }) => theme.colors.n20};
  &:hover {
    background-color: ${({ theme }) => theme.colors.n20};
  }
`;
var TagStyle = (0, import_styled_components63.default)(Flex_default)`
  cursor: pointer;
  border-radius: ${({ theme }) => theme.space * 4}px;
  background-color: ${({ theme, active }) => active ? theme.colors.b100 : theme.colors.n40};
  &:hover {
    background-color: ${({ theme, active }) => active ? theme.colors.b50Hover : theme.colors.n50};
  }
  ${({ disabled }) => disabled && disabledStyle}
`;
var Tag = ({ active, disabled, iconLeft, iconRight, children, ...args }) => {
  const theme = (0, import_styled_components63.useTheme)();
  const mainColor = active ? theme.colors.white : theme.colors.n70;
  const color2 = disabled ? theme.colors.n60 : mainColor;
  return /* @__PURE__ */ (0, import_jsx_runtime69.jsxs)(
    TagStyle,
    {
      active,
      disabled,
      alignItems: "center",
      justifyContent: "center",
      px: 3,
      py: 1,
      ...args,
      children: [
        iconLeft && /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(Icon_default, { color: color2, mr: 2, name: iconLeft, size: 9 }),
        /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(Text_default, { semibold: true, color: color2, children }),
        iconRight && /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(Icon_default, { color: color2, ml: 2, name: iconRight, size: 9 })
      ]
    }
  );
};
var Tag_default = Tag;

// src/components/atoms/Form/TagSelect/TagSelect.tsx
var import_jsx_runtime70 = require("react/jsx-runtime");
var TagSelectWrapper = (0, import_styled_components64.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  background-color: ${({ theme }) => theme.colors.n20};
`;
var TagSelect = ({ options, defaultValue, onChange, value, gap, ...props }) => {
  const [selectedValue, setSelectedValue] = (0, import_react59.useState)([]);
  const [isSelectedValueChanged, setIsSelectedValueChanged] = (0, import_react59.useState)(false);
  const handleTagValue = (value2, action) => {
    setIsSelectedValueChanged(true);
    if (action === "add") {
      return setSelectedValue((prev) => [...prev, value2]);
    }
    setSelectedValue((prev) => prev.filter((item) => item !== value2));
  };
  (0, import_react59.useEffect)(() => {
    setSelectedValue(defaultValue || []);
  }, [defaultValue]);
  (0, import_react59.useEffect)(() => {
    if (onChange && isSelectedValueChanged) {
      onChange(selectedValue);
    }
  }, [selectedValue, isSelectedValueChanged]);
  (0, import_react59.useEffect)(() => {
    if (value && (0, import_lodash16.difference)(value, selectedValue).length) {
      setSelectedValue(value);
    }
  }, [value, setSelectedValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(TagSelectWrapper, { p: 2, flexWrap: "wrap", gap: gap || 8, ...props, children: options.map((item) => {
    const isActive = !!selectedValue.find((value2) => value2 === item.value);
    return /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
      Tag_default,
      {
        active: isActive,
        iconRight: isActive ? "close" : "plus",
        onClick: () => handleTagValue(item.value, isActive ? "remove" : "add"),
        children: item.label
      },
      item.value
    );
  }) });
};
var TagSelect_default = TagSelect;

// src/components/atoms/Form/RadioInput/RadioInput.styles.tsx
var import_styled_components65 = __toESM(require("styled-components"));
var StyledRadio = import_styled_components65.default.input`
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  width: 18px;
  height: 18px;
  border: 1px solid ${({ theme }) => theme.colors.n60};
  border-radius: 50%;

  ::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin: 3px;
  }
  :checked {
    border: 2px solid ${({ theme }) => theme.colors.b50} !important;
    ::after {
      background-color: ${({ theme }) => theme.colors.b50};
    }
  }
  :hover {
    border-color: ${({ theme }) => theme.colors.n70};
  }
  :disabled {
    border: 1px solid ${({ theme }) => theme.colors.n50};
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.n20};

    :checked {
      border: 2px solid ${({ theme }) => theme.colors.n50} !important;
      ::after {
        background-color: ${({ theme }) => theme.colors.n50};
      }
    }
  }
`;

// src/components/atoms/Form/RadioInput/RadioInput.tsx
var import_jsx_runtime71 = require("react/jsx-runtime");
function RadioInput({ onChange, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(Flex_default, { alignItems: "center", ...args, children: /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(StyledRadio, { type: "radio", onChange, ...args }) });
}
var RadioInput_default = RadioInput;

// src/components/atoms/Form/InputAutocomplete/InputAutocomplete.tsx
var import_react60 = require("react");
var import_styled_components67 = require("styled-components");
var import_react_i18next20 = require("react-i18next");
var import_react_select6 = __toESM(require("react-select"));

// src/components/atoms/Form/InputAutocomplete/InputAutocomplete.styles.ts
var import_styled_components66 = __toESM(require("styled-components"));
var OptionContainer = (0, import_styled_components66.default)(Flex_default)`
  cursor: ${({ isDisabled }) => isDisabled ? "not-allowed" : "pointer"};
`;
var DisabledBoxWrapper = (0, import_styled_components66.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space}px;
  min-width: fit-content;
`;

// src/components/atoms/Form/InputAutocomplete/InputAutocomplete.tsx
var import_jsx_runtime72 = require("react/jsx-runtime");
var { Option: Option4 } = import_react_select6.components;
var InputAutocomplete = ({
  options,
  onChange,
  placeholder,
  ...props
}) => {
  const theme = (0, import_styled_components67.useTheme)();
  const { t } = (0, import_react_i18next20.useTranslation)("common", { keyPrefix: "labels" });
  const [inputValue, setInputValue] = (0, import_react60.useState)("");
  const handleInputValue = (value, { action }) => {
    if (action !== "input-blur" && action !== "menu-close") {
      setInputValue(value);
      if (onChange)
        onChange(value);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(StyledSelectWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
    import_react_select6.default,
    {
      isSearchable: true,
      menuPortalTarget: document.body,
      menuPlacement: "auto",
      filterOption: (0, import_react_select6.createFilter)({ matchFrom: "any", stringify: (option) => `${option.label}` }),
      inputValue,
      backspaceRemovesValue: true,
      isClearable: true,
      placeholder,
      defaultInputValue: inputValue,
      onChange: (option) => onChange && onChange(option?.value || ""),
      styles: {
        menuPortal: (base) => ({ ...base, zIndex: 150 }),
        // Prevent iOS Safari zoom on focus (requires 16px minimum)
        input: (base) => ({ ...base, fontSize: "16px" })
      },
      blurInputOnSelect: false,
      onInputChange: handleInputValue,
      classNamePrefix: "select",
      options,
      components: {
        DropdownIndicator: () => null,
        ClearIndicator: () => null,
        NoOptionsMessage: () => /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(Flex_default, { h: 42, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(Text_default, { color: theme.colors.n70, children: t`noOptions` }) }),
        Option: ({ children, ...props2 }) => /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(Option4, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime72.jsxs)(
          OptionContainer,
          {
            justifyContent: "space-between",
            alignItems: "center",
            isDisabled: props2.isDisabled,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(Text_default, { color: props2.isDisabled ? theme.colors.n80 : theme.colors.n90, children }),
              props2.isDisabled && /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(DisabledBoxWrapper, { px: 2, py: 1, children: /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(Text_default, { semibold: true, sm: true, color: theme.colors.n80, children: t`added` }) })
            ]
          }
        ) })
      }
    }
  ) });
};
var InputAutocomplete_default = InputAutocomplete;

// src/components/atoms/Form/WorkingWeekHoursInput/WorkingWeekHoursInput.tsx
var import_moment7 = __toESM(require("moment"));
var import_react62 = require("react");
var import_styled_components70 = __toESM(require("styled-components"));
var import_react_i18next22 = require("react-i18next");
var import_dash_common22 = require("dash-common");

// src/components/organisms/WorkingHoursInput/WorkingHoursInput.tsx
var import_moment6 = __toESM(require("moment"));
var import_styled_components69 = __toESM(require("styled-components"));
var import_react_i18next21 = require("react-i18next");
var import_react61 = require("react");

// src/components/molecules/TimePicker/TimePicker.helpers.ts
var import_moment5 = __toESM(require("moment"));
var createValueByHours = (hours) => {
  const today = (0, import_moment5.default)().format("YYYY-MM-DD");
  return (0, import_moment5.default)(`${today} ${hours}`, "YYYY-MM-DD hh:mm A", "en", true).toISOString();
};

// src/components/molecules/TimePicker/TimePicker.tsx
var import_jsx_runtime73 = require("react/jsx-runtime");
var OPTIONS = [
  { label: "12:00 AM", value: "12:00 AM" },
  { label: "12:30 AM", value: "12:30 AM" },
  { label: "01:00 AM", value: "01:00 AM" },
  { label: "01:30 AM", value: "01:30 AM" },
  { label: "02:00 AM", value: "02:00 AM" },
  { label: "02:30 AM", value: "02:30 AM" },
  { label: "03:00 AM", value: "03:00 AM" },
  { label: "03:30 AM", value: "03:30 AM" },
  { label: "04:00 AM", value: "04:00 AM" },
  { label: "04:30 AM", value: "04:30 AM" },
  { label: "05:00 AM", value: "05:00 AM" },
  { label: "05:30 AM", value: "05:30 AM" },
  { label: "06:00 AM", value: "06:00 AM" },
  { label: "06:30 AM", value: "06:30 AM" },
  { label: "07:00 AM", value: "07:00 AM" },
  { label: "07:30 AM", value: "07:30 AM" },
  { label: "08:00 AM", value: "08:00 AM" },
  { label: "08:30 AM", value: "08:30 AM" },
  { label: "09:00 AM", value: "09:00 AM" },
  { label: "09:30 AM", value: "09:30 AM" },
  { label: "10:00 AM", value: "10:00 AM" },
  { label: "10:30 AM", value: "10:30 AM" },
  { label: "11:00 AM", value: "11:00 AM" },
  { label: "11:30 AM", value: "11:30 AM" },
  { label: "12:00 PM", value: "12:00 PM" },
  { label: "12:30 PM", value: "12:30 PM" },
  { label: "01:00 PM", value: "01:00 PM" },
  { label: "01:30 PM", value: "01:30 PM" },
  { label: "02:00 PM", value: "02:00 PM" },
  { label: "02:30 PM", value: "02:30 PM" },
  { label: "03:00 PM", value: "03:00 PM" },
  { label: "03:30 PM", value: "03:30 PM" },
  { label: "04:00 PM", value: "04:00 PM" },
  { label: "04:30 PM", value: "04:30 PM" },
  { label: "05:00 PM", value: "05:00 PM" },
  { label: "05:30 PM", value: "05:30 PM" },
  { label: "06:00 PM", value: "06:00 PM" },
  { label: "06:30 PM", value: "06:30 PM" },
  { label: "07:00 PM", value: "07:00 PM" },
  { label: "07:30 PM", value: "07:30 PM" },
  { label: "08:00 PM", value: "08:00 PM" },
  { label: "08:30 PM", value: "08:30 PM" },
  { label: "09:00 PM", value: "09:00 PM" },
  { label: "09:30 PM", value: "09:30 PM" },
  { label: "10:00 PM", value: "10:00 PM" },
  { label: "10:30 PM", value: "10:30 PM" },
  { label: "11:00 PM", value: "11:00 PM" },
  { label: "11:30 PM", value: "11:30 PM" }
];
var TimePicker = ({ onChanged, minValue, ...args }) => {
  const minIndex = minValue && OPTIONS.findIndex((item) => item.value === minValue);
  const options = minIndex ? OPTIONS.slice(minIndex, OPTIONS.length) : OPTIONS;
  return /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(
    Select_default,
    {
      ...args,
      options,
      onChanged: (value) => onChanged && onChanged(createValueByHours(value))
    }
  );
};
var TimePicker_default = TimePicker;

// src/components/atoms/Toggle/Toggle.styles.ts
var import_styled_components68 = __toESM(require("styled-components"));
var import_react_toggle = __toESM(require("react-toggle"));
var ToggleStyle = (0, import_styled_components68.default)(import_react_toggle.default)`
  &.react-toggle {
    touch-action: pan-x;

    display: inline-block;
    position: relative;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    padding: 0;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
  }

  & .react-toggle-screenreader-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  & .react-toggle-track {
    width: ${({ width }) => width || 48}px;
    height: ${({ height }) => height || 24}px;
    padding: 0;
    border-radius: 24px;
    background-color: ${({ theme }) => theme.colors.n40};
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  // hover state
  &.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${({ theme }) => theme.colors.n50};
  }

  &.react-toggle--checked .react-toggle-track {
    background-color: ${({ theme, color: color2 }) => color2 || theme.colors.b50Active};
  }

  &.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${({ theme, color: color2 }) => color2 || theme.colors.b50Hover};
  }
  // disabled state
  &.react-toggle--checked.react-toggle--disabled .react-toggle-track {
    background-color: ${({ theme }) => theme.colors.n60};
  }
  &.react-toggle--disabled .react-toggle-track {
    background-color: ${({ theme }) => theme.colors.n30};
  }

  & .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    left: 8px;
    opacity: 0;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  &.react-toggle--checked .react-toggle-track-check {
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  & .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    right: 10px;
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  &.react-toggle--checked .react-toggle-track-x {
    opacity: 0;
  }

  & .react-toggle-thumb {
    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    position: absolute;
    top: 4px;
    left: 4px;
    width: ${({ theme, thumbsize }) => thumbsize || theme.space * 4}px;
    height: ${({ theme, thumbsize }) => thumbsize || theme.space * 4}px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.white};

    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transition: all 0.25s ease;
    -moz-transition: all 0.25s ease;
    transition: all 0.25s ease;
  }

  &.react-toggle--checked .react-toggle-thumb {
    left: 28px;
  }
`;
var Toggle_styles_default = ToggleStyle;

// src/components/atoms/Toggle/Toggle.tsx
var import_jsx_runtime74 = require("react/jsx-runtime");
function Toggle({ type = "checkbox", label, labelProps = {}, flexProps, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(Flex_default, { ...flexProps, children: [
    /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Toggle_styles_default, { icons: false, type, ...args }),
    label && /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Box_default, { ml: 1, children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Text_default, { ...labelProps, children: label }) })
  ] });
}
var Toggle_default = Toggle;

// src/components/organisms/WorkingHoursInput/WorkingHoursInput.tsx
var import_jsx_runtime75 = require("react/jsx-runtime");
var TextWrapper = (0, import_styled_components69.default)(Box_default)`
  white-space: nowrap;
`;
var WorkingHoursInput = ({
  onChange,
  onSwitch,
  defaultValue,
  $errorType,
  label,
  withRightIcon = true,
  disabled = false,
  ...args
}) => {
  const theme = (0, import_styled_components69.useTheme)();
  const { t } = (0, import_react_i18next21.useTranslation)("common");
  const [checked, setChecked] = (0, import_react61.useState)(false);
  const [timeStripe, setTimeStripe] = (0, import_react61.useState)({});
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const timerPickerWidth = isMobile ? "100%" : withRightIcon ? 128 : 104;
  const handleTimeSelector = (value, type) => {
    if (type === "from" /* From */) {
      setTimeStripe((prev) => ({
        from: value,
        to: new Date(value).getTime() < new Date(prev?.to || "").getTime() ? prev.to : value
      }));
    }
    setTimeStripe((prev) => ({ ...prev, [type]: value }));
  };
  (0, import_react61.useEffect)(() => {
    if (timeStripe?.from || timeStripe?.to) {
      onChange(timeStripe);
    }
  }, [timeStripe]);
  (0, import_react61.useLayoutEffect)(() => {
    if (defaultValue) {
      setTimeStripe(defaultValue);
      setChecked(true);
    } else {
      setTimeStripe({});
      setChecked(false);
    }
  }, [defaultValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime75.jsxs)(
    Flex_default,
    {
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "flex-start" : "center",
      ...args,
      w: "100%",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime75.jsxs)(Flex_default, { alignItems: "center", mb: [3, 0, 0, 0], children: [
          label && /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(Box_default, { mr: 3, w: 48, children: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(Text_default, { children: label }) }),
          /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
            Toggle_default,
            {
              color: theme.colors.g20,
              width: 60,
              height: 32,
              thumbsize: 24,
              icons: {
                checked: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(Icon_default, { name: "check", color: theme.colors.white, size: 12 }),
                unchecked: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(Icon_default, { name: "close", color: theme.colors.white, size: 12 })
              },
              checked,
              onChange: (e) => {
                setChecked(e.target.checked);
                if (!e.target.checked) {
                  setTimeStripe({});
                }
                if (onSwitch) {
                  onSwitch(e.target.checked);
                }
              },
              disabled
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime75.jsxs)(Flex_default, { w: "100%", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
            TimePicker_default,
            {
              ml: [0, 3, 3, 3],
              placeholder: "00:00 AM",
              w: timerPickerWidth,
              minValue: "05:00 AM",
              value: timeStripe.from ? (0, import_moment6.default)(timeStripe.from).format("hh:mm A") : void 0,
              disabled: disabled || !checked,
              onChanged: (value) => handleTimeSelector(value, "from" /* From */),
              isSearchable: false,
              $errorType,
              components: withRightIcon ? {} : { DropdownIndicator: () => null }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(TextWrapper, { mx: isMobile ? 1 : 5, children: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(Text_default, { whiteSpace: "nowrap", children: t("labels.to").toUpperCase() }) }),
          /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
            TimePicker_default,
            {
              placeholder: "00:00 PM",
              w: timerPickerWidth,
              value: timeStripe.to ? (0, import_moment6.default)(timeStripe.to).format("hh:mm A") : void 0,
              minValue: timeStripe.from ? (0, import_moment6.default)(defaultValue?.from || timeStripe.from).format("hh:mm A") : "05:00 AM",
              disabled: disabled || !checked,
              onChanged: (value) => handleTimeSelector(value, "to" /* To */),
              isSearchable: false,
              $errorType,
              components: withRightIcon ? {} : { DropdownIndicator: () => null }
            }
          )
        ] })
      ]
    }
  );
};
var WorkingHoursInput_default = WorkingHoursInput;

// src/components/atoms/Form/WorkingWeekHoursInput/WorkingWeekHoursInput.tsx
var import_jsx_runtime76 = require("react/jsx-runtime");
var StyledWrapper2 = (0, import_styled_components70.default)(Flex_default)`
  max-width: 966px;
`;
var WorkingWeekHoursInput = ({
  formField,
  disabled
}) => {
  const { stateHandlers, formState } = (0, import_react62.useContext)(FormContext);
  const { t } = (0, import_react_i18next22.useTranslation)(["forms", "common"]);
  const handleTimePickerValue = (day) => (value) => {
    stateHandlers[formField]({
      ...formState.workingHours,
      [day]: value
    });
  };
  const setDefaultWorkingHours = (day) => (checked) => {
    if (!checked) {
      stateHandlers[formField]({
        ...formState.workingHours,
        [day]: null
      });
    } else {
      const [defaultFrom, defaultTo] = [
        (0, import_moment7.default)().set({ hour: 5, minute: 0, second: 0, millisecond: 0 }).toISOString(),
        (0, import_moment7.default)().set({ hour: 22, minute: 0, second: 0, millisecond: 0 }).toISOString()
      ];
      stateHandlers[formField]({
        ...formState.workingHours,
        [day]: { from: defaultFrom, to: defaultTo }
      });
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(StyledWrapper2, { flexWrap: "wrap", justifyContent: "space-between", children: Object.values(import_dash_common22.WeekDays).map((day) => {
    const date = formState.workingHours && formState.workingHours[day];
    return /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(Box_default, { w: "100%", mb: 9, children: /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
      WorkingHoursInput_default,
      {
        disabled,
        label: t(`common:labels.weekDays.${day}`).slice(0, day === import_dash_common22.WeekDays.Tuesday ? 4 : 3).toUpperCase(),
        onChange: handleTimePickerValue(day),
        onSwitch: setDefaultWorkingHours(day),
        ...date && { defaultValue: date }
      }
    ) }, day);
  }) });
};
var WorkingWeekHoursInput_default = WorkingWeekHoursInput;

// src/components/atoms/Form/LocalTimeWeekHoursInput/LocalTimeWeekHoursInput.tsx
var import_react64 = require("react");
var import_styled_components72 = __toESM(require("styled-components"));
var import_react_i18next24 = require("react-i18next");
var import_dash_common23 = require("dash-common");

// src/components/organisms/LocalTimeHoursInput/LocalTimeHoursInput.tsx
var import_styled_components71 = __toESM(require("styled-components"));
var import_react_i18next23 = require("react-i18next");
var import_react63 = require("react");
var import_jsx_runtime77 = require("react/jsx-runtime");
var TextWrapper2 = (0, import_styled_components71.default)(Box_default)`
  white-space: nowrap;
`;
var convertTo24Hour = (time12) => {
  if (!time12)
    return "";
  const [time, period] = time12.split(" ");
  const [hours, minutes] = time.split(":");
  let hour = parseInt(hours, 10);
  if (period === "PM" && hour !== 12) {
    hour += 12;
  } else if (period === "AM" && hour === 12) {
    hour = 0;
  }
  return `${hour.toString().padStart(2, "0")}:${minutes}`;
};
var convertTo12Hour = (time24) => {
  if (!time24)
    return "";
  const [hours, minutes] = time24.split(":");
  let hour = parseInt(hours, 10);
  const period = hour < 12 ? "AM" : "PM";
  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour -= 12;
  }
  return `${hour.toString().padStart(2, "0")}:${minutes} ${period}`;
};
var LocalTimeHoursInput = ({
  onChange,
  onSwitch,
  defaultValue,
  $errorType,
  label,
  withRightIcon = true,
  disabled = false,
  ...args
}) => {
  const theme = (0, import_styled_components71.useTheme)();
  const { t } = (0, import_react_i18next23.useTranslation)("common");
  const [checked, setChecked] = (0, import_react63.useState)(false);
  const [timeStripe, setTimeStripe] = (0, import_react63.useState)(
    {}
  );
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const timerPickerWidth = isMobile ? "100%" : withRightIcon ? 128 : 104;
  const handleTimeSelector = (value, type) => {
    const dateObj = new Date(value);
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const time24 = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    if (type === "from" /* From */) {
      setTimeStripe((prev) => {
        const newFrom = time24;
        const currentTo = prev?.to;
        if (currentTo && newFrom >= currentTo) {
          const nextSlot = getNextTimeSlot(convertTo12Hour(newFrom));
          const nextSlot24 = convertTo24Hour(nextSlot);
          return { from: newFrom, to: nextSlot24 };
        }
        return { ...prev, from: newFrom };
      });
    } else {
      setTimeStripe((prev) => ({ ...prev, [type]: time24 }));
    }
  };
  const getNextTimeSlot = (time12) => {
    const times = [
      "12:00 AM",
      "12:30 AM",
      "01:00 AM",
      "01:30 AM",
      "02:00 AM",
      "02:30 AM",
      "03:00 AM",
      "03:30 AM",
      "04:00 AM",
      "04:30 AM",
      "05:00 AM",
      "05:30 AM",
      "06:00 AM",
      "06:30 AM",
      "07:00 AM",
      "07:30 AM",
      "08:00 AM",
      "08:30 AM",
      "09:00 AM",
      "09:30 AM",
      "10:00 AM",
      "10:30 AM",
      "11:00 AM",
      "11:30 AM",
      "12:00 PM",
      "12:30 PM",
      "01:00 PM",
      "01:30 PM",
      "02:00 PM",
      "02:30 PM",
      "03:00 PM",
      "03:30 PM",
      "04:00 PM",
      "04:30 PM",
      "05:00 PM",
      "05:30 PM",
      "06:00 PM",
      "06:30 PM",
      "07:00 PM",
      "07:30 PM",
      "08:00 PM",
      "08:30 PM",
      "09:00 PM",
      "09:30 PM",
      "10:00 PM",
      "10:30 PM",
      "11:00 PM",
      "11:30 PM"
    ];
    const currentIndex = times.indexOf(time12);
    if (currentIndex === -1 || currentIndex === times.length - 1) {
      return time12;
    }
    return times[currentIndex + 1];
  };
  (0, import_react63.useEffect)(() => {
    if (timeStripe?.from || timeStripe?.to) {
      onChange(timeStripe);
    }
  }, [timeStripe]);
  (0, import_react63.useEffect)(() => {
    if (defaultValue) {
      setTimeStripe(defaultValue);
      if (!checked) {
        setChecked(true);
      }
    } else {
      setTimeStripe({});
      setChecked(false);
    }
  }, [defaultValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(
    Flex_default,
    {
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "flex-start" : "center",
      ...args,
      w: "100%",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(Flex_default, { alignItems: "center", mb: [3, 0, 0, 0], children: [
          label && /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Box_default, { mr: 3, w: 48, children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Text_default, { children: label }) }),
          /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
            Toggle_default,
            {
              color: theme.colors.g20,
              width: 60,
              height: 32,
              thumbsize: 24,
              icons: {
                checked: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Icon_default, { name: "check", color: theme.colors.white, size: 12 }),
                unchecked: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Icon_default, { name: "close", color: theme.colors.white, size: 12 })
              },
              checked,
              onChange: (e) => {
                setChecked(e.target.checked);
                if (!e.target.checked) {
                  setTimeStripe({});
                }
                if (onSwitch) {
                  onSwitch(e.target.checked);
                }
              },
              disabled
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(Flex_default, { w: "100%", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
            TimePicker_default,
            {
              ml: [0, 3, 3, 3],
              placeholder: "00:00 AM",
              w: timerPickerWidth,
              minValue: "05:00 AM",
              value: timeStripe.from ? convertTo12Hour(timeStripe.from) : void 0,
              disabled: disabled || !checked,
              onChanged: (value) => handleTimeSelector(value, "from" /* From */),
              isSearchable: false,
              components: withRightIcon ? {} : { DropdownIndicator: () => null }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(TextWrapper2, { mx: isMobile ? 1 : 5, children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Text_default, { whiteSpace: "nowrap", children: t("labels.to").toUpperCase() }) }),
          /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
            TimePicker_default,
            {
              placeholder: "00:00 PM",
              w: timerPickerWidth,
              value: timeStripe.to ? convertTo12Hour(timeStripe.to) : void 0,
              minValue: timeStripe.from ? getNextTimeSlot(convertTo12Hour(timeStripe.from)) : "05:00 AM",
              disabled: disabled || !checked,
              onChanged: (value) => handleTimeSelector(value, "to" /* To */),
              isSearchable: false,
              components: withRightIcon ? {} : { DropdownIndicator: () => null }
            },
            `to-${timeStripe.to}`
          )
        ] })
      ]
    }
  );
};
var LocalTimeHoursInput_default = LocalTimeHoursInput;

// src/components/atoms/Form/LocalTimeWeekHoursInput/LocalTimeWeekHoursInput.tsx
var import_jsx_runtime78 = require("react/jsx-runtime");
var StyledWrapper3 = (0, import_styled_components72.default)(Flex_default)`
  max-width: 966px;
`;
var LocalTimeWeekHoursInput = ({
  formField,
  disabled
}) => {
  const { stateHandlers, formState } = (0, import_react64.useContext)(FormContext);
  const { t } = (0, import_react_i18next24.useTranslation)(["forms", "common"]);
  const handleTimePickerValue = (day) => (value) => {
    stateHandlers[formField]({
      ...formState[formField] || {},
      [day]: value
    });
  };
  const setDefaultWorkingHours = (day) => (checked) => {
    if (!checked) {
      stateHandlers[formField]({
        ...formState[formField] || {},
        [day]: null
      });
    } else {
      stateHandlers[formField]({
        ...formState[formField] || {},
        [day]: { from: "10:00", to: "18:00" }
      });
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(StyledWrapper3, { flexWrap: "wrap", justifyContent: "space-between", children: Object.values(import_dash_common23.WeekDays).map((day) => {
    const hours = formState[formField] && formState[formField][day];
    return /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(Box_default, { w: "100%", mb: 9, children: /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
      LocalTimeHoursInput_default,
      {
        disabled,
        label: t(`common:labels.weekDays.${day}`).slice(0, day === import_dash_common23.WeekDays.Tuesday ? 4 : 3).toUpperCase(),
        onChange: handleTimePickerValue(day),
        onSwitch: setDefaultWorkingHours(day),
        ...hours && { defaultValue: hours }
      }
    ) }, day);
  }) });
};
var LocalTimeWeekHoursInput_default = LocalTimeWeekHoursInput;

// src/components/atoms/Steps/Steps.helpers.ts
var getStepStatus = (stepIndex, activeStep) => {
  if (Number.isInteger(activeStep)) {
    if (activeStep === stepIndex) {
      return "ACTIVE" /* ACTIVE */;
    }
    if (activeStep && activeStep > stepIndex) {
      return "PASSED" /* PASSED */;
    }
  }
  return "DISABLED" /* DISABLED */;
};

// src/components/atoms/Steps/Steps.styles.ts
var import_styled_components73 = __toESM(require("styled-components"));
var stepStyle = import_styled_components73.css`
  ${({ theme, status }) => {
  const statusStyleRelations = {
    ["ACTIVE" /* ACTIVE */]: import_styled_components73.css`
        color: ${theme.colors.black};
        border-bottom: 1px solid ${theme.colors.g20};
      `,
    ["DISABLED" /* DISABLED */]: import_styled_components73.css`
        color: ${theme.colors.n70};
        cursor: default;
      `,
    ["PASSED" /* PASSED */]: import_styled_components73.css`
        color: ${theme.colors.g20};
        padding: 8px 10px;
      `
  };
  return statusStyleRelations[status] || "";
}}
`;
var StepButtonStyle = import_styled_components73.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  cursor: pointer;
  background-color: transparent;
  padding: 8px 24px;
  display: flex;
  align-items: center;
  ${textStyle}
  ${stepStyle}
`;

// src/components/atoms/Steps/Steps.tsx
var import_jsx_runtime79 = require("react/jsx-runtime");
function Steps({ steps: steps2, activeStep, onClick, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(Flex_default, { ...args, children: steps2.map(({ label, icon }, index2) => {
    const stepStatus = getStepStatus(index2, activeStep);
    const isPassed = stepStatus === "PASSED" /* PASSED */;
    return /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
      StepButtonStyle,
      {
        onClick: () => isPassed && onClick(index2),
        status: stepStatus,
        children: [
          isPassed && /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(Icon_default, { name: icon || "check", size: 14, mr: 2 }),
          label
        ]
      },
      index2 + label
    );
  }) });
}
var Steps_default = Steps;

// src/components/atoms/Breadcrumb/Breadcrumb.helpers.ts
var cutBreadcrumbItemsByLimit = (items, limit) => {
  const withLimit = items.length > limit && limit > 3;
  if (withLimit) {
    const limitedItems = [...items];
    const startFrom = limit - 3;
    const endTo = items.length - limit + 1;
    limitedItems.splice(startFrom, endTo, { label: "..." });
    return limitedItems;
  }
  return items;
};

// src/components/atoms/Breadcrumb/Breadcrumb.styles.ts
var import_styled_components74 = __toESM(require("styled-components"));
var InlineFlexBox = import_styled_components74.default.span`
  ${textStyle};
  display: inline-flex;
  color: ${({ theme }) => theme.colors.n70};
`;
var BreadcrumbItemStyle = import_styled_components74.default.a`
  ${textStyle};
  display: inline-flex;
  align-items: center;
  cursor: ${({ enabledNavigation }) => enabledNavigation ? "pointer" : "default"};
  ${({ enabledNavigation }) => enabledNavigation && "&:hover { text-decoration: underline;}"};
  color: ${({ theme, active }) => active ? theme.colors.n90 : theme.colors.n70};
`;

// src/components/atoms/Breadcrumb/Breadcrumb.tsx
var import_jsx_runtime80 = require("react/jsx-runtime");
function Breadcrumb({
  items,
  limit = 20,
  onNavigate,
  withIcon = true,
  ...args
}) {
  const breadcrumbItems = cutBreadcrumbItemsByLimit(items, limit);
  return /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(Box_default, { ...args, children: breadcrumbItems.map(({ label, icon, path }, index2) => {
    const isFirst = index2 === 0;
    const isLast = index2 === breadcrumbItems.length - 1;
    const enabledNavigation = !isLast && !!path;
    return /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(InlineFlexBox, { children: [
      !isFirst && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(Flex_default, { ml: 2, mr: 2, children: /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(Text_default, { md: true, children: "/" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(
        BreadcrumbItemStyle,
        {
          onClick: () => enabledNavigation && onNavigate(path),
          enabledNavigation,
          active: isLast,
          children: [
            isFirst && withIcon && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(Icon_default, { name: icon || "home1", size: 14, mr: 2 }),
            label
          ]
        }
      )
    ] }, `${path}-${index2}`);
  }) });
}
var Breadcrumb_default = Breadcrumb;

// src/components/atoms/Tabs/Tabs.tsx
var import_react65 = require("react");
var import_styled_components76 = require("styled-components");

// src/components/atoms/Tabs/Tabs.styles.ts
var import_styled_components75 = __toESM(require("styled-components"));
var tabStyle = import_styled_components75.css`
  ${({
  theme,
  variation,
  active,
  activeButtonColor
}) => {
  const basePrimaryStyle = import_styled_components75.css`
      background-color: ${active ? theme.colors.b50 : theme.colors.b20};
      & p {
        color: ${active && theme.colors.white};
      }

      &:hover {
        & p {
          color: ${!active && theme.colors.b50};
        }
      }
      &:disabled {
        background-color: ${theme.colors.n20};
      }
    `;
  const statusStyleRelations = {
    primary: basePrimaryStyle,
    secondary: import_styled_components75.css`
        background-color: transparent;
        color: ${active && (activeButtonColor || theme.colors.g20)};
        & p {
          color: ${active && (activeButtonColor || theme.colors.g20)};
          font-weight: ${active ? "bold" : "normal"};
        }
        border-bottom: 1px solid
          ${active ? activeButtonColor || theme.colors.g20 : theme.colors.n30};
        &:hover {
          color: ${activeButtonColor || theme.colors.g20};
          & p {
            color: ${activeButtonColor || theme.colors.g20};
          }
        }
      `,
    primaryRounded: import_styled_components75.css`
        ${basePrimaryStyle}
        border-radius: 8px;
      `
  };
  return statusStyleRelations[variation] || "";
}}
`;
var TabButtonStyle = import_styled_components75.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  padding: 8px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: ${({ isFullWidthTabs, tabsLength, withScrollButtons }) => !isFullWidthTabs || withScrollButtons ? "fit-content" : `calc(${100 / tabsLength}%)`};

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.n70};
  }

  ${textStyle}
  ${tabStyle}
  @media ${({ theme }) => theme.devices.mobile} {
    padding: 8px 12px;
    ${({ adaptiveFullWidthTabs }) => adaptiveFullWidthTabs && "width: 100%"};
  }

  @media ${({ theme }) => theme.devices.tablet} {
    ${({ adaptiveFullWidthTabs }) => adaptiveFullWidthTabs && "width: 100%"};
  }
`;
var TabsWrapperStyle = (0, import_styled_components75.default)(Flex_default)`
  ${({
  variation,
  theme,
  withScrollButtons
}) => import_styled_components75.css`
    ${withScrollButtons && import_styled_components75.css`
      max-width: 100%;

      ::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none;

      button {
        white-space: nowrap;
      }
    `}
    @media ${({ theme: theme2 }) => theme2.devices.mobile} {
      & button {
        flex-shrink: 2;
        min-width: ${withScrollButtons ? "fit-content" : "auto"};
        &:last-child {
          flex-shrink: 1;
          min-width: ${withScrollButtons ? "fit-content" : "auto"};
        }
        &:first-child {
          flex-shrink: 1;
          min-width: ${withScrollButtons ? "fit-content" : "auto"};
        }
      }
    }
    ${variation === "primary" && import_styled_components75.css`
      & button {
        &:last-child {
          border-right-width: 1px;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }
        &:first-child {
          border-right-width: 1px;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
      }
    `}

    ${variation === "primaryRounded" && import_styled_components75.css`
      background-color: ${theme.colors.b20};
      border-radius: ${({ theme: theme2 }) => theme2.space}px;

      & button {
        border-radius: ${({ theme: theme2 }) => theme2.space}px;
      }
    `}
  `}
`;
var ArrowContainer = (0, import_styled_components75.default)(Box_default)`
  cursor: pointer;
  display: ${({ isVisible }) => isVisible ? "block" : "none"};
`;

// src/components/atoms/Tabs/Tabs.tsx
var import_jsx_runtime81 = require("react/jsx-runtime");
function Tabs({
  tabs,
  activeTab,
  onClick,
  variation = "primary",
  isFullWidthTabs = false,
  adaptiveFullWidthTabs = false,
  withScrollButtons = false,
  activeButtonColor,
  ...args
}) {
  const containerRef = (0, import_react65.useRef)(null);
  const [scrollX, setScrollX] = (0, import_react65.useState)(0);
  const [scrollEnd, setScrollEnd] = (0, import_react65.useState)(false);
  const theme = (0, import_styled_components76.useTheme)();
  (0, import_react65.useEffect)(() => {
    if (containerRef.current && activeTab) {
      if (containerRef.current.scrollWidth > containerRef.current.clientWidth) {
        setScrollEnd(true);
      }
    }
  }, [activeTab]);
  const slide = (shift) => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += shift;
      if (Math.floor(containerRef.current.scrollWidth - containerRef.current.scrollLeft) <= containerRef.current.offsetWidth) {
        setScrollEnd(false);
      } else {
        setScrollEnd(true);
      }
    }
  };
  const scrollCheck = () => {
    if (containerRef.current) {
      setScrollX(containerRef.current.scrollLeft);
      if (Math.floor(containerRef.current.scrollWidth - containerRef.current.scrollLeft) <= containerRef.current.offsetWidth) {
        setScrollEnd(false);
      } else {
        setScrollEnd(true);
      }
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)(import_jsx_runtime81.Fragment, { children: [
    withScrollButtons && /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(ArrowContainer, { isVisible: scrollX !== 0, children: /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(Icon_default, { name: "arrowLeft", color: theme.colors.b50, onClick: () => slide(-100), size: 24 }) }),
    /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
      TabsWrapperStyle,
      {
        ...withScrollButtons && {
          mx: 2,
          overflow: "auto",
          ref: containerRef,
          withScrollButtons,
          onScroll: scrollCheck
        },
        variation,
        ...args,
        children: tabs.map(({ label, key, disabled, children }) => /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
          TabButtonStyle,
          {
            withScrollButtons,
            tabsLength: tabs.length,
            disabled,
            variation,
            semibold: activeTab === key,
            active: activeTab === key,
            isFullWidthTabs,
            adaptiveFullWidthTabs,
            activeButtonColor,
            onClick: () => !disabled && onClick(key),
            type: "button",
            children: children ? children : /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(Text_default, { ellipsis: true, children: label })
          },
          key
        ))
      }
    ),
    withScrollButtons && /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(ArrowContainer, { isVisible: scrollEnd, children: /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(Icon_default, { name: "arrowRight", color: theme.colors.b50, onClick: () => slide(100), size: 24 }) })
  ] });
}
var Tabs_default = Tabs;

// src/components/atoms/Alert/Alert.tsx
var import_react66 = require("react");
var import_styled_components77 = __toESM(require("styled-components"));
var import_jsx_runtime82 = require("react/jsx-runtime");
var AlertStyle = (0, import_styled_components77.default)(Flex_default)`
  border-radius: ${({ theme }) => 2 * theme.space}px;
  ${({ type }) => {
  const states = {
    ["info" /* Info */]: import_styled_components77.css`
        color: ${({ theme }) => theme.colors.b50};
        border: 1px solid ${({ theme }) => theme.colors.b40};
        background-color: ${({ theme }) => theme.colors.b40};
      `,
    ["valid" /* Valid */]: import_styled_components77.css`
        color: ${({ theme }) => theme.colors.g20};
        border: 1px solid ${({ theme }) => theme.colors.g10};
        background-color: ${({ theme }) => theme.colors.g10};
      `,
    ["invalid" /* Invalid */]: import_styled_components77.css`
        color: ${({ theme }) => theme.colors.r20};
        border: 1px solid ${({ theme }) => theme.colors.r20};
        background-color: ${({ theme }) => theme.colors.r20};
      `
  };
  return type ? states[type] : "";
}}
`;
function Alert({ children, type, duration = 3e3, alertType, ...args }) {
  const { toggleAlert } = (0, import_react66.useContext)(AlertsContext);
  (0, import_react66.useEffect)(() => {
    const timeoutId = setTimeout(() => {
      if (alertType) {
        toggleAlert(alertType, false);
      }
    }, duration);
    return () => clearTimeout(timeoutId);
  }, [alertType]);
  return /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(AlertStyle, { px: 3, py: 2, type, ...args, children: /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(Text_default, { color: "inherit", children }) });
}
var Alert_default = Alert;

// src/components/atoms/A/A.tsx
var import_styled_components78 = __toESM(require("styled-components"));
var import_jsx_runtime83 = require("react/jsx-runtime");
var ellipsisStyle2 = import_styled_components78.css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: ${({ clamp }) => clamp || 1};
  -webkit-box-orient: vertical;
`;
var textStyle3 = import_styled_components78.css`
  margin-block-start: unset;
  margin-block-end: unset;
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: ${({ theme, bold, semibold, medium, regular = true }) => getFontWeight(theme, {
  bold,
  semibold,
  medium,
  regular
})};
  font-size: ${({ theme, xs, sm, md, lg, xl }) => getSize(theme, { xs, sm, md, lg, xl }, "fontSize")}px;
  line-height: ${({ theme, xs, sm, md, lg, xl }) => getSize(theme, { xs, sm, md, lg, xl }, "lineHeight")}px;
  color: ${({ color: color2 }) => color2 || mainTheme.colors.b50};
  cursor: pointer;
  text-decoration-line: ${({ textDecoration }) => textDecoration || "underline"};
  ${({ ellipsis }) => ellipsis ? ellipsisStyle2 : ""}
`;
var AnchorStyles = import_styled_components78.default.a`
  ${textStyle3}
`;
function A({ children, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(AnchorStyles, { ...args, children });
}
var A_default = A;

// src/components/atoms/Stepper/Stepper.tsx
var import_react67 = require("react");
var import_styled_components79 = __toESM(require("styled-components"));
var import_jsx_runtime84 = require("react/jsx-runtime");
var Line = (0, import_styled_components79.default)(Flex_default)`
  background: ${({ theme, isActive }) => isActive ? theme.colors.b100 : theme.colors.n30};
`;
var Dot = (0, import_styled_components79.default)(Flex_default)`
  background-color: ${({ theme, isComplete }) => isComplete ? theme.colors.b100 : "transpared"};
  border-radius: 50%;
  position: relative;
  border: 2px solid
    ${({ theme, isComplete, isActive }) => isComplete || isActive ? theme.colors.b100 : theme.colors.n30}; ;
`;
var TextBoxStyle = (0, import_styled_components79.default)(Box_default)`
  position: absolute;
  width: max-content;
  top: ${({ theme }) => theme.space * 4}px;
  ${({ isLast, isMiddle }) => isLast ? "right: 0px" : !isMiddle && "left: 0"}
`;
function Stepper({ steps: steps2, activeStep, ...args }) {
  const theme = (0, import_styled_components79.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(Flex_default, { flex: 1, ...args, children: /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(Flex_default, { pb: 6, flex: 1, alignItems: "center", ...args, children: steps2.map(({ label, value }, index2) => {
    const isActive = index2 === activeStep;
    const isComplete = index2 < (activeStep || 0);
    const isLastItem = index2 === steps2.length - 1;
    return /* @__PURE__ */ (0, import_jsx_runtime84.jsxs)(import_react67.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime84.jsxs)(
        Dot,
        {
          alignItems: "center",
          justifyContent: "center",
          isActive,
          isComplete,
          flexGrow: 0,
          w: 14,
          h: 14,
          children: [
            isComplete && /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(Icon_default, { color: theme.colors.white, size: 8, name: "check" }),
            /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(TextBoxStyle, { isLast: isLastItem, isMiddle: !isLastItem && index2 !== 0, children: /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(Text_default, { color: isComplete ? theme.colors.b50 : theme.colors.n70, children: label }) })
          ]
        }
      ),
      !isLastItem && /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(Line, { isActive: isComplete, flex: 1, flexGrow: 1, h: 2 })
    ] }, value);
  }) }) });
}
var Stepper_default = Stepper;

// src/components/atoms/Card/Card.tsx
var import_styled_components80 = __toESM(require("styled-components"));
var Card = (0, import_styled_components80.default)(Flex_default)`
  min-width: 0;
  border-radius: ${({ theme, borderRadius }) => borderRadius || theme.space * 2}px;
  box-shadow: ${({ theme, shadow }) => shadow || theme.shadows.shadow2};
  background-color: ${({ theme, bgColor }) => bgColor || theme.colors.white};
`;
var Card_default = Card;

// src/components/atoms/Video/Video.tsx
var import_styled_components81 = __toESM(require("styled-components"));
var import_jsx_runtime85 = require("react/jsx-runtime");
var IconWrapper4 = (0, import_styled_components81.default)(Flex_default)`
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.black, 20)};
  cursor: pointer;
`;
var Video = ({
  src,
  controlsList,
  controls,
  autoPlay,
  withPlayIcon = true,
  maxHeight,
  w,
  h,
  fit = "cover",
  ...props
}) => {
  const theme = (0, import_styled_components81.useTheme)();
  usePermission();
  const resolvedMaxHeight = typeof maxHeight === "object" ? maxHeight[0] : maxHeight;
  return /* @__PURE__ */ (0, import_jsx_runtime85.jsxs)(Box_default, { w: w || "100%", h: h || "100%", pos: "relative", ...props, children: [
    withPlayIcon && /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
      IconWrapper4,
      {
        justifyContent: "center",
        alignItems: "center",
        pos: "absolute",
        w: "100%",
        h: "100%",
        children: /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(Icon_default, { name: "playCircleOutline", size: 46, color: theme.colors.white })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
      "video",
      {
        width: "100%",
        height: "100%",
        src,
        controls,
        autoPlay,
        controlsList: "nodownload",
        style: {
          objectFit: fit,
          ...resolvedMaxHeight != null && { maxHeight: resolvedMaxHeight }
        }
      }
    )
  ] });
};
var Video_default = Video;

// src/components/atoms/FileList/FileList.tsx
var import_styled_components82 = __toESM(require("styled-components"));
var import_jsx_runtime86 = require("react/jsx-runtime");
var StyledBadge2 = (0, import_styled_components82.default)(Badge_default)`
  & svg {
    cursor: pointer;
  }
`;
var FileList = ({ files, ...args }) => {
  const theme = (0, import_styled_components82.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime86.jsx)(Flex_default, { ...args, children: files.map((fileItem) => /* @__PURE__ */ (0, import_jsx_runtime86.jsx)(
    StyledBadge2,
    {
      square: true,
      my: 1,
      mr: 2,
      onClick: () => {
        if (fileItem.onClick) {
          fileItem.onClick(fileItem._id);
        }
      },
      title: fileItem.name,
      renderLeftIcon: fileItem.isLoading ? () => /* @__PURE__ */ (0, import_jsx_runtime86.jsx)(Spinner_default, { size: 16, mr: 1, color: "inherit" }) : void 0,
      iconRight: Boolean(fileItem.onRemoveIconClick) ? "close" : void 0,
      iconRightProps: {
        onClick: () => {
          if (fileItem.onRemoveIconClick) {
            fileItem.onRemoveIconClick(fileItem._id);
          }
        },
        size: 16,
        color: theme.colors.r20
      }
    },
    fileItem._id
  )) });
};
var FileList_default = FileList;

// src/components/molecules/Avatar/Avatar.tsx
var import_styled_components83 = __toESM(require("styled-components"));
var import_jsx_runtime87 = require("react/jsx-runtime");
var getTextSize = (theme, { xs, sm, md, lg, xl, xxl }, textFieldType) => {
  const sizeArray = theme.typography[textFieldType][xxl ? "header" : "text"];
  const size = { xs, sm, md, lg, xl, xxl };
  const index2 = Object.keys(size).findIndex((key) => !!size[key]);
  return sizeArray[index2 === 0 ? index2 + 1 : index2] || sizeArray[2];
};
var getSize2 = ({ size, xs, sm, md, lg, xl, xxl }) => {
  return size ? size : xs && 24 || sm && 32 || md && 44 || lg && 48 || xl && 56 || xxl && 96 || 44;
};
var avatarStyle = import_styled_components83.css`
  border-radius: 50%;
  background-color: unset;
`;
var ButtonStyle2 = import_styled_components83.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  cursor: pointer;
  ${avatarStyle}
  ${boxStyle};
`;
var BoxStyle3 = (0, import_styled_components83.default)(Box_default)`
  ${avatarStyle}
`;
var ImgStyle2 = import_styled_components83.default.img`
  ${avatarStyle}
  ${({ size }) => size ? `width:${size}${typeof size === "number" ? "px" : ""};` : ""}
  ${({ size }) => size ? `height:${size}${typeof size === "number" ? "px" : ""};` : ""}
  object-fit: cover;
`;
var AvatarPlaceholderStyle = (0, import_styled_components83.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.b20};
  color: ${({ theme }) => theme.colors.b50};
  border-radius: 50%;
`;
var LabelStyle2 = (0, import_styled_components83.default)(Text_default)`
  color: ${({ theme }) => theme.colors.b50};
  font-size: ${({ theme, xs, sm, md, lg, xl, xxl }) => getTextSize(theme, { xs, sm, md, lg, xl, xxl }, "fontSize")}px;
  line-height: ${({ theme, xs, sm, md, lg, xl, xxl }) => getTextSize(theme, { xs, sm, md, lg, xl, xxl }, "lineHeight")}px;
`;
function AvatarPlaceholder({
  firstName = "",
  lastName = "",
  size,
  ...textSize
}) {
  const first = firstName?.toUpperCase()[0] || "";
  const last = lastName?.toUpperCase()[0] || "";
  const slag = `${first}${last}`;
  return /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(AvatarPlaceholderStyle, { w: size, h: size, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(LabelStyle2, { ...textSize, children: slag || "D" }) });
}
function AvatarImage({ url, size }) {
  return /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(ImgStyle2, { src: url, size });
}
function Avatar({ firstName, lastName, url, onClick, ...args }) {
  const size = getSize2(args);
  const Content2 = url ? /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(AvatarImage, { url, size }) : /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(AvatarPlaceholder, { firstName, lastName, ...args, size });
  return onClick ? /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(ButtonStyle2, { w: size, h: size, onClick, ...args, children: Content2 }) : /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(BoxStyle3, { w: size, h: size, ...args, children: Content2 });
}
var Avatar_default = Avatar;

// src/components/molecules/Table/Table.tsx
var import_react_table = require("react-table");
var import_react_table_sticky = require("react-table-sticky");
var import_styled_components84 = __toESM(require("styled-components"));
var import_jsx_runtime88 = require("react/jsx-runtime");
var TableStyle = import_styled_components84.default.table`
  ${boxStyle}
  ${textStyle}
  color: ${({ theme }) => theme.colors.n80};
  border-spacing: 0;
  width: 100%;
  text-align: left;
  border-radius: ${({ theme }) => theme.space}px;
  & thead {
    position: ${({ stickyHeader }) => stickyHeader ? "sticky" : "static"};
    top: ${({ stickyHeader }) => stickyHeader ? 0 : "unset"};
    & tr {
      min-height: 48px;
      & th {
        white-space: nowrap;
        padding: unset;
        font-weight: normal;
        border: unset;
        vertical-align: ${({ isSticky }) => isSticky ? "top" : "middle"};
        padding-left: ${({ theme }) => theme.space * 2}px;
        padding-top: ${({ theme, isSticky }) => theme.space * (isSticky ? 3 : 0)}px;
        &:first-child {
          padding-left: ${({ theme }) => theme.space * 6}px;
        }
        &:last-child {
          padding-right: ${({ theme }) => theme.space * 6}px;
        }
        background-color: ${({ theme }) => theme.colors.white};
      }
    }
  }
  & tbody {
    & tr {
      cursor: pointer;
      & td {
        white-space: nowrap;
        border: unset;
        vertical-align: ${({ isSticky }) => isSticky ? "top" : "middle"};
        padding-left: ${({ theme }) => theme.space * 2}px;
        padding-top: ${({ theme }) => theme.space * 3}px;
        padding-bottom: ${({ theme }) => theme.space * 3}px;
        &:first-child {
          padding-left: ${({ theme }) => theme.space * 6}px;
        }
        &:last-child {
          padding-right: ${({ theme }) => theme.space * 6}px;
        }
        background-color: ${({ theme }) => theme.colors.white};
      }
      &:nth-child(odd) td {
        background-color: ${({ theme }) => theme.colors.b10};
      }
      &:last-child > td {
        border-bottom: 1px solid ${({ theme }) => theme.colors.n20};
      }
    }
  }
  & {
    [data-sticky-td] {
      // to fix shadow when more then one columns are sticked
      z-index: 4 !important;
    }
    [data-sticky-last-left-td] {
      box-shadow: ${({ theme }) => theme.shadows.shadow1};
      z-index: 3 !important;
    }

    [data-sticky-first-right-td] {
      box-shadow: ${({ theme }) => theme.shadows.shadow1};
      z-index: 3;
    }
  }
`;
var PlaceholderStyle = (0, import_styled_components84.default)(Flex_default)`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
  color: ${({ theme }) => theme.colors.n80};
`;
function Table({
  columns,
  data,
  placeholder,
  placeholderProps,
  renderBody,
  defaultColumn,
  layouts: layouts2 = [],
  loading = false,
  loadingProps = {},
  withHeader = true,
  stickyHeader = false,
  onRowClick,
  ...boxArgs
}) {
  const theme = (0, import_styled_components84.useTheme)();
  const tableProps = (0, import_react_table.useTable)(
    {
      columns,
      data,
      defaultColumn
    },
    ...layouts2
  );
  const stickyTableProps = (0, import_react_table.useTable)(
    {
      columns,
      data,
      defaultColumn
    },
    import_react_table.useBlockLayout,
    import_react_table_sticky.useSticky
  );
  const isSticky = columns.find(({ sticky }) => !!sticky);
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = isSticky ? stickyTableProps : tableProps;
  return /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)(Box_default, { pos: "relative", ...boxArgs, children: [
    /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)(TableStyle, { ...getTableProps(), isSticky, stickyHeader, children: [
      withHeader && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("thead", { children: headerGroups.map(
        (headerGroup) => /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("tr", { ...headerGroup.getHeaderGroupProps(), children: headerGroup.headers.map((column) => /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("th", { ...column.getHeaderProps(), children: column.render("Header") })) })
      ) }),
      !renderBody && Boolean(data.length) && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("tbody", { ...getTableBodyProps(), children: rows.map(
        (row) => {
          prepareRow(row);
          return /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
            "tr",
            {
              ...row.getRowProps(),
              onClick: () => {
                if (onRowClick) {
                  onRowClick(row.original);
                }
              },
              children: row.cells.map((cell) => {
                return /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("td", { ...cell.getCellProps(), children: cell.render("Cell") });
              })
            }
          );
        }
      ) }),
      renderBody ? renderBody(getTableBodyProps()) : null
    ] }),
    (placeholderProps || placeholder) && !data.length && /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)(
      PlaceholderStyle,
      {
        py: 45,
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        children: [
          placeholderProps?.image && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Image_default, { src: placeholderProps.image, w: 180, h: 180, mb: 8 }),
          placeholderProps?.title && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Text_default, { children: placeholderProps.title }),
          placeholderProps?.label || placeholder && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Text_default, { children: placeholderProps?.label || placeholder }),
          placeholderProps?.buttonProps && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Button_default, { ...placeholderProps.buttonProps })
        ]
      }
    ),
    loading && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Spinner_default, { size: 32, color: theme.colors.b50, fullContent: true, ...loadingProps })
  ] });
}
var Table_default = Table;

// src/components/molecules/Table/components/SortHeader/SortHeader.tsx
var import_styled_components85 = __toESM(require("styled-components"));
var import_react68 = require("react");
var import_jsx_runtime89 = require("react/jsx-runtime");
var FlexStyle = (0, import_styled_components85.default)(Flex_default)`
  cursor: pointer;
`;
function SortHeader({
  children,
  accessor,
  isDefault = false,
  sortOrder: sortOrderProp = 1,
  variation = "blue",
  reversed = false
}) {
  const { state, setSortState } = (0, import_react68.useContext)(SortContext);
  const [sortOrder, setSortOrder] = (0, import_react68.useState)(
    state.fieldName === accessor ? state.sortOrder : sortOrderProp
  );
  const theme = (0, import_styled_components85.useTheme)();
  const onClickSpy = (0, import_react68.useCallback)(() => {
    setSortOrder(sortOrder * -1);
    setSortState({
      fieldName: accessor,
      sortOrder: sortOrder * -1
    });
  }, [sortOrder]);
  (0, import_react68.useEffect)(() => {
    if (isDefault) {
      setSortState({
        fieldName: accessor,
        sortOrder: sortOrderProp
      });
    }
  }, [accessor, isDefault, sortOrderProp]);
  const isActive = state.fieldName === accessor;
  const iconColor = variation === "blue" ? theme.colors.b50 : theme.colors.g20;
  return /* @__PURE__ */ (0, import_jsx_runtime89.jsxs)(FlexStyle, { alignItems: "center", onClick: onClickSpy, children: [
    children,
    /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(
      Icon_default,
      {
        size: 19,
        name: sortOrder === (reversed ? -1 : 1) ? "arrowUp" : "arrowDown",
        color: isActive ? iconColor : "inherit",
        ml: 2
      }
    )
  ] });
}
var SortHeader_default = SortHeader;

// src/components/molecules/Pagination/Pagination.tsx
var import_styled_components86 = __toESM(require("styled-components"));
var import_react69 = require("react");

// src/components/molecules/Pagination/helper.ts
var pageButtons = ({ isMobile, currentPage, countOfPage }) => {
  const limit = isMobile ? 3 : 7;
  if ([1, 2, 3].includes(countOfPage)) {
    return Array.from(Array(countOfPage).keys());
  }
  const isExtremeLeft = currentPage <= Math.floor(limit / 2) - 1;
  if (isExtremeLeft) {
    const pages3 = countOfPage < limit ? countOfPage : limit;
    return Array.from(Array(pages3).keys());
  }
  const isExtremeRight = currentPage >= countOfPage - Math.floor(limit / 2);
  if (isExtremeRight) {
    return Array.from(Array(countOfPage).keys()).slice(-limit);
  }
  return Array.from(Array(countOfPage).keys()).slice(currentPage - Math.floor(limit / 2), currentPage + Math.floor(limit / 2) + 1);
};

// src/components/molecules/Pagination/Pagination.tsx
var import_jsx_runtime90 = require("react/jsx-runtime");
var PaginationWrapper = (0, import_styled_components86.default)(Flex_default)`
  button > div {
    white-space: nowrap;
  }
`;
var StyledButton = (0, import_styled_components86.default)(Button_default)`
  * {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
function Pagination({
  previousButtonLabel,
  nextButtonLabel,
  countPerPage = 7,
  paginationAction,
  ...args
}) {
  const { state, goToPage, setButtons } = (0, import_react69.useContext)(PaginationContext);
  const { currentPage, total, perPage, buttons } = state;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const onGoBack = (0, import_react69.useCallback)(() => {
    goToPage(currentPage - 1);
  }, [currentPage, goToPage]);
  const onGoForward = (0, import_react69.useCallback)(() => {
    goToPage(currentPage + 1);
  }, [currentPage, goToPage]);
  const countOfPage = Math.ceil(total / perPage);
  (0, import_react69.useEffect)(() => {
    const array = pageButtons({ isMobile, currentPage, countOfPage });
    setButtons(array);
  }, [countOfPage, currentPage, isMobile]);
  return countOfPage > 1 ? /* @__PURE__ */ (0, import_jsx_runtime90.jsxs)(PaginationWrapper, { ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime90.jsxs)(
      StyledButton,
      {
        disabled: currentPage === 0,
        mr: 1,
        px: 4,
        w: "unset",
        medium: true,
        variation: "flat",
        onClick: () => {
          if (paginationAction) {
            paginationAction();
          } else
            onGoBack();
        },
        minWidth: "unset",
        type: "button",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(Icon_default, { name: "chevronLeft", size: 16, mr: 2 }),
          previousButtonLabel
        ]
      }
    ),
    buttons.map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(
      Button_default,
      {
        mr: 1,
        variation: buttons[index2] === currentPage ? "primary" : "flat",
        medium: true,
        square: true,
        onClick: () => {
          if (paginationAction) {
            paginationAction();
          } else
            goToPage(buttons[index2]);
        },
        type: "button",
        children: buttons[index2] + 1
      },
      `pagination-button-${buttons[index2]}`
    )),
    /* @__PURE__ */ (0, import_jsx_runtime90.jsxs)(
      StyledButton,
      {
        px: 4,
        w: "unset",
        medium: true,
        variation: "flat",
        onClick: () => {
          if (paginationAction) {
            paginationAction();
          } else
            onGoForward();
        },
        disabled: currentPage + 1 === countOfPage,
        minWidth: "unset",
        type: "button",
        children: [
          nextButtonLabel,
          /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(Icon_default, { name: "chevronRight", size: 16, ml: 2 })
        ]
      }
    )
  ] }) : null;
}
function PaginationPerPageSelect({
  options = [10, 25, 50, 100],
  label = "",
  defaultValue,
  menuPosition,
  ...args
}) {
  const { state, setPerPage } = (0, import_react69.useContext)(PaginationContext);
  (0, import_react69.useEffect)(() => {
    if (defaultValue) {
      setPerPage(defaultValue);
    }
  }, [defaultValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(
    Select_default,
    {
      menuPosition,
      options: options.map((value) => ({
        value: value.toString(),
        label: value.toString()
      })),
      onChanged: (value) => {
        if (value) {
          setPerPage(parseInt(value));
        }
      },
      withCheckbox: false,
      isSearchable: false,
      leftIcon: null,
      valuePrefix: label,
      value: state.perPage.toString(),
      ...args
    }
  );
}
function PaginationInfoLabel({ label = "", ...args }) {
  const { state } = (0, import_react69.useContext)(PaginationContext);
  const { currentPage, total, perPage } = state;
  const page = perPage * (currentPage + 1);
  return /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(Text_default, { ...args, children: label?.replace("{{page}}", (total && total > page ? page : total).toString()).replace("{{total}}", total.toString()) });
}
function PaginationLoadMore({
  onClick,
  fetchMoreProps,
  isLoading,
  ...args
}) {
  const { state, goToPage } = (0, import_react69.useContext)(PaginationContext);
  const { currentPage, total, perPage } = state;
  const [isFetchingMore, setIsFetchingMore] = (0, import_react69.useState)(false);
  const countOfPage = Math.ceil(total / perPage);
  const onGoForward = (0, import_react69.useCallback)(
    (e) => {
      if (fetchMoreProps) {
        const { fetchMore, queryName, variables, collectionName } = fetchMoreProps;
        const collection = collectionName || "collection";
        setIsFetchingMore(true);
        fetchMore({
          variables: {
            ...variables,
            pagination: {
              skip: (currentPage + 1) * perPage,
              limit: perPage
            }
          },
          updateQuery: (previousResult, { fetchMoreResult }) => ({
            [queryName]: {
              // @ts-ignore
              ...previousResult[queryName],
              [collection]: [
                // @ts-ignore
                ...previousResult[queryName][collection] || [],
                // @ts-ignore
                ...fetchMoreResult[queryName][collection] || []
              ]
            }
          })
        }).then(() => {
          setIsFetchingMore(false);
          goToPage(currentPage + 1);
        }).catch(() => setIsFetchingMore(false));
      } else {
        goToPage(currentPage + 1);
      }
      if (onClick) {
        onClick(e);
      }
    },
    [currentPage, onClick, perPage, goToPage]
  );
  const isShow = countOfPage > 1 && currentPage + 1 < countOfPage;
  return isShow ? /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(
    Button_default,
    {
      isLoading: isFetchingMore || isLoading,
      variation: "outline",
      onClick: onGoForward,
      ...args
    }
  ) : null;
}
var Pagination_default = Pagination;

// src/components/molecules/Modal/Modal.styles.tsx
var import_styled_components88 = __toESM(require("styled-components"));

// src/components/molecules/Modal/Modal.tsx
var import_react_modal2 = __toESM(require("react-modal"));
var import_styled_components87 = require("styled-components");
var import_jsx_runtime91 = require("react/jsx-runtime");
function Modal2({
  submitButton,
  cancelButton,
  children,
  AdditionalHeader,
  title,
  className,
  isOpen,
  onRequestClose,
  closeIcon,
  withDevider,
  $iframeViewport,
  ...args
}) {
  const theme = (0, import_styled_components87.useTheme)();
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;
  return /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
    import_react_modal2.default,
    {
      className: contentClassName,
      overlayClassName: {
        base: overlayClassName,
        afterOpen: `${overlayClassName}--after-open`,
        beforeClose: `${overlayClassName}--before-close`
      },
      isOpen,
      onRequestClose,
      ...args,
      children: /* @__PURE__ */ (0, import_jsx_runtime91.jsxs)(Box_default, { children: [
        title && /* @__PURE__ */ (0, import_jsx_runtime91.jsxs)(Flex_default, { alignItems: "flex-start", justifyContent: "space-between", children: [
          /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(Text_default, { lg: true, semibold: true, color: theme.colors.n90, children: title }) }),
          AdditionalHeader && AdditionalHeader(),
          closeIcon && /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(CloseButton, { className: "close-icon", onClick: onRequestClose, children: /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(Icon_default, { name: "close", size: 20, color: theme.colors.n70 }) })
        ] }),
        withDevider && /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(Devider_default, { mt: 4, mx: -6 }),
        /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(Box_default, { mt: 5, children }),
        (submitButton || cancelButton) && /* @__PURE__ */ (0, import_jsx_runtime91.jsxs)(Flex_default, { mt: 6, justifyContent: "center", gap: 6, children: [
          submitButton && /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(Button_default, { variation: "primary", w: "100%", maxWidth: 200, h: 44, ...submitButton, children: submitButton.title }),
          cancelButton && /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(Button_default, { variation: "outline", w: "100%", maxWidth: 200, h: 44, ...cancelButton, children: cancelButton.title })
        ] })
      ] })
    }
  );
}
var Modal_default = Modal2;

// src/components/molecules/Modal/Modal.styles.tsx
var getModalSize = (theme, modalSize, deviceSize) => {
  const targetSizeKey = Object.entries(modalSize).reduceRight(
    (size, [nextSize, enabled]) => size || enabled && nextSize,
    ""
  ) || "sm";
  const widthArray = theme.modalSize.width[targetSizeKey];
  const deviceIndex = Object.values(theme.breakpoints).findIndex((item) => item === deviceSize);
  return `width: ${widthArray[deviceIndex]}px`;
};
var commonModalStyles = import_styled_components88.css`
  &${({ className }) => className ? `.${className}` : ""}__overlay {
    position: ${({ $iframeViewport }) => $iframeViewport ? "absolute" : "fixed"};
    inset: 0px;
    ${({ $iframeViewport }) => $iframeViewport && "min-height: 100%;"}
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 0;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
    align-items: ${(props) => props.isCentered ? "center" : "start"};
    z-index: ${({ viewHierarchy }) => 100 - (viewHierarchy || 0)};
    ${({ blur }) => blur && `backdrop-filter: blur(25px)`};
    padding-top: ${({ theme, isCentered, topMargin }) => !isCentered ? topMargin ?? 80 : theme.space * 2}px;
    padding-bottom: ${({ theme }) => theme.space * 2}px;
    @media ${({ theme }) => theme.devices.tablet} {
      inset: ${(props) => !props.isExchange && "0px"}; // Full viewport height on mobile since bottom navbar auto-hides on scroll down
    }
    @media ${({ theme }) => theme.devices.mobile} {
      inset: ${(props) => !props.isExchange && "0px"}; // Full viewport height on mobile since bottom navbar auto-hides on scroll down
    }
  }

  &${({ className }) => className ? `.${className}` : ""}__overlay--after-open {
    opacity: 1;
    transition: opacity 150ms ease-out;
  }

  &${({ className }) => className ? `.${className}` : ""}__overlay--before-close {
    opacity: 0;
  }
`;
var Modal3 = (0, import_styled_components88.default)(Modal_default).attrs((props) => ({
  $iframeViewport: props.$iframeViewport !== void 0 ? props.$iframeViewport : props.isOpen ? getIdxIframeViewport() : null
}))`
  ${commonModalStyles}
  &${({ className }) => className ? `.${className}` : ""}__content {
    background-color: ${({ theme }) => theme.colors.white};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 8px;
    outline: none;
    padding: 24px;
    margin: ${({ isCentered, topMargin, $iframeViewport }) => $iframeViewport ? `${$iframeViewport.top}px auto auto auto` : isCentered ? "auto" : `${topMargin ?? 80}px auto`};
    box-sizing: border-box;
    max-height: ${({ theme, isCentered, topMargin, $iframeViewport }) => {
  if ($iframeViewport) {
    return `calc(${$iframeViewport.height}px - 80px)`;
  }
  const paddingTop = !isCentered ? topMargin ?? 80 : theme.space * 2;
  const paddingBottom = theme.space * 2;
  const buffer = 64;
  return `calc(100vh - ${paddingTop + paddingBottom + buffer}px)`;
}};
    ${({ theme, md, lg, xl, w }) => w ? `width: ${w}px` : getModalSize(theme, { md, lg, xl }, theme.breakpoints.xl)};
    ${boxStyle}

    /* Minimal scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.3);
    }

    @media ${({ theme }) => theme.devices.mobile} {
      ${({ theme, md, lg, xl, w }) => w ? `width: ${w}px` : getModalSize(theme, { md, lg, xl }, theme.breakpoints.xsm)};

      h2 {
        font-size: 20px;
        line-height: 32px;
      }
      padding: ${({ theme }) => theme.space * 4}px;
    }

    .close-icon:hover {
      cursor: pointer;
    }
  }
`;
var CloseButton = (0, import_styled_components88.default)(Box_default)`
  cursor: pointer;
  padding: 8px;
  margin-top: -8px;
  margin-right: -8px;
  border-radius: 4px;
  margin-left: 8px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

// src/components/molecules/List/List.tsx
var import_react71 = require("react");
var import_styled_components91 = require("styled-components");

// src/components/molecules/List/List.styles.ts
var import_styled_components89 = __toESM(require("styled-components"));
var getMaxWidth = (itemsLength, maxWidth, isMobile) => {
  if (isMobile)
    return "1fr";
  if (itemsLength < 3 && itemsLength >= 1)
    return `${maxWidth}px`;
  return "1fr";
};
var getMediaQueries = (itemsLength, minWidth, breakpoint, isMobile) => {
  const maxWidth = getMaxWidth(itemsLength, minWidth, isMobile);
  return import_styled_components89.css`
    @media ${({ theme }) => theme.devices[breakpoint]} {
      grid-template-columns: repeat(auto-fit, minmax(${minWidth}px, ${maxWidth}));
    }
  `;
};
var getGridStyles = (itemsLength, grid, isMobile) => {
  if (!grid)
    return null;
  if (typeof grid === "number") {
    return import_styled_components89.css`
      display: grid;
      grid-template-columns: repeat(
        auto-fit,
        minmax(${grid}px, ${getMaxWidth(itemsLength, grid, isMobile)})
      );
    `;
  }
  const [mobile, tablet, laptop, desktop] = grid;
  return import_styled_components89.css`
    display: grid;

    ${getMediaQueries(itemsLength, +mobile, "mobile", isMobile)}
    ${getMediaQueries(itemsLength, +tablet, "tablet")}
    ${getMediaQueries(itemsLength, +laptop, "laptop")}
    ${getMediaQueries(itemsLength, +desktop, "desktop")}
  `;
};
var ListWrapper = (0, import_styled_components89.default)(Flex_default)`
  ${({ grid, itemsLength, isMobile }) => grid && getGridStyles(itemsLength, grid, isMobile)}
`;
var TextAligned = (0, import_styled_components89.default)(Text_default)`
  text-align: center;
`;

// src/components/molecules/List/components/ListItem/ListItem.tsx
var import_react70 = require("react");
var import_react_dnd2 = require("react-dnd");
var import_styled_components90 = __toESM(require("styled-components"));
var import_jsx_runtime92 = require("react/jsx-runtime");
var DragBackground = (0, import_styled_components90.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n20};
  border-radius: ${({ theme }) => theme.space * 2}px;
  z-index: 2;
  top: 0;
`;
var ListItem = ({ item, index: index2, children, moveItem, onDrop }) => {
  const ref = (0, import_react70.useRef)(null);
  const theme = (0, import_styled_components90.useTheme)();
  const [, drop] = (0, import_react_dnd2.useDrop)({
    accept: "CARD" /* CARD */,
    hover: (entry, monitor) => {
      if (!ref.current)
        return;
      const dragIndex = entry.index;
      const hoverIndex = index2;
      if (dragIndex === hoverIndex)
        return;
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset)
        return;
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY)
        return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY)
        return;
      moveItem(dragIndex, hoverIndex);
      entry.index = hoverIndex;
      entry._id = item._id;
    },
    drop: (entry) => {
      if (onDrop) {
        onDrop(item._id, entry._id);
      }
    }
  });
  const [{ isDragging }, drag] = (0, import_react_dnd2.useDrag)({
    type: "CARD" /* CARD */,
    item: () => ({ _id: item._id, index: index2 }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });
  drag(drop(ref));
  return /* @__PURE__ */ (0, import_jsx_runtime92.jsxs)(Box_default, { pos: "relative", ref, children: [
    isDragging && /* @__PURE__ */ (0, import_jsx_runtime92.jsx)(
      DragBackground,
      {
        justifyContent: "center",
        alignItems: "center",
        w: "100%",
        h: "100%",
        pos: "absolute",
        children: /* @__PURE__ */ (0, import_jsx_runtime92.jsx)(Icon_default, { name: "plus", color: theme.colors.n70, size: 14 })
      }
    ),
    children && children(item, index2)
  ] });
};
var ListItem_default = ListItem;

// src/components/molecules/List/List.tsx
var import_jsx_runtime93 = require("react/jsx-runtime");
var List = ({
  children,
  data,
  placeholder,
  containerClassName,
  placeholderProps,
  loading,
  loadingProps = {},
  isDraggable = false,
  onItemDrop,
  ...args
}) => {
  const theme = (0, import_styled_components91.useTheme)();
  const [orderedFiles, setOrderedFiles] = (0, import_react71.useState)([]);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const moveItem = (0, import_react71.useCallback)(
    (dragIndex, hoverIndex) => {
      const filesCopy = [...orderedFiles];
      const dragItem = filesCopy[dragIndex];
      const filteredFiles = filesCopy.filter((f) => f._id !== dragItem._id);
      filteredFiles.splice(hoverIndex, 0, dragItem);
      setOrderedFiles(filteredFiles);
    },
    [orderedFiles]
  );
  (0, import_react71.useEffect)(() => {
    setOrderedFiles(data);
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime93.jsxs)(
    ListWrapper,
    {
      className: containerClassName,
      isMobile,
      w: "100%",
      minHeight: "96px",
      pos: "relative",
      itemsLength: data.length,
      ...args,
      children: [
        orderedFiles.map(
          (item, index2) => isDraggable ? /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(
            ListItem_default,
            {
              onDrop: onItemDrop,
              item,
              index: index2,
              moveItem,
              children
            },
            item._id
          ) : /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(import_react71.Fragment, { children: children && children(item, index2) }, item._id)
        ),
        (placeholderProps || placeholder) && !data.length && /* @__PURE__ */ (0, import_jsx_runtime93.jsxs)(Flex_default, { w: "100%", my: 45, justifyContent: "center", alignItems: "center", flexDirection: "column", children: [
          placeholderProps?.image && /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(Image_default, { src: placeholderProps.image, w: 180, h: 180, mb: 8 }),
          placeholderProps?.title && /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(Text_default, { semibold: true, children: placeholderProps.title }),
          Boolean(placeholderProps?.label || placeholder) && /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(TextAligned, { children: placeholderProps?.label || placeholder }),
          placeholderProps?.buttonProps && /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(Button_default, { mt: 4, ...placeholderProps.buttonProps })
        ] }),
        loading && /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(Spinner_default, { size: 32, color: theme.colors.b50, fullContent: true, ...loadingProps })
      ]
    }
  );
};
var List_default = List;

// src/components/molecules/DashPlaceholder/DashPlaceholder.tsx
var import_styled_components92 = __toESM(require("styled-components"));
var import_jsx_runtime94 = require("react/jsx-runtime");
var FlexStyle2 = (0, import_styled_components92.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n30};
  border-radius: ${({ borderRadius }) => typeof borderRadius === "number" ? borderRadius : borderRadius.join("px ")}px;
`;
function DashPlaceholder({
  size = 48,
  variation = "primary",
  borderRadius = 4,
  icon,
  iconProps,
  ...args
}) {
  const theme = (0, import_styled_components92.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(
    FlexStyle2,
    {
      w: size,
      h: size,
      alignItems: "center",
      borderRadius,
      justifyContent: "center",
      ...args,
      children: variation === "primary" && !icon ? /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(
        "img",
        {
          width: "70%",
          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB/MAAAYOCAYAAACwEQpBAAAgAElEQVR4nOzd3Wtcd2IG4N/5mpEjKanZQru3Wwjsli6OY1hqDCWQi/ayd77qTSEXpX9O6R/gS9+YbdLFu6m9lb0e40SOBaEQRCKWSEupI3s80nydM3POKaOMseSPxJu1JY3meUAgD0LWOWfkEX71njcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwNwDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABg7gEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwsiJnCgBmW13Xe1//vXv3vK6/Bu+880594g7qmHqVz+HJ90VZlmE8HseT9x9/nzA7osg/aQAnRT114cIFL8gAh8jP1AAw+7yaA8CMm4SU//HLX/5VHcLfu5av3uLi4tX333//q5N2XMfFf3744SRsT6qqWqyj6J0Qws9exZcWhZCGyVsUNU/EiZo3dV2FECZvQh+AYyqO4+d+YXFy8PFJkJQk6RdJHK8mSbKTpGlIkiQ/f/782LUFeL2E+QAw+7yaA8CM++yzz6Kvv/76X6Io+jfX8tXL0vRf//LHP/53Df1XbxrkL9d1/RdVCL+IouifQwh/d9KOEwDmXl3fDiFcCiGsT0/FVhzHm1EcF2mSfPvIJPSf/oLA5BcFkunjWaPxwrOn8Q/w3YT5ADD7UtcQAICjMGnkT4L8Oor+MQrhH0IIf+1CAMAJFEU/DXX9T3UInenBtcuq2oiqqlOOX66gPwmk9kKp6MldAdI022v8t1qtnemHafwDAAAnijAfAIAjMb21/i+mQb5GPgCcXH8Wouhv/5R+aD2dl5q8U1Xl3mPj0Xiv8d/r9fYa/2kSb1391a820ywrojgKaZKGOI5CkmYHP5dGPwAAMCOE+QAAHLp79+5Fk4386a31NfIBgD/eU43/UVm1Q1ltFKNR5+nPFcXx3tbkZNM/iZMv0jTV6AcAAI49YT4AAEflZxr5AMCf4KUb/5NW/6SGX43LMK7Ht/M832v0T0L+JApbH3/8m80kTorJVv/TO/2a/AAAwFER5gMAAAAwP/Y1+uuqClUI7VF/sBE92fT/dqM/jvb2+Sfb/FmmyQ8AABw+YT4AAAAA8+R7G/17G/1VvbfPP9nmHw7CpW7UXZ9u8G9dv3ZtM8vSYrLHr7kPAAC8LsJ8AAAAAHiRaZO/qutOVdZhXObtPM+/bfJHUUiT+IskSVf/+7e/3UnSNCRJorkPAAC8EsJ8AAAAAHix72zyj8fl7fG4vJTn+frkz3Ecb/3m17/eTNO0yLJ00uTf+zgNfgAA4I8lzAcAAACAH2rfBv/kM5RV1R4Mh082+KPJ9n4U0jT9otFo2t4HAABemjAfAAAAAH64793gr6o6FHlxu8iLS71udz1J4km4v7WysrKZZVkRNPcBAIDnEOYDAAAAwOu2f3t/XIbRuGwPhvlGFEWdx839ZlNzHwAAeEKYDwAAAACv3wsb/Pub+924t54kSciybOvmzZubcRznGvsAADCfhPkAAAAAcNQeN/erqlNVVRiNRu1+v7+RxPGdLMtWV1ZWdrIsCxr7AAAwP4T5AAAAAHD0ntvcr6rqdp7nl/I8X4+ivdvxb12/dm2z0WwWcRzb2gcAgBNMmA8AAAAAx9W0sV+H0KnrOhSjUbsYjTaibrcTJ7GtfQAAOMGE+QAAAABwfL3U1n4v7q2naRKyRnPr1q1bm5NQX2MfAABmmzAfAAAAAGbVtLlfVlWnLKqQF6N2v9fbSNL0zsLCgsY+AADMMGE+AAAAAMyuZ5r7kyr+eDS63R2NLvV6vfU0SUKjqbEPAACzRpgPAAAAACfNtLFfVVWnqKq9rX2NfQAAmC3CfAAAAAA4eb6zsd/v9dazLAuNRvZVq9XaOn/+fOk5AAAAx4swHwAAAADmxf6N/TwPeZ5fH/QHl69f+6/trNEMSZJo6gMAwDEhzAcAAACA+XGwsV/Xb43Lcrfb7a2H0AtZlm1dv3Zts7mwYFsfAACOmDAfAAAAAObVtKlfh9CZnIHJtn4xGm30+r07WZqt3rixspOmWbCtDwAAh0+YDwAAAADz65lt/Ym6qm8XRXGpKIr1JIlDo9Hcunnz5mYcxxr7AABwSIT5AAAAAMBB+xr747IK48GgPRgMNtIsu7OwsLDaarV2ph+vsQ8AAK+JMB8AAAAAeNpzG/vj0eh2dzS61O/11rNGFprNha9ardbW+fPnS2cQAABeLWE+AAAAAPBypo39sqo65TAPeV5cb2TZ5Rs3VrZt6wMAwKslzAcA4EhEIcTOPADAzDnY2K/rt4qi2H28ra+pDwAAr44wHwCAQ1fX9eSvFOYDAMy6p7b1y37/+jDPL1/7+OPtxsJCSJJEUx8AAH4gYT4AAIeuqqrgZ1EAgBPhmaZ+VZa7vX5/vT8YhCzLtm7cWNlMkjSv67q+cOFC7bIDAMDL8R+oAAAcuqqqohBFTWceAOCE2dfUn9yNKS+Kdl4UG1mW3Wk2GqutVmtnesAa+wAA8D2E+QAAHLqyLCNnHQDgRDrY1J8aj0a3x6PRpeFwsJ5mWTh16g3b+gAA8D2E+QAAHLrpZj4AAPNi2tgfl1VnXOahyIvrCwsLl1ut1vb0DGjqAwDAU4T5AAAcOmE+AMDcOdDYr+v6rcFgsDvM8/UsTcKCpj4AADxDmA8AAAAAHK5pU7+qqk5eVKEY7VxvNhqXb968uZ0kSWg0GoNz585VrgoAAPNMmA8AAAAAHLaD2/p1/Vae57tFUaxnWRoWl5b/Z21t7f6ZM2fc0gkAgLklzAcAAAAAjtbjpn5dd/JiFIp2+8PhYHD5k08+6Uya+kmSjAX7AADMG2E+AAAAAHDUnm7qL/YHg4fD4fDLRrMRlpaWf7+2tvZAoA8AwDwR5gMAAAAAx0sU/TSq6w+qum4Ph3nIh/nVfq93RVMfAIB5IswHAAAAAI6bPw9R9N6+pv7p/mCwq6kPAMA8EeYDAAAAAMdbFP2Npj4AAPNGmA8AAAAAHHcvbOovnFrQ1AcA4EQS5gMAAAAAs2VfU7/fH4ThcHh18Y3FK6urq504jsuzZ89WrigAALNOmA8AAAAAzJoDTf26qk/vdru7w3x4d2lpeXt1dbV77ty5kasKAMAsi109AAAAAGCmTZr6IXwwHo0vdtrtt7e/+eZ069bvTq2trUUuLAAAs0ozHwAAAACYdXtN/VDXP6pDGOdF8fmD7QcPu93e+t27dx+8++67tvQBAJg5wnwAAAAA4GSIop+Eur4YhfBeFcJgMBh89L9/+MOVld2dztLymyFJkvGZM2cE+wAAzARhPgAAAABwUiyFKPr55Fim99dfLut6t9PZ+XJ3txuWl5d/v7a29kCgDwDALBDmAwAAAAAn02RLv64/qENol1UVHj16dLXf614ZDgedLGto6gMAcKwJ8wEAAACAk2pvSz96cnCni3G5e///7n/ZXGiGpSVNfQAAji9hPgAAAAAwH/Y19YfDPBRFcbXI8yurq6udOI7Ls2fPVp4JAAAcF8J8AAAAAGBeHGjq11V9emd3d3cwHNx98803t1dXV7vnzp0beTYAAHAcxK4CAAAAADCXJk39ED4Yj8YX2w8evv3oUfv0p59+emptbS3yhAAA4Khp5gMAAAAA82qvqR/q+kd1CONer//5cDh8uLy0vG5LHwCAoybMBwAAAADmWxT9JNT1xSiE98qyGjx69Oij4XB45c6dO50sy2zpAwBwJIT5AAAAAMC8WwpR9PPJOZjeX395mOe79+/fv7u0uGhLHwCAI2EzHwAAAABgv+mWfl1VF7u7u29/8803p1u3fmdLHwCAQ6WZDwAAAABw0IEt/aIoPn/wsP1wMBjY0gcA4NAI8wEAAAAAnmffln5VVYNut/dRkedXBv1ep7lwypY+AACvlTAfAAAAAOD5ntnSL8bl7vaDh3ffOLVgSx8AgNfKZj4AAAAAwMvYt6Xf7/Vt6QMA8Fpp5gMAAAAAvBxb+gAAHBphPgAAAADw/+zd25Oc530n9t/zvt09gEwQoMiV1itSssk1RLoklyTTUkii7MLuykqqvFpbtVGxfMGrlG6Sq/wBqVQu81couUilfBGnZDul00qWa9Ay5QGF3UgmRQeUxJMpHGeIOXT3e3hS72BAgSAB4jCHPnw+VRBIihLefp6enp7+vt/nx50wSx8AgH0gzAcAAAAAuDM3naV/32/8hln6AADsCjPzAQAAAADuxXWz9NevXDl+4fz5B/7+7//eLH0AAO6JMB8AAAAA4N5cnaUf8R9zxL8ZTyafP3/+/GfXVlcfFOgDAHC3HLMPAAAAALAbbpilv7q6+tfj8fgvV1ZW1oqiMEsfAIA7IswHAAAAANgd75mlvzUaXTn31lunjxw9apY+AAB3xDH7AAAAAAB7YWeWft00z66urh6/srZ2ZGVlpW+tAQC4HZr5AAAAAAB74+os/ZwfzG1br6+vp/Fkcvb5559f/cIXvqChDwDALWnmAwAAAADspW6WfsSzbc5fqSaTxy6cP//A8vLy4TNnziTrDgDAzWjmAwAAAADsre1Z+l1ynyMu103z0OWLFy+NR1svnzlz5uJnPvOZbP0BALiRMB8AAAAAYD90Df2cn00RJ9uIrfX1jb+uquovnx+P1/r9fvO5z32utQ8AAFwjzAcAAAAA2B/bDf3uT9o5X//IeFJdOX/+3OmjR49dWFlZWX/yySfN0gcAYJuZ+QAAAAAAByGlT6eIr7VN++zq6urxK2trR1ZWVvr2AgCA0MwHAAAAADgwD0VKJyPnB3Pb1uvr66mqqrMrKyurGvoAAGjmAwAAAAAcpG6WfsSzbc5fGY/Hj53/1a8eGJ5aPnzmzJlkXwAAFpdmPgAAAADAwdqepd8l9zni8qSuH7p46fKlqqpfPnPmzMXPfOYz2f4AACweYT4AAAAAwDToGvo5P5siTrZtu7W6uvrXdV395crKylpRFM3nPve51j4BACwOYT4AAAAAwHTYbuh3V7Jzvv6R9Y3NK3XdnD5y//0XVlZW1s3SBwBYHGbmAwAAAABMo5Q+nSK+Nh6Pn7186dLxyWRyZGVlpW+vAAAWg2Y+AMy4z372s/lXb731zaZt/gd7ufuWlpa+2a3xvD2ug5Zzbnu93jfbtlnsheAdKaU2RWquVdCmSc7xiaZp/l1EfNKOAQD77KFI6WTk/GDTNPXFixfT0aNHz66srKxq6AMAzL8p/KgMALgTOV/NmX/84x/7vr4HBPl7Z3l5OaWUnBTFO1KazpexnPMDFy5c+J9TSv/9FFwOALCY1iPnV3LO3ypS+r/uu+++l48cPXpFoM+tTOv7awDg9vluDgAz7lqYD8DeGA6H5YXz5//HSOl/tcQAwIHK+b9ExP+ZIr5/6PDhsw98+MMa+tyUMB8AZp8mFAAAAADALEjp0Yh4ts35K6Otrccunj9/5PnnnzdDHwBgTgnzAQAAPpifnQCAaXBfpPR7KaUv5YiTk8nk+KXz548J9AEA5pMPpAAAAG6hbdvufNKBNQIApsZ1Df26aR47f+7cA8vLy4fPnDnjXHUAgDnSs5kAAAA31zRN8rMTADBlrjb0uzH6EZfbtn3o8uXLl6rJ5OUzZ85c/MxnPpNtGADA7POBFAAAwC3knJ1oBgBMp66hn/OzKeJk27Zbb7/99l/nnP9yZWVlrSiK5nOf+1xr5wAAZpcwHwAA4BZyVmwDAKbWdkO/u7id8/WPXFlfv1LV9eljx45dWFlZWX/yyScr2wcAMJs0TAAAAAAA5kFKn04RXxuPRs+uXrp0vGmaIysrK317CwAwm4T5AAAAAADz4aFI6WRE/MfxZPJvLl64cHw0Gh0T6AMAzCZhPgAAAADAPOlm6Uc8W1XVV9ZWVx+bTCYa+gAAM0iYDwAAAAAwX7Zn6aeUvtQ0zcnLly4d39zc1NAHAJgxwnwAAAAAgHm009Cv6/ora2trj21tbWnoAwDMEGE+AAAAAMB8eqehn9v25OrqqoY+AMAMEeYDAAAAAMyznYZ+2zTbDf0ra2sa+gAAM6BnkwAAAAAA5trVhn5E5La9vL6+3j3WsysrK6tPPvlkZesBAKaTZj4AAAAAwCK41tDP+Svr6+sa+gAAU04zHwAAAABgMfy6oR+hoQ8AMOU08wEAAAAAFskNDf01DX0AgKmkmQ8AAAAAsFje1dDfXF+Ppqo09AEApoxmPgAAAADAIrquoT8ejx+7dPGihj4AwBQR5gMAAAAALKarDf2UvpQjTo5Ho+OXLlw4JtAHAJgOwnwAAAAAgEWmoQ8AMJWE+QAAAAAAi01DHwBgCgnzAQAAAADQ0AcAmDLCfAAAAAAAQkMfAGC6CPMBAAAAAPg1DX0AgKkgzAcAAAAA4Hoa+gAAU0CYDwAAAADAe2noAwAcKGE+AAAAAADv5z0N/Straxr6AAD7RJgPAAAAAMDNXdfQX19ff+zK2pqGPgDAPuhZZAAAAAAAbuFqQz8icsTl9fX17t88u7Kysvrkk09WFg4AYG9o5gMAAAAA8ME09AEA9pUwHwAAAACA2/GuGfrr6+vH19fXzdAHANgjwnwAAAAAAG7fdQ39K1euPLa1taWhDwCwB4T5AAAAAADciV839Nv25Orq6vHNzU0NfQCAXSbMBwAAAADgzl1r6DfNV9bW1h6bTCYa+gAAu0iYDwAAAADA3XhXQ//ypUvHR6ORhj4AwC4R5gMAAAAAcPd2Gvp1XX9lbXVVQx8AYJcI8wEAAAAAuBfvNPSbpjm5trr6O03T3PfCCy/4/BkA4B70LB4AAAAAAPesa+jn/GxVVb3Vy5cvPfjQQ+sR0VpYAIC7485IAAAAAAB2w3ZDPyJOjsbj319bvXz0zJkzycoCANwdYT4AAAAAALsnpeGik7IAACAASURBVE+niK+tr2/82aWLFx8U6AMA3B3H7AMAAAAAsJseipRORsSVjfX1nw6Wln4cEVtWGADgzmjmAwAAAACw61LE4Tbiw6uXLx85depU3woDANwZYT4AAAAAAHvhoyni07ltH3378uVjzz//vEAfAOAOCPMBAAAAANh9KT0aEc+2OX+lbprHLl24cGRlZUWgDwBwm4T5AAAAAADshfsipd9LKX0pR5ys6/r4pQsXjgn0AQBujzAfAAAAAIC9c11DfzweP7a2tqahDwBwG4T5AAAAAADspXc19DfX14+vX7mioQ8A8AGE+QAAAAAA7L3rGvpX1tcf29ra0tAHALgFYT4AAAAAAPvh1w39tj25trb6O5PJ5L4XXnjB59QAAO/DmyQAAAAAAPbPtYZ+0/7x6qVLD7VtW1p9AID3EuYDAAAAALCfthv6EXGyaprfv3jhwtEzZ84kOwAA8G7CfAAAAAAA9l9Kn04RXxuNRn926eLFBwX6AADv1rMeAAAAAAAcgIcipZMRcWVjff2ng6WlH0fElo0AALhKMx8AAAAAgAOTIg63ER9evXz5yPPPP9+3EwAAVwnzAQAAAAA4SB9NEZ/ObfvopUsXj62srAj0AYCFF8J8AAAAAAAOVEqPRsSzbc5fqSfVY6uXLh0R6AMACPMBAAAAADhY90VKv5dS+lKOOLm1tXV8/coVDX0AYOEJ8wEAAAAAOHjXNfSvrK8/trW1paEPACw0YT4AAAAAANPg1w39tj359tra70wmk/teeOEFn2MDAAupZ9sBAAAAAJgaXUM/52ebpuldefvtS4PBYD0iWhsEACwadzQCAAAAADBNthv6EXFyNB7//ttra0fPnDmT7BAAsGiE+QAAAAAATJ+UPp0ivra+vv5na2trDwr0AYBF45h9AAAAAACm0UOR0smc85X1K1d+urS09OOI2LJTAMCi0MwHAAAAAGBqpYjDddN8+O3V1SMrKyt9OwUALAphPgAAAAAA0+yjKeLT4/H4t6+8/fZ9L7zwgs+1AYCF4Jh9AAAAAACmV0qPRs5/niMG6xsbq4cOLa1HRGvHAIB55w5GAAAAAACm2X2R0qci4ktt2z516dLlD58+fTrZMQBg3gnzAQAAAACYfik9kSK+1jTNn184f/5jzz//fGnXAIB5JswHAAAAAGAWHIuUnoqI/2YyHn96Y2Pj/uXlZQ19AGBuCfMBAAAAAJglh9qIBzc3No7lnA+fOnXK59wAwFzyJgcAAAAAgNmR0kdSxKdy2z5+5cqVj+aclzT0AYB5JMwHAAAAAGCWfCxS+tM24t83VfX4aHPzwa6tr6EPAMybnh0FAAAAAGCG3BcRn0wpRc757a3xuOkN+v84GCydi4iJjQQA5oUwHwAAAACAWbTd0M9tW2xsbFzs9foX7SIAME8cOwQAAAAAwCzabuhHxImmbv5gc3PjI8PhsLSTAMC8EOYDAAAAADC7UnoiIp4bbY2+urW19fBwOHQiLQAwF4T5AAAAAADMsmOR0lMR8cWtzc3fbdv2yPLycrKjAMCsE+YDAAAAADAPDjVt++DGxsaxiDh86tQpn38DADPNcUMAAHdgp92ROtbt7uWc2xMnTuRZvf5ZcSfP1/16Srdtm6qqmqk5pimlf5kjPuGLHgBgyqX0kZTzpyaj0bnBYFAtLS2di4iJbQMAZpUwHwDgA3znO98ucpt7EbnXtvmBpmk+nyM/Yd3uXlGU3/zBD37w4z/6oz8S6O+yv/3b7xeT8eS2n68pUptSaiPFfuxFkXMMZu7nkJw/kVI6MQVXAgDArX0sUvrTnHOxub5+sd/vX7ReAMAsE+YDAHyA8Wjci5wfzDk/nCP+q0jpz6P7nbvWtnXktv3PEdFYxd3V3XgyGY/v4PnqfgoAAObGfRHxyYg40bTtKxvr6xeGw+HrTz/9tJ87AICZZGYQAMAHyDn3toPRlP7DTjD6uDVjWrWerwAALLqUupOpnhuPx1/d2tp6eDgcKrUBADNJmA8AcAt//Vd/lXLbPpCvNpv/7U7D+Zg1Yxp1M/LbpvF8BQBg0R2LlJ6KiC+OtrZ+t23bI9175UVfFABg9gjzAQBuIUWknNLnNZyZEaluGs9XAAC46lDdNA9ubm50N7gePnXqlM/DAYCZ4nghAIBbS+nqEY1m5DP1uidr27aerwAAENtvkD+Scv7UeDw5NxgMqsFg6VxETKwNADArhPkAAAAAAMyjj0VKf5rbttjY2LjY6/Uv2mUAYJY4VggAAAAAgHl0X0R8MiJONHXzB6OtrY8Mh8PSTgMAs0KYDwAAAADA/Lo6Ou25za2tr04mk4eHw6ETawGAmSDMBwAAAABgnh2LlJ7KOf+brc3NxyJiyW4DALNAmA8AAAAAwEKoqiom47HNBgBmgjAfAAAAAIC5lyKORsTx9Y2Nh8zOBwBmgTAfAAAAAID5tzM7v22ar66vXzE7HwCYesJ8AAAAAAAWwfbs/Ij44ng8+d1qMj6yvLyc7DwAMK2E+QAAAAAALJJDbds+uLG5dSwiDp86dcrn5ADAVHKMEAAAAMyf9Yi4GBFrkfOo+z1HvJkiVu313OnliI+kiId3HlgZKf2r+PXfA3CjlD6Scv5UU1XnJpNJdejQoXMRMbFOAMC0EeYDAADA/LmYUvrbiDgbKV1MES+llF6KlNbt9fzIbRs55yLl/Ikc8dnugaWIfs75TyIlYT7AzX0sUvrT7jV0Y2Pj4mAwuGitAIBpJMwHAIA5klJq7SeQUlrr9/tny7L8YVEUb+ac/7mu6yuTyaRZ+MWZM0VRxNLS0stFUWyfulDXdZFzPt+27c+7v885d/+x/aDbnd9j50aAG3QN/99MEb+58481/IF5dl9EfDIiTuS2fWVjff3CcDh8/emnn/Z9EgCYKsJ8AACYI0VRCPOBLswfpZQudkF+27avNk0zaprG68Mc6sL6uq7HKaU34+reR6/Xeyvn/L3bebTXwv66aYoU8YmmbT8bkSM3rYY/MP9SeiJyfm48mRxZmkz+YjgcvvH000/Xdh4AmBbCfAAAmC/ZfgLdjPyiKF7qGvldkK+RP7+6ML6qqu61//rwqfvr0Z086GsN/8FOw787erppmvNN0/y8+zO2j/R/d9Nfkx+YB8cipadyzmubm5unB4PBhRteTwEADpQwHwAA5kTXxgSIq68Hb3Yz8ruj9TXyuR3v1/Avy/Ktoijet+Hftm3RNs12k3874G81+YHZVldVTMZjuwgATBVhPgAAAMyZlNJqznldI5/bdacN/y7sP3To0DtN/i7c327y1/XPu9n8OedezllzH5gJKeJoRBzf3Ng4OxwOR2bnAwDTQpgPAAAAwB17v1n9ZVl+b+fvi7ZtP1HX9Wfb7oj+nPu5bTX3gem0Mzu/bpojG+vrZucDAFNDmA8AAADAHfmgJv+15v7S0tI7M/jrut6ewb8d7retmfvANHlndv5oPD596PBhs/MBgKkgzAcAAABg131Qc7+u6080TbPd3N+Zuf8fNPeBg5bbNkajLfsAAEwFYT4AAAAAu+p2m/v9fn+7ud80da+p6wt10/6ibVuNfeBAXJudP94anV1eXh6dOHHC7HwA4EAJ8wEAAADYdzc29/uDpTf7Ed9/16z9ptHYB/bPzuz8NucjV65cMTsfADhwwnwAAAAA9tXNmvsppdGhQ4f+6dez9tteVdUX6rrW2Af2w/bs/Mh5vZ5MflJNxm8vLy+vnjhxIlt9AOAgCPMBAAAAmBrvaez3+2/2+/1fN/abpptprbEP7KVDbcSDG5tbx+6/vz8+derU6JlnnmmtOACw34T5AAAAAEyFncZ+F5hdH5q9p7Ff13WvrusLTdP8IuessQ/srpQ+knL+VFNV5yaTSXXo0KFzETGxygDAfhPmAwAAADD1bmzsLy0tdX/9/bqqPlE3XWO/jRShsQ/sho9FSn+acy62tjYvDgaDi1YVADgIwnwAAAAAptoHNfb7g8Fq0zRd4N9v6rrMOX9459/R1Afuxn0R8cmIONHUzStbm5sXhsPh608//XRjNQGA/STMBwAAAGBmXd/YL8syDQaD704mk1EX7ofZ+sC9SOmJyPm50Wh0ZOnQob8YDodvPP3007U1BQD2izAfAAAAgJl0Y2O/O37/0KFDby4tLX0/rgb9/clkUua21dQH7saxSOmpNue1ra3N00eO3H+he2mxkgDAfhHmAwAAADA3bpitnw4fPvzduq5HTV1H2zSa+sBdmUwqCwcA7DthPgAAAABz4WZN/X6///1+vx9N0/SryaRsmkZTH7htKeJobtvj6+tXzg6Hw5HZ+QDAfhHmAwAAADC3bmzqLx06pKkP3Jl3ZuePjwwGS2bnAwD7RpgPAAAAwFy6jab+oJpMDjdN8y+2PydLqfusrPvr3/SMAK6zPTs/57w22to8PRgMzM4HAPaFMB8AAACAhXF9U7/7bKw/GPxdUdddsB9tzocj5y9FSsJ84H1V1dXXCwCA/SDMBwAAAGAh3NDU707dz4PB4NWy1/te2etF27ZLdV0XbdMc3V4PTX3gOtuz83M+vrmxYXY+ALAvhPkAAAAALJq086tr2G5ExCvdXxdFUWwfv18UG13zNmvqA9fbmZ0/nkyOLE0mZucDAHtOmA8AAADAokg7j7OInaZ+Xddds3a7XdtV9QeDwc97vd641+t1Qf92Uz/n/ODO/+ZwRDy4PT8bWERm5wMA+0qYDwAAAMAieFeQfxP5xqb+YDCIuqpGbdven3P+aER8IVL6nGcMLDaz8wGA/SDMBwAAAGBR3CrIv2lTvz8Y1G3bPljX9cfbq+GdWfqwwMzOBwD2yy1/gAEAAACAGXdtPv7dfA623dSv6/psURRnB4PB2V6//7cppf8jcn7JEwMWVDc7P6Kbnf/VyWTy8HA4VJoDAPaENxkAAAAAzLu7KrRca+qnlNqiKC4VRRFlWb5VluXZuqqKpm3N0ofFZHY+ALAvhPkAAAAAzKu7beTfKNd1PS6K4lxcnaVf9vr9KNpmVNfN/bltzdKHBdXNzgcA2CvCfAAAAADm0W4F+dsN/Zxz24mrs/TrbpZ+WfbqoigfbOr647VZ+rBwrs3O31hfNzsfANgTZuYDAAAAMG92Lci/iXdm6aeUujn63Tx9s/Rh0ezMzh+NRl+t69rsfABg13lzAQAAAMA82esg/31n6aeU3hoMBmfrui6apjFLHxbD9uz8Nue1ra3N00eO3G92PgCwq4T5AAAAAMyLPQ/yb/DeWfq9XhRFMksfFsxkUtlyAGDXCfMBAAAAmHVp5/r3daTkB83Sr+v64029XdI1Sx/m2Pbs/LY9vrmx8eLy8vLmiRMnsv0GAHaDMB8AAACAWXYgQf5NbM/Sj4izvV5vtd/vV0VRbNZ1/cvctl+KlIT5MI+62fk5Pzcej944/KEP/U33WmCfAYDdIMwHAAAAYFZNU5D/vrP0i6LYnqVfTSZFm7NZ+jCftmfn1037hWoy+W5EbNlnAGA3CPMBAAAAmGVTEeTf4D2z9PuDQRf0j5qmuT9yNksf5tOjW1tbjwyHw1eefvrp2h4DAPdKmA8AAADALEpTGuTfdJZ+v9+vy7J8sKqqj+e2/VBEHNXQh7nyQFVVD9d19UZECPMBgHsmzAcAAABg1kxtkH8T75mlX9d1v22aTQ19mD+jrZFdBQB2xSz90AMAAAAA6bpZ+TPh2iz9pmnGbdt2s/RfHQwGPy17vR9FxP/bhfwRsb7wOwszLl09beP4ZDx+aHl5ubSfAMC9EuYDAAAAMCvSLIb519mepV/XdTdL/9V+v3+21++fiohvR8QrU3OVwN1J6YmIeK7N+asb6+sPD4dDJ+MCAPfEmwkAAAAAZsGsB/nvzNLPOeeiKNa6hn6v12tSSt2x+9v/fUT8i4j4zYO/WuAuHIuUnso5r02q6nREXDA7HwC4F8J8AAAAAKbdzAf5N9hu6BdFca4L88uyLFNKm1VVvZbb9ouRkjAfZlxu2xhtbdpGAOCeOGYfAAAAgGk3T0H+dgO/bdu2aZq6bdu17sj9lNKPB4PBt1NRfD8i/ktE/MQsfZhN12bnj7ZGDw2HQ7PzAYC7ppkPAAAAwDSbqyD/Bu809Lt/XBRFbzAYRF3X603T3B85fzRSeiYifm+aLhr4AN3s/Jyfq5vmyNbW1l8Mh8M3nn76acftAwB3TJgPAAAAwLRK83yy5LUZ+p3Yzv9SPRgMftHv9+uU0oNNVX085/yhSOk3IuKjEXHfwV81cBvemZ0/Ho9PHz582Ox8AOCuCPMBAAAAmEbz3Mi/mdw0zXpK6Wyv11stiqKqJpN+znlTQx9mU11V0TSN3QMA7oqZ+QAAAABMm7SIYX7X1K/ruumO3m/b9lJRFK/2B4OfpqL4UeT8YzP0Yba8Mzt/c/P+5eXlRbs5CQDYBZr5AAAAAEyThQzyb9A19LtA/1yv12v6/X5ZVVU/t62GPsySndn5o8n4jQ/dd9/fdF/b9g8AuBPCfAAAAACmyaIH+dsN/aZp2pRSLopirWvoDwaDpppMqrZtzdCH2bE9O79t8xfGo9F3I2LL3gEAd8Ix+wAAAABMA43899pu6Nd1fS6l9Gqv3z+biuJU5PztiHhl2i4WuKlHR+PRI8PhULkOALgj3jwAAAAAMC0UT66joQ9z44G6qh+u6+qNiKhtKwBwu4T5AAAAABw0jfxbe9cM/Z4Z+jCTxuOxjQMA7oi7nQEAAAA4SI7X/wDXGvpN09Rt215r6P+0KIofRc4/joizEbE+1Q8CFliKOBoRx8fjyUPD4bD0XAAAbpcwHwAAAICDIsi/M2bowyxK6YmIeK5tmq9ubmw8bHY+AHC7vGkAAAAA4CAJ8m+TGfows45FSk/lnNcmk/HpD/3Gb1wwOx8AuB3CfAAAAAAOgkb+3TNDH2ZUXTdR15XtAwBui2P2AQAAANhvjte/B7c5Q391Zh8gzKl3Zudvje5fXl72+gcAfCDNfAAAAAD2myB/d9y8oR/xhUjpc/PwIGFudLPzc35uNBm/8aH77vub7mvY5gIAtyLMBwAAAGA/CfJ3yfvN0O/3+01VVVVu2+4PuTZD/9g8PF6YA9uz89s2f6Gu6+9GxJZNBQBuxTH7AAAAAOwXQf7e2G7o13V9bifQP5tSGkbO34icX57HBwwz7tHNjY1HhsOhsh0AcEveLAAAcBCOtjkPNFEAYKGYk79H3q+hP1ha2ppMJmVu20/O5YOG2fZAXdcPR8QbEVHbSwDgZjTzAQA4CL9VV9VvnTp1ys2lALA4BPl7752GflmWv+qV5aWIuDLvDxpmUXcTzmhr094BALckzAcA4CA81Ob8O03THPu7v/u70g4AwNwT5O+Daw39pmnqnPNqfzB4qdfvPR85/ygiXp/7BYAZkSKORsTx8Xj80HA49PMQAHBTwnwAAA7CUtu2D1ZV9ZHuiEkNfQCYa4L8/Zfrut5q2/bVwWDpm2VZ/m85558s2iLA1ErpiYh4rqrqr45HWw+bnQ8A3Iw3CQAAt5BTaqNtvxnJ58/3qGue/FbXyO+C/Ii42Lbtb43H46iq6mKR0j9973vf+0WR0uT6PyZZ9zvStu0DbdN84rr/zfr2HM6cz0XEKEdciIhXUsTaPf5R3c8Rh/bpYe27HPFgRDySIh7Yfr6m1P39RyPivnl9zAfslznnH6WINxd6FXZZURT/KSKquXpQzDrf1PdR19CvqqrtLC0tnV86dOhMu7X10Zzzb+98Tzu2MIsB0+lYpPRUznltMqlOLx06fMHsfADg/QjzAQBu4U/+5E/y8vLyj1NK/9k63b22bQeTyeS3mqb5na6R3wX5TdN8pq7rfxsR4+hC5vH4F5Hz6tUs9V2/uE054hMppX937d8uy/KNfr//f5dl+ZOiKC4WRXG21+u9lm64aeJONU1T1HU9t6d8pZQON03zr3POx3eer5+cTCb/tTB/b5Rl+aNDhw79L117dB4f3wGq6roeL+yjZ5po5R+gLtTPOddFUVweDAZnJpPJ4dy2fxQpfX5hFwWmTFW59w4AuDlhPgDABzhx4kQXKDfW6Z5snTp16p+apjnfHa3ffWC1E+Q/867/U038e3Ld6q13QX6v1/tev9//Qa/XeymltFoUxZWnn356Nxo/c/318J3vfGfS7/d/GhG/aprmX27/w5z/IFJ67MAvbg6llN7sgvytra0ri74WMIeSEY8HayfM75LC871eb3su93g8/tDOqUka+nDAutn5bdseH49HLy4vL2/u/OwJAPAOP1ABALAvnnnmmS5Evtzv9891LfF0tZHP3thu5A8Gg78qy7IL8n8VEau7FOTPvS9+8Yu5qqpR27a/Ksvyre75Gp6vAHfDXXoHr5udX1VVtZZzfqMsy1cGg8HfRc7fiJxfXvTFgQO3Mzt/a2v0ZDJjDAB4H8J8AAD2zR/+4R82ZVmu9nq9f4qUzlv5vZEiznVH63eN/KIofpVSGmn53Jku0G+apmsyXkgpvZwjLs/S9QNMAcfrT4GumV/XdXeTWt227WZKqbvh7x/7g/4PI+IfIuJn3Q1/i75OcIC2Z+c3df2FiFiyEQDAjRyzDwDAvuoa+qdOnfrF1ubm2SbLl/fIaPv0g5S6D+e3nnnmGQt9F7pA/zvf+c6o3+//fxHx2sw9AJgTX/7yl/f0Newb3/iGwHn3CfKnUNfQb9t2rdfrNf3+oGybtt80zWZEmKEPB6zN+dHRaPTIcDh8xWlaAMD1hPkAAOy7lNIkFWk1Wmu/J1K6UBTF2Z0Z+YL8e9AF+t///ve3UsTFmX0QMKP2OsS/Zr/+nLsx4zcaCPOnyLWGfkqpLopisyzLN/qDQeTx+HDbtp9c9PWBKfDAZDx++PDhw290997YEADgGmE+AADMn1d6vd5rWj3ArJrmgJ0PpJU/5a5r6A96/f6lyWRyZdHXBKZB3TT2AQB4DzPzAQBgzqSIte70A/sKzCJB/q91azGD6yHMn2LXGvp1XXepYRfov9Tr9Z6PnF+IiNcXfX3goKSIo7ltj49Go/uXl5e9hgIA7xDmAwAAAFNBkP/+ZmhdBPkzIuecq6oatW376mAw+GZRll+PnF9c9HWBA5PSExHx3Gg0ejKl5HUUAHiHMB8AAAA4cIL8W5uB9RHkz5CuoV9VVVtVVRUR55eWlk6novhRRPwsIlYXfX3gAByLlJ5q6voLEbFkAwCAa4T5AAAAwIES5N+eGQn0mR4f+HzpQv2cc10UxeV+v386Ir4ROb9sD+FgtDk/OhqNHhkOhz1bAACEMB8AAAA4SIL8OzOl65V8xjSb8lXb7fyyLP+p3+8/HxH/oKEPB+aByXj8sHY+AHCNH7QAAACAAyHIvztTtm6O159Ot/0cqeu6O21/LaX0Vr/fP1uW5XLkrKEPB6RuGksPALxDmA8AAADsO0H+vZnCQJ8Z1B2zX9d1rqqqbtv2Skrp9cHS0ksR8Y8R8ZY9hf2VIo7mtj0+Go3uX15e9toKAAjzAQAAgP0lyN8dU7COjtefI9c19M8NlpYuRsTGoq8J7LuUnoiI5yaT8ZMpJWE+AOAHLgAAAGD/CPJ31wGvp6BpTlxr6Nd13Z3vvVaW5c+Ksvxh5PxCRLy+6OsD++hYpPRUVdWPC/MBgBDmAwAAAPtFkL83DmhdzcqfQznn7sj9Uc75l4PB4Fsppa9Hzi8u+rrAfsttG01dWXcAQJgPAAAA7D1B/t46gPUV5M+hrqFfVVXbnbdfFMX5/mDQBflvLvq6wH7LEUcnk8nAwgMAwnwAAABgTwny98c+rrNW/vTbledCWZZRFD4+hAPw6HgyeWQ4HPYsPgAsNu/GAQAAgD0jyN9f+7DegvwF0DX0I2ISEa/2+v3TEWF2PuyvB+qqfrhpmiXrDgCLTZgPAAAA7AlB/sHYp0CfOXb97PyyLL/V6/XMzocDUFXm5gPAohPmAwAAAMyZPQr0tfIXxPWz81NK5/v9/umiKH4UET+LiNVFXx/YayniaEQcH4/H9y8vL3vdBYAFJswHAAAAdp1W/sHbw0CfBZJzrouiuNwfDLrj9r8ROb9s/2GPpfRERDxX19WTKSWvuwCwwIT5AAAAAHNqFwP95HOkxdO2bXfifjc7/3xZlj/v9Xr/GBFvLfq6wD44Fik91bb5C3Vdm5sPAAvMD2EAAAAAc2yXAn3N0Nmya6cy1HXdnba/FhHner3exVQUGwuyhjANHt3a2npkOBz27AYALCZhPgAAAMCcu8dA36z82bJrQX43O7+u61zXdRMRaymln/XK8oeR8wsR8fqCrCccpAeauno4IrTzAWBBCfMBAAAAFsA9BPqC/AXXnbVfVdUo5/zLXr//raIsvx45v7jo6wL7oWnaaJrGWgPAghLmAwAAACyILtC/w1BfK5/thn5VVW133n5K6Xy/33sxUnrTysDeShFHI+L4eDS6f3l52WsxACwgYT4AAADAgtmlOfpMpz3f26Iooyh8rAh7LqUnIuK5SVU9mVIS5gPAAvKuGwAAAGAB3Uagn3x2xPW6hn5ETCLi1X6/fzoizM6HvXUsUnqqqevHhfkAsJj8QAYAAACwoDT0uRPXz84viuJbvZ7Z+bAfuhtpmrqy1gCwgIT5AAAAAAvsJoG+Vj7v8d7Z+YPTqSh+FBE/i4hVKwZ7I0ccnVT1wPICwOLxQxkAAAAAcEdyznVRFJe3j9vP+RuR88tWEPbMo+Px6JHhcNizxACwWIT5AAAAAAvuhnZ+2vnFbNrz0Qlt23Yn7nez88/3er2fF2XxjxHxlucL7JkHmrp5OCKWLDEALBZhPgAAAADvF+gze/Y8yL+mruvutP21iDjX6/UvRsSG5wvsnZ0xF1YYABaMMB8AAACAbTuBviCfW+pCxbquc13XTUSslWX5s6Isfxg5vxARr1s92F0p4mhEHJ+MRvcvLy97jQaABSLMBwAAAOB67c4vuKXurP2qqkY5518OBv1vRcTXI+cX2tYYwwAAIABJREFUrRrsspSeiIjnqrp6MqUkzAeABSLMBwAAAOAdXTv/y1/+crufR7aza/Z1z3aO/W678/aLojxflmUX5L9pO2HXHYuUnqqb9nFhPgAsFmE+AAAAAO9HQ5870uv3LBjsJXPzAWDhCPMBAAAAeA8NfW5X19CPiElZ9l4ryvItCwd7I0ccravJwPICwOIQ5gMAAABwKxr6syEf1I0X183Of7XX6700g2sHs+LR8WTyyHA4dAwGACwIYT4AAAAAN6Whzwe5Nju/rutxr9d7OaX0QkS8buFg1z3Q1M3DEbFkaQFgMQjzAQAAALgdGvrT7cBvttg5bv/VXll+PXJ+cbqXC2ZT93VW1+bmA8CiEOYDAAAA8IE09PkgO2H+Rq/ffzEVxZsWDHZXijgaEcfH4/H9y8vLyfICwPwT5gMAAABwJzT0+UBF4WNH2HUpPRERz1VV/WRKSZgPAAvAu2oAAAAAbpuGPjez08yfbB+13+udjgiz82F3HYuUnmqa5nFhPgAshp59BgAAAOAutFdPfVYWmRLTMDM/V1U1Ksvyl0VRfKvXK6Ou6n8fKT08LYsE8yC3bbStA1IAYBH4YQsAAACAO6ahP1WmYg+6Zn5VVW1VVVVK6Xy/P3gxUjI7H3ZZjjhaV9XAugLA/BPmAwAAAHAvzNA/eFN7Q4XZ+bAnHh2Nx48Mh0Mn7wLAnPNuGgAAAIC7pqHPjd41O78sT0fOZufD7nqgqatufMWSdQWA+ebOPQAAAAB2gxn6bLt+dn7Z632raJpom8bsfNhFbev+KQBYBH64AgAAAOCeaegfmDxta37j7Pxer/diRJidD7skRRzNOR8fj0f3Ly8vJ+sKAPNLmA8AAADAbjJDn3cpyzJSkjfCrknpiYh4bjKpnky+uABgrgnzAQAAANg1Gvr7bmrX+drs/JTSa0VZvnXwVwRz41ik9FTT1I8L8wFgvgnzAQAAANgLGvoL7trs/Jzzq71e76VFXw/YbW3jJRYA5p0wHwAAAIBdp6HPtdn5dV2Py7J8OaX0QkS8vvALA7ukzV5eAWDeCfMBAAAA2Esa+nsnz8LNEjvH7b9aluXXI+cXD/6KYE7kHE1d2U0AmGPCfAAAAAD2jIb+npqJNd0J8zf6/f6LKaU3D/6KYH7UdWM3AWCOCfMBAACAXfeNb3wjWVVuoKFPpOSlAXZT0wjzAWCeCfMBAAAA2HMa+ntilpr5k5TSa2WvfOvgrwjmQ444WlfVwHYCwPwS5gMAAAB7Qjufm9DQ3x0zc1NEzjlXVTXKOb9aFOVLU3BJMC8erZrmkeFw2LOjADCfhPkAAADAnhHocyMN/V0zS2F+VFXV1nU9Lsvy5ZTSCxHx+hRcGsy6B3LbPtw0zZKdBID5JMwHAAAA9pRAn5vQ0F8wO8ftv9rv9b4eOb+46OsBu6Wpa2sJAHNKmA8AAADsOYE+N9LQvyczuWY7Yf5G2eu9mIrizYO/IphtKeJoRByvJpP7l5eXfZ8FgDkkzAcAAAD2hUCfm9DQvzszfRNEkbwcwD1L6YmIeK5qmidT8kUFAPNImA8AAADsG4E+N9LQvyuz3MyfpJReK8rirYO/Iph5xyKlp9qmeVyYDwDzSZgPAAAA7CuBPjehoT/ncs65qqpRzvnVoihfWvT1gN3Stl46AWBeCfMBAACAfSfQ50Ya+ndkZpv5VVW1dV2Py7J8OaX0QkS8PgWXBjOvqSubCABzSJgPAAAAHAiBPjehoX9rM3+zw85x+6/2e72vR84vHvwVwexrW/dBAcA8EuYDAAAAB0agz4009D/QvIT5G2Wv92JK6c2DvyKYfVWlmQ8A80iYDwAAABwogT43oaG/AFLy5Q+7YecmGQBgzgjzAQAAgAMn0OdGGvrvK89RM3+SUnqtKMu3Dv6KYLbliKNNXQ9sIwDMH2E+AAAAMBUE+tyEhv6vzcWNDTnnXFXVKOf8almWL03BJcGse7Sq60eGw2HPTgLAfBHmAwAAAFNDoM+NNPTnT9fMr6qqret6XJblyymlFyLinxd9XeAePJBzfjgiliwiAMwXYT4AAAAwVQT63MSiN/Tn4oj96+0ct/9qWRZfj5x/MjUXBjNqMh7bOgCYM8J8AAAAYOoI9LmRhv78Pe6dMH+jLHs/i4g3D/6KYDaliKMRcbyu6/uXl5d9/wSAOSLMBwAAAKaSQJ+bWPSG/txJKW3/Au5SSk9ExHNVVT2ZfDEBwFwR5gMAAABTS6DPjRa0oT93R+zHr5v5k7IsX0tFce7grwhm1rFI6am2bR8X5gPAfBHmAwAAAFNNoM9NLFJDfy5vXMg556qqRjnnX5RF8dIUXBLMtJ0bZACAOSLMBwBg33Uf3KZIL0XOP4yIVTvAlGtzxCuR8wsRsW6z4GAI9LmRGfqzrwseq6pqq6qaFGV5adHXA+6VMB8A5o8wHwCAfdeF+UVRrETE/x45v2gHmGZt2zYpYhgRfxE5v2yz4OAI9LmJeW/oL0Q652RwuHfCfACYP8J8AAD23YkTJ3JRpNUU8aNI6Vsa+kyz7ZMkUrqw83z9gYb+7koRZ1NK9w0Gg35ZlpIcPpBAnxstQEN/Lufl3yildD6l1H2P/efpujKYLVVV2TEAmCPCfAAADkhqUkpvpJz/SkOfadY1BVNKVaT02s7zVUN/F6Wi+ElEPN7r9X67LMve3Dww9pRAn5tYpBn6c6Vt2+7GuV+WZfH1yPkni74ecE+08wFgrvigBACAA9Hr9+uIuByR327b/M9t276RIz9uN+5dr9f/ds5ZmLFLmqbpnq/jFPFWRL7Ytvn1nPNbOeLRuXiAuyovRY7B7dw4nnP+Vznnz9dV9a/rqnorUvpYirhSlqVTD3ZBWZZVznlcVdXcfqLfBfpdI3sKLoUpsfN8yDs3e8zLDR8L0crfMSrL3s/qqv79qbgamFF1U9s6AJgjwnwAAA7EyZMnu7B50v3Zy8vLo5TS36SU/h+7ce+6IP+ZZ54RcO2SP/7jP87f/va367Is624OaS+ltaIofuGks/dI3USCtm173e8f9C8XRfHx8Xj8P9VV9d9FxD90nz13Wdz+X/Z8KsvyP/V6ve9WVTWa58cp0Ocm2p0wfx5epxfq+b09N9/sfLgnufVtEQDmiTAfAIAD183QX7QPq5ktXaB/3QVnxzjf3O0ef3748OFXU0pvRkr/bUR8/oAud261bdsF+j/omq7z/lgF+txoThv6i2CrLMvXUkrnsmPC4a517wEAgPmhSQIAAADMNDP0uYlZn6G/MDc75pxzXdejnPMvyqJ4aQouCWaWm2EAYL4I8wEAAICZJ9DnRl1D/8tf/nI7w4H4wiRyXZN4Mpm0VVVNirK8NAWXBDMpRxxt2nZg9wBgfgjzAQAAAJhns9jQX9hqbTIzH+7Fo3VVPTIcDo3XBYA5IcwHAAAA5oJ2Pu9nRhv6C3PE/o2E+XBPHoiIhyNiyTICwHwQ5gMAAABzQ6DPLcz6DH34/9m72x7JzvNO7Nd9Hqr6aTiUtJQoUiJtLSyS8nojUzQD1oxkey2ahiMzQbB5EcCQlRfJJ0je5CPk7X6BBYEAgZMXykgAbdGmLIuwIIjYF2uGQ9MRoQWHCUiL4vAhnu6uc84dnJ5uqjkazlNXd1ed8/tBgx5xhsOq61RX99S//vcFt2R3Z8egAGAghPkAAAAADN6hhv6yG20rP6428/8ppfQfIuL/XYKbAyslRZyNiC+2bXvXCy+84M1tADAAwnwAAAAWpg/LTJPTpp3PTbRLPqDRPo92XZdTSv+pLMt/Hzm/tAQ3CVZLSo9ExDebpnks2VkBAIMgzAcAAABgNPbfdLSsgb43REVsF0XxDxHx/yzBbYFVc3ek9ETbtQ8L8wFgGIT5AAAAwOBo57OiRn3E/oGi8JIlAACEMB8AAAAAWCJXyrJ8PRXFWy4K3Jmu60wOAAZCmA8AAAAMknY+K2b0rfycc26aZjvn/LMipVeW4CbBahr9+R4AMByVawkAAAAAp2708VvfJt7d3e1yzruR0i+W4CYBAMCp0swHAABgoZ5++unRB1IAt2n0rfxrFcnBGnCnHLMPAMMhzAcAAACA0yXIv0YqvGwJAAC+KwYAAACA0yPIv46kmQ8AAMJ8AAAAADhFjti/DmE+HM18PjdBABgAYT4AAAAwWBcuXJAIssyE+MDxyJ5eAGAIhPkAAAAAjMb+GzzKJbm/WvkAAMDHEuYDAACwcE8//bRwClhWyxLkAwAA3JAwHwAAABg0R+0T+4+DCxcuLNNrYZ1WPnBc7MwHgGGoXEcAAAAARqAP8r2xAwAAWBnCfAAAAAAGa/9khrRkQb5d+QAAwE05Zh8AAIBjYW8+sCSKJXwNzPMjAABwU5r5AAAAwKB5Y8k4LWkjP7Tyb01K6Z/KsvwPbdt+NiI+uwq3GZZJ23WuBwAMgGY+AAAAAEO0jI38EOTfXNd1OaX0n6qq+veR80vLfnthKWVPNQAwBJr5AAAAAAzGEjfyQyv/tmynlP4hIr6yQrcZAAAWSjMfAAAAgCFZ1kZ+CPJvXyq8fAkAwHj5bhgAAIBjY1c5cFL6Rv6FCxeKJW3kh1b+bbtSluXrEfHWit1uAABYGGE+AAAAMGj7x64zfMvcyA9B/q3LOeemabZzzj9LKV5ZldsNAACLZmc+AAAAMHh9oO+kiGFa8h35B7Tyb0PXdbG7u9vlnHcjxy9W5obDEmnmc5cDAAZAMx8AAAAYBQ39wVr2Rn4I8u+cnfkAAIyZ74YBAAA4VtrQLBOB/nCswI78A1r5AADAHRHmAwAAAKMi0B+MVWjkhyAfAAC4U8J8AAAAYHQE+qtrhRr5oZUPAAAchTAfAAAAGCWB/spalUZ+CPIBAICjEOYDAABw7OzNZ1ntt7yF+itgxRr5vU6YDwAAHIUwHwAAABg9of5K0MgfobLw8iUAAOPlu2EAAACAfQL95bOCjfywK3+Bkk9JAADGS5gPAADAiXDUPqtCoL90VqmRH4J8AABgUYT5AAAAANcQ6J++FW3khyAfAABYFGE+AAAAwHUI9E/dqjXyQysfAABYJGE+AAAAJ8ZR+6wagf7JW/FGfrcEtwMAABgIYT4AAADADQj0T9wqNvJDIx8AAFg0YT4AAADATQj0j98KN/Jjv5EvzAcAABZKmA8AAMCJSykJvVg5Av1jp5HPdaZrvAAAjJcwHwAAgBO1vzdfOsNKEugv3oo38mP/+cxz2jFpu26Q9wsAAG6FMB8AAIATp5nPKhPoL9yqNvJDkA8AABwnYT4AAACnoUspqVuysgT6RzeARn4I8gEAgOMkzAcAAODEpSQHZfUJ9I9slRv5vU6YDwAAHKfKdAEAADgFfQDWGDyr7iDQf/rpp4W6t2h/Zhr5AAAANyHMBwAA4MTtN/Mdsw/jVA7gXtuVDwAAHDthPgAAAKcipaSZz2Bo6N/chQsXyhVv4x8Q5J+kbNQAAIyXnfkAAACcBukMjMj+mx2GEuQ7VeQEZWE+AAAjppkPAADAaWlNnqE5aOifgHQMJY38MT9PH/PzsdHIBwAATpQwHwAAAIAQ2t+UMB8AADhRjtkHAAAAgBsT4p+goihiMpkUdV1Puq775GjuOAAAXEMzHwAAAAA+XtbKP1kppVRV1VpK6YGIeHhM9x0WpSj1+ABgCHxFBwAAAICPJ8g/Hett234+Ij49xjsPR1UUpRkCwAAI8wEAAADg+jpB/unpum6sdx0AAPYI8wEAAADgVwnxT9da7rqHIuK+MQ8BAIBxszMfAAAAYPUImo+XPfmnqCiKlHN+sGnbb0VKnx3tIAAAGD1hPgAAAAB8lCD/lOWc78k5PzrqIQAAMHqO2QcAAABYTcLm4yHIB1ZeWZYuIgAMgDAfAAAAAK4S5AMAAEtDmA8AAAAA9uSfqpTS3g8AAOCXhPkAAAAAIMgHAACWTOWCAAAAADBygvxTlvNHx3/t/wduT1Ho8QHAEPiKDgAAAMCYCfKXkDAfjqYsSxMEgAEQ5gMAAAAwVvbkL6ncdWMfAQAACPMBAAAAVpQA+mgE+UumPxZ8MpkUdV1Pcs6fHPs8AADAznwAAAAAxkiQv2RSSqmqqrWU0gNd1z089nnAUdSTifkBwABo5gMAAAAwNoL85bXetu3nc8Snxz4IAAAQ5gMAAAAwJt3+D5aYnfkAACDMBwAAAGA8tPGX31rbtg9FxH1jHwTcqVR42R8AhsLOfAAAAADGIDtef7kVRZFyzg82TfOtSOmzY58H3KlkcgAwGMJ8AAAAAIZOkL8ics735JwfHfscAAAgHLMPAAAAsLKE07fOrIDRKByzDwCDoZkPAHAbXnjhhXTA3O5czrk7d+6cF9QBgJPQCfKBUfG3VQAYDGE+AMBNfP/73y9SRNXlXOauu7vtuse6rnvY3O5cVVXf++EPf/gfv/rVr3phHQA4ToL8FZNzN/YRwJElaT4ADIYwHwDgJv6/Dz6oIudP5JzvzxGPR8Q3I6UnzO3O7e7sRF1VL0VEu6r3gXH6/ve/n/a7TqW1ZUeTUro35/xg5PzDiPjbW3w+mEbExOxvriiKv46I+bLfThYi62B+LKnwiuiPBK+qqqiqajLf3f3k2OcBR3A5cr5YVtUrOWdvZAKAARDmAwDcRM65jD7IT+lPIuenIqVHzAzG5bnnvldE7v/+lMuuy59s2/Z3c8RDHgZHkPODXc7nJ9PJ/1yW1XeKlG4ldEtd15V7z8vceFBFMW+aZseUGDE78ldIv8Wqqqq1lNIDrROw4M7lfDEinimL4kVhPgAMgzAfAOAGvvud76T+aP1I6fH9IF8jH0ZoZ3vHCR3HpCjK//vJJ5+8cqt/+oULFzSQgZvJWvkrab1t28/nnD899kHAncoR76aIVyfT6Xvnz58X5gPAADiaEADgBlJEyik9th/caeTDSPVN8HxwQofng1P19NNPe2EauBGN/BWXO+/DgKMqS4cYAcBQaOYDANxYShEPa+DCeL3wwgtO6ABYDVmYv9LW2qbpV9jcN/ZBwBG8k4riUn+wlCECwDBo5gMAANxAv8fXCR3LRTsfuA5B/opJKe39iL2VK0XKOT/YtO23IqV/NfbZwBG8Vpfl67PZrDFEABgGYT4AAMAN9GH+oRM67jar5SDQhw8JsAX5g5Bzvifn/GhEfHbss4A7lfqd+WW5a4AAMByO2QcAAABgVQnyV1TOLhkch7LQ3wOAIfGVHQAAgJWknQ+jJ8hfcf3ZN3VdF3VdT7qu++TY5wEAANfSzAcAAABYbfnq6cqjIsgfgH6TTV3XaymlB9q2fXjs84BFqOvaHAFgQDTzAQAAWFna+TBKgvyB6Jv5ETFp2/bzXdd9euzzgIVIY3tvFwAMmzAfAAAAgFUhyB+o3HVjHwEshGY+AAyLMB8AAICVpp0Powm2BfkDs9/M32yb5qGIuG/s84Aj08oHgMGxMx8AAABg9Q19b74gf4D2w/wHmrb9VqT02bHPA46qEOYDwOBo5gMAALDytPNh0AT5w5X6Xfk550cjQpgPR5SE+QAwOMJ8AAAAgNU31KBbkD9wduXD4qRCmA8AQyPMBwAAYBC082Fw+s/pTpA/PH17uK7roqqqSdt1d499HrAAlyPnH5Vl9UrO2XMmAAyIMB8AAIDBEOjDYHT7PxiIPsA/OAI8pZTqul5LKT3Qte3DrjEcUc4XI+KZqixfFOYDwLBUricAAADAyhtSeCPEH7j9UH/Sdd3nu667N+z5hiPJEe+miFfXNzbem81mwnwAGBDNfAAAAAZFO58RW/XH/uFj9X0eD0xfFr62MNw2zdjHAguTvCkGAAZJmA8AAMDgCPRh5WQh/njsh46bbds+EhH3jX0esADvlEW6FBE7hgkAw+KYfQAAAIBh6IPwVaxmCvJHpg/zc+4e6LruW5HSp8c+D1iA1+rJ9PXZbOa4CwAYGM18AAAABkk7H1aCIH9E+hC/ruuiqqrpfN58MVJ6NCI+N/a5wFGlfmd+SrsGCQDDo5kPAAAAMAx5xdr53f5HQf5IpJRSXddrfYDfte3DY58HLFJd1+YJAAOkmQ8AAMBgaefDUsoa+eO0vyt/0nXd57uuu3fs84BFKopV3LICANyMMB8AAIBBE+gzMqvweM+HWvmMUNtY6w0LlVKUlWY+AAyRY/YBAAAAOAna+CPVN/KrqirKsqxyzvc0bftIRNw39rnAohRJKx8AhkozHwAAgMHTzodTJ8gfsYNd+SmlB9umeSp33bcipUfGPhdYlKLwMj8ADJWv8gAAAIyCQJ+RWLbHuf34I7a/I//DXfkR8UDTtl+JlB6NiM+NfT6wAJcj5x8VZfFKztlzLAAMkDAfAAAAYFiWaR/9wX58IdPIXBPkfyh3y/TwhBWX88WIeKau6heF+QAwTMJ8AAAARkM7H06MEJ8P7Qf6m818/kjO2a58WJAc8W5EvLq+sfHe+fPnPd8CwAAJ8wEAABgVgT4cq8Mhvs+1ETsoCfcf98P8/oh9u/JhwZJ9+QAwaJXLCwAAADAoB0F6OuE7ZTc+v6Ku66Kqqknbtl/MOT9qQrBQ75RlcSkidowVAIbJ2/YAAAAYHe18WDhBPr8ipZTqul5LKT3QzOcPmxAs3Gt1Xb8+m80aowWAYRLmAwAAMEoCfQbupB7fjtXnY+0frz/JOX++67p7TQoWK0W8O6knu8YKAMMlzAcAAGC0BPpwJFkjn1vRNs2HO/SBxSorm3QBYMh8pQcAAAAYnuPemy/E51f0Tfw+tO8/VlVVlGVZ5ZzvmTfNIxFxn4nBYvWfa0WhrwcAQ+YrPQAAAKOmnc+AHcdj27H6XNf+kfp7Hw/tyn+wbZqnctd9K1J6xORgsVJxXO/XAgCWhTAfAACA0RPowy3pNPK5FQe78iPigXnTfCVSejQiPmd4sDCXI+cflUX5SrbDAgAGTZgPAAAAwM0I8bmhgzzxcK7YdW3krjM4WLScL0bEM5PJ5EVhPgAMmzAfAAAAtPMZpkWE7wfH6ktkuSV1XRd1Xdf9rvxmblc+HIcc8W5EvDqZTt87f/68718AYMCE+QAAALBPoM8A3elj2m58bttHduW37VOtXflwbIqiiLIsDRgABk6YDwAAAIcI9Bm5fJ0fcEsO78pv+l35EXblw/F4pyzLSxGxY74AMGyV6wsAAAAwWAfhfLqFO2gvPgvRr/Du7MqH4/TaZDp9fTabNaYMAMOmmQ8AAADX0M5nYG72eHakPndkv4m/9/Eju/Kb+SORs135cExSxLtVVe2aLwAMnzAfAAAArkOgz0hce6w+3JLDQf7hXfld1z3VNK1d+XCcrr6BxogBYASE+QAAAPAxBPoM2EEbvxPic1Qf3ZU/tysfjs/lyPlHZZFeyf0+CwBg8IT5AAAAcAMCfQbg2ta9Jj5HdpAjHs4T93blt3blw7HJ+WJEPFNV9YvCfAAYB2E+AAAA3IRAnwHI2vgch8O78ue7u49ku/Lh2OSIdyPi1el0+t758+c9jwPACAjzAQAA4BYI9FlxWYjPoh3eld+27VNt19mVDydgMp0aMwCMhDAfAAAAYOC8GYXj8NFd+Y1d+XD83qnK4lJE7Jg1AIyDMB8AAABukUCUVdM/Zj1uOW57u/I7u/LhBLxWT6evz2azxrABYBwq1xkAAABuXR+MXrhwIRkZy0yAz3Hom/h9cN9/rKqqKMuy6nfl7+7uPhL9rvzkqRGOU4p4d1JPdg0ZAMZDMx8AAABuk6CUZXWjJr7HLUexf6T+3seP7Mpvmqe6trUrH05IPZkYNQCMiGY+AAAA3AENfZaJoJ6TdHhX/rzflZ/Soy4AHKvLkfPFsixeyf3xGADAaGjmAwAAwB0SoHKaDlr4t/M49JjlTh3kh4dzxLZtI9uVD8cv54sR8UxV1S8K8wFgXDTzAQAAAFaIQJ7TVNf1h7vy5/2u/Ij7XBA4Xjni3RTx6nQ6fe/8+fO+BgDAiAjzAQAA4Agct89JEeJz2g525eec75/v7j6Vc+535X/ahYGTMZlOTRoARsYx+wAAAHBEQlaO0+0epX8zHq/crn5HflVVqaqqMiLO5pwfatr2if1d+Z8zUDh271R1dSkidowaAMZFMx8AAAAWQEOfRRO6s0yqqqrLsjyTc/707u7upyLnzUie8uCEvDadTF6fzWaNgQPAuGjmAwAAcGpSSu2Qpi98ZREW3cSHO5X2w/qiKPoT9icRcU/TNL/ete2XIuJeg4WTkSLererJrnEDwPgI8wEAADg1RVFcGdr0hbDcqZMM8T1OuZmDIP/Qx6rruk/Md3e/Eik9HSl90RDhZPSfh3VdmzYAjJBj9gEAADhN3RCn78h9bpVQnWVX13VRFEWVc75nd2fnKznnxyOlh1w4OBGXI+eLZV2/knP29QIARkgzHwAAAI6BkJYbWYaj9D1GuZE+N+zP1q+qaq0oigeapnmqbdtvRUqPGByckJwvRsQzk7p+UZgPAOOkmQ8AAADHREOfawnQWWb9Ud77IX6UZZmKoigj4mzXdQ83TfNEpPSoCwgnJ0e8myJena6tvXf+/HlfPwBghIT5AAAAcIwE+gjwWQXX7sivqqouy/JMzvnTTdN8KnfdZiRPZXDSyrLo31xj7gAwUo7ZBwAAgGMmzB2fg2P0l/3ae2xyPUVR9CfsTyLinrZtf71pmi9FxL2GBSfunbquL0XEjtEDwDhp5gMAAMAJ0NAfPsE4q+zgeP2Dtdz9uvyu6z6xu7v7lf7hHSl9xgWGE/fadG399dls1hg9AIyTZj4AAACcEGHvMK1CA/9GPC7HqQ/u03WOza/ruqjrus4537O7s/OV3HWPR8RDEXH32GcGJ+hy5Pyjokg/rqpKKx8ARkwzHwAAAE6Qhv7qE34zJNe08VNd12s55/ubpnmqbdtvRUqfdsHhhOV8MSKeqav6xXzwCQoAjJIwHwAAAE6YQH/1CPAZsj7QL8syFUVRRsTZnPNDTdM8ESk96sLDycsR76aIVyfT6XsXFt23AAAgAElEQVTnz5/39QcARswx+wAAAHAKhMPL7+D4/DFcK4/H8Too/VZV1Z+ufzYiPj3f3f1U7rrNsc8GTlP/Jpu1tTXXAABGTjMfAAAATomG/nIRaDMmh0/uLoqiP2F/EhH3NPP5r7dt+6WIuNcDAk7NO1VVXYoI+/IBYOSE+QAAAHCKDgJkof7pEOD/kjeXjFtKqWqb+Sd25/OvREpPR8Rnxj4TOEWvTafT12ezWeMiAMC4CfMBAACAURDcw0f1x3hXVVWUZVnlnO/Z2Z1/JXJ+PFJ6yKjgVFyOnC9GxI/ryUQrHwAQ5gMAAMAy0NA/HgL826OdPy792fp1Xa/lnO/f2dl5KnfdtyKlT499LnBqrgb5z0zq6sWUkq9fAIAwHwAAAJaJMPXOCO3hxvoWfuzvyu9/XpZlKoqijIizTdM81LXtE5HSo8YIpydHvJsiXp1Op++dP3/e1zUAQJgPAAAAy0agf3PC++Pj8TdsB6F+VVV1WZZn2ra9Z767+6mI2Bz7bGBZ1JOpawEA7BHmAwAAwBISqArs4TgcNPKLotho27Y/Xr/fj/+liLjXwOHUvVPV1aWyLO3LBwD2CPMBAABgSY1hj77Afjl5M8lw9Y38oijOpJTunc/nX8hd97VI6esR8ZmxzwaWwGvT6drrs9mscTEAgBDmAwAAwPI7HHivUsAqqIfT83E78vtGfkTcv7Oz/VDbNI9FxO9ExEMuFZyqy5HzxYj48WQy0coHAD4kzAcAAIAVIiDnpGjnD8O1O/L74/T7Rn4zbzTyYVlcDfKfmdTViyklX+cBgA8J8wEAbiCn1EXE9yJ7PWXBvpcjukHdIwCAJXS4kZ9zvr9pmod2d3c18mGJ5Ih3U8Sr0+n0vfPnz/vLJwDwIWE+AMANfOMb38h//dxz/zFHvGROi5Miut/7vd/zIhUALDnt/NV3eEd+0zRfmM/nX4uIr0dKGvmwZOrJ1CUBAD5CmA8AcBN/8OSTfejcmhOr5G/+5m/6Q3ULF+3ouq77RI54UJJ1PHZ3dr7w3Pf+8mcpFd7gcxtyRMo5p8i5P4s3XXuCTFEU8yf/8A+dgAIjcnhH/sHHoihSSqlOKf2Ltm1/Y3d394ncdb8TKWnkw3J5p67rS2VZ2pcPAHyEMB8AAAbmL//iL9LOzs6/jog/dG2Pbi/Iv7pTmGMwn8//x/l8/tth9cad6t+0M7n27/cbm5v/LiJ+vlL3BFiIPtQ/CPT3A/4q5/zJ3d3dL+ecn9bIh6X02nQ6fX02mzUuDwBwmDAfAACGp9gL8lP6X1zbo9PIP2YpPRkRTw76Pp6Cruv+d2E+i+Ko/dXTh/hVVRVlWVYppXt2dna+3Lbt40kjH5bN5cj5Yor48XRtTSsfAPgVjt0EAAAA4Ib6QN+EVkPfyt87W7+u14qieGB3d+eP2qb5s5TSvxr7bGDp5HwxIp6pJ5MXc86eZwGAX6GZDwAAAAOTUrK2AAbuejvy9xv5qSiKMiLOznd3H27mzX8eKT3u8QDLJ0e8myJe3djYeO/8+fPCfADgV2jmAwAAwPDYucvCaecvp4NQ/0BVVXVd12e7rrunadtPRsSZsc8Illkqiqjr2jUCAK5LMx8AAAAGJqU0d01hPPpAvyzLvUZ+URQbbdvev7O9/VDO+Tcj4l4PBVha79R1fSki7MsHAK5LMx8AAAAGxjH7HBft/OVzcMz+oUb+/Ts7O1/IOX8tUno6Uvri2GcES+y1jY3112ezmRN1AIDr0swHAAAAgCV3sx351zTyH4uI34mIh1xXWEqXI+eLVVn8uCwrrXwA4GNp5gMAAABwy7TzT9fH7cjPOd+/q5EPqyHnixHxzGQ6fTEfvEMHAOA6NPMBAAAAYIVcd0f+zs5Dues08mEF5Ih3i5Re3dzcem82mwnzAYCPpZkPAAAAwG3Rzj891+7I/7CR33Ua+bBCykrPDgC4Od8xAAAAAMCSueUd+Rr5sEr2duWniOen0+lPI8K+fADghjTzAQAAALht2vkn46Y78jXyYXXs78ovyvLP19fXL81ms8bVAwBuRJgPAAAAwB0R6J+Mg0Z+XdfVQSN/e3v7S13XPXGokX/3GGYBq6zflR8Rr26sr/18Npu1LiYAcDOO2QcAAACAJXXoeP26LMszbdvee6iR//WI+IxrB6uj/3yuJ1NXDAC4JZr5AAAAANwx7fzF6AO+w0fqH+zKv7aRv6ORD6vsnaqqLpVlaVc+AHBLhPkAAAAAHIlAf3E+bkd+13X37/SN/JztyIfV9drG5ubrduUDALfKMfsAAAAAsET2j9UviqIo94/W7xv5D+WcHzvUyAdWx+XI+WJVFj+uqkorHwC4ZZr5AAAAAByZdv5i7O/I74/WXyvL8v757u6v7Vy5opEPqyznixHxzGQ6fTEf7NAAALgFmvkAAAAAcMIOjtPfD++jLMvUV/H7X9r/eN/u7u5Xm6Y5GxGf1ciH1ZUj3i1SenVzc+u92WwmzAcAbpkwHwAAAICF6Nv5Fy5cSKZ56w5C/X43flEUZyKijoit7e3tP+ra9k/3Xr9LaTMiPrMa9wi4nrr2UjwAcPscsw8AAADAwjhu//b0jfy6rvsF+RsRcX/Xdb+1feXKk23b/nGk9Hik9Oh+I//uVbpfwJ5+V/6PUsTz0+n0pxFhXz4AcFu8HRAAAAAATslBIz+ldG/TzL+wuzt/Infd76aU7nNNYMXt78qvJ5Nnp2vrl2azWeuSAgC3QzMfAAAAgIXSzr96fP7BEfrX+7WiKD7SyJ/P51/a2dndC/L3GvkRnzvxGw0sVL8rPyJeXV9b+7kgHwC4E8J8AAAAABZOoH/VxwX6dZ/kV9XZlFIf5H9hd2fna/3YIqUvnvytBI5LURQxmU7NFwC4I47ZBwAAAIAT0Af7VVUVKaWyP1q/b+RvX7nyUNu2j0XE7+zvxgdWX78r/6Jd+QDAUWnmAwAAAHAstPP7ldkfHUFVVdOqqu7vuu7Xtq9c+ULbtl+LlDTyYUj2d+UXZfnnm1tb/a78xvUFAO6EMB8AAACAYzOWQP/aHfkHIX5ZlmkymZSTyaSaTqd1f6x+M5///s729le7rnsiIh7db+TffYo3H1igg1350+nErnwA4Egcsw8AAAAAC9IH+ofb+P1u/P0j9euI2NrZ2XmybZo/23tdLqXNiPiU2cPw9M8Fa2vrriwAcCSa+QAAAAAcq7Edt9+HeH0jv67rqiiKjX43ftd1v3XlypU/aJvmjyOlxyOlg0b+v1iCmwwsRr8r/0f9rvy6rn9alqVd+QDAkQjzAQAAADh2Ywn0D1r5fSO/qqqze8fqN80Xtre3v5677r+LlP6zU7+RwPHY35UfOf/55uaGXfkAwJEJ8wEAAAA4Easc6B/sxD+8F/+wQyF+ceho/fu3t7e/tLuz80TkfH6vkR/xudO5B8BxO9iVv7a+/vOvfu137coHAI7MznwAAAAAuAXX7sO/nqqqpimlz7Rt+6n57u7nu677WqT0dbvxYTzW1tdcbQBgITTzAQAAADgxQzpu/2A3/mQyKSeTSTWdTuv+WP3dnZ3f39nZ+WrXdU9EhN34MB7vVHV1qapqu/IBgIXQzAcAAADgRPWB/oULF65/Xv0Su14r/9CR+nXXdVtXrlx5Mnfdn+297pbSpkY+jMprG+sbr9uVDwAsimY+AAAAACdu2Rv61+7I74P8gx/9P7t2N/7u7u5vbW9v/0Huuj/e242fkkY+jMflyPlHVVn8uJ5MtPIBgIXRzAcAAACA67jRjvzr7Mbvj9T/3UjpPrOEkcn5YkQ8s7a2/mL+uCcNAIA7oJkPAAAAwKlYlf35B038fi/+4d34Ox/djX9+r5Ef8bkluMnACcoR75Zl8er6xsZ758+fF+YDAAujmQ8AAAAA13G4YNs38YuiuKf/edM0E7vxgcMm0zXzAAAWTpgPAAAAwKnp2/kXLlxIJ/3fP9iFH9eE9ge/VlVVkVLaO9WyKPqfpvvn8/m5pplH1+W1yPmP95v4wHj1u/IvlkXx/HQ6/WlE2JcPACyUMB8AAACAU3Wagf6NduIfNPFzzpOdnZ0n26b50/1fLu3GBw525a9vbDxbVdWl2WzWGgoAsEjCfAAAAABO3WkF+nGDJn7btueapom2adby1Sb+Ex4pwIF+V37V78pfX/+5IB8AOA7CfAAAAACWwkkH+h+3E79v4s93d5+c9038q79HEx+4LrvyAYDjJMwHAAAAYGksKtC/k534fRO/a9uY9038rrvaxE+nclgAsNzsygcAToQwHwAAAIBBup2d+PP5/MlmPv/TrIkP3Ixd+QDACRHmAwAAALBUFn3c/rVN/HTVfW3bntfEB27DBxHxRkS8UFblT6bT6VuCfADgOAnzAQAAAFg6iwj0b7ATv57P519v5vNvauIDt+GNyPnbKeL59fWNN4uiEOQDAMdKmA8AAADAUjoc6N9oB/61btbEb9q27tr2G5r4wG3J+a0c8VJV1/84mUx+kXNuDBAAOE7CfAAAAACW1rWB/s2C/APXNvF3d3e/3jTNN0MTH7hz20XE2+vr65cj4sq5c+du7QkJAOAOCfMBAAAAWGkf18RvmuZ82zTRdl2du04TH7hTlyPnixHxXDWZvDydTt+fzWaCfADg2AnzAQAAAFhqfTv/O9/5TrpRK/9wE79pmnpne/vrbdt+c/+XNfGBO3c1yH8mcn52a3Pj0mw2sysfADgRwnwAAAAAlt6f/Mmf5O9+97upqqq0F87vN/LLsuxf35p2Xffgzs7Ob/c78XPfxI+42sQHOKIc8W6KeHV9Y+PnX/3a7wryAYATI8wHAAAAYCV84xvfyH/1V3816Rv4Oecy51w1TfOv5/P5H+Su+2xEfHb/fmjiAwvVv3lobX3dUAGAEyXMBwAAAGBpfe9730tFUXy46L4oik/N5/N+F/7a/i78/zJS+i/swgeOwd6u/BTx/GQy+WlZljuGDACcJGE+AAAAAEurqqqqLMuzXdfFfHe33L5y5Wtd1/0P+69rTTXwgWOzvyu/KMtnN7e27MoHAE6cMB8AAACAU3dtA7+qqqJt27ppmnuv/PM/f7lt20gR/S78/zpS+n1XDDhuB7vyN9bXfn7+/HlBPgBw4oT5AAAAAJy6gwZ+0zTRNE25vX3lN7u2+zc54tdSxF77PvevZaX0gKsFnJSiKGJtfcO8AYBTIcwHAAAA4Nhdr3mfcy77n7dtW8x3d+9t2/bL/XH6+w38fxsp/Tc24QOn4MNd+esbGz+NCLvyAYBTIcwHAAAA4NgdNO/7/858Pi92trd/c940v9eH95FzqYEPLI39Xfl1XT27vr5uVz4AcGqE+QAAAAAc2Y2a913XFW3T3Lt95cpe8z53Xd+8/68ipf927zenFBr4wLI42JW/ubX1c0E+AHCahPkAAAAAHNmvNO93dn6zmc9/r8u5D+8/0rwPzXtgyU0mdVRV7TIBAKdKmA8AAADAx7pR4/5A0zRF17X3Xvnn5st9eB+a98BqurorP6Xn19btygcATp8wHwAAAICPdbhx3x+X3zfu237Xfd+4v9q6739J8x5Yffu78tfX1p6dTCZ25QMAp06YDwAAADBSf/u3f5t6XX8Mfs5F7GVZeW8Y/W77g133bdt+eT+4/2jjPq627vc+eBABq+uDiHgjIl4oq/In6xsbbwnyAYBlIMwHAAAAGJEf/vCHqSzLjf173Dftf2M+330yd7nocjfJOYr9tn1o3AMj8Ubk/O0U8fzGxuabRVEI8gGApSDMBwAAAFhBf/d3f9eX4Yub3fL57u7Vj/N537RPTdt+Inftb7Vt17fpqxzxbyOl//4j/1L6Zc9e4x4YvJzfyhEvTafTf6zr+hc558ZFBwCWgTAfAAAAYAUcbtQ3TVPs7u7+RtM0f5Bz95Gj8SPv/S8OtesPK3LE5yPiX+7/szJS+oLrD4zcdlEUb69vbFyOiCvnzp3LYx8IALAchPkAAAAwMFf++Z//5V/+xV9cWsi9SinK4qbl748oyzKKW/x3yqq65d87NAeN+cP69vxhbXv1pOcud6ltu090bftbcbUtf/1G/WHp+p16TXuAD12OnC9GxHNr0+nLVVW9P5vNBPkAwNIQ5gMAAMDAtF33P3U7O18Z3B1LKYqPCahv1d4bB+70j8j7zffb0PWN+byQXEijHmDRrgb5z1Rl+ezm1tal2WxmVz4AsFSE+QAAADAwKaU/iog/GuJ17Y4YjHftKeQ0R3wDwod/zEL+FAAO5Ih3U8Srm2fO/FyQDwAso3GeYwcAAAAAwOhNJnXUdT32MQAAS0ozHwAAAACAMdnblV+k9Pza+sZPI2LH1QcAlpEwHwAAAACA8djflb+xufnsZDKxKx8AWFrCfAAAAAAAxuCDiHgjIl6oJ5OfTKfTtwT5AMAyE+YDAAAAADAGb0TO305F8fzGxsabRVEI8gGApVa4PAAAAAAADF7Ob+WIl9bX1/+xLMtf5JwbFx0AWGaa+QAAAAAAjMF2VZZvr62tXY6IK+fOncuuOgCwzIT5AAAAAAAM2eXI+WKk9NzGxvrLRVG8P5vNBPkAwNIT5gMAAAAAMFx9kB/xzNra9Nnp2vql2WxmVz4AsBKE+QAAAAAADNEHEfFGRLxQVuVPNjY23xLkAwCrRJgPAAAAAMAQvRE5fzsVxfObm5tvFkUhyAcAVoowHwCApfHCCy+kA67Knctd94kc8aAhAgAwajm/lSNeWptO/rGq6l/knJuxjwQAWC3CfAAATtVzz32viNx/X5rLrst3d133WI78sKty59qmfTCl9PVVvf0AALAg21VZvr2xsXk5Iq6cO3cuGywAsEqE+QAAnKqd7Z0qcv5Ezvn+HPF4RHwzUnrCVblzKaXvV0Xxv0aK7VW9D8uk6/L5ruv+MCLWxj4LAIAVcTlyvhgpPbexsf5yURTvz2YzQT4AsHKE+QAAnKqccxl9kJ/Sn0TOT0VKj7giR7M2nf679Y2N7xZF0a3y/VgWOzs7f/v+++//m7HPAQBgZfRBfsQzG+vrz07X1i/NZjO78gGAlSTMBwDg1Hz3O99JuevujpQe3w/yNfIXIBXFaxHRaB8txg9/+MOfRcT7EbE1hPsDADBgH0TEGxHxQl1VP1lbX39LkA8ArLLC1QMA4LSkiJRTemz/aH2N/AXpuu6BlFIaxJ0BAIBb90bk/O1UFH+1sbX1ZlEUgnwAYKUJ8wEAOE194vzwfiP/bldiMbque1iYDwDAiPSN/H/IOT+fIn6wubn5clmWb+ecGw8CAGCVOWYfAAAAAIBVttfILyJ+MJlOX5lMJm9HxPa5c+esnQIAVpowHwAAAACA1ZXzWznipaosX9nY3HwzpbQjyAcAhkCYDwAAAADAKtsuIt5e39y8nFK6IsgHAIZCmA8AAAAAwCq6HDlfjIjnputrL0+n0/dns5kgHwAYDGE+AAAAAACr52qQ/0xdV89ubZ25NJvNWlcRABgSYT4AAAAAAKvkg4h4IyJeSEXxk60zd70lyAcAhkiYDwAAAADAKnkjcv52inh+c3PzzbIsBfkAwCAJ8wEAAAAAWAV7jfyc8/NFxA/6PfmTyeTtnHPj6gEAQyTMBwAAAABgFew18vsgv6yrVzY2Nt+OiO1z585lVw8AGCJhPgAAAAAAyy/nt3LES6koXjlz5q43U0o7gnwAYMiE+QAAAAAArILtIuLtzc3NyymlK4J8AGDohPkAAAAAACyzy5HzxYh4bjKdvry2tvb+bDYT5AMAgyfMBwAAAABgeV0N8p+pyvLZM3fddWk2m7WuFgAwBsJ8AAAAAACW0QcR8UZEvJCK4idnzp59S5APAIyJMB8AAAAAgGX0RuT87RTx/NbW1ptlWQryAYBREeYDAAAAALBM9hr5Oefni4gfrK+vv1zX9ds558ZVAgDGRJgPAAAAAMAy2Wvk90F+XdevrG1svB0R2+fOncuuEgAwJsJ8AAAAAACWR85v5YiXqrJ8Zeuuu95MKe0I8gGAMRLmAwAAAACwTLaLonh7c2vzckRcEeQDAGMlzAcAAAAAYBlcjpwvRsRzGxsbL9eT6fuz2UyQDwCMljAfAAAAAIDTdzXIf2Z9ff3Z9fX1S7PZrHVVAIAxE+YDAAAAAHCaPoiINyLihXoy+cn6xsZbgnwAAGE+AAAAAACn643I+dtFUTy/tbX1ZlEUgnwAYPRCmA8AAAAAwCnZa+TnnJ8viuIHZ+666+WU0ts558YFAQAQ5gMAAAAAcDoOGvk/2NzcfKUsy7cjYvvcuXPZ9QAAEOYDAAAAAHCyftnIj/jBxvr6308mk7dTSjuCfACAXxLmAwAAAABwkq428iN+MF1be2W6tqaRDwBwHcJ8AAAAAABOwkca+fVk8vcbm5sa+QAAH0OYDwAAAADASfiwkV/W1StbZ85o5AMA3IAwHwAAAACA4/SRRn5Zln9/5sxdGvkAADchzAcAAAAA4Dh92MiPonhlc2urD/I18gEAbkKYDwAAAADA8cn5rRzxUiqKV86cOfNmVdca+QAAt0CYDwAAAADAcdouIt7e3Ni4XFXVFUE+AMCtEeYDAAAAAHAcLkfOFyPiubX19ZfX1tffn81mgnwAgFskzAcAAAAAYPGuBvnPTKfTZze3ti7NZrPWlAEAbp0wHwAAAACARfogIt6IiBfqyeQnm1tbbwnyAQBunzAfAAAAAIBFeiNy/nZd189vbW29WRSFIB8A4A4I8wEAAAAAWIS9Rn7O+fmyKH6wsbn5ckrp7ZxzY7oAALdPmA8AAAAAwCLsNfL7IH9za+uVsizfjojtc+fOZdMFALh9wnwAAAAAAI7iI438M3fd9fdVVb1dFMX2E088IcgHALhDwnwAAAAAAI7iZ5Hz/1kUxfObW1uvTqfTfyqKYvfxxx8X5AMAHIEwHwAAAACAO/FB5PyzHPHXRVE8d/bs2f9rfX393aqqmt/+7d8W5AMAHJEwHwAAAACA25fzaxHxfxRF8ddnz579x42NjXcfe+yxuUkCACyGMB8AAAAAgNvRN/Jfyzn/ZVGWz919992vrq+vvy/IBwBYLGE+AAAAAAC37moj/38rUvr+ma2tnwryAQCOhzAfAAAAAIBb8ctGfkrf39raenXrzBlBPgDAMRHmAwAAAABwc4ca+VtbWz89c/asIB8A4BgJ8wEAAAAAuJFfaeQL8gEAjp8wHwAAAACAj6eRDwBwKoT5AAAAAABcj0Y+AMApEuYDAAAAAPCrNPIBAE6VMB8AAAAAgMM08gEAloAwHwAAAACAX9LIBwBYCsJ8AAAAAABCIx8AYLkI8wEAAAAA0MgHAFgywnwAAAAAgHHTyAcAWELCfAAAAACAMdPIBwBYSsJ8AAAAAIBx+mUjvyy/f9fW1qubZ84I8gEAloQwHwAAAABgjA4a+WX5/bNnz/50Y2NDkA8AsESE+QAAAAAA4/KRRv7dd9/96vr6uiAf4P9n72524yj7NA4/9dlVXVVdHSesZzTLWVmOJRbAbjQHNEcw6zkEjoDVrLIIr6x4Q7LLJpZGkbEhejeWJSdg2fkQxH5G7bQhzhcEYru7fV0SQrEUSHdFAvzj7j/AjBHzAQAAAACukjcW+UI+AMBsEvMBAAAAAK6G3xb5eZ6vj/reIh8AYIaJ+QAAAAAAV8F0kT8J+f14vF1VlZAPADDDxHwAAAAAgMW2F2LcCCGsZ1l259rS0vdlWQr5AAAzTswHAAAAAFhkMW7EEL6uBoP742vX9rIsOxTyAQBmn5gPAAAAALBYDqcfqb8bQ3geYrxVVdXa9Rs39tM0PVpZWTn2vAEAZp+YDwAAAACwSKa38WMIG2kIT4Zts3n9xmePl5eXo+cMADA/xHwAAAAAgMVwssiPMX6bJsl6EsIPo1F30F9beiHkAwDMHzEfAAAAAGARTBf5JyE/Tbf78fjnr776ym18AIA5JeYDAAAAAMy3s4v8NN28trR08MUXXwj5AABzTMwHAAAAAJhnry3y8yzbXvrss4PPP/9cyAcAmHNiPgAAAADAfDqzyC/LcnO8tCTkAwAsCDEfAAAAAGAevbbIHwwG20s3bhysrq4K+QAAC0LMBwCABZOm6cMYY/RcAQAW1plFftu2m13fC/kAAAtGzAcAgAWTpuk/xXwAgAV2usjPsvWu67bbthXyAQAWkJgPAAAL6MsvvxTzAQAWz16IcSOEsJ5l2Z1R339f17WQDwCwoMR8AAAAAIB5EONGDOHrQVHcH43He2VZHgr5AACLS8wHAODSVFV1/OvR0T+Oj488hE8gxvAvx8fH/xFC/Lfvvvvu/9I0PZ77FzUDXr58+a8hhO6qvw8AwKU4nH6k/m4M4XmI8VZd12tL16/vp2l6tLKy4t/3AAAWWOLhAsB8cxabeXf37t0kSZLUg/z7YozXnj59+t+//PLLv6dJsh6S8GLeX9MsOD6OXx4fH//n5P8/uervBQBwwWJ8MLmNH0PYSNP0STMcbi5dv/54eXnZfwjyh5LEt/8BYN75pzkAzDkxHzh179697OnTp//1/Pnz//GmAADMtZNFfozx2zRJ/jfNsh/68figbdsXQj5/lpgPAPPPx+wDAAAAAMySVx+t/83k05bystheWrr+8+eff+42PgDAFSPmAwAAAADMhtcX+et1XW+Ol5YOVldXhXwAgCtIzAcAAAAAmAWni/wsW+/adrvtOiEfAOAKE/MBAAAAAC7XXohxI4SwnmXZnVHff1/XtZAPAHDFifkAAAAAAJcpxo0YwtfVYHC/G432yrI8FPIBABDzAQAAAAAu1uH0I/V3YwjPkxBudW27Nur7/TRNj1ZWVo49DwAAxHwAAAAAgIs0vY0fQ9jIs+xJ23Wbfd8/Xl5ejp4DAACnxHwAAAAAgItxssiPMX6bJsl6NRj8MBqPD6qqeiHkAwDwJjEfAAAAAOAiTBf5aZatt8Phdtf3P7uNDwDA+4j5AAAAAADnay/EuBFCWM+y7DZ/BjoAABVbSURBVM6o77+v6/pAyAcA4EPEfAAAAACA8xTjRgzh66qq7nddt1eW5aGQDwDAHxHzAQAAAAA+rcPpR+rvxhCeJyHcGnXdWjca7adperSysnLs/QYA4I+I+QAAAAAAn9L0Nn4MYaPI8yf9eLzZNM3j5eXl6H0GAODPEvMBAAAAAD6N327jJ2l6pxnWP45G/UFRFC+EfAAAPpaYDwAAAADwKUxv4xdZdr/r+726rt3GBwDgLxPzAQAAAAD+mjO38UOMt4bD4dq1pSW38QEA+NvEfAAAAACAv+K12/hZlj7putFm3/du4wMA8EmI+QAAAAAAH+f32/gh3BnW9Y/taHRQVZXb+AAAfDJiPgAAAADAx5jexs+y9P5o1O8Nh0O38QEA+OTEfAAAAACAD3vrNn5d12v9eLxfFIXb+AAAnAsxHwAAAADgQ968jd92m/147DY+AADnSswHAAAAAHi3s7fxm+GPbdu5jQ8AwIUQ8wEAAAAA3mV6G7/Isvtd3+/Vde02PgAAF0bMBwAAAAB4ZW8a8H+a/CgJ4fawrteuLS3tp2nqNj4AABdKzAcAAAAACL8v8ZMQtvI8C13XPepGvdv4AABcCjEfAAAAALiqDkOMP4QQdmMIz0OMt7I0XevH4/1h04Qsy14K+QAAXBYxHwAAAAC4ml6F/G9iCBtpCE8Gdb15/caNxzdv3hTwAQC4dGI+AAAAAHDVnNzGDyGsJyHcKfL8x67vD9q2fWGJDwDArBDzAQAAAICrZXobP03T+00z3BuN+sPV1dVf/S4AAGCWiPkAAAAAwKLbmwb8n05eZ4y367o+uY1fFMXRysrKsd8BAADMGjEfAAAAAFhs0yV+EsJWnmehabtHfd8/9pH6AADMMjEfAAAAAFg0hyHGH0IIuzGE5yHGW1mer426br9p25Bl2UshHwCAWSfmAwAAAACL5VXI/yaGsJGm6ZNqMNhcun798c2bNwV8AADmhpgPAAAAACyKk9v4IYT1JIQ71WDwY9u1B8OmfWGJDwDAvBHzAQAAAIDFML2NXxT5/bbt9obD4eHq6uqvni4AAPNIzAcAAAAA5tXeNOD/NPn1p2lyu2vatW402k/T9GhlZeXYkwUAYF6J+QAAAADAfJou8dMk2arqKrRt96iu68c+Uh8AgEUg5gMAAAAA8+LMEj8J4fawrtf68Xg/y7KQZdlLIR8AgEUh5gMAAAAA82G6xE9C2BpUg5MlftM0lvgAACwkMR8AAAAAmFVnlvghxttVVa31436/KEpLfAAAFpqYDwAAAADMpteW+EVZhrYZPupGvSU+AABXgpgPAAAAAMwKS3wAAJgS8wEAAACA2WCJDwAAvxHzAQAAAIDLYokPAADvIeYDAAAAAJfDEh8AAN5LzAcAAAAALsqZJX4Swu1qMLDEBwCAdxDzAQAAAICLMV3ip0myVQ7K0Lbdo6ZpLPEBAOAdxHwAAAAA4LycWeKnaXK7qeu1btTvZ1lmiQ8AAB8g5gMAAAAA52O6xM+z7Lclfl3XlvgAAPAniPkAAAAAwN91ZoEfQngcYtwuyuJeM2wetF33bPJFS3wAAPjzxHwAAAAA4O+ZLvCTELaSJAllWe704363quoj8R4AAP4aMR8AAAAA+Fhnl/gx3s7yfK1rm/162ExivgU+AAD8TWI+AAAAAPBxXlvi53kW6nr46NrSklv4AADwCYn5AAAAAMAfObPET0K4XVfV2qgf7RdF6RY+AACcAzEfAAAAAPiw6RI/z7KtclCG4bB51DSNJT4AAJwjMR8AAAAAOHX2Fn4Ij5MQtvOiuNe27YOmaZ5NvmiJDwAA50/MBwAAAABeeeMWflVVO2032i3L8ki8BwCAiyXmAwAAAMDV89YCP8S4nWbpvWpQPRiNumdu4QMAwOUS8wEAAADgqnltgT955YPBYKdpmt226yzwAQBgRoj5AAAAALD4zi7xY7xdFvla03b7VV2Hsiwt8AEAYMaI+QAAAACw6KZL/DzLtsqymNzCf9SN+scCPgAAzC4xHwAAAAAWx1u38NMk2S6K4l7btQ/qYfNs8kW38AEAYPaJ+QAAAACwKKYL/CxNt4o8D9VwuNN13W6apm7hAwDAnBHzAQAAAGD+vHeBP2zbB01jgQ8AAPNOzAcAAACAefPGDfxBVe20rQU+AAAsEjEfAAAAAGbPW8v7EON2COFJXuShKIqHw7p2Ax8AABaYmA8AAAAAs2a6vE9C2EqSJJRludM0zW49HB5lWXbyixXvAQBgsYn5AAAAAHB53rnAz7PsXjkYPGi77llZlpb3AABwBYn5AAAAAHBZpgv8LE23sjwPg8Fgp23b3bIs3b4HAIArTswHAAAAgPPzzuV9kiRPsjxz+x4AAHgvMR8AAAAAzst0eZ8myVaeZ6Esyp1h2+7WdX10+ncU7wEAgHcR8wEAAADg471zcR9CeDL5QZIk4XR5X1X1g6axvAcAAD6OmA8AAAAAH2u6uE9C2Jr8zDTLduqq2h0MyqO8KENVVb/9BcV7AADgrxDzAQAAAOBt713eT1b3eZ49LIryQVVVzwZVFcqytLgHAAA+KTEfAAAAAN702vJ+cus+z4uduq52i3JwdLq6F+8BAIDzJOYDAAAAcBV88MZ9OL1zn2Uhy9JJvH9YDgZu3QMAAJdGzAcAAABg8b1x477Is51yUO3meX40GAxCUZYnIf914j0AAHCZxHwAAAAA5skfLuxPnS7t0zQNaZo8rKr6waAaPCuK0tIeAACYeWI+AAAAAPPjjYV9mmU7ZZ7vFkVxlGZZKPJ88rVQ1fVbL0m8BwAA5omYDwAAAMB5+tNL+neZLOsnC/vJH2k6WdrnD8uyfFAOBs/K0sIeAABYXGI+AAAAAOfnjSV9iHEnL4rdsiyPwvSj8PP81beoTlf1E+9a1p8S7wEAgKtAzAcAgAURYzwuiuIfz58980iBD3kZQphE1Jcxxl+9U3ysNEtDmqRv/azJXfokee0LSRqyk1v16cM8z92qBwAA+EiJNwwA5luMvg8K/O7u3btJkryjsABXWvKqsMbJn7Msi5OPLZ+EV7go4j3AxUsS3/4HAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK48AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArjwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4//bggAAAAABBkP9XNyQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBDNQJ75E2RuWS4AAAADmVYSWZNTQAqAAAACAAAAAAAAADSU5MAAAAASUVORK5CYII=",
          alt: ""
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(Icon_default, { name: icon || "filePhoto", color: theme.colors.n60, size: 24, ...iconProps })
    }
  );
}
var DashPlaceholder_default = DashPlaceholder;

// src/components/molecules/IconBadge/IconBadge.tsx
var import_styled_components93 = __toESM(require("styled-components"));
var import_jsx_runtime95 = require("react/jsx-runtime");
var getIconsSize = ({ regular, medium, small }, theme) => regular && theme.space * 6 || medium && theme.space * 5 || small && theme.space * 4 || theme.space * 6;
var variationsStyle2 = import_styled_components93.css`
  ${({ theme, variation }) => {
  const variations = {
    primary: import_styled_components93.css`
        background-color: ${theme.colors.white};
        color: ${theme.colors.black};
        border: 1px solid ${theme.colors.black};
      `,
    outline: import_styled_components93.css`
        background-color: ${theme.colors.g20};
        color: ${theme.colors.white};
        border: 1px solid ${theme.colors.g20};
      `
  };
  return variations[variation] || "";
}}
`;
var BadgeStyle2 = (0, import_styled_components93.default)(Flex_default)`
  border-radius: 50%;
  ${variationsStyle2}
`;
function IconBadge({
  icon,
  regular,
  medium,
  small,
  size,
  iconProps = {},
  ...args
}) {
  const theme = (0, import_styled_components93.useTheme)();
  const sizeBadge = size || getButtonHeight({ regular, medium, small });
  const sizeIcon = iconProps?.size || getIconsSize({ regular, medium, small }, theme);
  return /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(BadgeStyle2, { w: sizeBadge, h: sizeBadge, alignItems: "center", justifyContent: "center", ...args, children: /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(Icon_default, { name: icon, size: sizeIcon, ...iconProps }) });
}
var IconBadge_default = IconBadge;

// src/components/molecules/UploadMediaContainer/UploadMediaContainer.tsx
var import_dash_common24 = require("dash-common");
var import_styled_components95 = require("styled-components");
var import_react_i18next25 = require("react-i18next");
var import_react72 = require("react");

// src/components/molecules/UploadMediaContainer/UploadMediaContainer.styles.ts
var import_styled_components94 = __toESM(require("styled-components"));
var MainContainer = (0, import_styled_components94.default)(Flex_default)`
  position: fixed;
  bottom: 0;
  right: 18px;
  min-height: ${({ toggle }) => toggle ? "244px" : 0};
  max-height: 528px;
  z-index: 99;
  filter: drop-shadow(0px 2px 14px ${({ theme }) => theme.colors.black}40);
`;
var HeaderContainer = (0, import_styled_components94.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.b50};
  border-radius: 8px 8px 0 0;
  min-height: 76px;

  p {
    font-size: 20px;
    line-height: 24px;
  }
`;
var ContentContainer2 = (0, import_styled_components94.default)(Flex_default)`
  display: ${({ toggle }) => toggle ? "block" : "none"};
  background-color: ${({ theme }) => theme.colors.white};
  overflow: auto;

  & > div:first-child {
    border: none;
    width: 100%;
    height: 100%;
    padding-bottom: 0;
  }
`;
var IconWrapper5 = (0, import_styled_components94.default)(Flex_default)`
  cursor: pointer;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.colors.white};
`;

// src/components/molecules/UploadMediaContainer/UploadMediaContainer.tsx
var import_jsx_runtime96 = require("react/jsx-runtime");
var UploadMediaContainer = ({
  visible,
  onClose,
  onUpload,
  cancelUpload,
  cancelAllUploads,
  ...props
}) => {
  const { t } = (0, import_react_i18next25.useTranslation)("pages");
  const theme = (0, import_styled_components95.useTheme)();
  const [toggle, setToggle] = (0, import_react72.useState)(true);
  const { onHistoryClear, filesToUpload } = (0, import_react72.useContext)(MultiFileUploadContext);
  const fileTypeValidator = (file) => {
    const maxSizeInMb = import_dash_common24.MEDIA_SIZE_LIMITATION_EXCEPTIONS_BY_MIME_TYPES_IN_MB[file.type] || import_dash_common24.MEDIA_SIZE_LIMITATION_IN_MB;
    const maxSizeInBytes = (0, import_dash_common24.mBytesToBytes)(maxSizeInMb);
    if (file.size >= maxSizeInBytes) {
      return {
        code: "file-size-limitation",
        message: t("forms:messages.uploadErrors.fileTooLarge", { maxSize: maxSizeInMb })
      };
    }
    return null;
  };
  return visible ? /* @__PURE__ */ (0, import_jsx_runtime96.jsxs)(MainContainer, { w: 412, toggle, flexDirection: "column", ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime96.jsxs)(HeaderContainer, { px: 5, alignItems: "center", justifyContent: "space-between", w: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(Text_default, { color: theme.colors.white, children: t("propertyPage.uploadMedia") }),
      filesToUpload.some((item) => item.status === import_dash_common24.ProgressTrackingFileStatusesEnum.UPLOADING) || !toggle ? /* @__PURE__ */ (0, import_jsx_runtime96.jsxs)(Flex_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(IconWrapper5, { px: 2, py: 2, mr: 4, onClick: () => setToggle(!toggle), children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(Icon_default, { name: toggle ? "chevronDown" : "chevronUp", color: theme.colors.white }) }),
        /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
          DropDown_default,
          {
            items: [
              {
                children: t("propertyPage.cancelAllUpdates"),
                key: "cancel",
                w: 200,
                onClick: (e) => {
                  e.stopPropagation();
                  if (cancelAllUploads) {
                    cancelAllUploads();
                  }
                }
              },
              {
                children: t("propertyPage.clearUploadHistory"),
                key: "clear",
                w: 200,
                onClick: (e) => {
                  e.stopPropagation();
                  onHistoryClear();
                }
              }
            ],
            Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(IconWrapper5, { px: 2, py: 2, children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(Icon_default, { name: "dots", color: theme.colors.white }) })
          }
        )
      ] }) : /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
        IconWrapper5,
        {
          px: 2,
          py: 2,
          onClick: () => {
            if (onClose) {
              onClose();
            }
            onHistoryClear();
          },
          children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(Icon_default, { name: "close", color: theme.colors.white })
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(ContentContainer2, { toggle, w: "100%", flex: 1, alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
      FileUpload_default.Multi,
      {
        isInContainer: true,
        accept: Object.values(import_dash_common24.AllowedMediaFileExtensionsEnum).reduce(
          (memo2, value) => ({ ...memo2, [import_dash_common24.ALLOWED_MEDIA_TYPE_MIMES[value]]: [`.${value}`] }),
          {}
        ),
        validator: fileTypeValidator,
        onAbortManually: cancelUpload,
        onUpload
      }
    ) })
  ] }) : null;
};
var UploadMediaContainer_default = UploadMediaContainer;

// src/components/molecules/FilePreviewModal/FilePreviewModal.tsx
var import_dash_common25 = require("dash-common");
var import_lodash17 = require("lodash");
var import_react76 = require("react");
var import_react_i18next27 = require("react-i18next");
var import_styled_components98 = require("styled-components");

// src/components/molecules/FilePreviewModal/FilePreviewModal.styles.ts
var import_styled_components96 = __toESM(require("styled-components"));
var StyledModal = (0, import_styled_components96.default)(Modal3)`
  ${commonModalStyles}
  &__content {
    background-color: ${({ theme }) => theme.colors.white};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    border-radius: 8px;
    outline: none;
    padding: 24px;
    max-height: 828px;
    max-width: 1368px;
    width: 100%;
    height: 100%;
    margin-left: 36px;
    margin-right: 36px;

    h2 {
      line-height: 36px;
      font-size: 24px;
      margin-bottom: 12px;
    }

    & > div {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    @media ${({ theme }) => theme.devices.mobile} {
      max-height: 500px;

      h2 {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }
`;
var ImageWrapper = (0, import_styled_components96.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n20};
  border-radius: 8px;
  max-height: 670px;
`;
var StyledImage = (0, import_styled_components96.default)(Image_default)`
  height: 100%;
  max-width: 100%;
  width: fit-content;
  border-radius: 0;
`;
var StyledVideo = (0, import_styled_components96.default)(Video_default)`
  height: 100%;
  max-width: 100%;
  border-radius: 0;
`;

// src/components/atoms/PDFViewer/PDFViewer.tsx
var import_react73 = require("react");
var import_react_i18next26 = require("react-i18next");
var import_AnnotationLayer = require("react-pdf/dist/Page/AnnotationLayer.css");
var import_TextLayer = require("react-pdf/dist/Page/TextLayer.css");

// src/components/atoms/PDFViewer/PDFViewer.styles.ts
var import_styled_components97 = __toESM(require("styled-components"));
var StyledWrapper4 = import_styled_components97.default.div`
  height: 100%;
  max-width: 100%;
  width: 100%;
  border-radius: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border: ${({ $hideBorders }) => $hideBorders ? "none" : "2px solid ${({ theme }) => theme.colors.n20}"};
  border-top: ${({ $hideBorders }) => $hideBorders ? "none" : "0px"};

  .sticky-header {
    position: sticky;
    top: 0;
    background-color: ${({ theme }) => theme.colors.n20};
    padding: 5px;
    z-index: 100; /* Ensure the header is above PDF content */
  }
`;

// src/components/atoms/PDFViewer/PDFViewer.tsx
var import_core = require("@react-pdf-viewer/core");
var import_zoom = require("@react-pdf-viewer/zoom");
var import_styles = require("@react-pdf-viewer/core/lib/styles/index.css");
var import_jsx_runtime97 = require("react/jsx-runtime");
var WORKER_URL = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;
function PDFViewer({
  url,
  s3Key,
  name,
  hideTitle = false
}) {
  const { t } = (0, import_react_i18next26.useTranslation)("common");
  const zoomPluginInstance = (0, import_zoom.zoomPlugin)();
  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
  const [fileUrl, setFileUrl] = (0, import_react73.useState)(url);
  const [loading, setLoading] = (0, import_react73.useState)(true);
  const [triedFetching, setTriedFetching] = (0, import_react73.useState)(false);
  const filteredFileName = (0, import_react73.useMemo)(() => {
    const regex = /^[a-f0-9-]+-(?:[a-f0-9-]+.pdf|(.+))$/;
    const match = name.match(regex);
    if (!match)
      return name;
    return match[1] || match[0];
  }, [name]);
  const handleRenderError = () => {
    if (!triedFetching)
      fetchDocument();
    return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("p", { style: { textAlign: "center" }, children: t("components.pdfViewer.loadError") });
  };
  const fetchDocument = async () => {
    setLoading(true);
    setTriedFetching(true);
    await fetch(`${process.env.REACT_APP_REST}/files/aws-file`, {
      method: "POST",
      headers: {
        api_key: process.env.REACT_APP_API_KEY || "",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ s3Key })
    }).then((res) => res.json()).then((jsonResponse) => {
      setFileUrl(jsonResponse.data);
    });
    setLoading(false);
  };
  return !fileUrl ? /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(Spinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(StyledWrapper4, { id: "pdfDocument", $hideBorders: hideTitle, children: [
    /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(
      Flex_default,
      {
        h: hideTitle ? "auto" : "10%",
        style: { maxHeight: "10%" },
        flexDirection: "row",
        justifyContent: hideTitle ? "flex-end" : "space-between",
        alignItems: "center",
        py: hideTitle ? 2 : 0,
        children: [
          !hideTitle && /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(Text_default, { bold: true, lg: true, className: "sticky-header", ellipsis: true, children: filteredFileName }),
          /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(Flex_default, { flexDirection: "row", children: [
            /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(ZoomOutButton, {}),
            /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(ZoomPopover, {}),
            /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(ZoomInButton, {})
          ] })
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)("div", { style: { position: "relative", height: "90%" }, children: [
      loading ? /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
        Flex_default,
        {
          w: "100%",
          h: "100%",
          alignItems: "center",
          justifyContent: "center",
          style: { position: "absolute", top: 0, left: 0, zIndex: 1 },
          children: /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(Spinner_default, {})
        }
      ) : null,
      /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("div", { style: { height: "100%", opacity: loading ? 0 : 1 }, children: /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(import_core.Worker, { workerUrl: WORKER_URL, children: /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
        import_core.Viewer,
        {
          fileUrl,
          renderError: handleRenderError,
          plugins: [zoomPluginInstance],
          renderLoader: (percentages) => /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("div", { style: { width: "240px" }, children: /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(import_core.ProgressBar, { progress: Math.round(percentages) }) }),
          defaultScale: import_core.SpecialZoomLevel.PageFit,
          onDocumentLoad: () => setLoading(false)
        }
      ) }) })
    ] })
  ] });
}
var PDFViewer_default = PDFViewer;

// src/components/molecules/FilePreviewModal/FilePreviewModal.tsx
var import_dash_common26 = require("dash-common");

// src/components/molecules/FilePreviewModal/components/ImagePreview/ImagePreview.tsx
var import_react74 = require("react");
var import_jsx_runtime98 = require("react/jsx-runtime");
function ImagePreview({
  publicUrl,
  thumbnailFileUrl,
  name,
  isMobile = false,
  hideTitle = false
}) {
  const filteredFileName = (0, import_react74.useMemo)(() => {
    const regex = /^[a-f0-9-]+-(?:[a-f0-9-]+.pdf|(.+))$/;
    const match = name.match(regex);
    if (!match)
      return name;
    const restOfFilename = match[1] || match[0];
    return restOfFilename;
  }, [name]);
  const imageUrl = isMobile && thumbnailFileUrl ? thumbnailFileUrl : publicUrl;
  return !imageUrl ? /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(Spinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)(Flex_default, { flexDirection: "column", h: "100%", w: "100%", children: [
    !hideTitle && /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
      Flex_default,
      {
        h: "10%",
        flexDirection: "row",
        justifyContent: "space-between",
        pl: 2,
        pt: 1,
        w: "100%",
        children: /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(Text_default, { bold: true, lg: true, className: "sticky-header", ellipsis: true, children: filteredFileName })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(Flex_default, { h: hideTitle ? "100%" : "90%", w: "100%", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(StyledImage, { src: imageUrl, alt: name, fit: "cover" }) })
  ] });
}
var ImagePreview_default = ImagePreview;

// src/components/molecules/FilePreviewModal/components/VideoPreview/VideoPreview.tsx
var import_react75 = require("react");
var import_jsx_runtime99 = require("react/jsx-runtime");
function VideoPreview({
  publicUrl,
  name,
  hideTitle = false
}) {
  const filteredFileName = (0, import_react75.useMemo)(() => {
    const regex = /^[a-f0-9-]+-(?:[a-f0-9-]+.mp4|(.+))$/;
    const match = name.match(regex);
    if (!match)
      return name;
    const restOfFilename = match[1] || match[0];
    return restOfFilename;
  }, [name]);
  return !publicUrl ? /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Spinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime99.jsxs)(Flex_default, { flexDirection: "column", h: "100%", w: "100%", children: [
    !hideTitle && /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Flex_default, { h: "10%", w: "100%", pl: 2, pt: 1, children: /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Text_default, { bold: true, lg: true, className: "sticky-header", ellipsis: true, children: filteredFileName }) }),
    /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Flex_default, { h: hideTitle ? "100%" : "90%", w: "100%", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(
      StyledVideo,
      {
        withPlayIcon: false,
        controls: true,
        src: publicUrl,
        autoPlay: true,
        controlsList: "nodownload",
        maxHeight: "100%"
      }
    ) })
  ] });
}
var VideoPreview_default = VideoPreview;

// src/components/molecules/FilePreviewModal/FilePreviewModal.tsx
var import_jsx_runtime100 = require("react/jsx-runtime");
var FilePreviewModal = ({
  isOpened,
  onClose,
  files,
  defaultIndex,
  onDownloadButtonClick,
  isDownloadButtonVisible = true,
  isPortfolioView = false,
  isCentered = true,
  isExchange = false,
  maxNavigableIndex,
  onNavigationRestricted
}) => {
  const { t } = (0, import_react_i18next27.useTranslation)("common");
  const [index2, setIndex] = (0, import_react76.useState)(0);
  const theme = (0, import_styled_components98.useTheme)();
  const {
    devices: { isMobile, isTablet }
  } = useScreenResolution();
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    import_dash_common25.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT
  ]);
  const { setUpgradeSubscriptionModal } = (0, import_react76.useContext)(ModalContext);
  (0, import_react76.useEffect)(() => {
    if ((0, import_lodash17.isNumber)(defaultIndex) && defaultIndex >= 0) {
      setIndex(defaultIndex);
    }
  }, [defaultIndex]);
  const file = files[index2];
  const Component2 = (0, import_react76.useCallback)(() => {
    if (import_dash_common25.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER[import_dash_common25.MediaFileTypesFilterEnum.IMAGES].includes(file.type)) {
      return /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
        ImagePreview_default,
        {
          publicUrl: file.publicUrl,
          thumbnailFileUrl: file.thumbnailFileUrl,
          name: file.name,
          isMobile
        }
      );
    }
    if (import_dash_common25.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER[import_dash_common25.MediaFileTypesFilterEnum.VIDEOS].includes(file.type)) {
      return /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(VideoPreview_default, { publicUrl: file.publicUrl, name: file.name });
    }
    if (import_dash_common25.ALLOWED_MEDIA_TYPE_MIMES.pdf === file.type) {
      return /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(PDFViewer_default, { url: file.publicUrl, s3Key: file.s3Key, name: file.name });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(Icon_default, { name: "filePlaceholder", color: theme.colors.n20, size: 200 });
  }, [file]);
  if (!file) {
    return null;
  }
  const modalClose = () => {
    onClose();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
    StyledModal,
    {
      isOpen: isOpened,
      onRequestClose: modalClose,
      title: t("labels.preview") || "",
      viewHierarchy: 2,
      AdditionalHeader: () => /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(Flex_default, { justifyContent: "end", children: `${index2 + 1}/${files.length}` }),
      isCentered,
      isExchange,
      children: /* @__PURE__ */ (0, import_jsx_runtime100.jsxs)(Flex_default, { h: "92%", flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
          ImageWrapper,
          {
            w: "100%",
            h: "90%",
            mb: 3,
            mt: 2,
            justifyContent: "center",
            alignItems: "center",
            children: /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(Component2, {})
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime100.jsxs)(Flex_default, { h: "10%", justifyContent: "space-between", w: "100%", children: [
          /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
            Button_default,
            {
              variation: "outline",
              onClick: modalClose,
              square: isMobile,
              minWidth: isTablet ? 113 : void 0,
              icon: isMobile ? "close" : void 0,
              children: !isMobile && t("labels.close")
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime100.jsxs)(Flex_default, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
              Button_default,
              {
                mr: 4,
                px: [0, 20, 20, 20],
                variation: "outline",
                disabled: !index2 || !files[index2 - 1],
                square: isMobile,
                icon: isMobile ? "chevronLeft" : void 0,
                onClick: () => setIndex(index2 - 1),
                children: !isMobile && t("labels.previous")
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
              Button_default,
              {
                variation: "primary",
                px: [0, 20, 20, 20],
                disabled: index2 === files.length - 1,
                onClick: () => {
                  if (maxNavigableIndex !== void 0 && index2 >= maxNavigableIndex) {
                    onNavigationRestricted?.();
                  } else {
                    setIndex(index2 + 1);
                  }
                },
                square: isMobile,
                icon: isMobile ? "chevronRight" : void 0,
                children: !isMobile && t("labels.next")
              }
            )
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(Flex_default, { w: isMobile || isTablet ? 0 : 200, justifyContent: "flex-end", children: isDownloadButtonVisible && /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
            Button_default,
            {
              square: true,
              variation: "primary",
              icon: "download",
              onClick: () => {
                setUpgradeSubscriptionModal({
                  type: "DOWNLOAD" /* DOWNLOAD */
                });
                const isActive = checkFeatureAccess({
                  disableModal: isPortfolioView
                });
                if ((0, import_dash_common26.nor)(isActive, isPortfolioView))
                  return;
                if (onDownloadButtonClick) {
                  onDownloadButtonClick(file._id);
                } else {
                  downloadMedia([file._id]);
                }
              }
            }
          ) })
        ] })
      ] })
    }
  );
};
var FilePreviewModal_default = FilePreviewModal;

// src/components/molecules/FilePreviewModal/FullPageFilePreview.tsx
var import_dash_common28 = require("dash-common");
var import_lodash18 = require("lodash");
var import_react77 = require("react");
var import_react_i18next29 = require("react-i18next");
var import_styled_components101 = require("styled-components");
var import_dash_common29 = require("dash-common");

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventorySummaryItem.tsx
var import_react_i18next28 = require("react-i18next");
var import_styled_components99 = __toESM(require("styled-components"));
var import_dash_common27 = require("dash-common");
var import_jsx_runtime101 = require("react/jsx-runtime");
var PriceText = (0, import_styled_components99.default)(Text_default)`
  font-size: ${({ $fontSize }) => $fontSize || 14}px;
`;
var CustomRoomsText = (0, import_styled_components99.default)(Text_default)`
  font-size: ${({ $fontSize }) => $fontSize || 14}px;
  line-height: 1;
`;
var InfoRow = (0, import_styled_components99.default)(Flex_default)`
  column-gap: ${({ theme }) => theme.space * 5}px;
  row-gap: ${({ theme }) => theme.space * 2}px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;
var InventoryPrice = ({ startingPrice, highestPrice, fontSize }) => {
  const theme = (0, import_styled_components99.useTheme)();
  const { t: tLabels } = (0, import_react_i18next28.useTranslation)("common", { keyPrefix: "labels" });
  if (!startingPrice && !highestPrice)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
    TooltipWrapper_default,
    {
      content: (0, import_dash_common27.formatPriceRange)(startingPrice, highestPrice, {
        shortMax: false,
        shortMin: false,
        prefix: tLabels("from") || ""
      }),
      children: /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { gap: 4, children: [
        /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(PriceText, { $fontSize: fontSize, color: theme.colors.gr5, children: [
          tLabels("from"),
          ":"
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(PriceText, { $fontSize: fontSize, semibold: true, color: theme.colors.gr1, children: (0, import_dash_common27.formatPriceRange)(
          startingPrice,
          highestPrice,
          {
            shortMin: true,
            shortMax: true
          },
          {
            maximumFractionDigits: 2
          }
        ) })
      ] })
    }
  );
};
var InventoryCustomRooms = ({ customRooms, fontSize }) => {
  const theme = (0, import_styled_components99.useTheme)();
  const { t } = (0, import_react_i18next28.useTranslation)();
  if (!customRooms)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(TooltipWrapper_default, { content: customRooms, children: /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { gap: 4, children: [
    /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Flex_default, { style: { flexShrink: 0 }, children: /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(CustomRoomsText, { $fontSize: fontSize, color: theme.colors.gr5, children: [
      t("tables:inventory.customRoomsShortened"),
      ":"
    ] }) }),
    /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(CustomRoomsText, { $fontSize: fontSize, semibold: true, color: theme.colors.gr1, children: customRooms })
  ] }) });
};
var InventoryBeds = ({ averageBedroomsNumber }) => {
  const theme = (0, import_styled_components99.useTheme)();
  const { t } = (0, import_react_i18next28.useTranslation)();
  const hasBeds = !!(averageBedroomsNumber?.min || averageBedroomsNumber?.max);
  if (!hasBeds)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Flex_default, { style: { display: "inline-flex", whiteSpace: "nowrap" }, children: /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
    TooltipWrapper_default,
    {
      content: formatBedroomsRangeValues(averageBedroomsNumber, {
        isNullable: (averageBedroomsNumber?.min || 0) === 0 && !averageBedroomsNumber?.max,
        t
      }),
      children: /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { alignItems: "center", gap: theme.space / 2, children: [
        /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Icon_default, { name: "bedroom", size: 20, color: theme.colors.gr2 }),
        /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Text_default, { color: theme.colors.gr1, children: averageBedroomsNumber?.min || averageBedroomsNumber?.max || "-" })
      ] })
    }
  ) });
};
var InventoryBaths = ({ averageBathroomsNumber }) => {
  const theme = (0, import_styled_components99.useTheme)();
  const { t } = (0, import_react_i18next28.useTranslation)();
  const hasBaths = !!(averageBathroomsNumber?.min || averageBathroomsNumber?.max);
  if (!hasBaths)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Flex_default, { style: { display: "inline-flex", whiteSpace: "nowrap" }, children: /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
    TooltipWrapper_default,
    {
      content: formatBathroomsRangeValues(averageBathroomsNumber, {
        t
      }),
      children: /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { alignItems: "center", gap: theme.space / 2, children: [
        /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Icon_default, { name: "bathroom", size: 20, color: theme.colors.gr2 }),
        /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Text_default, { color: theme.colors.gr1, children: averageBathroomsNumber?.min || averageBathroomsNumber?.max || "-" })
      ] })
    }
  ) });
};
var InventorySqft = ({
  averageTotalSqft,
  averageInteriorSqft,
  averageExteriorSqft
}) => {
  const theme = (0, import_styled_components99.useTheme)();
  const { t } = (0, import_react_i18next28.useTranslation)();
  const hasTotal = !!(averageTotalSqft?.min || averageTotalSqft?.max);
  if (!hasTotal)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Flex_default, { style: { display: "inline-flex", whiteSpace: "nowrap" }, children: /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
    TooltipWrapper_default,
    {
      content: /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Box_default, { minWidth: "fit-content", w: "100%", px: 2, children: /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { minWidth: "fit-content", flexDirection: "column", w: "100%", children: [
        /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { minWidth: "fit-content", justifyContent: "space-between", w: "100%", children: [
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: t("tables:inventory.interiorSqft") }),
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Box_default, { mx: 1 }),
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: formatGeneralRangeValues(averageInteriorSqft) })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { color: theme.colors.white, justifyContent: "space-between", w: "100%", children: [
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: t("tables:inventory.exteriorSqft") }),
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Box_default, { mx: 1 }),
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: formatGeneralRangeValues(averageExteriorSqft) })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { justifyContent: "space-between", w: "100%", children: [
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: t("tables:inventory.totalSqft") }),
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Box_default, { mx: 1 }),
          /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: formatGeneralRangeValues(averageTotalSqft) })
        ] })
      ] }) }),
      children: /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Flex_default, { alignItems: "center", gap: theme.space / 2, children: [
        /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Icon_default, { name: "floorPlan", size: 20, color: theme.colors.gr2 }),
        /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(Text_default, { color: theme.colors.gr1, children: [
          formatGeneralRangeValues(averageTotalSqft, { t }),
          " ",
          t("common:labels.sqft")
        ] })
      ] })
    }
  ) });
};
var InventorySummaryRow = ({
  startingPrice,
  highestPrice,
  customRooms,
  averageBedroomsNumber,
  averageBathroomsNumber,
  averageTotalSqft,
  averageInteriorSqft,
  averageExteriorSqft
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(InfoRow, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(InventoryPrice, { startingPrice, highestPrice }),
    /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(InventoryCustomRooms, { customRooms }),
    /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(InventoryBeds, { averageBedroomsNumber }),
    /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(InventoryBaths, { averageBathroomsNumber }),
    /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
      InventorySqft,
      {
        averageTotalSqft,
        averageInteriorSqft,
        averageExteriorSqft
      }
    )
  ] });
};

// src/components/molecules/FilePreviewModal/FullPageFilePreview.styles.ts
var import_styled_components100 = __toESM(require("styled-components"));
var Overlay = import_styled_components100.default.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme, $transparent, $iframeMode }) => $iframeMode ? "rgba(20, 20, 20, 0.95)" : $transparent ? "transparent" : theme.colors.white};
  z-index: 101;
  display: ${({ $isOpen }) => $isOpen ? "flex" : "none"};
  flex-direction: column;
  ${({ $iframeMode }) => $iframeMode && "align-items: center;"}
  opacity: ${({ $isOpen }) => $isOpen ? 1 : 0};
  transition: opacity 0.2s ease;
`;
var IdxWrapper = import_styled_components100.default.div`
  width: 100%;
  height: ${({ $iframeMode, $viewportHeight }) => $iframeMode && $viewportHeight ? `${$viewportHeight}px` : "900px"};
  ${({ $iframeMode, $viewportTop }) => $iframeMode && $viewportTop !== void 0 && `margin-top: ${$viewportTop}px;`}
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};

  /* Mobile: use smaller height */
  @media (max-width: 768px) {
    height: ${({ $iframeMode, $viewportHeight }) => $iframeMode && $viewportHeight ? `${$viewportHeight}px` : "650px"};
  }
`;
var IdxTransparentOverlay = import_styled_components100.default.div`
  position: absolute;
  top: 900px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(20, 20, 20, 0.95);
  pointer-events: none;

  /* Mobile: start from 650px */
  @media (max-width: 768px) {
    top: 650px;
  }
`;
var TopBar = import_styled_components100.default.div`
  flex-shrink: 0;
  padding: 16px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 64px;
`;
var TopBarLeft = (0, import_styled_components100.default)(Flex_default)`
  flex: 1;
  align-items: flex-start;
  gap: 12px;
`;
var TopBarRight = (0, import_styled_components100.default)(Flex_default)`
  align-items: flex-start;
`;
var FileName = import_styled_components100.default.div`
  font-size: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gr1};
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-word;

  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}px) {
    line-height: 1.25;
    font-size: 16px;
  }
`;
var InventorySummaryBar = import_styled_components100.default.div`
  flex-shrink: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.n20};
  padding: 12px 24px;
  padding-top: 0px;
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.colors.white};
`;
var SummaryItem = (0, import_styled_components100.default)(Flex_default)`
  align-items: center;
  gap: 8px;
`;
var BackButton = import_styled_components100.default.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.n10};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}px) {
    padding: 0px 8px;
  }
`;
var CloseButton2 = import_styled_components100.default.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}px) {
    padding: 0px 8px;
  }
`;
var ContentArea = import_styled_components100.default.div`
  flex: 1;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.gr7};
`;
var BottomControlBar = import_styled_components100.default.div`
  flex-shrink: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.n20};
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 72px;

  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}px) {
    padding: 12px 12px;
    min-height: 56px;
    gap: 8px;
  }
`;
var PageCounter = import_styled_components100.default.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.n70};
`;
var NavigationButtons = (0, import_styled_components100.default)(Flex_default)`
  gap: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}px) {
    gap: 8px;
  }
`;

// src/components/molecules/FilePreviewModal/FullPageFilePreview.tsx
var import_jsx_runtime102 = require("react/jsx-runtime");
var FullPageFilePreview = ({
  isOpen,
  onClose,
  files,
  defaultIndex,
  onDownloadButtonClick,
  isDownloadButtonVisible = true,
  isPortfolioView = false,
  maxNavigableIndex,
  onNavigationRestricted,
  inventorySummaries,
  isIdxView = false
}) => {
  const { t } = (0, import_react_i18next29.useTranslation)("common");
  const [currentIndex, setCurrentIndex] = (0, import_react77.useState)(0);
  const theme = (0, import_styled_components101.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    import_dash_common28.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT
  ]);
  const { setUpgradeSubscriptionModal } = (0, import_react77.useContext)(ModalContext);
  (0, import_react77.useEffect)(() => {
    if (isOpen && (0, import_lodash18.isNumber)(defaultIndex) && defaultIndex >= 0) {
      setCurrentIndex(defaultIndex);
    }
  }, [isOpen, defaultIndex]);
  const currentFile = files[currentIndex];
  const filteredFileName = currentFile?.name ? currentFile.name.replace(/^[a-f0-9-]+-(?:[a-f0-9-]+.pdf|(.+))$/, "$1") : "";
  const PreviewComponent = (0, import_react77.useCallback)(() => {
    if (!currentFile)
      return null;
    if (import_dash_common28.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER[import_dash_common28.MediaFileTypesFilterEnum.IMAGES].includes(currentFile.type)) {
      return /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
        ImagePreview_default,
        {
          publicUrl: currentFile.publicUrl,
          thumbnailFileUrl: currentFile.thumbnailFileUrl,
          name: currentFile.name,
          isMobile,
          hideTitle: true
        }
      );
    }
    if (import_dash_common28.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER[import_dash_common28.MediaFileTypesFilterEnum.VIDEOS].includes(currentFile.type)) {
      return /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(VideoPreview_default, { publicUrl: currentFile.publicUrl, name: currentFile.name, hideTitle: true });
    }
    if (import_dash_common28.ALLOWED_MEDIA_TYPE_MIMES.pdf === currentFile.type) {
      return /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
        PDFViewer_default,
        {
          url: currentFile.publicUrl,
          s3Key: currentFile.s3Key,
          name: currentFile.name,
          hideTitle: true
        }
      );
    }
    return /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Icon_default, { name: "filePlaceholder", color: theme.colors.n20, size: 200 });
  }, [currentFile, isMobile, theme]);
  const handlePrevious = (0, import_react77.useCallback)(() => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  }, [currentIndex]);
  const handleNext = (0, import_react77.useCallback)(() => {
    if (maxNavigableIndex !== void 0 && currentIndex >= maxNavigableIndex) {
      onNavigationRestricted?.();
      return;
    }
    if (currentIndex < files.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  }, [currentIndex, files.length, maxNavigableIndex, onNavigationRestricted]);
  const handleDownload = (0, import_react77.useCallback)(() => {
    if (!currentFile)
      return;
    setUpgradeSubscriptionModal({
      type: "DOWNLOAD" /* DOWNLOAD */
    });
    const isActive = checkFeatureAccess({
      disableModal: isPortfolioView
    });
    if ((0, import_dash_common29.nor)(isActive, isPortfolioView))
      return;
    if (onDownloadButtonClick) {
      onDownloadButtonClick(currentFile._id);
    } else {
      downloadMedia([currentFile._id]);
    }
  }, [
    currentFile,
    checkFeatureAccess,
    isPortfolioView,
    onDownloadButtonClick,
    setUpgradeSubscriptionModal
  ]);
  const handleKeyDown = (0, import_react77.useCallback)(
    (e) => {
      if (e.key === "Escape") {
        onClose();
      } else if (e.key === "ArrowLeft") {
        handlePrevious();
      } else if (e.key === "ArrowRight") {
        handleNext();
      }
    },
    [onClose, handlePrevious, handleNext]
  );
  (0, import_react77.useEffect)(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
    return void 0;
  }, [isOpen, handleKeyDown]);
  if (!currentFile || !isOpen) {
    return null;
  }
  const hasPrevious = currentIndex > 0;
  const hasNext = currentIndex < files.length - 1;
  const isNextRestricted = maxNavigableIndex !== void 0 && currentIndex >= maxNavigableIndex;
  const currentSummary = inventorySummaries?.[currentIndex];
  const iframeViewport = isIdxView ? getIdxIframeViewport() : null;
  const hasIframeViewport = iframeViewport !== null;
  const content = /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(import_jsx_runtime102.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(TopBar, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(TopBarLeft, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(BackButton, { onClick: onClose, "aria-label": t("labels.goBack") || "", children: /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Icon_default, { name: "arrowLeft", size: 24, color: theme.colors.gr1 }) }),
        /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(FileName, { title: filteredFileName, children: filteredFileName })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(TopBarRight, { children: /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(CloseButton2, { onClick: onClose, "aria-label": t("labels.close") || "", children: /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Icon_default, { name: "close", size: 24, color: theme.colors.gr4 }) }) })
    ] }),
    currentSummary && /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(InventorySummaryBar, { children: /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
      InventorySummaryRow,
      {
        startingPrice: currentSummary.startingPrice,
        highestPrice: currentSummary.highestPrice,
        customRooms: currentSummary.customRooms,
        averageBedroomsNumber: currentSummary.averageBedroomsNumber,
        averageBathroomsNumber: currentSummary.averageBathroomsNumber,
        averageTotalSqft: currentSummary.averageTotalSqft,
        averageInteriorSqft: currentSummary.averageInteriorSqft,
        averageExteriorSqft: currentSummary.averageExteriorSqft
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(ContentArea, { children: /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(PreviewComponent, {}) }),
    /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(BottomControlBar, { children: [
      isDownloadButtonVisible && /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Button_default, { icon: "download", onClick: handleDownload, square: isMobile, children: !isMobile && t("labels.download") }),
      /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(NavigationButtons, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
          Button_default,
          {
            variation: "outline",
            disabled: !hasPrevious,
            onClick: handlePrevious,
            square: isMobile,
            icon: isMobile ? "chevronLeft" : void 0,
            px: isMobile ? 8 : 14,
            children: !isMobile && t("labels.previous")
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
          Button_default,
          {
            variation: "primary",
            disabled: !hasNext || isNextRestricted,
            onClick: handleNext,
            square: isMobile,
            icon: isMobile ? "chevronRight" : void 0,
            px: isMobile ? 8 : 14,
            children: !isMobile && t("labels.next")
          }
        )
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(PageCounter, { children: `${currentIndex + 1} / ${files.length}` })
    ] })
  ] });
  return /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(
    Overlay,
    {
      $isOpen: isOpen,
      $transparent: isIdxView,
      $iframeMode: hasIframeViewport,
      onClick: (e) => {
        if (e.target === e.currentTarget)
          onClose();
      },
      children: [
        isIdxView ? /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
          IdxWrapper,
          {
            $iframeMode: hasIframeViewport,
            $viewportTop: iframeViewport?.top,
            $viewportHeight: iframeViewport?.height,
            children: content
          }
        ) : content,
        isIdxView && !hasIframeViewport && /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(IdxTransparentOverlay, {})
      ]
    }
  );
};
var FullPageFilePreview_default = FullPageFilePreview;

// src/components/molecules/NotFoundPage/NotFoundPage.tsx
var import_styled_components103 = require("styled-components");
var import_react_i18next30 = require("react-i18next");

// src/components/molecules/NotFoundPage/NotFoundPage.styles.ts
var import_styled_components102 = __toESM(require("styled-components"));
var PageWrapper = (0, import_styled_components102.default)(Flex_default)`
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
var VerticalDevider = (0, import_styled_components102.default)(Box_default)`
  background: ${({ theme }) => theme.colors.n90};
  border-radius: ${({ theme }) => theme.space * 2}px;
`;
var StyledHeading = (0, import_styled_components102.default)(H_default)`
  display: flex;
  align-items: center;
`;

// src/components/molecules/NotFoundPage/NotFoundPage.tsx
var import_jsx_runtime103 = require("react/jsx-runtime");
var NotFoundPage = ({
  onRedirect,
  showGoBack = false
}) => {
  const theme = (0, import_styled_components103.useTheme)();
  const { t } = (0, import_react_i18next30.useTranslation)("pages");
  const handleGoBack = () => {
    window.history.back();
  };
  const buttonText = showGoBack ? t("propertyPage.goBack") : t("notFoundPage.buttonLabel");
  const buttonAction = showGoBack ? handleGoBack : onRedirect;
  return /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(PageWrapper, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(Flex_default, { w: 443, flexDirection: "column", justifyContent: "center", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(StyledHeading, { lg: true, bold: true, color: theme.colors.n90, children: [
      "404",
      /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(VerticalDevider, { h: 38, w: 4, mx: 8 }),
      t("notFoundPage.title")
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Box_default, { mb: 4, mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Text_default, { color: theme.colors.n80, children: t("notFoundPage.subtitle") }) }),
    (showGoBack || onRedirect) && /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Button_default, { h: 40, minWidth: 153, onClick: buttonAction, children: buttonText })
  ] }) });
};
var NotFoundPage_default = NotFoundPage;

// src/components/molecules/Toast/Toast.tsx
var import_react_toastify = require("react-toastify");
var import_styled_components104 = __toESM(require("styled-components"));
var import_jsx_runtime104 = require("react/jsx-runtime");
var StyledContainer = (0, import_styled_components104.default)(import_react_toastify.ToastContainer)`
  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
    top: ${({ theme, shiftTop }) => shiftTop ? shiftTop + theme.space * 3 : theme.space * 3}px;
    right: ${({ theme, shiftRight }) => shiftRight ? shiftRight + theme.space * 3 : theme.space * 3}px;
    padding: unset;
  }
  .Toastify__toast {
    min-height: 40px;
    box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: ${({ theme }) => theme.space * 2}px;
  }
  .Toastify__toast-icon {
    margin-right: ${({ theme }) => theme.space * 2};
  }
  .Toastify__toast-body {
    padding: unset;
    width: unset;
    ${textStyle}
  }
  .Toastify__progress-bar {
    visibility: hidden;
  }
  .close-button {
    margin-right: ${({ theme }) => theme.space}px;
    color: ${({ theme }) => theme.colors.n200};
  }
  .Toastify__toast--info {
    .Toastify__toast-body {
      color: ${({ theme }) => theme.colors.b50};
    }
  }
  .Toastify__toast--success {
    .Toastify__toast-body {
      color: ${({ theme }) => theme.colors.g20};
    }
  }
  .Toastify__toast--error {
    .Toastify__toast-body {
      color: ${({ theme }) => theme.colors.r20};
    }
  }
`;
var toast = {
  info: (message, options) => {
    import_react_toastify.toast.info(message, {
      // @ts-ignore
      icon: () => /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(Icon_default, { name: "infoCircle" }),
      ...options
    });
  },
  success: (message, options) => {
    import_react_toastify.toast.success(message, {
      // @ts-ignore
      icon: () => /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(Icon_default, { name: "checkCircle" }),
      ...options
    });
  },
  error: (message, options) => {
    import_react_toastify.toast.error(message, {
      // @ts-ignore
      icon: () => /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(Icon_default, { name: "cancelCircle" }),
      ...options
    });
  }
};
function Toast({
  shiftTop,
  shiftRight,
  semibold = true,
  autoClose = 3e3,
  ...args
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(
    StyledContainer,
    {
      shiftTop,
      shiftRight,
      semibold,
      autoClose,
      ...args,
      closeButton: ({ closeToast }) => /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(Flex_default, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(Icon_default, { name: "close", className: "close-button", onClick: () => closeToast() }) })
    }
  );
}
var Toast_default = Toast;

// src/components/molecules/GoogleMap/GoogleMap.tsx
var import_react80 = __toESM(require("react"));
var import_api2 = require("@react-google-maps/api");
var import_dash_common30 = require("dash-common");

// ../../node_modules/react-icons/lib/iconBase.mjs
var import_react79 = __toESM(require("react"), 1);

// ../../node_modules/react-icons/lib/iconContext.mjs
var import_react78 = __toESM(require("react"), 1);
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = import_react78.default.createContext && /* @__PURE__ */ import_react78.default.createContext(DefaultContext);

// ../../node_modules/react-icons/lib/iconBase.mjs
var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0)
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function Tree2Element(tree) {
  return tree && tree.map((node, i) => /* @__PURE__ */ import_react79.default.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  return (props) => /* @__PURE__ */ import_react79.default.createElement(IconBase, _extends({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = (conf) => {
    var {
      attr,
      size,
      title
    } = props, svgProps = _objectWithoutProperties(props, _excluded);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return /* @__PURE__ */ import_react79.default.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /* @__PURE__ */ import_react79.default.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? /* @__PURE__ */ import_react79.default.createElement(IconContext.Consumer, null, (conf) => elem(conf)) : elem(DefaultContext);
}

// ../../node_modules/react-icons/fi/index.mjs
function FiMaximize2(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "polyline", "attr": { "points": "15 3 21 3 21 9" }, "child": [] }, { "tag": "polyline", "attr": { "points": "9 21 3 21 3 15" }, "child": [] }, { "tag": "line", "attr": { "x1": "21", "y1": "3", "x2": "14", "y2": "10" }, "child": [] }, { "tag": "line", "attr": { "x1": "3", "y1": "21", "x2": "10", "y2": "14" }, "child": [] }] })(props);
}

// src/components/molecules/GoogleMap/GoogleMap.tsx
var import_react_i18next31 = require("react-i18next");

// src/components/molecules/GoogleMap/GoogleMap.constants.tsx
var DEFAULT_GOOGLE_MAP_OPTIONS = {
  styles: [
    { featureType: "all", stylers: [{ visibility: "off" }] },
    { featureType: "road", stylers: [{ visibility: "on" }] },
    { featureType: "administrative", stylers: [{ visibility: "on" }] },
    { featureType: "landscape", stylers: [{ visibility: "on" }] },
    { featureType: "water", stylers: [{ visibility: "on" }] }
  ],
  zoomControl: true,
  fullscreenControl: false,
  streetViewControl: false,
  draggableCursor: "pointer",
  mapTypeControl: true,
  mapTypeControlOptions: { mapTypeIds: ["roadmap", "satellite"] }
};

// src/components/molecules/GoogleMap/GoogleMap.styles.ts
var import_styled_components105 = __toESM(require("styled-components"));
var MapContainer = import_styled_components105.default.div`
  width: ${({ $width }) => typeof $width === "number" ? `${$width}px` : $width};
  height: ${({ $height }) => typeof $height === "number" ? `${$height}px` : $height};
  position: relative;
`;
var FullscreenContainer = import_styled_components105.default.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: white;
`;
var BaseButton = import_styled_components105.default.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: rgba(30, 30, 30, 0.85);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.3);
  cursor: pointer;
`;
var CloseButton3 = (0, import_styled_components105.default)(BaseButton)`
  z-index: 10;
`;
var ExpandButton = (0, import_styled_components105.default)(BaseButton)`
  z-index: 2;
`;
var Overlay2 = import_styled_components105.default.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  z-index: 1;

  &:focus {
    outline: 2px solid rgba(30, 30, 30, 0.5);
    outline-offset: -2px;
  }
`;

// src/components/molecules/GoogleMap/GoogleMap.tsx
var import_jsx_runtime105 = require("react/jsx-runtime");
var MAP_RESIZE_DELAY_MS = 200;
var MAP_CONTAINER_STYLE = { width: "100%", height: "100%" };
var GoogleMapComponent = import_react80.default.forwardRef(
  ({
    // see all possible props https://react-google-maps-api-docs.netlify.app/#googlemap
    children,
    h = "inherit",
    w = "inherit",
    center = import_dash_common30.DEFAULT_GOOGLE_MAP_CENTER,
    zoom = 12,
    options,
    // <- see more https://developers.google.com/maps/documentation/javascript/reference?csw=1#MapOptions
    onLoad: onLoadProp,
    disableScroll = false,
    isIdxView = false,
    ...googleMapProps
  }, forwardRef4) => {
    const { t } = (0, import_react_i18next31.useTranslation)("common");
    const [isFullscreen, setIsFullscreen] = (0, import_react80.useState)(false);
    const [mapInstance, setMapInstance] = (0, import_react80.useState)(null);
    const isMountedRef = (0, import_react80.useRef)(true);
    const {
      devices: { isMobile }
    } = useScreenResolution();
    (0, import_react80.useEffect)(() => {
      isMountedRef.current = true;
      return () => {
        isMountedRef.current = false;
      };
    }, []);
    (0, import_react80.useEffect)(() => {
      if (isFullscreen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return () => {
        document.body.style.overflow = "";
      };
    }, [isFullscreen]);
    (0, import_react80.useEffect)(() => {
      if (!mapInstance || !center)
        return;
      const timeoutId = setTimeout(() => {
        google.maps.event.trigger(mapInstance, "resize");
        mapInstance.panTo(center);
        if (zoom) {
          mapInstance.setZoom(zoom);
        }
      }, MAP_RESIZE_DELAY_MS);
      return () => clearTimeout(timeoutId);
    }, [isFullscreen, mapInstance, center?.lat, center?.lng, zoom]);
    const handleOverlayClick = (0, import_react80.useCallback)(() => {
      if (isMountedRef.current) {
        setIsFullscreen(true);
      }
    }, []);
    const handleCloseFullscreen = (0, import_react80.useCallback)(() => {
      if (isMountedRef.current) {
        setIsFullscreen(false);
      }
    }, []);
    const handleKeyDown = (0, import_react80.useCallback)((event, action) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        action();
      }
    }, []);
    const onLoad = (0, import_react80.useCallback)(
      (map2) => {
        if (isMountedRef.current) {
          setMapInstance(map2);
        }
        if (onLoadProp) {
          onLoadProp(map2);
        }
      },
      [onLoadProp]
    );
    const gestureHandlingValue = (0, import_react80.useMemo)(() => {
      if (isMobile && !isIdxView && !isFullscreen)
        return "none";
      if (isIdxView || disableScroll)
        return "cooperative";
      return "greedy";
    }, [isMobile, isIdxView, isFullscreen, disableScroll]);
    const shouldShowOverlay = (0, import_react80.useMemo)(
      () => isMobile && !isIdxView && !isFullscreen,
      [isMobile, isIdxView, isFullscreen]
    );
    const mapOptions = (0, import_react80.useMemo)(
      () => ({
        ...DEFAULT_GOOGLE_MAP_OPTIONS,
        ...options,
        gestureHandling: gestureHandlingValue,
        // Disable UI only for original mobile behavior (NOT IDX view)
        disableDefaultUI: isMobile && !isIdxView && !isFullscreen,
        fullscreenControl: false,
        zoomControl: isMobile && !isIdxView && !isFullscreen ? false : options?.zoomControl ?? DEFAULT_GOOGLE_MAP_OPTIONS.zoomControl,
        mapTypeControl: isMobile && !isIdxView && !isFullscreen ? false : options?.mapTypeControl ?? DEFAULT_GOOGLE_MAP_OPTIONS.mapTypeControl,
        streetViewControl: false
      }),
      [options, gestureHandlingValue, isMobile, isIdxView, isFullscreen]
    );
    const mapContent = /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(
      import_api2.GoogleMap,
      {
        ref: forwardRef4,
        ...googleMapProps,
        onLoad,
        mapContainerStyle: MAP_CONTAINER_STYLE,
        center,
        zoom,
        options: mapOptions,
        children
      }
    );
    const shouldShowFullscreen = (0, import_react80.useMemo)(
      () => isFullscreen && !isIdxView && isMobile,
      [isFullscreen, isIdxView, isMobile]
    );
    if (shouldShowFullscreen) {
      return /* @__PURE__ */ (0, import_jsx_runtime105.jsxs)(FullscreenContainer, { children: [
        mapContent,
        /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(
          CloseButton3,
          {
            onClick: handleCloseFullscreen,
            onKeyDown: (e) => handleKeyDown(e, handleCloseFullscreen),
            "aria-label": t("components.map.close") || "",
            children: "\u2715"
          }
        )
      ] });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime105.jsxs)(MapContainer, { $width: w, $height: h, children: [
      mapContent,
      shouldShowOverlay && /* @__PURE__ */ (0, import_jsx_runtime105.jsxs)(import_jsx_runtime105.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(
          Overlay2,
          {
            onClick: handleOverlayClick,
            onKeyDown: (e) => handleKeyDown(e, handleOverlayClick),
            tabIndex: 0,
            role: "button",
            "aria-label": t("components.map.expandFullscreen") || ""
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(
          ExpandButton,
          {
            onClick: handleOverlayClick,
            onKeyDown: (e) => handleKeyDown(e, handleOverlayClick),
            "aria-label": t("components.map.expand") || "",
            children: /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(FiMaximize2, {})
          }
        )
      ] })
    ] });
  }
);
var GoogleMap_default = (0, import_react80.memo)(GoogleMapComponent);

// src/components/molecules/GoogleMap/components/Marker/Marker.tsx
var import_api3 = require("@react-google-maps/api");
var Marker_default = import_api3.MarkerF;

// src/components/molecules/GoogleMap/components/PropertyMarker/PropertyMarker.tsx
var import_api4 = require("@react-google-maps/api");
var import_styled_components107 = require("styled-components");

// src/components/molecules/GoogleMap/components/PropertyMarker/PropertyMarker.styles.ts
var import_styled_components106 = __toESM(require("styled-components"));
var MarkerBackground = (0, import_styled_components106.default)(Box_default)`
  transform: rotate(-45deg);
  border-radius: 100% 100% 100% 0;
  background-color: ${({ theme }) => theme.colors.white};

  :hover {
    background-color: ${({ color: color2 }) => color2};

    & > div {
      background-color: ${({ theme }) => theme.colors.white};

      svg {
        color: ${({ color: color2 }) => color2};
      }
    }
  }
`;
var MarkerInnerBackground = (0, import_styled_components106.default)(Flex_default)`
  transform: rotate(45deg);
  border-radius: 100%;
  background-color: ${({ color: color2 }) => color2};
`;

// src/components/molecules/GoogleMap/components/PropertyMarker/PropertyMarker.constants.ts
var import_dash_common31 = require("dash-common");
var MARKER_ICONS_MAP = {
  [import_dash_common31.BuildingTypesEnum.CONDO]: {
    name: "condominium",
    color: mainTheme.colors.n80
  },
  [import_dash_common31.BuildingTypesEnum.CONDO_HOTEL]: {
    name: "condoHotels",
    color: mainTheme.colors.n90
  },
  [import_dash_common31.BuildingTypesEnum.PENTHOUSE]: {
    name: "penthouse",
    color: mainTheme.colors.y20
  },
  [import_dash_common31.BuildingTypesEnum.TOWNHOME]: {
    name: "townhouses",
    color: mainTheme.colors.b40
  },
  [import_dash_common31.BuildingTypesEnum.SINGLE_FAMILY_HOME]: {
    name: "singleFamily",
    color: mainTheme.colors.g20
  }
};
var DEFAULT_MARKER_ICON = {
  name: "house",
  color: mainTheme.colors.n30,
  iconColor: mainTheme.colors.n90,
  hoverColor: mainTheme.colors.n80
};

// src/components/molecules/GoogleMap/components/PropertyMarker/PropertyMarker.tsx
var import_jsx_runtime106 = require("react/jsx-runtime");
var PropertyMarker = ({
  buildingTypes,
  children,
  onClick,
  onMouseOnMarker,
  onMouseOutMarker,
  mapPaneName = "overlayMouseTarget",
  getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -((height + 55) / 2)
  }),
  ...props
}) => {
  const iconProps = buildingTypes?.length && MARKER_ICONS_MAP[buildingTypes[0]] ? MARKER_ICONS_MAP[buildingTypes[0]] : DEFAULT_MARKER_ICON;
  const theme = (0, import_styled_components107.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(
    import_api4.OverlayViewF,
    {
      mapPaneName,
      getPixelPositionOffset,
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime106.jsxs)(
        MarkerBackground,
        {
          w: 40,
          h: 40,
          p: 1,
          color: iconProps.hoverColor || iconProps.color,
          onMouseOver: onMouseOnMarker,
          onMouseOut: onMouseOutMarker,
          onClick,
          children: [
            children,
            /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(
              MarkerInnerBackground,
              {
                w: "100%",
                h: "100%",
                justifyContent: "center",
                alignItems: "center",
                color: iconProps.color,
                children: /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(Icon_default, { name: iconProps.name, color: iconProps.iconColor || theme.colors.white })
              }
            )
          ]
        }
      )
    }
  );
};
var PropertyMarker_default = PropertyMarker;

// src/components/molecules/CardPaymentForm/CardPaymentForm.tsx
var import_react83 = require("react");
var import_react_i18next34 = require("react-i18next");
var import_styled_components109 = __toESM(require("styled-components"));
var import_react_stripe_js4 = require("@stripe/react-stripe-js");

// src/components/molecules/CardPaymentForm/constants/constants.ts
var FormFieldsList = [
  "fullName" /* FullName */,
  "county" /* County */,
  "state" /* State */,
  "city" /* City */,
  "street" /* Street */,
  "zipCode" /* ZipCode */
];

// src/components/molecules/CardPaymentForm/components/AddressSection/AddressSection.tsx
var import_react82 = require("react");
var import_react_i18next33 = require("react-i18next");
var import_styled_components108 = __toESM(require("styled-components"));
var import_dash_common33 = require("dash-common");

// src/components/molecules/CardPaymentForm/hooks/useValidation.ts
var import_react81 = require("react");
var import_react_i18next32 = require("react-i18next");
var import_dash_common32 = require("dash-common");
var useValidation = () => {
  const { errorHandlers } = (0, import_react81.useContext)(FormContext);
  const { t } = (0, import_react_i18next32.useTranslation)(["forms", "common", "pages"]);
  const validateFieldByName = (fieldName, value) => {
    const setInvalid = (message) => {
      errorHandlers[fieldName]({
        type: "invalid" /* Invalid */,
        message: t(message)
      });
    };
    switch (fieldName) {
      case "fullName" /* FullName */: {
        if ((0, import_dash_common32.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.nameBlank"));
          return false;
        }
        if (!(0, import_dash_common32.isNameLengthValid)(value)) {
          setInvalid(t("forms:messages.nameInvalid"));
          return false;
        }
        break;
      }
      case "street" /* Street */: {
        if ((0, import_dash_common32.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.streetBlank"));
          return false;
        }
        break;
      }
      case "city" /* City */: {
        if ((0, import_dash_common32.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.cityBlank"));
          return false;
        }
        break;
      }
      case "zipCode" /* ZipCode */: {
        if ((0, import_dash_common32.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.zipCodeBlank"));
          return false;
        }
        break;
      }
      case "state" /* State */: {
        if ((0, import_dash_common32.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.stateBlank"));
          return false;
        }
        break;
      }
      case "county" /* County */: {
        if ((0, import_dash_common32.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.countyBlank"));
          return false;
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };
  return validateFieldByName;
};
var useValidation_default = useValidation;

// src/components/molecules/CardPaymentForm/components/AddressSection/AddressSection.tsx
var import_jsx_runtime107 = require("react/jsx-runtime");
var NumberInput = (0, import_styled_components108.default)(Input_default)`
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
var GeneralInputs = ({ statesOptions }) => {
  const { t } = (0, import_react_i18next33.useTranslation)(["forms", "common"]);
  const theme = (0, import_styled_components108.useTheme)();
  const { formState, formErrors, stateHandlers } = (0, import_react82.useContext)(FormContext);
  const validateFieldByName = useValidation_default();
  const handleTextInputs = (fieldName) => (e) => {
    const { value } = e.target;
    if (fieldName === "zipCode" /* ZipCode */) {
      if (value.length <= import_dash_common33.DashValidation.MaxZipCodeLength) {
        stateHandlers[fieldName](value);
        validateFieldByName(fieldName, value);
      }
      return;
    }
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
  };
  const handleSelectInputs = (fieldName) => (value) => {
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
    if (fieldName === "state" /* State */) {
      stateHandlers["county" /* County */]("");
      stateHandlers["county" /* County */](null);
    }
  };
  const stateName = formState.state || "";
  const countiesOptions = (0, import_react82.useMemo)(() => {
    const counties = (0, import_dash_common33.getCountiesByStateName)(stateName);
    return counties.map((value) => ({
      label: value,
      value
    }));
  }, [stateName]);
  const handleCountySelect = (value) => {
    if (value) {
      stateHandlers["county" /* County */](value);
      validateFieldByName("county" /* County */, value);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(import_jsx_runtime107.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Flex_default, { mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Text_default, { semibold: true, color: theme.colors.n90, children: t("common:labels:billingAddress") }) }),
    /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Flex_default, { flex: 1, flexDirection: "row", children: [
      /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Flex_default, { flex: 1, flexDirection: "column", mr: 4, children: [
        /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Label, { required: true, children: t("forms:labels.state") }),
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
            Form_default.Select,
            {
              options: statesOptions,
              menuPlacement: "top",
              placeholder: t("forms:placeholders.selectOne"),
              w: "100%",
              onChanged: handleSelectInputs("state" /* State */),
              $errorType: formErrors["state" /* State */]?.type,
              value: formState.state
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Feedback, { $errorType: formErrors["state" /* State */]?.type, children: formErrors["state" /* State */]?.message })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Label, { required: true, children: t("forms:labels.city") }),
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
            Form_default.Input,
            {
              placeholder: t("forms:placeholders.nameOfCity") || "",
              onChange: handleTextInputs("city" /* City */),
              $errorType: formErrors["city" /* City */]?.type,
              value: formState.city || ""
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Feedback, { $errorType: formErrors["city" /* City */]?.type, children: formErrors["city" /* City */]?.message })
        ] })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Label, { required: true, children: t("forms:labels.county") }),
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
            Form_default.Select,
            {
              disabled: !formState.state || !countiesOptions.length,
              options: countiesOptions,
              value: formState.county,
              menuPlacement: "top",
              placeholder: t("forms:placeholders.selectOne"),
              onChanged: handleCountySelect,
              w: "100%",
              $errorType: formErrors["county" /* County */]?.type
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Feedback, { $errorType: formErrors["county" /* County */]?.type, children: formErrors["county" /* County */]?.message })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Label, { required: true, children: t("forms:labels.zipCode") }),
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
            NumberInput,
            {
              value: formState.zipCode || "",
              placeholder: t("forms:placeholders.digits", { number: 5 }) || "",
              type: "number",
              onChange: handleTextInputs("zipCode" /* ZipCode */),
              $errorType: formErrors["zipCode" /* ZipCode */]?.type
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Feedback, { $errorType: formErrors["zipCode" /* ZipCode */]?.type, children: formErrors["zipCode" /* ZipCode */]?.message })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Flex_default, { flex: 1, flexDirection: "row", children: /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Label, { required: true, children: t("forms:labels.streetName") }),
      /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
        Form_default.Input,
        {
          placeholder: t("forms:placeholders.nameOfStreet") || "",
          onChange: handleTextInputs("street" /* Street */),
          value: formState.street || "",
          $errorType: formErrors["street" /* Street */]?.type
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(Form_default.Feedback, { $errorType: formErrors["street" /* Street */]?.type, children: formErrors["street" /* Street */]?.message })
    ] }) })
  ] });
};
var AddressSection_default = GeneralInputs;

// src/components/molecules/CardPaymentForm/CardPaymentForm.tsx
var import_jsx_runtime108 = require("react/jsx-runtime");
var StyledInput2 = (0, import_styled_components109.default)(Input_default)`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.n60};
`;
var InputsContainer = (0, import_styled_components109.default)(Flex_default)`
  align-items: center;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
var ExpInputsContainer = (0, import_styled_components109.default)(Flex_default)`
  margin-left: ${({ theme }) => theme.space * 4}px;
  margin-top: 0px;
  @media ${({ theme }) => theme.devices.mobile} {
    margin-left: 0px;
    margin-top: ${({ theme }) => theme.space * 4}px;
  }
`;
var CardPaymentForm = ({
  stripe,
  elements,
  formRef,
  handleSubmit,
  withAddress = false,
  statesOptions,
  ...args
}) => {
  const { t } = (0, import_react_i18next34.useTranslation)(["common"]);
  const { formErrors, formState, formOnSubmit, resetFormErrors, stateHandlers } = (0, import_react83.useContext)(FormContext);
  const valid = useValidation_default();
  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    formOnSubmit();
    const { fullName, isLoading, errorSlug, ...address } = formState;
    if (!valid("fullName" /* FullName */, fullName))
      return;
    if (withAddress) {
      const invalidFields = Object.entries(address).map(([name, value]) => !valid(name, value) && name).filter(Boolean);
      if (invalidFields.length)
        return;
    }
    const cardElement = elements?.getElement(import_react_stripe_js4.CardNumberElement);
    if (!cardElement)
      return;
    const stripeAddress = {
      country: "US",
      city: address.city,
      line1: address.street,
      line2: address.county,
      postal_code: address.zipCode,
      state: address.state
    };
    const stripeResponse = await stripe?.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        name: fullName,
        ...withAddress ? { address: stripeAddress } : {}
      }
    });
    resetFormErrors();
    if (stripe && stripeResponse && stripeResponse.paymentMethod) {
      return handleSubmit(stripeResponse.paymentMethod.id, stripe.confirmCardPayment);
    }
    return;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Form_default, { onSubmit, ref: formRef, ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Form_default.Group, { mb: 4, children: [
      /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Form_default.Label, { required: true, children: t("common:labels.creditCardNumber") }),
      /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Form_default.CardNumberInput, { options: { placeholder: "xxxx xxxx xxxx xxxx" } })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(InputsContainer, { w: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Flex_default, { flex: 2, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Form_default.Label, { required: true, children: t("common:labels.fullName") }),
        /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
          StyledInput2,
          {
            w: "100%",
            placeholder: t("common:placeholders.firstAndLastName") || "",
            onChange: (e) => {
              const value = e.target.value;
              stateHandlers["fullName" /* FullName */](value);
              valid("fullName" /* FullName */, value);
            },
            $errorType: formErrors["fullName" /* FullName */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Form_default.Feedback, { $errorType: formErrors["fullName" /* FullName */]?.type, children: formErrors["fullName" /* FullName */]?.message })
      ] }) }),
      /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(ExpInputsContainer, { w: "100%", flex: 1, children: [
        /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
          /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Form_default.Label, { required: true, children: t("common:labels.expiryDate") }),
          /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
            Form_default.ExpiryDateInput,
            {
              w: "100%",
              options: { placeholder: t("common:placeholders.cardExpiry") || "" }
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Flex_default, { flex: 1, flexDirection: "column", ml: 4, children: [
          /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Form_default.Label, { required: true, children: t("common:labels.cvv") }),
          /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Form_default.CardCvvInput, { w: "100%", options: { placeholder: "123" } })
        ] })
      ] })
    ] }),
    withAddress && /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(AddressSection_default, { statesOptions })
  ] });
};
var CardPaymentForm_default = ({ ...args }) => /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(FormProvider, { fieldsList: FormFieldsList, children: /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(CardPaymentForm, { ...args }) });

// src/components/molecules/CopyToClipboardButton/CopyToClipboardButton.tsx
var import_styled_components110 = __toESM(require("styled-components"));
var import_jsx_runtime109 = require("react/jsx-runtime");
var PointerWrapper = (0, import_styled_components110.default)(Box_default)`
  cursor: pointer;
`;
var CopyToClipboardButton = ({
  textToCopy,
  successMessage,
  size = 20,
  ml = 2,
  mr = 2
}) => {
  const theme = (0, import_styled_components110.useTheme)();
  const copyToClipboard = () => {
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      toast.success(successMessage);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(PointerWrapper, { onClick: copyToClipboard, ml, mr, children: /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(Icon_default, { name: "contentCopy", size, color: theme.colors.b50 }) });
};
var CopyToClipboardButton_default = CopyToClipboardButton;

// src/components/molecules/FileTypeIcon/FileTypeIcon.tsx
var import_styled_components111 = __toESM(require("styled-components"));
var import_dash_common34 = require("dash-common");
var import_react_i18next35 = require("react-i18next");
var import_jsx_runtime110 = require("react/jsx-runtime");
var iconsMap = {
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.doc]: "fileDoc",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.docx]: "fileDoc",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.avi]: "fileVideo",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.mov]: "fileVideo",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.mp4]: "fileVideo",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.xls]: "fileDoc",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.xlsx]: "fileDoc",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.pdf]: "filePdf",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.jpeg]: "filePhoto",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.jpg]: "filePhoto",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.png]: "filePhoto",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.svg]: "filePhoto",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.csv]: "filePhoto"
};
var textMap = {
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.doc]: "doc",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.docx]: "doc",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.avi]: "video",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.mov]: "video",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.mp4]: "video",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.xls]: "exel",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.xlsx]: "exel",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.pdf]: "pdf",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.jpeg]: "photo",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.jpg]: "photo",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.png]: "photo",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.svg]: "photo",
  [import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.csv]: "photo"
};
var IconMask = (0, import_styled_components111.default)(Icon_default)`
  position: absolute;
`;
var TextStyled = (0, import_styled_components111.default)(Text_default)`
  font-size: ${({ size }) => size}px;
  line-height: ${({ size }) => size + 2}px;
`;
var sizeMap = {
  sm: {
    containerW: 21,
    containerH: 24,
    textFontSize: 3,
    iconSize: 9
  },
  md: {
    containerW: 30,
    containerH: 33,
    textFontSize: 6,
    iconSize: 12
  },
  lg: {
    containerW: 68,
    containerH: 82,
    textFontSize: 14,
    iconSize: 24
  }
};
var FileTypeIcon = ({ file, md, sm, lg, ...args }) => {
  const { type } = file;
  const theme = (0, import_styled_components111.useTheme)();
  const { t, i18n: i18nErrorSlugs } = (0, import_react_i18next35.useTranslation)(["common"]);
  const label = i18nErrorSlugs.exists(`common:fileTypes:${textMap[type]}`) ? t(`common:fileTypes:${textMap[type]}`) : t("common:fileTypes:file");
  const mdSize = md && sizeMap.md;
  const smSize = sm && sizeMap.sm;
  const lgSize = lg && sizeMap.lg;
  const size = smSize || mdSize || lgSize || sizeMap.md;
  return /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)(
    Flex_default,
    {
      w: size.containerW,
      h: size.containerH,
      justifyContent: "center",
      alignItems: "center",
      ...args,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(IconMask, { color: theme.colors.b20, size: size.containerH, name: "file", fill: "none" }),
        /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)(Flex_default, { flexDirection: "column", alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(
            Icon_default,
            {
              color: type === import_dash_common34.ALLOWED_MEDIA_TYPE_MIMES.pdf ? theme.colors.r20 : theme.colors.n80,
              size: size.iconSize,
              name: iconsMap[type]
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(Flex_default, { mt: smSize ? 0.5 : 1, children: /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(TextStyled, { bold: true, size: size.textFontSize, children: label }) })
        ] })
      ]
    }
  );
};
var FileTypeIcon_default = FileTypeIcon;

// src/components/molecules/ExpandableText/ExpandableText.tsx
var import_styled_components112 = __toESM(require("styled-components"));
var import_react_i18next36 = require("react-i18next");
var import_react84 = require("react");
var import_jsx_runtime111 = require("react/jsx-runtime");
var StyledButton2 = (0, import_styled_components112.default)(Button_default)`
  padding: 0;
`;
var StyledText = (0, import_styled_components112.default)(Text_default)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  ${({ isOpened, lineClamp }) => !isOpened && `-webkit-line-clamp: ${lineClamp}`};
`;
var ExpandableText = ({
  children,
  lineClamp = 0,
  withButton = true,
  ...rest
}) => {
  const [isOpened, setIsOpened] = (0, import_react84.useState)(false);
  const [isOverflowing, setIsOverflowing] = (0, import_react84.useState)(false);
  const { t } = (0, import_react_i18next36.useTranslation)("common");
  const textRef = (0, import_react84.useRef)(null);
  (0, import_react84.useEffect)(() => {
    if (textRef.current) {
      const { clientHeight, scrollHeight } = textRef.current;
      if (clientHeight < scrollHeight) {
        setIsOverflowing(true);
      }
    }
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime111.jsxs)(import_jsx_runtime111.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime111.jsx)(StyledText, { textRef, isOpened, lineClamp, ...rest, children }),
    isOverflowing && withButton && /* @__PURE__ */ (0, import_jsx_runtime111.jsx)(
      StyledButton2,
      {
        variation: "flat",
        onClick: () => setIsOpened(!isOpened),
        minWidth: "fit-content",
        h: "fit-content",
        children: t(`labels.${isOpened ? "showLess" : "showMore"}`)
      }
    )
  ] });
};
var ExpandableText_default = ExpandableText;

// src/components/molecules/SubscriptionRecurringSwitch/SubscriptionRecurringSwitch.tsx
var import_styled_components113 = __toESM(require("styled-components"));
var import_lodash19 = require("lodash");
var import_react85 = require("react");
var import_react_i18next37 = require("react-i18next");
var import_dash_common35 = require("dash-common");
var import_jsx_runtime112 = require("react/jsx-runtime");
var Container4 = (0, import_styled_components113.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space * 8}px;
  border: 1px solid ${({ theme }) => theme.colors.n50};
`;
var ButtonStyle3 = (0, import_styled_components113.default)(Badge_default)`
  background-color: ${({ isActive, theme }) => isActive ? theme.colors.g20 : "transparent"};
  color: ${({ isActive, theme }) => isActive ? theme.colors.white : theme.colors.n70};
  border-radius: ${({ theme }) => theme.space * 8}px;
`;
function SubscriptionRecurringSwitch({
  defaultRecurringType,
  onToggle
}) {
  const { t } = (0, import_react_i18next37.useTranslation)(["pages"]);
  const [type, setType] = (0, import_react85.useState)(
    defaultRecurringType || import_dash_common35.RecurringTypesEnum.MONTH
  );
  (0, import_react85.useEffect)(() => {
    if (onToggle) {
      onToggle(type);
    }
  }, [type, onToggle]);
  return /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(Container4, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
      ButtonStyle3,
      {
        sm: true,
        px: 6.5,
        py: 2,
        isActive: type === import_dash_common35.RecurringTypesEnum.MONTH,
        onClick: () => setType(import_dash_common35.RecurringTypesEnum.MONTH),
        title: t(
          `pages:completeSignUpPickSubscription:subscriptionProductRecurringLabels:${(0, import_lodash19.camelCase)(
            import_dash_common35.RecurringTypesEnum.MONTH
          )}`
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
      ButtonStyle3,
      {
        sm: true,
        px: 6.5,
        py: 2,
        isActive: type === import_dash_common35.RecurringTypesEnum.YEAR,
        onClick: () => setType(import_dash_common35.RecurringTypesEnum.YEAR),
        title: t(
          `pages:completeSignUpPickSubscription:subscriptionProductRecurringLabels:${(0, import_lodash19.camelCase)(
            import_dash_common35.RecurringTypesEnum.YEAR
          )}`
        )
      }
    )
  ] });
}
var SubscriptionRecurringSwitch_default = SubscriptionRecurringSwitch;

// src/components/molecules/Drawer/Drawer.styles.ts
var import_styled_components115 = __toESM(require("styled-components"));

// src/components/molecules/Drawer/Drawer.tsx
var import_react_modal3 = __toESM(require("react-modal"));
var import_styled_components114 = __toESM(require("styled-components"));
var import_jsx_runtime113 = require("react/jsx-runtime");
var Footer = (0, import_styled_components114.default)(Flex_default)`
  border-top: 1px solid ${({ theme }) => theme.colors.n30};

  button > div {
    white-space: nowrap;
  }
`;
function UnstyledDrawer({
  submitButton,
  cancelButton,
  backButton,
  children,
  title,
  className,
  isOpen,
  onRequestClose,
  closeIcon = true,
  subtitle,
  $iframeViewport,
  ...args
}) {
  const theme = (0, import_styled_components114.useTheme)();
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;
  return /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(
    import_react_modal3.default,
    {
      className: contentClassName,
      overlayClassName: {
        base: overlayClassName,
        afterOpen: `${overlayClassName}--after-open`,
        beforeClose: `${overlayClassName}--before-close`
      },
      isOpen,
      onRequestClose,
      ...args,
      children: /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(
        Flex_default,
        {
          flexDirection: "column",
          h: "100%",
          w: "100%",
          justifyContent: "space-between",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(Box_default, { w: "100%", ...submitButton || cancelButton ? {} : { h: "100%" }, children: [
              /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(Box_default, { children: [
                /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", children: [
                  backButton && /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(Button_default, { icon: "chevronLeft", variation: "flat", ...backButton }),
                  title && /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(Text_default, { lg: true, semibold: true, children: title }),
                  closeIcon && /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(Icon_default, { name: "close", size: 20, onClick: onRequestClose })
                ] }),
                subtitle && /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(Text_default, { color: theme.colors.n70, children: subtitle })
              ] }),
              children
            ] }),
            (submitButton || cancelButton) && /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(Footer, { pt: 6, pb: 4, w: "100%", children: [
              submitButton && /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(
                Button_default,
                {
                  "data-tutorial": "drawer-submit-button",
                  minWidth: 120,
                  h: 40,
                  onClick: submitButton.onClick,
                  isLoading: submitButton.isLoading,
                  disabled: submitButton.disabled,
                  mr: 2,
                  children: submitButton.title
                }
              ),
              cancelButton && /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(
                Button_default,
                {
                  h: 40,
                  variation: "outline",
                  minWidth: 120,
                  onClick: cancelButton.onClick,
                  isLoading: cancelButton.isLoading,
                  disabled: cancelButton.disabled,
                  children: cancelButton.title
                }
              )
            ] })
          ]
        }
      )
    }
  );
}
var Drawer_default = UnstyledDrawer;

// src/components/molecules/Drawer/Drawer.styles.ts
var Drawer = (0, import_styled_components115.default)(Drawer_default).attrs((props) => ({
  $iframeViewport: props.$iframeViewport !== void 0 ? props.$iframeViewport : props.isOpen ? getIdxIframeViewport() : null
}))`
  &__overlay {
    position: ${({ $iframeViewport }) => $iframeViewport ? "absolute" : "fixed"};
    inset: 0px;
    ${({ $iframeViewport }) => $iframeViewport && "min-height: 100%;"}
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 0;
    overflow: auto;
    display: flex;
    justify-content: flex-end;
    z-index: 100;
    height: ${({ $iframeViewport }) => $iframeViewport ? "auto" : "100%"};
  }

  &__overlay--after-open {
    opacity: 1;
    transition: opacity 150ms ease-in-out;
  }

  &__overlay--before-close {
    opacity: 0;
  }

  &__content {
    background-color: ${({ theme }) => theme.colors.white};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    outline: none;
    padding: 24px 16px;
    width: 410px;
    height: ${({ $iframeViewport }) => $iframeViewport ? `${$iframeViewport.height}px` : "100%"};
    ${({ $iframeViewport }) => $iframeViewport && `margin-top: ${$iframeViewport.top}px;`}
  }

  @media ${({ theme }) => theme.devices.mobile} {
    &__content {
      width: 330px;
    }
  }
`;

// src/components/molecules/AvatarUpload/AvatarUpload.tsx
var import_react86 = require("react");
var import_styled_components116 = __toESM(require("styled-components"));
var import_dash_common36 = require("dash-common");
var import_react_i18next38 = require("react-i18next");
var import_jsx_runtime114 = require("react/jsx-runtime");
var Container5 = (0, import_styled_components116.default)(Flex_default)`
  position: relative;
  min-width: max-content;
`;
var InputStyle2 = (0, import_styled_components116.default)(Box_default)`
  display: none;
`;
var ImgStyle3 = import_styled_components116.default.img`
  background-color: unset;
  border-radius: 10px;
  ${({ size }) => size ? `width:${size}${typeof size === "number" ? "px" : ""};` : ""}
  object-fit: cover;
`;
var AvatarPlaceholderStyle2 = (0, import_styled_components116.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n20};
  aspect-ratio: 4 / 3;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.n60};
`;
var ButtonContainer = (0, import_styled_components116.default)(Box_default)`
  position: absolute;
  bottom: ${({ offsetTop }) => offsetTop}px;
  right: ${({ offsetLeft }) => offsetLeft}px;
  border: 2px solid ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  z-index: 1;
`;
function AvatarUpload({
  url,
  medium,
  small,
  large,
  isLoading,
  onChange,
  isDeletable,
  onDelete,
  allowedMimeTypes = import_dash_common36.ALLOWED_AVATAR_MIME_TYPES
}) {
  const size = large && 212 || medium && 136 || small && 88 || 88;
  const buttonOffset = -10;
  const buttonSize = large && 40 || medium && 32 || small && 24 || 24;
  const iconSize = large && 34 || medium && 25 || small && 16 || 16;
  const [avatarUrl, setAvatarUrl] = (0, import_react86.useState)(null);
  const inputRef = (0, import_react86.useRef)(null);
  const { toggleModal, setPayload } = (0, import_react86.useContext)(ModalContext);
  const { t } = (0, import_react_i18next38.useTranslation)("common");
  const handleFileChange = (e) => {
    if (onChange && e.target.files) {
      const file = e.target.files[0];
      setPayload({
        file,
        onComplete: (croppedFile) => {
          onChange(croppedFile);
          setAvatarUrl(URL.createObjectURL(croppedFile));
        }
      });
      toggleModal(true, "CropImageModal");
    }
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };
  (0, import_react86.useEffect)(() => {
    if (url) {
      setAvatarUrl(url);
    }
  }, [url]);
  return /* @__PURE__ */ (0, import_jsx_runtime114.jsxs)(Container5, { children: [
    avatarUrl ? /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(ImgStyle3, { src: avatarUrl, size }) : /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(AvatarPlaceholderStyle2, { w: size, alignItems: "center", justifyContent: "center", children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(Spinner_default, { size: iconSize }) : /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(Icon_default, { size: iconSize, name: "addPhoto" }) }),
    /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(ButtonContainer, { offsetTop: buttonOffset, offsetLeft: buttonOffset, children: isDeletable && avatarUrl ? /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(
      DropDown_default,
      {
        variant: "dark",
        placementHorizontal: "left",
        optionsStyle: {
          minWidth: "160px",
          maxWidth: "none"
        },
        Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(Button_default, { type: "button", h: buttonSize, round: true, icon: "edit", iconProps: { size: 12 } }),
        items: [
          {
            icon: "addPhoto",
            key: "change",
            children: t("labels.changePhoto"),
            onClick: () => {
              if (inputRef.current) {
                inputRef.current.click();
              }
            }
          },
          {
            icon: "trashSolid",
            key: "remove",
            children: t("labels.remove"),
            onClick: () => {
              setPayload({
                onDelete: () => {
                  if (onDelete) {
                    onDelete();
                    setAvatarUrl(null);
                  }
                }
              });
              toggleModal(true, "DeleteAvatarModal");
            }
          }
        ]
      }
    ) : /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(
      Button_default,
      {
        type: "button",
        onClick: () => {
          if (inputRef.current) {
            inputRef.current.click();
          }
        },
        h: buttonSize,
        round: true,
        icon: "edit",
        iconProps: { size: 12 }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(InputStyle2, { children: /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(
      "input",
      {
        ref: inputRef,
        type: "file",
        accept: allowedMimeTypes.join(","),
        onChange: handleFileChange
      }
    ) })
  ] });
}
var AvatarUpload_default = AvatarUpload;

// src/components/molecules/PageViewToggle/PageViewToggle.tsx
var import_react87 = require("react");
var import_styled_components117 = __toESM(require("styled-components"));
var import_jsx_runtime115 = require("react/jsx-runtime");
var StyledWrapper5 = (0, import_styled_components117.default)(Flex_default)`
  background: ${({ theme }) => theme.colors.white};
`;
var PropertiesViewToggle = ({
  buttons,
  defaultButton
}) => {
  const theme = (0, import_styled_components117.useTheme)();
  const { viewType, setViewType } = (0, import_react87.useContext)(PageViewContext);
  const [firstButton, secondButton] = buttons;
  const isSecondButton = viewType === secondButton.viewType;
  const isFirstButton = viewType === firstButton.viewType;
  (0, import_react87.useEffect)(() => {
    if (defaultButton) {
      setViewType(defaultButton);
    }
  }, [defaultButton]);
  return /* @__PURE__ */ (0, import_jsx_runtime115.jsxs)(StyledWrapper5, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
      Button_default,
      {
        square: true,
        icon: firstButton.icon,
        iconProps: { size: 24, color: isFirstButton ? theme.colors.white : theme.colors.n80 },
        disabled: firstButton.disabled,
        borderRadius: 4,
        variation: isFirstButton ? "primary" : "flat",
        onClick: () => setViewType(firstButton.viewType)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
      Button_default,
      {
        square: true,
        disabled: secondButton.disabled,
        icon: secondButton.icon,
        borderRadius: 4,
        iconProps: { size: 24, color: isSecondButton ? theme.colors.white : theme.colors.n80 },
        variation: isSecondButton ? "primary" : "flat",
        onClick: () => setViewType(secondButton.viewType)
      }
    )
  ] });
};
var PageViewToggle_default = PropertiesViewToggle;

// src/components/molecules/FlatPagination/FlatPagination.tsx
var import_react88 = require("react");
var import_jsx_runtime116 = require("react/jsx-runtime");
function FlatPagination({
  currentStartingAfter,
  currentEndingBefore,
  hasMore,
  ...args
}) {
  const { state, setStartingAfter, setEndingBefore } = (0, import_react88.useContext)(FlatPaginationContext);
  const onGoForward = (0, import_react88.useCallback)(() => {
    currentStartingAfter && setStartingAfter(currentStartingAfter);
  }, [currentStartingAfter, setStartingAfter]);
  const onGoBack = (0, import_react88.useCallback)(() => {
    currentEndingBefore && setEndingBefore(currentEndingBefore);
  }, [currentEndingBefore, setEndingBefore]);
  const isFirstPage = !state.startingAfter && !state.endingBefore;
  const hasPreviousPage = state.endingBefore && hasMore || !isFirstPage && state.startingAfter;
  const hasNextPage = state.startingAfter && hasMore || state.endingBefore || isFirstPage && hasMore;
  if (isFirstPage && !hasMore) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(Flex_default, { ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
      Button_default,
      {
        disabled: !hasPreviousPage,
        mr: 1,
        square: true,
        small: true,
        variation: "outline",
        onClick: onGoBack,
        icon: "chevronLeft"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
      Button_default,
      {
        disabled: !hasNextPage,
        mr: 1,
        square: true,
        small: true,
        variation: "outline",
        onClick: onGoForward,
        icon: "chevronRight"
      }
    )
  ] });
}
var FlatPagination_default = FlatPagination;

// src/components/molecules/BrokersBanner/BrokersBanner.tsx
var import_styled_components120 = require("styled-components");
var import_dash_common38 = require("dash-common");

// src/components/molecules/BrokersBanner/BrokersBanner.styles.ts
var import_styled_components118 = __toESM(require("styled-components"));
var hiddenDivStyles = import_styled_components118.css`
  ${({ isVertical }) => isVertical && `display: none`}
`;
var BannerWrapper = (0, import_styled_components118.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b60};
  position: relative;
  color: ${({ theme }) => theme.colors.white};
  height: ${({ isVertical }) => isVertical ? "100%" : "384px"};
  width: ${({ isVertical }) => isVertical ? "255px" : "100%"};
  border-radius: ${({ theme }) => theme.space * 4}px;
  @media ${({ theme }) => theme.devices.tablet} {
    width: ${({ isVertical }) => isVertical ? "215px" : "100%"};
  }
  @media ${({ theme }) => theme.devices.mobile} {
    height: fit-content;
    width: 100%;
    background-color: unset;
  }
`;
var OuterCircle = (0, import_styled_components118.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b70};
  width: 669px;
  height: 669px;
  border-radius: 100%;
  position: absolute;
  bottom: -23px;
  right: 183px;
  ${hiddenDivStyles}
`;
var InnerCircle = (0, import_styled_components118.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b80};
  position: absolute;
  width: 100%;
  height: 572px;
  border-radius: 0 255px 255px 0;
  right: calc(183px + 195px);
  bottom: -79px;
  z-index: 1;
  ${hiddenDivStyles}
  @media ${({ theme }) => theme.devices.tablet} {
    border-radius: 0 215px 215px 0;
  }
`;
var AvatarCircleWrapper = (0, import_styled_components118.default)(Box_default)`
  overflow: hidden;
  position: relative;
  border-radius: ${({ theme }) => theme.space * 4}px;
  min-width: ${({ isVertical }) => isVertical ? "255px" : "332px"};
  height: ${({ isVertical }) => isVertical ? "270px" : "384px"};
  @media ${({ theme }) => theme.devices.tablet} {
    min-width: ${({ isVertical }) => isVertical ? "215px" : "332px"};
  }
  @media ${({ theme }) => theme.devices.mobile} {
    height: 230px;
    width: 100%;
  }
`;
var AvatarCircle = (0, import_styled_components118.default)(Box_default)`
  border-radius: ${({ isVertical }) => isVertical ? "0 0 196px 196px" : "0 251px 251px 0"};
  width: ${({ isVertical }) => isVertical ? "358px" : "332px"};
  height: ${({ isVertical }) => isVertical ? "270px" : "502px"};
  overflow: hidden;
  position: absolute;
  top: ${({ isVertical }) => isVertical ? 0 : "-59px"};
  left: ${({ isVertical }) => isVertical ? "-55px" : 0};
  background-color: ${({ theme }) => theme.colors.n30};

  & img {
    border-radius: ${({ isVertical }) => isVertical ? "0 0 196px 196px" : "0 251px 251px 0"};
  }
  @media ${({ theme }) => theme.devices.tablet} {
    width: ${({ isVertical }) => isVertical ? "338px" : "332px"};
  }
  @media ${({ theme }) => theme.devices.mobile} {
    border-radius: unset;
    & img {
      border-radius: unset;
    }
    height: inherit;
    width: 100%;
    left: unset;
    position: relative;
  }
`;
var InfoWrapper = (0, import_styled_components118.default)(Flex_default)`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 2;
  border-radius: ${({ theme }) => theme.space * 5}px;
  @media ${({ theme }) => theme.devices.mobile} {
    position: relative;
    background-color: ${({ theme }) => theme.colors.b60};
    border-radius: ${({ theme }) => theme.space * 5}px;
  }
`;
var BackgroundWrapper = (0, import_styled_components118.default)(Box_default)`
  position: absolute;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.space * 4}px;
  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
`;

// src/components/molecules/BrokersBanner/components/ButtonsSection.tsx
var import_moment8 = __toESM(require("moment"));
var import_styled_components119 = __toESM(require("styled-components"));
var import_react_i18next39 = require("react-i18next");
var import_dash_common37 = require("dash-common");
var import_jsx_runtime117 = require("react/jsx-runtime");
var StyledContainer2 = (0, import_styled_components119.default)(Flex_default)`
  flex-direction: ${({ isVertical }) => isVertical ? "column" : "row"};
  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: row;
  }
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: row;
  }
`;
var ButtonContainer2 = (0, import_styled_components119.default)(Flex_default)`
  flex: ${({ isVertical }) => isVertical ? 1 : "unset"};
  width: ${({ isVertical }) => isVertical ? "100%" : "unset"};
  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }
`;
var StyledButton3 = (0, import_styled_components119.default)(Button_default)`
  background-color: ${({ theme }) => theme.colors.b10};

  :hover {
    & p {
      color: ${({ theme }) => theme.colors.white};
    }
  }
  & p {
    color: ${({ theme }) => theme.colors.b50};
  }
  width: ${({ isVertical }) => isVertical ? "100%" : "unset"};
  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }
`;
var ButtonsSection = ({
  broker,
  isVertical,
  onAvailabilityClick
}) => {
  const theme = (0, import_styled_components119.useTheme)();
  const { t } = (0, import_react_i18next39.useTranslation)(["pages", "common"]);
  const { account, agencyWebsite } = broker;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(StyledContainer2, { flex: 1, flexWrap: "wrap", isVertical, mt: 6, children: [
    /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
      ButtonContainer2,
      {
        isVertical,
        mr: [3, isVertical ? 0 : 3, isVertical ? 0 : 3, isVertical ? 0 : 3],
        children: /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
          DropDown_default,
          {
            placement: "bottom",
            placementHorizontal: (0, import_dash_common37.or)(!isVertical, isMobile) ? "right" : "left",
            w: isVertical ? "100%" : "fit-content",
            Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(StyledButton3, { px: [0, 10, 10, 10], isVertical, children: t("pages:portfoliosPage.contactMe") }),
            children: () => /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(
              Flex_default,
              {
                px: 4,
                py: 5,
                minWidth: isMobile ? "83vw" : 350,
                maxWidth: isMobile ? "83vw" : 473,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(Flex_default, { flex: 1, mr: 2, flexDirection: "column", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(Text_default, { color: theme.colors.n70, children: [
                      t("common:labels.phone").toUpperCase(),
                      ":"
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(Box_default, { my: 5.5, children: /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(Text_default, { color: theme.colors.n70, children: [
                      t("forms:labels.email").toUpperCase(),
                      ":"
                    ] }) }),
                    !!agencyWebsite && /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(Text_default, { color: theme.colors.n70, children: [
                      t("common:labels.website").toUpperCase(),
                      ":"
                    ] })
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(Flex_default, { overflow: "auto", flex: 2, flexDirection: "column", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(Flex_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
                      A_default,
                      {
                        href: `tel:${account.phone?.dialCode}${account.phone?.number}`,
                        children: `${account.phone?.dialCode} ${account.phone?.number}`
                      }
                    ) }),
                    /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(Flex_default, { my: 5.5, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(A_default, { href: `mailto:${account.email}`, children: account.email }) }),
                    !!agencyWebsite && /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(Flex_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(A_default, { ellipsis: true, href: agencyWebsite, children: agencyWebsite }) })
                  ] })
                ]
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
      ButtonContainer2,
      {
        isVertical,
        mt: [0, isVertical ? 3 : 0, isVertical ? 3 : 0, isVertical ? 3 : 0],
        children: !onAvailabilityClick ? /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
          DropDown_default,
          {
            placement: "bottom",
            w: isVertical ? "100%" : "fit-content",
            Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(StyledButton3, { px: [0, 9, 9, 9], isVertical, children: t("pages:portfoliosPage.availability") }),
            children: () => /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(Box_default, { p: 4, w: "100%", children: Object.values(import_dash_common37.WeekDays).map((day, index2) => {
              const range = (broker.workingHours || {})[day];
              const from2 = (0, import_moment8.default)(range?.from).format("hh:mm A");
              const to2 = (0, import_moment8.default)(range?.to).format("hh:mm A");
              return /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(Flex_default, { alignItems: "center", mt: index2 === 0 ? 0 : 3.5, children: [
                /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(Box_default, { mr: 2, w: 40, children: /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(Text_default, { whiteSpace: "nowrap", children: [
                  t(`common:labels.weekDays.${day}`).slice(
                    0,
                    day === import_dash_common37.WeekDays.Tuesday ? 4 : 3
                  ),
                  ":"
                ] }) }),
                /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
                  Text_default,
                  {
                    whiteSpace: "nowrap",
                    sm: true,
                    color: !range ? theme.colors.r20 : theme.colors.b50,
                    children: !range ? t("common:labels.notWorking") : `${from2} - ${to2}`
                  }
                )
              ] }, day);
            }) })
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(StyledButton3, { px: [0, 9, 9, 9], isVertical, onClick: onAvailabilityClick, children: t("pages:portfoliosPage.availability") })
      }
    )
  ] });
};
var ButtonsSection_default = ButtonsSection;

// src/components/molecules/BrokersBanner/BrokersBanner.tsx
var import_jsx_runtime118 = require("react/jsx-runtime");
var BrokersBanner = ({
  broker,
  h,
  variation = "horizontal",
  maxWidth,
  onAvailabilityClick,
  ...props
}) => {
  const theme = (0, import_styled_components120.useTheme)();
  const { profile, description } = broker;
  const isVertical = variation === "vertical";
  const BrokerName = isVertical ? Text_default : H_default;
  const isVerifiedBroker = broker.account.phone?.status === import_dash_common38.AccountPhoneNumberStatusesEnum.VERIFIED && broker.license.licenseStatus === import_dash_common38.BrokerLicenseStatusesEnum.ACTIVE;
  return /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(BannerWrapper, { isVertical, maxWidth: maxWidth || 1100, ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(BackgroundWrapper, { w: "100%", h: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(OuterCircle, { isVertical }),
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(InnerCircle, { isVertical })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(InfoWrapper, { alignItems: "center", flexDirection: isVertical ? "column" : "row", children: [
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(AvatarCircleWrapper, { isVertical, children: /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(AvatarCircle, { id: "avatar-cicle", isVertical, children: profile.avatarFile ? /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Image_default, { src: profile.avatarFile.publicUrl, size: "100%", position: "50% 35%", fit: "cover" }) : /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(DashPlaceholder_default, { w: "100%", h: "100%" }) }) }),
      /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(Box_default, { w: "100%", ml: isVertical ? 0 : 6.5, px: isVertical ? 4 : 0, pb: 4, children: [
        /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(Flex_default, { mb: 1, alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(BrokerName, { sm: !isVertical, xxl: isVertical, bold: true, color: theme.colors.white, children: `${profile.firstName} ${profile.lastName}` }),
          isVerifiedBroker && /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Icon_default, { name: "verified", color: theme.colors.g40, size: 20, ml: 3 })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Box_default, { maxWidth: 672, children: /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(ExpandableText_default, { lineClamp: 3, withButton: false, color: theme.colors.n30, children: description }) }),
        /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(
          ButtonsSection_default,
          {
            broker,
            isVertical,
            onAvailabilityClick
          }
        )
      ] })
    ] })
  ] });
};
var BrokersBanner_default = BrokersBanner;

// src/components/molecules/PropertyPreviewComponents/AdditionalInfoSection/AdditionalInfoSection.tsx
var import_lodash20 = require("lodash");
var import_react_i18next42 = require("react-i18next");
var import_dash_common40 = require("dash-common");
var import_styled_components126 = __toESM(require("styled-components"));

// src/components/molecules/PropertyPreviewComponents/RestrictedField/RestrictedField.helpers.tsx
var import_dash_common39 = require("dash-common");

// src/components/molecules/PropertyPreviewComponents/RestrictedField/RestrictedField.tsx
var import_styled_components122 = require("styled-components");
var import_react_i18next40 = require("react-i18next");

// src/components/molecules/PropertyPreviewComponents/RestrictedField/RestrictedField.styles.ts
var import_styled_components121 = __toESM(require("styled-components"));
var RestrictedFieldContainer = (0, import_styled_components121.default)(Flex_default)`
  cursor: pointer;
  user-select: none;
  align-items: center;
  gap: ${({ theme }) => theme.space}px;
  flex-wrap: nowrap;
  max-width: 100%;
  overflow: hidden;

  &:hover {
    opacity: 0.9;
  }
`;
var TextContainer2 = import_styled_components121.default.span`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;

  & > *[class] {
    display: inline;
    white-space: nowrap;
  }
`;
var BlurredText = (0, import_styled_components121.default)(Text_default)`
  filter: blur(3px);
  opacity: 0.7;
`;

// src/components/molecules/PropertyPreviewComponents/RestrictedField/RestrictedField.tsx
var import_jsx_runtime119 = require("react/jsx-runtime");
var renderDisplayContent = (value, type, formattedVisible) => {
  if (type === "phone") {
    const hasVisibleContent = formattedVisible && formattedVisible.trim().length > 0;
    return /* @__PURE__ */ (0, import_jsx_runtime119.jsxs)(TextContainer2, { children: [
      hasVisibleContent && /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Text_default, { as: "span", children: formattedVisible }),
      /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(BlurredText, { as: "span", children: "\u2022\u2022\u2022-\u2022\u2022\u2022\u2022" })
    ] });
  }
  const { visible, blurred } = getPartialValue(value, type);
  return /* @__PURE__ */ (0, import_jsx_runtime119.jsxs)(TextContainer2, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Text_default, { as: "span", children: visible }),
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(BlurredText, { as: "span", children: blurred })
  ] });
};
var RestrictedField = ({
  value,
  type = "text",
  formattedVisible,
  onClick,
  iconSize = 18
}) => {
  const theme = (0, import_styled_components122.useTheme)();
  const { t } = (0, import_react_i18next40.useTranslation)("common");
  if (value && isNoValueIndicator(value)) {
    return /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Text_default, { children: value });
  }
  const displayContent = value && type ? renderDisplayContent(value, type, formattedVisible) : null;
  return /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(TooltipWrapper_default, { content: t("common:labels.upgradeToView"), placement: "top", disableOnTouch: true, children: /* @__PURE__ */ (0, import_jsx_runtime119.jsxs)(RestrictedFieldContainer, { onClick, children: [
    displayContent,
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Icon_default, { name: "lock", size: iconSize, color: theme.colors.n60 })
  ] }) });
};

// src/components/molecules/PropertyPreviewComponents/RestrictedField/RestrictedField.helpers.tsx
var import_styled_components123 = __toESM(require("styled-components"));
var import_jsx_runtime120 = require("react/jsx-runtime");
var StyledLinkText = (0, import_styled_components123.default)(Text_default)`
  overflow: hidden;
  display: block;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.colors.gr3};
`;
var StyledText2 = (0, import_styled_components123.default)(Text_default)`
  ${({ $fontSize }) => $fontSize && `font-size: ${$fontSize}px;`}
`;
var StyledLink = (0, import_styled_components123.default)(A_default)`
  display: inline;
  word-break: break-word;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.colors.gr3};
  ${({ $fontSize }) => $fontSize && `font-size: ${$fontSize}px;`}
`;
var WEBSITE_VISIBLE_CHARS = 4;
var WEBSITE_BLURRED_BULLETS = 8;
var PHONE_AREA_CODE_LENGTH = 3;
var EMAIL_VISIBLE_CHARS = 5;
var isNoValueIndicator = (value) => {
  const noValueIndicators = [
    "n/a",
    "na",
    "n / a",
    "none",
    "null",
    "undefined",
    "-",
    "not available",
    "not applicable"
  ];
  const normalizedValue = value.toLowerCase().trim().replace(/\s+/g, "").replace(/\//g, "");
  return noValueIndicators.some(
    (indicator) => normalizedValue === indicator.replace(/\s+/g, "").replace(/\//g, "")
  ) || normalizedValue === "";
};
var getPartialValue = (value, type) => {
  if (type === "phone") {
    return {
      visible: value,
      blurred: ""
    };
  } else if (type === "email") {
    const visibleChars = value.slice(0, EMAIL_VISIBLE_CHARS);
    const blurredPart = "\u2022".repeat(WEBSITE_BLURRED_BULLETS);
    return {
      visible: visibleChars,
      blurred: blurredPart
    };
  } else {
    const httpsPrefix = "https://";
    const httpPrefix = "http://";
    const wwwPrefix = "www.";
    let prefix = "";
    let remainder = value;
    if (value.startsWith(httpsPrefix)) {
      prefix = httpsPrefix;
      remainder = value.slice(httpsPrefix.length);
    } else if (value.startsWith(httpPrefix)) {
      prefix = httpPrefix;
      remainder = value.slice(httpPrefix.length);
    }
    if (remainder.startsWith(wwwPrefix)) {
      prefix += wwwPrefix;
      remainder = remainder.slice(wwwPrefix.length);
    }
    const visibleChars = remainder.slice(0, WEBSITE_VISIBLE_CHARS);
    const blurredPart = remainder.length > WEBSITE_VISIBLE_CHARS ? "\u2022".repeat(WEBSITE_BLURRED_BULLETS) : "";
    return {
      visible: prefix + visibleChars,
      blurred: blurredPart
    };
  }
};
var renderPhoneField = ({
  phone,
  isRestricted,
  onRestrictedClick,
  theme
}) => {
  if (!phone?.number) {
    return null;
  }
  const phoneNumber = phone.number;
  const dialCode = phone.dialCode || "";
  const fullPhone = `${dialCode}${phoneNumber}`.trim();
  if (isNoValueIndicator(phoneNumber) || isNoValueIndicator(fullPhone)) {
    return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(Text_default, { color: theme.colors.n80, children: fullPhone || phoneNumber });
  }
  if (isRestricted) {
    const hasFullAreaCode = phoneNumber.length >= PHONE_AREA_CODE_LENGTH;
    const areaCode = hasFullAreaCode ? phoneNumber.slice(0, PHONE_AREA_CODE_LENGTH) : phoneNumber;
    const separator = dialCode && areaCode && hasFullAreaCode ? " (" : dialCode && areaCode ? " " : "";
    const closing = areaCode && hasFullAreaCode ? ") " : "";
    const formattedVisible = `${dialCode}${separator}${areaCode}${closing}`;
    return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(
      RestrictedField,
      {
        value: fullPhone,
        type: "phone",
        formattedVisible,
        onClick: onRestrictedClick,
        iconSize: 16
      }
    );
  }
  const formattedNumber = (0, import_dash_common39.formatByMask)(phoneNumber, import_dash_common39.PROPERTY_PHONE_NUMBER_MASK);
  return /* @__PURE__ */ (0, import_jsx_runtime120.jsxs)(Text_default, { color: theme.colors.gr3, children: [
    dialCode && `${dialCode} `,
    formattedNumber
  ] });
};
var renderWebsiteField = ({
  website,
  isRestricted,
  onRestrictedClick,
  fontSize
}) => {
  if (!website) {
    return null;
  }
  const fontSizeProps = typeof fontSize === "number" ? { $fontSize: fontSize } : fontSize ? { [fontSize]: true } : {};
  if (isNoValueIndicator(website)) {
    return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(StyledText2, { ...fontSizeProps, children: website });
  }
  if (isRestricted) {
    return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(RestrictedField, { value: website, type: "text", onClick: onRestrictedClick, iconSize: 16 });
  }
  const normalizedWebsite = (0, import_dash_common39.normalizeUrl)(website);
  return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(Box_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(StyledLinkText, { children: /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(StyledLink, { target: "_blank", href: normalizedWebsite, ...fontSizeProps, children: website }) }) });
};
var renderEmailField = ({
  email,
  isRestricted,
  onRestrictedClick
}) => {
  if (!email) {
    return null;
  }
  if (isNoValueIndicator(email)) {
    return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(Text_default, { children: email });
  }
  if (isRestricted) {
    return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(RestrictedField, { value: email, type: "email", onClick: onRestrictedClick, iconSize: 16 });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(Box_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(StyledLinkText, { children: /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(StyledLink, { href: `mailto:${email}`, children: email }) }) });
};

// src/components/molecules/PropertyPreviewComponents/AdditionalInfoSection/components/TextBlock.tsx
var import_styled_components124 = require("styled-components");
var import_react_i18next41 = require("react-i18next");
var import_styled_components125 = __toESM(require("styled-components"));
var import_jsx_runtime121 = require("react/jsx-runtime");
var StyledTextTitle = (0, import_styled_components125.default)(Text_default)`
  font-size: 14px;
  margin-top: 8px;
`;
var StyledText3 = (0, import_styled_components125.default)(Text_default)`
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  margin-top: 8px;
`;
var TextBlock = ({
  title,
  description,
  children,
  disableDefaultNoValueLabel = false,
  showDivider = true
}) => {
  const theme = (0, import_styled_components124.useTheme)();
  const { t } = (0, import_react_i18next41.useTranslation)(["common"]);
  const value = description || !disableDefaultNoValueLabel && t("common:labels.noValue");
  return /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Box_default, { children: /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Box_default, { maxWidth: "100%", children: [
    showDivider && /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Devider_default, { mt: 2, mb: 4, h: 1, w: "100%", color: theme.colors.gr7 }),
    /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(TooltipWrapper_default, { content: value, children: [
      /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(StyledTextTitle, { color: theme.colors.gr5, children: title }),
      children || /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(StyledText3, { color: theme.colors.gr1, children: value })
    ] })
  ] }) });
};
var TextBlock_default = TextBlock;

// src/components/molecules/PropertyPreviewComponents/AdditionalInfoSection/AdditionalInfoSection.tsx
var import_jsx_runtime122 = require("react/jsx-runtime");
var StyledGrid = (0, import_styled_components126.default)(Box_default)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 64px;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;
var SecondItemWrapper = (0, import_styled_components126.default)(Box_default)`
  @media (max-width: 576px) {
    padding-top: 12px;
    margin-top: 8px;
    border-top: 1px solid ${(props) => props.theme.colors.gr7};
  }
`;
var ClickableTextButton = import_styled_components126.default.button`
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
  font-family: inherit;

  & span {
    text-decoration: underline;
    text-underline-offset: 2px;
    color: ${({ $color }) => $color};
  }

  &:hover span {
    opacity: 0.7;
  }
`;
var AdditionalInfoSection = ({
  property,
  containerRef,
  isViewAsClient = false,
  isRestricted = false,
  onRestrictedFieldClick,
  onLastUpdatedClick
}) => {
  const { t } = (0, import_react_i18next42.useTranslation)(["forms", "pages"]);
  const theme = (0, import_styled_components126.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const {
    numberOfUnits,
    numberOfTowers,
    stories,
    // todo: hiden for now
    // constructionStartDate,
    yearBuilt,
    // completionDate,
    taxInformation,
    location,
    buildingTypes,
    propertyTags,
    website,
    projectStatus,
    leadArchitect,
    landscapeArchitect,
    interiorDesigner,
    lastUpdatedAtByChangelog
  } = property;
  const fromNow = usePropertyUpdatedAgo(lastUpdatedAtByChangelog);
  return /* @__PURE__ */ (0, import_jsx_runtime122.jsxs)(Box_default, { mt: 8, mb: 2, ref: containerRef, maxWidth: "100%", pr: 8, children: [
    /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(Box_default, { mb: 7, children: /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(Text_default, { semibold: true, ...isMobile ? { xl: true } : { xxl: true }, color: theme.colors.gr1, children: t("pages:propertyPreviewPage.additionalInformation") }) }),
    /* @__PURE__ */ (0, import_jsx_runtime122.jsxs)(StyledGrid, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
        TextBlock_default,
        {
          showDivider: false,
          title: t("forms:labels.nbrOfUnits"),
          description: numberOfUnits
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(SecondItemWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
        TextBlock_default,
        {
          showDivider: false,
          title: t("forms:labels.projectStatus"),
          description: projectStatus && projectStatus !== import_dash_common40.ProjectStatusesEnum.LEAVING_SOON ? t(`forms:labels.projectStatuses.${(0, import_lodash20.camelCase)(projectStatus)}`) : ""
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("forms:labels.yearBuilt"), description: yearBuilt }),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.address"),
          description: (0, import_dash_common40.formatAddress)(location.address)
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.buildingType"),
          description: buildingTypes?.length && buildingTypes.map((b) => t(`forms:labels.buildingTypes.${(0, import_lodash20.camelCase)(b)}`)).join(", ")
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.propertyTag"),
          description: propertyTags?.length && propertyTags.map((tag) => t(`forms:labels.propertyTags.${(0, import_lodash20.camelCase)(tag)}`)).join(", ")
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("pages:propertyPreviewPage.nbrOfStories"), description: stories }),
      !!numberOfTowers && /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("forms:labels.nbrOfTowers"), description: numberOfTowers }),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("forms:labels.leadArchitect"), description: leadArchitect }),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("forms:labels.landscapeArchitect"), description: landscapeArchitect }),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("forms:labels.interiorDesigner"), description: interiorDesigner }),
      !isViewAsClient && /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("pages:propertyPreviewPage.websiteLink"), children: /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(Box_default, { mt: 2, children: renderWebsiteField({
        website,
        isRestricted,
        onRestrictedClick: onRestrictedFieldClick,
        fontSize: 16
      }) }) }),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("forms:labels.taxInformation"), description: taxInformation }),
      !isViewAsClient && /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(import_jsx_runtime122.Fragment, { children: onLastUpdatedClick ? /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("pages:propertyPage.lastUpdated"), children: /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
        ClickableTextButton,
        {
          onClick: onLastUpdatedClick,
          type: "button",
          $color: theme.colors.gr3,
          children: /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(StyledText3, { color: theme.colors.gr3, as: "span", children: fromNow })
        }
      ) }) : /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TextBlock_default, { title: t("pages:propertyPage.lastUpdated"), description: fromNow }) })
    ] })
  ] });
};
var AdditionalInfoSection_default = AdditionalInfoSection;

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/DeveloperInfoSection.tsx
var import_react90 = require("react");
var import_react_i18next43 = require("react-i18next");
var import_styled_components130 = __toESM(require("styled-components"));

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/components/InfoCard.tsx
var import_styled_components127 = __toESM(require("styled-components"));
var import_jsx_runtime123 = require("react/jsx-runtime");
var Card2 = (0, import_styled_components127.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space * 2}px;
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  overflow: hidden;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.space * 3}px;
  padding: ${({ theme }) => theme.space * 4}px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }

  &:hover {
    transform: scale(1.02);
    border-color: ${({ theme }) => theme.colors.n40};
  }
`;
var LogoContainer = (0, import_styled_components127.default)(Flex_default)`
  width: 100px;
  height: 100px;
  background-color: ${({ theme }) => theme.colors.n10};
  border-radius: ${({ theme }) => theme.space}px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 60px;
    height: 60px;
  }
`;
var InfoCard = ({
  logoUrl,
  name,
  website,
  isRestricted = false,
  onUpgradeClick,
  phone,
  renderPhoneField: renderPhoneField2,
  salesAssociates,
  t,
  theme,
  isMobile
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(Card2, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(LogoContainer, { children: logoUrl ? /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Image_default, { maxHeight: isMobile ? 60 : 100, size: "unset", src: logoUrl }) : /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(DashPlaceholder_default, { size: isMobile ? 60 : 100 }) }),
    /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(Flex_default, { flexDirection: "column", justifyContent: "center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Box_default, { mb: 2, children: /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Text_default, { lg: true, semibold: true, color: theme.colors.gr1, children: name || t("common:labels.noValue") }) }),
      website && /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(Flex_default, { mb: 2, alignItems: "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Icon_default, { mr: 1.5, ml: 0.5, mt: 0.5, name: "world", size: 18, color: theme.colors.gr2 }),
        renderWebsiteField({
          website,
          isRestricted,
          onRestrictedClick: onUpgradeClick
        })
      ] }),
      phone?.number && renderPhoneField2 && /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(Flex_default, { mb: 2, alignItems: "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Icon_default, { mr: 1, name: "mobile", size: 22, color: theme.colors.gr2 }),
        renderPhoneField2({
          phone,
          isRestricted,
          onRestrictedClick: onUpgradeClick,
          theme
        })
      ] }),
      salesAssociates && salesAssociates.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(Flex_default, { mt: 3, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Box_default, { mb: 2, children: /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Text_default, { sm: true, color: theme.colors.gr2, children: t("forms:labels:salesAssociate") }) }),
        salesAssociates.map((associate, index2) => /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Text_default, { md: true, color: theme.colors.gr3, children: associate.profile.lastName ? `${associate.profile.firstName} ${associate.profile.lastName}` : associate.profile.firstName }, index2))
      ] })
    ] })
  ] });
};

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/components/AnimatedCardRow.tsx
var import_styled_components129 = __toESM(require("styled-components"));

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/animations.ts
var import_styled_components128 = require("styled-components");
var slideInRight = import_styled_components128.keyframes`
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;
var slideInLeft = import_styled_components128.keyframes`
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/components/AnimatedCardRow.tsx
var import_jsx_runtime124 = require("react/jsx-runtime");
var Row = (0, import_styled_components129.default)(Flex_default)`
  flex-direction: row;
  align-items: stretch;
  gap: ${({ theme }) => theme.space * 3}px;
  width: 100%;
  animation: ${({ $direction }) => $direction === "right" ? import_styled_components129.css`
          ${slideInRight} 0.3s ease-out
        ` : $direction === "left" ? import_styled_components129.css`
          ${slideInLeft} 0.3s ease-out
        ` : "none"};

  & > ${Box_default} {
    flex: 1 1 calc(50% - ${({ theme }) => theme.space * 1.5}px);
    max-width: calc(50% - ${({ theme }) => theme.space * 1.5}px);
  }

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;

    & > ${Box_default} {
      width: 100%;
      max-width: 100%;
      flex: 1 1 100%;
    }
  }
`;
var AnimatedCardRow = ({ children, direction }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Row, { $direction: direction, children });
};

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/hooks/useCardPagination.ts
var import_react89 = require("react");
var useCardPagination = ({
  totalCount,
  cardsPerPage
}) => {
  const [currentPageIndex, setCurrentPageIndex] = (0, import_react89.useState)(0);
  const [animationDirection, setAnimationDirection] = (0, import_react89.useState)(null);
  const totalPages = Math.ceil(totalCount / cardsPerPage);
  const handlePageChange = (0, import_react89.useCallback)(
    (newPageIndex) => {
      if (newPageIndex > currentPageIndex) {
        setAnimationDirection("right");
      } else if (newPageIndex < currentPageIndex) {
        setAnimationDirection("left");
      }
      setCurrentPageIndex(newPageIndex);
    },
    [currentPageIndex]
  );
  const handleNextPage = (0, import_react89.useCallback)(() => {
    if (currentPageIndex < totalPages - 1) {
      handlePageChange(currentPageIndex + 1);
    }
  }, [currentPageIndex, totalPages, handlePageChange]);
  const handlePreviousPage = (0, import_react89.useCallback)(() => {
    if (currentPageIndex > 0) {
      handlePageChange(currentPageIndex - 1);
    }
  }, [currentPageIndex, handlePageChange]);
  (0, import_react89.useEffect)(() => {
    if (animationDirection) {
      const timer = setTimeout(() => setAnimationDirection(null), 300);
      return () => {
        clearTimeout(timer);
      };
    }
    return void 0;
  }, [animationDirection]);
  return {
    currentPageIndex,
    totalPages,
    animationDirection,
    handleNextPage,
    handlePreviousPage,
    canGoNext: currentPageIndex < totalPages - 1,
    canGoPrevious: currentPageIndex > 0
  };
};

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/components/DeveloperCards.tsx
var import_jsx_runtime125 = require("react/jsx-runtime");
var DeveloperCards = ({
  title,
  cards,
  t,
  theme,
  isRestricted,
  onRestrictedFieldClick
}) => {
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const cardsPerPage = isMobile ? 1 : 2;
  const pagination = useCardPagination({
    totalCount: cards.length,
    cardsPerPage
  });
  const start = pagination.currentPageIndex * cardsPerPage;
  const end = start + cardsPerPage;
  const cardsToShow = cards.slice(start, end);
  const handleUpgradeClick = onRestrictedFieldClick || (() => {
  });
  return /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(Flex_default, { flex: 1, flexDirection: "column", alignItems: "stretch", w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(Flex_default, { flexGrow: 1, flex: 1, w: "100%", mb: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(Text_default, { ...isMobile ? { lg: true } : { xl: true }, color: theme.colors.gr1, semibold: true, children: title }),
      pagination.totalPages > 1 && /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(Flex_default, { flex: 1, alignItems: "center", justifyContent: "flex-end", children: [
        /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
          Button_default,
          {
            w: 32,
            h: 32,
            variation: "flat",
            icon: "chevronLeft",
            iconProps: {
              size: 32,
              color: pagination.currentPageIndex === 0 ? theme.colors.gr6 : theme.colors.gr1
            },
            disabled: !pagination.canGoPrevious,
            onClick: pagination.handlePreviousPage
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(Text_default, { color: theme.colors.gr1, children: `${pagination.currentPageIndex + 1}/${pagination.totalPages}` }),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
          Button_default,
          {
            w: 32,
            h: 32,
            variation: "flat",
            icon: "chevronRight",
            iconProps: {
              size: 32,
              color: pagination.canGoNext ? theme.colors.gr1 : theme.colors.gr6
            },
            disabled: !pagination.canGoNext,
            onClick: pagination.handleNextPage
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(Box_default, { overflow: "hidden", w: "100%", p: 2, children: /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(AnimatedCardRow, { direction: pagination.animationDirection, children: cardsToShow.map((card, index2) => /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
      InfoCard,
      {
        logoUrl: card.logoUrl,
        name: card.name,
        website: card.website,
        isRestricted,
        onWebsiteClick: () => card.website && window.open(card.website, "_blank"),
        onUpgradeClick: handleUpgradeClick,
        t,
        theme,
        isMobile
      },
      card._id || `dev-${index2}`
    )) }) })
  ] });
};

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/components/SalesTeamCards.tsx
var import_jsx_runtime126 = require("react/jsx-runtime");
var SalesTeamCards = ({
  title,
  cards,
  t,
  theme,
  isRestricted,
  onRestrictedFieldClick
}) => {
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const cardsPerPage = isMobile ? 1 : 2;
  const pagination = useCardPagination({
    totalCount: cards.length,
    cardsPerPage
  });
  const start = pagination.currentPageIndex * cardsPerPage;
  const end = start + cardsPerPage;
  const cardsToShow = cards.slice(start, end);
  const handleUpgradeClick = onRestrictedFieldClick || (() => {
  });
  return /* @__PURE__ */ (0, import_jsx_runtime126.jsxs)(Flex_default, { flex: 1, flexDirection: "column", alignItems: "stretch", w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime126.jsxs)(Flex_default, { flexGrow: 1, flex: 1, w: "100%", mb: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(Flex_default, { flex: 1, children: /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(Text_default, { ...isMobile ? { lg: true } : { xl: true }, color: theme.colors.n90, semibold: true, children: title }) }),
      pagination.totalPages > 1 && /* @__PURE__ */ (0, import_jsx_runtime126.jsxs)(Flex_default, { flex: 1, alignItems: "center", justifyContent: "flex-end", children: [
        /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
          Button_default,
          {
            w: 32,
            h: 32,
            variation: "flat",
            icon: "chevronLeft",
            iconProps: {
              size: 32,
              color: pagination.currentPageIndex === 0 ? theme.colors.n70 : theme.colors.n90
            },
            disabled: !pagination.canGoPrevious,
            onClick: pagination.handlePreviousPage
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(Text_default, { color: theme.colors.n90, children: `${pagination.currentPageIndex + 1}/${pagination.totalPages}` }),
        /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
          Button_default,
          {
            w: 32,
            h: 32,
            variation: "flat",
            icon: "chevronRight",
            iconProps: {
              size: 32,
              color: pagination.canGoNext ? theme.colors.n90 : theme.colors.n70
            },
            disabled: !pagination.canGoNext,
            onClick: pagination.handleNextPage
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(Box_default, { overflow: "hidden", w: "100%", p: 2, children: /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(AnimatedCardRow, { direction: pagination.animationDirection, children: cardsToShow.map((saleTeamItem, index2) => {
      const saleTeam = saleTeamItem?.saleTeam;
      if (!saleTeam)
        return null;
      return /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
        InfoCard,
        {
          logoUrl: saleTeam.logoFile?.publicUrl,
          name: saleTeam.name,
          website: saleTeam.website,
          isRestricted,
          onWebsiteClick: () => saleTeam.website && window.open(saleTeam.website, "_blank"),
          onUpgradeClick: handleUpgradeClick,
          phone: saleTeam.phone,
          renderPhoneField: (props) => renderPhoneField({
            ...props,
            theme
          }),
          salesAssociates: saleTeamItem.saleAssociates,
          t,
          theme,
          isMobile
        },
        saleTeam._id || `sale-${index2}`
      );
    }) }) })
  ] });
};

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/DeveloperInfoSection.tsx
var import_dash_common41 = require("dash-common");
var import_jsx_runtime127 = require("react/jsx-runtime");
var Container6 = (0, import_styled_components130.default)(Flex_default)`
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: stretch;
    & > div {
      width: 100%;
      margin-bottom: ${({ theme }) => theme.space * 4}px;
    }
  }
  flex-direction: column;
  gap: ${({ theme }) => theme.space * 6}px;
  width: 100%;
`;
var DeveloperInfoSection = ({
  property,
  isSaleTeamVisible = true,
  isRestricted = false,
  onRestrictedFieldClick
}) => {
  const { t } = (0, import_react_i18next43.useTranslation)(["common", "pages"]);
  const theme = (0, import_styled_components130.useTheme)();
  const { primaryOrganization, organizations } = property;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const organizationsToShow = (0, import_react90.useMemo)(
    () => [primaryOrganization, ...organizations || []],
    [primaryOrganization, organizations]
  );
  const handleUpgradeClick = onRestrictedFieldClick || (() => {
  });
  const isRent = property?.transactionType === import_dash_common41.PropertyTransactionTypesEnum.FOR_RENT;
  return /* @__PURE__ */ (0, import_jsx_runtime127.jsxs)(import_jsx_runtime127.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(Text_default, { ...isMobile ? { xl: true } : { xxl: true }, semibold: true, color: theme.colors.gr1, children: t("pages:propertyPage.developmentAndSalesLabel") }),
    /* @__PURE__ */ (0, import_jsx_runtime127.jsxs)(Container6, { mt: 6, children: [
      /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(
        DeveloperCards,
        {
          title: t`pages:propertyPreviewPage:developerInfoLabel`,
          cards: organizationsToShow,
          t,
          theme,
          isRestricted,
          onRestrictedFieldClick: handleUpgradeClick
        }
      ),
      property.saleTeams && property.saleTeams?.length > 0 && isSaleTeamVisible && /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(
        SalesTeamCards,
        {
          title: isRent ? t`pages:propertyPreviewPage:propertyManagementLabel` : t`pages:propertyPreviewPage:salesTeamLabel`,
          cards: property.saleTeams,
          t,
          theme,
          isRestricted,
          onRestrictedFieldClick: handleUpgradeClick
        }
      )
    ] })
  ] });
};
var DeveloperInfoSection_default = DeveloperInfoSection;

// src/components/molecules/PropertyPreviewComponents/FeaturesAndAmenitiesList/FeaturesAndAmenitiesList.tsx
var import_react92 = require("react");
var import_styled_components133 = __toESM(require("styled-components"));
var import_react_i18next46 = require("react-i18next");

// src/components/molecules/PropertyPreviewComponents/FeaturesAndAmenitiesList/components/FeatureAndAmenitiesModal/FeatureAndAmenitiesModal.tsx
var import_react_i18next44 = require("react-i18next");
var import_styled_components131 = __toESM(require("styled-components"));
var import_jsx_runtime128 = require("react/jsx-runtime");
var StyledBox4 = (0, import_styled_components131.default)(Box_default)`
  overflow: auto;
`;
var FeatureAndAmenitiesModal = ({ amenities, isOpen, onRequestClose }) => {
  const theme = (0, import_styled_components131.useTheme)();
  const { t } = (0, import_react_i18next44.useTranslation)("pages");
  return /* @__PURE__ */ (0, import_jsx_runtime128.jsx)(
    Modal3,
    {
      closeIcon: true,
      isOpen,
      onRequestClose,
      title: t("propertyPage.amenitiesTabLabel") || "",
      children: /* @__PURE__ */ (0, import_jsx_runtime128.jsx)(StyledBox4, { h: 420, mt: 7, children: amenities.map((amenity) => /* @__PURE__ */ (0, import_jsx_runtime128.jsxs)(Flex_default, { alignItems: "center", mb: 6, w: 250, children: [
        /* @__PURE__ */ (0, import_jsx_runtime128.jsx)(Image_default, { mr: 3, src: amenity.imageUrl || "", alt: amenity.name, size: 24 }),
        /* @__PURE__ */ (0, import_jsx_runtime128.jsx)(Text_default, { color: theme.colors.n80, children: amenity.name })
      ] }, amenity._id)) })
    }
  );
};
var FeatureAndAmenitiesModal_default = FeatureAndAmenitiesModal;

// src/components/molecules/PropertyPreviewComponents/FeaturesAndAmenitiesList/components/AmenitiesCTACard/AmenitiesCTACard.tsx
var import_styled_components132 = __toESM(require("styled-components"));
var import_react_i18next45 = require("react-i18next");
var import_jsx_runtime129 = require("react/jsx-runtime");
var StyledCTAButton = import_styled_components132.default.button`
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  border: 2px dashed ${({ theme }) => theme.colors.n40};
  position: relative;
  overflow: hidden;
  padding: ${({ theme }) => theme.space * 4}px ${({ theme }) => theme.space * 3}px;
  background: transparent;
  text-align: left;
  font: inherit;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.b50};
    outline-offset: 2px;
  }
`;
var FrostedOverlay = (0, import_styled_components132.default)(Box_default)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.15);
  -webkit-backdrop-filter: blur(5px); /* Webkit browsers (Safari, older Chrome) */
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space * 1.5}px;
`;
var UpgradeButton = (0, import_styled_components132.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b50};
  padding: ${({ theme }) => theme.space * 1.5}px ${({ theme }) => theme.space * 5}px;
  border-radius: 20px;
  cursor: pointer;
`;
var IconTextContainer = (0, import_styled_components132.default)(Flex_default)`
  gap: ${({ theme }) => theme.space * 0.75}px;
`;
var AmenitiesCTACard = ({
  amenity,
  totalCount,
  shownCount,
  onClick
}) => {
  const theme = (0, import_styled_components132.useTheme)();
  const { t } = (0, import_react_i18next45.useTranslation)("pages");
  const hiddenCount = totalCount - shownCount;
  const ariaLabel = t("propertyPage.lockedAmenitiesAriaLabel", {
    count: hiddenCount
  });
  return /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(
    StyledCTAButton,
    {
      onClick,
      "aria-label": ariaLabel,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(Flex_default, { alignItems: "center", "aria-hidden": "true", children: [
          /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
            Image_default,
            {
              mr: 3,
              src: amenity.imageUrl || "",
              alt: "",
              size: 24,
              fit: "scale-down"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Text_default, { color: theme.colors.n80, children: amenity.name })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(FrostedOverlay, { "aria-hidden": "true", children: [
          /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(IconTextContainer, { alignItems: "center", children: [
            /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Icon_default, { name: "lock", color: theme.colors.n70, size: 18 }),
            /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Text_default, { color: theme.colors.n80, sm: true, children: t("propertyPage.seeMoreAmenities", { count: hiddenCount }) })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(UpgradeButton, { children: /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Text_default, { color: "white", sm: true, children: t("propertyPage.startFreeTrial") }) })
        ] })
      ]
    }
  );
};
var AmenitiesCTACard_default = AmenitiesCTACard;

// src/components/molecules/PropertyPreviewComponents/FeaturesAndAmenitiesList/hooks/useAmenitiesDisplay.ts
var import_react91 = require("react");
var MOBILE_AMENITIES_PREVIEW_COUNT = 6;
var DESKTOP_AMENITIES_PREVIEW_COUNT = 8;
var useAmenitiesDisplay = ({
  amenities,
  isMobile,
  maxAmenities
}) => {
  return (0, import_react91.useMemo)(() => {
    let displayCount;
    let showCTA = false;
    if (maxAmenities && amenities.length > maxAmenities) {
      displayCount = maxAmenities - 1;
      showCTA = true;
    } else if (isMobile) {
      displayCount = MOBILE_AMENITIES_PREVIEW_COUNT;
    } else {
      if (amenities.length > DESKTOP_AMENITIES_PREVIEW_COUNT) {
        displayCount = DESKTOP_AMENITIES_PREVIEW_COUNT;
      } else {
        displayCount = amenities.length;
      }
    }
    return {
      slicedAmenitiesList: amenities.slice(0, displayCount),
      fullAmenitiesList: amenities,
      showUpgradeCTA: showCTA,
      totalCount: amenities.length
    };
  }, [amenities, isMobile, maxAmenities]);
};

// src/components/molecules/PropertyPreviewComponents/FeaturesAndAmenitiesList/FeaturesAndAmenitiesList.tsx
var import_jsx_runtime130 = require("react/jsx-runtime");
var GridBox = (0, import_styled_components133.default)(Box_default)`
  display: grid;
  max-width: 960px;
  grid-template-columns: repeat(auto-fit, minmax(max(45%, 256px), 1fr));
  /* Tighter column gap when CTA card is present to fit more content */
  column-gap: ${({ theme, $hasMore }) => theme.space * ($hasMore ? 3 : 6)}px;
  /* Standard vertical spacing between amenity rows */
  row-gap: ${({ theme }) => theme.space * 6}px;
`;
var StyledButton4 = (0, import_styled_components133.default)(Button_default)`
  background-color: ${({ theme }) => theme.colors.gr7};
  border-color: ${({ theme }) => theme.colors.gr7};

  & p {
    color: ${({ theme }) => theme.colors.gr2};
  }

  :hover {
    background-color: ${({ theme }) => theme.colors.gr6};
    border-color: ${({ theme }) => theme.colors.gr6};
    color: ${({ theme }) => theme.colors.gr2};
  }
`;
var AmenityItem = (0, import_styled_components133.default)(Flex_default)`
  max-width: 300px;
  /* Align amenities with CTA card content vertically */
  padding-top: ${({ theme, $alignWithCTA }) => $alignWithCTA ? `${theme.space * 4}px` : "0"};
`;
var FeatureAndAmenitiesList = ({
  amenities,
  loading,
  maxAmenities,
  totalAmenitiesCount,
  onViewMoreAmenitiesRestricted
}) => {
  const [isOpen, setIsOpen] = (0, import_react92.useState)(false);
  const { t } = (0, import_react_i18next46.useTranslation)("pages");
  const theme = (0, import_styled_components133.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const { slicedAmenitiesList, fullAmenitiesList, showUpgradeCTA, totalCount } = useAmenitiesDisplay({
    amenities,
    isMobile,
    maxAmenities
  });
  if (!loading && !amenities.length) {
    return /* @__PURE__ */ (0, import_jsx_runtime130.jsxs)(Box_default, { pos: "relative", children: [
      /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(Text_default, { semibold: true, ...isMobile ? { xl: true } : { xxl: true }, color: theme.colors.gr1, children: t("propertyPage.amenitiesTabLabel") }),
      /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(Box_default, { mt: 2, children: /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(Text_default, { children: t("common:labels.noValue") }) })
    ] });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime130.jsxs)(Box_default, { pos: "relative", children: [
    " ",
    /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(
      FeatureAndAmenitiesModal_default,
      {
        isOpen,
        onRequestClose: () => setIsOpen(false),
        amenities: fullAmenitiesList
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(Text_default, { semibold: true, ...isMobile ? { xl: true } : { xxl: true }, color: theme.colors.gr1, children: t("propertyPage.amenitiesTabLabel") }),
    /* @__PURE__ */ (0, import_jsx_runtime130.jsxs)(GridBox, { mt: showUpgradeCTA ? 4 : 8, $hasMore: showUpgradeCTA, children: [
      slicedAmenitiesList.map((amenity) => /* @__PURE__ */ (0, import_jsx_runtime130.jsxs)(AmenityItem, { alignItems: "flex-start", $alignWithCTA: showUpgradeCTA, children: [
        /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(
          Image_default,
          {
            mr: 3,
            src: amenity.imageUrl || "",
            alt: amenity.name,
            size: 24,
            fit: "scale-down"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(Text_default, { color: theme.colors.n80, children: amenity.name })
      ] }, amenity._id)),
      showUpgradeCTA && onViewMoreAmenitiesRestricted && /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(
        AmenitiesCTACard_default,
        {
          amenity: amenities[(maxAmenities || 0) - 1],
          totalCount: totalAmenitiesCount || totalCount,
          shownCount: (maxAmenities || 0) - 1,
          onClick: onViewMoreAmenitiesRestricted
        }
      )
    ] }),
    !showUpgradeCTA && (isMobile && totalCount > MOBILE_AMENITIES_PREVIEW_COUNT || totalCount > DESKTOP_AMENITIES_PREVIEW_COUNT) && /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(
      StyledButton4,
      {
        onClick: () => setIsOpen(true),
        mt: 6,
        minWidth: isMobile ? "100%" : "",
        children: t("propertyPage.showFeaturesAndAmenities")
      }
    ),
    loading && /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(Spinner_default, { fullContent: true, bgColor: theme.colors.n20, size: 32 })
  ] });
};
var FeaturesAndAmenitiesList_default = FeatureAndAmenitiesList;

// src/components/molecules/PropertyPreviewComponents/GeneralInfoSection/GeneralInfoSection.tsx
var import_react_i18next47 = require("react-i18next");
var import_styled_components134 = require("styled-components");
var import_jsx_runtime131 = require("react/jsx-runtime");
var GeneralInfoSection = ({
  property,
  containerRef
}) => {
  const { t } = (0, import_react_i18next47.useTranslation)(["common"]);
  const theme = (0, import_styled_components134.useTheme)();
  const { projectDetails, overview } = property;
  const {
    devices: { isMobile }
    // eslint-disable-next-line react-hooks/rules-of-hooks
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(Flex_default, { flexDirection: "column", ref: containerRef, children: [
    /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Flex_default, { mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Text_default, { ...isMobile ? { lg: true } : { xl: true }, color: theme.colors.n90, semibold: true, children: t`common:labels:highlights` }) }),
    /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Flex_default, { mt: 2, flexDirection: "column", children: /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(ExpandableText_default, { lineClamp: 6, color: theme.colors.n80, children: overview || t("common:labels.noValue") }) }),
    /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Flex_default, { mt: 8, children: /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
      Text_default,
      {
        ...isMobile ? { lg: true } : { xl: true },
        color: theme.colors.n90,
        semibold: true,
        children: t`forms:labels:projectDetails`
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Flex_default, { mt: 2, flexDirection: "column", children: /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(ExpandableText_default, { lineClamp: 6, color: theme.colors.n80, children: projectDetails || t("common:labels.noValue") }) })
  ] });
};
var GeneralInfoSection_default = GeneralInfoSection;

// src/components/molecules/PropertyPreviewComponents/MapSection/MapSection.tsx
var import_styled_components135 = __toESM(require("styled-components"));
var import_jsx_runtime132 = require("react/jsx-runtime");
var Container7 = (0, import_styled_components135.default)(Box_default)`
  border-radius: ${({ theme }) => theme.space}px;
  overflow: hidden;
  height: ${({ $height }) => $height || "auto"};
  display: flex;
  flex-direction: column;
  flex: 1;
`;
var MapSection = ({
  property,
  h,
  disableMapScroll = false,
  isIdxView = false
}) => {
  const isReady = useGoogleApiLoader();
  const [lng, lat] = property.location.geoLocation?.coordinates || [];
  const position = lat && lng ? { lat, lng } : void 0;
  return isReady ? /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(Container7, { $height: h || 400, children: /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(
    GoogleMap_default,
    {
      h: h || 400,
      center: position,
      disableScroll: disableMapScroll,
      isIdxView,
      children: position && /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(Marker_default, { position })
    }
  ) }) : /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(Spinner_default, {});
};
var MapSection_default = MapSection;

// src/components/molecules/PropertyPreviewComponents/NameSection/NameSection.tsx
var import_lodash21 = require("lodash");
var import_styled_components136 = require("styled-components");
var import_react_i18next48 = require("react-i18next");
var import_dash_common42 = require("dash-common");
var import_react93 = require("react");
var import_jsx_runtime133 = require("react/jsx-runtime");
function NameSection({ property }) {
  const { t } = (0, import_react_i18next48.useTranslation)(["common", "pages", "forms"]);
  const theme = (0, import_styled_components136.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const {
    location,
    priceRange,
    marketArea,
    projectStatus,
    yearBuilt,
    averageBedroomsNumberValue,
    averageBathroomsNumberValue
  } = property;
  const isComingSoon = (0, import_react93.useMemo)(() => projectStatus === import_dash_common42.ProjectStatusesEnum.COMING_SOON, [property]);
  const isCompleted = (0, import_react93.useMemo)(() => projectStatus === import_dash_common42.ProjectStatusesEnum.COMPLETED, [property]);
  return /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { flexDirection: "column", flex: 1, children: [
    /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { mt: 2, alignItems: "center", flexWrap: "wrap-reverse", children: [
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Box_default, { mr: 3, children: /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { ...isMobile ? { lg: true } : { xl: true }, bold: true, color: theme.colors.n90, children: property.name }) }),
      /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { mb: [1, 0, 0, 0], children: [
        isComingSoon && /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
          Badge_default,
          {
            title: t("common:labels.comingSoon"),
            bgColor: theme.colors.setOpacity(theme.colors.b30, 70),
            titleColor: theme.colors.b50,
            mr: 3,
            square: true
          }
        ),
        projectStatus === "PROPOSED" && /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
          Badge_default,
          {
            title: t("common:labels.proposed"),
            square: true,
            mr: 3,
            bgColor: theme.colors.setOpacity(theme.colors.b30, 70),
            titleColor: theme.colors.b50
          }
        ),
        property.transactionType && /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
          Badge_default,
          {
            type: "neutralSolid",
            mr: 3,
            square: true,
            bgColor: theme.colors.setOpacity(theme.colors.b60, 70),
            title: t(
              `forms:labels.propertyTransactionTypes.${(0, import_lodash21.camelCase)(property.transactionType)}`
            )
          }
        ),
        marketArea && /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
          Badge_default,
          {
            type: "neutralSolid",
            square: true,
            bgColor: theme.colors.setOpacity(theme.colors.b50, 70),
            title: marketArea?.name || ""
          }
        ),
        [import_dash_common42.CmsStatusEnum.NEW_LISTING, import_dash_common42.CmsStatusEnum.RECENTLY_UPDATED].includes(
          property.cmsStatus
        ) && /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
          Badge_default,
          {
            type: "neutralSolid",
            ml: 3,
            square: true,
            bgColor: theme.colors.setOpacity(theme.colors.g20, 70),
            title: t(`common:labels.${property.cmsStatus?.toLowerCase()}`)
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { w: "100%", alignItems: "center", mt: 2, flexWrap: "wrap", children: [
      !isComingSoon && /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(import_jsx_runtime133.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { lg: true, color: theme.colors.n90, ellipsis: true, "data-tooltip-id": `price-${property._id}`, children: (0, import_dash_common42.formatPriceRange)(
          priceRange?.min || 0,
          priceRange?.max || 0,
          {
            shortMin: true,
            shortMax: true,
            prefix: t("common:labels:from") || ""
          },
          {
            maximumFractionDigits: 2
          }
        ) || t("common:labels:noValue") }) }),
        /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Devider_default, { mx: 2, h: 10, size: 2, orientation: "vertical", color: theme.colors.n60 }),
        /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Icon_default, { name: "bedroom", mr: 1, size: 24, color: theme.colors.n90 }),
          /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { lg: true, ellipsis: true, "data-testid": "bedrooms", children: formatBedroomsRangeValues(averageBedroomsNumberValue, {
            isNullable: averageBedroomsNumberValue?.min === 0,
            t
          }) || t("common:labels:noValue") })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Devider_default, { mx: 2, h: 10, size: 2, orientation: "vertical", color: theme.colors.n60 }),
        /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Icon_default, { name: "bathroom", mr: 1, size: 24, color: theme.colors.n80 }),
          /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { lg: true, ellipsis: true, "data-testid": "bathrooms", children: formatBathroomsRangeValues(averageBathroomsNumberValue, {
            isNullable: averageBathroomsNumberValue?.min === 0,
            t
          }) || t("common:labels.noValue") })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Devider_default, { mx: 2, h: 10, size: 2, orientation: "vertical", color: theme.colors.n60 })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { overflow: "hidden", alignItems: isMobile ? "flex-start" : "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Flex_default, { alignItems: "center", mt: [1, 0, 0, 0], children: /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Icon_default, { color: theme.colors.n90, name: "pin", mr: [1, 2, 2, 2] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { ellipsis: false, lg: true, color: theme.colors.n90, "data-testid": "address", children: location?.address ? (0, import_dash_common42.formatAddress)(location.address) : "" })
      ] })
    ] }),
    projectStatus && /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Flex_default, { mt: 2, children: /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Text_default, { color: theme.colors.n70, "data-testid": "project-status", children: [
      !isComingSoon && !isCompleted && t(`forms:labels:projectStatuses:${(0, import_lodash21.camelCase)(projectStatus)}`),
      yearBuilt ? isComingSoon || isCompleted ? t(
        `pages:propertyPage:${projectStatus === import_dash_common42.ProjectStatusesEnum.NEW_CONSTRUCTION || isCompleted ? "completedIn" : "estCompletion"}`,
        {
          date: yearBuilt
        }
      ) : `, ${t(
        `pages:propertyPage:${projectStatus === import_dash_common42.ProjectStatusesEnum.NEW_CONSTRUCTION || isCompleted ? "completedIn" : "estCompletion"}`,
        {
          date: yearBuilt
        }
      )}` : ""
    ] }) })
  ] });
}
var NameSection_default = NameSection;

// src/components/molecules/PropertyPreviewComponents/PropertyNavigationTabs/PropertyNavigationTabs.tsx
var import_react94 = require("react");
var import_react_i18next49 = require("react-i18next");
var import_styled_components137 = __toESM(require("styled-components"));
var import_jsx_runtime134 = require("react/jsx-runtime");
var TabsWrapper = import_styled_components137.default.div`
  background-color: ${({ theme }) => theme.colors.n20};
  width: 100%;
  top: ${({ isViewAsClient, top }) => top ? `${top}px` : isViewAsClient ? "50px" : "107px"};
  position: sticky;
  margin-top: 12px;
  z-index: 3;
  background-color: transparent;
`;
var PropertyNavigationTabs = ({
  isViewAsClient,
  isSeeker,
  brandedFilesReady,
  navigationElementsRefs,
  top
}) => {
  const { t } = (0, import_react_i18next49.useTranslation)(["common", "pages"]);
  const [activeTab, setActiveTab] = (0, import_react94.useState)("GENERAL" /* GENERAL */);
  const { devices } = useScreenResolution();
  const [generalInfoRef, additionalInfoRef, marketingFilesInfoRef] = navigationElementsRefs;
  const visibleElements = {
    ["GENERAL" /* GENERAL */]: useIsVisible(generalInfoRef, "-50px"),
    ["ADDITIONAL" /* ADDITIONAL */]: useIsVisible(additionalInfoRef, "-50px"),
    ["MARKETING" /* MARKETING */]: useIsVisible(marketingFilesInfoRef, "-50px")
  };
  const tabElementsRefs = {
    ["GENERAL" /* GENERAL */]: generalInfoRef,
    ["ADDITIONAL" /* ADDITIONAL */]: additionalInfoRef,
    ["MARKETING" /* MARKETING */]: marketingFilesInfoRef
  };
  const onTabClick = (tabKey) => {
    const targetElementOffsetTop = tabElementsRefs[tabKey]?.current?.offsetTop;
    if (targetElementOffsetTop) {
      window.scrollTo({
        top: targetElementOffsetTop - 180,
        behavior: "smooth"
      });
    }
  };
  (0, import_react94.useEffect)(() => {
    const firstVisibleKey = Object.keys(visibleElements).find(
      (key) => !!visibleElements[key]
    );
    if (firstVisibleKey) {
      setActiveTab(firstVisibleKey);
    }
  }, [visibleElements]);
  return /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(TabsWrapper, { isViewAsClient, top, children: /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(
    Tabs_default,
    {
      w: "100%",
      isFullWidthTabs: true,
      variation: "primaryRounded",
      tabs: [
        {
          key: "GENERAL" /* GENERAL */,
          label: t`pages:propertyPreviewPage:generalTabLabel`
        },
        {
          key: "ADDITIONAL" /* ADDITIONAL */,
          label: devices.isMobile ? t`pages:propertyPreviewPage:additionalInformationShort` || "" : t`pages:propertyPreviewPage:additionalTabLabel` || ""
        },
        ...!isViewAsClient && !isSeeker ? [
          {
            key: "MARKETING" /* MARKETING */,
            label: t`pages:propertyPreviewPage:marketingTabLabel`
          }
        ] : isSeeker && brandedFilesReady ? [
          {
            key: "MARKETING" /* MARKETING */,
            label: devices.isMobile ? t`pages:propertyPreviewPage:downloadsTabLabel` || "" : t`pages:propertyPreviewPage:propertyDownloadsTabLabel` || ""
          }
        ] : []
      ],
      activeTab,
      onClick: onTabClick
    }
  ) });
};
var PropertyNavigationTabs_default = PropertyNavigationTabs;

// src/components/molecules/PropertyPreviewComponents/PropertyStickyHeader/PropertyStickyHeader.tsx
var import_react95 = require("react");
var import_react_i18next50 = require("react-i18next");
var import_styled_components138 = __toESM(require("styled-components"));
var import_jsx_runtime135 = require("react/jsx-runtime");
var StickyHeaderWrapper = import_styled_components138.default.div`
  position: relative;
  width: 100%;
  ${({ $isPortfolioView }) => $isPortfolioView && `
    height: 0;
  `}
`;
var StickyHeaderContainer = import_styled_components138.default.div`
  position: fixed;
  top: ${({ top, isPortfolioView }) => isPortfolioView ? `${APP_HEADER_HEIGHT}px` : top !== void 0 ? `${top}px` : `${DEFAULT_HEADER_OFFSET}px`};
  ${({ containerWidth, containerLeft, isMobile }) => isMobile ? `left: 0; right: 0; width: 100%;` : containerWidth !== void 0 && containerLeft !== void 0 ? `left: ${containerLeft}px; width: ${containerWidth}px;` : `left: 0; right: 0;`};
  background-color: ${({ theme }) => theme.colors.bluePrimary};
  z-index: 3;
  transition: transform 0.3s ease, opacity 0.3s ease;
  border-radius: ${({ isMobile }) => isMobile ? "0px" : "4px"};

  ${({ isVisible }) => !isVisible && `
    transform: translateY(-100%);
    opacity: 0;
    pointer-events: none;
  `}
`;
var StickyHeaderInner = import_styled_components138.default.div`
  width: 100%;
`;
var ActionsRow = import_styled_components138.default.div`
  padding: ${({ theme }) => theme.space * 2}px 0px;
  background-color: #f8fbfd;

  @media ${({ theme }) => theme.devices.mobile} {
    display: flex;
    justify-content: center;
  }
`;
var TabsRow = import_styled_components138.default.div`
  padding: ${({ theme }) => theme.space * 4}px ${({ theme }) => theme.space * 4}px;
`;
var TabButton = import_styled_components138.default.button`
  background: none;
  border: none;
  border-bottom: 1px solid ${({ theme, isActive }) => isActive ? theme.colors.or1 : "transparent"};
  padding: ${({ theme }) => theme.space * 1}px ${({ theme }) => theme.space * 3}px;
  cursor: pointer;
  font-family: inherit;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.white};
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    border-bottom-color: ${({ theme }) => theme.colors.or1};
    color: ${({ theme }) => theme.colors.white};
  }
`;
var TabText = (0, import_styled_components138.default)(Text_default)`
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ isActive }) => isActive ? "600" : "400"};
  font-size: 16px;

  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }
`;
var VERY_SMALL_SCREEN_BREAKPOINT = 440;
var SMOOTH_SCROLL_TIMEOUT = 1e3;
var DEFAULT_HEADER_OFFSET = 107;
var APP_HEADER_HEIGHT = 50;
var PropertyStickyHeader = ({
  isSeeker,
  isPortfolioView,
  brandedFilesReady = false,
  hideMarketingFiles = false,
  isAddedToMediaKit = false,
  showMediaKit = false,
  showContactInfo,
  showDownloads,
  summaryRef,
  navigationRefs,
  onTabClick,
  top,
  children,
  containerWidth,
  containerLeft,
  showContactTabOnMobilePortfolio = false
}) => {
  const { t } = (0, import_react_i18next50.useTranslation)("pages");
  const [activeTab, setActiveTab] = (0, import_react95.useState)("PROPERTY_INFO" /* PROPERTY_INFO */);
  const [isHeaderVisible, setIsHeaderVisible] = (0, import_react95.useState)(false);
  const [isAutoScrolling, setIsAutoScrolling] = (0, import_react95.useState)(false);
  const { propertyInfoRef, inventoryRef, contactRef, downloadsRef } = navigationRefs;
  const { devices, width } = useScreenResolution();
  const isMobile = devices?.isMobile || false;
  const isVerySmallScreen = width < VERY_SMALL_SCREEN_BREAKPOINT;
  const tabLabels = {
    PROPERTY_INFO: isMobile ? t("propertyPreviewPage.stickyHeader.propertyInfoShort") : t("propertyPreviewPage.stickyHeader.propertyInfo"),
    INVENTORY: t("propertyPreviewPage.stickyHeader.inventory"),
    CONTACT_INFO: isMobile ? t("propertyPreviewPage.stickyHeader.contactInfoShort") : t("propertyPreviewPage.stickyHeader.contactInfo"),
    DOWNLOADS: isMobile ? t("propertyPreviewPage.stickyHeader.downloadsShort") : t("propertyPreviewPage.stickyHeader.downloads")
  };
  const isPropertyInfoVisible = useIsVisible(propertyInfoRef, "-50%");
  const isInventoryVisible = useIsVisible(inventoryRef, "-50%");
  const isContactVisible = useIsVisible(contactRef, "-50%");
  const isDownloadsVisible = useIsVisible(downloadsRef, "-50%");
  (0, import_react95.useEffect)(() => {
    const handleScroll = () => {
      if (summaryRef?.current) {
        const summaryRect = summaryRef.current.getBoundingClientRect();
        const summaryBottom = summaryRect.bottom;
        const shouldBeVisible = summaryBottom < 100;
        setIsHeaderVisible(shouldBeVisible);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [summaryRef]);
  (0, import_react95.useEffect)(() => {
    if (isAutoScrolling)
      return;
    const shouldShowContactTab = showContactInfo !== false && !(isMobile && isPortfolioView);
    const shouldShowDownloadsTab = showDownloads !== false && (!isSeeker || brandedFilesReady) && !hideMarketingFiles;
    const shouldShowInventoryTab = !isVerySmallScreen || isPortfolioView;
    const shouldShowPropertyInfoTab = true;
    if (shouldShowDownloadsTab && isDownloadsVisible) {
      setActiveTab("DOWNLOADS" /* DOWNLOADS */);
    } else if (shouldShowContactTab && isContactVisible) {
      setActiveTab("CONTACT_INFO" /* CONTACT_INFO */);
    } else if (shouldShowInventoryTab && isInventoryVisible) {
      setActiveTab("INVENTORY" /* INVENTORY */);
    } else if (shouldShowPropertyInfoTab) {
      setActiveTab("PROPERTY_INFO" /* PROPERTY_INFO */);
    }
  }, [
    isPropertyInfoVisible,
    isInventoryVisible,
    isContactVisible,
    isDownloadsVisible,
    isAutoScrolling,
    isVerySmallScreen,
    isPortfolioView,
    isMobile,
    isSeeker,
    brandedFilesReady,
    hideMarketingFiles,
    showContactInfo,
    showDownloads
  ]);
  (0, import_react95.useEffect)(() => {
    if (isVerySmallScreen && !isPortfolioView && activeTab === "INVENTORY" /* INVENTORY */) {
      setActiveTab("PROPERTY_INFO" /* PROPERTY_INFO */);
    }
  }, [isVerySmallScreen, activeTab, isPortfolioView]);
  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
    setIsAutoScrolling(true);
    onTabClick(tabKey);
    setTimeout(() => {
      setIsAutoScrolling(false);
    }, SMOOTH_SCROLL_TIMEOUT);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(StickyHeaderWrapper, { $isPortfolioView: isPortfolioView, children: /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
    StickyHeaderContainer,
    {
      top,
      isVisible: isHeaderVisible,
      containerWidth,
      containerLeft,
      isMobile,
      isPortfolioView,
      children: /* @__PURE__ */ (0, import_jsx_runtime135.jsxs)(StickyHeaderInner, { children: [
        children && /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(ActionsRow, { children }),
        /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(TabsRow, { children: /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(Flex_default, { w: "100%", justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime135.jsxs)(Flex_default, { gap: 8, children: [
          /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
            TabButton,
            {
              isActive: activeTab === "PROPERTY_INFO" /* PROPERTY_INFO */,
              onClick: () => handleTabClick("PROPERTY_INFO" /* PROPERTY_INFO */),
              children: /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(TabText, { isActive: activeTab === "PROPERTY_INFO" /* PROPERTY_INFO */, children: tabLabels["PROPERTY_INFO" /* PROPERTY_INFO */] })
            }
          ),
          (!isVerySmallScreen || isPortfolioView) && /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
            TabButton,
            {
              isActive: activeTab === "INVENTORY" /* INVENTORY */,
              onClick: () => handleTabClick("INVENTORY" /* INVENTORY */),
              children: /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(TabText, { isActive: activeTab === "INVENTORY" /* INVENTORY */, children: tabLabels["INVENTORY" /* INVENTORY */] })
            }
          ),
          showContactInfo !== false && (!(isMobile && isPortfolioView) || showContactTabOnMobilePortfolio) && /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
            TabButton,
            {
              isActive: activeTab === "CONTACT_INFO" /* CONTACT_INFO */,
              onClick: () => handleTabClick("CONTACT_INFO" /* CONTACT_INFO */),
              children: /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(TabText, { isActive: activeTab === "CONTACT_INFO" /* CONTACT_INFO */, children: tabLabels["CONTACT_INFO" /* CONTACT_INFO */] })
            }
          ),
          showDownloads !== false && (!isSeeker || brandedFilesReady) && !hideMarketingFiles && (!isPortfolioView || isAddedToMediaKit || showMediaKit || showDownloads === true) && /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
            TabButton,
            {
              isActive: activeTab === "DOWNLOADS" /* DOWNLOADS */,
              onClick: () => handleTabClick("DOWNLOADS" /* DOWNLOADS */),
              children: /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(TabText, { isActive: activeTab === "DOWNLOADS" /* DOWNLOADS */, children: tabLabels["DOWNLOADS" /* DOWNLOADS */] })
            }
          )
        ] }) }) })
      ] })
    }
  ) });
};
var PropertyStickyHeader_default = PropertyStickyHeader;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/InventoryTable.tsx
var import_react102 = require("react");
var import_styled_components147 = require("styled-components");
var import_react_i18next57 = require("react-i18next");

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryContent.tsx
var import_react99 = require("react");
var import_react_i18next53 = require("react-i18next");
var import_styled_components143 = __toESM(require("styled-components"));

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryCard.tsx
var import_react_i18next52 = require("react-i18next");
var import_styled_components140 = __toESM(require("styled-components"));
var import_dash_common43 = require("dash-common");

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/components/UnitInventoryRow.tsx
var import_lodash22 = require("lodash");
var import_styled_components139 = require("styled-components");
var import_react_i18next51 = require("react-i18next");
var import_react96 = require("react");
var import_jsx_runtime136 = require("react/jsx-runtime");
var UnitInventoryRow = ({ unit }) => {
  const theme = (0, import_styled_components139.useTheme)();
  const { t: tDefault } = (0, import_react_i18next51.useTranslation)();
  const {
    averageBedroomsNumber,
    averageBathroomsNumber,
    averageTotalSqft,
    averageInteriorSqft,
    averageExteriorSqft
  } = unit;
  const { hasBeds, hasBaths } = (0, import_react96.useMemo)(() => {
    return {
      hasBeds: !!((0, import_lodash22.isNumber)(averageBedroomsNumber?.min) || (0, import_lodash22.isNumber)(averageBedroomsNumber?.max)),
      hasBaths: !!(averageBathroomsNumber?.min || averageBathroomsNumber?.max),
      hasInterior: !!(averageInteriorSqft?.min || averageInteriorSqft?.max),
      hasExterior: !!(averageExteriorSqft?.min || averageExteriorSqft?.max),
      hasTotal: !!(averageTotalSqft?.min || averageTotalSqft?.max)
    };
  }, [unit]);
  return /* @__PURE__ */ (0, import_jsx_runtime136.jsxs)(Flex_default, { alignItems: "center", children: [
    hasBeds && /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
      TooltipWrapper_default,
      {
        content: formatBedroomsRangeValues(averageBedroomsNumber, {
          isNullable: (averageBedroomsNumber?.min || 0) === 0 && !averageBedroomsNumber?.max,
          t: tDefault
        }),
        children: /* @__PURE__ */ (0, import_jsx_runtime136.jsxs)(
          Flex_default,
          {
            alignItems: "center",
            overflow: "hidden",
            "data-tooltip-id": `${unit._id}-bedrooms`,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(Flex_default, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(Icon_default, { name: "bedroom", size: 24, mr: 1, color: theme.colors.n80 }) }),
              /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(Text_default, { smplus: true, semibold: true, children: formatBedroomsRangeValues(averageBedroomsNumber, {
                isNullable: (averageBedroomsNumber?.min || 0) === 0 && !averageBedroomsNumber?.max,
                t: tDefault
              }) })
            ]
          }
        )
      }
    ),
    hasBaths && /* @__PURE__ */ (0, import_jsx_runtime136.jsxs)(import_jsx_runtime136.Fragment, { children: [
      hasBeds && /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(Devider_default, { orientation: "vertical", h: 16, mx: 2, color: theme.colors.n50 }),
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
        TooltipWrapper_default,
        {
          content: formatBathroomsRangeValues(averageBathroomsNumber, {
            t: tDefault
          }),
          children: /* @__PURE__ */ (0, import_jsx_runtime136.jsxs)(
            Flex_default,
            {
              alignItems: "center",
              overflow: "hidden",
              "data-tooltip-id": `${unit._id}-bathrooms`,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(Flex_default, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(Icon_default, { name: "bathroom", size: 24, mr: 1, color: theme.colors.n80 }) }),
                /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(Text_default, { smplus: true, semibold: true, children: formatBathroomsRangeValues(averageBathroomsNumber, {
                  t: tDefault
                }) })
              ]
            }
          )
        }
      )
    ] })
  ] });
};
var UnitInventoryRow_default = UnitInventoryRow;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryCard.tsx
var import_react97 = require("react");
var import_jsx_runtime137 = require("react/jsx-runtime");
var CardWrapper = (0, import_styled_components140.default)(Box_default)`
  p,
  button {
    white-space: nowrap;
  }
`;
var BorderContainer = (0, import_styled_components140.default)(Flex_default)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
  width: 100%;
`;
var ViewButton = (0, import_styled_components140.default)(Button_default)`
  text-underline-offset: ${({ theme }) => theme.space * 2}px;
`;
var ImageWrapper2 = (0, import_styled_components140.default)(Box_default)`
  left: 0;
  background-color: ${({ theme }) => theme.colors.white};
`;
var InventoryCard = ({
  unit,
  onViewButtonClick
}) => {
  const theme = (0, import_styled_components140.useTheme)();
  const { t } = (0, import_react_i18next52.useTranslation)("tables", {
    keyPrefix: "inventory"
  });
  const { t: tLabels } = (0, import_react_i18next52.useTranslation)("common", {
    keyPrefix: "labels"
  });
  const { t: tDefault } = (0, import_react_i18next52.useTranslation)();
  const { t: tComponents } = (0, import_react_i18next52.useTranslation)("common", { keyPrefix: "components" });
  const {
    devices: { isLaptop }
  } = useScreenResolution();
  const { name, type, startingPrice, highestPrice, floorPlanFile, customRooms, ...rest } = unit;
  const { averageTotalSqft, averageExteriorSqft, averageInteriorSqft } = rest;
  const hasTotal = (0, import_react97.useMemo)(() => !!(averageTotalSqft?.min || averageTotalSqft?.max), [unit]);
  return /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(CardWrapper, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(BorderContainer, { alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(ImageWrapper2, { p: 3, minWidth: 88, children: floorPlanFile && floorPlanFile.thumbnailFileUrl ? /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Image_default, { src: floorPlanFile.thumbnailFileUrl, size: 88 }) : /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(DashPlaceholder_default, { size: 88 }) }),
    /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { w: "100%", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { flexDirection: "column", py: 3, children: [
        " ",
        /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { lg: true, semibold: true, children: name }),
        /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { lg: true, semibold: true, children: type }),
        /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Flex_default, { mt: 1, children: /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(UnitInventoryRow_default, { unit: rest }) }),
        /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { alignItems: "center", children: [
          (startingPrice || highestPrice) && /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Box_default, { mr: 1.5, children: /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Text_default, { smplus: true, color: theme.colors.n70, children: [
              t`lastListedFromShortened`,
              ":"
            ] }) }),
            /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(
              TooltipWrapper_default,
              {
                content: (0, import_dash_common43.formatPriceRange)(startingPrice, highestPrice, {
                  shortMax: false,
                  shortMin: false,
                  prefix: tLabels("from") || ""
                }),
                children: /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Box_default, { maxWidth: isLaptop ? 106 : 180, "data-tooltip-id": `price-${unit._id}`, children: /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { smplus: true, semibold: true, ellipsis: true, children: (0, import_dash_common43.formatPriceRange)(
                  startingPrice,
                  highestPrice,
                  {
                    shortMin: true,
                    shortMax: true
                  },
                  {
                    maximumFractionDigits: 2
                  }
                ) }) })
              }
            )
          ] }),
          customRooms && /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(import_jsx_runtime137.Fragment, { children: [
            (startingPrice || highestPrice) && /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Devider_default, { orientation: "vertical", h: 16, mx: 2, color: theme.colors.n50 }),
            /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { children: [
              /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Box_default, { mr: 1.5, children: /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Text_default, { smplus: true, color: theme.colors.n70, children: [
                t`customRoomsShortened`,
                ":"
              ] }) }),
              /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(TooltipWrapper_default, { content: customRooms, children: /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(
                Box_default,
                {
                  maxWidth: !(startingPrice || highestPrice) ? 150 : isLaptop ? 70 : 95,
                  "data-tooltip-id": `customRooms-${unit._id}`,
                  children: /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { smplus: true, semibold: true, ellipsis: true, children: customRooms })
                }
              ) })
            ] })
          ] }),
          hasTotal && /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(import_jsx_runtime137.Fragment, { children: [
            (customRooms || startingPrice || highestPrice) && /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Devider_default, { orientation: "vertical", h: 16, mx: 2, color: theme.colors.n50 }),
            /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(
              TooltipWrapper_default,
              {
                py: 0,
                content: /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Box_default, { minWidth: "fit-content", w: "100%", px: 2, children: /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { minWidth: "fit-content", flexDirection: "column", w: "100%", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { minWidth: "fit-content", justifyContent: "space-between", w: "100%", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: tComponents("inventory.intSqft") }),
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Box_default, { mx: 1 }),
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: formatGeneralRangeValues(averageInteriorSqft) })
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { color: theme.colors.white, justifyContent: "space-between", w: "100%", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: tComponents("inventory.extSqft") }),
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Box_default, { mx: 1 }),
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: formatGeneralRangeValues(averageExteriorSqft) })
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { justifyContent: "space-between", w: "100%", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: tComponents("inventory.totalSqft") }),
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Box_default, { mx: 1 }),
                    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { color: theme.colors.white, whiteSpace: "nowrap", children: formatGeneralRangeValues(averageTotalSqft) })
                  ] })
                ] }) }),
                children: /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { "data-tooltip-id": `totalSqft-${unit._id}`, children: [
                  /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Box_default, { mr: 2, children: /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Text_default, { smplus: true, color: theme.colors.n70, children: [
                    t`totalSqft`.toUpperCase(),
                    ":"
                  ] }) }),
                  /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(
                    Box_default,
                    {
                      maxWidth: !(customRooms && (startingPrice || highestPrice)) ? 120 : isLaptop ? 90 : 96,
                      overflow: "hidden",
                      children: /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Text_default, { smplus: true, semibold: true, ellipsis: true, children: formatGeneralRangeValues(averageTotalSqft, {
                        t: tDefault
                      }) })
                    }
                  )
                ] })
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(
        ViewButton,
        {
          mr: 3,
          mb: 3,
          ml: 3,
          medium: true,
          md: true,
          lg: true,
          semibold: true,
          disabled: !floorPlanFile,
          onClick: onViewButtonClick,
          children: tLabels`view`
        }
      )
    ] })
  ] }) });
};
var InventoryCard_default = InventoryCard;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/InventoryTable.styles.ts
var import_styled_components142 = __toESM(require("styled-components"));

// src/components/organisms/ListWithPagination/ListWithPagination.tsx
var import_react98 = require("react");
var import_styled_components141 = __toESM(require("styled-components"));
var import_jsx_runtime138 = require("react/jsx-runtime");
var Wrapper = (0, import_styled_components141.default)(Flex_default)`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
  padding-bottom: 8px;
`;
var ListWithPagination = ({
  listProps,
  paginationProps,
  children,
  ...args
}) => {
  const theme = (0, import_styled_components141.useTheme)();
  const { data, loading } = listProps;
  const { state, goToPage, setTotal } = (0, import_react98.useContext)(PaginationContext);
  (0, import_react98.useEffect)(() => {
    if (!data.length && !loading && state.currentPage >= 1) {
      goToPage(state.currentPage - 1);
      setTotal(state.perPage * (state.currentPage - 1));
    }
  }, [data, state, loading]);
  return /* @__PURE__ */ (0, import_jsx_runtime138.jsxs)(Flex_default, { flexDirection: "column", flex: 1, w: "100%", ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(Wrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(List_default, { ...listProps, children }) }),
    /* @__PURE__ */ (0, import_jsx_runtime138.jsxs)(
      Flex_default,
      {
        flex: 1,
        w: "100%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        px: 8,
        children: [
          paginationProps.label && /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(Flex_default, { my: 4, children: /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(
            PaginationInfoLabel,
            {
              label: paginationProps.label || "",
              color: theme.colors.n70
            }
          ) }),
          data.length ? /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(
            Pagination_default,
            {
              my: 4,
              previousButtonLabel: paginationProps.previousButtonLabel,
              nextButtonLabel: paginationProps.nextButtonLabel,
              paginationAction: paginationProps.paginationAction
            }
          ) : null
        ]
      }
    )
  ] });
};
var ListWithPagination_default = ListWithPagination;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/InventoryTable.styles.ts
var containerStyles = import_styled_components142.css`
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
`;
var StyledList = (0, import_styled_components142.default)(ListWithPagination_default)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  display: grid;
  grid-template-columns: 1fr;

  & > div:first-child {
    border-bottom: none;
    padding-bottom: 0;
    overflow: auto;
  }

  & > div:last-child {
    padding: 0 ${({ theme }) => theme.space * 3}px;
  }
`;
var StyledListWithoutPagination = (0, import_styled_components142.default)(Flex_default)`
  ${containerStyles}
  flex-direction: column;
`;
var StyledCard = (0, import_styled_components142.default)(Flex_default)`
  ${containerStyles}
`;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryContent.tsx
var import_jsx_runtime139 = require("react/jsx-runtime");
var ScrollableContainer = (0, import_styled_components143.default)(Box_default)`
  overflow-x: auto;
  width: 100%;
`;
var BlurredPreviewContainer = (0, import_styled_components143.default)(Box_default)`
  position: relative;
  width: 100%;
  isolation: isolate;
  overflow: hidden;
`;
var BlurredCardsWrapper = (0, import_styled_components143.default)(Box_default)`
  filter: blur(4px);
  opacity: 0.6;
  pointer-events: none;
  will-change: transform;
  overflow: hidden;
`;
var LockOverlay = import_styled_components143.default.button`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(4px);
  border: none;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space * 3}px;
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
  will-change: transform;
  transform: translateZ(0);

  &:hover {
    background-color: rgba(255, 255, 255, 0.35);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.b50};
    outline-offset: 2px;
  }
`;
var UpgradeButton2 = (0, import_styled_components143.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b50};
  padding: ${({ theme }) => theme.space * 2}px ${({ theme }) => theme.space * 6}px;
  border-radius: 24px;
  cursor: pointer;
`;
var InventoryContent = ({
  displayData,
  previewData,
  isRestricted,
  hiddenUnitsCount,
  loading,
  emptyStateText,
  onViewMoreUnitsRestricted,
  onViewButtonClick,
  setFileToPreview,
  paginationLabel,
  previousButtonLabel,
  nextButtonLabel
}) => {
  const { t } = (0, import_react_i18next53.useTranslation)("common");
  const theme = (0, import_styled_components143.useTheme)();
  const emptyInventoryCallback = (0, import_react99.useMemo)(() => () => {
  }, []);
  const handleUnitViewClick = (unit) => {
    setFileToPreview(unit.floorPlanFile);
    if (onViewButtonClick) {
      onViewButtonClick();
    }
  };
  if (!loading && !displayData.length) {
    return /* @__PURE__ */ (0, import_jsx_runtime139.jsxs)(StyledCard, { minHeight: 198, w: "100%", justifyContent: "center", alignItems: "center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(
        Icon_default,
        {
          name: "building",
          size: 48,
          color: theme.colors.setOpacity(theme.colors.b50, 20),
          mr: 6.5
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(Box_default, { maxWidth: 360, children: /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(
        "p",
        {
          className: "prose",
          style: { color: theme.colors.n80 },
          dangerouslySetInnerHTML: { __html: emptyStateText ?? "" }
        }
      ) })
    ] });
  }
  if (isRestricted) {
    return /* @__PURE__ */ (0, import_jsx_runtime139.jsxs)(StyledListWithoutPagination, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(ScrollableContainer, { children: /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(List_default, { data: displayData, loading, flexDirection: "column", children: (unit) => /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(InventoryCard_default, { unit, onViewButtonClick: () => handleUnitViewClick(unit) }) }) }),
      onViewMoreUnitsRestricted && previewData.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime139.jsxs)(BlurredPreviewContainer, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(BlurredCardsWrapper, { children: previewData.map((unit) => /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(
          InventoryCard_default,
          {
            unit,
            onViewButtonClick: emptyInventoryCallback
          },
          unit._id
        )) }),
        /* @__PURE__ */ (0, import_jsx_runtime139.jsxs)(
          LockOverlay,
          {
            onClick: onViewMoreUnitsRestricted,
            "aria-label": t("components.inventory.seeMoreUnitsAria", { count: hiddenUnitsCount }) || "",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(Icon_default, { name: "lock", color: theme.colors.n60, size: 40 }),
              /* @__PURE__ */ (0, import_jsx_runtime139.jsxs)(
                Flex_default,
                {
                  flexDirection: "column",
                  alignItems: "center",
                  style: { gap: `${theme.space}px`, textAlign: "center" },
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(Text_default, { color: theme.colors.n90, semibold: true, lg: true, children: t("components.inventory.seeMoreUnits", { count: hiddenUnitsCount }) }),
                    /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(Text_default, { color: theme.colors.n70, sm: true, children: t("components.inventory.viewAllHint") })
                  ]
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(UpgradeButton2, { children: /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(Text_default, { color: "white", semibold: true, sm: true, children: t("pages:propertyPage.startFreeTrial") }) })
            ]
          }
        )
      ] })
    ] });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(
    StyledList,
    {
      listProps: { data: displayData, loading, flexDirection: "column" },
      paginationProps: {
        label: paginationLabel,
        previousButtonLabel,
        nextButtonLabel
      },
      children: (unit) => /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(InventoryCard_default, { unit, onViewButtonClick: () => handleUnitViewClick(unit) })
    }
  );
};
var InventoryContent_default = InventoryContent;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryGrid.tsx
var import_react100 = require("react");
var import_react_i18next55 = require("react-i18next");
var import_styled_components145 = __toESM(require("styled-components"));

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryGridCard.tsx
var import_react_i18next54 = require("react-i18next");
var import_styled_components144 = __toESM(require("styled-components"));
var import_jsx_runtime140 = require("react/jsx-runtime");
var CardWrapper2 = (0, import_styled_components144.default)(Box_default)`
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space * 2}px;
  overflow: hidden;
  transition: all 0.2s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  cursor: ${({ $clickable }) => $clickable ? "pointer" : "default"};

  &:hover {
    transform: scale(1.02);
    border-color: ${({ theme }) => theme.colors.n40};
  }
`;
var ImageContainer = (0, import_styled_components144.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n10};
  padding: ${({ theme }) => theme.space * 5}px;
  min-height: 200px;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  > div {
    width: 100% !important;
    height: auto !important;
  }

  img {
    width: 100% !important;
    height: 160px !important;
    max-height: 160px !important;
    object-fit: cover !important;
    object-position: center !important;
  }
`;
var ContentContainer3 = (0, import_styled_components144.default)(Flex_default)`
  padding: ${({ theme }) => theme.space * 4}px;
  flex-direction: column;
  flex: 1;
`;
var OverlayContainer = (0, import_styled_components144.default)(Box_default)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
`;
var DetailsRow = (0, import_styled_components144.default)(Flex_default)`
  column-gap: ${({ theme }) => theme.space * 5}px;
  row-gap: ${({ theme }) => theme.space * 2}px;
  flex-wrap: wrap;
`;
var InventoryGridCard = ({ unit, onViewButtonClick, overlay }) => {
  const theme = (0, import_styled_components144.useTheme)();
  const { t: tDefault } = (0, import_react_i18next54.useTranslation)();
  const {
    name,
    startingPrice,
    highestPrice,
    floorPlanFile,
    customRooms,
    averageBedroomsNumber,
    averageBathroomsNumber,
    averageTotalSqft,
    averageInteriorSqft,
    averageExteriorSqft
  } = unit;
  const handleCardClick = () => {
    if (floorPlanFile) {
      onViewButtonClick();
    }
  };
  const handleButtonClick = (e) => {
    e.stopPropagation();
    onViewButtonClick();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime140.jsxs)(CardWrapper2, { w: "100%", $clickable: !!floorPlanFile && !overlay, onClick: handleCardClick, children: [
    /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(ImageContainer, { children: floorPlanFile && floorPlanFile.thumbnailFileUrl ? /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Image_default, { src: floorPlanFile.thumbnailFileUrl, alt: name, fit: "cover" }) : /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(DashPlaceholder_default, { size: 160 }) }),
    /* @__PURE__ */ (0, import_jsx_runtime140.jsxs)(ContentContainer3, { gap: 2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Text_default, { xl: true, semibold: true, color: theme.colors.gr1, children: name }),
      /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Box_default, { mt: 1.5, children: /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(InventoryPrice, { startingPrice, highestPrice, fontSize: 16 }) }),
      customRooms && /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Box_default, { mt: 1, children: /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(InventoryCustomRooms, { customRooms, fontSize: 14 }) }),
      /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Box_default, { mt: 3, children: /* @__PURE__ */ (0, import_jsx_runtime140.jsxs)(DetailsRow, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(InventoryBeds, { averageBedroomsNumber }),
        /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(InventoryBaths, { averageBathroomsNumber }),
        /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(
          InventorySqft,
          {
            averageTotalSqft,
            averageInteriorSqft,
            averageExteriorSqft
          }
        )
      ] }) }),
      /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Box_default, { style: { flex: 1 } }),
      /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Button_default, { mt: 2, w: "100%", disabled: !floorPlanFile, onClick: handleButtonClick, children: tDefault("tables:inventory.viewFloorPlan") })
    ] }),
    overlay && /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(OverlayContainer, { children: overlay })
  ] });
};
var InventoryGridCard_default = InventoryGridCard;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryGrid.tsx
var import_jsx_runtime141 = require("react/jsx-runtime");
var containerStyles2 = import_styled_components145.css`
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
`;
var StyledCard2 = (0, import_styled_components145.default)(Flex_default)`
  ${containerStyles2}
  flex-direction: column;
`;
var GridContainer = (0, import_styled_components145.default)(Box_default)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.space * 6}px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl - 1}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    grid-template-columns: 1fr;
  }
`;
var BlurredCardWrapper = (0, import_styled_components145.default)(Box_default)`
  filter: blur(4px);
  pointer-events: none;
  will-change: transform;
`;
var LockOverlay2 = import_styled_components145.default.button`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(4px);
  border: none;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space * 3}px;
  border-radius: ${({ theme }) => theme.space * 2}px;
  cursor: pointer;
  font: inherit;
  will-change: transform;
  transform: translateZ(0);

  &:hover {
    background-color: rgba(255, 255, 255, 0.35);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.b50};
    outline-offset: 2px;
  }
`;
var UpgradeButton3 = (0, import_styled_components145.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b50};
  padding: ${({ theme }) => theme.space * 2}px ${({ theme }) => theme.space * 6}px;
  border-radius: 24px;
  cursor: pointer;
`;
var PaginationContainer = (0, import_styled_components145.default)(Flex_default)`
  width: 100%;
  margin-top: ${({ theme }) => theme.space * 4}px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.space * 2}px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: space-between;
  }
`;
var LoadingOverlay = (0, import_styled_components145.default)(Box_default)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  pointer-events: none;
`;
var RelativeWrapper = (0, import_styled_components145.default)(Box_default)`
  position: relative;
  width: 100%;
`;
var InventoryGrid = ({
  displayData,
  previewData,
  isRestricted,
  hiddenUnitsCount,
  loading,
  emptyStateText,
  onViewMoreUnitsRestricted,
  onViewButtonClick,
  setFileToPreview,
  // paginationLabel,
  previousButtonLabel,
  nextButtonLabel,
  itemsPerPage = 6,
  total
}) => {
  const { t } = (0, import_react_i18next55.useTranslation)("pages");
  const theme = (0, import_styled_components145.useTheme)();
  const { state: paginationState } = (0, import_react100.useContext)(PaginationContext);
  const emptyInventoryCallback = (0, import_react100.useMemo)(() => () => {
  }, []);
  const [hasInitialContent, setHasInitialContent] = (0, import_react100.useState)(false);
  const [isPaginating, setIsPaginating] = (0, import_react100.useState)(false);
  const [displayedData, setDisplayedData] = (0, import_react100.useState)(displayData);
  const previousPageRef = (0, import_react100.useRef)(paginationState.currentPage);
  (0, import_react100.useEffect)(() => {
    if (displayData.length > 0) {
      setHasInitialContent(true);
    }
  }, [displayData.length]);
  (0, import_react100.useEffect)(() => {
    if (hasInitialContent && previousPageRef.current !== paginationState.currentPage) {
      setIsPaginating(true);
      previousPageRef.current = paginationState.currentPage;
    }
  }, [paginationState.currentPage, hasInitialContent]);
  (0, import_react100.useEffect)(() => {
    if (!isPaginating && !loading) {
      setDisplayedData(displayData);
    }
  }, [displayData, isPaginating, loading]);
  (0, import_react100.useEffect)(() => {
    if (!loading && isPaginating) {
      setDisplayedData(displayData);
      setIsPaginating(false);
    }
  }, [loading, isPaginating, displayData]);
  const handleUnitViewClick = (unit) => {
    setFileToPreview(unit.floorPlanFile);
    if (onViewButtonClick) {
      onViewButtonClick(unit);
    }
  };
  const totalPages = total ? Math.ceil(total / itemsPerPage) : Math.ceil(displayData.length / itemsPerPage);
  const currentPage = paginationState.currentPage;
  const showLoadingOverlay = (isPaginating || loading) && hasInitialContent;
  if (!loading && !displayData.length) {
    return /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)(StyledCard2, { minHeight: 198, w: "100%", justifyContent: "center", alignItems: "center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
        Icon_default,
        {
          name: "building",
          size: 48,
          color: theme.colors.setOpacity(theme.colors.b50, 20),
          mr: 6.5
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Box_default, { maxWidth: 360, children: /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
        "p",
        {
          className: "prose",
          style: { color: theme.colors.n80 },
          dangerouslySetInnerHTML: { __html: emptyStateText ?? "" }
        }
      ) })
    ] });
  }
  if (isRestricted) {
    const unitToCopy = previewData.length > 0 ? previewData[0] : displayData[displayData.length - 1];
    const restrictedCardOverlay = onViewMoreUnitsRestricted && unitToCopy ? /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)(import_jsx_runtime141.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(BlurredCardWrapper, { style: { position: "absolute", inset: 0 }, children: /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
        InventoryGridCard_default,
        {
          unit: unitToCopy,
          onViewButtonClick: emptyInventoryCallback
        },
        `restricted-${unitToCopy._id}`
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)(
        LockOverlay2,
        {
          onClick: onViewMoreUnitsRestricted,
          "aria-label": t("propertyPage.seeXMoreUnits", { count: hiddenUnitsCount }) || "",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Icon_default, { name: "lock", color: theme.colors.gr5, size: 40 }),
            /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)(
              Flex_default,
              {
                flexDirection: "column",
                alignItems: "center",
                style: { gap: `${theme.space}px`, textAlign: "center" },
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Text_default, { color: theme.colors.n90, semibold: true, lg: true, children: t("propertyPage.seeXMoreUnitsCaps", { count: hiddenUnitsCount }) }),
                  /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Text_default, { color: theme.colors.n70, sm: true, children: t("propertyPage.viewAllFloorPlansPricingAvailability") })
                ]
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(UpgradeButton3, { children: /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Text_default, { color: "white", semibold: true, sm: true, children: t("propertyPage.startFreeTrial") }) })
          ]
        }
      )
    ] }) : null;
    return /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Flex_default, { flexDirection: "column", children: /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)(GridContainer, { children: [
      displayData.map((unit) => /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
        InventoryGridCard_default,
        {
          unit,
          onViewButtonClick: () => handleUnitViewClick(unit)
        },
        unit._id
      )),
      onViewMoreUnitsRestricted && unitToCopy && /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
        InventoryGridCard_default,
        {
          unit: unitToCopy,
          onViewButtonClick: emptyInventoryCallback,
          overlay: restrictedCardOverlay
        },
        `restricted-${unitToCopy._id}`
      )
    ] }) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)(Flex_default, { flexDirection: "column", children: [
    /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)(RelativeWrapper, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(GridContainer, { children: displayedData.map((unit) => /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
        InventoryGridCard_default,
        {
          unit,
          onViewButtonClick: () => handleUnitViewClick(unit)
        },
        unit._id
      )) }),
      showLoadingOverlay && /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(LoadingOverlay, { children: /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Spinner_default, {}) })
    ] }),
    totalPages > 1 && /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)(PaginationContainer, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Text_default, { color: theme.colors.n70, children: t("propertyPage.showingXOfYUnits", {
        current: Math.min((currentPage + 1) * itemsPerPage, total || displayedData.length),
        total: total || displayedData.length
      }) }),
      /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Pagination_default, { previousButtonLabel, nextButtonLabel })
    ] })
  ] });
};
var InventoryGrid_default = InventoryGrid;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryTableHeader.tsx
var import_styled_components146 = __toESM(require("styled-components"));
var import_react101 = require("react");
var import_react_i18next56 = require("react-i18next");
var import_jsx_runtime142 = require("react/jsx-runtime");
var StyledSortButton = (0, import_styled_components146.default)(Flex_default)`
  border: 1px solid ${({ theme }) => theme.colors.gr4};
  border-radius: 8px;
  padding: ${({ theme }) => theme.space * 2}px ${({ theme }) => theme.space * 3}px;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.n10};
    border-color: ${({ theme }) => theme.colors.gr1};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.b50};
    outline-offset: 2px;
  }
`;
var DropdownItem = (0, import_styled_components146.default)(Text_default).attrs({ as: "span" })`
  color: ${({ theme }) => theme.colors.gr4};
  padding: ${({ theme }) => theme.space * 2}px ${({ theme }) => theme.space * 1}px;
  display: block;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.gr4};
  }
`;
var SortLabel = (0, import_styled_components146.default)(Text_default)`
  color: ${({ theme }) => theme.colors.gr4} !important;
`;
var SortValue = (0, import_styled_components146.default)(Text_default)`
  color: ${({ theme }) => theme.colors.gr4} !important;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    max-width: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    max-width: 120px;
  }
`;
var SwitchButton = (0, import_styled_components146.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  border: 1px solid ${({ theme }) => theme.colors.b20};
`;
var ControlsRow = (0, import_styled_components146.default)(Flex_default)`
  column-gap: 4px;
  row-gap: 16px;
`;
var StyledViewButton = (0, import_styled_components146.default)(Flex_default)`
  background-color: ${({ theme, isActive }) => isActive ? theme.colors.b20 : ""};
  border-radius: ${({ theme }) => theme.space}px;
  cursor: pointer;
`;
var InventoryTableHeader = ({
  onSortChange,
  layout = "table",
  onLayoutChange,
  currentSort
}) => {
  const theme = (0, import_styled_components146.useTheme)();
  const { setSortState } = (0, import_react101.useContext)(SortContext);
  const { t: tLabels } = (0, import_react_i18next56.useTranslation)("common", { keyPrefix: "labels" });
  const { t } = (0, import_react_i18next56.useTranslation)("tables", {
    keyPrefix: "inventory"
  });
  const setSort = onSortChange || ((fieldName, sortOrder) => () => {
    setSortState({ sortOrder, fieldName });
  });
  const getSortLabel = () => {
    if (!currentSort)
      return t`recent`;
    const { fieldName, sortOrder } = currentSort;
    if (fieldName === "createdAt")
      return t`recent`;
    if (fieldName === "startingPrice" && sortOrder === -1)
      return t`priceDown`;
    if (fieldName === "startingPrice" && sortOrder === 1)
      return t`priceUp`;
    return t`recent`;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(Flex_default, { flexDirection: "column", w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(ControlsRow, { w: "100%", alignItems: "center", mb: 6, flexWrap: "wrap", children: /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)(Flex_default, { gap: 12, alignItems: "end", justifyContent: "flex-end", flex: 1, flexWrap: "wrap", children: [
    onLayoutChange && /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)(SwitchButton, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
        StyledViewButton,
        {
          alignItems: "center",
          justifyContent: "center",
          isActive: layout === "grid",
          onClick: () => onLayoutChange("grid"),
          w: 32,
          h: 32,
          children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
            Icon_default,
            {
              name: "dashboard",
              color: layout === "grid" ? theme.colors.b50 : theme.colors.gr6,
              size: 24
            }
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
        StyledViewButton,
        {
          alignItems: "center",
          justifyContent: "center",
          w: 32,
          h: 32,
          isActive: layout === "table",
          onClick: () => onLayoutChange("table"),
          children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
            Icon_default,
            {
              name: "list",
              color: layout === "table" ? theme.colors.b50 : theme.colors.gr6,
              size: 24
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
      DropDown_default,
      {
        placementHorizontal: "left",
        Anchor: ({ isOpen, onClick }) => /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)(
          StyledSortButton,
          {
            isOpen,
            onClick,
            alignItems: "center",
            role: "button",
            tabIndex: 0,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
                Icon_default,
                {
                  name: "sort",
                  size: 16,
                  color: theme.colors.gr4,
                  mr: 2,
                  className: "flex-shrink-0"
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)(Flex_default, { gap: 8, children: [
                /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)(SortLabel, { whiteSpace: "nowrap", children: [
                  tLabels`sortBy`,
                  ": "
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(SortValue, { ellipsis: true, children: getSortLabel() })
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
                Icon_default,
                {
                  name: isOpen ? "arrowUp" : "arrowDown",
                  size: 16,
                  color: theme.colors.gr4,
                  ml: 2,
                  className: "flex-shrink-0"
                }
              )
            ]
          }
        ),
        items: [
          {
            children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(DropdownItem, { children: t`recent` }),
            key: "recent",
            contentCentered: false,
            w: 250,
            onClick: setSort("createdAt", -1)
          },
          {
            children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(DropdownItem, { children: t`priceDown` }),
            key: "priceDown",
            contentCentered: false,
            w: 250,
            onClick: setSort("startingPrice", -1)
          },
          {
            children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(DropdownItem, { children: t`priceUp` }),
            key: "priceUp",
            contentCentered: false,
            w: 250,
            onClick: setSort("startingPrice", 1)
          }
        ]
      }
    ) })
  ] }) }) });
};
var InventoryTableHeader_default = InventoryTableHeader;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/InventoryTable.tsx
var import_jsx_runtime143 = require("react/jsx-runtime");
var ITEMS_PER_PAGE = {
  GRID_MOBILE: 3,
  GRID_DESKTOP: 6,
  TABLE: 5
};
var InventoryTable = ({
  data,
  loading,
  emptyStateText,
  onViewButtonClick,
  onDownloadButtonClick,
  isPortfolioView,
  maxUnits,
  totalUnits,
  onViewMoreUnitsRestricted,
  layout = "table",
  isIdxView = false,
  seeMorePlans,
  ...props
}) => {
  const theme = (0, import_styled_components147.useTheme)();
  const { t } = (0, import_react_i18next57.useTranslation)("tables", {
    keyPrefix: "inventory"
  });
  const { t: tLabels } = (0, import_react_i18next57.useTranslation)("common", { keyPrefix: "labels" });
  const [previewIndex, setPreviewIndex] = (0, import_react102.useState)(-1);
  const [currentLayout, setCurrentLayout] = (0, import_react102.useState)(layout);
  const { resetPagination, setPerPage } = (0, import_react102.useContext)(PaginationContext);
  const { state: sortState } = (0, import_react102.useContext)(SortContext);
  const { devices } = useScreenResolution();
  const isRestricted = maxUnits !== void 0 && totalUnits !== void 0 && totalUnits > maxUnits;
  const displayData = (0, import_react102.useMemo)(
    () => isRestricted ? data.slice(0, maxUnits) : data,
    [isRestricted, data, maxUnits]
  );
  const previewData = (0, import_react102.useMemo)(
    () => isRestricted ? displayData : [],
    // Repeat first 2 units to create the FOMO effect without displaying more data
    [isRestricted, displayData]
  );
  const hiddenUnitsCount = isRestricted ? totalUnits - maxUnits : 0;
  const floorPlanFiles = (0, import_react102.useMemo)(() => {
    return displayData.map((unit) => unit.floorPlanFile).filter((file) => file != null);
  }, [displayData]);
  const inventorySummaries = (0, import_react102.useMemo)(() => {
    return displayData.filter((unit) => unit.floorPlanFile != null).map((unit) => ({
      name: unit.name,
      averageBedroomsNumber: unit.averageBedroomsNumber,
      averageBathroomsNumber: unit.averageBathroomsNumber,
      averageTotalSqft: unit.averageTotalSqft,
      averageInteriorSqft: unit.averageInteriorSqft,
      averageExteriorSqft: unit.averageExteriorSqft,
      startingPrice: unit.startingPrice,
      highestPrice: unit.highestPrice,
      customRooms: unit.customRooms
    }));
  }, [displayData]);
  const itemsPerPage = (0, import_react102.useMemo)(() => {
    if (currentLayout === "grid") {
      return devices.isMobile ? ITEMS_PER_PAGE.GRID_MOBILE : ITEMS_PER_PAGE.GRID_DESKTOP;
    }
    return ITEMS_PER_PAGE.TABLE;
  }, [currentLayout, devices.isMobile]);
  (0, import_react102.useEffect)(() => {
    setPerPage(itemsPerPage);
  }, [itemsPerPage]);
  const handleLayoutChange = (newLayout) => {
    setCurrentLayout(newLayout);
    resetPagination();
  };
  const handleSetFileToPreview = (file) => {
    if (!file) {
      setPreviewIndex(-1);
      return;
    }
    const index2 = floorPlanFiles.findIndex((f) => f._id === file._id);
    if (index2 >= 0) {
      setPreviewIndex(index2);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime143.jsxs)(Box_default, { ...props, pos: "relative", w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(Box_default, { mb: 8, children: /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(
      Text_default,
      {
        semibold: true,
        ...devices.isMobile ? { xl: true } : { xxl: true },
        color: theme.colors.gr1,
        children: tLabels`featuredFloorPlans`
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(
      InventoryTableHeader_default,
      {
        layout: currentLayout,
        onLayoutChange: handleLayoutChange,
        currentSort: sortState
      }
    ),
    currentLayout === "grid" ? /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(Box_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(
      InventoryGrid_default,
      {
        displayData,
        previewData,
        isRestricted,
        hiddenUnitsCount,
        loading,
        emptyStateText,
        onViewMoreUnitsRestricted,
        onViewButtonClick,
        setFileToPreview: handleSetFileToPreview,
        paginationLabel: t`paginationLabel` || "",
        previousButtonLabel: tLabels`previous`,
        nextButtonLabel: tLabels`next`,
        itemsPerPage,
        total: totalUnits
      }
    ) }) : /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(Box_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(
      InventoryContent_default,
      {
        displayData,
        previewData,
        isRestricted,
        hiddenUnitsCount,
        loading,
        emptyStateText,
        onViewMoreUnitsRestricted,
        onViewButtonClick,
        setFileToPreview: handleSetFileToPreview,
        paginationLabel: t`paginationLabel` || "",
        previousButtonLabel: tLabels("previous"),
        nextButtonLabel: tLabels("next")
      }
    ) }),
    seeMorePlans,
    /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(
      FullPageFilePreview_default,
      {
        isOpen: previewIndex >= 0,
        onClose: () => setPreviewIndex(-1),
        files: floorPlanFiles,
        defaultIndex: previewIndex >= 0 ? previewIndex : 0,
        isPortfolioView,
        onDownloadButtonClick: () => {
          if (onDownloadButtonClick) {
            onDownloadButtonClick();
          } else if (previewIndex >= 0 && floorPlanFiles[previewIndex]) {
            downloadFile([floorPlanFiles[previewIndex]._id]);
          }
        },
        isDownloadButtonVisible: props.allowDownloads,
        inventorySummaries,
        isIdxView
      }
    )
  ] });
};
var InventoryTable_default = InventoryTable;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MarketingFiles.tsx
var import_dash_common46 = require("dash-common");
var import_react108 = require("react");
var import_styled_components161 = require("styled-components");
var import_react_i18next62 = require("react-i18next");

// src/components/molecules/TabsWithDropdown/TabsWithDropdown.tsx
var import_react103 = require("react");
var import_react_i18next58 = require("react-i18next");
var import_styled_components149 = require("styled-components");

// src/components/molecules/TabsWithDropdown/TabsWithDropdown.styles.ts
var import_styled_components148 = __toESM(require("styled-components"));
var TabsContainer = import_styled_components148.default.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
`;
var TabsInnerWrapper = (0, import_styled_components148.default)(Box_default)`
  flex: 1;
  overflow: hidden;
  min-width: 0; // Allow flex item to shrink below content size
`;
var MoreButton = (0, import_styled_components148.default)(Box_default)`
  position: relative;
  flex-shrink: 0;
  margin-bottom: 4px;

  button {
    padding: 8px 16px !important;
    height: auto !important;
    min-height: unset !important;
  }
`;
var MobileScrollContainer = import_styled_components148.default.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
`;
var MobileScrollWrapper = import_styled_components148.default.div`
  width: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;
  display: flex;

  /* Hide scrollbar */
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;
var ScrollIndicator = import_styled_components148.default.div`
  position: absolute;
  ${({ position }) => position}: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  background: linear-gradient(
    to ${({ position }) => position === "left" ? "right" : "left"},
    rgba(248, 251, 253, 0.80) 0%,
    rgba(248, 251, 253, 0.2) 100%
  );
  padding: 8px;
  padding-${({ position }) => position === "left" ? "right" : "left"}: 30px;
  pointer-events: none;
  display: flex;
  align-items: center;

  svg {
    pointer-events: auto;
    cursor: pointer;
    background: white;
    border-radius: 50%;
    padding: 2px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;
var DropdownMenu = import_styled_components148.default.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  padding: 4px 0;
  z-index: 3;
  max-height: 400px;
  overflow-y: auto;
`;
var DropdownMenuItem = import_styled_components148.default.button`
  appearance: none;
  border: none;
  background: ${({ active, theme }) => active ? theme.colors.n10 : "transparent"};
  width: 100%;
  padding: 10px 16px;
  text-align: left;
  cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};
  transition: background-color 0.2s;
  display: block;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.n10};
  }

  & p {
    margin: 0;
  }
`;

// src/components/molecules/TabsWithDropdown/TabsWithDropdown.tsx
var import_jsx_runtime144 = require("react/jsx-runtime");
var TabsWithDropdown = ({
  tabs,
  activeTab,
  onClick,
  variation = "secondary",
  activeButtonColor,
  ...props
}) => {
  const { t } = (0, import_react_i18next58.useTranslation)();
  const theme = (0, import_styled_components149.useTheme)();
  const measureRef = (0, import_react103.useRef)(null);
  const dropdownRef = (0, import_react103.useRef)(null);
  const mobileScrollRef = (0, import_react103.useRef)(null);
  const [visibleTabs, setVisibleTabs] = (0, import_react103.useState)(tabs);
  const [overflowTabs, setOverflowTabs] = (0, import_react103.useState)([]);
  const [isDropdownOpen, setIsDropdownOpen] = (0, import_react103.useState)(false);
  const [showLeftScroll, setShowLeftScroll] = (0, import_react103.useState)(false);
  const [showRightScroll, setShowRightScroll] = (0, import_react103.useState)(false);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  useOnClickOutside(dropdownRef, () => {
    setIsDropdownOpen(false);
  });
  const checkScrollIndicators = (0, import_react103.useCallback)(() => {
    if (!mobileScrollRef.current || !isMobile)
      return;
    const { scrollLeft, scrollWidth, clientWidth } = mobileScrollRef.current;
    setShowLeftScroll(scrollLeft > 0);
    setShowRightScroll(scrollLeft + clientWidth < scrollWidth - 5);
  }, [isMobile]);
  const handleMobileScroll = (0, import_react103.useCallback)(() => {
    checkScrollIndicators();
  }, [checkScrollIndicators]);
  const calculateVisibleTabs = (0, import_react103.useCallback)(() => {
    if (isMobile) {
      setVisibleTabs(tabs);
      setOverflowTabs([]);
      return;
    }
    const parentElement = measureRef.current?.parentElement;
    if (!parentElement) {
      setVisibleTabs(tabs);
      setOverflowTabs([]);
      return;
    }
    const parentStyles = window.getComputedStyle(parentElement);
    const hasSpaceBetween = parentStyles.justifyContent === "space-between";
    const reservedSpace = hasSpaceBetween ? 80 : 50;
    const containerWidth = parentElement.offsetWidth - reservedSpace;
    const tempContainer = document.createElement("div");
    tempContainer.style.cssText = "position:absolute;visibility:hidden;display:flex;";
    document.body.appendChild(tempContainer);
    let totalTabsWidth = 0;
    tabs.forEach((tab) => {
      const tempTab = document.createElement("button");
      tempTab.style.cssText = "padding:12px 24px;white-space:nowrap;";
      tempTab.textContent = tab.label || "";
      tempContainer.appendChild(tempTab);
      const tabWidth = tempTab.offsetWidth;
      totalTabsWidth += tabWidth;
      tempContainer.removeChild(tempTab);
    });
    document.body.removeChild(tempContainer);
    if (totalTabsWidth <= containerWidth) {
      setVisibleTabs(tabs);
      setOverflowTabs([]);
      return;
    }
    const moreButtonWidth = 100;
    const availableWidth = containerWidth - moreButtonWidth;
    const tempContainer2 = document.createElement("div");
    tempContainer2.style.cssText = "position:absolute;visibility:hidden;display:flex;";
    document.body.appendChild(tempContainer2);
    let currentWidth = 0;
    const visible = [];
    const overflow = [];
    let stopAdding = false;
    tabs.forEach((tab) => {
      if (stopAdding) {
        overflow.push(tab);
        return;
      }
      const tempTab = document.createElement("button");
      tempTab.style.cssText = "padding:12px 24px;white-space:nowrap;";
      tempTab.textContent = tab.label || "";
      tempContainer2.appendChild(tempTab);
      const tabWidth = tempTab.offsetWidth;
      tempContainer2.removeChild(tempTab);
      if (currentWidth + tabWidth <= availableWidth) {
        currentWidth += tabWidth;
        visible.push(tab);
      } else {
        stopAdding = true;
        overflow.push(tab);
      }
    });
    document.body.removeChild(tempContainer2);
    if (activeTab && overflow.some((t2) => t2.key === activeTab)) {
      const activeTabData = overflow.find((t2) => t2.key === activeTab);
      const activeIndex = overflow.findIndex((t2) => t2.key === activeTab);
      if (activeTabData && visible.length > 0) {
        overflow.splice(activeIndex, 1);
        const removedTabs = [];
        const tempActive = document.createElement("button");
        tempActive.style.cssText = "padding:12px 24px;white-space:nowrap;";
        tempActive.textContent = activeTabData.label || "";
        document.body.appendChild(tempActive);
        const activeTabWidth = tempActive.offsetWidth;
        document.body.removeChild(tempActive);
        let visibleWidth = 0;
        visible.forEach((tab) => {
          const temp = document.createElement("button");
          temp.style.cssText = "padding:12px 24px;white-space:nowrap;";
          temp.textContent = tab.label || "";
          document.body.appendChild(temp);
          visibleWidth += temp.offsetWidth;
          document.body.removeChild(temp);
        });
        while (visible.length > 0 && visibleWidth + activeTabWidth > availableWidth) {
          const removed = visible.pop();
          if (removed) {
            removedTabs.unshift(removed);
            const temp = document.createElement("button");
            temp.style.cssText = "padding:12px 24px;white-space:nowrap;";
            temp.textContent = removed.label || "";
            document.body.appendChild(temp);
            visibleWidth -= temp.offsetWidth;
            document.body.removeChild(temp);
          }
        }
        const originalIndex = tabs.findIndex((t2) => t2.key === activeTab);
        let inserted = false;
        const newVisible = [];
        for (const tab of visible) {
          const tabIndex = tabs.findIndex((t2) => t2.key === tab.key);
          if (!inserted && originalIndex < tabIndex) {
            newVisible.push(activeTabData);
            inserted = true;
          }
          newVisible.push(tab);
        }
        if (!inserted) {
          newVisible.push(activeTabData);
        }
        overflow.unshift(...removedTabs);
        setVisibleTabs(newVisible);
        setOverflowTabs(overflow);
      } else {
        setVisibleTabs(overflow.length > 0 ? visible : tabs);
        setOverflowTabs(overflow);
      }
    } else {
      setVisibleTabs(overflow.length > 0 ? visible : tabs);
      setOverflowTabs(overflow);
    }
  }, [tabs, activeTab, isMobile]);
  (0, import_react103.useEffect)(() => {
    calculateVisibleTabs();
  }, [tabs, activeTab, calculateVisibleTabs]);
  (0, import_react103.useEffect)(() => {
    if (isMobile) {
      checkScrollIndicators();
      const timer = setTimeout(checkScrollIndicators, 100);
      return () => clearTimeout(timer);
    }
    return void 0;
  }, [isMobile, tabs, checkScrollIndicators]);
  const handleTabClick = (key) => {
    onClick(key);
    setIsDropdownOpen(false);
  };
  if (isMobile) {
    return /* @__PURE__ */ (0, import_jsx_runtime144.jsxs)(MobileScrollContainer, { children: [
      showLeftScroll && /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(ScrollIndicator, { position: "left", children: /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
        Icon_default,
        {
          name: "chevronLeft",
          size: 22,
          color: theme.colors.b50,
          onClick: () => {
            if (mobileScrollRef.current) {
              mobileScrollRef.current.scrollLeft -= 100;
            }
          }
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
        MobileScrollWrapper,
        {
          ref: mobileScrollRef,
          onScroll: handleMobileScroll,
          children: /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
            Tabs_default,
            {
              ...props,
              tabs,
              activeTab,
              onClick: handleTabClick,
              variation,
              activeButtonColor,
              withScrollButtons: false
            }
          )
        }
      ),
      showRightScroll && /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(ScrollIndicator, { position: "right", children: /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
        Icon_default,
        {
          name: "chevronRight",
          size: 22,
          color: theme.colors.b50,
          onClick: () => {
            if (mobileScrollRef.current) {
              mobileScrollRef.current.scrollLeft += 100;
            }
          }
        }
      ) })
    ] });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime144.jsxs)(
    "div",
    {
      ref: measureRef,
      style: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: "8px"
      },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
          Tabs_default,
          {
            ...props,
            tabs: visibleTabs,
            activeTab,
            onClick: handleTabClick,
            variation,
            activeButtonColor,
            withScrollButtons: false
          }
        ),
        overflowTabs.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime144.jsxs)(MoreButton, { ref: dropdownRef, children: [
          /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
            Button_default,
            {
              type: "button",
              variation: "flat",
              iconRight: isDropdownOpen ? "chevronUp" : "chevronDown",
              onClick: () => setIsDropdownOpen(!isDropdownOpen),
              children: t("common:labels.more")
            }
          ),
          isDropdownOpen && /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(DropdownMenu, { children: overflowTabs.map((tab) => /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
            DropdownMenuItem,
            {
              active: activeTab === tab.key,
              disabled: tab.disabled,
              onClick: () => !tab.disabled && handleTabClick(tab.key),
              children: /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(Text_default, { semibold: activeTab === tab.key, children: tab.label })
            },
            tab.key
          )) })
        ] })
      ]
    }
  );
};
var TabsWithDropdown_default = TabsWithDropdown;

// src/components/molecules/ResponsivePills/ResponsivePills.tsx
var import_react104 = require("react");
var import_styled_components151 = require("styled-components");
var import_react_i18next59 = require("react-i18next");

// src/components/molecules/ResponsivePills/ResponsivePills.styles.ts
var import_styled_components150 = __toESM(require("styled-components"));
var PillsContainer = (0, import_styled_components150.default)(Flex_default)`
  position: relative;
  width: 100%;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 8px;
`;
var PillsScrollWrapper = (0, import_styled_components150.default)(Flex_default)`
  width: 100%;
  overflow-x: ${({ isMobile }) => isMobile ? "auto" : "visible"};
  overflow-y: ${({ isMobile }) => isMobile ? "hidden" : "visible"};
  scroll-behavior: smooth;
  gap: 8px;
  flex-wrap: nowrap;

  ${({ isMobile }) => isMobile && import_styled_components150.css`
      ::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
      padding: 4px 0;
    `}
`;
var PillButton = import_styled_components150.default.button`
  appearance: none;
  border: 1px solid
    ${({ theme, active }) => active ? theme.colors.b50 : theme.colors.n30};
  background-color: ${({ theme, active }) => active ? theme.colors.b50 : theme.colors.white};
  color: ${({ theme, active }) => active ? theme.colors.white : theme.colors.n70};
  padding: 6px 16px;
  border-radius: 24px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  outline: none !important;

  &:hover {
    background-color: ${({ theme, active }) => active ? theme.colors.b50 : theme.colors.n10};
    border-color: ${({ theme, active }) => active ? theme.colors.b50 : theme.colors.n40};
  }

  &:focus {
    outline: none !important;
    border-color: ${({ theme, active }) => active ? theme.colors.b50 : theme.colors.n30};
  }

  &:focus-visible {
    outline: none !important;
    border-color: ${({ theme, active }) => active ? theme.colors.b50 : theme.colors.n30};
  }

  & p {
    color: ${({ theme, active }) => active ? theme.colors.white : theme.colors.n70};
    margin: 0;
  }

  ${({ isInDropdown, theme, active }) => isInDropdown && import_styled_components150.css`
      width: 100%;
      justify-content: space-between;
      margin: 0;
      border-radius: 0;
      border: none;
      border-bottom: 1px solid ${theme.colors.n20};

      &:hover {
        background-color: ${active ? theme.colors.b50 : theme.colors.n10};
      }

      &:last-child {
        border-bottom: none;
      }
    `}
`;
var ScrollIndicator2 = (0, import_styled_components150.default)(Box_default)`
  position: absolute;
  top: 0;
  bottom: 0;
  ${({ position }) => position === "left" ? "left: 0;" : "right: 0;"}
  z-index: 2;
  background: linear-gradient(
    to ${({ position }) => position === "left" ? "right" : "left"},
    rgba(248, 251, 253, 0.80) 0%,
    rgba(248, 251, 253, 0) 100%
  );
  padding: 8px;
  padding-${({ position }) => position === "left" ? "right" : "left"}: 16px;
  pointer-events: none;
  display: flex;
  align-items: center;

  svg {
    pointer-events: auto;
    cursor: pointer;
    background: white;
    border-radius: 50%;
    padding: 2px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  @media ${({ theme }) => theme.devices.tablet} {
    display: none;
  }

  @media ${({ theme }) => theme.devices.desktop} {
    display: none;
  }
`;
var MoreDropdown = (0, import_styled_components150.default)(Box_default)`
  flex-shrink: 0;
  position: relative;
`;
var MoreDropdownMenu = import_styled_components150.default.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  max-height: 300px;
  overflow-y: auto;
  padding: 4px 0;
  z-index: 3;
`;
var DropdownMenuItem2 = import_styled_components150.default.button`
  appearance: none;
  border: none;
  background: ${({ active, theme }) => active ? theme.colors.b10 : "transparent"};
  width: 100%;
  padding: 8px 16px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background-color: ${({ active, theme }) => active ? theme.colors.b10 : theme.colors.n10};
  }

  & p {
    margin: 0;
    color: ${({ active, theme }) => active ? theme.colors.b50 : theme.colors.n80};
    font-weight: ${({ active }) => active ? 600 : 400};
  }
`;

// src/components/molecules/ResponsivePills/ResponsivePills.tsx
var import_jsx_runtime145 = require("react/jsx-runtime");
var ResponsivePills = ({
  pills,
  selectedPills = [],
  onPillClick,
  className,
  multiSelect = true
}) => {
  const theme = (0, import_styled_components151.useTheme)();
  const { t } = (0, import_react_i18next59.useTranslation)();
  const pillsContainerRef = (0, import_react104.useRef)(null);
  const [visiblePills, setVisiblePills] = (0, import_react104.useState)([]);
  const [overflowPills, setOverflowPills] = (0, import_react104.useState)([]);
  const [showLeftScroll, setShowLeftScroll] = (0, import_react104.useState)(false);
  const [showRightScroll, setShowRightScroll] = (0, import_react104.useState)(false);
  const [isDropdownOpen, setIsDropdownOpen] = (0, import_react104.useState)(false);
  const dropdownRef = (0, import_react104.useRef)(null);
  useOnClickOutside(dropdownRef, () => {
    setIsDropdownOpen(false);
  });
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const checkScrollIndicators = (0, import_react104.useCallback)(() => {
    if (!pillsContainerRef.current || !isMobile)
      return;
    const container = pillsContainerRef.current;
    const { scrollLeft, scrollWidth, clientWidth } = container;
    setShowLeftScroll(scrollLeft > 0);
    setShowRightScroll(scrollLeft + clientWidth < scrollWidth - 5);
  }, [isMobile]);
  const calculateVisiblePills = (0, import_react104.useCallback)(() => {
    if (isMobile || !pillsContainerRef.current || pills.length === 0) {
      setVisiblePills(pills.map((pill) => pill.id));
      setOverflowPills([]);
      return;
    }
    const parentElement = pillsContainerRef.current?.parentElement;
    if (!parentElement) {
      setVisiblePills(pills.map((pill) => pill.id));
      setOverflowPills([]);
      return;
    }
    const containerWidth = parentElement.offsetWidth - 50;
    if (containerWidth === 0) {
      setTimeout(() => calculateVisiblePills(), 100);
      return;
    }
    const tempContainer = document.createElement("div");
    tempContainer.style.cssText = "position:absolute;visibility:hidden;display:flex;";
    document.body.appendChild(tempContainer);
    let totalPillsWidth = 0;
    pills.forEach((pill) => {
      const tempPill = document.createElement("button");
      tempPill.style.cssText = "padding:6px 16px;margin-right:8px;white-space:nowrap;";
      tempPill.textContent = pill.label;
      tempContainer.appendChild(tempPill);
      totalPillsWidth += tempPill.offsetWidth + 8;
      tempContainer.removeChild(tempPill);
    });
    document.body.removeChild(tempContainer);
    if (totalPillsWidth <= containerWidth) {
      setVisiblePills(pills.map((pill) => pill.id));
      setOverflowPills([]);
      return;
    }
    const moreButtonWidth = 110;
    const availableWidth = containerWidth - moreButtonWidth;
    let visiblePillIds = [];
    let overflowPillIds = [];
    let currentWidth = 0;
    const tempContainer2 = document.createElement("div");
    tempContainer2.style.cssText = "position:absolute;visibility:hidden;display:flex;";
    document.body.appendChild(tempContainer2);
    pills.forEach((pill) => {
      const tempPill = document.createElement("button");
      tempPill.style.cssText = "padding:6px 16px;margin-right:8px;white-space:nowrap;";
      tempPill.textContent = pill.label;
      tempContainer2.appendChild(tempPill);
      const pillWidth = tempPill.offsetWidth + 8;
      if (currentWidth + pillWidth <= availableWidth) {
        currentWidth += pillWidth;
        visiblePillIds.push(pill.id);
      } else {
        overflowPillIds.push(pill.id);
      }
      tempContainer2.removeChild(tempPill);
    });
    document.body.removeChild(tempContainer2);
    setVisiblePills(visiblePillIds);
    setOverflowPills(overflowPillIds);
  }, [pills, isMobile]);
  (0, import_react104.useEffect)(() => {
    const timer = setTimeout(() => {
      calculateVisiblePills();
      checkScrollIndicators();
    }, 50);
    const handleResize = () => {
      calculateVisiblePills();
      checkScrollIndicators();
    };
    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [calculateVisiblePills, checkScrollIndicators]);
  const handleScroll = (0, import_react104.useCallback)(() => {
    checkScrollIndicators();
  }, [checkScrollIndicators]);
  const handlePillClick = (pillId, event) => {
    if (multiSelect) {
      if (selectedPills.includes(pillId)) {
        onPillClick(selectedPills.filter((id2) => id2 !== pillId));
      } else {
        onPillClick([...selectedPills, pillId]);
      }
    } else {
      onPillClick([pillId]);
    }
    if (event?.currentTarget) {
      event.currentTarget.blur();
    }
  };
  const renderPill = (pill, isInDropdown = false) => {
    const isActive = selectedPills.includes(pill.id);
    return /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(
      PillButton,
      {
        "data-pill-id": pill.id,
        active: isActive,
        onClick: (e) => handlePillClick(pill.id, e),
        onMouseDown: (e) => e.preventDefault(),
        isInDropdown,
        "aria-pressed": isActive,
        "aria-label": `${pill.label} ${isActive ? "selected" : "not selected"}`,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(Text_default, { semibold: true, children: pill.label }),
          isActive ? /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(Icon_default, { name: "close", size: 14, color: theme.colors.white }) : /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(Icon_default, { name: "plus", size: 14, color: theme.colors.b50 })
        ]
      },
      pill.id
    );
  };
  const renderOverflowMenu = () => {
    if (overflowPills.length === 0)
      return null;
    return /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(MoreDropdownMenu, { children: overflowPills.map((id2) => {
      const pill = pills.find((p) => p.id === id2);
      if (!pill)
        return null;
      const isSelected = selectedPills.includes(id2);
      return /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(
        DropdownMenuItem2,
        {
          active: isSelected,
          onClick: (e) => {
            e.stopPropagation();
            handlePillClick(pill.id, e);
          },
          onMouseDown: (e) => e.preventDefault(),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(Text_default, { children: pill.label }),
            isSelected && /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(Icon_default, { name: "check", size: 16, color: theme.colors.b50 })
          ]
        },
        pill.id
      );
    }) });
  };
  if (pills.length === 0) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(PillsContainer, { className, children: [
    isMobile && showLeftScroll && /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(ScrollIndicator2, { position: "left", children: /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(
      Icon_default,
      {
        name: "chevronLeft",
        size: 20,
        color: theme.colors.n80,
        onClick: () => {
          if (pillsContainerRef.current) {
            pillsContainerRef.current.scrollLeft -= 100;
          }
        }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(
      PillsScrollWrapper,
      {
        ref: pillsContainerRef,
        onScroll: handleScroll,
        isMobile,
        children: isMobile ? (
          // Mobile: render all pills with horizontal scroll
          pills.map((pill) => renderPill(pill))
        ) : (
          // Desktop/Laptop: render visible pills with overflow dropdown
          /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(import_jsx_runtime145.Fragment, { children: [
            pills.filter((pill) => visiblePills.includes(pill.id)).map((pill) => renderPill(pill)),
            overflowPills.length > 0 && (() => {
              const selectedOverflowCount = overflowPills.filter(
                (id2) => selectedPills.includes(id2)
              ).length;
              const hasSelectedOverflow = selectedOverflowCount > 0;
              return /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(MoreDropdown, { ref: dropdownRef, children: [
                /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(
                  PillButton,
                  {
                    type: "button",
                    active: hasSelectedOverflow,
                    onClick: (e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      setIsDropdownOpen((prev) => !prev);
                    },
                    onMouseDown: (e) => e.preventDefault(),
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(Text_default, { children: [
                        t("common:labels.more"),
                        hasSelectedOverflow && ` (${selectedOverflowCount})`
                      ] }),
                      /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(
                        Icon_default,
                        {
                          name: isDropdownOpen ? "chevronUp" : "chevronDown",
                          size: 16,
                          color: hasSelectedOverflow ? theme.colors.white : theme.colors.n70
                        }
                      )
                    ]
                  }
                ),
                isDropdownOpen && renderOverflowMenu()
              ] });
            })()
          ] })
        )
      }
    ),
    isMobile && showRightScroll && /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(ScrollIndicator2, { position: "right", children: /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(
      Icon_default,
      {
        name: "chevronRight",
        size: 20,
        color: theme.colors.n80,
        onClick: () => {
          if (pillsContainerRef.current) {
            pillsContainerRef.current.scrollLeft += 100;
          }
        }
      }
    ) })
  ] });
};
var ResponsivePills_default = ResponsivePills;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/MediaFileCard/MediaFileCard.tsx
var import_react_i18next60 = require("react-i18next");
var import_react106 = require("react");
var import_styled_components155 = require("styled-components");
var import_dash_common45 = require("dash-common");

// src/components/organisms/SlideshowPreview/components/Thumbnail/Thumbnail.tsx
var import_dash_common44 = require("dash-common");
var import_styled_components153 = require("styled-components");

// src/components/organisms/SlideshowPreview/components/Thumbnail/Thumbnail.styles.ts
var import_styled_components152 = __toESM(require("styled-components"));
var import_isNumber = __toESM(require("lodash/isNumber"));
var ThumbnailWrapper = (0, import_styled_components152.default)(Box_default)`
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
  cursor: pointer;
`;
var StyledImage2 = (0, import_styled_components152.default)(Image_default)`
  height: 100%;
  width: 100%;
  border-top-left-radius: ${({ theme }) => theme.space}px;
  border-top-right-radius: ${({ theme }) => theme.space}px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  ${({ borderRadius }) => (0, import_isNumber.default)(borderRadius) && `border-radius: ${borderRadius}px`};
`;
var BackGroundMask = (0, import_styled_components152.default)(Flex_default)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.b50, 60)};
  width: inherit;
  height: inherit;
  top: 0;
`;
var TextMaskMobile = (0, import_styled_components152.default)(Flex_default)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.n90, 60)};
  border-radius: ${({ theme }) => theme.space}px;
  bottom: ${({ theme }) => theme.space * 4}px;
  right: ${({ theme }) => theme.space * 4}px;
`;

// src/components/organisms/SlideshowPreview/components/Thumbnail/Thumbnail.tsx
var import_jsx_runtime146 = require("react/jsx-runtime");
var Thumbnail = ({
  file,
  label,
  totalCount,
  placeholderProps,
  borderRadius,
  imagePlaceholder,
  ...args
}) => {
  const theme = (0, import_styled_components153.useTheme)();
  const isVideo = file && import_dash_common44.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.VIDEOS.includes(file.type);
  const isImage = file && (import_dash_common44.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type) || file.type === import_dash_common44.ALLOWED_MEDIA_TYPE_MIMES.pdf);
  const ViewComponent2 = () => {
    if (isVideo) {
      return /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(Video_default, { src: file.thumbnailFileUrl || file.publicUrl });
    }
    if (isImage) {
      if (!file.thumbnailFileUrl) {
        return imagePlaceholder || /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(FileTypeIcon_default, { file, lg: true });
      }
      return /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(
        StyledImage2,
        {
          src: file.thumbnailFileUrl || file.publicUrl,
          alt: file.name,
          borderRadius
        }
      );
    }
    return imagePlaceholder || /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(FileTypeIcon_default, { file, lg: true });
  };
  return file ? /* @__PURE__ */ (0, import_jsx_runtime146.jsxs)(ThumbnailWrapper, { ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(Flex_default, { justifyContent: "center", alignItems: "center", w: "100%", h: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(ViewComponent2, {}) }),
    label && /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(BackGroundMask, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(H_default, { lg: true, semibold: true, color: theme.colors.white, children: label }) }),
    totalCount && /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(TextMaskMobile, { py: 0, px: 3, children: /* @__PURE__ */ (0, import_jsx_runtime146.jsxs)(Text_default, { semibold: true, color: theme.colors.white, children: [
      "1 / ",
      totalCount
    ] }) })
  ] }) : /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(DashPlaceholder_default, { variation: "secondary", w: "100%", h: "100%", ...placeholderProps });
};
var Thumbnail_default = Thumbnail;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MarketingFiles.context.tsx
var import_react105 = require("react");
var import_jsx_runtime147 = require("react/jsx-runtime");
var MarketingFilesContext = (0, import_react105.createContext)({
  selected: {},
  setSelected: () => null
});
var MarketingFilesProvider = ({ children }) => {
  const [selected, setSelected] = (0, import_react105.useState)({});
  return /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(MarketingFilesContext.Provider, { value: { selected, setSelected }, children });
};

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/MediaFileCard/MediaFileCard.styles.ts
var import_styled_components154 = __toESM(require("styled-components"));
var MediaFileCardWrapper = (0, import_styled_components154.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  border: 1px solid ${({ theme }) => theme.colors.n30};
  cursor: pointer;

  :hover {
    & > div:first-child > div:first-child {
      display: block;
    }
  }
`;
var CheckboxWrapper2 = (0, import_styled_components154.default)(Box_default)`
  top: 5px;
  left: 5px;
  z-index: 2;
  display: ${({ isSelected, isList }) => isSelected || isList ? "block" : "none"};

  @media ${({ theme }) => theme.devices.mobile} {
    display: block;
  }
`;
var ThumbnailWrapper2 = (0, import_styled_components154.default)(Flex_default)`
  background-color: ${({ bgColor, theme }) => bgColor || theme.colors.b10};
  ${({ isBorder, theme }) => isBorder ? `border: 1px solid ${theme.colors.n30}` : `border-bottom: 1px solid ${theme.colors.n30}`};
`;
var FileNameWrapper = (0, import_styled_components154.default)(Box_default)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  /* Height matches exactly 2 lines based on Text component's line height (28px × 2 = 56px) */
  height: 56px;
`;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/MediaFileCard/MediaFileCard.tsx
var import_jsx_runtime148 = require("react/jsx-runtime");
var MediaFileCard = ({
  file,
  isList,
  onClick,
  isMediaKit,
  compact = false,
  addToMediaKit,
  removeFromMediaKit,
  index: index2,
  hideCheckbox
}) => {
  const theme = (0, import_styled_components155.useTheme)();
  const { t } = (0, import_react_i18next60.useTranslation)();
  const { selected, setSelected } = (0, import_react106.useContext)(MarketingFilesContext);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const onSelectItem = (0, import_react106.useCallback)(
    (value) => {
      setSelected((previous) => ({ ...previous, [file._id]: value }));
    },
    [setSelected]
  );
  const containerOptions = isList ? { w: "unset", mr: !compact ? 4 : 0, ml: [3, 0, 0, 0] } : { mt: 1, px: 3, pb: 4, w: "100%" };
  return /* @__PURE__ */ (0, import_jsx_runtime148.jsxs)(
    MediaFileCardWrapper,
    {
      onClick,
      flexDirection: isList ? "row" : "column",
      w: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      pos: "relative",
      ...isMobile && { flexWrap: "wrap" },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime148.jsxs)(
          Flex_default,
          {
            flexDirection: isList ? "row" : "column",
            alignItems: isList ? "center" : "flex-start",
            w: "100%",
            children: [
              !isMediaKit && !hideCheckbox && /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
                CheckboxWrapper2,
                {
                  isList,
                  isSelected: selected[file._id],
                  pos: isList ? "static" : "absolute",
                  mx: isList ? 1 : 0,
                  children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Checkbox_default, { onChange: onSelectItem, checked: selected[file._id] })
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
                ThumbnailWrapper2,
                {
                  isBorder: !import_dash_common45.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type),
                  bgColor: file.backgroundColor,
                  alignItems: "center",
                  justifyContent: "center",
                  w: isList ? 56 : "100%",
                  h: isList ? 56 : 170,
                  children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
                    Thumbnail_default,
                    {
                      file,
                      ...(isList || file.backgroundColor) && {
                        borderRadius: 0,
                        imagePlaceholder: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Icon_default, { name: "filePlaceholder", size: 45, color: theme.colors.n20 })
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(TooltipWrapper_default, { content: file.name, placement: compact && index2 === 0 ? "bottom" : "top", children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(FileNameWrapper, { px: 3, mb: 1, mt: 1.5, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Text_default, { semibold: true, children: file.name }) }) })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime148.jsxs)(
          Flex_default,
          {
            alignItems: "center",
            mt: [2, 0, 0, 0],
            justifyContent: "space-between",
            flexWrap: "wrap",
            ...containerOptions,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Text_default, { sm: compact, whiteSpace: "nowrap", color: theme.colors.n70, children: formatDisplayDate(file.createdAt) }),
              /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
                Flex_default,
                {
                  minWidth: isList && !compact ? 100 : 0,
                  justifyContent: "flex-end",
                  mr: isMediaKit ? 3 : 0,
                  children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Text_default, { sm: compact, whiteSpace: "nowrap", color: theme.colors.n70, children: (0, import_dash_common45.bytesToMBytes)(file.size) > 1 ? t("common:labels.mBytes", {
                    size: (0, import_dash_common45.bytesToMBytes)(file.size)
                  }) : t("common:labels.kBytes", {
                    size: (0, import_dash_common45.bytesToKBytes)(file.size)
                  }) })
                }
              ),
              isMediaKit && /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(import_jsx_runtime148.Fragment, { children: file.isAddedToMediaKit ? /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
                Button_default,
                {
                  variation: "flat",
                  icon: "fillTrash",
                  whiteSpace: "nowrap",
                  type: "button",
                  colorVariation: "danger",
                  onClick: (event) => {
                    event.stopPropagation();
                    if (file.isAddedToMediaKit && removeFromMediaKit) {
                      return removeFromMediaKit({ ...file, isAddedToMediaKit: false });
                    }
                  },
                  children: t("common:labels.delete")
                }
              ) : /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
                Button_default,
                {
                  variation: "flat",
                  icon: file.isCurrentItemAdded ? "check" : "addCircleOutline",
                  whiteSpace: "nowrap",
                  type: "button",
                  colorVariation: file.isCurrentItemAdded ? "success" : "default",
                  onClick: (event) => {
                    event.stopPropagation();
                    if (addToMediaKit) {
                      return addToMediaKit({ ...file, isAddedToMediaKit: true });
                    }
                  },
                  children: file.isCurrentItemAdded ? t("pages:mediaKit.added") : t("pages:mediaKit.addToMedia")
                }
              ) })
            ]
          }
        )
      ]
    }
  );
};
var MediaFileCard_default = MediaFileCard;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MarketingFiles.styles.ts
var import_styled_components156 = __toESM(require("styled-components"));
var TabsWrapper2 = (0, import_styled_components156.default)(Flex_default)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
`;
var MediaListWrapper = import_styled_components156.default.div`
  width: 100%;
  height: ${({ compact }) => compact ? "198px" : "450px"};
  overflow-y: ${({ compact }) => compact ? "scroll" : "auto"};
  padding-right: ${({ theme }) => theme.space * 2}px;
`;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MediaFilesViewButton/MediaFilesViewButton.tsx
var import_styled_components158 = require("styled-components");

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MediaFilesViewButton/MediaFilesViewButton.styles.ts
var import_styled_components157 = __toESM(require("styled-components"));
var SwitchButton2 = (0, import_styled_components157.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  border: 1px solid ${({ theme }) => theme.colors.b20};
`;
var StyledButton5 = (0, import_styled_components157.default)(Flex_default)`
  background-color: ${({ theme, isActive }) => isActive ? theme.colors.b20 : theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
  cursor: pointer;
`;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MediaFilesViewButton/MediaFilesViewButton.tsx
var import_jsx_runtime149 = require("react/jsx-runtime");
var MediaFilesViewButton = ({
  setButtonType,
  isCard,
  isList
}) => {
  const theme = (0, import_styled_components158.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime149.jsxs)(SwitchButton2, { ml: 3, children: [
    /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(
      StyledButton5,
      {
        alignItems: "center",
        justifyContent: "center",
        isActive: isCard,
        onClick: () => setButtonType("Card" /* Card */),
        w: 32,
        h: 32,
        children: /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Icon_default, { name: "dashboard", color: isCard ? theme.colors.b50 : theme.colors.b40, size: 24 })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(
      StyledButton5,
      {
        alignItems: "center",
        justifyContent: "center",
        w: 32,
        h: 32,
        isActive: isList,
        onClick: () => setButtonType("List" /* List */),
        children: /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Icon_default, { name: "list", color: isList ? theme.colors.b50 : theme.colors.b40, size: 24 })
      }
    )
  ] });
};
var MediaFilesViewButton_default = MediaFilesViewButton;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/RestrictedFilesView/RestrictedFilesView.tsx
var import_react107 = require("react");
var import_react_i18next61 = require("react-i18next");
var import_styled_components160 = require("styled-components");

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/RestrictedFilesView/RestrictedFilesView.styles.ts
var import_styled_components159 = __toESM(require("styled-components"));
var RestrictedContainer = (0, import_styled_components159.default)(Box_default)`
  position: relative;
  width: 100%;
  min-height: ${({ hasFiles }) => hasFiles ? "auto" : "450px"};
`;
var RestrictedOverlay = (0, import_styled_components159.default)(Flex_default)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(7px);
  z-index: 2;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space * 3}px;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.85);
  }
`;
var UpgradeButton4 = (0, import_styled_components159.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b50};
  padding: ${({ theme }) => theme.space * 2}px ${({ theme }) => theme.space * 6}px;
  border-radius: 24px;
  cursor: pointer;
`;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/RestrictedFilesView/RestrictedFilesView.tsx
var import_jsx_runtime150 = require("react/jsx-runtime");
var MOCK_FILE_COLORS = ["#4A5A4E", "#6B5D52", "#3D5A6C", "#5C6B4A"];
var RestrictedFilesView = ({
  files,
  filesTotalCount,
  isList,
  isMediaKit,
  compactMediaList,
  listOptions,
  onRestrictedFieldClick
}) => {
  const theme = (0, import_styled_components160.useTheme)();
  const { t } = (0, import_react_i18next61.useTranslation)("common");
  const mockFiles = (0, import_react107.useMemo)(() => {
    const count = Math.min(filesTotalCount || files.length, 4);
    return Array.from({ length: count }, (_, i) => ({
      _id: `mock-${i}`,
      name: `Sample File ${i + 1}.jpg`,
      size: 1024e3,
      publicUrl: "",
      thumbnailFileUrl: "",
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      type: "image/jpeg",
      mediaFolderId: "",
      backgroundColor: MOCK_FILE_COLORS[i]
    }));
  }, [files.length, filesTotalCount]);
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onRestrictedFieldClick?.();
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime150.jsxs)(RestrictedContainer, { hasFiles: mockFiles.length > 0, children: [
    mockFiles.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(MediaListWrapper, { compact: compactMediaList, children: /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(List_default, { w: "100%", gap: 12, ...listOptions, data: mockFiles, children: (file, index2 = -1) => /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(
      MediaFileCard_default,
      {
        file,
        isList,
        index: index2,
        onClick: () => {
        },
        isMediaKit,
        compact: compactMediaList
      }
    ) }) }),
    /* @__PURE__ */ (0, import_jsx_runtime150.jsxs)(
      RestrictedOverlay,
      {
        onClick: onRestrictedFieldClick || (() => {
        }),
        onKeyDown: handleKeyDown,
        role: "button",
        "aria-label": t("components.restrictedFiles.ariaLabel") || "",
        tabIndex: 0,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(Icon_default, { name: "lock", color: theme.colors.n70, size: 40 }),
          /* @__PURE__ */ (0, import_jsx_runtime150.jsxs)(
            Flex_default,
            {
              flexDirection: "column",
              alignItems: "center",
              style: { gap: `${theme.space}px`, textAlign: "center" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(Text_default, { color: theme.colors.n90, semibold: true, lg: true, children: filesTotalCount === 0 ? t("components.restrictedFiles.empty") : t("components.restrictedFiles.filesInFolder", { count: filesTotalCount }) }),
                /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(Text_default, { color: theme.colors.n80, sm: true, children: t("components.restrictedFiles.upgradeHint") })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(UpgradeButton4, { children: /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(Text_default, { color: "white", semibold: true, sm: true, children: t("labels.startSevenDayTrial") }) })
        ]
      }
    )
  ] });
};
var RestrictedFilesView_default = RestrictedFilesView;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MarketingFiles.tsx
var import_jsx_runtime151 = require("react/jsx-runtime");
var SCROLL_THRESHOLD_PX = 10;
var SCROLL_CHECK_DELAY_MS = 100;
var MarketingFiles = ({
  tabs,
  files,
  filesTotalCount,
  folders = [],
  activeTab,
  setActiveTab,
  onDownloadClick,
  fetchMoreProps,
  loading,
  isMediaKit,
  compactMediaList = false,
  addToMediaKit,
  removeFromMediaKit,
  isPortfolioView = false,
  allowDownloads = true,
  isSeeker = false,
  isRestricted = false,
  hideDownloads,
  onRestrictedFieldClick,
  isIdxView = false
}) => {
  const theme = (0, import_styled_components161.useTheme)();
  const { t } = (0, import_react_i18next62.useTranslation)();
  const { setUpgradeSubscriptionModal } = (0, import_react108.useContext)(ModalContext);
  const [fileIdToPreview, setFileIdToPreview] = (0, import_react108.useState)(-1);
  const { selected, setSelected } = (0, import_react108.useContext)(MarketingFilesContext);
  const [buttonType, setButtonType] = (0, import_react108.useState)(isMediaKit ? "List" /* List */ : "Card" /* Card */);
  const { setFilterState, state: filterState } = (0, import_react108.useContext)(FilterContext);
  const isList = buttonType === "List" /* List */;
  const isCard = buttonType === "Card" /* Card */;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    import_dash_common46.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT
  ]);
  const scrollRef = (0, import_react108.useRef)(null);
  const [showLoadMore, setShowLoadMore] = (0, import_react108.useState)(false);
  const listOptions = (0, import_react108.useMemo)(() => {
    if (isMobile) {
      return {
        w: "100%",
        flexWrap: "wrap",
        flexDirection: "row",
        overflow: "auto",
        maxHeight: "100%"
      };
    }
    if (isList) {
      return {
        flexDirection: "column",
        h: "100%",
        overflow: "auto"
      };
    }
    return { grid: 260 };
  }, [isMobile, isList]);
  const onSelectAll = (0, import_react108.useCallback)(
    (value) => {
      setSelected(files.reduce((obj, item) => ({ ...obj, [item._id]: value }), {}));
    },
    [files, setSelected]
  );
  const totalSelected = (0, import_react108.useMemo)(
    () => Object.values(selected).filter((value) => value).length,
    [selected]
  );
  const systemFolderName = useSystemFolderName();
  const tabsFolders = (0, import_react108.useMemo)(
    () => tabs.map((item) => ({
      ...item,
      label: systemFolderName(
        item.label === import_dash_common46.DEFAULT_ROOT_MEDIA_FOLDER_NAME ? import_dash_common46.RESERVED_MEDIA_FOLDER_NAME : item.label
      )
    })),
    [tabs, systemFolderName]
  );
  const handlePillClick = (0, import_react108.useCallback)(
    (selectedIds) => {
      const currentSelected = filterState.foldersIds || [];
      const newSelectedIds = [...selectedIds];
      const deselectedIds = currentSelected.filter((id2) => !selectedIds.includes(id2));
      if (deselectedIds.length > 0) {
        deselectedIds.forEach((deselectedId) => {
          folders.forEach((childFolder) => {
            if (childFolder.parentMediaFoldersIds?.includes(deselectedId)) {
              const childIndex = newSelectedIds.indexOf(childFolder._id);
              if (childIndex > -1) {
                newSelectedIds.splice(childIndex, 1);
              }
            }
          });
        });
      } else {
        selectedIds.forEach((folderId) => {
          if (currentSelected.includes(folderId)) {
            return;
          }
          const folder = folders.find(({ _id }) => _id === folderId);
          if (folder) {
            folders.forEach((childFolder) => {
              if (childFolder.parentMediaFoldersIds?.includes(folderId) && !newSelectedIds.includes(childFolder._id)) {
                newSelectedIds.push(childFolder._id);
              }
            });
          }
        });
      }
      setFilterState("foldersIds", newSelectedIds);
    },
    [folders, filterState.foldersIds, setFilterState]
  );
  (0, import_react108.useEffect)(() => {
    const scrollElement = scrollRef.current;
    if (!scrollElement)
      return;
    const checkScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = scrollElement;
      const isScrollable = scrollHeight > clientHeight;
      const isAtBottom = scrollHeight - scrollTop - clientHeight < SCROLL_THRESHOLD_PX;
      setShowLoadMore(!isScrollable || isAtBottom);
    };
    const timeoutId = setTimeout(checkScroll, SCROLL_CHECK_DELAY_MS);
    scrollElement.addEventListener("scroll", checkScroll);
    return () => {
      clearTimeout(timeoutId);
      scrollElement.removeEventListener("scroll", checkScroll);
    };
  }, [files.length]);
  return /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(Box_default, { pos: "relative", w: "100%", children: [
    !isMediaKit && /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(import_jsx_runtime151.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Text_default, { ...isMobile ? { xl: true } : { xxl: true }, semibold: true, color: theme.colors.gr1, children: t(
      isSeeker ? "pages:propertyPreviewPage.propertyDownloadsLabel" : "pages:propertyPreviewPage.downloadsLabel"
    ) }) }),
    !isMediaKit && !hideDownloads && /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(
      Card_default,
      {
        mt: 4.5,
        mb: 3,
        p: 3,
        shadow: theme.shadows.shadow1,
        borderRadius: theme.space,
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          !isMobile && /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(Flex_default, { alignItems: "center", children: [
            /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Checkbox_default, { size: 18, checked: totalSelected > 0, mr: 2, onChange: onSelectAll }),
            /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Text_default, { children: t("tables:marketingFiles:filesSelectedLabel", {
              totalCount: totalSelected
            }) })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
            Button_default,
            {
              w: ["100%", "unset", "unset", "unset"],
              px: 6,
              icon: "download",
              onClick: () => {
                setUpgradeSubscriptionModal({
                  type: "DOWNLOAD" /* DOWNLOAD */
                });
                const isActive = checkFeatureAccess({
                  disableModal: isPortfolioView
                });
                if ((0, import_dash_common46.nor)(isActive, isPortfolioView))
                  return;
                if (onDownloadClick) {
                  onDownloadClick(selected);
                }
              },
              disabled: !allowDownloads,
              children: totalSelected > 0 ? t("tables:marketingFiles:downloadSelectedLabel") : t("tables:marketingFiles:downloadAllLabel")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(
      Card_default,
      {
        p: isMediaKit ? 0 : 4.5,
        mt: hideDownloads ? 4 : 0,
        shadow: isMediaKit ? "none" : theme.shadows.shadow1,
        borderRadius: theme.space,
        flexDirection: "column",
        w: "100%",
        children: [
          isMobile && /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", mb: 4, w: "100%", children: [
            /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(Flex_default, { alignItems: "center", children: [
              /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Checkbox_default, { size: 18, checked: totalSelected > 0, mr: 2, onChange: onSelectAll }),
              /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Text_default, { children: t("tables:marketingFiles:filesSelectedLabel", {
                totalCount: totalSelected
              }) })
            ] }),
            /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(MediaFilesViewButton_default, { setButtonType, isCard, isList })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Flex_default, { w: "100%", maxWidth: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(TabsWrapper2, { justifyContent: "space-between", w: "100%", alignItems: "center", children: [
            /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
              TabsWithDropdown_default,
              {
                activeTab: activeTab || (tabs.length > 0 ? tabs[0].key : ""),
                tabs: tabsFolders,
                onClick: (tab) => {
                  setFilterState("foldersIds", []);
                  setActiveTab(tab);
                },
                variation: "secondary",
                activeButtonColor: theme.colors.b50
              }
            ),
            !isMobile && !isMediaKit && /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(MediaFilesViewButton_default, { setButtonType, isCard, isList })
          ] }) }),
          /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Box_default, { mb: 4, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
            ResponsivePills_default,
            {
              pills: folders.map((folder) => ({
                id: folder._id,
                label: systemFolderName(folder.folderName)
              })),
              selectedPills: filterState.foldersIds || [],
              onPillClick: handlePillClick,
              multiSelect: true
            }
          ) }),
          loading ? /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
            Flex_default,
            {
              w: "100%",
              h: compactMediaList ? 214 : 450,
              justifyContent: "center",
              alignItems: "center",
              pos: "relative",
              children: /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Spinner_default, { fullContent: true })
            }
          ) : isRestricted ? /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
            RestrictedFilesView_default,
            {
              files,
              filesTotalCount,
              isList,
              isMediaKit,
              compactMediaList,
              listOptions,
              onRestrictedFieldClick
            }
          ) : files.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(MediaListWrapper, { ref: scrollRef, compact: compactMediaList, children: /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(List_default, { w: "100%", gap: 12, ...listOptions, data: files, children: (file, index2 = -1) => /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
            MediaFileCard_default,
            {
              file,
              isList,
              index: index2,
              onClick: () => setFileIdToPreview(index2),
              isMediaKit,
              compact: compactMediaList,
              addToMediaKit,
              removeFromMediaKit,
              hideCheckbox: hideDownloads
            }
          ) }) }) : /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Flex_default, { w: "100%", h: compactMediaList ? 214 : 450, justifyContent: "center", pt: 24, children: /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Text_default, { children: t("pages:propertyPage.mediaEmptyState") }) }),
          /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
            Flex_default,
            {
              w: "100%",
              justifyContent: "center",
              mt: 2,
              style: { visibility: showLoadMore ? "visible" : "hidden" },
              children: isMediaKit ? /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
                Pagination_default,
                {
                  previousButtonLabel: t("common:labels.previous"),
                  nextButtonLabel: t("common:labels.next")
                }
              ) : /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(PaginationLoadMore, { medium: true, variation: "outline", fetchMoreProps, px: 8, children: t("common:labels.showMore") })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
      FullPageFilePreview_default,
      {
        isOpen: fileIdToPreview >= 0,
        onClose: () => setFileIdToPreview(-1),
        defaultIndex: fileIdToPreview,
        files,
        isDownloadButtonVisible: allowDownloads && !hideDownloads,
        isPortfolioView,
        isIdxView
      }
    )
  ] });
};
var MarketingFiles_default = MarketingFiles;

// src/components/molecules/PropertyPreviewComponents/PropertyUpgradeBanner/PropertyUpgradeBanner.tsx
var import_styled_components163 = require("styled-components");
var import_react_i18next63 = require("react-i18next");

// src/components/molecules/PropertyPreviewComponents/PropertyUpgradeBanner/PropertyUpgradeBanner.styles.ts
var import_styled_components162 = __toESM(require("styled-components"));
var BannerContainer3 = (0, import_styled_components162.default)(Box_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid ${({ theme }) => theme.colors.n30};
`;
var ImageSplitWrapper = (0, import_styled_components162.default)(Box_default)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  min-height: 320px;

  @media ${({ theme }) => theme.devices.mobile} {
    min-height: auto;
  }
`;
var ImageSideWrapper = (0, import_styled_components162.default)(Box_default)`
  min-height: 320px;
  position: relative;
  overflow: hidden;

  @media ${({ theme }) => theme.devices.mobile} {
    min-height: 200px;
  }
`;
var StyledImage3 = (0, import_styled_components162.default)(Image_default)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 0;
`;
var ImagePlaceholder = (0, import_styled_components162.default)(Box_default)`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: absolute;
  top: 0;
  left: 0;
`;
var ContentWrapper = (0, import_styled_components162.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 40px 40px 0;
    border-color: transparent ${({ theme }) => theme.colors.b50} transparent transparent;
    z-index: 1;
  }

  /* When grid wraps to single column (container < ~600px) */
  @media (max-width: 600px) {
    &::before {
      top: auto;
      bottom: 0;
      right: 0;
      border-width: 0 0 40px 40px;
      border-color: transparent transparent ${({ theme }) => theme.colors.b50} transparent;
    }
  }
`;
var FeatureItem = (0, import_styled_components162.default)(Flex_default)`
  align-items: flex-start;
  gap: ${({ theme }) => theme.space * 1.5}px;
  margin-top: ${({ theme }) => theme.space * 1.5}px;

  svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-top: 5px;
  }
`;
var CTAButton = (0, import_styled_components162.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b50};
  color: white;
  padding: ${({ theme }) => theme.space * 1.5}px ${({ theme }) => theme.space * 5}px;
  border-radius: 24px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
  display: inline-block;
  border: none;
  outline: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.b60};
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.b60};
    outline-offset: 2px;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    padding: ${({ theme }) => theme.space * 1.5}px ${({ theme }) => theme.space * 4}px;
  }
`;

// src/components/molecules/PropertyPreviewComponents/PropertyUpgradeBanner/PropertyUpgradeBanner.tsx
var import_jsx_runtime152 = require("react/jsx-runtime");
var PropertyUpgradeBanner = ({
  propertyName,
  propertyImage,
  propertyId,
  onUpgradeClick,
  isSeeker = false
}) => {
  const theme = (0, import_styled_components163.useTheme)();
  const { t } = (0, import_react_i18next63.useTranslation)("common");
  const basicFeatures = [
    { icon: "check", text: t("components.upgradeBanner.featurePropertyData") },
    { icon: "check", text: t("components.upgradeBanner.featureContacts") },
    { icon: "check", text: t("components.upgradeBanner.featureAssets") },
    { icon: "check", text: t("components.upgradeBanner.featureTracking") }
  ];
  const planName = isSeeker ? "DASH Direct" : "DASH Basic";
  return /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(BannerContainer3, { children: /* @__PURE__ */ (0, import_jsx_runtime152.jsxs)(ImageSplitWrapper, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(ImageSideWrapper, { children: propertyImage ? /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(StyledImage3, { src: propertyImage, alt: propertyName, fit: "cover" }) : /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(ImagePlaceholder, {}) }),
    /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(ContentWrapper, { flexDirection: "column", p: 5, children: /* @__PURE__ */ (0, import_jsx_runtime152.jsxs)(Box_default, { style: { position: "relative", zIndex: 1 }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime152.jsxs)(Flex_default, { flexDirection: "column", mb: 5, children: [
        /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Box_default, { mb: 1, children: /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Text_default, { xl: true, semibold: true, color: theme.colors.n90, children: t("components.upgradeBanner.title", { propertyName }) }) }),
        /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Text_default, { color: theme.colors.n70, children: /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(
          import_react_i18next63.Trans,
          {
            i18nKey: "common:components.upgradeBanner.subtitle",
            values: { planName },
            components: { bold: /* @__PURE__ */ (0, import_jsx_runtime152.jsx)("b", {}) }
          }
        ) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Box_default, { mb: 5, children: basicFeatures.map((feature, index2) => /* @__PURE__ */ (0, import_jsx_runtime152.jsxs)(FeatureItem, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Icon_default, { name: feature.icon, size: 18, color: theme.colors.b50 }),
        /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Text_default, { color: theme.colors.n80, children: feature.text })
      ] }, index2)) }),
      /* @__PURE__ */ (0, import_jsx_runtime152.jsxs)(Flex_default, { flexDirection: "column", alignItems: "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(
          CTAButton,
          {
            as: "button",
            onClick: onUpgradeClick,
            mb: 1,
            id: propertyId ? `upgrade-banner-cta-${propertyId}` : "upgrade-banner-cta",
            children: /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Text_default, { semibold: true, color: "white", children: t("labels.startSevenDayTrial") })
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Text_default, { sm: true, color: theme.colors.n60, children: t("labels.cancelAnytime") })
      ] })
    ] }) })
  ] }) });
};
var PropertyUpgradeBanner_default = PropertyUpgradeBanner;

// src/components/molecules/InfoCard/InfoCard.tsx
var import_styled_components167 = require("styled-components");
var import_react_i18next65 = require("react-i18next");

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.enums.ts
var DatePeriodTypesEnum = /* @__PURE__ */ ((DatePeriodTypesEnum3) => {
  DatePeriodTypesEnum3["CURRENT_YEAR"] = "CURRENT_YEAR";
  DatePeriodTypesEnum3["CURRENT_WEEK"] = "CURRENT_WEEK";
  DatePeriodTypesEnum3["PAST_WEEK"] = "PAST_WEEK";
  DatePeriodTypesEnum3["CURRENT_MONTH"] = "CURRENT_MONTH";
  DatePeriodTypesEnum3["PAST_MONTH"] = "PAST_MONTH";
  DatePeriodTypesEnum3["THREE_MONTH"] = "THREE_MONTH";
  DatePeriodTypesEnum3["CUSTOM"] = "CUSTOM";
  return DatePeriodTypesEnum3;
})(DatePeriodTypesEnum || {});

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.helpers.ts
var import_moment9 = __toESM(require("moment"));
var import_dash_common47 = require("dash-common");
var getPeriodRangeByPeriodType = (type) => {
  if (type === "CURRENT_WEEK" /* CURRENT_WEEK */) {
    return (0, import_dash_common47.getDateRangeByPeriod)("week");
  }
  if (type === "CURRENT_MONTH" /* CURRENT_MONTH */) {
    return (0, import_dash_common47.getDateRangeByPeriod)("month");
  }
  if (type === "CURRENT_YEAR" /* CURRENT_YEAR */) {
    return (0, import_dash_common47.getDateRangeByPeriod)("year");
  }
  if (type === "PAST_WEEK" /* PAST_WEEK */) {
    const lastWeekDate = (0, import_moment9.default)().subtract(1, "week").toDate();
    return (0, import_dash_common47.getDateRangeByPeriod)("week", lastWeekDate);
  }
  if (type === "PAST_MONTH" /* PAST_MONTH */) {
    const lastWeekDate = (0, import_moment9.default)().subtract(1, "month").toDate();
    return (0, import_dash_common47.getDateRangeByPeriod)("month", lastWeekDate);
  }
  const startOfThreeMonth = (0, import_moment9.default)().subtract(2, "month").startOf("month").toDate();
  const endOfThreeMonth = (0, import_moment9.default)().endOf("month").toDate();
  return { startDate: startOfThreeMonth, endDate: endOfThreeMonth };
};

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.tsx
var import_lodash23 = require("lodash");
var import_react109 = require("react");
var import_styled_components165 = require("styled-components");
var import_react_i18next64 = require("react-i18next");

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.styles.tsx
var import_styled_components164 = __toESM(require("styled-components"));
var PeriodButton = (0, import_styled_components164.default)(Button_default)`
  border-radius: 0px;
  background-color: ${({ theme, active }) => active && theme.colors.b20};
  justify-content: left;
  white-space: nowrap;

  & p {
    color: ${({ theme }) => theme.colors.n90} !important;
  }
  :hover {
    background-color: ${({ theme }) => theme.colors.b20};
  }
`;

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.tsx
var import_jsx_runtime153 = require("react/jsx-runtime");
var DatePeriodPicker = ({
  color: color2,
  customEnabled,
  defaultType,
  anchorTextProps = { sm: true },
  anchorIconProps = { size: 16 },
  onChange,
  placementHorizontal = "right",
  hidePeriodTypes = [],
  ...args
}) => {
  const theme = (0, import_styled_components165.useTheme)();
  const { t } = (0, import_react_i18next64.useTranslation)("common");
  const [type, setType] = (0, import_react109.useState)(
    defaultType || "CURRENT_WEEK" /* CURRENT_WEEK */
  );
  const [dateRange, setDateRange] = (0, import_react109.useState)({
    startDate: /* @__PURE__ */ new Date()
  });
  const datePeriodTypes = Object.values(DatePeriodTypesEnum).filter(
    (value) => !hidePeriodTypes.includes(value)
  );
  const periodOptions = customEnabled ? datePeriodTypes : datePeriodTypes.filter((type2) => type2 !== "CUSTOM" /* CUSTOM */);
  (0, import_react109.useEffect)(() => {
    if (type !== "CUSTOM" /* CUSTOM */) {
      setDateRange(getPeriodRangeByPeriodType(type));
    }
  }, [type]);
  (0, import_react109.useEffect)(() => {
    if (dateRange.startDate && dateRange.endDate) {
      onChange(dateRange, type);
    }
  }, [dateRange]);
  return /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
    DropDown_default,
    {
      rerender: type,
      placementHorizontal,
      w: "100%",
      ...args,
      Anchor: ({ isOpen }) => /* @__PURE__ */ (0, import_jsx_runtime153.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", children: [
        /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(Text_default, { ellipsis: true, color: color2 || theme.colors.n90, ...anchorTextProps, children: (0, import_lodash23.capitalize)(
          t(`labels.dateRangePeriods.${(0, import_lodash23.camelCase)(type)}`)
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
          Icon_default,
          {
            color: color2 || theme.colors.n90,
            name: isOpen ? "arrowUp" : "arrowDown",
            ...anchorIconProps
          }
        )
      ] }),
      children: ({ closeDropdown }) => /* @__PURE__ */ (0, import_jsx_runtime153.jsxs)(Flex_default, { flexDirection: "column", children: [
        periodOptions.map((periodType) => /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
          PeriodButton,
          {
            active: type === periodType,
            w: "100%",
            variation: "flat",
            onClick: () => {
              setType(periodType);
              if (periodType !== "CUSTOM" /* CUSTOM */) {
                closeDropdown();
              }
            },
            children: t(`labels.dateRangePeriods.${(0, import_lodash23.camelCase)(periodType)}`)
          },
          periodType
        )),
        type === "CUSTOM" /* CUSTOM */ && /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(Box_default, { pt: 2, p: 4, minWidth: 276, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
          DateRangePicker_default,
          {
            popperProps: { strategy: "fixed" },
            selected: dateRange.startDate,
            onChange: (range) => {
              setDateRange(range);
            },
            startDate: dateRange.startDate,
            endDate: dateRange.endDate
          }
        ) })
      ] })
    }
  );
};
var DatePeriodPicker_default = DatePeriodPicker;

// src/components/molecules/InfoCard/InfoCard.styles.tsx
var import_styled_components166 = __toESM(require("styled-components"));
var StyledInfoCard = (0, import_styled_components166.default)(Flex_default)`
  flex-direction: column;
  box-shadow: none;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: ${({ theme }) => theme.space * 3}px;
  color: ${({ theme }) => theme.colors.white};
  ${({ bgImgSrc }) => bgImgSrc && `
      background-repeat: no-repeat;
      background-size: contain;
      background-position-y: 20px;
      background-position-x: calc(100% - 15px);
      background-image: url(${bgImgSrc});
    `};
`;
var ItemsGroupStyle = (0, import_styled_components166.default)(Flex_default)`
  & > div {
    margin: 0 ${({ theme }) => theme.space * 3}px;
    padding: 0 ${({ theme }) => theme.space * 3}px;
    justify-content: center;
    border-left: ${({ theme }) => `1px solid ${theme.colors.setOpacity(theme.colors.white, 20)};`}
    border-right: ${({ theme }) => `1px solid ${theme.colors.setOpacity(theme.colors.white, 20)};`}

    :first-child, :last-child {
      margin: 0;
      padding: 0;
      border: none;
      justify-content: left;
    }
  }
`;
var DisableWrapper = (0, import_styled_components166.default)(Flex_default)`
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${({ theme }) => `${theme.colors.setOpacity(theme.colors.white, 60)};`};
  cursor: not-allowed;
`;
var DropdownContainer = (0, import_styled_components166.default)(Box_default)`
  & div > div {
    left: 0;
    min-width: fit-content;
  }
`;

// src/components/molecules/InfoCard/InfoCard.tsx
var import_jsx_runtime154 = require("react/jsx-runtime");
var InfoCard2 = ({
  hasInfoData,
  infoPlaceholderDescription,
  infoDescription,
  infoPlaceholder,
  itemsInfo,
  buttonTitle,
  disabled,
  loading,
  buttonDisabled,
  onButtonClick,
  onRangeChange,
  range,
  ...args
}) => {
  const theme = (0, import_styled_components167.useTheme)();
  const { i18n } = (0, import_react_i18next65.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime154.jsxs)(StyledInfoCard, { w: "100%", h: 211, pos: "relative", p: 4, ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime154.jsxs)(Flex_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(DropdownContainer, { children: /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(DatePeriodPicker_default, { color: theme.colors.n30, onChange: onRangeChange }) }),
      /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Box_default, { ml: 2, children: /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Text_default, { sm: true, color: theme.colors.white, children: range.startDate && range.endDate ? formatDisplayRange(range.startDate, range.endDate, i18n.language) : "" }) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Flex_default, { mt: 6, mb: 2, alignItems: "center", children: hasInfoData && itemsInfo?.length ? /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(ItemsGroupStyle, { children: itemsInfo.map(({ key, info, iconName, iconProps, tooltipText }) => /* @__PURE__ */ (0, import_jsx_runtime154.jsxs)(Flex_default, { alignItems: "center", flex: 1, children: [
      /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Text_default, { ellipsis: true, xxl: true, bold: true, color: theme.colors.white, children: info }),
      /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(TooltipWrapper_default, { placement: "bottom", content: tooltipText, children: /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Icon_default, { ml: 3, size: 24, name: iconName, ...iconProps }) })
    ] }, key)) }) : /* @__PURE__ */ (0, import_jsx_runtime154.jsxs)(import_jsx_runtime154.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Icon_default, { name: infoPlaceholder.iconName, size: 24, mr: 3, ...infoPlaceholder.iconProps }),
      /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Text_default, { ellipsis: true, lg: true, bold: true, color: theme.colors.white, children: infoPlaceholder.info })
    ] }) }),
    /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Box_default, { children: hasInfoData ? /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Text_default, { color: theme.colors.white, children: infoDescription }) : /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Text_default, { sm: true, color: theme.colors.n30, children: infoPlaceholderDescription }) }),
    /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Flex_default, { flex: 1, alignItems: "end", pb: 1, children: /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(
      Button_default,
      {
        lg: true,
        disabled: disabled || buttonDisabled,
        minWidth: 147,
        variation: "outline",
        colorVariation: "light",
        onClick: onButtonClick,
        children: buttonTitle
      }
    ) }),
    disabled && /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(DisableWrapper, { pos: "absolute" }),
    loading && /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(
      Spinner_default,
      {
        fullContent: true,
        size: 26,
        bgColor: args.bgColor,
        color: theme.colors.white,
        opacity: 70
      }
    )
  ] });
};
var InfoCard_default = InfoCard2;

// src/components/molecules/AddressLabel/AddressLabel.tsx
var import_dash_common48 = require("dash-common");
var import_jsx_runtime155 = require("react/jsx-runtime");
function AddressLabel({
  address,
  tooltip = true,
  ellipsis = true,
  offset,
  ...args
}) {
  const addressLabel = address ? (0, import_dash_common48.formatAddress)(address) : "";
  const content = /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(Box_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(Text_default, { ellipsis, ...args, children: addressLabel }) });
  return /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(import_jsx_runtime155.Fragment, { children: tooltip ? /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(TooltipWrapper_default, { content: addressLabel, offset, ...args, children: content }) : content });
}
var AddressLabel_default = AddressLabel;

// src/components/molecules/DashboardBanner/DashboardBanner.tsx
var import_react111 = require("react");

// src/components/molecules/DashboardBanner/DashboardBanner.context.tsx
var import_react110 = require("react");
var import_jsx_runtime156 = require("react/jsx-runtime");
var DashboardNotificationBannerContext = (0, import_react110.createContext)({
  notifications: [],
  setNotification: () => {
  },
  setNotifications: () => {
  },
  removeNotification: () => {
  }
});
var DashboardNotificationBannerProvider = ({ children }) => {
  const [notifications, setStateNotifications] = (0, import_react110.useState)([]);
  const setNotifications = (items) => {
    setStateNotifications((prev) => [...prev, ...items]);
  };
  const setNotification = (item) => {
    setStateNotifications((prev) => {
      const isNotificationExist = prev.some(({ itemId }) => itemId === item.itemId);
      return isNotificationExist ? prev : [...prev, item];
    });
  };
  const removeNotification = (notificationId) => {
    setStateNotifications((prev) => prev.filter(({ itemId }) => itemId !== notificationId));
  };
  const sortedNotifications = (0, import_react110.useMemo)(
    () => notifications.sort(
      (prev, curr) => BANNER_SORT_ORDER[prev.type || "success" /* SUCCESS */] - BANNER_SORT_ORDER[curr.type || "success" /* SUCCESS */]
    ),
    [notifications]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(
    DashboardNotificationBannerContext.Provider,
    {
      value: {
        notifications: sortedNotifications,
        removeNotification,
        setNotifications,
        setNotification
      },
      children
    }
  );
};

// src/components/molecules/DashboardBanner/DashboardBanner.tsx
var import_jsx_runtime157 = require("react/jsx-runtime");
var DashboardBanner = ({ ...props }) => {
  const [currentIndex, setCurrentIndex] = (0, import_react111.useState)(0);
  const { notifications } = (0, import_react111.useContext)(DashboardNotificationBannerContext);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const countPerPage = 5;
  const shift = currentIndex - countPerPage + 1 > 0 ? currentIndex - countPerPage + 1 : 0;
  return /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Flex_default, { flexDirection: "column", w: "100%", alignItems: "center", ...props, children: [
    notifications.map(
      ({ type, message, onViewClick, itemId, onDismissClick, submitButtonLabel }, index2) => {
        const { background, color: color2 } = BANNER_OPTIONS[type || "success" /* SUCCESS */];
        return index2 === currentIndex ? /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Flex_default, { w: "100%", alignItems: "stretch", children: [
          /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
            Banner_default,
            {
              message,
              type: type || "success" /* SUCCESS */,
              onDismissClick: onDismissClick ? () => onDismissClick(itemId) : onDismissClick,
              onViewClick: onViewClick ? () => onViewClick(itemId) : onViewClick,
              submitButtonLabel
            }
          ),
          notifications.length > 1 && !isMobile && /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(import_jsx_runtime157.Fragment, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
              PaginationButton,
              {
                w: 48,
                h: "unset",
                icon: "chevronLeft",
                background,
                color: color2,
                mx: 2,
                disabled: !(currentIndex > 0),
                onClick: () => setCurrentIndex((prevIndex) => prevIndex - 1)
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
              PaginationButton,
              {
                w: 48,
                h: "unset",
                icon: "chevronRight",
                color: color2,
                background,
                disabled: !(currentIndex < notifications.length - 1),
                onClick: () => setCurrentIndex((prevIndex) => prevIndex + 1)
              }
            )
          ] })
        ] }, `${itemId}-${index2}`) : null;
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Flex_default, { mt: 2, children: Array.from({
      length: notifications.length > countPerPage ? countPerPage : notifications.length
    }).map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
      PaginationDot,
      {
        mr: 2,
        w: 8,
        h: 8,
        isActive: shift + index2 === currentIndex,
        onClick: () => setCurrentIndex(index2 + shift)
      },
      index2
    )) })
  ] });
};
var DashboardBanner_default = DashboardBanner;

// src/components/molecules/WasDeleted/WasDeleted.tsx
var import_styled_components169 = require("styled-components");
var import_react_i18next66 = require("react-i18next");

// src/components/molecules/WasDeleted/WasDeleted.styles.ts
var import_styled_components168 = __toESM(require("styled-components"));
var PageWrapper2 = (0, import_styled_components168.default)(Flex_default)`
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
var VerticalDevider2 = (0, import_styled_components168.default)(Box_default)`
  background: ${({ theme }) => theme.colors.n90};
  border-radius: ${({ theme }) => theme.space * 2}px;
`;
var StyledHeading2 = (0, import_styled_components168.default)(H_default)`
  display: flex;
  align-items: center;
`;

// src/components/molecules/WasDeleted/WasDeleted.tsx
var import_jsx_runtime158 = require("react/jsx-runtime");
var WasDeleted = ({ onRedirect, entityName }) => {
  const theme = (0, import_styled_components169.useTheme)();
  const { t } = (0, import_react_i18next66.useTranslation)("pages");
  return /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(PageWrapper2, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime158.jsxs)(Flex_default, { w: 443, flexDirection: "column", justifyContent: "center", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime158.jsxs)(StyledHeading2, { lg: true, bold: true, color: theme.colors.n90, children: [
      "404",
      /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(VerticalDevider2, { h: 38, w: 4, mx: 8 }),
      t("wasDeleted.title", {
        entityName
      })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(Button_default, { h: 40, minWidth: 153, onClick: onRedirect, children: t("notFoundPage.buttonLabel") })
  ] }) });
};
var WasDeleted_default = WasDeleted;

// src/components/molecules/ScrollDragable/ScrollDragable.tsx
var import_react112 = require("react");
var import_styled_components170 = __toESM(require("styled-components"));
var import_jsx_runtime159 = require("react/jsx-runtime");
var DivStyles = import_styled_components170.default.div`
  cursor: pointer;
  width: 100%;
  overflow: auto;
  touchaction: none;
  ::-webkit-scrollbar {
    height: 2px;
    width: 3px;
  }
  ::-webkit-scrollbar-track:horizontal {
    box-shadow: inset 0 0 6px ${({ theme }) => theme.colors.n60};
  }
  ::-webkit-scrollbar-thumb:horizontal {
    background-color: ${({ theme }) => theme.colors.g20};
  }
  ::-webkit-scrollbar-thumb:vertical {
    background-color: ${({ theme }) => theme.colors.n60};
  }
`;
var ScrollDragable = ({ children }) => {
  const ref = (0, import_react112.useRef)(null);
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;
  (0, import_react112.useEffect)(() => {
    const slider = ref.current;
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown)
        return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(DivStyles, { ref, children });
};
var ScrollDragable_default = ScrollDragable;

// src/components/molecules/UnauthorizedIDX/UnauthorizedPage.tsx
var import_styled_components172 = require("styled-components");
var import_react_i18next67 = require("react-i18next");

// src/components/molecules/UnauthorizedIDX/UnauthorizedPage.style.ts
var import_styled_components171 = __toESM(require("styled-components"));
var PageWrapper3 = (0, import_styled_components171.default)(Flex_default)`
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
var VerticalDevider3 = (0, import_styled_components171.default)(Box_default)`
  background: ${({ theme }) => theme.colors.n90};
  border-radius: ${({ theme }) => theme.space * 2}px;
`;
var StyledHeading3 = (0, import_styled_components171.default)(H_default)`
  display: flex;
  align-items: center;
`;

// src/components/molecules/UnauthorizedIDX/UnauthorizedPage.tsx
var import_jsx_runtime160 = require("react/jsx-runtime");
var UnauthorizedPage = ({ onRedirect }) => {
  const theme = (0, import_styled_components172.useTheme)();
  const { t } = (0, import_react_i18next67.useTranslation)("pages");
  return /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(PageWrapper3, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime160.jsxs)(
    Flex_default,
    {
      w: 443,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime160.jsxs)(StyledHeading3, { lg: true, bold: true, color: theme.colors.n90, children: [
          "401",
          /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(VerticalDevider3, { h: 38, w: 4, mx: 8 }),
          t("idx.unauthorizedTitle")
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(Box_default, { mb: 4, mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(Text_default, { color: theme.colors.n80, children: t("idx.unauthorizedSubtitle") }) }),
        /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(Button_default, { h: 40, minWidth: 153, onClick: onRedirect, children: t("idx.visitDash") })
      ]
    }
  ) });
};
var UnauthorizedPage_default = UnauthorizedPage;

// src/components/molecules/PropertySalesGallerySection/PropertySalesGallerySection.tsx
var import_react145 = require("react");
var import_react_i18next106 = require("react-i18next");

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/ApiAccessChart.tsx
var import_react116 = require("react");
var import_styled_components174 = __toESM(require("styled-components"));

// ../../node_modules/react-chartjs-2/dist/index.js
var import_react113 = __toESM(require("react"), 1);

// ../../node_modules/@kurkle/color/dist/color.esm.js
function round(v) {
  return v + 0.5 | 0;
}
var lim = (v, l, h) => Math.max(Math.min(v, h), l);
function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}
function n2b(v) {
  return lim(round(v * 255), 0, 255);
}
function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
  return lim(round(v * 100), 0, 100);
}
var map$1 = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 };
var hex = [..."0123456789ABCDEF"];
var h1 = (b) => hex[b & 15];
var h2 = (b) => hex[(b & 240) >> 4] + hex[b & 15];
var eq = (b) => (b & 240) >> 4 === (b & 15);
var isShort = (v) => eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === "#") {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
      };
    }
  }
  return ret;
}
var alpha = (a, f) => a < 255 ? f(a) : "";
function hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v ? "#" + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : void 0;
}
var HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  return [f(0), f(8), f(4)];
}
function hsv2rgbn(h, s, v) {
  const f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  return [f(5), f(3), f(1)];
}
function hwb2rgbn(h, w, b) {
  const rgb2 = hsl2rgbn(h, 1, 0.5);
  let i;
  if (w + b > 1) {
    i = 1 / (w + b);
    w *= i;
    b *= i;
  }
  for (i = 0; i < 3; i++) {
    rgb2[i] *= 1 - w - b;
    rgb2[i] += w;
  }
  return rgb2;
}
function hueValue(r, g, b, d, max) {
  if (r === max) {
    return (g - b) / d + (g < b ? 6 : 0);
  }
  if (g === max) {
    return (b - r) / d + 2;
  }
  return (r - g) / d + 4;
}
function rgb2hsl(v) {
  const range = 255;
  const r = v.r / range;
  const g = v.g / range;
  const b = v.b / range;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h, s, d;
  if (max !== min) {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = hueValue(r, g, b, d, max);
    h = h * 60 + 0.5;
  }
  return [h | 0, s || 0, l];
}
function calln(f, a, b, c) {
  return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
  return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
  return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
  return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
  return (h % 360 + 360) % 360;
}
function hueParse(str) {
  const m = HUE_RE.exec(str);
  let a = 255;
  let v;
  if (!m) {
    return;
  }
  if (m[5] !== v) {
    a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
  }
  const h = hue(+m[2]);
  const p1 = +m[3] / 100;
  const p2 = +m[4] / 100;
  if (m[1] === "hwb") {
    v = hwb2rgb(h, p1, p2);
  } else if (m[1] === "hsv") {
    v = hsv2rgb(h, p1, p2);
  } else {
    v = hsl2rgb(h, p1, p2);
  }
  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a
  };
}
function rotate(v, deg) {
  var h = rgb2hsl(v);
  h[0] = hue(h[0] + deg);
  h = hsl2rgb(h);
  v.r = h[0];
  v.g = h[1];
  v.b = h[2];
}
function hslString(v) {
  if (!v) {
    return;
  }
  const a = rgb2hsl(v);
  const h = a[0];
  const s = n2p(a[1]);
  const l = n2p(a[2]);
  return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
var map = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
};
var names$1 = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function unpack() {
  const unpacked = {};
  const keys = Object.keys(names$1);
  const tkeys = Object.keys(map);
  let i, j, k, ok, nk;
  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];
    for (j = 0; j < tkeys.length; j++) {
      k = tkeys[j];
      nk = nk.replace(k, map[k]);
    }
    k = parseInt(names$1[ok], 16);
    unpacked[nk] = [k >> 16 & 255, k >> 8 & 255, k & 255];
  }
  return unpacked;
}
var names;
function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }
  const a = names[str.toLowerCase()];
  return a && {
    r: a[0],
    g: a[1],
    b: a[2],
    a: a.length === 4 ? a[3] : 255
  };
}
var RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m = RGB_RE.exec(str);
  let a = 255;
  let r, g, b;
  if (!m) {
    return;
  }
  if (m[7] !== r) {
    const v = +m[7];
    a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
  }
  r = +m[1];
  g = +m[3];
  b = +m[5];
  r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
  g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
  b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
  return {
    r,
    g,
    b,
    a
  };
}
function rgbString(v) {
  return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
var to = (v) => v <= 31308e-7 ? v * 12.92 : Math.pow(v, 1 / 2.4) * 1.055 - 0.055;
var from = (v) => v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
  const r = from(b2n(rgb1.r));
  const g = from(b2n(rgb1.g));
  const b = from(b2n(rgb1.b));
  return {
    r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
    g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
    b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
    a: rgb1.a + t * (rgb2.a - rgb1.a)
  };
}
function modHSL(v, i, ratio) {
  if (v) {
    let tmp = rgb2hsl(v);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}
function clone(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
  var v = { r: 0, g: 0, b: 0, a: 255 };
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = { r: input[0], g: input[1], b: input[2], a: 255 };
      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone(input, { r: 0, g: 0, b: 0, a: 1 });
    v.a = n2b(v.a);
  }
  return v;
}
function functionParse(str) {
  if (str.charAt(0) === "r") {
    return rgbParse(str);
  }
  return hueParse(str);
}
var Color = class _Color {
  constructor(input) {
    if (input instanceof _Color) {
      return input;
    }
    const type = typeof input;
    let v;
    if (type === "object") {
      v = fromObject(input);
    } else if (type === "string") {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v;
    this._valid = !!v;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v = clone(this._rgb);
    if (v) {
      v.a = b2n(v.a);
    }
    return v;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : void 0;
  }
  mix(color2, weight) {
    if (color2) {
      const c1 = this.rgb;
      const c2 = color2.rgb;
      let w2;
      const p = weight === w2 ? 0.5 : weight;
      const w = 2 * p - 1;
      const a = c1.a - c2.a;
      const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
      w2 = 1 - w1;
      c1.r = 255 & w1 * c1.r + w2 * c2.r + 0.5;
      c1.g = 255 & w1 * c1.g + w2 * c2.g + 0.5;
      c1.b = 255 & w1 * c1.b + w2 * c2.b + 0.5;
      c1.a = p * c1.a + (1 - p) * c2.a;
      this.rgb = c1;
    }
    return this;
  }
  interpolate(color2, t) {
    if (color2) {
      this._rgb = interpolate(this._rgb, color2._rgb, t);
    }
    return this;
  }
  clone() {
    return new _Color(this.rgb);
  }
  alpha(a) {
    this._rgb.a = n2b(a);
    return this;
  }
  clearer(ratio) {
    const rgb2 = this._rgb;
    rgb2.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb2 = this._rgb;
    const val = round(rgb2.r * 0.3 + rgb2.g * 0.59 + rgb2.b * 0.11);
    rgb2.r = rgb2.g = rgb2.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb2 = this._rgb;
    rgb2.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v = this._rgb;
    v.r = 255 - v.r;
    v.g = 255 - v.g;
    v.b = 255 - v.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
};

// ../../node_modules/chart.js/dist/chunks/helpers.segment.js
function noop() {
}
var uid = (() => {
  let id2 = 0;
  return () => id2++;
})();
function isNullOrUndef(value) {
  return value === null || typeof value === "undefined";
}
function isArray(value) {
  if (Array.isArray && Array.isArray(value)) {
    return true;
  }
  const type = Object.prototype.toString.call(value);
  if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") {
    return true;
  }
  return false;
}
function isObject(value) {
  return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
function isNumberFinite(value) {
  return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
function finiteOrDefault(value, defaultValue) {
  return isNumberFinite(value) ? value : defaultValue;
}
function valueOrDefault(value, defaultValue) {
  return typeof value === "undefined" ? defaultValue : value;
}
var toDimension = (value, dimension) => typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function callback(fn, args, thisArg) {
  if (fn && typeof fn.call === "function") {
    return fn.apply(thisArg, args);
  }
}
function each(loopable, fn, thisArg, reverse) {
  let i, len, keys;
  if (isArray(loopable)) {
    len = loopable.length;
    if (reverse) {
      for (i = len - 1; i >= 0; i--) {
        fn.call(thisArg, loopable[i], i);
      }
    } else {
      for (i = 0; i < len; i++) {
        fn.call(thisArg, loopable[i], i);
      }
    }
  } else if (isObject(loopable)) {
    keys = Object.keys(loopable);
    len = keys.length;
    for (i = 0; i < len; i++) {
      fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
  }
}
function _elementsEqual(a0, a1) {
  let i, ilen, v0, v1;
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }
  for (i = 0, ilen = a0.length; i < ilen; ++i) {
    v0 = a0[i];
    v1 = a1[i];
    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }
  return true;
}
function clone2(source) {
  if (isArray(source)) {
    return source.map(clone2);
  }
  if (isObject(source)) {
    const target = /* @__PURE__ */ Object.create(null);
    const keys = Object.keys(source);
    const klen = keys.length;
    let k = 0;
    for (; k < klen; ++k) {
      target[keys[k]] = clone2(source[keys[k]]);
    }
    return target;
  }
  return source;
}
function isValidKey(key) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(key) === -1;
}
function _merger(key, target, source, options) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    merge(tval, sval, options);
  } else {
    target[key] = clone2(sval);
  }
}
function merge(target, source, options) {
  const sources = isArray(source) ? source : [
    source
  ];
  const ilen = sources.length;
  if (!isObject(target)) {
    return target;
  }
  options = options || {};
  const merger = options.merger || _merger;
  let current;
  for (let i = 0; i < ilen; ++i) {
    current = sources[i];
    if (!isObject(current)) {
      continue;
    }
    const keys = Object.keys(current);
    for (let k = 0, klen = keys.length; k < klen; ++k) {
      merger(keys[k], target, current, options);
    }
  }
  return target;
}
function mergeIf(target, source) {
  return merge(target, source, {
    merger: _mergerIf
  });
}
function _mergerIf(key, target, source) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = clone2(sval);
  }
}
var keyResolvers = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (v) => v,
  // default resolvers
  x: (o) => o.x,
  y: (o) => o.y
};
function _splitKey(key) {
  const parts = key.split(".");
  const keys = [];
  let tmp = "";
  for (const part of parts) {
    tmp += part;
    if (tmp.endsWith("\\")) {
      tmp = tmp.slice(0, -1) + ".";
    } else {
      keys.push(tmp);
      tmp = "";
    }
  }
  return keys;
}
function _getKeyResolver(key) {
  const keys = _splitKey(key);
  return (obj) => {
    for (const k of keys) {
      if (k === "") {
        break;
      }
      obj = obj && obj[k];
    }
    return obj;
  };
}
function resolveObjectKey(obj, key) {
  const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
  return resolver(obj);
}
function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
var defined = (value) => typeof value !== "undefined";
var isFunction = (value) => typeof value === "function";
var setsEqual = (a, b) => {
  if (a.size !== b.size) {
    return false;
  }
  for (const item of a) {
    if (!b.has(item)) {
      return false;
    }
  }
  return true;
};
function _isClickEvent(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
var PI = Math.PI;
var TAU = 2 * PI;
var PITAU = TAU + PI;
var INFINITY = Number.POSITIVE_INFINITY;
var RAD_PER_DEG = PI / 180;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;
var log10 = Math.log10;
var sign = Math.sign;
function almostEquals(x, y, epsilon) {
  return Math.abs(x - y) < epsilon;
}
function niceNum(range) {
  const roundedRange = Math.round(range);
  range = almostEquals(range, roundedRange, range / 1e3) ? roundedRange : range;
  const niceRange = Math.pow(10, Math.floor(log10(range)));
  const fraction = range / niceRange;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}
function _factorize(value) {
  const result = [];
  const sqrt = Math.sqrt(value);
  let i;
  for (i = 1; i < sqrt; i++) {
    if (value % i === 0) {
      result.push(i);
      result.push(value / i);
    }
  }
  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }
  result.sort((a, b) => a - b).pop();
  return result;
}
function isNumber6(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
  const rounded = Math.round(x);
  return rounded - epsilon <= x && rounded + epsilon >= x;
}
function _setMinAndMaxByKey(array, target, property) {
  let i, ilen, value;
  for (i = 0, ilen = array.length; i < ilen; i++) {
    value = array[i][property];
    if (!isNaN(value)) {
      target.min = Math.min(target.min, value);
      target.max = Math.max(target.max, value);
    }
  }
}
function toRadians(degrees) {
  return degrees * (PI / 180);
}
function toDegrees(radians) {
  return radians * (180 / PI);
}
function _decimalPlaces(x) {
  if (!isNumberFinite(x)) {
    return;
  }
  let e = 1;
  let p = 0;
  while (Math.round(x * e) / e !== x) {
    e *= 10;
    p++;
  }
  return p;
}
function getAngleFromPoint(centrePoint, anglePoint) {
  const distanceFromXCenter = anglePoint.x - centrePoint.x;
  const distanceFromYCenter = anglePoint.y - centrePoint.y;
  const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
  if (angle < -0.5 * PI) {
    angle += TAU;
  }
  return {
    angle,
    distance: radialDistanceFromCenter
  };
}
function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function _angleDiff(a, b) {
  return (a - b + PITAU) % TAU - PI;
}
function _normalizeAngle(a) {
  return (a % TAU + TAU) % TAU;
}
function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
  const a = _normalizeAngle(angle);
  const s = _normalizeAngle(start);
  const e = _normalizeAngle(end);
  const angleToStart = _normalizeAngle(s - a);
  const angleToEnd = _normalizeAngle(e - a);
  const startToAngle = _normalizeAngle(a - s);
  const endToAngle = _normalizeAngle(a - e);
  return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function _limitValue(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function _int16Range(value) {
  return _limitValue(value, -32768, 32767);
}
function _isBetween(value, start, end, epsilon = 1e-6) {
  return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
  cmp = cmp || ((index2) => table[index2] < value);
  let hi = table.length - 1;
  let lo = 0;
  let mid;
  while (hi - lo > 1) {
    mid = lo + hi >> 1;
    if (cmp(mid)) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  return {
    lo,
    hi
  };
}
var _lookupByKey = (table, key, value, last) => _lookup(table, value, last ? (index2) => {
  const ti = table[index2][key];
  return ti < value || ti === value && table[index2 + 1][key] === value;
} : (index2) => table[index2][key] < value);
var _rlookupByKey = (table, key, value) => _lookup(table, value, (index2) => table[index2][key] >= value);
function _filterBetween(values, min, max) {
  let start = 0;
  let end = values.length;
  while (start < end && values[start] < min) {
    start++;
  }
  while (end > start && values[end - 1] > max) {
    end--;
  }
  return start > 0 || end < values.length ? values.slice(start, end) : values;
}
var arrayEvents = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);
    return;
  }
  Object.defineProperty(array, "_chartjs", {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [
        listener
      ]
    }
  });
  arrayEvents.forEach((key) => {
    const method = "_onData" + _capitalize(key);
    const base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value(...args) {
        const res = base.apply(this, args);
        array._chartjs.listeners.forEach((object) => {
          if (typeof object[method] === "function") {
            object[method](...args);
          }
        });
        return res;
      }
    });
  });
}
function unlistenArrayEvents(array, listener) {
  const stub = array._chartjs;
  if (!stub) {
    return;
  }
  const listeners = stub.listeners;
  const index2 = listeners.indexOf(listener);
  if (index2 !== -1) {
    listeners.splice(index2, 1);
  }
  if (listeners.length > 0) {
    return;
  }
  arrayEvents.forEach((key) => {
    delete array[key];
  });
  delete array._chartjs;
}
function _arrayUnique(items) {
  const set2 = new Set(items);
  if (set2.size === items.length) {
    return items;
  }
  return Array.from(set2);
}
var requestAnimFrame = function() {
  if (typeof window === "undefined") {
    return function(callback2) {
      return callback2();
    };
  }
  return window.requestAnimationFrame;
}();
function throttled(fn, thisArg) {
  let argsToUse = [];
  let ticking = false;
  return function(...args) {
    argsToUse = args;
    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, () => {
        ticking = false;
        fn.apply(thisArg, argsToUse);
      });
    }
  };
}
function debounce(fn, delay) {
  let timeout;
  return function(...args) {
    if (delay) {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay, args);
    } else {
      fn.apply(this, args);
    }
    return delay;
  };
}
var _toLeftRightCenter = (align) => align === "start" ? "left" : align === "end" ? "right" : "center";
var _alignStartEnd = (align, start, end) => align === "start" ? start : align === "end" ? end : (start + end) / 2;
function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  const pointCount = points.length;
  let start = 0;
  let count = pointCount;
  if (meta._sorted) {
    const { iScale, _parsed } = meta;
    const axis = iScale.axis;
    const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) {
      start = _limitValue(Math.min(
        // @ts-expect-error Need to type _parsed
        _lookupByKey(_parsed, axis, min).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo
      ), 0, pointCount - 1);
    }
    if (maxDefined) {
      count = _limitValue(Math.max(
        // @ts-expect-error Need to type _parsed
        _lookupByKey(_parsed, iScale.axis, max, true).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1
      ), start, pointCount) - start;
    } else {
      count = pointCount - start;
    }
  }
  return {
    start,
    count
  };
}
function _scaleRangesChanged(meta) {
  const { xScale, yScale, _scaleRanges } = meta;
  const newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };
  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }
  const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}
var atEdge = (t) => t === 0 || t === 1;
var elasticIn = (t, s, p) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
var elasticOut = (t, s, p) => Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
var effects = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * HALF_PI) + 1,
  easeOutSine: (t) => Math.sin(t * HALF_PI),
  easeInOutSine: (t) => -0.5 * (Math.cos(PI * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
  easeOutElastic: (t) => atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
  easeInOutElastic(t) {
    const s = 0.1125;
    const p = 0.45;
    return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
  },
  easeInBack(t) {
    const s = 1.70158;
    return t * t * ((s + 1) * t - s);
  },
  easeOutBack(t) {
    const s = 1.70158;
    return (t -= 1) * t * ((s + 1) * t + s) + 1;
  },
  easeInOutBack(t) {
    let s = 1.70158;
    if ((t /= 0.5) < 1) {
      return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
    }
    return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
  },
  easeInBounce: (t) => 1 - effects.easeOutBounce(1 - t),
  easeOutBounce(t) {
    const m = 7.5625;
    const d = 2.75;
    if (t < 1 / d) {
      return m * t * t;
    }
    if (t < 2 / d) {
      return m * (t -= 1.5 / d) * t + 0.75;
    }
    if (t < 2.5 / d) {
      return m * (t -= 2.25 / d) * t + 0.9375;
    }
    return m * (t -= 2.625 / d) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
  if (value && typeof value === "object") {
    const type = value.toString();
    return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
  }
  return false;
}
function color(value) {
  return isPatternOrGradient(value) ? value : new Color(value);
}
function getHoverColor(value) {
  return isPatternOrGradient(value) ? value : new Color(value).saturate(0.5).darken(0.1).hexString();
}
var numbers = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
];
var colors = [
  "color",
  "borderColor",
  "backgroundColor"
];
function applyAnimationsDefaults(defaults2) {
  defaults2.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  });
  defaults2.describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name) => name !== "onProgress" && name !== "onComplete" && name !== "fn"
  });
  defaults2.set("animations", {
    colors: {
      type: "color",
      properties: colors
    },
    numbers: {
      type: "number",
      properties: numbers
    }
  });
  defaults2.describe("animations", {
    _fallback: "animation"
  });
  defaults2.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (v) => v | 0
        }
      }
    }
  });
}
function applyLayoutsDefaults(defaults2) {
  defaults2.set("layout", {
    autoPadding: true,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
var intlCache = /* @__PURE__ */ new Map();
function getNumberFormat(locale, options) {
  options = options || {};
  const cacheKey = locale + JSON.stringify(options);
  let formatter = intlCache.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options);
    intlCache.set(cacheKey, formatter);
  }
  return formatter;
}
function formatNumber(num, locale, options) {
  return getNumberFormat(locale, options).format(num);
}
var formatters = {
  values(value) {
    return isArray(value) ? value : "" + value;
  },
  numeric(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const locale = this.chart.options.locale;
    let notation;
    let delta = tickValue;
    if (ticks.length > 1) {
      const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
      if (maxTick < 1e-4 || maxTick > 1e15) {
        notation = "scientific";
      }
      delta = calculateDelta(tickValue, ticks);
    }
    const logDelta = log10(Math.abs(delta));
    const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    const options = {
      notation,
      minimumFractionDigits: numDecimal,
      maximumFractionDigits: numDecimal
    };
    Object.assign(options, this.options.ticks.format);
    return formatNumber(tickValue, locale, options);
  },
  logarithmic(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const remain = ticks[index2].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
    if ([
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(remain) || index2 > 0.8 * ticks.length) {
      return formatters.numeric.call(this, tickValue, index2, ticks);
    }
    return "";
  }
};
function calculateDelta(tickValue, ticks) {
  let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }
  return delta;
}
var Ticks = {
  formatters
};
function applyScaleDefaults(defaults2) {
  defaults2.set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    clip: true,
    grace: 0,
    grid: {
      display: true,
      lineWidth: 1,
      drawOnChartArea: true,
      drawTicks: true,
      tickLength: 8,
      tickWidth: (_ctx, options) => options.lineWidth,
      tickColor: (_ctx, options) => options.color,
      offset: false
    },
    border: {
      display: true,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: false,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: false,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: true,
      autoSkip: true,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ticks.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: false,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  });
  defaults2.route("scale.ticks", "color", "", "color");
  defaults2.route("scale.grid", "color", "", "borderColor");
  defaults2.route("scale.border", "color", "", "borderColor");
  defaults2.route("scale.title", "color", "", "color");
  defaults2.describe("scale", {
    _fallback: false,
    _scriptable: (name) => !name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name) => name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
  });
  defaults2.describe("scales", {
    _fallback: "scale"
  });
  defaults2.describe("scale.ticks", {
    _scriptable: (name) => name !== "backdropPadding" && name !== "callback",
    _indexable: (name) => name !== "backdropPadding"
  });
}
var overrides = /* @__PURE__ */ Object.create(null);
var descriptors = /* @__PURE__ */ Object.create(null);
function getScope$1(node, key) {
  if (!key) {
    return node;
  }
  const keys = key.split(".");
  for (let i = 0, n = keys.length; i < n; ++i) {
    const k = keys[i];
    node = node[k] || (node[k] = /* @__PURE__ */ Object.create(null));
  }
  return node;
}
function set(root, scope, values) {
  if (typeof scope === "string") {
    return merge(getScope$1(root, scope), values);
  }
  return merge(getScope$1(root, ""), scope);
}
var Defaults = class {
  constructor(_descriptors2, _appliers) {
    this.animation = void 0;
    this.backgroundColor = "rgba(0,0,0,0.1)";
    this.borderColor = "rgba(0,0,0,0.1)";
    this.color = "#666";
    this.datasets = {};
    this.devicePixelRatio = (context) => context.chart.platform.getDevicePixelRatio();
    this.elements = {};
    this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};
    this.hoverBackgroundColor = (ctx, options) => getHoverColor(options.backgroundColor);
    this.hoverBorderColor = (ctx, options) => getHoverColor(options.borderColor);
    this.hoverColor = (ctx, options) => getHoverColor(options.color);
    this.indexAxis = "x";
    this.interaction = {
      mode: "nearest",
      intersect: true,
      includeInvisible: false
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = void 0;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors2);
    this.apply(_appliers);
  }
  set(scope, values) {
    return set(this, scope, values);
  }
  get(scope) {
    return getScope$1(this, scope);
  }
  describe(scope, values) {
    return set(descriptors, scope, values);
  }
  override(scope, values) {
    return set(overrides, scope, values);
  }
  route(scope, name, targetScope, targetName) {
    const scopeObject = getScope$1(this, scope);
    const targetScopeObject = getScope$1(this, targetScope);
    const privateName = "_" + name;
    Object.defineProperties(scopeObject, {
      [privateName]: {
        value: scopeObject[name],
        writable: true
      },
      [name]: {
        enumerable: true,
        get() {
          const local = this[privateName];
          const target = targetScopeObject[targetName];
          if (isObject(local)) {
            return Object.assign({}, target, local);
          }
          return valueOrDefault(local, target);
        },
        set(value) {
          this[privateName] = value;
        }
      }
    });
  }
  apply(appliers) {
    appliers.forEach((apply) => apply(this));
  }
};
var defaults = /* @__PURE__ */ new Defaults({
  _scriptable: (name) => !name.startsWith("on"),
  _indexable: (name) => name !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: false,
    _indexable: false
  }
}, [
  applyAnimationsDefaults,
  applyLayoutsDefaults,
  applyScaleDefaults
]);
function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }
  return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function _measureText(ctx, data, gc, longest, string) {
  let textWidth = data[string];
  if (!textWidth) {
    textWidth = data[string] = ctx.measureText(string).width;
    gc.push(string);
  }
  if (textWidth > longest) {
    longest = textWidth;
  }
  return longest;
}
function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  let data = cache.data = cache.data || {};
  let gc = cache.garbageCollect = cache.garbageCollect || [];
  if (cache.font !== font) {
    data = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }
  ctx.save();
  ctx.font = font;
  let longest = 0;
  const ilen = arrayOfThings.length;
  let i, j, jlen, thing, nestedThing;
  for (i = 0; i < ilen; i++) {
    thing = arrayOfThings[i];
    if (thing !== void 0 && thing !== null && !isArray(thing)) {
      longest = _measureText(ctx, data, gc, longest, thing);
    } else if (isArray(thing)) {
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];
        if (nestedThing !== void 0 && nestedThing !== null && !isArray(nestedThing)) {
          longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
      }
    }
  }
  ctx.restore();
  const gcLen = gc.length / 2;
  if (gcLen > arrayOfThings.length) {
    for (i = 0; i < gcLen; i++) {
      delete data[gc[i]];
    }
    gc.splice(0, gcLen);
  }
  return longest;
}
function _alignPixel(chart, pixel, width) {
  const devicePixelRatio = chart.currentDevicePixelRatio;
  const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function clearCanvas(canvas, ctx) {
  ctx = ctx || canvas.getContext("2d");
  ctx.save();
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}
function drawPoint(ctx, options, x, y) {
  drawPointLegend(ctx, options, x, y, null);
}
function drawPointLegend(ctx, options, x, y, w) {
  let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
  const style = options.pointStyle;
  const rotation = options.rotation;
  const radius = options.radius;
  let rad = (rotation || 0) * RAD_PER_DEG;
  if (style && typeof style === "object") {
    type = style.toString();
    if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }
  if (isNaN(radius) || radius <= 0) {
    return;
  }
  ctx.beginPath();
  switch (style) {
    default:
      if (w) {
        ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
      } else {
        ctx.arc(x, y, radius, 0, TAU);
      }
      ctx.closePath();
      break;
    case "triangle":
      width = w ? w / 2 : radius;
      ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      ctx.closePath();
      break;
    case "rectRounded":
      cornerRadius = radius * 0.516;
      size = radius - cornerRadius;
      xOffset = Math.cos(rad + QUARTER_PI) * size;
      xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
      yOffset = Math.sin(rad + QUARTER_PI) * size;
      yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
      ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
      ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
      ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
      ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
      ctx.closePath();
      break;
    case "rect":
      if (!rotation) {
        size = Math.SQRT1_2 * radius;
        width = w ? w / 2 : size;
        ctx.rect(x - width, y - size, 2 * width, 2 * size);
        break;
      }
      rad += QUARTER_PI;
    case "rectRot":
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      ctx.closePath();
      break;
    case "crossRot":
      rad += QUARTER_PI;
    case "cross":
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      break;
    case "star":
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      rad += QUARTER_PI;
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      break;
    case "line":
      xOffset = w ? w / 2 : Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      break;
    case "dash":
      ctx.moveTo(x, y);
      ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
      break;
    case false:
      ctx.closePath();
      break;
  }
  ctx.fill();
  if (options.borderWidth > 0) {
    ctx.stroke();
  }
}
function _isPointInArea(point, area, margin) {
  margin = margin || 0.5;
  return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}
function unclipArea(ctx) {
  ctx.restore();
}
function _steppedLineTo(ctx, previous, target, flip, mode) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  if (mode === "middle") {
    const midpoint = (previous.x + target.x) / 2;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target.y);
  } else if (mode === "after" !== !!flip) {
    ctx.lineTo(previous.x, target.y);
  } else {
    ctx.lineTo(target.x, previous.y);
  }
  ctx.lineTo(target.x, target.y);
}
function _bezierCurveTo(ctx, previous, target, flip) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }
  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }
  if (opts.color) {
    ctx.fillStyle = opts.color;
  }
  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }
  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}
function decorateText(ctx, x, y, line, opts) {
  if (opts.strikethrough || opts.underline) {
    const metrics = ctx.measureText(line);
    const left = x - metrics.actualBoundingBoxLeft;
    const right = x + metrics.actualBoundingBoxRight;
    const top = y - metrics.actualBoundingBoxAscent;
    const bottom = y + metrics.actualBoundingBoxDescent;
    const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left, yDecoration);
    ctx.lineTo(right, yDecoration);
    ctx.stroke();
  }
}
function drawBackdrop(ctx, opts) {
  const oldColor = ctx.fillStyle;
  ctx.fillStyle = opts.color;
  ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
  ctx.fillStyle = oldColor;
}
function renderText(ctx, text, x, y, font, opts = {}) {
  const lines = isArray(text) ? text : [
    text
  ];
  const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
  let i, line;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);
  for (i = 0; i < lines.length; ++i) {
    line = lines[i];
    if (opts.backdrop) {
      drawBackdrop(ctx, opts.backdrop);
    }
    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }
      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }
      ctx.strokeText(line, x, y, opts.maxWidth);
    }
    ctx.fillText(line, x, y, opts.maxWidth);
    decorateText(ctx, x, y, line, opts);
    y += Number(font.lineHeight);
  }
  ctx.restore();
}
function addRoundedRectPath(ctx, rect) {
  const { x, y, w, h, radius } = rect;
  ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
  ctx.lineTo(x, y + h - radius.bottomLeft);
  ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
  ctx.lineTo(x + w - radius.bottomRight, y + h);
  ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
  ctx.lineTo(x + w, y + radius.topRight);
  ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
  ctx.lineTo(x + radius.topLeft, y);
}
var LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
var FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function toLineHeight(value, size) {
  const matches = ("" + value).match(LINE_HEIGHT);
  if (!matches || matches[1] === "normal") {
    return size * 1.2;
  }
  value = +matches[2];
  switch (matches[3]) {
    case "px":
      return value;
    case "%":
      value /= 100;
      break;
  }
  return size * value;
}
var numberOrZero = (v) => +v || 0;
function _readValueToProps(value, props) {
  const ret = {};
  const objProps = isObject(props);
  const keys = objProps ? Object.keys(props) : props;
  const read = isObject(value) ? objProps ? (prop) => valueOrDefault(value[prop], value[props[prop]]) : (prop) => value[prop] : () => value;
  for (const prop of keys) {
    ret[prop] = numberOrZero(read(prop));
  }
  return ret;
}
function toTRBL(value) {
  return _readValueToProps(value, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function toTRBLCorners(value) {
  return _readValueToProps(value, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function toPadding(value) {
  const obj = toTRBL(value);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}
function toFont(options, fallback) {
  options = options || {};
  fallback = fallback || defaults.font;
  let size = valueOrDefault(options.size, fallback.size);
  if (typeof size === "string") {
    size = parseInt(size, 10);
  }
  let style = valueOrDefault(options.style, fallback.style);
  if (style && !("" + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = void 0;
  }
  const font = {
    family: valueOrDefault(options.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
    size,
    style,
    weight: valueOrDefault(options.weight, fallback.weight),
    string: ""
  };
  font.string = toFontString(font);
  return font;
}
function resolve(inputs, context, index2, info) {
  let cacheable = true;
  let i, ilen, value;
  for (i = 0, ilen = inputs.length; i < ilen; ++i) {
    value = inputs[i];
    if (value === void 0) {
      continue;
    }
    if (context !== void 0 && typeof value === "function") {
      value = value(context);
      cacheable = false;
    }
    if (index2 !== void 0 && isArray(value)) {
      value = value[index2 % value.length];
      cacheable = false;
    }
    if (value !== void 0) {
      if (info && !cacheable) {
        info.cacheable = false;
      }
      return value;
    }
  }
}
function _addGrace(minmax, grace, beginAtZero) {
  const { min, max } = minmax;
  const change = toDimension(grace, (max - min) / 2);
  const keepZero = (value, add) => beginAtZero && value === 0 ? 0 : value + add;
  return {
    min: keepZero(min, -Math.abs(change)),
    max: keepZero(max, change)
  };
}
function createContext20(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}
function _createResolver(scopes, prefixes = [
  ""
], rootScopes, fallback, getTarget = () => scopes[0]) {
  const finalRootScopes = rootScopes || scopes;
  if (typeof fallback === "undefined") {
    fallback = _resolve("_fallback", scopes);
  }
  const cache = {
    [Symbol.toStringTag]: "Object",
    _cacheable: true,
    _scopes: scopes,
    _rootScopes: finalRootScopes,
    _fallback: fallback,
    _getTarget: getTarget,
    override: (scope) => _createResolver([
      scope,
      ...scopes
    ], prefixes, finalRootScopes, fallback)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop];
      delete target._keys;
      delete scopes[0][prop];
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop) {
      return _cached(target, prop, () => _resolveWithPrefixes(prop, prefixes, scopes, target));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return getKeysFromAllScopes(target).includes(prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(target) {
      return getKeysFromAllScopes(target);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      const storage = target._storage || (target._storage = getTarget());
      target[prop] = storage[prop] = value;
      delete target._keys;
      return true;
    }
  });
}
function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  const cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: (ctx) => _attachContext(proxy, ctx, subProxy, descriptorDefaults),
    override: (scope) => _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop];
      delete proxy[prop];
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop, receiver) {
      return _cached(target, prop, () => _resolveWithContext(target, prop, receiver));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
        enumerable: true,
        configurable: true
      } : void 0 : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return Reflect.has(proxy, prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      proxy[prop] = value;
      delete target[prop];
      return true;
    }
  });
}
function _descriptors(proxy, defaults2 = {
  scriptable: true,
  indexable: true
}) {
  const { _scriptable = defaults2.scriptable, _indexable = defaults2.indexable, _allKeys = defaults2.allKeys } = proxy;
  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : () => _scriptable,
    isIndexable: isFunction(_indexable) ? _indexable : () => _indexable
  };
}
var readKey = (prefix, name) => prefix ? prefix + _capitalize(name) : name;
var needsSubResolver = (prop, value) => isObject(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve2) {
  if (Object.prototype.hasOwnProperty.call(target, prop)) {
    return target[prop];
  }
  const value = resolve2();
  target[prop] = value;
  return value;
}
function _resolveWithContext(target, prop, receiver) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target;
  let value = _proxy[prop];
  if (isFunction(value) && descriptors2.isScriptable(prop)) {
    value = _resolveScriptable(prop, value, target, receiver);
  }
  if (isArray(value) && value.length) {
    value = _resolveArray(prop, value, target, descriptors2.isIndexable);
  }
  if (needsSubResolver(prop, value)) {
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors2);
  }
  return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
  const { _proxy, _context, _subProxy, _stack } = target;
  if (_stack.has(prop)) {
    throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
  }
  _stack.add(prop);
  let value = getValue(_context, _subProxy || receiver);
  _stack.delete(prop);
  if (needsSubResolver(prop, value)) {
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
  }
  return value;
}
function _resolveArray(prop, value, target, isIndexable) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target;
  if (typeof _context.index !== "undefined" && isIndexable(prop)) {
    return value[_context.index % value.length];
  } else if (isObject(value[0])) {
    const arr = value;
    const scopes = _proxy._scopes.filter((s) => s !== arr);
    value = [];
    for (const item of arr) {
      const resolver = createSubResolver(scopes, _proxy, prop, item);
      value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors2));
    }
  }
  return value;
}
function resolveFallback(fallback, prop, value) {
  return isFunction(fallback) ? fallback(prop, value) : fallback;
}
var getScope = (key, parent) => key === true ? parent : typeof key === "string" ? resolveObjectKey(parent, key) : void 0;
function addScopes(set2, parentScopes, key, parentFallback, value) {
  for (const parent of parentScopes) {
    const scope = getScope(key, parent);
    if (scope) {
      set2.add(scope);
      const fallback = resolveFallback(scope._fallback, key, value);
      if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) {
        return fallback;
      }
    } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) {
      return null;
    }
  }
  return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
  const rootScopes = resolver._rootScopes;
  const fallback = resolveFallback(resolver._fallback, prop, value);
  const allScopes = [
    ...parentScopes,
    ...rootScopes
  ];
  const set2 = /* @__PURE__ */ new Set();
  set2.add(value);
  let key = addScopesFromKey(set2, allScopes, prop, fallback || prop, value);
  if (key === null) {
    return false;
  }
  if (typeof fallback !== "undefined" && fallback !== prop) {
    key = addScopesFromKey(set2, allScopes, fallback, key, value);
    if (key === null) {
      return false;
    }
  }
  return _createResolver(Array.from(set2), [
    ""
  ], rootScopes, fallback, () => subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set2, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set2, allScopes, key, fallback, item);
  }
  return key;
}
function subGetTarget(resolver, prop, value) {
  const parent = resolver._getTarget();
  if (!(prop in parent)) {
    parent[prop] = {};
  }
  const target = parent[prop];
  if (isArray(target) && isObject(value)) {
    return value;
  }
  return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
  let value;
  for (const prefix of prefixes) {
    value = _resolve(readKey(prefix, prop), scopes);
    if (typeof value !== "undefined") {
      return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
  }
}
function _resolve(key, scopes) {
  for (const scope of scopes) {
    if (!scope) {
      continue;
    }
    const value = scope[key];
    if (typeof value !== "undefined") {
      return value;
    }
  }
}
function getKeysFromAllScopes(target) {
  let keys = target._keys;
  if (!keys) {
    keys = target._keys = resolveKeysFromAllScopes(target._scopes);
  }
  return keys;
}
function resolveKeysFromAllScopes(scopes) {
  const set2 = /* @__PURE__ */ new Set();
  for (const scope of scopes) {
    for (const key of Object.keys(scope).filter((k) => !k.startsWith("_"))) {
      set2.add(key);
    }
  }
  return Array.from(set2);
}
var EPSILON = Number.EPSILON || 1e-14;
var getPoint = (points, i) => i < points.length && !points[i].skip && points[i];
var getValueAxis = (indexAxis) => indexAxis === "x" ? "y" : "x";
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
  const previous = firstPoint.skip ? middlePoint : firstPoint;
  const current = middlePoint;
  const next = afterPoint.skip ? middlePoint : afterPoint;
  const d01 = distanceBetweenPoints(current, previous);
  const d12 = distanceBetweenPoints(next, current);
  let s01 = d01 / (d01 + d12);
  let s12 = d12 / (d01 + d12);
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  const fa = t * s01;
  const fb = t * s12;
  return {
    previous: {
      x: current.x - fa * (next.x - previous.x),
      y: current.y - fa * (next.y - previous.y)
    },
    next: {
      x: current.x + fb * (next.x - previous.x),
      y: current.y + fb * (next.y - previous.y)
    }
  };
}
function monotoneAdjust(points, deltaK, mK) {
  const pointsLen = points.length;
  let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen - 1; ++i) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent || !pointAfter) {
      continue;
    }
    if (almostEquals(deltaK[i], 0, EPSILON)) {
      mK[i] = mK[i + 1] = 0;
      continue;
    }
    alphaK = mK[i] / deltaK[i];
    betaK = mK[i + 1] / deltaK[i];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
    if (squaredMagnitude <= 9) {
      continue;
    }
    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i] = alphaK * tauK * deltaK[i];
    mK[i + 1] = betaK * tauK * deltaK[i];
  }
}
function monotoneCompute(points, mK, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  let delta, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    const iPixel = pointCurrent[indexAxis];
    const vPixel = pointCurrent[valueAxis];
    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
      pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
    }
    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
      pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
    }
  }
}
function splineCurveMonotone(points, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  const deltaK = Array(pointsLen).fill(0);
  const mK = Array(pointsLen);
  let i, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    if (pointAfter) {
      const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }
    mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
  }
  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
  return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
  let i, ilen, point, inArea, inAreaPrev;
  let inAreaNext = _isPointInArea(points[0], area);
  for (i = 0, ilen = points.length; i < ilen; ++i) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
    if (!inArea) {
      continue;
    }
    point = points[i];
    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }
    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}
function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
  let i, ilen, point, controlPoints;
  if (options.spanGaps) {
    points = points.filter((pt) => !pt.skip);
  }
  if (options.cubicInterpolationMode === "monotone") {
    splineCurveMonotone(points, indexAxis);
  } else {
    let prev = loop ? points[points.length - 1] : points[0];
    for (i = 0, ilen = points.length; i < ilen; ++i) {
      point = points[i];
      controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      prev = point;
    }
  }
  if (options.capBezierPoints) {
    capBezierPoints(points, area);
  }
}
function _isDomSupported() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function _getParentNode(domNode) {
  let parent = domNode.parentNode;
  if (parent && parent.toString() === "[object ShadowRoot]") {
    parent = parent.host;
  }
  return parent;
}
function parseMaxStyle(styleValue, node, parentProperty) {
  let valueInPixels;
  if (typeof styleValue === "string") {
    valueInPixels = parseInt(styleValue, 10);
    if (styleValue.indexOf("%") !== -1) {
      valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }
  return valueInPixels;
}
var getComputedStyle2 = (element) => element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
  return getComputedStyle2(el).getPropertyValue(property);
}
var positions = [
  "top",
  "right",
  "bottom",
  "left"
];
function getPositionedStyle(styles, style, suffix) {
  const result = {};
  suffix = suffix ? "-" + suffix : "";
  for (let i = 0; i < 4; i++) {
    const pos = positions[i];
    result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
  }
  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}
var useOffsetPos = (x, y, target) => (x > 0 || y > 0) && (!target || !target.shadowRoot);
function getCanvasPosition(e, canvas) {
  const touches = e.touches;
  const source = touches && touches.length ? touches[0] : e;
  const { offsetX, offsetY } = source;
  let box = false;
  let x, y;
  if (useOffsetPos(offsetX, offsetY, e.target)) {
    x = offsetX;
    y = offsetY;
  } else {
    const rect = canvas.getBoundingClientRect();
    x = source.clientX - rect.left;
    y = source.clientY - rect.top;
    box = true;
  }
  return {
    x,
    y,
    box
  };
}
function getRelativePosition(event, chart) {
  if ("native" in event) {
    return event;
  }
  const { canvas, currentDevicePixelRatio } = chart;
  const style = getComputedStyle2(canvas);
  const borderBox = style.boxSizing === "border-box";
  const paddings = getPositionedStyle(style, "padding");
  const borders = getPositionedStyle(style, "border", "width");
  const { x, y, box } = getCanvasPosition(event, canvas);
  const xOffset = paddings.left + (box && borders.left);
  const yOffset = paddings.top + (box && borders.top);
  let { width, height } = chart;
  if (borderBox) {
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  return {
    x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
  };
}
function getContainerSize(canvas, width, height) {
  let maxWidth, maxHeight;
  if (width === void 0 || height === void 0) {
    const container = _getParentNode(canvas);
    if (!container) {
      width = canvas.clientWidth;
      height = canvas.clientHeight;
    } else {
      const rect = container.getBoundingClientRect();
      const containerStyle = getComputedStyle2(container);
      const containerBorder = getPositionedStyle(containerStyle, "border", "width");
      const containerPadding = getPositionedStyle(containerStyle, "padding");
      width = rect.width - containerPadding.width - containerBorder.width;
      height = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
      maxHeight = parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
    }
  }
  return {
    width,
    height,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}
var round1 = (v) => Math.round(v * 10) / 10;
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  const style = getComputedStyle2(canvas);
  const margins = getPositionedStyle(style, "margin");
  const maxWidth = parseMaxStyle(style.maxWidth, canvas, "clientWidth") || INFINITY;
  const maxHeight = parseMaxStyle(style.maxHeight, canvas, "clientHeight") || INFINITY;
  const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  let { width, height } = containerSize;
  if (style.boxSizing === "content-box") {
    const borders = getPositionedStyle(style, "border", "width");
    const paddings = getPositionedStyle(style, "padding");
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  width = Math.max(0, width - margins.width);
  height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
  if (width && !height) {
    height = round1(width / 2);
  }
  const maintainHeight = bbWidth !== void 0 || bbHeight !== void 0;
  if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
    height = containerSize.height;
    width = round1(Math.floor(height * aspectRatio));
  }
  return {
    width,
    height
  };
}
function retinaScale(chart, forceRatio, forceStyle) {
  const pixelRatio = forceRatio || 1;
  const deviceHeight = Math.floor(chart.height * pixelRatio);
  const deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = Math.floor(chart.height);
  chart.width = Math.floor(chart.width);
  const canvas = chart.canvas;
  if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
    canvas.style.height = `${chart.height}px`;
    canvas.style.width = `${chart.width}px`;
  }
  if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }
  return false;
}
var supportsEventListenerOptions = function() {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    window.addEventListener("test", null, options);
    window.removeEventListener("test", null, options);
  } catch (e) {
  }
  return passiveSupported;
}();
function readUsedSize(element, property) {
  const value = getStyle(element, property);
  const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
  return matches ? +matches[1] : void 0;
}
function _pointInLine(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: p1.y + t * (p2.y - p1.y)
  };
}
function _steppedInterpolation(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
  };
}
function _bezierInterpolation(p1, p2, t, mode) {
  const cp1 = {
    x: p1.cp2x,
    y: p1.cp2y
  };
  const cp2 = {
    x: p2.cp1x,
    y: p2.cp1y
  };
  const a = _pointInLine(p1, cp1, t);
  const b = _pointInLine(cp1, cp2, t);
  const c = _pointInLine(cp2, p2, t);
  const d = _pointInLine(a, b, t);
  const e = _pointInLine(b, c, t);
  return _pointInLine(d, e, t);
}
var getRightToLeftAdapter = function(rectX, width) {
  return {
    x(x) {
      return rectX + rectX + width - x;
    },
    setWidth(w) {
      width = w;
    },
    textAlign(align) {
      if (align === "center") {
        return align;
      }
      return align === "right" ? "left" : "right";
    },
    xPlus(x, value) {
      return x - value;
    },
    leftForLtr(x, itemWidth) {
      return x - itemWidth;
    }
  };
};
var getLeftToRightAdapter = function() {
  return {
    x(x) {
      return x;
    },
    setWidth(w) {
    },
    textAlign(align) {
      return align;
    },
    xPlus(x, value) {
      return x + value;
    },
    leftForLtr(x, _itemWidth) {
      return x;
    }
  };
};
function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
  let style, original;
  if (direction === "ltr" || direction === "rtl") {
    style = ctx.canvas.style;
    original = [
      style.getPropertyValue("direction"),
      style.getPropertyPriority("direction")
    ];
    style.setProperty("direction", direction, "important");
    ctx.prevTextDirection = original;
  }
}
function restoreTextDirection(ctx, original) {
  if (original !== void 0) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty("direction", original[0], original[1]);
  }
}
function propertyFn(property) {
  if (property === "angle") {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle
    };
  }
  return {
    between: _isBetween,
    compare: (a, b) => a - b,
    normalize: (x) => x
  };
}
function normalizeSegment({ start, end, count, loop, style }) {
  return {
    start: start % count,
    end: end % count,
    loop: loop && (end - start + 1) % count === 0,
    style
  };
}
function getSegment(segment, points, bounds) {
  const { property, start: startBound, end: endBound } = bounds;
  const { between, normalize } = propertyFn(property);
  const count = points.length;
  let { start, end, loop } = segment;
  let i, ilen;
  if (loop) {
    start += count;
    end += count;
    for (i = 0, ilen = count; i < ilen; ++i) {
      if (!between(normalize(points[start % count][property]), startBound, endBound)) {
        break;
      }
      start--;
      end--;
    }
    start %= count;
    end %= count;
  }
  if (end < start) {
    end += count;
  }
  return {
    start,
    end,
    loop,
    style: segment.style
  };
}
function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [
      segment
    ];
  }
  const { property, start: startBound, end: endBound } = bounds;
  const count = points.length;
  const { compare, between, normalize } = propertyFn(property);
  const { start, end, loop, style } = getSegment(segment, points, bounds);
  const result = [];
  let inside = false;
  let subStart = null;
  let value, point, prevValue;
  const startIsBefore = () => between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
  const endIsBefore = () => compare(endBound, value) === 0 || between(endBound, prevValue, value);
  const shouldStart = () => inside || startIsBefore();
  const shouldStop = () => !inside || endIsBefore();
  for (let i = start, prev = start; i <= end; ++i) {
    point = points[i % count];
    if (point.skip) {
      continue;
    }
    value = normalize(point[property]);
    if (value === prevValue) {
      continue;
    }
    inside = between(value, startBound, endBound);
    if (subStart === null && shouldStart()) {
      subStart = compare(value, startBound) === 0 ? i : prev;
    }
    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({
        start: subStart,
        end: i,
        loop,
        count,
        style
      }));
      subStart = null;
    }
    prev = i;
    prevValue = value;
  }
  if (subStart !== null) {
    result.push(normalizeSegment({
      start: subStart,
      end,
      loop,
      count,
      style
    }));
  }
  return result;
}
function _boundSegments(line, bounds) {
  const result = [];
  const segments = line.segments;
  for (let i = 0; i < segments.length; i++) {
    const sub = _boundSegment(segments[i], line.points, bounds);
    if (sub.length) {
      result.push(...sub);
    }
  }
  return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
  let start = 0;
  let end = count - 1;
  if (loop && !spanGaps) {
    while (start < count && !points[start].skip) {
      start++;
    }
  }
  while (start < count && points[start].skip) {
    start++;
  }
  start %= count;
  if (loop) {
    end += start;
  }
  while (end > start && points[end % count].skip) {
    end--;
  }
  end %= count;
  return {
    start,
    end
  };
}
function solidSegments(points, start, max, loop) {
  const count = points.length;
  const result = [];
  let last = start;
  let prev = points[start];
  let end;
  for (end = start + 1; end <= max; ++end) {
    const cur = points[end % count];
    if (cur.skip || cur.stop) {
      if (!prev.skip) {
        loop = false;
        result.push({
          start: start % count,
          end: (end - 1) % count,
          loop
        });
        start = last = cur.stop ? end : null;
      }
    } else {
      last = end;
      if (prev.skip) {
        start = end;
      }
    }
    prev = cur;
  }
  if (last !== null) {
    result.push({
      start: start % count,
      end: last % count,
      loop
    });
  }
  return result;
}
function _computeSegments(line, segmentOptions) {
  const points = line.points;
  const spanGaps = line.options.spanGaps;
  const count = points.length;
  if (!count) {
    return [];
  }
  const loop = !!line._loop;
  const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
  if (spanGaps === true) {
    return splitByStyles(line, [
      {
        start,
        end,
        loop
      }
    ], points, segmentOptions);
  }
  const max = end < start ? end + count : end;
  const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
  return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }
  return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
  const chartContext = line._chart.getContext();
  const baseStyle = readStyle(line.options);
  const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
  const count = points.length;
  const result = [];
  let prevStyle = baseStyle;
  let start = segments[0].start;
  let i = start;
  function addStyle(s, e, l, st) {
    const dir = spanGaps ? -1 : 1;
    if (s === e) {
      return;
    }
    s += count;
    while (points[s % count].skip) {
      s -= dir;
    }
    while (points[e % count].skip) {
      e += dir;
    }
    if (s % count !== e % count) {
      result.push({
        start: s % count,
        end: e % count,
        loop: l,
        style: st
      });
      prevStyle = st;
      start = e % count;
    }
  }
  for (const segment of segments) {
    start = spanGaps ? start : segment.start;
    let prev = points[start % count];
    let style;
    for (i = start + 1; i <= segment.end; i++) {
      const pt = points[i % count];
      style = readStyle(segmentOptions.setContext(createContext20(chartContext, {
        type: "segment",
        p0: prev,
        p1: pt,
        p0DataIndex: (i - 1) % count,
        p1DataIndex: i % count,
        datasetIndex
      })));
      if (styleChanged(style, prevStyle)) {
        addStyle(start, i - 1, segment.loop, prevStyle);
      }
      prev = pt;
      prevStyle = style;
    }
    if (start < i - 1) {
      addStyle(start, i - 1, segment.loop, prevStyle);
    }
  }
  return result;
}
function readStyle(options) {
  return {
    backgroundColor: options.backgroundColor,
    borderCapStyle: options.borderCapStyle,
    borderDash: options.borderDash,
    borderDashOffset: options.borderDashOffset,
    borderJoinStyle: options.borderJoinStyle,
    borderWidth: options.borderWidth,
    borderColor: options.borderColor
  };
}
function styleChanged(style, prevStyle) {
  if (!prevStyle) {
    return false;
  }
  const cache = [];
  const replacer = function(key, value) {
    if (!isPatternOrGradient(value)) {
      return value;
    }
    if (!cache.includes(value)) {
      cache.push(value);
    }
    return cache.indexOf(value);
  };
  return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

// ../../node_modules/chart.js/dist/chart.js
var Animator = class {
  constructor() {
    this._request = null;
    this._charts = /* @__PURE__ */ new Map();
    this._running = false;
    this._lastDate = void 0;
  }
  _notify(chart, anims, date, type) {
    const callbacks = anims.listeners[type];
    const numSteps = anims.duration;
    callbacks.forEach((fn) => fn({
      chart,
      initial: anims.initial,
      numSteps,
      currentStep: Math.min(date - anims.start, numSteps)
    }));
  }
  _refresh() {
    if (this._request) {
      return;
    }
    this._running = true;
    this._request = requestAnimFrame.call(window, () => {
      this._update();
      this._request = null;
      if (this._running) {
        this._refresh();
      }
    });
  }
  _update(date = Date.now()) {
    let remaining = 0;
    this._charts.forEach((anims, chart) => {
      if (!anims.running || !anims.items.length) {
        return;
      }
      const items = anims.items;
      let i = items.length - 1;
      let draw2 = false;
      let item;
      for (; i >= 0; --i) {
        item = items[i];
        if (item._active) {
          if (item._total > anims.duration) {
            anims.duration = item._total;
          }
          item.tick(date);
          draw2 = true;
        } else {
          items[i] = items[items.length - 1];
          items.pop();
        }
      }
      if (draw2) {
        chart.draw();
        this._notify(chart, anims, date, "progress");
      }
      if (!items.length) {
        anims.running = false;
        this._notify(chart, anims, date, "complete");
        anims.initial = false;
      }
      remaining += items.length;
    });
    this._lastDate = date;
    if (remaining === 0) {
      this._running = false;
    }
  }
  _getAnims(chart) {
    const charts = this._charts;
    let anims = charts.get(chart);
    if (!anims) {
      anims = {
        running: false,
        initial: true,
        items: [],
        listeners: {
          complete: [],
          progress: []
        }
      };
      charts.set(chart, anims);
    }
    return anims;
  }
  listen(chart, event, cb) {
    this._getAnims(chart).listeners[event].push(cb);
  }
  add(chart, items) {
    if (!items || !items.length) {
      return;
    }
    this._getAnims(chart).items.push(...items);
  }
  has(chart) {
    return this._getAnims(chart).items.length > 0;
  }
  start(chart) {
    const anims = this._charts.get(chart);
    if (!anims) {
      return;
    }
    anims.running = true;
    anims.start = Date.now();
    anims.duration = anims.items.reduce((acc, cur) => Math.max(acc, cur._duration), 0);
    this._refresh();
  }
  running(chart) {
    if (!this._running) {
      return false;
    }
    const anims = this._charts.get(chart);
    if (!anims || !anims.running || !anims.items.length) {
      return false;
    }
    return true;
  }
  stop(chart) {
    const anims = this._charts.get(chart);
    if (!anims || !anims.items.length) {
      return;
    }
    const items = anims.items;
    let i = items.length - 1;
    for (; i >= 0; --i) {
      items[i].cancel();
    }
    anims.items = [];
    this._notify(chart, anims, Date.now(), "complete");
  }
  remove(chart) {
    return this._charts.delete(chart);
  }
};
var animator = /* @__PURE__ */ new Animator();
var transparent = "transparent";
var interpolators = {
  boolean(from2, to2, factor) {
    return factor > 0.5 ? to2 : from2;
  },
  color(from2, to2, factor) {
    const c0 = color(from2 || transparent);
    const c1 = c0.valid && color(to2 || transparent);
    return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to2;
  },
  number(from2, to2, factor) {
    return from2 + (to2 - from2) * factor;
  }
};
var Animation = class {
  constructor(cfg, target, prop, to2) {
    const currentValue = target[prop];
    to2 = resolve([
      cfg.to,
      to2,
      currentValue,
      cfg.from
    ]);
    const from2 = resolve([
      cfg.from,
      currentValue,
      to2
    ]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || typeof from2];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target;
    this._prop = prop;
    this._from = from2;
    this._to = to2;
    this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(cfg, to2, date) {
    if (this._active) {
      this._notify(false);
      const currentValue = this._target[this._prop];
      const elapsed = date - this._start;
      const remain = this._duration - elapsed;
      this._start = date;
      this._duration = Math.floor(Math.max(remain, cfg.duration));
      this._total += elapsed;
      this._loop = !!cfg.loop;
      this._to = resolve([
        cfg.to,
        to2,
        currentValue,
        cfg.from
      ]);
      this._from = resolve([
        cfg.from,
        currentValue,
        to2
      ]);
    }
  }
  cancel() {
    if (this._active) {
      this.tick(Date.now());
      this._active = false;
      this._notify(false);
    }
  }
  tick(date) {
    const elapsed = date - this._start;
    const duration = this._duration;
    const prop = this._prop;
    const from2 = this._from;
    const loop = this._loop;
    const to2 = this._to;
    let factor;
    this._active = from2 !== to2 && (loop || elapsed < duration);
    if (!this._active) {
      this._target[prop] = to2;
      this._notify(true);
      return;
    }
    if (elapsed < 0) {
      this._target[prop] = from2;
      return;
    }
    factor = elapsed / duration % 2;
    factor = loop && factor > 1 ? 2 - factor : factor;
    factor = this._easing(Math.min(1, Math.max(0, factor)));
    this._target[prop] = this._fn(from2, to2, factor);
  }
  wait() {
    const promises = this._promises || (this._promises = []);
    return new Promise((res, rej) => {
      promises.push({
        res,
        rej
      });
    });
  }
  _notify(resolved) {
    const method = resolved ? "res" : "rej";
    const promises = this._promises || [];
    for (let i = 0; i < promises.length; i++) {
      promises[i][method]();
    }
  }
};
var Animations = class {
  constructor(chart, config) {
    this._chart = chart;
    this._properties = /* @__PURE__ */ new Map();
    this.configure(config);
  }
  configure(config) {
    if (!isObject(config)) {
      return;
    }
    const animationOptions = Object.keys(defaults.animation);
    const animatedProps = this._properties;
    Object.getOwnPropertyNames(config).forEach((key) => {
      const cfg = config[key];
      if (!isObject(cfg)) {
        return;
      }
      const resolved = {};
      for (const option of animationOptions) {
        resolved[option] = cfg[option];
      }
      (isArray(cfg.properties) && cfg.properties || [
        key
      ]).forEach((prop) => {
        if (prop === key || !animatedProps.has(prop)) {
          animatedProps.set(prop, resolved);
        }
      });
    });
  }
  _animateOptions(target, values) {
    const newOptions = values.options;
    const options = resolveTargetOptions(target, newOptions);
    if (!options) {
      return [];
    }
    const animations = this._createAnimations(options, newOptions);
    if (newOptions.$shared) {
      awaitAll(target.options.$animations, newOptions).then(() => {
        target.options = newOptions;
      }, () => {
      });
    }
    return animations;
  }
  _createAnimations(target, values) {
    const animatedProps = this._properties;
    const animations = [];
    const running = target.$animations || (target.$animations = {});
    const props = Object.keys(values);
    const date = Date.now();
    let i;
    for (i = props.length - 1; i >= 0; --i) {
      const prop = props[i];
      if (prop.charAt(0) === "$") {
        continue;
      }
      if (prop === "options") {
        animations.push(...this._animateOptions(target, values));
        continue;
      }
      const value = values[prop];
      let animation = running[prop];
      const cfg = animatedProps.get(prop);
      if (animation) {
        if (cfg && animation.active()) {
          animation.update(cfg, value, date);
          continue;
        } else {
          animation.cancel();
        }
      }
      if (!cfg || !cfg.duration) {
        target[prop] = value;
        continue;
      }
      running[prop] = animation = new Animation(cfg, target, prop, value);
      animations.push(animation);
    }
    return animations;
  }
  update(target, values) {
    if (this._properties.size === 0) {
      Object.assign(target, values);
      return;
    }
    const animations = this._createAnimations(target, values);
    if (animations.length) {
      animator.add(this._chart, animations);
      return true;
    }
  }
};
function awaitAll(animations, properties) {
  const running = [];
  const keys = Object.keys(properties);
  for (let i = 0; i < keys.length; i++) {
    const anim = animations[keys[i]];
    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }
  return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
  if (!newOptions) {
    return;
  }
  let options = target.options;
  if (!options) {
    target.options = newOptions;
    return;
  }
  if (options.$shared) {
    target.options = options = Object.assign({}, options, {
      $shared: false,
      $animations: {}
    });
  }
  return options;
}
function scaleClip(scale, allowedOverflow) {
  const opts = scale && scale.options || {};
  const reverse = opts.reverse;
  const min = opts.min === void 0 ? allowedOverflow : 0;
  const max = opts.max === void 0 ? allowedOverflow : 0;
  return {
    start: reverse ? max : min,
    end: reverse ? min : max
  };
}
function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }
  const x = scaleClip(xScale, allowedOverflow);
  const y = scaleClip(yScale, allowedOverflow);
  return {
    top: y.end,
    right: x.end,
    bottom: y.start,
    left: x.start
  };
}
function toClip(value) {
  let t, r, b, l;
  if (isObject(value)) {
    t = value.top;
    r = value.right;
    b = value.bottom;
    l = value.left;
  } else {
    t = r = b = l = value;
  }
  return {
    top: t,
    right: r,
    bottom: b,
    left: l,
    disabled: value === false
  };
}
function getSortedDatasetIndices(chart, filterVisible) {
  const keys = [];
  const metasets = chart._getSortedDatasetMetas(filterVisible);
  let i, ilen;
  for (i = 0, ilen = metasets.length; i < ilen; ++i) {
    keys.push(metasets[i].index);
  }
  return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
  const keys = stack.keys;
  const singleMode = options.mode === "single";
  let i, ilen, datasetIndex, otherValue;
  if (value === null) {
    return;
  }
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    datasetIndex = +keys[i];
    if (datasetIndex === dsIndex) {
      if (options.all) {
        continue;
      }
      break;
    }
    otherValue = stack.values[datasetIndex];
    if (isNumberFinite(otherValue) && (singleMode || value === 0 || sign(value) === sign(otherValue))) {
      value += otherValue;
    }
  }
  return value;
}
function convertObjectDataToArray(data) {
  const keys = Object.keys(data);
  const adata = new Array(keys.length);
  let i, ilen, key;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    key = keys[i];
    adata[i] = {
      x: key,
      y: data[key]
    };
  }
  return adata;
}
function isStacked(scale, meta) {
  const stacked = scale && scale.options.stacked;
  return stacked || stacked === void 0 && meta.stack !== void 0;
}
function getStackKey(indexScale, valueScale, meta) {
  return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
  const { min, max, minDefined, maxDefined } = scale.getUserBounds();
  return {
    min: minDefined ? min : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
  const subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
  for (const meta of vScale.getMatchingVisibleMetas(type).reverse()) {
    const value = stack[meta.index];
    if (positive && value > 0 || !positive && value < 0) {
      return meta.index;
    }
  }
  return null;
}
function updateStacks(controller, parsed) {
  const { chart, _cachedMeta: meta } = controller;
  const stacks = chart._stacks || (chart._stacks = {});
  const { iScale, vScale, index: datasetIndex } = meta;
  const iAxis = iScale.axis;
  const vAxis = vScale.axis;
  const key = getStackKey(iScale, vScale, meta);
  const ilen = parsed.length;
  let stack;
  for (let i = 0; i < ilen; ++i) {
    const item = parsed[i];
    const { [iAxis]: index2, [vAxis]: value } = item;
    const itemStacks = item._stacks || (item._stacks = {});
    stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index2);
    stack[datasetIndex] = value;
    stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
    stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
    const visualValues = stack._visualValues || (stack._visualValues = {});
    visualValues[datasetIndex] = value;
  }
}
function getFirstScaleId(chart, axis) {
  const scales = chart.scales;
  return Object.keys(scales).filter((key) => scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index2) {
  return createContext20(parent, {
    active: false,
    dataset: void 0,
    datasetIndex: index2,
    index: index2,
    mode: "default",
    type: "dataset"
  });
}
function createDataContext(parent, index2, element) {
  return createContext20(parent, {
    active: false,
    dataIndex: index2,
    parsed: void 0,
    raw: void 0,
    element,
    index: index2,
    mode: "default",
    type: "data"
  });
}
function clearStacks(meta, items) {
  const datasetIndex = meta.controller.index;
  const axis = meta.vScale && meta.vScale.axis;
  if (!axis) {
    return;
  }
  items = items || meta._parsed;
  for (const parsed of items) {
    const stacks = parsed._stacks;
    if (!stacks || stacks[axis] === void 0 || stacks[axis][datasetIndex] === void 0) {
      return;
    }
    delete stacks[axis][datasetIndex];
    if (stacks[axis]._visualValues !== void 0 && stacks[axis]._visualValues[datasetIndex] !== void 0) {
      delete stacks[axis]._visualValues[datasetIndex];
    }
  }
}
var isDirectUpdateMode = (mode) => mode === "reset" || mode === "none";
var cloneIfNotShared = (cached, shared) => shared ? cached : Object.assign({}, cached);
var createStack = (canStack, meta, chart) => canStack && !meta.hidden && meta._stacked && {
  keys: getSortedDatasetIndices(chart, true),
  values: null
};
var DatasetController = class {
  static defaults = {};
  static datasetElementType = null;
  static dataElementType = null;
  constructor(chart, datasetIndex) {
    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = void 0;
    this._parsing = false;
    this._data = void 0;
    this._objectData = void 0;
    this._sharedOptions = void 0;
    this._drawStart = void 0;
    this._drawCount = void 0;
    this.enableOptionSharing = false;
    this.supportsDecimation = false;
    this.$context = void 0;
    this._syncList = [];
    this.datasetElementType = new.target.datasetElementType;
    this.dataElementType = new.target.dataElementType;
    this.initialize();
  }
  initialize() {
    const meta = this._cachedMeta;
    this.configure();
    this.linkScales();
    meta._stacked = isStacked(meta.vScale, meta);
    this.addElements();
    if (this.options.fill && !this.chart.isPluginEnabled("filler")) {
      console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
  }
  updateIndex(datasetIndex) {
    if (this.index !== datasetIndex) {
      clearStacks(this._cachedMeta);
    }
    this.index = datasetIndex;
  }
  linkScales() {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    const chooseId = (axis, x, y, r) => axis === "x" ? x : axis === "r" ? r : y;
    const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, "x"));
    const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, "y"));
    const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, "r"));
    const indexAxis = meta.indexAxis;
    const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
    const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
    meta.xScale = this.getScaleForId(xid);
    meta.yScale = this.getScaleForId(yid);
    meta.rScale = this.getScaleForId(rid);
    meta.iScale = this.getScaleForId(iid);
    meta.vScale = this.getScaleForId(vid);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(scaleID) {
    return this.chart.scales[scaleID];
  }
  _getOtherScale(scale) {
    const meta = this._cachedMeta;
    return scale === meta.iScale ? meta.vScale : meta.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const meta = this._cachedMeta;
    if (this._data) {
      unlistenArrayEvents(this._data, this);
    }
    if (meta._stacked) {
      clearStacks(meta);
    }
  }
  _dataCheck() {
    const dataset = this.getDataset();
    const data = dataset.data || (dataset.data = []);
    const _data = this._data;
    if (isObject(data)) {
      this._data = convertObjectDataToArray(data);
    } else if (_data !== data) {
      if (_data) {
        unlistenArrayEvents(_data, this);
        const meta = this._cachedMeta;
        clearStacks(meta);
        meta._parsed = [];
      }
      if (data && Object.isExtensible(data)) {
        listenArrayEvents(data, this);
      }
      this._syncList = [];
      this._data = data;
    }
  }
  addElements() {
    const meta = this._cachedMeta;
    this._dataCheck();
    if (this.datasetElementType) {
      meta.dataset = new this.datasetElementType();
    }
  }
  buildOrUpdateElements(resetNewElements) {
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    let stackChanged = false;
    this._dataCheck();
    const oldStacked = meta._stacked;
    meta._stacked = isStacked(meta.vScale, meta);
    if (meta.stack !== dataset.stack) {
      stackChanged = true;
      clearStacks(meta);
      meta.stack = dataset.stack;
    }
    this._resyncElements(resetNewElements);
    if (stackChanged || oldStacked !== meta._stacked) {
      updateStacks(this, meta._parsed);
    }
  }
  configure() {
    const config = this.chart.config;
    const scopeKeys = config.datasetScopeKeys(this._type);
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
    this.options = config.createResolver(scopes, this.getContext());
    this._parsing = this.options.parsing;
    this._cachedDataOpts = {};
  }
  parse(start, count) {
    const { _cachedMeta: meta, _data: data } = this;
    const { iScale, _stacked } = meta;
    const iAxis = iScale.axis;
    let sorted = start === 0 && count === data.length ? true : meta._sorted;
    let prev = start > 0 && meta._parsed[start - 1];
    let i, cur, parsed;
    if (this._parsing === false) {
      meta._parsed = data;
      meta._sorted = true;
      parsed = data;
    } else {
      if (isArray(data[start])) {
        parsed = this.parseArrayData(meta, data, start, count);
      } else if (isObject(data[start])) {
        parsed = this.parseObjectData(meta, data, start, count);
      } else {
        parsed = this.parsePrimitiveData(meta, data, start, count);
      }
      const isNotInOrderComparedToPrev = () => cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
      for (i = 0; i < count; ++i) {
        meta._parsed[i + start] = cur = parsed[i];
        if (sorted) {
          if (isNotInOrderComparedToPrev()) {
            sorted = false;
          }
          prev = cur;
        }
      }
      meta._sorted = sorted;
    }
    if (_stacked) {
      updateStacks(this, parsed);
    }
  }
  parsePrimitiveData(meta, data, start, count) {
    const { iScale, vScale } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = new Array(count);
    let i, ilen, index2;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      parsed[i] = {
        [iAxis]: singleScale || iScale.parse(labels[index2], index2),
        [vAxis]: vScale.parse(data[index2], index2)
      };
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const { xScale, yScale } = meta;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      item = data[index2];
      parsed[i] = {
        x: xScale.parse(item[0], index2),
        y: yScale.parse(item[1], index2)
      };
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const { xScale, yScale } = meta;
    const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      item = data[index2];
      parsed[i] = {
        x: xScale.parse(resolveObjectKey(item, xAxisKey), index2),
        y: yScale.parse(resolveObjectKey(item, yAxisKey), index2)
      };
    }
    return parsed;
  }
  getParsed(index2) {
    return this._cachedMeta._parsed[index2];
  }
  getDataElement(index2) {
    return this._cachedMeta.data[index2];
  }
  applyStack(scale, parsed, mode) {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const value = parsed[scale.axis];
    const stack = {
      keys: getSortedDatasetIndices(chart, true),
      values: parsed._stacks[scale.axis]._visualValues
    };
    return applyStack(stack, value, meta.index, {
      mode
    });
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    const parsedValue = parsed[scale.axis];
    let value = parsedValue === null ? NaN : parsedValue;
    const values = stack && parsed._stacks[scale.axis];
    if (stack && values) {
      stack.values = values;
      value = applyStack(stack, parsedValue, this._cachedMeta.index);
    }
    range.min = Math.min(range.min, value);
    range.max = Math.max(range.max, value);
  }
  getMinMax(scale, canStack) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const sorted = meta._sorted && scale === meta.iScale;
    const ilen = _parsed.length;
    const otherScale = this._getOtherScale(scale);
    const stack = createStack(canStack, meta, this.chart);
    const range = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
    let i, parsed;
    function _skip() {
      parsed = _parsed[i];
      const otherValue = parsed[otherScale.axis];
      return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
    }
    for (i = 0; i < ilen; ++i) {
      if (_skip()) {
        continue;
      }
      this.updateRangeFromParsed(range, scale, parsed, stack);
      if (sorted) {
        break;
      }
    }
    if (sorted) {
      for (i = ilen - 1; i >= 0; --i) {
        if (_skip()) {
          continue;
        }
        this.updateRangeFromParsed(range, scale, parsed, stack);
        break;
      }
    }
    return range;
  }
  getAllParsedValues(scale) {
    const parsed = this._cachedMeta._parsed;
    const values = [];
    let i, ilen, value;
    for (i = 0, ilen = parsed.length; i < ilen; ++i) {
      value = parsed[i][scale.axis];
      if (isNumberFinite(value)) {
        values.push(value);
      }
    }
    return values;
  }
  getMaxOverflow() {
    return false;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const parsed = this.getParsed(index2);
    return {
      label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
      value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
    };
  }
  _update(mode) {
    const meta = this._cachedMeta;
    this.update(mode || "default");
    meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
  }
  update(mode) {
  }
  draw() {
    const ctx = this._ctx;
    const chart = this.chart;
    const meta = this._cachedMeta;
    const elements = meta.data || [];
    const area = chart.chartArea;
    const active = [];
    const start = this._drawStart || 0;
    const count = this._drawCount || elements.length - start;
    const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
    let i;
    if (meta.dataset) {
      meta.dataset.draw(ctx, area, start, count);
    }
    for (i = start; i < start + count; ++i) {
      const element = elements[i];
      if (element.hidden) {
        continue;
      }
      if (element.active && drawActiveElementsOnTop) {
        active.push(element);
      } else {
        element.draw(ctx, area);
      }
    }
    for (i = 0; i < active.length; ++i) {
      active[i].draw(ctx, area);
    }
  }
  getStyle(index2, active) {
    const mode = active ? "active" : "default";
    return index2 === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index2 || 0, mode);
  }
  getContext(index2, active, mode) {
    const dataset = this.getDataset();
    let context;
    if (index2 >= 0 && index2 < this._cachedMeta.data.length) {
      const element = this._cachedMeta.data[index2];
      context = element.$context || (element.$context = createDataContext(this.getContext(), index2, element));
      context.parsed = this.getParsed(index2);
      context.raw = dataset.data[index2];
      context.index = context.dataIndex = index2;
    } else {
      context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
      context.dataset = dataset;
      context.index = context.datasetIndex = this.index;
    }
    context.active = !!active;
    context.mode = mode;
    return context;
  }
  resolveDatasetElementOptions(mode) {
    return this._resolveElementOptions(this.datasetElementType.id, mode);
  }
  resolveDataElementOptions(index2, mode) {
    return this._resolveElementOptions(this.dataElementType.id, mode, index2);
  }
  _resolveElementOptions(elementType, mode = "default", index2) {
    const active = mode === "active";
    const cache = this._cachedDataOpts;
    const cacheKey = elementType + "-" + mode;
    const cached = cache[cacheKey];
    const sharing = this.enableOptionSharing && defined(index2);
    if (cached) {
      return cloneIfNotShared(cached, sharing);
    }
    const config = this.chart.config;
    const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
    const prefixes = active ? [
      `${elementType}Hover`,
      "hover",
      elementType,
      ""
    ] : [
      elementType,
      ""
    ];
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
    const names2 = Object.keys(defaults.elements[elementType]);
    const context = () => this.getContext(index2, active, mode);
    const values = config.resolveNamedOptions(scopes, names2, context, prefixes);
    if (values.$shared) {
      values.$shared = sharing;
      cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
    }
    return values;
  }
  _resolveAnimations(index2, transition, active) {
    const chart = this.chart;
    const cache = this._cachedDataOpts;
    const cacheKey = `animation-${transition}`;
    const cached = cache[cacheKey];
    if (cached) {
      return cached;
    }
    let options;
    if (chart.options.animation !== false) {
      const config = this.chart.config;
      const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
      const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
      options = config.createResolver(scopes, this.getContext(index2, active, transition));
    }
    const animations = new Animations(chart, options && options.animations);
    if (options && options._cacheable) {
      cache[cacheKey] = Object.freeze(animations);
    }
    return animations;
  }
  getSharedOptions(options) {
    if (!options.$shared) {
      return;
    }
    return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
  }
  includeOptions(mode, sharedOptions) {
    return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
  }
  _getSharedOptions(start, mode) {
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const previouslySharedOptions = this._sharedOptions;
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
    return {
      sharedOptions,
      includeOptions
    };
  }
  updateElement(element, index2, properties, mode) {
    if (isDirectUpdateMode(mode)) {
      Object.assign(element, properties);
    } else {
      this._resolveAnimations(index2, mode).update(element, properties);
    }
  }
  updateSharedOptions(sharedOptions, mode, newOptions) {
    if (sharedOptions && !isDirectUpdateMode(mode)) {
      this._resolveAnimations(void 0, mode).update(sharedOptions, newOptions);
    }
  }
  _setStyle(element, index2, mode, active) {
    element.active = active;
    const options = this.getStyle(index2, active);
    this._resolveAnimations(index2, mode, active).update(element, {
      options: !active && this.getSharedOptions(options) || options
    });
  }
  removeHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", false);
  }
  setHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", true);
  }
  _removeDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", false);
    }
  }
  _setDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", true);
    }
  }
  _resyncElements(resetNewElements) {
    const data = this._data;
    const elements = this._cachedMeta.data;
    for (const [method, arg1, arg2] of this._syncList) {
      this[method](arg1, arg2);
    }
    this._syncList = [];
    const numMeta = elements.length;
    const numData = data.length;
    const count = Math.min(numData, numMeta);
    if (count) {
      this.parse(0, count);
    }
    if (numData > numMeta) {
      this._insertElements(numMeta, numData - numMeta, resetNewElements);
    } else if (numData < numMeta) {
      this._removeElements(numData, numMeta - numData);
    }
  }
  _insertElements(start, count, resetNewElements = true) {
    const meta = this._cachedMeta;
    const data = meta.data;
    const end = start + count;
    let i;
    const move = (arr) => {
      arr.length += count;
      for (i = arr.length - 1; i >= end; i--) {
        arr[i] = arr[i - count];
      }
    };
    move(data);
    for (i = start; i < end; ++i) {
      data[i] = new this.dataElementType();
    }
    if (this._parsing) {
      move(meta._parsed);
    }
    this.parse(start, count);
    if (resetNewElements) {
      this.updateElements(data, start, count, "reset");
    }
  }
  updateElements(element, start, count, mode) {
  }
  _removeElements(start, count) {
    const meta = this._cachedMeta;
    if (this._parsing) {
      const removed = meta._parsed.splice(start, count);
      if (meta._stacked) {
        clearStacks(meta, removed);
      }
    }
    meta.data.splice(start, count);
  }
  _sync(args) {
    if (this._parsing) {
      this._syncList.push(args);
    } else {
      const [method, arg1, arg2] = args;
      this[method](arg1, arg2);
    }
    this.chart._dataChanges.push([
      this.index,
      ...args
    ]);
  }
  _onDataPush() {
    const count = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - count,
      count
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(start, count) {
    if (count) {
      this._sync([
        "_removeElements",
        start,
        count
      ]);
    }
    const newCount = arguments.length - 2;
    if (newCount) {
      this._sync([
        "_insertElements",
        start,
        newCount
      ]);
    }
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
};
var LineController = class extends DatasetController {
  static id = "line";
  static defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
  };
  static overrides = {
    scales: {
      _index_: {
        type: "category"
      },
      _value_: {
        type: "linear"
      }
    }
  };
  initialize() {
    this.enableOptionSharing = true;
    this.supportsDecimation = true;
    super.initialize();
  }
  update(mode) {
    const meta = this._cachedMeta;
    const { dataset: line, data: points = [], _dataset } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let { start, count } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    line._chart = this.chart;
    line._datasetIndex = this.index;
    line._decimated = !!_dataset._decimated;
    line.points = points;
    const options = this.resolveDatasetElementOptions(mode);
    if (!this.options.showLine) {
      options.borderWidth = 0;
    }
    options.segment = this.options.segment;
    this.updateElement(line, void 0, {
      animated: !animationsDisabled,
      options
    }, mode);
    this.updateElements(points, start, count, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const { spanGaps, segment } = this.options;
    const maxGapLength = isNumber6(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
    const end = start + count;
    const pointsCount = points.length;
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i = 0; i < pointsCount; ++i) {
      const point = points[i];
      const properties = directUpdate ? point : {};
      if (i < start || i >= end) {
        properties.skip = true;
        continue;
      }
      const parsed = this.getParsed(i);
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    const data = meta.data || [];
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
  draw() {
    const meta = this._cachedMeta;
    meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
    super.draw();
  }
};
function abstract() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
var DateAdapterBase = class _DateAdapterBase {
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(members) {
    Object.assign(_DateAdapterBase.prototype, members);
  }
  options;
  constructor(options) {
    this.options = options || {};
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return abstract();
  }
  parse() {
    return abstract();
  }
  format() {
    return abstract();
  }
  add() {
    return abstract();
  }
  diff() {
    return abstract();
  }
  startOf() {
    return abstract();
  }
  endOf() {
    return abstract();
  }
};
var adapters = {
  _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
  const { controller, data, _sorted } = metaset;
  const iScale = controller._cachedMeta.iScale;
  if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
    const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
    if (!intersect) {
      return lookupMethod(data, axis, value);
    } else if (controller._sharedOptions) {
      const el = data[0];
      const range = typeof el.getRange === "function" && el.getRange(axis);
      if (range) {
        const start = lookupMethod(data, axis, value - range);
        const end = lookupMethod(data, axis, value + range);
        return {
          lo: start.lo,
          hi: end.hi
        };
      }
    }
  }
  return {
    lo: 0,
    hi: data.length - 1
  };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  const value = position[axis];
  for (let i = 0, ilen = metasets.length; i < ilen; ++i) {
    const { index: index2, data } = metasets[i];
    const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
    for (let j = lo; j <= hi; ++j) {
      const element = data[j];
      if (!element.skip) {
        handler(element, index2, j);
      }
    }
  }
}
function getDistanceMetricForAxis(axis) {
  const useX = axis.indexOf("x") !== -1;
  const useY = axis.indexOf("y") !== -1;
  return function(pt1, pt2) {
    const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
  const items = [];
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return items;
  }
  const evaluationFunc = function(element, datasetIndex, index2) {
    if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
      return;
    }
    if (element.inRange(position.x, position.y, useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  };
  evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
  return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
  let items = [];
  function evaluationFunc(element, datasetIndex, index2) {
    const { startAngle, endAngle } = element.getProps([
      "startAngle",
      "endAngle"
    ], useFinalPosition);
    const { angle } = getAngleFromPoint(element, {
      x: position.x,
      y: position.y
    });
    if (_angleBetween(angle, startAngle, endAngle)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  let items = [];
  const distanceMetric = getDistanceMetricForAxis(axis);
  let minDistance = Number.POSITIVE_INFINITY;
  function evaluationFunc(element, datasetIndex, index2) {
    const inRange = element.inRange(position.x, position.y, useFinalPosition);
    if (intersect && !inRange) {
      return;
    }
    const center = element.getCenterPoint(useFinalPosition);
    const pointInArea = !!includeInvisible || chart.isPointInArea(center);
    if (!pointInArea && !inRange) {
      return;
    }
    const distance = distanceMetric(position, center);
    if (distance < minDistance) {
      items = [
        {
          element,
          datasetIndex,
          index: index2
        }
      ];
      minDistance = distance;
    } else if (distance === minDistance) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return [];
  }
  return axis === "r" && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
  const items = [];
  const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
  let intersectsItem = false;
  evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index2) => {
    if (element[rangeMethod](position[axis], useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
      intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
    }
  });
  if (intersect && !intersectsItem) {
    return [];
  }
  return items;
}
var Interaction = {
  evaluateInteractionItems,
  modes: {
    index(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "x";
      const includeInvisible = options.includeInvisible || false;
      const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      const elements = [];
      if (!items.length) {
        return [];
      }
      chart.getSortedVisibleDatasetMetas().forEach((meta) => {
        const index2 = items[0].index;
        const element = meta.data[index2];
        if (element && !element.skip) {
          elements.push({
            element,
            datasetIndex: meta.index,
            index: index2
          });
        }
      });
      return elements;
    },
    dataset(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      if (items.length > 0) {
        const datasetIndex = items[0].datasetIndex;
        const data = chart.getDatasetMeta(datasetIndex).data;
        items = [];
        for (let i = 0; i < data.length; ++i) {
          items.push({
            element: data[i],
            datasetIndex,
            index: i
          });
        }
      }
      return items;
    },
    point(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
    },
    nearest(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
    },
    x(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
    },
    y(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
    }
  }
};
var STATIC_POSITIONS = [
  "left",
  "top",
  "right",
  "bottom"
];
function filterByPosition(array, position) {
  return array.filter((v) => v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
  return array.filter((v) => STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
  return array.sort((a, b) => {
    const v0 = reverse ? b : a;
    const v1 = reverse ? a : b;
    return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
  });
}
function wrapBoxes(boxes) {
  const layoutBoxes = [];
  let i, ilen, box, pos, stack, stackWeight;
  for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
    box = boxes[i];
    ({ position: pos, options: { stack, stackWeight = 1 } } = box);
    layoutBoxes.push({
      index: i,
      box,
      pos,
      horizontal: box.isHorizontal(),
      weight: box.weight,
      stack: stack && pos + stack,
      stackWeight
    });
  }
  return layoutBoxes;
}
function buildStacks(layouts2) {
  const stacks = {};
  for (const wrap of layouts2) {
    const { stack, pos, stackWeight } = wrap;
    if (!stack || !STATIC_POSITIONS.includes(pos)) {
      continue;
    }
    const _stack = stacks[stack] || (stacks[stack] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    _stack.count++;
    _stack.weight += stackWeight;
  }
  return stacks;
}
function setLayoutDims(layouts2, params) {
  const stacks = buildStacks(layouts2);
  const { vBoxMaxWidth, hBoxMaxHeight } = params;
  let i, ilen, layout;
  for (i = 0, ilen = layouts2.length; i < ilen; ++i) {
    layout = layouts2[i];
    const { fullSize } = layout.box;
    const stack = stacks[layout.stack];
    const factor = stack && layout.stackWeight / stack.weight;
    if (layout.horizontal) {
      layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout.height = hBoxMaxHeight;
    } else {
      layout.width = vBoxMaxWidth;
      layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }
  return stacks;
}
function buildLayoutBoxes(boxes) {
  const layoutBoxes = wrapBoxes(boxes);
  const fullSize = sortByWeight(layoutBoxes.filter((wrap) => wrap.box.fullSize), true);
  const left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
  const right = sortByWeight(filterByPosition(layoutBoxes, "right"));
  const top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
  const bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
  const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, "x");
  const centerVertical = filterDynamicPositionByAxis(layoutBoxes, "y");
  return {
    fullSize,
    leftAndTop: left.concat(top),
    rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, "chartArea"),
    vertical: left.concat(right).concat(centerVertical),
    horizontal: top.concat(bottom).concat(centerHorizontal)
  };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
  return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
  const { pos, box } = layout;
  const maxPadding = chartArea.maxPadding;
  if (!isObject(pos)) {
    if (layout.size) {
      chartArea[pos] -= layout.size;
    }
    const stack = stacks[layout.stack] || {
      size: 0,
      count: 1
    };
    stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
    layout.size = stack.size / stack.count;
    chartArea[pos] += layout.size;
  }
  if (box.getPadding) {
    updateMaxPadding(maxPadding, box.getPadding());
  }
  const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right"));
  const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom"));
  const widthChanged = newWidth !== chartArea.w;
  const heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout.horizontal ? {
    same: widthChanged,
    other: heightChanged
  } : {
    same: heightChanged,
    other: widthChanged
  };
}
function handleMaxPadding(chartArea) {
  const maxPadding = chartArea.maxPadding;
  function updatePos(pos) {
    const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }
  chartArea.y += updatePos("top");
  chartArea.x += updatePos("left");
  updatePos("right");
  updatePos("bottom");
}
function getMargins(horizontal, chartArea) {
  const maxPadding = chartArea.maxPadding;
  function marginForPositions(positions2) {
    const margin = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    positions2.forEach((pos) => {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }
  return horizontal ? marginForPositions([
    "left",
    "right"
  ]) : marginForPositions([
    "top",
    "bottom"
  ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
  const refitBoxes = [];
  let i, ilen, layout, box, refit, changed;
  for (i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i) {
    layout = boxes[i];
    box = layout.box;
    box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
    const { same, other } = updateDims(chartArea, params, layout, stacks);
    refit |= same && refitBoxes.length;
    changed = changed || other;
    if (!box.fullSize) {
      refitBoxes.push(layout);
    }
  }
  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
  box.top = top;
  box.left = left;
  box.right = left + width;
  box.bottom = top + height;
  box.width = width;
  box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
  const userPadding = params.padding;
  let { x, y } = chartArea;
  for (const layout of boxes) {
    const box = layout.box;
    const stack = stacks[layout.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    };
    const weight = layout.stackWeight / stack.weight || 1;
    if (layout.horizontal) {
      const width = chartArea.w * weight;
      const height = stack.size || box.height;
      if (defined(stack.start)) {
        y = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
      } else {
        setBoxDims(box, chartArea.left + stack.placed, y, width, height);
      }
      stack.start = y;
      stack.placed += width;
      y = box.bottom;
    } else {
      const height = chartArea.h * weight;
      const width = stack.size || box.width;
      if (defined(stack.start)) {
        x = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
      } else {
        setBoxDims(box, x, chartArea.top + stack.placed, width, height);
      }
      stack.start = x;
      stack.placed += height;
      x = box.right;
    }
  }
  chartArea.x = x;
  chartArea.y = y;
}
var layouts = {
  addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }
    item.fullSize = item.fullSize || false;
    item.position = item.position || "top";
    item.weight = item.weight || 0;
    item._layers = item._layers || function() {
      return [
        {
          z: 0,
          draw(chartArea) {
            item.draw(chartArea);
          }
        }
      ];
    };
    chart.boxes.push(item);
  },
  removeBox(chart, layoutItem) {
    const index2 = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
    if (index2 !== -1) {
      chart.boxes.splice(index2, 1);
    }
  },
  configure(chart, item, options) {
    item.fullSize = options.fullSize;
    item.position = options.position;
    item.weight = options.weight;
  },
  update(chart, width, height, minPadding) {
    if (!chart) {
      return;
    }
    const padding = toPadding(chart.options.layout.padding);
    const availableWidth = Math.max(width - padding.width, 0);
    const availableHeight = Math.max(height - padding.height, 0);
    const boxes = buildLayoutBoxes(chart.boxes);
    const verticalBoxes = boxes.vertical;
    const horizontalBoxes = boxes.horizontal;
    each(chart.boxes, (box) => {
      if (typeof box.beforeLayout === "function") {
        box.beforeLayout();
      }
    });
    const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap) => wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
    const params = Object.freeze({
      outerWidth: width,
      outerHeight: height,
      padding,
      availableWidth,
      availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    const maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    const chartArea = Object.assign({
      maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);
    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }
    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w
    };
    each(boxes.chartArea, (layout) => {
      const box = layout.box;
      Object.assign(box, chart.chartArea);
      box.update(chartArea.w, chartArea.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
var BasePlatform = class {
  acquireContext(canvas, aspectRatio) {
  }
  releaseContext(context) {
    return false;
  }
  addEventListener(chart, type, listener) {
  }
  removeEventListener(chart, type, listener) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(element, width, height, aspectRatio) {
    width = Math.max(0, width || element.width);
    height = height || element.height;
    return {
      width,
      height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
    };
  }
  isAttached(canvas) {
    return true;
  }
  updateConfig(config) {
  }
};
var BasicPlatform = class extends BasePlatform {
  acquireContext(item) {
    return item && item.getContext && item.getContext("2d") || null;
  }
  updateConfig(config) {
    config.options.animation = false;
  }
};
var EXPANDO_KEY = "$chartjs";
var EVENT_TYPES = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
};
var isNullOrEmpty = (value) => value === null || value === "";
function initCanvas(canvas, aspectRatio) {
  const style = canvas.style;
  const renderHeight = canvas.getAttribute("height");
  const renderWidth = canvas.getAttribute("width");
  canvas[EXPANDO_KEY] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || "block";
  style.boxSizing = style.boxSizing || "border-box";
  if (isNullOrEmpty(renderWidth)) {
    const displayWidth = readUsedSize(canvas, "width");
    if (displayWidth !== void 0) {
      canvas.width = displayWidth;
    }
  }
  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === "") {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      const displayHeight = readUsedSize(canvas, "height");
      if (displayHeight !== void 0) {
        canvas.height = displayHeight;
      }
    }
  }
  return canvas;
}
var eventListenerOptions = supportsEventListenerOptions ? {
  passive: true
} : false;
function addListener(node, type, listener) {
  node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
  chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
  const type = EVENT_TYPES[event.type] || event.type;
  const { x, y } = getRelativePosition(event, chart);
  return {
    type,
    chart,
    native: event,
    x: x !== void 0 ? x : null,
    y: y !== void 0 ? y : null
  };
}
function nodeListContains(nodeList, canvas) {
  for (const node of nodeList) {
    if (node === canvas || node.contains(canvas)) {
      return true;
    }
  }
}
function createAttachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries) => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.addedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
function createDetachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries) => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.removedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
var drpListeningCharts = /* @__PURE__ */ new Map();
var oldDevicePixelRatio = 0;
function onWindowResize() {
  const dpr = window.devicePixelRatio;
  if (dpr === oldDevicePixelRatio) {
    return;
  }
  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach((resize, chart) => {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}
function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener("resize", onWindowResize);
  }
  drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts.delete(chart);
  if (!drpListeningCharts.size) {
    window.removeEventListener("resize", onWindowResize);
  }
}
function createResizeObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const container = canvas && _getParentNode(canvas);
  if (!container) {
    return;
  }
  const resize = throttled((width, height) => {
    const w = container.clientWidth;
    listener(width, height);
    if (w < container.clientWidth) {
      listener();
    }
  }, window);
  const observer = new ResizeObserver((entries) => {
    const entry = entries[0];
    const width = entry.contentRect.width;
    const height = entry.contentRect.height;
    if (width === 0 && height === 0) {
      return;
    }
    resize(width, height);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}
function releaseObserver(chart, type, observer) {
  if (observer) {
    observer.disconnect();
  }
  if (type === "resize") {
    unlistenDevicePixelRatioChanges(chart);
  }
}
function createProxyAndListen(chart, type, listener) {
  const canvas = chart.canvas;
  const proxy = throttled((event) => {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart);
  addListener(canvas, type, proxy);
  return proxy;
}
var DomPlatform = class extends BasePlatform {
  acquireContext(canvas, aspectRatio) {
    const context = canvas && canvas.getContext && canvas.getContext("2d");
    if (context && context.canvas === canvas) {
      initCanvas(canvas, aspectRatio);
      return context;
    }
    return null;
  }
  releaseContext(context) {
    const canvas = context.canvas;
    if (!canvas[EXPANDO_KEY]) {
      return false;
    }
    const initial = canvas[EXPANDO_KEY].initial;
    [
      "height",
      "width"
    ].forEach((prop) => {
      const value = initial[prop];
      if (isNullOrUndef(value)) {
        canvas.removeAttribute(prop);
      } else {
        canvas.setAttribute(prop, value);
      }
    });
    const style = initial.style || {};
    Object.keys(style).forEach((key) => {
      canvas.style[key] = style[key];
    });
    canvas.width = canvas.width;
    delete canvas[EXPANDO_KEY];
    return true;
  }
  addEventListener(chart, type, listener) {
    this.removeEventListener(chart, type);
    const proxies = chart.$proxies || (chart.$proxies = {});
    const handlers = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    };
    const handler = handlers[type] || createProxyAndListen;
    proxies[type] = handler(chart, type, listener);
  }
  removeEventListener(chart, type) {
    const proxies = chart.$proxies || (chart.$proxies = {});
    const proxy = proxies[type];
    if (!proxy) {
      return;
    }
    const handlers = {
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    };
    const handler = handlers[type] || removeListener;
    handler(chart, type, proxy);
    proxies[type] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(canvas, width, height, aspectRatio) {
    return getMaximumSize(canvas, width, height, aspectRatio);
  }
  isAttached(canvas) {
    const container = _getParentNode(canvas);
    return !!(container && container.isConnected);
  }
};
function _detectPlatform(canvas) {
  if (!_isDomSupported() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) {
    return BasicPlatform;
  }
  return DomPlatform;
}
var Element = class {
  static defaults = {};
  static defaultRoutes = void 0;
  x;
  y;
  active = false;
  options;
  $animations;
  tooltipPosition(useFinalPosition) {
    const { x, y } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return {
      x,
      y
    };
  }
  hasValue() {
    return isNumber6(this.x) && isNumber6(this.y);
  }
  getProps(props, final) {
    const anims = this.$animations;
    if (!final || !anims) {
      return this;
    }
    const ret = {};
    props.forEach((prop) => {
      ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
    });
    return ret;
  }
};
function autoSkip(scale, ticks) {
  const tickOpts = scale.options.ticks;
  const determinedMaxTicks = determineMaxTicks(scale);
  const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
  const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  const numMajorIndices = majorIndices.length;
  const first = majorIndices[0];
  const last = majorIndices[numMajorIndices - 1];
  const newTicks = [];
  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }
  const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
  if (numMajorIndices > 0) {
    let i, ilen;
    const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
    for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
      skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
    }
    skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
    return newTicks;
  }
  skip(ticks, newTicks, spacing);
  return newTicks;
}
function determineMaxTicks(scale) {
  const offset = scale.options.offset;
  const tickLength = scale._tickSize();
  const maxScale = scale._length / tickLength + (offset ? 0 : 1);
  const maxChart = scale._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
  const evenMajorSpacing = getEvenSpacing(majorIndices);
  const spacing = ticks.length / ticksLimit;
  if (!evenMajorSpacing) {
    return Math.max(spacing, 1);
  }
  const factors = _factorize(evenMajorSpacing);
  for (let i = 0, ilen = factors.length - 1; i < ilen; i++) {
    const factor = factors[i];
    if (factor > spacing) {
      return factor;
    }
  }
  return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
  const result = [];
  let i, ilen;
  for (i = 0, ilen = ticks.length; i < ilen; i++) {
    if (ticks[i].major) {
      result.push(i);
    }
  }
  return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
  let count = 0;
  let next = majorIndices[0];
  let i;
  spacing = Math.ceil(spacing);
  for (i = 0; i < ticks.length; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = majorIndices[count * spacing];
    }
  }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
  const start = valueOrDefault(majorStart, 0);
  const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  let count = 0;
  let length, i, next;
  spacing = Math.ceil(spacing);
  if (majorEnd) {
    length = majorEnd - majorStart;
    spacing = length / Math.floor(length / spacing);
  }
  next = start;
  while (next < 0) {
    count++;
    next = Math.round(start + count * spacing);
  }
  for (i = Math.max(start, 0); i < end; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = Math.round(start + count * spacing);
    }
  }
}
function getEvenSpacing(arr) {
  const len = arr.length;
  let i, diff;
  if (len < 2) {
    return false;
  }
  for (diff = arr[0], i = 1; i < len; ++i) {
    if (arr[i] - arr[i - 1] !== diff) {
      return false;
    }
  }
  return diff;
}
var reverseAlign = (align) => align === "left" ? "right" : align === "right" ? "left" : align;
var offsetFromEdge = (scale, edge, offset) => edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
var getTicksLimit = (ticksLength, maxTicksLimit) => Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
  const result = [];
  const increment = arr.length / numItems;
  const len = arr.length;
  let i = 0;
  for (; i < len; i += increment) {
    result.push(arr[Math.floor(i)]);
  }
  return result;
}
function getPixelForGridLine(scale, index2, offsetGridLines) {
  const length = scale.ticks.length;
  const validIndex2 = Math.min(index2, length - 1);
  const start = scale._startPixel;
  const end = scale._endPixel;
  const epsilon = 1e-6;
  let lineValue = scale.getPixelForTick(validIndex2);
  let offset;
  if (offsetGridLines) {
    if (length === 1) {
      offset = Math.max(lineValue - start, end - lineValue);
    } else if (index2 === 0) {
      offset = (scale.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset = (lineValue - scale.getPixelForTick(validIndex2 - 1)) / 2;
    }
    lineValue += validIndex2 < index2 ? offset : -offset;
    if (lineValue < start - epsilon || lineValue > end + epsilon) {
      return;
    }
  }
  return lineValue;
}
function garbageCollect(caches, length) {
  each(caches, (cache) => {
    const gc = cache.gc;
    const gcLen = gc.length / 2;
    let i;
    if (gcLen > length) {
      for (i = 0; i < gcLen; ++i) {
        delete cache.data[gc[i]];
      }
      gc.splice(0, gcLen);
    }
  });
}
function getTickMarkLength(options) {
  return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
  if (!options.display) {
    return 0;
  }
  const font = toFont(options.font, fallback);
  const padding = toPadding(options.padding);
  const lines = isArray(options.text) ? options.text.length : 1;
  return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
  return createContext20(parent, {
    scale,
    type: "scale"
  });
}
function createTickContext(parent, index2, tick) {
  return createContext20(parent, {
    tick,
    index: index2,
    type: "tick"
  });
}
function titleAlign(align, position, reverse) {
  let ret = _toLeftRightCenter(align);
  if (reverse && position !== "right" || !reverse && position === "right") {
    ret = reverseAlign(ret);
  }
  return ret;
}
function titleArgs(scale, offset, position, align) {
  const { top, left, bottom, right, chart } = scale;
  const { chartArea, scales } = chart;
  let rotation = 0;
  let maxWidth, titleX, titleY;
  const height = bottom - top;
  const width = right - left;
  if (scale.isHorizontal()) {
    titleX = _alignStartEnd(align, left, right);
    if (isObject(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
    } else if (position === "center") {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
    } else {
      titleY = offsetFromEdge(scale, position, offset);
    }
    maxWidth = right - left;
  } else {
    if (isObject(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
    } else if (position === "center") {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
    } else {
      titleX = offsetFromEdge(scale, position, offset);
    }
    titleY = _alignStartEnd(align, bottom, top);
    rotation = position === "left" ? -HALF_PI : HALF_PI;
  }
  return {
    titleX,
    titleY,
    maxWidth,
    rotation
  };
}
var Scale = class _Scale extends Element {
  constructor(cfg) {
    super();
    this.id = cfg.id;
    this.type = cfg.type;
    this.options = void 0;
    this.ctx = cfg.ctx;
    this.chart = cfg.chart;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this.maxWidth = void 0;
    this.maxHeight = void 0;
    this.paddingTop = void 0;
    this.paddingBottom = void 0;
    this.paddingLeft = void 0;
    this.paddingRight = void 0;
    this.axis = void 0;
    this.labelRotation = void 0;
    this.min = void 0;
    this.max = void 0;
    this._range = void 0;
    this.ticks = [];
    this._gridLineItems = null;
    this._labelItems = null;
    this._labelSizes = null;
    this._length = 0;
    this._maxLength = 0;
    this._longestTextCache = {};
    this._startPixel = void 0;
    this._endPixel = void 0;
    this._reversePixels = false;
    this._userMax = void 0;
    this._userMin = void 0;
    this._suggestedMax = void 0;
    this._suggestedMin = void 0;
    this._ticksLength = 0;
    this._borderValue = 0;
    this._cache = {};
    this._dataLimitsCached = false;
    this.$context = void 0;
  }
  init(options) {
    this.options = options.setContext(this.getContext());
    this.axis = options.axis;
    this._userMin = this.parse(options.min);
    this._userMax = this.parse(options.max);
    this._suggestedMin = this.parse(options.suggestedMin);
    this._suggestedMax = this.parse(options.suggestedMax);
  }
  parse(raw, index2) {
    return raw;
  }
  getUserBounds() {
    let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
    _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
    _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
    _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
    _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
    return {
      min: finiteOrDefault(_userMin, _suggestedMin),
      max: finiteOrDefault(_userMax, _suggestedMax),
      minDefined: isNumberFinite(_userMin),
      maxDefined: isNumberFinite(_userMax)
    };
  }
  getMinMax(canStack) {
    let { min, max, minDefined, maxDefined } = this.getUserBounds();
    let range;
    if (minDefined && maxDefined) {
      return {
        min,
        max
      };
    }
    const metas = this.getMatchingVisibleMetas();
    for (let i = 0, ilen = metas.length; i < ilen; ++i) {
      range = metas[i].controller.getMinMax(this, canStack);
      if (!minDefined) {
        min = Math.min(min, range.min);
      }
      if (!maxDefined) {
        max = Math.max(max, range.max);
      }
    }
    min = maxDefined && min > max ? max : min;
    max = minDefined && min > max ? min : max;
    return {
      min: finiteOrDefault(min, finiteOrDefault(max, min)),
      max: finiteOrDefault(max, finiteOrDefault(min, max))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const data = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
  }
  getLabelItems(chartArea = this.chart.chartArea) {
    const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
    return items;
  }
  beforeLayout() {
    this._cache = {};
    this._dataLimitsCached = false;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [
      this
    ]);
  }
  update(maxWidth, maxHeight, margins) {
    const { beginAtZero, grace, ticks: tickOpts } = this.options;
    const sampleSize = tickOpts.sampleSize;
    this.beforeUpdate();
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, margins);
    this.ticks = null;
    this._labelSizes = null;
    this._gridLineItems = null;
    this._labelItems = null;
    this.beforeSetDimensions();
    this.setDimensions();
    this.afterSetDimensions();
    this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
    if (!this._dataLimitsCached) {
      this.beforeDataLimits();
      this.determineDataLimits();
      this.afterDataLimits();
      this._range = _addGrace(this, grace, beginAtZero);
      this._dataLimitsCached = true;
    }
    this.beforeBuildTicks();
    this.ticks = this.buildTicks() || [];
    this.afterBuildTicks();
    const samplingEnabled = sampleSize < this.ticks.length;
    this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
    this.configure();
    this.beforeCalculateLabelRotation();
    this.calculateLabelRotation();
    this.afterCalculateLabelRotation();
    if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
      this.ticks = autoSkip(this, this.ticks);
      this._labelSizes = null;
      this.afterAutoSkip();
    }
    if (samplingEnabled) {
      this._convertTicksToLabels(this.ticks);
    }
    this.beforeFit();
    this.fit();
    this.afterFit();
    this.afterUpdate();
  }
  configure() {
    let reversePixels = this.options.reverse;
    let startPixel, endPixel;
    if (this.isHorizontal()) {
      startPixel = this.left;
      endPixel = this.right;
    } else {
      startPixel = this.top;
      endPixel = this.bottom;
      reversePixels = !reversePixels;
    }
    this._startPixel = startPixel;
    this._endPixel = endPixel;
    this._reversePixels = reversePixels;
    this._length = endPixel - startPixel;
    this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = 0;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = 0;
      this.bottom = this.height;
    }
    this.paddingLeft = 0;
    this.paddingTop = 0;
    this.paddingRight = 0;
    this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(name) {
    this.chart.notifyPlugins(name, this.getContext());
    callback(this.options[name], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(ticks) {
    const tickOpts = this.options.ticks;
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      tick = ticks[i];
      tick.label = callback(tickOpts.callback, [
        tick.value,
        i,
        ticks
      ], this);
    }
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const options = this.options;
    const tickOpts = options.ticks;
    const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
    const minRotation = tickOpts.minRotation || 0;
    const maxRotation = tickOpts.maxRotation;
    let labelRotation = minRotation;
    let tickWidth, maxHeight, maxLabelDiagonal;
    if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
      this.labelRotation = minRotation;
      return;
    }
    const labelSizes = this._getLabelSizes();
    const maxLabelWidth = labelSizes.widest.width;
    const maxLabelHeight = labelSizes.highest.height;
    const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
    tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
    if (maxLabelWidth + 6 > tickWidth) {
      tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
      maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
      maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
      labelRotation = toDegrees(Math.min(Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
      labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
    }
    this.labelRotation = labelRotation;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    callback(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const minSize = {
      width: 0,
      height: 0
    };
    const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
    const display = this._isVisible();
    const isHorizontal = this.isHorizontal();
    if (display) {
      const titleHeight = getTitleHeight(titleOpts, chart.options.font);
      if (isHorizontal) {
        minSize.width = this.maxWidth;
        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
      } else {
        minSize.height = this.maxHeight;
        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
      }
      if (tickOpts.display && this.ticks.length) {
        const { first, last, widest, highest } = this._getLabelSizes();
        const tickPadding = tickOpts.padding * 2;
        const angleRadians = toRadians(this.labelRotation);
        const cos = Math.cos(angleRadians);
        const sin = Math.sin(angleRadians);
        if (isHorizontal) {
          const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
          minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
        } else {
          const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
          minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
        }
        this._calculatePadding(first, last, sin, cos);
      }
    }
    this._handleMargins();
    if (isHorizontal) {
      this.width = this._length = chart.width - this._margins.left - this._margins.right;
      this.height = minSize.height;
    } else {
      this.width = minSize.width;
      this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
    }
  }
  _calculatePadding(first, last, sin, cos) {
    const { ticks: { align, padding }, position } = this.options;
    const isRotated = this.labelRotation !== 0;
    const labelsBelowTicks = position !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const offsetLeft = this.getPixelForTick(0) - this.left;
      const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
      let paddingLeft = 0;
      let paddingRight = 0;
      if (isRotated) {
        if (labelsBelowTicks) {
          paddingLeft = cos * first.width;
          paddingRight = sin * last.height;
        } else {
          paddingLeft = sin * first.height;
          paddingRight = cos * last.width;
        }
      } else if (align === "start") {
        paddingRight = last.width;
      } else if (align === "end") {
        paddingLeft = first.width;
      } else if (align !== "inner") {
        paddingLeft = first.width / 2;
        paddingRight = last.width / 2;
      }
      this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
      this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
    } else {
      let paddingTop = last.height / 2;
      let paddingBottom = first.height / 2;
      if (align === "start") {
        paddingTop = 0;
        paddingBottom = first.height;
      } else if (align === "end") {
        paddingTop = last.height;
        paddingBottom = 0;
      }
      this.paddingTop = paddingTop + padding;
      this.paddingBottom = paddingBottom + padding;
    }
  }
  _handleMargins() {
    if (this._margins) {
      this._margins.left = Math.max(this.paddingLeft, this._margins.left);
      this._margins.top = Math.max(this.paddingTop, this._margins.top);
      this._margins.right = Math.max(this.paddingRight, this._margins.right);
      this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
    }
  }
  afterFit() {
    callback(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis, position } = this.options;
    return position === "top" || position === "bottom" || axis === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(ticks) {
    this.beforeTickToLabelConversion();
    this.generateTickLabels(ticks);
    let i, ilen;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      if (isNullOrUndef(ticks[i].label)) {
        ticks.splice(i, 1);
        ilen--;
        i--;
      }
    }
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let labelSizes = this._labelSizes;
    if (!labelSizes) {
      const sampleSize = this.options.ticks.sampleSize;
      let ticks = this.ticks;
      if (sampleSize < ticks.length) {
        ticks = sample(ticks, sampleSize);
      }
      this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
    }
    return labelSizes;
  }
  _computeLabelSizes(ticks, length, maxTicksLimit) {
    const { ctx, _longestTextCache: caches } = this;
    const widths = [];
    const heights = [];
    const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
    let widestLabelSize = 0;
    let highestLabelSize = 0;
    let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
    for (i = 0; i < length; i += increment) {
      label = ticks[i].label;
      tickFont = this._resolveTickFontOptions(i);
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || {
        data: {},
        gc: []
      };
      lineHeight = tickFont.lineHeight;
      width = height = 0;
      if (!isNullOrUndef(label) && !isArray(label)) {
        width = _measureText(ctx, cache.data, cache.gc, width, label);
        height = lineHeight;
      } else if (isArray(label)) {
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
            width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height, highestLabelSize);
    }
    garbageCollect(caches, length);
    const widest = widths.indexOf(widestLabelSize);
    const highest = heights.indexOf(highestLabelSize);
    const valueAt = (idx) => ({
      width: widths[idx] || 0,
      height: heights[idx] || 0
    });
    return {
      first: valueAt(0),
      last: valueAt(length - 1),
      widest: valueAt(widest),
      highest: valueAt(highest),
      widths,
      heights
    };
  }
  getLabelForValue(value) {
    return value;
  }
  getPixelForValue(value, index2) {
    return NaN;
  }
  getValueForPixel(pixel) {
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getPixelForDecimal(decimal) {
    if (this._reversePixels) {
      decimal = 1 - decimal;
    }
    const pixel = this._startPixel + decimal * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
  }
  getDecimalForPixel(pixel) {
    const decimal = (pixel - this._startPixel) / this._length;
    return this._reversePixels ? 1 - decimal : decimal;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min, max } = this;
    return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
  }
  getContext(index2) {
    const ticks = this.ticks || [];
    if (index2 >= 0 && index2 < ticks.length) {
      const tick = ticks[index2];
      return tick.$context || (tick.$context = createTickContext(this.getContext(), index2, tick));
    }
    return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const optionTicks = this.options.ticks;
    const rot = toRadians(this.labelRotation);
    const cos = Math.abs(Math.cos(rot));
    const sin = Math.abs(Math.sin(rot));
    const labelSizes = this._getLabelSizes();
    const padding = optionTicks.autoSkipPadding || 0;
    const w = labelSizes ? labelSizes.widest.width + padding : 0;
    const h = labelSizes ? labelSizes.highest.height + padding : 0;
    return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
  }
  _isVisible() {
    const display = this.options.display;
    if (display !== "auto") {
      return !!display;
    }
    return this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(chartArea) {
    const axis = this.axis;
    const chart = this.chart;
    const options = this.options;
    const { grid, position, border } = options;
    const offset = grid.offset;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const ticksLength = ticks.length + (offset ? 1 : 0);
    const tl = getTickMarkLength(grid);
    const items = [];
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = borderOpts.display ? borderOpts.width : 0;
    const axisHalfWidth = axisWidth / 2;
    const alignBorderValue = function(pixel) {
      return _alignPixel(chart, pixel, axisWidth);
    };
    let borderValue, i, lineValue, alignedLineValue;
    let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
    if (position === "top") {
      borderValue = alignBorderValue(this.bottom);
      ty1 = this.bottom - tl;
      ty2 = borderValue - axisHalfWidth;
      y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
      y2 = chartArea.bottom;
    } else if (position === "bottom") {
      borderValue = alignBorderValue(this.top);
      y1 = chartArea.top;
      y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
      ty1 = borderValue + axisHalfWidth;
      ty2 = this.top + tl;
    } else if (position === "left") {
      borderValue = alignBorderValue(this.right);
      tx1 = this.right - tl;
      tx2 = borderValue - axisHalfWidth;
      x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
      x2 = chartArea.right;
    } else if (position === "right") {
      borderValue = alignBorderValue(this.left);
      x1 = chartArea.left;
      x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
      tx1 = borderValue + axisHalfWidth;
      tx2 = this.left + tl;
    } else if (axis === "x") {
      if (position === "center") {
        borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      y1 = chartArea.top;
      y2 = chartArea.bottom;
      ty1 = borderValue + axisHalfWidth;
      ty2 = ty1 + tl;
    } else if (axis === "y") {
      if (position === "center") {
        borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      tx1 = borderValue - axisHalfWidth;
      tx2 = tx1 - tl;
      x1 = chartArea.left;
      x2 = chartArea.right;
    }
    const limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
    const step = Math.max(1, Math.ceil(ticksLength / limit));
    for (i = 0; i < ticksLength; i += step) {
      const context = this.getContext(i);
      const optsAtIndex = grid.setContext(context);
      const optsAtIndexBorder = border.setContext(context);
      const lineWidth = optsAtIndex.lineWidth;
      const lineColor = optsAtIndex.color;
      const borderDash = optsAtIndexBorder.dash || [];
      const borderDashOffset = optsAtIndexBorder.dashOffset;
      const tickWidth = optsAtIndex.tickWidth;
      const tickColor = optsAtIndex.tickColor;
      const tickBorderDash = optsAtIndex.tickBorderDash || [];
      const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
      lineValue = getPixelForGridLine(this, i, offset);
      if (lineValue === void 0) {
        continue;
      }
      alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
      if (isHorizontal) {
        tx1 = tx2 = x1 = x2 = alignedLineValue;
      } else {
        ty1 = ty2 = y1 = y2 = alignedLineValue;
      }
      items.push({
        tx1,
        ty1,
        tx2,
        ty2,
        x1,
        y1,
        x2,
        y2,
        width: lineWidth,
        color: lineColor,
        borderDash,
        borderDashOffset,
        tickWidth,
        tickColor,
        tickBorderDash,
        tickBorderDashOffset
      });
    }
    this._ticksLength = ticksLength;
    this._borderValue = borderValue;
    return items;
  }
  _computeLabelItems(chartArea) {
    const axis = this.axis;
    const options = this.options;
    const { position, ticks: optionTicks } = options;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const { align, crossAlign, padding, mirror } = optionTicks;
    const tl = getTickMarkLength(options.grid);
    const tickAndPadding = tl + padding;
    const hTickAndPadding = mirror ? -padding : tickAndPadding;
    const rotation = -toRadians(this.labelRotation);
    const items = [];
    let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
    let textBaseline = "middle";
    if (position === "top") {
      y = this.bottom - hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === "bottom") {
      y = this.top + hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === "left") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (position === "right") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (axis === "x") {
      if (position === "center") {
        y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
      }
      textAlign = this._getXAxisLabelAlignment();
    } else if (axis === "y") {
      if (position === "center") {
        x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        x = this.chart.scales[positionAxisID].getPixelForValue(value);
      }
      textAlign = this._getYAxisLabelAlignment(tl).textAlign;
    }
    if (axis === "y") {
      if (align === "start") {
        textBaseline = "top";
      } else if (align === "end") {
        textBaseline = "bottom";
      }
    }
    const labelSizes = this._getLabelSizes();
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      label = tick.label;
      const optsAtIndex = optionTicks.setContext(this.getContext(i));
      pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
      font = this._resolveTickFontOptions(i);
      lineHeight = font.lineHeight;
      lineCount = isArray(label) ? label.length : 1;
      const halfCount = lineCount / 2;
      const color2 = optsAtIndex.color;
      const strokeColor = optsAtIndex.textStrokeColor;
      const strokeWidth = optsAtIndex.textStrokeWidth;
      let tickTextAlign = textAlign;
      if (isHorizontal) {
        x = pixel;
        if (textAlign === "inner") {
          if (i === ilen - 1) {
            tickTextAlign = !this.options.reverse ? "right" : "left";
          } else if (i === 0) {
            tickTextAlign = !this.options.reverse ? "left" : "right";
          } else {
            tickTextAlign = "center";
          }
        }
        if (position === "top") {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = -lineCount * lineHeight + lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
          } else {
            textOffset = -labelSizes.highest.height + lineHeight / 2;
          }
        } else {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
          } else {
            textOffset = labelSizes.highest.height - lineCount * lineHeight;
          }
        }
        if (mirror) {
          textOffset *= -1;
        }
        if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) {
          x += lineHeight / 2 * Math.sin(rotation);
        }
      } else {
        y = pixel;
        textOffset = (1 - lineCount) * lineHeight / 2;
      }
      let backdrop;
      if (optsAtIndex.showLabelBackdrop) {
        const labelPadding = toPadding(optsAtIndex.backdropPadding);
        const height = labelSizes.heights[i];
        const width = labelSizes.widths[i];
        let top = textOffset - labelPadding.top;
        let left = 0 - labelPadding.left;
        switch (textBaseline) {
          case "middle":
            top -= height / 2;
            break;
          case "bottom":
            top -= height;
            break;
        }
        switch (textAlign) {
          case "center":
            left -= width / 2;
            break;
          case "right":
            left -= width;
            break;
        }
        backdrop = {
          left,
          top,
          width: width + labelPadding.width,
          height: height + labelPadding.height,
          color: optsAtIndex.backdropColor
        };
      }
      items.push({
        label,
        font,
        textOffset,
        options: {
          rotation,
          color: color2,
          strokeColor,
          strokeWidth,
          textAlign: tickTextAlign,
          textBaseline,
          translation: [
            x,
            y
          ],
          backdrop
        }
      });
    }
    return items;
  }
  _getXAxisLabelAlignment() {
    const { position, ticks } = this.options;
    const rotation = -toRadians(this.labelRotation);
    if (rotation) {
      return position === "top" ? "left" : "right";
    }
    let align = "center";
    if (ticks.align === "start") {
      align = "left";
    } else if (ticks.align === "end") {
      align = "right";
    } else if (ticks.align === "inner") {
      align = "inner";
    }
    return align;
  }
  _getYAxisLabelAlignment(tl) {
    const { position, ticks: { crossAlign, mirror, padding } } = this.options;
    const labelSizes = this._getLabelSizes();
    const tickAndPadding = tl + padding;
    const widest = labelSizes.widest.width;
    let textAlign;
    let x;
    if (position === "left") {
      if (mirror) {
        x = this.right + padding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x += widest / 2;
        } else {
          textAlign = "right";
          x += widest;
        }
      } else {
        x = this.right - tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x -= widest / 2;
        } else {
          textAlign = "left";
          x = this.left;
        }
      }
    } else if (position === "right") {
      if (mirror) {
        x = this.left + padding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x -= widest / 2;
        } else {
          textAlign = "left";
          x -= widest;
        }
      } else {
        x = this.left + tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x += widest / 2;
        } else {
          textAlign = "right";
          x = this.right;
        }
      }
    } else {
      textAlign = "right";
    }
    return {
      textAlign,
      x
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror) {
      return;
    }
    const chart = this.chart;
    const position = this.options.position;
    if (position === "left" || position === "right") {
      return {
        top: 0,
        left: this.left,
        bottom: chart.height,
        right: this.right
      };
    }
    if (position === "top" || position === "bottom") {
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: chart.width
      };
    }
  }
  drawBackground() {
    const { ctx, options: { backgroundColor }, left, top, width, height } = this;
    if (backgroundColor) {
      ctx.save();
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(left, top, width, height);
      ctx.restore();
    }
  }
  getLineWidthForValue(value) {
    const grid = this.options.grid;
    if (!this._isVisible() || !grid.display) {
      return 0;
    }
    const ticks = this.ticks;
    const index2 = ticks.findIndex((t) => t.value === value);
    if (index2 >= 0) {
      const opts = grid.setContext(this.getContext(index2));
      return opts.lineWidth;
    }
    return 0;
  }
  drawGrid(chartArea) {
    const grid = this.options.grid;
    const ctx = this.ctx;
    const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
    let i, ilen;
    const drawLine = (p1, p2, style) => {
      if (!style.width || !style.color) {
        return;
      }
      ctx.save();
      ctx.lineWidth = style.width;
      ctx.strokeStyle = style.color;
      ctx.setLineDash(style.borderDash || []);
      ctx.lineDashOffset = style.borderDashOffset;
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
      ctx.restore();
    };
    if (grid.display) {
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        const item = items[i];
        if (grid.drawOnChartArea) {
          drawLine({
            x: item.x1,
            y: item.y1
          }, {
            x: item.x2,
            y: item.y2
          }, item);
        }
        if (grid.drawTicks) {
          drawLine({
            x: item.tx1,
            y: item.ty1
          }, {
            x: item.tx2,
            y: item.ty2
          }, {
            color: item.tickColor,
            width: item.tickWidth,
            borderDash: item.tickBorderDash,
            borderDashOffset: item.tickBorderDashOffset
          });
        }
      }
    }
  }
  drawBorder() {
    const { chart, ctx, options: { border, grid } } = this;
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = border.display ? borderOpts.width : 0;
    if (!axisWidth) {
      return;
    }
    const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
    const borderValue = this._borderValue;
    let x1, x2, y1, y2;
    if (this.isHorizontal()) {
      x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
      x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
      y1 = y2 = borderValue;
    } else {
      y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
      y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
      x1 = x2 = borderValue;
    }
    ctx.save();
    ctx.lineWidth = borderOpts.width;
    ctx.strokeStyle = borderOpts.color;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.restore();
  }
  drawLabels(chartArea) {
    const optionTicks = this.options.ticks;
    if (!optionTicks.display) {
      return;
    }
    const ctx = this.ctx;
    const area = this._computeLabelArea();
    if (area) {
      clipArea(ctx, area);
    }
    const items = this.getLabelItems(chartArea);
    for (const item of items) {
      const renderTextOptions = item.options;
      const tickFont = item.font;
      const label = item.label;
      const y = item.textOffset;
      renderText(ctx, label, 0, y, tickFont, renderTextOptions);
    }
    if (area) {
      unclipArea(ctx);
    }
  }
  drawTitle() {
    const { ctx, options: { position, title, reverse } } = this;
    if (!title.display) {
      return;
    }
    const font = toFont(title.font);
    const padding = toPadding(title.padding);
    const align = title.align;
    let offset = font.lineHeight / 2;
    if (position === "bottom" || position === "center" || isObject(position)) {
      offset += padding.bottom;
      if (isArray(title.text)) {
        offset += font.lineHeight * (title.text.length - 1);
      }
    } else {
      offset += padding.top;
    }
    const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset, position, align);
    renderText(ctx, title.text, 0, 0, font, {
      color: title.color,
      maxWidth,
      rotation,
      textAlign: titleAlign(align, position, reverse),
      textBaseline: "middle",
      translation: [
        titleX,
        titleY
      ]
    });
  }
  draw(chartArea) {
    if (!this._isVisible()) {
      return;
    }
    this.drawBackground();
    this.drawGrid(chartArea);
    this.drawBorder();
    this.drawTitle();
    this.drawLabels(chartArea);
  }
  _layers() {
    const opts = this.options;
    const tz = opts.ticks && opts.ticks.z || 0;
    const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
    const bz = valueOrDefault(opts.border && opts.border.z, 0);
    if (!this._isVisible() || this.draw !== _Scale.prototype.draw) {
      return [
        {
          z: tz,
          draw: (chartArea) => {
            this.draw(chartArea);
          }
        }
      ];
    }
    return [
      {
        z: gz,
        draw: (chartArea) => {
          this.drawBackground();
          this.drawGrid(chartArea);
          this.drawTitle();
        }
      },
      {
        z: bz,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: tz,
        draw: (chartArea) => {
          this.drawLabels(chartArea);
        }
      }
    ];
  }
  getMatchingVisibleMetas(type) {
    const metas = this.chart.getSortedVisibleDatasetMetas();
    const axisID = this.axis + "AxisID";
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      const meta = metas[i];
      if (meta[axisID] === this.id && (!type || meta.type === type)) {
        result.push(meta);
      }
    }
    return result;
  }
  _resolveTickFontOptions(index2) {
    const opts = this.options.ticks.setContext(this.getContext(index2));
    return toFont(opts.font);
  }
  _maxDigits() {
    const fontSize = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / fontSize;
  }
};
var TypedRegistry = class {
  constructor(type, scope, override) {
    this.type = type;
    this.scope = scope;
    this.override = override;
    this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(type) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
  }
  register(item) {
    const proto = Object.getPrototypeOf(item);
    let parentScope;
    if (isIChartComponent(proto)) {
      parentScope = this.register(proto);
    }
    const items = this.items;
    const id2 = item.id;
    const scope = this.scope + "." + id2;
    if (!id2) {
      throw new Error("class does not have id: " + item);
    }
    if (id2 in items) {
      return scope;
    }
    items[id2] = item;
    registerDefaults(item, scope, parentScope);
    if (this.override) {
      defaults.override(item.id, item.overrides);
    }
    return scope;
  }
  get(id2) {
    return this.items[id2];
  }
  unregister(item) {
    const items = this.items;
    const id2 = item.id;
    const scope = this.scope;
    if (id2 in items) {
      delete items[id2];
    }
    if (scope && id2 in defaults[scope]) {
      delete defaults[scope][id2];
      if (this.override) {
        delete overrides[id2];
      }
    }
  }
};
function registerDefaults(item, scope, parentScope) {
  const itemDefaults = merge(/* @__PURE__ */ Object.create(null), [
    parentScope ? defaults.get(parentScope) : {},
    defaults.get(scope),
    item.defaults
  ]);
  defaults.set(scope, itemDefaults);
  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }
  if (item.descriptors) {
    defaults.describe(scope, item.descriptors);
  }
}
function routeDefaults(scope, routes) {
  Object.keys(routes).forEach((property) => {
    const propertyParts = property.split(".");
    const sourceName = propertyParts.pop();
    const sourceScope = [
      scope
    ].concat(propertyParts).join(".");
    const parts = routes[property].split(".");
    const targetName = parts.pop();
    const targetScope = parts.join(".");
    defaults.route(sourceScope, sourceName, targetScope, targetName);
  });
}
function isIChartComponent(proto) {
  return "id" in proto && "defaults" in proto;
}
var Registry = class {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, "datasets", true);
    this.elements = new TypedRegistry(Element, "elements");
    this.plugins = new TypedRegistry(Object, "plugins");
    this.scales = new TypedRegistry(Scale, "scales");
    this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...args) {
    this._each("register", args);
  }
  remove(...args) {
    this._each("unregister", args);
  }
  addControllers(...args) {
    this._each("register", args, this.controllers);
  }
  addElements(...args) {
    this._each("register", args, this.elements);
  }
  addPlugins(...args) {
    this._each("register", args, this.plugins);
  }
  addScales(...args) {
    this._each("register", args, this.scales);
  }
  getController(id2) {
    return this._get(id2, this.controllers, "controller");
  }
  getElement(id2) {
    return this._get(id2, this.elements, "element");
  }
  getPlugin(id2) {
    return this._get(id2, this.plugins, "plugin");
  }
  getScale(id2) {
    return this._get(id2, this.scales, "scale");
  }
  removeControllers(...args) {
    this._each("unregister", args, this.controllers);
  }
  removeElements(...args) {
    this._each("unregister", args, this.elements);
  }
  removePlugins(...args) {
    this._each("unregister", args, this.plugins);
  }
  removeScales(...args) {
    this._each("unregister", args, this.scales);
  }
  _each(method, args, typedRegistry) {
    [
      ...args
    ].forEach((arg) => {
      const reg = typedRegistry || this._getRegistryForType(arg);
      if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
        this._exec(method, reg, arg);
      } else {
        each(arg, (item) => {
          const itemReg = typedRegistry || this._getRegistryForType(item);
          this._exec(method, itemReg, item);
        });
      }
    });
  }
  _exec(method, registry2, component) {
    const camelMethod = _capitalize(method);
    callback(component["before" + camelMethod], [], component);
    registry2[method](component);
    callback(component["after" + camelMethod], [], component);
  }
  _getRegistryForType(type) {
    for (let i = 0; i < this._typedRegistries.length; i++) {
      const reg = this._typedRegistries[i];
      if (reg.isForType(type)) {
        return reg;
      }
    }
    return this.plugins;
  }
  _get(id2, typedRegistry, type) {
    const item = typedRegistry.get(id2);
    if (item === void 0) {
      throw new Error('"' + id2 + '" is not a registered ' + type + ".");
    }
    return item;
  }
};
var registry = /* @__PURE__ */ new Registry();
var PluginService = class {
  constructor() {
    this._init = [];
  }
  notify(chart, hook, args, filter) {
    if (hook === "beforeInit") {
      this._init = this._createDescriptors(chart, true);
      this._notify(this._init, chart, "install");
    }
    const descriptors2 = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
    const result = this._notify(descriptors2, chart, hook, args);
    if (hook === "afterDestroy") {
      this._notify(descriptors2, chart, "stop");
      this._notify(this._init, chart, "uninstall");
    }
    return result;
  }
  _notify(descriptors2, chart, hook, args) {
    args = args || {};
    for (const descriptor of descriptors2) {
      const plugin = descriptor.plugin;
      const method = plugin[hook];
      const params = [
        chart,
        args,
        descriptor.options
      ];
      if (callback(method, params, plugin) === false && args.cancelable) {
        return false;
      }
    }
    return true;
  }
  invalidate() {
    if (!isNullOrUndef(this._cache)) {
      this._oldCache = this._cache;
      this._cache = void 0;
    }
  }
  _descriptors(chart) {
    if (this._cache) {
      return this._cache;
    }
    const descriptors2 = this._cache = this._createDescriptors(chart);
    this._notifyStateChanges(chart);
    return descriptors2;
  }
  _createDescriptors(chart, all) {
    const config = chart && chart.config;
    const options = valueOrDefault(config.options && config.options.plugins, {});
    const plugins = allPlugins(config);
    return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
  }
  _notifyStateChanges(chart) {
    const previousDescriptors = this._oldCache || [];
    const descriptors2 = this._cache;
    const diff = (a, b) => a.filter((x) => !b.some((y) => x.plugin.id === y.plugin.id));
    this._notify(diff(previousDescriptors, descriptors2), chart, "stop");
    this._notify(diff(descriptors2, previousDescriptors), chart, "start");
  }
};
function allPlugins(config) {
  const localIds = {};
  const plugins = [];
  const keys = Object.keys(registry.plugins.items);
  for (let i = 0; i < keys.length; i++) {
    plugins.push(registry.getPlugin(keys[i]));
  }
  const local = config.plugins || [];
  for (let i = 0; i < local.length; i++) {
    const plugin = local[i];
    if (plugins.indexOf(plugin) === -1) {
      plugins.push(plugin);
      localIds[plugin.id] = true;
    }
  }
  return {
    plugins,
    localIds
  };
}
function getOpts(options, all) {
  if (!all && options === false) {
    return null;
  }
  if (options === true) {
    return {};
  }
  return options;
}
function createDescriptors(chart, { plugins, localIds }, options, all) {
  const result = [];
  const context = chart.getContext();
  for (const plugin of plugins) {
    const id2 = plugin.id;
    const opts = getOpts(options[id2], all);
    if (opts === null) {
      continue;
    }
    result.push({
      plugin,
      options: pluginOpts(chart.config, {
        plugin,
        local: localIds[id2]
      }, opts, context)
    });
  }
  return result;
}
function pluginOpts(config, { plugin, local }, opts, context) {
  const keys = config.pluginScopeKeys(plugin);
  const scopes = config.getOptionScopes(opts, keys);
  if (local && plugin.defaults) {
    scopes.push(plugin.defaults);
  }
  return config.createResolver(scopes, context, [
    ""
  ], {
    scriptable: false,
    indexable: false,
    allKeys: true
  });
}
function getIndexAxis(type, options) {
  const datasetDefaults = defaults.datasets[type] || {};
  const datasetOptions = (options.datasets || {})[type] || {};
  return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function getAxisFromDefaultScaleID(id2, indexAxis) {
  let axis = id2;
  if (id2 === "_index_") {
    axis = indexAxis;
  } else if (id2 === "_value_") {
    axis = indexAxis === "x" ? "y" : "x";
  }
  return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? "_index_" : "_value_";
}
function idMatchesAxis(id2) {
  if (id2 === "x" || id2 === "y" || id2 === "r") {
    return id2;
  }
}
function axisFromPosition(position) {
  if (position === "top" || position === "bottom") {
    return "x";
  }
  if (position === "left" || position === "right") {
    return "y";
  }
}
function determineAxis(id2, ...scaleOptions) {
  if (idMatchesAxis(id2)) {
    return id2;
  }
  for (const opts of scaleOptions) {
    const axis = opts.axis || axisFromPosition(opts.position) || id2.length > 1 && idMatchesAxis(id2[0].toLowerCase());
    if (axis) {
      return axis;
    }
  }
  throw new Error(`Cannot determine type of '${id2}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id2, axis, dataset) {
  if (dataset[axis + "AxisID"] === id2) {
    return {
      axis
    };
  }
}
function retrieveAxisFromDatasets(id2, config) {
  if (config.data && config.data.datasets) {
    const boundDs = config.data.datasets.filter((d) => d.xAxisID === id2 || d.yAxisID === id2);
    if (boundDs.length) {
      return getAxisFromDataset(id2, "x", boundDs[0]) || getAxisFromDataset(id2, "y", boundDs[0]);
    }
  }
  return {};
}
function mergeScaleConfig(config, options) {
  const chartDefaults = overrides[config.type] || {
    scales: {}
  };
  const configScales = options.scales || {};
  const chartIndexAxis = getIndexAxis(config.type, options);
  const scales = /* @__PURE__ */ Object.create(null);
  Object.keys(configScales).forEach((id2) => {
    const scaleConf = configScales[id2];
    if (!isObject(scaleConf)) {
      return console.error(`Invalid scale configuration for scale: ${id2}`);
    }
    if (scaleConf._proxy) {
      return console.warn(`Ignoring resolver passed as options for scale: ${id2}`);
    }
    const axis = determineAxis(id2, scaleConf, retrieveAxisFromDatasets(id2, config), defaults.scales[scaleConf.type]);
    const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    const defaultScaleOptions = chartDefaults.scales || {};
    scales[id2] = mergeIf(/* @__PURE__ */ Object.create(null), [
      {
        axis
      },
      scaleConf,
      defaultScaleOptions[axis],
      defaultScaleOptions[defaultId]
    ]);
  });
  config.data.datasets.forEach((dataset) => {
    const type = dataset.type || config.type;
    const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
    const datasetDefaults = overrides[type] || {};
    const defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach((defaultID) => {
      const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      const id2 = dataset[axis + "AxisID"] || axis;
      scales[id2] = scales[id2] || /* @__PURE__ */ Object.create(null);
      mergeIf(scales[id2], [
        {
          axis
        },
        configScales[id2],
        defaultScaleOptions[defaultID]
      ]);
    });
  });
  Object.keys(scales).forEach((key) => {
    const scale = scales[key];
    mergeIf(scale, [
      defaults.scales[scale.type],
      defaults.scale
    ]);
  });
  return scales;
}
function initOptions(config) {
  const options = config.options || (config.options = {});
  options.plugins = valueOrDefault(options.plugins, {});
  options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
  data = data || {};
  data.datasets = data.datasets || [];
  data.labels = data.labels || [];
  return data;
}
function initConfig(config) {
  config = config || {};
  config.data = initData(config.data);
  initOptions(config);
  return config;
}
var keyCache = /* @__PURE__ */ new Map();
var keysCached = /* @__PURE__ */ new Set();
function cachedKeys(cacheKey, generate) {
  let keys = keyCache.get(cacheKey);
  if (!keys) {
    keys = generate();
    keyCache.set(cacheKey, keys);
    keysCached.add(keys);
  }
  return keys;
}
var addIfFound = (set2, obj, key) => {
  const opts = resolveObjectKey(obj, key);
  if (opts !== void 0) {
    set2.add(opts);
  }
};
var Config = class {
  constructor(config) {
    this._config = initConfig(config);
    this._scopeCache = /* @__PURE__ */ new Map();
    this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(type) {
    this._config.type = type;
  }
  get data() {
    return this._config.data;
  }
  set data(data) {
    this._config.data = initData(data);
  }
  get options() {
    return this._config.options;
  }
  set options(options) {
    this._config.options = options;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const config = this._config;
    this.clearCache();
    initOptions(config);
  }
  clearCache() {
    this._scopeCache.clear();
    this._resolverCache.clear();
  }
  datasetScopeKeys(datasetType) {
    return cachedKeys(datasetType, () => [
      [
        `datasets.${datasetType}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(datasetType, transition) {
    return cachedKeys(`${datasetType}.transition.${transition}`, () => [
      [
        `datasets.${datasetType}.transitions.${transition}`,
        `transitions.${transition}`
      ],
      [
        `datasets.${datasetType}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(datasetType, elementType) {
    return cachedKeys(`${datasetType}-${elementType}`, () => [
      [
        `datasets.${datasetType}.elements.${elementType}`,
        `datasets.${datasetType}`,
        `elements.${elementType}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(plugin) {
    const id2 = plugin.id;
    const type = this.type;
    return cachedKeys(`${type}-plugin-${id2}`, () => [
      [
        `plugins.${id2}`,
        ...plugin.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(mainScope, resetCache) {
    const _scopeCache = this._scopeCache;
    let cache = _scopeCache.get(mainScope);
    if (!cache || resetCache) {
      cache = /* @__PURE__ */ new Map();
      _scopeCache.set(mainScope, cache);
    }
    return cache;
  }
  getOptionScopes(mainScope, keyLists, resetCache) {
    const { options, type } = this;
    const cache = this._cachedScopes(mainScope, resetCache);
    const cached = cache.get(keyLists);
    if (cached) {
      return cached;
    }
    const scopes = /* @__PURE__ */ new Set();
    keyLists.forEach((keys) => {
      if (mainScope) {
        scopes.add(mainScope);
        keys.forEach((key) => addIfFound(scopes, mainScope, key));
      }
      keys.forEach((key) => addIfFound(scopes, options, key));
      keys.forEach((key) => addIfFound(scopes, overrides[type] || {}, key));
      keys.forEach((key) => addIfFound(scopes, defaults, key));
      keys.forEach((key) => addIfFound(scopes, descriptors, key));
    });
    const array = Array.from(scopes);
    if (array.length === 0) {
      array.push(/* @__PURE__ */ Object.create(null));
    }
    if (keysCached.has(keyLists)) {
      cache.set(keyLists, array);
    }
    return array;
  }
  chartOptionScopes() {
    const { options, type } = this;
    return [
      options,
      overrides[type] || {},
      defaults.datasets[type] || {},
      {
        type
      },
      defaults,
      descriptors
    ];
  }
  resolveNamedOptions(scopes, names2, context, prefixes = [
    ""
  ]) {
    const result = {
      $shared: true
    };
    const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
    let options = resolver;
    if (needContext(resolver, names2)) {
      result.$shared = false;
      context = isFunction(context) ? context() : context;
      const subResolver = this.createResolver(scopes, context, subPrefixes);
      options = _attachContext(resolver, context, subResolver);
    }
    for (const prop of names2) {
      result[prop] = options[prop];
    }
    return result;
  }
  createResolver(scopes, context, prefixes = [
    ""
  ], descriptorDefaults) {
    const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
    return isObject(context) ? _attachContext(resolver, context, void 0, descriptorDefaults) : resolver;
  }
};
function getResolver(resolverCache, scopes, prefixes) {
  let cache = resolverCache.get(scopes);
  if (!cache) {
    cache = /* @__PURE__ */ new Map();
    resolverCache.set(scopes, cache);
  }
  const cacheKey = prefixes.join();
  let cached = cache.get(cacheKey);
  if (!cached) {
    const resolver = _createResolver(scopes, prefixes);
    cached = {
      resolver,
      subPrefixes: prefixes.filter((p) => !p.toLowerCase().includes("hover"))
    };
    cache.set(cacheKey, cached);
  }
  return cached;
}
var hasFunction = (value) => isObject(value) && Object.getOwnPropertyNames(value).reduce((acc, key) => acc || isFunction(value[key]), false);
function needContext(proxy, names2) {
  const { isScriptable, isIndexable } = _descriptors(proxy);
  for (const prop of names2) {
    const scriptable = isScriptable(prop);
    const indexable = isIndexable(prop);
    const value = (indexable || scriptable) && proxy[prop];
    if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray(value)) {
      return true;
    }
  }
  return false;
}
var version = "4.4.0";
var KNOWN_POSITIONS = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function positionIsHorizontal(position, axis) {
  return position === "top" || position === "bottom" || KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function compare2Level(l1, l2) {
  return function(a, b) {
    return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
  };
}
function onAnimationsComplete(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  chart.notifyPlugins("afterRender");
  callback(animationOptions && animationOptions.onComplete, [
    context
  ], chart);
}
function onAnimationProgress(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  callback(animationOptions && animationOptions.onProgress, [
    context
  ], chart);
}
function getCanvas(item) {
  if (_isDomSupported() && typeof item === "string") {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }
  if (item && item.canvas) {
    item = item.canvas;
  }
  return item;
}
var instances = {};
var getChart = (key) => {
  const canvas = getCanvas(key);
  return Object.values(instances).filter((c) => c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
  const keys = Object.keys(obj);
  for (const key of keys) {
    const intKey = +key;
    if (intKey >= start) {
      const value = obj[key];
      delete obj[key];
      if (move > 0 || intKey > start) {
        obj[intKey + move] = value;
      }
    }
  }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e.type === "mouseout") {
    return null;
  }
  if (isClick) {
    return lastEvent;
  }
  return e;
}
function getSizeForArea(scale, chartArea, field) {
  return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
  const { xScale, yScale } = meta;
  if (xScale && yScale) {
    return {
      left: getSizeForArea(xScale, chartArea, "left"),
      right: getSizeForArea(xScale, chartArea, "right"),
      top: getSizeForArea(yScale, chartArea, "top"),
      bottom: getSizeForArea(yScale, chartArea, "bottom")
    };
  }
  return chartArea;
}
var Chart = class {
  static defaults = defaults;
  static instances = instances;
  static overrides = overrides;
  static registry = registry;
  static version = version;
  static getChart = getChart;
  static register(...items) {
    registry.add(...items);
    invalidatePlugins();
  }
  static unregister(...items) {
    registry.remove(...items);
    invalidatePlugins();
  }
  constructor(item, userConfig) {
    const config = this.config = new Config(userConfig);
    const initialCanvas = getCanvas(item);
    const existingChart = getChart(initialCanvas);
    if (existingChart) {
      throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "' must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
    }
    const options = config.createResolver(config.chartOptionScopes(), this.getContext());
    this.platform = new (config.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config);
    const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
    const canvas = context && context.canvas;
    const height = canvas && canvas.height;
    const width = canvas && canvas.width;
    this.id = uid();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height;
    this._options = options;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = void 0;
    this.boxes = [];
    this.currentDevicePixelRatio = void 0;
    this.chartArea = void 0;
    this._active = [];
    this._lastEvent = void 0;
    this._listeners = {};
    this._responsiveListeners = void 0;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = void 0;
    this.$context = void 0;
    this._doResize = debounce((mode) => this.update(mode), options.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;
    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, "complete", onAnimationsComplete);
    animator.listen(this, "progress", onAnimationProgress);
    this._initialize();
    if (this.attached) {
      this.update();
    }
  }
  get aspectRatio() {
    const { options: { aspectRatio, maintainAspectRatio }, width, height, _aspectRatio } = this;
    if (!isNullOrUndef(aspectRatio)) {
      return aspectRatio;
    }
    if (maintainAspectRatio && _aspectRatio) {
      return _aspectRatio;
    }
    return height ? width / height : null;
  }
  get data() {
    return this.config.data;
  }
  set data(data) {
    this.config.data = data;
  }
  get options() {
    return this._options;
  }
  set options(options) {
    this.config.options = options;
  }
  get registry() {
    return registry;
  }
  _initialize() {
    this.notifyPlugins("beforeInit");
    if (this.options.responsive) {
      this.resize();
    } else {
      retinaScale(this, this.options.devicePixelRatio);
    }
    this.bindEvents();
    this.notifyPlugins("afterInit");
    return this;
  }
  clear() {
    clearCanvas(this.canvas, this.ctx);
    return this;
  }
  stop() {
    animator.stop(this);
    return this;
  }
  resize(width, height) {
    if (!animator.running(this)) {
      this._resize(width, height);
    } else {
      this._resizeBeforeDraw = {
        width,
        height
      };
    }
  }
  _resize(width, height) {
    const options = this.options;
    const canvas = this.canvas;
    const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
    const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
    const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
    const mode = this.width ? "resize" : "attach";
    this.width = newSize.width;
    this.height = newSize.height;
    this._aspectRatio = this.aspectRatio;
    if (!retinaScale(this, newRatio, true)) {
      return;
    }
    this.notifyPlugins("resize", {
      size: newSize
    });
    callback(options.onResize, [
      this,
      newSize
    ], this);
    if (this.attached) {
      if (this._doResize(mode)) {
        this.render();
      }
    }
  }
  ensureScalesHaveIDs() {
    const options = this.options;
    const scalesOptions = options.scales || {};
    each(scalesOptions, (axisOptions, axisID) => {
      axisOptions.id = axisID;
    });
  }
  buildOrUpdateScales() {
    const options = this.options;
    const scaleOpts = options.scales;
    const scales = this.scales;
    const updated = Object.keys(scales).reduce((obj, id2) => {
      obj[id2] = false;
      return obj;
    }, {});
    let items = [];
    if (scaleOpts) {
      items = items.concat(Object.keys(scaleOpts).map((id2) => {
        const scaleOptions = scaleOpts[id2];
        const axis = determineAxis(id2, scaleOptions);
        const isRadial = axis === "r";
        const isHorizontal = axis === "x";
        return {
          options: scaleOptions,
          dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
          dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
        };
      }));
    }
    each(items, (item) => {
      const scaleOptions = item.options;
      const id2 = scaleOptions.id;
      const axis = determineAxis(id2, scaleOptions);
      const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
      if (scaleOptions.position === void 0 || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
        scaleOptions.position = item.dposition;
      }
      updated[id2] = true;
      let scale = null;
      if (id2 in scales && scales[id2].type === scaleType) {
        scale = scales[id2];
      } else {
        const scaleClass = registry.getScale(scaleType);
        scale = new scaleClass({
          id: id2,
          type: scaleType,
          ctx: this.ctx,
          chart: this
        });
        scales[scale.id] = scale;
      }
      scale.init(scaleOptions, options);
    });
    each(updated, (hasUpdated, id2) => {
      if (!hasUpdated) {
        delete scales[id2];
      }
    });
    each(scales, (scale) => {
      layouts.configure(this, scale, scale.options);
      layouts.addBox(this, scale);
    });
  }
  _updateMetasets() {
    const metasets = this._metasets;
    const numData = this.data.datasets.length;
    const numMeta = metasets.length;
    metasets.sort((a, b) => a.index - b.index);
    if (numMeta > numData) {
      for (let i = numData; i < numMeta; ++i) {
        this._destroyDatasetMeta(i);
      }
      metasets.splice(numData, numMeta - numData);
    }
    this._sortedMetasets = metasets.slice(0).sort(compare2Level("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: metasets, data: { datasets } } = this;
    if (metasets.length > datasets.length) {
      delete this._stacks;
    }
    metasets.forEach((meta, index2) => {
      if (datasets.filter((x) => x === meta._dataset).length === 0) {
        this._destroyDatasetMeta(index2);
      }
    });
  }
  buildOrUpdateControllers() {
    const newControllers = [];
    const datasets = this.data.datasets;
    let i, ilen;
    this._removeUnreferencedMetasets();
    for (i = 0, ilen = datasets.length; i < ilen; i++) {
      const dataset = datasets[i];
      let meta = this.getDatasetMeta(i);
      const type = dataset.type || this.config.type;
      if (meta.type && meta.type !== type) {
        this._destroyDatasetMeta(i);
        meta = this.getDatasetMeta(i);
      }
      meta.type = type;
      meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
      meta.order = dataset.order || 0;
      meta.index = i;
      meta.label = "" + dataset.label;
      meta.visible = this.isDatasetVisible(i);
      if (meta.controller) {
        meta.controller.updateIndex(i);
        meta.controller.linkScales();
      } else {
        const ControllerClass = registry.getController(type);
        const { datasetElementType, dataElementType } = defaults.datasets[type];
        Object.assign(ControllerClass, {
          dataElementType: registry.getElement(dataElementType),
          datasetElementType: datasetElementType && registry.getElement(datasetElementType)
        });
        meta.controller = new ControllerClass(this, i);
        newControllers.push(meta.controller);
      }
    }
    this._updateMetasets();
    return newControllers;
  }
  _resetElements() {
    each(this.data.datasets, (dataset, datasetIndex) => {
      this.getDatasetMeta(datasetIndex).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements();
    this.notifyPlugins("reset");
  }
  update(mode) {
    const config = this.config;
    config.update();
    const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
    const animsDisabled = this._animationsDisabled = !options.animation;
    this._updateScales();
    this._checkEventBindings();
    this._updateHiddenIndices();
    this._plugins.invalidate();
    if (this.notifyPlugins("beforeUpdate", {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    const newControllers = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let minPadding = 0;
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; i++) {
      const { controller } = this.getDatasetMeta(i);
      const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
      controller.buildOrUpdateElements(reset);
      minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
    }
    minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
    this._updateLayout(minPadding);
    if (!animsDisabled) {
      each(newControllers, (controller) => {
        controller.reset();
      });
    }
    this._updateDatasets(mode);
    this.notifyPlugins("afterUpdate", {
      mode
    });
    this._layers.sort(compare2Level("z", "_idx"));
    const { _active, _lastEvent } = this;
    if (_lastEvent) {
      this._eventHandler(_lastEvent, true);
    } else if (_active.length) {
      this._updateHoverStyles(_active, _active, true);
    }
    this.render();
  }
  _updateScales() {
    each(this.scales, (scale) => {
      layouts.removeBox(this, scale);
    });
    this.ensureScalesHaveIDs();
    this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const options = this.options;
    const existingEvents = new Set(Object.keys(this._listeners));
    const newEvents = new Set(options.events);
    if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
      this.unbindEvents();
      this.bindEvents();
    }
  }
  _updateHiddenIndices() {
    const { _hiddenIndices } = this;
    const changes = this._getUniformDataChanges() || [];
    for (const { method, start, count } of changes) {
      const move = method === "_removeElements" ? -count : count;
      moveNumericKeys(_hiddenIndices, start, move);
    }
  }
  _getUniformDataChanges() {
    const _dataChanges = this._dataChanges;
    if (!_dataChanges || !_dataChanges.length) {
      return;
    }
    this._dataChanges = [];
    const datasetCount = this.data.datasets.length;
    const makeSet = (idx) => new Set(_dataChanges.filter((c) => c[0] === idx).map((c, i) => i + "," + c.splice(1).join(",")));
    const changeSet = makeSet(0);
    for (let i = 1; i < datasetCount; i++) {
      if (!setsEqual(changeSet, makeSet(i))) {
        return;
      }
    }
    return Array.from(changeSet).map((c) => c.split(",")).map((a) => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(minPadding) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: true
    }) === false) {
      return;
    }
    layouts.update(this, this.width, this.height, minPadding);
    const area = this.chartArea;
    const noArea = area.width <= 0 || area.height <= 0;
    this._layers = [];
    each(this.boxes, (box) => {
      if (noArea && box.position === "chartArea") {
        return;
      }
      if (box.configure) {
        box.configure();
      }
      this._layers.push(...box._layers());
    }, this);
    this._layers.forEach((item, index2) => {
      item._idx = index2;
    });
    this.notifyPlugins("afterLayout");
  }
  _updateDatasets(mode) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this.getDatasetMeta(i).controller.configure();
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._updateDataset(i, isFunction(mode) ? mode({
        datasetIndex: i
      }) : mode);
    }
    this.notifyPlugins("afterDatasetsUpdate", {
      mode
    });
  }
  _updateDataset(index2, mode) {
    const meta = this.getDatasetMeta(index2);
    const args = {
      meta,
      index: index2,
      mode,
      cancelable: true
    };
    if (this.notifyPlugins("beforeDatasetUpdate", args) === false) {
      return;
    }
    meta.controller._update(mode);
    args.cancelable = false;
    this.notifyPlugins("afterDatasetUpdate", args);
  }
  render() {
    if (this.notifyPlugins("beforeRender", {
      cancelable: true
    }) === false) {
      return;
    }
    if (animator.has(this)) {
      if (this.attached && !animator.running(this)) {
        animator.start(this);
      }
    } else {
      this.draw();
      onAnimationsComplete({
        chart: this
      });
    }
  }
  draw() {
    let i;
    if (this._resizeBeforeDraw) {
      const { width, height } = this._resizeBeforeDraw;
      this._resize(width, height);
      this._resizeBeforeDraw = null;
    }
    this.clear();
    if (this.width <= 0 || this.height <= 0) {
      return;
    }
    if (this.notifyPlugins("beforeDraw", {
      cancelable: true
    }) === false) {
      return;
    }
    const layers = this._layers;
    for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
      layers[i].draw(this.chartArea);
    }
    this._drawDatasets();
    for (; i < layers.length; ++i) {
      layers[i].draw(this.chartArea);
    }
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(filterVisible) {
    const metasets = this._sortedMetasets;
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metasets.length; i < ilen; ++i) {
      const meta = metasets[i];
      if (!filterVisible || meta.visible) {
        result.push(meta);
      }
    }
    return result;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(true);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: true
    }) === false) {
      return;
    }
    const metasets = this.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      this._drawDataset(metasets[i]);
    }
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(meta) {
    const ctx = this.ctx;
    const clip = meta._clip;
    const useClip = !clip.disabled;
    const area = getDatasetArea(meta, this.chartArea);
    const args = {
      meta,
      index: meta.index,
      cancelable: true
    };
    if (this.notifyPlugins("beforeDatasetDraw", args) === false) {
      return;
    }
    if (useClip) {
      clipArea(ctx, {
        left: clip.left === false ? 0 : area.left - clip.left,
        right: clip.right === false ? this.width : area.right + clip.right,
        top: clip.top === false ? 0 : area.top - clip.top,
        bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
      });
    }
    meta.controller.draw();
    if (useClip) {
      unclipArea(ctx);
    }
    args.cancelable = false;
    this.notifyPlugins("afterDatasetDraw", args);
  }
  isPointInArea(point) {
    return _isPointInArea(point, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, mode, options, useFinalPosition) {
    const method = Interaction.modes[mode];
    if (typeof method === "function") {
      return method(this, e, options, useFinalPosition);
    }
    return [];
  }
  getDatasetMeta(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    const metasets = this._metasets;
    let meta = metasets.filter((x) => x && x._dataset === dataset).pop();
    if (!meta) {
      meta = {
        type: null,
        data: [],
        dataset: null,
        controller: null,
        hidden: null,
        xAxisID: null,
        yAxisID: null,
        order: dataset && dataset.order || 0,
        index: datasetIndex,
        _dataset: dataset,
        _parsed: [],
        _sorted: false
      };
      metasets.push(meta);
    }
    return meta;
  }
  getContext() {
    return this.$context || (this.$context = createContext20(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    if (!dataset) {
      return false;
    }
    const meta = this.getDatasetMeta(datasetIndex);
    return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
  }
  setDatasetVisibility(datasetIndex, visible) {
    const meta = this.getDatasetMeta(datasetIndex);
    meta.hidden = !visible;
  }
  toggleDataVisibility(index2) {
    this._hiddenIndices[index2] = !this._hiddenIndices[index2];
  }
  getDataVisibility(index2) {
    return !this._hiddenIndices[index2];
  }
  _updateVisibility(datasetIndex, dataIndex, visible) {
    const mode = visible ? "show" : "hide";
    const meta = this.getDatasetMeta(datasetIndex);
    const anims = meta.controller._resolveAnimations(void 0, mode);
    if (defined(dataIndex)) {
      meta.data[dataIndex].hidden = !visible;
      this.update();
    } else {
      this.setDatasetVisibility(datasetIndex, visible);
      anims.update(meta, {
        visible
      });
      this.update((ctx) => ctx.datasetIndex === datasetIndex ? mode : void 0);
    }
  }
  hide(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, false);
  }
  show(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, true);
  }
  _destroyDatasetMeta(datasetIndex) {
    const meta = this._metasets[datasetIndex];
    if (meta && meta.controller) {
      meta.controller._destroy();
    }
    delete this._metasets[datasetIndex];
  }
  _stop() {
    let i, ilen;
    this.stop();
    animator.remove(this);
    for (i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._destroyDatasetMeta(i);
    }
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas, ctx } = this;
    this._stop();
    this.config.clearCache();
    if (canvas) {
      this.unbindEvents();
      clearCanvas(canvas, ctx);
      this.platform.releaseContext(ctx);
      this.canvas = null;
      this.ctx = null;
    }
    delete instances[this.id];
    this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...args) {
    return this.canvas.toDataURL(...args);
  }
  bindEvents() {
    this.bindUserEvents();
    if (this.options.responsive) {
      this.bindResponsiveEvents();
    } else {
      this.attached = true;
    }
  }
  bindUserEvents() {
    const listeners = this._listeners;
    const platform = this.platform;
    const _add = (type, listener2) => {
      platform.addEventListener(this, type, listener2);
      listeners[type] = listener2;
    };
    const listener = (e, x, y) => {
      e.offsetX = x;
      e.offsetY = y;
      this._eventHandler(e);
    };
    each(this.options.events, (type) => _add(type, listener));
  }
  bindResponsiveEvents() {
    if (!this._responsiveListeners) {
      this._responsiveListeners = {};
    }
    const listeners = this._responsiveListeners;
    const platform = this.platform;
    const _add = (type, listener2) => {
      platform.addEventListener(this, type, listener2);
      listeners[type] = listener2;
    };
    const _remove = (type, listener2) => {
      if (listeners[type]) {
        platform.removeEventListener(this, type, listener2);
        delete listeners[type];
      }
    };
    const listener = (width, height) => {
      if (this.canvas) {
        this.resize(width, height);
      }
    };
    let detached;
    const attached = () => {
      _remove("attach", attached);
      this.attached = true;
      this.resize();
      _add("resize", listener);
      _add("detach", detached);
    };
    detached = () => {
      this.attached = false;
      _remove("resize", listener);
      this._stop();
      this._resize(0, 0);
      _add("attach", attached);
    };
    if (platform.isAttached(this.canvas)) {
      attached();
    } else {
      detached();
    }
  }
  unbindEvents() {
    each(this._listeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._listeners = {};
    each(this._responsiveListeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._responsiveListeners = void 0;
  }
  updateHoverStyle(items, mode, enabled) {
    const prefix = enabled ? "set" : "remove";
    let meta, item, i, ilen;
    if (mode === "dataset") {
      meta = this.getDatasetMeta(items[0].datasetIndex);
      meta.controller["_" + prefix + "DatasetHoverStyle"]();
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      item = items[i];
      const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
      if (controller) {
        controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
      }
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements) {
    const lastActive = this._active || [];
    const active = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("No dataset found at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(active, lastActive);
    if (changed) {
      this._active = active;
      this._lastEvent = null;
      this._updateHoverStyles(active, lastActive);
    }
  }
  notifyPlugins(hook, args, filter) {
    return this._plugins.notify(this, hook, args, filter);
  }
  isPluginEnabled(pluginId) {
    return this._plugins._cache.filter((p) => p.plugin.id === pluginId).length === 1;
  }
  _updateHoverStyles(active, lastActive, replay) {
    const hoverOptions = this.options.hover;
    const diff = (a, b) => a.filter((x) => !b.some((y) => x.datasetIndex === y.datasetIndex && x.index === y.index));
    const deactivated = diff(lastActive, active);
    const activated = replay ? active : diff(active, lastActive);
    if (deactivated.length) {
      this.updateHoverStyle(deactivated, hoverOptions.mode, false);
    }
    if (activated.length && hoverOptions.mode) {
      this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
  }
  _eventHandler(e, replay) {
    const args = {
      event: e,
      replay,
      cancelable: true,
      inChartArea: this.isPointInArea(e)
    };
    const eventFilter = (plugin) => (plugin.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) {
      return;
    }
    const changed = this._handleEvent(e, replay, args.inChartArea);
    args.cancelable = false;
    this.notifyPlugins("afterEvent", args, eventFilter);
    if (changed || args.changed) {
      this.render();
    }
    return this;
  }
  _handleEvent(e, replay, inChartArea) {
    const { _active: lastActive = [], options } = this;
    const useFinalPosition = replay;
    const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
    const isClick = _isClickEvent(e);
    const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
    if (inChartArea) {
      this._lastEvent = null;
      callback(options.onHover, [
        e,
        active,
        this
      ], this);
      if (isClick) {
        callback(options.onClick, [
          e,
          active,
          this
        ], this);
      }
    }
    const changed = !_elementsEqual(active, lastActive);
    if (changed || replay) {
      this._active = active;
      this._updateHoverStyles(active, lastActive, replay);
    }
    this._lastEvent = lastEvent;
    return changed;
  }
  _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
    if (e.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const hoverOptions = this.options.hover;
    return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
  }
};
function invalidatePlugins() {
  return each(Chart.instances, (chart) => chart._plugins.invalidate());
}
function setStyle(ctx, options, style = options) {
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
  ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
  if (options.stepped) {
    return _steppedLineTo;
  }
  if (options.tension || options.cubicInterpolationMode === "monotone") {
    return _bezierCurveTo;
  }
  return lineTo;
}
function pathVars(points, segment, params = {}) {
  const count = points.length;
  const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
  const { start: segmentStart, end: segmentEnd } = segment;
  const start = Math.max(paramsStart, segmentStart);
  const end = Math.min(paramsEnd, segmentEnd);
  const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count,
    start,
    loop: segment.loop,
    ilen: end < start && !outside ? count + end - start : end - start
  };
}
function pathSegment(ctx, line, segment, params) {
  const { points, options } = line;
  const { count, start, loop, ilen } = pathVars(points, segment, params);
  const lineMethod = getLineMethod(options);
  let { move = true, reverse } = params || {};
  let i, point, prev;
  for (i = 0; i <= ilen; ++i) {
    point = points[(start + (reverse ? ilen - i : i)) % count];
    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    prev = point;
  }
  if (loop) {
    point = points[(start + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev, point, reverse, options.stepped);
  }
  return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
  const points = line.points;
  const { count, start, ilen } = pathVars(points, segment, params);
  const { move = true, reverse } = params || {};
  let avgX = 0;
  let countX = 0;
  let i, point, prevX, minY, maxY, lastY;
  const pointIndex = (index2) => (start + (reverse ? ilen - index2 : index2)) % count;
  const drawX = () => {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };
  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }
  for (i = 0; i <= ilen; ++i) {
    point = points[pointIndex(i)];
    if (point.skip) {
      continue;
    }
    const x = point.x;
    const y = point.y;
    const truncX = x | 0;
    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      avgX = (countX * avgX + x) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x, y);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
    }
    lastY = y;
  }
  drawX();
}
function _getSegmentMethod(line) {
  const opts = line.options;
  const borderDash = opts.borderDash && opts.borderDash.length;
  const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
  if (options.stepped) {
    return _steppedInterpolation;
  }
  if (options.tension || options.cubicInterpolationMode === "monotone") {
    return _bezierInterpolation;
  }
  return _pointInLine;
}
function strokePathWithCache(ctx, line, start, count) {
  let path = line._path;
  if (!path) {
    path = line._path = new Path2D();
    if (line.path(path, start, count)) {
      path.closePath();
    }
  }
  setStyle(ctx, line.options);
  ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
  const { segments, options } = line;
  const segmentMethod = _getSegmentMethod(line);
  for (const segment of segments) {
    setStyle(ctx, options, segment.style);
    ctx.beginPath();
    if (segmentMethod(ctx, line, segment, {
      start,
      end: start + count - 1
    })) {
      ctx.closePath();
    }
    ctx.stroke();
  }
}
var usePath2D = typeof Path2D === "function";
function draw(ctx, line, start, count) {
  if (usePath2D && !line.options.segment) {
    strokePathWithCache(ctx, line, start, count);
  } else {
    strokePathDirect(ctx, line, start, count);
  }
}
var LineElement = class extends Element {
  static id = "line";
  static defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
  };
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  static descriptors = {
    _scriptable: true,
    _indexable: (name) => name !== "borderDash" && name !== "fill"
  };
  constructor(cfg) {
    super();
    this.animated = true;
    this.options = void 0;
    this._chart = void 0;
    this._loop = void 0;
    this._fullLoop = void 0;
    this._path = void 0;
    this._points = void 0;
    this._segments = void 0;
    this._decimated = false;
    this._pointsUpdated = false;
    this._datasetIndex = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  updateControlPoints(chartArea, indexAxis) {
    const options = this.options;
    if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
      const loop = options.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
      this._pointsUpdated = true;
    }
  }
  set points(points) {
    this._points = points;
    delete this._segments;
    delete this._path;
    this._pointsUpdated = false;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const segments = this.segments;
    const points = this.points;
    return segments.length && points[segments[0].start];
  }
  last() {
    const segments = this.segments;
    const points = this.points;
    const count = segments.length;
    return count && points[segments[count - 1].end];
  }
  interpolate(point, property) {
    const options = this.options;
    const value = point[property];
    const points = this.points;
    const segments = _boundSegments(this, {
      property,
      start: value,
      end: value
    });
    if (!segments.length) {
      return;
    }
    const result = [];
    const _interpolate = _getInterpolationMethod(options);
    let i, ilen;
    for (i = 0, ilen = segments.length; i < ilen; ++i) {
      const { start, end } = segments[i];
      const p1 = points[start];
      const p2 = points[end];
      if (p1 === p2) {
        result.push(p1);
        continue;
      }
      const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
      const interpolated = _interpolate(p1, p2, t, options.stepped);
      interpolated[property] = point[property];
      result.push(interpolated);
    }
    return result.length === 1 ? result[0] : result;
  }
  pathSegment(ctx, segment, params) {
    const segmentMethod = _getSegmentMethod(this);
    return segmentMethod(ctx, this, segment, params);
  }
  path(ctx, start, count) {
    const segments = this.segments;
    const segmentMethod = _getSegmentMethod(this);
    let loop = this._loop;
    start = start || 0;
    count = count || this.points.length - start;
    for (const segment of segments) {
      loop &= segmentMethod(ctx, this, segment, {
        start,
        end: start + count - 1
      });
    }
    return !!loop;
  }
  draw(ctx, chartArea, start, count) {
    const options = this.options || {};
    const points = this.points || [];
    if (points.length && options.borderWidth) {
      ctx.save();
      draw(ctx, this, start, count);
      ctx.restore();
    }
    if (this.animated) {
      this._pointsUpdated = false;
      this._path = void 0;
    }
  }
};
function inRange$1(el, pos, axis, useFinalPosition) {
  const options = el.options;
  const { [axis]: value } = el.getProps([
    axis
  ], useFinalPosition);
  return Math.abs(pos - value) < options.radius + options.hitRadius;
}
var PointElement = class extends Element {
  static id = "point";
  parsed;
  skip;
  stop;
  /**
  * @type {any}
  */
  static defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
  };
  /**
  * @type {any}
  */
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  constructor(cfg) {
    super();
    this.options = void 0;
    this.parsed = void 0;
    this.skip = void 0;
    this.stop = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    const options = this.options;
    const { x, y } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$1(this, mouseX, "x", useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$1(this, mouseY, "y", useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const { x, y } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return {
      x,
      y
    };
  }
  size(options) {
    options = options || this.options || {};
    let radius = options.radius || 0;
    radius = Math.max(radius, radius && options.hoverRadius || 0);
    const borderWidth = radius && options.borderWidth || 0;
    return (radius + borderWidth) * 2;
  }
  draw(ctx, area) {
    const options = this.options;
    if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
      return;
    }
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.fillStyle = options.backgroundColor;
    drawPoint(ctx, options, this.x, this.y);
  }
  getRange() {
    const options = this.options || {};
    return options.radius + options.hitRadius;
  }
};
function _segments(line, target, property) {
  const segments = line.segments;
  const points = line.points;
  const tpoints = target.points;
  const parts = [];
  for (const segment of segments) {
    let { start, end } = segment;
    end = _findSegmentEnd(start, end, points);
    const bounds = _getBounds(property, points[start], points[end], segment.loop);
    if (!target.segments) {
      parts.push({
        source: segment,
        target: bounds,
        start: points[start],
        end: points[end]
      });
      continue;
    }
    const targetSegments = _boundSegments(target, bounds);
    for (const tgt of targetSegments) {
      const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
      const fillSources = _boundSegment(segment, points, subBounds);
      for (const fillSource of fillSources) {
        parts.push({
          source: fillSource,
          target: tgt,
          start: {
            [property]: _getEdge(bounds, subBounds, "start", Math.max)
          },
          end: {
            [property]: _getEdge(bounds, subBounds, "end", Math.min)
          }
        });
      }
    }
  }
  return parts;
}
function _getBounds(property, first, last, loop) {
  if (loop) {
    return;
  }
  let start = first[property];
  let end = last[property];
  if (property === "angle") {
    start = _normalizeAngle(start);
    end = _normalizeAngle(end);
  }
  return {
    property,
    start,
    end
  };
}
function _pointsFromSegments(boundary, line) {
  const { x = null, y = null } = boundary || {};
  const linePoints = line.points;
  const points = [];
  line.segments.forEach(({ start, end }) => {
    end = _findSegmentEnd(start, end, linePoints);
    const first = linePoints[start];
    const last = linePoints[end];
    if (y !== null) {
      points.push({
        x: first.x,
        y
      });
      points.push({
        x: last.x,
        y
      });
    } else if (x !== null) {
      points.push({
        x,
        y: first.y
      });
      points.push({
        x,
        y: last.y
      });
    }
  });
  return points;
}
function _findSegmentEnd(start, end, points) {
  for (; end > start; end--) {
    const point = points[end];
    if (!isNaN(point.x) && !isNaN(point.y)) {
      break;
    }
  }
  return end;
}
function _getEdge(a, b, prop, fn) {
  if (a && b) {
    return fn(a[prop], b[prop]);
  }
  return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
  let points = [];
  let _loop = false;
  if (isArray(boundary)) {
    _loop = true;
    points = boundary;
  } else {
    points = _pointsFromSegments(boundary, line);
  }
  return points.length ? new LineElement({
    points,
    options: {
      tension: 0
    },
    _loop,
    _fullLoop: _loop
  }) : null;
}
function _shouldApplyFill(source) {
  return source && source.fill !== false;
}
function _resolveTarget(sources, index2, propagate) {
  const source = sources[index2];
  let fill2 = source.fill;
  const visited = [
    index2
  ];
  let target;
  if (!propagate) {
    return fill2;
  }
  while (fill2 !== false && visited.indexOf(fill2) === -1) {
    if (!isNumberFinite(fill2)) {
      return fill2;
    }
    target = sources[fill2];
    if (!target) {
      return false;
    }
    if (target.visible) {
      return fill2;
    }
    visited.push(fill2);
    fill2 = target.fill;
  }
  return false;
}
function _decodeFill(line, index2, count) {
  const fill2 = parseFillOption(line);
  if (isObject(fill2)) {
    return isNaN(fill2.value) ? false : fill2;
  }
  let target = parseFloat(fill2);
  if (isNumberFinite(target) && Math.floor(target) === target) {
    return decodeTargetIndex(fill2[0], index2, target, count);
  }
  return [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(fill2) >= 0 && fill2;
}
function decodeTargetIndex(firstCh, index2, target, count) {
  if (firstCh === "-" || firstCh === "+") {
    target = index2 + target;
  }
  if (target === index2 || target < 0 || target >= count) {
    return false;
  }
  return target;
}
function _getTargetPixel(fill2, scale) {
  let pixel = null;
  if (fill2 === "start") {
    pixel = scale.bottom;
  } else if (fill2 === "end") {
    pixel = scale.top;
  } else if (isObject(fill2)) {
    pixel = scale.getPixelForValue(fill2.value);
  } else if (scale.getBasePixel) {
    pixel = scale.getBasePixel();
  }
  return pixel;
}
function _getTargetValue(fill2, scale, startValue) {
  let value;
  if (fill2 === "start") {
    value = startValue;
  } else if (fill2 === "end") {
    value = scale.options.reverse ? scale.min : scale.max;
  } else if (isObject(fill2)) {
    value = fill2.value;
  } else {
    value = scale.getBaseValue();
  }
  return value;
}
function parseFillOption(line) {
  const options = line.options;
  const fillOption = options.fill;
  let fill2 = valueOrDefault(fillOption && fillOption.target, fillOption);
  if (fill2 === void 0) {
    fill2 = !!options.backgroundColor;
  }
  if (fill2 === false || fill2 === null) {
    return false;
  }
  if (fill2 === true) {
    return "origin";
  }
  return fill2;
}
function _buildStackLine(source) {
  const { scale, index: index2, line } = source;
  const points = [];
  const segments = line.segments;
  const sourcePoints = line.points;
  const linesBelow = getLinesBelow(scale, index2);
  linesBelow.push(_createBoundaryLine({
    x: null,
    y: scale.bottom
  }, line));
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    for (let j = segment.start; j <= segment.end; j++) {
      addPointsBelow(points, sourcePoints[j], linesBelow);
    }
  }
  return new LineElement({
    points,
    options: {}
  });
}
function getLinesBelow(scale, index2) {
  const below = [];
  const metas = scale.getMatchingVisibleMetas("line");
  for (let i = 0; i < metas.length; i++) {
    const meta = metas[i];
    if (meta.index === index2) {
      break;
    }
    if (!meta.hidden) {
      below.unshift(meta.dataset);
    }
  }
  return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
  const postponed = [];
  for (let j = 0; j < linesBelow.length; j++) {
    const line = linesBelow[j];
    const { first, last, point } = findPoint(line, sourcePoint, "x");
    if (!point || first && last) {
      continue;
    }
    if (first) {
      postponed.unshift(point);
    } else {
      points.push(point);
      if (!last) {
        break;
      }
    }
  }
  points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
  const point = line.interpolate(sourcePoint, property);
  if (!point) {
    return {};
  }
  const pointValue = point[property];
  const segments = line.segments;
  const linePoints = line.points;
  let first = false;
  let last = false;
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    const firstValue = linePoints[segment.start][property];
    const lastValue = linePoints[segment.end][property];
    if (_isBetween(pointValue, firstValue, lastValue)) {
      first = pointValue === firstValue;
      last = pointValue === lastValue;
      break;
    }
  }
  return {
    first,
    last,
    point
  };
}
var simpleArc = class {
  constructor(opts) {
    this.x = opts.x;
    this.y = opts.y;
    this.radius = opts.radius;
  }
  pathSegment(ctx, bounds, opts) {
    const { x, y, radius } = this;
    bounds = bounds || {
      start: 0,
      end: TAU
    };
    ctx.arc(x, y, radius, bounds.end, bounds.start, true);
    return !opts.bounds;
  }
  interpolate(point) {
    const { x, y, radius } = this;
    const angle = point.angle;
    return {
      x: x + Math.cos(angle) * radius,
      y: y + Math.sin(angle) * radius,
      angle
    };
  }
};
function _getTarget(source) {
  const { chart, fill: fill2, line } = source;
  if (isNumberFinite(fill2)) {
    return getLineByIndex(chart, fill2);
  }
  if (fill2 === "stack") {
    return _buildStackLine(source);
  }
  if (fill2 === "shape") {
    return true;
  }
  const boundary = computeBoundary(source);
  if (boundary instanceof simpleArc) {
    return boundary;
  }
  return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index2) {
  const meta = chart.getDatasetMeta(index2);
  const visible = meta && chart.isDatasetVisible(index2);
  return visible ? meta.dataset : null;
}
function computeBoundary(source) {
  const scale = source.scale || {};
  if (scale.getPointPositionForValue) {
    return computeCircularBoundary(source);
  }
  return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
  const { scale = {}, fill: fill2 } = source;
  const pixel = _getTargetPixel(fill2, scale);
  if (isNumberFinite(pixel)) {
    const horizontal = scale.isHorizontal();
    return {
      x: horizontal ? pixel : null,
      y: horizontal ? null : pixel
    };
  }
  return null;
}
function computeCircularBoundary(source) {
  const { scale, fill: fill2 } = source;
  const options = scale.options;
  const length = scale.getLabels().length;
  const start = options.reverse ? scale.max : scale.min;
  const value = _getTargetValue(fill2, scale, start);
  const target = [];
  if (options.grid.circular) {
    const center = scale.getPointPositionForValue(0, start);
    return new simpleArc({
      x: center.x,
      y: center.y,
      radius: scale.getDistanceFromCenterForValue(value)
    });
  }
  for (let i = 0; i < length; ++i) {
    target.push(scale.getPointPositionForValue(i, value));
  }
  return target;
}
function _drawfill(ctx, source, area) {
  const target = _getTarget(source);
  const { line, scale, axis } = source;
  const lineOpts = line.options;
  const fillOption = lineOpts.fill;
  const color2 = lineOpts.backgroundColor;
  const { above = color2, below = color2 } = fillOption || {};
  if (target && line.points.length) {
    clipArea(ctx, area);
    doFill(ctx, {
      line,
      target,
      above,
      below,
      area,
      scale,
      axis
    });
    unclipArea(ctx);
  }
}
function doFill(ctx, cfg) {
  const { line, target, above, below, area, scale } = cfg;
  const property = line._loop ? "angle" : cfg.axis;
  ctx.save();
  if (property === "x" && below !== above) {
    clipVertical(ctx, target, area.top);
    fill(ctx, {
      line,
      target,
      color: above,
      scale,
      property
    });
    ctx.restore();
    ctx.save();
    clipVertical(ctx, target, area.bottom);
  }
  fill(ctx, {
    line,
    target,
    color: below,
    scale,
    property
  });
  ctx.restore();
}
function clipVertical(ctx, target, clipY) {
  const { segments, points } = target;
  let first = true;
  let lineLoop = false;
  ctx.beginPath();
  for (const segment of segments) {
    const { start, end } = segment;
    const firstPoint = points[start];
    const lastPoint = points[_findSegmentEnd(start, end, points)];
    if (first) {
      ctx.moveTo(firstPoint.x, firstPoint.y);
      first = false;
    } else {
      ctx.lineTo(firstPoint.x, clipY);
      ctx.lineTo(firstPoint.x, firstPoint.y);
    }
    lineLoop = !!target.pathSegment(ctx, segment, {
      move: lineLoop
    });
    if (lineLoop) {
      ctx.closePath();
    } else {
      ctx.lineTo(lastPoint.x, clipY);
    }
  }
  ctx.lineTo(target.first().x, clipY);
  ctx.closePath();
  ctx.clip();
}
function fill(ctx, cfg) {
  const { line, target, property, color: color2, scale } = cfg;
  const segments = _segments(line, target, property);
  for (const { source: src, target: tgt, start, end } of segments) {
    const { style: { backgroundColor = color2 } = {} } = src;
    const notShape = target !== true;
    ctx.save();
    ctx.fillStyle = backgroundColor;
    clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
    ctx.beginPath();
    const lineLoop = !!line.pathSegment(ctx, src);
    let loop;
    if (notShape) {
      if (lineLoop) {
        ctx.closePath();
      } else {
        interpolatedLineTo(ctx, target, end, property);
      }
      const targetLoop = !!target.pathSegment(ctx, tgt, {
        move: lineLoop,
        reverse: true
      });
      loop = lineLoop && targetLoop;
      if (!loop) {
        interpolatedLineTo(ctx, target, start, property);
      }
    }
    ctx.closePath();
    ctx.fill(loop ? "evenodd" : "nonzero");
    ctx.restore();
  }
}
function clipBounds(ctx, scale, bounds) {
  const { top, bottom } = scale.chart.chartArea;
  const { property, start, end } = bounds || {};
  if (property === "x") {
    ctx.beginPath();
    ctx.rect(start, top, end - start, bottom - top);
    ctx.clip();
  }
}
function interpolatedLineTo(ctx, target, point, property) {
  const interpolatedPoint = target.interpolate(point, property);
  if (interpolatedPoint) {
    ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
  }
}
var index = {
  id: "filler",
  afterDatasetsUpdate(chart, _args, options) {
    const count = (chart.data.datasets || []).length;
    const sources = [];
    let meta, i, line, source;
    for (i = 0; i < count; ++i) {
      meta = chart.getDatasetMeta(i);
      line = meta.dataset;
      source = null;
      if (line && line.options && line instanceof LineElement) {
        source = {
          visible: chart.isDatasetVisible(i),
          index: i,
          fill: _decodeFill(line, i, count),
          chart,
          axis: meta.controller.options.indexAxis,
          scale: meta.vScale,
          line
        };
      }
      meta.$filler = source;
      sources.push(source);
    }
    for (i = 0; i < count; ++i) {
      source = sources[i];
      if (!source || source.fill === false) {
        continue;
      }
      source.fill = _resolveTarget(sources, i, options.propagate);
    }
  },
  beforeDraw(chart, _args, options) {
    const draw2 = options.drawTime === "beforeDraw";
    const metasets = chart.getSortedVisibleDatasetMetas();
    const area = chart.chartArea;
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (!source) {
        continue;
      }
      source.line.updateControlPoints(area, source.axis);
      if (draw2 && source.fill) {
        _drawfill(chart.ctx, source, area);
      }
    }
  },
  beforeDatasetsDraw(chart, _args, options) {
    if (options.drawTime !== "beforeDatasetsDraw") {
      return;
    }
    const metasets = chart.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (_shouldApplyFill(source)) {
        _drawfill(chart.ctx, source, chart.chartArea);
      }
    }
  },
  beforeDatasetDraw(chart, args, options) {
    const source = args.meta.$filler;
    if (!_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") {
      return;
    }
    _drawfill(chart.ctx, source, chart.chartArea);
  },
  defaults: {
    propagate: true,
    drawTime: "beforeDatasetDraw"
  }
};
var Title = class extends Element {
  constructor(config) {
    super();
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this._padding = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this.position = void 0;
    this.weight = void 0;
    this.fullSize = void 0;
  }
  update(maxWidth, maxHeight) {
    const opts = this.options;
    this.left = 0;
    this.top = 0;
    if (!opts.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = maxWidth;
    this.height = this.bottom = maxHeight;
    const lineCount = isArray(opts.text) ? opts.text.length : 1;
    this._padding = toPadding(opts.padding);
    const textSize = lineCount * toFont(opts.font).lineHeight + this._padding.height;
    if (this.isHorizontal()) {
      this.height = textSize;
    } else {
      this.width = textSize;
    }
  }
  isHorizontal() {
    const pos = this.options.position;
    return pos === "top" || pos === "bottom";
  }
  _drawArgs(offset) {
    const { top, left, bottom, right, options } = this;
    const align = options.align;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    if (this.isHorizontal()) {
      titleX = _alignStartEnd(align, left, right);
      titleY = top + offset;
      maxWidth = right - left;
    } else {
      if (options.position === "left") {
        titleX = left + offset;
        titleY = _alignStartEnd(align, bottom, top);
        rotation = PI * -0.5;
      } else {
        titleX = right - offset;
        titleY = _alignStartEnd(align, top, bottom);
        rotation = PI * 0.5;
      }
      maxWidth = bottom - top;
    }
    return {
      titleX,
      titleY,
      maxWidth,
      rotation
    };
  }
  draw() {
    const ctx = this.ctx;
    const opts = this.options;
    if (!opts.display) {
      return;
    }
    const fontOpts = toFont(opts.font);
    const lineHeight = fontOpts.lineHeight;
    const offset = lineHeight / 2 + this._padding.top;
    const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset);
    renderText(ctx, opts.text, 0, 0, fontOpts, {
      color: opts.color,
      maxWidth,
      rotation,
      textAlign: _toLeftRightCenter(opts.align),
      textBaseline: "middle",
      translation: [
        titleX,
        titleY
      ]
    });
  }
};
function createTitle(chart, titleOpts) {
  const title = new Title({
    ctx: chart.ctx,
    options: titleOpts,
    chart
  });
  layouts.configure(chart, title, titleOpts);
  layouts.addBox(chart, title);
  chart.titleBlock = title;
}
var plugin_title = {
  id: "title",
  _element: Title,
  start(chart, _args, options) {
    createTitle(chart, options);
  },
  stop(chart) {
    const titleBlock = chart.titleBlock;
    layouts.removeBox(chart, titleBlock);
    delete chart.titleBlock;
  },
  beforeUpdate(chart, _args, options) {
    const title = chart.titleBlock;
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: "center",
    display: false,
    font: {
      weight: "bold"
    },
    fullSize: true,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
var positioners = {
  average(items) {
    if (!items.length) {
      return false;
    }
    let i, len;
    let x = 0;
    let y = 0;
    let count = 0;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const pos = el.tooltipPosition();
        x += pos.x;
        y += pos.y;
        ++count;
      }
    }
    return {
      x: x / count,
      y: y / count
    };
  },
  nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }
    let x = eventPosition.x;
    let y = eventPosition.y;
    let minDistance = Number.POSITIVE_INFINITY;
    let i, len, nearestElement;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const center = el.getCenterPoint();
        const d = distanceBetweenPoints(eventPosition, center);
        if (d < minDistance) {
          minDistance = d;
          nearestElement = el;
        }
      }
    }
    if (nearestElement) {
      const tp = nearestElement.tooltipPosition();
      x = tp.x;
      y = tp.y;
    }
    return {
      x,
      y
    };
  }
};
function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }
  return base;
}
function splitNewlines(str) {
  if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) {
    return str.split("\n");
  }
  return str;
}
function createTooltipItem(chart, item) {
  const { element, datasetIndex, index: index2 } = item;
  const controller = chart.getDatasetMeta(datasetIndex).controller;
  const { label, value } = controller.getLabelAndValue(index2);
  return {
    chart,
    label,
    parsed: controller.getParsed(index2),
    raw: chart.data.datasets[datasetIndex].data[index2],
    formattedValue: value,
    dataset: controller.getDataset(),
    dataIndex: index2,
    datasetIndex,
    element
  };
}
function getTooltipSize(tooltip, options) {
  const ctx = tooltip.chart.ctx;
  const { body, footer, title } = tooltip;
  const { boxWidth, boxHeight } = options;
  const bodyFont = toFont(options.bodyFont);
  const titleFont = toFont(options.titleFont);
  const footerFont = toFont(options.footerFont);
  const titleLineCount = title.length;
  const footerLineCount = footer.length;
  const bodyLineItemCount = body.length;
  const padding = toPadding(options.padding);
  let height = padding.height;
  let width = 0;
  let combinedBodyLength = body.reduce((count, bodyItem) => count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
  if (titleLineCount) {
    height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
  }
  if (combinedBodyLength) {
    const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
  }
  if (footerLineCount) {
    height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
  }
  let widthPadding = 0;
  const maxLineWidth = function(line) {
    width = Math.max(width, ctx.measureText(line).width + widthPadding);
  };
  ctx.save();
  ctx.font = titleFont.string;
  each(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
  each(body, (bodyItem) => {
    each(bodyItem.before, maxLineWidth);
    each(bodyItem.lines, maxLineWidth);
    each(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return {
    width,
    height
  };
}
function determineYAlign(chart, size) {
  const { y, height } = size;
  if (y < height / 2) {
    return "top";
  } else if (y > chart.height - height / 2) {
    return "bottom";
  }
  return "center";
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
  const { x, width } = size;
  const caret = options.caretSize + options.caretPadding;
  if (xAlign === "left" && x + width + caret > chart.width) {
    return true;
  }
  if (xAlign === "right" && x - width - caret < 0) {
    return true;
  }
}
function determineXAlign(chart, options, size, yAlign) {
  const { x, width } = size;
  const { width: chartWidth, chartArea: { left, right } } = chart;
  let xAlign = "center";
  if (yAlign === "center") {
    xAlign = x <= (left + right) / 2 ? "left" : "right";
  } else if (x <= width / 2) {
    xAlign = "left";
  } else if (x >= chartWidth - width / 2) {
    xAlign = "right";
  }
  if (doesNotFitWithAlign(xAlign, chart, options, size)) {
    xAlign = "center";
  }
  return xAlign;
}
function determineAlignment(chart, options, size) {
  const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
  return {
    xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
    yAlign
  };
}
function alignX(size, xAlign) {
  let { x, width } = size;
  if (xAlign === "right") {
    x -= width;
  } else if (xAlign === "center") {
    x -= width / 2;
  }
  return x;
}
function alignY(size, yAlign, paddingAndSize) {
  let { y, height } = size;
  if (yAlign === "top") {
    y += paddingAndSize;
  } else if (yAlign === "bottom") {
    y -= height + paddingAndSize;
  } else {
    y -= height / 2;
  }
  return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
  const { caretSize, caretPadding, cornerRadius } = options;
  const { xAlign, yAlign } = alignment;
  const paddingAndSize = caretSize + caretPadding;
  const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
  let x = alignX(size, xAlign);
  const y = alignY(size, yAlign, paddingAndSize);
  if (yAlign === "center") {
    if (xAlign === "left") {
      x += paddingAndSize;
    } else if (xAlign === "right") {
      x -= paddingAndSize;
    }
  } else if (xAlign === "left") {
    x -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === "right") {
    x += Math.max(topRight, bottomRight) + caretSize;
  }
  return {
    x: _limitValue(x, 0, chart.width - size.width),
    y: _limitValue(y, 0, chart.height - size.height)
  };
}
function getAlignedX(tooltip, align, options) {
  const padding = toPadding(options.padding);
  return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback2) {
  return pushOrConcat([], splitNewlines(callback2));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext20(parent, {
    tooltip,
    tooltipItems,
    type: "tooltip"
  });
}
function overrideCallbacks(callbacks, context) {
  const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}
var defaultCallbacks = {
  beforeTitle: noop,
  title(tooltipItems) {
    if (tooltipItems.length > 0) {
      const item = tooltipItems[0];
      const labels = item.chart.data.labels;
      const labelCount = labels ? labels.length : 0;
      if (this && this.options && this.options.mode === "dataset") {
        return item.dataset.label || "";
      } else if (item.label) {
        return item.label;
      } else if (labelCount > 0 && item.dataIndex < labelCount) {
        return labels[item.dataIndex];
      }
    }
    return "";
  },
  afterTitle: noop,
  beforeBody: noop,
  beforeLabel: noop,
  label(tooltipItem) {
    if (this && this.options && this.options.mode === "dataset") {
      return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
    }
    let label = tooltipItem.dataset.label || "";
    if (label) {
      label += ": ";
    }
    const value = tooltipItem.formattedValue;
    if (!isNullOrUndef(value)) {
      label += value;
    }
    return label;
  },
  labelColor(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      borderColor: options.borderColor,
      backgroundColor: options.backgroundColor,
      borderWidth: options.borderWidth,
      borderDash: options.borderDash,
      borderDashOffset: options.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      pointStyle: options.pointStyle,
      rotation: options.rotation
    };
  },
  afterLabel: noop,
  afterBody: noop,
  beforeFooter: noop,
  footer: noop,
  afterFooter: noop
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
  const result = callbacks[name].call(ctx, arg);
  if (typeof result === "undefined") {
    return defaultCallbacks[name].call(ctx, arg);
  }
  return result;
}
var Tooltip = class extends Element {
  static positioners = positioners;
  constructor(config) {
    super();
    this.opacity = 0;
    this._active = [];
    this._eventPosition = void 0;
    this._size = void 0;
    this._cachedAnimations = void 0;
    this._tooltipItems = [];
    this.$animations = void 0;
    this.$context = void 0;
    this.chart = config.chart;
    this.options = config.options;
    this.dataPoints = void 0;
    this.title = void 0;
    this.beforeBody = void 0;
    this.body = void 0;
    this.afterBody = void 0;
    this.footer = void 0;
    this.xAlign = void 0;
    this.yAlign = void 0;
    this.x = void 0;
    this.y = void 0;
    this.height = void 0;
    this.width = void 0;
    this.caretX = void 0;
    this.caretY = void 0;
    this.labelColors = void 0;
    this.labelPointStyles = void 0;
    this.labelTextColors = void 0;
  }
  initialize(options) {
    this.options = options;
    this._cachedAnimations = void 0;
    this.$context = void 0;
  }
  _resolveAnimations() {
    const cached = this._cachedAnimations;
    if (cached) {
      return cached;
    }
    const chart = this.chart;
    const options = this.options.setContext(this.getContext());
    const opts = options.enabled && chart.options.animation && options.animations;
    const animations = new Animations(this.chart, opts);
    if (opts._cacheable) {
      this._cachedAnimations = Object.freeze(animations);
    }
    return animations;
  }
  getContext() {
    return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(context, options) {
    const { callbacks } = options;
    const beforeTitle = invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
    const title = invokeCallbackWithFallback(callbacks, "title", this, context);
    const afterTitle = invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeTitle));
    lines = pushOrConcat(lines, splitNewlines(title));
    lines = pushOrConcat(lines, splitNewlines(afterTitle));
    return lines;
  }
  getBeforeBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
  }
  getBody(tooltipItems, options) {
    const { callbacks } = options;
    const bodyItems = [];
    each(tooltipItems, (context) => {
      const bodyItem = {
        before: [],
        lines: [],
        after: []
      };
      const scoped = overrideCallbacks(callbacks, context);
      pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
      pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, "label", this, context));
      pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
      bodyItems.push(bodyItem);
    });
    return bodyItems;
  }
  getAfterBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
  }
  getFooter(tooltipItems, options) {
    const { callbacks } = options;
    const beforeFooter = invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
    const footer = invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
    const afterFooter = invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeFooter));
    lines = pushOrConcat(lines, splitNewlines(footer));
    lines = pushOrConcat(lines, splitNewlines(afterFooter));
    return lines;
  }
  _createItems(options) {
    const active = this._active;
    const data = this.chart.data;
    const labelColors = [];
    const labelPointStyles = [];
    const labelTextColors = [];
    let tooltipItems = [];
    let i, len;
    for (i = 0, len = active.length; i < len; ++i) {
      tooltipItems.push(createTooltipItem(this.chart, active[i]));
    }
    if (options.filter) {
      tooltipItems = tooltipItems.filter((element, index2, array) => options.filter(element, index2, array, data));
    }
    if (options.itemSort) {
      tooltipItems = tooltipItems.sort((a, b) => options.itemSort(a, b, data));
    }
    each(tooltipItems, (context) => {
      const scoped = overrideCallbacks(options.callbacks, context);
      labelColors.push(invokeCallbackWithFallback(scoped, "labelColor", this, context));
      labelPointStyles.push(invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
      labelTextColors.push(invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
    });
    this.labelColors = labelColors;
    this.labelPointStyles = labelPointStyles;
    this.labelTextColors = labelTextColors;
    this.dataPoints = tooltipItems;
    return tooltipItems;
  }
  update(changed, replay) {
    const options = this.options.setContext(this.getContext());
    const active = this._active;
    let properties;
    let tooltipItems = [];
    if (!active.length) {
      if (this.opacity !== 0) {
        properties = {
          opacity: 0
        };
      }
    } else {
      const position = positioners[options.position].call(this, active, this._eventPosition);
      tooltipItems = this._createItems(options);
      this.title = this.getTitle(tooltipItems, options);
      this.beforeBody = this.getBeforeBody(tooltipItems, options);
      this.body = this.getBody(tooltipItems, options);
      this.afterBody = this.getAfterBody(tooltipItems, options);
      this.footer = this.getFooter(tooltipItems, options);
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, size);
      const alignment = determineAlignment(this.chart, options, positionAndSize);
      const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
      this.xAlign = alignment.xAlign;
      this.yAlign = alignment.yAlign;
      properties = {
        opacity: 1,
        x: backgroundPoint.x,
        y: backgroundPoint.y,
        width: size.width,
        height: size.height,
        caretX: position.x,
        caretY: position.y
      };
    }
    this._tooltipItems = tooltipItems;
    this.$context = void 0;
    if (properties) {
      this._resolveAnimations().update(this, properties);
    }
    if (changed && options.external) {
      options.external.call(this, {
        chart: this.chart,
        tooltip: this,
        replay
      });
    }
  }
  drawCaret(tooltipPoint, ctx, size, options) {
    const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
    ctx.lineTo(caretPosition.x1, caretPosition.y1);
    ctx.lineTo(caretPosition.x2, caretPosition.y2);
    ctx.lineTo(caretPosition.x3, caretPosition.y3);
  }
  getCaretPosition(tooltipPoint, size, options) {
    const { xAlign, yAlign } = this;
    const { caretSize, cornerRadius } = options;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
    const { x: ptX, y: ptY } = tooltipPoint;
    const { width, height } = size;
    let x1, x2, x3, y1, y2, y3;
    if (yAlign === "center") {
      y2 = ptY + height / 2;
      if (xAlign === "left") {
        x1 = ptX;
        x2 = x1 - caretSize;
        y1 = y2 + caretSize;
        y3 = y2 - caretSize;
      } else {
        x1 = ptX + width;
        x2 = x1 + caretSize;
        y1 = y2 - caretSize;
        y3 = y2 + caretSize;
      }
      x3 = x1;
    } else {
      if (xAlign === "left") {
        x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
      } else if (xAlign === "right") {
        x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
      } else {
        x2 = this.caretX;
      }
      if (yAlign === "top") {
        y1 = ptY;
        y2 = y1 - caretSize;
        x1 = x2 - caretSize;
        x3 = x2 + caretSize;
      } else {
        y1 = ptY + height;
        y2 = y1 + caretSize;
        x1 = x2 + caretSize;
        x3 = x2 - caretSize;
      }
      y3 = y1;
    }
    return {
      x1,
      x2,
      x3,
      y1,
      y2,
      y3
    };
  }
  drawTitle(pt, ctx, options) {
    const title = this.title;
    const length = title.length;
    let titleFont, titleSpacing, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.titleAlign, options);
      ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
      ctx.textBaseline = "middle";
      titleFont = toFont(options.titleFont);
      titleSpacing = options.titleSpacing;
      ctx.fillStyle = options.titleColor;
      ctx.font = titleFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
        pt.y += titleFont.lineHeight + titleSpacing;
        if (i + 1 === length) {
          pt.y += options.titleMarginBottom - titleSpacing;
        }
      }
    }
  }
  _drawColorBox(ctx, pt, i, rtlHelper, options) {
    const labelColor = this.labelColors[i];
    const labelPointStyle = this.labelPointStyles[i];
    const { boxHeight, boxWidth } = options;
    const bodyFont = toFont(options.bodyFont);
    const colorX = getAlignedX(this, "left", options);
    const rtlColorX = rtlHelper.x(colorX);
    const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
    const colorY = pt.y + yOffSet;
    if (options.usePointStyle) {
      const drawOptions = {
        radius: Math.min(boxWidth, boxHeight) / 2,
        pointStyle: labelPointStyle.pointStyle,
        rotation: labelPointStyle.rotation,
        borderWidth: 1
      };
      const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
      const centerY = colorY + boxHeight / 2;
      ctx.strokeStyle = options.multiKeyBackground;
      ctx.fillStyle = options.multiKeyBackground;
      drawPoint(ctx, drawOptions, centerX, centerY);
      ctx.strokeStyle = labelColor.borderColor;
      ctx.fillStyle = labelColor.backgroundColor;
      drawPoint(ctx, drawOptions, centerX, centerY);
    } else {
      ctx.lineWidth = isObject(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
      ctx.strokeStyle = labelColor.borderColor;
      ctx.setLineDash(labelColor.borderDash || []);
      ctx.lineDashOffset = labelColor.borderDashOffset || 0;
      const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
      const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
      const borderRadius = toTRBLCorners(labelColor.borderRadius);
      if (Object.values(borderRadius).some((v) => v !== 0)) {
        ctx.beginPath();
        ctx.fillStyle = options.multiKeyBackground;
        addRoundedRectPath(ctx, {
          x: outerX,
          y: colorY,
          w: boxWidth,
          h: boxHeight,
          radius: borderRadius
        });
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: innerX,
          y: colorY + 1,
          w: boxWidth - 2,
          h: boxHeight - 2,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillStyle = options.multiKeyBackground;
        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
      }
    }
    ctx.fillStyle = this.labelTextColors[i];
  }
  drawBody(pt, ctx, options) {
    const { body } = this;
    const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
    const bodyFont = toFont(options.bodyFont);
    let bodyLineHeight = bodyFont.lineHeight;
    let xLinePadding = 0;
    const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
    const fillLineOfText = function(line) {
      ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
      pt.y += bodyLineHeight + bodySpacing;
    };
    const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
    let bodyItem, textColor, lines, i, j, ilen, jlen;
    ctx.textAlign = bodyAlign;
    ctx.textBaseline = "middle";
    ctx.font = bodyFont.string;
    pt.x = getAlignedX(this, bodyAlignForCalculation, options);
    ctx.fillStyle = options.bodyColor;
    each(this.beforeBody, fillLineOfText);
    xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
    for (i = 0, ilen = body.length; i < ilen; ++i) {
      bodyItem = body[i];
      textColor = this.labelTextColors[i];
      ctx.fillStyle = textColor;
      each(bodyItem.before, fillLineOfText);
      lines = bodyItem.lines;
      if (displayColors && lines.length) {
        this._drawColorBox(ctx, pt, i, rtlHelper, options);
        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
      }
      for (j = 0, jlen = lines.length; j < jlen; ++j) {
        fillLineOfText(lines[j]);
        bodyLineHeight = bodyFont.lineHeight;
      }
      each(bodyItem.after, fillLineOfText);
    }
    xLinePadding = 0;
    bodyLineHeight = bodyFont.lineHeight;
    each(this.afterBody, fillLineOfText);
    pt.y -= bodySpacing;
  }
  drawFooter(pt, ctx, options) {
    const footer = this.footer;
    const length = footer.length;
    let footerFont, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.footerAlign, options);
      pt.y += options.footerMarginTop;
      ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
      ctx.textBaseline = "middle";
      footerFont = toFont(options.footerFont);
      ctx.fillStyle = options.footerColor;
      ctx.font = footerFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
        pt.y += footerFont.lineHeight + options.footerSpacing;
      }
    }
  }
  drawBackground(pt, ctx, tooltipSize, options) {
    const { xAlign, yAlign } = this;
    const { x, y } = pt;
    const { width, height } = tooltipSize;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(options.cornerRadius);
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.beginPath();
    ctx.moveTo(x + topLeft, y);
    if (yAlign === "top") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width - topRight, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
    if (yAlign === "center" && xAlign === "right") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width, y + height - bottomRight);
    ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
    if (yAlign === "bottom") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + bottomLeft, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
    if (yAlign === "center" && xAlign === "left") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x, y + topLeft);
    ctx.quadraticCurveTo(x, y, x + topLeft, y);
    ctx.closePath();
    ctx.fill();
    if (options.borderWidth > 0) {
      ctx.stroke();
    }
  }
  _updateAnimationTarget(options) {
    const chart = this.chart;
    const anims = this.$animations;
    const animX = anims && anims.x;
    const animY = anims && anims.y;
    if (animX || animY) {
      const position = positioners[options.position].call(this, this._active, this._eventPosition);
      if (!position) {
        return;
      }
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, this._size);
      const alignment = determineAlignment(chart, options, positionAndSize);
      const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
      if (animX._to !== point.x || animY._to !== point.y) {
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        this.width = size.width;
        this.height = size.height;
        this.caretX = position.x;
        this.caretY = position.y;
        this._resolveAnimations().update(this, point);
      }
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(ctx) {
    const options = this.options.setContext(this.getContext());
    let opacity = this.opacity;
    if (!opacity) {
      return;
    }
    this._updateAnimationTarget(options);
    const tooltipSize = {
      width: this.width,
      height: this.height
    };
    const pt = {
      x: this.x,
      y: this.y
    };
    opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
    const padding = toPadding(options.padding);
    const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    if (options.enabled && hasTooltipContent) {
      ctx.save();
      ctx.globalAlpha = opacity;
      this.drawBackground(pt, ctx, tooltipSize, options);
      overrideTextDirection(ctx, options.textDirection);
      pt.y += padding.top;
      this.drawTitle(pt, ctx, options);
      this.drawBody(pt, ctx, options);
      this.drawFooter(pt, ctx, options);
      restoreTextDirection(ctx, options.textDirection);
      ctx.restore();
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements, eventPosition) {
    const lastActive = this._active;
    const active = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.chart.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("Cannot find a dataset at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(lastActive, active);
    const positionChanged = this._positionChanged(active, eventPosition);
    if (changed || positionChanged) {
      this._active = active;
      this._eventPosition = eventPosition;
      this._ignoreReplayEvents = true;
      this.update(true);
    }
  }
  handleEvent(e, replay, inChartArea = true) {
    if (replay && this._ignoreReplayEvents) {
      return false;
    }
    this._ignoreReplayEvents = false;
    const options = this.options;
    const lastActive = this._active || [];
    const active = this._getActiveElements(e, lastActive, replay, inChartArea);
    const positionChanged = this._positionChanged(active, e);
    const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
    if (changed) {
      this._active = active;
      if (options.enabled || options.external) {
        this._eventPosition = {
          x: e.x,
          y: e.y
        };
        this.update(true, replay);
      }
    }
    return changed;
  }
  _getActiveElements(e, lastActive, replay, inChartArea) {
    const options = this.options;
    if (e.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
    if (options.reverse) {
      active.reverse();
    }
    return active;
  }
  _positionChanged(active, e) {
    const { caretX, caretY, options } = this;
    const position = positioners[options.position].call(this, active, e);
    return position !== false && (caretX !== position.x || caretY !== position.y);
  }
};
var plugin_tooltip = {
  id: "tooltip",
  _element: Tooltip,
  positioners,
  afterInit(chart, _args, options) {
    if (options) {
      chart.tooltip = new Tooltip({
        chart,
        options
      });
    }
  },
  beforeUpdate(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  reset(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  afterDraw(chart) {
    const tooltip = chart.tooltip;
    if (tooltip && tooltip._willRender()) {
      const args = {
        tooltip
      };
      if (chart.notifyPlugins("beforeTooltipDraw", {
        ...args,
        cancelable: true
      }) === false) {
        return;
      }
      tooltip.draw(chart.ctx);
      chart.notifyPlugins("afterTooltipDraw", args);
    }
  },
  afterEvent(chart, args) {
    if (chart.tooltip) {
      const useFinalPosition = args.replay;
      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (ctx, opts) => opts.bodyFont.size,
    boxWidth: (ctx, opts) => opts.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: true,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: defaultCallbacks
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (name) => name !== "filter" && name !== "itemSort" && name !== "external",
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
var addIfString = (labels, raw, index2, addedLabels) => {
  if (typeof raw === "string") {
    index2 = labels.push(raw) - 1;
    addedLabels.unshift({
      index: index2,
      label: raw
    });
  } else if (isNaN(raw)) {
    index2 = null;
  }
  return index2;
};
function findOrAddLabel(labels, raw, index2, addedLabels) {
  const first = labels.indexOf(raw);
  if (first === -1) {
    return addIfString(labels, raw, index2, addedLabels);
  }
  const last = labels.lastIndexOf(raw);
  return first !== last ? index2 : first;
}
var validIndex = (index2, max) => index2 === null ? null : _limitValue(Math.round(index2), 0, max);
function _getLabelForValue(value) {
  const labels = this.getLabels();
  if (value >= 0 && value < labels.length) {
    return labels[value];
  }
  return value;
}
var CategoryScale = class extends Scale {
  static id = "category";
  static defaults = {
    ticks: {
      callback: _getLabelForValue
    }
  };
  constructor(cfg) {
    super(cfg);
    this._startValue = void 0;
    this._valueRange = 0;
    this._addedLabels = [];
  }
  init(scaleOptions) {
    const added = this._addedLabels;
    if (added.length) {
      const labels = this.getLabels();
      for (const { index: index2, label } of added) {
        if (labels[index2] === label) {
          labels.splice(index2, 1);
        }
      }
      this._addedLabels = [];
    }
    super.init(scaleOptions);
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    const labels = this.getLabels();
    index2 = isFinite(index2) && labels[index2] === raw ? index2 : findOrAddLabel(labels, raw, valueOrDefault(index2, raw), this._addedLabels);
    return validIndex(index2, labels.length - 1);
  }
  determineDataLimits() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min, max } = this.getMinMax(true);
    if (this.options.bounds === "ticks") {
      if (!minDefined) {
        min = 0;
      }
      if (!maxDefined) {
        max = this.getLabels().length - 1;
      }
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const min = this.min;
    const max = this.max;
    const offset = this.options.offset;
    const ticks = [];
    let labels = this.getLabels();
    labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
    this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
    this._startValue = this.min - (offset ? 0.5 : 0);
    for (let value = min; value <= max; value++) {
      ticks.push({
        value
      });
    }
    return ticks;
  }
  getLabelForValue(value) {
    return _getLabelForValue.call(this, value);
  }
  configure() {
    super.configure();
    if (!this.isHorizontal()) {
      this._reversePixels = !this._reversePixels;
    }
  }
  getPixelForValue(value) {
    if (typeof value !== "number") {
      value = this.parse(value);
    }
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getValueForPixel(pixel) {
    return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
};
function generateTicks$1(generationOptions, dataRange) {
  const ticks = [];
  const MIN_SPACING = 1e-14;
  const { bounds, step, min, max, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
  const unit = step || 1;
  const maxSpaces = maxTicks - 1;
  const { min: rmin, max: rmax } = dataRange;
  const minDefined = !isNullOrUndef(min);
  const maxDefined = !isNullOrUndef(max);
  const countDefined = !isNullOrUndef(count);
  const minSpacing = (rmax - rmin) / (maxDigits + 1);
  let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  let factor, niceMin, niceMax, numSpaces;
  if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
    return [
      {
        value: rmin
      },
      {
        value: rmax
      }
    ];
  }
  numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
  if (numSpaces > maxSpaces) {
    spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
  }
  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing = Math.ceil(spacing * factor) / factor;
  }
  if (bounds === "ticks") {
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }
  if (minDefined && maxDefined && step && almostWhole((max - min) / step, spacing / 1e3)) {
    numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
    spacing = (max - min) / numSpaces;
    niceMin = min;
    niceMax = max;
  } else if (countDefined) {
    niceMin = minDefined ? min : niceMin;
    niceMax = maxDefined ? max : niceMax;
    numSpaces = count - 1;
    spacing = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing;
    if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1e3)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }
  const decimalPlaces = Math.max(_decimalPlaces(spacing), _decimalPlaces(niceMin));
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  let j = 0;
  if (minDefined) {
    if (includeBounds && niceMin !== min) {
      ticks.push({
        value: min
      });
      if (niceMin < min) {
        j++;
      }
      if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min) {
      j++;
    }
  }
  for (; j < numSpaces; ++j) {
    const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
    if (maxDefined && tickValue > max) {
      break;
    }
    ticks.push({
      value: tickValue
    });
  }
  if (maxDefined && includeBounds && niceMax !== max) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max;
    } else {
      ticks.push({
        value: max
      });
    }
  } else if (!maxDefined || niceMax === max) {
    ticks.push({
      value: niceMax
    });
  }
  return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
  const rad = toRadians(minRotation);
  const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 1e-3;
  const length = 0.75 * minSpacing * ("" + value).length;
  return Math.min(minSpacing / ratio, length);
}
var LinearScaleBase = class extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._endValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) {
      return null;
    }
    return +raw;
  }
  handleTickRangeOptions() {
    const { beginAtZero } = this.options;
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min, max } = this;
    const setMin = (v) => min = minDefined ? min : v;
    const setMax = (v) => max = maxDefined ? max : v;
    if (beginAtZero) {
      const minSign = sign(min);
      const maxSign = sign(max);
      if (minSign < 0 && maxSign < 0) {
        setMax(0);
      } else if (minSign > 0 && maxSign > 0) {
        setMin(0);
      }
    }
    if (min === max) {
      let offset = max === 0 ? 1 : Math.abs(max * 0.05);
      setMax(max + offset);
      if (!beginAtZero) {
        setMin(min - offset);
      }
    }
    this.min = min;
    this.max = max;
  }
  getTickLimit() {
    const tickOpts = this.options.ticks;
    let { maxTicksLimit, stepSize } = tickOpts;
    let maxTicks;
    if (stepSize) {
      maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
      if (maxTicks > 1e3) {
        console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
        maxTicks = 1e3;
      }
    } else {
      maxTicks = this.computeTickLimit();
      maxTicksLimit = maxTicksLimit || 11;
    }
    if (maxTicksLimit) {
      maxTicks = Math.min(maxTicksLimit, maxTicks);
    }
    return maxTicks;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const opts = this.options;
    const tickOpts = opts.ticks;
    let maxTicks = this.getTickLimit();
    maxTicks = Math.max(2, maxTicks);
    const numericGeneratorOptions = {
      maxTicks,
      bounds: opts.bounds,
      min: opts.min,
      max: opts.max,
      precision: tickOpts.precision,
      step: tickOpts.stepSize,
      count: tickOpts.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: tickOpts.minRotation || 0,
      includeBounds: tickOpts.includeBounds !== false
    };
    const dataRange = this._range || this;
    const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  configure() {
    const ticks = this.ticks;
    let start = this.min;
    let end = this.max;
    super.configure();
    if (this.options.offset && ticks.length) {
      const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
      start -= offset;
      end += offset;
    }
    this._startValue = start;
    this._endValue = end;
    this._valueRange = end - start;
  }
  getLabelForValue(value) {
    return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
};
var LinearScale = class extends LinearScaleBase {
  static id = "linear";
  static defaults = {
    ticks: {
      callback: Ticks.formatters.numeric
    }
  };
  determineDataLimits() {
    const { min, max } = this.getMinMax(true);
    this.min = isNumberFinite(min) ? min : 0;
    this.max = isNumberFinite(max) ? max : 1;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const horizontal = this.isHorizontal();
    const length = horizontal ? this.width : this.height;
    const minRotation = toRadians(this.options.ticks.minRotation);
    const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 1e-3;
    const tickFont = this._resolveTickFontOptions(0);
    return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
  }
  getPixelForValue(value) {
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
  }
};
var log10Floor = (v) => Math.floor(log10(v));
var changeExponent = (v, m) => Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
  const remain = tickVal / Math.pow(10, log10Floor(tickVal));
  return remain === 1;
}
function steps(min, max, rangeExp) {
  const rangeStep = Math.pow(10, rangeExp);
  const start = Math.floor(min / rangeStep);
  const end = Math.ceil(max / rangeStep);
  return end - start;
}
function startExp(min, max) {
  const range = max - min;
  let rangeExp = log10Floor(range);
  while (steps(min, max, rangeExp) > 10) {
    rangeExp++;
  }
  while (steps(min, max, rangeExp) < 10) {
    rangeExp--;
  }
  return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, { min, max }) {
  min = finiteOrDefault(generationOptions.min, min);
  const ticks = [];
  const minExp = log10Floor(min);
  let exp = startExp(min, max);
  let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
  const stepSize = Math.pow(10, exp);
  const base = minExp > exp ? Math.pow(10, minExp) : 0;
  const start = Math.round((min - base) * precision) / precision;
  const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
  let significand = Math.floor((start - offset) / Math.pow(10, exp));
  let value = finiteOrDefault(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
  while (value < max) {
    ticks.push({
      value,
      major: isMajor(value),
      significand
    });
    if (significand >= 10) {
      significand = significand < 15 ? 15 : 20;
    } else {
      significand++;
    }
    if (significand >= 20) {
      exp++;
      significand = 2;
      precision = exp >= 0 ? 1 : precision;
    }
    value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
  }
  const lastTick = finiteOrDefault(generationOptions.max, value);
  ticks.push({
    value: lastTick,
    major: isMajor(lastTick),
    significand
  });
  return ticks;
}
var LogarithmicScale = class extends Scale {
  static id = "logarithmic";
  static defaults = {
    ticks: {
      callback: Ticks.formatters.logarithmic,
      major: {
        enabled: true
      }
    }
  };
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    const value = LinearScaleBase.prototype.parse.apply(this, [
      raw,
      index2
    ]);
    if (value === 0) {
      this._zero = true;
      return void 0;
    }
    return isNumberFinite(value) && value > 0 ? value : null;
  }
  determineDataLimits() {
    const { min, max } = this.getMinMax(true);
    this.min = isNumberFinite(min) ? Math.max(0, min) : null;
    this.max = isNumberFinite(max) ? Math.max(0, max) : null;
    if (this.options.beginAtZero) {
      this._zero = true;
    }
    if (this._zero && this.min !== this._suggestedMin && !isNumberFinite(this._userMin)) {
      this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
    }
    this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let min = this.min;
    let max = this.max;
    const setMin = (v) => min = minDefined ? min : v;
    const setMax = (v) => max = maxDefined ? max : v;
    if (min === max) {
      if (min <= 0) {
        setMin(1);
        setMax(10);
      } else {
        setMin(changeExponent(min, -1));
        setMax(changeExponent(max, 1));
      }
    }
    if (min <= 0) {
      setMin(changeExponent(max, -1));
    }
    if (max <= 0) {
      setMax(changeExponent(min, 1));
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const opts = this.options;
    const generationOptions = {
      min: this._userMin,
      max: this._userMax
    };
    const ticks = generateTicks(generationOptions, this);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  getLabelForValue(value) {
    return value === void 0 ? "0" : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const start = this.min;
    super.configure();
    this._startValue = log10(start);
    this._valueRange = log10(this.max) - log10(start);
  }
  getPixelForValue(value) {
    if (value === void 0 || value === 0) {
      value = this.min;
    }
    if (value === null || isNaN(value)) {
      return NaN;
    }
    return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    const decimal = this.getDecimalForPixel(pixel);
    return Math.pow(10, this._startValue + decimal * this._valueRange);
  }
};
function getTickBackdropHeight(opts) {
  const tickOpts = opts.ticks;
  if (tickOpts.display && opts.display) {
    const padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults.font.size) + padding.height;
  }
  return 0;
}
function measureLabelSize(ctx, font, label) {
  label = isArray(label) ? label : [
    label
  ];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}
function determineLimits(angle, pos, size, min, max) {
  if (angle === min || angle === max) {
    return {
      start: pos - size / 2,
      end: pos + size / 2
    };
  } else if (angle < min || angle > max) {
    return {
      start: pos - size,
      end: pos
    };
  }
  return {
    start: pos,
    end: pos + size
  };
}
function fitWithPointLabels(scale) {
  const orig = {
    l: scale.left + scale._padding.left,
    r: scale.right - scale._padding.right,
    t: scale.top + scale._padding.top,
    b: scale.bottom - scale._padding.bottom
  };
  const limits = Object.assign({}, orig);
  const labelSizes = [];
  const padding = [];
  const valueCount = scale._pointLabels.length;
  const pointLabelOpts = scale.options.pointLabels;
  const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
    padding[i] = opts.padding;
    const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
    const plFont = toFont(opts.font);
    const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
    labelSizes[i] = textSize;
    const angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
    const angle = Math.round(toDegrees(angleRadians));
    const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
    const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }
  scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
  scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
  const sin = Math.abs(Math.sin(angle));
  const cos = Math.abs(Math.cos(angle));
  let x = 0;
  let y = 0;
  if (hLimits.start < orig.l) {
    x = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x);
  } else if (hLimits.end > orig.r) {
    x = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x);
  }
  if (vLimits.start < orig.t) {
    y = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y);
  } else if (vLimits.end > orig.b) {
    y = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y);
  }
}
function createPointLabelItem(scale, index2, itemOpts) {
  const outerDistance = scale.drawingArea;
  const { extra, additionalAngle, padding, size } = itemOpts;
  const pointLabelPosition = scale.getPointPosition(index2, outerDistance + extra + padding, additionalAngle);
  const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
  const y = yForAngle(pointLabelPosition.y, size.h, angle);
  const textAlign = getTextAlignForAngle(angle);
  const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
  return {
    visible: true,
    x: pointLabelPosition.x,
    y,
    textAlign,
    left,
    top: y,
    right: left + size.w,
    bottom: y + size.h
  };
}
function isNotOverlapped(item, area) {
  if (!area) {
    return true;
  }
  const { left, top, right, bottom } = item;
  const apexesInArea = _isPointInArea({
    x: left,
    y: top
  }, area) || _isPointInArea({
    x: left,
    y: bottom
  }, area) || _isPointInArea({
    x: right,
    y: top
  }, area) || _isPointInArea({
    x: right,
    y: bottom
  }, area);
  return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
  const items = [];
  const valueCount = scale._pointLabels.length;
  const opts = scale.options;
  const { centerPointLabels, display } = opts.pointLabels;
  const itemOpts = {
    extra: getTickBackdropHeight(opts) / 2,
    additionalAngle: centerPointLabels ? PI / valueCount : 0
  };
  let area;
  for (let i = 0; i < valueCount; i++) {
    itemOpts.padding = padding[i];
    itemOpts.size = labelSizes[i];
    const item = createPointLabelItem(scale, i, itemOpts);
    items.push(item);
    if (display === "auto") {
      item.visible = isNotOverlapped(item, area);
      if (item.visible) {
        area = item;
      }
    }
  }
  return items;
}
function getTextAlignForAngle(angle) {
  if (angle === 0 || angle === 180) {
    return "center";
  } else if (angle < 180) {
    return "left";
  }
  return "right";
}
function leftForTextAlign(x, w, align) {
  if (align === "right") {
    x -= w;
  } else if (align === "center") {
    x -= w / 2;
  }
  return x;
}
function yForAngle(y, h, angle) {
  if (angle === 90 || angle === 270) {
    y -= h / 2;
  } else if (angle > 270 || angle < 90) {
    y -= h;
  }
  return y;
}
function drawPointLabelBox(ctx, opts, item) {
  const { left, top, right, bottom } = item;
  const { backdropColor } = opts;
  if (!isNullOrUndef(backdropColor)) {
    const borderRadius = toTRBLCorners(opts.borderRadius);
    const padding = toPadding(opts.backdropPadding);
    ctx.fillStyle = backdropColor;
    const backdropLeft = left - padding.left;
    const backdropTop = top - padding.top;
    const backdropWidth = right - left + padding.width;
    const backdropHeight = bottom - top + padding.height;
    if (Object.values(borderRadius).some((v) => v !== 0)) {
      ctx.beginPath();
      addRoundedRectPath(ctx, {
        x: backdropLeft,
        y: backdropTop,
        w: backdropWidth,
        h: backdropHeight,
        radius: borderRadius
      });
      ctx.fill();
    } else {
      ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
  }
}
function drawPointLabels(scale, labelCount) {
  const { ctx, options: { pointLabels } } = scale;
  for (let i = labelCount - 1; i >= 0; i--) {
    const item = scale._pointLabelItems[i];
    if (!item.visible) {
      continue;
    }
    const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
    drawPointLabelBox(ctx, optsAtIndex, item);
    const plFont = toFont(optsAtIndex.font);
    const { x, y, textAlign } = item;
    renderText(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
      color: optsAtIndex.color,
      textAlign,
      textBaseline: "middle"
    });
  }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
  const { ctx } = scale;
  if (circular) {
    ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
  } else {
    let pointPosition = scale.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);
    for (let i = 1; i < labelCount; i++) {
      pointPosition = scale.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
  const ctx = scale.ctx;
  const circular = gridLineOpts.circular;
  const { color: color2, lineWidth } = gridLineOpts;
  if (!circular && !labelCount || !color2 || !lineWidth || radius < 0) {
    return;
  }
  ctx.save();
  ctx.strokeStyle = color2;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(borderOpts.dash);
  ctx.lineDashOffset = borderOpts.dashOffset;
  ctx.beginPath();
  pathRadiusLine(scale, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}
function createPointLabelContext(parent, index2, label) {
  return createContext20(parent, {
    label,
    index: index2,
    type: "pointLabel"
  });
}
var RadialLinearScale = class extends LinearScaleBase {
  static id = "radialLinear";
  static defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
      display: true,
      lineWidth: 1,
      borderDash: [],
      borderDashOffset: 0
    },
    grid: {
      circular: false
    },
    startAngle: 0,
    ticks: {
      showLabelBackdrop: true,
      callback: Ticks.formatters.numeric
    },
    pointLabels: {
      backdropColor: void 0,
      backdropPadding: 2,
      display: true,
      font: {
        size: 10
      },
      callback(label) {
        return label;
      },
      padding: 5,
      centerPointLabels: false
    }
  };
  static defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
  };
  static descriptors = {
    angleLines: {
      _fallback: "grid"
    }
  };
  constructor(cfg) {
    super(cfg);
    this.xCenter = void 0;
    this.yCenter = void 0;
    this.drawingArea = void 0;
    this._pointLabels = [];
    this._pointLabelItems = [];
  }
  setDimensions() {
    const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
    const w = this.width = this.maxWidth - padding.width;
    const h = this.height = this.maxHeight - padding.height;
    this.xCenter = Math.floor(this.left + w / 2 + padding.left);
    this.yCenter = Math.floor(this.top + h / 2 + padding.top);
    this.drawingArea = Math.floor(Math.min(w, h) / 2);
  }
  determineDataLimits() {
    const { min, max } = this.getMinMax(false);
    this.min = isNumberFinite(min) && !isNaN(min) ? min : 0;
    this.max = isNumberFinite(max) && !isNaN(max) ? max : 0;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(ticks) {
    LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
    this._pointLabels = this.getLabels().map((value, index2) => {
      const label = callback(this.options.pointLabels.callback, [
        value,
        index2
      ], this);
      return label || label === 0 ? label : "";
    }).filter((v, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const opts = this.options;
    if (opts.display && opts.pointLabels.display) {
      fitWithPointLabels(this);
    } else {
      this.setCenterPoint(0, 0, 0, 0);
    }
  }
  setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
    this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
    this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
    this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
  }
  getIndexAngle(index2) {
    const angleMultiplier = TAU / (this._pointLabels.length || 1);
    const startAngle = this.options.startAngle || 0;
    return _normalizeAngle(index2 * angleMultiplier + toRadians(startAngle));
  }
  getDistanceFromCenterForValue(value) {
    if (isNullOrUndef(value)) {
      return NaN;
    }
    const scalingFactor = this.drawingArea / (this.max - this.min);
    if (this.options.reverse) {
      return (this.max - value) * scalingFactor;
    }
    return (value - this.min) * scalingFactor;
  }
  getValueForDistanceFromCenter(distance) {
    if (isNullOrUndef(distance)) {
      return NaN;
    }
    const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
  }
  getPointLabelContext(index2) {
    const pointLabels = this._pointLabels || [];
    if (index2 >= 0 && index2 < pointLabels.length) {
      const pointLabel = pointLabels[index2];
      return createPointLabelContext(this.getContext(), index2, pointLabel);
    }
  }
  getPointPosition(index2, distanceFromCenter, additionalAngle = 0) {
    const angle = this.getIndexAngle(index2) - HALF_PI + additionalAngle;
    return {
      x: Math.cos(angle) * distanceFromCenter + this.xCenter,
      y: Math.sin(angle) * distanceFromCenter + this.yCenter,
      angle
    };
  }
  getPointPositionForValue(index2, value) {
    return this.getPointPosition(index2, this.getDistanceFromCenterForValue(value));
  }
  getBasePosition(index2) {
    return this.getPointPositionForValue(index2 || 0, this.getBaseValue());
  }
  getPointLabelPosition(index2) {
    const { left, top, right, bottom } = this._pointLabelItems[index2];
    return {
      left,
      top,
      right,
      bottom
    };
  }
  drawBackground() {
    const { backgroundColor, grid: { circular } } = this.options;
    if (backgroundColor) {
      const ctx = this.ctx;
      ctx.save();
      ctx.beginPath();
      pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
      ctx.closePath();
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const { angleLines, grid, border } = opts;
    const labelCount = this._pointLabels.length;
    let i, offset, position;
    if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }
    if (grid.display) {
      this.ticks.forEach((tick, index2) => {
        if (index2 !== 0) {
          offset = this.getDistanceFromCenterForValue(tick.value);
          const context = this.getContext(index2);
          const optsAtIndex = grid.setContext(context);
          const optsAtIndexBorder = border.setContext(context);
          drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
        }
      });
    }
    if (angleLines.display) {
      ctx.save();
      for (i = labelCount - 1; i >= 0; i--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
        const { color: color2, lineWidth } = optsAtIndex;
        if (!lineWidth || !color2) {
          continue;
        }
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color2;
        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
        offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
        position = this.getPointPosition(i, offset);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position.x, position.y);
        ctx.stroke();
      }
      ctx.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const ctx = this.ctx;
    const opts = this.options;
    const tickOpts = opts.ticks;
    if (!tickOpts.display) {
      return;
    }
    const startAngle = this.getIndexAngle(0);
    let offset, width;
    ctx.save();
    ctx.translate(this.xCenter, this.yCenter);
    ctx.rotate(startAngle);
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    this.ticks.forEach((tick, index2) => {
      if (index2 === 0 && !opts.reverse) {
        return;
      }
      const optsAtIndex = tickOpts.setContext(this.getContext(index2));
      const tickFont = toFont(optsAtIndex.font);
      offset = this.getDistanceFromCenterForValue(this.ticks[index2].value);
      if (optsAtIndex.showLabelBackdrop) {
        ctx.font = tickFont.string;
        width = ctx.measureText(tick.label).width;
        ctx.fillStyle = optsAtIndex.backdropColor;
        const padding = toPadding(optsAtIndex.backdropPadding);
        ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
      }
      renderText(ctx, tick.label, 0, -offset, tickFont, {
        color: optsAtIndex.color,
        strokeColor: optsAtIndex.textStrokeColor,
        strokeWidth: optsAtIndex.textStrokeWidth
      });
    });
    ctx.restore();
  }
  drawTitle() {
  }
};
var INTERVALS = {
  millisecond: {
    common: true,
    size: 1,
    steps: 1e3
  },
  second: {
    common: true,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: true,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: true,
    size: 36e5,
    steps: 24
  },
  day: {
    common: true,
    size: 864e5,
    steps: 30
  },
  week: {
    common: false,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: true,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: false,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: true,
    size: 3154e7
  }
};
var UNITS = /* @__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
  return a - b;
}
function parse(scale, input) {
  if (isNullOrUndef(input)) {
    return null;
  }
  const adapter = scale._adapter;
  const { parser, round: round2, isoWeekday } = scale._parseOpts;
  let value = input;
  if (typeof parser === "function") {
    value = parser(value);
  }
  if (!isNumberFinite(value)) {
    value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
  }
  if (value === null) {
    return null;
  }
  if (round2) {
    value = round2 === "week" && (isNumber6(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round2);
  }
  return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
  const ilen = UNITS.length;
  for (let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
    const interval = INTERVALS[UNITS[i]];
    const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
    if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
      return UNITS[i];
    }
  }
  return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
  for (let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
    const unit = UNITS[i];
    if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
      return unit;
    }
  }
  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
  for (let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
    if (INTERVALS[UNITS[i]].common) {
      return UNITS[i];
    }
  }
}
function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    const { lo, hi } = _lookup(timestamps, time);
    const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
    ticks[timestamp] = true;
  }
}
function setMajorTicks(scale, ticks, map2, majorUnit) {
  const adapter = scale._adapter;
  const first = +adapter.startOf(ticks[0].value, majorUnit);
  const last = ticks[ticks.length - 1].value;
  let major, index2;
  for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
    index2 = map2[major];
    if (index2 >= 0) {
      ticks[index2].major = true;
    }
  }
  return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
  const ticks = [];
  const map2 = {};
  const ilen = values.length;
  let i, value;
  for (i = 0; i < ilen; ++i) {
    value = values[i];
    map2[value] = i;
    ticks.push({
      value,
      major: false
    });
  }
  return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map2, majorUnit);
}
var TimeScale = class extends Scale {
  static id = "time";
  static defaults = {
    bounds: "data",
    adapters: {},
    time: {
      parser: false,
      unit: false,
      round: false,
      isoWeekday: false,
      minUnit: "millisecond",
      displayFormats: {}
    },
    ticks: {
      source: "auto",
      callback: false,
      major: {
        enabled: false
      }
    }
  };
  constructor(props) {
    super(props);
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
    this._unit = "day";
    this._majorUnit = void 0;
    this._offsets = {};
    this._normalized = false;
    this._parseOpts = void 0;
  }
  init(scaleOpts, opts = {}) {
    const time = scaleOpts.time || (scaleOpts.time = {});
    const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
    adapter.init(opts);
    mergeIf(time.displayFormats, adapter.formats());
    this._parseOpts = {
      parser: time.parser,
      round: time.round,
      isoWeekday: time.isoWeekday
    };
    super.init(scaleOpts);
    this._normalized = opts.normalized;
  }
  parse(raw, index2) {
    if (raw === void 0) {
      return null;
    }
    return parse(this, raw);
  }
  beforeLayout() {
    super.beforeLayout();
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const options = this.options;
    const adapter = this._adapter;
    const unit = options.time.unit || "day";
    let { min, max, minDefined, maxDefined } = this.getUserBounds();
    function _applyBounds(bounds) {
      if (!minDefined && !isNaN(bounds.min)) {
        min = Math.min(min, bounds.min);
      }
      if (!maxDefined && !isNaN(bounds.max)) {
        max = Math.max(max, bounds.max);
      }
    }
    if (!minDefined || !maxDefined) {
      _applyBounds(this._getLabelBounds());
      if (options.bounds !== "ticks" || options.ticks.source !== "labels") {
        _applyBounds(this.getMinMax(false));
      }
    }
    min = isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
    max = isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
    this.min = Math.min(min, max - 1);
    this.max = Math.max(min + 1, max);
  }
  _getLabelBounds() {
    const arr = this.getLabelTimestamps();
    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;
    if (arr.length) {
      min = arr[0];
      max = arr[arr.length - 1];
    }
    return {
      min,
      max
    };
  }
  buildTicks() {
    const options = this.options;
    const timeOpts = options.time;
    const tickOpts = options.ticks;
    const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
    if (options.bounds === "ticks" && timestamps.length) {
      this.min = this._userMin || timestamps[0];
      this.max = this._userMax || timestamps[timestamps.length - 1];
    }
    const min = this.min;
    const max = this.max;
    const ticks = _filterBetween(timestamps, min, max);
    this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
    this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? void 0 : determineMajorUnit(this._unit);
    this.initOffsets(timestamps);
    if (options.reverse) {
      ticks.reverse();
    }
    return ticksFromTimestamps(this, ticks, this._majorUnit);
  }
  afterAutoSkip() {
    if (this.options.offsetAfterAutoskip) {
      this.initOffsets(this.ticks.map((tick) => +tick.value));
    }
  }
  initOffsets(timestamps = []) {
    let start = 0;
    let end = 0;
    let first, last;
    if (this.options.offset && timestamps.length) {
      first = this.getDecimalForValue(timestamps[0]);
      if (timestamps.length === 1) {
        start = 1 - first;
      } else {
        start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
      }
      last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
      if (timestamps.length === 1) {
        end = last;
      } else {
        end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
      }
    }
    const limit = timestamps.length < 3 ? 0.5 : 0.25;
    start = _limitValue(start, 0, limit);
    end = _limitValue(end, 0, limit);
    this._offsets = {
      start,
      end,
      factor: 1 / (start + 1 + end)
    };
  }
  _generate() {
    const adapter = this._adapter;
    const min = this.min;
    const max = this.max;
    const options = this.options;
    const timeOpts = options.time;
    const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
    const stepSize = valueOrDefault(options.ticks.stepSize, 1);
    const weekday = minor === "week" ? timeOpts.isoWeekday : false;
    const hasWeekday = isNumber6(weekday) || weekday === true;
    const ticks = {};
    let first = min;
    let time, count;
    if (hasWeekday) {
      first = +adapter.startOf(first, "isoWeek", weekday);
    }
    first = +adapter.startOf(first, hasWeekday ? "day" : minor);
    if (adapter.diff(max, min, minor) > 1e5 * stepSize) {
      throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
    }
    const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
    for (time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++) {
      addTick(ticks, time, timestamps);
    }
    if (time === max || options.bounds === "ticks" || count === 1) {
      addTick(ticks, time, timestamps);
    }
    return Object.keys(ticks).sort(sorter).map((x) => +x);
  }
  getLabelForValue(value) {
    const adapter = this._adapter;
    const timeOpts = this.options.time;
    if (timeOpts.tooltipFormat) {
      return adapter.format(value, timeOpts.tooltipFormat);
    }
    return adapter.format(value, timeOpts.displayFormats.datetime);
  }
  format(value, format2) {
    const options = this.options;
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const fmt = format2 || formats[unit];
    return this._adapter.format(value, fmt);
  }
  _tickFormatFunction(time, index2, ticks, format2) {
    const options = this.options;
    const formatter = options.ticks.callback;
    if (formatter) {
      return callback(formatter, [
        time,
        index2,
        ticks
      ], this);
    }
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const majorUnit = this._majorUnit;
    const minorFormat = unit && formats[unit];
    const majorFormat = majorUnit && formats[majorUnit];
    const tick = ticks[index2];
    const major = majorUnit && majorFormat && tick && tick.major;
    return this._adapter.format(time, format2 || (major ? majorFormat : minorFormat));
  }
  generateTickLabels(ticks) {
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      tick.label = this._tickFormatFunction(tick.value, i, ticks);
    }
  }
  getDecimalForValue(value) {
    return value === null ? NaN : (value - this.min) / (this.max - this.min);
  }
  getPixelForValue(value) {
    const offsets = this._offsets;
    const pos = this.getDecimalForValue(value);
    return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return this.min + pos * (this.max - this.min);
  }
  _getLabelSize(label) {
    const ticksOpts = this.options.ticks;
    const tickLabelWidth = this.ctx.measureText(label).width;
    const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
    const cosRotation = Math.cos(angle);
    const sinRotation = Math.sin(angle);
    const tickFontSize = this._resolveTickFontOptions(0).size;
    return {
      w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
      h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
    };
  }
  _getLabelCapacity(exampleTime) {
    const timeOpts = this.options.time;
    const displayFormats = timeOpts.displayFormats;
    const format2 = displayFormats[timeOpts.unit] || displayFormats.millisecond;
    const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
      exampleTime
    ], this._majorUnit), format2);
    const size = this._getLabelSize(exampleLabel);
    const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
    return capacity > 0 ? capacity : 1;
  }
  getDataTimestamps() {
    let timestamps = this._cache.data || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const metas = this.getMatchingVisibleMetas();
    if (this._normalized && metas.length) {
      return this._cache.data = metas[0].controller.getAllParsedValues(this);
    }
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
    }
    return this._cache.data = this.normalize(timestamps);
  }
  getLabelTimestamps() {
    const timestamps = this._cache.labels || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const labels = this.getLabels();
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      timestamps.push(parse(this, labels[i]));
    }
    return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
  }
  normalize(values) {
    return _arrayUnique(values.sort(sorter));
  }
};
function interpolate2(table, val, reverse) {
  let lo = 0;
  let hi = table.length - 1;
  let prevSource, nextSource, prevTarget, nextTarget;
  if (reverse) {
    if (val >= table[lo].pos && val <= table[hi].pos) {
      ({ lo, hi } = _lookupByKey(table, "pos", val));
    }
    ({ pos: prevSource, time: prevTarget } = table[lo]);
    ({ pos: nextSource, time: nextTarget } = table[hi]);
  } else {
    if (val >= table[lo].time && val <= table[hi].time) {
      ({ lo, hi } = _lookupByKey(table, "time", val));
    }
    ({ time: prevSource, pos: prevTarget } = table[lo]);
    ({ time: nextSource, pos: nextTarget } = table[hi]);
  }
  const span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
var TimeSeriesScale = class extends TimeScale {
  static id = "timeseries";
  static defaults = TimeScale.defaults;
  constructor(props) {
    super(props);
    this._table = [];
    this._minPos = void 0;
    this._tableRange = void 0;
  }
  initOffsets() {
    const timestamps = this._getTimestampsForTable();
    const table = this._table = this.buildLookupTable(timestamps);
    this._minPos = interpolate2(table, this.min);
    this._tableRange = interpolate2(table, this.max) - this._minPos;
    super.initOffsets(timestamps);
  }
  buildLookupTable(timestamps) {
    const { min, max } = this;
    const items = [];
    const table = [];
    let i, ilen, prev, curr, next;
    for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
      curr = timestamps[i];
      if (curr >= min && curr <= max) {
        items.push(curr);
      }
    }
    if (items.length < 2) {
      return [
        {
          time: min,
          pos: 0
        },
        {
          time: max,
          pos: 1
        }
      ];
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      next = items[i + 1];
      prev = items[i - 1];
      curr = items[i];
      if (Math.round((next + prev) / 2) !== curr) {
        table.push({
          time: curr,
          pos: i / (ilen - 1)
        });
      }
    }
    return table;
  }
  _generate() {
    const min = this.min;
    const max = this.max;
    let timestamps = super.getDataTimestamps();
    if (!timestamps.includes(min) || !timestamps.length) {
      timestamps.splice(0, 0, min);
    }
    if (!timestamps.includes(max) || timestamps.length === 1) {
      timestamps.push(max);
    }
    return timestamps.sort((a, b) => a - b);
  }
  _getTimestampsForTable() {
    let timestamps = this._cache.all || [];
    if (timestamps.length) {
      return timestamps;
    }
    const data = this.getDataTimestamps();
    const label = this.getLabelTimestamps();
    if (data.length && label.length) {
      timestamps = this.normalize(data.concat(label));
    } else {
      timestamps = data.length ? data : label;
    }
    timestamps = this._cache.all = timestamps;
    return timestamps;
  }
  getDecimalForValue(value) {
    return (interpolate2(this._table, value) - this._minPos) / this._tableRange;
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return interpolate2(this._table, decimal * this._tableRange + this._minPos, true);
  }
};

// ../../node_modules/react-chartjs-2/dist/index.js
var defaultDatasetIdKey = "label";
function reforwardRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function setOptions(chart, nextOptions) {
  const options = chart.options;
  if (options && nextOptions) {
    Object.assign(options, nextOptions);
  }
}
function setLabels(currentData, nextLabels) {
  currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
  let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
  const addedDatasets = [];
  currentData.datasets = nextDatasets.map((nextDataset) => {
    const currentDataset = currentData.datasets.find((dataset) => dataset[datasetIdKey] === nextDataset[datasetIdKey]);
    if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
      return {
        ...nextDataset
      };
    }
    addedDatasets.push(currentDataset);
    Object.assign(currentDataset, nextDataset);
    return currentDataset;
  });
}
function cloneData(data) {
  let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
  const nextData = {
    labels: [],
    datasets: []
  };
  setLabels(nextData, data.labels);
  setDatasets(nextData, data.datasets, datasetIdKey);
  return nextData;
}
function ChartComponent(props, ref) {
  const { height = 150, width = 300, redraw = false, datasetIdKey, type, data, options, plugins = [], fallbackContent, updateMode, ...canvasProps } = props;
  const canvasRef = (0, import_react113.useRef)(null);
  const chartRef = (0, import_react113.useRef)();
  const renderChart = () => {
    if (!canvasRef.current)
      return;
    chartRef.current = new Chart(canvasRef.current, {
      type,
      data: cloneData(data, datasetIdKey),
      options: options && {
        ...options
      },
      plugins
    });
    reforwardRef(ref, chartRef.current);
  };
  const destroyChart = () => {
    reforwardRef(ref, null);
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };
  (0, import_react113.useEffect)(() => {
    if (!redraw && chartRef.current && options) {
      setOptions(chartRef.current, options);
    }
  }, [
    redraw,
    options
  ]);
  (0, import_react113.useEffect)(() => {
    if (!redraw && chartRef.current) {
      setLabels(chartRef.current.config.data, data.labels);
    }
  }, [
    redraw,
    data.labels
  ]);
  (0, import_react113.useEffect)(() => {
    if (!redraw && chartRef.current && data.datasets) {
      setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }
  }, [
    redraw,
    data.datasets
  ]);
  (0, import_react113.useEffect)(() => {
    if (!chartRef.current)
      return;
    if (redraw) {
      destroyChart();
      setTimeout(renderChart);
    } else {
      chartRef.current.update(updateMode);
    }
  }, [
    redraw,
    options,
    data.labels,
    data.datasets,
    updateMode
  ]);
  (0, import_react113.useEffect)(() => {
    if (!chartRef.current)
      return;
    destroyChart();
    setTimeout(renderChart);
  }, [
    type
  ]);
  (0, import_react113.useEffect)(() => {
    renderChart();
    return () => destroyChart();
  }, []);
  return /* @__PURE__ */ import_react113.default.createElement("canvas", Object.assign({
    ref: canvasRef,
    role: "img",
    height,
    width
  }, canvasProps), fallbackContent);
}
var Chart2 = /* @__PURE__ */ (0, import_react113.forwardRef)(ChartComponent);
function createTypedChart(type, registerables) {
  Chart.register(registerables);
  return /* @__PURE__ */ (0, import_react113.forwardRef)((props, ref) => /* @__PURE__ */ import_react113.default.createElement(Chart2, Object.assign({}, props, {
    ref,
    type
  })));
}
var Line2 = /* @__PURE__ */ createTypedChart("line", LineController);

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/ApiAccessChart.tsx
var import_react_i18next70 = require("react-i18next");

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessPlaceholder/ApiAccessPlaceholder.tsx
var import_react_i18next68 = require("react-i18next");
var import_styled_components173 = __toESM(require("styled-components"));
var import_jsx_runtime161 = require("react/jsx-runtime");
var Container8 = (0, import_styled_components173.default)(Flex_default)`
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;
function ApiAccessPlaceholder({ message }) {
  const { t } = (0, import_react_i18next68.useTranslation)(["pages"]);
  const theme = (0, import_styled_components173.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime161.jsxs)(Container8, { p: [8, 0, 0, 0], flex: 1, w: "100%", h: "100%", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(
      Flex_default,
      {
        w: "100%",
        flex: 1,
        alignItems: "center",
        justifyContent: isMobile ? "flex-start" : "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(
          Icon_default,
          {
            name: "presentation",
            size: isMobile ? 50 : 126,
            color: theme.colors.b30
          }
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime161.jsxs)(Flex_default, { flex: 2, flexDirection: "column", justifyContent: "center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(Text_default, { lg: true, semibold: true, children: t(
        "pages:dashboardPage:portfoliosWidget:noPortfoliosPlaceholderTitle"
      ) }) }),
      /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(Flex_default, { mt: 0.5, children: /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(Text_default, { color: theme.colors.n80, children: message }) })
    ] })
  ] });
}
var ApiAccessPlaceholder_default = ApiAccessPlaceholder;

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/hooks/useContainerWidth.ts
var import_react114 = require("react");
function useContainerWidth(ref) {
  const [width, setWidth] = (0, import_react114.useState)(0);
  (0, import_react114.useLayoutEffect)(() => {
    const element = ref.current;
    if (!element)
      return;
    setWidth(element.offsetWidth);
    const observer = new window.ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === element) {
          setWidth(entry.contentRect.width);
        }
      }
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [ref.current]);
  return width;
}

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/hooks/useChartData.ts
var import_moment10 = __toESM(require("moment"));
var import_react115 = require("react");
var import_react_i18next69 = require("react-i18next");
var import_lodash24 = require("lodash");
function useChartData(list, groupOption) {
  const { t } = (0, import_react_i18next69.useTranslation)("common");
  return (0, import_react115.useMemo)(() => {
    if (groupOption === "HOURLY" /* HOURLY */) {
      const allDataPoints = list.flatMap((item) => item.dataPoints ?? []);
      const groupedByHour = (0, import_lodash24.groupBy)(
        allDataPoints,
        (dp) => (0, import_moment10.default)(dp.timestamp).format("YYYY-MM-DD HH:00")
      );
      const sortedHours = Object.keys(groupedByHour).sort();
      const aggregatedData2 = sortedHours.map((hourGroup) => {
        const pointsInGroup = groupedByHour[hourGroup];
        const totalRequests = pointsInGroup.reduce((sum, dp) => sum + (dp.requestCount || 0), 0);
        const representativeDate = (0, import_moment10.default)(pointsInGroup[0].timestamp);
        return {
          hourGroup,
          representativeDate,
          totalRequests
        };
      });
      const suggestedMax2 = Math.max(...aggregatedData2.map((d) => d.totalRequests), 0);
      const labels2 = aggregatedData2.map((d) => d.representativeDate.format("DD-MMM-YYYY HH:00"));
      const datasets2 = [
        {
          label: t("components.apiChart.requests"),
          data: aggregatedData2.map((d) => d.totalRequests),
          borderColor: "#1b75bb",
          backgroundColor: "transparent",
          pointBackgroundColor: "#293c75",
          fill: false
        }
      ];
      return {
        data: { labels: labels2, datasets: datasets2 },
        suggestedMax: suggestedMax2
      };
    }
    const formattedData = list.map((item) => {
      const date = (0, import_moment10.default)(item.endDate);
      let formattedDate;
      switch (groupOption) {
        case "WEEKLY" /* WEEKLY */:
          formattedDate = date.format("YYYY-[W]WW");
          break;
        case "MONTHLY" /* MONTHLY */:
          formattedDate = date.format("YYYY-MM");
          break;
        case "DAILY" /* DAILY */:
        default:
          formattedDate = date.format("YYYY-MM-DD");
          break;
      }
      return {
        ...item,
        formattedDate,
        momentDate: date
      };
    });
    const groupedByDate = (0, import_lodash24.groupBy)(formattedData, "formattedDate");
    const sortedDates = Object.keys(groupedByDate).sort();
    const aggregatedData = sortedDates.map((dateGroup) => {
      const itemsInGroup = groupedByDate[dateGroup];
      const totalRequests = itemsInGroup.reduce((sum, item) => sum + (item.totalRequests || 0), 0);
      const representativeDate = itemsInGroup[0].momentDate;
      return {
        dateGroup,
        representativeDate,
        totalRequests
      };
    });
    const suggestedMax = Math.max(...aggregatedData.map((d) => d.totalRequests), 0);
    const labels = aggregatedData.map((d) => {
      switch (groupOption) {
        case "WEEKLY" /* WEEKLY */:
          return d.representativeDate.clone().startOf("isoWeek").format("DD-MMM-YYYY");
        case "MONTHLY" /* MONTHLY */:
          return d.representativeDate.format("MMM YYYY");
        case "DAILY" /* DAILY */:
        default:
          return d.representativeDate.format("DD-MMM-YYYY");
      }
    });
    const datasets = [
      {
        label: t("components.apiChart.requests"),
        data: aggregatedData.map((d) => d.totalRequests),
        borderColor: "#1b75bb",
        backgroundColor: "transparent",
        pointBackgroundColor: "#293c75",
        fill: false
      }
    ];
    return {
      data: { labels, datasets },
      suggestedMax
    };
  }, [list, groupOption, t]);
}

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/ApiAccessChart.tsx
var import_jsx_runtime162 = require("react/jsx-runtime");
Chart.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  index,
  plugin_tooltip,
  plugin_title
);
var GroupOptionEnum = /* @__PURE__ */ ((GroupOptionEnum2) => {
  GroupOptionEnum2["HOURLY"] = "HOURLY";
  GroupOptionEnum2["DAILY"] = "DAILY";
  GroupOptionEnum2["WEEKLY"] = "WEEKLY";
  GroupOptionEnum2["MONTHLY"] = "MONTHLY";
  return GroupOptionEnum2;
})(GroupOptionEnum || {});
var ChartContainer = (0, import_styled_components174.default)(Flex_default)`
  width: 100%;
  min-width: 0;
  @media ${({ theme }) => theme.devices.mobile} {
    overflow-x: scroll;
  }
`;
var getChartOptions = (suggestedMax) => ({
  responsive: true,
  aspectRatio: 2,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      mode: "index"
    }
  },
  interaction: {
    mode: "nearest",
    axis: "x",
    intersect: false
  },
  scales: {
    y: {
      suggestedMin: 0,
      suggestedMax: Math.max(suggestedMax + Math.round(suggestedMax * 0.3), 2)
    }
  }
});
function ApiAccessChart({
  fetchFunction
}) {
  const { t } = (0, import_react_i18next70.useTranslation)(["pages"]);
  const { state: filterState } = (0, import_react116.useContext)(FilterContext);
  const { dateRange, groupOption } = filterState;
  const chartContainerRef = (0, import_react116.useRef)(null);
  const containerWidth = useContainerWidth(chartContainerRef);
  const { data: fetchData, loading } = fetchFunction(dateRange);
  const { data, suggestedMax } = useChartData(fetchData, groupOption);
  if (loading) {
    return /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
      Flex_default,
      {
        minHeight: "200px",
        w: "100%",
        justifyContent: "center",
        alignItems: "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(Spinner_default, {})
      }
    );
  }
  if (fetchData.length === 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
      ApiAccessPlaceholder_default,
      {
        message: t(
          "pages:dashboardPage:portfoliosWidget:noPortfoliosPlaceholderMatches"
        )
      }
    );
  }
  return /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(ChartContainer, { w: "100%", ref: chartContainerRef, children: /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
    Line2,
    {
      data,
      options: getChartOptions(suggestedMax)
    },
    containerWidth
  ) });
}
var ApiAccessChart_default = ApiAccessChart;

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessHeader/ApiAccessHeader.tsx
var import_react117 = require("react");
var import_react_i18next71 = require("react-i18next");
var import_styled_components175 = require("styled-components");
var import_lodash25 = require("lodash");
var import_styled_components176 = __toESM(require("styled-components"));
var import_jsx_runtime163 = require("react/jsx-runtime");
var PeriodButton2 = (0, import_styled_components176.default)(Button_default)`
  border-radius: 0px;
  background-color: ${({ theme, active }) => active && theme.colors.b20};
  justify-content: left;
  white-space: nowrap;

  & p {
    color: ${({ theme }) => theme.colors.n90} !important;
  }
  :hover {
    background-color: ${({ theme }) => theme.colors.b20};
  }
`;
function ApiAccessHeader({
  title,
  hidePeriodTypes
}) {
  const { t } = (0, import_react_i18next71.useTranslation)(["pages", "common"]);
  const theme = (0, import_styled_components175.useTheme)();
  const { setFilterState } = (0, import_react117.useContext)(FilterContext);
  (0, import_react117.useContext)(ColorContext);
  const periodOptions = Object.values(GroupOptionEnum);
  const [type, setType] = (0, import_react117.useState)("DAILY");
  return /* @__PURE__ */ (0, import_jsx_runtime163.jsxs)(Flex_default, { w: "100%", pos: "sticky", children: [
    /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Flex_default, { flex: 1, children: /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Text_default, { lg: true, semibold: true, children: title }) }),
    /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Flex_default, { flex: 1, justifyContent: "flex-end", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime163.jsxs)(Flex_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Flex_default, { mr: 6, children: /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
        DatePeriodPicker_default,
        {
          placementHorizontal: "left",
          customEnabled: true,
          anchorIconProps: { ml: 1, size: 16 },
          onChange: (dateRange) => {
            setFilterState("dateRange", dateRange);
          },
          hidePeriodTypes
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
        DropDown_default,
        {
          rerender: type,
          placementHorizontal: "left",
          w: "100%",
          Anchor: ({ isOpen }) => /* @__PURE__ */ (0, import_jsx_runtime163.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", children: [
            /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Text_default, { ellipsis: true, color: theme.colors.n90, ...{ sm: true }, children: (0, import_lodash25.capitalize)(
              t(
                `common:labels.dateRangeGroups.${(0, import_lodash25.camelCase)(type)}`
              )
            ) }),
            /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
              Icon_default,
              {
                color: theme.colors.n90,
                name: isOpen ? "arrowUp" : "arrowDown",
                ...{ ml: 1, size: 16 }
              }
            )
          ] }),
          children: ({ closeDropdown }) => /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Flex_default, { flexDirection: "column", children: periodOptions.map((periodType) => /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
            PeriodButton2,
            {
              active: type === periodType,
              w: "100%",
              variation: "flat",
              onClick: () => {
                setType(periodType);
                setFilterState("groupOption", periodType);
                closeDropdown();
              },
              children: t(
                `common:labels.dateRangeGroups.${(0, import_lodash25.camelCase)(periodType)}`
              )
            },
            periodType
          )) })
        }
      )
    ] }) })
  ] });
}
var ApiAccessHeader_default = ApiAccessHeader;

// src/components/organisms/ApiAccessChartWidget/ApiAccessChartWidget.tsx
var import_jsx_runtime164 = require("react/jsx-runtime");
function ApiAccessChartWidget({
  title,
  fetchFunction,
  hidePeriodTypes
}) {
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(import_jsx_runtime164.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(FilterProvider, { children: /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(Card_default, { p: 4, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime164.jsxs)(
    Flex_default,
    {
      w: "100%",
      minHeight: 272,
      flexDirection: "column",
      overflow: isMobile ? "scroll" : "unset",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(ApiAccessHeader_default, { title, hidePeriodTypes }),
        /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(ApiAccessChart_default, { fetchFunction })
      ]
    }
  ) }) }) });
}
var ApiAccessChartWidget_default = ApiAccessChartWidget;

// src/components/organisms/DeleteModal/DeleteModal.tsx
var import_react118 = require("react");
var import_react_i18next72 = require("react-i18next");
var import_jsx_runtime165 = require("react/jsx-runtime");
function DeleteModal({
  w,
  entity,
  name,
  modalName,
  onClick,
  message,
  title,
  note,
  isLoading = false,
  colorVariation = "danger",
  showSuccessToast = true
}) {
  const translateServerResponse = useServerResponseTranslation();
  const { t: tModal } = (0, import_react_i18next72.useTranslation)("common", {
    keyPrefix: "modalDelete"
  });
  const { t: tLabels } = (0, import_react_i18next72.useTranslation)("common", {
    keyPrefix: "labels"
  });
  const { t: tM } = (0, import_react_i18next72.useTranslation)("common", {
    keyPrefix: "serverMessages"
  });
  const { isOpenCurrent, toggleModal, setPayload } = (0, import_react118.useContext)(ModalContext);
  const isOpen = isOpenCurrent[modalName];
  function closeModal() {
    setPayload(null);
    toggleModal(false, modalName);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime165.jsx)(
    Modal3,
    {
      w,
      isOpen,
      title: title ? title : tModal("title", { entity }) || "",
      onRequestClose: closeModal,
      cancelButton: {
        title: tLabels`cancel`,
        onClick: closeModal
      },
      submitButton: {
        title: tLabels`remove`,
        onClick: async () => {
          try {
            await onClick();
            if (showSuccessToast) {
              toast.success(tModal("removedToast", { entity }));
            }
          } catch (error) {
            const translateMessage = translateServerResponse(error);
            const errorMessage = translateMessage !== tM("unknown") ? translateMessage : error.message;
            toast.error(errorMessage);
          } finally {
            setPayload(null);
            toggleModal(false, modalName);
          }
        },
        colorVariation,
        isLoading
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime165.jsxs)(Flex_default, { flexDirection: "column", gap: 4, children: [
        message ? message : /* @__PURE__ */ (0, import_jsx_runtime165.jsx)(Text_default, { children: /* @__PURE__ */ (0, import_jsx_runtime165.jsx)(
          import_react_i18next72.Trans,
          {
            i18nKey: "common:modalDelete.confirmationWithName",
            values: { name, entity },
            components: { bold: /* @__PURE__ */ (0, import_jsx_runtime165.jsx)("strong", {}) }
          }
        ) }),
        note && /* @__PURE__ */ (0, import_jsx_runtime165.jsx)(Box_default, { mt: 2, children: /* @__PURE__ */ (0, import_jsx_runtime165.jsxs)(Text_default, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime165.jsx)("strong", { children: tModal("note") }),
          " ",
          note
        ] }) })
      ] })
    }
  );
}
var DeleteModal_default = DeleteModal;

// src/components/organisms/TableWitPagination/TableWitPagination.tsx
var import_styled_components177 = require("styled-components");
var import_jsx_runtime166 = require("react/jsx-runtime");
function TableWithPagination({
  tableProps,
  paginationProps: {
    countPerPage,
    label,
    nextButtonLabel,
    previousButtonLabel,
    showPagination = true
  },
  overflow,
  ...args
}) {
  const theme = (0, import_styled_components177.useTheme)();
  const { data } = tableProps;
  return /* @__PURE__ */ (0, import_jsx_runtime166.jsx)(Flex_default, { flexDirection: "column", ...args, children: /* @__PURE__ */ (0, import_jsx_runtime166.jsxs)(Flex_default, { flexDirection: "column", flex: 1, w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime166.jsx)(ScrollDragable_default, { children: /* @__PURE__ */ (0, import_jsx_runtime166.jsx)(Table_default, { ...tableProps }) }),
    /* @__PURE__ */ (0, import_jsx_runtime166.jsxs)(
      Flex_default,
      {
        flex: 1,
        w: "100%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: showPagination ? "space-between" : "flex-end",
        my: 4,
        pl: 6,
        pr: 2,
        children: [
          showPagination && /* @__PURE__ */ (0, import_jsx_runtime166.jsx)(PaginationInfoLabel, { label, color: theme.colors.n70 }),
          data?.length ? /* @__PURE__ */ (0, import_jsx_runtime166.jsx)(
            Pagination_default,
            {
              countPerPage,
              previousButtonLabel,
              nextButtonLabel
            }
          ) : null
        ]
      }
    )
  ] }) });
}
var TableWitPagination_default = TableWithPagination;

// src/components/organisms/SideBar/SideBar.tsx
var import_styled_components178 = __toESM(require("styled-components"));
var import_dash_common49 = require("dash-common");
var import_jsx_runtime167 = require("react/jsx-runtime");
var RightPanelStyle = (0, import_styled_components178.default)(Flex_default)`
  position: fixed;
  min-height: calc(100vh - 50px);
  background-color: ${({ theme, variation }) => variation === "primary" ? theme.colors.white : theme.colors.b10};
  border-right: ${({ variation, theme }) => variation === "primary" ? `1px solid ${theme.colors.n30}` : "none"};

  @media ${({ theme }) => `${theme.devices.tablet}, ${theme.devices.mobile}`} {
    min-height: 56px;
    overflow: auto;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme }) => theme.shadows.sidebarShadow};
    transform: ${({ $isHidden }) => $isHidden ? "translateY(100%)" : "translateY(0)"};
    transition: transform 0.3s ease-in-out;
    will-change: transform;
  }
`;
var ButtonStyle4 = (0, import_styled_components178.default)(Button_default)`
  @media ${({ theme }) => `${theme.devices.tablet}, ${theme.devices.mobile}`} {
    justify-content: center;
    & > div {
      flex-direction: column;
    }
    border-radius: 0;
    height: 56px;
  }
  text-align: left;
  svg {
    width: 24px;
    ${({ $iconSize }) => $iconSize ? `transform: scale(${$iconSize / 16});` : ""}
  }
  @media ${({ theme }) => `${theme.devices.laptop}, ${theme.devices.desktop}`} {
    justify-content: flex-start;
    height: 100%;
  }
  white-space: nowrap;
  ${({ transparent: transparent2, isActive }) => transparent2 && !isActive && "background-color: transparent"}

  ${({ isActive, theme }) => isActive && `&, :hover {
      background-color: ${theme.colors.b50};
      color: ${theme.colors.white};
      p {
        color: ${theme.colors.white};
      }
    }`}
`;
var StyledWrapper6 = import_styled_components178.default.div`
  width: 248px;

  @media ${({ theme }) => `${theme.devices.tablet}, ${theme.devices.mobile}`} {
    width: 100%;
    position: fixed;
    z-index: 100;
    bottom: 0;
  }
`;
function Sidebar({ items, variation = "primary", forceVisible, dataTour }) {
  const {
    devices: { isTablet, isMobile }
  } = useScreenResolution();
  const isResponsive = isTablet || isMobile;
  const scrollDirection = useScrollDirection();
  const isHidden = !forceVisible && isResponsive && scrollDirection === "down";
  return /* @__PURE__ */ (0, import_jsx_runtime167.jsx)(StyledWrapper6, { $isHidden: isHidden, children: /* @__PURE__ */ (0, import_jsx_runtime167.jsx)(
    RightPanelStyle,
    {
      px: [0, 0, 4, 4],
      w: ["100%", "100%", 248, 248],
      flexDirection: "column",
      variation,
      $isHidden: isHidden,
      "data-tour": dataTour,
      children: /* @__PURE__ */ (0, import_jsx_runtime167.jsx)(Flex_default, { flex: 1, flexDirection: isResponsive ? "row" : "column", w: "100%", mt: [0, 0, 7, 7], children: items.map(({ icon, iconSize, label, onClick, isActive, disabled = false }) => /* @__PURE__ */ (0, import_jsx_runtime167.jsx)(
        ButtonStyle4,
        {
          disabled,
          icon,
          p: [2, 2, 3, 3],
          w: "100%",
          mt: [0, 0, 3, 3],
          variation: "flat",
          iconProps: { px: 1, size: 16, mb: [1, 1, 0, 0] },
          $iconSize: iconSize,
          onClick,
          isActive,
          transparent: variation === "secondary",
          sm: isResponsive,
          children: label
        },
        (0, import_dash_common49.RandomId)()
      )) })
    }
  ) });
}
var SideBar_default = Sidebar;

// src/components/organisms/Slideshow/Slideshow.tsx
var import_react119 = require("react");
var import_react_i18next74 = require("react-i18next");
var import_styled_components182 = require("styled-components");

// src/components/organisms/Slideshow/components/Thumbnail/Thumbnail.tsx
var import_react_i18next73 = require("react-i18next");
var import_dash_common50 = require("dash-common");
var import_styled_components180 = require("styled-components");

// src/components/organisms/Slideshow/components/Thumbnail/Thumbnail.styles.ts
var import_styled_components179 = __toESM(require("styled-components"));
var StyledPreviewButton = (0, import_styled_components179.default)(Button_default)`
  display: none;
  position: absolute;
  bottom: ${({ theme }) => theme.space * 2}px;
  right: ${({ theme }) => theme.space * 2}px;
`;
var StyledMainButton = (0, import_styled_components179.default)(Badge_default)`
  position: absolute;
  display: ${({ isMain }) => isMain ? "flex" : "none"};
  border-radius: ${({ theme }) => theme.space * 4}px;
  top: ${({ theme }) => theme.space * 2}px;
  left: ${({ theme }) => theme.space * 2}px;
`;
var ThumbnailWrapper3 = (0, import_styled_components179.default)(Box_default)`
  position: relative;
  border-radius: ${({ theme }) => theme.space * 2}px;
  background-color: ${({ theme }) => theme.colors.n30};
  cursor: pointer;

  :hover {
    & > :not(:first-child) {
      display: flex;
    }
  }
`;
var StyledImage4 = (0, import_styled_components179.default)(Image_default)`
  height: 100%;
  border-radius: 0;
  width: 100%;
`;

// src/components/organisms/Slideshow/components/Thumbnail/Thumbnail.tsx
var import_jsx_runtime168 = require("react/jsx-runtime");
var ViewComponent = ({ file }) => {
  const theme = (0, import_styled_components180.useTheme)();
  const isVideo = import_dash_common50.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.VIDEOS.includes(file.type);
  const isImage = import_dash_common50.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type);
  if (isVideo) {
    return /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(Video_default, { src: file.thumbnailFileUrl || file.publicUrl });
  }
  if (isImage) {
    return /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(StyledImage4, { src: file.thumbnailFileUrl || file.publicUrl, alt: file.name, fit: "cover" });
  }
  if (import_dash_common50.ALLOWED_MEDIA_TYPE_MIMES.pdf === file.type) {
    return /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(FileTypeIcon_default, { file });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(Icon_default, { name: "filePlaceholder", size: 45, color: theme.colors.n20 });
};
var Thumbnail2 = ({ file, openPreview, setMain, isMain }) => {
  const { t } = (0, import_react_i18next73.useTranslation)("pages");
  const isVideo = import_dash_common50.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.VIDEOS.includes(file.type);
  const isImage = import_dash_common50.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type);
  return /* @__PURE__ */ (0, import_jsx_runtime168.jsxs)(ThumbnailWrapper3, { py: 9.25, w: 224, h: 212, pos: "relative", children: [
    /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(Flex_default, { justifyContent: "center", alignItems: "center", w: "100%", h: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(ViewComponent, { file }) }),
    setMain && (isImage || isVideo) && /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(
      StyledMainButton,
      {
        semibold: true,
        isMain,
        onClick: () => setMain(file._id),
        title: t("propertyPage.main")
      }
    ),
    openPreview && /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(StyledPreviewButton, { square: true, variation: "primary", onClick: () => openPreview(file._id), children: /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(Icon_default, { name: "show" }) })
  ] });
};
var Thumbnail_default2 = Thumbnail2;

// src/components/organisms/Slideshow/Slideshow.styles.ts
var import_styled_components181 = __toESM(require("styled-components"));
var StyledList2 = (0, import_styled_components181.default)(ListWithPagination_default)`
  & > div:first-child {
    padding: 0;
    padding-bottom: 8px;
  }

  & > div:last-child {
    padding: 0;
  }
`;
var EmptyContainer = (0, import_styled_components181.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  border: 1px solid ${({ theme }) => theme.colors.n30};
  text-align: center;
`;

// src/components/organisms/Slideshow/Slideshow.tsx
var import_jsx_runtime169 = require("react/jsx-runtime");
var Slideshow = ({
  files,
  paginationProps,
  setMainFile,
  mainFileId,
  onDownloadButtonClick,
  loading,
  onItemDrop,
  ...args
}) => {
  const theme = (0, import_styled_components182.useTheme)();
  const { t } = (0, import_react_i18next74.useTranslation)("pages");
  const [fileIdToOpen, setFileIdToOpen] = (0, import_react119.useState)("");
  return /* @__PURE__ */ (0, import_jsx_runtime169.jsxs)(Box_default, { ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(
      FilePreviewModal_default,
      {
        isOpened: !!fileIdToOpen,
        onClose: () => setFileIdToOpen(""),
        files,
        onDownloadButtonClick,
        defaultIndex: files.findIndex((item) => item._id === fileIdToOpen)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(Box_default, { mb: 8, children: /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(Text_default, { semibold: true, lg: true, children: t("propertyPage.slideshow") }) }),
    files.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(
      StyledList2,
      {
        mt: 8,
        listProps: {
          data: files,
          flexWrap: "wrap",
          onItemDrop,
          isDraggable: true,
          gap: 40,
          loading
        },
        paginationProps,
        children: (file) => /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(
          Thumbnail_default2,
          {
            file,
            openPreview: setFileIdToOpen,
            isMain: file._id === mainFileId,
            setMain: setMainFile
          }
        )
      }
    ) : /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(EmptyContainer, { alignItems: "center", h: 240, justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(Box_default, { w: 440, children: /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(Text_default, { color: theme.colors.n80, children: t("propertyPage.noFilesPlaceholder") }) }) })
  ] });
};
var Slideshow_default = Slideshow;

// src/components/organisms/SlideshowPreview/SlideshowPreview.tsx
var import_react122 = require("react");
var import_styled_components188 = require("styled-components");

// src/components/organisms/SlideshowPreview/components/FullPageImageCarousel/FullPageImageCarousel.tsx
var import_react120 = require("react");
var import_lodash26 = require("lodash");
var import_styled_components184 = require("styled-components");
var import_react_i18next75 = require("react-i18next");

// src/components/organisms/SlideshowPreview/components/FullPageImageCarousel/FullPageImageCarousel.styles.ts
var import_styled_components183 = __toESM(require("styled-components"));
var Overlay3 = import_styled_components183.default.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(20, 20, 20, 0.95);
  z-index: 101;
  display: ${({ $isOpen }) => $isOpen ? "flex" : "none"};
  flex-direction: column;
  opacity: ${({ $isOpen }) => $isOpen ? 1 : 0};
  transition: opacity 0.2s ease;
`;
var TopBar2 = import_styled_components183.default.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 16px;
`;
var CloseButton4 = import_styled_components183.default.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
var ContentArea2 = import_styled_components183.default.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;
var NavigationButton = import_styled_components183.default.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${({ $direction }) => $direction === "left" ? "24px" : "auto"};
  right: ${({ $direction }) => $direction === "right" ? "24px" : "auto"};
  background: none;
  border: none;
  cursor: pointer;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  z-index: 10;

  &:hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.1);
  }

  /* Tablet/small laptop: reduced padding and closer to edges */
  @media (min-width: 769px) and (max-width: 1279px) {
    padding: 12px;
    left: ${({ $direction }) => $direction === "left" ? "4px" : "auto"};
    right: ${({ $direction }) => $direction === "right" ? "4px" : "auto"};
  }

  /* Remove hover effect on mobile and also when active (being clicked) */
  @media (max-width: 768px) {
    &:hover:not(:disabled) {
      background-color: transparent;
    }

    &:active:not(:disabled) {
      background-color: transparent;
    }

    left: ${({ $direction }) => $direction === "left" ? "0px" : "auto"};
    right: ${({ $direction }) => $direction === "right" ? "0px" : "auto"};
    padding: 12px;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;
var DesktopCarouselTrack = import_styled_components183.default.div`
  display: flex;
  width: 100%;
  height: 100%;
  transform: translateX(-${({ $currentIndex }) => $currentIndex * 100}%);
  transition: ${({ $hasMounted }) => $hasMounted ? "transform 0.7s ease-out" : "none"};
`;
var DesktopCarouselSlide = import_styled_components183.default.div`
  min-width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 120px 60px 120px;
`;
var MobileCarouselTrack = import_styled_components183.default.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */

  /* Hide scrollbar for Chrome, Safari, Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`;
var MobileCarouselSlide = import_styled_components183.default.div`
  flex: 0 0 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;
`;
var StyledImage5 = import_styled_components183.default.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  user-select: none;
`;
var ContentAreaIdx = (0, import_styled_components183.default)(ContentArea2)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  max-height: 900px;
  align-items: center;
  justify-content: center;

  /* Mobile: use smaller max-height */
  @media (max-width: 768px) {
    max-height: 650px;
  }
`;

// src/components/organisms/SlideshowPreview/components/FullPageImageCarousel/FullPageImageCarousel.tsx
var import_jsx_runtime170 = require("react/jsx-runtime");
var SCROLL_DEBOUNCE_MS = 50;
var FullPageImageCarousel = ({
  isOpen,
  onClose,
  files,
  defaultIndex,
  maxNavigableIndex,
  onNavigationRestricted,
  isIdxView = false
}) => {
  const { t } = (0, import_react_i18next75.useTranslation)("common");
  const theme = (0, import_styled_components184.useTheme)();
  const previousIsOpenRef = (0, import_react120.useRef)(isOpen);
  const firstRenderRef = (0, import_react120.useRef)(true);
  const pendingIndexRef = (0, import_react120.useRef)(null);
  const trackRef = (0, import_react120.useRef)(null);
  const [trackReady, setTrackReady] = (0, import_react120.useState)(false);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const [currentIndex, setCurrentIndex] = (0, import_react120.useState)(() => {
    if ((0, import_lodash26.isNumber)(defaultIndex) && defaultIndex >= 0) {
      return defaultIndex;
    }
    return 0;
  });
  const [hasMounted, setHasMounted] = (0, import_react120.useState)(false);
  const [arrowIndex, setArrowIndex] = (0, import_react120.useState)(currentIndex);
  const modalTriggeredRef = (0, import_react120.useRef)(false);
  (0, import_react120.useEffect)(() => {
    if (!isMobile) {
      setArrowIndex(currentIndex);
    }
  }, [currentIndex, isMobile]);
  const handleScrollImmediate = (0, import_react120.useCallback)(() => {
    if (!trackRef.current || !isMobile)
      return;
    const scrollLeft = trackRef.current.scrollLeft;
    const slideWidth = trackRef.current.offsetWidth;
    const newIndex = Math.round(scrollLeft / slideWidth);
    setArrowIndex(newIndex);
    if (maxNavigableIndex !== void 0 && newIndex > maxNavigableIndex && !modalTriggeredRef.current) {
      modalTriggeredRef.current = true;
      onNavigationRestricted?.();
      onClose();
    }
  }, [isMobile, maxNavigableIndex, onNavigationRestricted, onClose]);
  (0, import_react120.useEffect)(() => {
    const track = trackRef.current;
    if (!track || !isMobile || !trackReady)
      return;
    let timeoutId;
    const debouncedHandleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleScrollImmediate, SCROLL_DEBOUNCE_MS);
    };
    track.addEventListener("scroll", debouncedHandleScroll, { passive: true });
    return () => {
      track.removeEventListener("scroll", debouncedHandleScroll);
      clearTimeout(timeoutId);
    };
  }, [isMobile, trackReady, handleScrollImmediate]);
  (0, import_react120.useEffect)(() => {
    const wasClosed = previousIsOpenRef.current === false && isOpen === true;
    if (wasClosed) {
      setTrackReady(false);
      modalTriggeredRef.current = false;
      if ((0, import_lodash26.isNumber)(defaultIndex) && defaultIndex >= 0) {
        pendingIndexRef.current = defaultIndex;
        setCurrentIndex(defaultIndex);
        setArrowIndex(defaultIndex);
        if (isMobile && trackRef.current) {
          setTimeout(() => {
            trackRef.current?.scrollTo({
              left: defaultIndex * trackRef.current.offsetWidth,
              behavior: "auto"
            });
          }, 0);
        }
        setTimeout(() => {
          pendingIndexRef.current = null;
        }, 0);
      }
      firstRenderRef.current = true;
      setHasMounted(false);
      setTimeout(() => {
        firstRenderRef.current = false;
        setHasMounted(true);
      }, 100);
    }
    previousIsOpenRef.current = isOpen;
  }, [isOpen, defaultIndex, isMobile]);
  const handlePrevious = (0, import_react120.useCallback)(() => {
    const effectiveIndex = isMobile ? arrowIndex : currentIndex;
    let newIndex;
    if (effectiveIndex > 0) {
      newIndex = effectiveIndex - 1;
    } else {
      newIndex = files.length - 1;
    }
    if (isMobile && trackRef.current) {
      trackRef.current.scrollTo({
        left: newIndex * trackRef.current.offsetWidth,
        behavior: "smooth"
      });
    }
    setArrowIndex(newIndex);
    setCurrentIndex(newIndex);
  }, [currentIndex, arrowIndex, isMobile, files.length]);
  const handleNext = (0, import_react120.useCallback)(() => {
    const effectiveIndex = isMobile ? arrowIndex : currentIndex;
    if (maxNavigableIndex !== void 0 && effectiveIndex >= maxNavigableIndex) {
      onNavigationRestricted?.();
      onClose();
      return;
    }
    let newIndex;
    if (effectiveIndex < files.length - 1) {
      newIndex = effectiveIndex + 1;
    } else {
      newIndex = 0;
    }
    if (isMobile && trackRef.current) {
      trackRef.current.scrollTo({
        left: newIndex * trackRef.current.offsetWidth,
        behavior: "smooth"
      });
    }
    setArrowIndex(newIndex);
    setCurrentIndex(newIndex);
  }, [
    currentIndex,
    arrowIndex,
    files.length,
    maxNavigableIndex,
    onNavigationRestricted,
    onClose,
    isMobile
  ]);
  const handleKeyDown = (0, import_react120.useCallback)(
    (e) => {
      if (e.key === "Escape") {
        onClose();
      } else if (e.key === "ArrowLeft") {
        handlePrevious();
      } else if (e.key === "ArrowRight") {
        handleNext();
      }
    },
    [onClose, handlePrevious, handleNext]
  );
  (0, import_react120.useEffect)(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
    return void 0;
  }, [isOpen, handleKeyDown]);
  if (!files.length || !isOpen) {
    return null;
  }
  const hasPrevious = files.length > 1;
  const hasNext = files.length > 1;
  const arrowIconSize = 48;
  const displayIndex = pendingIndexRef.current !== null ? pendingIndexRef.current : currentIndex;
  const ContentAreaComponent = isIdxView ? ContentAreaIdx : ContentArea2;
  return /* @__PURE__ */ (0, import_jsx_runtime170.jsxs)(Overlay3, { $isOpen: isOpen, children: [
    /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(TopBar2, { children: /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(CloseButton4, { onClick: onClose, "aria-label": t("labels.close") || "", children: /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(Icon_default, { name: "close", size: 28, color: theme.colors.white }) }) }),
    /* @__PURE__ */ (0, import_jsx_runtime170.jsxs)(ContentAreaComponent, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(
        NavigationButton,
        {
          $direction: "left",
          onClick: handlePrevious,
          disabled: !hasPrevious,
          "aria-label": t("components.slideshow.previousImage") || "",
          children: /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(Icon_default, { name: "chevronLeft", size: arrowIconSize, color: theme.colors.white })
        }
      ),
      isMobile ? /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(
        MobileCarouselTrack,
        {
          ref: (node) => {
            trackRef.current = node;
            if (node && !trackReady) {
              setTrackReady(true);
            }
          },
          $currentIndex: currentIndex,
          children: files.map((file, index2) => /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(MobileCarouselSlide, { children: /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(
            StyledImage5,
            {
              src: file.publicUrl,
              alt: file.name,
              loading: index2 === displayIndex || index2 === displayIndex - 1 || index2 === displayIndex + 1 ? "eager" : "lazy",
              decoding: "async"
            }
          ) }, file._id || index2))
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(DesktopCarouselTrack, { $currentIndex: displayIndex, $hasMounted: hasMounted, children: files.map((file, index2) => /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(DesktopCarouselSlide, { children: /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(
        StyledImage5,
        {
          src: file.publicUrl,
          alt: file.name,
          loading: index2 === displayIndex || index2 === displayIndex - 1 || index2 === displayIndex + 1 ? "eager" : "lazy",
          decoding: "async"
        }
      ) }, file._id || index2)) }),
      /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(
        NavigationButton,
        {
          $direction: "right",
          onClick: handleNext,
          disabled: !hasNext,
          "aria-label": t("components.slideshow.nextImage") || "",
          children: /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(Icon_default, { name: "chevronRight", size: arrowIconSize, color: theme.colors.white })
        }
      )
    ] })
  ] });
};
var FullPageImageCarousel_default = FullPageImageCarousel;

// src/components/organisms/SlideshowPreview/components/MobileImageCarousel/MobileImageCarousel.tsx
var import_react121 = require("react");
var import_styled_components186 = require("styled-components");

// src/components/organisms/SlideshowPreview/components/MobileImageCarousel/MobileImageCarousel.styles.ts
var import_styled_components185 = __toESM(require("styled-components"));
var CarouselContainer = (0, import_styled_components185.default)(Box_default)`
  position: relative;
  width: 100%;
  overflow: hidden;
`;
var CarouselTrack = import_styled_components185.default.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  /* Make focusable without outline */
  &:focus {
    outline: none;
  }

  /* Hide scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;
var CarouselSlide = import_styled_components185.default.div`
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  position: relative;
`;
var CurrentImageIndicator = (0, import_styled_components185.default)(Flex_default)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.n90, 60)};
  border-radius: ${({ theme }) => theme.space}px;
  bottom: ${({ theme }) => theme.space * 4}px;
  right: ${({ theme }) => theme.space * 4}px;
  z-index: 1;
`;

// src/components/organisms/SlideshowPreview/components/MobileImageCarousel/MobileImageCarousel.tsx
var import_jsx_runtime171 = require("react/jsx-runtime");
var SCROLL_DEBOUNCE_MS2 = 50;
var SCROLL_ANIMATION_DURATION_MS = 300;
var MODAL_COOLDOWN_MS = 1e3;
var MobileImageCarousel = ({
  files,
  totalCount,
  borderRadius,
  h = 376,
  maxNavigableIndex,
  onNavigationRestricted,
  onItemClick,
  ...args
}) => {
  const theme = (0, import_styled_components186.useTheme)();
  const [currentIndex, setCurrentIndex] = (0, import_react121.useState)(0);
  const [restrictionState, setRestrictionState] = (0, import_react121.useState)("idle");
  const trackRef = (0, import_react121.useRef)(null);
  const touchStartPosRef = (0, import_react121.useRef)(null);
  const validFiles = (0, import_react121.useMemo)(
    () => files.filter((file) => file !== void 0 && file !== null),
    [files]
  );
  const renderableFiles = maxNavigableIndex !== void 0 ? validFiles.slice(0, maxNavigableIndex + 2) : validFiles;
  const handleScroll = (0, import_react121.useCallback)(() => {
    if (!trackRef.current)
      return;
    const scrollLeft = trackRef.current.scrollLeft;
    const slideWidth = trackRef.current.offsetWidth;
    const newIndex = Math.round(scrollLeft / slideWidth);
    if (maxNavigableIndex !== void 0 && newIndex > maxNavigableIndex && onNavigationRestricted) {
      if (restrictionState === "idle") {
        setRestrictionState("triggered");
        trackRef.current.scrollTo({
          left: maxNavigableIndex * slideWidth,
          behavior: "smooth"
        });
        setCurrentIndex(maxNavigableIndex);
        requestAnimationFrame(() => {
          trackRef.current?.focus({ preventScroll: true });
        });
        setTimeout(() => {
          onNavigationRestricted();
        }, SCROLL_ANIMATION_DURATION_MS);
        setTimeout(() => {
          setRestrictionState("idle");
        }, MODAL_COOLDOWN_MS);
      }
      return;
    }
    setCurrentIndex(newIndex);
  }, [maxNavigableIndex, onNavigationRestricted, restrictionState]);
  const handleTouchStart = (0, import_react121.useCallback)((e) => {
    touchStartPosRef.current = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY
    };
  }, []);
  const handleTouchEnd = (0, import_react121.useCallback)((e, index2) => {
    if (!touchStartPosRef.current || !onItemClick)
      return;
    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;
    const diffX = Math.abs(touchEndX - touchStartPosRef.current.x);
    const diffY = Math.abs(touchEndY - touchStartPosRef.current.y);
    if (diffX < 10 && diffY < 10) {
      onItemClick(index2);
    }
    touchStartPosRef.current = null;
  }, [onItemClick]);
  const handleClick = (0, import_react121.useCallback)((_e, index2) => {
    if (!touchStartPosRef.current && onItemClick) {
      onItemClick(index2);
    }
  }, [onItemClick]);
  (0, import_react121.useEffect)(() => {
    const track = trackRef.current;
    if (!track)
      return;
    let timeoutId;
    const debouncedHandleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleScroll, SCROLL_DEBOUNCE_MS2);
    };
    track.addEventListener("scroll", debouncedHandleScroll, { passive: true });
    return () => {
      track.removeEventListener("scroll", debouncedHandleScroll);
      clearTimeout(timeoutId);
    };
  }, [handleScroll]);
  return /* @__PURE__ */ (0, import_jsx_runtime171.jsxs)(CarouselContainer, { h, ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime171.jsx)(CarouselTrack, { ref: trackRef, tabIndex: -1, children: renderableFiles.map((file, index2) => /* @__PURE__ */ (0, import_jsx_runtime171.jsx)(
      CarouselSlide,
      {
        onTouchStart: handleTouchStart,
        onTouchEnd: (e) => handleTouchEnd(e, index2),
        onClick: (e) => handleClick(e, index2),
        style: { cursor: onItemClick ? "pointer" : "default" },
        children: /* @__PURE__ */ (0, import_jsx_runtime171.jsx)(
          Thumbnail_default,
          {
            file,
            borderRadius
          }
        )
      },
      file._id || index2
    )) }),
    totalCount > 0 && /* @__PURE__ */ (0, import_jsx_runtime171.jsx)(CurrentImageIndicator, { py: 0, px: 3, children: /* @__PURE__ */ (0, import_jsx_runtime171.jsxs)(Text_default, { semibold: true, color: theme.colors.white, children: [
      currentIndex + 1,
      " / ",
      totalCount
    ] }) })
  ] });
};
var MobileImageCarousel_default = MobileImageCarousel;

// src/components/organisms/SlideshowPreview/SlideshowPreview.styles.ts
var import_styled_components187 = __toESM(require("styled-components"));
var LeftContainer2 = (0, import_styled_components187.default)(Flex_default)`
  border-top-left-radius: ${({ theme }) => theme.space}px;
  border-bottom-left-radius: ${({ theme }) => theme.space}px;
  overflow: hidden;
`;
var RightContainer = (0, import_styled_components187.default)(Flex_default)`
  border-top-right-radius: ${({ theme }) => theme.space}px;
  border-bottom-right-radius: ${({ theme }) => theme.space}px;
  overflow: hidden;
`;
var SingleContainer = (0, import_styled_components187.default)(Flex_default)`
  & > div {
    ${({ borderRadius, theme }) => typeof borderRadius === "number" ? `border-radius: ${borderRadius}px;` : `border-radius: ${theme.space}px;`}
  }
`;

// src/components/organisms/SlideshowPreview/SlideshowPreview.tsx
var import_jsx_runtime172 = require("react/jsx-runtime");
var NARROW_CONTAINER_THRESHOLD = 1e3;
var SlideshowPreview = ({
  files: currentFiles,
  h = 376,
  totalCount,
  mainFileId,
  loading,
  maxNavigableIndex,
  onNavigationRestricted,
  borderRadius,
  topMargin,
  isIdxView = false,
  ...args
}) => {
  const theme = (0, import_styled_components188.useTheme)();
  const [fileIdToOpen, setFileIdToOpen] = (0, import_react122.useState)(-1);
  const [isNarrowContainer, setIsNarrowContainer] = (0, import_react122.useState)(false);
  const containerRef = (0, import_react122.useRef)(null);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  (0, import_react122.useEffect)(() => {
    const container = containerRef.current;
    if (!container)
      return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        setIsNarrowContainer(width < NARROW_CONTAINER_THRESHOLD);
      }
    });
    resizeObserver.observe(container);
    const initialWidth = container.getBoundingClientRect().width;
    setIsNarrowContainer(initialWidth < NARROW_CONTAINER_THRESHOLD);
    return () => {
      resizeObserver.unobserve(container);
    };
  }, []);
  const halfHeight = h / 2 - theme.space * 1.5;
  const files = (0, import_react122.useMemo)(() => {
    const copy = [...currentFiles];
    const index2 = copy.findIndex((item) => item._id === mainFileId);
    if (index2 === -1)
      return copy;
    const targetIndex = isMobile || isNarrowContainer ? 0 : 2;
    const [mainFile] = copy.splice(index2, 1);
    copy.splice(targetIndex, 0, mainFile);
    return copy;
  }, [currentFiles, mainFileId, isMobile, isNarrowContainer]);
  const onItemClick = (index2) => {
    setFileIdToOpen(files[index2] ? index2 : -1);
  };
  const createOnClickHandler = (index2) => () => {
    onItemClick(index2);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime172.jsxs)(Flex_default, { ref: containerRef, flexDirection: "row", h, pos: "relative", ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(
      FullPageImageCarousel_default,
      {
        isOpen: fileIdToOpen >= 0,
        onClose: () => setFileIdToOpen(-1),
        files,
        defaultIndex: fileIdToOpen >= 0 ? fileIdToOpen : 0,
        maxNavigableIndex,
        onNavigationRestricted,
        isIdxView
      }
    ),
    isMobile ? /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(
      MobileImageCarousel_default,
      {
        files,
        totalCount,
        borderRadius,
        h,
        w: "100%",
        maxNavigableIndex,
        onNavigationRestricted,
        onItemClick
      }
    ) : isNarrowContainer ? /* @__PURE__ */ (0, import_jsx_runtime172.jsxs)(import_jsx_runtime172.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Flex_default, { flex: 2, h, mr: 3, onClick: createOnClickHandler(0), children: /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Thumbnail_default, { file: files[0], borderRadius }) }),
      /* @__PURE__ */ (0, import_jsx_runtime172.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(LeftContainer2, { h: halfHeight, w: "100%", onClick: createOnClickHandler(1), children: /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Thumbnail_default, { file: files[1], borderRadius }) }),
        /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(LeftContainer2, { h: halfHeight, w: "100%", mt: 3, onClick: createOnClickHandler(2), children: /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(
          Thumbnail_default,
          {
            file: files[2],
            label: totalCount - 3 > 0 ? `+${totalCount - 3}` : "",
            borderRadius
          }
        ) })
      ] })
    ] }) : /* @__PURE__ */ (0, import_jsx_runtime172.jsxs)(import_jsx_runtime172.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime172.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(LeftContainer2, { h: halfHeight, w: "100%", onClick: createOnClickHandler(0), children: /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Thumbnail_default, { file: files[0], borderRadius }) }),
        /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(LeftContainer2, { h: halfHeight, w: "100%", mt: 3, onClick: createOnClickHandler(1), children: /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Thumbnail_default, { file: files[1], borderRadius }) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Flex_default, { flex: 2, h, mx: 3, onClick: createOnClickHandler(2), children: /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Thumbnail_default, { file: files[2], borderRadius }) }),
      /* @__PURE__ */ (0, import_jsx_runtime172.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(RightContainer, { h: halfHeight, w: "100%", onClick: createOnClickHandler(3), children: /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Thumbnail_default, { file: files[3], borderRadius }) }),
        /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(RightContainer, { h: halfHeight, w: "100%", mt: 3, onClick: createOnClickHandler(4), children: /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(
          Thumbnail_default,
          {
            file: files[4],
            label: totalCount - 5 > 0 ? `+${totalCount - 5}` : "",
            borderRadius
          }
        ) })
      ] })
    ] }),
    loading && /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(Spinner_default, { fullContent: true, size: 32 })
  ] });
};
var SlideshowPreview_default = SlideshowPreview;

// src/components/organisms/TableView/TableView.tsx
var import_react124 = require("react");
var import_styled_components189 = __toESM(require("styled-components"));

// src/components/organisms/TableView/context.tsx
var import_react123 = require("react");

// src/components/organisms/TableView/constants.ts
var TableViewType = /* @__PURE__ */ ((TableViewType2) => {
  TableViewType2["Table"] = "Table";
  TableViewType2["List"] = "List";
  return TableViewType2;
})(TableViewType || {});

// src/components/organisms/TableView/context.tsx
var import_jsx_runtime173 = require("react/jsx-runtime");
var TableViewContext = (0, import_react123.createContext)({
  viewType: "List" /* List */,
  setViewType: () => null
});
function TableViewProvider({ children }) {
  const [tableViewType, setTableViewType] = (0, import_react123.useState)("List" /* List */);
  return /* @__PURE__ */ (0, import_jsx_runtime173.jsx)(TableViewContext.Provider, { value: { viewType: tableViewType, setViewType: setTableViewType }, children });
}

// src/components/organisms/TableView/TableView.tsx
var import_jsx_runtime174 = require("react/jsx-runtime");
var ListStyle = (0, import_styled_components189.default)(List_default)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
  width: 100%;
`;
function TableViewToggle() {
  const { viewType, setViewType } = (0, import_react124.useContext)(TableViewContext);
  return /* @__PURE__ */ (0, import_jsx_runtime174.jsxs)(Flex_default, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(
      Button_default,
      {
        h: 40,
        square: true,
        variation: viewType === "List" /* List */ ? "primary" : "flat",
        icon: "dashboard",
        onClick: () => setViewType("List" /* List */)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(
      Button_default,
      {
        h: 40,
        square: true,
        variation: viewType === "Table" /* Table */ ? "primary" : "flat",
        icon: "list",
        onClick: () => setViewType("Table" /* Table */)
      }
    )
  ] });
}
function TableView({
  data,
  tableProps,
  placeholder,
  listProps,
  loading,
  paginationProps,
  ...args
}) {
  const { viewType } = (0, import_react124.useContext)(TableViewContext);
  const { setSortState } = (0, import_react124.useContext)(SortContext);
  const theme = (0, import_styled_components189.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  (0, import_react124.useEffect)(() => {
    setSortState({ fieldName: "name", sortOrder: 1 });
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(Flex_default, { flexDirection: "column", w: "100%", ...args, children: /* @__PURE__ */ (0, import_jsx_runtime174.jsxs)(Flex_default, { flexDirection: "column", flex: 1, w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime174.jsxs)(Box_default, { pos: "relative", w: "100%", overflow: "auto", children: [
      viewType === "Table" /* Table */ && /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(Table_default, { w: "100%", placeholder, data, ...tableProps }),
      viewType === "List" /* List */ && /* @__PURE__ */ (0, import_jsx_runtime174.jsxs)(import_jsx_runtime174.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(
          Table_default,
          {
            data,
            placeholder,
            withHeader: false,
            renderBody: () => null,
            ...tableProps
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(ListStyle, { data, grid: [153, 148, 196, 196], ...listProps, children: (item, index2) => listProps.renderItem(item, index2) })
      ] }),
      loading && /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(Spinner_default, { size: 32, fullContent: true })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime174.jsxs)(
      Flex_default,
      {
        flex: 1,
        w: "100%",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "center",
        justifyContent: "space-between",
        my: 4,
        pl: 6,
        pr: 2,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(PaginationInfoLabel, { label: paginationProps.label, color: theme.colors.n70 }),
          data?.length ? /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(
            Pagination_default,
            {
              mt: [4, 0, 0, 0],
              previousButtonLabel: paginationProps.previousButtonLabel,
              nextButtonLabel: paginationProps.nextButtonLabel
            }
          ) : null
        ]
      }
    )
  ] }) });
}
var TableView_default = TableView;

// src/components/organisms/MediaFilePreviewCard/MediaFilePreviewCard.tsx
var import_react_i18next76 = require("react-i18next");
var import_styled_components192 = require("styled-components");
var import_dash_common52 = require("dash-common");

// src/components/organisms/MediaFilePreviewCard/MediaFilePreviewCard.styles.ts
var import_styled_components190 = __toESM(require("styled-components"));
var MediaFilterItemWrapper = (0, import_styled_components190.default)(Flex_default)`
  border: 1px solid ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space * 2}px;
  cursor: pointer;
  position: relative;
  width: 100%;
`;
var ImageWrapper3 = (0, import_styled_components190.default)(Flex_default)`
  background: ${({ theme }) => theme.colors.b10};
  border-radius: ${({ theme }) => {
  const radius = theme.space * 2;
  return `${radius}px ${radius}px 0 0`;
}};
`;
var Overlay4 = (0, import_styled_components190.default)(Box_default)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  z-index: 2;
`;
var StyledTopContainer = (0, import_styled_components190.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
  bottom: unset;
  right: 12px;
  top: 12px;
  position: absolute;
  z-index: 3;
`;

// src/components/organisms/MediaFilePreviewCard/components/ViewFileContainer.tsx
var import_styled_components191 = __toESM(require("styled-components"));
var import_dash_common51 = require("dash-common");
var import_jsx_runtime175 = require("react/jsx-runtime");
var ThumbnailView = (0, import_styled_components191.default)(Image_default)`
  border-radius: 8px 8px 0 0;
`;
var ViewFileContainer = ({
  file,
  mediaType
}) => {
  const theme = (0, import_styled_components191.useTheme)();
  const isVideo = file && import_dash_common51.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.VIDEOS.includes(file.type);
  const isPdf = file?.type === import_dash_common51.ALLOWED_MEDIA_TYPE_MIMES.pdf;
  const isImage = file && import_dash_common51.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type);
  if (mediaType === import_dash_common51.MediaTypesEnum.FOLDER) {
    return /* @__PURE__ */ (0, import_jsx_runtime175.jsx)(Icon_default, { name: "mediaFolderPlaceholder", size: 96, color: theme.colors.b50Hover });
  }
  if (isVideo) {
    return /* @__PURE__ */ (0, import_jsx_runtime175.jsx)(Video_default, { src: file.publicUrl });
  }
  if (isImage) {
    return /* @__PURE__ */ (0, import_jsx_runtime175.jsx)(
      ThumbnailView,
      {
        w: "100%",
        h: "100%",
        fit: "cover",
        src: file.thumbnailFile?.publicUrl || file.publicUrl
      }
    );
  }
  if (isPdf) {
    return /* @__PURE__ */ (0, import_jsx_runtime175.jsx)(FileTypeIcon_default, { lg: true, file });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime175.jsx)(FileTypeIcon_default, { lg: true, file });
};
var ViewFileContainer_default = ViewFileContainer;

// src/components/organisms/MediaFilePreviewCard/MediaFilePreviewCard.tsx
var import_jsx_runtime176 = require("react/jsx-runtime");
var MediaFilePreviewCard = ({
  media,
  onClick,
  selectItemProps,
  ...args
}) => {
  const { t } = (0, import_react_i18next76.useTranslation)(["common", "pages"]);
  const theme = (0, import_styled_components192.useTheme)();
  const { devices } = useScreenResolution();
  const systemFolderName = useSystemFolderName();
  return /* @__PURE__ */ (0, import_jsx_runtime176.jsxs)(
    MediaFilterItemWrapper,
    {
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-between",
      ...args,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(Overlay4, { onClick }),
        /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(ImageWrapper3, { w: "100%", h: 112, justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(ViewFileContainer_default, { mediaType: media.type, file: media?.files[0] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime176.jsxs)(
          Flex_default,
          {
            flex: 1,
            flexDirection: "column",
            p: 3.5,
            alignItems: "flex-start",
            justifyContent: "space-between",
            w: "inherit",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(Flex_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(
                Text_default,
                {
                  ellipsis: true,
                  medium: devices.isDesktop || devices.isLaptop,
                  sm: devices.isMobile || devices.isTablet,
                  color: theme.colors.n90,
                  semibold: true,
                  children: media.folderName ? `${systemFolderName(media.folderName)} (${media.files.length})` : media.files.length && media.files[0].name
                }
              ) }),
              /* @__PURE__ */ (0, import_jsx_runtime176.jsxs)(
                Flex_default,
                {
                  w: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 1,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(
                      Text_default,
                      {
                        medium: devices.isDesktop || devices.isLaptop,
                        sm: devices.isMobile || devices.isTablet,
                        color: theme.colors.n70,
                        children: formatDisplayDate(media.updatedAt)
                      }
                    ),
                    /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(
                      Text_default,
                      {
                        medium: devices.isDesktop || devices.isLaptop,
                        sm: devices.isMobile || devices.isTablet,
                        color: theme.colors.n70,
                        children: (0, import_dash_common52.bytesToMBytes)(media.sizeInBytes) > 1 ? t("common:labels.mBytes", {
                          size: (0, import_dash_common52.bytesToMBytes)(media.sizeInBytes)
                        }) : t("common:labels.kBytes", {
                          size: (0, import_dash_common52.bytesToKBytes)(media.sizeInBytes)
                        })
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(StyledTopContainer, { children: selectItemProps ? /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(Checkbox_default, { onChange: selectItemProps.onSelect, checked: selectItemProps.checked }) : null })
      ]
    }
  );
};
var MediaFilePreviewCard_default = MediaFilePreviewCard;

// src/components/organisms/TableWithFlatPagination/TableWithFlatPagination.helpers.tsx
var getFlatPaginationPointsProps = (targetPaginationField, data) => {
  const points = {
    currentEndingBefore: "",
    currentStartingAfter: ""
  };
  if (data.length) {
    const firstFieldId = data[0][targetPaginationField];
    const lastFieldId = data[data.length - 1][targetPaginationField];
    if (firstFieldId) {
      points.currentEndingBefore = firstFieldId;
    }
    if (lastFieldId) {
      points.currentStartingAfter = lastFieldId;
    }
  }
  return points;
};

// src/components/organisms/TableWithFlatPagination/TableWithFlatPagination.tsx
var import_jsx_runtime177 = require("react/jsx-runtime");
function TableWithFlatPagination({
  targetPaginationField,
  tableProps,
  paginationProps,
  ...args
}) {
  const { data = [] } = tableProps;
  return /* @__PURE__ */ (0, import_jsx_runtime177.jsxs)(Flex_default, { flexDirection: "column", ...args, flex: 1, w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime177.jsx)(Table_default, { ...tableProps }),
    !!data?.length && /* @__PURE__ */ (0, import_jsx_runtime177.jsx)(
      FlatPagination_default,
      {
        w: "100%",
        alignItems: "center",
        justifyContent: "right",
        my: 4,
        pl: 6,
        pr: 2,
        ...paginationProps,
        ...getFlatPaginationPointsProps(targetPaginationField, data)
      }
    )
  ] });
}
var TableWithFlatPagination_default = TableWithFlatPagination;

// src/components/organisms/ModalWitBrokerBanner/ModalWithBrokerBanner.tsx
var import_react_modal4 = __toESM(require("react-modal"));
var import_styled_components194 = __toESM(require("styled-components"));

// src/components/organisms/ModalWitBrokerBanner/ModalWithBrokerBanner.styles.ts
var import_styled_components193 = __toESM(require("styled-components"));
var ContentWrapper2 = (0, import_styled_components193.default)(Box_default)`
  position: relative;
`;
var CloseIconContainer = (0, import_styled_components193.default)(Box_default)`
  position: absolute;
  cursor: pointer;
  top: ${({ theme }) => theme.space * 4}px;
  right: ${({ theme }) => theme.space * 4}px;
  z-index: 3;
`;

// src/components/organisms/ModalWitBrokerBanner/ModalWithBrokerBanner.tsx
var import_jsx_runtime178 = require("react/jsx-runtime");
var UnstyledModal = ({
  className,
  isOpen,
  onRequestClose,
  children,
  broker,
  closeIcon = true
}) => {
  const theme = (0, import_styled_components194.useTheme)();
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime178.jsx)(
    import_react_modal4.default,
    {
      className: contentClassName,
      overlayClassName: {
        base: overlayClassName,
        afterOpen: `${overlayClassName}--after-open`,
        beforeClose: `${overlayClassName}--before-close`
      },
      isOpen,
      onRequestClose,
      children: /* @__PURE__ */ (0, import_jsx_runtime178.jsxs)(ContentWrapper2, { children: [
        isMobile ? /* @__PURE__ */ (0, import_jsx_runtime178.jsx)(BrokersBanner_default, { variation: "vertical", broker }) : /* @__PURE__ */ (0, import_jsx_runtime178.jsx)(BrokersBanner_default, { variation: "horizontal", broker }),
        children,
        /* @__PURE__ */ (0, import_jsx_runtime178.jsx)(CloseIconContainer, { children: closeIcon && /* @__PURE__ */ (0, import_jsx_runtime178.jsx)(Icon_default, { onClick: onRequestClose, name: "close", size: 24, color: theme.colors.white }) })
      ] })
    }
  );
};
var ModalWithBrokerBanner = (0, import_styled_components194.default)(UnstyledModal)`
  &${({ className }) => className ? `.${className}` : ""}__overlay {
    position: fixed;
    inset: 0px;
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 0;
    overflow: auto;
    z-index: 100;
    padding-left: ${({ theme }) => theme.space * 4}px;
    padding-right: ${({ theme }) => theme.space * 4}px;
  }

  &${({ className }) => className ? `.${className}` : ""}__overlay--after-open {
    opacity: 1;
    transition: opacity 150ms ease-out;
  }

  &${({ className }) => className ? `.${className}` : ""}__overlay--before-close {
    opacity: 0;
  }

  &__content {
    background-color: ${({ theme }) => theme.colors.white};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 16px;
    box-sizing: border-box;
    outline: none;
    max-width: 1054px;
    width: 100%;
    margin: 265px auto 24px;

    @media ${({ theme }) => theme.devices.mobile} {
      margin-top: 165px;
    }
  }
`;
var ModalWithBrokerBanner_default = ModalWithBrokerBanner;

// src/components/organisms/PropertiesTable/PropertiesTable.tsx
var import_react130 = require("react");
var import_react_i18next82 = require("react-i18next");

// src/components/organisms/PropertiesTable/PropertiesTableActions/PropertiesTableActions.tsx
var import_noop = __toESM(require("lodash/noop"));
var import_isEmpty = __toESM(require("lodash/isEmpty"));
var import_camelCase = __toESM(require("lodash/camelCase"));
var import_startCase = __toESM(require("lodash/startCase"));
var import_react_i18next81 = require("react-i18next");
var import_dash_common56 = require("dash-common");
var import_react129 = require("react");
var import_styled_components196 = __toESM(require("styled-components"));

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/AddPropertyModal.tsx
var import_react_i18next80 = require("react-i18next");
var import_react128 = require("react");
var import_dash_common55 = require("dash-common");

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/constants/constants.ts
var NON_MANUAL_FIELDS = ["name" /* Name */, "primaryOrganizationId" /* PrimaryOrganizationId */, "place" /* Place */];

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/hooks/useValidation.ts
var import_react125 = require("react");
var import_react_i18next77 = require("react-i18next");
var import_dash_common53 = require("dash-common");
var useValidation2 = () => {
  const { formState, errorHandlers } = (0, import_react125.useContext)(FormContext);
  const { t } = (0, import_react_i18next77.useTranslation)(["forms", "common", "pages"]);
  const isMarketOptional = (0, import_dash_common53.getIsMarketOptional)(formState.state);
  const validateFieldByName = (fieldName, value) => {
    const setInvalid = (message, values) => {
      errorHandlers[fieldName]({
        type: "invalid" /* Invalid */,
        message: t(message, values || {})
      });
    };
    switch (fieldName) {
      case "name" /* Name */: {
        if ((0, import_dash_common53.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.nameBlank");
          return false;
        }
        if (!(0, import_dash_common53.isNameLengthValid)(value)) {
          setInvalid("forms:messages.maxCharacterLimit", {
            number: import_dash_common53.DashValidation.MaxNameLength.toString()
          });
          return false;
        }
        break;
      }
      case "primaryOrganizationId" /* PrimaryOrganizationId */: {
        if ((0, import_dash_common53.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.organizationBlank");
          return false;
        }
        if (!(0, import_dash_common53.isNameLengthValid)(value)) {
          setInvalid("forms:messages.maxCharacterLimit", {
            number: import_dash_common53.DashValidation.MaxNameLength.toString()
          });
          return false;
        }
        break;
      }
      case "place" /* Place */: {
        if (!value) {
          setInvalid("forms:messages.mapBlank");
          return false;
        }
        break;
      }
      case "street" /* Street */: {
        if ((0, import_dash_common53.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.streetBlank");
          return false;
        }
        break;
      }
      case "city" /* City */: {
        if ((0, import_dash_common53.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.cityBlank");
          return false;
        }
        break;
      }
      case "zipCode" /* ZipCode */: {
        if ((0, import_dash_common53.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.streetBlank");
          return false;
        }
        break;
      }
      case "state" /* State */: {
        if ((0, import_dash_common53.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.stateBlank");
          return false;
        }
        break;
      }
      case "county" /* County */: {
        if ((0, import_dash_common53.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.countyBlank");
          return false;
        }
        break;
      }
      case "market" /* Market */: {
        if (!isMarketOptional && (0, import_dash_common53.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.marketBlank");
          return false;
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };
  return validateFieldByName;
};
var useValidation_default2 = useValidation2;

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/components/PlaceSection/PlaceSection.tsx
var import_react_i18next78 = require("react-i18next");
var import_react126 = require("react");
var import_jsx_runtime179 = require("react/jsx-runtime");
var PlaceSection = () => {
  const { t } = (0, import_react_i18next78.useTranslation)(["forms", "common", "pages"]);
  const isGoogleApiReady = useGoogleApiLoader();
  const googleAutocompleteContainerRef = (0, import_react126.useRef)(null);
  const { formState, formErrors, stateHandlers } = (0, import_react126.useContext)(FormContext);
  const { place } = formState;
  const center = place?.geometry?.location ?? void 0;
  const geocoder = isGoogleApiReady ? new google.maps.Geocoder() : null;
  const onPlaceSelected = (place2) => {
    const address = googlePlaceToAddress(place2);
    stateHandlers["place" /* Place */](place2);
    stateHandlers["street" /* Street */](address.street);
    stateHandlers["city" /* City */](address.city);
    stateHandlers["zipCode" /* ZipCode */](address.zipCode);
    stateHandlers["state" /* State */](address.state);
    stateHandlers["county" /* County */](address.county);
  };
  const onShowAddress = () => {
    stateHandlers["isShowAddress" /* IsShowAddress */](!formState.isShowAddress);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime179.jsxs)(import_jsx_runtime179.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime179.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime179.jsxs)(Flex_default, { justifyContent: "space-between", children: [
        /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(Form_default.Label, { required: true, children: t("forms:labels.map") }) }),
        /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(
          Button_default,
          {
            type: "button",
            onClick: onShowAddress,
            variation: "flat",
            minWidth: "unset",
            h: "unset",
            children: t("forms:labels.addManually")
          }
        ) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(Box_default, { w: "100%", ref: googleAutocompleteContainerRef, children: isGoogleApiReady ? /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(
        GoogleAutocomplete_default,
        {
          menuPortalTarget: googleAutocompleteContainerRef.current,
          onPlaceSelected,
          defaultValue: place?.formatted_address || "",
          placeholder: t("forms:placeholders:map") || "",
          $errorType: formErrors["place" /* Place */]?.type
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(Spinner_default, {}) }),
      /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(Form_default.Feedback, { $errorType: formErrors["place" /* Place */]?.type, children: formErrors["place" /* Place */]?.message })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(Form_default.Group, { w: "100%", mt: 3, children: isGoogleApiReady && /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(
      GoogleMap_default,
      {
        h: 208,
        center,
        onClick: (e) => {
          if (e.latLng && geocoder) {
            geocoder.geocode(
              { location: { lat: e.latLng.lat(), lng: e.latLng.lng() } },
              (result) => {
                if (result?.length) {
                  onPlaceSelected(result[0]);
                }
              }
            );
          }
        },
        children: center && /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(Marker_default, { position: center })
      }
    ) })
  ] });
};
var PlaceSection_default = PlaceSection;

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/components/AddressSection/AddressSection.tsx
var import_react127 = require("react");
var import_react_i18next79 = require("react-i18next");
var import_styled_components195 = __toESM(require("styled-components"));
var import_dash_common54 = require("dash-common");
var import_jsx_runtime180 = require("react/jsx-runtime");
var NumberInput2 = (0, import_styled_components195.default)(Input_default)`
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
var AddressSection = ({ statesOptions, marketOptions }) => {
  const { t } = (0, import_react_i18next79.useTranslation)(["forms", "common", "pages"]);
  const { formState, formErrors, stateHandlers } = (0, import_react127.useContext)(FormContext);
  const validateFieldByName = useValidation_default2();
  const handleTextInputs = (fieldName) => (e) => {
    const { value } = e.target;
    if (fieldName === "zipCode" /* ZipCode */) {
      if (value.length <= import_dash_common54.DashValidation.MaxZipCodeLength) {
        stateHandlers[fieldName](value);
        validateFieldByName(fieldName, value);
      }
      return;
    }
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
  };
  const handleSelectInputs = (fieldName) => (value) => {
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
    if (fieldName === "state" /* State */) {
      stateHandlers["county" /* County */](null);
      stateHandlers["market" /* Market */](null);
    }
  };
  const stateName = formState.state || "";
  const countiesOptions = (0, import_react127.useMemo)(() => {
    const counties = (0, import_dash_common54.getCountiesByStateName)(stateName);
    return counties.map((value) => ({
      label: value,
      value
    }));
  }, [stateName]);
  const handleCountySelect = (value) => {
    if (value) {
      stateHandlers["county" /* County */](value);
      validateFieldByName("county" /* County */, value);
    }
  };
  const isMarketOptional = (0, import_dash_common54.getIsMarketOptional)(stateName);
  return formState.isShowAddress ? /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Flex_default, { flex: 1, flexDirection: "row", children: [
    /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Flex_default, { flex: 1, flexDirection: "column", mr: 4, children: [
      /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Label, { required: true, children: t("forms:labels.streetName") }),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(
          Form_default.Input,
          {
            placeholder: t("forms:placeholders.nameOfStreet") || "",
            onChange: handleTextInputs("street" /* Street */),
            value: formState.street || "",
            $errorType: formErrors["street" /* Street */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Feedback, { $errorType: formErrors["street" /* Street */]?.type, children: formErrors["street" /* Street */]?.message })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Label, { required: true, children: t("forms:labels.zipCode") }),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(
          NumberInput2,
          {
            value: formState.zipCode || "",
            placeholder: t("forms:placeholders.digits", { number: 5 }) || "",
            type: "number",
            onChange: handleTextInputs("zipCode" /* ZipCode */),
            $errorType: formErrors["zipCode" /* ZipCode */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Feedback, { $errorType: formErrors["zipCode" /* ZipCode */]?.type, children: formErrors["zipCode" /* ZipCode */]?.message })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Label, { required: true, children: t("forms:labels.county") }),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(
          Form_default.Select,
          {
            disabled: !formState.state || !countiesOptions.length,
            options: countiesOptions,
            value: formState.county,
            menuPlacement: "top",
            menuPosition: "fixed",
            placeholder: t("forms:placeholders.selectOne"),
            onChanged: handleCountySelect,
            w: "100%",
            $errorType: formErrors["county" /* County */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Feedback, { $errorType: formErrors["county" /* County */]?.type, children: formErrors["county" /* County */]?.message })
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
      /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Label, { required: true, children: t("forms:labels.city") }),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(
          Form_default.Input,
          {
            placeholder: t("forms:placeholders.nameOfCity") || "",
            onChange: handleTextInputs("city" /* City */),
            $errorType: formErrors["city" /* City */]?.type,
            value: formState.city
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Feedback, { $errorType: formErrors["city" /* City */]?.type, children: formErrors["city" /* City */]?.message })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Label, { required: true, children: t("forms:labels.state") }),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(
          Form_default.Select,
          {
            options: statesOptions,
            menuPlacement: "top",
            menuPosition: "fixed",
            placeholder: t("forms:placeholders.selectOne"),
            w: "100%",
            onChanged: handleSelectInputs("state" /* State */),
            $errorType: formErrors["state" /* State */]?.type,
            value: formState.state
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Feedback, { $errorType: formErrors["state" /* State */]?.type, children: formErrors["state" /* State */]?.message })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime180.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Label, { required: !isMarketOptional, children: t("forms:labels.marketArea") }),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(
          Form_default.Select,
          {
            menuPlacement: "top",
            menuPosition: "fixed",
            options: marketOptions,
            disabled: isMarketOptional,
            placeholder: t("forms:placeholders.selectOne"),
            w: "100%",
            onChanged: handleSelectInputs("market" /* Market */),
            $errorType: formErrors["market" /* Market */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(Form_default.Feedback, { $errorType: formErrors["market" /* Market */]?.type, children: formErrors["market" /* Market */]?.message })
      ] })
    ] })
  ] }) : null;
};
var AddressSection_default2 = AddressSection;

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/AddPropertyModal.tsx
var import_jsx_runtime181 = require("react/jsx-runtime");
var AddPropertyModal = ({
  isOpened,
  onClose,
  organizations,
  handleCreateProperty,
  loadingCreateProperty,
  loadingOrganizations,
  statesOptions,
  marketOptions
}) => {
  const { t } = (0, import_react_i18next80.useTranslation)(["forms", "common", "pages"]);
  const {
    formState,
    formErrors,
    formOnSubmit,
    formOnError,
    resetForm,
    resetFormErrors,
    stateHandlers,
    errorHandlers
  } = (0, import_react128.useContext)(FormContext);
  const formRef = (0, import_react128.useRef)(null);
  const validateFieldByName = useValidation_default2();
  const translateServerError = useServerResponseTranslation();
  const closeModal = () => {
    resetForm();
    resetFormErrors();
    stateHandlers["isMinimalMode" /* IsMinimalMode */](false);
    onClose();
  };
  const handleTextInputs = (fieldName) => (e) => {
    const { value } = e.target;
    if (fieldName === "zipCode" /* ZipCode */) {
      if (value.length <= import_dash_common55.DashValidation.MaxZipCodeLength) {
        stateHandlers[fieldName](value);
        validateFieldByName(fieldName, value);
      }
      return;
    }
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
  };
  const handleSelectInputs = (fieldName) => (value) => {
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
  };
  const handleMinimalModeToggle = () => {
    const newValue = !formState["isMinimalMode" /* IsMinimalMode */];
    stateHandlers["isMinimalMode" /* IsMinimalMode */](newValue);
    if (newValue) {
      stateHandlers["primaryOrganizationId" /* PrimaryOrganizationId */]("");
      stateHandlers["place" /* Place */]("");
      stateHandlers["market" /* Market */]("");
      stateHandlers["isShowAddress" /* IsShowAddress */](false);
      stateHandlers["city" /* City */]("");
      stateHandlers["county" /* County */]("");
      stateHandlers["zipCode" /* ZipCode */]("");
      stateHandlers["street" /* Street */]("");
      stateHandlers["state" /* State */]("");
      resetFormErrors();
    }
  };
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    formOnSubmit();
    const { isLoading, errorSlug, ...formValues } = formState;
    const isMinimalMode = formState["isMinimalMode" /* IsMinimalMode */];
    if (isMinimalMode) {
      if (!validateFieldByName("name" /* Name */, formValues["name" /* Name */])) {
        return null;
      }
    } else {
      const invalidFields = Object.entries(formValues).filter(([name]) => name !== "isMinimalMode" /* IsMinimalMode */).map(([name, value]) => !validateFieldByName(name, value) && name).filter(Boolean);
      if (invalidFields.length) {
        if (invalidFields.some((field) => !NON_MANUAL_FIELDS.includes(field))) {
          stateHandlers["isShowAddress" /* IsShowAddress */](true);
        }
        return null;
      }
    }
    handleCreateProperty(
      formValues,
      () => {
        closeModal();
      },
      (error) => {
        if (error.message === import_dash_common55.ServerErrors.PROPERTY_NAME_EXISTS) {
          return errorHandlers["name" /* Name */]({
            type: "invalid" /* Invalid */,
            message: translateServerError(error)
          });
        }
        formOnError(translateServerError(error));
      }
    );
  };
  return /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(
    Modal3,
    {
      title: t("pages:propertyPage.propertyCreateModalTitle") || "",
      isOpen: isOpened,
      onRequestClose: closeModal,
      submitButton: {
        title: t("common:labels.add"),
        isLoading: loadingCreateProperty,
        disabled: loadingCreateProperty,
        onClick: () => {
          if (formRef.current) {
            formRef.current.requestSubmit();
          }
        }
      },
      cancelButton: {
        title: t("common:labels.cancel"),
        onClick: closeModal
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime181.jsxs)(Form_default, { ref: formRef, onSubmit, children: [
        /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(Form_default.Group, { w: "100%", mt: 3, children: /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(
          Toggle_default,
          {
            checked: !!formState["isMinimalMode" /* IsMinimalMode */],
            onChange: handleMinimalModeToggle,
            label: t("forms:labels.proposedPropertyOnly") || ""
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime181.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(Form_default.Label, { required: true, children: t("forms:labels.name") }),
          /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(
            Form_default.Input,
            {
              placeholder: t("forms:placeholders.nameOfProperty") || "",
              onChange: handleTextInputs("name" /* Name */),
              $errorType: formErrors["name" /* Name */]?.type
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(Form_default.Feedback, { $errorType: formErrors["name" /* Name */]?.type, children: formErrors["name" /* Name */]?.message })
        ] }),
        !formState["isMinimalMode" /* IsMinimalMode */] && /* @__PURE__ */ (0, import_jsx_runtime181.jsxs)(import_jsx_runtime181.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime181.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
            /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(Form_default.Label, { required: true, children: t("forms:labels.organization") }),
            /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(
              Form_default.Select,
              {
                options: organizations.map((item) => ({
                  value: item._id,
                  label: item.name
                })),
                isLoading: loadingOrganizations,
                menuPosition: "fixed",
                placeholder: t("forms:placeholders.selectOne"),
                w: "100%",
                onChanged: handleSelectInputs("primaryOrganizationId" /* PrimaryOrganizationId */),
                $errorType: formErrors["primaryOrganizationId" /* PrimaryOrganizationId */]?.type
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(
              Form_default.Feedback,
              {
                $errorType: formErrors["primaryOrganizationId" /* PrimaryOrganizationId */]?.type,
                children: formErrors["primaryOrganizationId" /* PrimaryOrganizationId */]?.message
              }
            )
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(PlaceSection_default, {}),
          /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(
            AddressSection_default2,
            {
              statesOptions,
              marketOptions
            }
          )
        ] })
      ] })
    }
  );
};
var AddPropertyModal_default = AddPropertyModal;

// src/components/organisms/PropertiesTable/PropertiesTableActions/PropertiesTableActions.tsx
var import_jsx_runtime182 = require("react/jsx-runtime");
var ActionsBar = (0, import_styled_components196.default)(Flex_default)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`;
var SearchWrapper = (0, import_styled_components196.default)(Flex_default)`
  flex: 1;
  min-width: 260px;
`;
var FiltersGroup = (0, import_styled_components196.default)(Flex_default)`
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  row-gap: 12px;
`;
function PropertiesTableActions({
  excludeStatuses = [],
  withStatusFilter,
  withCmsStatusFilter,
  withProjectStatusFilter,
  withTransactionTypeFilter,
  withCreateAction = true,
  withOrganizationsFilter,
  withMarketAreaFilter,
  withBuildingTypeFilter,
  withTagsFilter,
  handleCreateProperty = import_noop.default,
  organizations = [],
  loadingCreateProperty = false,
  loadingOrganizations = false,
  filterTableName = "PROPERTIES" /* PROPERTIES */,
  statesOptions = [],
  marketOptions
}) {
  const { t } = (0, import_react_i18next81.useTranslation)("tables", { keyPrefix: "properties" });
  const { t: tLabels } = (0, import_react_i18next81.useTranslation)("common", { keyPrefix: "labels" });
  const { t: tForms } = (0, import_react_i18next81.useTranslation)("forms", { keyPrefix: "labels.propertyTransactionTypes" });
  const { t: tFormsLabels } = (0, import_react_i18next81.useTranslation)("forms", { keyPrefix: "labels" });
  const { searchSlug, setSearchSlug } = (0, import_react129.useContext)(SearchContext);
  const { state: paginationState, resetPagination } = (0, import_react129.useContext)(PaginationContext);
  const { state, setFilterState } = (0, import_react129.useContext)(FilterContext);
  const [search, setSearch] = (0, import_react129.useState)(searchSlug);
  const [isOpenedCreateModal, setIsOpenedCreateModal] = (0, import_react129.useState)(false);
  const statusOptions = (0, import_react129.useMemo)(
    () => [
      {
        value: import_dash_common56.PropertyStatusesEnum.DRAFT,
        label: tLabels`draft`
      },
      {
        value: import_dash_common56.PropertyStatusesEnum.PUBLIC,
        label: tLabels`public`
      },
      {
        value: import_dash_common56.PropertyStatusesEnum.PRIVATE,
        label: tLabels`private`
      },
      {
        value: import_dash_common56.PropertyStatusesEnum.ARCHIVED,
        label: tLabels`archived`
      },
      {
        value: import_dash_common56.PropertyStatusesEnum.SOLD_OUT,
        label: tLabels`sold_out`
      }
    ].filter(({ value }) => !excludeStatuses.includes(value)),
    [tLabels, excludeStatuses]
  );
  const cmsStatusOptions = (0, import_react129.useMemo)(
    () => Object.values(import_dash_common56.CmsStatusEnum).map((status) => ({
      value: status,
      label: tLabels(status.toLowerCase())
    })),
    [tLabels]
  );
  const projectStatusOptions = (0, import_react129.useMemo)(
    () => Object.values(import_dash_common56.ProjectStatusesEnum).map((status) => ({
      value: status,
      label: tLabels(status.toLowerCase(), {
        defaultValue: (0, import_startCase.default)((0, import_camelCase.default)(status))
      })
    })),
    [tLabels]
  );
  const transactionTypeOptions = (0, import_react129.useMemo)(
    () => [
      {
        value: import_dash_common56.PropertyTransactionTypesEnum.FOR_SALE,
        label: tForms("forSale")
      },
      {
        value: import_dash_common56.PropertyTransactionTypesEnum.FOR_RENT,
        label: tForms("forRent")
      }
    ],
    [tForms]
  );
  const organizationOptions = (0, import_react129.useMemo)(
    () => organizations.map(({ _id: value, name }) => ({ value, label: name })),
    [organizations]
  );
  const buildingTypeOptions = (0, import_react129.useMemo)(
    () => import_dash_common56.VISIBLE_BUILDING_TYPES.map((value) => ({
      value,
      label: tFormsLabels(`buildingTypes.${(0, import_camelCase.default)(value)}`, {
        defaultValue: (0, import_startCase.default)((0, import_camelCase.default)(value))
      })
    })),
    [tFormsLabels]
  );
  const tagOptions = (0, import_react129.useMemo)(
    () => Object.values(import_dash_common56.PropertyTagsEnum).map((value) => ({
      value,
      label: tFormsLabels(`propertyTags.${(0, import_camelCase.default)(value)}`, {
        defaultValue: (0, import_startCase.default)((0, import_camelCase.default)(value))
      })
    })),
    [tFormsLabels]
  );
  (0, import_react129.useEffect)(() => {
    const localFilter = localStorage2.getTableFilter(filterTableName) && JSON.parse(localStorage2.getTableFilter(filterTableName));
    if (localFilter) {
      setFilterState("statuses", localFilter.statuses);
      setFilterState("cmsStatuses", localFilter.cmsStatuses);
      setFilterState("transactionTypes", localFilter.transactionTypes);
      setFilterState("organizationId", localFilter.organizationId);
      setFilterState("marketAreaIds", localFilter.marketAreaIds);
      setFilterState("buildingTypes", localFilter.buildingTypes);
      setFilterState("projectStatuses", localFilter.projectStatuses);
      setFilterState("propertyTags", localFilter.propertyTags);
    }
  }, []);
  (0, import_react129.useEffect)(() => {
    if (!(0, import_isEmpty.default)(state)) {
      localStorage2.setTableFilter(filterTableName, state);
    }
  }, [state]);
  return /* @__PURE__ */ (0, import_jsx_runtime182.jsxs)(ActionsBar, { px: 6, py: 4, children: [
    withCreateAction && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
      AddPropertyModal_default,
      {
        marketOptions,
        isOpened: isOpenedCreateModal,
        onClose: () => setIsOpenedCreateModal(false),
        handleCreateProperty,
        organizations,
        loadingCreateProperty,
        loadingOrganizations,
        statesOptions
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(SearchWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
      InputSearch_default,
      {
        w: "100%",
        css: "height: 40px",
        onClear: () => {
          setSearch("");
          setSearchSlug("");
          resetPagination();
        },
        value: search,
        placeholder: t`searchInputPlaceholder` || "",
        onChange: (event) => {
          resetPagination();
          setSearch(event.target.value);
          setSearchSlug(event.target.value);
        }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime182.jsxs)(FiltersGroup, { children: [
      withTransactionTypeFilter && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Select_default,
        {
          ml: 4,
          w: 200,
          isSearchable: false,
          isMulti: true,
          options: transactionTypeOptions,
          value: state.transactionTypes || [],
          onChanged: (_, values) => {
            setFilterState("transactionTypes", values);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t`transactionTypeSelectPlaceholder`
        }
      ),
      withMarketAreaFilter && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Select_default,
        {
          ml: 4,
          w: 200,
          isMulti: true,
          options: marketOptions,
          value: state.marketAreaIds || [],
          onChanged: (_, values) => {
            setFilterState("marketAreaIds", values);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t("marketAreaSelectPlaceholder", { defaultValue: "Market Area" })
        }
      ),
      withBuildingTypeFilter && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Select_default,
        {
          ml: 4,
          w: 200,
          isMulti: true,
          options: buildingTypeOptions,
          value: state.buildingTypes || [],
          onChanged: (_, values) => {
            setFilterState("buildingTypes", values);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t("buildingTypeSelectPlaceholder", { defaultValue: "Property Type" })
        }
      ),
      withTagsFilter && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Select_default,
        {
          ml: 4,
          w: 200,
          isMulti: true,
          options: tagOptions,
          value: state.propertyTags || [],
          onChanged: (_, values) => {
            setFilterState("propertyTags", values);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t("tagsSelectPlaceholder", { defaultValue: "Tags" })
        }
      ),
      withOrganizationsFilter && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Select_default,
        {
          ml: 4,
          w: 140,
          isClearable: true,
          options: organizationOptions,
          value: state.organizationId || "",
          onChanged: (organizationId) => {
            setFilterState("organizationId", organizationId);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t`organizationSelectPlaceholder`
        }
      ),
      withStatusFilter && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Select_default,
        {
          ml: 4,
          w: 200,
          isMulti: true,
          options: statusOptions,
          value: state.statuses || [],
          onChanged: (_, values) => {
            setFilterState("statuses", values);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t`statusSelectPlaceholder`
        }
      ),
      withCmsStatusFilter && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Select_default,
        {
          ml: 4,
          w: 200,
          isMulti: true,
          options: cmsStatusOptions,
          value: state.cmsStatuses || [],
          onChanged: (_, values) => {
            setFilterState("cmsStatuses", values);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t`cmsStatusSelectPlaceholder`
        }
      ),
      withProjectStatusFilter && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Select_default,
        {
          ml: 4,
          w: 200,
          isMulti: true,
          options: projectStatusOptions,
          value: state.projectStatuses || [],
          onChanged: (_, values) => {
            setFilterState("projectStatuses", values);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t("projectStatusSelectPlaceholder", {
            defaultValue: "Property Status"
          })
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(PaginationPerPageSelect, { defaultValue: null, label: `${tLabels`show`} `, w: 130, ml: 4 }),
      withCreateAction && /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
        Button_default,
        {
          ml: 4,
          icon: "plus",
          px: 5.5,
          onClick: () => setIsOpenedCreateModal(true),
          children: t`addNewButtonLabel`
        }
      )
    ] })
  ] });
}
var PropertiesTableActions_default = PropertiesTableActions;

// src/components/organisms/PropertiesTable/PropertiesTable.tsx
var import_jsx_runtime183 = require("react/jsx-runtime");
function PropertiesTable({
  actionProps,
  columns,
  data,
  loading,
  placeholder,
  placeholderImage,
  searchPlaceholder,
  searchPlaceholderImage
}) {
  const { t } = (0, import_react_i18next82.useTranslation)("tables", {
    keyPrefix: "properties"
  });
  const { t: tLabels } = (0, import_react_i18next82.useTranslation)("common", { keyPrefix: "labels" });
  const { searchSlug } = (0, import_react130.useContext)(SearchContext);
  const labelToShow = !loading ? (searchSlug ? searchPlaceholder : placeholder) || t`placeholder` || "" : "";
  const imageToShow = !loading ? searchSlug ? searchPlaceholderImage : placeholderImage : void 0;
  return /* @__PURE__ */ (0, import_jsx_runtime183.jsx)(import_jsx_runtime183.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime183.jsxs)("div", { style: { overflowX: "auto", width: "100%" }, children: [
    /* @__PURE__ */ (0, import_jsx_runtime183.jsx)(PropertiesTableActions_default, { ...actionProps }),
    /* @__PURE__ */ (0, import_jsx_runtime183.jsx)(
      TableWitPagination_default,
      {
        w: "100%",
        m: 0,
        tableProps: {
          loading,
          data,
          columns,
          maxHeight: "calc(100vh - 350px)",
          stickyHeader: true,
          placeholderProps: {
            label: labelToShow,
            image: imageToShow
          }
        },
        paginationProps: {
          label: t`paginationLabel`,
          previousButtonLabel: tLabels`previous`,
          nextButtonLabel: tLabels`next`
        }
      }
    )
  ] }) });
}
var PropertiesTable_default = PropertiesTable;

// src/components/organisms/PropertyHistoryModal/PropertyHistoryModal.tsx
var import_moment11 = __toESM(require("moment"));
var import_react131 = require("react");
var import_styled_components199 = require("styled-components");
var import_react_i18next84 = require("react-i18next");

// src/components/organisms/PropertyHistoryModal/components/PropertyThumbnail.tsx
var import_styled_components197 = require("styled-components");

// src/components/organisms/PropertyHistoryModal/PropertyHistoryModel.helpers.ts
var import_react_i18next83 = require("react-i18next");
var import_dash_common57 = require("dash-common");
var getChangelogHistoryLabel = (changelog) => {
  const { t } = (0, import_react_i18next83.useTranslation)(["common"]);
  const type = changelog.type;
  if (type === import_dash_common57.PropertyChangelogTypesEnum.PROPERTY_MEDIA_UPLOADED) {
    const changelogFolderName = changelog?.afterUpdate?.folderName;
    return t(`common:historyTypesMessages.${type}`, {
      folderName: !changelogFolderName || changelogFolderName === import_dash_common57.DEFAULT_ROOT_MEDIA_FOLDER_NAME ? t("common:labels.rootMediaFolder").toLowerCase() : changelogFolderName
    });
  }
  return t(`common:historyTypesMessages.${type}`);
};

// src/components/organisms/PropertyHistoryModal/components/PropertyThumbnail.tsx
var import_jsx_runtime184 = require("react/jsx-runtime");
var PropertyThumbnail = ({ history }) => {
  const theme = (0, import_styled_components197.useTheme)();
  const file = history.property.mainPropertyMediaFile?.files[0];
  return /* @__PURE__ */ (0, import_jsx_runtime184.jsxs)(Flex_default, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime184.jsx)(Flex_default, { minWidth: 40, w: 40, h: 40, mr: 3, children: /* @__PURE__ */ (0, import_jsx_runtime184.jsx)(Thumbnail_default, { file }) }),
    /* @__PURE__ */ (0, import_jsx_runtime184.jsxs)(Box_default, { maxWidth: [164, 264, "unset", "unset"], children: [
      /* @__PURE__ */ (0, import_jsx_runtime184.jsx)(Text_default, { ellipsis: true, semibold: true, children: history.property.name }),
      /* @__PURE__ */ (0, import_jsx_runtime184.jsx)(Text_default, { ellipsis: true, sm: true, color: theme.colors.n80, children: getChangelogHistoryLabel(history) })
    ] })
  ] });
};
var PropertyThumbnail_default = PropertyThumbnail;

// src/components/organisms/PropertyHistoryModal/PropertyHistoryModal.styles.tsx
var import_styled_components198 = __toESM(require("styled-components"));
var HistoryTable = (0, import_styled_components198.default)(TableWitPagination_default)`
  ${({ isSecondary, theme }) => isSecondary && `
      margin-top: ${theme.space * 2}px;
      td:first-child {
        padding-left: ${theme.space * 2}px !important;
      }
      td:last-child {
        vertical-align: bottom;
        text-align: right;
      }
    `}

  @media ${({ theme }) => theme.devices.mobile} {
    & > div > div:last-child {
      justify-content: center;
    }
    tbody tr td:last-child {
      padding-right: unset;
    }
  }
`;

// src/components/organisms/PropertyHistoryModal/PropertyHistoryModal.tsx
var import_jsx_runtime185 = require("react/jsx-runtime");
var PropertyHistoryModal = ({
  data,
  loading,
  onClose,
  isOpen,
  variation = "primary",
  onRowClick,
  placeholder,
  datePeriodPickerProps
}) => {
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const theme = (0, import_styled_components199.useTheme)();
  const { t } = (0, import_react_i18next84.useTranslation)(["common"]);
  const isSecondary = variation === "secondary";
  const columns = (0, import_react131.useMemo)(() => {
    return [
      {
        Header: () => t("common:labels.update"),
        accessor: "type",
        Cell: ({ row: { original } }) => /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(
          Flex_default,
          {
            onClick: () => {
              if (onRowClick) {
                onRowClick(original.property._id);
              }
            },
            children: isSecondary ? /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(PropertyThumbnail_default, { history: original }) : /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(Text_default, { children: getChangelogHistoryLabel(original) })
          }
        )
      },
      {
        Header: () => t("common:labels.date"),
        accessor: "createdAt",
        Cell: ({ value }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(Text_default, { ...isSecondary && { sm: true, color: theme.colors.n80 }, children: (0, import_moment11.default)(value).format("HH:mm, L") });
        }
      }
    ];
  }, [isSecondary]);
  return /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(
    Modal3,
    {
      title: isSecondary ? t("common:history.propertyUpdates") || "" : t("common:history.historyUpdates") || "",
      isOpen,
      onRequestClose: onClose,
      closeIcon: true,
      isCentered: true,
      w: [343, 576, 576, 576],
      ...datePeriodPickerProps && {
        AdditionalHeader: () => /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(Flex_default, { alignItems: "center", flex: 1, children: /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(Box_default, { children: /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(DatePeriodPicker_default, { ...datePeriodPickerProps }) }) })
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(
        HistoryTable,
        {
          isSecondary,
          tableProps: { data, columns, withHeader: !isSecondary, loading, placeholder },
          paginationProps: {
            nextButtonLabel: t("common:labels.next"),
            previousButtonLabel: t("common:labels.previous"),
            countPerPage: isMobile ? 3 : 7,
            label: t("tables:properties.updatePaginationLabel"),
            showPagination: false
          }
        }
      )
    }
  );
};
var PropertyHistoryModal_default = PropertyHistoryModal;

// src/components/organisms/PropertySalesAvailabilityModal/PropertySalesAvailabilityModal.tsx
var import_react133 = require("react");
var import_styled_components201 = require("styled-components");
var import_react_i18next86 = require("react-i18next");
var import_dash_common58 = require("dash-common");

// src/components/molecules/ExpandableHtmlText/ExpandableHtmlText.tsx
var import_react132 = require("react");
var import_react_i18next85 = require("react-i18next");
var import_styled_components200 = __toESM(require("styled-components"));
var import_jsx_runtime186 = require("react/jsx-runtime");
var HtmlContent = import_styled_components200.default.div`
  color: ${(props) => props.theme.colors.n80};
  font-size: 14px;
  line-height: 1.5;

  /* Preserve HTML formatting */
  strong,
  b {
    font-weight: 700;
    color: ${(props) => props.theme.colors.n90};
  }

  em,
  i {
    font-style: italic;
  }

  p {
    margin: 0;
    color: inherit;
  }

  p + p {
    margin-top: 0.5rem;
  }

  ${(props) => !props.isExpanded && `
    display: -webkit-box;
    -webkit-line-clamp: ${props.lineClamp || 3};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}
`;
var ExpandableHtmlText = ({
  text,
  lineClamp = 3
}) => {
  const [isExpanded, setIsExpanded] = (0, import_react132.useState)(false);
  const [showButton, setShowButton] = (0, import_react132.useState)(false);
  const contentRef = (0, import_react132.useRef)(null);
  const { t } = (0, import_react_i18next85.useTranslation)("common");
  (0, import_react132.useEffect)(() => {
    if (contentRef.current) {
      const { scrollHeight, clientHeight } = contentRef.current;
      if (scrollHeight > clientHeight) {
        setShowButton(true);
      }
    }
  }, [text]);
  return /* @__PURE__ */ (0, import_jsx_runtime186.jsxs)(Box_default, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime186.jsx)(
      HtmlContent,
      {
        ref: contentRef,
        lineClamp,
        isExpanded,
        dangerouslySetInnerHTML: { __html: text }
      }
    ),
    showButton && /* @__PURE__ */ (0, import_jsx_runtime186.jsx)(
      Button_default,
      {
        maxHeight: 36,
        mt: 2,
        variation: "outline",
        onClick: () => setIsExpanded(!isExpanded),
        minWidth: "fit-content",
        children: t(isExpanded ? "labels.showLess" : "labels.showMore")
      }
    )
  ] });
};
var ExpandableHtmlText_default = ExpandableHtmlText;

// src/components/organisms/PropertySalesAvailabilityModal/PropertySalesAvailabilityModal.tsx
var import_jsx_runtime187 = require("react/jsx-runtime");
var convertTo12Hour2 = (time24) => {
  const [hours, minutes] = time24.split(":");
  const hour = parseInt(hours, 10);
  const period = hour < 12 ? "AM" : "PM";
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour.toString().padStart(2, "0")}:${minutes} ${period}`;
};
var formatPhoneNumber = (dialCode, number) => {
  if (!number)
    return "";
  const formattedNumber = (0, import_dash_common58.formatByMask)(number, import_dash_common58.PROPERTY_PHONE_NUMBER_MASK);
  return dialCode ? `${dialCode} ${formattedNumber}` : formattedNumber || "";
};
var getAbbreviatedDay = (day, t) => {
  const fullName = t(`common:labels.weekDays.${day}`);
  return fullName.slice(0, day === import_dash_common58.WeekDays.Tuesday ? 4 : 3);
};
var shouldShowAvailability = (status, hours) => {
  return status === import_dash_common58.SalesGalleryStatusesEnum.COMING_SOON || status === import_dash_common58.SalesGalleryStatusesEnum.APPOINTMENT_ONLY || status === import_dash_common58.SalesGalleryStatusesEnum.HOURS_AVAILABLE && !!hours;
};
var PropertySalesAvailabilityModal = ({
  salesGalleryHours,
  salesGalleryAddress,
  salesGalleryStatus,
  contactEmail,
  contactPhone,
  isRental = false
}) => {
  const { t } = (0, import_react_i18next86.useTranslation)("pages");
  const theme = (0, import_styled_components201.useTheme)();
  const { isOpenCurrent, toggleModal } = (0, import_react133.useContext)(ModalContext);
  const isOpen = isOpenCurrent["PropertySalesAvailabilityModal"];
  const closeModal = () => {
    toggleModal(false, "PropertySalesAvailabilityModal");
  };
  const hasContactInfo = !!(contactEmail || contactPhone?.number);
  const showAvailability = shouldShowAvailability(salesGalleryStatus, salesGalleryHours);
  const AddressSection2 = () => {
    if (!salesGalleryAddress)
      return null;
    return /* @__PURE__ */ (0, import_jsx_runtime187.jsxs)(Box_default, { mb: 6, mt: 4, children: [
      /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Box_default, { mb: 2, children: /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Text_default, { semibold: true, md: true, color: theme.colors.n80, children: t("common:labels.address") }) }),
      /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(ExpandableHtmlText_default, { text: salesGalleryAddress, lineClamp: 3 })
    ] });
  };
  const ContactInfo = () => {
    if (!hasContactInfo)
      return null;
    return /* @__PURE__ */ (0, import_jsx_runtime187.jsxs)(Box_default, { mt: 4, children: [
      contactPhone?.number && /* @__PURE__ */ (0, import_jsx_runtime187.jsxs)(Flex_default, { alignItems: "center", mb: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Icon_default, { mr: 2, name: "mobile", size: 22, color: theme.colors.g20 }),
        /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Text_default, { color: theme.colors.n80, children: formatPhoneNumber(contactPhone.dialCode, contactPhone.number) })
      ] }),
      contactEmail && /* @__PURE__ */ (0, import_jsx_runtime187.jsx)("a", { href: `mailto:${contactEmail}`, style: { textDecoration: "none" }, children: /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Button_default, { colorVariation: "success", w: "100%", icon: "send", children: t("common:labels.email") }) })
    ] });
  };
  const HoursDisplay = () => {
    if (!salesGalleryHours)
      return null;
    return /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Box_default, { children: Object.values(import_dash_common58.WeekDays).map((day) => {
      const range = salesGalleryHours[day];
      const timeDisplay = range ? `${convertTo12Hour2(range.from)} - ${convertTo12Hour2(range.to)}` : t("common:labels.notAvailable");
      return /* @__PURE__ */ (0, import_jsx_runtime187.jsxs)(Flex_default, { alignItems: "center", mt: 3.5, children: [
        /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Box_default, { mr: 2, w: 40, children: /* @__PURE__ */ (0, import_jsx_runtime187.jsxs)(Text_default, { whiteSpace: "nowrap", children: [
          getAbbreviatedDay(day, t),
          ":"
        ] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Text_default, { whiteSpace: "nowrap", sm: true, color: !range ? theme.colors.r20 : theme.colors.b50, children: timeDisplay })
      ] }, day);
    }) });
  };
  const AvailabilityContent = () => {
    switch (salesGalleryStatus) {
      case import_dash_common58.SalesGalleryStatusesEnum.COMING_SOON:
        return /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Text_default, { color: theme.colors.n80, children: t("common:labels.comingSoon") });
      case import_dash_common58.SalesGalleryStatusesEnum.APPOINTMENT_ONLY:
        return /* @__PURE__ */ (0, import_jsx_runtime187.jsxs)(Box_default, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Box_default, { mb: 3, children: /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Text_default, { color: theme.colors.n80, children: t("common:labels.byAppointmentOnly") }) }),
          /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(ContactInfo, {})
        ] });
      case import_dash_common58.SalesGalleryStatusesEnum.HOURS_AVAILABLE:
        return /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(HoursDisplay, {});
      default:
        return null;
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime187.jsxs)(
    Modal3,
    {
      isOpen,
      title: (isRental ? t("pages:propertyPage.leasingOfficeInfo") : t("pages:propertyPage.salesGalleryInfo")) || "",
      onRequestClose: closeModal,
      closeIcon: true,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(AddressSection2, {}),
        showAvailability && /* @__PURE__ */ (0, import_jsx_runtime187.jsxs)(Box_default, { mt: salesGalleryAddress ? 4 : 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Box_default, { mb: 3, children: /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(Text_default, { semibold: true, md: true, color: theme.colors.n80, children: t("pages:portfoliosPage.availability") }) }),
          /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(AvailabilityContent, {})
        ] })
      ]
    }
  );
};
var PropertySalesAvailabilityModal_default = PropertySalesAvailabilityModal;

// src/components/organisms/PortfoliosTreeSelect/PortfoliosTreeSelect.tsx
var import_react_select7 = require("react-select");
var import_react134 = require("react");

// src/components/organisms/PortfoliosTreeSelect/PortfolioTreeSelect.styles.ts
var import_styled_components202 = __toESM(require("styled-components"));
var styledSelectWrapper = import_styled_components202.css`
  .select__control {
    border: unset;
    box-shadow: none;
    height: 16px;
    min-height: inherit;
    width: inherit;
    font-size: 12px;
    line-height: 16px;

    :hover {
      border-color: unset;
      box-shadow: unset;
      cursor: pointer;
    }
  }
  .select__control--is-focused {
    border-color: unset;
  }
  .select__indicator-separator {
    display: none;
  }

  .select__indicators {
    margin: unset;
    margin-left: ${({ theme }) => theme.space * 2}px;
    height: 16px;
  }

  .select__placeholder {
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.n70};
  }
`;
var Dot2 = (0, import_styled_components202.default)(Box_default)`
  border-radius: 50%;
  background-color: ${({ color: color2 }) => color2};
`;

// src/components/organisms/PortfoliosTreeSelect/components/OptionsMenu/OptionsMenu.tsx
var import_jsx_runtime188 = require("react/jsx-runtime");
var Option5 = ({ option, onClick, isSelected }) => {
  const { isVisible = true, treeIndex, label, color: color2, disabled } = option;
  return isVisible && /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(Box_default, { mb: 4, children: /* @__PURE__ */ (0, import_jsx_runtime188.jsxs)(Flex_default, { flexDirection: "row", ml: treeIndex * 8, alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(Flex_default, { flex: 1, minWidth: 0, overflow: "hidden", children: /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(
      Checkbox_default,
      {
        disabled,
        checked: isSelected,
        onChange: onClick,
        mr: 2,
        label
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(Flex_default, { alignItems: "center", children: !disabled && /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(Dot2, { ml: 1.5, w: 8, h: 8, color: color2 }) })
  ] }) });
};
var OptionsMenu = ({
  options,
  selectedValues,
  setSelectedValues,
  setSelectedFoldersIds,
  selectedFoldersIds
}) => {
  const setValues = (option) => (checked) => {
    if (option.children) {
      if (checked) {
        setSelectedFoldersIds((prev) => [...prev, option.value]);
        return setSelectedValues((prev) => [
          ...prev,
          ...option.children.map((child) => ({
            itemId: child.value,
            parentFolderId: child.parentFolderId
          }))
        ]);
      } else {
        setSelectedFoldersIds((prev) => prev.filter((id2) => id2 !== option.value));
        return setSelectedValues(
          (prev) => prev.filter((value) => value.parentFolderId !== option.value)
        );
      }
    }
    if (checked) {
      setSelectedValues((prev) => [...prev, { itemId: option.value }]);
    } else {
      setSelectedValues((prev) => prev.filter((value) => value.itemId !== option.value));
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(Box_default, { p: 4, pb: 0, maxHeight: 300, maxWidth: "calc(100vw - 150px)", overflow: "auto", children: options?.map((option) => {
    const isSelectedParent = selectedValues.some((value) => value.itemId === option.value);
    const isSelectedFolder = selectedFoldersIds.some((id2) => id2 === option.value);
    return /* @__PURE__ */ (0, import_jsx_runtime188.jsxs)(Box_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(
        Option5,
        {
          option,
          isSelected: isSelectedParent || isSelectedFolder,
          onClick: setValues(option)
        }
      ),
      option.children && option.children.map((child) => {
        const isSelectedChild = selectedValues.some((item) => item.itemId === child.value);
        return /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(
          Option5,
          {
            option: child,
            isSelected: isSelectedChild,
            onClick: (checked) => {
              if (checked) {
                setSelectedValues((prev) => [
                  ...prev,
                  { itemId: child.value, parentFolderId: child.parentFolderId }
                ]);
              } else {
                setSelectedValues(
                  (prev) => prev.filter((value) => value.itemId !== child.value)
                );
              }
            }
          },
          child.value
        );
      })
    ] }, option.value);
  }) });
};
var OptionsMenu_default = OptionsMenu;

// src/components/organisms/PortfoliosTreeSelect/PortfoliosTreeSelect.tsx
var import_jsx_runtime189 = require("react/jsx-runtime");
var { Menu: Menu3 } = import_react_select7.components;
var ChevronUp3 = () => /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(Icon_default, { name: "arrowUp", size: 16 });
var ChevronDown3 = () => /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(Icon_default, { name: "arrowDown", size: 16 });
var PortfoliosTreeSelect = ({
  handleSelectedValues,
  options,
  selectedValues,
  setSelectedValues,
  selectedFoldersIds,
  setSelectedFoldersIds,
  ...props
}) => {
  const optionsRef = (0, import_react134.useRef)(options);
  const selectedValuesRef = (0, import_react134.useRef)(selectedValues);
  const selectedFoldersIdsRef = (0, import_react134.useRef)(selectedFoldersIds);
  optionsRef.current = options;
  selectedValuesRef.current = selectedValues;
  selectedFoldersIdsRef.current = selectedFoldersIds;
  (0, import_react134.useEffect)(() => {
    if (handleSelectedValues) {
      const values = [...selectedValues.map((value) => value.itemId), ...selectedFoldersIds];
      handleSelectedValues(values);
    }
  }, [selectedValues]);
  return /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(
    Select_default,
    {
      isMulti: true,
      isSearchable: false,
      css: styledSelectWrapper,
      options,
      components: {
        Input: () => null,
        // @ts-ignore
        DropdownIndicator: ({ isOpen }) => isOpen ? /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(ChevronUp3, {}) : /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(ChevronDown3, {}),
        Menu: (args) => /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(Menu3, { ...args, children: /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(
          OptionsMenu_default,
          {
            setSelectedFoldersIds,
            selectedFoldersIds: selectedFoldersIdsRef.current,
            setSelectedValues,
            selectedValues: selectedValuesRef.current,
            options: optionsRef.current
          }
        ) })
      },
      ...props,
      menuFixedWidth: false
    }
  );
};
var PortfoliosTreeSelect_default = PortfoliosTreeSelect;

// src/components/organisms/PropertyPreview/components/PropertyPreviewGeneralInfoSection/GeneralInfoSection.tsx
var import_styled_components207 = __toESM(require("styled-components"));

// src/components/organisms/PropertyPreview/components/PropertyPreviewGeneralInfoSection/components/AgentHighlightsSection.tsx
var import_styled_components204 = require("styled-components");
var import_react_i18next88 = require("react-i18next");

// src/components/organisms/PropertyPreview/components/PropertyPreviewGeneralInfoSection/components/ExpandableText.tsx
var import_react135 = require("react");
var import_styled_components203 = require("styled-components");
var import_react_i18next87 = require("react-i18next");
var import_jsx_runtime190 = require("react/jsx-runtime");
function ExpandableText2(props) {
  const [showButton, setShowButton] = (0, import_react135.useState)(false);
  const [showText, setShowText] = (0, import_react135.useState)(false);
  const [minContainerHeight, setMinContainerHeight] = (0, import_react135.useState)(void 0);
  const mainColor = props.mainColor || "";
  const lineClamp = props.lineClamp || 10;
  const theme = (0, import_styled_components203.useTheme)();
  const { t } = (0, import_react_i18next87.useTranslation)(["common"]);
  const ref = (0, import_react135.useRef)(null);
  const isTextTruncatedByCharLimit = props.charLimit && props.text.length > props.charLimit;
  const displayText = props.charLimit && !showText && props.text.length > props.charLimit && !props.showInlineLock ? props.text.substring(0, props.charLimit) : props.text;
  const textFadeColor = props.textFadeColor || "rgba(248, 251, 253, 1)";
  const textFadeTransparent = textFadeColor.replace(/[\d.]+\)$/g, "0)");
  (0, import_react135.useEffect)(() => {
    if (isTextTruncatedByCharLimit && ref.current) {
      const MIN_VISIBLE_LINES = 4;
      const APPROX_LINE_HEIGHT = 28;
      const minVisibleHeight = MIN_VISIBLE_LINES * APPROX_LINE_HEIGHT;
      setShowButton(true);
      setMinContainerHeight(minVisibleHeight);
    } else if (ref.current && ref.current.scrollHeight > ref.current.clientHeight) {
      setShowButton(true);
    }
  }, [isTextTruncatedByCharLimit]);
  if (props.showInlineLock && isTextTruncatedByCharLimit) {
    return /* @__PURE__ */ (0, import_jsx_runtime190.jsxs)(
      "div",
      {
        role: "button",
        tabIndex: 0,
        className: "flex items-center gap-2 text-base text-slate-700 cursor-pointer hover:opacity-80",
        onClick: props.onReadMoreRestricted,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            props.onReadMoreRestricted?.();
          }
        },
        "aria-label": t("common:labels.upgradeToView") || "",
        title: t("common:labels.upgradeToView") || "",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(
            "p",
            {
              className: `prose prose-slate ${showText ? "line-clamp-none" : ""}`,
              dangerouslySetInnerHTML: { __html: displayText },
              style: { color: theme.colors.gr3 },
              ref
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(Icon_default, { name: "lock", size: 16, color: theme.colors.n60, "aria-hidden": "true" })
        ]
      }
    );
  }
  return /* @__PURE__ */ (0, import_jsx_runtime190.jsx)("div", { className: "flex flex-col gap-1 items-center w-full max-w-[960px]", children: /* @__PURE__ */ (0, import_jsx_runtime190.jsxs)("div", { className: "relative w-full", style: { minHeight: minContainerHeight }, children: [
    isTextTruncatedByCharLimit && !showText ? /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(import_jsx_runtime190.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(
      "p",
      {
        className: `prose prose-slate min-w-full ${showText ? "line-clamp-none" : ""}`,
        style: !showText ? {
          display: "-webkit-box",
          WebkitLineClamp: lineClamp,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          color: theme.colors.gr3
        } : {},
        dangerouslySetInnerHTML: { __html: displayText + "..." },
        ref
      }
    ) }) : /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(
      "p",
      {
        className: `prose prose-slate min-w-full ${showText ? "line-clamp-none" : ""}`,
        style: !showText ? {
          display: "-webkit-box",
          WebkitLineClamp: lineClamp,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          color: theme.colors.gr3
        } : {},
        dangerouslySetInnerHTML: { __html: displayText },
        ref
      }
    ),
    showButton && !showText && /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(
      "div",
      {
        className: "absolute bottom-0 left-0 right-0 h-32 pointer-events-none",
        style: {
          background: `linear-gradient(to bottom, ${textFadeTransparent} 0%, ${textFadeColor} 70%)`
        }
      }
    ),
    showButton && /* @__PURE__ */ (0, import_jsx_runtime190.jsxs)(
      "button",
      {
        onClick: () => {
          if (props.onReadMoreRestricted && !showText) {
            props.onReadMoreRestricted();
          } else {
            setShowText(!showText);
          }
        },
        className: `${showText ? "relative mt-4" : "absolute bottom-0"} left-1/2 transform -translate-x-1/2 text-slate-600 font-medium flex items-center gap-1.5 hover:bg-slate-50 transition-all px-4 py-2 rounded-full bg-white border border-slate-300 whitespace-nowrap`,
        style: { color: mainColor, zIndex: 1 },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime190.jsx)("span", { children: showText ? t("common:labels.showLess") : props.readMoreText || t("common:labels.readMore") }),
          /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(
            "svg",
            {
              className: `w-4 h-4 transition-transform ${showText ? "rotate-180" : ""}`,
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              "aria-hidden": "true",
              children: /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: 2,
                  d: "M19 9l-7 7-7-7"
                }
              )
            }
          )
        ]
      }
    )
  ] }) });
}

// src/components/organisms/PropertyPreview/components/PropertyPreviewGeneralInfoSection/components/AgentHighlightsSection.tsx
var import_jsx_runtime191 = require("react/jsx-runtime");
var DEFAULT_RESTRICTED_CHAR_LIMIT = 200;
function AgentHighlightsSection({
  highlights,
  isRestricted,
  onRestrictedFieldClick,
  restrictedCharLimit
}) {
  const theme = (0, import_styled_components204.useTheme)();
  const { t } = (0, import_react_i18next88.useTranslation)(["common"]);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const highlightsRestriction = isRestricted ? { lineClamp: void 0, charLimit: restrictedCharLimit ?? DEFAULT_RESTRICTED_CHAR_LIMIT } : { lineClamp: void 0, charLimit: void 0 };
  return /* @__PURE__ */ (0, import_jsx_runtime191.jsxs)(Flex_default, { flexDirection: "column", gap: 12, children: [
    /* @__PURE__ */ (0, import_jsx_runtime191.jsx)(Box_default, { mb: 5, children: /* @__PURE__ */ (0, import_jsx_runtime191.jsx)(Text_default, { ...isMobile ? { xl: true } : { xxl: true }, bold: true, color: theme.colors.gr1, children: t("common:labels.agentHighlights") }) }),
    highlights && /* @__PURE__ */ (0, import_jsx_runtime191.jsx)(
      ExpandableText2,
      {
        text: highlights,
        charLimit: highlightsRestriction.charLimit,
        onReadMoreRestricted: isRestricted ? onRestrictedFieldClick : void 0,
        readMoreText: t("pages:propertyPage.viewAllHighlights") || ""
      }
    )
  ] });
}

// src/components/organisms/PropertyPreview/components/PropertyPreviewGeneralInfoSection/components/PropertyOverviewSection.tsx
var import_styled_components205 = require("styled-components");
var import_react_i18next89 = require("react-i18next");
var import_jsx_runtime192 = require("react/jsx-runtime");
function PropertyOverviewSection({
  overview,
  overviewCharLimit,
  onOverviewReadMoreRestricted,
  textFadeColor
}) {
  const theme = (0, import_styled_components205.useTheme)();
  const { t } = (0, import_react_i18next89.useTranslation)(["common"]);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime192.jsxs)(Flex_default, { flexDirection: "column", gap: 12, children: [
    /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(Box_default, { mb: 5, children: /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(Text_default, { ...isMobile ? { xl: true } : { xxl: true }, bold: true, color: theme.colors.gr1, children: t("common:labels.propertyOverview") }) }),
    overview && /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(
      ExpandableText2,
      {
        text: overview,
        charLimit: overviewCharLimit,
        onReadMoreRestricted: onOverviewReadMoreRestricted,
        readMoreText: t("pages:propertyPage.viewFullOverview") || "",
        textFadeColor
      }
    ),
    !overview && /* @__PURE__ */ (0, import_jsx_runtime192.jsx)("p", { children: "N/A" })
  ] });
}

// src/components/organisms/PropertyPreview/components/PropertyPreviewGeneralInfoSection/components/VirtualToursSection.tsx
var import_styled_components206 = __toESM(require("styled-components"));
var import_react_i18next90 = require("react-i18next");
var import_dash_common59 = require("dash-common");
var import_jsx_runtime193 = require("react/jsx-runtime");
var VirtualTourButton = import_styled_components206.default.button`
  display: flex;
  align-items: center;
  width: 100%;
  text-decoration: underline;
  text-underline-offset: 2px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  padding: ${({ theme }) => theme.space * 1.5}px;
  border-radius: ${({ theme }) => theme.space}px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.n30};
  }
`;
var GridBox2 = (0, import_styled_components206.default)(Box_default)`
  width: 100%;
  max-width: 960px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(max(45%, 256px), 1fr));
  column-gap: ${({ theme }) => theme.space * 6}px;
  /* Standard vertical spacing between amenity rows */
  row-gap: ${({ theme }) => theme.space * 3}px;

  /* Base border style for all items with border-b class */
  & .border-b {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gr7};
  }

  @media (max-width: 579px) {
    /* On mobile (single column), hide border for last item only */
    & .border-b:last-child {
      border-bottom: none;
    }
  }

  @media (min-width: 580px) {
    /* On desktop (2 columns), hide border for last 2 items */
    & .border-b:nth-last-child(1),
    & .border-b:nth-last-child(2) {
      border-bottom: none;
    }
  }
`;
function VirtualToursSection({
  virtualTours,
  isRestricted,
  onRestrictedFieldClick
}) {
  const theme = (0, import_styled_components206.useTheme)();
  const { t } = (0, import_react_i18next90.useTranslation)(["common"]);
  const handleLinkClick = (url) => {
    if (isRestricted && onRestrictedFieldClick) {
      onRestrictedFieldClick();
      return;
    }
    const normalizedUrl = (0, import_dash_common59.normalizeUrl)(url);
    window.open(normalizedUrl, "_blank", "noopener,noreferrer");
  };
  return /* @__PURE__ */ (0, import_jsx_runtime193.jsxs)(import_jsx_runtime193.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(Box_default, { mt: 8, children: /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(Text_default, { xl: true, bold: true, color: theme.colors.gr1, children: t("pages:propertyPage.virtualTours") }) }),
    /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(GridBox2, { children: virtualTours?.map((virtualTourLink, index2) => {
      return /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(Box_default, { pb: 2, maxWidth: 300, className: "border-b", children: /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(VirtualTourButton, { onClick: () => handleLinkClick(virtualTourLink.url), children: /* @__PURE__ */ (0, import_jsx_runtime193.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", w: "100%", children: [
        /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(
          Text_default,
          {
            textDecoration: "underline",
            className: "underline-offset-2",
            color: theme.colors.gr2,
            ellipsis: true,
            children: virtualTourLink.label || `${t("pages:propertyPage.virtualTour")} ${index2 + 1}`
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(Icon_default, { name: "chevronRight", className: "flex-shrink-0", ml: 4 })
      ] }) }) }, index2);
    }) })
  ] });
}

// src/components/organisms/PropertyPreview/components/PropertyPreviewGeneralInfoSection/GeneralInfoSection.tsx
var import_jsx_runtime194 = require("react/jsx-runtime");
var StyledFlex = import_styled_components207.default.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
function PropertyPreviewGeneralInfoSection(props) {
  const theme = (0, import_styled_components207.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime194.jsxs)("div", { className: "flex flex-col", ref: props.containerRef, children: [
    !props.isViewAsClient && !props.isSeeker && props.data.highlights && /* @__PURE__ */ (0, import_jsx_runtime194.jsxs)(import_jsx_runtime194.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime194.jsx)(
        AgentHighlightsSection,
        {
          highlights: props.data.highlights,
          isRestricted: props.isRestricted,
          onRestrictedFieldClick: props.onRestrictedFieldClick
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime194.jsx)(Devider_default, { mt: 8, mb: 8, h: 1, w: "100%", color: theme.colors.gr7 })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime194.jsxs)(StyledFlex, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime194.jsx)(
        PropertyOverviewSection,
        {
          overview: props.data.overview,
          overviewCharLimit: props.overviewCharLimit,
          onOverviewReadMoreRestricted: props.onOverviewReadMoreRestricted,
          textFadeColor: props.textFadeColor
        }
      ),
      props?.data?.virtualTours && props?.data?.virtualTours?.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime194.jsx)(
        VirtualToursSection,
        {
          virtualTours: props.data.virtualTours,
          isRestricted: props.isRestricted,
          onRestrictedFieldClick: props.onRestrictedFieldClick
        }
      )
    ] })
  ] });
}

// src/components/organisms/PropertyPreview/components/LocationAndContactSection/LocationAndContactSection.tsx
var import_react136 = require("react");
var import_react_i18next92 = require("react-i18next");
var import_styled_components209 = __toESM(require("styled-components"));
var import_dash_common60 = require("dash-common");

// src/components/organisms/PropertyPreview/components/LocationAndContactSection/components/SalesGalleryAddressSection.tsx
var import_react_i18next91 = require("react-i18next");
var import_styled_components208 = require("styled-components");
var import_jsx_runtime195 = require("react/jsx-runtime");
function SalesGalleryAddressSection({ salesGalleryAddress }) {
  const theme = (0, import_styled_components208.useTheme)();
  const { t } = (0, import_react_i18next91.useTranslation)();
  if (!salesGalleryAddress)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime195.jsxs)(Box_default, { mb: 2, mt: 5, children: [
    /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(Box_default, { mb: 2, children: /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(Text_default, { semibold: true, md: true, color: theme.colors.gr2, children: t("common:labels.address") }) }),
    /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(ExpandableHtmlText_default, { text: salesGalleryAddress, lineClamp: 3 })
  ] });
}

// src/components/organisms/PropertyPreview/components/LocationAndContactSection/LocationAndContactSection.tsx
var import_jsx_runtime196 = require("react/jsx-runtime");
var StyledTitle = (0, import_styled_components209.default)(Text_default)``;
var MapBox = (0, import_styled_components209.default)(Box_default)`
  min-height: 400px;
  display: flex;
  flex-direction: column;
`;
var ContentBox = (0, import_styled_components209.default)(Box_default)`
  display: flex;
  flex-direction: column;
`;
var TwoColumnGrid = (0, import_styled_components209.default)(Box_default)`
  display: grid;
  grid-template-columns: ${({ $isPortfolioView }) => $isPortfolioView ? "1fr" : "1fr 1fr"};
  column-gap: ${({ theme }) => theme.space * 4}px;
  row-gap: ${({ theme }) => theme.space * 6}px;
  align-items: stretch;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;
var shouldShowAvailability2 = (status, hours) => {
  return status === import_dash_common60.SalesGalleryStatusesEnum.COMING_SOON || status === import_dash_common60.SalesGalleryStatusesEnum.APPOINTMENT_ONLY || status === import_dash_common60.SalesGalleryStatusesEnum.HOURS_AVAILABLE && !!hours;
};
var convertTo12Hour3 = (time24) => {
  const [hours, minutes] = time24.split(":");
  const hour = parseInt(hours, 10);
  const period = hour < 12 ? "AM" : "PM";
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour.toString().padStart(2, "0")}:${minutes} ${period}`;
};
var getAbbreviatedDay2 = (day, t) => {
  const fullName = t(`common:labels.weekDays.${day}`);
  return fullName.slice(0, day === import_dash_common60.WeekDays.Tuesday ? 4 : 3);
};
function LocationAndContactSection({
  property,
  isRestricted = false,
  onRestrictedClick,
  isPortfolioView,
  contactScrollRef,
  disableMapScroll = false,
  isIdxView = false
}) {
  const { t } = (0, import_react_i18next92.useTranslation)();
  const theme = (0, import_styled_components209.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const modalContext = (0, import_react136.useContext)(ModalContext);
  const handleRestrictedClick = () => {
    if (onRestrictedClick) {
      onRestrictedClick();
    } else if (modalContext) {
      const { toggleModal, setUpgradeSubscriptionModal } = modalContext;
      setUpgradeSubscriptionModal({
        type: "BASIC" /* BASIC */
      });
      toggleModal(true, "UpgradeSubscriptionModal");
    }
  };
  const isRent = property?.transactionType === import_dash_common60.PropertyTransactionTypesEnum.FOR_RENT;
  const websiteUrl = property?.website;
  const salesGalleryAddress = property?.salesGalleryAddress;
  const hasContactInfo = !!(property?.contactEmail || property?.contactPhone?.number);
  const salesGalleryStatus = property?.salesGalleryStatus;
  const salesGalleryHours = property?.salesGalleryHours;
  const showAvailability = shouldShowAvailability2(salesGalleryStatus, salesGalleryHours);
  const contactPhone = property?.contactPhone;
  const contactEmail = property?.contactEmail;
  const ContactInfo = () => {
    if (!hasContactInfo)
      return null;
    return /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Box_default, { mt: 4, children: [
      contactPhone?.number && /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Flex_default, { mb: 3, alignItems: "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Icon_default, { mr: 1, name: "mobile", size: 22, color: theme.colors.gr2 }),
        renderPhoneField({
          phone: property.contactPhone,
          isRestricted,
          onRestrictedClick: handleRestrictedClick,
          theme
        })
      ] }),
      contactEmail && /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Flex_default, { mb: 3, alignItems: "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Icon_default, { mr: 1.5, ml: 0.5, mt: 0.5, name: "send", size: 18, color: theme.colors.gr2 }),
        renderEmailField({
          email: contactEmail,
          isRestricted,
          onRestrictedClick: handleRestrictedClick
        })
      ] })
    ] });
  };
  const HoursDisplay = () => {
    if (!salesGalleryHours)
      return null;
    return /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Box_default, { children: Object.values(import_dash_common60.WeekDays).map((day) => {
      const range = salesGalleryHours[day];
      const timeDisplay = range && range.from && range.to ? `${convertTo12Hour3(range.from)} - ${convertTo12Hour3(range.to)}` : t("common:labels.notAvailable");
      return /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Flex_default, { alignItems: "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Box_default, { mr: 2, w: 40, children: /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Text_default, { whiteSpace: "nowrap", children: [
          getAbbreviatedDay2(day, t),
          ":"
        ] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Text_default, { whiteSpace: "nowrap", sm: true, color: !range ? theme.colors.r20 : theme.colors.b50, children: timeDisplay })
      ] }, day);
    }) });
  };
  const AvailabilityContent = () => {
    switch (property?.salesGalleryStatus) {
      case import_dash_common60.SalesGalleryStatusesEnum.COMING_SOON:
        return /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Text_default, { color: theme.colors.n80, children: t("common:labels.comingSoon") });
      case import_dash_common60.SalesGalleryStatusesEnum.APPOINTMENT_ONLY:
        return /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Box_default, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Box_default, { mb: 3, children: /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Text_default, { color: theme.colors.n80, children: t("common:labels.byAppointmentOnly") }) }),
          /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(ContactInfo, {})
        ] });
      case import_dash_common60.SalesGalleryStatusesEnum.HOURS_AVAILABLE:
        return /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(HoursDisplay, {});
      default:
        return null;
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(TwoColumnGrid, { w: "100%", $isPortfolioView: isPortfolioView, children: [
    /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(MapBox, { children: /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
      MapSection_default,
      {
        property,
        h: "100%",
        disableMapScroll,
        isIdxView
      }
    ) }),
    !isPortfolioView && /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(ContentBox, { ref: contactScrollRef, children: [
      /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Box_default, { mb: 6, children: [
        /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
          StyledTitle,
          {
            ...isMobile ? { lg: true } : { xl: true },
            semibold: true,
            color: theme.colors.gr1,
            children: t("pages:propertyPage.propertyLocation")
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Flex_default, { overflow: "hidden", alignItems: "start", mt: 4, children: [
          /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Flex_default, { alignItems: "center", mt: 0.5, children: /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Icon_default, { color: theme.colors.gr3, name: "pin", mr: [2, 2, 2, 2] }) }),
          /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Text_default, { ellipsis: false, md: true, color: theme.colors.gr3, "data-testid": "address", children: property?.location?.address ? (0, import_dash_common60.formatAddress)(property?.location.address) : "" })
        ] })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Box_default, { mb: 6, children: [
        /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
          StyledTitle,
          {
            ...isMobile ? { lg: true } : { xl: true },
            semibold: true,
            color: theme.colors.gr1,
            children: isRent ? t("pages:propertyPage.contactLeasingOffice") : t("pages:propertyPage.contact")
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Box_default, { mt: 5, children: [
          property?.contactPhone?.number && /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Flex_default, { mb: 3, alignItems: "center", children: [
            /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Icon_default, { mr: 1, name: "mobile", size: 22, color: theme.colors.gr2 }),
            renderPhoneField({
              phone: property.contactPhone,
              isRestricted,
              onRestrictedClick: handleRestrictedClick,
              theme
            })
          ] }),
          property?.contactEmail && /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Flex_default, { mb: 3, alignItems: "center", children: [
            /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Icon_default, { mr: 1.5, ml: 0.5, mt: 0.5, name: "send", size: 18, color: theme.colors.gr2 }),
            renderEmailField({
              email: property?.contactEmail,
              isRestricted,
              onRestrictedClick: handleRestrictedClick
            })
          ] }),
          websiteUrl && /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Flex_default, { mb: 3, alignItems: "center", children: [
            /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
              Icon_default,
              {
                mr: 1.5,
                ml: 0.5,
                mt: 0.5,
                name: "world",
                size: 18,
                color: theme.colors.gr2
              }
            ),
            renderWebsiteField({
              website: websiteUrl,
              isRestricted,
              onRestrictedClick: handleRestrictedClick
            })
          ] })
        ] })
      ] }),
      property.salesGalleryStatus && property.salesGalleryStatus !== import_dash_common60.SalesGalleryStatusesEnum.NO_INFORMATION && /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(import_jsx_runtime196.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
          StyledTitle,
          {
            ...isMobile ? { lg: true } : { xl: true },
            semibold: true,
            color: theme.colors.gr1,
            children: isRent ? t("pages:propertyPage.leasingOfficeInfo") : t("pages:propertyPage.salesGalleryInfo")
          }
        ),
        isRestricted ? /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Box_default, { mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Button_default, { px: 5, onClick: handleRestrictedClick, children: t("pages:propertyPage.viewDetails") }) }) : /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(import_jsx_runtime196.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(SalesGalleryAddressSection, { salesGalleryAddress }),
          showAvailability && /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(Box_default, { mt: salesGalleryAddress ? 4 : 3, children: [
            /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Box_default, { mb: 3, children: /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(Text_default, { semibold: true, md: true, color: theme.colors.gr2, children: t("pages:portfoliosPage.availability") }) }),
            /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(AvailabilityContent, {})
          ] })
        ] })
      ] })
    ] })
  ] });
}
var LocationAndContactSection_default = LocationAndContactSection;

// src/components/organisms/PropertyPreview/components/SummarySection/SummarySection.tsx
var import_dash_common63 = require("dash-common");
var import_react138 = require("react");

// src/components/organisms/PropertyPreview/components/SummarySection/components/PropertySummaryContainer.tsx
var import_dash_common61 = require("dash-common");
var import_lodash27 = require("lodash");
var import_react_i18next93 = require("react-i18next");
var import_styled_components210 = require("styled-components");
var import_jsx_runtime197 = require("react/jsx-runtime");
function PropertySummaryContainer({
  property,
  isComingSoon,
  isCompleted
}) {
  const theme = (0, import_styled_components210.useTheme)();
  const { t } = (0, import_react_i18next93.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime197.jsxs)(import_jsx_runtime197.Fragment, { children: [
    !isComingSoon && /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(import_jsx_runtime197.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(Flex_default, { mb: 2, children: /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(Text_default, { xxl: true, color: theme.colors.gr1, ellipsis: true, "data-tooltip-id": `price-${property._id}`, children: (0, import_dash_common61.formatPriceRange)(
      property?.priceRange?.min || 0,
      property?.priceRange?.max || 0,
      {
        shortMin: true,
        shortMax: true,
        prefix: t("common:labels:from") || ""
      },
      {
        maximumFractionDigits: 2
      }
    ) || t("common:labels.noValue") }) }) }),
    /* @__PURE__ */ (0, import_jsx_runtime197.jsxs)(Flex_default, { overflow: "hidden", alignItems: "start", mt: 2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(Flex_default, { alignItems: "center", mt: 1, children: /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(Icon_default, { color: theme.colors.gr5, name: "pin", mr: [2, 2, 2, 2] }) }),
      /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(Text_default, { ellipsis: false, lg: true, color: theme.colors.gr5, "data-testid": "address", children: property?.location?.address ? (0, import_dash_common61.formatAddress)(property?.location.address) : "" })
    ] }),
    property?.projectStatus && /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(Flex_default, { mt: 3, children: /* @__PURE__ */ (0, import_jsx_runtime197.jsxs)(Text_default, { color: theme.colors.gr3, "data-testid": "project-status", children: [
      !isComingSoon && !isCompleted && property.projectStatus !== import_dash_common61.ProjectStatusesEnum.LEAVING_SOON && t(`forms:labels:projectStatuses:${(0, import_lodash27.camelCase)(property?.projectStatus)}`),
      property?.yearBuilt ? isComingSoon || isCompleted || property.projectStatus === import_dash_common61.ProjectStatusesEnum.LEAVING_SOON ? t(
        `pages:propertyPage:${property?.projectStatus === import_dash_common61.ProjectStatusesEnum.NEW_CONSTRUCTION || isCompleted ? "completedIn" : "estCompletion"}`,
        {
          date: property?.yearBuilt
        }
      ) : `, ${t(
        `pages:propertyPage:${property?.projectStatus === import_dash_common61.ProjectStatusesEnum.NEW_CONSTRUCTION || isCompleted ? "completedIn" : "estCompletion"}`,
        {
          date: property?.yearBuilt
        }
      )}` : ""
    ] }) })
  ] });
}

// src/components/organisms/PropertyPreview/components/SummarySection/components/TagsContainer.tsx
var import_dash_common62 = require("dash-common");
var import_lodash28 = require("lodash");
var import_react137 = require("react");
var import_react_i18next94 = require("react-i18next");
var import_styled_components212 = __toESM(require("styled-components"));

// src/components/organisms/PropertyPreview/components/SummarySection/components/Tag.tsx
var import_styled_components211 = __toESM(require("styled-components"));

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}

// ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

// ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}

// ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

// ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}

// ../../node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}

// ../../node_modules/@babel/runtime/helpers/esm/construct.js
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

// ../../node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper2);
    }
    function Wrapper2() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper2.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper2,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper2, Class2);
  };
  return _wrapNativeSuper(Class);
}

// ../../node_modules/polished/dist/polished.esm.js
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
  "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
  "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
  "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
  "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
  "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
  "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
  "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
  "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
};
function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function(d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
var PolishedError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(PolishedError2, _Error);
  function PolishedError2(code) {
    var _this;
    if (process.env.NODE_ENV === "production") {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized(_this);
  }
  return PolishedError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function colorToInt(color2) {
  return Math.round(color2 * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue2, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    return convert(lightness, lightness, lightness);
  }
  var huePrime = (hue2 % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function nameToHex(color2) {
  if (typeof color2 !== "string")
    return color2;
  var normalizedColorName = color2.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color2;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb(color2) {
  if (typeof color2 !== "string") {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color2);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha2 = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha2
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue2 = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue2, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}
function rgbToHsl(color2) {
  var red = color2.red / 255;
  var green = color2.green / 255;
  var blue = color2.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;
  if (max === min) {
    if (color2.alpha !== void 0) {
      return {
        hue: 0,
        saturation: 0,
        lightness,
        alpha: color2.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness
      };
    }
  }
  var hue2;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue2 = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue2 = (blue - red) / delta + 2;
      break;
    default:
      hue2 = (red - green) / delta + 4;
      break;
  }
  hue2 *= 60;
  if (color2.alpha !== void 0) {
    return {
      hue: hue2,
      saturation,
      lightness,
      alpha: color2.alpha
    };
  }
  return {
    hue: hue2,
    saturation,
    lightness
  };
}
function parseToHsl(color2) {
  return rgbToHsl(parseToRgb(color2));
}
var reduceHexValue = function reduceHexValue2(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
  var hex2 = value.toString(16);
  return hex2.length === 1 ? "0" + hex2 : hex2;
}
function colorToHex(color2) {
  return numberToHex(Math.round(color2 * 255));
}
function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue2, saturation, lightness) {
  return hslToRgb(hue2, saturation, lightness, convertToHex);
}
function hsl(value, saturation, lightness) {
  if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number") {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === "object" && saturation === void 0 && lightness === void 0) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }
  throw new PolishedError(1);
}
function hsla(value, saturation, lightness, alpha2) {
  if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number" && typeof alpha2 === "number") {
    return alpha2 >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha2 + ")";
  } else if (typeof value === "object" && saturation === void 0 && lightness === void 0 && alpha2 === void 0) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new PolishedError(2);
}
function rgb(value, green, blue) {
  if (typeof value === "number" && typeof green === "number" && typeof blue === "number") {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === "object" && green === void 0 && blue === void 0) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === "string" && typeof secondValue === "number") {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}
var isRgb = function isRgb2(color2) {
  return typeof color2.red === "number" && typeof color2.green === "number" && typeof color2.blue === "number" && (typeof color2.alpha !== "number" || typeof color2.alpha === "undefined");
};
var isRgba = function isRgba2(color2) {
  return typeof color2.red === "number" && typeof color2.green === "number" && typeof color2.blue === "number" && typeof color2.alpha === "number";
};
var isHsl = function isHsl2(color2) {
  return typeof color2.hue === "number" && typeof color2.saturation === "number" && typeof color2.lightness === "number" && (typeof color2.alpha !== "number" || typeof color2.alpha === "undefined");
};
var isHsla = function isHsla2(color2) {
  return typeof color2.hue === "number" && typeof color2.saturation === "number" && typeof color2.lightness === "number" && typeof color2.alpha === "number";
};
function toColorString(color2) {
  if (typeof color2 !== "object")
    throw new PolishedError(8);
  if (isRgba(color2))
    return rgba(color2);
  if (isRgb(color2))
    return rgb(color2);
  if (isHsla(color2))
    return hsla(color2);
  if (isHsl(color2))
    return hsl(color2);
  throw new PolishedError(8);
}
function curried(f, length, acc) {
  return function fn() {
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}
function curry(f) {
  return curried(f, f.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
function lighten(amount, color2) {
  if (color2 === "transparent")
    return color2;
  var hslColor = parseToHsl(color2);
  return toColorString(_extends2({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
}
var curriedLighten = /* @__PURE__ */ curry(lighten);
var curriedLighten$1 = curriedLighten;

// src/components/organisms/PropertyPreview/components/SummarySection/components/Tag.tsx
var import_jsx_runtime198 = require("react/jsx-runtime");
var StyledTags = (0, import_styled_components211.default)(Box_default)`
  background-color: ${({ theme, $idxBranding, $variant }) => $idxBranding ? $variant === "light" ? curriedLighten$1(0.1, $idxBranding.mainColor) : $idxBranding.mainColor : theme.colors.gr7};
  color: ${({ theme, $idxBranding }) => $idxBranding ? "#ffffff" : theme.colors.gr2};
  border-radius: 4px;
  padding: 4px 12px;
`;
var StyledTagsText = (0, import_styled_components211.default)(Text_default)`
  color: inherit;
  font-size: 13px;
`;
function Tag2({
  title,
  idxBranding,
  variant = "default"
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(StyledTags, { $idxBranding: idxBranding, $variant: variant, children: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(StyledTagsText, { children: title }) });
}

// src/components/organisms/PropertyPreview/components/SummarySection/components/TagsContainer.tsx
var import_jsx_runtime199 = require("react/jsx-runtime");
var ExpandableText3 = (0, import_styled_components212.default)(Text_default)`
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
var MAX_VISIBLE_TAGS = 4;
function TagsContainer({ property, isComingSoon, idxBranding }) {
  const { t } = (0, import_react_i18next94.useTranslation)();
  const theme = (0, import_styled_components212.useTheme)();
  const [isExpanded, setIsExpanded] = (0, import_react137.useState)(false);
  const tags = [];
  if (property?.marketArea) {
    tags.push(
      /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
        Tag2,
        {
          title: property?.marketArea?.name,
          idxBranding,
          variant: "default"
        },
        "marketArea"
      )
    );
  }
  if (property?.transactionType) {
    tags.push(
      /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
        Tag2,
        {
          title: t(`forms:labels.propertyTransactionTypes.${(0, import_lodash28.camelCase)(property.transactionType)}`),
          idxBranding,
          variant: "light"
        },
        "transactionType"
      )
    );
  }
  if (isComingSoon) {
    tags.push(
      /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
        Tag2,
        {
          title: t("common:labels.comingSoon"),
          idxBranding,
          variant: "light"
        },
        "comingSoon"
      )
    );
  }
  if (property?.projectStatus === "PROPOSED") {
    tags.push(
      /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
        Tag2,
        {
          title: t("common:labels.proposed"),
          idxBranding,
          variant: "light"
        },
        "proposed"
      )
    );
  }
  if ([import_dash_common62.CmsStatusEnum.NEW_LISTING, import_dash_common62.CmsStatusEnum.RECENTLY_UPDATED].includes(
    property.cmsStatus
  )) {
    tags.push(
      /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
        Tag2,
        {
          title: t(`common:labels.${property.cmsStatus?.toLowerCase()}`),
          idxBranding,
          variant: "light"
        },
        "cmsStatus"
      )
    );
  }
  (property?.propertyTags ?? []).forEach((tag) => {
    tags.push(
      /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
        Tag2,
        {
          title: t(`forms:labels.propertyTags.${(0, import_lodash28.camelCase)(tag)}`),
          idxBranding,
          variant: "light"
        },
        `tag-${tag}`
      )
    );
  });
  const hasMore = tags.length > MAX_VISIBLE_TAGS;
  const visibleTags = isExpanded ? tags : tags.slice(0, MAX_VISIBLE_TAGS);
  return /* @__PURE__ */ (0, import_jsx_runtime199.jsxs)(Flex_default, { mt: 6, gap: 12, flexWrap: "wrap", alignItems: "center", children: [
    visibleTags,
    hasMore && /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(Box_default, { onClick: () => setIsExpanded(!isExpanded), children: /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(ExpandableText3, { md: true, color: theme.colors.gr4, children: isExpanded ? t("pages:featuredPortfolios.modal.showLess") : t("pages:featuredPortfolios.modal.xMore", {
      count: tags.length - MAX_VISIBLE_TAGS
    }) }) })
  ] });
}

// src/components/organisms/PropertyPreview/components/SummarySection/components/KeyFeaturesContainer.tsx
var import_react_i18next95 = require("react-i18next");

// src/components/organisms/PropertyPreview/components/SummarySection/components/KeyFeature.tsx
var import_styled_components213 = require("styled-components");
var import_jsx_runtime200 = require("react/jsx-runtime");
function KeyFeature({
  iconName,
  amountText,
  label
}) {
  const theme = (0, import_styled_components213.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime200.jsxs)(Flex_default, { flexDirection: "column", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime200.jsx)(Icon_default, { name: iconName, size: 38, color: theme.colors.gr2 }),
    /* @__PURE__ */ (0, import_jsx_runtime200.jsx)(Text_default, { lg: true, ellipsis: true, color: theme.colors.gr1, children: amountText }),
    /* @__PURE__ */ (0, import_jsx_runtime200.jsx)(Text_default, { color: theme.colors.gr4, md: true, children: label })
  ] });
}

// src/components/organisms/PropertyPreview/components/SummarySection/components/KeyFeaturesContainer.tsx
var import_jsx_runtime201 = require("react/jsx-runtime");
function KeyFeaturesContainer({
  property,
  unitsSqftRange
}) {
  const { t } = (0, import_react_i18next95.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime201.jsxs)(Flex_default, { gap: 32, children: [
    /* @__PURE__ */ (0, import_jsx_runtime201.jsx)(
      KeyFeature,
      {
        iconName: "bedroom",
        amountText: formatBedroomsRangeValues(property?.averageBedroomsNumberValue, {
          isNullable: property?.averageBedroomsNumberValue?.min === 0,
          t
        }) || t("common:labels.noValue"),
        label: t("common:labels.beds")
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime201.jsx)(
      KeyFeature,
      {
        iconName: "bathroom",
        amountText: formatBathroomsRangeValues(property?.averageBathroomsNumberValue, {
          isNullable: property?.averageBathroomsNumberValue?.min === 0,
          t
        }) || t("common:labels.noValue"),
        label: t("common:labels.baths")
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime201.jsx)(
      KeyFeature,
      {
        iconName: "floorPlan",
        amountText: unitsSqftRange ? formatGeneralRangeValues(unitsSqftRange, { t }) : t("common:labels.noValue"),
        label: t("common:labels.sqft")
      }
    )
  ] });
}

// src/components/organisms/PropertyPreview/components/SummarySection/SummarySection.tsx
var import_jsx_runtime202 = require("react/jsx-runtime");
function SummarySection({ property, idxBranding, unitsSqftRange }) {
  const isComingSoon = (0, import_react138.useMemo)(
    () => property?.projectStatus === import_dash_common63.ProjectStatusesEnum.COMING_SOON,
    [property]
  );
  const isCompleted = (0, import_react138.useMemo)(
    () => property?.projectStatus === import_dash_common63.ProjectStatusesEnum.COMPLETED,
    [property]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime202.jsx)(import_jsx_runtime202.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime202.jsxs)(Flex_default, { w: "100%", flexWrap: "wrap", justifyContent: "space-between", gap: 32, mt: 2, children: [
    /* @__PURE__ */ (0, import_jsx_runtime202.jsxs)(Flex_default, { flexDirection: "column", children: [
      /* @__PURE__ */ (0, import_jsx_runtime202.jsx)(
        PropertySummaryContainer,
        {
          property,
          isComingSoon,
          isCompleted
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime202.jsx)(
        TagsContainer,
        {
          property,
          isComingSoon,
          idxBranding
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime202.jsx)(KeyFeaturesContainer, { property, unitsSqftRange })
  ] }) });
}

// src/components/organisms/PropertyPreview/components/AdditionalInfoSectionWithHistory/AdditionalInfoSectionWithHistory.tsx
var import_jsx_runtime203 = require("react/jsx-runtime");
function AdditionalInfoSectionWithHistory({
  property,
  containerRef,
  isViewAsClient,
  isRestricted,
  onRestrictedFieldClick,
  propertyHistory = [],
  propertyHistoryLoading = false,
  isOpenHistoryModal = false,
  onOpenHistoryModal,
  onCloseHistoryModal,
  renderModal = true
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime203.jsxs)(import_jsx_runtime203.Fragment, { children: [
    renderModal && /* @__PURE__ */ (0, import_jsx_runtime203.jsx)(
      PropertyHistoryModal_default,
      {
        isOpen: isOpenHistoryModal,
        onClose: onCloseHistoryModal || (() => {
        }),
        loading: propertyHistoryLoading,
        data: propertyHistory
      }
    ),
    property && /* @__PURE__ */ (0, import_jsx_runtime203.jsx)(
      AdditionalInfoSection_default,
      {
        property,
        containerRef,
        isViewAsClient: !!isViewAsClient,
        isRestricted,
        onRestrictedFieldClick,
        onLastUpdatedClick: onOpenHistoryModal
      }
    )
  ] });
}

// src/components/organisms/PropertyPreview/components/SlideShowSection/SlideShowSection.tsx
var import_react139 = require("react");
var import_jsx_runtime204 = require("react/jsx-runtime");
function SlideShowSection({
  property,
  isIdxView = false,
  slideshowMedia = [],
  slideshowLoading = false,
  maxNavigableIndex,
  onNavigationRestricted
}) {
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const files = (0, import_react139.useMemo)(
    () => slideshowMedia.map((item) => {
      const [file] = item.files;
      return {
        _id: item._id,
        name: file?.name || "",
        publicUrl: file?.publicUrl || "",
        type: file?.type || "",
        s3Key: file?.s3Key || "",
        thumbnailFileUrl: file?.thumbnailFileUrl || file?.publicUrl || ""
      };
    }),
    [slideshowMedia]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime204.jsx)(
    SlideshowPreview_default,
    {
      w: "100%",
      files,
      loading: slideshowLoading,
      totalCount: files.length,
      mainFileId: property?.mainPropertyMediaFile?._id,
      maxNavigableIndex,
      onNavigationRestricted,
      topMargin: isIdxView ? 20 : void 0,
      borderRadius: isMobile ? 0 : void 0,
      isIdxView
    }
  );
}

// src/components/organisms/PropertyPreview/components/AmenitiesSection/AmenitiesSection.tsx
var import_jsx_runtime205 = require("react/jsx-runtime");
function AmenitiesSection({
  amenities = [],
  amenitiesCount = 0,
  amenitiesLoading = false,
  maxAmenities,
  onViewMoreAmenitiesRestricted
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime205.jsx)(
    FeaturesAndAmenitiesList_default,
    {
      totalAmenitiesCount: amenitiesCount,
      amenities,
      loading: amenitiesLoading,
      maxAmenities,
      onViewMoreAmenitiesRestricted
    }
  );
}

// src/components/organisms/PropertyPreview/components/PropertyActions/PropertyActions.tsx
var import_react_i18next96 = require("react-i18next");
var import_styled_components214 = __toESM(require("styled-components"));
var import_jsx_runtime206 = require("react/jsx-runtime");
var ActionButton2 = import_styled_components214.default.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space * 1.5}px;
  text-decoration: underline;
  text-underline-offset: 2px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-family: inherit;
  white-space: nowrap;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.gr4};
  padding: ${({ theme }) => theme.space * 1.5}px ${({ theme }) => theme.space * 1.5}px;
  border-radius: ${({ theme }) => theme.space}px;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.n30};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  ${({ isLoading }) => isLoading && `
    opacity: 0.7;
    pointer-events: none;
  `}
`;
var ActionsRow2 = (0, import_styled_components214.default)(Flex_default)`
  @media ${({ theme }) => theme.devices.mobile} {
    justify-content: flex-start;
  }
`;
var HeartIcon = ({ isSaved, isLoading }) => {
  const theme = (0, import_styled_components214.useTheme)();
  if (isLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime206.jsx)(Spinner_default, { size: 16, color: theme.colors.n80 });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime206.jsx)(
    Icon_default,
    {
      name: isSaved ? "favoriteFilled" : "favorite",
      size: 16,
      className: "flex-shrink-0",
      color: isSaved ? theme.colors.r60 : "currentColor"
    }
  );
};
function PropertyActions({
  property,
  hideShareButton = false,
  disabled = false,
  propertyHistory = [],
  propertyHistoryLoading = false,
  isOpenHistoryModal = false,
  onOpenHistoryModal,
  onCloseHistoryModal,
  onOpenShareModal,
  loadingTrackProperty = false,
  onTrackProperty,
  renderModal = true,
  isPropertySaved = false
}) {
  const { t } = (0, import_react_i18next96.useTranslation)();
  const fromNow = usePropertyUpdatedAgo(property?.lastUpdatedAtByChangelog);
  return /* @__PURE__ */ (0, import_jsx_runtime206.jsxs)(import_jsx_runtime206.Fragment, { children: [
    renderModal && /* @__PURE__ */ (0, import_jsx_runtime206.jsx)(
      PropertyHistoryModal_default,
      {
        isOpen: isOpenHistoryModal,
        onClose: onCloseHistoryModal || (() => {
        }),
        loading: propertyHistoryLoading,
        data: propertyHistory
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime206.jsxs)(ActionsRow2, { gap: 6, flexWrap: "wrap", justifyContent: "flex-end", children: [
      /* @__PURE__ */ (0, import_jsx_runtime206.jsxs)(ActionButton2, { onClick: onOpenHistoryModal, children: [
        /* @__PURE__ */ (0, import_jsx_runtime206.jsx)(Icon_default, { name: "history", size: 16, className: "flex-shrink-0" }),
        /* @__PURE__ */ (0, import_jsx_runtime206.jsx)("span", { children: t("pages:propertyPreviewPage.lastUpdatedLabel", {
          date: fromNow
        }) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime206.jsxs)(
        ActionButton2,
        {
          disabled: disabled || loadingTrackProperty,
          isLoading: loadingTrackProperty,
          onClick: onTrackProperty,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime206.jsx)(HeartIcon, { isSaved: isPropertySaved, isLoading: loadingTrackProperty }),
            /* @__PURE__ */ (0, import_jsx_runtime206.jsx)("span", { children: isPropertySaved ? t("pages:propertyPreviewPage.savedActionLabel") : t("pages:propertyPreviewPage.saveActionLabel") })
          ]
        }
      ),
      !hideShareButton && /* @__PURE__ */ (0, import_jsx_runtime206.jsxs)(ActionButton2, { onClick: onOpenShareModal, disabled, children: [
        /* @__PURE__ */ (0, import_jsx_runtime206.jsx)(Icon_default, { name: "share", size: 16, className: "flex-shrink-0" }),
        /* @__PURE__ */ (0, import_jsx_runtime206.jsx)("span", { children: t("pages:propertyPreviewPage.shareActionLabel") })
      ] })
    ] })
  ] });
}

// src/components/organisms/FeaturedPortfolio/FeaturedPortfolioCard.tsx
var import_styled_components215 = __toESM(require("styled-components"));
var import_react_i18next97 = require("react-i18next");
var import_jsx_runtime207 = require("react/jsx-runtime");
var StyledWrapper7 = (0, import_styled_components215.default)(Box_default)`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  border-radius: 8px;
  height: 100%;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
  }
`;
var ImageContainer2 = (0, import_styled_components215.default)(Box_default)`
  position: relative;
  z-index: 1;
  overflow: visible;
`;
var imageCss = `
  width: 100%;
  height: 100%;
  border-radius: 8px 8px 0 0;
`;
var StyledImage6 = (0, import_styled_components215.default)(Thumbnail_default)`
  ${imageCss}
`;
var StyledDashPlaceholder = (0, import_styled_components215.default)(DashPlaceholder_default)`
  ${imageCss}
`;
var CardTitle = (0, import_styled_components215.default)(Text_default)`
  font-size: 20px;
  line-height: 1.25;
  margin-top: 4px;
`;
var CardDescriptionWrapper = (0, import_styled_components215.default)(Box_default)`
  font-size: 16px;
  line-height: 1.5;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  color: ${({ color: color2 }) => color2};

  /* Prose styling for HTML content */
  p {
    margin: 0;
    color: inherit;
  }

  ul,
  ol {
    margin: 0;
    padding-left: 20px;
    color: inherit;
  }

  strong {
    font-weight: 600;
    color: inherit;
  }

  em {
    font-style: italic;
    color: inherit;
  }

  * {
    color: inherit;
  }
`;
var PropertiesAmountText = (0, import_styled_components215.default)(Text_default)`
  font-size: 14px;
`;
var PropertiesAmountSection = (0, import_styled_components215.default)(Flex_default)`
  margin-top: 16px;
  align-items: center;
  gap: 16px;
`;
var OverlayContainer2 = (0, import_styled_components215.default)(Box_default)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
`;
var ActionButtons = (0, import_styled_components215.default)(Flex_default)`
  position: absolute;
  top: ${({ theme }) => theme.space * 3}px;
  right: ${({ theme }) => theme.space * 3}px;
  z-index: 2;
  gap: 12px;
  opacity: ${({ $alwaysVisible }) => $alwaysVisible ? 1 : 0};
  transition: opacity 0.2s ease-in-out;
  overflow: visible;

  ${StyledWrapper7}:hover & {
    opacity: 1;
  }
`;
var FavoriteButton = (0, import_styled_components215.default)(Flex_default)`
  padding: 4px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: visible;

  /* Ensure SVG doesn't clip its own content */
  svg {
    overflow: visible !important;
    transition: transform 0.2s ease-in-out;
    stroke: white !important;
  }

  /* Target the SVG path directly to override stroke color */
  svg path {
    stroke: white !important;
    transition: transform 0.2s ease-in-out;
  }

  /* Only scale up on hover if not loading (spinner should not animate) */
  &:hover {
    svg:not([data-loading='true']) {
      transform: scale(1.08);
    }

    svg:not([data-loading='true']) path {
      transform: scale(1.08);
    }
  }
`;
var FeaturedPortfolioCard = ({
  coverImage,
  title,
  description,
  numberOfProperties,
  cardWidth,
  onClick,
  showActions = false,
  onFavoriteClick,
  isFavorited = false,
  isLoadingFavorite = false,
  overlay
}) => {
  const theme = (0, import_styled_components215.useTheme)();
  const { t } = (0, import_react_i18next97.useTranslation)("pages");
  const { devices } = useScreenResolution();
  const isMobile = devices.isMobile;
  return /* @__PURE__ */ (0, import_jsx_runtime207.jsxs)(StyledWrapper7, { w: "100%", maxWidth: cardWidth ?? "100%", onClick, children: [
    /* @__PURE__ */ (0, import_jsx_runtime207.jsxs)(ImageContainer2, { h: 180, pos: "relative", children: [
      coverImage ? /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(StyledImage6, { file: coverImage }) : /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(StyledDashPlaceholder, { variation: "secondary" }),
      showActions && /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(ActionButtons, { $alwaysVisible: isFavorited || isMobile, children: /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(
        FavoriteButton,
        {
          onClick: (e) => {
            e.stopPropagation();
            onFavoriteClick?.();
          },
          children: isLoadingFavorite ? /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(Spinner_default, { size: 20, "data-loading": "true", color: theme.colors.white }) : /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(
            Icon_default,
            {
              name: "favoriteFilledStroke",
              size: 24,
              color: isFavorited ? theme.colors.r60 : "rgba(0, 0, 0, 0.5)"
            }
          )
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime207.jsxs)(Flex_default, { flexDirection: "column", p: 4, flex: 1, children: [
      /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(CardTitle, { semibold: true, color: theme.colors.gr1, children: title }),
      /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(Box_default, { mt: 5, children: /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(
        CardDescriptionWrapper,
        {
          color: theme.colors.gr4,
          dangerouslySetInnerHTML: { __html: description }
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(Box_default, { style: { flex: 1 } }),
      /* @__PURE__ */ (0, import_jsx_runtime207.jsxs)(PropertiesAmountSection, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(Icon_default, { name: "house", color: theme.colors.gr5 }),
        /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(PropertiesAmountText, { color: theme.colors.gr5, children: t("featuredPortfolios.properties", { count: numberOfProperties }) })
      ] })
    ] }),
    overlay && /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(OverlayContainer2, { children: overlay })
  ] });
};

// src/components/organisms/FeaturedPortfolio/Modal/FeaturedPortfolioModal.tsx
var import_react142 = require("react");
var import_styled_components221 = __toESM(require("styled-components"));
var import_react_i18next103 = require("react-i18next");

// src/components/organisms/FeaturedPortfolio/Modal/FeaturedPortfolioSummary.tsx
var import_styled_components216 = __toESM(require("styled-components"));
var import_react_i18next98 = require("react-i18next");
var import_dash_common64 = require("dash-common");
var import_jsx_runtime208 = require("react/jsx-runtime");
var SummaryFlex = (0, import_styled_components216.default)(Flex_default)`
  column-gap: 24px;
  row-gap: 4px;
`;
var FeaturedPortfolioSummary = ({
  priceRange,
  completionYearRange,
  propertyCount,
  propertyIds
}) => {
  const { t } = (0, import_react_i18next98.useTranslation)("pages");
  const theme = (0, import_styled_components216.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime208.jsxs)(SummaryFlex, { alignItems: "center", flexWrap: "wrap", children: [
    priceRange && /* @__PURE__ */ (0, import_jsx_runtime208.jsxs)(import_jsx_runtime208.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime208.jsx)(Text_default, { semibold: true, color: theme.colors.gr2, lg: true, children: (0, import_dash_common64.formatPriceRange)(priceRange.min ?? void 0, priceRange.max ?? void 0, {
        shortMin: true,
        shortMax: true
      }) }),
      /* @__PURE__ */ (0, import_jsx_runtime208.jsx)(Text_default, { color: theme.colors.gr2, lg: true, children: "\u2022" })
    ] }),
    completionYearRange && /* @__PURE__ */ (0, import_jsx_runtime208.jsxs)(import_jsx_runtime208.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime208.jsxs)(Text_default, { color: theme.colors.gr2, lg: true, children: [
        t("featuredPortfolios.modal.completionFrom"),
        " ",
        completionYearRange.min ?? "-",
        " ",
        t("featuredPortfolios.modal.to"),
        " ",
        completionYearRange.max ?? "-"
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime208.jsx)(Text_default, { color: theme.colors.gr2, lg: true, children: "\u2022" })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime208.jsxs)(Text_default, { color: theme.colors.gr2, lg: true, children: [
      propertyCount ?? propertyIds.length,
      " ",
      t("featuredPortfolios.modal.propertiesCount")
    ] })
  ] });
};

// src/components/organisms/FeaturedPortfolio/Modal/MarketAreasList.tsx
var import_styled_components217 = __toESM(require("styled-components"));
var import_react_i18next99 = require("react-i18next");
var import_react140 = require("react");
var import_jsx_runtime209 = require("react/jsx-runtime");
var ExpandableText4 = (0, import_styled_components217.default)(Text_default)`
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
var MAX_VISIBLE_MARKET_AREAS = 6;
var MarketAreasList = ({ marketAreas }) => {
  const { t } = (0, import_react_i18next99.useTranslation)("pages");
  const theme = (0, import_styled_components217.useTheme)();
  const [isExpanded, setIsExpanded] = (0, import_react140.useState)(false);
  const hasMore = marketAreas.length > MAX_VISIBLE_MARKET_AREAS;
  const visibleAreas = isExpanded ? marketAreas : marketAreas.slice(0, MAX_VISIBLE_MARKET_AREAS);
  return /* @__PURE__ */ (0, import_jsx_runtime209.jsxs)(Box_default, { mt: 4, children: [
    /* @__PURE__ */ (0, import_jsx_runtime209.jsxs)(Flex_default, { gap: 8, alignItems: "center", flexWrap: "wrap", children: [
      /* @__PURE__ */ (0, import_jsx_runtime209.jsx)(Icon_default, { name: "pin", color: theme.colors.gr2 }),
      /* @__PURE__ */ (0, import_jsx_runtime209.jsx)(Text_default, { semibold: true, color: theme.colors.gr2, lg: true, children: t("featuredPortfolios.modal.marketAreasLabel") })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime209.jsxs)(Flex_default, { mt: 3, gap: 16, flexWrap: "wrap", alignItems: "center", children: [
      visibleAreas.map((area) => /* @__PURE__ */ (0, import_jsx_runtime209.jsx)(Tag2, { title: area }, area)),
      hasMore && /* @__PURE__ */ (0, import_jsx_runtime209.jsx)(Box_default, { onClick: () => setIsExpanded(!isExpanded), children: /* @__PURE__ */ (0, import_jsx_runtime209.jsx)(ExpandableText4, { md: true, color: theme.colors.gr4, children: isExpanded ? t("featuredPortfolios.modal.showLess") : t("featuredPortfolios.modal.xMore", {
        count: marketAreas.length - MAX_VISIBLE_MARKET_AREAS
      }) }) })
    ] })
  ] });
};

// src/components/organisms/FeaturedPortfolio/Modal/PortfolioActions.tsx
var import_styled_components218 = __toESM(require("styled-components"));
var import_react_i18next100 = require("react-i18next");
var import_jsx_runtime210 = require("react/jsx-runtime");
var ViewPortfolioButton = (0, import_styled_components218.default)(Button_default)`
  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}px) {
    width: 100%;
  }
`;
var SocialButtonsRow = (0, import_styled_components218.default)(Flex_default)`
  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}px) {
    width: 100%;
  }
`;
var PortfolioActions = ({
  onViewPortfolio,
  onShare,
  onFavorite,
  isSaved = false,
  isLoading = false
}) => {
  const { t } = (0, import_react_i18next100.useTranslation)("pages");
  const theme = (0, import_styled_components218.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime210.jsxs)(Flex_default, { gap: 20, mt: 6, flexWrap: "wrap", children: [
    onViewPortfolio && /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(ViewPortfolioButton, { variation: "outline", px: 8, onClick: onViewPortfolio, children: t("featuredPortfolios.modal.viewPortfolio") }),
    /* @__PURE__ */ (0, import_jsx_runtime210.jsxs)(SocialButtonsRow, { gap: 20, children: [
      onShare && /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(ViewPortfolioButton, { icon: "share", px: 8, onClick: onShare, children: t("featuredPortfolios.modal.sharePortfolio") }),
      onFavorite && /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(import_jsx_runtime210.Fragment, { children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(Button_default, { variation: "outline", px: 3, disabled: true, children: /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(Spinner_default, { size: 16 }) }) : isSaved ? /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(Button_default, { variation: "outline", px: 3, onClick: onFavorite, children: /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(Icon_default, { name: "favoriteFilled", size: 18, color: theme.colors.r60 }) }) : /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(Button_default, { variation: "outline", icon: "favorite", px: 2, onClick: onFavorite }) })
    ] })
  ] });
};

// src/components/organisms/FeaturedPortfolio/Modal/PropertiesList.tsx
var import_styled_components220 = __toESM(require("styled-components"));
var import_react_i18next102 = require("react-i18next");
var import_react141 = require("react");

// src/components/organisms/FeaturedPortfolio/Modal/FeaturedPropertyCard.tsx
var import_styled_components219 = __toESM(require("styled-components"));
var import_react_i18next101 = require("react-i18next");
var import_dash_common65 = require("dash-common");
var import_jsx_runtime211 = require("react/jsx-runtime");
var StyledPropertyDescription = (0, import_styled_components219.default)(Box_default)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  color: ${({ color: color2 }) => color2};

  /* Prose styling for HTML content */
  p {
    margin: 0;
    color: inherit;
  }

  ul,
  ol {
    margin: 0;
    padding-left: 20px;
    color: inherit;
  }

  strong {
    font-weight: 600;
    color: inherit;
  }

  em {
    font-style: italic;
    color: inherit;
  }

  * {
    color: inherit;
  }
`;
var StyledDashPlaceholder2 = (0, import_styled_components219.default)(DashPlaceholder_default)`
  width: 100%;
  height: 100%;
`;
var PropertyThumbnailContainer = (0, import_styled_components219.default)(Box_default)`
  width: 30%;
  min-height: 200px;
  max-height: 300px;
  aspect-ratio: 16 / 9;
  position: relative;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }
`;
var PropertyCardOuterContainer = (0, import_styled_components219.default)(Flex_default)`
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.n30};
    cursor: pointer;
  }
`;
var PropertyCardContainer = (0, import_styled_components219.default)(Flex_default)`
  flex-direction: row;
  gap: 24px;
  padding: 24px;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }
`;
var PropertyInfoContainer = (0, import_styled_components219.default)(Flex_default)`
  width: 68%;
  padding-top: 8px;
  padding-bottom: 8px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }
`;
var DetailsFlex = (0, import_styled_components219.default)(Flex_default)`
  column-gap: 16px;
  row-gap: 8px;
`;
var MarketAreaBadgeWrapper = (0, import_styled_components219.default)(Box_default)`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;
`;
var FeaturedPropertyCard = ({
  thumbnailUrl,
  title,
  price,
  beds,
  baths,
  yearBuilt,
  marketArea,
  description,
  projectStatus,
  onClick
}) => {
  const { t } = (0, import_react_i18next101.useTranslation)("pages");
  const { t: tCommon } = (0, import_react_i18next101.useTranslation)("common", { keyPrefix: "labels" });
  const theme = (0, import_styled_components219.useTheme)();
  const showOnlyBadge = projectStatus === import_dash_common65.ProjectStatusesEnum.COMING_SOON;
  return /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(PropertyCardOuterContainer, { mt: 6, onClick, children: /* @__PURE__ */ (0, import_jsx_runtime211.jsxs)(PropertyCardContainer, { w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime211.jsxs)(PropertyThumbnailContainer, { children: [
      marketArea && /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(MarketAreaBadgeWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(
        Badge_default,
        {
          title: marketArea,
          bgColor: theme.colors.setOpacity(theme.colors.b50, 70),
          titleColor: theme.colors.white,
          sm: true,
          semibold: false,
          md: true,
          py: 1.5,
          px: 4,
          square: true
        }
      ) }),
      thumbnailUrl ? /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(
        "img",
        {
          src: thumbnailUrl,
          alt: title,
          style: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 0
          }
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(StyledDashPlaceholder2, { variation: "secondary", borderRadius: 0 })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime211.jsxs)(PropertyInfoContainer, { flexDirection: "column", gap: 12, children: [
      /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(Text_default, { xl: true, semibold: true, color: theme.colors.gr1, children: title }),
      !showOnlyBadge && price && /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(Text_default, { lg: true, semibold: true, color: theme.colors.gr1, children: price }),
      showOnlyBadge && /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(Flex_default, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(
        Badge_default,
        {
          title: tCommon("comingSoon"),
          bgColor: theme.colors.setOpacity(theme.colors.b30, 70),
          titleColor: theme.colors.b50,
          sm: true,
          py: 1,
          mr: 2,
          square: true
        }
      ) }),
      !showOnlyBadge && (yearBuilt || beds || baths) && /* @__PURE__ */ (0, import_jsx_runtime211.jsxs)(DetailsFlex, { alignItems: "center", flexWrap: "wrap", children: [
        beds && /* @__PURE__ */ (0, import_jsx_runtime211.jsxs)(Flex_default, { alignItems: "center", gap: 6, children: [
          /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(Icon_default, { name: "bedroom", size: 24, color: theme.colors.gr3 }),
          /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(Text_default, { lg: true, color: theme.colors.gr2, children: beds })
        ] }),
        baths && /* @__PURE__ */ (0, import_jsx_runtime211.jsxs)(Flex_default, { alignItems: "center", gap: 6, children: [
          /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(Icon_default, { name: "bathroom", size: 24, color: theme.colors.gr3 }),
          /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(Text_default, { lg: true, color: theme.colors.gr2, children: baths })
        ] }),
        yearBuilt && /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(Text_default, { lg: true, color: theme.colors.gr3, children: t("featuredPortfolios.modal.estCompletion", { year: yearBuilt }) })
      ] }),
      description && /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(
        StyledPropertyDescription,
        {
          color: theme.colors.gr4,
          dangerouslySetInnerHTML: { __html: description }
        }
      )
    ] })
  ] }) });
};

// src/components/organisms/FeaturedPortfolio/Modal/PropertiesList.tsx
var import_dash_common66 = require("dash-common");

// src/components/organisms/FeaturedPortfolio/Modal/formatters.ts
var formatBeds = (bedrooms, options) => {
  const result = formatBedroomsRangeValues(bedrooms, {
    isNullable: bedrooms?.min === 0,
    t: options?.t
  });
  return result ? String(result) : void 0;
};
var formatBaths = (bathrooms, options) => {
  const result = formatBathroomsRangeValues(bathrooms, {
    isNullable: bathrooms?.min === 0,
    t: options?.t
  });
  return result ? String(result) : void 0;
};
var getPropertyThumbnail = (property) => {
  const file = property.mainPropertyMediaFile?.files?.[0];
  return file?.thumbnailFile?.publicUrl || file?.publicUrl;
};
var getPropertyMarketArea = (property) => {
  return property.marketArea?.name;
};

// src/components/organisms/FeaturedPortfolio/Modal/PropertiesList.tsx
var import_jsx_runtime212 = require("react/jsx-runtime");
var PropertiesFullWidthContainer = (0, import_styled_components220.default)(Box_default)`
  margin-left: -24px;
  margin-right: -24px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-left: -16px;
    margin-right: -16px;
  }

  & > div:first-child {
    margin-top: 0 !important;
  }

  & > div:not(:last-child) {
    margin-bottom: 24px;
  }
`;
var PropertiesList = ({
  properties,
  isLoadingProperties,
  isLoadingMore,
  onLoadMore,
  onPropertyClick,
  loadMoreRef
}) => {
  const { t } = (0, import_react_i18next102.useTranslation)("pages");
  const { t: tCommon } = (0, import_react_i18next102.useTranslation)("common");
  const theme = (0, import_styled_components220.useTheme)();
  const formattedProperties = (0, import_react141.useMemo)(
    () => properties.map((property) => ({
      _id: property._id,
      name: property.name,
      yearBuilt: property.yearBuilt,
      thumbnailUrl: getPropertyThumbnail(property),
      price: (0, import_dash_common66.formatPriceRange)(
        property.priceRange?.min ?? void 0,
        property.priceRange?.max ?? void 0,
        {
          shortMin: true,
          shortMax: true,
          prefix: property.priceRange?.min && !property.priceRange?.max ? tCommon("labels.from") || "" : void 0
        }
      ),
      beds: formatBeds(property.averageBedroomsNumber, { t: tCommon }),
      baths: formatBaths(property.averageBathroomsNumber, { t: tCommon }),
      marketArea: getPropertyMarketArea(property),
      description: property.overview ?? void 0,
      projectStatus: property.projectStatus
    })),
    [properties, tCommon]
  );
  const handlePropertyClick = (0, import_react141.useCallback)(
    (property) => {
      onPropertyClick?.(property);
    },
    [onPropertyClick]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime212.jsxs)(Box_default, { mt: 8, w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(Text_default, { xl: true, semibold: true, color: theme.colors.gr1, children: t("featuredPortfolios.modal.properties") }),
    /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(PropertiesFullWidthContainer, { mt: 4, children: isLoadingProperties ? /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(Flex_default, { justifyContent: "center", w: "100%", py: 8, children: /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(Spinner_default, { size: 32 }) }) : /* @__PURE__ */ (0, import_jsx_runtime212.jsxs)(import_jsx_runtime212.Fragment, { children: [
      formattedProperties.map((property) => /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(
        FeaturedPropertyCard,
        {
          thumbnailUrl: property.thumbnailUrl,
          title: property.name,
          price: property.price,
          beds: property.beds,
          baths: property.baths,
          yearBuilt: property.yearBuilt,
          marketArea: property.marketArea,
          description: property.description,
          projectStatus: property.projectStatus,
          onClick: () => handlePropertyClick(properties.find((p) => p._id === property._id))
        },
        property._id
      )),
      onLoadMore && /* @__PURE__ */ (0, import_jsx_runtime212.jsxs)(import_jsx_runtime212.Fragment, { children: [
        isLoadingMore && /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(Flex_default, { justifyContent: "center", w: "100%", py: 8, children: /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(Spinner_default, { size: 32 }) }),
        /* @__PURE__ */ (0, import_jsx_runtime212.jsx)("div", { ref: loadMoreRef, style: { height: "20px" } })
      ] })
    ] }) })
  ] });
};

// src/components/organisms/FeaturedPortfolio/Modal/FeaturedPortfolioModal.tsx
var import_jsx_runtime213 = require("react/jsx-runtime");
var StyledDashPlaceholder3 = (0, import_styled_components221.default)(DashPlaceholder_default)`
  width: 100%;
  height: 100%;
`;
var CoverImageContainer = (0, import_styled_components221.default)(Box_default)`
  position: relative;
  z-index: 1;
  margin-left: -24px;
  margin-right: -24px;
  width: calc(100% + 48px);
  aspect-ratio: 16 / 9;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-left: -16px;
    margin-right: -16px;
    width: calc(100% + 32px);
  }
`;
var StyledTitle2 = (0, import_styled_components221.default)(Text_default)`
  font-size: 28px;
  line-height: 1.25;
  @media ${({ theme }) => theme.devices.mobile} {
    font-size: 24px;
  }
`;
var OverviewText = (0, import_styled_components221.default)(Box_default)`
  /* Prose styling for HTML content */
  color: ${({ color: color2 }) => color2};
  line-height: 1.5;

  p {
    margin: 0;
    color: inherit;
  }

  ul,
  ol {
    margin: 0;
    padding-left: 20px;
    color: inherit;
  }

  strong {
    font-weight: 600;
    color: inherit;
  }

  em {
    font-style: italic;
    color: inherit;
  }

  * {
    color: inherit;
  }
`;
var FEATURED_PORTFOLIO_MODAL = "featuredPortfolioModal";
var FeaturedPortfolioModal = ({
  isOpen,
  onClose,
  title,
  overview,
  coverImage,
  propertyIds,
  properties = [],
  marketAreas = [],
  priceRange,
  completionYearRange,
  propertyCount,
  isLoadingProperties,
  isLoadingMore,
  onLoadMore,
  onViewPortfolio,
  onShare,
  onFavorite,
  isSaved = false,
  isLoadingFavorite = false,
  onPropertyClick
}) => {
  const { t } = (0, import_react_i18next103.useTranslation)("pages");
  const theme = (0, import_styled_components221.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const loadMoreRef = useInfiniteScroll({
    isLoadingMore: isLoadingMore ?? false,
    onLoadMore: () => onLoadMore?.()
  });
  (0, import_react142.useEffect)(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [isOpen]);
  return /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(
    Modal3,
    {
      isOpen,
      w: "90%",
      h: isMobile ? "80%" : "90%",
      maxWidth: 1024,
      onRequestClose: onClose,
      viewHierarchy: 3,
      isCentered: true,
      title: t("featuredPortfolios.modal.title") || "",
      closeIcon: true,
      ariaHideApp: false,
      children: /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(Box_default, { children: /* @__PURE__ */ (0, import_jsx_runtime213.jsxs)(Flex_default, { flexDirection: "column", flex: 1, w: "100%", gap: 16, children: [
        /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(CoverImageContainer, { maxHeight: 480, children: coverImage ? /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(
          "img",
          {
            src: coverImage,
            alt: title,
            style: {
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: 0
            }
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(StyledDashPlaceholder3, { variation: "secondary", borderRadius: 0 }) }),
        /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(Box_default, { mt: 4, children: /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(StyledTitle2, { color: theme.colors.gr1, semibold: true, children: title }) }),
        /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(
          FeaturedPortfolioSummary,
          {
            priceRange,
            completionYearRange,
            propertyCount,
            propertyIds
          }
        ),
        marketAreas && marketAreas.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(MarketAreasList, { marketAreas }),
        overview && /* @__PURE__ */ (0, import_jsx_runtime213.jsxs)(Box_default, { mt: 4, children: [
          /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(Text_default, { xl: true, semibold: true, color: theme.colors.gr1, children: t("featuredPortfolios.modal.overview") }),
          /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(Box_default, { mt: 4, children: /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(
            OverviewText,
            {
              color: theme.colors.gr4,
              dangerouslySetInnerHTML: { __html: overview }
            }
          ) })
        ] }),
        (onViewPortfolio || onShare || onFavorite) && /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(
          PortfolioActions,
          {
            onViewPortfolio,
            onShare,
            onFavorite,
            isSaved,
            isLoading: isLoadingFavorite
          }
        ),
        (properties.length > 0 || isLoadingProperties) && /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(
          PropertiesList,
          {
            properties,
            isLoadingProperties,
            isLoadingMore,
            onLoadMore,
            onPropertyClick,
            loadMoreRef
          }
        )
      ] }) })
    }
  );
};

// src/components/organisms/FeaturedPropertiesBanner/FeaturedPropertiesBanner.tsx
var import_dash_common67 = require("dash-common");
var import_lodash29 = require("lodash");
var import_react143 = require("react");
var import_react_i18next104 = require("react-i18next");
var import_styled_components222 = __toESM(require("styled-components"));
var import_jsx_runtime214 = require("react/jsx-runtime");
var BannerContainer4 = (0, import_styled_components222.default)(Box_default)`
  position: relative;
  width: 100%;
  height: 340px;
  overflow: hidden;
`;
var BackgroundImage = import_styled_components222.default.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
var Overlay5 = import_styled_components222.default.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ isMobile }) => isMobile ? "linear-gradient(to left, rgba(25, 25, 25, 0.3) 0%, rgba(25, 25, 25, 0.6) 100%)" : "linear-gradient(to left, rgba(25, 25, 25, 0.1) 0%, rgba(25, 25, 25, 0.6) 100%)"};
`;
var Content = (0, import_styled_components222.default)(Flex_default)`
  position: relative;
  z-index: 2;
  height: 100%;
  width: 100%;
  padding: ${({ isMobile }) => isMobile ? "40px 40px" : "48px 64px"};
`;
var InnerContent = (0, import_styled_components222.default)(Flex_default)`
  height: 100%;
  width: 100%;
`;
var CarouselArrowButton = import_styled_components222.default.button`
  position: absolute;
  top: ${({ isMobile }) => isMobile ? "45%" : "50%"};
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.9);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.b50};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var LeftArrow = (0, import_styled_components222.default)(CarouselArrowButton)`
  left: ${({ isMobile }) => isMobile ? "-2px" : "12px"};
`;
var RightArrow = (0, import_styled_components222.default)(CarouselArrowButton)`
  right: ${({ isMobile }) => isMobile ? "-2px" : "12px"};
`;
var FeaturedPropertyTag = (0, import_styled_components222.default)(Box_default)`
  background-color: rgba(22, 22, 22, 0.4);
  border: 1px solid rgba(215, 215, 215, 0.6);
  padding: 4px 8px;
  border-radius: 4px;
`;
var FeaturedPropertyTagText = (0, import_styled_components222.default)(Text_default)`
  color: rgb(235, 235, 235);
  font-size: 12px;
  line-height: 1;
`;
var StyledTitle3 = (0, import_styled_components222.default)(Text_default)`
  font-size: ${({ isMobile }) => isMobile ? "24px" : "28px"};
  line-height: 1.25;
  margin-bottom: 16px;
`;
var SeeMoreButton = (0, import_styled_components222.default)(Button_default)`
  color: white;
  border: none;
  padding: ${({ theme }) => theme.space * 1}px ${({ theme }) => theme.space * 3}px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space}px;
  font-weight: 600;
  font-size: 14px;

  &:hover {
    border: 0px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var ButtonContent = import_styled_components222.default.span`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  margin-right: 8px;
  margin-left: 8px;
`;
var ArrowIconWrapper = import_styled_components222.default.span`
  display: flex;
  align-items: center;

  svg {
    transform: translateX(0) !important;
    transition: transform 0.3s ease-in-out !important;
  }

  button:hover & svg {
    transform: translateX(8px) !important;
  }
`;
var ButtonWrapper = (0, import_styled_components222.default)(Box_default)`
  ${({ isMobile }) => isMobile && "align-self: flex-end;"}
`;
var DotsContainer = (0, import_styled_components222.default)(Flex_default)`
  gap: 8px;
  align-items: center;
`;
var Dot3 = import_styled_components222.default.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  transition: opacity 0.2s ease;
  opacity: ${({ $isSelected }) => $isSelected ? 1 : 0.5};
  background-color: white;
`;
var FeaturedPropertiesBanner = ({
  featuredProperty,
  showNavigationArrows = false,
  isMobile: isMobileProp,
  onSeeMoreClick,
  onPreviousClick,
  onNextClick,
  seeMoreLabel,
  totalItems = 1,
  currentIndex = 0
}) => {
  const { t } = (0, import_react_i18next104.useTranslation)();
  const { devices } = useScreenResolution();
  const isMobile = isMobileProp ?? devices.isMobile;
  const isCompleted = featuredProperty.property?.projectStatus === import_dash_common67.ProjectStatusesEnum.COMPLETED;
  const handleSeeMoreClick = (0, import_react143.useCallback)(() => {
    onSeeMoreClick?.();
  }, [onSeeMoreClick]);
  const imageUrl = featuredProperty.coverImageFile?.publicUrl || featuredProperty.coverImageFile?.thumbnailFile?.publicUrl;
  return /* @__PURE__ */ (0, import_jsx_runtime214.jsxs)(BannerContainer4, { children: [
    imageUrl && /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(BackgroundImage, { src: imageUrl, alt: featuredProperty.title }),
    /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Overlay5, { isMobile }),
    showNavigationArrows && /* @__PURE__ */ (0, import_jsx_runtime214.jsxs)(import_jsx_runtime214.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(
        LeftArrow,
        {
          isMobile,
          onClick: onPreviousClick,
          "aria-label": t("common:labels.previous") || "",
          children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Icon_default, { name: "arrowLeft", size: 28, color: "#fff" })
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(
        RightArrow,
        {
          isMobile,
          onClick: onNextClick,
          "aria-label": t("common:labels.next") || "",
          children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Icon_default, { name: "arrowRight", size: 28, color: "#fff" })
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Content, { isMobile, flexDirection: "column", justifyContent: "space-between", p: 6, children: /* @__PURE__ */ (0, import_jsx_runtime214.jsxs)(
      InnerContent,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        onClick: handleSeeMoreClick,
        style: {
          cursor: featuredProperty.propertyId ? "pointer" : "default"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Box_default, { mb: 4, children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(FeaturedPropertyTag, { children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(FeaturedPropertyTagText, { children: t("common:labels.featuredProperties") }) }) }),
          /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Box_default, { maxWidth: 400, children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(StyledTitle3, { isMobile, color: "white", xl: true, semibold: true, children: featuredProperty.title }) }),
          /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Box_default, { mb: 4, maxWidth: 450, children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Text_default, { color: "rgb(245, 245, 245)", children: [
            featuredProperty.property?.priceRange?.min || featuredProperty.property?.priceRange?.max ? (0, import_dash_common67.formatPriceRange)(
              featuredProperty.property?.priceRange?.min || featuredProperty.property?.priceRange?.max || 0,
              0,
              {
                shortMin: true,
                shortMax: true,
                prefix: t("common:labels:from") || ""
              },
              {
                maximumFractionDigits: 2
              }
            ) : null,
            featuredProperty.property?.marketArea?.name || null,
            featuredProperty?.property?.projectStatus ? t(
              `forms:labels:projectStatuses:${(0, import_lodash29.camelCase)(
                featuredProperty?.property?.projectStatus
              )}`
            ) : null,
            featuredProperty.property?.yearBuilt ? t(
              `pages:propertyPage:${featuredProperty.property?.projectStatus === import_dash_common67.ProjectStatusesEnum.NEW_CONSTRUCTION || isCompleted ? "completedIn" : "estCompletion"}`,
              {
                date: featuredProperty.property?.yearBuilt
              }
            ) : null
          ].filter(Boolean).join(" \u2022 ") }) }),
          /* @__PURE__ */ (0, import_jsx_runtime214.jsxs)(Flex_default, { w: "100%", justifyContent: "space-between", alignItems: "flex-end", children: [
            /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(ButtonWrapper, { isMobile, children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(
              SeeMoreButton,
              {
                disabled: !featuredProperty.propertyId,
                "aria-label": t("common:components.featuredBanner.seeMoreDetails") || "",
                variation: "primary",
                children: /* @__PURE__ */ (0, import_jsx_runtime214.jsxs)(ButtonContent, { children: [
                  seeMoreLabel ?? t("common:components.featuredBanner.seeMore"),
                  /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(ArrowIconWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Icon_default, { name: "arrowRight", size: 16 }) })
                ] })
              }
            ) }),
            totalItems > 1 && /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(DotsContainer, { children: Array.from({ length: totalItems }).map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(Dot3, { $isSelected: index2 === currentIndex }, index2)) })
          ] })
        ]
      }
    ) })
  ] });
};

// src/components/organisms/FeaturedPropertiesCarousel/FeaturedPropertiesCarousel.tsx
var import_react144 = require("react");
var import_styled_components223 = __toESM(require("styled-components"));
var import_react_i18next105 = require("react-i18next");
var import_jsx_runtime215 = require("react/jsx-runtime");
var SCROLL_DEBOUNCE_MS3 = 50;
var CarouselContainer2 = import_styled_components223.default.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;
var NavigationButton2 = import_styled_components223.default.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.b50};
    outline-offset: 2px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    top: 45%;
    &:hover {
      background-color: transparent;
    }
  }
`;
var LeftArrow2 = (0, import_styled_components223.default)(NavigationButton2)`
  left: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    left: -2px;
  }
`;
var RightArrow2 = (0, import_styled_components223.default)(NavigationButton2)`
  right: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    right: -2px;
  }
`;
var DesktopCarouselTrack2 = import_styled_components223.default.div`
  display: flex;
  width: 100%;
  height: 100%;
  transform: translateX(-${({ $currentIndex }) => $currentIndex * 100}%);
  transition: ${({ $hasMounted }) => $hasMounted ? "transform 0.7s ease-out" : "none"};
`;
var DesktopCarouselSlide2 = import_styled_components223.default.div`
  min-width: 100%;
  height: 100%;
`;
var MobileCarouselTrack2 = import_styled_components223.default.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */

  /* Hide scrollbar for Chrome, Safari, Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`;
var MobileCarouselSlide2 = import_styled_components223.default.div`
  flex: 0 0 100%;
  height: 100%;
  scroll-snap-align: start;
`;
var FeaturedPropertiesCarousel = ({
  items,
  children,
  autoPlay = false,
  autoPlayInterval = 8e3
}) => {
  const { t } = (0, import_react_i18next105.useTranslation)("common");
  const [currentIndex, setCurrentIndex] = (0, import_react144.useState)(0);
  const [hasMounted, setHasMounted] = (0, import_react144.useState)(false);
  const [isPaused, setIsPaused] = (0, import_react144.useState)(false);
  const trackRef = (0, import_react144.useRef)(null);
  const trackReadyRef = (0, import_react144.useRef)(false);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  (0, import_react144.useEffect)(() => {
    if (!autoPlay || items.length <= 1 || isPaused)
      return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        const newIndex = (prev + 1) % items.length;
        if (isMobile && trackRef.current) {
          trackRef.current.scrollTo({
            left: newIndex * trackRef.current.offsetWidth,
            behavior: "smooth"
          });
        }
        return newIndex;
      });
    }, autoPlayInterval);
    return () => clearInterval(interval);
  }, [autoPlay, autoPlayInterval, items.length, isPaused, isMobile, currentIndex]);
  const handleScroll = (0, import_react144.useCallback)(() => {
    if (!trackRef.current || !isMobile)
      return;
    const scrollLeft = trackRef.current.scrollLeft;
    const slideWidth = trackRef.current.offsetWidth;
    const newIndex = Math.round(scrollLeft / slideWidth);
    setCurrentIndex(newIndex);
  }, [isMobile]);
  (0, import_react144.useEffect)(() => {
    const track = trackRef.current;
    if (!track || !isMobile || !trackReadyRef.current)
      return;
    let timeoutId;
    const debouncedHandleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleScroll, SCROLL_DEBOUNCE_MS3);
    };
    track.addEventListener("scroll", debouncedHandleScroll, { passive: true });
    return () => {
      track.removeEventListener("scroll", debouncedHandleScroll);
      clearTimeout(timeoutId);
    };
  }, [isMobile, handleScroll]);
  const handlePrevious = (0, import_react144.useCallback)(() => {
    setCurrentIndex((prev) => prev === 0 ? items.length - 1 : prev - 1);
    if (isMobile && trackRef.current) {
      const newIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
      trackRef.current.scrollTo({
        left: newIndex * trackRef.current.offsetWidth,
        behavior: "smooth"
      });
    }
  }, [currentIndex, items.length, isMobile]);
  const handleNext = (0, import_react144.useCallback)(() => {
    setCurrentIndex((prev) => (prev + 1) % items.length);
    if (isMobile && trackRef.current) {
      const newIndex = (currentIndex + 1) % items.length;
      trackRef.current.scrollTo({
        left: newIndex * trackRef.current.offsetWidth,
        behavior: "smooth"
      });
    }
  }, [currentIndex, items.length, isMobile]);
  (0, import_react144.useEffect)(() => {
    setTimeout(() => {
      setHasMounted(true);
    }, 100);
  }, []);
  if (items.length === 0) {
    return null;
  }
  const hasMultipleSlides = items.length > 1;
  return /* @__PURE__ */ (0, import_jsx_runtime215.jsxs)(
    CarouselContainer2,
    {
      onMouseEnter: () => !isMobile && setIsPaused(true),
      onMouseLeave: () => !isMobile && setIsPaused(false),
      children: [
        hasMultipleSlides && /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(LeftArrow2, { onClick: handlePrevious, "aria-label": t("labels.previous") || "", children: /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(Icon_default, { name: "arrowLeft", size: 32, color: "#fff" }) }),
        isMobile ? /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(
          MobileCarouselTrack2,
          {
            ref: (node) => {
              trackRef.current = node;
              if (node && !trackReadyRef.current) {
                trackReadyRef.current = true;
              }
            },
            children: items.map((item, index2) => /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(MobileCarouselSlide2, { children: children(item, index2, currentIndex) }, index2))
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(DesktopCarouselTrack2, { $currentIndex: currentIndex, $hasMounted: hasMounted, children: items.map((item, index2) => /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(DesktopCarouselSlide2, { children: children(item, index2, currentIndex) }, index2)) }),
        hasMultipleSlides && /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(RightArrow2, { onClick: handleNext, "aria-label": t("labels.next") || "", children: /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(Icon_default, { name: "arrowRight", size: 32, color: "#fff" }) })
      ]
    }
  );
};

// src/components/molecules/PropertySalesGallerySection/PropertySalesGallerySection.tsx
var import_jsx_runtime216 = require("react/jsx-runtime");
var PropertySalesGallerySection = ({
  salesGalleryStatus,
  salesGalleryHours,
  salesGalleryAddress,
  contactEmail,
  contactPhone,
  isRental = false,
  isRestricted = false,
  closeModal,
  setUpgradeSubscriptionModal,
  toggleModal: toggleModalProp
}) => {
  const { t } = (0, import_react_i18next106.useTranslation)("pages");
  const { toggleModal: toggleModalContext } = (0, import_react145.useContext)(ModalContext);
  const toggleModal = toggleModalProp || toggleModalContext;
  const handleViewDetails = () => {
    if (isRestricted) {
      if (closeModal)
        closeModal();
      if (setUpgradeSubscriptionModal) {
        setUpgradeSubscriptionModal({
          type: "BASIC" /* BASIC */
        });
      }
      toggleModal(true, "UpgradeSubscriptionModal");
    } else {
      toggleModal(true, "PropertySalesAvailabilityModal");
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime216.jsxs)(import_jsx_runtime216.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime216.jsxs)(Box_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime216.jsx)(Text_default, { semibold: true, children: isRental ? t("propertyPage.leasingOffice") : t("propertyPage.salesGallery") }),
      /* @__PURE__ */ (0, import_jsx_runtime216.jsx)(Box_default, { mb: 3 }),
      /* @__PURE__ */ (0, import_jsx_runtime216.jsx)(Button_default, { colorVariation: "success", variation: "outline", w: "100%", onClick: handleViewDetails, children: t("propertyPage.viewDetails") })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime216.jsx)(
      PropertySalesAvailabilityModal_default,
      {
        salesGalleryHours,
        salesGalleryAddress,
        salesGalleryStatus,
        contactEmail,
        contactPhone,
        isRental
      }
    )
  ] });
};
var PropertySalesGallerySection_default = PropertySalesGallerySection;

// src/components/molecules/VirtualToursButton/VirtualToursButton.tsx
var import_react146 = require("react");
var import_react_i18next107 = require("react-i18next");
var import_styled_components224 = __toESM(require("styled-components"));
var import_dash_common68 = require("dash-common");
var import_jsx_runtime217 = require("react/jsx-runtime");
var InlineButtonsGrid = import_styled_components224.default.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  max-width: 600px; // Limits width to approximately 3 buttons

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }
`;
var VirtualToursButton = ({
  virtualTourLinks,
  className,
  displayMode = "modal",
  isRestricted = false,
  closeModal,
  setUpgradeSubscriptionModal,
  toggleModal
}) => {
  const { t } = (0, import_react_i18next107.useTranslation)("common");
  const [isModalOpen, setIsModalOpen] = (0, import_react146.useState)(false);
  if (!virtualTourLinks || virtualTourLinks.length === 0) {
    return null;
  }
  const handleUpgradeClick = () => {
    if (closeModal)
      closeModal();
    if (setUpgradeSubscriptionModal && toggleModal) {
      setUpgradeSubscriptionModal({
        type: "BASIC" /* BASIC */
      });
      toggleModal(true, "UpgradeSubscriptionModal");
    }
  };
  const handleClick = () => {
    if (isRestricted) {
      handleUpgradeClick();
      return;
    }
    if (virtualTourLinks.length === 1) {
      const normalizedUrl = (0, import_dash_common68.normalizeUrl)(virtualTourLinks[0].url);
      window.open(normalizedUrl, "_blank", "noopener,noreferrer");
    } else {
      setIsModalOpen(true);
    }
  };
  const handleLinkClick = (url) => {
    if (isRestricted) {
      handleUpgradeClick();
      return;
    }
    const normalizedUrl = (0, import_dash_common68.normalizeUrl)(url);
    window.open(normalizedUrl, "_blank", "noopener,noreferrer");
  };
  const buttonLabel = (virtualTourLinks2) => {
    if (virtualTourLinks2?.length === 1) {
      return virtualTourLinks2[0].label || t("pages:propertyPage.virtualTour");
    }
    return t("pages:propertyPage.virtualTours");
  };
  if (displayMode === "inline") {
    return /* @__PURE__ */ (0, import_jsx_runtime217.jsx)(InlineButtonsGrid, { className, children: virtualTourLinks.map((link, index2) => /* @__PURE__ */ (0, import_jsx_runtime217.jsx)(
      Button_default,
      {
        variation: "primary",
        onClick: () => handleLinkClick(link.url),
        icon: "playCircleOutline",
        p: 2.5,
        contentCentered: true,
        children: link.label || t("components.virtualTours.numbered", { number: index2 + 1 })
      },
      index2
    )) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime217.jsxs)(import_jsx_runtime217.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime217.jsx)(
      Button_default,
      {
        variation: "primary",
        onClick: handleClick,
        className,
        icon: "playCircleOutline",
        w: "100%",
        p: 2.5,
        children: buttonLabel(virtualTourLinks)
      }
    ),
    virtualTourLinks.length > 1 && /* @__PURE__ */ (0, import_jsx_runtime217.jsx)(
      Modal3,
      {
        isOpen: isModalOpen,
        onRequestClose: () => setIsModalOpen(false),
        title: t("components.virtualTours.select") || "",
        closeIcon: true,
        children: /* @__PURE__ */ (0, import_jsx_runtime217.jsx)(Flex_default, { flexDirection: "column", gap: 10, mt: 8, children: virtualTourLinks.map((link, index2) => /* @__PURE__ */ (0, import_jsx_runtime217.jsx)(
          Button_default,
          {
            variation: "outline",
            onClick: () => handleLinkClick(link.url),
            icon: "playCircleOutline",
            w: "100%",
            contentCentered: false,
            children: link.label || t("components.virtualTours.numbered", { number: index2 + 1 })
          },
          index2
        )) })
      }
    )
  ] });
};

// src/components/molecules/ResponsiveTabs/ResponsiveTabs.tsx
var import_react147 = require("react");
var import_styled_components226 = require("styled-components");

// src/components/molecules/ResponsiveTabs/ResponsiveTabs.styles.ts
var import_styled_components225 = __toESM(require("styled-components"));
var TabsContainer2 = (0, import_styled_components225.default)(Flex_default)`
  position: relative;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
`;
var TabsScrollWrapper = (0, import_styled_components225.default)(Flex_default)`
  width: 100%;
  overflow-x: ${({ isMobile }) => isMobile ? "auto" : "visible"};
  overflow-y: hidden;
  scroll-behavior: smooth;
  position: relative;
  flex-wrap: wrap;

  ${({ isMobile }) => isMobile && import_styled_components225.css`
      flex-wrap: nowrap;
      ::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
    `}
    
  @media ${({ theme }) => theme.devices.tablet} {
    flex-wrap: nowrap;
    overflow-x: auto;
  }
`;
var TabButton2 = import_styled_components225.default.button`
  appearance: none;
  border: none;
  background: transparent;
  padding: 12px 24px;
  cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.2s ease;
  position: relative;

  ${({ variation, active, activeButtonColor, theme }) => {
  if (variation === "secondary") {
    return import_styled_components225.css`
        color: ${active ? activeButtonColor || theme.colors.b50 : theme.colors.n70};
        border-bottom: 2px solid
          ${active ? activeButtonColor || theme.colors.b50 : "transparent"};
        margin-bottom: -1px;

        &:hover:not(:disabled) {
          color: ${activeButtonColor || theme.colors.b50};
        }

        & p {
          color: ${active ? activeButtonColor || theme.colors.b50 : theme.colors.n70};
        }
      `;
  }
  if (variation === "primary") {
    return import_styled_components225.css`
        background-color: ${active ? theme.colors.b50 : theme.colors.b20};
        color: ${active ? theme.colors.white : theme.colors.n70};

        &:first-child {
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }

        &:last-child {
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }

        &:hover:not(:disabled) {
          background-color: ${active ? theme.colors.b50 : theme.colors.b30};
        }

        & p {
          color: ${active ? theme.colors.white : theme.colors.n70};
        }
      `;
  }
  return "";
}}

  &:disabled {
    opacity: 0.5;
    color: ${({ theme }) => theme.colors.n50};
  }

  ${({ isInDropdown, theme }) => isInDropdown && import_styled_components225.css`
      width: 100%;
      text-align: left;
      padding: 8px 16px;
      border-bottom: none;

      &:hover:not(:disabled) {
        background-color: ${theme.colors.n10};
      }
    `}

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 10px 16px;
  }
`;
var ScrollIndicator3 = (0, import_styled_components225.default)(Box_default)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ position }) => position === "left" ? "left: 0;" : "right: 0;"}
  z-index: 2;
  background: linear-gradient(
    ${({ position }) => position === "left" ? "90deg" : "270deg"},
    ${({ theme }) => theme.colors.white} 0%,
    ${({ theme }) => theme.colors.white}00 100%
  );
  padding: 4px;
  pointer-events: none;

  @media ${({ theme }) => theme.devices.tablet} {
    display: none;
  }

  @media ${({ theme }) => theme.devices.desktop} {
    display: none;
  }
`;
var MoreButton2 = (0, import_styled_components225.default)(Box_default)`
  margin-left: auto;
  flex-shrink: 0;
  position: relative;
`;
var MoreDropdownMenu2 = import_styled_components225.default.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  padding: 4px 0;
  z-index: 100;
`;
var DropdownMenuItem3 = import_styled_components225.default.button`
  appearance: none;
  border: none;
  background: ${({ active, theme }) => active ? theme.colors.n10 : "transparent"};
  width: 100%;
  padding: 8px 16px;
  text-align: left;
  cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.n10};
  }

  & p {
    margin: 0;
  }
`;

// src/components/molecules/ResponsiveTabs/ResponsiveTabs.tsx
var import_jsx_runtime218 = require("react/jsx-runtime");
var ResponsiveTabs = ({
  tabs,
  activeTab,
  onTabClick,
  variation = "secondary",
  activeButtonColor,
  className,
  customFoldersAtEnd = true
}) => {
  const theme = (0, import_styled_components226.useTheme)();
  const systemFolderName = useSystemFolderName();
  const tabsContainerRef = (0, import_react147.useRef)(null);
  const [showLeftScroll, setShowLeftScroll] = (0, import_react147.useState)(false);
  const [showRightScroll, setShowRightScroll] = (0, import_react147.useState)(false);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const sortedTabs = (0, import_react147.useMemo)(() => {
    if (!customFoldersAtEnd)
      return tabs;
    const standardFolders = ["Brochures", "Fact Sheets", "Floor Plans", "Images", "Videos"];
    const agentsOnlyTab = tabs.find((tab) => tab.label === "Agents-Only");
    const otherTab = tabs.find((tab) => tab.label === "Other");
    const customTabs = tabs.filter(
      (tab) => !standardFolders.includes(tab.label) && tab.label !== "Agents-Only" && tab.label !== "Other"
    );
    const standardTabs = tabs.filter((tab) => standardFolders.includes(tab.label));
    return [
      ...standardTabs,
      ...customTabs,
      ...agentsOnlyTab ? [agentsOnlyTab] : [],
      ...otherTab ? [otherTab] : []
    ];
  }, [tabs, customFoldersAtEnd]);
  const checkScrollIndicators = (0, import_react147.useCallback)(() => {
    if (!tabsContainerRef.current || !isMobile)
      return;
    const container = tabsContainerRef.current;
    const { scrollLeft, scrollWidth, clientWidth } = container;
    setShowLeftScroll(scrollLeft > 0);
    setShowRightScroll(scrollLeft + clientWidth < scrollWidth - 5);
  }, [isMobile]);
  (0, import_react147.useEffect)(() => {
    if (!isMobile || !tabsContainerRef.current || !activeTab)
      return;
    const container = tabsContainerRef.current;
    const activeElement = container.querySelector(`[data-tab-key="${activeTab}"]`);
    if (activeElement) {
      const containerWidth = container.offsetWidth;
      const elementLeft = activeElement.offsetLeft;
      const elementWidth = activeElement.offsetWidth;
      const scrollPosition = elementLeft - containerWidth / 2 + elementWidth / 2;
      container.scrollTo({
        left: scrollPosition,
        behavior: "smooth"
      });
    }
  }, [activeTab, isMobile]);
  const handleScroll = (0, import_react147.useCallback)(() => {
    checkScrollIndicators();
  }, [checkScrollIndicators]);
  (0, import_react147.useEffect)(() => {
    checkScrollIndicators();
    const handleResize = () => {
      checkScrollIndicators();
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [checkScrollIndicators]);
  const renderTab = (tab) => /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(
    TabButton2,
    {
      "data-tab-key": tab.key,
      active: activeTab === tab.key,
      disabled: tab.disabled,
      variation,
      activeButtonColor,
      onClick: () => {
        if (!tab.disabled) {
          onTabClick(tab.key);
        }
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(Text_default, { ellipsis: true, semibold: activeTab === tab.key, children: systemFolderName(tab.label) })
    },
    tab.key
  );
  return /* @__PURE__ */ (0, import_jsx_runtime218.jsxs)(TabsContainer2, { className, children: [
    isMobile && showLeftScroll && /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(ScrollIndicator3, { position: "left", children: /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(Icon_default, { name: "chevronLeft", size: 20, color: theme.colors.n70 }) }),
    /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(TabsScrollWrapper, { ref: tabsContainerRef, onScroll: handleScroll, isMobile, children: sortedTabs.map((tab) => renderTab(tab)) }),
    isMobile && showRightScroll && /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(ScrollIndicator3, { position: "right", children: /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(Icon_default, { name: "chevronRight", size: 20, color: theme.colors.n70 }) })
  ] });
};
var ResponsiveTabs_default = ResponsiveTabs;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  A,
  AdditionalInfoSection,
  AdditionalInfoSectionWithHistory,
  AddressLabel,
  Alert,
  Alerts,
  AlertsContext,
  AlertsProvider,
  AmenitiesSection,
  ApiAccessChartWidget,
  Avatar,
  AvatarUpload,
  Badge,
  Banner,
  BannerTypesEnum,
  BathsAndBedsSelect,
  Box,
  Breadcrumb,
  BrokersBanner,
  BulkActionsContext,
  BulkActionsProvider,
  Button,
  ButtonGroups,
  Card,
  CardPaymentForm,
  Checkbox,
  ColorContext,
  ColorProvider,
  CopyToClipboardButton,
  DEFAULT_COUNTRY,
  DashPlaceholder,
  DashboardBanner,
  DashboardNotificationBannerContext,
  DashboardNotificationBannerProvider,
  DatePeriodPicker,
  DatePeriodTypesEnum,
  DatePicker,
  DatePickerTimeRangeEnum,
  DatePickerWithTimeRange,
  DateRangePicker,
  DefaultPaginationValues,
  DeleteModal,
  DevelopInfoSection,
  Devider,
  Drawer,
  DropDown,
  DropdownContext,
  DropdownOptions,
  DropdownProvider,
  ExpandableHtmlText,
  ExpandableText,
  FEATURED_PORTFOLIO_MODAL,
  FeaturedPortfolioCard,
  FeaturedPortfolioModal,
  FeaturedPortfolioStateContext,
  FeaturedPortfolioStateProvider,
  FeaturedPortfolioSummary,
  FeaturedPropertiesBanner,
  FeaturedPropertiesCarousel,
  FeaturedPropertyCard,
  FeaturesAndAmenitiesList,
  Feedback,
  FileInput,
  FileList,
  FilePreviewModal,
  FileTypeIcon,
  FileUpload,
  FilterContext,
  FilterProvider,
  FlatPagination,
  FlatPaginationContext,
  FlatPaginationProvider,
  Flex,
  Form,
  FormContext,
  FormErrorMessages,
  FormErrorTypes,
  FormProvider,
  FullPageFilePreview,
  GeneralInfoSection,
  GoogleAutocomplete,
  GoogleMap,
  Group,
  H,
  Icon,
  IconBadge,
  Image,
  InfoCard,
  Input,
  InputAutocomplete,
  InputGroup,
  InputNumber,
  InputPassword,
  InputPercentage,
  InputPhone,
  InputPrice,
  InputSearch,
  InventoryTable,
  Label,
  List,
  ListWithPagination,
  LocalCashTables,
  LocalTimeHoursInput,
  LocalTimeWeekHoursInput,
  LocationAndContactSection,
  MapSection,
  Marker,
  MarketAreaTag,
  MarketAreasList,
  MarketingFiles,
  MarketingFilesContext,
  MarketingFilesProvider,
  MediaDragAndDropContext,
  MediaDragAndDropProvider,
  MediaFilePreviewCard,
  Modal,
  ModalContext,
  ModalProvider,
  ModalWithBrokerBanner,
  MultiFileUploadContext,
  MultiFileUploadProvider,
  NameSection,
  NotFoundPage,
  PageViewContext,
  PageViewProvider,
  PageViewToggle,
  PageViewTypeEnum,
  Pagination,
  PaginationContext,
  PaginationInfoLabel,
  PaginationLoadMore,
  PaginationPerPageSelect,
  PaginationProvider,
  PhoneInputMask,
  PortfolioActions,
  PortfoliosTreeSelect,
  PriceInputWithDropDown,
  PriceRange,
  ProgressBar,
  PropertiesList,
  PropertiesTable,
  PropertyActions,
  PropertyHistoryModal,
  PropertyMarker,
  PropertyPreviewExpandableText,
  PropertyPreviewGeneralInfoSection,
  PropertyPreviewNavigationTabs,
  PropertySalesAvailabilityModal,
  PropertySalesGallerySection,
  PropertyStickyHeader,
  PropertyUpgradeBanner,
  RadioInput,
  RawNumberSelect,
  ResponsivePills,
  ResponsiveTabs,
  RestrictedField,
  ScrollDragable,
  SearchContext,
  SearchProvider,
  Select,
  SelectLegacy,
  SelectPrice,
  SelectTree,
  SideBar,
  SlideShowSection,
  Slider,
  Slideshow,
  SlideshowPreview,
  SortByEnum,
  SortContext,
  SortHeader,
  SortProvider,
  Spinner,
  Stepper,
  Steps,
  SubscriptionRecurringSwitch,
  SummarySection,
  Table,
  TableView,
  TableViewContext,
  TableViewProvider,
  TableViewToggle,
  TableViewType,
  TableWitPagination,
  TableWithFlatPagination,
  Tabs,
  TabsWithDropdown,
  Tag,
  TagSelect,
  Text,
  Textarea,
  ThemeProvider,
  Thumbnail,
  TimePicker,
  ToastContainer,
  Toggle,
  TooltipContext,
  TooltipPopup,
  TooltipProvider,
  TooltipWrapper,
  UnauthorizedPage,
  UpgradeSubscriptionModalType,
  UploadMediaContainer,
  Video,
  ViewerContext,
  ViewerProvider,
  VirtualToursButton,
  WasDeleted,
  WorkingHoursInput,
  WorkingWeekHoursInput,
  dictionary,
  downloadFile,
  downloadMedia,
  fetchAccessToken,
  fileUploadFetch,
  formatBathroomsRangeValues,
  formatBedroomsRangeValues,
  formatDisplayDate,
  formatDisplayMonthDate,
  formatDisplayRange,
  formatGeneralRangeValues,
  formatLocalizedDate,
  getCountryList,
  getIdxIframeViewport,
  getPeriodRangeByPeriodType,
  googlePlaceToAddress,
  googleZoomLevelToMiles,
  i18next,
  isAccessTokenExpired,
  jwtDecodeSafely,
  localStorage,
  mainTheme,
  mortgage,
  priceMaxRange,
  priceMaxRangeRent,
  priceMinRange,
  priceMinRangeRent,
  renderEmailField,
  renderPhoneField,
  renderWebsiteField,
  toDisplayLocaleDateString,
  toast,
  useAsyncState,
  useBackendErrorMessage,
  useCheckIfSubscriptionFeatureActiveBroker,
  useFormState,
  useFormValidation,
  useFromNow,
  useGoogleApiLoader,
  useInfiniteScroll,
  useIsVisible,
  useOnClickOutside,
  usePropertyUpdatedAgo,
  useScreenResolution,
  useScrollDirection,
  useServerResponseTranslation,
  useSystemFolderName,
  validatePrice
});
/*! Bundled license information:

@kurkle/color/dist/color.esm.js:
  (*!
   * @kurkle/color v0.3.2
   * https://github.com/kurkle/color#readme
   * (c) 2023 Jukka Kurkela
   * Released under the MIT License
   *)

chart.js/dist/chunks/helpers.segment.js:
  (*!
   * Chart.js v4.4.0
   * https://www.chartjs.org
   * (c) 2023 Chart.js Contributors
   * Released under the MIT License
   *)

chart.js/dist/chart.js:
  (*!
   * Chart.js v4.4.0
   * https://www.chartjs.org
   * (c) 2023 Chart.js Contributors
   * Released under the MIT License
   *)
*/
